(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8d4a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8d4a"] = parcelRequire;
}
parcelRequire.register("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRequire.register("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRequire.register("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1ObTH = parcelRequire("1ObTH");
var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function forEach(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.2.0";

});
parcelRequire.register("1ObTH", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $1513b08bb76c1101$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $1513b08bb76c1101$export$5f0017c582d45a2d; });
function $1513b08bb76c1101$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});




parcelRequire.register("9nHRL", function(module, exports) {
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

module.exports = (parcelRequire("jZA9I"));

});
parcelRequire.register("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $1ObTH = parcelRequire("1ObTH");
var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $1ObTH._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $1ObTH._)(c)));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function get() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function onError(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    var b = function b(_b) {
        return $e8dfc29dafb3bbd7$var$ad(_b, a);
    };
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    var b = function b(_b, d, e, f, g) {
        this._reactName = _b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (_b = a[c], this[c] = _b ? _b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    };
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $1ObTH._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $1ObTH._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function persist() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var _$d = f, _$e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $e8dfc29dafb3bbd7$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = _$d ? $e8dfc29dafb3bbd7$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = _$d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, _$e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = _$e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(_$d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) _$d = $e8dfc29dafb3bbd7$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function Jf(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Mg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Ng = null, $e8dfc29dafb3bbd7$var$Og = null, $e8dfc29dafb3bbd7$var$Pg = null;
function $e8dfc29dafb3bbd7$var$Qg() {
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Ng = null;
}
function $e8dfc29dafb3bbd7$var$Rg(a) {
    var b = $e8dfc29dafb3bbd7$var$Mg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Mg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$Tg(a, b) {
    $e8dfc29dafb3bbd7$var$Ng = a;
    $e8dfc29dafb3bbd7$var$Pg = $e8dfc29dafb3bbd7$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$Ug = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$Vg(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Og) {
            if (null === $e8dfc29dafb3bbd7$var$Ng) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Og = a;
            $e8dfc29dafb3bbd7$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Og = $e8dfc29dafb3bbd7$var$Og.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$Wg = null;
function $e8dfc29dafb3bbd7$var$Xg(a) {
    null === $e8dfc29dafb3bbd7$var$Wg ? $e8dfc29dafb3bbd7$var$Wg = [
        a
    ] : $e8dfc29dafb3bbd7$var$Wg.push(a);
}
function $e8dfc29dafb3bbd7$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$Zg(a, d);
}
function $e8dfc29dafb3bbd7$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$$g = !1;
function $e8dfc29dafb3bbd7$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$Zg(a, c);
}
function $e8dfc29dafb3bbd7$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$jh = (new $6cds3.Component).refs;
function $e8dfc29dafb3bbd7$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$nh = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$L(), e = $e8dfc29dafb3bbd7$var$lh(a), f = $e8dfc29dafb3bbd7$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$dh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, e, d), $e8dfc29dafb3bbd7$var$eh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$L(), d = $e8dfc29dafb3bbd7$var$lh(a), e = $e8dfc29dafb3bbd7$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$dh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$mh(b, a, d, c), $e8dfc29dafb3bbd7$var$eh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$ph(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$Vg(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $e8dfc29dafb3bbd7$var$jh;
    $e8dfc29dafb3bbd7$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$Vg(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$nh.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                _$b === $e8dfc29dafb3bbd7$var$jh && (_$b = e.refs = {});
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$vh(a) {
    var b = function b(_b, c) {
        if (a) {
            var d = _b.deletions;
            null === d ? (_b.deletions = [
                c
            ], _b.flags |= 16) : d.push(c);
        }
    };
    var c = function c(_c, d) {
        if (!a) return null;
        for(; null !== d;)b(_c, d), d = d.sibling;
        return null;
    };
    var d = function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    };
    var e = function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    };
    var f = function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    };
    var g = function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    };
    var h = function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var k = function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$sh(a, b, c);
        d.return = a;
        return d;
    };
    var l = function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    };
    var m = function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    };
    var n = function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    };
    var t = function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    };
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$sh(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$zh(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Ah(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$th(b, d);
        }
        return null;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Bh = $e8dfc29dafb3bbd7$var$vh(!0), $e8dfc29dafb3bbd7$var$Ch = $e8dfc29dafb3bbd7$var$vh(!1), $e8dfc29dafb3bbd7$var$Dh = {}, $e8dfc29dafb3bbd7$var$Eh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh), $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Dh);
function $e8dfc29dafb3bbd7$var$Hh(a) {
    if (a === $e8dfc29dafb3bbd7$var$Dh) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$Ih(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Gh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, $e8dfc29dafb3bbd7$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, b);
}
function $e8dfc29dafb3bbd7$var$Jh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Gh);
}
function $e8dfc29dafb3bbd7$var$Kh(a) {
    $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
    var b = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Fh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Eh, c));
}
function $e8dfc29dafb3bbd7$var$Lh(a) {
    $e8dfc29dafb3bbd7$var$Fh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Eh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Fh));
}
var $e8dfc29dafb3bbd7$var$M = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nh = [];
function $e8dfc29dafb3bbd7$var$Oh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Nh.length; a++)$e8dfc29dafb3bbd7$var$Nh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Nh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Ph = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Qh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Rh = 0, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$P = null, $e8dfc29dafb3bbd7$var$Sh = !1, $e8dfc29dafb3bbd7$var$Th = !1, $e8dfc29dafb3bbd7$var$Uh = 0, $e8dfc29dafb3bbd7$var$Vh = 0;
function $e8dfc29dafb3bbd7$var$Q() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Rh = f;
    $e8dfc29dafb3bbd7$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Ph.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Yh : $e8dfc29dafb3bbd7$var$Zh;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Th) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$$h;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Th);
    }
    $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
    b = null !== $e8dfc29dafb3bbd7$var$O && null !== $e8dfc29dafb3bbd7$var$O.next;
    $e8dfc29dafb3bbd7$var$Rh = 0;
    $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
    $e8dfc29dafb3bbd7$var$Sh = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$bi() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Uh;
    $e8dfc29dafb3bbd7$var$Uh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$di() {
    if (null === $e8dfc29dafb3bbd7$var$O) {
        var a = $e8dfc29dafb3bbd7$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$O.next;
    var b = null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState : $e8dfc29dafb3bbd7$var$P.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$P = b, $e8dfc29dafb3bbd7$var$O = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$O = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$O.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$O.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$O.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$O.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$P ? $e8dfc29dafb3bbd7$var$N.memoizedState = $e8dfc29dafb3bbd7$var$P = a : $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$P.next = a;
    }
    return $e8dfc29dafb3bbd7$var$P;
}
function $e8dfc29dafb3bbd7$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$N.lanes |= m;
                $e8dfc29dafb3bbd7$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$N.lanes |= f, $e8dfc29dafb3bbd7$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$gi(a) {
    var b = $e8dfc29dafb3bbd7$var$di(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$hi() {}
function $e8dfc29dafb3bbd7$var$ii(a, b) {
    var c = $e8dfc29dafb3bbd7$var$N, d = $e8dfc29dafb3bbd7$var$di(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$Ug = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$ji($e8dfc29dafb3bbd7$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$P && $e8dfc29dafb3bbd7$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$oi(b) && $e8dfc29dafb3bbd7$var$pi(a);
    });
}
function $e8dfc29dafb3bbd7$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$pi(a) {
    var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$mh(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$qi(a) {
    var b = $e8dfc29dafb3bbd7$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ri.bind(null, $e8dfc29dafb3bbd7$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$si() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ti(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$ci();
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$O) {
        var g = $e8dfc29dafb3bbd7$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Wh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$li(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$N.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$li(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    return $e8dfc29dafb3bbd7$var$ti(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ji(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$wi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$xi(a, b) {
    return $e8dfc29dafb3bbd7$var$ui(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$ui(4, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$Ai() {}
function $e8dfc29dafb3bbd7$var$Bi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    var c = $e8dfc29dafb3bbd7$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Rh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$Ug = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$N.lanes |= c, $e8dfc29dafb3bbd7$var$hh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ei(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Qh.transition;
    $e8dfc29dafb3bbd7$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Qh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$Fi() {
    return $e8dfc29dafb3bbd7$var$di().memoizedState;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$Yg(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$L();
        $e8dfc29dafb3bbd7$var$mh(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Ji(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ri(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$Hi(a)) $e8dfc29dafb3bbd7$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$Yg(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$L(), $e8dfc29dafb3bbd7$var$mh(c, a, d, e), $e8dfc29dafb3bbd7$var$Ji(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$Hi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$N || null !== b && b === $e8dfc29dafb3bbd7$var$N;
}
function $e8dfc29dafb3bbd7$var$Ii(a, b) {
    $e8dfc29dafb3bbd7$var$Th = $e8dfc29dafb3bbd7$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$ai = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Q,
    useContext: $e8dfc29dafb3bbd7$var$Q,
    useEffect: $e8dfc29dafb3bbd7$var$Q,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$Q,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$Q,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$Q,
    useMemo: $e8dfc29dafb3bbd7$var$Q,
    useReducer: $e8dfc29dafb3bbd7$var$Q,
    useRef: $e8dfc29dafb3bbd7$var$Q,
    useState: $e8dfc29dafb3bbd7$var$Q,
    useDebugValue: $e8dfc29dafb3bbd7$var$Q,
    useDeferredValue: $e8dfc29dafb3bbd7$var$Q,
    useTransition: $e8dfc29dafb3bbd7$var$Q,
    useMutableSource: $e8dfc29dafb3bbd7$var$Q,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Q,
    useId: $e8dfc29dafb3bbd7$var$Q,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Yh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: function useCallback(a, b) {
        $e8dfc29dafb3bbd7$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$vi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, $e8dfc29dafb3bbd7$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $e8dfc29dafb3bbd7$var$ti(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$Gi.bind(null, $e8dfc29dafb3bbd7$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $e8dfc29dafb3bbd7$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$qi,
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        return $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$qi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$Ei.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$N, e = $e8dfc29dafb3bbd7$var$ci();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$R) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Rh & 30) || $e8dfc29dafb3bbd7$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$vi($e8dfc29dafb3bbd7$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$li(9, $e8dfc29dafb3bbd7$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $e8dfc29dafb3bbd7$var$ci(), b = $e8dfc29dafb3bbd7$var$R.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Zh = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$fi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function useState() {
        return $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$fi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$$h = {
    readContext: $e8dfc29dafb3bbd7$var$Vg,
    useCallback: $e8dfc29dafb3bbd7$var$Bi,
    useContext: $e8dfc29dafb3bbd7$var$Vg,
    useEffect: $e8dfc29dafb3bbd7$var$ji,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$zi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$wi,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$xi,
    useMemo: $e8dfc29dafb3bbd7$var$Ci,
    useReducer: $e8dfc29dafb3bbd7$var$gi,
    useRef: $e8dfc29dafb3bbd7$var$si,
    useState: function useState() {
        return $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$Ai,
    useDeferredValue: function useDeferredValue(a) {
        var b = $e8dfc29dafb3bbd7$var$di();
        return null === $e8dfc29dafb3bbd7$var$O ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$Di(b, $e8dfc29dafb3bbd7$var$O.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $e8dfc29dafb3bbd7$var$gi($e8dfc29dafb3bbd7$var$ei)[0], b = $e8dfc29dafb3bbd7$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$hi,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$ii,
    useId: $e8dfc29dafb3bbd7$var$Fi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Oi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Pi || ($e8dfc29dafb3bbd7$var$Pi = !0, $e8dfc29dafb3bbd7$var$Qi = d);
        $e8dfc29dafb3bbd7$var$Mi(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Ri(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Mi(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Si ? $e8dfc29dafb3bbd7$var$Si = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Si.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$ch(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Xi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$Ug = !1;
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Ch(b, null, c, d) : $e8dfc29dafb3bbd7$var$Bh(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    d = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$cj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$Ug = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$$i(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj);
            $e8dfc29dafb3bbd7$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$fj, $e8dfc29dafb3bbd7$var$gj), $e8dfc29dafb3bbd7$var$gj |= d;
    $e8dfc29dafb3bbd7$var$Yi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    c = $e8dfc29dafb3bbd7$var$Xh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$bi();
    if (null !== a && !$e8dfc29dafb3bbd7$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$$i(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$Tg(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$jj(a, b), $e8dfc29dafb3bbd7$var$ph(b, c, d), $e8dfc29dafb3bbd7$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$Vg(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$qh(b, g, d, l);
        $e8dfc29dafb3bbd7$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$kh(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$Vg(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$qh(b, g, d, k);
        $e8dfc29dafb3bbd7$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$$g ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$kh(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$$g || $e8dfc29dafb3bbd7$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$kj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$kj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$$i(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$Ih(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$mj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Yi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$qj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$nj, a) : $e8dfc29dafb3bbd7$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$wh(h, f) : (f = $e8dfc29dafb3bbd7$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$rj(a, b) {
    b = $e8dfc29dafb3bbd7$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$tj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$oj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Li(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$Ug || h) {
        d = $e8dfc29dafb3bbd7$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$Zg(a, e), $e8dfc29dafb3bbd7$var$mh(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$uj();
        d = $e8dfc29dafb3bbd7$var$Li(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$Sg(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Yi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$lj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Kh(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$pj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
                a = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$$i(a, b, c);
}
var $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj, $e8dfc29dafb3bbd7$var$Dj;
$e8dfc29dafb3bbd7$var$Aj = function Aj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Bj = function Bj() {};
$e8dfc29dafb3bbd7$var$Cj = function Cj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Dj = function Dj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Ej(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$Jh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Bj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Lh(b);
            var e = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Gh.current);
                $e8dfc29dafb3bbd7$var$Hh($e8dfc29dafb3bbd7$var$Eh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Gj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$M.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$Bj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Ej(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, $e8dfc29dafb3bbd7$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Hj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$M.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$M, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$gj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Jj(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$Jh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Lh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$Jh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Kj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Oj = !1;
function $e8dfc29dafb3bbd7$var$Pj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Oj;
    $e8dfc29dafb3bbd7$var$Oj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Xj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Yj = !1;
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$ak(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$ak(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Mj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Yj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Yj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Yj = !0;
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Nj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Zj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Zj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Zj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Lj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Yj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$ak(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$ek(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Qj(3, a, a.return), $e8dfc29dafb3bbd7$var$Rj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Qj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$gk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$dk(b, a);
            $e8dfc29dafb3bbd7$var$fk(a);
            d & 4 && $e8dfc29dafb3bbd7$var$bk(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$dk(b, a), $e8dfc29dafb3bbd7$var$fk(a);
    }
}
function $e8dfc29dafb3bbd7$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Vj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$jk(a, b, c);
}
function $e8dfc29dafb3bbd7$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Kj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Kj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$kk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$kk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$jk(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Kj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$lk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$lk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Sj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$hk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Sj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$mk = Math.ceil, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$pk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$gj = 0, $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$qk = null, $e8dfc29dafb3bbd7$var$hh = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = 0, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$gk = 0, $e8dfc29dafb3bbd7$var$Hj = Infinity, $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Pi = !1, $e8dfc29dafb3bbd7$var$Qi = null, $e8dfc29dafb3bbd7$var$Si = null, $e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = null, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, $e8dfc29dafb3bbd7$var$Bk = -1, $e8dfc29dafb3bbd7$var$Ck = 0;
function $e8dfc29dafb3bbd7$var$L() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Bk ? $e8dfc29dafb3bbd7$var$Bk : $e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Ck && ($e8dfc29dafb3bbd7$var$Ck = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Ck;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$mh(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$zk) throw $e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$R) a === $e8dfc29dafb3bbd7$var$R && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$rk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Ek(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Ek(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Fk.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Fk.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Gk(c, $e8dfc29dafb3bbd7$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Hk(a, b) {
    $e8dfc29dafb3bbd7$var$Bk = -1;
    $e8dfc29dafb3bbd7$var$Ck = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Ik() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$R ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Jk(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Kk();
        if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Lk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Mk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Nk(a, h);
        }
        $e8dfc29dafb3bbd7$var$Qg();
        $e8dfc29dafb3bbd7$var$nk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Ok(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Pk(e) && (b = $e8dfc29dafb3bbd7$var$Jk(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Ok(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, d), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$gk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Qk.bind(null, a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Hk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Ok(a, b) {
    var c = $e8dfc29dafb3bbd7$var$tk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Lk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Jk(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$uk = c, null !== b && $e8dfc29dafb3bbd7$var$Gj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Gj(a) {
    null === $e8dfc29dafb3bbd7$var$uk ? $e8dfc29dafb3bbd7$var$uk = a : $e8dfc29dafb3bbd7$var$uk.push.apply($e8dfc29dafb3bbd7$var$uk, a);
}
function $e8dfc29dafb3bbd7$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$sk;
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Fk(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Ok(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$qk, $e8dfc29dafb3bbd7$var$Lk(a, 0), $e8dfc29dafb3bbd7$var$Dk(a, b), $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Qk(a, $e8dfc29dafb3bbd7$var$uk, $e8dfc29dafb3bbd7$var$vk);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Rk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    null !== $e8dfc29dafb3bbd7$var$xk && 0 === $e8dfc29dafb3bbd7$var$xk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Ik();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$pk.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$pk.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Ij() {
    $e8dfc29dafb3bbd7$var$gj = $e8dfc29dafb3bbd7$var$fj.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$fj);
}
function $e8dfc29dafb3bbd7$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$Jh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Oh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Lh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$Jh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$M);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Ij();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$R = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$wh(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$gj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$qk = null;
    $e8dfc29dafb3bbd7$var$sk = $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$hh = 0;
    $e8dfc29dafb3bbd7$var$uk = $e8dfc29dafb3bbd7$var$tk = null;
    if (null !== $e8dfc29dafb3bbd7$var$Wg) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$Wg.length; b++)if (c = $e8dfc29dafb3bbd7$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$Wg = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$Qg();
            $e8dfc29dafb3bbd7$var$Ph.current = $e8dfc29dafb3bbd7$var$ai;
            if ($e8dfc29dafb3bbd7$var$Sh) {
                for(var d = $e8dfc29dafb3bbd7$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Sh = !1;
            }
            $e8dfc29dafb3bbd7$var$Rh = 0;
            $e8dfc29dafb3bbd7$var$P = $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            $e8dfc29dafb3bbd7$var$Th = !1;
            $e8dfc29dafb3bbd7$var$Uh = 0;
            $e8dfc29dafb3bbd7$var$ok.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$qk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Ti(f, l, b);
                            $e8dfc29dafb3bbd7$var$uj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Wi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ki(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Oi(f, k, b);
                            $e8dfc29dafb3bbd7$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Ri(f, h, b);
                                $e8dfc29dafb3bbd7$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Tk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Kk() {
    var a = $e8dfc29dafb3bbd7$var$nk.current;
    $e8dfc29dafb3bbd7$var$nk.current = $e8dfc29dafb3bbd7$var$ai;
    return null === a ? $e8dfc29dafb3bbd7$var$ai : a;
}
function $e8dfc29dafb3bbd7$var$uj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$R || 0 === ($e8dfc29dafb3bbd7$var$hh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$rk & 268435455) || $e8dfc29dafb3bbd7$var$Dk($e8dfc29dafb3bbd7$var$R, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Jk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Kk();
    if ($e8dfc29dafb3bbd7$var$R !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$vk = null, $e8dfc29dafb3bbd7$var$Lk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Uk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Nk(a, e);
    }
    $e8dfc29dafb3bbd7$var$Qg();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$nk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$R = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Uk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Mk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Vk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Vk(a) {
    var b = $e8dfc29dafb3bbd7$var$Wk(a.alternate, a, $e8dfc29dafb3bbd7$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Tk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$ok.current = null;
}
function $e8dfc29dafb3bbd7$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Fj(c, b, $e8dfc29dafb3bbd7$var$gj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Qk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$pk.transition;
    try {
        $e8dfc29dafb3bbd7$var$pk.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Xk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$pk.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Ik();
    while (null !== $e8dfc29dafb3bbd7$var$xk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$R && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$R = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$wk || ($e8dfc29dafb3bbd7$var$wk = !0, $e8dfc29dafb3bbd7$var$Gk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$pk.transition;
        $e8dfc29dafb3bbd7$var$pk.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$ok.current = null;
        $e8dfc29dafb3bbd7$var$Pj(a, c);
        $e8dfc29dafb3bbd7$var$ek(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$ik(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$pk.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$wk && ($e8dfc29dafb3bbd7$var$wk = !1, $e8dfc29dafb3bbd7$var$xk = a, $e8dfc29dafb3bbd7$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Si = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Ek(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Pi) throw $e8dfc29dafb3bbd7$var$Pi = !1, a = $e8dfc29dafb3bbd7$var$Qi, $e8dfc29dafb3bbd7$var$Qi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$yk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$zk++ : ($e8dfc29dafb3bbd7$var$zk = 0, $e8dfc29dafb3bbd7$var$Ak = a) : $e8dfc29dafb3bbd7$var$zk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Ik() {
    if (null !== $e8dfc29dafb3bbd7$var$xk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$yk), b = $e8dfc29dafb3bbd7$var$pk.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$pk.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$xk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$xk;
                $e8dfc29dafb3bbd7$var$xk = null;
                $e8dfc29dafb3bbd7$var$yk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Tj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Rj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$pk.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Yk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ki(c, b);
    b = $e8dfc29dafb3bbd7$var$Oi(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$dh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$L();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Ek(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Si || !$e8dfc29dafb3bbd7$var$Si.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ki(c, a);
                a = $e8dfc29dafb3bbd7$var$Ri(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$dh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$L();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$R === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$gk ? $e8dfc29dafb3bbd7$var$Lk(a, 0) : $e8dfc29dafb3bbd7$var$sk |= c);
    $e8dfc29dafb3bbd7$var$Ek(a, b);
}
function $e8dfc29dafb3bbd7$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$L();
    a = $e8dfc29dafb3bbd7$var$Zg(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Ek(a, c));
}
function $e8dfc29dafb3bbd7$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Zk(a, c);
}
var $e8dfc29dafb3bbd7$var$Wk;
$e8dfc29dafb3bbd7$var$Wk = function Wk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$zj(a, b, c);
            $e8dfc29dafb3bbd7$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$Ug = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$jj(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$Tg(b, c);
            e = $e8dfc29dafb3bbd7$var$Xh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$ah(b), e.updater = $e8dfc29dafb3bbd7$var$nh, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$rh(b, d, a, c), b = $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$$k(d);
                a = $e8dfc29dafb3bbd7$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$aj(null, b, d, $e8dfc29dafb3bbd7$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$lj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$bh(a, b);
                $e8dfc29dafb3bbd7$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$mj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Kh(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$hj(a, b), $e8dfc29dafb3bbd7$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$pj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Bh(b, null, d, c) : $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$Zi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$Tg(b, c), e = $e8dfc29dafb3bbd7$var$Vg(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Lg(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Lg(d.type, e), $e8dfc29dafb3bbd7$var$aj(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Lg(d, e), $e8dfc29dafb3bbd7$var$jj(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$Tg(b, c), $e8dfc29dafb3bbd7$var$ph(b, d, e), $e8dfc29dafb3bbd7$var$rh(b, d, e, c), $e8dfc29dafb3bbd7$var$kj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$yj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$ej(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$al(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$$k(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Ah(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a), ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ah(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$qj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$xh(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$zh(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$ah(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$el(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$el(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$L();
    e = $e8dfc29dafb3bbd7$var$lh(c);
    f = $e8dfc29dafb3bbd7$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$dh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Ek(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$gl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$L(), g = $e8dfc29dafb3bbd7$var$lh(e);
    c = $e8dfc29dafb3bbd7$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$dh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$mh(a, e, g, f), $e8dfc29dafb3bbd7$var$eh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$jl(a, b) {
    $e8dfc29dafb3bbd7$var$il(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$il(a, b);
}
function $e8dfc29dafb3bbd7$var$kl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$ll = "function" === typeof reportError ? reportError : function ll(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.render = $e8dfc29dafb3bbd7$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$gl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$nl.prototype.unmount = $e8dfc29dafb3bbd7$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Sk(function() {
            $e8dfc29dafb3bbd7$var$gl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$ql() {}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $e8dfc29dafb3bbd7$var$hl(g);
                f.call(_$a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$fl(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $e8dfc29dafb3bbd7$var$hl(k);
            h.call(_$a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$cl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$ql);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$gl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $e8dfc29dafb3bbd7$var$hl(g);
                h.call(_$a);
            };
        }
        $e8dfc29dafb3bbd7$var$gl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$rl(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$hl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Ek(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Hj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Sk(function() {
                var b = $e8dfc29dafb3bbd7$var$Zg(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$L();
                    $e8dfc29dafb3bbd7$var$mh(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$jl(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$jl(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$lh(a), c = $e8dfc29dafb3bbd7$var$Zg(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$L();
            $e8dfc29dafb3bbd7$var$mh(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$jl(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function Hc() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function Ic(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Sk;
var $e8dfc29dafb3bbd7$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Rk
    ]
}, $e8dfc29dafb3bbd7$var$ul = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$vl = {
    bundleType: $e8dfc29dafb3bbd7$var$ul.bundleType,
    version: $e8dfc29dafb3bbd7$var$ul.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$ul.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$ul.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$wl.isDisabled && $e8dfc29dafb3bbd7$var$wl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$wl.inject($e8dfc29dafb3bbd7$var$vl), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$wl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$tl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$dl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Sk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$nl(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$pl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$sl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$pl(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Sk(function() {
        $e8dfc29dafb3bbd7$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Rk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$pl(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$sl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRequire.register("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function S() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function S() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function S() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});




parcelRequire.register("17QCl", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0d1f42a1cefd465e$export$bdfd709ae4826697; }, function (v) { return $0d1f42a1cefd465e$export$bdfd709ae4826697 = v; });
var $0d1f42a1cefd465e$export$bdfd709ae4826697;
var $0d1f42a1cefd465e$export$c9e73fbda7da57b6;
var $0d1f42a1cefd465e$export$5a759dc7a1cfb72a;
"use strict";
var $0d1f42a1cefd465e$var$bundleURL = {};
function $0d1f42a1cefd465e$var$getBundleURLCached(id) {
    var value = $0d1f42a1cefd465e$var$bundleURL[id];
    if (!value) {
        value = $0d1f42a1cefd465e$var$getBundleURL();
        $0d1f42a1cefd465e$var$bundleURL[id] = value;
    }
    return value;
}
function $0d1f42a1cefd465e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0d1f42a1cefd465e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $0d1f42a1cefd465e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0d1f42a1cefd465e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$0d1f42a1cefd465e$export$bdfd709ae4826697 = $0d1f42a1cefd465e$var$getBundleURLCached;
$0d1f42a1cefd465e$export$c9e73fbda7da57b6 = $0d1f42a1cefd465e$var$getBaseURL;
$0d1f42a1cefd465e$export$5a759dc7a1cfb72a = $0d1f42a1cefd465e$var$getOrigin;

});

parcelRequire.register("8GFUW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6532c2e6670e28d1$export$fdf2a89c76341bbf; });

var $jbUp2 = parcelRequire("jbUp2");

var $6zrOq = parcelRequire("6zrOq");

var $4Tldu = parcelRequire("4Tldu");

var $imR8K = parcelRequire("imR8K");
function $6532c2e6670e28d1$export$fdf2a89c76341bbf(arr, i) {
    return (0, $jbUp2._array_with_holes)(arr) || (0, $6zrOq._iterable_to_array_limit)(arr, i) || (0, $imR8K._unsupported_iterable_to_array)(arr, i) || (0, $4Tldu._non_iterable_rest)();
}

});
parcelRequire.register("jbUp2", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $df8acbd513f0a551$export$e6256bf45c68d561; });
function $df8acbd513f0a551$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("6zrOq", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $4c8b95e34bd7aafb$export$2fd15edff6687200; });
function $4c8b95e34bd7aafb$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("4Tldu", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $38fcc1ab263aa6c9$export$60dbc22abd7da546; });
function $38fcc1ab263aa6c9$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("imR8K", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $d5f380987878722e$export$a5be06335b3a083c; });

var $dkOJL = parcelRequire("dkOJL");
function $d5f380987878722e$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $dkOJL._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $dkOJL._array_like_to_array)(o, minLen);
}

});
parcelRequire.register("dkOJL", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $9b547ff733c97a35$export$79e617b1955a2616; });
function $9b547ff733c97a35$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRequire.register("fLnyw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b79d847807e3ac29$export$1b5e630bc3aea29f; });

var $c1J0v = parcelRequire("c1J0v");

var $2uHzb = parcelRequire("2uHzb");

var $cKglA = parcelRequire("cKglA");

var $imR8K = parcelRequire("imR8K");
function $b79d847807e3ac29$export$1b5e630bc3aea29f(arr) {
    return (0, $c1J0v._array_without_holes)(arr) || (0, $2uHzb._iterable_to_array)(arr) || (0, $imR8K._unsupported_iterable_to_array)(arr) || (0, $cKglA._non_iterable_spread)();
}

});
parcelRequire.register("c1J0v", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $8c187d86836ebd16$export$7e0947b5ad3404e2; });

var $dkOJL = parcelRequire("dkOJL");
function $8c187d86836ebd16$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $dkOJL._array_like_to_array)(arr);
}

});

parcelRequire.register("2uHzb", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $1d102d83300b551e$export$1eb58a6e75231000; });
function $1d102d83300b551e$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("cKglA", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $9476761b01b79dcb$export$e6f3c4780d19eb2b; });
function $9476761b01b79dcb$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("978gY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6a2b2f5024d4ec83$export$2996f80ef42b8419; });
function $6a2b2f5024d4ec83$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("kry2a", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ee20bab046a9ef96$export$d60067ff2358eee8; });
function $ee20bab046a9ef96$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ee20bab046a9ef96$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $ee20bab046a9ef96$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ee20bab046a9ef96$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("ftJVG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b44d311756de33f4$export$7e4530ad35d3bb8; });

var $azwGX = parcelRequire("azwGX");
function $b44d311756de33f4$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $azwGX._set_prototype_of)(subClass, superClass);
}

});
parcelRequire.register("azwGX", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $7b26882fd1cd0ac2$export$c2c98ac76e997b63; });
function $7b26882fd1cd0ac2$export$c2c98ac76e997b63(o, p) {
    $7b26882fd1cd0ac2$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7b26882fd1cd0ac2$export$c2c98ac76e997b63(o, p);
}

});


parcelRequire.register("2TMdq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $21c61e66a13e7076$export$2466d533fda16e33; });

var $34cAK = parcelRequire("34cAK");

var $g3d7z = parcelRequire("g3d7z");

var $cM94G = parcelRequire("cM94G");

var $azwGX = parcelRequire("azwGX");
function $21c61e66a13e7076$export$2466d533fda16e33(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $21c61e66a13e7076$export$2466d533fda16e33 = function(Class) {
        if (Class === null || !(0, $cM94G._is_native_function)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $34cAK._construct)(Class, arguments, (0, $g3d7z._get_prototype_of)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $azwGX._set_prototype_of)(Wrapper, Class);
    };
    return $21c61e66a13e7076$export$2466d533fda16e33(Class);
}

});
parcelRequire.register("34cAK", function(module, exports) {

$parcel$export(module.exports, "_construct", function () { return $23bb83417b6a52ec$export$2d841144c5f8c4ab; });
$parcel$export(module.exports, "_", function () { return $23bb83417b6a52ec$export$2d841144c5f8c4ab; });

var $1vcmW = parcelRequire("1vcmW");

var $azwGX = parcelRequire("azwGX");
function $23bb83417b6a52ec$export$2d841144c5f8c4ab(Parent, args, Class) {
    if ((0, $1vcmW._is_native_reflect_construct)()) $23bb83417b6a52ec$export$2d841144c5f8c4ab = Reflect.construct;
    else $23bb83417b6a52ec$export$2d841144c5f8c4ab = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $azwGX._set_prototype_of)(instance, Class.prototype);
        return instance;
    };
    return $23bb83417b6a52ec$export$2d841144c5f8c4ab.apply(null, arguments);
}

});
parcelRequire.register("1vcmW", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $118247e7c3dd6008$export$685354647fba1516; });
function $118247e7c3dd6008$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRequire.register("g3d7z", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $baf71ab6cd4d51b1$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $baf71ab6cd4d51b1$export$f09211a7d3c496a1; });
function $baf71ab6cd4d51b1$export$f09211a7d3c496a1(o) {
    $baf71ab6cd4d51b1$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $baf71ab6cd4d51b1$export$f09211a7d3c496a1(o);
}

});

parcelRequire.register("cM94G", function(module, exports) {

$parcel$export(module.exports, "_is_native_function", function () { return $94d101b80d8606f0$export$514eda94019f4334; });
function $94d101b80d8606f0$export$514eda94019f4334(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRequire.register("6OZAO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4f7730a4a64324ea$export$8dd05c13f5255580; });

var $g3d7z = parcelRequire("g3d7z");

var $1vcmW = parcelRequire("1vcmW");

var $ho5gk = parcelRequire("ho5gk");
function $4f7730a4a64324ea$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $1vcmW._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $g3d7z._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $g3d7z._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ho5gk._possible_constructor_return)(this, result);
    };
}

});
parcelRequire.register("ho5gk", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $ca88c28e2dc74ceb$export$ef97c660ca164e52; });
$parcel$export(module.exports, "_", function () { return $ca88c28e2dc74ceb$export$ef97c660ca164e52; });

var $3vWwE = parcelRequire("3vWwE");

var $1ObTH = parcelRequire("1ObTH");
function $ca88c28e2dc74ceb$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $1ObTH._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $3vWwE._assert_this_initialized)(self);
}

});
parcelRequire.register("3vWwE", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8; });
function $28f1aa4c4240ff0b$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRequire.register("7UAGh", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $5c2a37736a53c5f6$export$3c9a16f847548506; });
$parcel$export(module.exports, "__generator", function () { return $5c2a37736a53c5f6$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $5c2a37736a53c5f6$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $1ObTH = parcelRequire("1ObTH");
var $5c2a37736a53c5f6$var$extendStatics = function extendStatics1(d, b) {
    $5c2a37736a53c5f6$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c2a37736a53c5f6$var$extendStatics(d, b);
};
function $5c2a37736a53c5f6$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c2a37736a53c5f6$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c2a37736a53c5f6$export$18ce0697a983be9b = function __assign1() {
    $5c2a37736a53c5f6$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c2a37736a53c5f6$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c2a37736a53c5f6$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c2a37736a53c5f6$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c2a37736a53c5f6$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c2a37736a53c5f6$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c2a37736a53c5f6$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c2a37736a53c5f6$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $1ObTH._)(x)) === "symbol" ? x : "".concat(x);
}
function $5c2a37736a53c5f6$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $1ObTH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c2a37736a53c5f6$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c2a37736a53c5f6$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c2a37736a53c5f6$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $5c2a37736a53c5f6$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c2a37736a53c5f6$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c2a37736a53c5f6$export$45d3717a4c69092e(o, m, p);
}
function $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c2a37736a53c5f6$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c2a37736a53c5f6$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c2a37736a53c5f6$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c2a37736a53c5f6$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c2a37736a53c5f6$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c2a37736a53c5f6$export$10c90e4f7922046c(v) {
    return this instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? (this.v = v, this) : new $5c2a37736a53c5f6$export$10c90e4f7922046c(v);
}
function $5c2a37736a53c5f6$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $5c2a37736a53c5f6$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $5c2a37736a53c5f6$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c2a37736a53c5f6$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $5c2a37736a53c5f6$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c2a37736a53c5f6$export$19a8beecd37a4c45 === "function" ? $5c2a37736a53c5f6$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $5c2a37736a53c5f6$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c2a37736a53c5f6$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c2a37736a53c5f6$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c2a37736a53c5f6$export$45d3717a4c69092e(result, mod, k);
    }
    $5c2a37736a53c5f6$var$__setModuleDefault(result, mod);
    return result;
}
function $5c2a37736a53c5f6$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c2a37736a53c5f6$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c2a37736a53c5f6$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c2a37736a53c5f6$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c2a37736a53c5f6$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c2a37736a53c5f6$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c2a37736a53c5f6$export$8f076105dc360e92(env) {
    var fail = function fail(e) {
        env.error = env.hasError ? new $5c2a37736a53c5f6$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    };
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c2a37736a53c5f6$export$2e2bcd8739ae039 = {
    __extends: $5c2a37736a53c5f6$export$a8ba968b8961cb8a,
    __assign: $5c2a37736a53c5f6$export$18ce0697a983be9b,
    __rest: $5c2a37736a53c5f6$export$3c9a16f847548506,
    __decorate: $5c2a37736a53c5f6$export$29e00dfd3077644b,
    __param: $5c2a37736a53c5f6$export$d5ad3fd78186038f,
    __metadata: $5c2a37736a53c5f6$export$f1db080c865becb9,
    __awaiter: $5c2a37736a53c5f6$export$1050f835b63b671e,
    __generator: $5c2a37736a53c5f6$export$67ebef60e6f28a6,
    __createBinding: $5c2a37736a53c5f6$export$45d3717a4c69092e,
    __exportStar: $5c2a37736a53c5f6$export$f33643c0debef087,
    __values: $5c2a37736a53c5f6$export$19a8beecd37a4c45,
    __read: $5c2a37736a53c5f6$export$8d051b38c9118094,
    __spread: $5c2a37736a53c5f6$export$afc72e2116322959,
    __spreadArrays: $5c2a37736a53c5f6$export$6388937ca91ccae8,
    __spreadArray: $5c2a37736a53c5f6$export$1216008129fb82ed,
    __await: $5c2a37736a53c5f6$export$10c90e4f7922046c,
    __asyncGenerator: $5c2a37736a53c5f6$export$e427f37a30a4de9b,
    __asyncDelegator: $5c2a37736a53c5f6$export$bbd80228419bb833,
    __asyncValues: $5c2a37736a53c5f6$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c2a37736a53c5f6$export$4fb47efe1390b86f,
    __importStar: $5c2a37736a53c5f6$export$c21735bcef00d192,
    __importDefault: $5c2a37736a53c5f6$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c2a37736a53c5f6$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c2a37736a53c5f6$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c2a37736a53c5f6$export$81fdc39f203e4e04,
    __addDisposableResource: $5c2a37736a53c5f6$export$88ac25d8e944e405,
    __disposeResources: $5c2a37736a53c5f6$export$8f076105dc360e92
};

});

parcelRequire.register("3cct3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $253c29e4a8bc609b$export$afb3516d9d608401; });

var $i8pJC = parcelRequire("i8pJC");
function $253c29e4a8bc609b$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $253c29e4a8bc609b$export$afb3516d9d608401 = Reflect.get;
    else $253c29e4a8bc609b$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $i8pJC._super_prop_base)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $253c29e4a8bc609b$export$afb3516d9d608401(target, property, receiver || target);
}

});
parcelRequire.register("i8pJC", function(module, exports) {

$parcel$export(module.exports, "_super_prop_base", function () { return $d33cefbe4adc536f$export$e4187255aefbc259; });

var $g3d7z = parcelRequire("g3d7z");
function $d33cefbe4adc536f$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $g3d7z._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRequire.register("a8i8g", function(module, exports) {
// shim for using process in browser
var $7608b7726638efe3$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7608b7726638efe3$var$cachedSetTimeout;
var $7608b7726638efe3$var$cachedClearTimeout;
function $7608b7726638efe3$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $7608b7726638efe3$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        else $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    } catch (e) {
        $7608b7726638efe3$var$cachedSetTimeout = $7608b7726638efe3$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        else $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    } catch (e) {
        $7608b7726638efe3$var$cachedClearTimeout = $7608b7726638efe3$var$defaultClearTimeout;
    }
})();
function $7608b7726638efe3$var$runTimeout(fun) {
    if ($7608b7726638efe3$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedSetTimeout === $7608b7726638efe3$var$defaultSetTimout || !$7608b7726638efe3$var$cachedSetTimeout) && setTimeout) {
        $7608b7726638efe3$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7608b7726638efe3$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7608b7726638efe3$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7608b7726638efe3$var$runClearTimeout(marker) {
    if ($7608b7726638efe3$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7608b7726638efe3$var$cachedClearTimeout === $7608b7726638efe3$var$defaultClearTimeout || !$7608b7726638efe3$var$cachedClearTimeout) && clearTimeout) {
        $7608b7726638efe3$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7608b7726638efe3$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7608b7726638efe3$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7608b7726638efe3$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7608b7726638efe3$var$queue = [];
var $7608b7726638efe3$var$draining = false;
var $7608b7726638efe3$var$currentQueue;
var $7608b7726638efe3$var$queueIndex = -1;
function $7608b7726638efe3$var$cleanUpNextTick() {
    if (!$7608b7726638efe3$var$draining || !$7608b7726638efe3$var$currentQueue) return;
    $7608b7726638efe3$var$draining = false;
    if ($7608b7726638efe3$var$currentQueue.length) $7608b7726638efe3$var$queue = $7608b7726638efe3$var$currentQueue.concat($7608b7726638efe3$var$queue);
    else $7608b7726638efe3$var$queueIndex = -1;
    if ($7608b7726638efe3$var$queue.length) $7608b7726638efe3$var$drainQueue();
}
function $7608b7726638efe3$var$drainQueue() {
    if ($7608b7726638efe3$var$draining) return;
    var timeout = $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$cleanUpNextTick);
    $7608b7726638efe3$var$draining = true;
    var len = $7608b7726638efe3$var$queue.length;
    while(len){
        $7608b7726638efe3$var$currentQueue = $7608b7726638efe3$var$queue;
        $7608b7726638efe3$var$queue = [];
        while(++$7608b7726638efe3$var$queueIndex < len)if ($7608b7726638efe3$var$currentQueue) $7608b7726638efe3$var$currentQueue[$7608b7726638efe3$var$queueIndex].run();
        $7608b7726638efe3$var$queueIndex = -1;
        len = $7608b7726638efe3$var$queue.length;
    }
    $7608b7726638efe3$var$currentQueue = null;
    $7608b7726638efe3$var$draining = false;
    $7608b7726638efe3$var$runClearTimeout(timeout);
}
$7608b7726638efe3$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7608b7726638efe3$var$queue.push(new $7608b7726638efe3$var$Item(fun, args));
    if ($7608b7726638efe3$var$queue.length === 1 && !$7608b7726638efe3$var$draining) $7608b7726638efe3$var$runTimeout($7608b7726638efe3$var$drainQueue);
};
// v8 likes predictible objects
function $7608b7726638efe3$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7608b7726638efe3$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7608b7726638efe3$var$process.title = "browser";
$7608b7726638efe3$var$process.browser = true;
$7608b7726638efe3$var$process.env = {};
$7608b7726638efe3$var$process.argv = [];
$7608b7726638efe3$var$process.version = ""; // empty string to avoid regexp issues
$7608b7726638efe3$var$process.versions = {};
function $7608b7726638efe3$var$noop() {}
$7608b7726638efe3$var$process.on = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.addListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.once = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.off = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.removeAllListeners = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.emit = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.prependOnceListener = $7608b7726638efe3$var$noop;
$7608b7726638efe3$var$process.listeners = function(name) {
    return [];
};
$7608b7726638efe3$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$7608b7726638efe3$var$process.cwd = function() {
    return "/";
};
$7608b7726638efe3$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$7608b7726638efe3$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("kK49L", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "react-dom",
        "./lib/ScriptCache",
        "./lib/GoogleApi"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("9nHRL")), (parcelRequire("5OWPI")), (parcelRequire("jBsPM")));
    }
})(undefined, function(exports1, _react, _reactDom, _ScriptCache, _GoogleApi) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.wrapper = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _GoogleApi2 = _interopRequireDefault(_GoogleApi);
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var defaultMapConfig = {};
    var serialize = function serialize(obj) {
        return JSON.stringify(obj);
    };
    var isSame = function isSame(obj1, obj2) {
        return obj1 === obj2 || serialize(obj1) === serialize(obj2);
    };
    var defaultCreateCache = function defaultCreateCache(options) {
        options = options || {};
        var apiKey = options.apiKey;
        var libraries = options.libraries || [
            "places"
        ];
        var version = options.version || "3";
        var language = options.language || "en";
        var url = options.url;
        var client = options.client;
        var region = options.region;
        return (0, _ScriptCache.ScriptCache)({
            google: (0, _GoogleApi2.default)({
                apiKey: apiKey,
                language: language,
                libraries: libraries,
                version: version,
                url: url,
                client: client,
                region: region
            })
        });
    };
    var DefaultLoadingContainer = function DefaultLoadingContainer(props) {
        return _react2.default.createElement("div", null, "Loading...");
    };
    var wrapper = exports1.wrapper = function wrapper(input) {
        return function(WrappedComponent) {
            var Wrapper = function(_React$Component) {
                _inherits(Wrapper, _React$Component);
                function Wrapper(props, context) {
                    _classCallCheck(this, Wrapper);
                    // Build options from input
                    var _this = _possibleConstructorReturn(this, (Wrapper.__proto__ || Object.getPrototypeOf(Wrapper)).call(this, props, context));
                    var options = typeof input === "function" ? input(props) : input;
                    // Initialize required Google scripts and other configured options
                    _this.initialize(options);
                    _this.state = {
                        loaded: false,
                        map: null,
                        google: null,
                        options: options
                    };
                    _this.mapRef = _react2.default.createRef();
                    return _this;
                }
                _createClass(Wrapper, [
                    {
                        key: "UNSAFE_componentWillReceiveProps",
                        value: function UNSAFE_componentWillReceiveProps(props) {
                            // Do not update input if it's not dynamic
                            if (typeof input !== "function") return;
                            // Get options to compare
                            var prevOptions = this.state.options;
                            var options = typeof input === "function" ? input(props) : input;
                            // Ignore when options are not changed
                            if (isSame(options, prevOptions)) return;
                            // Initialize with new options
                            this.initialize(options);
                            // Save new options in component state,
                            // and remove information about previous API handlers
                            this.setState({
                                options: options,
                                loaded: false,
                                google: null
                            });
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            if (this.unregisterLoadHandler) this.unregisterLoadHandler();
                        }
                    },
                    {
                        key: "initialize",
                        value: function initialize(options) {
                            // Avoid race condition: remove previous 'load' listener
                            if (this.unregisterLoadHandler) {
                                this.unregisterLoadHandler();
                                this.unregisterLoadHandler = null;
                            }
                            // Load cache factory
                            var createCache = options.createCache || defaultCreateCache;
                            // Build script
                            this.scriptCache = createCache(options);
                            this.unregisterLoadHandler = this.scriptCache.google.onLoad(this.onLoad.bind(this));
                            // Store information about loading container
                            this.LoadingContainer = options.LoadingContainer || DefaultLoadingContainer;
                        }
                    },
                    {
                        key: "onLoad",
                        value: function onLoad(err, tag) {
                            this._gapi = window.google;
                            this.setState({
                                loaded: true,
                                google: this._gapi
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            var LoadingContainer = this.LoadingContainer;
                            if (!this.state.loaded) return _react2.default.createElement(LoadingContainer, null);
                            var props = Object.assign({}, this.props, {
                                loaded: this.state.loaded,
                                google: window.google
                            });
                            return _react2.default.createElement("div", null, _react2.default.createElement(WrappedComponent, props), _react2.default.createElement("div", {
                                ref: this.mapRef
                            }));
                        }
                    }
                ]);
                return Wrapper;
            }(_react2.default.Component);
            return Wrapper;
        };
    };
    exports1.default = wrapper;
});

});
parcelRequire.register("5OWPI", function(module, exports) {

(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./windowOrGlobal"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("bOdGp")));
    }
})(module.exports, function(exports1, window) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var counter = 0;
    var scriptMap = typeof window !== "undefined" && window._scriptMap || new Map();
    var ScriptCache = exports1.ScriptCache = function(global) {
        global._scriptMap = global._scriptMap || scriptMap;
        return function ScriptCache(scripts) {
            var Cache = {};
            Cache._onLoad = function(key) {
                return function(cb) {
                    var unregister = function unregister() {
                        registered = false;
                    };
                    var registered = true;
                    var stored = scriptMap.get(key);
                    if (stored) stored.promise.then(function() {
                        if (registered) stored.error ? cb(stored.error) : cb(null, stored);
                        return stored;
                    }).catch(function(error) {
                        return cb(error);
                    });
                    return unregister;
                };
            };
            Cache._scriptTag = function(key, src) {
                if (!scriptMap.has(key)) {
                    // Server side rendering environments don't always have access to the `document` global.
                    // In these cases, we're not going to be able to return a script tag, so just return null.
                    if (typeof document === "undefined") return null;
                    var tag = document.createElement("script");
                    var promise = new Promise(function(resolve, reject) {
                        var body = document.getElementsByTagName("body")[0];
                        tag.type = "text/javascript";
                        tag.async = false; // Load in order
                        var cbName = "loaderCB" + counter++ + Date.now();
                        var cb = void 0;
                        var handleResult = function handleResult(state) {
                            return function(evt) {
                                var stored = scriptMap.get(key);
                                if (state === "loaded") {
                                    stored.resolved = true;
                                    resolve(src);
                                // stored.handlers.forEach(h => h.call(null, stored))
                                // stored.handlers = []
                                } else if (state === "error") {
                                    stored.errored = true;
                                    // stored.handlers.forEach(h => h.call(null, stored))
                                    // stored.handlers = [];
                                    reject(evt);
                                }
                                stored.loaded = true;
                                cleanup();
                            };
                        };
                        var cleanup = function cleanup() {
                            if (global[cbName] && typeof global[cbName] === "function") {
                                global[cbName] = null;
                                delete global[cbName];
                            }
                        };
                        tag.onload = handleResult("loaded");
                        tag.onerror = handleResult("error");
                        tag.onreadystatechange = function() {
                            handleResult(tag.readyState);
                        };
                        // Pick off callback, if there is one
                        if (src.match(/callback=CALLBACK_NAME/)) {
                            src = src.replace(/(callback=)[^\&]+/, "$1" + cbName);
                            cb = window[cbName] = tag.onload;
                        } else tag.addEventListener("load", tag.onload);
                        tag.addEventListener("error", tag.onerror);
                        tag.src = src;
                        body.appendChild(tag);
                        return tag;
                    });
                    var initialState = {
                        loaded: false,
                        error: false,
                        promise: promise,
                        tag: tag
                    };
                    scriptMap.set(key, initialState);
                }
                return scriptMap.get(key).tag;
            };
            // let scriptTags = document.querySelectorAll('script')
            //
            // NodeList.prototype.filter = Array.prototype.filter;
            // NodeList.prototype.map = Array.prototype.map;
            // const initialScripts = scriptTags
            //   .filter(s => !!s.src)
            //   .map(s => s.src.split('?')[0])
            //   .reduce((memo, script) => {
            //     memo[script] = script;
            //     return memo;
            //   }, {});
            Object.keys(scripts).forEach(function(key) {
                var script = scripts[key];
                var tag = window._scriptMap.has(key) ? window._scriptMap.get(key).tag : Cache._scriptTag(key, script);
                Cache[key] = {
                    tag: tag,
                    onLoad: Cache._onLoad(key)
                };
            });
            return Cache;
        };
    }(window);
    exports1.default = ScriptCache;
});

});
parcelRequire.register("bOdGp", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
(function(global1, factory) {
    if (typeof define === "function" && define.amd) define([
        "module"
    ], factory);
    else {
        var mod;
        factory(module);
    }
})(undefined, function(module1) {
    "use strict";
    var _typeof = typeof Symbol === "function" && (0, $1ObTH._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $1ObTH._)(obj);
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $1ObTH._)(obj);
    };
    module1.exports = (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" && self.self === self && self || (typeof $parcel$global === "undefined" ? "undefined" : _typeof($parcel$global)) === "object" && $parcel$global.global === $parcel$global && $parcel$global || undefined;
});

});


parcelRequire.register("jBsPM", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var GoogleApi = exports1.GoogleApi = function GoogleApi(opts) {
        opts = opts || {};
        if (!opts.hasOwnProperty("apiKey")) throw new Error("You must pass an apiKey to use GoogleApi");
        var apiKey = opts.apiKey;
        var libraries = opts.libraries || [
            "places"
        ];
        var client = opts.client;
        var URL = opts.url || "https://maps.googleapis.com/maps/api/js";
        var googleVersion = opts.version || "3.31";
        var script = null;
        var google = typeof window !== "undefined" && window.google || null;
        var loading = false;
        var channel = null;
        var language = opts.language;
        var region = opts.region || null;
        var onLoadEvents = [];
        var url = function url() {
            var url = URL;
            var params = {
                key: apiKey,
                callback: "CALLBACK_NAME",
                libraries: libraries.join(","),
                client: client,
                v: googleVersion,
                channel: channel,
                language: language,
                region: region,
                onerror: "ERROR_FUNCTION"
            };
            var paramStr = Object.keys(params).filter(function(k) {
                return !!params[k];
            }).map(function(k) {
                return k + "=" + params[k];
            }).join("&");
            return url + "?" + paramStr;
        };
        return url();
    };
    exports1.default = GoogleApi;
});

});


parcelRequire.register("kA2Ux", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");



(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("cdv1q")));
    }
})(undefined, function(exports1, _react, _propTypes, _String) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _objectWithoutProperties = function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Marker = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var evtNames = [
        "click",
        "dblclick",
        "dragend",
        "mousedown",
        "mouseout",
        "mouseover",
        "mouseup",
        "recenter"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Marker = exports1.Marker = function(_React$Component) {
        _inherits(Marker, _React$Component);
        function Marker() {
            _classCallCheck(this, Marker);
            return _possibleConstructorReturn(this, (Marker.__proto__ || Object.getPrototypeOf(Marker)).apply(this, arguments));
        }
        _createClass(Marker, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.markerPromise = wrappedPromise();
                    this.renderMarker();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || this.props.position !== prevProps.position || this.props.icon !== prevProps.icon) {
                        if (this.marker) this.marker.setMap(null);
                        this.renderMarker();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.marker) this.marker.setMap(null);
                }
            },
            {
                key: "renderMarker",
                value: function renderMarker() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, position = _props.position, mapCenter = _props.mapCenter, icon = _props.icon, label = _props.label, draggable = _props.draggable, title = _props.title, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "position",
                        "mapCenter",
                        "icon",
                        "label",
                        "draggable",
                        "title"
                    ]);
                    if (!google) return null;
                    var pos = position || mapCenter;
                    if (!(pos instanceof google.maps.LatLng)) pos = new google.maps.LatLng(pos.lat, pos.lng);
                    var pref = _extends({
                        map: map,
                        position: pos,
                        icon: icon,
                        label: label,
                        title: title,
                        draggable: draggable
                    }, props);
                    this.marker = new google.maps.Marker(pref);
                    evtNames.forEach(function(e) {
                        _this2.marker.addListener(e, _this2.handleEvent(e));
                    });
                    this.markerPromise.resolve(this.marker);
                }
            },
            {
                key: "getMarker",
                value: function getMarker() {
                    return this.markerPromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.marker, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Marker;
    }(_react2.default.Component);
    Marker.propTypes = {
        position: _propTypes2.default.object,
        map: _propTypes2.default.object
    };
    evtNames.forEach(function(e) {
        return Marker.propTypes[e] = _propTypes2.default.func;
    });
    Marker.defaultProps = {
        name: "Marker"
    };
    exports1.default = Marker;
});

});
parcelRequire.register("aMJGV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7da1d47045483a0e$var$ReactIs, $7da1d47045483a0e$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("lrct3"))();

});
parcelRequire.register("lrct3", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aGGuH = parcelRequire("aGGuH");
function $f9b5ca6aeff231cf$var$emptyFunction() {}
function $f9b5ca6aeff231cf$var$emptyFunctionWithReset() {}
$f9b5ca6aeff231cf$var$emptyFunctionWithReset.resetWarningCache = $f9b5ca6aeff231cf$var$emptyFunction;
module.exports = function() {
    var shim = function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aGGuH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    };
    var getShim = function getShim() {
        return shim;
    };
    shim.isRequired = shim;
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $f9b5ca6aeff231cf$var$emptyFunctionWithReset,
        resetWarningCache: $f9b5ca6aeff231cf$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("aGGuH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7c7eca1397927a3e$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7c7eca1397927a3e$var$ReactPropTypesSecret;

});



parcelRequire.register("cdv1q", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var camelize = exports1.camelize = function camelize(str) {
        return str.split("_").map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join("");
    };
});

});


parcelRequire.register("T1vzD", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "react-dom",
        "react-dom/server"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("9nHRL")), (parcelRequire("lUrln")));
    }
})(undefined, function(exports1, _react, _propTypes, _reactDom, _server) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _objectWithoutProperties = function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.InfoWindow = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _server2 = _interopRequireDefault(_server);
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var InfoWindow = exports1.InfoWindow = function(_React$Component) {
        _inherits(InfoWindow, _React$Component);
        function InfoWindow() {
            _classCallCheck(this, InfoWindow);
            return _possibleConstructorReturn(this, (InfoWindow.__proto__ || Object.getPrototypeOf(InfoWindow)).apply(this, arguments));
        }
        _createClass(InfoWindow, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.renderInfoWindow();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _props = this.props, google1 = _props.google, map = _props.map;
                    if (!google1 || !map) return;
                    if (map !== prevProps.map) this.renderInfoWindow();
                    if (this.props.position !== prevProps.position) this.updatePosition();
                    if (this.props.children !== prevProps.children) this.updateContent();
                    if (this.props.visible !== prevProps.visible || this.props.marker !== prevProps.marker || this.props.position !== prevProps.position) this.props.visible ? this.openWindow() : this.closeWindow();
                }
            },
            {
                key: "renderInfoWindow",
                value: function renderInfoWindow() {
                    var _props2 = this.props, map = _props2.map, google1 = _props2.google, mapCenter = _props2.mapCenter, props = _objectWithoutProperties(_props2, [
                        "map",
                        "google",
                        "mapCenter"
                    ]);
                    if (!google1 || !google1.maps) return;
                    var iw = this.infowindow = new google1.maps.InfoWindow(_extends({
                        content: ""
                    }, props));
                    google1.maps.event.addListener(iw, "closeclick", this.onClose.bind(this));
                    google1.maps.event.addListener(iw, "domready", this.onOpen.bind(this));
                }
            },
            {
                key: "onOpen",
                value: function onOpen() {
                    if (this.props.onOpen) this.props.onOpen();
                }
            },
            {
                key: "onClose",
                value: function onClose() {
                    if (this.props.onClose) this.props.onClose();
                }
            },
            {
                key: "openWindow",
                value: function openWindow() {
                    this.infowindow.open(this.props.map, this.props.marker);
                }
            },
            {
                key: "updatePosition",
                value: function updatePosition() {
                    var pos = this.props.position;
                    if (!(pos instanceof google.maps.LatLng)) pos = pos && new google.maps.LatLng(pos.lat, pos.lng);
                    this.infowindow.setPosition(pos);
                }
            },
            {
                key: "updateContent",
                value: function updateContent() {
                    var content = this.renderChildren();
                    this.infowindow.setContent(content);
                }
            },
            {
                key: "closeWindow",
                value: function closeWindow() {
                    this.infowindow.close();
                }
            },
            {
                key: "renderChildren",
                value: function renderChildren() {
                    var children = this.props.children;
                    return _server2.default.renderToString(children);
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return InfoWindow;
    }(_react2.default.Component);
    InfoWindow.propTypes = {
        children: _propTypes2.default.element.isRequired,
        map: _propTypes2.default.object,
        marker: _propTypes2.default.object,
        position: _propTypes2.default.object,
        visible: _propTypes2.default.bool,
        // callbacks
        onClose: _propTypes2.default.func,
        onOpen: _propTypes2.default.func
    };
    InfoWindow.defaultProps = {
        visible: false
    };
    exports1.default = InfoWindow;
});

});
parcelRequire.register("lUrln", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $ff3409d93734d0a0$export$83d89fbfd8236492; }, function (v) { return $ff3409d93734d0a0$export$83d89fbfd8236492 = v; });
$parcel$export(module.exports, "renderToString", function () { return $ff3409d93734d0a0$export$80e7718417253a51; }, function (v) { return $ff3409d93734d0a0$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $ff3409d93734d0a0$export$eb3a06aef9e6ee51; }, function (v) { return $ff3409d93734d0a0$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToNodeStream", function () { return $ff3409d93734d0a0$export$307591e98609eddd; }, function (v) { return $ff3409d93734d0a0$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $ff3409d93734d0a0$export$b23711c915539651; }, function (v) { return $ff3409d93734d0a0$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToReadableStream", function () { return $ff3409d93734d0a0$export$7020a3240b287705; }, function (v) { return $ff3409d93734d0a0$export$7020a3240b287705 = v; });
var $ff3409d93734d0a0$export$83d89fbfd8236492;
var $ff3409d93734d0a0$export$80e7718417253a51;
var $ff3409d93734d0a0$export$eb3a06aef9e6ee51;
var $ff3409d93734d0a0$export$307591e98609eddd;
var $ff3409d93734d0a0$export$b23711c915539651;
var $ff3409d93734d0a0$export$7020a3240b287705;
"use strict";
var $ff3409d93734d0a0$var$l, $ff3409d93734d0a0$var$s;

$ff3409d93734d0a0$var$l = (parcelRequire("dCU8g"));

$ff3409d93734d0a0$var$s = (parcelRequire("aslFr"));
$ff3409d93734d0a0$export$83d89fbfd8236492 = $ff3409d93734d0a0$var$l.version;
$ff3409d93734d0a0$export$80e7718417253a51 = $ff3409d93734d0a0$var$l.renderToString;
$ff3409d93734d0a0$export$eb3a06aef9e6ee51 = $ff3409d93734d0a0$var$l.renderToStaticMarkup;
$ff3409d93734d0a0$export$307591e98609eddd = $ff3409d93734d0a0$var$l.renderToNodeStream;
$ff3409d93734d0a0$export$b23711c915539651 = $ff3409d93734d0a0$var$l.renderToStaticNodeStream;
$ff3409d93734d0a0$export$7020a3240b287705 = $ff3409d93734d0a0$var$s.renderToReadableStream;

});
parcelRequire.register("dCU8g", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", function () { return $9eba5dab1570c304$export$307591e98609eddd; }, function (v) { return $9eba5dab1570c304$export$307591e98609eddd = v; });
$parcel$export(module.exports, "renderToStaticMarkup", function () { return $9eba5dab1570c304$export$eb3a06aef9e6ee51; }, function (v) { return $9eba5dab1570c304$export$eb3a06aef9e6ee51 = v; });
$parcel$export(module.exports, "renderToStaticNodeStream", function () { return $9eba5dab1570c304$export$b23711c915539651; }, function (v) { return $9eba5dab1570c304$export$b23711c915539651 = v; });
$parcel$export(module.exports, "renderToString", function () { return $9eba5dab1570c304$export$80e7718417253a51; }, function (v) { return $9eba5dab1570c304$export$80e7718417253a51 = v; });
$parcel$export(module.exports, "version", function () { return $9eba5dab1570c304$export$83d89fbfd8236492; }, function (v) { return $9eba5dab1570c304$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1ObTH = parcelRequire("1ObTH");
var $9eba5dab1570c304$export$307591e98609eddd;
var $9eba5dab1570c304$export$eb3a06aef9e6ee51;
var $9eba5dab1570c304$export$b23711c915539651;
var $9eba5dab1570c304$export$80e7718417253a51;
var $9eba5dab1570c304$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");
function $9eba5dab1570c304$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9eba5dab1570c304$var$p = Object.prototype.hasOwnProperty, $9eba5dab1570c304$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9eba5dab1570c304$var$ha = {}, $9eba5dab1570c304$var$ia = {};
function $9eba5dab1570c304$var$ja(a) {
    if ($9eba5dab1570c304$var$p.call($9eba5dab1570c304$var$ia, a)) return !0;
    if ($9eba5dab1570c304$var$p.call($9eba5dab1570c304$var$ha, a)) return !1;
    if ($9eba5dab1570c304$var$fa.test(a)) return $9eba5dab1570c304$var$ia[a] = !0;
    $9eba5dab1570c304$var$ha[a] = !0;
    return !1;
}
function $9eba5dab1570c304$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $9eba5dab1570c304$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9eba5dab1570c304$var$t[b] = new $9eba5dab1570c304$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9eba5dab1570c304$var$ka = /[\-:]([a-z])/g;
function $9eba5dab1570c304$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9eba5dab1570c304$var$ka, $9eba5dab1570c304$var$la);
    $9eba5dab1570c304$var$t[b] = new $9eba5dab1570c304$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9eba5dab1570c304$var$ka, $9eba5dab1570c304$var$la);
    $9eba5dab1570c304$var$t[b] = new $9eba5dab1570c304$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9eba5dab1570c304$var$ka, $9eba5dab1570c304$var$la);
    $9eba5dab1570c304$var$t[b] = new $9eba5dab1570c304$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9eba5dab1570c304$var$t.xlinkHref = new $9eba5dab1570c304$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9eba5dab1570c304$var$t[a] = new $9eba5dab1570c304$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $9eba5dab1570c304$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9eba5dab1570c304$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9eba5dab1570c304$var$u).forEach(function(a) {
    $9eba5dab1570c304$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9eba5dab1570c304$var$u[b] = $9eba5dab1570c304$var$u[a];
    });
});
var $9eba5dab1570c304$var$na = /["'&<>]/;
function $9eba5dab1570c304$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $9eba5dab1570c304$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $9eba5dab1570c304$var$oa = /([A-Z])/g, $9eba5dab1570c304$var$pa = /^ms-/, $9eba5dab1570c304$var$qa = Array.isArray;
function $9eba5dab1570c304$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $9eba5dab1570c304$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $9eba5dab1570c304$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $9eba5dab1570c304$var$w(2, null);
        case "math":
            return $9eba5dab1570c304$var$w(3, null);
        case "foreignObject":
            return $9eba5dab1570c304$var$w(1, null);
        case "table":
            return $9eba5dab1570c304$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $9eba5dab1570c304$var$w(5, null);
        case "colgroup":
            return $9eba5dab1570c304$var$w(7, null);
        case "tr":
            return $9eba5dab1570c304$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $9eba5dab1570c304$var$w(1, null) : a;
}
var $9eba5dab1570c304$var$sa = new Map;
function $9eba5dab1570c304$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($9eba5dab1570c304$var$l(62));
    b = !0;
    for(var d in c)if ($9eba5dab1570c304$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $9eba5dab1570c304$var$v(d);
                f = $9eba5dab1570c304$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $9eba5dab1570c304$var$sa.get(e);
                void 0 !== g ? e = g : (g = $9eba5dab1570c304$var$v(e.replace($9eba5dab1570c304$var$oa, "-$1").toLowerCase().replace($9eba5dab1570c304$var$pa, "-ms-")), $9eba5dab1570c304$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $9eba5dab1570c304$var$p.call($9eba5dab1570c304$var$u, d) ? "" + f : f + "px" : $9eba5dab1570c304$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $9eba5dab1570c304$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $9eba5dab1570c304$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $9eba5dab1570c304$var$t.hasOwnProperty(c) ? $9eba5dab1570c304$var$t[c] : null, null !== b) {
            switch(typeof d === "undefined" ? "undefined" : (0, $1ObTH._)(d)){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $9eba5dab1570c304$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $9eba5dab1570c304$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $9eba5dab1570c304$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $9eba5dab1570c304$var$v(d), '"');
            }
        } else if ($9eba5dab1570c304$var$ja(c)) {
            switch(typeof d === "undefined" ? "undefined" : (0, $1ObTH._)(d)){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $9eba5dab1570c304$var$v(d), '"');
        }
    }
}
function $9eba5dab1570c304$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($9eba5dab1570c304$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($9eba5dab1570c304$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $9eba5dab1570c304$var$ua(a) {
    var b = "";
    $6cds3.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $9eba5dab1570c304$var$va(a, b, c, d) {
    a.push($9eba5dab1570c304$var$A(c));
    var f = c = null, e;
    for(e in b)if ($9eba5dab1570c304$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $9eba5dab1570c304$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $9eba5dab1570c304$var$y(a, f, c);
    return "string" === typeof c ? (a.push($9eba5dab1570c304$var$v(c)), null) : c;
}
var $9eba5dab1570c304$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $9eba5dab1570c304$var$xa = new Map;
function $9eba5dab1570c304$var$A(a) {
    var b = $9eba5dab1570c304$var$xa.get(a);
    if (void 0 === b) {
        if (!$9eba5dab1570c304$var$wa.test(a)) throw Error($9eba5dab1570c304$var$l(65, a));
        b = "<" + a;
        $9eba5dab1570c304$var$xa.set(a, b);
    }
    return b;
}
function $9eba5dab1570c304$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($9eba5dab1570c304$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($9eba5dab1570c304$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $9eba5dab1570c304$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $9eba5dab1570c304$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($9eba5dab1570c304$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($9eba5dab1570c304$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $9eba5dab1570c304$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $9eba5dab1570c304$var$ua(h), $9eba5dab1570c304$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $9eba5dab1570c304$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($9eba5dab1570c304$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($9eba5dab1570c304$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($9eba5dab1570c304$var$l(91));
                default:
                    $9eba5dab1570c304$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($9eba5dab1570c304$var$l(92));
                if ($9eba5dab1570c304$var$qa(n) && 1 < n.length) throw Error($9eba5dab1570c304$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($9eba5dab1570c304$var$v("" + e));
            return null;
        case "input":
            a.push($9eba5dab1570c304$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($9eba5dab1570c304$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9eba5dab1570c304$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $9eba5dab1570c304$var$x(a, d, g, m);
            }
            null !== n ? $9eba5dab1570c304$var$x(a, d, "checked", n) : null !== k && $9eba5dab1570c304$var$x(a, d, "checked", k);
            null !== e ? $9eba5dab1570c304$var$x(a, d, "value", e) : null !== h && $9eba5dab1570c304$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($9eba5dab1570c304$var$A("menuitem"));
            for(var C in c)if ($9eba5dab1570c304$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9eba5dab1570c304$var$l(400));
                default:
                    $9eba5dab1570c304$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($9eba5dab1570c304$var$A("title"));
            e = null;
            for(q in c)if ($9eba5dab1570c304$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($9eba5dab1570c304$var$l(434));
                default:
                    $9eba5dab1570c304$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($9eba5dab1570c304$var$A(b));
            g = e = null;
            for(k in c)if ($9eba5dab1570c304$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $9eba5dab1570c304$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($9eba5dab1570c304$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($9eba5dab1570c304$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($9eba5dab1570c304$var$A(b));
            for(var D in c)if ($9eba5dab1570c304$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($9eba5dab1570c304$var$l(399, b));
                default:
                    $9eba5dab1570c304$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $9eba5dab1570c304$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $9eba5dab1570c304$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $9eba5dab1570c304$var$va(a, c, b, d);
            a.push($9eba5dab1570c304$var$A(b));
            g = e = null;
            for(m in c)if ($9eba5dab1570c304$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $9eba5dab1570c304$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $9eba5dab1570c304$var$ja(m) && "function" !== typeof h && "symbol" !== (typeof h === "undefined" ? "undefined" : (0, $1ObTH._)(h)) && a.push(" ", m, '="', $9eba5dab1570c304$var$v(h), '"');
            }
            a.push(">");
            $9eba5dab1570c304$var$y(a, g, e);
            return e;
    }
}
function $9eba5dab1570c304$var$za(a, b, c) {
    a.push('<!--$?--><template id="');
    if (null === c) throw Error($9eba5dab1570c304$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $9eba5dab1570c304$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($9eba5dab1570c304$var$l(397));
    }
}
function $9eba5dab1570c304$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($9eba5dab1570c304$var$l(397));
    }
}
var $9eba5dab1570c304$var$Ca = /[<\u2028\u2029]/g;
function $9eba5dab1570c304$var$Da(a) {
    return JSON.stringify(a).replace($9eba5dab1570c304$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $9eba5dab1570c304$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $9eba5dab1570c304$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($9eba5dab1570c304$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("<!-- -->"), a.push($9eba5dab1570c304$var$v(b)), a = !0);
    return a;
}
var $9eba5dab1570c304$var$B = Object.assign, $9eba5dab1570c304$var$Ga = Symbol.for("react.element"), $9eba5dab1570c304$var$Ha = Symbol.for("react.portal"), $9eba5dab1570c304$var$Ia = Symbol.for("react.fragment"), $9eba5dab1570c304$var$Ja = Symbol.for("react.strict_mode"), $9eba5dab1570c304$var$Ka = Symbol.for("react.profiler"), $9eba5dab1570c304$var$La = Symbol.for("react.provider"), $9eba5dab1570c304$var$Ma = Symbol.for("react.context"), $9eba5dab1570c304$var$Na = Symbol.for("react.forward_ref"), $9eba5dab1570c304$var$Oa = Symbol.for("react.suspense"), $9eba5dab1570c304$var$Pa = Symbol.for("react.suspense_list"), $9eba5dab1570c304$var$Qa = Symbol.for("react.memo"), $9eba5dab1570c304$var$Ra = Symbol.for("react.lazy"), $9eba5dab1570c304$var$Sa = Symbol.for("react.scope"), $9eba5dab1570c304$var$Ta = Symbol.for("react.debug_trace_mode"), $9eba5dab1570c304$var$Ua = Symbol.for("react.legacy_hidden"), $9eba5dab1570c304$var$Va = Symbol.for("react.default_value"), $9eba5dab1570c304$var$Wa = Symbol.iterator;
function $9eba5dab1570c304$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9eba5dab1570c304$var$Ia:
            return "Fragment";
        case $9eba5dab1570c304$var$Ha:
            return "Portal";
        case $9eba5dab1570c304$var$Ka:
            return "Profiler";
        case $9eba5dab1570c304$var$Ja:
            return "StrictMode";
        case $9eba5dab1570c304$var$Oa:
            return "Suspense";
        case $9eba5dab1570c304$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9eba5dab1570c304$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $9eba5dab1570c304$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $9eba5dab1570c304$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9eba5dab1570c304$var$Qa:
            return b = a.displayName || null, null !== b ? b : $9eba5dab1570c304$var$Xa(a.type) || "Memo";
        case $9eba5dab1570c304$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $9eba5dab1570c304$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $9eba5dab1570c304$var$Ya = {};
function $9eba5dab1570c304$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $9eba5dab1570c304$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $9eba5dab1570c304$var$E = null;
function $9eba5dab1570c304$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($9eba5dab1570c304$var$l(401));
        } else {
            if (null === c) throw Error($9eba5dab1570c304$var$l(401));
            $9eba5dab1570c304$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $9eba5dab1570c304$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $9eba5dab1570c304$var$$a(a);
}
function $9eba5dab1570c304$var$ab(a) {
    var b = a.parent;
    null !== b && $9eba5dab1570c304$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $9eba5dab1570c304$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($9eba5dab1570c304$var$l(402));
    a.depth === b.depth ? $9eba5dab1570c304$var$F(a, b) : $9eba5dab1570c304$var$bb(a, b);
}
function $9eba5dab1570c304$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($9eba5dab1570c304$var$l(402));
    a.depth === c.depth ? $9eba5dab1570c304$var$F(a, c) : $9eba5dab1570c304$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $9eba5dab1570c304$var$G(a) {
    var b = $9eba5dab1570c304$var$E;
    b !== a && (null === b ? $9eba5dab1570c304$var$ab(a) : null === a ? $9eba5dab1570c304$var$$a(b) : b.depth === a.depth ? $9eba5dab1570c304$var$F(b, a) : b.depth > a.depth ? $9eba5dab1570c304$var$bb(b, a) : $9eba5dab1570c304$var$cb(b, a), $9eba5dab1570c304$var$E = a);
}
var $9eba5dab1570c304$var$db = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueSetState: function enqueueSetState(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function enqueueForceUpdate() {}
};
function $9eba5dab1570c304$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $9eba5dab1570c304$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $9eba5dab1570c304$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $9eba5dab1570c304$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $9eba5dab1570c304$var$B({}, e, h)) : $9eba5dab1570c304$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $9eba5dab1570c304$var$fb = {
    id: 1,
    overflow: ""
};
function $9eba5dab1570c304$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $9eba5dab1570c304$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $9eba5dab1570c304$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $9eba5dab1570c304$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $9eba5dab1570c304$var$H = Math.clz32 ? Math.clz32 : $9eba5dab1570c304$var$hb, $9eba5dab1570c304$var$ib = Math.log, $9eba5dab1570c304$var$jb = Math.LN2;
function $9eba5dab1570c304$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9eba5dab1570c304$var$ib(a) / $9eba5dab1570c304$var$jb | 0) | 0;
}
function $9eba5dab1570c304$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9eba5dab1570c304$var$lb = "function" === typeof Object.is ? Object.is : $9eba5dab1570c304$var$kb, $9eba5dab1570c304$var$I = null, $9eba5dab1570c304$var$ob = null, $9eba5dab1570c304$var$J = null, $9eba5dab1570c304$var$K = null, $9eba5dab1570c304$var$L = !1, $9eba5dab1570c304$var$M = !1, $9eba5dab1570c304$var$N = 0, $9eba5dab1570c304$var$O = null, $9eba5dab1570c304$var$P = 0;
function $9eba5dab1570c304$var$Q() {
    if (null === $9eba5dab1570c304$var$I) throw Error($9eba5dab1570c304$var$l(321));
    return $9eba5dab1570c304$var$I;
}
function $9eba5dab1570c304$var$pb() {
    if (0 < $9eba5dab1570c304$var$P) throw Error($9eba5dab1570c304$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $9eba5dab1570c304$var$qb() {
    null === $9eba5dab1570c304$var$K ? null === $9eba5dab1570c304$var$J ? ($9eba5dab1570c304$var$L = !1, $9eba5dab1570c304$var$J = $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$pb()) : ($9eba5dab1570c304$var$L = !0, $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$J) : null === $9eba5dab1570c304$var$K.next ? ($9eba5dab1570c304$var$L = !1, $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$K.next = $9eba5dab1570c304$var$pb()) : ($9eba5dab1570c304$var$L = !0, $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$K.next);
    return $9eba5dab1570c304$var$K;
}
function $9eba5dab1570c304$var$rb() {
    $9eba5dab1570c304$var$ob = $9eba5dab1570c304$var$I = null;
    $9eba5dab1570c304$var$M = !1;
    $9eba5dab1570c304$var$J = null;
    $9eba5dab1570c304$var$P = 0;
    $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$O = null;
}
function $9eba5dab1570c304$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9eba5dab1570c304$var$tb(a, b, c) {
    $9eba5dab1570c304$var$I = $9eba5dab1570c304$var$Q();
    $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$qb();
    if ($9eba5dab1570c304$var$L) {
        var d = $9eba5dab1570c304$var$K.queue;
        b = d.dispatch;
        if (null !== $9eba5dab1570c304$var$O && (c = $9eba5dab1570c304$var$O.get(d), void 0 !== c)) {
            $9eba5dab1570c304$var$O.delete(d);
            d = $9eba5dab1570c304$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $9eba5dab1570c304$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $9eba5dab1570c304$var$K.memoizedState,
            b
        ];
    }
    a = a === $9eba5dab1570c304$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $9eba5dab1570c304$var$K.memoizedState = a;
    a = $9eba5dab1570c304$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $9eba5dab1570c304$var$ub.bind(null, $9eba5dab1570c304$var$I, a);
    return [
        $9eba5dab1570c304$var$K.memoizedState,
        a
    ];
}
function $9eba5dab1570c304$var$vb(a, b) {
    $9eba5dab1570c304$var$I = $9eba5dab1570c304$var$Q();
    $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $9eba5dab1570c304$var$K) {
        var c = $9eba5dab1570c304$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$9eba5dab1570c304$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $9eba5dab1570c304$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9eba5dab1570c304$var$ub(a, b, c) {
    if (25 <= $9eba5dab1570c304$var$P) throw Error($9eba5dab1570c304$var$l(301));
    if (a === $9eba5dab1570c304$var$I) {
        if ($9eba5dab1570c304$var$M = !0, a = {
            action: c,
            next: null
        }, null === $9eba5dab1570c304$var$O && ($9eba5dab1570c304$var$O = new Map), c = $9eba5dab1570c304$var$O.get(b), void 0 === c) $9eba5dab1570c304$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $9eba5dab1570c304$var$wb() {
    throw Error($9eba5dab1570c304$var$l(394));
}
function $9eba5dab1570c304$var$R() {}
var $9eba5dab1570c304$var$xb = {
    readContext: function readContext(a) {
        return a._currentValue2;
    },
    useContext: function useContext(a) {
        $9eba5dab1570c304$var$Q();
        return a._currentValue2;
    },
    useMemo: $9eba5dab1570c304$var$vb,
    useReducer: $9eba5dab1570c304$var$tb,
    useRef: function useRef(a) {
        $9eba5dab1570c304$var$I = $9eba5dab1570c304$var$Q();
        $9eba5dab1570c304$var$K = $9eba5dab1570c304$var$qb();
        var b = $9eba5dab1570c304$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $9eba5dab1570c304$var$K.memoizedState = a) : b;
    },
    useState: function useState(a) {
        return $9eba5dab1570c304$var$tb($9eba5dab1570c304$var$sb, a);
    },
    useInsertionEffect: $9eba5dab1570c304$var$R,
    useLayoutEffect: function useLayoutEffect() {},
    useCallback: function useCallback(a, b) {
        return $9eba5dab1570c304$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $9eba5dab1570c304$var$R,
    useEffect: $9eba5dab1570c304$var$R,
    useDebugValue: $9eba5dab1570c304$var$R,
    useDeferredValue: function useDeferredValue(a) {
        $9eba5dab1570c304$var$Q();
        return a;
    },
    useTransition: function useTransition() {
        $9eba5dab1570c304$var$Q();
        return [
            !1,
            $9eba5dab1570c304$var$wb
        ];
    },
    useId: function useId() {
        var a = $9eba5dab1570c304$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $9eba5dab1570c304$var$H(a) - 1)).toString(32) + b;
        var c = $9eba5dab1570c304$var$S;
        if (null === c) throw Error($9eba5dab1570c304$var$l(404));
        b = $9eba5dab1570c304$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function useMutableSource(a, b) {
        $9eba5dab1570c304$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        if (void 0 === c) throw Error($9eba5dab1570c304$var$l(407));
        return c();
    }
}, $9eba5dab1570c304$var$S = null, $9eba5dab1570c304$var$yb = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $9eba5dab1570c304$var$zb(a) {
    console.error(a);
    return null;
}
function $9eba5dab1570c304$var$T() {}
function $9eba5dab1570c304$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $9eba5dab1570c304$var$zb : f,
        onAllReady: void 0 === e ? $9eba5dab1570c304$var$T : e,
        onShellReady: void 0 === g ? $9eba5dab1570c304$var$T : g,
        onShellError: void 0 === h ? $9eba5dab1570c304$var$T : h,
        onFatalError: void 0 === k ? $9eba5dab1570c304$var$T : k
    };
    c = $9eba5dab1570c304$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $9eba5dab1570c304$var$Bb(b, a, null, c, n, $9eba5dab1570c304$var$Ya, null, $9eba5dab1570c304$var$fb);
    m.push(a);
    return b;
}
function $9eba5dab1570c304$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function ping() {
            var _$b = a.pingedTasks;
            _$b.push(k);
            1 === _$b.length && $9eba5dab1570c304$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $9eba5dab1570c304$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $9eba5dab1570c304$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + (typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a)) + '" instead');
    return a;
}
function $9eba5dab1570c304$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $9eba5dab1570c304$var$Db(a, b, c, d, f) {
    $9eba5dab1570c304$var$I = {};
    $9eba5dab1570c304$var$ob = b;
    $9eba5dab1570c304$var$N = 0;
    for(a = c(d, f); $9eba5dab1570c304$var$M;)$9eba5dab1570c304$var$M = !1, $9eba5dab1570c304$var$N = 0, $9eba5dab1570c304$var$P += 1, $9eba5dab1570c304$var$K = null, a = c(d, f);
    $9eba5dab1570c304$var$rb();
    return a;
}
function $9eba5dab1570c304$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($9eba5dab1570c304$var$l(108, $9eba5dab1570c304$var$Xa(d) || "Unknown", h));
            d = $9eba5dab1570c304$var$B({}, g, c);
        }
        b.legacyContext = d;
        $9eba5dab1570c304$var$X(a, b, f);
        b.legacyContext = g;
    } else $9eba5dab1570c304$var$X(a, b, f);
}
function $9eba5dab1570c304$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $9eba5dab1570c304$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9eba5dab1570c304$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $9eba5dab1570c304$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $9eba5dab1570c304$var$eb(e, c, d, f);
            $9eba5dab1570c304$var$Eb(a, b, e, c);
        } else {
            e = $9eba5dab1570c304$var$Za(c, b.legacyContext);
            f = $9eba5dab1570c304$var$Db(a, b, c, d, e);
            var g = 0 !== $9eba5dab1570c304$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $9eba5dab1570c304$var$eb(f, c, d, e), $9eba5dab1570c304$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $9eba5dab1570c304$var$gb(d, 1, 0);
                try {
                    $9eba5dab1570c304$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $9eba5dab1570c304$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $9eba5dab1570c304$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $9eba5dab1570c304$var$ra(g, c, d);
        $9eba5dab1570c304$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $9eba5dab1570c304$var$Ua:
            case $9eba5dab1570c304$var$Ta:
            case $9eba5dab1570c304$var$Ja:
            case $9eba5dab1570c304$var$Ka:
            case $9eba5dab1570c304$var$Ia:
                $9eba5dab1570c304$var$X(a, b, d.children);
                return;
            case $9eba5dab1570c304$var$Pa:
                $9eba5dab1570c304$var$X(a, b, d.children);
                return;
            case $9eba5dab1570c304$var$Sa:
                throw Error($9eba5dab1570c304$var$l(343));
            case $9eba5dab1570c304$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $9eba5dab1570c304$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $9eba5dab1570c304$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($9eba5dab1570c304$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("<!-- -->"), m.status = 1, $9eba5dab1570c304$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $9eba5dab1570c304$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $9eba5dab1570c304$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $9eba5dab1570c304$var$Na:
                d = $9eba5dab1570c304$var$Db(a, b, c.render, d, f);
                if (0 !== $9eba5dab1570c304$var$N) {
                    c = b.treeContext;
                    b.treeContext = $9eba5dab1570c304$var$gb(c, 1, 0);
                    try {
                        $9eba5dab1570c304$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $9eba5dab1570c304$var$X(a, b, d);
                return;
            case $9eba5dab1570c304$var$Qa:
                c = c.type;
                d = $9eba5dab1570c304$var$Fb(c, d);
                $9eba5dab1570c304$var$Gb(a, b, c, d, f);
                return;
            case $9eba5dab1570c304$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $9eba5dab1570c304$var$E;
                $9eba5dab1570c304$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $9eba5dab1570c304$var$X(a, b, f);
                a = $9eba5dab1570c304$var$E;
                if (null === a) throw Error($9eba5dab1570c304$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $9eba5dab1570c304$var$Va ? a.context._defaultValue : d;
                a = $9eba5dab1570c304$var$E = a.parent;
                b.context = a;
                return;
            case $9eba5dab1570c304$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $9eba5dab1570c304$var$X(a, b, d);
                return;
            case $9eba5dab1570c304$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $9eba5dab1570c304$var$Fb(c, d);
                $9eba5dab1570c304$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($9eba5dab1570c304$var$l(130, null == c ? c : typeof c === "undefined" ? "undefined" : (0, $1ObTH._)(c), ""));
    }
}
function $9eba5dab1570c304$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $9eba5dab1570c304$var$Ga:
                $9eba5dab1570c304$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $9eba5dab1570c304$var$Ha:
                throw Error($9eba5dab1570c304$var$l(257));
            case $9eba5dab1570c304$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $9eba5dab1570c304$var$X(a, b, c);
                return;
        }
        if ($9eba5dab1570c304$var$qa(c)) {
            $9eba5dab1570c304$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $9eba5dab1570c304$var$Wa && c[$9eba5dab1570c304$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $9eba5dab1570c304$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($9eba5dab1570c304$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $9eba5dab1570c304$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $9eba5dab1570c304$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $9eba5dab1570c304$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $9eba5dab1570c304$var$gb(e, d, f);
        try {
            $9eba5dab1570c304$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $9eba5dab1570c304$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $9eba5dab1570c304$var$X(a, b, c);
    } catch (k) {
        if ($9eba5dab1570c304$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $9eba5dab1570c304$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $9eba5dab1570c304$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $9eba5dab1570c304$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $9eba5dab1570c304$var$G(e), k;
    }
}
function $9eba5dab1570c304$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $9eba5dab1570c304$var$Kb(this, b, a);
}
function $9eba5dab1570c304$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($9eba5dab1570c304$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $9eba5dab1570c304$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $9eba5dab1570c304$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $9eba5dab1570c304$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $9eba5dab1570c304$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($9eba5dab1570c304$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $9eba5dab1570c304$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $9eba5dab1570c304$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($9eba5dab1570c304$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($9eba5dab1570c304$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $9eba5dab1570c304$var$Cb(a) {
    if (2 !== a.status) {
        var b = $9eba5dab1570c304$var$E, c = $9eba5dab1570c304$var$yb.current;
        $9eba5dab1570c304$var$yb.current = $9eba5dab1570c304$var$xb;
        var d = $9eba5dab1570c304$var$S;
        $9eba5dab1570c304$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $9eba5dab1570c304$var$G(g.context);
                    try {
                        $9eba5dab1570c304$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("<!-- -->"), g.abortSet.delete(g), k.status = 1, $9eba5dab1570c304$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($9eba5dab1570c304$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $9eba5dab1570c304$var$V(h, q);
                            null === n ? $9eba5dab1570c304$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $9eba5dab1570c304$var$Mb(a, a.destination);
        } catch (z) {
            $9eba5dab1570c304$var$V(a, z), $9eba5dab1570c304$var$W(a, z);
        } finally{
            $9eba5dab1570c304$var$S = d, $9eba5dab1570c304$var$yb.current = c, c === $9eba5dab1570c304$var$xb && $9eba5dab1570c304$var$G(b);
        }
    }
}
function $9eba5dab1570c304$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $9eba5dab1570c304$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($9eba5dab1570c304$var$l(390));
    }
}
function $9eba5dab1570c304$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $9eba5dab1570c304$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("<!--$!-->"), b.push("<template"), d && (b.push(' data-dgst="'), d = $9eba5dab1570c304$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $9eba5dab1570c304$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $9eba5dab1570c304$var$za(b, a.responseState, d);
        $9eba5dab1570c304$var$Z(a, b, c);
        return b.push("<!--/$-->");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $9eba5dab1570c304$var$za(b, a.responseState, d.id), $9eba5dab1570c304$var$Z(a, b, c), b.push("<!--/$-->");
    a.responseState.generateStaticMarkup || b.push("<!--$-->");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($9eba5dab1570c304$var$l(391));
    $9eba5dab1570c304$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("<!--/$-->");
    return a;
}
function $9eba5dab1570c304$var$Ob(a, b, c) {
    $9eba5dab1570c304$var$Aa(b, a.responseState, c.formatContext, c.id);
    $9eba5dab1570c304$var$Nb(a, b, c);
    return $9eba5dab1570c304$var$Ba(b, c.formatContext);
}
function $9eba5dab1570c304$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$9eba5dab1570c304$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($9eba5dab1570c304$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")</script>');
}
function $9eba5dab1570c304$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($9eba5dab1570c304$var$l(392));
        return $9eba5dab1570c304$var$Ob(a, b, d);
    }
    $9eba5dab1570c304$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")</script>');
}
function $9eba5dab1570c304$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $9eba5dab1570c304$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($9eba5dab1570c304$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $9eba5dab1570c304$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $9eba5dab1570c304$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $9eba5dab1570c304$var$Da(q);
                d.push(z);
            }
            if (!d.push(")</script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$9eba5dab1570c304$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$9eba5dab1570c304$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$9eba5dab1570c304$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $9eba5dab1570c304$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $9eba5dab1570c304$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $9eba5dab1570c304$var$Mb(a, a.destination);
    } catch (d) {
        $9eba5dab1570c304$var$V(a, d), $9eba5dab1570c304$var$W(a, d);
    }
}
function $9eba5dab1570c304$var$Sb() {}
function $9eba5dab1570c304$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function push(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function destroy(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $9eba5dab1570c304$var$Ab(a, $9eba5dab1570c304$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $9eba5dab1570c304$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $9eba5dab1570c304$var$Cb(a);
    $9eba5dab1570c304$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $9eba5dab1570c304$var$Mb(a, h);
        } catch (m) {
            $9eba5dab1570c304$var$V(a, m), $9eba5dab1570c304$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($9eba5dab1570c304$var$l(426));
    return g;
}
$9eba5dab1570c304$export$307591e98609eddd = function() {
    throw Error($9eba5dab1570c304$var$l(207));
};
$9eba5dab1570c304$export$eb3a06aef9e6ee51 = function(a, b) {
    return $9eba5dab1570c304$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$9eba5dab1570c304$export$b23711c915539651 = function() {
    throw Error($9eba5dab1570c304$var$l(208));
};
$9eba5dab1570c304$export$80e7718417253a51 = function(a, b) {
    return $9eba5dab1570c304$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$9eba5dab1570c304$export$83d89fbfd8236492 = "18.2.0";

});

parcelRequire.register("aslFr", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", function () { return $79cd5395ca36be60$export$7020a3240b287705; }, function (v) { return $79cd5395ca36be60$export$7020a3240b287705 = v; });
$parcel$export(module.exports, "version", function () { return $79cd5395ca36be60$export$83d89fbfd8236492; }, function (v) { return $79cd5395ca36be60$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $1ObTH = parcelRequire("1ObTH");
var $79cd5395ca36be60$export$7020a3240b287705;
var $79cd5395ca36be60$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");
function $79cd5395ca36be60$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $79cd5395ca36be60$var$l = null, $79cd5395ca36be60$var$n = 0;
function $79cd5395ca36be60$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $79cd5395ca36be60$var$n && (a.enqueue(new Uint8Array($79cd5395ca36be60$var$l.buffer, 0, $79cd5395ca36be60$var$n)), $79cd5395ca36be60$var$l = new Uint8Array(512), $79cd5395ca36be60$var$n = 0), a.enqueue(b);
        else {
            var c = $79cd5395ca36be60$var$l.length - $79cd5395ca36be60$var$n;
            c < b.length && (0 === c ? a.enqueue($79cd5395ca36be60$var$l) : ($79cd5395ca36be60$var$l.set(b.subarray(0, c), $79cd5395ca36be60$var$n), a.enqueue($79cd5395ca36be60$var$l), b = b.subarray(c)), $79cd5395ca36be60$var$l = new Uint8Array(512), $79cd5395ca36be60$var$n = 0);
            $79cd5395ca36be60$var$l.set(b, $79cd5395ca36be60$var$n);
            $79cd5395ca36be60$var$n += b.length;
        }
    }
}
function $79cd5395ca36be60$var$t(a, b) {
    $79cd5395ca36be60$var$p(a, b);
    return !0;
}
function $79cd5395ca36be60$var$ba(a) {
    $79cd5395ca36be60$var$l && 0 < $79cd5395ca36be60$var$n && (a.enqueue(new Uint8Array($79cd5395ca36be60$var$l.buffer, 0, $79cd5395ca36be60$var$n)), $79cd5395ca36be60$var$l = null, $79cd5395ca36be60$var$n = 0);
}
var $79cd5395ca36be60$var$ca = new TextEncoder;
function $79cd5395ca36be60$var$u(a) {
    return $79cd5395ca36be60$var$ca.encode(a);
}
function $79cd5395ca36be60$var$w(a) {
    return $79cd5395ca36be60$var$ca.encode(a);
}
function $79cd5395ca36be60$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $79cd5395ca36be60$var$x = Object.prototype.hasOwnProperty, $79cd5395ca36be60$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $79cd5395ca36be60$var$fa = {}, $79cd5395ca36be60$var$ha = {};
function $79cd5395ca36be60$var$ia(a) {
    if ($79cd5395ca36be60$var$x.call($79cd5395ca36be60$var$ha, a)) return !0;
    if ($79cd5395ca36be60$var$x.call($79cd5395ca36be60$var$fa, a)) return !1;
    if ($79cd5395ca36be60$var$ea.test(a)) return $79cd5395ca36be60$var$ha[a] = !0;
    $79cd5395ca36be60$var$fa[a] = !0;
    return !1;
}
function $79cd5395ca36be60$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $79cd5395ca36be60$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $79cd5395ca36be60$var$z[b] = new $79cd5395ca36be60$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $79cd5395ca36be60$var$ja = /[\-:]([a-z])/g;
function $79cd5395ca36be60$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($79cd5395ca36be60$var$ja, $79cd5395ca36be60$var$ka);
    $79cd5395ca36be60$var$z[b] = new $79cd5395ca36be60$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($79cd5395ca36be60$var$ja, $79cd5395ca36be60$var$ka);
    $79cd5395ca36be60$var$z[b] = new $79cd5395ca36be60$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($79cd5395ca36be60$var$ja, $79cd5395ca36be60$var$ka);
    $79cd5395ca36be60$var$z[b] = new $79cd5395ca36be60$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$79cd5395ca36be60$var$z.xlinkHref = new $79cd5395ca36be60$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $79cd5395ca36be60$var$z[a] = new $79cd5395ca36be60$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $79cd5395ca36be60$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $79cd5395ca36be60$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($79cd5395ca36be60$var$B).forEach(function(a) {
    $79cd5395ca36be60$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $79cd5395ca36be60$var$B[b] = $79cd5395ca36be60$var$B[a];
    });
});
var $79cd5395ca36be60$var$oa = /["'&<>]/;
function $79cd5395ca36be60$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $79cd5395ca36be60$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $79cd5395ca36be60$var$pa = /([A-Z])/g, $79cd5395ca36be60$var$qa = /^ms-/, $79cd5395ca36be60$var$ra = Array.isArray, $79cd5395ca36be60$var$sa = $79cd5395ca36be60$var$w("<script>"), $79cd5395ca36be60$var$ta = $79cd5395ca36be60$var$w("</script>"), $79cd5395ca36be60$var$ua = $79cd5395ca36be60$var$w('<script src="'), $79cd5395ca36be60$var$va = $79cd5395ca36be60$var$w('<script type="module" src="'), $79cd5395ca36be60$var$wa = $79cd5395ca36be60$var$w('" async=""></script>'), $79cd5395ca36be60$var$xa = /(<\/|<)(s)(cript)/gi;
function $79cd5395ca36be60$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $79cd5395ca36be60$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $79cd5395ca36be60$var$sa : $79cd5395ca36be60$var$w('<script nonce="' + $79cd5395ca36be60$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $79cd5395ca36be60$var$u(("" + c).replace($79cd5395ca36be60$var$xa, $79cd5395ca36be60$var$ya)), $79cd5395ca36be60$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($79cd5395ca36be60$var$ua, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d[c])), $79cd5395ca36be60$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($79cd5395ca36be60$var$va, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(f[d])), $79cd5395ca36be60$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $79cd5395ca36be60$var$w(a + "P:"),
        segmentPrefix: $79cd5395ca36be60$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $79cd5395ca36be60$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $79cd5395ca36be60$var$Aa(a) {
    return $79cd5395ca36be60$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $79cd5395ca36be60$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $79cd5395ca36be60$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $79cd5395ca36be60$var$D(2, null);
        case "math":
            return $79cd5395ca36be60$var$D(3, null);
        case "foreignObject":
            return $79cd5395ca36be60$var$D(1, null);
        case "table":
            return $79cd5395ca36be60$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $79cd5395ca36be60$var$D(5, null);
        case "colgroup":
            return $79cd5395ca36be60$var$D(7, null);
        case "tr":
            return $79cd5395ca36be60$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $79cd5395ca36be60$var$D(1, null) : a;
}
var $79cd5395ca36be60$var$Ca = $79cd5395ca36be60$var$w("<!-- -->");
function $79cd5395ca36be60$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($79cd5395ca36be60$var$Ca);
    a.push($79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(b)));
    return !0;
}
var $79cd5395ca36be60$var$Ea = new Map, $79cd5395ca36be60$var$Fa = $79cd5395ca36be60$var$w(' style="'), $79cd5395ca36be60$var$Ga = $79cd5395ca36be60$var$w(":"), $79cd5395ca36be60$var$Ha = $79cd5395ca36be60$var$w(";");
function $79cd5395ca36be60$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($79cd5395ca36be60$var$k(62));
    b = !0;
    for(var d in c)if ($79cd5395ca36be60$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d));
                f = $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $79cd5395ca36be60$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $79cd5395ca36be60$var$w($79cd5395ca36be60$var$C(e.replace($79cd5395ca36be60$var$pa, "-$1").toLowerCase().replace($79cd5395ca36be60$var$qa, "-ms-"))), $79cd5395ca36be60$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $79cd5395ca36be60$var$x.call($79cd5395ca36be60$var$B, d) ? $79cd5395ca36be60$var$u("" + f) : $79cd5395ca36be60$var$u(f + "px") : $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($79cd5395ca36be60$var$Fa, e, $79cd5395ca36be60$var$Ga, f)) : a.push($79cd5395ca36be60$var$Ha, e, $79cd5395ca36be60$var$Ga, f);
        }
    }
    b || a.push($79cd5395ca36be60$var$E);
}
var $79cd5395ca36be60$var$H = $79cd5395ca36be60$var$w(" "), $79cd5395ca36be60$var$I = $79cd5395ca36be60$var$w('="'), $79cd5395ca36be60$var$E = $79cd5395ca36be60$var$w('"'), $79cd5395ca36be60$var$Ja = $79cd5395ca36be60$var$w('=""');
function $79cd5395ca36be60$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $79cd5395ca36be60$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $79cd5395ca36be60$var$z.hasOwnProperty(c) ? $79cd5395ca36be60$var$z[c] : null, null !== b) {
            switch(typeof d === "undefined" ? "undefined" : (0, $1ObTH._)(d)){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $79cd5395ca36be60$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($79cd5395ca36be60$var$H, c, $79cd5395ca36be60$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($79cd5395ca36be60$var$H, c, $79cd5395ca36be60$var$Ja) : !1 !== d && a.push($79cd5395ca36be60$var$H, c, $79cd5395ca36be60$var$I, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d)), $79cd5395ca36be60$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($79cd5395ca36be60$var$H, c, $79cd5395ca36be60$var$I, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d)), $79cd5395ca36be60$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($79cd5395ca36be60$var$H, c, $79cd5395ca36be60$var$I, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d)), $79cd5395ca36be60$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($79cd5395ca36be60$var$H, c, $79cd5395ca36be60$var$I, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d)), $79cd5395ca36be60$var$E);
            }
        } else if ($79cd5395ca36be60$var$ia(c)) {
            switch(typeof d === "undefined" ? "undefined" : (0, $1ObTH._)(d)){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($79cd5395ca36be60$var$H, $79cd5395ca36be60$var$u(c), $79cd5395ca36be60$var$I, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d)), $79cd5395ca36be60$var$E);
        }
    }
}
var $79cd5395ca36be60$var$K = $79cd5395ca36be60$var$w(">"), $79cd5395ca36be60$var$Ka = $79cd5395ca36be60$var$w("/>");
function $79cd5395ca36be60$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($79cd5395ca36be60$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($79cd5395ca36be60$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($79cd5395ca36be60$var$u("" + b));
    }
}
function $79cd5395ca36be60$var$La(a) {
    var b = "";
    $6cds3.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $79cd5395ca36be60$var$Ma = $79cd5395ca36be60$var$w(' selected=""');
function $79cd5395ca36be60$var$Na(a, b, c, d) {
    a.push($79cd5395ca36be60$var$M(c));
    var f = c = null, e;
    for(e in b)if ($79cd5395ca36be60$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $79cd5395ca36be60$var$J(a, d, e, g);
        }
    }
    a.push($79cd5395ca36be60$var$K);
    $79cd5395ca36be60$var$L(a, f, c);
    return "string" === typeof c ? (a.push($79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(c))), null) : c;
}
var $79cd5395ca36be60$var$Oa = $79cd5395ca36be60$var$w("\n"), $79cd5395ca36be60$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $79cd5395ca36be60$var$Qa = new Map;
function $79cd5395ca36be60$var$M(a) {
    var b = $79cd5395ca36be60$var$Qa.get(a);
    if (void 0 === b) {
        if (!$79cd5395ca36be60$var$Pa.test(a)) throw Error($79cd5395ca36be60$var$k(65, a));
        b = $79cd5395ca36be60$var$w("<" + a);
        $79cd5395ca36be60$var$Qa.set(a, b);
    }
    return b;
}
var $79cd5395ca36be60$var$Ra = $79cd5395ca36be60$var$w("<!DOCTYPE html>");
function $79cd5395ca36be60$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($79cd5395ca36be60$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($79cd5395ca36be60$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $79cd5395ca36be60$var$J(a, d, r, h);
                }
            }
            a.push($79cd5395ca36be60$var$K);
            $79cd5395ca36be60$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($79cd5395ca36be60$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($79cd5395ca36be60$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $79cd5395ca36be60$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $79cd5395ca36be60$var$La(h), $79cd5395ca36be60$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($79cd5395ca36be60$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($79cd5395ca36be60$var$Ma);
            } else q && a.push($79cd5395ca36be60$var$Ma);
            a.push($79cd5395ca36be60$var$K);
            $79cd5395ca36be60$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($79cd5395ca36be60$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($79cd5395ca36be60$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($79cd5395ca36be60$var$k(91));
                default:
                    $79cd5395ca36be60$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($79cd5395ca36be60$var$K);
            if (null != r) {
                if (null != e) throw Error($79cd5395ca36be60$var$k(92));
                if ($79cd5395ca36be60$var$ra(r) && 1 < r.length) throw Error($79cd5395ca36be60$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($79cd5395ca36be60$var$Oa);
            null !== e && a.push($79cd5395ca36be60$var$u($79cd5395ca36be60$var$C("" + e)));
            return null;
        case "input":
            a.push($79cd5395ca36be60$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($79cd5395ca36be60$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($79cd5395ca36be60$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $79cd5395ca36be60$var$J(a, d, g, q);
            }
            null !== r ? $79cd5395ca36be60$var$J(a, d, "checked", r) : null !== m && $79cd5395ca36be60$var$J(a, d, "checked", m);
            null !== e ? $79cd5395ca36be60$var$J(a, d, "value", e) : null !== h && $79cd5395ca36be60$var$J(a, d, "value", h);
            a.push($79cd5395ca36be60$var$Ka);
            return null;
        case "menuitem":
            a.push($79cd5395ca36be60$var$M("menuitem"));
            for(var A in c)if ($79cd5395ca36be60$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($79cd5395ca36be60$var$k(400));
                default:
                    $79cd5395ca36be60$var$J(a, d, A, e);
            }
            a.push($79cd5395ca36be60$var$K);
            return null;
        case "title":
            a.push($79cd5395ca36be60$var$M("title"));
            e = null;
            for(v in c)if ($79cd5395ca36be60$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($79cd5395ca36be60$var$k(434));
                default:
                    $79cd5395ca36be60$var$J(a, d, v, g);
            }
            a.push($79cd5395ca36be60$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($79cd5395ca36be60$var$M(b));
            g = e = null;
            for(m in c)if ($79cd5395ca36be60$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $79cd5395ca36be60$var$J(a, d, m, h);
            }
            a.push($79cd5395ca36be60$var$K);
            if (null != g) {
                if (null != e) throw Error($79cd5395ca36be60$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($79cd5395ca36be60$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($79cd5395ca36be60$var$Oa, $79cd5395ca36be60$var$u(c)) : a.push($79cd5395ca36be60$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($79cd5395ca36be60$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($79cd5395ca36be60$var$M(b));
            for(var F in c)if ($79cd5395ca36be60$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($79cd5395ca36be60$var$k(399, b));
                default:
                    $79cd5395ca36be60$var$J(a, d, F, e);
            }
            a.push($79cd5395ca36be60$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $79cd5395ca36be60$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($79cd5395ca36be60$var$Ra), $79cd5395ca36be60$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $79cd5395ca36be60$var$Na(a, c, b, d);
            a.push($79cd5395ca36be60$var$M(b));
            g = e = null;
            for(q in c)if ($79cd5395ca36be60$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $79cd5395ca36be60$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $79cd5395ca36be60$var$ia(q) && "function" !== typeof h && "symbol" !== (typeof h === "undefined" ? "undefined" : (0, $1ObTH._)(h)) && a.push($79cd5395ca36be60$var$H, $79cd5395ca36be60$var$u(q), $79cd5395ca36be60$var$I, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(h)), $79cd5395ca36be60$var$E);
            }
            a.push($79cd5395ca36be60$var$K);
            $79cd5395ca36be60$var$L(a, g, e);
            return e;
    }
}
var $79cd5395ca36be60$var$Ta = $79cd5395ca36be60$var$w("</"), $79cd5395ca36be60$var$Ua = $79cd5395ca36be60$var$w(">"), $79cd5395ca36be60$var$Va = $79cd5395ca36be60$var$w('<template id="'), $79cd5395ca36be60$var$Wa = $79cd5395ca36be60$var$w('"></template>'), $79cd5395ca36be60$var$Xa = $79cd5395ca36be60$var$w("<!--$-->"), $79cd5395ca36be60$var$Ya = $79cd5395ca36be60$var$w('<!--$?--><template id="'), $79cd5395ca36be60$var$Za = $79cd5395ca36be60$var$w('"></template>'), $79cd5395ca36be60$var$$a = $79cd5395ca36be60$var$w("<!--$!-->"), $79cd5395ca36be60$var$ab = $79cd5395ca36be60$var$w("<!--/$-->"), $79cd5395ca36be60$var$bb = $79cd5395ca36be60$var$w("<template"), $79cd5395ca36be60$var$cb = $79cd5395ca36be60$var$w('"'), $79cd5395ca36be60$var$db = $79cd5395ca36be60$var$w(' data-dgst="');
$79cd5395ca36be60$var$w(' data-msg="');
$79cd5395ca36be60$var$w(' data-stck="');
var $79cd5395ca36be60$var$eb = $79cd5395ca36be60$var$w("></template>");
function $79cd5395ca36be60$var$fb(a, b, c) {
    $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$Ya);
    if (null === c) throw Error($79cd5395ca36be60$var$k(395));
    $79cd5395ca36be60$var$p(a, c);
    return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$Za);
}
var $79cd5395ca36be60$var$gb = $79cd5395ca36be60$var$w('<div hidden id="'), $79cd5395ca36be60$var$hb = $79cd5395ca36be60$var$w('">'), $79cd5395ca36be60$var$ib = $79cd5395ca36be60$var$w("</div>"), $79cd5395ca36be60$var$jb = $79cd5395ca36be60$var$w('<svg aria-hidden="true" style="display:none" id="'), $79cd5395ca36be60$var$kb = $79cd5395ca36be60$var$w('">'), $79cd5395ca36be60$var$lb = $79cd5395ca36be60$var$w("</svg>"), $79cd5395ca36be60$var$mb = $79cd5395ca36be60$var$w('<math aria-hidden="true" style="display:none" id="'), $79cd5395ca36be60$var$nb = $79cd5395ca36be60$var$w('">'), $79cd5395ca36be60$var$ob = $79cd5395ca36be60$var$w("</math>"), $79cd5395ca36be60$var$pb = $79cd5395ca36be60$var$w('<table hidden id="'), $79cd5395ca36be60$var$qb = $79cd5395ca36be60$var$w('">'), $79cd5395ca36be60$var$rb = $79cd5395ca36be60$var$w("</table>"), $79cd5395ca36be60$var$sb = $79cd5395ca36be60$var$w('<table hidden><tbody id="'), $79cd5395ca36be60$var$tb = $79cd5395ca36be60$var$w('">'), $79cd5395ca36be60$var$ub = $79cd5395ca36be60$var$w("</tbody></table>"), $79cd5395ca36be60$var$vb = $79cd5395ca36be60$var$w('<table hidden><tr id="'), $79cd5395ca36be60$var$wb = $79cd5395ca36be60$var$w('">'), $79cd5395ca36be60$var$xb = $79cd5395ca36be60$var$w("</tr></table>"), $79cd5395ca36be60$var$yb = $79cd5395ca36be60$var$w('<table hidden><colgroup id="'), $79cd5395ca36be60$var$zb = $79cd5395ca36be60$var$w('">'), $79cd5395ca36be60$var$Ab = $79cd5395ca36be60$var$w("</colgroup></table>");
function $79cd5395ca36be60$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$gb), $79cd5395ca36be60$var$p(a, b.segmentPrefix), $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$u(d.toString(16))), $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$hb);
        case 2:
            return $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$jb), $79cd5395ca36be60$var$p(a, b.segmentPrefix), $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$u(d.toString(16))), $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$kb);
        case 3:
            return $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$mb), $79cd5395ca36be60$var$p(a, b.segmentPrefix), $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$u(d.toString(16))), $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$nb);
        case 4:
            return $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$pb), $79cd5395ca36be60$var$p(a, b.segmentPrefix), $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$u(d.toString(16))), $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$qb);
        case 5:
            return $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$sb), $79cd5395ca36be60$var$p(a, b.segmentPrefix), $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$u(d.toString(16))), $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$tb);
        case 6:
            return $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$vb), $79cd5395ca36be60$var$p(a, b.segmentPrefix), $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$u(d.toString(16))), $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$wb);
        case 7:
            return $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$yb), $79cd5395ca36be60$var$p(a, b.segmentPrefix), $79cd5395ca36be60$var$p(a, $79cd5395ca36be60$var$u(d.toString(16))), $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$zb);
        default:
            throw Error($79cd5395ca36be60$var$k(397));
    }
}
function $79cd5395ca36be60$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$ib);
        case 2:
            return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$lb);
        case 3:
            return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$ob);
        case 4:
            return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$rb);
        case 5:
            return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$ub);
        case 6:
            return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$xb);
        case 7:
            return $79cd5395ca36be60$var$t(a, $79cd5395ca36be60$var$Ab);
        default:
            throw Error($79cd5395ca36be60$var$k(397));
    }
}
var $79cd5395ca36be60$var$Db = $79cd5395ca36be60$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $79cd5395ca36be60$var$Eb = $79cd5395ca36be60$var$w('$RS("'), $79cd5395ca36be60$var$Gb = $79cd5395ca36be60$var$w('","'), $79cd5395ca36be60$var$Hb = $79cd5395ca36be60$var$w('")</script>'), $79cd5395ca36be60$var$Ib = $79cd5395ca36be60$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $79cd5395ca36be60$var$Jb = $79cd5395ca36be60$var$w('$RC("'), $79cd5395ca36be60$var$Kb = $79cd5395ca36be60$var$w('","'), $79cd5395ca36be60$var$Lb = $79cd5395ca36be60$var$w('")</script>'), $79cd5395ca36be60$var$Mb = $79cd5395ca36be60$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $79cd5395ca36be60$var$Nb = $79cd5395ca36be60$var$w('$RX("'), $79cd5395ca36be60$var$Ob = $79cd5395ca36be60$var$w('"'), $79cd5395ca36be60$var$Pb = $79cd5395ca36be60$var$w(")</script>"), $79cd5395ca36be60$var$Qb = $79cd5395ca36be60$var$w(","), $79cd5395ca36be60$var$Rb = /[<\u2028\u2029]/g;
function $79cd5395ca36be60$var$Sb(a) {
    return JSON.stringify(a).replace($79cd5395ca36be60$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $79cd5395ca36be60$var$N = Object.assign, $79cd5395ca36be60$var$Tb = Symbol.for("react.element"), $79cd5395ca36be60$var$Ub = Symbol.for("react.portal"), $79cd5395ca36be60$var$Vb = Symbol.for("react.fragment"), $79cd5395ca36be60$var$Wb = Symbol.for("react.strict_mode"), $79cd5395ca36be60$var$Xb = Symbol.for("react.profiler"), $79cd5395ca36be60$var$Yb = Symbol.for("react.provider"), $79cd5395ca36be60$var$Zb = Symbol.for("react.context"), $79cd5395ca36be60$var$$b = Symbol.for("react.forward_ref"), $79cd5395ca36be60$var$ac = Symbol.for("react.suspense"), $79cd5395ca36be60$var$bc = Symbol.for("react.suspense_list"), $79cd5395ca36be60$var$cc = Symbol.for("react.memo"), $79cd5395ca36be60$var$dc = Symbol.for("react.lazy"), $79cd5395ca36be60$var$ec = Symbol.for("react.scope"), $79cd5395ca36be60$var$fc = Symbol.for("react.debug_trace_mode"), $79cd5395ca36be60$var$gc = Symbol.for("react.legacy_hidden"), $79cd5395ca36be60$var$hc = Symbol.for("react.default_value"), $79cd5395ca36be60$var$ic = Symbol.iterator;
function $79cd5395ca36be60$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $79cd5395ca36be60$var$Vb:
            return "Fragment";
        case $79cd5395ca36be60$var$Ub:
            return "Portal";
        case $79cd5395ca36be60$var$Xb:
            return "Profiler";
        case $79cd5395ca36be60$var$Wb:
            return "StrictMode";
        case $79cd5395ca36be60$var$ac:
            return "Suspense";
        case $79cd5395ca36be60$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $79cd5395ca36be60$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $79cd5395ca36be60$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $79cd5395ca36be60$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $79cd5395ca36be60$var$cc:
            return b = a.displayName || null, null !== b ? b : $79cd5395ca36be60$var$jc(a.type) || "Memo";
        case $79cd5395ca36be60$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $79cd5395ca36be60$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $79cd5395ca36be60$var$kc = {};
function $79cd5395ca36be60$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $79cd5395ca36be60$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $79cd5395ca36be60$var$O = null;
function $79cd5395ca36be60$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($79cd5395ca36be60$var$k(401));
        } else {
            if (null === c) throw Error($79cd5395ca36be60$var$k(401));
            $79cd5395ca36be60$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $79cd5395ca36be60$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $79cd5395ca36be60$var$mc(a);
}
function $79cd5395ca36be60$var$nc(a) {
    var b = a.parent;
    null !== b && $79cd5395ca36be60$var$nc(b);
    a.context._currentValue = a.value;
}
function $79cd5395ca36be60$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($79cd5395ca36be60$var$k(402));
    a.depth === b.depth ? $79cd5395ca36be60$var$P(a, b) : $79cd5395ca36be60$var$oc(a, b);
}
function $79cd5395ca36be60$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($79cd5395ca36be60$var$k(402));
    a.depth === c.depth ? $79cd5395ca36be60$var$P(a, c) : $79cd5395ca36be60$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $79cd5395ca36be60$var$Q(a) {
    var b = $79cd5395ca36be60$var$O;
    b !== a && (null === b ? $79cd5395ca36be60$var$nc(a) : null === a ? $79cd5395ca36be60$var$mc(b) : b.depth === a.depth ? $79cd5395ca36be60$var$P(b, a) : b.depth > a.depth ? $79cd5395ca36be60$var$oc(b, a) : $79cd5395ca36be60$var$pc(b, a), $79cd5395ca36be60$var$O = a);
}
var $79cd5395ca36be60$var$qc = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueSetState: function enqueueSetState(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function enqueueReplaceState(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function enqueueForceUpdate() {}
};
function $79cd5395ca36be60$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $79cd5395ca36be60$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $79cd5395ca36be60$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $79cd5395ca36be60$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $79cd5395ca36be60$var$N({}, e, h)) : $79cd5395ca36be60$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $79cd5395ca36be60$var$sc = {
    id: 1,
    overflow: ""
};
function $79cd5395ca36be60$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $79cd5395ca36be60$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $79cd5395ca36be60$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $79cd5395ca36be60$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $79cd5395ca36be60$var$uc = Math.clz32 ? Math.clz32 : $79cd5395ca36be60$var$vc, $79cd5395ca36be60$var$wc = Math.log, $79cd5395ca36be60$var$xc = Math.LN2;
function $79cd5395ca36be60$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($79cd5395ca36be60$var$wc(a) / $79cd5395ca36be60$var$xc | 0) | 0;
}
function $79cd5395ca36be60$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $79cd5395ca36be60$var$zc = "function" === typeof Object.is ? Object.is : $79cd5395ca36be60$var$yc, $79cd5395ca36be60$var$R = null, $79cd5395ca36be60$var$Ac = null, $79cd5395ca36be60$var$Bc = null, $79cd5395ca36be60$var$S = null, $79cd5395ca36be60$var$T = !1, $79cd5395ca36be60$var$Cc = !1, $79cd5395ca36be60$var$U = 0, $79cd5395ca36be60$var$V = null, $79cd5395ca36be60$var$Dc = 0;
function $79cd5395ca36be60$var$W() {
    if (null === $79cd5395ca36be60$var$R) throw Error($79cd5395ca36be60$var$k(321));
    return $79cd5395ca36be60$var$R;
}
function $79cd5395ca36be60$var$Ec() {
    if (0 < $79cd5395ca36be60$var$Dc) throw Error($79cd5395ca36be60$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $79cd5395ca36be60$var$Fc() {
    null === $79cd5395ca36be60$var$S ? null === $79cd5395ca36be60$var$Bc ? ($79cd5395ca36be60$var$T = !1, $79cd5395ca36be60$var$Bc = $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$Ec()) : ($79cd5395ca36be60$var$T = !0, $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$Bc) : null === $79cd5395ca36be60$var$S.next ? ($79cd5395ca36be60$var$T = !1, $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$S.next = $79cd5395ca36be60$var$Ec()) : ($79cd5395ca36be60$var$T = !0, $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$S.next);
    return $79cd5395ca36be60$var$S;
}
function $79cd5395ca36be60$var$Gc() {
    $79cd5395ca36be60$var$Ac = $79cd5395ca36be60$var$R = null;
    $79cd5395ca36be60$var$Cc = !1;
    $79cd5395ca36be60$var$Bc = null;
    $79cd5395ca36be60$var$Dc = 0;
    $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$V = null;
}
function $79cd5395ca36be60$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $79cd5395ca36be60$var$Ic(a, b, c) {
    $79cd5395ca36be60$var$R = $79cd5395ca36be60$var$W();
    $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$Fc();
    if ($79cd5395ca36be60$var$T) {
        var d = $79cd5395ca36be60$var$S.queue;
        b = d.dispatch;
        if (null !== $79cd5395ca36be60$var$V && (c = $79cd5395ca36be60$var$V.get(d), void 0 !== c)) {
            $79cd5395ca36be60$var$V.delete(d);
            d = $79cd5395ca36be60$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $79cd5395ca36be60$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $79cd5395ca36be60$var$S.memoizedState,
            b
        ];
    }
    a = a === $79cd5395ca36be60$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $79cd5395ca36be60$var$S.memoizedState = a;
    a = $79cd5395ca36be60$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $79cd5395ca36be60$var$Jc.bind(null, $79cd5395ca36be60$var$R, a);
    return [
        $79cd5395ca36be60$var$S.memoizedState,
        a
    ];
}
function $79cd5395ca36be60$var$Kc(a, b) {
    $79cd5395ca36be60$var$R = $79cd5395ca36be60$var$W();
    $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $79cd5395ca36be60$var$S) {
        var c = $79cd5395ca36be60$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$79cd5395ca36be60$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $79cd5395ca36be60$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $79cd5395ca36be60$var$Jc(a, b, c) {
    if (25 <= $79cd5395ca36be60$var$Dc) throw Error($79cd5395ca36be60$var$k(301));
    if (a === $79cd5395ca36be60$var$R) {
        if ($79cd5395ca36be60$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $79cd5395ca36be60$var$V && ($79cd5395ca36be60$var$V = new Map), c = $79cd5395ca36be60$var$V.get(b), void 0 === c) $79cd5395ca36be60$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $79cd5395ca36be60$var$Lc() {
    throw Error($79cd5395ca36be60$var$k(394));
}
function $79cd5395ca36be60$var$Mc() {}
var $79cd5395ca36be60$var$Oc = {
    readContext: function readContext(a) {
        return a._currentValue;
    },
    useContext: function useContext(a) {
        $79cd5395ca36be60$var$W();
        return a._currentValue;
    },
    useMemo: $79cd5395ca36be60$var$Kc,
    useReducer: $79cd5395ca36be60$var$Ic,
    useRef: function useRef(a) {
        $79cd5395ca36be60$var$R = $79cd5395ca36be60$var$W();
        $79cd5395ca36be60$var$S = $79cd5395ca36be60$var$Fc();
        var b = $79cd5395ca36be60$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $79cd5395ca36be60$var$S.memoizedState = a) : b;
    },
    useState: function useState(a) {
        return $79cd5395ca36be60$var$Ic($79cd5395ca36be60$var$Hc, a);
    },
    useInsertionEffect: $79cd5395ca36be60$var$Mc,
    useLayoutEffect: function useLayoutEffect() {},
    useCallback: function useCallback(a, b) {
        return $79cd5395ca36be60$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $79cd5395ca36be60$var$Mc,
    useEffect: $79cd5395ca36be60$var$Mc,
    useDebugValue: $79cd5395ca36be60$var$Mc,
    useDeferredValue: function useDeferredValue(a) {
        $79cd5395ca36be60$var$W();
        return a;
    },
    useTransition: function useTransition() {
        $79cd5395ca36be60$var$W();
        return [
            !1,
            $79cd5395ca36be60$var$Lc
        ];
    },
    useId: function useId() {
        var a = $79cd5395ca36be60$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $79cd5395ca36be60$var$uc(a) - 1)).toString(32) + b;
        var c = $79cd5395ca36be60$var$Nc;
        if (null === c) throw Error($79cd5395ca36be60$var$k(404));
        b = $79cd5395ca36be60$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function useMutableSource(a, b) {
        $79cd5395ca36be60$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        if (void 0 === c) throw Error($79cd5395ca36be60$var$k(407));
        return c();
    }
}, $79cd5395ca36be60$var$Nc = null, $79cd5395ca36be60$var$Pc = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $79cd5395ca36be60$var$Qc(a) {
    console.error(a);
    return null;
}
function $79cd5395ca36be60$var$X() {}
function $79cd5395ca36be60$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $79cd5395ca36be60$var$Qc : f,
        onAllReady: void 0 === e ? $79cd5395ca36be60$var$X : e,
        onShellReady: void 0 === g ? $79cd5395ca36be60$var$X : g,
        onShellError: void 0 === h ? $79cd5395ca36be60$var$X : h,
        onFatalError: void 0 === m ? $79cd5395ca36be60$var$X : m
    };
    c = $79cd5395ca36be60$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $79cd5395ca36be60$var$Tc(b, a, null, c, r, $79cd5395ca36be60$var$kc, null, $79cd5395ca36be60$var$sc);
    q.push(a);
    return b;
}
function $79cd5395ca36be60$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function ping() {
            var _$b = a.pingedTasks;
            _$b.push(m);
            1 === _$b.length && $79cd5395ca36be60$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $79cd5395ca36be60$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $79cd5395ca36be60$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + (typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a)) + '" instead');
    return a;
}
function $79cd5395ca36be60$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $79cd5395ca36be60$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $79cd5395ca36be60$var$Wc(a, b, c, d, f) {
    $79cd5395ca36be60$var$R = {};
    $79cd5395ca36be60$var$Ac = b;
    $79cd5395ca36be60$var$U = 0;
    for(a = c(d, f); $79cd5395ca36be60$var$Cc;)$79cd5395ca36be60$var$Cc = !1, $79cd5395ca36be60$var$U = 0, $79cd5395ca36be60$var$Dc += 1, $79cd5395ca36be60$var$S = null, a = c(d, f);
    $79cd5395ca36be60$var$Gc();
    return a;
}
function $79cd5395ca36be60$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($79cd5395ca36be60$var$k(108, $79cd5395ca36be60$var$jc(d) || "Unknown", h));
            d = $79cd5395ca36be60$var$N({}, g, c);
        }
        b.legacyContext = d;
        $79cd5395ca36be60$var$Z(a, b, f);
        b.legacyContext = g;
    } else $79cd5395ca36be60$var$Z(a, b, f);
}
function $79cd5395ca36be60$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $79cd5395ca36be60$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $79cd5395ca36be60$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $79cd5395ca36be60$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $79cd5395ca36be60$var$rc(e, c, d, f);
            $79cd5395ca36be60$var$Xc(a, b, e, c);
        } else {
            e = $79cd5395ca36be60$var$lc(c, b.legacyContext);
            f = $79cd5395ca36be60$var$Wc(a, b, c, d, e);
            var g = 0 !== $79cd5395ca36be60$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $79cd5395ca36be60$var$rc(f, c, d, e), $79cd5395ca36be60$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $79cd5395ca36be60$var$tc(d, 1, 0);
                try {
                    $79cd5395ca36be60$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $79cd5395ca36be60$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $79cd5395ca36be60$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $79cd5395ca36be60$var$Ba(g, c, d);
        $79cd5395ca36be60$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($79cd5395ca36be60$var$Ta, $79cd5395ca36be60$var$u(c), $79cd5395ca36be60$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $79cd5395ca36be60$var$gc:
            case $79cd5395ca36be60$var$fc:
            case $79cd5395ca36be60$var$Wb:
            case $79cd5395ca36be60$var$Xb:
            case $79cd5395ca36be60$var$Vb:
                $79cd5395ca36be60$var$Z(a, b, d.children);
                return;
            case $79cd5395ca36be60$var$bc:
                $79cd5395ca36be60$var$Z(a, b, d.children);
                return;
            case $79cd5395ca36be60$var$ec:
                throw Error($79cd5395ca36be60$var$k(343));
            case $79cd5395ca36be60$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $79cd5395ca36be60$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $79cd5395ca36be60$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($79cd5395ca36be60$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($79cd5395ca36be60$var$Ca), q.status = 1, $79cd5395ca36be60$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $79cd5395ca36be60$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $79cd5395ca36be60$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $79cd5395ca36be60$var$$b:
                d = $79cd5395ca36be60$var$Wc(a, b, c.render, d, f);
                if (0 !== $79cd5395ca36be60$var$U) {
                    c = b.treeContext;
                    b.treeContext = $79cd5395ca36be60$var$tc(c, 1, 0);
                    try {
                        $79cd5395ca36be60$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $79cd5395ca36be60$var$Z(a, b, d);
                return;
            case $79cd5395ca36be60$var$cc:
                c = c.type;
                d = $79cd5395ca36be60$var$Yc(c, d);
                $79cd5395ca36be60$var$Zc(a, b, c, d, f);
                return;
            case $79cd5395ca36be60$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $79cd5395ca36be60$var$O;
                $79cd5395ca36be60$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $79cd5395ca36be60$var$Z(a, b, f);
                a = $79cd5395ca36be60$var$O;
                if (null === a) throw Error($79cd5395ca36be60$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $79cd5395ca36be60$var$hc ? a.context._defaultValue : d;
                a = $79cd5395ca36be60$var$O = a.parent;
                b.context = a;
                return;
            case $79cd5395ca36be60$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $79cd5395ca36be60$var$Z(a, b, d);
                return;
            case $79cd5395ca36be60$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $79cd5395ca36be60$var$Yc(c, d);
                $79cd5395ca36be60$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($79cd5395ca36be60$var$k(130, null == c ? c : typeof c === "undefined" ? "undefined" : (0, $1ObTH._)(c), ""));
    }
}
function $79cd5395ca36be60$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $79cd5395ca36be60$var$Tb:
                $79cd5395ca36be60$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $79cd5395ca36be60$var$Ub:
                throw Error($79cd5395ca36be60$var$k(257));
            case $79cd5395ca36be60$var$dc:
                var d = c._init;
                c = d(c._payload);
                $79cd5395ca36be60$var$Z(a, b, c);
                return;
        }
        if ($79cd5395ca36be60$var$ra(c)) {
            $79cd5395ca36be60$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $79cd5395ca36be60$var$ic && c[$79cd5395ca36be60$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $79cd5395ca36be60$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($79cd5395ca36be60$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $79cd5395ca36be60$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $79cd5395ca36be60$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $79cd5395ca36be60$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $79cd5395ca36be60$var$tc(e, d, f);
        try {
            $79cd5395ca36be60$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $79cd5395ca36be60$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $79cd5395ca36be60$var$Z(a, b, c);
    } catch (m) {
        if ($79cd5395ca36be60$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $79cd5395ca36be60$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $79cd5395ca36be60$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $79cd5395ca36be60$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $79cd5395ca36be60$var$Q(e), m;
    }
}
function $79cd5395ca36be60$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $79cd5395ca36be60$var$dd(this, b, a);
}
function $79cd5395ca36be60$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($79cd5395ca36be60$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $79cd5395ca36be60$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $79cd5395ca36be60$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $79cd5395ca36be60$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $79cd5395ca36be60$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($79cd5395ca36be60$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $79cd5395ca36be60$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $79cd5395ca36be60$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($79cd5395ca36be60$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($79cd5395ca36be60$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $79cd5395ca36be60$var$Uc(a) {
    if (2 !== a.status) {
        var b = $79cd5395ca36be60$var$O, c = $79cd5395ca36be60$var$Pc.current;
        $79cd5395ca36be60$var$Pc.current = $79cd5395ca36be60$var$Oc;
        var d = $79cd5395ca36be60$var$Nc;
        $79cd5395ca36be60$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $79cd5395ca36be60$var$Q(g.context);
                    try {
                        $79cd5395ca36be60$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($79cd5395ca36be60$var$Ca), g.abortSet.delete(g), m.status = 1, $79cd5395ca36be60$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($79cd5395ca36be60$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $79cd5395ca36be60$var$Y(h, v);
                            null === r ? $79cd5395ca36be60$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $79cd5395ca36be60$var$fd(a, a.destination);
        } catch (G) {
            $79cd5395ca36be60$var$Y(a, G), $79cd5395ca36be60$var$Vc(a, G);
        } finally{
            $79cd5395ca36be60$var$Nc = d, $79cd5395ca36be60$var$Pc.current = c, c === $79cd5395ca36be60$var$Oc && $79cd5395ca36be60$var$Q(b);
        }
    }
}
function $79cd5395ca36be60$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$Va);
            $79cd5395ca36be60$var$p(b, a.placeholderPrefix);
            a = $79cd5395ca36be60$var$u(d.toString(16));
            $79cd5395ca36be60$var$p(b, a);
            return $79cd5395ca36be60$var$t(b, $79cd5395ca36be60$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$79cd5395ca36be60$var$p(b, d[e]);
                f = $79cd5395ca36be60$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$79cd5395ca36be60$var$p(b, d[e]);
            e < d.length && (f = $79cd5395ca36be60$var$t(b, d[e]));
            return f;
        default:
            throw Error($79cd5395ca36be60$var$k(390));
    }
}
function $79cd5395ca36be60$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $79cd5395ca36be60$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $79cd5395ca36be60$var$t(b, $79cd5395ca36be60$var$$a), $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$bb), d && ($79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$db), $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$C(d))), $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$cb)), $79cd5395ca36be60$var$t(b, $79cd5395ca36be60$var$eb), $79cd5395ca36be60$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $79cd5395ca36be60$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $79cd5395ca36be60$var$fb(b, a.responseState, d);
        $79cd5395ca36be60$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $79cd5395ca36be60$var$fb(b, a.responseState, d.id), $79cd5395ca36be60$var$gd(a, b, c);
    else {
        $79cd5395ca36be60$var$t(b, $79cd5395ca36be60$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($79cd5395ca36be60$var$k(391));
        $79cd5395ca36be60$var$hd(a, b, c[0]);
    }
    return $79cd5395ca36be60$var$t(b, $79cd5395ca36be60$var$ab);
}
function $79cd5395ca36be60$var$id(a, b, c) {
    $79cd5395ca36be60$var$Bb(b, a.responseState, c.formatContext, c.id);
    $79cd5395ca36be60$var$hd(a, b, c);
    return $79cd5395ca36be60$var$Cb(b, c.formatContext);
}
function $79cd5395ca36be60$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$79cd5395ca36be60$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $79cd5395ca36be60$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$Ib));
    if (null === d) throw Error($79cd5395ca36be60$var$k(395));
    c = $79cd5395ca36be60$var$u(c.toString(16));
    $79cd5395ca36be60$var$p(b, d);
    $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$Kb);
    $79cd5395ca36be60$var$p(b, a.segmentPrefix);
    $79cd5395ca36be60$var$p(b, c);
    return $79cd5395ca36be60$var$t(b, $79cd5395ca36be60$var$Lb);
}
function $79cd5395ca36be60$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($79cd5395ca36be60$var$k(392));
        return $79cd5395ca36be60$var$id(a, b, d);
    }
    $79cd5395ca36be60$var$id(a, b, d);
    a = a.responseState;
    $79cd5395ca36be60$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$Eb) : (a.sentCompleteSegmentFunction = !0, $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$Db));
    $79cd5395ca36be60$var$p(b, a.segmentPrefix);
    f = $79cd5395ca36be60$var$u(f.toString(16));
    $79cd5395ca36be60$var$p(b, f);
    $79cd5395ca36be60$var$p(b, $79cd5395ca36be60$var$Gb);
    $79cd5395ca36be60$var$p(b, a.placeholderPrefix);
    $79cd5395ca36be60$var$p(b, f);
    return $79cd5395ca36be60$var$t(b, $79cd5395ca36be60$var$Hb);
}
function $79cd5395ca36be60$var$fd(a, b) {
    $79cd5395ca36be60$var$l = new Uint8Array(512);
    $79cd5395ca36be60$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $79cd5395ca36be60$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$79cd5395ca36be60$var$p(b, d[c]);
            c < d.length && $79cd5395ca36be60$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $79cd5395ca36be60$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$Nb) : (h.sentClientRenderFunction = !0, $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$Mb));
            if (null === m) throw Error($79cd5395ca36be60$var$k(395));
            $79cd5395ca36be60$var$p(d, m);
            $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$Ob);
            if (q || r || v) $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$Qb), $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$Sb(q || "")));
            if (r || v) $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$Qb), $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$Sb(r || "")));
            v && ($79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$Qb), $79cd5395ca36be60$var$p(d, $79cd5395ca36be60$var$u($79cd5395ca36be60$var$Sb(v))));
            if (!$79cd5395ca36be60$var$t(d, $79cd5395ca36be60$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$79cd5395ca36be60$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $79cd5395ca36be60$var$ba(b);
        $79cd5395ca36be60$var$l = new Uint8Array(512);
        $79cd5395ca36be60$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$79cd5395ca36be60$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$79cd5395ca36be60$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $79cd5395ca36be60$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $79cd5395ca36be60$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $79cd5395ca36be60$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $79cd5395ca36be60$var$fd(a, a.destination);
    } catch (d) {
        $79cd5395ca36be60$var$Y(a, d), $79cd5395ca36be60$var$Vc(a, d);
    }
}
$79cd5395ca36be60$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $79cd5395ca36be60$var$Rc(a, $79cd5395ca36be60$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $79cd5395ca36be60$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var _$a = new ReadableStream({
                type: "bytes",
                pull: function pull(a) {
                    if (1 === h.status) h.status = 2, $79cd5395ca36be60$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $79cd5395ca36be60$var$fd(h, a);
                        } catch (A) {
                            $79cd5395ca36be60$var$Y(h, A), $79cd5395ca36be60$var$Vc(h, A);
                        }
                    }
                },
                cancel: function cancel() {
                    $79cd5395ca36be60$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            _$a.allReady = g;
            c(_$a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function q1() {
                $79cd5395ca36be60$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $79cd5395ca36be60$var$Uc(h);
    });
};
$79cd5395ca36be60$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("cdzNs", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");



(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("cdv1q")));
    }
})(undefined, function(exports1, _react, _propTypes, _String) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _objectWithoutProperties = function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.HeatMap = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var evtNames = [
        "click",
        "mouseover",
        "recenter"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var HeatMap = exports1.HeatMap = function(_React$Component) {
        _inherits(HeatMap, _React$Component);
        function HeatMap() {
            _classCallCheck(this, HeatMap);
            return _possibleConstructorReturn(this, (HeatMap.__proto__ || Object.getPrototypeOf(HeatMap)).apply(this, arguments));
        }
        _createClass(HeatMap, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.heatMapPromise = wrappedPromise();
                    this.renderHeatMap();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || this.props.position !== prevProps.position) {
                        if (this.heatMap) {
                            this.heatMap.setMap(null);
                            this.renderHeatMap();
                        }
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.heatMap) this.heatMap.setMap(null);
                }
            },
            {
                key: "renderHeatMap",
                value: function renderHeatMap() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, positions = _props.positions, mapCenter = _props.mapCenter, icon = _props.icon, gradient = _props.gradient, _props$radius = _props.radius, radius = _props$radius === undefined ? 20 : _props$radius, _props$opacity = _props.opacity, opacity = _props$opacity === undefined ? 0.2 : _props$opacity, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "positions",
                        "mapCenter",
                        "icon",
                        "gradient",
                        "radius",
                        "opacity"
                    ]);
                    if (!google) return null;
                    var data = positions.map(function(pos) {
                        return {
                            location: new google.maps.LatLng(pos.lat, pos.lng),
                            weight: pos.weight
                        };
                    });
                    var pref = _extends({
                        map: map,
                        gradient: gradient,
                        radius: radius,
                        opacity: opacity,
                        data: data
                    }, props);
                    this.heatMap = new google.maps.visualization.HeatmapLayer(pref);
                    this.heatMap.set("radius", radius === undefined ? 20 : radius);
                    this.heatMap.set("opacity", opacity === undefined ? 0.2 : opacity);
                    evtNames.forEach(function(e) {
                        _this2.heatMap.addListener(e, _this2.handleEvent(e));
                    });
                    this.heatMapPromise.resolve(this.heatMap);
                }
            },
            {
                key: "getHeatMap",
                value: function getHeatMap() {
                    return this.heatMapPromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.heatMap, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return HeatMap;
    }(_react2.default.Component);
    HeatMap.propTypes = {
        position: _propTypes2.default.object,
        map: _propTypes2.default.object,
        icon: _propTypes2.default.string
    };
    evtNames.forEach(function(e) {
        return HeatMap.propTypes[e] = _propTypes2.default.func;
    });
    HeatMap.defaultProps = {
        name: "HeatMap"
    };
    exports1.default = HeatMap;
});

});

parcelRequire.register("32tNv", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/arePathsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("5OBfl")), (parcelRequire("cdv1q")));
    }
})(undefined, function(exports1, _react, _propTypes, _arePathsEqual, _String) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _objectWithoutProperties = function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Polygon = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Polygon = exports1.Polygon = function(_React$Component) {
        _inherits(Polygon, _React$Component);
        function Polygon() {
            _classCallCheck(this, Polygon);
            return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
        }
        _createClass(Polygon, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.polygonPromise = wrappedPromise();
                    this.renderPolygon();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.paths, prevProps.paths)) {
                        if (this.polygon) this.polygon.setMap(null);
                        this.renderPolygon();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.polygon) this.polygon.setMap(null);
                }
            },
            {
                key: "renderPolygon",
                value: function renderPolygon() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, paths = _props.paths, strokeColor = _props.strokeColor, strokeOpacity = _props.strokeOpacity, strokeWeight = _props.strokeWeight, fillColor = _props.fillColor, fillOpacity = _props.fillOpacity, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "paths",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight",
                        "fillColor",
                        "fillOpacity"
                    ]);
                    if (!google) return null;
                    var params = _extends({
                        map: map,
                        paths: paths,
                        strokeColor: strokeColor,
                        strokeOpacity: strokeOpacity,
                        strokeWeight: strokeWeight,
                        fillColor: fillColor,
                        fillOpacity: fillOpacity
                    }, props);
                    this.polygon = new google.maps.Polygon(params);
                    evtNames.forEach(function(e) {
                        _this2.polygon.addListener(e, _this2.handleEvent(e));
                    });
                    this.polygonPromise.resolve(this.polygon);
                }
            },
            {
                key: "getPolygon",
                value: function getPolygon() {
                    return this.polygonPromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.polygon, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Polygon;
    }(_react2.default.Component);
    Polygon.propTypes = {
        paths: _propTypes2.default.array,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number,
        fillColor: _propTypes2.default.string,
        fillOpacity: _propTypes2.default.number
    };
    evtNames.forEach(function(e) {
        return Polygon.propTypes[e] = _propTypes2.default.func;
    });
    Polygon.defaultProps = {
        name: "Polygon"
    };
    exports1.default = Polygon;
});

});
parcelRequire.register("5OBfl", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(undefined, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _typeof = typeof Symbol === "function" && (0, $1ObTH._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $1ObTH._)(obj);
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $1ObTH._)(obj);
    };
    /**
   * Compares two path arrays of LatLng objects.
   */ var arePathsEqual = exports1.arePathsEqual = function arePathsEqual(pathA, pathB) {
        if (pathA === pathB) return true;
        if (!Array.isArray(pathA) || !Array.isArray(pathB)) return false;
        if (pathA.length !== pathB.length) return false;
        for(var i = 0; i < pathA.length; ++i){
            if (pathA[i] === pathB[i]) continue;
            if (!isValidLatLng(pathA[i]) || !isValidLatLng(pathB[i])) return false;
            if (pathB[i].lat !== pathA[i].lat || pathB[i].lng !== pathA[i].lng) return false;
        }
        return true;
    };
    /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */ var isValidLatLng = function isValidLatLng(elem) {
        return elem !== null && (typeof elem === "undefined" ? "undefined" : _typeof(elem)) === "object" && elem.hasOwnProperty("lat") && elem.hasOwnProperty("lng");
    };
});

});


parcelRequire.register("lFdtz", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/arePathsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("5OBfl")), (parcelRequire("cdv1q")));
    }
})(undefined, function(exports1, _react, _propTypes, _arePathsEqual, _String) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _objectWithoutProperties = function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Polyline = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Polyline = exports1.Polyline = function(_React$Component) {
        _inherits(Polyline, _React$Component);
        function Polyline() {
            _classCallCheck(this, Polyline);
            return _possibleConstructorReturn(this, (Polyline.__proto__ || Object.getPrototypeOf(Polyline)).apply(this, arguments));
        }
        _createClass(Polyline, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.polylinePromise = wrappedPromise();
                    this.renderPolyline();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(this.props.path, prevProps.path)) {
                        if (this.polyline) this.polyline.setMap(null);
                        this.renderPolyline();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.polyline) this.polyline.setMap(null);
                }
            },
            {
                key: "renderPolyline",
                value: function renderPolyline() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, path = _props.path, strokeColor = _props.strokeColor, strokeOpacity = _props.strokeOpacity, strokeWeight = _props.strokeWeight, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "path",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight"
                    ]);
                    if (!google) return null;
                    var params = _extends({
                        map: map,
                        path: path,
                        strokeColor: strokeColor,
                        strokeOpacity: strokeOpacity,
                        strokeWeight: strokeWeight
                    }, props);
                    this.polyline = new google.maps.Polyline(params);
                    evtNames.forEach(function(e) {
                        _this2.polyline.addListener(e, _this2.handleEvent(e));
                    });
                    this.polylinePromise.resolve(this.polyline);
                }
            },
            {
                key: "getPolyline",
                value: function getPolyline() {
                    return this.polylinePromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.polyline, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Polyline;
    }(_react2.default.Component);
    Polyline.propTypes = {
        path: _propTypes2.default.array,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number
    };
    evtNames.forEach(function(e) {
        return Polyline.propTypes[e] = _propTypes2.default.func;
    });
    Polyline.defaultProps = {
        name: "Polyline"
    };
    exports1.default = Polyline;
});

});

parcelRequire.register("fdRPg", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/arePathsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("5OBfl")), (parcelRequire("cdv1q")));
    }
})(undefined, function(exports1, _react, _propTypes, _arePathsEqual, _String) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _objectWithoutProperties = function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Circle = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Circle = exports1.Circle = function(_React$Component) {
        _inherits(Circle, _React$Component);
        function Circle() {
            var _ref;
            var _temp, _this, _ret;
            _classCallCheck(this, Circle);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Circle.__proto__ || Object.getPrototypeOf(Circle)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.centerChanged = function _ret(newCenter) {
                var _this$props$center = _this.props.center, lat = _this$props$center.lat, lng = _this$props$center.lng;
                return lat !== newCenter.lat || lng !== newCenter.lng;
            }, _this.propsChanged = function(newProps) {
                if (_this.centerChanged(newProps.center)) return true;
                return Object.keys(Circle.propTypes).some(function(key) {
                    return _this.props[key] !== newProps[key];
                });
            }, _this.destroyCircle = function() {
                if (_this.circle) _this.circle.setMap(null);
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }
        _createClass(Circle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.circlePromise = wrappedPromise();
                    this.renderCircle();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    var _props = this.props, path = _props.path, map = _props.map;
                    if (this.propsChanged(prevProps) || map !== prevProps.map || !(0, _arePathsEqual.arePathsEqual)(path, prevProps.path)) {
                        this.destroyCircle();
                        this.renderCircle();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.destroyCircle();
                }
            },
            {
                key: "renderCircle",
                value: function renderCircle() {
                    var _this2 = this;
                    var _props2 = this.props, map = _props2.map, google = _props2.google, center = _props2.center, radius = _props2.radius, strokeColor = _props2.strokeColor, strokeOpacity = _props2.strokeOpacity, strokeWeight = _props2.strokeWeight, fillColor = _props2.fillColor, fillOpacity = _props2.fillOpacity, draggable = _props2.draggable, visible = _props2.visible, props = _objectWithoutProperties(_props2, [
                        "map",
                        "google",
                        "center",
                        "radius",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight",
                        "fillColor",
                        "fillOpacity",
                        "draggable",
                        "visible"
                    ]);
                    if (!google) return null;
                    var params = _extends({}, props, {
                        map: map,
                        center: center,
                        radius: radius,
                        draggable: draggable,
                        visible: visible,
                        options: {
                            strokeColor: strokeColor,
                            strokeOpacity: strokeOpacity,
                            strokeWeight: strokeWeight,
                            fillColor: fillColor,
                            fillOpacity: fillOpacity
                        }
                    });
                    this.circle = new google.maps.Circle(params);
                    evtNames.forEach(function(e) {
                        _this2.circle.addListener(e, _this2.handleEvent(e));
                    });
                    this.circlePromise.resolve(this.circle);
                }
            },
            {
                key: "getCircle",
                value: function getCircle() {
                    return this.circlePromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.circle, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    return null;
                }
            }
        ]);
        return Circle;
    }(_react2.default.Component);
    Circle.propTypes = {
        center: _propTypes2.default.object,
        radius: _propTypes2.default.number,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number,
        fillColor: _propTypes2.default.string,
        fillOpacity: _propTypes2.default.number,
        draggable: _propTypes2.default.bool,
        visible: _propTypes2.default.bool
    };
    evtNames.forEach(function(e) {
        return Circle.propTypes[e] = _propTypes2.default.func;
    });
    Circle.defaultProps = {
        name: "Circle"
    };
    exports1.default = Circle;
});

});

parcelRequire.register("4JvLw", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");




(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "react",
        "prop-types",
        "../lib/areBoundsEqual",
        "../lib/String"
    ], factory);
    else {
        var mod;
        factory(module.exports, (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("1S9f9")), (parcelRequire("cdv1q")));
    }
})(undefined, function(exports1, _react, _propTypes, _areBoundsEqual, _String) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _objectWithoutProperties = function _objectWithoutProperties(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Rectangle = undefined;
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var evtNames = [
        "click",
        "mouseout",
        "mouseover"
    ];
    var wrappedPromise = function wrappedPromise() {
        var wrappedPromise = {}, promise = new Promise(function(resolve, reject) {
            wrappedPromise.resolve = resolve;
            wrappedPromise.reject = reject;
        });
        wrappedPromise.then = promise.then.bind(promise);
        wrappedPromise.catch = promise.catch.bind(promise);
        wrappedPromise.promise = promise;
        return wrappedPromise;
    };
    var Rectangle = exports1.Rectangle = function(_React$Component) {
        _inherits(Rectangle, _React$Component);
        function Rectangle() {
            _classCallCheck(this, Rectangle);
            return _possibleConstructorReturn(this, (Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).apply(this, arguments));
        }
        _createClass(Rectangle, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.rectanglePromise = wrappedPromise();
                    this.renderRectangle();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    if (this.props.map !== prevProps.map || !(0, _areBoundsEqual.areBoundsEqual)(this.props.bounds, prevProps.bounds)) {
                        if (this.rectangle) this.rectangle.setMap(null);
                        this.renderRectangle();
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if (this.rectangle) this.rectangle.setMap(null);
                }
            },
            {
                key: "renderRectangle",
                value: function renderRectangle() {
                    var _this2 = this;
                    var _props = this.props, map = _props.map, google = _props.google, bounds = _props.bounds, strokeColor = _props.strokeColor, strokeOpacity = _props.strokeOpacity, strokeWeight = _props.strokeWeight, fillColor = _props.fillColor, fillOpacity = _props.fillOpacity, props = _objectWithoutProperties(_props, [
                        "map",
                        "google",
                        "bounds",
                        "strokeColor",
                        "strokeOpacity",
                        "strokeWeight",
                        "fillColor",
                        "fillOpacity"
                    ]);
                    if (!google) return null;
                    var params = _extends({
                        map: map,
                        bounds: bounds,
                        strokeColor: strokeColor,
                        strokeOpacity: strokeOpacity,
                        strokeWeight: strokeWeight,
                        fillColor: fillColor,
                        fillOpacity: fillOpacity
                    }, props);
                    this.rectangle = new google.maps.Rectangle(params);
                    evtNames.forEach(function(e) {
                        _this2.rectangle.addListener(e, _this2.handleEvent(e));
                    });
                    this.rectanglePromise.resolve(this.rectangle);
                }
            },
            {
                key: "getRectangle",
                value: function getRectangle() {
                    return this.rectanglePromise;
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evt) {
                    var _this3 = this;
                    return function(e) {
                        var evtName = "on" + (0, _String.camelize)(evt);
                        if (_this3.props[evtName]) _this3.props[evtName](_this3.props, _this3.rectangle, e);
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    console.log("hii, ", this.props.bounds);
                    return null;
                }
            }
        ]);
        return Rectangle;
    }(_react2.default.Component);
    Rectangle.propTypes = {
        bounds: _propTypes2.default.object,
        strokeColor: _propTypes2.default.string,
        strokeOpacity: _propTypes2.default.number,
        strokeWeight: _propTypes2.default.number,
        fillColor: _propTypes2.default.string,
        fillOpacity: _propTypes2.default.number
    };
    evtNames.forEach(function(e) {
        return Rectangle.propTypes[e] = _propTypes2.default.func;
    });
    Rectangle.defaultProps = {
        name: "Rectangle"
    };
    exports1.default = Rectangle;
});

});
parcelRequire.register("1S9f9", function(module, exports) {

var $1ObTH = parcelRequire("1ObTH");
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(undefined, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    var _typeof = typeof Symbol === "function" && (0, $1ObTH._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $1ObTH._)(obj);
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $1ObTH._)(obj);
    };
    /**
   * Compares two bound objects.
   */ var areBoundsEqual = exports1.areBoundsEqual = function areBoundsEqual(boundA, boundB) {
        if (boundA === boundB) return true;
        if (!(boundA instanceof Object) || !(boundB instanceof Object)) return false;
        if (Object.keys(boundA).length !== Object.keys(boundB).length) return false;
        if (!areValidBounds(boundA) || !areValidBounds(boundB)) return false;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(boundA)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (boundA[key] !== boundB[key]) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        return true;
    };
    /**
   * Helper that checks whether an array consists of objects
   * with lat and lng properties
   * @param {object} elem the element to check
   * @returns {boolean} whether or not it's valid
   */ var areValidBounds = function areValidBounds(elem) {
        return elem !== null && (typeof elem === "undefined" ? "undefined" : _typeof(elem)) === "object" && elem.hasOwnProperty("north") && elem.hasOwnProperty("south") && elem.hasOwnProperty("east") && elem.hasOwnProperty("west");
    };
});

});


parcelRequire.register("36D9o", function(module, exports) {
(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports"
    ], factory);
    else {
        var mod;
        factory(module.exports);
    }
})(module.exports, function(exports1) {
    "use strict";
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    // https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
    var makeCancelable = exports1.makeCancelable = function makeCancelable(promise) {
        var hasCanceled_ = false;
        var wrappedPromise = new Promise(function(resolve, reject) {
            promise.then(function(val) {
                return hasCanceled_ ? reject({
                    isCanceled: true
                }) : resolve(val);
            });
            promise.catch(function(error) {
                return hasCanceled_ ? reject({
                    isCanceled: true
                }) : reject(error);
            });
        });
        return {
            promise: wrappedPromise,
            cancel: function cancel() {
                hasCanceled_ = true;
            }
        };
    };
});

});

parcelRequire.register("6lLHD", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var __extends = function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
    var __awaiter = function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    var __generator = function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    };
    var __spreadArray = function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    };
    var hue2rgb = function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    };
    var isSupportedImage = function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    };
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    var __assign = function __assign1() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    var Bounds = /** @class */ function() {
        var Bounds = function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        };
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function parseBounds(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function parseDocumentSize(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function toCodePoints$1(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function fromCodePoint$1() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function decode$1(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function polyUint16Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function polyUint32Array$1(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function slice16$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function slice32$1(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function createTrieFromBase64$1(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        var Trie = function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        };
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        var Break = function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        };
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function LineBreaker(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function next() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function isDigit(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function isSurrogateCodePoint(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function isHex(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function isLowerCaseLetter(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function isUpperCaseLetter(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function isLetter(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function isNonASCIICodePoint(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function isWhiteSpace(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function isNameStartCodePoint(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function isNameCodePoint(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function isNonPrintableCodePoint(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function isValidEscape(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function isIdentifierStart(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function isNumberStart(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function stringToNumber(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        var Tokenizer = function Tokenizer() {
            this._value = [];
        };
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        var Parser = function Parser(tokens) {
            this._tokens = tokens;
        };
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function isDimensionToken(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function isNumberToken(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function isIdentToken(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function isStringToken(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function isIdentWithValue(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function nonWhiteSpace(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function nonFunctionArgSeparator(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function parseFunctionArgs(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function isEndingTokenFor(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function isLength(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function isLengthPercentage(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function parseLengthPercentageTuple(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function getAbsoluteValueForTuple(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function getAbsoluteValue(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function isAngle(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function parseNamedSide(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function deg(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function parse(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function isTransparent(color) {
        return (0xff & color) === 0;
    };
    var asString = function asString(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function pack(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function getTokenColorValue(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function rgb(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    var hsl = function hsl(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function parseColor(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function parseColorStop(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function processColorStops(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function getAngleFromCorner(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function calculateGradientDirection(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function distance(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function findCorner(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function calculateRadius(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function linearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function prefixLinearGradient(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function webkitGradient(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function radialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function prefixRadialGradient(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function isLinearGradient(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function isRadialGradient(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function parse(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function parseBackgroundRepeat(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function isBackgroundSizeInfoToken(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function borderColorForSide(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function borderRadiusForSide(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function parse(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function borderStyleForSide(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function parse(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function borderWidthForSide(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function parse(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function parseDisplayValue(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function computeLineHeight(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function marginForSide(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function paddingForSide(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function matrix(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function matrix3d(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function parse(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function parse(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function parse(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function contains(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function getQuote(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function parse(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function parse(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function parse(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        var CSSParsedDeclaration = function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        };
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        var CSSParsedPseudoDeclaration = function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        };
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        var CSSParsedCounterDeclaration = function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        };
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function parse(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function getElementDebugType(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function isDebugging(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        var ElementContainer = function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        };
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function decode(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function polyUint16Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function polyUint32Array(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function slice16(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function slice32(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function createTrieFromBase64(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        var Trie = function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        };
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function toCodePoints(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function fromCodePoint() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function codePointToClass(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function _graphemeBreakAtIndex(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function GraphemeBreaker(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function next() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function splitGraphemes(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function testRangeBounds(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function testIOSLineBreak(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function testCORS() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function testResponseType() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function testSVG(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function isGreenPixel(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function testForeignObject(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function loadSerializedSVG$1(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        var TextBounds = function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        };
        return TextBounds;
    }();
    var parseTextBounds = function parseTextBounds(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function getWrapperBounds(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function createRange(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function segmentGraphemes(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function segmentWords(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function breakText(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function breakWords(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function _loop_1() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        var TextContainer = function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        };
        return TextContainer;
    }();
    var transform = function transform(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function capitalize(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        var ImageElementContainer = function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        };
        __extends(ImageElementContainer, _super);
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        var CanvasElementContainer = function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        };
        __extends(CanvasElementContainer, _super);
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        var SVGElementContainer = function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        };
        __extends(SVGElementContainer, _super);
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        var LIElementContainer = function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        };
        __extends(LIElementContainer, _super);
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        var OLElementContainer = function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        };
        __extends(OLElementContainer, _super);
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function reformatInputBounds(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function getInputValue(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("•") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        var InputElementContainer = function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        };
        __extends(InputElementContainer, _super);
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        var SelectElementContainer = function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        };
        __extends(SelectElementContainer, _super);
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        var TextareaElementContainer = function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        };
        __extends(TextareaElementContainer, _super);
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        var IFrameElementContainer = function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        };
        __extends(IFrameElementContainer, _super);
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function parseNodeTree1(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function createContainer(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function parseTree(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function createsRealStackingContext(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function createsStackingContext(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function isHTMLElementNode(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function isSVGElementNode(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function isLIElement(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function isOLElement(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function isInputElement(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function isHTMLElement(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function isSVGElement(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function isBodyElement(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function isCanvasElement(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function isVideoElement(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function isImageElement(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function isIFrameElement(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function isStyleElement(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function isScriptElement(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function isTextareaElement(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function isSelectElement(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function isSlotElement(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function isCustomElement(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        var CounterState = function CounterState() {
            this.counters = {};
        };
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "Ք",
            "Փ",
            "Ւ",
            "Ց",
            "Ր",
            "Տ",
            "Վ",
            "Ս",
            "Ռ",
            "Ջ",
            "Պ",
            "Չ",
            "Ո",
            "Շ",
            "Ն",
            "Յ",
            "Մ",
            "Ճ",
            "Ղ",
            "Ձ",
            "Հ",
            "Կ",
            "Ծ",
            "Խ",
            "Լ",
            "Ի",
            "Ժ",
            "Թ",
            "Ը",
            "Է",
            "Զ",
            "Ե",
            "Դ",
            "Գ",
            "Բ",
            "Ա"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "י׳",
            "ט׳",
            "ח׳",
            "ז׳",
            "ו׳",
            "ה׳",
            "ד׳",
            "ג׳",
            "ב׳",
            "א׳",
            "ת",
            "ש",
            "ר",
            "ק",
            "צ",
            "פ",
            "ע",
            "ס",
            "נ",
            "מ",
            "ל",
            "כ",
            "יט",
            "יח",
            "יז",
            "טז",
            "טו",
            "י",
            "ט",
            "ח",
            "ז",
            "ו",
            "ה",
            "ד",
            "ג",
            "ב",
            "א"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "ჵ",
            "ჰ",
            "ჯ",
            "ჴ",
            "ხ",
            "ჭ",
            "წ",
            "ძ",
            "ც",
            "ჩ",
            "შ",
            "ყ",
            "ღ",
            "ქ",
            "ფ",
            "ჳ",
            "ტ",
            "ს",
            "რ",
            "ჟ",
            "პ",
            "ო",
            "ჲ",
            "ნ",
            "მ",
            "ლ",
            "კ",
            "ი",
            "თ",
            "ჱ",
            "ზ",
            "ვ",
            "ე",
            "დ",
            "გ",
            "ბ",
            "ა"
        ]
    };
    var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "十百千萬";
    var CHINESE_FORMAL_MULTIPLIERS = "拾佰仟萬";
    var JAPANESE_NEGATIVE = "マイナス";
    var KOREAN_NEGATIVE = "마이너스";
    var createCounterText = function createCounterText(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "、" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "•" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "◦" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "◾" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "〇一二三四五六七八九", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "子丑寅卯辰巳午未申酉戌亥", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "甲乙丙丁戊己庚辛壬癸", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹貳參肆伍陸柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "負", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", CHINESE_INFORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "零壹贰叁肆伍陆柒捌玖", CHINESE_FORMAL_MULTIPLIERS, "负", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "〇一二三四五六七八九", "十百千万", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "零壱弐参四伍六七八九", "拾百千万", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "영일이삼사오육칠팔구", "십백천만", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "零一二三四五六七八九", "十百千萬", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "零壹貳參四五六七八九", "拾百千", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        var DocumentCloner = function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        };
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var _$window = node.ownerDocument.defaultView;
            if (_$window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = _$window.getComputedStyle(node);
                var styleBefore = _$window.getComputedStyle(node, ":before");
                var styleAfter = _$window.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var _$document = clone.ownerDocument;
            if (!_$document || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = _$document.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = _$document.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(_$document.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(_$document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(_$document.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(_$document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(_$document.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function createIFrameContainer(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function imageReady(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function imagesReady(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function iframeLoader(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function copyCSSStyles(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function serializeDoctype(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function restoreNodeScroll(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function createPseudoHideStyles(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function createStyles(body, styles) {
        var _$document = body.ownerDocument;
        if (_$document) {
            var style = _$document.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        var CacheStorage = function CacheStorage() {};
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        var Cache = function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        };
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function isRenderable(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function isInlineImage(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function isInlineBase64Image(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function isBlobImage(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function isSVG(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        var Vector = function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        };
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function lerp(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        var BezierCurve = function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        };
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function isBezierCurve(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        var BoundCurves = function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        };
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function calculateContentBoxPath(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        var TransformEffect = function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        };
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        var ClipEffect = function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        };
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        var OpacityEffect = function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        };
        return OpacityEffect;
    }();
    var isTransformEffect = function isTransformEffect(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function isClipEffect(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function isOpacityEffect(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function equalPath(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function transformPath(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        var StackingContext = function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        };
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        var ElementPaint = function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        };
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function parseStackTree1(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function processListItems(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function parseStackingContexts(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function parsePathForBorder(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function parsePathForBorderDoubleOuter(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function parsePathForBorderDoubleInner(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function parsePathForBorderStroke(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function createStrokePathFromCurves(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function paddingBox(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function contentBox(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function calculateBackgroundPositioningArea(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function calculateBackgroundPaintingArea(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function calculateBackgroundRendering(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function isAuto(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function hasIntrinsicValue(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function calculateBackgroundSize(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function getBackgroundValueForIndex(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        var FontMetrics = function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        };
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        var Renderer = function Renderer(context, options) {
            this.context = context;
            this.options = options;
        };
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        var CanvasRenderer = function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        };
        __extends(CanvasRenderer, _super);
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function _loop_1(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function isTextInputElement(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function calculateBackgroundCurvedPaintingArea(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function canvasTextAlign(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function fixIOSSystemFonts(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        var ForeignObjectRenderer = function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        };
        __extends(ForeignObjectRenderer, _super);
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function loadSerializedSVG(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        var Logger = function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function html2canvas(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function renderElement(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function parseBackgroundColor(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRequire.register("hrVOB", function(module, exports) {
function $cb41ce2cd8de63fa$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $cb41ce2cd8de63fa$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cb41ce2cd8de63fa$var$_typeof(o);
}
module.exports = $cb41ce2cd8de63fa$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("jkOtN", function(module, exports) {



module.exports = (parcelRequire("9FZDf"))((parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("gN8Mf")).then(function() {
    return parcelRequire("3RVAP");
});

});
parcelRequire.register("9FZDf", function(module, exports) {
"use strict";

var $9jW6n = parcelRequire("9jW6n");
module.exports = $9jW6n(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("9jW6n", function(module, exports) {
"use strict";
var $6c92f53da2785287$var$cachedBundles = {};
var $6c92f53da2785287$var$cachedPreloads = {};
var $6c92f53da2785287$var$cachedPrefetches = {};
function $6c92f53da2785287$var$getCache(type) {
    switch(type){
        case "preload":
            return $6c92f53da2785287$var$cachedPreloads;
        case "prefetch":
            return $6c92f53da2785287$var$cachedPrefetches;
        default:
            return $6c92f53da2785287$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $6c92f53da2785287$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRequire.register("2cAE0", function(module, exports) {



module.exports = (parcelRequire("9FZDf"))((parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("4p7nV")).then(function() {
    return parcelRequire("eL0bM");
});

});

var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));


parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";

var $9nHRL = parcelRequire("9nHRL");
var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $9nHRL.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $9nHRL.hydrateRoot;



parcelRequire("6cds3");

parcelRequire("6cds3");

parcelRequire("6cds3");
var $0cb14a93ab0e80fb$exports = {};


$0cb14a93ab0e80fb$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("9kIV3");


var $05aab5ccdefa059a$exports = {};


$05aab5ccdefa059a$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("5WcQT");


/**
 * React Router DOM v6.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $6cds3 = parcelRequire("6cds3");
/**
 * @remix-run/router v1.7.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $869ea882f885334a$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $869ea882f885334a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");
function $9dcc00a39e7f7954$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $jbUp2 = parcelRequire("jbUp2");

var $2uHzb = parcelRequire("2uHzb");

var $4Tldu = parcelRequire("4Tldu");

var $imR8K = parcelRequire("imR8K");
function $e5fd8313026a48a6$export$e62c166da838fa3(arr) {
    return (0, $jbUp2._array_with_holes)(arr) || (0, $2uHzb._iterable_to_array)(arr) || (0, $imR8K._unsupported_iterable_to_array)(arr) || (0, $4Tldu._non_iterable_rest)();
}



var $fLnyw = parcelRequire("fLnyw");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $7UAGh = parcelRequire("7UAGh");
function $96b280a33643b696$var$_extends() {
    $96b280a33643b696$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96b280a33643b696$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $96b280a33643b696$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($96b280a33643b696$export$e19cd5f9376f8cee || ($96b280a33643b696$export$e19cd5f9376f8cee = {}));
var $96b280a33643b696$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $96b280a33643b696$export$2b76ad033c6e6d08(options) {
    var clampIndex = function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    };
    var getCurrentLocation = function getCurrentLocation() {
        return entries[index];
    };
    var createMemoryLocation = function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $96b280a33643b696$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    };
    var createHref = function createHref(to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $96b280a33643b696$export$719fc203c4e16dee(options) {
    var createBrowserLocation = function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createBrowserHref = function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
    };
    if (options === void 0) options = {};
    return $96b280a33643b696$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $96b280a33643b696$export$b71fdd3798280242(options) {
    var createHashLocation = function createHashLocation(window1, globalHistory) {
        var _parsePath = $96b280a33643b696$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        return $96b280a33643b696$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    };
    var createHashHref = function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to));
    };
    var validateHashLocation = function validateHashLocation(location, to) {
        $96b280a33643b696$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    };
    if (options === void 0) options = {};
    return $96b280a33643b696$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $96b280a33643b696$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $96b280a33643b696$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $96b280a33643b696$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $96b280a33643b696$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $96b280a33643b696$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $96b280a33643b696$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $96b280a33643b696$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $96b280a33643b696$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $96b280a33643b696$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $96b280a33643b696$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    var getIndex = function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    };
    var handlePop = function handlePop() {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    };
    var push = function push(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
        var location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $96b280a33643b696$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    };
    var replace = function replace(to, state) {
        action = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
        var location = $96b280a33643b696$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $96b280a33643b696$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    };
    var createURL = function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $96b280a33643b696$export$fe53371bee54353d(to);
        $96b280a33643b696$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    };
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($96b280a33643b696$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($96b280a33643b696$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $96b280a33643b696$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($96b280a33643b696$var$ResultType || ($96b280a33643b696$var$ResultType = {}));
var $96b280a33643b696$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $96b280a33643b696$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $fLnyw._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $96b280a33643b696$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $96b280a33643b696$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($96b280a33643b696$var$isIndexRoute(route)) {
            var indexRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $96b280a33643b696$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $96b280a33643b696$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $96b280a33643b696$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $96b280a33643b696$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $96b280a33643b696$var$flattenRoutes(routes);
    $96b280a33643b696$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = $96b280a33643b696$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $96b280a33643b696$var$safelyDecodeURI(pathname));
    return matches;
}
function $96b280a33643b696$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $96b280a33643b696$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $96b280a33643b696$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $96b280a33643b696$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $96b280a33643b696$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $96b280a33643b696$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $96b280a33643b696$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $96b280a33643b696$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $e5fd8313026a48a6$export$e62c166da838fa3)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $96b280a33643b696$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $fLnyw._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $fLnyw._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $96b280a33643b696$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $96b280a33643b696$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $96b280a33643b696$var$paramRe = /^:\w+$/;
var $96b280a33643b696$var$dynamicSegmentValue = 3;
var $96b280a33643b696$var$indexRouteValue = 2;
var $96b280a33643b696$var$emptySegmentValue = 1;
var $96b280a33643b696$var$staticSegmentValue = 10;
var $96b280a33643b696$var$splatPenalty = -2;
var $96b280a33643b696$var$isSplat = function(s) {
    return s === "*";
};
function $96b280a33643b696$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($96b280a33643b696$var$isSplat)) initialScore += $96b280a33643b696$var$splatPenalty;
    if (index) initialScore += $96b280a33643b696$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$96b280a33643b696$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($96b280a33643b696$var$paramRe.test(segment) ? $96b280a33643b696$var$dynamicSegmentValue : segment === "" ? $96b280a33643b696$var$emptySegmentValue : $96b280a33643b696$var$staticSegmentValue);
    }, initialScore);
}
function $96b280a33643b696$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $96b280a33643b696$var$matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $96b280a33643b696$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $96b280a33643b696$export$a5c6d149b50c1d86($96b280a33643b696$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $96b280a33643b696$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $96b280a33643b696$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $8GFUW._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $96b280a33643b696$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $96b280a33643b696$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $8GFUW._)($96b280a33643b696$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $96b280a33643b696$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $96b280a33643b696$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $96b280a33643b696$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $96b280a33643b696$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $96b280a33643b696$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $96b280a33643b696$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $96b280a33643b696$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $96b280a33643b696$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $96b280a33643b696$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $96b280a33643b696$var$normalizeSearch(search),
        hash: $96b280a33643b696$var$normalizeHash(hash)
    };
}
function $96b280a33643b696$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $96b280a33643b696$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $96b280a33643b696$export$90ba53ce1c7fdff2(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function $96b280a33643b696$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $96b280a33643b696$export$8ccf933b0513f8d0(toArg);
    else {
        to = $96b280a33643b696$var$_extends({}, toArg);
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $96b280a33643b696$var$getInvalidPathError("?", "pathname", "search", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "pathname", "hash", to));
        $96b280a33643b696$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $96b280a33643b696$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $96b280a33643b696$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $96b280a33643b696$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $96b280a33643b696$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $96b280a33643b696$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $96b280a33643b696$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $96b280a33643b696$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $96b280a33643b696$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $96b280a33643b696$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(AbortedDeferredError, Error1);
    var _super = (0, $6OZAO._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, $978gY._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, $2TMdq._)(Error));
var $96b280a33643b696$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $978gY._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $96b280a33643b696$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $96b280a33643b696$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, $8GFUW._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $kry2a._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $96b280a33643b696$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var aborted, onAbort;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $96b280a33643b696$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, $8GFUW._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, key, $96b280a33643b696$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $96b280a33643b696$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $96b280a33643b696$var$unwrapTrackedPromise(value) {
    if (!$96b280a33643b696$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $96b280a33643b696$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $96b280a33643b696$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $96b280a33643b696$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $96b280a33643b696$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ var $96b280a33643b696$export$acf1a680051f5031 = function ErrorResponse(status, statusText, data, internal) {
    "use strict";
    (0, $978gY._)(this, ErrorResponse);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $96b280a33643b696$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $96b280a33643b696$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $96b280a33643b696$var$validMutationMethods = new Set($96b280a33643b696$var$validMutationMethodsArr);
var $96b280a33643b696$var$validRequestMethodsArr = [
    "get"
].concat((0, $fLnyw._)($96b280a33643b696$var$validMutationMethodsArr));
var $96b280a33643b696$var$validRequestMethods = new Set($96b280a33643b696$var$validRequestMethodsArr);
var $96b280a33643b696$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $96b280a33643b696$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $96b280a33643b696$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $96b280a33643b696$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $96b280a33643b696$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $96b280a33643b696$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $96b280a33643b696$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $96b280a33643b696$export$baddd0131ee8c05b(init) {
    var initialize = // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $96b280a33643b696$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($96b280a33643b696$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    };
    var dispose = // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    };
    var subscribe = // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    };
    var updateState = // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $96b280a33643b696$var$_extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state);
        });
    };
    var completeNavigation = // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $96b280a33643b696$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $96b280a33643b696$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $96b280a33643b696$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $96b280a33643b696$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($96b280a33643b696$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    };
    var revalidate = // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    };
    var getFetcher = function getFetcher(key) {
        return state.fetchers.get(key) || $96b280a33643b696$export$52eace9c284d3585;
    };
    var fetch = // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $96b280a33643b696$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        var match = $96b280a33643b696$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    };
    var interruptActiveLoads = function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $fLnyw._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    };
    var setFetcherError = function setFetcherError(key, routeId, error) {
        var boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        });
    };
    var deleteFetcher = function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    };
    var abortFetcher = function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $96b280a33643b696$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    };
    var markFetchersDone = function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $96b280a33643b696$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var markFetchRedirectsDone = function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    };
    var abortStaleFetchLoads = function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $96b280a33643b696$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    };
    var getBlocker = function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    };
    var deleteBlocker = function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    };
    var updateBlocker = // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $96b280a33643b696$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $96b280a33643b696$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    };
    var shouldBlockNavigation = function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $96b280a33643b696$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $8GFUW._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    };
    var cancelActiveDeferreds = function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    };
    var enableScrollRestoration = // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $96b280a33643b696$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    };
    var getScrollKey = function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $96b280a33643b696$var$createUseMatchesMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    };
    var saveScrollPosition = function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    };
    var getSavedScrollPosition = function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    };
    var _internalSetRoutes = function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    };
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $96b280a33643b696$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    // Config driven behavior flags
    var future = $96b280a33643b696$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $96b280a33643b696$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, route.id, error);
    }
    var initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $96b280a33643b696$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $869ea882f885334a$export$7c398597f8905a1)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $96b280a33643b696$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $96b280a33643b696$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $96b280a33643b696$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $96b280a33643b696$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $96b280a33643b696$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $96b280a33643b696$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $96b280a33643b696$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $869ea882f885334a$export$7c398597f8905a1)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, _ref, shortCircuited, loaderData, errors;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, location, basename);
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = $96b280a33643b696$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = $96b280a33643b696$var$getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, route.id, error)
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $96b280a33643b696$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $96b280a33643b696$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, $96b280a33643b696$var$findNearestBoundary(matches).route.id, opts.pendingError);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $96b280a33643b696$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        loadingNavigation = $96b280a33643b696$var$getLoadingNavigation(location, opts.submission);
                        // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $96b280a33643b696$var$_extends({
                            matches: matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $869ea882f885334a$export$7c398597f8905a1)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        navigation = $96b280a33643b696$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        });
                        actionMatch = $96b280a33643b696$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: $96b280a33643b696$var$ResultType.error,
                            error: $96b280a33643b696$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!$96b280a33643b696$var$isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if ($96b280a33643b696$var$isErrorResult(result)) {
                            boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = $96b280a33643b696$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error)
                                }
                            ];
                        }
                        if ($96b280a33643b696$var$isDeferredResult(result)) throw $96b280a33643b696$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data)
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $869ea882f885334a$export$7c398597f8905a1)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || $96b280a33643b696$var$getLoadingNavigation(location, submission);
                        activeSubmission = submission || fetcherSubmission || $96b280a33643b696$var$getSubmissionFromNavigation(loadingNavigation);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $8GFUW._)($96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $96b280a33643b696$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState($96b280a33643b696$var$_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData: actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect = $96b280a33643b696$var$findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(state, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        _processLoaderData = $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $96b280a33643b696$var$_extends({
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $869ea882f885334a$export$7c398597f8905a1)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, originatingLoadId, actionResult, doneFetcher, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher1, didAbortFetchLoads;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = $96b280a33643b696$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        }
                        existingFetcher = state.fetchers.get(key);
                        fetcher = $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher);
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if ($96b280a33643b696$var$isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            if (pendingNavigationLoadId > originatingLoadId) {
                                doneFetcher = $96b280a33643b696$var$getDoneFetcher(undefined);
                                state.fetchers.set(key, doneFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2
                                ];
                            } else {
                                fetchRedirectIds.add(key);
                                loadingFetcher = $96b280a33643b696$var$getLoadingFetcher(submission);
                                state.fetchers.set(key, loadingFetcher);
                                updateState({
                                    fetchers: new Map(state.fetchers)
                                });
                                return [
                                    2,
                                    startRedirectNavigation(state, actionResult, {
                                        submission: submission,
                                        isFetchActionRedirect: true
                                    })
                                ];
                            }
                        }
                        // Process any non-redirect errors thrown
                        if ($96b280a33643b696$var$isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if ($96b280a33643b696$var$isDeferredResult(actionResult)) throw $96b280a33643b696$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $96b280a33643b696$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $96b280a33643b696$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $96b280a33643b696$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $8GFUW._)($96b280a33643b696$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, match.route.id, actionResult.data), undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $96b280a33643b696$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $96b280a33643b696$var$findRedirect(results);
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(state, redirect.result)
                            ];
                        }
                        _processLoaderData = $96b280a33643b696$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher1 = $96b280a33643b696$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher1);
                        }
                        didAbortFetchLoads = abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $96b280a33643b696$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState($96b280a33643b696$var$_extends({
                                errors: errors,
                                loaderData: $96b280a33643b696$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $869ea882f885334a$export$7c398597f8905a1)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, originatingLoadId, result, doneFetcher, boundaryMatch, doneFetcher1;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        loadingFetcher = $96b280a33643b696$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortController = new AbortController();
                        fetchRequest = $96b280a33643b696$var$createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!$96b280a33643b696$var$isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            $96b280a33643b696$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (!$96b280a33643b696$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        doneFetcher = $96b280a33643b696$var$getDoneFetcher(undefined);
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        // Process any non-redirect errors thrown
                        if ($96b280a33643b696$var$isErrorResult(result)) {
                            boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, routeId);
                            state.fetchers.delete(key);
                            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error)
                            });
                            return [
                                2
                            ];
                        }
                        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        doneFetcher1 = $96b280a33643b696$var$getDoneFetcher(result.data);
                        state.fetchers.set(key, doneFetcher1);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(state, redirect, _temp) {
            var _ref, submission, replace, isFetchActionRedirect, redirectLocation, url, isDifferentBasename, redirectHistoryAction, activeSubmission, overrideNavigation;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, replace = _ref.replace, isFetchActionRedirect = _ref.isFetchActionRedirect;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = $96b280a33643b696$var$createLocation(state.location, redirect.location, $96b280a33643b696$var$_extends({
                            _isRedirect: true
                        }, isFetchActionRedirect ? {
                            _isFetchActionRedirect: true
                        } : {}));
                        $96b280a33643b696$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
                        // Check if this an absolute external redirect that goes to a new origin
                        if ($96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
                            url = init.history.createURL(redirect.location);
                            isDifferentBasename = $96b280a33643b696$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                                if (replace) routerWindow.location.replace(redirect.location);
                                else routerWindow.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $96b280a33643b696$export$e19cd5f9376f8cee.Replace : $96b280a33643b696$export$e19cd5f9376f8cee.Push;
                        activeSubmission = submission || $96b280a33643b696$var$getSubmissionFromNavigation(state.navigation);
                        if (!($96b280a33643b696$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $96b280a33643b696$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $96b280a33643b696$var$_extends({}, activeSubmission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!isFetchActionRedirect) return [
                            3,
                            4
                        ];
                        // For a fetch action redirect, we kick off a new loading navigation
                        // without the fetcher submission, but we send it along for shouldRevalidate
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: $96b280a33643b696$var$getLoadingNavigation(redirectLocation),
                                fetcherSubmission: activeSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        overrideNavigation = $96b280a33643b696$var$getLoadingNavigation(redirectLocation, activeSubmission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $869ea882f885334a$export$7c398597f8905a1)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, $fLnyw._)(matchesToLoad.map(function(match) {
                                return $96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, $fLnyw._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return $96b280a33643b696$var$callLoaderOrAction("loader", $96b280a33643b696$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: $96b280a33643b696$var$ResultType.error,
                                        error: $96b280a33643b696$var$getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $96b280a33643b696$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results: results,
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $96b280a33643b696$export$4d0306f8f6a4585b = Symbol("deferred");
function $96b280a33643b696$export$3336b097a6fbc59a(routes, opts) {
    $96b280a33643b696$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $96b280a33643b696$var$defaultMapRouteProperties;
    var dataRoutes = $96b280a33643b696$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
                        matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD") {
                            error = $96b280a33643b696$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $96b280a33643b696$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $96b280a33643b696$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($96b280a33643b696$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $96b280a33643b696$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = $96b280a33643b696$var$createLocation("", $96b280a33643b696$export$fe53371bee54353d(url), null, "default");
                        matches = $96b280a33643b696$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$96b280a33643b696$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $96b280a33643b696$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $96b280a33643b696$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $96b280a33643b696$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $96b280a33643b696$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $96b280a33643b696$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($96b280a33643b696$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$96b280a33643b696$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $869ea882f885334a$export$7c398597f8905a1)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $96b280a33643b696$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$96b280a33643b696$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $96b280a33643b696$var$getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $96b280a33643b696$var$isResponse(result1) ? result1 : $96b280a33643b696$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if ($96b280a33643b696$var$isQueryRouteResponse(e)) {
                            if (e.type === $96b280a33643b696$var$ResultType.error && !$96b280a33643b696$var$isRedirectResponse(e.response)) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($96b280a33643b696$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $869ea882f885334a$export$7c398597f8905a1)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $96b280a33643b696$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $96b280a33643b696$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            $96b280a33643b696$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                                isStaticRequest: true,
                                isRouteRequest: isRouteRequest,
                                requestContext: requestContext
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        _state.label = 3;
                    case 3:
                        if ($96b280a33643b696$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if ($96b280a33643b696$var$isDeferredResult(result)) {
                            error1 = $96b280a33643b696$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $96b280a33643b696$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($96b280a33643b696$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!$96b280a33643b696$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error))
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $96b280a33643b696$var$_extends({}, context, {
                                statusCode: $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $96b280a33643b696$var$_extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.data),
                                actionHeaders: $96b280a33643b696$var$_extends({}, result.headers ? (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $869ea882f885334a$export$7c398597f8905a1)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $96b280a33643b696$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, $fLnyw._)(matchesToLoad.map(function(match) {
                                return $96b280a33643b696$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                                    isStaticRequest: true,
                                    isRouteRequest: isRouteRequest,
                                    requestContext: requestContext
                                });
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        activeDeferreds = new Map();
                        context = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $96b280a33643b696$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $96b280a33643b696$export$fec11da027c70692(routes, context, error) {
    var newContext = $96b280a33643b696$var$_extends({}, context, {
        statusCode: 500,
        errors: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $96b280a33643b696$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $96b280a33643b696$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $96b280a33643b696$export$cae722b0cc860f13(to ? to : ".", $96b280a33643b696$export$90ba53ce1c7fdff2(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), $96b280a33643b696$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$96b280a33643b696$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $96b280a33643b696$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $96b280a33643b696$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $96b280a33643b696$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$96b280a33643b696$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$96b280a33643b696$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $96b280a33643b696$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $96b280a33643b696$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $96b280a33643b696$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, $8GFUW._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$96b280a33643b696$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $96b280a33643b696$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $96b280a33643b696$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $96b280a33643b696$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($96b280a33643b696$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $96b280a33643b696$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $96b280a33643b696$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $96b280a33643b696$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $96b280a33643b696$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = $96b280a33643b696$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($96b280a33643b696$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $96b280a33643b696$var$shouldRevalidateLoader(match, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $96b280a33643b696$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = $96b280a33643b696$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $96b280a33643b696$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $96b280a33643b696$var$shouldRevalidateLoader(fetcherMatch, $96b280a33643b696$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $96b280a33643b696$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $96b280a33643b696$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $96b280a33643b696$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $96b280a33643b696$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $96b280a33643b696$var$_loadLazyRouteModule.apply(this, arguments);
}
function $96b280a33643b696$var$_loadLazyRouteModule() {
    $96b280a33643b696$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $96b280a33643b696$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $96b280a33643b696$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !$96b280a33643b696$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $96b280a33643b696$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_loadLazyRouteModule.apply(this, arguments);
}
function $96b280a33643b696$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    return $96b280a33643b696$var$_callLoaderOrAction.apply(this, arguments);
}
function $96b280a33643b696$var$_callLoaderOrAction() {
    $96b280a33643b696$var$_callLoaderOrAction = (0, $869ea882f885334a$export$7c398597f8905a1)(function(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
        var resultType, result, onReject, runHandler, handler, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, data, contentType, _result$init, _result$init2;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (opts === void 0) opts = {};
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request: request,
                                params: match.params,
                                context: opts.requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler),
                            $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $96b280a33643b696$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $96b280a33643b696$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $96b280a33643b696$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $96b280a33643b696$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = $96b280a33643b696$var$ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!$96b280a33643b696$var$isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status;
                    // Process redirects
                    if ($96b280a33643b696$var$redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        $96b280a33643b696$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
                        // Support relative routing in internal redirects
                        if (!$96b280a33643b696$var$ABSOLUTE_URL_REGEX.test(location)) location = $96b280a33643b696$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!opts.isStaticRequest) {
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = $96b280a33643b696$export$b69e3301ce081aa3(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        }
                        // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (opts.isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.redirect,
                                status: status,
                                location: location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null
                            }
                        ];
                    }
                    // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
                    throw {
                        type: resultType || $96b280a33643b696$var$ResultType.data,
                        response: result
                    };
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === $96b280a33643b696$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new $96b280a33643b696$export$acf1a680051f5031(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === $96b280a33643b696$var$ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if ($96b280a33643b696$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_callLoaderOrAction.apply(this, arguments);
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $96b280a33643b696$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($96b280a33643b696$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $96b280a33643b696$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $96b280a33643b696$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $96b280a33643b696$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $96b280a33643b696$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $96b280a33643b696$export$3e9cee6b33872309(!$96b280a33643b696$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($96b280a33643b696$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = $96b280a33643b696$var$findNearestBoundary(matches, id);
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $96b280a33643b696$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($96b280a33643b696$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $96b280a33643b696$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $96b280a33643b696$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $96b280a33643b696$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($96b280a33643b696$var$isErrorResult(result)) {
            var boundaryMatch = $96b280a33643b696$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $96b280a33643b696$var$_extends({}, errors, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($96b280a33643b696$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($96b280a33643b696$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $96b280a33643b696$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $96b280a33643b696$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $96b280a33643b696$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $96b280a33643b696$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $96b280a33643b696$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $fLnyw._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $96b280a33643b696$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $96b280a33643b696$var$getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $96b280a33643b696$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $96b280a33643b696$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($96b280a33643b696$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $96b280a33643b696$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(path) : path;
    return $96b280a33643b696$export$fe53371bee54353d($96b280a33643b696$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $96b280a33643b696$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $96b280a33643b696$var$isDeferredResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.deferred;
}
function $96b280a33643b696$var$isErrorResult(result) {
    return result.type === $96b280a33643b696$var$ResultType.error;
}
function $96b280a33643b696$var$isRedirectResult(result) {
    return (result && result.type) === $96b280a33643b696$var$ResultType.redirect;
}
function $96b280a33643b696$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $96b280a33643b696$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $96b280a33643b696$var$isRedirectResponse(result) {
    if (!$96b280a33643b696$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $96b280a33643b696$var$isQueryRouteResponse(obj) {
    return obj && $96b280a33643b696$var$isResponse(obj.response) && (obj.type === $96b280a33643b696$var$ResultType.data || $96b280a33643b696$var$ResultType.error);
}
function $96b280a33643b696$var$isValidMethod(method) {
    return $96b280a33643b696$var$validRequestMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$isMutationMethod(method) {
    return $96b280a33643b696$var$validMutationMethods.has(method.toLowerCase());
}
function $96b280a33643b696$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $96b280a33643b696$var$_resolveDeferredResults.apply(this, arguments);
}
function $96b280a33643b696$var$_resolveDeferredResults() {
    $96b280a33643b696$var$_resolveDeferredResults = (0, $869ea882f885334a$export$7c398597f8905a1)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$96b280a33643b696$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($96b280a33643b696$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    signal = signals[index];
                                    $96b280a33643b696$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $96b280a33643b696$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $7UAGh.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_resolveDeferredResults.apply(this, arguments);
}
function $96b280a33643b696$var$resolveDeferredData(result, signal, unwrap) {
    return $96b280a33643b696$var$_resolveDeferredData.apply(this, arguments);
}
function $96b280a33643b696$var$_resolveDeferredData() {
    $96b280a33643b696$var$_resolveDeferredData = (0, $869ea882f885334a$export$7c398597f8905a1)(function(result, signal, unwrap) {
        var aborted;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $96b280a33643b696$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $96b280a33643b696$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $96b280a33643b696$var$_resolveDeferredData.apply(this, arguments);
}
function $96b280a33643b696$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $96b280a33643b696$var$createUseMatchesMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $96b280a33643b696$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $96b280a33643b696$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $96b280a33643b696$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $96b280a33643b696$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $96b280a33643b696$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $96b280a33643b696$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $96b280a33643b696$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $96b280a33643b696$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher1;
    }
}
function $96b280a33643b696$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $96b280a33643b696$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}

/**
 * React Router v6.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $6OZAO = parcelRequire("6OZAO");

var $6cds3 = parcelRequire("6cds3");

function $4a3e215446c0ed92$var$_extends() {
    $4a3e215446c0ed92$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a3e215446c0ed92$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $4a3e215446c0ed92$export$3add0d5dce533e2e = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$export$145dfa71566a64dc = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$var$AwaitContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $4a3e215446c0ed92$export$26749e8557646306 = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$export$c7914228fb69b0f5 = /*#__PURE__*/ $6cds3.createContext(null);
var $4a3e215446c0ed92$export$9072aa6dd1f93057 = /*#__PURE__*/ $6cds3.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $4a3e215446c0ed92$var$RouteErrorContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $4a3e215446c0ed92$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var _React_useContext = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $4a3e215446c0ed92$export$9c954a9d03d32f4a() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $4a3e215446c0ed92$export$45d76561a5302f2b() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $4a3e215446c0ed92$export$1b3f31771c5d07c() {
    return $6cds3.useContext($4a3e215446c0ed92$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $4a3e215446c0ed92$export$6c330e8992e8a295(pattern) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var pathname = $4a3e215446c0ed92$export$45d76561a5302f2b().pathname;
    return $6cds3.useMemo(function() {
        return (0, $96b280a33643b696$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $4a3e215446c0ed92$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6cds3.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $4a3e215446c0ed92$export$9770f232ac06a008() {
    var isDataRoute = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4a3e215446c0ed92$var$useNavigateStable() : $4a3e215446c0ed92$var$useNavigateUnstable();
}
function $4a3e215446c0ed92$var$useNavigateUnstable() {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    var _React_useContext = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var _useLocation = $4a3e215446c0ed92$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $4a3e215446c0ed92$var$OutletContext = /*#__PURE__*/ $6cds3.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $4a3e215446c0ed92$export$4138103a3ae699cc() {
    return $6cds3.useContext($4a3e215446c0ed92$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $4a3e215446c0ed92$export$a3be3530d8e40d0b(context) {
    var outlet = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $4a3e215446c0ed92$export$99eaa27ddbbb95ef() {
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $4a3e215446c0ed92$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var _useLocation = $4a3e215446c0ed92$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $96b280a33643b696$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return $6cds3.useMemo(function() {
        return (0, $96b280a33643b696$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $4a3e215446c0ed92$export$5d3fca4a98652595(routes, locationArg) {
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var navigator = $6cds3.useContext($4a3e215446c0ed92$export$26749e8557646306).navigator;
    var _React_useContext = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $4a3e215446c0ed92$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, $96b280a33643b696$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $4a3e215446c0ed92$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $96b280a33643b696$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4a3e215446c0ed92$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4a3e215446c0ed92$var$DefaultErrorComponent() {
    var error = $4a3e215446c0ed92$export$ed527bf60f6e05f2();
    var message = (0, $96b280a33643b696$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6cds3.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6cds3.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $4a3e215446c0ed92$var$defaultErrorElement = /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DefaultErrorComponent, null);
var $4a3e215446c0ed92$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $ftJVG._)(RenderErrorBoundary, _React_Component);
    var _super = (0, $6OZAO._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, $978gY._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $kry2a._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($6cds3.Component);
function $4a3e215446c0ed92$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4a3e215446c0ed92$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $4a3e215446c0ed92$var$defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6cds3.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4a3e215446c0ed92$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($4a3e215446c0ed92$var$DataRouterHook || ($4a3e215446c0ed92$var$DataRouterHook = {}));
var $4a3e215446c0ed92$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($4a3e215446c0ed92$var$DataRouterStateHook || ($4a3e215446c0ed92$var$DataRouterStateHook = {}));
function $4a3e215446c0ed92$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4a3e215446c0ed92$var$useDataRouterContext(hookName) {
    var ctx = $6cds3.useContext($4a3e215446c0ed92$export$3add0d5dce533e2e);
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4a3e215446c0ed92$var$useDataRouterState(hookName) {
    var state = $6cds3.useContext($4a3e215446c0ed92$export$145dfa71566a64dc);
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
function $4a3e215446c0ed92$var$useRouteContext(hookName) {
    var route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4a3e215446c0ed92$var$useCurrentRouteId(hookName) {
    var route = $4a3e215446c0ed92$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4a3e215446c0ed92$export$5fc8298006ad9e58() {
    return $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4a3e215446c0ed92$export$d0fd4b7106de2769() {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4a3e215446c0ed92$export$600dc272ed516c15() {
    var dataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseRevalidator);
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4a3e215446c0ed92$export$2378eb7f5ff86053() {
    var _useDataRouterState = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $6cds3.useMemo(function() {
        return matches.map(function(match) {
            var pathname = match.pathname, params = match.params;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4a3e215446c0ed92$export$1448a5050d252c4d() {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    var routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4a3e215446c0ed92$export$fd5d37484eab868d(routeId) {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4a3e215446c0ed92$export$fdc00f3f26066d5e() {
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseActionData);
    var route = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057);
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4a3e215446c0ed92$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $6cds3.useContext($4a3e215446c0ed92$var$RouteErrorContext);
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    var routeId = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $4a3e215446c0ed92$export$78a72ddb39bdd145() {
    var value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $4a3e215446c0ed92$export$17f53340677d5831() {
    var value = $6cds3.useContext($4a3e215446c0ed92$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $4a3e215446c0ed92$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4a3e215446c0ed92$export$2af03a1de5c0910(shouldBlock) {
    var _useDataRouterContext = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $4a3e215446c0ed92$var$useDataRouterState($4a3e215446c0ed92$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $8GFUW._)($6cds3.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $6cds3.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $4a3e215446c0ed92$var$_extends({}, currentLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4a3e215446c0ed92$var$_extends({}, nextLocation, {
                pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6cds3.useEffect(function() {
        var key = String(++$4a3e215446c0ed92$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6cds3.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $96b280a33643b696$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4a3e215446c0ed92$var$useNavigateStable() {
    var router = $4a3e215446c0ed92$var$useDataRouterContext($4a3e215446c0ed92$var$DataRouterHook.UseNavigateStable).router;
    var id = $4a3e215446c0ed92$var$useCurrentRouteId($4a3e215446c0ed92$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $6cds3.useRef(false);
    $4a3e215446c0ed92$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $6cds3.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4a3e215446c0ed92$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $4a3e215446c0ed92$var$alreadyWarned = {};
function $4a3e215446c0ed92$var$warningOnce(key, cond, message) {
    if (!cond && !$4a3e215446c0ed92$var$alreadyWarned[key]) $4a3e215446c0ed92$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $4a3e215446c0ed92$var$START_TRANSITION = "startTransition";
var $4a3e215446c0ed92$var$startTransitionImpl = $6cds3[$4a3e215446c0ed92$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4a3e215446c0ed92$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    var _React_useState = (0, $8GFUW._)($6cds3.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = $6cds3.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $6cds3.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $4a3e215446c0ed92$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return $4a3e215446c0ed92$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $4a3e215446c0ed92$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $4a3e215446c0ed92$var$startTransitionImpl ? $4a3e215446c0ed92$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $4a3e215446c0ed92$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var matches = $6cds3.useContext($4a3e215446c0ed92$export$9072aa6dd1f93057).matches;
    var _useLocation = $4a3e215446c0ed92$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $4a3e215446c0ed92$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $96b280a33643b696$export$cae722b0cc860f13)(to, (0, $96b280a33643b696$export$90ba53ce1c7fdff2)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $6cds3.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $4a3e215446c0ed92$export$910ae8079b2c2852(props) {
    return $4a3e215446c0ed92$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $4a3e215446c0ed92$export$e7b0ac011bb776c6(_props) {
    (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $4a3e215446c0ed92$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $96b280a33643b696$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!$4a3e215446c0ed92$export$9c954a9d03d32f4a() && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $6cds3.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $96b280a33643b696$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $6cds3.useMemo(function() {
        var trailingPathname = (0, $96b280a33643b696$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $4a3e215446c0ed92$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $4a3e215446c0ed92$export$5d3fca4a98652595($4a3e215446c0ed92$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4a3e215446c0ed92$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$ResolveAwait, null, children));
}
var $4a3e215446c0ed92$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($4a3e215446c0ed92$var$AwaitRenderStatus || ($4a3e215446c0ed92$var$AwaitRenderStatus = {}));
var $4a3e215446c0ed92$var$neverSettledPromise = new Promise(function() {});
var $4a3e215446c0ed92$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $ftJVG._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, $6OZAO._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, $978gY._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $kry2a._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $4a3e215446c0ed92$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $4a3e215446c0ed92$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.error : promise._data !== undefined ? $4a3e215446c0ed92$var$AwaitRenderStatus.success : $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $4a3e215446c0ed92$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && promise._error instanceof (0, $96b280a33643b696$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $4a3e215446c0ed92$var$neverSettledPromise;
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $4a3e215446c0ed92$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $6cds3.createElement($4a3e215446c0ed92$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($6cds3.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $4a3e215446c0ed92$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $4a3e215446c0ed92$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6cds3.createElement($6cds3.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $4a3e215446c0ed92$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $6cds3.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $6cds3.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $fLnyw._)(parentPath).concat([
            index
        ]);
        if (element.type === $6cds3.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4a3e215446c0ed92$export$e7b0ac011bb776c6) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4a3e215446c0ed92$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4a3e215446c0ed92$export$daf73786167a7f72(matches) {
    return $4a3e215446c0ed92$var$_renderMatches(matches);
}
function $4a3e215446c0ed92$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6cds3.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6cds3.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4a3e215446c0ed92$export$f30f7e456d254e83(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4a3e215446c0ed92$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4a3e215446c0ed92$export$52b333d321859367
    }).initialize();
}



function $0e36e707c39d0f3a$var$_extends() {
    $0e36e707c39d0f3a$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0e36e707c39d0f3a$var$_extends.apply(this, arguments);
}
function $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0e36e707c39d0f3a$var$defaultMethod = "get";
var $0e36e707c39d0f3a$var$defaultEncType = "application/x-www-form-urlencoded";
function $0e36e707c39d0f3a$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0e36e707c39d0f3a$var$isButtonElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0e36e707c39d0f3a$var$isFormElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0e36e707c39d0f3a$var$isInputElement(object) {
    return $0e36e707c39d0f3a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0e36e707c39d0f3a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0e36e707c39d0f3a$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0e36e707c39d0f3a$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
                    searchParams.append(key, value);
                });
            };
            for(var _iterator = defaultSearchParams.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return searchParams;
}
// One-time check for submitter support
var $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = null;
function $0e36e707c39d0f3a$var$isFormDataSubmitterSupported() {
    if ($0e36e707c39d0f3a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0e36e707c39d0f3a$var$_formDataSupportsSubmitter = true;
    }
    return $0e36e707c39d0f3a$var$_formDataSupportsSubmitter;
}
var $0e36e707c39d0f3a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0e36e707c39d0f3a$var$getFormEncType(encType) {
    if (encType != null && !$0e36e707c39d0f3a$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($0e36e707c39d0f3a$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0e36e707c39d0f3a$var$isButtonElement(target) || $0e36e707c39d0f3a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $96b280a33643b696$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0e36e707c39d0f3a$var$defaultMethod;
        encType = $0e36e707c39d0f3a$var$getFormEncType(target.getAttribute("formenctype")) || $0e36e707c39d0f3a$var$getFormEncType(form.getAttribute("enctype")) || $0e36e707c39d0f3a$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0e36e707c39d0f3a$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0e36e707c39d0f3a$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0e36e707c39d0f3a$var$defaultMethod;
        action = null;
        encType = $0e36e707c39d0f3a$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $0e36e707c39d0f3a$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $0e36e707c39d0f3a$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $0e36e707c39d0f3a$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $0e36e707c39d0f3a$export$1f3f55432a00e06d(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367)
    }).initialize();
}
function $0e36e707c39d0f3a$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $96b280a33643b696$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0e36e707c39d0f3a$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $96b280a33643b696$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0e36e707c39d0f3a$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4a3e215446c0ed92$export$52b333d321859367)
    }).initialize();
}
function $0e36e707c39d0f3a$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0e36e707c39d0f3a$var$_extends({}, state, {
        errors: $0e36e707c39d0f3a$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0e36e707c39d0f3a$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $96b280a33643b696$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $0e36e707c39d0f3a$var$START_TRANSITION = "startTransition";
var $0e36e707c39d0f3a$var$startTransitionImpl = $6cds3[$0e36e707c39d0f3a$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0e36e707c39d0f3a$export$9ba4e89fdfa1fc54(_ref) {
    var basename = _ref.basename, children = _ref.children, future = _ref.future, _$window = _ref.window;
    var historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0e36e707c39d0f3a$export$7221d69dcfc8e36b(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, future = _ref2.future, _$window = _ref2.window;
    var historyRef = $6cds3.useRef();
    if (historyRef.current == null) historyRef.current = (0, $96b280a33643b696$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0e36e707c39d0f3a$export$eefb0c834599897e(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, future = _ref3.future, history = _ref3.history;
    var _React_useState = (0, $8GFUW._)($6cds3.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $6cds3.useCallback(function(newState) {
        v7_startTransition && $0e36e707c39d0f3a$var$startTransitionImpl ? $0e36e707c39d0f3a$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6cds3.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $6cds3.createElement((0, $4a3e215446c0ed92$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var $0e36e707c39d0f3a$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ var $0e36e707c39d0f3a$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6cds3.forwardRef(function LinkWithRef(_ref4, ref) {
    var handleClick = function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    };
    var onClick = _ref4.onClick, relative = _ref4.relative, reloadDocument = _ref4.reloadDocument, replace = _ref4.replace, state = _ref4.state, target = _ref4.target, to = _ref4.to, preventScrollReset = _ref4.preventScrollReset, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref4, $0e36e707c39d0f3a$var$_excluded);
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $0e36e707c39d0f3a$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0e36e707c39d0f3a$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $96b280a33643b696$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $4a3e215446c0ed92$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $0e36e707c39d0f3a$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6cds3.createElement("a", $0e36e707c39d0f3a$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $0e36e707c39d0f3a$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6cds3.forwardRef(function NavLinkWithRef(_ref5, ref) {
    var tmp = _ref5["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref5_caseSensitive = _ref5.caseSensitive, caseSensitive = _ref5_caseSensitive === void 0 ? false : _ref5_caseSensitive, tmp1 = _ref5.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref5_end = _ref5.end, end = _ref5_end === void 0 ? false : _ref5_end, styleProp = _ref5.style, to = _ref5.to, children = _ref5.children, rest = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref5, $0e36e707c39d0f3a$var$_excluded2);
    var path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var routerState = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    var navigator = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).navigator;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$export$a6c7ac8248d6e38a, $0e36e707c39d0f3a$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $0e36e707c39d0f3a$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6cds3.forwardRef(function(props, ref) {
    var submit = $0e36e707c39d0f3a$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$FormImpl, $0e36e707c39d0f3a$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
var $0e36e707c39d0f3a$var$FormImpl = /*#__PURE__*/ $6cds3.forwardRef(function(_ref6, forwardedRef) {
    var reloadDocument = _ref6.reloadDocument, replace = _ref6.replace, state = _ref6.state, _ref6_method = _ref6.method, method = _ref6_method === void 0 ? $0e36e707c39d0f3a$var$defaultMethod : _ref6_method, action = _ref6.action, onSubmit = _ref6.onSubmit, submit = _ref6.submit, relative = _ref6.relative, preventScrollReset = _ref6.preventScrollReset, props = $0e36e707c39d0f3a$var$_objectWithoutPropertiesLoose(_ref6, $0e36e707c39d0f3a$var$_excluded3);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $6cds3.createElement("form", $0e36e707c39d0f3a$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0e36e707c39d0f3a$export$11aac1aab828f1fa(_ref7) {
    var getKey = _ref7.getKey, storageKey = _ref7.storageKey;
    $0e36e707c39d0f3a$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0e36e707c39d0f3a$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($0e36e707c39d0f3a$var$DataRouterHook || ($0e36e707c39d0f3a$var$DataRouterHook = {}));
var $0e36e707c39d0f3a$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0e36e707c39d0f3a$var$DataRouterStateHook || ($0e36e707c39d0f3a$var$DataRouterStateHook = {}));
function $0e36e707c39d0f3a$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0e36e707c39d0f3a$var$useDataRouterContext(hookName) {
    var ctx = $6cds3.useContext((0, $4a3e215446c0ed92$export$3add0d5dce533e2e));
    !ctx && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0e36e707c39d0f3a$var$useDataRouterState(hookName) {
    var state = $6cds3.useContext((0, $4a3e215446c0ed92$export$145dfa71566a64dc));
    !state && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0e36e707c39d0f3a$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative;
    var navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var path = (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6cds3.useCallback(function(event) {
        if ($0e36e707c39d0f3a$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $96b280a33643b696$export$fe53371bee54353d)(location) === (0, $96b280a33643b696$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0e36e707c39d0f3a$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $6cds3.useRef($0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $6cds3.useRef(false);
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var searchParams = $6cds3.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0e36e707c39d0f3a$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $4a3e215446c0ed92$export$9770f232ac06a008)();
    var setSearchParams = $6cds3.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $0e36e707c39d0f3a$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0e36e707c39d0f3a$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0e36e707c39d0f3a$export$47c85c6e3a081d3() {
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmit).router;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    var currentRouteId = (0, $4a3e215446c0ed92$export$5fc8298006ad9e58)();
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $0e36e707c39d0f3a$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseSubmitFetcher).router;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    return $6cds3.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0e36e707c39d0f3a$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $0e36e707c39d0f3a$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        !(fetcherRouteId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0e36e707c39d0f3a$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    var routeContext = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !routeContext && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $8GFUW._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $0e36e707c39d0f3a$var$_extends({}, (0, $4a3e215446c0ed92$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $96b280a33643b696$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $96b280a33643b696$export$fe53371bee54353d)(path);
}
function $0e36e707c39d0f3a$var$createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ $6cds3.forwardRef(function(props, ref) {
        var submit = $0e36e707c39d0f3a$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $6cds3.createElement($0e36e707c39d0f3a$var$FormImpl, $0e36e707c39d0f3a$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
var $0e36e707c39d0f3a$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0e36e707c39d0f3a$export$5b0d2d9a9921565a() {
    var _route$matches;
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseFetcher).router;
    var route = $6cds3.useContext((0, $4a3e215446c0ed92$export$9072aa6dd1f93057));
    !route && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
    var _React_useState = (0, $8GFUW._)($6cds3.useState(function() {
        return String(++$0e36e707c39d0f3a$var$fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, $8GFUW._)($6cds3.useState(function() {
        !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
        return $0e36e707c39d0f3a$var$createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, $8GFUW._)($6cds3.useState(function() {
        return function(href) {
            !router && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
            !routeId && (0, $96b280a33643b696$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = $0e36e707c39d0f3a$var$useSubmitFetcher(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = $6cds3.useMemo(function() {
        return $0e36e707c39d0f3a$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    $6cds3.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0e36e707c39d0f3a$export$fa996778a3a31087() {
    var state = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseFetchers);
    return (0, $fLnyw._)(state.fetchers.values());
}
var $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $0e36e707c39d0f3a$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0e36e707c39d0f3a$export$25057cfe5591e3e9(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $0e36e707c39d0f3a$var$useDataRouterContext($0e36e707c39d0f3a$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $0e36e707c39d0f3a$var$useDataRouterState($0e36e707c39d0f3a$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $6cds3.useContext((0, $4a3e215446c0ed92$export$26749e8557646306)).basename;
    var location = (0, $4a3e215446c0ed92$export$45d76561a5302f2b)();
    var matches = (0, $4a3e215446c0ed92$export$2378eb7f5ff86053)();
    var navigation = (0, $4a3e215446c0ed92$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6cds3.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0e36e707c39d0f3a$var$usePageHide($6cds3.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $0e36e707c39d0f3a$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0e36e707c39d0f3a$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $0e36e707c39d0f3a$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0e36e707c39d0f3a$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($0e36e707c39d0f3a$var$_extends({}, location, {
                    pathname: (0, $96b280a33643b696$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0e36e707c39d0f3a$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6cds3.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $6cds3.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0e36e707c39d0f3a$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $6cds3.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0e36e707c39d0f3a$export$39f4eb3dbd812741(_ref8) {
    var when = _ref8.when, message = _ref8.message;
    var blocker = (0, $4a3e215446c0ed92$export$2af03a1de5c0910)(when);
    $6cds3.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $6cds3.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}


var $b313b78281719b82$var$Headline = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex flex-wrap pt-28 px-[5%]",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "pt-6",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "text-2xl font-bold",
                        children: "Find Your Ideal Car Rental"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "text-6xl font-bold my-6",
                        children: [
                            "Easy ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "text-blue-800",
                                children: "Renting"
                            }),
                            " and",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            "Secure car ",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                className: "text-blue-800",
                                children: "Hosting"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "text-gray-600 mb-8 text-lg",
                        children: "Search and discover the best car rental options with ease."
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                className: "bg-blue-800 py-3 px-5 mr-8 font-bold text-white",
                                children: "find your best match"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "carHost",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
                                    className: "border-b-2 bg-gray-300 text-black font-bold py-3 px-8 flex items-center",
                                    children: [
                                        "Host Your Car",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            className: "pl-2",
                                            width: "25",
                                            height: "20",
                                            src: "https://img.icons8.com/ios-filled/100/car-rental.png",
                                            alt: "car-rental"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "hidden md:block",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    className: "absolute w-[50%] ml-10",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($05aab5ccdefa059a$exports))),
                    alt: "car"
                })
            })
        ]
    });
};
var $b313b78281719b82$export$2e2bcd8739ae039 = $b313b78281719b82$var$Headline;



parcelRequire("6cds3");
var $13894193f88fe9dc$var$BrandIcons = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "m-12 mt-16 px-4 bg-neutral-200 rounded-lg items-center justify-between shadow-lg hidden md:flex",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                width: "100",
                height: "100",
                src: "https://img.icons8.com/plasticine/100/bmw.png",
                alt: "bmw"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                width: "50",
                height: "50",
                src: "https://img.icons8.com/ios-filled/50/tesla-logo.png",
                alt: "tesla-logo"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                width: "50",
                height: "50",
                src: "https://img.icons8.com/ios/50/honda.png",
                alt: "honda"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                width: "100",
                height: "100",
                src: "https://img.icons8.com/plasticine/100/ford.png",
                alt: "ford"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                width: "67",
                height: "67",
                src: "https://img.icons8.com/external-others-inmotus-design/67/external-Mercedes-mercedes-and-bmw-others-inmotus-design-3.png",
                alt: "external-Mercedes-mercedes-and-bmw-others-inmotus-design-3"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                width: "100",
                height: "100",
                src: "https://img.icons8.com/carbon-copy/100/kia.png",
                alt: "kia"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                width: "50",
                height: "50",
                src: "https://img.icons8.com/ios/50/audi.png",
                alt: "audi"
            })
        ]
    });
};
var $13894193f88fe9dc$export$2e2bcd8739ae039 = $13894193f88fe9dc$var$BrandIcons;


var $ea75739bc7566219$var$HeadlineContainer = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b313b78281719b82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $13894193f88fe9dc$export$2e2bcd8739ae039), {})
        ]
    });
};
var $ea75739bc7566219$export$2e2bcd8739ae039 = $ea75739bc7566219$var$HeadlineContainer;



var $8GFUW = parcelRequire("8GFUW");


var $6cds3 = parcelRequire("6cds3");


var $3vWwE = parcelRequire("3vWwE");


var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");


var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $3vWwE = parcelRequire("3vWwE");

var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $a8i8g = parcelRequire("a8i8g");
var $b1467a785fc7cec5$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ var $b1467a785fc7cec5$export$a7a9523472993e97 = function assert(assertion, message) {
    if (!assertion) throw $b1467a785fc7cec5$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ var $b1467a785fc7cec5$export$a39cad550e7ab28a = function assertionError(message) {
    return new Error("Firebase Database (" + $b1467a785fc7cec5$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b1467a785fc7cec5$var$stringToByteArray$1 = function stringToByteArray$1(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ var $b1467a785fc7cec5$var$byteArrayToString = function byteArrayToString(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0, c = 0;
    while(pos < bytes.length){
        var c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c21 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (c21 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var c22 = bytes[pos++];
            var c31 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c22 & 63) << 6 | c31 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var $b1467a785fc7cec5$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray: function(input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for(var i = 0; i < input.length; i += 3){
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($b1467a785fc7cec5$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString: function(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $b1467a785fc7cec5$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray: function(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for(var i = 0; i < input.length;){
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $b1467a785fc7cec5$export$55ca9d4bee46aeb3();
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_: function() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(var i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ var $b1467a785fc7cec5$export$55ca9d4bee46aeb3 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(DecodeBase64StringError, Error1);
    var _super = (0, $6OZAO._)(DecodeBase64StringError);
    function DecodeBase64StringError() {
        (0, $978gY._)(this, DecodeBase64StringError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.name = "DecodeBase64StringError";
        return _this;
    }
    return DecodeBase64StringError;
}((0, $2TMdq._)(Error));
/**
 * URL-safe base64 encoding
 */ var $b1467a785fc7cec5$export$e510a73ee562749 = function base64Encode(str) {
    var utf8Bytes = $b1467a785fc7cec5$var$stringToByteArray$1(str);
    return $b1467a785fc7cec5$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ var $b1467a785fc7cec5$export$4b5284a3025a455 = function base64urlEncodeWithoutPadding(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $b1467a785fc7cec5$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ var $b1467a785fc7cec5$export$c62426fdd000a97e = function base64Decode(str) {
    try {
        return $b1467a785fc7cec5$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $b1467a785fc7cec5$export$6c40052bed430212(value) {
    return $b1467a785fc7cec5$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $b1467a785fc7cec5$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(var prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$b1467a785fc7cec5$var$isValidKey(prop)) continue;
        target[prop] = $b1467a785fc7cec5$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $b1467a785fc7cec5$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $b1467a785fc7cec5$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b1467a785fc7cec5$var$getDefaultsFromGlobal = function() {
    return $b1467a785fc7cec5$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
};
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ var $b1467a785fc7cec5$var$getDefaultsFromEnvVariable = function() {
    if (typeof $a8i8g === "undefined" || typeof $a8i8g.env === "undefined") return;
    var defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
var $b1467a785fc7cec5$var$getDefaultsFromCookie = function() {
    if (typeof document === "undefined") return;
    var match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    var decoded = match && $b1467a785fc7cec5$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ var $b1467a785fc7cec5$export$212bb2fc580a90a8 = function() {
    try {
        return $b1467a785fc7cec5$var$getDefaultsFromGlobal() || $b1467a785fc7cec5$var$getDefaultsFromEnvVariable() || $b1467a785fc7cec5$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info("Unable to get __FIREBASE_DEFAULTS__ due to: ".concat(e));
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ var $b1467a785fc7cec5$export$9c11895284c8adad = function(productName) {
    var _a, _b;
    return (_b = (_a = $b1467a785fc7cec5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ var $b1467a785fc7cec5$export$a3febcf1f14a3a0c = function(productName) {
    var host = $b1467a785fc7cec5$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    var separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error("Invalid host ".concat(host, " with no separate hostname and port!"));
    // eslint-disable-next-line no-restricted-globals
    var port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ var $b1467a785fc7cec5$export$3dfb6827a9f89756 = function() {
    var _a;
    return (_a = $b1467a785fc7cec5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ var $b1467a785fc7cec5$export$5539a1a3afe87d6 = function(name) {
    var _a;
    return (_a = $b1467a785fc7cec5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a["_".concat(name)];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b1467a785fc7cec5$export$85f6557964517f1a = /*#__PURE__*/ function() {
    "use strict";
    function Deferred() {
        var _this = this;
        (0, $978gY._)(this, Deferred);
        this.reject = function() {};
        this.resolve = function() {};
        this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    (0, $kry2a._)(Deferred, [
        {
            /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ key: "wrapCallback",
            value: function wrapCallback(callback) {
                var _this = this;
                return function(error, value) {
                    if (error) _this.reject(error);
                    else _this.resolve(value);
                    if (typeof callback === "function") {
                        // Attaching noop handler just in case developer wasn't expecting
                        // promises
                        _this.promise.catch(function() {});
                        // Some of our callbacks don't expect a value and our own tests
                        // assert that the parameter length is 1
                        if (callback.length === 1) callback(error);
                        else callback(error, value);
                    }
                };
            }
        }
    ]);
    return Deferred;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1467a785fc7cec5$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: "none",
        type: "JWT"
    };
    var project = projectId || "demo-project";
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    var payload = Object.assign({
        // Set all required fields to decent defaults
        iss: "https://securetoken.google.com/".concat(project),
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = "";
    return [
        $b1467a785fc7cec5$export$4b5284a3025a455(JSON.stringify(header)),
        $b1467a785fc7cec5$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $b1467a785fc7cec5$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $b1467a785fc7cec5$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($b1467a785fc7cec5$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $b1467a785fc7cec5$export$8ee0fc9ee280b4ee() {
    var _a;
    var forceEnvironment = (_a = $b1467a785fc7cec5$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $b1467a785fc7cec5$export$4e09c449d6c407f7() {
    return typeof self === "object" && self.self === self;
}
function $b1467a785fc7cec5$export$caa8774a9107a58e() {
    var runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $b1467a785fc7cec5$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $b1467a785fc7cec5$export$f2f6a8999f8ebd30() {
    return $b1467a785fc7cec5$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $b1467a785fc7cec5$export$7e7b1a9668aaed8() {
    var ua = $b1467a785fc7cec5$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $b1467a785fc7cec5$export$202944b2d2824246() {
    return $b1467a785fc7cec5$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $b1467a785fc7cec5$export$5d1d834fbbf8bab7() {
    return $b1467a785fc7cec5$export$588c7fdda06fbb0a.NODE_CLIENT === true || $b1467a785fc7cec5$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $b1467a785fc7cec5$export$95df08bae54cb4df() {
    return !$b1467a785fc7cec5$export$8ee0fc9ee280b4ee() && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $b1467a785fc7cec5$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $b1467a785fc7cec5$export$a8a3018f3d187a4d() {
    return new Promise(function(resolve, reject) {
        try {
            var preExist = true;
            var DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            var request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = function() {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = function() {
                preExist = false;
            };
            request.onerror = function() {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $b1467a785fc7cec5$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ var $b1467a785fc7cec5$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
var $b1467a785fc7cec5$export$dd24e9cd51226c56 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(FirebaseError, Error1);
    var _super = (0, $6OZAO._)(FirebaseError);
    function FirebaseError(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData) {
        (0, $978gY._)(this, FirebaseError);
        var _this;
        _this = _super.call(this, message);
        _this.code = code;
        _this.customData = customData;
        /** The custom name for all FirebaseErrors. */ _this.name = $b1467a785fc7cec5$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $3vWwE._)(_this), FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace((0, $3vWwE._)(_this), $b1467a785fc7cec5$export$3fa6e1b18a3b2d40.prototype.create);
        return _this;
    }
    return FirebaseError;
}((0, $2TMdq._)(Error));
var $b1467a785fc7cec5$export$3fa6e1b18a3b2d40 = /*#__PURE__*/ function() {
    "use strict";
    function ErrorFactory(service, serviceName, errors) {
        (0, $978gY._)(this, ErrorFactory);
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    (0, $kry2a._)(ErrorFactory, [
        {
            key: "create",
            value: function create(code) {
                for(var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    data[_key - 1] = arguments[_key];
                }
                var customData = data[0] || {};
                var fullCode = "".concat(this.service, "/").concat(code);
                var template = this.errors[code];
                var message = template ? $b1467a785fc7cec5$var$replaceTemplate(template, customData) : "Error";
                // Service Name: Error message (service/code).
                var fullMessage = "".concat(this.serviceName, ": ").concat(message, " (").concat(fullCode, ").");
                var error = new $b1467a785fc7cec5$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
                return error;
            }
        }
    ]);
    return ErrorFactory;
}();
function $b1467a785fc7cec5$var$replaceTemplate(template, data) {
    return template.replace($b1467a785fc7cec5$var$PATTERN, function(_, key) {
        var value = data[key];
        return value != null ? String(value) : "<".concat(key, "?>");
    });
}
var $b1467a785fc7cec5$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $b1467a785fc7cec5$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $b1467a785fc7cec5$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $b1467a785fc7cec5$export$2f872c0f2117be69 = function decode(token) {
    var header = {}, claims = {}, data = {}, signature = "";
    try {
        var parts = token.split(".");
        header = $b1467a785fc7cec5$export$c5a53ce6a17cf18d($b1467a785fc7cec5$export$c62426fdd000a97e(parts[0]) || "");
        claims = $b1467a785fc7cec5$export$c5a53ce6a17cf18d($b1467a785fc7cec5$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $b1467a785fc7cec5$export$5f870fcca7ae6a88 = function isValidTimestamp(token) {
    var claims = $b1467a785fc7cec5$export$2f872c0f2117be69(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $b1467a785fc7cec5$export$701c661ec91095f2 = function issuedAtTime(token) {
    var claims = $b1467a785fc7cec5$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $b1467a785fc7cec5$export$9565ca3d387f8aa0 = function isValidFormat(token) {
    var decoded = $b1467a785fc7cec5$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ var $b1467a785fc7cec5$export$fc970ed23da99565 = function isAdmin(token) {
    var claims = $b1467a785fc7cec5$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1467a785fc7cec5$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $b1467a785fc7cec5$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $b1467a785fc7cec5$export$dd1bc94b04021eeb(obj) {
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $b1467a785fc7cec5$export$871de8747c9eaa88(obj, fn, contextObj) {
    var res = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $b1467a785fc7cec5$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var k = _step.value;
            if (!bKeys.includes(k)) return false;
            var aProp = a[k];
            var bProp = b[k];
            if ($b1467a785fc7cec5$var$isObject(aProp) && $b1467a785fc7cec5$var$isObject(bProp)) {
                if (!$b1467a785fc7cec5$export$9cb4719e2e525b7a(aProp, bProp)) return false;
            } else if (aProp !== bProp) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = bKeys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var k1 = _step1.value;
            if (!aKeys.includes(k1)) return false;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return true;
}
function $b1467a785fc7cec5$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $b1467a785fc7cec5$export$a9cd205a244d9f54(promise) {
    var timeInMS = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2000;
    var deferredPromise = new $b1467a785fc7cec5$export$85f6557964517f1a();
    setTimeout(function() {
        return deferredPromise.reject("timeout!");
    }, timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $b1467a785fc7cec5$export$ac4103b836844853(querystringParams) {
    var params = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (Array.isArray(value)) value.forEach(function(arrayVal) {
                params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
            });
            else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
        };
        for(var _iterator = Object.entries(querystringParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $b1467a785fc7cec5$export$c1271ca4c8a70741(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach(function(token) {
        if (token) {
            var _token_split = (0, $8GFUW._)(token.split("="), 2), key = _token_split[0], value = _token_split[1];
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $b1467a785fc7cec5$export$1a8408415472d8ed(url) {
    var queryStart = url.indexOf("?");
    if (!queryStart) return "";
    var fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ var $b1467a785fc7cec5$export$c85d589bf4e25fef = /*#__PURE__*/ function() {
    "use strict";
    function Sha1() {
        (0, $978gY._)(this, Sha1);
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(var i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    (0, $kry2a._)(Sha1, [
        {
            key: "reset",
            value: function reset() {
                this.chain_[0] = 0x67452301;
                this.chain_[1] = 0xefcdab89;
                this.chain_[2] = 0x98badcfe;
                this.chain_[3] = 0x10325476;
                this.chain_[4] = 0xc3d2e1f0;
                this.inbuf_ = 0;
                this.total_ = 0;
            }
        },
        {
            /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ key: "compress_",
            value: function compress_(buf, offset) {
                if (!offset) offset = 0;
                var W = this.W_;
                // get 16 big endian words
                if (typeof buf === "string") for(var i = 0; i < 16; i++){
                    // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                    // have a bug that turns the post-increment ++ operator into pre-increment
                    // during JIT compilation.  We have code that depends heavily on SHA-1 for
                    // correctness and which is affected by this bug, so I've removed all uses
                    // of post-increment ++ in which the result value is used.  We can revert
                    // this change once the Safari bug
                    // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                    // most clients have been updated.
                    W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
                    offset += 4;
                }
                else for(var i1 = 0; i1 < 16; i1++){
                    W[i1] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
                    offset += 4;
                }
                // expand to 80 words
                for(var i2 = 16; i2 < 80; i2++){
                    var t = W[i2 - 3] ^ W[i2 - 8] ^ W[i2 - 14] ^ W[i2 - 16];
                    W[i2] = (t << 1 | t >>> 31) & 0xffffffff;
                }
                var a = this.chain_[0];
                var b = this.chain_[1];
                var c = this.chain_[2];
                var d = this.chain_[3];
                var e = this.chain_[4];
                var f, k;
                // TODO(user): Try to unroll this loop to speed up the computation.
                for(var i3 = 0; i3 < 80; i3++){
                    if (i3 < 40) {
                        if (i3 < 20) {
                            f = d ^ b & (c ^ d);
                            k = 0x5a827999;
                        } else {
                            f = b ^ c ^ d;
                            k = 0x6ed9eba1;
                        }
                    } else if (i3 < 60) {
                        f = b & c | d & (b | c);
                        k = 0x8f1bbcdc;
                    } else {
                        f = b ^ c ^ d;
                        k = 0xca62c1d6;
                    }
                    var t1 = (a << 5 | a >>> 27) + f + e + k + W[i3] & 0xffffffff;
                    e = d;
                    d = c;
                    c = (b << 30 | b >>> 2) & 0xffffffff;
                    b = a;
                    a = t1;
                }
                this.chain_[0] = this.chain_[0] + a & 0xffffffff;
                this.chain_[1] = this.chain_[1] + b & 0xffffffff;
                this.chain_[2] = this.chain_[2] + c & 0xffffffff;
                this.chain_[3] = this.chain_[3] + d & 0xffffffff;
                this.chain_[4] = this.chain_[4] + e & 0xffffffff;
            }
        },
        {
            key: "update",
            value: function update(bytes, length) {
                // TODO(johnlenz): tighten the function signature and remove this check
                if (bytes == null) return;
                if (length === undefined) length = bytes.length;
                var lengthMinusBlock = length - this.blockSize;
                var n = 0;
                // Using local instead of member variables gives ~5% speedup on Firefox 16.
                var buf = this.buf_;
                var inbuf = this.inbuf_;
                // The outer while loop should execute at most twice.
                while(n < length){
                    // When we have no data in the block to top up, we can directly process the
                    // input buffer (assuming it contains sufficient data). This gives ~25%
                    // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
                    // the data is provided in large chunks (or in multiples of 64 bytes).
                    if (inbuf === 0) while(n <= lengthMinusBlock){
                        this.compress_(bytes, n);
                        n += this.blockSize;
                    }
                    if (typeof bytes === "string") while(n < length){
                        buf[inbuf] = bytes.charCodeAt(n);
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                    else while(n < length){
                        buf[inbuf] = bytes[n];
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            break;
                        }
                    }
                }
                this.inbuf_ = inbuf;
                this.total_ += length;
            }
        },
        {
            /** @override */ key: "digest",
            value: function digest() {
                var digest = [];
                var totalBits = this.total_ * 8;
                // Add pad 0x80 0x00*.
                if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
                else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
                // Add # bits.
                for(var i = this.blockSize - 1; i >= 56; i--){
                    this.buf_[i] = totalBits & 255;
                    totalBits /= 256; // Don't use bit-shifting here!
                }
                this.compress_(this.buf_);
                var n = 0;
                for(var i1 = 0; i1 < 5; i1++)for(var j = 24; j >= 0; j -= 8){
                    digest[n] = this.chain_[i1] >> j & 255;
                    ++n;
                }
                return digest;
            }
        }
    ]);
    return Sha1;
}();
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $b1467a785fc7cec5$export$364097d812234b3f(executor, onNoObservers) {
    var proxy = new $b1467a785fc7cec5$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ var $b1467a785fc7cec5$var$ObserverProxy = /*#__PURE__*/ function() {
    "use strict";
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        (0, $978gY._)(this, ObserverProxy);
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function() {
            executor(_this);
        }).catch(function(e) {
            _this.error(e);
        });
    }
    (0, $kry2a._)(ObserverProxy, [
        {
            key: "next",
            value: function next(value) {
                this.forEachObserver(function(observer) {
                    observer.next(value);
                });
            }
        },
        {
            key: "error",
            value: function error(error) {
                this.forEachObserver(function(observer) {
                    observer.error(error);
                });
                this.close(error);
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.forEachObserver(function(observer) {
                    observer.complete();
                });
                this.close();
            }
        },
        {
            /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ key: "subscribe",
            value: function subscribe(nextOrObserver, error, complete) {
                var _this = this;
                var observer;
                if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
                // Assemble an Observer object when passed as callback functions.
                if ($b1467a785fc7cec5$var$implementsAnyMethods(nextOrObserver, [
                    "next",
                    "error",
                    "complete"
                ])) observer = nextOrObserver;
                else observer = {
                    next: nextOrObserver,
                    error: error,
                    complete: complete
                };
                if (observer.next === undefined) observer.next = $b1467a785fc7cec5$var$noop;
                if (observer.error === undefined) observer.error = $b1467a785fc7cec5$var$noop;
                if (observer.complete === undefined) observer.complete = $b1467a785fc7cec5$var$noop;
                var unsub = this.unsubscribeOne.bind(this, this.observers.length);
                // Attempt to subscribe to a terminated Observable - we
                // just respond to the Observer with the final error or complete
                // event.
                if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    try {
                        if (_this.finalError) observer.error(_this.finalError);
                        else observer.complete();
                    } catch (e) {
                    // nothing
                    }
                    return;
                });
                this.observers.push(observer);
                return unsub;
            }
        },
        {
            // Unsubscribe is synchronous - we guarantee that no events are sent to
            // any unsubscribed Observer.
            key: "unsubscribeOne",
            value: function unsubscribeOne(i) {
                if (this.observers === undefined || this.observers[i] === undefined) return;
                delete this.observers[i];
                this.observerCount -= 1;
                if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
            }
        },
        {
            key: "forEachObserver",
            value: function forEachObserver(fn) {
                if (this.finalized) // Already closed by previous event....just eat the additional values.
                return;
                // Since sendOne calls asynchronously - there is no chance that
                // this.observers will become undefined.
                for(var i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
            }
        },
        {
            // Call the Observer via one of it's callback function. We are careful to
            // confirm that the observe has not been unsubscribed since this asynchronous
            // function had been queued.
            key: "sendOne",
            value: function sendOne(i, fn) {
                var _this = this;
                // Execute the callback asynchronously
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    if (_this.observers !== undefined && _this.observers[i] !== undefined) try {
                        fn(_this.observers[i]);
                    } catch (e) {
                        // Ignore exceptions raised in Observers or missing methods of an
                        // Observer.
                        // Log error to console. b/31404806
                        if (typeof console !== "undefined" && console.error) console.error(e);
                    }
                });
            }
        },
        {
            key: "close",
            value: function close(err) {
                var _this = this;
                if (this.finalized) return;
                this.finalized = true;
                if (err !== undefined) this.finalError = err;
                // Proxy is no longer needed - garbage collect references
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function() {
                    _this.observers = undefined;
                    _this.onNoObservers = undefined;
                });
            }
        }
    ]);
    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b1467a785fc7cec5$export$12af436354f1a4f7(fn, onError) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        Promise.resolve(true).then(function() {
            fn.apply(void 0, (0, $fLnyw._)(args));
        }).catch(function(error) {
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $b1467a785fc7cec5$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = methods[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var method = _step.value;
            if (method in obj && typeof obj[method] === "function") return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $b1467a785fc7cec5$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ var $b1467a785fc7cec5$export$20164226a0ed35c3 = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        var error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $b1467a785fc7cec5$export$adea4917e02d93dc(fnName, argName) {
    return "".concat(fnName, " failed: ").concat(argName, " argument ");
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $b1467a785fc7cec5$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($b1467a785fc7cec5$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $b1467a785fc7cec5$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($b1467a785fc7cec5$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $b1467a785fc7cec5$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($b1467a785fc7cec5$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ var $b1467a785fc7cec5$export$655666783217a925 = function stringToByteArray(str) {
    var out = [];
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            $b1467a785fc7cec5$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ var $b1467a785fc7cec5$export$9536dc0a75b20bf9 = function stringLength(str) {
    var p = 0;
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ var $b1467a785fc7cec5$export$abe4376e1bf796d6 = function uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ var $b1467a785fc7cec5$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ var $b1467a785fc7cec5$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ var $b1467a785fc7cec5$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ var $b1467a785fc7cec5$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $b1467a785fc7cec5$export$4d810c0ca64ed8e9(backoffCount) {
    var intervalMillis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b1467a785fc7cec5$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $b1467a785fc7cec5$var$DEFAULT_BACKOFF_FACTOR;
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $b1467a785fc7cec5$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($b1467a785fc7cec5$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $b1467a785fc7cec5$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return "".concat(i);
    return i + $b1467a785fc7cec5$var$indicator(i);
}
function $b1467a785fc7cec5$var$indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    var dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1467a785fc7cec5$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}




var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");


var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");


var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ var $48bece3fef299311$export$16fa2f45be04daa8 = /*#__PURE__*/ function() {
    "use strict";
    function Component(name, instanceFactory, type) {
        (0, $978gY._)(this, Component);
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    (0, $kry2a._)(Component, [
        {
            key: "setInstantiationMode",
            value: function setInstantiationMode(mode) {
                this.instantiationMode = mode;
                return this;
            }
        },
        {
            key: "setMultipleInstances",
            value: function setMultipleInstances(multipleInstances) {
                this.multipleInstances = multipleInstances;
                return this;
            }
        },
        {
            key: "setServiceProps",
            value: function setServiceProps(props) {
                this.serviceProps = props;
                return this;
            }
        },
        {
            key: "setInstanceCreatedCallback",
            value: function setInstanceCreatedCallback(callback) {
                this.onInstanceCreated = callback;
                return this;
            }
        }
    ]);
    return Component;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $48bece3fef299311$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ var $48bece3fef299311$export$2881499e37b75b9a = /*#__PURE__*/ function() {
    "use strict";
    function Provider(name, container) {
        (0, $978gY._)(this, Provider);
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    (0, $kry2a._)(Provider, [
        {
            /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ key: "get",
            value: function get(identifier) {
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                if (!this.instancesDeferred.has(normalizedIdentifier)) {
                    var deferred = new (0, $b1467a785fc7cec5$export$85f6557964517f1a)();
                    this.instancesDeferred.set(normalizedIdentifier, deferred);
                    if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
                    try {
                        var instance = this.getOrInitializeService({
                            instanceIdentifier: normalizedIdentifier
                        });
                        if (instance) deferred.resolve(instance);
                    } catch (e) {
                    // when the instance factory throws an exception during get(), it should not cause
                    // a fatal error. We just return the unresolved promise in this case.
                    }
                }
                return this.instancesDeferred.get(normalizedIdentifier).promise;
            }
        },
        {
            key: "getImmediate",
            value: function getImmediate(options) {
                var _a;
                // if multipleInstances is not supported, use the default name
                var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
                var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
                if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
                    return this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                } catch (e) {
                    if (optional) return null;
                    else throw e;
                }
                else {
                    // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
                    if (optional) return null;
                    else throw Error("Service ".concat(this.name, " is not available"));
                }
            }
        },
        {
            key: "getComponent",
            value: function getComponent() {
                return this.component;
            }
        },
        {
            key: "setComponent",
            value: function setComponent(component) {
                if (component.name !== this.name) throw Error("Mismatching Component ".concat(component.name, " for Provider ").concat(this.name, "."));
                if (this.component) throw Error("Component for ".concat(this.name, " has already been provided"));
                this.component = component;
                // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
                if (!this.shouldAutoInitialize()) return;
                // if the service is eager, initialize the default instance
                if ($48bece3fef299311$var$isComponentEager(component)) try {
                    this.getOrInitializeService({
                        instanceIdentifier: $48bece3fef299311$var$DEFAULT_ENTRY_NAME
                    });
                } catch (e) {
                // when the instance factory for an eager Component throws an exception during the eager
                // initialization, it should not cause a fatal error.
                // TODO: Investigate if we need to make it configurable, because some component may want to cause
                // a fatal error in this case?
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Create service instances for the pending promises and resolve them
                    // NOTE: if this.multipleInstances is false, only the default instance will be created
                    // and all promises with resolve with it regardless of the identifier.
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8GFUW._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        try {
                            // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                            var instance = this.getOrInitializeService({
                                instanceIdentifier: normalizedIdentifier
                            });
                            instanceDeferred.resolve(instance);
                        } catch (e) {
                        // when the instance factory throws an exception, it should not cause
                        // a fatal error. We just leave the promise unresolved.
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clearInstance",
            value: function clearInstance() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $48bece3fef299311$var$DEFAULT_ENTRY_NAME;
                this.instancesDeferred.delete(identifier);
                this.instancesOptions.delete(identifier);
                this.instances.delete(identifier);
            }
        },
        {
            key: "delete",
            value: // app.delete() will call this method on every provider to delete the services
            // TODO: should we mark the provider as deleted?
            function _delete() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var services;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                services = Array.from(_this.instances.values());
                                return [
                                    4,
                                    Promise.all((0, $fLnyw._)(services.filter(function(service) {
                                        return "INTERNAL" in service;
                                    }) // legacy services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service.INTERNAL.delete();
                                    })).concat((0, $fLnyw._)(services.filter(function(service) {
                                        return "_delete" in service;
                                    }) // modularized services
                                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                    .map(function(service) {
                                        return service._delete();
                                    }))))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "isComponentSet",
            value: function isComponentSet() {
                return this.component != null;
            }
        },
        {
            key: "isInitialized",
            value: function isInitialized() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $48bece3fef299311$var$DEFAULT_ENTRY_NAME;
                return this.instances.has(identifier);
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $48bece3fef299311$var$DEFAULT_ENTRY_NAME;
                return this.instancesOptions.get(identifier) || {};
            }
        },
        {
            key: "initialize",
            value: function initialize() {
                var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _opts_options = opts.options, options = _opts_options === void 0 ? {} : _opts_options;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
                if (this.isInitialized(normalizedIdentifier)) throw Error("".concat(this.name, "(").concat(normalizedIdentifier, ") has already been initialized"));
                if (!this.isComponentSet()) throw Error("Component ".concat(this.name, " has not been registered yet"));
                var instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier,
                    options: options
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // resolve any pending promise waiting for the service instance
                    for(var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8GFUW._)(_step.value, 2), instanceIdentifier = _step_value[0], instanceDeferred = _step_value[1];
                        var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                        if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return instance;
            }
        },
        {
            /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ key: "onInit",
            value: function onInit(callback, identifier) {
                var _a;
                var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
                var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
                existingCallbacks.add(callback);
                this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
                var existingInstance = this.instances.get(normalizedIdentifier);
                if (existingInstance) callback(existingInstance, normalizedIdentifier);
                return function() {
                    existingCallbacks.delete(callback);
                };
            }
        },
        {
            /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ key: "invokeOnInitCallbacks",
            value: function invokeOnInitCallbacks(instance, identifier) {
                var callbacks = this.onInitCallbacks.get(identifier);
                if (!callbacks) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var callback = _step.value;
                        try {
                            callback(instance, identifier);
                        } catch (_a) {
                        // ignore errors in the onInit callback
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getOrInitializeService",
            value: function getOrInitializeService(param) {
                var instanceIdentifier = param.instanceIdentifier, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
                var instance = this.instances.get(instanceIdentifier);
                if (!instance && this.component) {
                    instance = this.component.instanceFactory(this.container, {
                        instanceIdentifier: $48bece3fef299311$var$normalizeIdentifierForFactory(instanceIdentifier),
                        options: options
                    });
                    this.instances.set(instanceIdentifier, instance);
                    this.instancesOptions.set(instanceIdentifier, options);
                    /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
                    /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                        this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                    } catch (_a) {
                    // ignore errors in the onInstanceCreatedCallback
                    }
                }
                return instance || null;
            }
        },
        {
            key: "normalizeInstanceIdentifier",
            value: function normalizeInstanceIdentifier() {
                var identifier = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $48bece3fef299311$var$DEFAULT_ENTRY_NAME;
                if (this.component) return this.component.multipleInstances ? identifier : $48bece3fef299311$var$DEFAULT_ENTRY_NAME;
                else return identifier; // assume multiple instances are supported before the component is provided.
            }
        },
        {
            key: "shouldAutoInitialize",
            value: function shouldAutoInitialize() {
                return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
            }
        }
    ]);
    return Provider;
}();
// undefined should be passed to the service factory for the default instance
function $48bece3fef299311$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $48bece3fef299311$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $48bece3fef299311$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ var $48bece3fef299311$export$436a80eea5d5c0c5 = /*#__PURE__*/ function() {
    "use strict";
    function ComponentContainer(name) {
        (0, $978gY._)(this, ComponentContainer);
        this.name = name;
        this.providers = new Map();
    }
    (0, $kry2a._)(ComponentContainer, [
        {
            /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ key: "addComponent",
            value: function addComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) throw new Error("Component ".concat(component.name, " has already been registered with ").concat(this.name));
                provider.setComponent(component);
            }
        },
        {
            key: "addOrOverwriteComponent",
            value: function addOrOverwriteComponent(component) {
                var provider = this.getProvider(component.name);
                if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
                this.providers.delete(component.name);
                this.addComponent(component);
            }
        },
        {
            /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ key: "getProvider",
            value: function getProvider(name) {
                if (this.providers.has(name)) return this.providers.get(name);
                // create a Provider for a service that hasn't registered with Firebase
                var provider = new $48bece3fef299311$export$2881499e37b75b9a(name, this);
                this.providers.set(name, provider);
                return provider;
            }
        },
        {
            key: "getProviders",
            value: function getProviders() {
                return Array.from(this.providers.values());
            }
        }
    ]);
    return ComponentContainer;
}();


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ 
var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");


var $fLnyw = parcelRequire("fLnyw");
var $a1a98c9cad39c4c7$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $a1a98c9cad39c4c7$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($a1a98c9cad39c4c7$export$243e62d78d3b544d || ($a1a98c9cad39c4c7$export$243e62d78d3b544d = {}));
var $a1a98c9cad39c4c7$var$levelStringToEnum = {
    "debug": $a1a98c9cad39c4c7$export$243e62d78d3b544d.DEBUG,
    "verbose": $a1a98c9cad39c4c7$export$243e62d78d3b544d.VERBOSE,
    "info": $a1a98c9cad39c4c7$export$243e62d78d3b544d.INFO,
    "warn": $a1a98c9cad39c4c7$export$243e62d78d3b544d.WARN,
    "error": $a1a98c9cad39c4c7$export$243e62d78d3b544d.ERROR,
    "silent": $a1a98c9cad39c4c7$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ var $a1a98c9cad39c4c7$var$defaultLogLevel = $a1a98c9cad39c4c7$export$243e62d78d3b544d.INFO;
var $a1a98c9cad39c4c7$var$_obj;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ var $a1a98c9cad39c4c7$var$ConsoleMethod = ($a1a98c9cad39c4c7$var$_obj = {}, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($a1a98c9cad39c4c7$var$_obj, $a1a98c9cad39c4c7$export$243e62d78d3b544d.DEBUG, "log"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($a1a98c9cad39c4c7$var$_obj, $a1a98c9cad39c4c7$export$243e62d78d3b544d.VERBOSE, "log"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($a1a98c9cad39c4c7$var$_obj, $a1a98c9cad39c4c7$export$243e62d78d3b544d.INFO, "info"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($a1a98c9cad39c4c7$var$_obj, $a1a98c9cad39c4c7$export$243e62d78d3b544d.WARN, "warn"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($a1a98c9cad39c4c7$var$_obj, $a1a98c9cad39c4c7$export$243e62d78d3b544d.ERROR, "error"), $a1a98c9cad39c4c7$var$_obj);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ var $a1a98c9cad39c4c7$var$defaultLogHandler = function(instance, logType) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var _console;
    if (logType < instance.logLevel) return;
    var now = new Date().toISOString();
    var method = $a1a98c9cad39c4c7$var$ConsoleMethod[logType];
    if (method) (_console = console)[method].apply(_console, [
        "[".concat(now, "]  ").concat(instance.name, ":")
    ].concat((0, $fLnyw._)(args)));
    else throw new Error("Attempted to log a message with an invalid logType (value: ".concat(logType, ")"));
};
var $a1a98c9cad39c4c7$export$efa9a398d6368992 = /*#__PURE__*/ function() {
    "use strict";
    function Logger(name) {
        (0, $978gY._)(this, Logger);
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $a1a98c9cad39c4c7$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $a1a98c9cad39c4c7$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $a1a98c9cad39c4c7$var$instances.push(this);
    }
    (0, $kry2a._)(Logger, [
        {
            key: "logLevel",
            get: function get() {
                return this._logLevel;
            },
            set: function set(val) {
                if (!(val in $a1a98c9cad39c4c7$export$243e62d78d3b544d)) throw new TypeError('Invalid value "'.concat(val, '" assigned to `logLevel`'));
                this._logLevel = val;
            }
        },
        {
            // Workaround for setter/getter having to be the same type.
            key: "setLogLevel",
            value: function setLogLevel(val) {
                this._logLevel = typeof val === "string" ? $a1a98c9cad39c4c7$var$levelStringToEnum[val] : val;
            }
        },
        {
            key: "logHandler",
            get: function get() {
                return this._logHandler;
            },
            set: function set(val) {
                if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
                this._logHandler = val;
            }
        },
        {
            key: "userLogHandler",
            get: function get() {
                return this._userLogHandler;
            },
            set: function set(val) {
                this._userLogHandler = val;
            }
        },
        {
            /**
     * The functions below are all based on the `console` interface
     */ key: "debug",
            value: function debug() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.DEBUG
                ].concat((0, $fLnyw._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.DEBUG
                ].concat((0, $fLnyw._)(args)));
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $fLnyw._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.VERBOSE
                ].concat((0, $fLnyw._)(args)));
            }
        },
        {
            key: "info",
            value: function info() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.INFO
                ].concat((0, $fLnyw._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.INFO
                ].concat((0, $fLnyw._)(args)));
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.WARN
                ].concat((0, $fLnyw._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.WARN
                ].concat((0, $fLnyw._)(args)));
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                this._userLogHandler && this._userLogHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.ERROR
                ].concat((0, $fLnyw._)(args)));
                this._logHandler.apply(this, [
                    this,
                    $a1a98c9cad39c4c7$export$243e62d78d3b544d.ERROR
                ].concat((0, $fLnyw._)(args)));
            }
        }
    ]);
    return Logger;
}();
function $a1a98c9cad39c4c7$export$c622e99c0ce7b1c9(level) {
    $a1a98c9cad39c4c7$var$instances.forEach(function(inst) {
        inst.setLogLevel(level);
    });
}
function $a1a98c9cad39c4c7$export$29577d29c84db5f6(logCallback, options) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var instance = _step.value;
            var customLogLevel = null;
            if (options && options.level) customLogLevel = $a1a98c9cad39c4c7$var$levelStringToEnum[options.level];
            if (logCallback === null) instance.userLogHandler = null;
            else instance.userLogHandler = function(instance, level) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var message = args.map(function(arg) {
                    if (arg == null) return null;
                    else if (typeof arg === "string") return arg;
                    else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                    else if (arg instanceof Error) return arg.message;
                    else try {
                        return JSON.stringify(arg);
                    } catch (ignored) {
                        return null;
                    }
                }).filter(function(arg) {
                    return arg;
                }).join(" ");
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                    level: $a1a98c9cad39c4c7$export$243e62d78d3b544d[level].toLowerCase(),
                    message: message,
                    args: args,
                    type: instance.name
                });
            };
        };
        for(var _iterator = $a1a98c9cad39c4c7$var$instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}





function $66a5668b38a29be4$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $64b790ae24ac5be1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64b790ae24ac5be1$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $64b790ae24ac5be1$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");

var $fLnyw = parcelRequire("fLnyw");
var $be8df64a58a2d4f8$export$23f2a1d2818174ef = function(object, constructors) {
    return constructors.some(function(c) {
        return object instanceof c;
    });
};
var $be8df64a58a2d4f8$var$idbProxyableTypes;
var $be8df64a58a2d4f8$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $be8df64a58a2d4f8$var$getIdbProxyableTypes() {
    return $be8df64a58a2d4f8$var$idbProxyableTypes || ($be8df64a58a2d4f8$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $be8df64a58a2d4f8$var$getCursorAdvanceMethods() {
    return $be8df64a58a2d4f8$var$cursorAdvanceMethods || ($be8df64a58a2d4f8$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
var $be8df64a58a2d4f8$var$cursorRequestMap = new WeakMap();
var $be8df64a58a2d4f8$var$transactionDoneMap = new WeakMap();
var $be8df64a58a2d4f8$var$transactionStoreNamesMap = new WeakMap();
var $be8df64a58a2d4f8$var$transformCache = new WeakMap();
var $be8df64a58a2d4f8$export$407448d2b89b1813 = new WeakMap();
function $be8df64a58a2d4f8$var$promisifyRequest(request) {
    var promise = new Promise(function(resolve, reject) {
        var unlisten = function() {
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        var success = function() {
            resolve($be8df64a58a2d4f8$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        var error = function() {
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then(function(value) {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $be8df64a58a2d4f8$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(function() {});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $be8df64a58a2d4f8$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $be8df64a58a2d4f8$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($be8df64a58a2d4f8$var$transactionDoneMap.has(tx)) return;
    var done = new Promise(function(resolve, reject) {
        var unlisten = function() {
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        var complete = function() {
            resolve();
            unlisten();
        };
        var error = function() {
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $be8df64a58a2d4f8$var$transactionDoneMap.set(tx, done);
}
var $be8df64a58a2d4f8$var$idbProxyTraps = {
    get: function(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $be8df64a58a2d4f8$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $be8df64a58a2d4f8$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $be8df64a58a2d4f8$export$efccba1c4a2ef57b(target[prop]);
    },
    set: function(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has: function(target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $be8df64a58a2d4f8$export$43caf9889c228507(callback) {
    $be8df64a58a2d4f8$var$idbProxyTraps = callback($be8df64a58a2d4f8$var$idbProxyTraps);
}
function $be8df64a58a2d4f8$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _func;
        var tx = (_func = func).call.apply(_func, [
            $be8df64a58a2d4f8$export$3b14a55fb2447963(this),
            storeNames
        ].concat((0, $fLnyw._)(args)));
        $be8df64a58a2d4f8$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $be8df64a58a2d4f8$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($be8df64a58a2d4f8$var$getCursorAdvanceMethods().includes(func)) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($be8df64a58a2d4f8$export$3b14a55fb2447963(this), args);
        return $be8df64a58a2d4f8$export$efccba1c4a2ef57b($be8df64a58a2d4f8$var$cursorRequestMap.get(this));
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $be8df64a58a2d4f8$export$efccba1c4a2ef57b(func.apply($be8df64a58a2d4f8$export$3b14a55fb2447963(this), args));
    };
}
function $be8df64a58a2d4f8$var$transformCachableValue(value) {
    if (typeof value === "function") return $be8df64a58a2d4f8$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $be8df64a58a2d4f8$var$cacheDonePromiseForTransaction(value);
    if ($be8df64a58a2d4f8$export$23f2a1d2818174ef(value, $be8df64a58a2d4f8$var$getIdbProxyableTypes())) return new Proxy(value, $be8df64a58a2d4f8$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $be8df64a58a2d4f8$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $be8df64a58a2d4f8$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($be8df64a58a2d4f8$var$transformCache.has(value)) return $be8df64a58a2d4f8$var$transformCache.get(value);
    var newValue = $be8df64a58a2d4f8$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $be8df64a58a2d4f8$var$transformCache.set(value, newValue);
        $be8df64a58a2d4f8$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
var $be8df64a58a2d4f8$export$3b14a55fb2447963 = function(value) {
    return $be8df64a58a2d4f8$export$407448d2b89b1813.get(value);
};


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $b7b0b5bea07b23fe$export$ca0ed41b1a2af7e(name, version) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, blocked = _ref.blocked, upgrade = _ref.upgrade, blocking = _ref.blocking, terminated = _ref.terminated;
    var request = indexedDB.open(name, version);
    var openPromise = (0, $be8df64a58a2d4f8$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", function(event) {
        upgrade((0, $be8df64a58a2d4f8$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $be8df64a58a2d4f8$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event);
    });
    openPromise.then(function(db) {
        if (terminated) db.addEventListener("close", function() {
            return terminated();
        });
        if (blocking) db.addEventListener("versionchange", function(event) {
            return blocking(event.oldVersion, event.newVersion, event);
        });
    }).catch(function() {});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $b7b0b5bea07b23fe$export$9d6df0ac66a98bb2(name) {
    var blocked = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).blocked;
    var request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", function(event) {
        return blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event);
    });
    return (0, $be8df64a58a2d4f8$export$efccba1c4a2ef57b)(request).then(function() {
        return undefined;
    });
}
var $b7b0b5bea07b23fe$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
var $b7b0b5bea07b23fe$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
var $b7b0b5bea07b23fe$var$cachedMethods = new Map();
function $b7b0b5bea07b23fe$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($b7b0b5bea07b23fe$var$cachedMethods.get(prop)) return $b7b0b5bea07b23fe$var$cachedMethods.get(prop);
    var targetFuncName = prop.replace(/FromIndex$/, "");
    var useIndex = prop !== targetFuncName;
    var isWrite = $b7b0b5bea07b23fe$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $b7b0b5bea07b23fe$var$readMethods.includes(targetFuncName))) return;
    var method = function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(storeName) {
            var _len, args, _key, _target, tx, _$target;
            var _arguments = arguments;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        for(_len = _arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = _arguments[_key];
                        }
                        tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
                        _$target = tx.store;
                        if (useIndex) _$target = _$target.index(args.shift());
                        return [
                            4,
                            Promise.all([
                                (_target = _$target)[targetFuncName].apply(_target, (0, $fLnyw._)(args)),
                                isWrite && tx.done
                            ])
                        ];
                    case 1:
                        // Must reject if op rejects.
                        // If it's a write operation, must reject if tx.done rejects.
                        // Must reject with op rejection first.
                        // Must resolve with op value.
                        // Must handle both promises (no unhandled rejections)
                        return [
                            2,
                            _state.sent()[0]
                        ];
                }
            });
        });
        return function method(storeName) {
            return _ref.apply(this, arguments);
        };
    }();
    $b7b0b5bea07b23fe$var$cachedMethods.set(prop, method);
    return method;
}
(0, $be8df64a58a2d4f8$export$43caf9889c228507)(function(oldTraps) {
    return (0, $64b790ae24ac5be1$export$4fa2f4023c9cbda5)((0, $66a5668b38a29be4$export$581ff339ea0ba762)({}, oldTraps), {
        get: function(target, prop, receiver) {
            return $b7b0b5bea07b23fe$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver);
        },
        has: function(target, prop) {
            return !!$b7b0b5bea07b23fe$var$getMethod(target, prop) || oldTraps.has(target, prop);
        }
    });
});


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2b7c3095396a3894$var$PlatformLoggerServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function PlatformLoggerServiceImpl(container) {
        (0, $978gY._)(this, PlatformLoggerServiceImpl);
        this.container = container;
    }
    (0, $kry2a._)(PlatformLoggerServiceImpl, [
        {
            // In initial implementation, this will be called by installations on
            // auth token refresh, and installations will send this string.
            key: "getPlatformInfoString",
            value: function getPlatformInfoString() {
                var providers = this.container.getProviders();
                // Loop through providers and get library/version pairs from any that are
                // version components.
                return providers.map(function(provider) {
                    if ($2b7c3095396a3894$var$isVersionServiceProvider(provider)) {
                        var service = provider.getImmediate();
                        return "".concat(service.library, "/").concat(service.version);
                    } else return null;
                }).filter(function(logString) {
                    return logString;
                }).join(" ");
            }
        }
    ]);
    return PlatformLoggerServiceImpl;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $2b7c3095396a3894$var$isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
var $2b7c3095396a3894$var$name$o = "@firebase/app";
var $2b7c3095396a3894$var$version$1 = "0.9.18";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2b7c3095396a3894$var$logger = new (0, $a1a98c9cad39c4c7$export$efa9a398d6368992)("@firebase/app");
var $2b7c3095396a3894$var$name$n = "@firebase/app-compat";
var $2b7c3095396a3894$var$name$m = "@firebase/analytics-compat";
var $2b7c3095396a3894$var$name$l = "@firebase/analytics";
var $2b7c3095396a3894$var$name$k = "@firebase/app-check-compat";
var $2b7c3095396a3894$var$name$j = "@firebase/app-check";
var $2b7c3095396a3894$var$name$i = "@firebase/auth";
var $2b7c3095396a3894$var$name$h = "@firebase/auth-compat";
var $2b7c3095396a3894$var$name$g = "@firebase/database";
var $2b7c3095396a3894$var$name$f = "@firebase/database-compat";
var $2b7c3095396a3894$var$name$e = "@firebase/functions";
var $2b7c3095396a3894$var$name$d = "@firebase/functions-compat";
var $2b7c3095396a3894$var$name$c = "@firebase/installations";
var $2b7c3095396a3894$var$name$b = "@firebase/installations-compat";
var $2b7c3095396a3894$var$name$a = "@firebase/messaging";
var $2b7c3095396a3894$var$name$9 = "@firebase/messaging-compat";
var $2b7c3095396a3894$var$name$8 = "@firebase/performance";
var $2b7c3095396a3894$var$name$7 = "@firebase/performance-compat";
var $2b7c3095396a3894$var$name$6 = "@firebase/remote-config";
var $2b7c3095396a3894$var$name$5 = "@firebase/remote-config-compat";
var $2b7c3095396a3894$var$name$4 = "@firebase/storage";
var $2b7c3095396a3894$var$name$3 = "@firebase/storage-compat";
var $2b7c3095396a3894$var$name$2 = "@firebase/firestore";
var $2b7c3095396a3894$var$name$1 = "@firebase/firestore-compat";
var $2b7c3095396a3894$var$name = "firebase";
var $2b7c3095396a3894$var$version = "10.3.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ var $2b7c3095396a3894$export$9f30fa0c10967f7f = "[DEFAULT]";
var $2b7c3095396a3894$var$_obj;
var $2b7c3095396a3894$var$PLATFORM_LOG_STRING = ($2b7c3095396a3894$var$_obj = {}, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$o, "fire-core"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$n, "fire-core-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$l, "fire-analytics"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$m, "fire-analytics-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$j, "fire-app-check"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$k, "fire-app-check-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$i, "fire-auth"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$h, "fire-auth-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$g, "fire-rtdb"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$f, "fire-rtdb-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$e, "fire-fn"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$d, "fire-fn-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$c, "fire-iid"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$b, "fire-iid-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$a, "fire-fcm"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$9, "fire-fcm-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$8, "fire-perf"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$7, "fire-perf-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$6, "fire-rc"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$5, "fire-rc-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$4, "fire-gcs"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$3, "fire-gcs-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$2, "fire-fst"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name$1, "fire-fst-compat"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, "fire-js", "fire-js"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj, $2b7c3095396a3894$var$name, "fire-js-all"), $2b7c3095396a3894$var$_obj);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var $2b7c3095396a3894$export$b4e3c36c855b14b5 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $2b7c3095396a3894$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $2b7c3095396a3894$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $2b7c3095396a3894$var$logger.debug("Component ".concat(component.name, " failed to register with FirebaseApp ").concat(app.name), e);
    }
}
/**
 *
 * @internal
 */ function $2b7c3095396a3894$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $2b7c3095396a3894$export$c930050e7bb63965(component) {
    var componentName = component.name;
    if ($2b7c3095396a3894$export$9566bce3835c0f28.has(componentName)) {
        $2b7c3095396a3894$var$logger.debug("There were multiple attempts to register component ".concat(componentName, "."));
        return false;
    }
    $2b7c3095396a3894$export$9566bce3835c0f28.set(componentName, component);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // add the component to existing app instances
        for(var _iterator = $2b7c3095396a3894$export$b4e3c36c855b14b5.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var app = _step.value;
            $2b7c3095396a3894$export$fa5244b94c62d36a(app, component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $2b7c3095396a3894$export$fa0d6da0f5838f50(app, name) {
    var heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $2b7c3095396a3894$export$48d18de2ff1c45a5(app, name) {
    var instanceIdentifier = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $2b7c3095396a3894$export$9f30fa0c10967f7f;
    $2b7c3095396a3894$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */ function $2b7c3095396a3894$export$3685d89b9c3cdfaf() {
    $2b7c3095396a3894$export$9566bce3835c0f28.clear();
}
var $2b7c3095396a3894$var$_obj1;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2b7c3095396a3894$var$ERRORS = ($2b7c3095396a3894$var$_obj1 = {}, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "no-app" /* AppError.NO_APP */ , "No Firebase App '{$appName}' has been created - call initializeApp() first"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "bad-app-name" /* AppError.BAD_APP_NAME */ , "Illegal App name: '{$appName}"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "duplicate-app" /* AppError.DUPLICATE_APP */ , "Firebase App named '{$appName}' already exists with different options or config"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "app-deleted" /* AppError.APP_DELETED */ , "Firebase App named '{$appName}' already deleted"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "no-options" /* AppError.NO_OPTIONS */ , "Need to provide options, when not being deployed to hosting via source."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ , "firebase.{$appName}() takes either no argument or a Firebase App instance."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ , "First argument to `onLog` must be null or a function."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "idb-open" /* AppError.IDB_OPEN */ , "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "idb-get" /* AppError.IDB_GET */ , "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "idb-set" /* AppError.IDB_WRITE */ , "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($2b7c3095396a3894$var$_obj1, "idb-delete" /* AppError.IDB_DELETE */ , "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}."), $2b7c3095396a3894$var$_obj1);
var $2b7c3095396a3894$var$ERROR_FACTORY = new (0, $b1467a785fc7cec5$export$3fa6e1b18a3b2d40)("app", "Firebase", $2b7c3095396a3894$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2b7c3095396a3894$var$FirebaseAppImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirebaseAppImpl(options, config, container) {
        var _this = this;
        (0, $978gY._)(this, FirebaseAppImpl);
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $48bece3fef299311$export$16fa2f45be04daa8)("app", function() {
            return _this;
        }, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    (0, $kry2a._)(FirebaseAppImpl, [
        {
            key: "automaticDataCollectionEnabled",
            get: function get() {
                this.checkDestroyed();
                return this._automaticDataCollectionEnabled;
            },
            set: function set(val) {
                this.checkDestroyed();
                this._automaticDataCollectionEnabled = val;
            }
        },
        {
            key: "name",
            get: function get() {
                this.checkDestroyed();
                return this._name;
            }
        },
        {
            key: "options",
            get: function get() {
                this.checkDestroyed();
                return this._options;
            }
        },
        {
            key: "config",
            get: function get() {
                this.checkDestroyed();
                return this._config;
            }
        },
        {
            key: "container",
            get: function get() {
                return this._container;
            }
        },
        {
            key: "isDeleted",
            get: function get() {
                return this._isDeleted;
            },
            set: function set(val) {
                this._isDeleted = val;
            }
        },
        {
            /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ key: "checkDestroyed",
            value: function checkDestroyed() {
                if (this.isDeleted) throw $2b7c3095396a3894$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
                    appName: this._name
                });
            }
        }
    ]);
    return FirebaseAppImpl;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ var $2b7c3095396a3894$export$31499a9cd224b78c = $2b7c3095396a3894$var$version;
function $2b7c3095396a3894$export$c55cfd413944906d(_options) {
    var rawConfig = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = _options;
    if (typeof rawConfig !== "object") {
        var name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    var config = Object.assign({
        name: $2b7c3095396a3894$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    var name1 = config.name;
    if (typeof name1 !== "string" || !name1) throw $2b7c3095396a3894$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name1)
    });
    options || (options = (0, $b1467a785fc7cec5$export$3dfb6827a9f89756)());
    if (!options) throw $2b7c3095396a3894$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    var existingApp = $2b7c3095396a3894$export$b4e3c36c855b14b5.get(name1);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $b1467a785fc7cec5$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $b1467a785fc7cec5$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $2b7c3095396a3894$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name1
        });
    }
    var container = new (0, $48bece3fef299311$export$436a80eea5d5c0c5)(name1);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $2b7c3095396a3894$export$9566bce3835c0f28.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var newApp = new $2b7c3095396a3894$var$FirebaseAppImpl(options, config, container);
    $2b7c3095396a3894$export$b4e3c36c855b14b5.set(name1, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $2b7c3095396a3894$export$f9962582c9e66d99() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $2b7c3095396a3894$export$9f30fa0c10967f7f;
    var app = $2b7c3095396a3894$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $2b7c3095396a3894$export$9f30fa0c10967f7f && (0, $b1467a785fc7cec5$export$3dfb6827a9f89756)()) return $2b7c3095396a3894$export$c55cfd413944906d();
    if (!app) throw $2b7c3095396a3894$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $2b7c3095396a3894$export$68ddedf7d44b3bdf() {
    return Array.from($2b7c3095396a3894$export$b4e3c36c855b14b5.values());
}
function $2b7c3095396a3894$export$6eec44aa53d5ea34(app) {
    return $2b7c3095396a3894$var$_deleteApp.apply(this, arguments);
}
function $2b7c3095396a3894$var$_deleteApp() {
    $2b7c3095396a3894$var$_deleteApp = /**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(app) {
        var name;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    name = app.name;
                    if (!$2b7c3095396a3894$export$b4e3c36c855b14b5.has(name)) return [
                        3,
                        2
                    ];
                    $2b7c3095396a3894$export$b4e3c36c855b14b5.delete(name);
                    return [
                        4,
                        Promise.all(app.container.getProviders().map(function(provider) {
                            return provider.delete();
                        }))
                    ];
                case 1:
                    _state.sent();
                    app.isDeleted = true;
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $2b7c3095396a3894$var$_deleteApp.apply(this, arguments);
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $2b7c3095396a3894$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    var library = (_a = $2b7c3095396a3894$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += "-".concat(variant);
    var libraryMismatch = library.match(/\s|\//);
    var versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        var warning = [
            'Unable to register library "'.concat(library, '" with version "').concat(version, '":')
        ];
        if (libraryMismatch) warning.push('library name "'.concat(library, '" contains illegal characters (whitespace or "/")'));
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push('version name "'.concat(version, '" contains illegal characters (whitespace or "/")'));
        $2b7c3095396a3894$var$logger.warn(warning.join(" "));
        return;
    }
    $2b7c3095396a3894$export$c930050e7bb63965(new (0, $48bece3fef299311$export$16fa2f45be04daa8)("".concat(library, "-version"), function() {
        return {
            library: library,
            version: version
        };
    }, "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $2b7c3095396a3894$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $2b7c3095396a3894$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $a1a98c9cad39c4c7$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $2b7c3095396a3894$export$c622e99c0ce7b1c9(logLevel) {
    (0, $a1a98c9cad39c4c7$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2b7c3095396a3894$var$DB_NAME = "firebase-heartbeat-database";
var $2b7c3095396a3894$var$DB_VERSION = 1;
var $2b7c3095396a3894$var$STORE_NAME = "firebase-heartbeat-store";
var $2b7c3095396a3894$var$dbPromise = null;
function $2b7c3095396a3894$var$getDbPromise() {
    if (!$2b7c3095396a3894$var$dbPromise) $2b7c3095396a3894$var$dbPromise = (0, $b7b0b5bea07b23fe$export$ca0ed41b1a2af7e)($2b7c3095396a3894$var$DB_NAME, $2b7c3095396a3894$var$DB_VERSION, {
        upgrade: function(db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore($2b7c3095396a3894$var$STORE_NAME);
            }
        }
    }).catch(function(e) {
        throw $2b7c3095396a3894$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $2b7c3095396a3894$var$dbPromise;
}
function $2b7c3095396a3894$var$readHeartbeatsFromIndexedDB(app) {
    return $2b7c3095396a3894$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $2b7c3095396a3894$var$_readHeartbeatsFromIndexedDB() {
    $2b7c3095396a3894$var$_readHeartbeatsFromIndexedDB = (0, $869ea882f885334a$export$7c398597f8905a1)(function(app) {
        var db, result, e, idbGetError;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $2b7c3095396a3894$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    return [
                        4,
                        db.transaction($2b7c3095396a3894$var$STORE_NAME).objectStore($2b7c3095396a3894$var$STORE_NAME).get($2b7c3095396a3894$var$computeKey(app))
                    ];
                case 2:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
                case 3:
                    e = _state.sent();
                    if (e instanceof (0, $b1467a785fc7cec5$export$dd24e9cd51226c56)) $2b7c3095396a3894$var$logger.warn(e.message);
                    else {
                        idbGetError = $2b7c3095396a3894$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $2b7c3095396a3894$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $2b7c3095396a3894$var$_readHeartbeatsFromIndexedDB.apply(this, arguments);
}
function $2b7c3095396a3894$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    return $2b7c3095396a3894$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $2b7c3095396a3894$var$_writeHeartbeatsToIndexedDB() {
    $2b7c3095396a3894$var$_writeHeartbeatsToIndexedDB = (0, $869ea882f885334a$export$7c398597f8905a1)(function(app, heartbeatObject) {
        var db, tx, objectStore, e, idbGetError;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $2b7c3095396a3894$var$getDbPromise()
                    ];
                case 1:
                    db = _state.sent();
                    tx = db.transaction($2b7c3095396a3894$var$STORE_NAME, "readwrite");
                    objectStore = tx.objectStore($2b7c3095396a3894$var$STORE_NAME);
                    return [
                        4,
                        objectStore.put(heartbeatObject, $2b7c3095396a3894$var$computeKey(app))
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        tx.done
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $b1467a785fc7cec5$export$dd24e9cd51226c56)) $2b7c3095396a3894$var$logger.warn(e.message);
                    else {
                        idbGetError = $2b7c3095396a3894$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                            originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
                        });
                        $2b7c3095396a3894$var$logger.warn(idbGetError.message);
                    }
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $2b7c3095396a3894$var$_writeHeartbeatsToIndexedDB.apply(this, arguments);
}
function $2b7c3095396a3894$var$computeKey(app) {
    return "".concat(app.name, "!").concat(app.options.appId);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $2b7c3095396a3894$var$MAX_HEADER_BYTES = 1024;
// 30 days
var $2b7c3095396a3894$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
var $2b7c3095396a3894$var$HeartbeatServiceImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatServiceImpl(container) {
        var _this = this;
        (0, $978gY._)(this, HeartbeatServiceImpl);
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        var app = this.container.getProvider("app").getImmediate();
        this._storage = new $2b7c3095396a3894$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(function(result) {
            _this._heartbeatsCache = result;
            return result;
        });
    }
    (0, $kry2a._)(HeartbeatServiceImpl, [
        {
            key: "triggerHeartbeat",
            value: /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ function triggerHeartbeat() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var platformLogger, agent, date;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                platformLogger = _this.container.getProvider("platform-logger").getImmediate();
                                agent = platformLogger.getPlatformInfoString();
                                date = $2b7c3095396a3894$var$getUTCDateString();
                                if (!(_this._heartbeatsCache === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _this._heartbeatsCache = _state.sent();
                                _state.label = 2;
                            case 2:
                                // Do not store a heartbeat if one is already stored for this day
                                // or if a header has already been sent today.
                                if (_this._heartbeatsCache.lastSentHeartbeatDate === date || _this._heartbeatsCache.heartbeats.some(function(singleDateHeartbeat) {
                                    return singleDateHeartbeat.date === date;
                                })) return [
                                    2
                                ];
                                else // There is no entry for this date. Create one.
                                _this._heartbeatsCache.heartbeats.push({
                                    date: date,
                                    agent: agent
                                });
                                // Remove entries older than 30 days.
                                _this._heartbeatsCache.heartbeats = _this._heartbeatsCache.heartbeats.filter(function(singleDateHeartbeat) {
                                    var hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                                    var now = Date.now();
                                    return now - hbTimestamp <= $2b7c3095396a3894$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                                });
                                return [
                                    2,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getHeartbeatsHeader",
            value: /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ function getHeartbeatsHeader() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var date, _extractHeartbeatsForHeader, heartbeatsToSend, unsentEntries, headerString;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this._heartbeatsCache === null)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._heartbeatsCachePromise
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                // If it's still null or the array is empty, there is no data to send.
                                if (_this._heartbeatsCache === null || _this._heartbeatsCache.heartbeats.length === 0) return [
                                    2,
                                    ""
                                ];
                                date = $2b7c3095396a3894$var$getUTCDateString();
                                _extractHeartbeatsForHeader = $2b7c3095396a3894$var$extractHeartbeatsForHeader(_this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsForHeader.heartbeatsToSend, unsentEntries = _extractHeartbeatsForHeader.unsentEntries;
                                headerString = (0, $b1467a785fc7cec5$export$4b5284a3025a455)(JSON.stringify({
                                    version: 2,
                                    heartbeats: heartbeatsToSend
                                }));
                                // Store last sent date to prevent another being logged/sent for the same day.
                                _this._heartbeatsCache.lastSentHeartbeatDate = date;
                                if (!(unsentEntries.length > 0)) return [
                                    3,
                                    4
                                ];
                                // Store any unsent entries if they exist.
                                _this._heartbeatsCache.heartbeats = unsentEntries;
                                // This seems more likely than emptying the array (below) to lead to some odd state
                                // since the cache isn't empty and this will be called again on the next request,
                                // and is probably safest if we await it.
                                return [
                                    4,
                                    _this._storage.overwrite(_this._heartbeatsCache)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _this._heartbeatsCache.heartbeats = [];
                                _this._storage.overwrite(_this._heartbeatsCache);
                                _state.label = 5;
                            case 5:
                                return [
                                    2,
                                    headerString
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatServiceImpl;
}();
function $2b7c3095396a3894$var$getUTCDateString() {
    var today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $2b7c3095396a3894$var$extractHeartbeatsForHeader(heartbeatsCache) {
    var maxSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $2b7c3095396a3894$var$MAX_HEADER_BYTES;
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    var heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    var unsentEntries = heartbeatsCache.slice();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var singleDateHeartbeat = _step.value;
            // Look for an existing entry with the same user agent.
            var heartbeatEntry = heartbeatsToSend.find(function(hb) {
                return hb.agent === singleDateHeartbeat.agent;
            });
            if (!heartbeatEntry) {
                // If no entry for this user agent exists, create one.
                heartbeatsToSend.push({
                    agent: singleDateHeartbeat.agent,
                    dates: [
                        singleDateHeartbeat.date
                    ]
                });
                if ($2b7c3095396a3894$var$countBytes(heartbeatsToSend) > maxSize) {
                    // If the header would exceed max size, remove the added heartbeat
                    // entry and stop adding to the header.
                    heartbeatsToSend.pop();
                    return "break";
                }
            } else {
                heartbeatEntry.dates.push(singleDateHeartbeat.date);
                // If the header would exceed max size, remove the added date
                // and stop adding to the header.
                if ($2b7c3095396a3894$var$countBytes(heartbeatsToSend) > maxSize) {
                    heartbeatEntry.dates.pop();
                    return "break";
                }
            }
            // Pop unsent entry from queue. (Skipped if adding the entry exceeded
            // quota and the loop breaks early.)
            unsentEntries = unsentEntries.slice(1);
        };
        for(var _iterator = heartbeatsCache[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if (_ret === "break") break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
var $2b7c3095396a3894$var$HeartbeatStorageImpl = /*#__PURE__*/ function() {
    "use strict";
    function HeartbeatStorageImpl(app) {
        (0, $978gY._)(this, HeartbeatStorageImpl);
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    (0, $kry2a._)(HeartbeatStorageImpl, [
        {
            key: "runIndexedDBEnvironmentCheck",
            value: function runIndexedDBEnvironmentCheck() {
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (!(0, $b1467a785fc7cec5$export$3865db50535c2055)()) return [
                            2,
                            false
                        ];
                        else return [
                            2,
                            (0, $b1467a785fc7cec5$export$a8a3018f3d187a4d)().then(function() {
                                return true;
                            }).catch(function() {
                                return false;
                            })
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "read",
            value: /**
     * Read all heartbeats.
     */ function read() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var canUseIndexedDB, idbHeartbeatObject;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2,
                                    {
                                        heartbeats: []
                                    }
                                ];
                            case 2:
                                return [
                                    4,
                                    $2b7c3095396a3894$var$readHeartbeatsFromIndexedDB(_this.app)
                                ];
                            case 3:
                                idbHeartbeatObject = _state.sent();
                                return [
                                    2,
                                    idbHeartbeatObject || {
                                        heartbeats: []
                                    }
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "overwrite",
            value: // overwrite the storage with the provided heartbeats
            function overwrite(heartbeatsObject) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $2b7c3095396a3894$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: heartbeatsObject.heartbeats
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "add",
            value: // add heartbeats
            function add(heartbeatsObject) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, canUseIndexedDB, existingHeartbeatsObject;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._canUseIndexedDBPromise
                                ];
                            case 1:
                                canUseIndexedDB = _state.sent();
                                if (!!canUseIndexedDB) return [
                                    3,
                                    2
                                ];
                                return [
                                    2
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.read()
                                ];
                            case 3:
                                existingHeartbeatsObject = _state.sent();
                                return [
                                    2,
                                    $2b7c3095396a3894$var$writeHeartbeatsToIndexedDB(_this.app, {
                                        lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                        heartbeats: (0, $fLnyw._)(existingHeartbeatsObject.heartbeats).concat((0, $fLnyw._)(heartbeatsObject.heartbeats))
                                    })
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return HeartbeatStorageImpl;
}();
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $2b7c3095396a3894$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $b1467a785fc7cec5$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2b7c3095396a3894$var$registerCoreComponents(variant) {
    $2b7c3095396a3894$export$c930050e7bb63965(new (0, $48bece3fef299311$export$16fa2f45be04daa8)("platform-logger", function(container) {
        return new $2b7c3095396a3894$var$PlatformLoggerServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    $2b7c3095396a3894$export$c930050e7bb63965(new (0, $48bece3fef299311$export$16fa2f45be04daa8)("heartbeat", function(container) {
        return new $2b7c3095396a3894$var$HeartbeatServiceImpl(container);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $2b7c3095396a3894$export$d29d5299a7137abc($2b7c3095396a3894$var$name$o, $2b7c3095396a3894$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $2b7c3095396a3894$export$d29d5299a7137abc($2b7c3095396a3894$var$name$o, $2b7c3095396a3894$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $2b7c3095396a3894$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $2b7c3095396a3894$var$registerCoreComponents("");




var $7UAGh = parcelRequire("7UAGh");

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ var $0021d6672f58c7eb$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ var $0021d6672f58c7eb$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ var $0021d6672f58c7eb$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ var $0021d6672f58c7eb$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ var $0021d6672f58c7eb$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $0021d6672f58c7eb$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
var $0021d6672f58c7eb$var$RecaptchaConfig = function RecaptchaConfig(response) {
    "use strict";
    (0, $978gY._)(this, RecaptchaConfig);
    /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
    /**
         * The reCAPTCHA enablement status of the {@link EmailAuthProvider} for the current tenant.
         */ this.emailPasswordEnabled = false;
    if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
    // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
    this.siteKey = response.recaptchaKey.split("/")[3];
    this.emailPasswordEnabled = response.recaptchaEnforcementState.some(function(enforcementState) {
        return enforcementState.provider === "EMAIL_PASSWORD_PROVIDER" && enforcementState.enforcementState !== "OFF";
    });
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$_debugErrorMap() {
    var _obj;
    return(_obj = {}, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ , "This operation is restricted to administrators only."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , ""), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ , "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ , "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ , "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "code-expired" /* AuthErrorCode.CODE_EXPIRED */ , "The SMS code has expired. Please re-send the verification code to try again."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ , "Cordova framework is not ready."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ , "This browser is not supported."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , "This credential is already associated with a different user account."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ , "The custom token corresponds to a different audience."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "This operation is sensitive and requires recent authentication. Log in again before retrying this request."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ , "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ , "Multi-factor users must always have a verified email."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , "The email address is already in use by another account."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ , 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.'), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ , "The action code has expired."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ , "This operation has been cancelled due to another conflicting popup being opened."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , "An internal AuthError has occurred."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ , "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ , "The mobile app identifier is not registed for the current project."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ , "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ , "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ , "The continue URL provided in the request is invalid."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ , "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ , "The custom token format is incorrect. Please check the documentation."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ , "The provided dynamic link domain is not configured or authorized for the current project."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ , "The email address is badly formatted."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ , "Emulator URL must start with a valid scheme (http:// or https://)."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , "Your API key is invalid, please check you have copied it correctly."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ , "The SHA-1 certificate hash provided is invalid."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ , "The supplied auth credential is malformed or has expired."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ , "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ , "The request does not contain a valid proof of first factor successful sign-in."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ , "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ , "The OAuth client ID provided is either invalid or does not match the specified API key."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ , "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ , "The action code is invalid. This can happen if the code is malformed, expired, or has already been used."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ , "The password is invalid or the user does not have a password."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ , "The specified persistence type is invalid. It can only be local, session or none."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ , "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code]."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ , "The specified provider ID is invalid."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ , "The email corresponding to this action failed to send as the provided recipient email address is invalid."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-sender" /* AuthErrorCode.INVALID_SENDER */ , "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ , "The verification ID used to create the phone auth credential is invalid."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ , "The Auth instance's tenant ID is invalid."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , "Login blocked by user-provided method: {$originalMessage}"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ , "An Android Package Name must be provided if the Android App is required to be installed."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ , "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ , "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-verification-code" /* AuthErrorCode.MISSING_CODE */ , "The phone auth credential was created with an empty SMS verification code."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ , "A continue URL must be provided in the request."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ , "An internal AuthError has occurred."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ , "An iOS Bundle ID must be provided if an App Store ID is provided."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ , "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ , "A non-empty password must be provided"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ , "No second factor identifier is provided."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ , "The request is missing proof of first factor successful sign-in."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ , "To send verification codes, provide a phone number for the recipient."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ , "The phone auth credential was created with an empty verification ID."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ , "This instance of FirebaseApp has been deleted."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ , "The user does not have a second factor matching the identifier provided."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , "Proof of ownership of a second factor is required to complete sign-in."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ , "An internal AuthError has occurred."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ , "User was not linked to an account with the given provider."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "null-user" /* AuthErrorCode.NULL_USER */ , "A null user object was provided as the argument for an operation which requires a non-null user object."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ , "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.'), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ , "Unable to establish a connection with the popup. It may have been blocked by the browser."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ , "The popup has been closed by the user before finalizing the operation."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ , "User can only be linked to one identity for the given provider."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ , "The project's quota for this operation has been exceeded."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ , "The redirect operation has been cancelled by the user before finalizing."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ , "A redirect sign-in operation is already pending."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ , "The request contains malformed or mismatching credentials."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ , "The second factor is already enrolled on this account."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ , "The maximum allowed number of second factors on a user has been exceeded."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ , "The provided tenant ID does not match the Auth instance's tenant ID"), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "timeout" /* AuthErrorCode.TIMEOUT */ , "The operation has timed out."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ , "The user's credential is no longer valid. The user must sign in again."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ , "We have blocked all requests from this device due to unusual activity. Try again later."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ , "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ , "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ , "The current environment does not support the specified persistence type."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ , "This operation is not supported in a multi-tenant context."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ , "The operation requires a verified email."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "user-cancelled" /* AuthErrorCode.USER_CANCELLED */ , "The user did not grant your application the permissions it requested."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "user-not-found" /* AuthErrorCode.USER_DELETED */ , "There is no user record corresponding to this identifier. The user may have been deleted."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , "The user account has been disabled by an administrator."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ , "The supplied credentials do not correspond to the previously signed in user."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ , ""), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "weak-password" /* AuthErrorCode.WEAK_PASSWORD */ , "The password must be 6 characters long or more."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ , "This browser is not supported or 3rd party cookies and data may be disabled."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ , "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is missing when sending request to the backend."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ , "The reCAPTCHA token is invalid when sending request to the backend."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ , "The reCAPTCHA action is invalid when sending request to the backend."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ , "reCAPTCHA Enterprise integration is not enabled for this project."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ , "The reCAPTCHA client type is missing when sending request to the backend."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ , "The reCAPTCHA version is missing when sending request to the backend."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ , "Invalid request parameters."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ , "The reCAPTCHA version is invalid when sending request to the backend."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK."), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "The password does not meet the requirements."), _obj);
}
function $0021d6672f58c7eb$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ , "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.");
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $0021d6672f58c7eb$export$a9c23c6ac3fc3eca = $0021d6672f58c7eb$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ var $0021d6672f58c7eb$export$2329c99376c9d0a4 = $0021d6672f58c7eb$var$_prodErrorMap;
var $0021d6672f58c7eb$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $b1467a785fc7cec5$export$3fa6e1b18a3b2d40)("auth", "Firebase", $0021d6672f58c7eb$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ var $0021d6672f58c7eb$export$7f8ddf7c7c20b3cd = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$logClient = new (0, $a1a98c9cad39c4c7$export$efa9a398d6368992)("@firebase/auth");
function $0021d6672f58c7eb$var$_logWarn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($0021d6672f58c7eb$var$logClient.logLevel <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).WARN) (_logClient = $0021d6672f58c7eb$var$logClient).warn.apply(_logClient, [
        "Auth (".concat((0, $2b7c3095396a3894$export$31499a9cd224b78c), "): ").concat(msg)
    ].concat((0, $fLnyw._)(args)));
}
function $0021d6672f58c7eb$var$_logError(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _logClient;
    if ($0021d6672f58c7eb$var$logClient.logLevel <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).ERROR) (_logClient = $0021d6672f58c7eb$var$logClient).error.apply(_logClient, [
        "Auth (".concat((0, $2b7c3095396a3894$export$31499a9cd224b78c), "): ").concat(msg)
    ].concat((0, $fLnyw._)(args)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$export$92108d983e8ee699(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    throw $0021d6672f58c7eb$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $fLnyw._)(rest)));
}
function $0021d6672f58c7eb$export$91c6e00c14e7e6fd(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    return $0021d6672f58c7eb$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $fLnyw._)(rest)));
}
function $0021d6672f58c7eb$var$_errorWithCustomMessage(auth, code, message) {
    var errorMap = Object.assign(Object.assign({}, $0021d6672f58c7eb$export$2329c99376c9d0a4()), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, code, message));
    var factory = new (0, $b1467a785fc7cec5$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $0021d6672f58c7eb$var$_assertInstanceOf(auth, object, instance) {
    var constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $0021d6672f58c7eb$export$92108d983e8ee699(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $0021d6672f58c7eb$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , "Type of ".concat(object.constructor.name, " does not match expected instance.") + "Did you pass a reference from a different Auth SDK?");
    }
}
function $0021d6672f58c7eb$var$createErrorInternal(authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        rest[_key - 1] = arguments[_key];
    }
    var _DEFAULT_AUTH_ERROR_FACTORY1;
    if (typeof authOrCode !== "string") {
        var _authOrCode__errorFactory;
        var code = rest[0];
        var fullParams = (0, $fLnyw._)(rest.slice(1));
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return (_authOrCode__errorFactory = authOrCode._errorFactory).create.apply(_authOrCode__errorFactory, [
            code
        ].concat((0, $fLnyw._)(fullParams)));
    }
    return (_DEFAULT_AUTH_ERROR_FACTORY1 = $0021d6672f58c7eb$var$_DEFAULT_AUTH_ERROR_FACTORY).create.apply(_DEFAULT_AUTH_ERROR_FACTORY1, [
        authOrCode
    ].concat((0, $fLnyw._)(rest)));
}
function $0021d6672f58c7eb$export$9d398bebfec1c039(assertion, authOrCode) {
    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rest[_key - 2] = arguments[_key];
    }
    if (!assertion) throw $0021d6672f58c7eb$var$createErrorInternal.apply(void 0, [
        authOrCode
    ].concat((0, $fLnyw._)(rest)));
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $0021d6672f58c7eb$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var message = "INTERNAL ASSERTION FAILED: " + failure;
    $0021d6672f58c7eb$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $0021d6672f58c7eb$export$493d36ec626b6698(assertion, message) {
    if (!assertion) $0021d6672f58c7eb$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $0021d6672f58c7eb$var$_isHttpOrHttps() {
    return $0021d6672f58c7eb$var$_getCurrentScheme() === "http:" || $0021d6672f58c7eb$var$_getCurrentScheme() === "https:";
}
function $0021d6672f58c7eb$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $0021d6672f58c7eb$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($0021d6672f58c7eb$var$_isHttpOrHttps() || (0, $b1467a785fc7cec5$export$caa8774a9107a58e)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $0021d6672f58c7eb$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    var navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ var $0021d6672f58c7eb$var$Delay = /*#__PURE__*/ function() {
    "use strict";
    function Delay(shortDelay, longDelay) {
        (0, $978gY._)(this, Delay);
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $0021d6672f58c7eb$export$493d36ec626b6698(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $b1467a785fc7cec5$export$872f8323f01d7ae0)() || (0, $b1467a785fc7cec5$export$f7a1e23e542d38e3)();
    }
    (0, $kry2a._)(Delay, [
        {
            key: "get",
            value: function get() {
                if (!$0021d6672f58c7eb$var$_isOnline()) // Pick the shorter timeout.
                return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
                // If running in a mobile environment, return the long delay, otherwise
                // return the short delay.
                // This could be improved in the future to dynamically change based on other
                // variables instead of just reading the current environment.
                return this.isMobile ? this.longDelay : this.shortDelay;
            }
        }
    ]);
    return Delay;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$_emulatorUrl(config, path) {
    $0021d6672f58c7eb$export$493d36ec626b6698(config.emulator, "Emulator should always be set here");
    var url = config.emulator.url;
    if (!path) return url;
    return "".concat(url).concat(path.startsWith("/") ? path.slice(1) : path);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$export$c03999cb2f36933f = /*#__PURE__*/ function() {
    "use strict";
    function FetchProvider() {
        (0, $978gY._)(this, FetchProvider);
    }
    (0, $kry2a._)(FetchProvider, null, [
        {
            key: "initialize",
            value: function initialize(fetchImpl, headersImpl, responseImpl) {
                this.fetchImpl = fetchImpl;
                if (headersImpl) this.headersImpl = headersImpl;
                if (responseImpl) this.responseImpl = responseImpl;
            }
        },
        {
            key: "fetch",
            value: function fetch1() {
                if (this.fetchImpl) return this.fetchImpl;
                if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
                $0021d6672f58c7eb$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "headers",
            value: function headers() {
                if (this.headersImpl) return this.headersImpl;
                if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
                $0021d6672f58c7eb$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        },
        {
            key: "response",
            value: function response() {
                if (this.responseImpl) return this.responseImpl;
                if (typeof self !== "undefined" && "Response" in self) return self.Response;
                $0021d6672f58c7eb$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
            }
        }
    ]);
    return FetchProvider;
}();
var $0021d6672f58c7eb$var$_obj;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ var $0021d6672f58c7eb$var$SERVER_ERROR_MAP = ($0021d6672f58c7eb$var$_obj = {}, // Custom token errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ , "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ), // This can only happen if the SDK sends a bad request.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Create Auth URI errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ , "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ), // This can only happen if the SDK sends a bad request.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Sign in with email and password errors (some apply to sign up too).
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ , "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ), // This can only happen if the SDK sends a bad request.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ , "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ), // Sign up with email and password errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ , "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ , "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ), // Verify assertion for sign in with credential errors:
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ , "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ), // This can only happen if the SDK sends a bad request.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Send Password reset email errors:
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ , "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ , "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ), // This can only happen if the SDK sends a bad request.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Operations that require ID token in request:
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ , "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ , "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ), // Other errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ , "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ , "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ), // Phone Auth related errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_CODE" /* ServerError.INVALID_CODE */ , "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ , "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ , "invalid-credential" /* AuthErrorCode.INVALID_IDP_RESPONSE */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ , "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ , "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ), // Other action code errors when additional settings passed.
// MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
// This is OK as this error will be caught by client side validation.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ , "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ , "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ), // getProjectConfig errors when clientId is passed.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ , "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ), // User actions (sign-up or deletion) disabled errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ , "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ), // Multi factor related errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ , "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ , "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ , "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ , "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ , "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ , "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ), // Blocking functions related errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ , "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ), // Recaptcha related errors.
(0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ , "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ , "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ , "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ , "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ , "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ , "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ , "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)($0021d6672f58c7eb$var$_obj, "INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ , "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ), $0021d6672f58c7eb$var$_obj);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$DEFAULT_API_TIMEOUT_MS = new $0021d6672f58c7eb$var$Delay(30000, 60000);
function $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
function $0021d6672f58c7eb$var$_performApiRequest(auth, method, path, request) {
    return $0021d6672f58c7eb$var$__performApiRequest.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__performApiRequest() {
    $0021d6672f58c7eb$var$__performApiRequest = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, method, path, request) {
        var customErrorMap;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
            return [
                2,
                $0021d6672f58c7eb$var$_performFetchWithErrorHandling(auth, customErrorMap, /*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var body, params, query, headers;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                body = {};
                                params = {};
                                if (request) {
                                    if (method === "GET" /* HttpMethod.GET */ ) params = request;
                                    else body = {
                                        body: JSON.stringify(request)
                                    };
                                }
                                query = (0, $b1467a785fc7cec5$export$ac4103b836844853)(Object.assign({
                                    key: auth.config.apiKey
                                }, params)).slice(1);
                                return [
                                    4,
                                    auth._getAdditionalHeaders()
                                ];
                            case 1:
                                headers = _state.sent();
                                headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
                                if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
                                return [
                                    2,
                                    $0021d6672f58c7eb$export$c03999cb2f36933f.fetch()($0021d6672f58c7eb$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
                                        method: method,
                                        headers: headers,
                                        referrerPolicy: "no-referrer"
                                    }, body))
                                ];
                        }
                    });
                }))
            ];
        });
    });
    return $0021d6672f58c7eb$var$__performApiRequest.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    return $0021d6672f58c7eb$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__performFetchWithErrorHandling() {
    $0021d6672f58c7eb$var$__performFetchWithErrorHandling = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, customErrorMap, fetchFn) {
        var errorMap, networkTimeout, response, json, errorMessage, _errorMessage_split, serverErrorCode, serverErrorMessage, authError, e;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth._canInitEmulator = false;
                    errorMap = Object.assign(Object.assign({}, $0021d6672f58c7eb$var$SERVER_ERROR_MAP), customErrorMap);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    networkTimeout = new $0021d6672f58c7eb$var$NetworkTimeout(auth);
                    return [
                        4,
                        Promise.race([
                            fetchFn(),
                            networkTimeout.promise
                        ])
                    ];
                case 2:
                    response = _state.sent();
                    // If we've reached this point, the fetch succeeded and the networkTimeout
                    // didn't throw; clear the network timeout delay so that Node won't hang
                    networkTimeout.clearNetworkTimeout();
                    return [
                        4,
                        response.json()
                    ];
                case 3:
                    json = _state.sent();
                    if ("needConfirmation" in json) throw $0021d6672f58c7eb$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
                    if (response.ok && !("errorMessage" in json)) return [
                        2,
                        json
                    ];
                    else {
                        errorMessage = response.ok ? json.errorMessage : json.error.message;
                        _errorMessage_split = (0, $8GFUW._)(errorMessage.split(" : "), 2), serverErrorCode = _errorMessage_split[0], serverErrorMessage = _errorMessage_split[1];
                        if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $0021d6672f58c7eb$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
                        else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $0021d6672f58c7eb$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
                        else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $0021d6672f58c7eb$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
                        authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
                        if (serverErrorMessage) throw $0021d6672f58c7eb$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
                        else $0021d6672f58c7eb$export$92108d983e8ee699(auth, authError);
                    }
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    if (e instanceof (0, $b1467a785fc7cec5$export$dd24e9cd51226c56)) throw e;
                    // Changing this to a different error code will log user out when there is a network error
                    // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
                    // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
                    $0021d6672f58c7eb$export$92108d983e8ee699(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
                        "message": String(e)
                    });
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__performFetchWithErrorHandling.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_performSignInRequest(auth, method, path, request) {
    return $0021d6672f58c7eb$var$__performSignInRequest.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__performSignInRequest() {
    $0021d6672f58c7eb$var$__performSignInRequest = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, method, path, request) {
        var customErrorMap, serverResponse;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    customErrorMap = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {};
                    return [
                        4,
                        $0021d6672f58c7eb$var$_performApiRequest(auth, method, path, request, customErrorMap)
                    ];
                case 1:
                    serverResponse = _state.sent();
                    if ("mfaPendingCredential" in serverResponse) $0021d6672f58c7eb$export$92108d983e8ee699(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
                        _serverResponse: serverResponse
                    });
                    return [
                        2,
                        serverResponse
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__performSignInRequest.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getFinalTarget(auth, host, path, query) {
    var base = "".concat(host).concat(path, "?").concat(query);
    if (!auth.config.emulator) return "".concat(auth.config.apiScheme, "://").concat(base);
    return $0021d6672f58c7eb$var$_emulatorUrl(auth.config, base);
}
var $0021d6672f58c7eb$var$NetworkTimeout = /*#__PURE__*/ function() {
    "use strict";
    function NetworkTimeout(auth) {
        var _this = this;
        (0, $978gY._)(this, NetworkTimeout);
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise(function(_, reject) {
            _this.timer = setTimeout(function() {
                return reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(_this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $0021d6672f58c7eb$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    (0, $kry2a._)(NetworkTimeout, [
        {
            key: "clearNetworkTimeout",
            value: function clearNetworkTimeout() {
                clearTimeout(this.timer);
            }
        }
    ]);
    return NetworkTimeout;
}();
function $0021d6672f58c7eb$var$_makeTaggedError(auth, code, response) {
    var errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    var error = $0021d6672f58c7eb$export$91c6e00c14e7e6fd(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
function $0021d6672f58c7eb$var$getRecaptchaParams(auth) {
    return $0021d6672f58c7eb$var$_getRecaptchaParams.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getRecaptchaParams() {
    $0021d6672f58c7eb$var$_getRecaptchaParams = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().recaptchaSiteKey || ""
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_getRecaptchaParams.apply(this, arguments);
}
function $0021d6672f58c7eb$var$getRecaptchaConfig(auth, request) {
    return $0021d6672f58c7eb$var$_getRecaptchaConfig.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getRecaptchaConfig() {
    $0021d6672f58c7eb$var$_getRecaptchaConfig = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_getRecaptchaConfig.apply(this, arguments);
}
function $0021d6672f58c7eb$var$deleteAccount(auth, request) {
    return $0021d6672f58c7eb$var$_deleteAccount.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_deleteAccount() {
    $0021d6672f58c7eb$var$_deleteAccount = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_deleteAccount.apply(this, arguments);
}
function $0021d6672f58c7eb$var$deleteLinkedAccounts(auth, request) {
    return $0021d6672f58c7eb$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_deleteLinkedAccounts() {
    $0021d6672f58c7eb$var$_deleteLinkedAccounts = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_deleteLinkedAccounts.apply(this, arguments);
}
function $0021d6672f58c7eb$var$getAccountInfo(auth, request) {
    return $0021d6672f58c7eb$var$_getAccountInfo.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getAccountInfo() {
    $0021d6672f58c7eb$var$_getAccountInfo = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_getAccountInfo.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        var date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $0021d6672f58c7eb$export$1a82df3d29112e01(user) {
    var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
function $0021d6672f58c7eb$export$306ddfe3a8403e2(user) {
    return $0021d6672f58c7eb$var$_getIdTokenResult.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getIdTokenResult() {
    $0021d6672f58c7eb$var$_getIdTokenResult = /**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user) {
        var forceRefresh, userInternal, token, claims, firebase, signInProvider;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    forceRefresh = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        userInternal.getIdToken(forceRefresh)
                    ];
                case 1:
                    token = _state.sent();
                    claims = $0021d6672f58c7eb$var$_parseToken(token);
                    $0021d6672f58c7eb$export$9d398bebfec1c039(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
                    signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
                    return [
                        2,
                        {
                            claims: claims,
                            token: token,
                            authTime: $0021d6672f58c7eb$var$utcTimestampToDateString($0021d6672f58c7eb$var$secondsStringToMilliseconds(claims.auth_time)),
                            issuedAtTime: $0021d6672f58c7eb$var$utcTimestampToDateString($0021d6672f58c7eb$var$secondsStringToMilliseconds(claims.iat)),
                            expirationTime: $0021d6672f58c7eb$var$utcTimestampToDateString($0021d6672f58c7eb$var$secondsStringToMilliseconds(claims.exp)),
                            signInProvider: signInProvider || null,
                            signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
                        }
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_getIdTokenResult.apply(this, arguments);
}
function $0021d6672f58c7eb$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $0021d6672f58c7eb$var$_parseToken(token) {
    var _token_split = (0, $8GFUW._)(token.split("."), 3), algorithm = _token_split[0], payload = _token_split[1], signature = _token_split[2];
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $0021d6672f58c7eb$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        var decoded = (0, $b1467a785fc7cec5$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $0021d6672f58c7eb$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $0021d6672f58c7eb$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $0021d6672f58c7eb$var$_tokenExpiresIn(token) {
    var parsedToken = $0021d6672f58c7eb$var$_parseToken(token);
    $0021d6672f58c7eb$export$9d398bebfec1c039(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
function $0021d6672f58c7eb$var$_logoutIfInvalidated(user, promise) {
    return $0021d6672f58c7eb$var$__logoutIfInvalidated.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__logoutIfInvalidated() {
    $0021d6672f58c7eb$var$__logoutIfInvalidated = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, promise) {
        var bypassAuthState, e;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    if (bypassAuthState) return [
                        2,
                        promise
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        promise
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    if (!(e instanceof (0, $b1467a785fc7cec5$export$dd24e9cd51226c56) && $0021d6672f58c7eb$var$isUserInvalidated(e))) return [
                        3,
                        5
                    ];
                    if (!(user.auth.currentUser === user)) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        user.auth.signOut()
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    throw e;
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__logoutIfInvalidated.apply(this, arguments);
}
function $0021d6672f58c7eb$var$isUserInvalidated(param) {
    var code = param.code;
    return code === "auth/user-disabled" /* AuthErrorCode.USER_DISABLED */  || code === "auth/user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$ProactiveRefresh = /*#__PURE__*/ function() {
    "use strict";
    function ProactiveRefresh(user) {
        (0, $978gY._)(this, ProactiveRefresh);
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    (0, $kry2a._)(ProactiveRefresh, [
        {
            key: "_start",
            value: function _start() {
                if (this.isRunning) return;
                this.isRunning = true;
                this.schedule();
            }
        },
        {
            key: "_stop",
            value: function _stop() {
                if (!this.isRunning) return;
                this.isRunning = false;
                if (this.timerId !== null) clearTimeout(this.timerId);
            }
        },
        {
            key: "getInterval",
            value: function getInterval(wasError) {
                var _a;
                if (wasError) {
                    var interval = this.errorBackoff;
                    this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
                    return interval;
                } else {
                    // Reset the error backoff
                    this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
                    var expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
                    var interval1 = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
                    return Math.max(0, interval1);
                }
            }
        },
        {
            key: "schedule",
            value: function schedule() {
                var wasError = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this.isRunning) // Just in case...
                return;
                var interval = this.getInterval(wasError);
                var _this = this;
                this.timerId = setTimeout(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.iteration()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }), interval);
            }
        },
        {
            key: "iteration",
            value: function iteration() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this.user.getIdToken(true)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                // Only retry on network errors
                                if ((e === null || e === void 0 ? void 0 : e.code) === "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) _this.schedule(/* wasError */ true);
                                return [
                                    2
                                ];
                            case 3:
                                _this.schedule();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProactiveRefresh;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$UserMetadata = /*#__PURE__*/ function() {
    "use strict";
    function UserMetadata(createdAt, lastLoginAt) {
        (0, $978gY._)(this, UserMetadata);
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    (0, $kry2a._)(UserMetadata, [
        {
            key: "_initializeTime",
            value: function _initializeTime() {
                this.lastSignInTime = $0021d6672f58c7eb$var$utcTimestampToDateString(this.lastLoginAt);
                this.creationTime = $0021d6672f58c7eb$var$utcTimestampToDateString(this.createdAt);
            }
        },
        {
            key: "_copy",
            value: function _copy(metadata) {
                this.createdAt = metadata.createdAt;
                this.lastLoginAt = metadata.lastLoginAt;
                this._initializeTime();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    createdAt: this.createdAt,
                    lastLoginAt: this.lastLoginAt
                };
            }
        }
    ]);
    return UserMetadata;
}();
function $0021d6672f58c7eb$var$_reloadWithoutSaving(user) {
    return $0021d6672f58c7eb$var$__reloadWithoutSaving.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__reloadWithoutSaving() {
    $0021d6672f58c7eb$var$__reloadWithoutSaving = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user) {
        var _a, auth, idToken, response, coreAccount, newProviderData, providerData, oldIsAnonymous, newIsAnonymous, isAnonymous, updates;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$_logoutIfInvalidated(user, $0021d6672f58c7eb$var$getAccountInfo(auth, {
                            idToken: idToken
                        }))
                    ];
                case 2:
                    response = _state.sent();
                    $0021d6672f58c7eb$export$9d398bebfec1c039(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    coreAccount = response.users[0];
                    user._notifyReloadListener(coreAccount);
                    newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $0021d6672f58c7eb$var$extractProviderData(coreAccount.providerUserInfo) : [];
                    providerData = $0021d6672f58c7eb$var$mergeProviderData(user.providerData, newProviderData);
                    oldIsAnonymous = user.isAnonymous;
                    newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
                    isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
                    updates = {
                        uid: coreAccount.localId,
                        displayName: coreAccount.displayName || null,
                        photoURL: coreAccount.photoUrl || null,
                        email: coreAccount.email || null,
                        emailVerified: coreAccount.emailVerified || false,
                        phoneNumber: coreAccount.phoneNumber || null,
                        tenantId: coreAccount.tenantId || null,
                        providerData: providerData,
                        metadata: new $0021d6672f58c7eb$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
                        isAnonymous: isAnonymous
                    };
                    Object.assign(user, updates);
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__reloadWithoutSaving.apply(this, arguments);
}
function $0021d6672f58c7eb$export$8a5498727ef6be21(user) {
    return $0021d6672f58c7eb$var$_reload.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_reload() {
    $0021d6672f58c7eb$var$_reload = /**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user) {
        var userInternal;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_reloadWithoutSaving(userInternal)
                    ];
                case 1:
                    _state.sent();
                    // Even though the current user hasn't changed, update
                    // current user will trigger a persistence update w/ the
                    // new info.
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 2:
                    _state.sent();
                    userInternal.auth._notifyListenersIfCurrent(userInternal);
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_reload.apply(this, arguments);
}
function $0021d6672f58c7eb$var$mergeProviderData(original, newData) {
    var deduped = original.filter(function(o) {
        return !newData.some(function(n) {
            return n.providerId === o.providerId;
        });
    });
    return (0, $fLnyw._)(deduped).concat((0, $fLnyw._)(newData));
}
function $0021d6672f58c7eb$var$extractProviderData(providers) {
    return providers.map(function(_a) {
        var providerId = _a.providerId, provider = (0, $7UAGh.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
function $0021d6672f58c7eb$var$requestStsToken(auth, refreshToken) {
    return $0021d6672f58c7eb$var$_requestStsToken.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_requestStsToken() {
    $0021d6672f58c7eb$var$_requestStsToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, refreshToken) {
        var response;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$_performFetchWithErrorHandling(auth, {}, /*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                            var body, _auth_config, tokenApiHost, apiKey, url, headers;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        body = (0, $b1467a785fc7cec5$export$ac4103b836844853)({
                                            "grant_type": "refresh_token",
                                            "refresh_token": refreshToken
                                        }).slice(1);
                                        _auth_config = auth.config, tokenApiHost = _auth_config.tokenApiHost, apiKey = _auth_config.apiKey;
                                        url = $0021d6672f58c7eb$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , "key=".concat(apiKey));
                                        return [
                                            4,
                                            auth._getAdditionalHeaders()
                                        ];
                                    case 1:
                                        headers = _state.sent();
                                        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
                                        return [
                                            2,
                                            $0021d6672f58c7eb$export$c03999cb2f36933f.fetch()(url, {
                                                method: "POST" /* HttpMethod.POST */ ,
                                                headers: headers,
                                                body: body
                                            })
                                        ];
                                }
                            });
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    // The response comes back in snake_case. Convert to camel:
                    return [
                        2,
                        {
                            accessToken: response.access_token,
                            expiresIn: response.expires_in,
                            refreshToken: response.refresh_token
                        }
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_requestStsToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ var $0021d6672f58c7eb$var$StsTokenManager = /*#__PURE__*/ function() {
    "use strict";
    function StsTokenManager() {
        (0, $978gY._)(this, StsTokenManager);
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    (0, $kry2a._)(StsTokenManager, [
        {
            key: "isExpired",
            get: function get() {
                return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
            }
        },
        {
            key: "updateFromServerResponse",
            value: function updateFromServerResponse(response) {
                $0021d6672f58c7eb$export$9d398bebfec1c039(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $0021d6672f58c7eb$export$9d398bebfec1c039(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $0021d6672f58c7eb$export$9d398bebfec1c039(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $0021d6672f58c7eb$var$_tokenExpiresIn(response.idToken);
                this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
            }
        },
        {
            key: "getToken",
            value: function getToken(auth) {
                var forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $0021d6672f58c7eb$export$9d398bebfec1c039(!_this.accessToken || _this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
                                if (!forceRefresh && _this.accessToken && !_this.isExpired) return [
                                    2,
                                    _this.accessToken
                                ];
                                if (!_this.refreshToken) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.refresh(auth, _this.refreshToken)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this.accessToken
                                ];
                            case 2:
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "clearRefreshToken",
            value: function clearRefreshToken() {
                this.refreshToken = null;
            }
        },
        {
            key: "refresh",
            value: function refresh(auth, oldToken) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _ref, accessToken, refreshToken, expiresIn;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$requestStsToken(auth, oldToken)
                                ];
                            case 1:
                                _ref = _state.sent(), accessToken = _ref.accessToken, refreshToken = _ref.refreshToken, expiresIn = _ref.expiresIn;
                                _this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "updateTokensAndExpiration",
            value: function updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
                this.refreshToken = refreshToken || null;
                this.accessToken = accessToken || null;
                this.expirationTime = Date.now() + expiresInSec * 1000;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    refreshToken: this.refreshToken,
                    accessToken: this.accessToken,
                    expirationTime: this.expirationTime
                };
            }
        },
        {
            key: "_assign",
            value: function _assign(stsTokenManager) {
                this.accessToken = stsTokenManager.accessToken;
                this.refreshToken = stsTokenManager.refreshToken;
                this.expirationTime = stsTokenManager.expirationTime;
            }
        },
        {
            key: "_clone",
            value: function _clone() {
                return Object.assign(new StsTokenManager(), this.toJSON());
            }
        },
        {
            key: "_performRefresh",
            value: function _performRefresh() {
                return $0021d6672f58c7eb$var$debugFail("not implemented");
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON(appName, object) {
                var refreshToken = object.refreshToken, accessToken = object.accessToken, expirationTime = object.expirationTime;
                var manager = new StsTokenManager();
                if (refreshToken) {
                    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.refreshToken = refreshToken;
                }
                if (accessToken) {
                    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.accessToken = accessToken;
                }
                if (expirationTime) {
                    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                        appName: appName
                    });
                    manager.expirationTime = expirationTime;
                }
                return manager;
            }
        }
    ]);
    return StsTokenManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$assertStringOrUndefined(assertion, appName) {
    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
var $0021d6672f58c7eb$export$a05254e7c3aeba6e = /*#__PURE__*/ function() {
    "use strict";
    function UserImpl(_a) {
        (0, $978gY._)(this, UserImpl);
        var uid = _a.uid, auth = _a.auth, stsTokenManager = _a.stsTokenManager, opt = (0, $7UAGh.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $0021d6672f58c7eb$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? (0, $fLnyw._)(opt.providerData) : [];
        this.metadata = new $0021d6672f58c7eb$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    (0, $kry2a._)(UserImpl, [
        {
            key: "getIdToken",
            value: function getIdToken(forceRefresh) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var accessToken;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_logoutIfInvalidated(_this, _this.stsTokenManager.getToken(_this.auth, forceRefresh))
                                ];
                            case 1:
                                accessToken = _state.sent();
                                $0021d6672f58c7eb$export$9d398bebfec1c039(accessToken, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                if (!(_this.accessToken !== accessToken)) return [
                                    3,
                                    3
                                ];
                                _this.accessToken = accessToken;
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 2:
                                _state.sent();
                                _this.auth._notifyListenersIfCurrent(_this);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    accessToken
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getIdTokenResult",
            value: function getIdTokenResult1(forceRefresh) {
                return $0021d6672f58c7eb$export$306ddfe3a8403e2(this, forceRefresh);
            }
        },
        {
            key: "reload",
            value: function reload1() {
                return $0021d6672f58c7eb$export$8a5498727ef6be21(this);
            }
        },
        {
            key: "_assign",
            value: function _assign(user) {
                if (this === user) return;
                $0021d6672f58c7eb$export$9d398bebfec1c039(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.displayName = user.displayName;
                this.photoURL = user.photoURL;
                this.email = user.email;
                this.emailVerified = user.emailVerified;
                this.phoneNumber = user.phoneNumber;
                this.isAnonymous = user.isAnonymous;
                this.tenantId = user.tenantId;
                this.providerData = user.providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                this.metadata._copy(user.metadata);
                this.stsTokenManager._assign(user.stsTokenManager);
            }
        },
        {
            key: "_clone",
            value: function _clone(auth) {
                var newUser = new UserImpl(Object.assign(Object.assign({}, this), {
                    auth: auth,
                    stsTokenManager: this.stsTokenManager._clone()
                }));
                newUser.metadata._copy(this.metadata);
                return newUser;
            }
        },
        {
            key: "_onReload",
            value: function _onReload(callback) {
                // There should only ever be one listener, and that is a single instance of MultiFactorUser
                $0021d6672f58c7eb$export$9d398bebfec1c039(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                this.reloadListener = callback;
                if (this.reloadUserInfo) {
                    this._notifyReloadListener(this.reloadUserInfo);
                    this.reloadUserInfo = null;
                }
            }
        },
        {
            key: "_notifyReloadListener",
            value: function _notifyReloadListener(userInfo) {
                if (this.reloadListener) this.reloadListener(userInfo);
                else // If no listener is subscribed yet, save the result so it's available when they do subscribe
                this.reloadUserInfo = userInfo;
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.proactiveRefresh._start();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.proactiveRefresh._stop();
            }
        },
        {
            key: "_updateTokensIfNecessary",
            value: function _updateTokensIfNecessary(response) {
                var reload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var tokensRefreshed;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                tokensRefreshed = false;
                                if (response.idToken && response.idToken !== _this.stsTokenManager.accessToken) {
                                    _this.stsTokenManager.updateFromServerResponse(response);
                                    tokensRefreshed = true;
                                }
                                if (!reload) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_reloadWithoutSaving(_this)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    4,
                                    _this.auth._persistUserIfCurrent(_this)
                                ];
                            case 3:
                                _state.sent();
                                if (tokensRefreshed) _this.auth._notifyListenersIfCurrent(_this);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var idToken;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_logoutIfInvalidated(_this, $0021d6672f58c7eb$var$deleteAccount(_this.auth, {
                                        idToken: idToken
                                    }))
                                ];
                            case 2:
                                _state.sent();
                                _this.stsTokenManager.clearRefreshToken();
                                // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
                                //       cancels pending actions...
                                return [
                                    2,
                                    _this.auth.signOut()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return Object.assign(Object.assign({
                    uid: this.uid,
                    email: this.email || undefined,
                    emailVerified: this.emailVerified,
                    displayName: this.displayName || undefined,
                    isAnonymous: this.isAnonymous,
                    photoURL: this.photoURL || undefined,
                    phoneNumber: this.phoneNumber || undefined,
                    tenantId: this.tenantId || undefined,
                    providerData: this.providerData.map(function(userInfo) {
                        return Object.assign({}, userInfo);
                    }),
                    stsTokenManager: this.stsTokenManager.toJSON(),
                    // Redirect event ID must be maintained in case there is a pending
                    // redirect event.
                    _redirectEventId: this._redirectEventId
                }, this.metadata.toJSON()), {
                    // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
                    apiKey: this.auth.config.apiKey,
                    appName: this.auth.name
                });
            }
        },
        {
            key: "refreshToken",
            get: function get() {
                return this.stsTokenManager.refreshToken || "";
            }
        }
    ], [
        {
            key: "_fromJSON",
            value: function _fromJSON(auth, object) {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                var displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
                var email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
                var phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
                var photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
                var tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
                var _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
                var createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
                var lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
                var uid = object.uid, emailVerified = object.emailVerified, isAnonymous = object.isAnonymous, providerData = object.providerData, plainObjectTokenManager = object.stsTokenManager;
                $0021d6672f58c7eb$export$9d398bebfec1c039(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var stsTokenManager = $0021d6672f58c7eb$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
                $0021d6672f58c7eb$export$9d398bebfec1c039(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $0021d6672f58c7eb$var$assertStringOrUndefined(displayName, auth.name);
                $0021d6672f58c7eb$var$assertStringOrUndefined(email, auth.name);
                $0021d6672f58c7eb$export$9d398bebfec1c039(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $0021d6672f58c7eb$export$9d398bebfec1c039(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                $0021d6672f58c7eb$var$assertStringOrUndefined(phoneNumber, auth.name);
                $0021d6672f58c7eb$var$assertStringOrUndefined(photoURL, auth.name);
                $0021d6672f58c7eb$var$assertStringOrUndefined(tenantId, auth.name);
                $0021d6672f58c7eb$var$assertStringOrUndefined(_redirectEventId, auth.name);
                $0021d6672f58c7eb$var$assertStringOrUndefined(createdAt, auth.name);
                $0021d6672f58c7eb$var$assertStringOrUndefined(lastLoginAt, auth.name);
                var user = new UserImpl({
                    uid: uid,
                    auth: auth,
                    email: email,
                    emailVerified: emailVerified,
                    displayName: displayName,
                    isAnonymous: isAnonymous,
                    photoURL: photoURL,
                    phoneNumber: phoneNumber,
                    tenantId: tenantId,
                    stsTokenManager: stsTokenManager,
                    createdAt: createdAt,
                    lastLoginAt: lastLoginAt
                });
                if (providerData && Array.isArray(providerData)) user.providerData = providerData.map(function(userInfo) {
                    return Object.assign({}, userInfo);
                });
                if (_redirectEventId) user._redirectEventId = _redirectEventId;
                return user;
            }
        },
        {
            key: "_fromIdTokenResponse",
            value: /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ function _fromIdTokenResponse(auth, idTokenResponse) {
                var isAnonymous = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var stsTokenManager, user;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                stsTokenManager = new $0021d6672f58c7eb$var$StsTokenManager();
                                stsTokenManager.updateFromServerResponse(idTokenResponse);
                                user = new UserImpl({
                                    uid: idTokenResponse.localId,
                                    auth: auth,
                                    stsTokenManager: stsTokenManager,
                                    isAnonymous: isAnonymous
                                });
                                // Updates the user info and data and resolves with a user instance.
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    user
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UserImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$instanceCache = new Map();
function $0021d6672f58c7eb$export$24baa2b76016ce0e(cls) {
    $0021d6672f58c7eb$export$493d36ec626b6698(cls instanceof Function, "Expected a class definition");
    var instance = $0021d6672f58c7eb$var$instanceCache.get(cls);
    if (instance) {
        $0021d6672f58c7eb$export$493d36ec626b6698(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $0021d6672f58c7eb$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$InMemoryPersistence = /*#__PURE__*/ function() {
    "use strict";
    function InMemoryPersistence() {
        (0, $978gY._)(this, InMemoryPersistence);
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    (0, $kry2a._)(InMemoryPersistence, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            true
                        ];
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this.storage[key] = value;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var value;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        value = _this.storage[key];
                        return [
                            2,
                            value === undefined ? null : value
                        ];
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        delete _this.storage[key];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
                return;
            }
        }
    ]);
    return InMemoryPersistence;
}();
$0021d6672f58c7eb$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ var $0021d6672f58c7eb$export$3722cfe417b6ed86 = $0021d6672f58c7eb$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$export$158acd800e1ef08b(key, apiKey, appName) {
    return "firebase:".concat(key, ":").concat(apiKey, ":").concat(appName);
}
var $0021d6672f58c7eb$var$PersistenceUserManager = /*#__PURE__*/ function() {
    "use strict";
    function PersistenceUserManager(persistence, auth, userKey) {
        (0, $978gY._)(this, PersistenceUserManager);
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        var _this_auth = this.auth, config = _this_auth.config, name = _this_auth.name;
        this.fullUserKey = $0021d6672f58c7eb$export$158acd800e1ef08b(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $0021d6672f58c7eb$export$158acd800e1ef08b("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    (0, $kry2a._)(PersistenceUserManager, [
        {
            key: "setCurrentUser",
            value: function setCurrentUser(user) {
                return this.persistence._set(this.fullUserKey, user.toJSON());
            }
        },
        {
            key: "getCurrentUser",
            value: function getCurrentUser() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var blob;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.persistence._get(_this.fullUserKey)
                                ];
                            case 1:
                                blob = _state.sent();
                                return [
                                    2,
                                    blob ? $0021d6672f58c7eb$export$a05254e7c3aeba6e._fromJSON(_this.auth, blob) : null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "removeCurrentUser",
            value: function removeCurrentUser() {
                return this.persistence._remove(this.fullUserKey);
            }
        },
        {
            key: "savePersistenceForRedirect",
            value: function savePersistenceForRedirect() {
                return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(newPersistence) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var currentUser;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.persistence === newPersistence) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.getCurrentUser()
                                ];
                            case 1:
                                currentUser = _state.sent();
                                return [
                                    4,
                                    _this.removeCurrentUser()
                                ];
                            case 2:
                                _state.sent();
                                _this.persistence = newPersistence;
                                if (currentUser) return [
                                    2,
                                    _this.setCurrentUser(currentUser)
                                ];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
            }
        }
    ], [
        {
            key: "create",
            value: function create(auth, persistenceHierarchy) {
                var userKey = arguments.length > 2 && arguments[2] !== void 0 /* KeyName.AUTH_USER */  ? arguments[2] : "authUser";
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var availablePersistences, selectedPersistence, key, userToMigrate, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, persistence, blob, user, _a, err, migrationHierarchy;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!persistenceHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager($0021d6672f58c7eb$export$24baa2b76016ce0e($0021d6672f58c7eb$export$3722cfe417b6ed86), auth, userKey)
                                ];
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(persistence) {
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            persistence._isAvailable()
                                                        ];
                                                    case 1:
                                                        if (_state.sent()) return [
                                                            2,
                                                            persistence
                                                        ];
                                                        return [
                                                            2,
                                                            undefined
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 1:
                                availablePersistences = _state.sent().filter(function(persistence) {
                                    return persistence;
                                });
                                selectedPersistence = availablePersistences[0] || $0021d6672f58c7eb$export$24baa2b76016ce0e($0021d6672f58c7eb$export$3722cfe417b6ed86);
                                key = $0021d6672f58c7eb$export$158acd800e1ef08b(userKey, auth.config.apiKey, auth.name);
                                userToMigrate = null;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = persistenceHierarchy[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                persistence = _step.value;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    persistence._get(key)
                                ];
                            case 5:
                                blob = _state.sent();
                                if (blob) {
                                    user = $0021d6672f58c7eb$export$a05254e7c3aeba6e._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                                    if (persistence !== selectedPersistence) userToMigrate = user;
                                    selectedPersistence = persistence;
                                    return [
                                        3,
                                        8
                                    ];
                                }
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _a = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                migrationHierarchy = availablePersistences.filter(function(p) {
                                    return p._shouldAllowMigration;
                                });
                                // If the persistence does _not_ allow migration, just finish off here
                                if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                                selectedPersistence = migrationHierarchy[0];
                                if (!userToMigrate) return [
                                    3,
                                    13
                                ];
                                // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
                                // we'll just let it bubble to surface the error.
                                return [
                                    4,
                                    selectedPersistence._set(key, userToMigrate.toJSON())
                                ];
                            case 12:
                                _state.sent();
                                _state.label = 13;
                            case 13:
                                // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
                                // such as users getting stuck with a previous account after signing out and refreshing the tab.
                                return [
                                    4,
                                    Promise.all(persistenceHierarchy.map(function() {
                                        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(persistence) {
                                            var _a;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(persistence !== selectedPersistence)) return [
                                                            3,
                                                            4
                                                        ];
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            persistence._remove(key)
                                                        ];
                                                    case 2:
                                                        _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        _a = _state.sent();
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(persistence) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()))
                                ];
                            case 14:
                                _state.sent();
                                return [
                                    2,
                                    new PersistenceUserManager(selectedPersistence, auth, userKey)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return PersistenceUserManager;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $0021d6672f58c7eb$var$_getBrowserName(userAgent) {
    var ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($0021d6672f58c7eb$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($0021d6672f58c7eb$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($0021d6672f58c7eb$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($0021d6672f58c7eb$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($0021d6672f58c7eb$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $0021d6672f58c7eb$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($0021d6672f58c7eb$export$d66dc83d8cfc8dd(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        var re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        var matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $0021d6672f58c7eb$var$_isFirefox() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /firefox\//i.test(ua);
}
function $0021d6672f58c7eb$var$_isSafari() {
    var userAgent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    var ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $0021d6672f58c7eb$var$_isChromeIOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /crios\//i.test(ua);
}
function $0021d6672f58c7eb$var$_isIEMobile() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /iemobile/i.test(ua);
}
function $0021d6672f58c7eb$export$d66dc83d8cfc8dd() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /android/i.test(ua);
}
function $0021d6672f58c7eb$var$_isBlackBerry() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /blackberry/i.test(ua);
}
function $0021d6672f58c7eb$var$_isWebOS() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /webos/i.test(ua);
}
function $0021d6672f58c7eb$export$1fbe638ecf81657e() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $0021d6672f58c7eb$export$3d12bd131bb975d1() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $0021d6672f58c7eb$var$_isIOSStandalone() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    var _a;
    return $0021d6672f58c7eb$export$1fbe638ecf81657e(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $0021d6672f58c7eb$var$_isIE10() {
    return (0, $b1467a785fc7cec5$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $0021d6672f58c7eb$var$_isMobileBrowser() {
    var ua = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    // TODO: implement getBrowserName equivalent for OS.
    return $0021d6672f58c7eb$export$1fbe638ecf81657e(ua) || $0021d6672f58c7eb$export$d66dc83d8cfc8dd(ua) || $0021d6672f58c7eb$var$_isWebOS(ua) || $0021d6672f58c7eb$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $0021d6672f58c7eb$var$_isIEMobile(ua);
}
function $0021d6672f58c7eb$var$_isIframe() {
    try {
        // Check that the current window is not the top window.
        // If so, return true.
        return !!(window && window !== window.top);
    } catch (e) {
        return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $0021d6672f58c7eb$export$91477dc880baac21(clientPlatform) {
    var frameworks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $0021d6672f58c7eb$var$_getBrowserName((0, $b1467a785fc7cec5$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = "".concat($0021d6672f58c7eb$var$_getBrowserName((0, $b1467a785fc7cec5$export$c36915b22ce77c19)()), "-").concat(clientPlatform);
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    var reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return "".concat(reportedPlatform, "/", "JsCore" /* ClientImplementation.CORE */ , "/").concat((0, $2b7c3095396a3894$export$31499a9cd224b78c), "/").concat(reportedFrameworks);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$AuthMiddlewareQueue = /*#__PURE__*/ function() {
    "use strict";
    function AuthMiddlewareQueue(auth) {
        (0, $978gY._)(this, AuthMiddlewareQueue);
        this.auth = auth;
        this.queue = [];
    }
    (0, $kry2a._)(AuthMiddlewareQueue, [
        {
            key: "pushCallback",
            value: function pushCallback(callback, onAbort) {
                var _this = this;
                // The callback could be sync or async. Wrap it into a
                // function that is always async.
                var wrappedCallback = function(user) {
                    return new Promise(function(resolve, reject) {
                        try {
                            var result = callback(user);
                            // Either resolve with existing promise or wrap a non-promise
                            // return value into a promise.
                            resolve(result);
                        } catch (e) {
                            // Sync callback throws.
                            reject(e);
                        }
                    });
                };
                // Attach the onAbort if present
                wrappedCallback.onAbort = onAbort;
                this.queue.push(wrappedCallback);
                var index = this.queue.length - 1;
                return function() {
                    // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
                    // indexing of other elements.
                    _this.queue[index] = function() {
                        return Promise.resolve();
                    };
                };
            }
        },
        {
            key: "runMiddleware",
            value: function runMiddleware(nextUser) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var onAbortStack, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, beforeStateCallback, err, e, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, onAbort;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.auth.currentUser === nextUser) return [
                                    2
                                ];
                                onAbortStack = [];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    10,
                                    ,
                                    11
                                ]);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = _this.queue[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                beforeStateCallback = _step.value;
                                return [
                                    4,
                                    beforeStateCallback(nextUser)
                                ];
                            case 4:
                                _state.sent();
                                // Only push the onAbort if the callback succeeds
                                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                e = _state.sent();
                                // Run all onAbort, with separate try/catch to ignore any errors and
                                // continue
                                onAbortStack.reverse();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = onAbortStack[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        onAbort = _step1.value;
                                        try {
                                            onAbort();
                                        } catch (_) {
                                        /* swallow error */ }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                throw _this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                                    originalMessage: e === null || e === void 0 ? void 0 : e.message
                                });
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthMiddlewareQueue;
}();
function $0021d6672f58c7eb$var$_getPasswordPolicy(auth) {
    return $0021d6672f58c7eb$var$__getPasswordPolicy.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__getPasswordPolicy() {
    $0021d6672f58c7eb$var$__getPasswordPolicy = /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$__getPasswordPolicy.apply(this, arguments);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
var $0021d6672f58c7eb$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ var $0021d6672f58c7eb$var$PasswordPolicyImpl = /*#__PURE__*/ function() {
    "use strict";
    function PasswordPolicyImpl(response) {
        (0, $978gY._)(this, PasswordPolicyImpl);
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        var responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $0021d6672f58c7eb$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    (0, $kry2a._)(PasswordPolicyImpl, [
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _a, _b, _c, _d, _e, _f;
                var status = {
                    isValid: true,
                    passwordPolicy: this
                };
                // Check the password length and character options.
                this.validatePasswordLengthOptions(password, status);
                this.validatePasswordCharacterOptions(password, status);
                // Combine the status into single isValid property.
                status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
                status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
                status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
                status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
                status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
                status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
                return status;
            }
        },
        {
            /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordLengthOptions",
            value: function validatePasswordLengthOptions(password, status) {
                var minPasswordLength = this.customStrengthOptions.minPasswordLength;
                var maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
                if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
                if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
            }
        },
        {
            /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ key: "validatePasswordCharacterOptions",
            value: function validatePasswordCharacterOptions(password, status) {
                // Assign statuses for requirements even if the password is an empty string.
                this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
                var passwordChar;
                for(var i = 0; i < password.length; i++){
                    passwordChar = password.charAt(i);
                    this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
                }
            }
        },
        {
            /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ key: "updatePasswordCharacterOptionsStatuses",
            value: function updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
                if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
                if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
                if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
                if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
            }
        }
    ]);
    return PasswordPolicyImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$export$23ebac1979863676 = /*#__PURE__*/ function() {
    "use strict";
    function AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config) {
        (0, $978gY._)(this, AuthImpl);
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $0021d6672f58c7eb$var$Subscription(this);
        this.idTokenSubscription = new $0021d6672f58c7eb$var$Subscription(this);
        this.beforeStateQueue = new $0021d6672f58c7eb$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $0021d6672f58c7eb$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    (0, $kry2a._)(AuthImpl, [
        {
            key: "_initializeWithPersistence",
            value: function _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
                if (popupRedirectResolver) this._popupRedirectResolver = $0021d6672f58c7eb$export$24baa2b76016ce0e(popupRedirectResolver);
                var _this = this;
                // Have to check for app deletion throughout initialization (after each
                // promise resolution)
                this._initializationPromise = this.queue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, _b, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$PersistenceUserManager.create(_this, persistenceHierarchy)
                                ];
                            case 1:
                                _this.persistenceManager = _state.sent();
                                if (_this._deleted) return [
                                    2
                                ];
                                if (!((_a = _this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively)) return [
                                    3,
                                    5
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._initialize(_this)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    4,
                                    _this.initializeCurrentUser(popupRedirectResolver)
                                ];
                            case 6:
                                _state.sent();
                                _this.lastNotifiedUid = ((_b = _this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
                                if (_this._deleted) return [
                                    2
                                ];
                                _this._isInitialized = true;
                                return [
                                    2
                                ];
                        }
                    });
                }));
                return this._initializationPromise;
            }
        },
        {
            key: "_onStorageEvent",
            value: /**
     * If the persistence is changed in another window, the user manager will let us know
     */ function _onStorageEvent() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var user;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                user = _state.sent();
                                if (!_this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
                                return [
                                    2
                                ];
                                if (!(_this.currentUser && user && _this.currentUser.uid === user.uid)) return [
                                    3,
                                    3
                                ];
                                // Data update, simply copy data changes.
                                _this._currentUser._assign(user);
                                // If tokens changed from previous user tokens, this will trigger
                                // notifyAuthListeners_.
                                return [
                                    4,
                                    _this.currentUser.getIdToken()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 3:
                                // Update current Auth state. Either a new login or logout.
                                // Skip blocking callbacks, they should not apply to a change in another tab.
                                return [
                                    4,
                                    _this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeCurrentUser",
            value: function initializeCurrentUser(popupRedirectResolver) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, previouslyStoredUser, futureCurrentUser, needsTocheckMiddleware, redirectUserEventId, storedUserEventId, result, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assertedPersistence.getCurrentUser()
                                ];
                            case 1:
                                previouslyStoredUser = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                needsTocheckMiddleware = false;
                                if (!(popupRedirectResolver && _this.config.authDomain)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 2:
                                _state.sent();
                                redirectUserEventId = (_a = _this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
                                storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
                                return [
                                    4,
                                    _this.tryRedirectSignIn(popupRedirectResolver)
                                ];
                            case 3:
                                result = _state.sent();
                                // If the stored user (i.e. the old "currentUser") has a redirectId that
                                // matches the redirect user, then we want to initially sign in with the
                                // new user object from result.
                                // TODO(samgho): More thoroughly test all of this
                                if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                                    futureCurrentUser = result.user;
                                    needsTocheckMiddleware = true;
                                }
                                _state.label = 4;
                            case 4:
                                // If no user in persistence, there is no current user. Set to null.
                                if (!futureCurrentUser) return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                if (!!futureCurrentUser._redirectEventId) return [
                                    3,
                                    9
                                ];
                                if (!needsTocheckMiddleware) return [
                                    3,
                                    8
                                ];
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(futureCurrentUser)
                                ];
                            case 6:
                                _state.sent();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                futureCurrentUser = previouslyStoredUser;
                                // We know this is available since the bit is only set when the
                                // resolver is available
                                _this._popupRedirectResolver._overrideRedirectResult(_this, function() {
                                    return Promise.reject(e);
                                });
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                if (futureCurrentUser) return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                                else return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                _state.label = 9;
                            case 9:
                                $0021d6672f58c7eb$export$9d398bebfec1c039(_this._popupRedirectResolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager()
                                ];
                            case 10:
                                _state.sent();
                                // If the redirect user's event ID matches the current user's event ID,
                                // DO NOT reload the current user, otherwise they'll be cleared from storage.
                                // This is important for the reauthenticateWithRedirect() flow.
                                if (_this.redirectUser && _this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return [
                                    2,
                                    _this.directlySetCurrentUser(futureCurrentUser)
                                ];
                                return [
                                    2,
                                    _this.reloadAndSetCurrentUserOrClear(futureCurrentUser)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "tryRedirectSignIn",
            value: function tryRedirectSignIn(redirectResolver) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var result, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                result = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    _this._popupRedirectResolver._completeRedirectFn(_this, redirectResolver, true)
                                ];
                            case 2:
                                // We know this._popupRedirectResolver is set since redirectResolver
                                // is passed in. The _completeRedirectFn expects the unwrapped extern.
                                result = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                e = _state.sent();
                                // Swallow any errors here; the code can retrieve them in
                                // getRedirectResult().
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "reloadAndSetCurrentUserOrClear",
            value: function reloadAndSetCurrentUserOrClear(user) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_reloadWithoutSaving(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                if ((e === null || e === void 0 ? void 0 : e.code) !== "auth/network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ) // Something's wrong with the user's token. Log them out and remove
                                // them from storage
                                return [
                                    2,
                                    _this.directlySetCurrentUser(null)
                                ];
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2,
                                    _this.directlySetCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "useDeviceLanguage",
            value: function useDeviceLanguage() {
                this.languageCode = $0021d6672f58c7eb$var$_getUserLanguage();
            }
        },
        {
            key: "_delete",
            value: function _delete() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this._deleted = true;
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "updateCurrentUser",
            value: function updateCurrentUser(userExtern) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var user;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        user = userExtern ? (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(userExtern) : null;
                        if (user) $0021d6672f58c7eb$export$9d398bebfec1c039(user.auth.config.apiKey === _this.config.apiKey, _this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
                        return [
                            2,
                            _this._updateCurrentUser(user && user._clone(_this))
                        ];
                    });
                })();
            }
        },
        {
            key: "_updateCurrentUser",
            value: function _updateCurrentUser(user) {
                var skipBeforeStateCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this._deleted) return [
                                    2
                                ];
                                if (user) $0021d6672f58c7eb$export$9d398bebfec1c039(_this.tenantId === user.tenantId, _this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
                                if (!!skipBeforeStateCallbacks) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(user)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    _this.queue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        _this.directlySetCurrentUser(user)
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _this.notifyAuthListeners();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }))
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signOut",
            value: function signOut() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Run first, to block _setRedirectUser() if any callbacks fail.
                                return [
                                    4,
                                    _this.beforeStateQueue.runMiddleware(null)
                                ];
                            case 1:
                                _state.sent();
                                if (!(_this.redirectPersistenceManager || _this._popupRedirectResolver)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this._setRedirectUser(null)
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                // Prevent callbacks from being called again in _updateCurrentUser, as
                                // they were already called in the first line.
                                return [
                                    2,
                                    _this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "setPersistence",
            value: function setPersistence(persistence) {
                var _this = this;
                return this.queue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.assertedPersistence.setPersistence($0021d6672f58c7eb$export$24baa2b76016ce0e(persistence))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        },
        {
            key: "_getRecaptchaConfig",
            value: function _getRecaptchaConfig() {
                if (this.tenantId == null) return this._agentRecaptchaConfig;
                else return this._tenantRecaptchaConfigs[this.tenantId];
            }
        },
        {
            key: "validatePassword",
            value: function validatePassword(password) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var passwordPolicy;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this._getPasswordPolicyInternal()) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._updatePasswordPolicy()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                passwordPolicy = _this._getPasswordPolicyInternal();
                                // Check that the policy schema version is supported by the SDK.
                                // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
                                if (passwordPolicy.schemaVersion !== _this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return [
                                    2,
                                    Promise.reject(_this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}))
                                ];
                                return [
                                    2,
                                    passwordPolicy.validatePassword(password)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPasswordPolicyInternal",
            value: function _getPasswordPolicyInternal() {
                if (this.tenantId === null) return this._projectPasswordPolicy;
                else return this._tenantPasswordPolicies[this.tenantId];
            }
        },
        {
            key: "_updatePasswordPolicy",
            value: function _updatePasswordPolicy() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var response, passwordPolicy;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_getPasswordPolicy(_this)
                                ];
                            case 1:
                                response = _state.sent();
                                passwordPolicy = new $0021d6672f58c7eb$var$PasswordPolicyImpl(response);
                                if (_this.tenantId === null) _this._projectPasswordPolicy = passwordPolicy;
                                else _this._tenantPasswordPolicies[_this.tenantId] = passwordPolicy;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getPersistence",
            value: function _getPersistence() {
                return this.assertedPersistence.persistence.type;
            }
        },
        {
            key: "_updateErrorMap",
            value: function _updateErrorMap(errorMap) {
                this._errorFactory = new (0, $b1467a785fc7cec5$export$3fa6e1b18a3b2d40)("auth", "Firebase", errorMap());
            }
        },
        {
            key: "onAuthStateChanged",
            value: function onAuthStateChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "beforeAuthStateChanged",
            value: function beforeAuthStateChanged(callback, onAbort) {
                return this.beforeStateQueue.pushCallback(callback, onAbort);
            }
        },
        {
            key: "onIdTokenChanged",
            value: function onIdTokenChanged(nextOrObserver, error, completed) {
                return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
            }
        },
        {
            key: "authStateReady",
            value: function authStateReady() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (_this.currentUser) resolve();
                    else {
                        var unsubscribe = _this.onAuthStateChanged(function() {
                            unsubscribe();
                            resolve();
                        }, reject);
                    }
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var _a;
                return {
                    apiKey: this.config.apiKey,
                    authDomain: this.config.authDomain,
                    appName: this.name,
                    currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
                };
            }
        },
        {
            key: "_setRedirectUser",
            value: function _setRedirectUser(user, popupRedirectResolver) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var redirectManager;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getOrInitRedirectPersistenceManager(popupRedirectResolver)
                                ];
                            case 1:
                                redirectManager = _state.sent();
                                return [
                                    2,
                                    user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getOrInitRedirectPersistenceManager",
            value: function getOrInitRedirectPersistenceManager(popupRedirectResolver) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var resolver;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!!_this.redirectPersistenceManager) return [
                                    3,
                                    3
                                ];
                                resolver = popupRedirectResolver && $0021d6672f58c7eb$export$24baa2b76016ce0e(popupRedirectResolver) || _this._popupRedirectResolver;
                                $0021d6672f58c7eb$export$9d398bebfec1c039(resolver, _this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$PersistenceUserManager.create(_this, [
                                        $0021d6672f58c7eb$export$24baa2b76016ce0e(resolver._redirectPersistence)
                                    ], "redirectUser" /* KeyName.REDIRECT_USER */ )
                                ];
                            case 1:
                                _this.redirectPersistenceManager = _state.sent();
                                return [
                                    4,
                                    _this.redirectPersistenceManager.getCurrentUser()
                                ];
                            case 2:
                                _this.redirectUser = _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    _this.redirectPersistenceManager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_redirectUserForId",
            value: function _redirectUserForId(id) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, _b;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._isInitialized) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.queue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            return [
                                                2
                                            ];
                                        });
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (((_a = _this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return [
                                    2,
                                    _this._currentUser
                                ];
                                if (((_b = _this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return [
                                    2,
                                    _this.redirectUser
                                ];
                                return [
                                    2,
                                    null
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_persistUserIfCurrent",
            value: function _persistUserIfCurrent(user) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (user === _this.currentUser) return [
                            2,
                            _this.queue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        _this.directlySetCurrentUser(user)
                                    ];
                                });
                            }))
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** Notifies listeners only if the user is current */ key: "_notifyListenersIfCurrent",
            value: function _notifyListenersIfCurrent(user) {
                if (user === this.currentUser) this.notifyAuthListeners();
            }
        },
        {
            key: "_key",
            value: function _key() {
                return "".concat(this.config.authDomain, ":").concat(this.config.apiKey, ":").concat(this.name);
            }
        },
        {
            key: "_startProactiveRefresh",
            value: function _startProactiveRefresh() {
                this.isProactiveRefreshEnabled = true;
                if (this.currentUser) this._currentUser._startProactiveRefresh();
            }
        },
        {
            key: "_stopProactiveRefresh",
            value: function _stopProactiveRefresh() {
                this.isProactiveRefreshEnabled = false;
                if (this.currentUser) this._currentUser._stopProactiveRefresh();
            }
        },
        {
            key: "_currentUser",
            get: /** Returns the current user cast as the internal type */ function get() {
                return this.currentUser;
            }
        },
        {
            key: "notifyAuthListeners",
            value: function notifyAuthListeners() {
                var _a, _b;
                if (!this._isInitialized) return;
                this.idTokenSubscription.next(this.currentUser);
                var currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
                if (this.lastNotifiedUid !== currentUid) {
                    this.lastNotifiedUid = currentUid;
                    this.authStateSubscription.next(this.currentUser);
                }
            }
        },
        {
            key: "registerStateListener",
            value: function registerStateListener(subscription, nextOrObserver, error, completed) {
                var _this = this;
                if (this._deleted) return function() {};
                var cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
                var isUnsubscribed = false;
                var promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
                $0021d6672f58c7eb$export$9d398bebfec1c039(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                // The callback needs to be called asynchronously per the spec.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                promise.then(function() {
                    if (isUnsubscribed) return;
                    cb(_this.currentUser);
                });
                if (typeof nextOrObserver === "function") {
                    var unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe();
                    };
                } else {
                    var unsubscribe1 = subscription.addObserver(nextOrObserver);
                    return function() {
                        isUnsubscribed = true;
                        unsubscribe1();
                    };
                }
            }
        },
        {
            key: "directlySetCurrentUser",
            value: /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ function directlySetCurrentUser(user) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.currentUser && _this.currentUser !== user) _this._currentUser._stopProactiveRefresh();
                                if (user && _this.isProactiveRefreshEnabled) user._startProactiveRefresh();
                                _this.currentUser = user;
                                if (!user) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.assertedPersistence.setCurrentUser(user)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 2:
                                return [
                                    4,
                                    _this.assertedPersistence.removeCurrentUser()
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "queue",
            value: function queue(action) {
                // In case something errors, the callback still should be called in order
                // to keep the promise chain alive
                this.operations = this.operations.then(action, action);
                return this.operations;
            }
        },
        {
            key: "assertedPersistence",
            get: function get() {
                $0021d6672f58c7eb$export$9d398bebfec1c039(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.persistenceManager;
            }
        },
        {
            key: "_logFramework",
            value: function _logFramework(framework) {
                if (!framework || this.frameworks.includes(framework)) return;
                this.frameworks.push(framework);
                // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
                // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
                this.frameworks.sort();
                this.clientVersion = $0021d6672f58c7eb$export$91477dc880baac21(this.config.clientPlatform, this._getFrameworks());
            }
        },
        {
            key: "_getFrameworks",
            value: function _getFrameworks() {
                return this.frameworks;
            }
        },
        {
            key: "_getAdditionalHeaders",
            value: function _getAdditionalHeaders() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, headers, heartbeatsHeader, appCheckToken;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                headers = (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, "X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ , _this.clientVersion);
                                if (_this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = _this.app.options.appId;
                                return [
                                    4,
                                    (_a = _this.heartbeatServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader()
                                ];
                            case 1:
                                heartbeatsHeader = _state.sent();
                                if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
                                return [
                                    4,
                                    _this._getAppCheckToken()
                                ];
                            case 2:
                                appCheckToken = _state.sent();
                                if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
                                return [
                                    2,
                                    headers
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_getAppCheckToken",
            value: function _getAppCheckToken() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, appCheckTokenResult;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (_a = _this.appCheckServiceProvider.getImmediate({
                                        optional: true
                                    })) === null || _a === void 0 ? void 0 : _a.getToken()
                                ];
                            case 1:
                                appCheckTokenResult = _state.sent();
                                if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
                                // In the error case, a dummy token will be returned along with an error field describing
                                // the error. In general, we shouldn't care about the error condition and just use
                                // the token (actual or dummy) to send requests.
                                $0021d6672f58c7eb$var$_logWarn("Error while retrieving App Check token: ".concat(appCheckTokenResult.error));
                                return [
                                    2,
                                    appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return AuthImpl;
}();
/**
 * Method to be used to cast down to our private implmentation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $0021d6672f58c7eb$export$b9a6b53f9be3734(auth) {
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ var $0021d6672f58c7eb$var$Subscription = /*#__PURE__*/ function() {
    "use strict";
    function Subscription(auth) {
        var _this = this;
        (0, $978gY._)(this, Subscription);
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $b1467a785fc7cec5$export$364097d812234b3f)(function(observer) {
            return _this.observer = observer;
        });
    }
    (0, $kry2a._)(Subscription, [
        {
            key: "next",
            get: function get() {
                $0021d6672f58c7eb$export$9d398bebfec1c039(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.observer.next.bind(this.observer);
            }
        }
    ]);
    return Subscription;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
function $0021d6672f58c7eb$var$_loadJS(url) {
    // TODO: consider adding timeout support & cancellation
    return new Promise(function(resolve, reject) {
        var el = document.createElement("script");
        el.setAttribute("src", url);
        el.onload = resolve;
        el.onerror = function(e) {
            var error = $0021d6672f58c7eb$export$91c6e00c14e7e6fd("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            error.customData = e;
            reject(error);
        };
        el.type = "text/javascript";
        el.charset = "UTF-8";
        $0021d6672f58c7eb$var$getScriptParentElement().appendChild(el);
    });
}
function $0021d6672f58c7eb$var$_generateCallbackName(prefix) {
    return "__".concat(prefix).concat(Math.floor(Math.random() * 1000000));
}
/* eslint-disable @typescript-eslint/no-require-imports */ var $0021d6672f58c7eb$var$RECAPTCHA_ENTERPRISE_URL = "https://www.google.com/recaptcha/enterprise.js?render=";
var $0021d6672f58c7eb$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
var $0021d6672f58c7eb$var$FAKE_TOKEN = "NO_RECAPTCHA";
var $0021d6672f58c7eb$var$RecaptchaEnterpriseVerifier = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaEnterpriseVerifier(authExtern) {
        (0, $978gY._)(this, RecaptchaEnterpriseVerifier);
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $0021d6672f58c7eb$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $0021d6672f58c7eb$export$b9a6b53f9be3734(authExtern);
    }
    (0, $kry2a._)(RecaptchaEnterpriseVerifier, [
        {
            key: "verify",
            value: /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ function verify() {
                var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "verify", forceRefresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    function retrieveSiteKey(auth) {
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function _retrieveSiteKey() {
                        _retrieveSiteKey = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                if (!forceRefresh) {
                                    if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return [
                                        2,
                                        auth._agentRecaptchaConfig.siteKey
                                    ];
                                    if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return [
                                        2,
                                        auth._tenantRecaptchaConfigs[auth.tenantId].siteKey
                                    ];
                                }
                                return [
                                    2,
                                    new Promise(function() {
                                        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(resolve, reject) {
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                $0021d6672f58c7eb$var$getRecaptchaConfig(auth, {
                                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                                                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                                                }).then(function(response) {
                                                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                                                    else {
                                                        var config = new $0021d6672f58c7eb$var$RecaptchaConfig(response);
                                                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                                                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                                                        return resolve(config.siteKey);
                                                    }
                                                }).catch(function(error) {
                                                    reject(error);
                                                });
                                                return [
                                                    2
                                                ];
                                            });
                                        });
                                        return function(resolve, reject) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            });
                        });
                        return _retrieveSiteKey.apply(this, arguments);
                    }
                    function retrieveRecaptchaToken(siteKey, resolve, reject) {
                        var grecaptcha = window.grecaptcha;
                        if ($0021d6672f58c7eb$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(function() {
                            grecaptcha.enterprise.execute(siteKey, {
                                action: action
                            }).then(function(token) {
                                resolve(token);
                            }).catch(function() {
                                resolve($0021d6672f58c7eb$var$FAKE_TOKEN);
                            });
                        });
                        else reject(Error("No reCAPTCHA enterprise script loaded."));
                    }
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                retrieveSiteKey(_this.auth).then(function(siteKey) {
                                    if (!forceRefresh && $0021d6672f58c7eb$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                                    else {
                                        if (typeof window === "undefined") {
                                            reject(new Error("RecaptchaVerifier is only supported in browser"));
                                            return;
                                        }
                                        $0021d6672f58c7eb$var$_loadJS($0021d6672f58c7eb$var$RECAPTCHA_ENTERPRISE_URL + siteKey).then(function() {
                                            retrieveRecaptchaToken(siteKey, resolve, reject);
                                        }).catch(function(error) {
                                            reject(error);
                                        });
                                    }
                                }).catch(function(error) {
                                    reject(error);
                                });
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return RecaptchaEnterpriseVerifier;
}();
function $0021d6672f58c7eb$var$injectRecaptchaFields(auth, request, action) {
    return $0021d6672f58c7eb$var$_injectRecaptchaFields.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_injectRecaptchaFields() {
    $0021d6672f58c7eb$var$_injectRecaptchaFields = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request, action) {
        var captchaResp, verifier, captchaResponse, error, newRequest;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    captchaResp = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : false;
                    verifier = new $0021d6672f58c7eb$var$RecaptchaEnterpriseVerifier(auth);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        verifier.verify(action)
                    ];
                case 2:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        4,
                        verifier.verify(action, true)
                    ];
                case 4:
                    captchaResponse = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    newRequest = Object.assign({}, request);
                    if (!captchaResp) Object.assign(newRequest, {
                        captchaResponse: captchaResponse
                    });
                    else Object.assign(newRequest, {
                        "captchaResp": captchaResponse
                    });
                    Object.assign(newRequest, {
                        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    });
                    Object.assign(newRequest, {
                        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                    });
                    return [
                        2,
                        newRequest
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_injectRecaptchaFields.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_initializeRecaptchaConfig(auth) {
    return $0021d6672f58c7eb$var$__initializeRecaptchaConfig.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__initializeRecaptchaConfig() {
    $0021d6672f58c7eb$var$__initializeRecaptchaConfig = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        var authInternal, response, config, verifier;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        $0021d6672f58c7eb$var$getRecaptchaConfig(authInternal, {
                            clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                            version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                        })
                    ];
                case 1:
                    response = _state.sent();
                    config = new $0021d6672f58c7eb$var$RecaptchaConfig(response);
                    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
                    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
                    if (config.emailPasswordEnabled) {
                        verifier = new $0021d6672f58c7eb$var$RecaptchaEnterpriseVerifier(authInternal);
                        verifier.verify();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__initializeRecaptchaConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $0021d6672f58c7eb$export$9bb611d729802a56(app, deps) {
    var provider = (0, $2b7c3095396a3894$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) {
        var auth = provider.getImmediate();
        var initialOptions = provider.getOptions();
        if ((0, $b1467a785fc7cec5$export$9cb4719e2e525b7a)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $0021d6672f58c7eb$export$92108d983e8ee699(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    var auth1 = provider.initialize({
        options: deps
    });
    return auth1;
}
function $0021d6672f58c7eb$var$_initializeAuthInstance(auth, deps) {
    var persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    var hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($0021d6672f58c7eb$export$24baa2b76016ce0e);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $0021d6672f58c7eb$export$b4171a6734a65d42(auth, url, options) {
    var authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
    $0021d6672f58c7eb$export$9d398bebfec1c039(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $0021d6672f58c7eb$export$9d398bebfec1c039(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    var disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    var protocol = $0021d6672f58c7eb$var$extractProtocol(url);
    var _extractHostAndPort = $0021d6672f58c7eb$var$extractHostAndPort(url), host = _extractHostAndPort.host, port = _extractHostAndPort.port;
    var portStr = port === null ? "" : ":".concat(port);
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: "".concat(protocol, "//").concat(host).concat(portStr, "/")
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $0021d6672f58c7eb$var$emitEmulatorWarning();
}
function $0021d6672f58c7eb$var$extractProtocol(url) {
    var protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $0021d6672f58c7eb$var$extractHostAndPort(url) {
    var protocol = $0021d6672f58c7eb$var$extractProtocol(url);
    var authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    var hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    var bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        var host = bracketedIPv6[1];
        return {
            host: host,
            port: $0021d6672f58c7eb$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        var _hostAndPort_split = (0, $8GFUW._)(hostAndPort.split(":"), 2), host1 = _hostAndPort_split[0], port = _hostAndPort_split[1];
        return {
            host: host1,
            port: $0021d6672f58c7eb$var$parsePort(port)
        };
    }
}
function $0021d6672f58c7eb$var$parsePort(portStr) {
    if (!portStr) return null;
    var port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $0021d6672f58c7eb$var$emitEmulatorWarning() {
    var attachBanner = function attachBanner() {
        var el = document.createElement("p");
        var sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    };
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $0021d6672f58c7eb$export$3466f893ebf79586 = /*#__PURE__*/ function() {
    "use strict";
    function AuthCredential(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod) {
        (0, $978gY._)(this, AuthCredential);
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    (0, $kry2a._)(AuthCredential, [
        {
            /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ key: "toJSON",
            value: function toJSON() {
                return $0021d6672f58c7eb$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(_auth) {
                return $0021d6672f58c7eb$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(_auth, _idToken) {
                return $0021d6672f58c7eb$var$debugFail("not implemented");
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(_auth) {
                return $0021d6672f58c7eb$var$debugFail("not implemented");
            }
        }
    ]);
    return AuthCredential;
}();
function $0021d6672f58c7eb$var$resetPassword(auth, request) {
    return $0021d6672f58c7eb$var$_resetPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_resetPassword() {
    $0021d6672f58c7eb$var$_resetPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_resetPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$updateEmailPassword(auth, request) {
    return $0021d6672f58c7eb$var$_updateEmailPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_updateEmailPassword() {
    $0021d6672f58c7eb$var$_updateEmailPassword = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_updateEmailPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$applyActionCode$1(auth, request) {
    return $0021d6672f58c7eb$var$_applyActionCode$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_applyActionCode$1() {
    $0021d6672f58c7eb$var$_applyActionCode$1 = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_applyActionCode$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$signInWithPassword(auth, request) {
    return $0021d6672f58c7eb$var$_signInWithPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithPassword() {
    $0021d6672f58c7eb$var$_signInWithPassword = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$sendOobCode(auth, request) {
    return $0021d6672f58c7eb$var$_sendOobCode.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendOobCode() {
    $0021d6672f58c7eb$var$_sendOobCode = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_sendOobCode.apply(this, arguments);
}
function $0021d6672f58c7eb$var$sendEmailVerification$1(auth, request) {
    return $0021d6672f58c7eb$var$_sendEmailVerification$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendEmailVerification$1() {
    $0021d6672f58c7eb$var$_sendEmailVerification$1 = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$sendOobCode(auth, request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_sendEmailVerification$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$sendPasswordResetEmail$1(auth, request) {
    return $0021d6672f58c7eb$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendPasswordResetEmail$1() {
    $0021d6672f58c7eb$var$_sendPasswordResetEmail$1 = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$sendOobCode(auth, request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_sendPasswordResetEmail$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$sendSignInLinkToEmail$1(auth, request) {
    return $0021d6672f58c7eb$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendSignInLinkToEmail$1() {
    $0021d6672f58c7eb$var$_sendSignInLinkToEmail$1 = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$sendOobCode(auth, request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_sendSignInLinkToEmail$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$verifyAndChangeEmail(auth, request) {
    return $0021d6672f58c7eb$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_verifyAndChangeEmail() {
    $0021d6672f58c7eb$var$_verifyAndChangeEmail = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$sendOobCode(auth, request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_verifyAndChangeEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$var$signInWithEmailLink$1(auth, request) {
    return $0021d6672f58c7eb$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithEmailLink$1() {
    $0021d6672f58c7eb$var$_signInWithEmailLink$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithEmailLink$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$signInWithEmailLinkForLinking(auth, request) {
    return $0021d6672f58c7eb$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithEmailLinkForLinking() {
    $0021d6672f58c7eb$var$_signInWithEmailLinkForLinking = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithEmailLinkForLinking.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ var $0021d6672f58c7eb$export$61196ced6d74a310 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $ftJVG._)(EmailAuthCredential, AuthCredential);
    var _super = (0, $6OZAO._)(EmailAuthCredential);
    function EmailAuthCredential(/** @internal */ _email, /** @internal */ _password, signInMethod) {
        var /** @internal */ _tenantId = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        (0, $978gY._)(this, EmailAuthCredential);
        var _this;
        _this = _super.call(this, "password" /* ProviderId.PASSWORD */ , signInMethod);
        _this._email = _email;
        _this._password = _password;
        _this._tenantId = _tenantId;
        return _this;
    }
    (0, $kry2a._)(EmailAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                return {
                    email: this._email,
                    password: this._password,
                    signInMethod: this.signInMethod,
                    tenantId: this._tenantId
                };
            }
        },
        {
            key: "_getIdTokenResponse",
            value: /** @internal */ function _getIdTokenResponse(auth) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, _, request, requestWithRecaptcha;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = _this.signInMethod;
                                switch(_){
                                    case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                        return [
                                            3,
                                            1
                                        ];
                                    case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                        return [
                                            3,
                                            4
                                        ];
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 1:
                                request = {
                                    returnSecureToken: true,
                                    email: _this._email,
                                    password: _this._password,
                                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                                };
                                if (!((_a = auth._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ )
                                ];
                            case 2:
                                requestWithRecaptcha = _state.sent();
                                return [
                                    2,
                                    $0021d6672f58c7eb$var$signInWithPassword(auth, requestWithRecaptcha)
                                ];
                            case 3:
                                return [
                                    2,
                                    $0021d6672f58c7eb$var$signInWithPassword(auth, request).catch(function() {
                                        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(error) {
                                            var requestWithRecaptcha;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                            3,
                                                            2
                                                        ];
                                                        console.log("Sign-in with email address and password is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                                                        return [
                                                            4,
                                                            $0021d6672f58c7eb$var$injectRecaptchaFields(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ )
                                                        ];
                                                    case 1:
                                                        requestWithRecaptcha = _state.sent();
                                                        return [
                                                            2,
                                                            $0021d6672f58c7eb$var$signInWithPassword(auth, requestWithRecaptcha)
                                                        ];
                                                    case 2:
                                                        return [
                                                            2,
                                                            Promise.reject(error)
                                                        ];
                                                    case 3:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(error) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 4:
                                return [
                                    2,
                                    $0021d6672f58c7eb$var$signInWithEmailLink$1(auth, {
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            case 5:
                                $0021d6672f58c7eb$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                _state.label = 6;
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_linkToIdToken",
            value: /** @internal */ function _linkToIdToken(auth, idToken) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_this.signInMethod){
                            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                                return [
                                    2,
                                    $0021d6672f58c7eb$var$updateEmailPassword(auth, {
                                        idToken: idToken,
                                        returnSecureToken: true,
                                        email: _this._email,
                                        password: _this._password
                                    })
                                ];
                            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                                return [
                                    2,
                                    $0021d6672f58c7eb$var$signInWithEmailLinkForLinking(auth, {
                                        idToken: idToken,
                                        email: _this._email,
                                        oobCode: _this._password
                                    })
                                ];
                            default:
                                $0021d6672f58c7eb$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return this._getIdTokenResponse(auth);
            }
        }
    ], [
        {
            key: "_fromEmailAndPassword",
            value: /** @internal */ function _fromEmailAndPassword(email, password) {
                return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
            }
        },
        {
            key: "_fromEmailAndCode",
            value: /** @internal */ function _fromEmailAndCode(email, oobCode) {
                var tenantId = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
                return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
                    if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
                    else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
                }
                return null;
            }
        }
    ]);
    return EmailAuthCredential;
}($0021d6672f58c7eb$export$3466f893ebf79586);
function $0021d6672f58c7eb$var$signInWithIdp(auth, request) {
    return $0021d6672f58c7eb$var$_signInWithIdp.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithIdp() {
    $0021d6672f58c7eb$var$_signInWithIdp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithIdp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ var $0021d6672f58c7eb$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $ftJVG._)(OAuthCredential, AuthCredential);
    var _super = (0, $6OZAO._)(OAuthCredential);
    function OAuthCredential() {
        (0, $978gY._)(this, OAuthCredential);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        _this.pendingToken = null;
        return _this;
    }
    (0, $kry2a._)(OAuthCredential, [
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    idToken: this.idToken,
                    accessToken: this.accessToken,
                    secret: this.secret,
                    nonce: this.nonce,
                    pendingToken: this.pendingToken,
                    providerId: this.providerId,
                    signInMethod: this.signInMethod
                };
            }
        },
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $0021d6672f58c7eb$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $0021d6672f58c7eb$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $0021d6672f58c7eb$var$signInWithIdp(auth, request);
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                var request = {
                    requestUri: $0021d6672f58c7eb$var$IDP_REQUEST_URI$1,
                    returnSecureToken: true
                };
                if (this.pendingToken) request.pendingToken = this.pendingToken;
                else {
                    var postBody = {};
                    if (this.idToken) postBody["id_token"] = this.idToken;
                    if (this.accessToken) postBody["access_token"] = this.accessToken;
                    if (this.secret) postBody["oauth_token_secret"] = this.secret;
                    postBody["providerId"] = this.providerId;
                    if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
                    request.postBody = (0, $b1467a785fc7cec5$export$ac4103b836844853)(postBody);
                }
                return request;
            }
        }
    ], [
        {
            key: "_fromParams",
            value: /** @internal */ function _fromParams(params) {
                var cred = new OAuthCredential(params.providerId, params.signInMethod);
                if (params.idToken || params.accessToken) {
                    // OAuth 2 and either ID token or access token.
                    if (params.idToken) cred.idToken = params.idToken;
                    if (params.accessToken) cred.accessToken = params.accessToken;
                    // Add nonce if available and no pendingToken is present.
                    if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
                    if (params.pendingToken) cred.pendingToken = params.pendingToken;
                } else if (params.oauthToken && params.oauthTokenSecret) {
                    // OAuth 1 and OAuth token with token secret
                    cred.accessToken = params.oauthToken;
                    cred.secret = params.oauthTokenSecret;
                } else $0021d6672f58c7eb$export$92108d983e8ee699("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return cred;
            }
        },
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, rest = (0, $7UAGh.__rest)(obj, [
                    "providerId",
                    "signInMethod"
                ]);
                if (!providerId || !signInMethod) return null;
                var cred = new OAuthCredential(providerId, signInMethod);
                cred.idToken = rest.idToken || undefined;
                cred.accessToken = rest.accessToken || undefined;
                cred.secret = rest.secret;
                cred.nonce = rest.nonce;
                cred.pendingToken = rest.pendingToken || null;
                return cred;
            }
        }
    ]);
    return OAuthCredential;
}($0021d6672f58c7eb$export$3466f893ebf79586);
function $0021d6672f58c7eb$var$sendPhoneVerificationCode(auth, request) {
    return $0021d6672f58c7eb$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendPhoneVerificationCode() {
    $0021d6672f58c7eb$var$_sendPhoneVerificationCode = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_sendPhoneVerificationCode.apply(this, arguments);
}
function $0021d6672f58c7eb$var$signInWithPhoneNumber$1(auth, request) {
    return $0021d6672f58c7eb$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithPhoneNumber$1() {
    $0021d6672f58c7eb$var$_signInWithPhoneNumber$1 = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithPhoneNumber$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$linkWithPhoneNumber$1(auth, request) {
    return $0021d6672f58c7eb$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_linkWithPhoneNumber$1() {
    $0021d6672f58c7eb$var$_linkWithPhoneNumber$1 = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        var response;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.temporaryProof) throw $0021d6672f58c7eb$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_linkWithPhoneNumber$1.apply(this, arguments);
}
var $0021d6672f58c7eb$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, "USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ , "user-not-found" /* AuthErrorCode.USER_DELETED */ );
function $0021d6672f58c7eb$var$verifyPhoneNumberForExisting(auth, request) {
    return $0021d6672f58c7eb$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_verifyPhoneNumberForExisting() {
    $0021d6672f58c7eb$var$_verifyPhoneNumberForExisting = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        var apiRequest;
        return (0, $7UAGh.__generator)(this, function(_state) {
            apiRequest = Object.assign(Object.assign({}, request), {
                operation: "REAUTH"
            });
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, apiRequest), $0021d6672f58c7eb$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_verifyPhoneNumberForExisting.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ var $0021d6672f58c7eb$export$a07804094c3ecf2d = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $ftJVG._)(PhoneAuthCredential, AuthCredential);
    var _super = (0, $6OZAO._)(PhoneAuthCredential);
    function PhoneAuthCredential(params) {
        (0, $978gY._)(this, PhoneAuthCredential);
        var _this;
        _this = _super.call(this, "phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        _this.params = params;
        return _this;
    }
    (0, $kry2a._)(PhoneAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $0021d6672f58c7eb$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $0021d6672f58c7eb$var$linkWithPhoneNumber$1(auth, Object.assign({
                    idToken: idToken
                }, this._makeVerificationRequest()));
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $0021d6672f58c7eb$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
            }
        },
        {
            /** @internal */ key: "_makeVerificationRequest",
            value: function _makeVerificationRequest() {
                var _this_params = this.params, temporaryProof = _this_params.temporaryProof, phoneNumber = _this_params.phoneNumber, verificationId = _this_params.verificationId, verificationCode = _this_params.verificationCode;
                if (temporaryProof && phoneNumber) return {
                    temporaryProof: temporaryProof,
                    phoneNumber: phoneNumber
                };
                return {
                    sessionInfo: verificationId,
                    code: verificationCode
                };
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON} */ key: "toJSON",
            value: function toJSON() {
                var obj = {
                    providerId: this.providerId
                };
                if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
                if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
                if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
                if (this.params.verificationId) obj.verificationId = this.params.verificationId;
                return obj;
            }
        }
    ], [
        {
            key: "_fromVerification",
            value: /** @internal */ function _fromVerification(verificationId, verificationCode) {
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode
                });
            }
        },
        {
            key: "_fromTokenResponse",
            value: /** @internal */ function _fromTokenResponse(phoneNumber, temporaryProof) {
                return new PhoneAuthCredential({
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        },
        {
            key: "fromJSON",
            value: /** Generates a phone credential based on a plain object or a JSON string. */ function fromJSON(json) {
                if (typeof json === "string") json = JSON.parse(json);
                var verificationId = json.verificationId, verificationCode = json.verificationCode, phoneNumber = json.phoneNumber, temporaryProof = json.temporaryProof;
                if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
                return new PhoneAuthCredential({
                    verificationId: verificationId,
                    verificationCode: verificationCode,
                    phoneNumber: phoneNumber,
                    temporaryProof: temporaryProof
                });
            }
        }
    ]);
    return PhoneAuthCredential;
}($0021d6672f58c7eb$export$3466f893ebf79586);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $0021d6672f58c7eb$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $0021d6672f58c7eb$var$parseDeepLink(url) {
    var link = (0, $b1467a785fc7cec5$export$c1271ca4c8a70741)((0, $b1467a785fc7cec5$export$1a8408415472d8ed)(url))["link"];
    // Double link case (automatic redirect).
    var doubleDeepLink = link ? (0, $b1467a785fc7cec5$export$c1271ca4c8a70741)((0, $b1467a785fc7cec5$export$1a8408415472d8ed)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    var iOSDeepLink = (0, $b1467a785fc7cec5$export$c1271ca4c8a70741)((0, $b1467a785fc7cec5$export$1a8408415472d8ed)(url))["deep_link_id"];
    var iOSDoubleDeepLink = iOSDeepLink ? (0, $b1467a785fc7cec5$export$c1271ca4c8a70741)((0, $b1467a785fc7cec5$export$1a8408415472d8ed)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ var $0021d6672f58c7eb$export$995eb9fca571757 = /*#__PURE__*/ function() {
    "use strict";
    function ActionCodeURL(actionLink) {
        (0, $978gY._)(this, ActionCodeURL);
        var _a, _b, _c, _d, _e, _f;
        var searchParams = (0, $b1467a785fc7cec5$export$c1271ca4c8a70741)((0, $b1467a785fc7cec5$export$1a8408415472d8ed)(actionLink));
        var apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        var code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        var operation = $0021d6672f58c7eb$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $0021d6672f58c7eb$export$9d398bebfec1c039(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    (0, $kry2a._)(ActionCodeURL, null, [
        {
            key: "parseLink",
            value: /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ function parseLink(link) {
                var actionLink = $0021d6672f58c7eb$var$parseDeepLink(link);
                try {
                    return new ActionCodeURL(actionLink);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return ActionCodeURL;
}();
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $0021d6672f58c7eb$export$f38c853ae54ed474(link) {
    return $0021d6672f58c7eb$export$995eb9fca571757.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ var $0021d6672f58c7eb$export$3a6d5c9ae78a2c08 = /*#__PURE__*/ function() {
    "use strict";
    function EmailAuthProvider() {
        (0, $978gY._)(this, EmailAuthProvider);
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    (0, $kry2a._)(EmailAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ function credential(email, password) {
                return $0021d6672f58c7eb$export$61196ced6d74a310._fromEmailAndPassword(email, password);
            }
        },
        {
            key: "credentialWithLink",
            value: /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ function credentialWithLink(email, emailLink) {
                var actionCodeUrl = $0021d6672f58c7eb$export$995eb9fca571757.parseLink(emailLink);
                $0021d6672f58c7eb$export$9d398bebfec1c039(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $0021d6672f58c7eb$export$61196ced6d74a310._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
            }
        }
    ]);
    return EmailAuthProvider;
}();
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $0021d6672f58c7eb$export$3a6d5c9ae78a2c08.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $0021d6672f58c7eb$export$3a6d5c9ae78a2c08.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $0021d6672f58c7eb$export$3a6d5c9ae78a2c08.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ var $0021d6672f58c7eb$var$FederatedAuthProvider = /*#__PURE__*/ function() {
    "use strict";
    function FederatedAuthProvider(providerId) {
        (0, $978gY._)(this, FederatedAuthProvider);
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    (0, $kry2a._)(FederatedAuthProvider, [
        {
            /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ key: "setDefaultLanguage",
            value: function setDefaultLanguage(languageCode) {
                this.defaultLanguageCode = languageCode;
            }
        },
        {
            /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ key: "setCustomParameters",
            value: function setCustomParameters(customOAuthParameters) {
                this.customParameters = customOAuthParameters;
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of {@link CustomParameters}.
     */ key: "getCustomParameters",
            value: function getCustomParameters() {
                return this.customParameters;
            }
        }
    ]);
    return FederatedAuthProvider;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ var $0021d6672f58c7eb$var$BaseOAuthProvider = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $ftJVG._)(BaseOAuthProvider, FederatedAuthProvider);
    var _super = (0, $6OZAO._)(BaseOAuthProvider);
    function BaseOAuthProvider() {
        (0, $978gY._)(this, BaseOAuthProvider);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments)));
        /** @internal */ _this.scopes = [];
        return _this;
    }
    (0, $kry2a._)(BaseOAuthProvider, [
        {
            /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ key: "addScope",
            value: function addScope(scope) {
                // If not already added, add scope to list.
                if (!this.scopes.includes(scope)) this.scopes.push(scope);
                return this;
            }
        },
        {
            /**
     * Retrieve the current list of OAuth scopes.
     */ key: "getScopes",
            value: function getScopes() {
                return (0, $fLnyw._)(this.scopes);
            }
        }
    ]);
    return BaseOAuthProvider;
}($0021d6672f58c7eb$var$FederatedAuthProvider);
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $0021d6672f58c7eb$export$8743009a87fcb00f = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $ftJVG._)(OAuthProvider, BaseOAuthProvider);
    var _super = (0, $6OZAO._)(OAuthProvider);
    function OAuthProvider() {
        (0, $978gY._)(this, OAuthProvider);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(OAuthProvider, [
        {
            /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ key: "credential",
            value: function credential(params) {
                return this._credential(Object.assign(Object.assign({}, params), {
                    nonce: params.rawNonce
                }));
            }
        },
        {
            /** An internal credential method that accepts more permissive options */ key: "_credential",
            value: function _credential(params) {
                $0021d6672f58c7eb$export$9d398bebfec1c039(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                // For OAuthCredential, sign in method is same as providerId.
                return $0021d6672f58c7eb$export$3a1a48c8f6ef640e._fromParams(Object.assign(Object.assign({}, params), {
                    providerId: this.providerId,
                    signInMethod: this.providerId
                }));
            }
        }
    ], [
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                $0021d6672f58c7eb$export$9d398bebfec1c039("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return $0021d6672f58c7eb$export$3a1a48c8f6ef640e._fromParams(obj);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "oauthCredentialFromTaggedObject",
            value: function oauthCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret, pendingToken = tokenResponse.pendingToken, nonce = tokenResponse.nonce, providerId = tokenResponse.providerId;
                if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
                if (!providerId) return null;
                try {
                    return new OAuthProvider(providerId)._credential({
                        idToken: oauthIdToken,
                        accessToken: oauthAccessToken,
                        nonce: nonce,
                        pendingToken: pendingToken
                    });
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return OAuthProvider;
}($0021d6672f58c7eb$var$BaseOAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $0021d6672f58c7eb$export$e7c866399fa523f5 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $ftJVG._)(FacebookAuthProvider, BaseOAuthProvider);
    var _super = (0, $6OZAO._)(FacebookAuthProvider);
    function FacebookAuthProvider() {
        (0, $978gY._)(this, FacebookAuthProvider);
        return _super.call(this, "facebook.com" /* ProviderId.FACEBOOK */ );
    }
    (0, $kry2a._)(FacebookAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ function credential(accessToken) {
                return $0021d6672f58c7eb$export$3a1a48c8f6ef640e._fromParams({
                    providerId: FacebookAuthProvider.PROVIDER_ID,
                    signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return FacebookAuthProvider;
}($0021d6672f58c7eb$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.FACEBOOK. */ $0021d6672f58c7eb$export$e7c866399fa523f5.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $0021d6672f58c7eb$export$e7c866399fa523f5.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ var $0021d6672f58c7eb$export$71cec2538cb2c617 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $ftJVG._)(GoogleAuthProvider, BaseOAuthProvider);
    var _super = (0, $6OZAO._)(GoogleAuthProvider);
    function GoogleAuthProvider() {
        (0, $978gY._)(this, GoogleAuthProvider);
        var _this;
        _this = _super.call(this, "google.com" /* ProviderId.GOOGLE */ );
        _this.addScope("profile");
        return _this;
    }
    (0, $kry2a._)(GoogleAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ function credential(idToken, accessToken) {
                return $0021d6672f58c7eb$export$3a1a48c8f6ef640e._fromParams({
                    providerId: GoogleAuthProvider.PROVIDER_ID,
                    signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
                    idToken: idToken,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthIdToken = tokenResponse.oauthIdToken, oauthAccessToken = tokenResponse.oauthAccessToken;
                if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
                return null;
                try {
                    return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GoogleAuthProvider;
}($0021d6672f58c7eb$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GOOGLE. */ $0021d6672f58c7eb$export$71cec2538cb2c617.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $0021d6672f58c7eb$export$71cec2538cb2c617.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Github Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Github Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ var $0021d6672f58c7eb$export$78acf4525d8a74c4 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $ftJVG._)(GithubAuthProvider, BaseOAuthProvider);
    var _super = (0, $6OZAO._)(GithubAuthProvider);
    function GithubAuthProvider() {
        (0, $978gY._)(this, GithubAuthProvider);
        return _super.call(this, "github.com" /* ProviderId.GITHUB */ );
    }
    (0, $kry2a._)(GithubAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Github.
     *
     * @param accessToken - Github access token.
     */ function credential(accessToken) {
                return $0021d6672f58c7eb$export$3a1a48c8f6ef640e._fromParams({
                    providerId: GithubAuthProvider.PROVIDER_ID,
                    signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
                    accessToken: accessToken
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return GithubAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
                if (!tokenResponse.oauthAccessToken) return null;
                try {
                    return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return GithubAuthProvider;
}($0021d6672f58c7eb$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.GITHUB. */ $0021d6672f58c7eb$export$78acf4525d8a74c4.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $0021d6672f58c7eb$export$78acf4525d8a74c4.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ var $0021d6672f58c7eb$export$2ed0fc6709e59212 = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $ftJVG._)(SAMLAuthCredential, AuthCredential);
    var _super = (0, $6OZAO._)(SAMLAuthCredential);
    function SAMLAuthCredential(providerId, pendingToken) {
        (0, $978gY._)(this, SAMLAuthCredential);
        var _this;
        _this = _super.call(this, providerId, providerId);
        _this.pendingToken = pendingToken;
        return _this;
    }
    (0, $kry2a._)(SAMLAuthCredential, [
        {
            /** @internal */ key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                var request = this.buildRequest();
                return $0021d6672f58c7eb$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                var request = this.buildRequest();
                request.idToken = idToken;
                return $0021d6672f58c7eb$var$signInWithIdp(auth, request);
            }
        },
        {
            /** @internal */ key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                var request = this.buildRequest();
                request.autoCreate = false;
                return $0021d6672f58c7eb$var$signInWithIdp(auth, request);
            }
        },
        {
            /** {@inheritdoc AuthCredential.toJSON}  */ key: "toJSON",
            value: function toJSON() {
                return {
                    signInMethod: this.signInMethod,
                    providerId: this.providerId,
                    pendingToken: this.pendingToken
                };
            }
        },
        {
            key: "buildRequest",
            value: function buildRequest() {
                return {
                    requestUri: $0021d6672f58c7eb$var$IDP_REQUEST_URI,
                    returnSecureToken: true,
                    pendingToken: this.pendingToken
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ function fromJSON(json) {
                var obj = typeof json === "string" ? JSON.parse(json) : json;
                var providerId = obj.providerId, signInMethod = obj.signInMethod, pendingToken = obj.pendingToken;
                if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        },
        {
            key: "_create",
            value: /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ function _create(providerId, pendingToken) {
                return new SAMLAuthCredential(providerId, pendingToken);
            }
        }
    ]);
    return SAMLAuthCredential;
}($0021d6672f58c7eb$export$3466f893ebf79586);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ var $0021d6672f58c7eb$export$dc98b0b04f4c7758 = /*#__PURE__*/ function(FederatedAuthProvider) {
    "use strict";
    (0, $ftJVG._)(SAMLAuthProvider, FederatedAuthProvider);
    var _super = (0, $6OZAO._)(SAMLAuthProvider);
    function SAMLAuthProvider(providerId) {
        (0, $978gY._)(this, SAMLAuthProvider);
        $0021d6672f58c7eb$export$9d398bebfec1c039(providerId.startsWith($0021d6672f58c7eb$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return _super.call(this, providerId);
    }
    (0, $kry2a._)(SAMLAuthProvider, null, [
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromJSON",
            value: /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ function credentialFromJSON(json) {
                var credential = $0021d6672f58c7eb$export$2ed0fc6709e59212.fromJSON(json);
                $0021d6672f58c7eb$export$9d398bebfec1c039(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                return credential;
            }
        },
        {
            key: "samlCredentialFromTaggedObject",
            value: function samlCredentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var pendingToken = tokenResponse.pendingToken, providerId = tokenResponse.providerId;
                if (!pendingToken || !providerId) return null;
                try {
                    return $0021d6672f58c7eb$export$2ed0fc6709e59212._create(providerId, pendingToken);
                } catch (e) {
                    return null;
                }
            }
        }
    ]);
    return SAMLAuthProvider;
}($0021d6672f58c7eb$var$FederatedAuthProvider);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ var $0021d6672f58c7eb$export$71511d61b312f219 = /*#__PURE__*/ function(BaseOAuthProvider) {
    "use strict";
    (0, $ftJVG._)(TwitterAuthProvider, BaseOAuthProvider);
    var _super = (0, $6OZAO._)(TwitterAuthProvider);
    function TwitterAuthProvider() {
        (0, $978gY._)(this, TwitterAuthProvider);
        return _super.call(this, "twitter.com" /* ProviderId.TWITTER */ );
    }
    (0, $kry2a._)(TwitterAuthProvider, null, [
        {
            key: "credential",
            value: /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ function credential(token, secret) {
                return $0021d6672f58c7eb$export$3a1a48c8f6ef640e._fromParams({
                    providerId: TwitterAuthProvider.PROVIDER_ID,
                    signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
                    oauthToken: token,
                    oauthTokenSecret: secret
                });
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ function credentialFromError(error) {
                return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var oauthAccessToken = tokenResponse.oauthAccessToken, oauthTokenSecret = tokenResponse.oauthTokenSecret;
                if (!oauthAccessToken || !oauthTokenSecret) return null;
                try {
                    return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
                } catch (_a) {
                    return null;
                }
            }
        }
    ]);
    return TwitterAuthProvider;
}($0021d6672f58c7eb$var$BaseOAuthProvider);
/** Always set to {@link SignInMethod}.TWITTER. */ $0021d6672f58c7eb$export$71511d61b312f219.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $0021d6672f58c7eb$export$71511d61b312f219.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
function $0021d6672f58c7eb$var$signUp(auth, request) {
    return $0021d6672f58c7eb$var$_signUp.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signUp() {
    $0021d6672f58c7eb$var$_signUp = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signUp.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$UserCredentialImpl = /*#__PURE__*/ function() {
    "use strict";
    function UserCredentialImpl(params) {
        (0, $978gY._)(this, UserCredentialImpl);
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    (0, $kry2a._)(UserCredentialImpl, null, [
        {
            key: "_fromIdTokenResponse",
            value: function _fromIdTokenResponse(auth, operationType, idTokenResponse) {
                var isAnonymous = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var user, providerId, userCred;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $0021d6672f58c7eb$export$a05254e7c3aeba6e._fromIdTokenResponse(auth, idTokenResponse, isAnonymous)
                                ];
                            case 1:
                                user = _state.sent();
                                providerId = $0021d6672f58c7eb$var$providerIdForResponse(idTokenResponse);
                                userCred = new UserCredentialImpl({
                                    user: user,
                                    providerId: providerId,
                                    _tokenResponse: idTokenResponse,
                                    operationType: operationType
                                });
                                return [
                                    2,
                                    userCred
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_forOperation",
            value: function _forOperation(user, operationType, response) {
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var providerId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    user._updateTokensIfNecessary(response, /* reload */ true)
                                ];
                            case 1:
                                _state.sent();
                                providerId = $0021d6672f58c7eb$var$providerIdForResponse(response);
                                return [
                                    2,
                                    new UserCredentialImpl({
                                        user: user,
                                        providerId: providerId,
                                        _tokenResponse: response,
                                        operationType: operationType
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return UserCredentialImpl;
}();
function $0021d6672f58c7eb$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
function $0021d6672f58c7eb$export$3d8c2f653ac9d0b9(auth) {
    return $0021d6672f58c7eb$var$_signInAnonymously.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInAnonymously() {
    $0021d6672f58c7eb$var$_signInAnonymously = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        var _a, authInternal, response, userCredential;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
                    return [
                        2,
                        new $0021d6672f58c7eb$var$UserCredentialImpl({
                            user: authInternal.currentUser,
                            providerId: null,
                            operationType: "signIn" /* OperationType.SIGN_IN */ 
                        })
                    ];
                    return [
                        4,
                        $0021d6672f58c7eb$var$signUp(authInternal, {
                            returnSecureToken: true
                        })
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true)
                    ];
                case 3:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_signInAnonymously.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$MultiFactorError = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $ftJVG._)(MultiFactorError, FirebaseError);
    var _super = (0, $6OZAO._)(MultiFactorError);
    function MultiFactorError(auth, error, operationType, user) {
        (0, $978gY._)(this, MultiFactorError);
        var _this;
        var _a;
        _this = _super.call(this, error.code, error.message);
        _this.operationType = operationType;
        _this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf((0, $3vWwE._)(_this), MultiFactorError.prototype);
        _this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
        return _this;
    }
    (0, $kry2a._)(MultiFactorError, null, [
        {
            key: "_fromErrorAndOperation",
            value: function _fromErrorAndOperation(auth, error, operationType, user) {
                return new MultiFactorError(auth, error, operationType, user);
            }
        }
    ]);
    return MultiFactorError;
}((0, $b1467a785fc7cec5$export$dd24e9cd51226c56));
function $0021d6672f58c7eb$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    var idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch(function(error) {
        if (error.code === "auth/multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ) throw $0021d6672f58c7eb$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $0021d6672f58c7eb$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(function(param) {
        var providerId = param.providerId;
        return providerId;
    }).filter(function(pid) {
        return !!pid;
    }));
}
function $0021d6672f58c7eb$export$7a38258bbe170828(user, providerId) {
    return $0021d6672f58c7eb$var$_unlink.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_unlink() {
    $0021d6672f58c7eb$var$_unlink = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, providerId) {
        var userInternal, providerUserInfo, _tmp, _tmp1, providersLeft;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_assertLinkedStatus(true, userInternal, providerId)
                    ];
                case 1:
                    _state.sent();
                    _tmp = [
                        userInternal.auth
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 2:
                    return [
                        4,
                        $0021d6672f58c7eb$var$deleteLinkedAccounts.apply(void 0, _tmp.concat([
                            (_tmp1.idToken = _state.sent(), _tmp1.deleteProvider = [
                                providerId
                            ], _tmp1)
                        ]))
                    ];
                case 3:
                    providerUserInfo = _state.sent().providerUserInfo;
                    providersLeft = $0021d6672f58c7eb$var$providerDataAsNames(providerUserInfo || []);
                    userInternal.providerData = userInternal.providerData.filter(function(pd) {
                        return providersLeft.has(pd.providerId);
                    });
                    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
                    return [
                        4,
                        userInternal.auth._persistUserIfCurrent(userInternal)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        userInternal
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_unlink.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_link$1(user, credential) {
    return $0021d6672f58c7eb$var$__link$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__link$1() {
    $0021d6672f58c7eb$var$__link$1 = (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, credential) {
        var bypassAuthState, response, _tmp, _, _tmp1;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    _tmp = [
                        user
                    ];
                    _ = credential._linkToIdToken;
                    _tmp1 = [
                        user.auth
                    ];
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    return [
                        4,
                        $0021d6672f58c7eb$var$_logoutIfInvalidated.apply(void 0, _tmp.concat([
                            _.apply(credential, _tmp1.concat([
                                _state.sent()
                            ])),
                            bypassAuthState
                        ]))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        $0021d6672f58c7eb$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response)
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__link$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_assertLinkedStatus(expected, user, provider) {
    return $0021d6672f58c7eb$var$__assertLinkedStatus.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__assertLinkedStatus() {
    $0021d6672f58c7eb$var$__assertLinkedStatus = (0, $869ea882f885334a$export$7c398597f8905a1)(function(expected, user, provider) {
        var providerIds, code;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$_reloadWithoutSaving(user)
                    ];
                case 1:
                    _state.sent();
                    providerIds = $0021d6672f58c7eb$var$providerDataAsNames(user.providerData);
                    code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
                    $0021d6672f58c7eb$export$9d398bebfec1c039(providerIds.has(provider) === expected, user.auth, code);
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__assertLinkedStatus.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_reauthenticate(user, credential) {
    return $0021d6672f58c7eb$var$__reauthenticate.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__reauthenticate() {
    $0021d6672f58c7eb$var$__reauthenticate = /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, credential) {
        var bypassAuthState, auth, operationType, response, parsed, localId, e;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    auth = user.auth;
                    operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_logoutIfInvalidated(user, $0021d6672f58c7eb$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState)
                    ];
                case 2:
                    response = _state.sent();
                    $0021d6672f58c7eb$export$9d398bebfec1c039(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    parsed = $0021d6672f58c7eb$var$_parseToken(response.idToken);
                    $0021d6672f58c7eb$export$9d398bebfec1c039(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    localId = parsed.sub;
                    $0021d6672f58c7eb$export$9d398bebfec1c039(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    return [
                        2,
                        $0021d6672f58c7eb$var$UserCredentialImpl._forOperation(user, operationType, response)
                    ];
                case 3:
                    e = _state.sent();
                    // Convert user deleted error into user mismatch
                    if ((e === null || e === void 0 ? void 0 : e.code) === "auth/user-not-found" /* AuthErrorCode.USER_DELETED */ ) $0021d6672f58c7eb$export$92108d983e8ee699(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__reauthenticate.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithCredential(auth, credential) {
    return $0021d6672f58c7eb$var$__signInWithCredential.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__signInWithCredential() {
    $0021d6672f58c7eb$var$__signInWithCredential = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, credential) {
        var bypassAuthState, operationType, response, userCredential;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    operationType = "signIn" /* OperationType.SIGN_IN */ ;
                    return [
                        4,
                        $0021d6672f58c7eb$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response)
                    ];
                case 2:
                    userCredential = _state.sent();
                    if (!!bypassAuthState) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        auth._updateCurrentUser(userCredential.user)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__signInWithCredential.apply(this, arguments);
}
function $0021d6672f58c7eb$export$34aec0b863436764(auth, credential) {
    return $0021d6672f58c7eb$var$_signInWithCredential1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithCredential1() {
    $0021d6672f58c7eb$var$_signInWithCredential1 = /**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, credential) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_signInWithCredential($0021d6672f58c7eb$export$b9a6b53f9be3734(auth), credential)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithCredential1.apply(this, arguments);
}
function $0021d6672f58c7eb$export$3c2fa207a37baaea(user, credential) {
    return $0021d6672f58c7eb$var$_linkWithCredential.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_linkWithCredential() {
    $0021d6672f58c7eb$var$_linkWithCredential = /**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, credential) {
        var userInternal;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_assertLinkedStatus(false, userInternal, credential.providerId)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $0021d6672f58c7eb$var$_link$1(userInternal, credential)
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_linkWithCredential.apply(this, arguments);
}
function $0021d6672f58c7eb$export$ce26c07117d59d6a(user, credential) {
    return $0021d6672f58c7eb$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_reauthenticateWithCredential() {
    $0021d6672f58c7eb$var$_reauthenticateWithCredential = /**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, credential) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_reauthenticate((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user), credential)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_reauthenticateWithCredential.apply(this, arguments);
}
function $0021d6672f58c7eb$var$signInWithCustomToken$1(auth, request) {
    return $0021d6672f58c7eb$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithCustomToken$1() {
    $0021d6672f58c7eb$var$_signInWithCustomToken$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithCustomToken$1.apply(this, arguments);
}
function $0021d6672f58c7eb$export$6559d589eb85fbb6(auth, customToken) {
    return $0021d6672f58c7eb$var$_signInWithCustomToken.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithCustomToken() {
    $0021d6672f58c7eb$var$_signInWithCustomToken = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, customToken) {
        var authInternal, response, cred;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        $0021d6672f58c7eb$var$signInWithCustomToken$1(authInternal, {
                            token: customToken,
                            returnSecureToken: true
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 2:
                    cred = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(cred.user)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        cred
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_signInWithCustomToken.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$MultiFactorInfoImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorInfoImpl(factorId, response) {
        (0, $978gY._)(this, MultiFactorInfoImpl);
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    (0, $kry2a._)(MultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(auth, enrollment) {
                if ("phoneInfo" in enrollment) return $0021d6672f58c7eb$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                else if ("totpInfo" in enrollment) return $0021d6672f58c7eb$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                return $0021d6672f58c7eb$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        }
    ]);
    return MultiFactorInfoImpl;
}();
var $0021d6672f58c7eb$var$PhoneMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $ftJVG._)(PhoneMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $6OZAO._)(PhoneMultiFactorInfoImpl);
    function PhoneMultiFactorInfoImpl(response) {
        (0, $978gY._)(this, PhoneMultiFactorInfoImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ , response);
        _this.phoneNumber = response.phoneInfo;
        return _this;
    }
    (0, $kry2a._)(PhoneMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new PhoneMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return PhoneMultiFactorInfoImpl;
}($0021d6672f58c7eb$var$MultiFactorInfoImpl);
var $0021d6672f58c7eb$var$TotpMultiFactorInfoImpl = /*#__PURE__*/ function(MultiFactorInfoImpl) {
    "use strict";
    (0, $ftJVG._)(TotpMultiFactorInfoImpl, MultiFactorInfoImpl);
    var _super = (0, $6OZAO._)(TotpMultiFactorInfoImpl);
    function TotpMultiFactorInfoImpl(response) {
        (0, $978gY._)(this, TotpMultiFactorInfoImpl);
        return _super.call(this, "totp" /* FactorId.TOTP */ , response);
    }
    (0, $kry2a._)(TotpMultiFactorInfoImpl, null, [
        {
            key: "_fromServerResponse",
            value: function _fromServerResponse(_auth, enrollment) {
                return new TotpMultiFactorInfoImpl(enrollment);
            }
        }
    ]);
    return TotpMultiFactorInfoImpl;
}($0021d6672f58c7eb$var$MultiFactorInfoImpl);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $0021d6672f58c7eb$export$9d398bebfec1c039(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $0021d6672f58c7eb$export$9d398bebfec1c039(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $0021d6672f58c7eb$export$9d398bebfec1c039(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
function $0021d6672f58c7eb$var$recachePasswordPolicy(auth) {
    return $0021d6672f58c7eb$var$_recachePasswordPolicy.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_recachePasswordPolicy() {
    $0021d6672f58c7eb$var$_recachePasswordPolicy = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        var authInternal;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    if (!authInternal._getPasswordPolicyInternal()) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        authInternal._updatePasswordPolicy()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_recachePasswordPolicy.apply(this, arguments);
}
function $0021d6672f58c7eb$export$efca4cbe5dd06740(auth, email, actionCodeSettings) {
    return $0021d6672f58c7eb$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendPasswordResetEmail() {
    $0021d6672f58c7eb$var$_sendPasswordResetEmail = /**
 * Sends a password reset email to the given email address.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, email, actionCodeSettings) {
        var _a, authInternal, request, requestWithRecaptcha;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    request = {
                        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (!((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $0021d6672f58c7eb$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    if (actionCodeSettings) $0021d6672f58c7eb$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                    return [
                        4,
                        $0021d6672f58c7eb$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    if (actionCodeSettings) $0021d6672f58c7eb$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
                    return [
                        4,
                        $0021d6672f58c7eb$var$sendPasswordResetEmail$1(authInternal, request).catch(function() {
                            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(error) {
                                var requestWithRecaptcha;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                3,
                                                3
                                            ];
                                            console.log("Password resets are protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the password reset flow.");
                                            return [
                                                4,
                                                $0021d6672f58c7eb$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                                            ];
                                        case 1:
                                            requestWithRecaptcha = _state.sent();
                                            if (actionCodeSettings) $0021d6672f58c7eb$var$_setActionCodeSettingsOnRequest(authInternal, requestWithRecaptcha, actionCodeSettings);
                                            return [
                                                4,
                                                $0021d6672f58c7eb$var$sendPasswordResetEmail$1(authInternal, requestWithRecaptcha)
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            return [
                                                2,
                                                Promise.reject(error)
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_sendPasswordResetEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$export$a8550f7dbe79f93a(auth, oobCode, newPassword) {
    return $0021d6672f58c7eb$var$_confirmPasswordReset.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_confirmPasswordReset() {
    $0021d6672f58c7eb$var$_confirmPasswordReset = /**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, oobCode, newPassword) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$resetPassword((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth), {
                            oobCode: oobCode,
                            newPassword: newPassword
                        }).catch(function() {
                            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(error) {
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $0021d6672f58c7eb$var$recachePasswordPolicy(auth);
                                    throw error;
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    // Do not return the email.
    });
    return $0021d6672f58c7eb$var$_confirmPasswordReset.apply(this, arguments);
}
function $0021d6672f58c7eb$export$2e2af4578d910ddf(auth, oobCode) {
    return $0021d6672f58c7eb$var$_applyActionCode.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_applyActionCode() {
    $0021d6672f58c7eb$var$_applyActionCode = /**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, oobCode) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$applyActionCode$1((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth), {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_applyActionCode.apply(this, arguments);
}
function $0021d6672f58c7eb$export$a93c5207d687da10(auth, oobCode) {
    return $0021d6672f58c7eb$var$_checkActionCode.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_checkActionCode() {
    $0021d6672f58c7eb$var$_checkActionCode = /**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, oobCode) {
        var authModular, response, operation, multiFactorInfo;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authModular = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth);
                    return [
                        4,
                        $0021d6672f58c7eb$var$resetPassword(authModular, {
                            oobCode: oobCode
                        })
                    ];
                case 1:
                    response = _state.sent();
                    operation = response.requestType;
                    $0021d6672f58c7eb$export$9d398bebfec1c039(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    switch(operation){
                        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
                            break;
                        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
                            $0021d6672f58c7eb$export$9d398bebfec1c039(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                            break;
                        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
                            $0021d6672f58c7eb$export$9d398bebfec1c039(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                        // fall through
                        default:
                            $0021d6672f58c7eb$export$9d398bebfec1c039(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    }
                    multiFactorInfo = null;
                    if (response.mfaInfo) multiFactorInfo = $0021d6672f58c7eb$var$MultiFactorInfoImpl._fromServerResponse($0021d6672f58c7eb$export$b9a6b53f9be3734(authModular), response.mfaInfo);
                    return [
                        2,
                        {
                            data: {
                                email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
                                previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
                                multiFactorInfo: multiFactorInfo
                            },
                            operation: operation
                        }
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_checkActionCode.apply(this, arguments);
}
function $0021d6672f58c7eb$export$c3950d9923825c02(auth, code) {
    return $0021d6672f58c7eb$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_verifyPasswordResetCode() {
    $0021d6672f58c7eb$var$_verifyPasswordResetCode = /**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, code) {
        var data;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$export$a93c5207d687da10((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth), code)
                    ];
                case 1:
                    data = _state.sent().data;
                    // Email should always be present since a code was sent to it
                    return [
                        2,
                        data.email
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_verifyPasswordResetCode.apply(this, arguments);
}
function $0021d6672f58c7eb$export$a9c996f45e5784d0(auth, email, password) {
    return $0021d6672f58c7eb$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_createUserWithEmailAndPassword() {
    $0021d6672f58c7eb$var$_createUserWithEmailAndPassword = /**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, email, password) {
        var _a, authInternal, request, signUpResponse, requestWithRecaptcha, response, userCredential;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    request = {
                        returnSecureToken: true,
                        email: email,
                        password: password,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (!((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $0021d6672f58c7eb$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ )
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    signUpResponse = $0021d6672f58c7eb$var$signUp(authInternal, requestWithRecaptcha);
                    return [
                        3,
                        3
                    ];
                case 2:
                    signUpResponse = $0021d6672f58c7eb$var$signUp(authInternal, request).catch(function() {
                        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(error) {
                            var requestWithRecaptcha;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                            3,
                                            2
                                        ];
                                        console.log("Sign-up is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-up flow.");
                                        return [
                                            4,
                                            $0021d6672f58c7eb$var$injectRecaptchaFields(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ )
                                        ];
                                    case 1:
                                        requestWithRecaptcha = _state.sent();
                                        return [
                                            2,
                                            $0021d6672f58c7eb$var$signUp(authInternal, requestWithRecaptcha)
                                        ];
                                    case 2:
                                        throw error;
                                }
                            });
                        });
                        return function(error) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _state.label = 3;
                case 3:
                    return [
                        4,
                        signUpResponse.catch(function(error) {
                            if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $0021d6672f58c7eb$var$recachePasswordPolicy(auth);
                            throw error;
                        })
                    ];
                case 4:
                    response = _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response)
                    ];
                case 5:
                    userCredential = _state.sent();
                    return [
                        4,
                        authInternal._updateCurrentUser(userCredential.user)
                    ];
                case 6:
                    _state.sent();
                    return [
                        2,
                        userCredential
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_createUserWithEmailAndPassword.apply(this, arguments);
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $0021d6672f58c7eb$export$7910e0436ed8d1de(auth, email, password) {
    return $0021d6672f58c7eb$export$34aec0b863436764((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth), $0021d6672f58c7eb$export$3a6d5c9ae78a2c08.credential(email, password)).catch(function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(error) {
            return (0, $7UAGh.__generator)(this, function(_state) {
                if (error.code === "auth/password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ) $0021d6672f58c7eb$var$recachePasswordPolicy(auth);
                throw error;
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
}
function $0021d6672f58c7eb$export$555508cbc6add439(auth, email, actionCodeSettings) {
    return $0021d6672f58c7eb$var$_sendSignInLinkToEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendSignInLinkToEmail() {
    $0021d6672f58c7eb$var$_sendSignInLinkToEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, email, actionCodeSettings) {
        var _a, authInternal, request, requestWithRecaptcha;
        function setActionCodeSettings(request, actionCodeSettings) {
            $0021d6672f58c7eb$export$9d398bebfec1c039(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            if (actionCodeSettings) $0021d6672f58c7eb$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
        }
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    request = {
                        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
                        email: email,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    };
                    if (!((_a = authInternal._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.emailPasswordEnabled)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $0021d6672f58c7eb$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                    ];
                case 1:
                    requestWithRecaptcha = _state.sent();
                    setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                    return [
                        4,
                        $0021d6672f58c7eb$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    setActionCodeSettings(request, actionCodeSettings);
                    return [
                        4,
                        $0021d6672f58c7eb$var$sendSignInLinkToEmail$1(authInternal, request).catch(function() {
                            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(error) {
                                var requestWithRecaptcha;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(error.code === "auth/missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ )) return [
                                                3,
                                                3
                                            ];
                                            console.log("Email link sign-in is protected by reCAPTCHA for this project. Automatically triggering the reCAPTCHA flow and restarting the sign-in flow.");
                                            return [
                                                4,
                                                $0021d6672f58c7eb$var$injectRecaptchaFields(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , true)
                                            ];
                                        case 1:
                                            requestWithRecaptcha = _state.sent();
                                            setActionCodeSettings(requestWithRecaptcha, actionCodeSettings);
                                            return [
                                                4,
                                                $0021d6672f58c7eb$var$sendSignInLinkToEmail$1(authInternal, requestWithRecaptcha)
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            return [
                                                2,
                                                Promise.reject(error)
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(error) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_sendSignInLinkToEmail.apply(this, arguments);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $0021d6672f58c7eb$export$2219238a014317b0(auth, emailLink) {
    var actionCodeUrl = $0021d6672f58c7eb$export$995eb9fca571757.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
function $0021d6672f58c7eb$export$4c3d22f3d993c33f(auth, email, emailLink) {
    return $0021d6672f58c7eb$var$_signInWithEmailLink.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithEmailLink() {
    $0021d6672f58c7eb$var$_signInWithEmailLink = /**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, email, emailLink) {
        var authModular, credential;
        return (0, $7UAGh.__generator)(this, function(_state) {
            authModular = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth);
            credential = $0021d6672f58c7eb$export$3a6d5c9ae78a2c08.credentialWithLink(email, emailLink || $0021d6672f58c7eb$var$_getCurrentUrl());
            // Check if the tenant ID in the email link matches the tenant ID on Auth
            // instance.
            $0021d6672f58c7eb$export$9d398bebfec1c039(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
            return [
                2,
                $0021d6672f58c7eb$export$34aec0b863436764(authModular, credential)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithEmailLink.apply(this, arguments);
}
function $0021d6672f58c7eb$var$createAuthUri(auth, request) {
    return $0021d6672f58c7eb$var$_createAuthUri.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_createAuthUri() {
    $0021d6672f58c7eb$var$_createAuthUri = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request))
            ];
        });
    });
    return $0021d6672f58c7eb$var$_createAuthUri.apply(this, arguments);
}
function $0021d6672f58c7eb$export$f787f51d84a910ad(auth, email) {
    return $0021d6672f58c7eb$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_fetchSignInMethodsForEmail() {
    $0021d6672f58c7eb$var$_fetchSignInMethodsForEmail = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, email) {
        var continueUri, request, signinMethods;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    continueUri = $0021d6672f58c7eb$var$_isHttpOrHttps() ? $0021d6672f58c7eb$var$_getCurrentUrl() : "http://localhost";
                    request = {
                        identifier: email,
                        continueUri: continueUri
                    };
                    return [
                        4,
                        $0021d6672f58c7eb$var$createAuthUri((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth), request)
                    ];
                case 1:
                    signinMethods = _state.sent().signinMethods;
                    return [
                        2,
                        signinMethods || []
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_fetchSignInMethodsForEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$export$c9170ad7d4cd7e57(user, actionCodeSettings) {
    return $0021d6672f58c7eb$var$_sendEmailVerification.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_sendEmailVerification() {
    $0021d6672f58c7eb$var$_sendEmailVerification = /**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
                        idToken: idToken
                    };
                    if (actionCodeSettings) $0021d6672f58c7eb$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $0021d6672f58c7eb$var$sendEmailVerification$1(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_sendEmailVerification.apply(this, arguments);
}
function $0021d6672f58c7eb$export$ee7c8ad385a60b7b(user, newEmail, actionCodeSettings) {
    return $0021d6672f58c7eb$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_verifyBeforeUpdateEmail() {
    $0021d6672f58c7eb$var$_verifyBeforeUpdateEmail = /**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, newEmail, actionCodeSettings) {
        var userInternal, idToken, request, email;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
                        idToken: idToken,
                        newEmail: newEmail
                    };
                    if (actionCodeSettings) $0021d6672f58c7eb$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
                    return [
                        4,
                        $0021d6672f58c7eb$var$verifyAndChangeEmail(userInternal.auth, request)
                    ];
                case 2:
                    email = _state.sent().email;
                    if (!(email !== user.email)) return [
                        3,
                        4
                    ];
                    // If the local copy of the email on user is outdated, reload the
                    // user.
                    return [
                        4,
                        user.reload()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_verifyBeforeUpdateEmail.apply(this, arguments);
}
function $0021d6672f58c7eb$var$updateProfile$1(auth, request) {
    return $0021d6672f58c7eb$var$_updateProfile$1.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_updateProfile$1() {
    $0021d6672f58c7eb$var$_updateProfile$1 = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, request) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_updateProfile$1.apply(this, arguments);
}
function $0021d6672f58c7eb$export$3b513254972cfc9c(user, _) {
    return $0021d6672f58c7eb$var$_updateProfile.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_updateProfile() {
    $0021d6672f58c7eb$var$_updateProfile = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, param) {
        var displayName, photoUrl, userInternal, idToken, profileRequest, response, passwordProvider;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    displayName = param.displayName, photoUrl = param.photoURL;
                    if (displayName === undefined && photoUrl === undefined) return [
                        2
                    ];
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        userInternal.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    profileRequest = {
                        idToken: idToken,
                        displayName: displayName,
                        photoUrl: photoUrl,
                        returnSecureToken: true
                    };
                    return [
                        4,
                        $0021d6672f58c7eb$var$_logoutIfInvalidated(userInternal, $0021d6672f58c7eb$var$updateProfile$1(userInternal.auth, profileRequest))
                    ];
                case 2:
                    response = _state.sent();
                    userInternal.displayName = response.displayName || null;
                    userInternal.photoURL = response.photoUrl || null;
                    passwordProvider = userInternal.providerData.find(function(param) {
                        var providerId = param.providerId;
                        return providerId === "password" /* ProviderId.PASSWORD */ ;
                    });
                    if (passwordProvider) {
                        passwordProvider.displayName = userInternal.displayName;
                        passwordProvider.photoURL = userInternal.photoURL;
                    }
                    return [
                        4,
                        userInternal._updateTokensIfNecessary(response)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_updateProfile.apply(this, arguments);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * @public
 */ function $0021d6672f58c7eb$export$21579262ef46735b(user, newEmail) {
    return $0021d6672f58c7eb$var$updateEmailOrPassword((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user), newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $0021d6672f58c7eb$export$ab83b03e4111b1d0(user, newPassword) {
    return $0021d6672f58c7eb$var$updateEmailOrPassword((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user), null, newPassword);
}
function $0021d6672f58c7eb$var$updateEmailOrPassword(user, email, password) {
    return $0021d6672f58c7eb$var$_updateEmailOrPassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_updateEmailOrPassword() {
    $0021d6672f58c7eb$var$_updateEmailOrPassword = (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, email, password) {
        var auth, idToken, request, response;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    auth = user.auth;
                    return [
                        4,
                        user.getIdToken()
                    ];
                case 1:
                    idToken = _state.sent();
                    request = {
                        idToken: idToken,
                        returnSecureToken: true
                    };
                    if (email) request.email = email;
                    if (password) request.password = password;
                    return [
                        4,
                        $0021d6672f58c7eb$var$_logoutIfInvalidated(user, $0021d6672f58c7eb$var$updateEmailPassword(auth, request))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        4,
                        user._updateTokensIfNecessary(response, /* reload */ true)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_updateEmailOrPassword.apply(this, arguments);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $0021d6672f58c7eb$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    var providerId = idTokenResponse.providerId;
    var profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    var isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        var signInProvider = (_b = (_a = $0021d6672f58c7eb$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            var filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $0021d6672f58c7eb$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $0021d6672f58c7eb$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $0021d6672f58c7eb$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $0021d6672f58c7eb$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $0021d6672f58c7eb$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $0021d6672f58c7eb$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $0021d6672f58c7eb$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
var $0021d6672f58c7eb$var$GenericAdditionalUserInfo = function GenericAdditionalUserInfo(isNewUser, providerId) {
    "use strict";
    var profile = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    (0, $978gY._)(this, GenericAdditionalUserInfo);
    this.isNewUser = isNewUser;
    this.providerId = providerId;
    this.profile = profile;
};
var $0021d6672f58c7eb$var$FederatedAdditionalUserInfoWithUsername = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $ftJVG._)(FederatedAdditionalUserInfoWithUsername, GenericAdditionalUserInfo);
    var _super = (0, $6OZAO._)(FederatedAdditionalUserInfoWithUsername);
    function FederatedAdditionalUserInfoWithUsername(isNewUser, providerId, profile, username) {
        (0, $978gY._)(this, FederatedAdditionalUserInfoWithUsername);
        var _this;
        _this = _super.call(this, isNewUser, providerId, profile);
        _this.username = username;
        return _this;
    }
    return FederatedAdditionalUserInfoWithUsername;
}($0021d6672f58c7eb$var$GenericAdditionalUserInfo);
var $0021d6672f58c7eb$var$FacebookAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $ftJVG._)(FacebookAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $6OZAO._)(FacebookAdditionalUserInfo);
    function FacebookAdditionalUserInfo(isNewUser, profile) {
        (0, $978gY._)(this, FacebookAdditionalUserInfo);
        return _super.call(this, isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
    return FacebookAdditionalUserInfo;
}($0021d6672f58c7eb$var$GenericAdditionalUserInfo);
var $0021d6672f58c7eb$var$GithubAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $ftJVG._)(GithubAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $6OZAO._)(GithubAdditionalUserInfo);
    function GithubAdditionalUserInfo(isNewUser, profile) {
        (0, $978gY._)(this, GithubAdditionalUserInfo);
        return _super.call(this, isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
    return GithubAdditionalUserInfo;
}($0021d6672f58c7eb$var$FederatedAdditionalUserInfoWithUsername);
var $0021d6672f58c7eb$var$GoogleAdditionalUserInfo = /*#__PURE__*/ function(GenericAdditionalUserInfo) {
    "use strict";
    (0, $ftJVG._)(GoogleAdditionalUserInfo, GenericAdditionalUserInfo);
    var _super = (0, $6OZAO._)(GoogleAdditionalUserInfo);
    function GoogleAdditionalUserInfo(isNewUser, profile) {
        (0, $978gY._)(this, GoogleAdditionalUserInfo);
        return _super.call(this, isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
    return GoogleAdditionalUserInfo;
}($0021d6672f58c7eb$var$GenericAdditionalUserInfo);
var $0021d6672f58c7eb$var$TwitterAdditionalUserInfo = /*#__PURE__*/ function(FederatedAdditionalUserInfoWithUsername) {
    "use strict";
    (0, $ftJVG._)(TwitterAdditionalUserInfo, FederatedAdditionalUserInfoWithUsername);
    var _super = (0, $6OZAO._)(TwitterAdditionalUserInfo);
    function TwitterAdditionalUserInfo(isNewUser, profile, screenName) {
        (0, $978gY._)(this, TwitterAdditionalUserInfo);
        return _super.call(this, isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
    return TwitterAdditionalUserInfo;
}($0021d6672f58c7eb$var$FederatedAdditionalUserInfoWithUsername);
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $0021d6672f58c7eb$export$2f6ca3d3b1f80bf5(userCredential) {
    var user = userCredential.user, _tokenResponse = userCredential._tokenResponse;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $0021d6672f58c7eb$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $0021d6672f58c7eb$export$9e5f44173e64f162(auth, persistence) {
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $0021d6672f58c7eb$export$625550452a3fa3ec(auth) {
    return $0021d6672f58c7eb$var$_initializeRecaptchaConfig(auth);
}
function $0021d6672f58c7eb$export$90a7f3efeed30595(auth, password) {
    return $0021d6672f58c7eb$var$_validatePassword.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_validatePassword() {
    $0021d6672f58c7eb$var$_validatePassword = /**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, password) {
        var authInternal;
        return (0, $7UAGh.__generator)(this, function(_state) {
            authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
            return [
                2,
                authInternal.validatePassword(password)
            ];
        });
    });
    return $0021d6672f58c7eb$var$_validatePassword.apply(this, arguments);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $0021d6672f58c7eb$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $0021d6672f58c7eb$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $0021d6672f58c7eb$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $0021d6672f58c7eb$export$df995fae86a55f06(auth) {
    (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $0021d6672f58c7eb$export$ef35774e6d314e91(auth, user) {
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $0021d6672f58c7eb$export$e7094788287c5e9b(auth) {
    return (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth).signOut();
}
function $0021d6672f58c7eb$export$96f57966bedc81b4(user) {
    return $0021d6672f58c7eb$var$_deleteUser.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_deleteUser() {
    $0021d6672f58c7eb$var$_deleteUser = /**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user).delete()
            ];
        });
    });
    return $0021d6672f58c7eb$var$_deleteUser.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$MultiFactorSessionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorSessionImpl(type, credential, user) {
        (0, $978gY._)(this, MultiFactorSessionImpl);
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    (0, $kry2a._)(MultiFactorSessionImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                var key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
                return {
                    multiFactorSession: (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)({}, key, this.credential)
                };
            }
        }
    ], [
        {
            key: "_fromIdtoken",
            value: function _fromIdtoken(idToken, user) {
                return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
            }
        },
        {
            key: "_fromMfaPendingCredential",
            value: function _fromMfaPendingCredential(mfaPendingCredential) {
                return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
            }
        },
        {
            key: "fromJSON",
            value: function fromJSON(obj) {
                var _a, _b;
                if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
                    if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
                    else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
                }
                return null;
            }
        }
    ]);
    return MultiFactorSessionImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$MultiFactorResolverImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorResolverImpl(session, hints, signInResolver) {
        (0, $978gY._)(this, MultiFactorResolverImpl);
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    (0, $kry2a._)(MultiFactorResolverImpl, [
        {
            key: "resolveSignIn",
            value: function resolveSignIn(assertionExtern) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var assertion;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        assertion = assertionExtern;
                        return [
                            2,
                            _this.signInResolver(assertion)
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromError",
            value: /** @internal */ function _fromError(authExtern, error) {
                var auth = $0021d6672f58c7eb$export$b9a6b53f9be3734(authExtern);
                var serverResponse = error.customData._serverResponse;
                var hints = (serverResponse.mfaInfo || []).map(function(enrollment) {
                    return $0021d6672f58c7eb$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment);
                });
                $0021d6672f58c7eb$export$9d398bebfec1c039(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                var session = $0021d6672f58c7eb$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
                return new MultiFactorResolverImpl(session, hints, function() {
                    var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(assertion) {
                        var mfaResponse, idTokenResponse, _, userCredential;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        assertion._process(auth, session)
                                    ];
                                case 1:
                                    mfaResponse = _state.sent();
                                    // Clear out the unneeded fields from the old login response
                                    delete serverResponse.mfaInfo;
                                    delete serverResponse.mfaPendingCredential;
                                    idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                                        idToken: mfaResponse.idToken,
                                        refreshToken: mfaResponse.refreshToken
                                    });
                                    _ = error.operationType;
                                    switch(_){
                                        case "signIn" /* OperationType.SIGN_IN */ :
                                            return [
                                                3,
                                                2
                                            ];
                                        case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                                            return [
                                                3,
                                                5
                                            ];
                                    }
                                    return [
                                        3,
                                        6
                                    ];
                                case 2:
                                    return [
                                        4,
                                        $0021d6672f58c7eb$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse)
                                    ];
                                case 3:
                                    userCredential = _state.sent();
                                    return [
                                        4,
                                        auth._updateCurrentUser(userCredential.user)
                                    ];
                                case 4:
                                    _state.sent();
                                    return [
                                        2,
                                        userCredential
                                    ];
                                case 5:
                                    $0021d6672f58c7eb$export$9d398bebfec1c039(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    return [
                                        2,
                                        $0021d6672f58c7eb$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse)
                                    ];
                                case 6:
                                    $0021d6672f58c7eb$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                    _state.label = 7;
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(assertion) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        }
    ]);
    return MultiFactorResolverImpl;
}();
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $0021d6672f58c7eb$export$d24c54395ce0c509(auth, error) {
    var _a;
    var authModular = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(auth);
    var errorInternal = error;
    $0021d6672f58c7eb$export$9d398bebfec1c039(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $0021d6672f58c7eb$export$9d398bebfec1c039((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $0021d6672f58c7eb$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$startEnrollPhoneMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
function $0021d6672f58c7eb$var$finalizeEnrollPhoneMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
function $0021d6672f58c7eb$var$startEnrollTotpMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
function $0021d6672f58c7eb$var$finalizeEnrollTotpMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
function $0021d6672f58c7eb$var$withdrawMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
var $0021d6672f58c7eb$var$MultiFactorUserImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorUserImpl(user) {
        var _this = this;
        (0, $978gY._)(this, MultiFactorUserImpl);
        this.user = user;
        this.enrolledFactors = [];
        user._onReload(function(userInfo) {
            if (userInfo.mfaInfo) _this.enrolledFactors = userInfo.mfaInfo.map(function(enrollment) {
                return $0021d6672f58c7eb$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment);
            });
        });
    }
    (0, $kry2a._)(MultiFactorUserImpl, [
        {
            key: "getSession",
            value: function getSession() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = $0021d6672f58c7eb$var$MultiFactorSessionImpl._fromIdtoken;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                return [
                                    2,
                                    _.apply($0021d6672f58c7eb$var$MultiFactorSessionImpl, [
                                        _state.sent(),
                                        _this.user
                                    ])
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "enroll",
            value: function enroll(assertionExtern, displayName) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var assertion, session, finalizeMfaResponse;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                assertion = assertionExtern;
                                return [
                                    4,
                                    _this.getSession()
                                ];
                            case 1:
                                session = _state.sent();
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_logoutIfInvalidated(_this.user, assertion._process(_this.user.auth, session, displayName))
                                ];
                            case 2:
                                finalizeMfaResponse = _state.sent();
                                // New tokens will be issued after enrollment of the new second factors.
                                // They need to be updated on the user.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(finalizeMfaResponse)
                                ];
                            case 3:
                                _state.sent();
                                // The user needs to be reloaded to get the new multi-factor information
                                // from server. USER_RELOADED event will be triggered and `enrolledFactors`
                                // will be updated.
                                return [
                                    2,
                                    _this.user.reload()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "unenroll",
            value: function unenroll(infoOrUid) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var mfaEnrollmentId, idToken, idTokenResponse, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
                                return [
                                    4,
                                    _this.user.getIdToken()
                                ];
                            case 1:
                                idToken = _state.sent();
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_logoutIfInvalidated(_this.user, $0021d6672f58c7eb$var$withdrawMfa(_this.user.auth, {
                                        idToken: idToken,
                                        mfaEnrollmentId: mfaEnrollmentId
                                    }))
                                ];
                            case 3:
                                idTokenResponse = _state.sent();
                                // Remove the second factor from the user's list.
                                _this.enrolledFactors = _this.enrolledFactors.filter(function(param) {
                                    var uid = param.uid;
                                    return uid !== mfaEnrollmentId;
                                });
                                // Depending on whether the backend decided to revoke the user's session,
                                // the tokenResponse may be empty. If the tokens were not updated (and they
                                // are now invalid), reloading the user will discover this and invalidate
                                // the user's state accordingly.
                                return [
                                    4,
                                    _this.user._updateTokensIfNecessary(idTokenResponse)
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    4,
                                    _this.user.reload()
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                throw e;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromUser",
            value: function _fromUser(user) {
                return new MultiFactorUserImpl(user);
            }
        }
    ]);
    return MultiFactorUserImpl;
}();
var $0021d6672f58c7eb$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $0021d6672f58c7eb$export$6554612db691658e(user) {
    var userModular = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
    if (!$0021d6672f58c7eb$var$multiFactorUserCache.has(userModular)) $0021d6672f58c7eb$var$multiFactorUserCache.set(userModular, $0021d6672f58c7eb$var$MultiFactorUserImpl._fromUser(userModular));
    return $0021d6672f58c7eb$var$multiFactorUserCache.get(userModular);
}
var $0021d6672f58c7eb$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
var $0021d6672f58c7eb$var$BrowserPersistenceClass = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPersistenceClass(storageRetriever, type) {
        (0, $978gY._)(this, BrowserPersistenceClass);
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    (0, $kry2a._)(BrowserPersistenceClass, [
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                try {
                    if (!this.storage) return Promise.resolve(false);
                    this.storage.setItem($0021d6672f58c7eb$var$STORAGE_AVAILABLE_KEY, "1");
                    this.storage.removeItem($0021d6672f58c7eb$var$STORAGE_AVAILABLE_KEY);
                    return Promise.resolve(true);
                } catch (_a) {
                    return Promise.resolve(false);
                }
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                this.storage.setItem(key, JSON.stringify(value));
                return Promise.resolve();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var json = this.storage.getItem(key);
                return Promise.resolve(json ? JSON.parse(json) : null);
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                this.storage.removeItem(key);
                return Promise.resolve();
            }
        },
        {
            key: "storage",
            get: function get() {
                return this.storageRetriever();
            }
        }
    ]);
    return BrowserPersistenceClass;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$_iframeCannotSyncWebStorage() {
    var ua = (0, $b1467a785fc7cec5$export$c36915b22ce77c19)();
    return $0021d6672f58c7eb$var$_isSafari(ua) || $0021d6672f58c7eb$export$1fbe638ecf81657e(ua);
}
// The polling period in case events are not supported
var $0021d6672f58c7eb$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
var $0021d6672f58c7eb$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
var $0021d6672f58c7eb$var$BrowserLocalPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $ftJVG._)(BrowserLocalPersistence, BrowserPersistenceClass);
    var _super = (0, $6OZAO._)(BrowserLocalPersistence);
    function BrowserLocalPersistence() {
        (0, $978gY._)(this, BrowserLocalPersistence);
        var _this;
        _this = _super.call(this, function() {
            return window.localStorage;
        }, "LOCAL" /* PersistenceType.LOCAL */ );
        _this.boundEventHandler = function(event, poll) {
            return _this.onStorageEvent(event, poll);
        };
        _this.listeners = {};
        _this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _this.pollTimer = null;
        // Safari or iOS browser and embedded in an iframe.
        _this.safariLocalStorageNotSynced = $0021d6672f58c7eb$var$_iframeCannotSyncWebStorage() && $0021d6672f58c7eb$var$_isIframe();
        // Whether to use polling instead of depending on window events
        _this.fallbackToPolling = $0021d6672f58c7eb$var$_isMobileBrowser();
        _this._shouldAllowMigration = true;
        return _this;
    }
    (0, $kry2a._)(BrowserLocalPersistence, [
        {
            key: "forAllChangedKeys",
            value: function forAllChangedKeys(cb) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Check all keys with listeners on them.
                    for(var _iterator = Object.keys(this.listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        // Get value from localStorage.
                        var newValue = this.storage.getItem(key);
                        var oldValue = this.localCache[key];
                        // If local map value does not match, trigger listener with storage event.
                        // Differentiate this simulated event from the real storage event.
                        if (newValue !== oldValue) cb(key, oldValue, newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "onStorageEvent",
            value: function onStorageEvent(event) {
                var poll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                // Key would be null in some situations, like when localStorage is cleared
                if (!event.key) {
                    this.forAllChangedKeys(function(key, _oldValue, newValue) {
                        _this.notifyListeners(key, newValue);
                    });
                    return;
                }
                var key = event.key;
                // Check the mechanism how this event was detected.
                // The first event will dictate the mechanism to be used.
                if (poll) // Environment detects storage changes via polling.
                // Remove storage event listener to prevent possible event duplication.
                this.detachListener();
                else // Environment detects storage changes via storage event listener.
                // Remove polling listener to prevent possible event duplication.
                this.stopPolling();
                // Safari embedded iframe. Storage event will trigger with the delta
                // changes but no changes will be applied to the iframe localStorage.
                if (this.safariLocalStorageNotSynced) {
                    // Get current iframe page value.
                    var storedValue = this.storage.getItem(key);
                    // Value not synchronized, synchronize manually.
                    if (event.newValue !== storedValue) {
                        if (event.newValue !== null) // Value changed from current value.
                        this.storage.setItem(key, event.newValue);
                        else // Current value deleted.
                        this.storage.removeItem(key);
                    } else if (this.localCache[key] === event.newValue && !poll) // Already detected and processed, do not trigger listeners again.
                    return;
                }
                var triggerListeners = function() {
                    // Keep local map up to date in case storage event is triggered before
                    // poll.
                    var storedValue = _this.storage.getItem(key);
                    if (!poll && _this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
                    // This seems to trigger in some IE browsers for some reason.
                    return;
                    _this.notifyListeners(key, storedValue);
                };
                var storedValue1 = this.storage.getItem(key);
                if ($0021d6672f58c7eb$var$_isIE10() && storedValue1 !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
                // correct key, oldValue and newValue but localStorage.getItem(key) does
                // not yield the updated value until a few milliseconds. This ensures
                // this recovers from that situation.
                setTimeout(triggerListeners, $0021d6672f58c7eb$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
                else triggerListeners();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, value) {
                this.localCache[key] = value;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(value ? JSON.parse(value) : value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                var _this = this;
                this.stopPolling();
                this.pollTimer = setInterval(function() {
                    _this.forAllChangedKeys(function(key, oldValue, newValue) {
                        _this.onStorageEvent(new StorageEvent("storage", {
                            key: key,
                            oldValue: oldValue,
                            newValue: newValue
                        }), /* poll */ true);
                    });
                }, $0021d6672f58c7eb$var$_POLLING_INTERVAL_MS$1);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "attachListener",
            value: function attachListener() {
                window.addEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "detachListener",
            value: function detachListener() {
                window.removeEventListener("storage", this.boundEventHandler);
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) {
                    // Whether browser can detect storage event when it had already been pushed to the background.
                    // This may happen in some mobile browsers. A localStorage change in the foreground window
                    // will not be detected in the background window via the storage event.
                    // This was detected in iOS 7.x mobile browsers
                    if (this.fallbackToPolling) this.startPolling();
                    else this.attachListener();
                }
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    // Populate the cache to avoid spuriously triggering on first poll.
                    this.localCache[key] = this.storage.getItem(key);
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key].delete(listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) {
                    this.detachListener();
                    this.stopPolling();
                }
            }
        },
        {
            key: "_set",
            value: // Update local cache on base operations:
            function _set(key, value) {
                var _this = this;
                var _this1 = this, _superprop_get__set = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(BrowserLocalPersistence.prototype), "_set", _this);
                };
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__set().call(_this1, key, value)
                                ];
                            case 1:
                                _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get1(key) {
                var _this = this;
                var _this1 = this, _superprop_get__get = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(BrowserLocalPersistence.prototype), "_get", _this);
                };
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var value;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__get().call(_this1, key)
                                ];
                            case 1:
                                value = _state.sent();
                                _this1.localCache[key] = JSON.stringify(value);
                                return [
                                    2,
                                    value
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                var _this1 = this, _superprop_get__remove = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(BrowserLocalPersistence.prototype), "_remove", _this);
                };
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get__remove().call(_this1, key)
                                ];
                            case 1:
                                _state.sent();
                                delete _this1.localCache[key];
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return BrowserLocalPersistence;
}($0021d6672f58c7eb$var$BrowserPersistenceClass);
$0021d6672f58c7eb$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ var $0021d6672f58c7eb$export$8b22cf2602fb60ce = $0021d6672f58c7eb$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$BrowserSessionPersistence = /*#__PURE__*/ function(BrowserPersistenceClass) {
    "use strict";
    (0, $ftJVG._)(BrowserSessionPersistence, BrowserPersistenceClass);
    var _super = (0, $6OZAO._)(BrowserSessionPersistence);
    function BrowserSessionPersistence() {
        (0, $978gY._)(this, BrowserSessionPersistence);
        return _super.call(this, function() {
            return window.sessionStorage;
        }, "SESSION" /* PersistenceType.SESSION */ );
    }
    (0, $kry2a._)(BrowserSessionPersistence, [
        {
            key: "_addListener",
            value: function _addListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(_key, _listener) {
                // Listeners are not supported for session storage since it cannot be shared across windows
                return;
            }
        }
    ]);
    return BrowserSessionPersistence;
}($0021d6672f58c7eb$var$BrowserPersistenceClass);
$0021d6672f58c7eb$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ var $0021d6672f58c7eb$export$407448d2b89b1813 = $0021d6672f58c7eb$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $0021d6672f58c7eb$var$_allSettled(promises) {
    return Promise.all(promises.map(function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(promise) {
            var value, reason;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            promise
                        ];
                    case 1:
                        value = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: true,
                                value: value
                            }
                        ];
                    case 2:
                        reason = _state.sent();
                        return [
                            2,
                            {
                                fulfilled: false,
                                reason: reason
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(promise) {
            return _ref.apply(this, arguments);
        };
    }()));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ var $0021d6672f58c7eb$var$Receiver = /*#__PURE__*/ function() {
    "use strict";
    function Receiver(eventTarget) {
        (0, $978gY._)(this, Receiver);
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    (0, $kry2a._)(Receiver, [
        {
            key: "isListeningto",
            value: function isListeningto(eventTarget) {
                return this.eventTarget === eventTarget;
            }
        },
        {
            key: "handleEvent",
            value: /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ function handleEvent(event) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var messageEvent, _messageEvent_data, eventId, eventType, data, handlers, promises, response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                messageEvent = event;
                                _messageEvent_data = messageEvent.data, eventId = _messageEvent_data.eventId, eventType = _messageEvent_data.eventType, data = _messageEvent_data.data;
                                handlers = _this.handlersMap[eventType];
                                if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return [
                                    2
                                ];
                                messageEvent.ports[0].postMessage({
                                    status: "ack" /* _Status.ACK */ ,
                                    eventId: eventId,
                                    eventType: eventType
                                });
                                promises = Array.from(handlers).map(function() {
                                    var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(handler) {
                                        return (0, $7UAGh.__generator)(this, function(_state) {
                                            return [
                                                2,
                                                handler(messageEvent.origin, data)
                                            ];
                                        });
                                    });
                                    return function(handler) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_allSettled(promises)
                                ];
                            case 1:
                                response = _state.sent();
                                messageEvent.ports[0].postMessage({
                                    status: "done" /* _Status.DONE */ ,
                                    eventId: eventId,
                                    eventType: eventType,
                                    response: response
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ key: "_subscribe",
            value: function _subscribe(eventType, eventHandler) {
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
                if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
                this.handlersMap[eventType].add(eventHandler);
            }
        },
        {
            /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optinoal event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ key: "_unsubscribe",
            value: function _unsubscribe(eventType, eventHandler) {
                if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
                if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
                if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
            }
        }
    ], [
        {
            key: "_getInstance",
            value: /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ function _getInstance(eventTarget) {
                // The results are stored in an array since objects can't be keys for other
                // objects. In addition, setting a unique property on an event target as a
                // hash map key may not be allowed due to CORS restrictions.
                var existingInstance = this.receivers.find(function(receiver) {
                    return receiver.isListeningto(eventTarget);
                });
                if (existingInstance) return existingInstance;
                var newInstance = new Receiver(eventTarget);
                this.receivers.push(newInstance);
                return newInstance;
            }
        }
    ]);
    return Receiver;
}();
$0021d6672f58c7eb$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$export$9f4f30ee63539e24() {
    var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", digits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var random = "";
    for(var i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ var $0021d6672f58c7eb$var$Sender = /*#__PURE__*/ function() {
    "use strict";
    function Sender(target) {
        (0, $978gY._)(this, Sender);
        this.target = target;
        this.handlers = new Set();
    }
    (0, $kry2a._)(Sender, [
        {
            /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ key: "removeMessageHandler",
            value: function removeMessageHandler(handler) {
                if (handler.messageChannel) {
                    handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
                    handler.messageChannel.port1.close();
                }
                this.handlers.delete(handler);
            }
        },
        {
            key: "_send",
            value: /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ function _send(eventType, data) {
                var timeout = arguments.length > 2 && arguments[2] !== void 0 /* _TimeoutDuration.ACK */  ? arguments[2] : 50;
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var messageChannel, completionTimer, handler;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
                        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var eventId = $0021d6672f58c7eb$export$9f4f30ee63539e24("", 20);
                                messageChannel.port1.start();
                                var ackTimer = setTimeout(function() {
                                    reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
                                }, timeout);
                                handler = {
                                    messageChannel: messageChannel,
                                    onMessage: function(event) {
                                        var messageEvent = event;
                                        if (messageEvent.data.eventId !== eventId) return;
                                        switch(messageEvent.data.status){
                                            case "ack" /* _Status.ACK */ :
                                                // The receiver should ACK first.
                                                clearTimeout(ackTimer);
                                                completionTimer = setTimeout(function() {
                                                    reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                                                }, 3000 /* _TimeoutDuration.COMPLETION */ );
                                                break;
                                            case "done" /* _Status.DONE */ :
                                                // Once the receiver's handlers are finished we will get the results.
                                                clearTimeout(completionTimer);
                                                resolve(messageEvent.data.response);
                                                break;
                                            default:
                                                clearTimeout(ackTimer);
                                                clearTimeout(completionTimer);
                                                reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                                                break;
                                        }
                                    }
                                };
                                _this.handlers.add(handler);
                                messageChannel.port1.addEventListener("message", handler.onMessage);
                                _this.target.postMessage({
                                    eventType: eventType,
                                    eventId: eventId,
                                    data: data
                                }, [
                                    messageChannel.port2
                                ]);
                            }).finally(function() {
                                if (handler) _this.removeMessageHandler(handler);
                            })
                        ];
                    });
                })();
            }
        }
    ]);
    return Sender;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $0021d6672f58c7eb$var$_window() {
    return window;
}
function $0021d6672f58c7eb$var$_setWindowLocation(url) {
    $0021d6672f58c7eb$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$_isWorker() {
    return typeof $0021d6672f58c7eb$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $0021d6672f58c7eb$var$_window()["importScripts"] === "function";
}
function $0021d6672f58c7eb$var$_getActiveServiceWorker() {
    return $0021d6672f58c7eb$var$__getActiveServiceWorker.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__getActiveServiceWorker() {
    $0021d6672f58c7eb$var$__getActiveServiceWorker = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var registration, _a;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return [
                        2,
                        null
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        navigator.serviceWorker.ready
                    ];
                case 2:
                    registration = _state.sent();
                    return [
                        2,
                        registration.active
                    ];
                case 3:
                    _a = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__getActiveServiceWorker.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $0021d6672f58c7eb$var$_getWorkerGlobalScope() {
    return $0021d6672f58c7eb$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$DB_NAME = "firebaseLocalStorageDb";
var $0021d6672f58c7eb$var$DB_VERSION = 1;
var $0021d6672f58c7eb$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
var $0021d6672f58c7eb$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ var $0021d6672f58c7eb$var$DBPromise = /*#__PURE__*/ function() {
    "use strict";
    function DBPromise(request) {
        (0, $978gY._)(this, DBPromise);
        this.request = request;
    }
    (0, $kry2a._)(DBPromise, [
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    _this.request.addEventListener("success", function() {
                        resolve(_this.request.result);
                    });
                    _this.request.addEventListener("error", function() {
                        reject(_this.request.error);
                    });
                });
            }
        }
    ]);
    return DBPromise;
}();
function $0021d6672f58c7eb$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $0021d6672f58c7eb$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($0021d6672f58c7eb$var$DB_OBJECTSTORE_NAME);
}
function $0021d6672f58c7eb$var$_deleteDatabase() {
    var request = indexedDB.deleteDatabase($0021d6672f58c7eb$var$DB_NAME);
    return new $0021d6672f58c7eb$var$DBPromise(request).toPromise();
}
function $0021d6672f58c7eb$var$_openDatabase() {
    var request = indexedDB.open($0021d6672f58c7eb$var$DB_NAME, $0021d6672f58c7eb$var$DB_VERSION);
    return new Promise(function(resolve, reject) {
        request.addEventListener("error", function() {
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", function() {
            var db = request.result;
            try {
                db.createObjectStore($0021d6672f58c7eb$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $0021d6672f58c7eb$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", /*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            var db;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        db = request.result;
                        if (!!db.objectStoreNames.contains($0021d6672f58c7eb$var$DB_OBJECTSTORE_NAME)) return [
                            3,
                            3
                        ];
                        // Need to close the database or else you get a `blocked` event
                        db.close();
                        return [
                            4,
                            $0021d6672f58c7eb$var$_deleteDatabase()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            $0021d6672f58c7eb$var$_openDatabase()
                        ];
                    case 2:
                        resolve.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        resolve(db);
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }));
    });
}
function $0021d6672f58c7eb$var$_putObject(db, key, value) {
    return $0021d6672f58c7eb$var$__putObject.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__putObject() {
    $0021d6672f58c7eb$var$__putObject = (0, $869ea882f885334a$export$7c398597f8905a1)(function(db, key, value) {
        var _obj, request;
        return (0, $7UAGh.__generator)(this, function(_state) {
            request = $0021d6672f58c7eb$var$getObjectStore(db, true).put((_obj = {}, (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, $0021d6672f58c7eb$var$DB_DATA_KEYPATH, key), (0, $9dcc00a39e7f7954$export$1e71eb4bef00f6b0)(_obj, "value", value), _obj));
            return [
                2,
                new $0021d6672f58c7eb$var$DBPromise(request).toPromise()
            ];
        });
    });
    return $0021d6672f58c7eb$var$__putObject.apply(this, arguments);
}
function $0021d6672f58c7eb$var$getObject(db, key) {
    return $0021d6672f58c7eb$var$_getObject.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getObject() {
    $0021d6672f58c7eb$var$_getObject = (0, $869ea882f885334a$export$7c398597f8905a1)(function(db, key) {
        var request, data;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = $0021d6672f58c7eb$var$getObjectStore(db, false).get(key);
                    return [
                        4,
                        new $0021d6672f58c7eb$var$DBPromise(request).toPromise()
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data === undefined ? null : data.value
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_getObject.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_deleteObject(db, key) {
    var request = $0021d6672f58c7eb$var$getObjectStore(db, true).delete(key);
    return new $0021d6672f58c7eb$var$DBPromise(request).toPromise();
}
var $0021d6672f58c7eb$var$_POLLING_INTERVAL_MS = 800;
var $0021d6672f58c7eb$var$_TRANSACTION_RETRY_COUNT = 3;
var $0021d6672f58c7eb$var$IndexedDBLocalPersistence = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDBLocalPersistence() {
        (0, $978gY._)(this, IndexedDBLocalPersistence);
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(function() {}, function() {});
    }
    (0, $kry2a._)(IndexedDBLocalPersistence, [
        {
            key: "_openDb",
            value: function _openDb() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.db) return [
                                    2,
                                    _this.db
                                ];
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_openDatabase()
                                ];
                            case 1:
                                _this.db = _state.sent();
                                return [
                                    2,
                                    _this.db
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withRetries",
            value: function _withRetries(op) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var numAttempts, db, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                numAttempts = 0;
                                _state.label = 1;
                            case 1:
                                if (!true) return [
                                    3,
                                    7
                                ];
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this._openDb()
                                ];
                            case 3:
                                db = _state.sent();
                                return [
                                    4,
                                    op(db)
                                ];
                            case 4:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 5:
                                e = _state.sent();
                                if (numAttempts++ > $0021d6672f58c7eb$var$_TRANSACTION_RETRY_COUNT) throw e;
                                if (_this.db) {
                                    _this.db.close();
                                    _this.db = undefined;
                                }
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    3,
                                    1
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initializeServiceWorkerMessaging",
            value: /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ function initializeServiceWorkerMessaging() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            $0021d6672f58c7eb$var$_isWorker() ? _this.initializeReceiver() : _this.initializeSender()
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeReceiver",
            value: /**
     * As the worker we should listen to events from the main window.
     */ function initializeReceiver() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this.receiver = $0021d6672f58c7eb$var$Receiver._getInstance($0021d6672f58c7eb$var$_getWorkerGlobalScope());
                        // Refresh from persistence if we receive a KeyChanged message.
                        _this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , function() {
                            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(_origin, data) {
                                var keys;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._poll()
                                            ];
                                        case 1:
                                            keys = _state.sent();
                                            return [
                                                2,
                                                {
                                                    keyProcessed: keys.includes(data.key)
                                                }
                                            ];
                                    }
                                });
                            });
                            return function(_origin, data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        // Let the sender know that we are listening so they give us more timeout.
                        _this.receiver._subscribe("ping" /* _EventType.PING */ , function() {
                            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(_origin, _data) {
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    return [
                                        2,
                                        [
                                            "keyChanged" /* _EventType.KEY_CHANGED */ 
                                        ]
                                    ];
                                });
                            });
                            return function(_origin, _data) {
                                return _ref.apply(this, arguments);
                            };
                        }());
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "initializeSender",
            value: /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ function initializeSender() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, _b, results;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_getActiveServiceWorker()
                                ];
                            case 1:
                                // Check to see if there's an active service worker.
                                _this.activeServiceWorker = _state.sent();
                                if (!_this.activeServiceWorker) return [
                                    2
                                ];
                                _this.sender = new $0021d6672f58c7eb$var$Sender(_this.activeServiceWorker);
                                return [
                                    4,
                                    _this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ )
                                ];
                            case 2:
                                results = _state.sent();
                                if (!results) return [
                                    2
                                ];
                                if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) _this.serviceWorkerReceiverAvailable = true;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyServiceWorker",
            value: /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ function notifyServiceWorker(key) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this.sender || !_this.activeServiceWorker || $0021d6672f58c7eb$var$_getServiceWorkerController() !== _this.activeServiceWorker) return [
                                    2
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                                        key: key
                                    }, // Use long timeout if receiver has previously responded to a ping from us.
                                    _this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ )
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _a = _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isAvailable",
            value: function _isAvailable() {
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var db, _a;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                if (!indexedDB) return [
                                    2,
                                    false
                                ];
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_openDatabase()
                                ];
                            case 1:
                                db = _state.sent();
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_putObject(db, $0021d6672f58c7eb$var$STORAGE_AVAILABLE_KEY, "1")
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_deleteObject(db, $0021d6672f58c7eb$var$STORAGE_AVAILABLE_KEY)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    2,
                                    true
                                ];
                            case 4:
                                _a = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2,
                                    false
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_withPendingWrite",
            value: function _withPendingWrite(write) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.pendingWrites++;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                return [
                                    4,
                                    write()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                _this.pendingWrites--;
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_set",
            value: function _set(key, value) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $0021d6672f58c7eb$var$_putObject(db, key, value);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            _this.localCache[key] = value;
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_get",
            value: function _get(key) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var obj;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        return $0021d6672f58c7eb$var$getObject(db, key);
                                    })
                                ];
                            case 1:
                                obj = _state.sent();
                                _this.localCache[key] = obj;
                                return [
                                    2,
                                    obj
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_remove",
            value: function _remove(key) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._withPendingWrite(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                _this._withRetries(function(db) {
                                                    return $0021d6672f58c7eb$var$_deleteObject(db, key);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            delete _this.localCache[key];
                                            return [
                                                2,
                                                _this.notifyServiceWorker(key)
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                })();
            }
        },
        {
            key: "_poll",
            value: function _poll() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var result, keys, keysInResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, localKey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._withRetries(function(db) {
                                        var getAllRequest = $0021d6672f58c7eb$var$getObjectStore(db, false).getAll();
                                        return new $0021d6672f58c7eb$var$DBPromise(getAllRequest).toPromise();
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result) return [
                                    2,
                                    []
                                ];
                                // If we have pending writes in progress abort, we'll get picked up on the next poll
                                if (_this.pendingWrites !== 0) return [
                                    2,
                                    []
                                ];
                                keys = [];
                                keysInResult = new Set();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = result[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = _step.value, key = _step_value.fbase_key, value = _step_value.value;
                                        keysInResult.add(key);
                                        if (JSON.stringify(_this.localCache[key]) !== JSON.stringify(value)) {
                                            _this.notifyListeners(key, value);
                                            keys.push(key);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = Object.keys(_this.localCache)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        localKey = _step1.value;
                                        if (_this.localCache[localKey] && !keysInResult.has(localKey)) {
                                            // Deleted
                                            _this.notifyListeners(localKey, null);
                                            keys.push(localKey);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    keys
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(key, newValue) {
                this.localCache[key] = newValue;
                var listeners = this.listeners[key];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (listeners) try {
                    for(var _iterator = Array.from(listeners)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        listener(newValue);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "startPolling",
            value: function startPolling() {
                this.stopPolling();
                var _this = this;
                this.pollTimer = setInterval(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this._poll()
                        ];
                    });
                }), $0021d6672f58c7eb$var$_POLLING_INTERVAL_MS);
            }
        },
        {
            key: "stopPolling",
            value: function stopPolling() {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        {
            key: "_addListener",
            value: function _addListener(key, listener) {
                if (Object.keys(this.listeners).length === 0) this.startPolling();
                if (!this.listeners[key]) {
                    this.listeners[key] = new Set();
                    this._get(key); // This can happen in the background async and we can return immediately.
                }
                this.listeners[key].add(listener);
            }
        },
        {
            key: "_removeListener",
            value: function _removeListener(key, listener) {
                if (this.listeners[key]) {
                    this.listeners[key].delete(listener);
                    if (this.listeners[key].size === 0) delete this.listeners[key];
                }
                if (Object.keys(this.listeners).length === 0) this.stopPolling();
            }
        }
    ]);
    return IndexedDBLocalPersistence;
}();
$0021d6672f58c7eb$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ var $0021d6672f58c7eb$export$23f2a1d2818174ef = $0021d6672f58c7eb$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$startSignInPhoneMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
function $0021d6672f58c7eb$var$finalizeSignInPhoneMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
function $0021d6672f58c7eb$var$finalizeSignInTotpMfa(auth, request) {
    return $0021d6672f58c7eb$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $0021d6672f58c7eb$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$_SOLVE_TIME_MS = 500;
var $0021d6672f58c7eb$var$_EXPIRATION_TIME_MS = 60000;
var $0021d6672f58c7eb$var$_WIDGET_ID_START = 1000000000000;
var $0021d6672f58c7eb$var$MockReCaptcha = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptcha(auth) {
        (0, $978gY._)(this, MockReCaptcha);
        this.auth = auth;
        this.counter = $0021d6672f58c7eb$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    (0, $kry2a._)(MockReCaptcha, [
        {
            key: "render",
            value: function render(container, parameters) {
                var id = this.counter;
                this._widgets.set(id, new $0021d6672f58c7eb$var$MockWidget(container, this.auth.name, parameters || {}));
                this.counter++;
                return id;
            }
        },
        {
            key: "reset",
            value: function reset(optWidgetId) {
                var _a;
                var id = optWidgetId || $0021d6672f58c7eb$var$_WIDGET_ID_START;
                (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
                this._widgets.delete(id);
            }
        },
        {
            key: "getResponse",
            value: function getResponse(optWidgetId) {
                var _a;
                var id = optWidgetId || $0021d6672f58c7eb$var$_WIDGET_ID_START;
                return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
            }
        },
        {
            key: "execute",
            value: function execute(optWidgetId) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, id;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        id = optWidgetId || $0021d6672f58c7eb$var$_WIDGET_ID_START;
                        (_a = _this._widgets.get(id)) === null || _a === void 0 || _a.execute();
                        return [
                            2,
                            ""
                        ];
                    });
                })();
            }
        }
    ]);
    return MockReCaptcha;
}();
var $0021d6672f58c7eb$var$MockWidget = /*#__PURE__*/ function() {
    "use strict";
    function MockWidget(containerOrId, appName, params) {
        var _this = this;
        (0, $978gY._)(this, MockWidget);
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = function() {
            _this.execute();
        };
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $0021d6672f58c7eb$export$9d398bebfec1c039(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    (0, $kry2a._)(MockWidget, [
        {
            key: "getResponse",
            value: function getResponse() {
                this.checkIfDeleted();
                return this.responseToken;
            }
        },
        {
            key: "delete",
            value: function _delete() {
                this.checkIfDeleted();
                this.deleted = true;
                if (this.timerId) {
                    clearTimeout(this.timerId);
                    this.timerId = null;
                }
                this.container.removeEventListener("click", this.clickHandler);
            }
        },
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                this.checkIfDeleted();
                if (this.timerId) return;
                this.timerId = window.setTimeout(function() {
                    _this.responseToken = $0021d6672f58c7eb$var$generateRandomAlphaNumericString(50);
                    var _this_params = _this.params, callback = _this_params.callback, expiredCallback = _this_params["expired-callback"];
                    if (callback) try {
                        callback(_this.responseToken);
                    } catch (e) {}
                    _this.timerId = window.setTimeout(function() {
                        _this.timerId = null;
                        _this.responseToken = null;
                        if (expiredCallback) try {
                            expiredCallback();
                        } catch (e) {}
                        if (_this.isVisible) _this.execute();
                    }, $0021d6672f58c7eb$var$_EXPIRATION_TIME_MS);
                }, $0021d6672f58c7eb$var$_SOLVE_TIME_MS);
            }
        },
        {
            key: "checkIfDeleted",
            value: function checkIfDeleted() {
                if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
            }
        }
    ]);
    return MockWidget;
}();
function $0021d6672f58c7eb$var$generateRandomAlphaNumericString(len) {
    var chars = [];
    var allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(var i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
var $0021d6672f58c7eb$var$_JSLOAD_CALLBACK = $0021d6672f58c7eb$var$_generateCallbackName("rcb");
var $0021d6672f58c7eb$var$NETWORK_TIMEOUT_DELAY = new $0021d6672f58c7eb$var$Delay(30000, 60000);
var $0021d6672f58c7eb$var$RECAPTCHA_BASE = "https://www.google.com/recaptcha/api.js?";
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ var $0021d6672f58c7eb$var$ReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function ReCaptchaLoaderImpl() {
        (0, $978gY._)(this, ReCaptchaLoaderImpl);
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $0021d6672f58c7eb$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    (0, $kry2a._)(ReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                var hl = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var _this = this;
                $0021d6672f58c7eb$export$9d398bebfec1c039($0021d6672f58c7eb$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                if (this.shouldResolveImmediately(hl) && $0021d6672f58c7eb$var$isV2($0021d6672f58c7eb$var$_window().grecaptcha)) return Promise.resolve($0021d6672f58c7eb$var$_window().grecaptcha);
                return new Promise(function(resolve, reject) {
                    var networkTimeout = $0021d6672f58c7eb$var$_window().setTimeout(function() {
                        reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                    }, $0021d6672f58c7eb$var$NETWORK_TIMEOUT_DELAY.get());
                    $0021d6672f58c7eb$var$_window()[$0021d6672f58c7eb$var$_JSLOAD_CALLBACK] = function() {
                        $0021d6672f58c7eb$var$_window().clearTimeout(networkTimeout);
                        delete $0021d6672f58c7eb$var$_window()[$0021d6672f58c7eb$var$_JSLOAD_CALLBACK];
                        var recaptcha = $0021d6672f58c7eb$var$_window().grecaptcha;
                        if (!recaptcha || !$0021d6672f58c7eb$var$isV2(recaptcha)) {
                            reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                            return;
                        }
                        // Wrap the greptcha render function so that we know if the developer has
                        // called it separately
                        var render = recaptcha.render;
                        recaptcha.render = function(container, params) {
                            var widgetId = render(container, params);
                            _this.counter++;
                            return widgetId;
                        };
                        _this.hostLanguage = hl;
                        resolve(recaptcha);
                    };
                    var url = "".concat($0021d6672f58c7eb$var$RECAPTCHA_BASE, "?").concat((0, $b1467a785fc7cec5$export$ac4103b836844853)({
                        onload: $0021d6672f58c7eb$var$_JSLOAD_CALLBACK,
                        render: "explicit",
                        hl: hl
                    }));
                    $0021d6672f58c7eb$var$_loadJS(url).catch(function() {
                        clearTimeout(networkTimeout);
                        reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    });
                });
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {
                this.counter--;
            }
        },
        {
            key: "shouldResolveImmediately",
            value: function shouldResolveImmediately(hl) {
                var _a;
                // We can resolve immediately if:
                //   • grecaptcha is already defined AND (
                //     1. the requested language codes are the same OR
                //     2. there exists already a ReCaptcha on the page
                //     3. the library was already loaded by the app
                // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
                // that are already in the page
                return !!((_a = $0021d6672f58c7eb$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
            }
        }
    ]);
    return ReCaptchaLoaderImpl;
}();
function $0021d6672f58c7eb$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
var $0021d6672f58c7eb$var$MockReCaptchaLoaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function MockReCaptchaLoaderImpl() {
        (0, $978gY._)(this, MockReCaptchaLoaderImpl);
    }
    (0, $kry2a._)(MockReCaptchaLoaderImpl, [
        {
            key: "load",
            value: function load(auth) {
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            new $0021d6672f58c7eb$var$MockReCaptcha(auth)
                        ];
                    });
                })();
            }
        },
        {
            key: "clearedOneInstance",
            value: function clearedOneInstance() {}
        }
    ]);
    return MockReCaptchaLoaderImpl;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
var $0021d6672f58c7eb$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ var $0021d6672f58c7eb$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    "use strict";
    function RecaptchaVerifier(authExtern, containerOrId) {
        var parameters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Object.assign({}, $0021d6672f58c7eb$var$DEFAULT_PARAMS);
        (0, $978gY._)(this, RecaptchaVerifier);
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $0021d6672f58c7eb$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $0021d6672f58c7eb$export$b9a6b53f9be3734(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $0021d6672f58c7eb$export$9d398bebfec1c039(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        var container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $0021d6672f58c7eb$export$9d398bebfec1c039(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $0021d6672f58c7eb$var$MockReCaptchaLoaderImpl() : new $0021d6672f58c7eb$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    }
    (0, $kry2a._)(RecaptchaVerifier, [
        {
            key: "verify",
            value: /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ function verify() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var id, recaptcha, response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertNotDestroyed();
                                return [
                                    4,
                                    _this.render()
                                ];
                            case 1:
                                id = _state.sent();
                                recaptcha = _this.getAssertedRecaptcha();
                                response = recaptcha.getResponse(id);
                                if (response) return [
                                    2,
                                    response
                                ];
                                return [
                                    2,
                                    new Promise(function(resolve) {
                                        var tokenChange = function(token) {
                                            if (!token) return; // Ignore token expirations.
                                            _this.tokenChangeListeners.delete(tokenChange);
                                            resolve(token);
                                        };
                                        _this.tokenChangeListeners.add(tokenChange);
                                        if (_this.isInvisible) recaptcha.execute(id);
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ key: "render",
            value: function render() {
                var _this = this;
                try {
                    this.assertNotDestroyed();
                } catch (e) {
                    // This method returns a promise. Since it's not async (we want to return the
                    // _same_ promise if rendering is still occurring), the API surface should
                    // reject with the error rather than just throw
                    return Promise.reject(e);
                }
                if (this.renderPromise) return this.renderPromise;
                this.renderPromise = this.makeRenderPromise().catch(function(e) {
                    _this.renderPromise = null;
                    throw e;
                });
                return this.renderPromise;
            }
        },
        {
            /** @internal */ key: "_reset",
            value: function _reset() {
                this.assertNotDestroyed();
                if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
            }
        },
        {
            /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ key: "clear",
            value: function clear() {
                var _this = this;
                this.assertNotDestroyed();
                this.destroyed = true;
                this._recaptchaLoader.clearedOneInstance();
                if (!this.isInvisible) this.container.childNodes.forEach(function(node) {
                    _this.container.removeChild(node);
                });
            }
        },
        {
            key: "validateStartingState",
            value: function validateStartingState() {
                $0021d6672f58c7eb$export$9d398bebfec1c039(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $0021d6672f58c7eb$export$9d398bebfec1c039(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                $0021d6672f58c7eb$export$9d398bebfec1c039(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
            }
        },
        {
            key: "makeTokenCallback",
            value: function makeTokenCallback(existing) {
                var _this = this;
                return function(token) {
                    _this.tokenChangeListeners.forEach(function(listener) {
                        return listener(token);
                    });
                    if (typeof existing === "function") existing(token);
                    else if (typeof existing === "string") {
                        var globalFunc = $0021d6672f58c7eb$var$_window()[existing];
                        if (typeof globalFunc === "function") globalFunc(token);
                    }
                };
            }
        },
        {
            key: "assertNotDestroyed",
            value: function assertNotDestroyed() {
                $0021d6672f58c7eb$export$9d398bebfec1c039(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        },
        {
            key: "makeRenderPromise",
            value: function makeRenderPromise() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var container, guaranteedEmpty;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.init()
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.widgetId) {
                                    container = _this.container;
                                    if (!_this.isInvisible) {
                                        guaranteedEmpty = document.createElement("div");
                                        container.appendChild(guaranteedEmpty);
                                        container = guaranteedEmpty;
                                    }
                                    _this.widgetId = _this.getAssertedRecaptcha().render(container, _this.parameters);
                                }
                                return [
                                    2,
                                    _this.widgetId
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var siteKey;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $0021d6672f58c7eb$export$9d398bebfec1c039($0021d6672f58c7eb$var$_isHttpOrHttps() && !$0021d6672f58c7eb$var$_isWorker(), _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$domReady()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this._recaptchaLoader.load(_this.auth, _this.auth.languageCode || undefined)
                                ];
                            case 2:
                                _this.recaptcha = _state.sent();
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$getRecaptchaParams(_this.auth)
                                ];
                            case 3:
                                siteKey = _state.sent();
                                $0021d6672f58c7eb$export$9d398bebfec1c039(siteKey, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                _this.parameters.sitekey = siteKey;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getAssertedRecaptcha",
            value: function getAssertedRecaptcha() {
                $0021d6672f58c7eb$export$9d398bebfec1c039(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                return this.recaptcha;
            }
        }
    ]);
    return RecaptchaVerifier;
}();
function $0021d6672f58c7eb$var$domReady() {
    var resolver = null;
    return new Promise(function(resolve) {
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = function() {
            return resolve();
        };
        window.addEventListener("load", resolver);
    }).catch(function(e) {
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$ConfirmationResultImpl = /*#__PURE__*/ function() {
    "use strict";
    function ConfirmationResultImpl(verificationId, onConfirmation) {
        (0, $978gY._)(this, ConfirmationResultImpl);
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    (0, $kry2a._)(ConfirmationResultImpl, [
        {
            key: "confirm",
            value: function confirm(verificationCode) {
                var authCredential = $0021d6672f58c7eb$export$a07804094c3ecf2d._fromVerification(this.verificationId, verificationCode);
                return this.onConfirmation(authCredential);
            }
        }
    ]);
    return ConfirmationResultImpl;
}();
function $0021d6672f58c7eb$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    return $0021d6672f58c7eb$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithPhoneNumber() {
    $0021d6672f58c7eb$var$_signInWithPhoneNumber = /**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, phoneNumber, appVerifier) {
        var authInternal, verificationId;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $0021d6672f58c7eb$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $0021d6672f58c7eb$export$34aec0b863436764(authInternal, cred);
                        })
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_signInWithPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    return $0021d6672f58c7eb$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_linkWithPhoneNumber() {
    $0021d6672f58c7eb$var$_linkWithPhoneNumber = /**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ )
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(appVerifier))
                    ];
                case 2:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $0021d6672f58c7eb$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $0021d6672f58c7eb$export$3c2fa207a37baaea(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_linkWithPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    return $0021d6672f58c7eb$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_reauthenticateWithPhoneNumber() {
    $0021d6672f58c7eb$var$_reauthenticateWithPhoneNumber = /**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, phoneNumber, appVerifier) {
        var userInternal, verificationId;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(appVerifier))
                    ];
                case 1:
                    verificationId = _state.sent();
                    return [
                        2,
                        new $0021d6672f58c7eb$var$ConfirmationResultImpl(verificationId, function(cred) {
                            return $0021d6672f58c7eb$export$ce26c07117d59d6a(userInternal, cred);
                        })
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_reauthenticateWithPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_verifyPhoneNumber(auth, options, verifier) {
    return $0021d6672f58c7eb$var$__verifyPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__verifyPhoneNumber() {
    $0021d6672f58c7eb$var$__verifyPhoneNumber = /**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, options, verifier) {
        var _a, recaptchaToken, phoneInfoOptions, session, response, mfaEnrollmentId, response1, sessionInfo;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        verifier.verify()
                    ];
                case 1:
                    recaptchaToken = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        ,
                        10,
                        11
                    ]);
                    $0021d6672f58c7eb$export$9d398bebfec1c039(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    $0021d6672f58c7eb$export$9d398bebfec1c039(verifier.type === $0021d6672f58c7eb$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    if (typeof options === "string") phoneInfoOptions = {
                        phoneNumber: options
                    };
                    else phoneInfoOptions = options;
                    if (!("session" in phoneInfoOptions)) return [
                        3,
                        7
                    ];
                    session = phoneInfoOptions.session;
                    if (!("phoneNumber" in phoneInfoOptions)) return [
                        3,
                        4
                    ];
                    $0021d6672f58c7eb$export$9d398bebfec1c039(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        4,
                        $0021d6672f58c7eb$var$startEnrollPhoneMfa(auth, {
                            idToken: session.credential,
                            phoneEnrollmentInfo: {
                                phoneNumber: phoneInfoOptions.phoneNumber,
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        response.phoneSessionInfo.sessionInfo
                    ];
                case 4:
                    $0021d6672f58c7eb$export$9d398bebfec1c039(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                    $0021d6672f58c7eb$export$9d398bebfec1c039(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                    return [
                        4,
                        $0021d6672f58c7eb$var$startSignInPhoneMfa(auth, {
                            mfaPendingCredential: session.credential,
                            mfaEnrollmentId: mfaEnrollmentId,
                            phoneSignInInfo: {
                                recaptchaToken: recaptchaToken
                            }
                        })
                    ];
                case 5:
                    response1 = _state.sent();
                    return [
                        2,
                        response1.phoneResponseInfo.sessionInfo
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    return [
                        4,
                        $0021d6672f58c7eb$var$sendPhoneVerificationCode(auth, {
                            phoneNumber: phoneInfoOptions.phoneNumber,
                            recaptchaToken: recaptchaToken
                        })
                    ];
                case 8:
                    sessionInfo = _state.sent().sessionInfo;
                    return [
                        2,
                        sessionInfo
                    ];
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    verifier._reset();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__verifyPhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$export$3b14a55fb2447963(user, credential) {
    return $0021d6672f58c7eb$var$_updatePhoneNumber.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_updatePhoneNumber() {
    $0021d6672f58c7eb$var$_updatePhoneNumber = /**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, credential) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$_link$1((0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user), credential)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_updatePhoneNumber.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ var $0021d6672f58c7eb$export$56c0d5a1e737357d = /*#__PURE__*/ function() {
    "use strict";
    function PhoneAuthProvider(auth) {
        (0, $978gY._)(this, PhoneAuthProvider);
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
    }
    (0, $kry2a._)(PhoneAuthProvider, [
        {
            /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ key: "verifyPhoneNumber",
            value: function verifyPhoneNumber(phoneOptions, applicationVerifier) {
                return $0021d6672f58c7eb$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(applicationVerifier));
            }
        }
    ], [
        {
            key: "credential",
            value: /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ function credential(verificationId, verificationCode) {
                return $0021d6672f58c7eb$export$a07804094c3ecf2d._fromVerification(verificationId, verificationCode);
            }
        },
        {
            key: "credentialFromResult",
            value: /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ function credentialFromResult(userCredential) {
                var credential = userCredential;
                return PhoneAuthProvider.credentialFromTaggedObject(credential);
            }
        },
        {
            key: "credentialFromError",
            value: /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ function credentialFromError(error) {
                return PhoneAuthProvider.credentialFromTaggedObject(error.customData || {});
            }
        },
        {
            key: "credentialFromTaggedObject",
            value: function credentialFromTaggedObject(param) {
                var tokenResponse = param._tokenResponse;
                if (!tokenResponse) return null;
                var phoneNumber = tokenResponse.phoneNumber, temporaryProof = tokenResponse.temporaryProof;
                if (phoneNumber && temporaryProof) return $0021d6672f58c7eb$export$a07804094c3ecf2d._fromTokenResponse(phoneNumber, temporaryProof);
                return null;
            }
        }
    ]);
    return PhoneAuthProvider;
}();
/** Always set to {@link ProviderId}.PHONE. */ $0021d6672f58c7eb$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $0021d6672f58c7eb$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $0021d6672f58c7eb$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $0021d6672f58c7eb$export$24baa2b76016ce0e(resolverOverride);
    $0021d6672f58c7eb$export$9d398bebfec1c039(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$IdpCredential = /*#__PURE__*/ function(AuthCredential) {
    "use strict";
    (0, $ftJVG._)(IdpCredential, AuthCredential);
    var _super = (0, $6OZAO._)(IdpCredential);
    function IdpCredential(params) {
        (0, $978gY._)(this, IdpCredential);
        var _this;
        _this = _super.call(this, "custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        _this.params = params;
        return _this;
    }
    (0, $kry2a._)(IdpCredential, [
        {
            key: "_getIdTokenResponse",
            value: function _getIdTokenResponse(auth) {
                return $0021d6672f58c7eb$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_linkToIdToken",
            value: function _linkToIdToken(auth, idToken) {
                return $0021d6672f58c7eb$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
            }
        },
        {
            key: "_getReauthenticationResolver",
            value: function _getReauthenticationResolver(auth) {
                return $0021d6672f58c7eb$var$signInWithIdp(auth, this._buildIdpRequest());
            }
        },
        {
            key: "_buildIdpRequest",
            value: function _buildIdpRequest(idToken) {
                var request = {
                    requestUri: this.params.requestUri,
                    sessionId: this.params.sessionId,
                    postBody: this.params.postBody,
                    tenantId: this.params.tenantId,
                    pendingToken: this.params.pendingToken,
                    returnSecureToken: true,
                    returnIdpCredential: true
                };
                if (idToken) request.idToken = idToken;
                return request;
            }
        }
    ]);
    return IdpCredential;
}($0021d6672f58c7eb$export$3466f893ebf79586);
function $0021d6672f58c7eb$var$_signIn(params) {
    return $0021d6672f58c7eb$var$_signInWithCredential(params.auth, new $0021d6672f58c7eb$var$IdpCredential(params), params.bypassAuthState);
}
function $0021d6672f58c7eb$var$_reauth(params) {
    var auth = params.auth, user = params.user;
    $0021d6672f58c7eb$export$9d398bebfec1c039(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $0021d6672f58c7eb$var$_reauthenticate(user, new $0021d6672f58c7eb$var$IdpCredential(params), params.bypassAuthState);
}
function $0021d6672f58c7eb$var$_link(params) {
    return $0021d6672f58c7eb$var$__link.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__link() {
    $0021d6672f58c7eb$var$__link = (0, $869ea882f885334a$export$7c398597f8905a1)(function(params) {
        var auth, user;
        return (0, $7UAGh.__generator)(this, function(_state) {
            auth = params.auth, user = params.user;
            $0021d6672f58c7eb$export$9d398bebfec1c039(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            return [
                2,
                $0021d6672f58c7eb$var$_link$1(user, new $0021d6672f58c7eb$var$IdpCredential(params), params.bypassAuthState)
            ];
        });
    });
    return $0021d6672f58c7eb$var$__link.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ var $0021d6672f58c7eb$var$AbstractPopupRedirectOperation = /*#__PURE__*/ function() {
    "use strict";
    function AbstractPopupRedirectOperation(auth, filter, resolver, user) {
        var bypassAuthState = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        (0, $978gY._)(this, AbstractPopupRedirectOperation);
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    (0, $kry2a._)(AbstractPopupRedirectOperation, [
        {
            key: "execute",
            value: function execute() {
                var _this = this;
                return new Promise(function() {
                    var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(resolve, reject) {
                        var e;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this.pendingPromise = {
                                        resolve: resolve,
                                        reject: reject
                                    };
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        4,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        _this.resolver._initialize(_this.auth)
                                    ];
                                case 2:
                                    _this.eventManager = _state.sent();
                                    return [
                                        4,
                                        _this.onExecution()
                                    ];
                                case 3:
                                    _state.sent();
                                    _this.eventManager.registerConsumer(_this);
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    e = _state.sent();
                                    _this.reject(e);
                                    return [
                                        3,
                                        5
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(resolve, reject) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var urlResponse, sessionId, postBody, tenantId, error, type, params, _, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                urlResponse = event.urlResponse, sessionId = event.sessionId, postBody = event.postBody, tenantId = event.tenantId, error = event.error, type = event.type;
                                if (error) {
                                    _this.reject(error);
                                    return [
                                        2
                                    ];
                                }
                                params = {
                                    auth: _this.auth,
                                    requestUri: urlResponse,
                                    sessionId: sessionId,
                                    tenantId: tenantId || undefined,
                                    postBody: postBody || undefined,
                                    user: _this.user,
                                    bypassAuthState: _this.bypassAuthState
                                };
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                _ = _this.resolve;
                                return [
                                    4,
                                    _this.getIdpTask(type)(params)
                                ];
                            case 2:
                                _.apply(_this, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                _this.reject(e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onError",
            value: function onError(error) {
                this.reject(error);
            }
        },
        {
            key: "getIdpTask",
            value: function getIdpTask(type) {
                switch(type){
                    case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
                    case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                        return $0021d6672f58c7eb$var$_signIn;
                    case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
                    case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                        return $0021d6672f58c7eb$var$_link;
                    case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
                    case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                        return $0021d6672f58c7eb$var$_reauth;
                    default:
                        $0021d6672f58c7eb$export$92108d983e8ee699(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }
            }
        },
        {
            key: "resolve",
            value: function resolve(cred) {
                $0021d6672f58c7eb$export$493d36ec626b6698(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.resolve(cred);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "reject",
            value: function reject(error) {
                $0021d6672f58c7eb$export$493d36ec626b6698(this.pendingPromise, "Pending promise was never set");
                this.pendingPromise.reject(error);
                this.unregisterAndCleanUp();
            }
        },
        {
            key: "unregisterAndCleanUp",
            value: function unregisterAndCleanUp() {
                if (this.eventManager) this.eventManager.unregisterConsumer(this);
                this.pendingPromise = null;
                this.cleanUp();
            }
        }
    ]);
    return AbstractPopupRedirectOperation;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $0021d6672f58c7eb$var$Delay(2000, 10000);
function $0021d6672f58c7eb$export$db3b6bfb95261072(auth, provider, resolver) {
    return $0021d6672f58c7eb$var$_signInWithPopup.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_signInWithPopup() {
    $0021d6672f58c7eb$var$_signInWithPopup = /**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, provider, resolver) {
        var authInternal, resolverInternal, action;
        return (0, $7UAGh.__generator)(this, function(_state) {
            authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
            $0021d6672f58c7eb$var$_assertInstanceOf(auth, provider, $0021d6672f58c7eb$var$FederatedAuthProvider);
            resolverInternal = $0021d6672f58c7eb$var$_withDefaultResolver(authInternal, resolver);
            action = new $0021d6672f58c7eb$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $0021d6672f58c7eb$var$_signInWithPopup.apply(this, arguments);
}
function $0021d6672f58c7eb$export$f1e1789686576879(user, provider, resolver) {
    return $0021d6672f58c7eb$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_reauthenticateWithPopup() {
    $0021d6672f58c7eb$var$_reauthenticateWithPopup = /**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $7UAGh.__generator)(this, function(_state) {
            userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
            $0021d6672f58c7eb$var$_assertInstanceOf(userInternal.auth, provider, $0021d6672f58c7eb$var$FederatedAuthProvider);
            resolverInternal = $0021d6672f58c7eb$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $0021d6672f58c7eb$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $0021d6672f58c7eb$var$_reauthenticateWithPopup.apply(this, arguments);
}
function $0021d6672f58c7eb$export$4368d992c4eafac0(user, provider, resolver) {
    return $0021d6672f58c7eb$var$_linkWithPopup.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_linkWithPopup() {
    $0021d6672f58c7eb$var$_linkWithPopup = /**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, action;
        return (0, $7UAGh.__generator)(this, function(_state) {
            userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
            $0021d6672f58c7eb$var$_assertInstanceOf(userInternal.auth, provider, $0021d6672f58c7eb$var$FederatedAuthProvider);
            resolverInternal = $0021d6672f58c7eb$var$_withDefaultResolver(userInternal.auth, resolver);
            action = new $0021d6672f58c7eb$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
            return [
                2,
                action.executeNotNull()
            ];
        });
    });
    return $0021d6672f58c7eb$var$_linkWithPopup.apply(this, arguments);
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ var $0021d6672f58c7eb$var$PopupOperation = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $ftJVG._)(PopupOperation, AbstractPopupRedirectOperation);
    var _super = (0, $6OZAO._)(PopupOperation);
    function PopupOperation(auth, filter, provider, resolver, user) {
        (0, $978gY._)(this, PopupOperation);
        var _this;
        _this = _super.call(this, auth, filter, resolver, user);
        _this.provider = provider;
        _this.authWindow = null;
        _this.pollId = null;
        if (PopupOperation.currentPopupAction) PopupOperation.currentPopupAction.cancel();
        PopupOperation.currentPopupAction = (0, $3vWwE._)(_this);
        return _this;
    }
    (0, $kry2a._)(PopupOperation, [
        {
            key: "executeNotNull",
            value: function executeNotNull() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var result;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.execute()
                                ];
                            case 1:
                                result = _state.sent();
                                $0021d6672f58c7eb$export$9d398bebfec1c039(result, _this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var eventId;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $0021d6672f58c7eb$export$493d36ec626b6698(_this.filter.length === 1, "Popup operations only handle one event");
                                eventId = $0021d6672f58c7eb$export$9f4f30ee63539e24();
                                return [
                                    4,
                                    _this.resolver._openPopup(_this.auth, _this.provider, _this.filter[0], eventId)
                                ];
                            case 1:
                                _this.authWindow = _state.sent();
                                _this.authWindow.associatedEvent = eventId;
                                // Check for web storage support and origin validation _after_ the popup is
                                // loaded. These operations are slow (~1 second or so) Rather than
                                // waiting on them before opening the window, optimistically open the popup
                                // and check for storage support at the same time. If storage support is
                                // not available, this will cause the whole thing to reject properly. It
                                // will also close the popup, but since the promise has already rejected,
                                // the popup closed by user poll will reject into the void.
                                _this.resolver._originValidation(_this.auth).catch(function(e) {
                                    _this.reject(e);
                                });
                                _this.resolver._isIframeWebStorageSupported(_this.auth, function(isSupported) {
                                    if (!isSupported) _this.reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(_this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
                                });
                                // Handle user closure. Notice this does *not* use await
                                _this.pollUserCancellation();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "eventId",
            get: function get() {
                var _a;
                return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {
                if (this.authWindow) this.authWindow.close();
                if (this.pollId) window.clearTimeout(this.pollId);
                this.authWindow = null;
                this.pollId = null;
                PopupOperation.currentPopupAction = null;
            }
        },
        {
            key: "pollUserCancellation",
            value: function pollUserCancellation() {
                var _this = this;
                var poll = function() {
                    var _a, _b;
                    if ((_b = (_a = _this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                        // Make sure that there is sufficient time for whatever action to
                        // complete. The window could have closed but the sign in network
                        // call could still be in flight. This is specifically true for
                        // Firefox or if the opener is in an iframe, in which case the oauth
                        // helper closes the popup.
                        _this.pollId = window.setTimeout(function() {
                            _this.pollId = null;
                            _this.reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(_this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                        }, 8000 /* _Timeout.AUTH_EVENT */ );
                        return;
                    }
                    _this.pollId = window.setTimeout(poll, $0021d6672f58c7eb$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
                };
                poll();
            }
        }
    ]);
    return PopupOperation;
}($0021d6672f58c7eb$var$AbstractPopupRedirectOperation);
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$0021d6672f58c7eb$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
var $0021d6672f58c7eb$var$redirectOutcomeMap = new Map();
var $0021d6672f58c7eb$var$RedirectAction = /*#__PURE__*/ function(AbstractPopupRedirectOperation) {
    "use strict";
    (0, $ftJVG._)(RedirectAction, AbstractPopupRedirectOperation);
    var _super = (0, $6OZAO._)(RedirectAction);
    function RedirectAction(auth, resolver) {
        var bypassAuthState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        (0, $978gY._)(this, RedirectAction);
        var _this;
        _this = _super.call(this, auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        _this.eventId = null;
        return _this;
    }
    (0, $kry2a._)(RedirectAction, [
        {
            key: "execute",
            value: /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ function execute() {
                var _this = this;
                var _this1 = this, _superprop_get_execute = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(RedirectAction.prototype), "execute", _this);
                };
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var readyOutcome, hasPendingRedirect, result, _tmp, e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                readyOutcome = $0021d6672f58c7eb$var$redirectOutcomeMap.get(_this1.auth._key());
                                if (!!readyOutcome) return [
                                    3,
                                    8
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_getAndClearPendingRedirectStatus(_this1.resolver, _this1.auth)
                                ];
                            case 2:
                                hasPendingRedirect = _state.sent();
                                if (!hasPendingRedirect) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _superprop_get_execute().call(_this1)
                                ];
                            case 3:
                                _tmp = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp = null;
                                _state.label = 5;
                            case 5:
                                result = _tmp;
                                readyOutcome = function() {
                                    return Promise.resolve(result);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                readyOutcome = function() {
                                    return Promise.reject(e);
                                };
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                $0021d6672f58c7eb$var$redirectOutcomeMap.set(_this1.auth._key(), readyOutcome);
                                _state.label = 8;
                            case 8:
                                // If we're not bypassing auth state, the ready outcome should be set to
                                // null.
                                if (!_this1.bypassAuthState) $0021d6672f58c7eb$var$redirectOutcomeMap.set(_this1.auth._key(), function() {
                                    return Promise.resolve(null);
                                });
                                return [
                                    2,
                                    readyOutcome()
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onAuthEvent",
            value: function onAuthEvent(event) {
                var _this = this;
                var _this1 = this, _superprop_get_onAuthEvent = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(RedirectAction.prototype), "onAuthEvent", _this);
                };
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var user;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return [
                                    2,
                                    _superprop_get_onAuthEvent().call(_this1, event)
                                ];
                                else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
                                    // This is a sentinel value indicating there's no pending redirect
                                    _this1.resolve(null);
                                    return [
                                        2
                                    ];
                                }
                                if (!event.eventId) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this1.auth._redirectUserForId(event.eventId)
                                ];
                            case 1:
                                user = _state.sent();
                                if (user) {
                                    _this1.user = user;
                                    return [
                                        2,
                                        _superprop_get_onAuthEvent().call(_this1, event)
                                    ];
                                } else _this1.resolve(null);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "onExecution",
            value: function onExecution() {
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "cleanUp",
            value: function cleanUp() {}
        }
    ]);
    return RedirectAction;
}($0021d6672f58c7eb$var$AbstractPopupRedirectOperation);
function $0021d6672f58c7eb$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    return $0021d6672f58c7eb$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__getAndClearPendingRedirectStatus() {
    $0021d6672f58c7eb$var$__getAndClearPendingRedirectStatus = (0, $869ea882f885334a$export$7c398597f8905a1)(function(resolver, auth) {
        var key, persistence, hasPendingRedirect;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = $0021d6672f58c7eb$var$pendingRedirectKey(auth);
                    persistence = $0021d6672f58c7eb$var$resolverPersistence(resolver);
                    return [
                        4,
                        persistence._isAvailable()
                    ];
                case 1:
                    if (!_state.sent()) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        persistence._get(key)
                    ];
                case 2:
                    hasPendingRedirect = _state.sent() === "true";
                    return [
                        4,
                        persistence._remove(key)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        hasPendingRedirect
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__getAndClearPendingRedirectStatus.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_setPendingRedirectStatus(resolver, auth) {
    return $0021d6672f58c7eb$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__setPendingRedirectStatus() {
    $0021d6672f58c7eb$var$__setPendingRedirectStatus = (0, $869ea882f885334a$export$7c398597f8905a1)(function(resolver, auth) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            return [
                2,
                $0021d6672f58c7eb$var$resolverPersistence(resolver)._set($0021d6672f58c7eb$var$pendingRedirectKey(auth), "true")
            ];
        });
    });
    return $0021d6672f58c7eb$var$__setPendingRedirectStatus.apply(this, arguments);
}
function $0021d6672f58c7eb$export$a33b77bbdbb8366c() {
    $0021d6672f58c7eb$var$redirectOutcomeMap.clear();
}
function $0021d6672f58c7eb$export$53a70dd1ebbae346(auth, result) {
    $0021d6672f58c7eb$var$redirectOutcomeMap.set(auth._key(), result);
}
function $0021d6672f58c7eb$var$resolverPersistence(resolver) {
    return $0021d6672f58c7eb$export$24baa2b76016ce0e(resolver._redirectPersistence);
}
function $0021d6672f58c7eb$var$pendingRedirectKey(auth) {
    return $0021d6672f58c7eb$export$158acd800e1ef08b($0021d6672f58c7eb$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $0021d6672f58c7eb$export$2d1720544b23b823(auth, provider, resolver) {
    return $0021d6672f58c7eb$var$_signInWithRedirect(auth, provider, resolver);
}
function $0021d6672f58c7eb$var$_signInWithRedirect(auth, provider, resolver) {
    return $0021d6672f58c7eb$var$__signInWithRedirect.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__signInWithRedirect() {
    $0021d6672f58c7eb$var$__signInWithRedirect = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, provider, resolver) {
        var authInternal, resolverInternal;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    $0021d6672f58c7eb$var$_assertInstanceOf(auth, provider, $0021d6672f58c7eb$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        authInternal._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $0021d6672f58c7eb$var$_withDefaultResolver(authInternal, resolver);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_setPendingRedirectStatus(resolverInternal, authInternal)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ )
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__signInWithRedirect.apply(this, arguments);
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $0021d6672f58c7eb$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $0021d6672f58c7eb$var$_reauthenticateWithRedirect(user, provider, resolver);
}
function $0021d6672f58c7eb$var$_reauthenticateWithRedirect(user, provider, resolver) {
    return $0021d6672f58c7eb$var$__reauthenticateWithRedirect.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__reauthenticateWithRedirect() {
    $0021d6672f58c7eb$var$__reauthenticateWithRedirect = (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    $0021d6672f58c7eb$var$_assertInstanceOf(userInternal.auth, provider, $0021d6672f58c7eb$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $0021d6672f58c7eb$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$prepareUserForRedirect(userInternal)
                    ];
                case 3:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__reauthenticateWithRedirect.apply(this, arguments);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $0021d6672f58c7eb$export$39b482c5e57630a8(user, provider, resolver) {
    return $0021d6672f58c7eb$var$_linkWithRedirect(user, provider, resolver);
}
function $0021d6672f58c7eb$var$_linkWithRedirect(user, provider, resolver) {
    return $0021d6672f58c7eb$var$__linkWithRedirect.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__linkWithRedirect() {
    $0021d6672f58c7eb$var$__linkWithRedirect = (0, $869ea882f885334a$export$7c398597f8905a1)(function(user, provider, resolver) {
        var userInternal, resolverInternal, eventId;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    userInternal = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(user);
                    $0021d6672f58c7eb$var$_assertInstanceOf(userInternal.auth, provider, $0021d6672f58c7eb$var$FederatedAuthProvider);
                    // Wait for auth initialization to complete, this will process pending redirects and clear the
                    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
                    // redirect and creating a PENDING_REDIRECT_KEY entry.
                    return [
                        4,
                        userInternal.auth._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    resolverInternal = $0021d6672f58c7eb$var$_withDefaultResolver(userInternal.auth, resolver);
                    return [
                        4,
                        $0021d6672f58c7eb$var$_assertLinkedStatus(false, userInternal, provider.providerId)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $0021d6672f58c7eb$var$prepareUserForRedirect(userInternal)
                    ];
                case 4:
                    eventId = _state.sent();
                    return [
                        2,
                        resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId)
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__linkWithRedirect.apply(this, arguments);
}
function $0021d6672f58c7eb$export$35e795649ee09318(auth, resolver) {
    return $0021d6672f58c7eb$var$_getRedirectResult.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_getRedirectResult() {
    $0021d6672f58c7eb$var$_getRedirectResult = /**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, resolver) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$export$b9a6b53f9be3734(auth)._initializationPromise
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        $0021d6672f58c7eb$export$cf2f7c5792f80b46(auth, resolver, false)
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_getRedirectResult.apply(this, arguments);
}
function $0021d6672f58c7eb$export$cf2f7c5792f80b46(auth, resolverExtern) {
    return $0021d6672f58c7eb$var$__getRedirectResult.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__getRedirectResult() {
    $0021d6672f58c7eb$var$__getRedirectResult = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, resolverExtern) {
        var bypassAuthState, authInternal, resolver, action, result;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    bypassAuthState = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                    authInternal = $0021d6672f58c7eb$export$b9a6b53f9be3734(auth);
                    resolver = $0021d6672f58c7eb$var$_withDefaultResolver(authInternal, resolverExtern);
                    action = new $0021d6672f58c7eb$var$RedirectAction(authInternal, resolver, bypassAuthState);
                    return [
                        4,
                        action.execute()
                    ];
                case 1:
                    result = _state.sent();
                    if (!(result && !bypassAuthState)) return [
                        3,
                        4
                    ];
                    delete result.user._redirectEventId;
                    return [
                        4,
                        authInternal._persistUserIfCurrent(result.user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        authInternal._setRedirectUser(null, resolverExtern)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__getRedirectResult.apply(this, arguments);
}
function $0021d6672f58c7eb$var$prepareUserForRedirect(user) {
    return $0021d6672f58c7eb$var$_prepareUserForRedirect.apply(this, arguments);
}
function $0021d6672f58c7eb$var$_prepareUserForRedirect() {
    $0021d6672f58c7eb$var$_prepareUserForRedirect = (0, $869ea882f885334a$export$7c398597f8905a1)(function(user) {
        var eventId;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    eventId = $0021d6672f58c7eb$export$9f4f30ee63539e24("".concat(user.uid, ":::"));
                    user._redirectEventId = eventId;
                    return [
                        4,
                        user.auth._setRedirectUser(user)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        user.auth._persistUserIfCurrent(user)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        eventId
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$_prepareUserForRedirect.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
var $0021d6672f58c7eb$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
var $0021d6672f58c7eb$export$890c4ad488842ce7 = /*#__PURE__*/ function() {
    "use strict";
    function AuthEventManager(auth) {
        (0, $978gY._)(this, AuthEventManager);
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    (0, $kry2a._)(AuthEventManager, [
        {
            key: "registerConsumer",
            value: function registerConsumer(authEventConsumer) {
                this.consumers.add(authEventConsumer);
                if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
                    this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
                    this.saveEventToCache(this.queuedRedirectEvent);
                    this.queuedRedirectEvent = null;
                }
            }
        },
        {
            key: "unregisterConsumer",
            value: function unregisterConsumer(authEventConsumer) {
                this.consumers.delete(authEventConsumer);
            }
        },
        {
            key: "onEvent",
            value: function onEvent(event) {
                var _this = this;
                // Check if the event has already been handled
                if (this.hasEventBeenHandled(event)) return false;
                var handled = false;
                this.consumers.forEach(function(consumer) {
                    if (_this.isEventForConsumer(event, consumer)) {
                        handled = true;
                        _this.sendToConsumer(event, consumer);
                        _this.saveEventToCache(event);
                    }
                });
                if (this.hasHandledPotentialRedirect || !$0021d6672f58c7eb$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
                // bail now
                return handled;
                this.hasHandledPotentialRedirect = true;
                // If the redirect wasn't handled, hang on to it
                if (!handled) {
                    this.queuedRedirectEvent = event;
                    handled = true;
                }
                return handled;
            }
        },
        {
            key: "sendToConsumer",
            value: function sendToConsumer(event, consumer) {
                var _a;
                if (event.error && !$0021d6672f58c7eb$var$isNullRedirectEvent(event)) {
                    var code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
                    consumer.onError($0021d6672f58c7eb$export$91c6e00c14e7e6fd(this.auth, code));
                } else consumer.onAuthEvent(event);
            }
        },
        {
            key: "isEventForConsumer",
            value: function isEventForConsumer(event, consumer) {
                var eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
                return consumer.filter.includes(event.type) && eventIdMatches;
            }
        },
        {
            key: "hasEventBeenHandled",
            value: function hasEventBeenHandled(event) {
                if (Date.now() - this.lastProcessedEventTime >= $0021d6672f58c7eb$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
                return this.cachedEventUids.has($0021d6672f58c7eb$var$eventUid(event));
            }
        },
        {
            key: "saveEventToCache",
            value: function saveEventToCache(event) {
                this.cachedEventUids.add($0021d6672f58c7eb$var$eventUid(event));
                this.lastProcessedEventTime = Date.now();
            }
        }
    ]);
    return AuthEventManager;
}();
function $0021d6672f58c7eb$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter(function(v) {
        return v;
    }).join("-");
}
function $0021d6672f58c7eb$var$isNullRedirectEvent(param) {
    var type = param.type, error = param.error;
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === "auth/no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ;
}
function $0021d6672f58c7eb$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $0021d6672f58c7eb$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
function $0021d6672f58c7eb$export$28f7fcd39efa255(auth) {
    return $0021d6672f58c7eb$var$__getProjectConfig.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__getProjectConfig() {
    $0021d6672f58c7eb$var$__getProjectConfig = /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        var request;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            request = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                $0021d6672f58c7eb$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request)
            ];
        });
    });
    return $0021d6672f58c7eb$var$__getProjectConfig.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
var $0021d6672f58c7eb$var$HTTP_REGEX = /^https?/;
function $0021d6672f58c7eb$var$_validateOrigin(auth) {
    return $0021d6672f58c7eb$var$__validateOrigin.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__validateOrigin() {
    $0021d6672f58c7eb$var$__validateOrigin = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        var authorizedDomains, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, domain;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Skip origin validation if we are in an emulated environment
                    if (auth.config.emulator) return [
                        2
                    ];
                    return [
                        4,
                        $0021d6672f58c7eb$export$28f7fcd39efa255(auth)
                    ];
                case 1:
                    authorizedDomains = _state.sent().authorizedDomains;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = authorizedDomains[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            domain = _step.value;
                            try {
                                if ($0021d6672f58c7eb$var$matchDomain(domain)) return [
                                    2
                                ];
                            } catch (_a) {
                            // Do nothing if there's a URL error; just continue searching
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // In the old SDK, this error also provides helpful messages.
                    $0021d6672f58c7eb$export$92108d983e8ee699(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
                    return [
                        2
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__validateOrigin.apply(this, arguments);
}
function $0021d6672f58c7eb$var$matchDomain(expected) {
    var currentUrl = $0021d6672f58c7eb$var$_getCurrentUrl();
    var _ref = new URL(currentUrl), protocol = _ref.protocol, hostname = _ref.hostname;
    if (expected.startsWith("chrome-extension://")) {
        var ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$0021d6672f58c7eb$var$HTTP_REGEX.test(protocol)) return false;
    if ($0021d6672f58c7eb$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    var escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    var re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$NETWORK_TIMEOUT = new $0021d6672f58c7eb$var$Delay(30000, 60000);
/**
 * Reset unlaoded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $0021d6672f58c7eb$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    var beacon = $0021d6672f58c7eb$var$_window().___jsl;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) try {
        // Get gapi hint.
        for(var _iterator = Object.keys(beacon.H)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var hint = _step.value;
            // Requested modules.
            beacon.H[hint].r = beacon.H[hint].r || [];
            // Loaded modules.
            beacon.H[hint].L = beacon.H[hint].L || [];
            // Set requested modules to a copy of the loaded modules.
            beacon.H[hint].r = (0, $fLnyw._)(beacon.H[hint].L);
            // Clear pending callbacks.
            if (beacon.CP) for(var i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
            beacon.CP[i] = null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $0021d6672f58c7eb$var$loadGapi(auth) {
    return new Promise(function(resolve, reject) {
        var loadGapiIframe = // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $0021d6672f58c7eb$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: function() {
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: function() {
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $0021d6672f58c7eb$var$resetUnloadedGapiModules();
                    reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $0021d6672f58c7eb$var$NETWORK_TIMEOUT.get()
            });
        };
        var _a, _b, _c;
        if ((_b = (_a = $0021d6672f58c7eb$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $0021d6672f58c7eb$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            var cbName = $0021d6672f58c7eb$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $0021d6672f58c7eb$var$_window()[cbName] = function() {
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($0021d6672f58c7eb$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $0021d6672f58c7eb$var$_loadJS("https://apis.google.com/js/api.js?onload=".concat(cbName)).catch(function(e) {
                return reject(e);
            });
        }
    }).catch(function(error) {
        // Reset cached promise to allow for retrial.
        $0021d6672f58c7eb$var$cachedGApiLoader = null;
        throw error;
    });
}
var $0021d6672f58c7eb$var$cachedGApiLoader = null;
function $0021d6672f58c7eb$var$_loadGapi(auth) {
    $0021d6672f58c7eb$var$cachedGApiLoader = $0021d6672f58c7eb$var$cachedGApiLoader || $0021d6672f58c7eb$var$loadGapi(auth);
    return $0021d6672f58c7eb$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$PING_TIMEOUT = new $0021d6672f58c7eb$var$Delay(5000, 15000);
var $0021d6672f58c7eb$var$IFRAME_PATH = "__/auth/iframe";
var $0021d6672f58c7eb$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
var $0021d6672f58c7eb$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
var $0021d6672f58c7eb$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $0021d6672f58c7eb$var$getIframeUrl(auth) {
    var config = auth.config;
    $0021d6672f58c7eb$export$9d398bebfec1c039(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    var url = config.emulator ? $0021d6672f58c7eb$var$_emulatorUrl(config, $0021d6672f58c7eb$var$EMULATED_IFRAME_PATH) : "https://".concat(auth.config.authDomain, "/").concat($0021d6672f58c7eb$var$IFRAME_PATH);
    var params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $2b7c3095396a3894$export$31499a9cd224b78c)
    };
    var eid = $0021d6672f58c7eb$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    var frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return "".concat(url, "?").concat((0, $b1467a785fc7cec5$export$ac4103b836844853)(params).slice(1));
}
function $0021d6672f58c7eb$var$_openIframe(auth) {
    return $0021d6672f58c7eb$var$__openIframe.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__openIframe() {
    $0021d6672f58c7eb$var$__openIframe = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth) {
        var context, gapi1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $0021d6672f58c7eb$var$_loadGapi(auth)
                    ];
                case 1:
                    context = _state.sent();
                    gapi1 = $0021d6672f58c7eb$var$_window().gapi;
                    $0021d6672f58c7eb$export$9d398bebfec1c039(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return [
                        2,
                        context.open({
                            where: document.body,
                            url: $0021d6672f58c7eb$var$getIframeUrl(auth),
                            messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
                            attributes: $0021d6672f58c7eb$var$IFRAME_ATTRIBUTES,
                            dontclear: true
                        }, function(iframe) {
                            return new Promise(function() {
                                var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(resolve, reject) {
                                    var networkError, networkErrorTimer;
                                    // Clear timer and resolve pending iframe ready promise.
                                    function clearTimerAndResolve() {
                                        $0021d6672f58c7eb$var$_window().clearTimeout(networkErrorTimer);
                                        resolve(iframe);
                                    }
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    iframe.restyle({
                                                        // Prevent iframe from closing on mouse out.
                                                        setHideOnLeave: false
                                                    })
                                                ];
                                            case 1:
                                                _state.sent();
                                                networkError = $0021d6672f58c7eb$export$91c6e00c14e7e6fd(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
                                                networkErrorTimer = $0021d6672f58c7eb$var$_window().setTimeout(function() {
                                                    reject(networkError);
                                                }, $0021d6672f58c7eb$var$PING_TIMEOUT.get());
                                                // This returns an IThenable. However the reject part does not call
                                                // when the iframe is not loaded.
                                                iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, function() {
                                                    reject(networkError);
                                                });
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(resolve, reject) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        })
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__openIframe.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
var $0021d6672f58c7eb$var$DEFAULT_WIDTH = 500;
var $0021d6672f58c7eb$var$DEFAULT_HEIGHT = 600;
var $0021d6672f58c7eb$var$TARGET_BLANK = "_blank";
var $0021d6672f58c7eb$var$FIREFOX_EMPTY_URL = "http://localhost";
var $0021d6672f58c7eb$export$faec65b429be379 = /*#__PURE__*/ function() {
    "use strict";
    function AuthPopup(window1) {
        (0, $978gY._)(this, AuthPopup);
        this.window = window1;
        this.associatedEvent = null;
    }
    (0, $kry2a._)(AuthPopup, [
        {
            key: "close",
            value: function close() {
                if (this.window) try {
                    this.window.close();
                } catch (e) {}
            }
        }
    ]);
    return AuthPopup;
}();
function $0021d6672f58c7eb$var$_open(auth, url, name) {
    var width = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $0021d6672f58c7eb$var$DEFAULT_WIDTH, height = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $0021d6672f58c7eb$var$DEFAULT_HEIGHT;
    var top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    var left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    var target = "";
    var options = Object.assign(Object.assign({}, $0021d6672f58c7eb$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    var ua = (0, $b1467a785fc7cec5$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $0021d6672f58c7eb$var$_isChromeIOS(ua) ? $0021d6672f58c7eb$var$TARGET_BLANK : name;
    if ($0021d6672f58c7eb$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $0021d6672f58c7eb$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    var optionsString = Object.entries(options).reduce(function(accum, param) {
        var _param = (0, $8GFUW._)(param, 2), key = _param[0], value = _param[1];
        return "".concat(accum).concat(key, "=").concat(value, ",");
    }, "");
    if ($0021d6672f58c7eb$var$_isIOSStandalone(ua) && target !== "_self") {
        $0021d6672f58c7eb$var$openAsNewWindowIOS(url || "", target);
        return new $0021d6672f58c7eb$export$faec65b429be379(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    var newWin = window.open(url || "", target, optionsString);
    $0021d6672f58c7eb$export$9d398bebfec1c039(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $0021d6672f58c7eb$export$faec65b429be379(newWin);
}
function $0021d6672f58c7eb$var$openAsNewWindowIOS(url, target) {
    var el = document.createElement("a");
    el.href = url;
    el.target = target;
    var click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ var $0021d6672f58c7eb$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ var $0021d6672f58c7eb$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ var $0021d6672f58c7eb$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
function $0021d6672f58c7eb$export$9fa96a7d116ea3ce(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    return $0021d6672f58c7eb$var$__getRedirectUrl.apply(this, arguments);
}
function $0021d6672f58c7eb$var$__getRedirectUrl() {
    $0021d6672f58c7eb$var$__getRedirectUrl = (0, $869ea882f885334a$export$7c398597f8905a1)(function(auth, provider, authType, redirectUrl, eventId, additionalParams) {
        var params, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, key, value, scopes, paramsDict, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, key1, appCheckToken, appCheckTokenFragment;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $0021d6672f58c7eb$export$9d398bebfec1c039(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
                    $0021d6672f58c7eb$export$9d398bebfec1c039(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
                    params = {
                        apiKey: auth.config.apiKey,
                        appName: auth.name,
                        authType: authType,
                        redirectUrl: redirectUrl,
                        v: (0, $2b7c3095396a3894$export$31499a9cd224b78c),
                        eventId: eventId
                    };
                    if (provider instanceof $0021d6672f58c7eb$var$FederatedAuthProvider) {
                        provider.setDefaultLanguage(auth.languageCode);
                        params.providerId = provider.providerId || "";
                        if (!(0, $b1467a785fc7cec5$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // TODO set additionalParams from the provider as well?
                            for(_iterator = Object.entries(additionalParams || {})[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                _step_value = (0, $8GFUW._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                                params[key] = value;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (provider instanceof $0021d6672f58c7eb$var$BaseOAuthProvider) {
                        scopes = provider.getScopes().filter(function(scope) {
                            return scope !== "";
                        });
                        if (scopes.length > 0) params.scopes = scopes.join(",");
                    }
                    if (auth.tenantId) params.tid = auth.tenantId;
                    paramsDict = params;
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = Object.keys(paramsDict)[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            key1 = _step1.value;
                            if (paramsDict[key1] === undefined) delete paramsDict[key1];
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        4,
                        auth._getAppCheckToken()
                    ];
                case 1:
                    appCheckToken = _state.sent();
                    appCheckTokenFragment = appCheckToken ? "#".concat($0021d6672f58c7eb$var$FIREBASE_APP_CHECK_FRAGMENT_ID, "=").concat(encodeURIComponent(appCheckToken)) : "";
                    // Start at index 1 to skip the leading '&' in the query string
                    return [
                        2,
                        "".concat($0021d6672f58c7eb$var$getHandlerBase(auth), "?").concat((0, $b1467a785fc7cec5$export$ac4103b836844853)(paramsDict).slice(1)).concat(appCheckTokenFragment)
                    ];
            }
        });
    });
    return $0021d6672f58c7eb$var$__getRedirectUrl.apply(this, arguments);
}
function $0021d6672f58c7eb$var$getHandlerBase(param) {
    var config = param.config;
    if (!config.emulator) return "https://".concat(config.authDomain, "/").concat($0021d6672f58c7eb$var$WIDGET_PATH);
    return $0021d6672f58c7eb$var$_emulatorUrl(config, $0021d6672f58c7eb$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ var $0021d6672f58c7eb$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
var $0021d6672f58c7eb$var$BrowserPopupRedirectResolver = /*#__PURE__*/ function() {
    "use strict";
    function BrowserPopupRedirectResolver() {
        (0, $978gY._)(this, BrowserPopupRedirectResolver);
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $0021d6672f58c7eb$export$407448d2b89b1813;
        this._completeRedirectFn = $0021d6672f58c7eb$export$cf2f7c5792f80b46;
        this._overrideRedirectResult = $0021d6672f58c7eb$export$53a70dd1ebbae346;
    }
    (0, $kry2a._)(BrowserPopupRedirectResolver, [
        {
            key: "_openPopup",
            value: // Wrapping in async even though we don't await anywhere in order
            // to make sure errors are raised as promise rejections
            function _openPopup(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, url;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                $0021d6672f58c7eb$export$493d36ec626b6698((_a = _this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
                                return [
                                    4,
                                    $0021d6672f58c7eb$export$9fa96a7d116ea3ce(auth, provider, authType, $0021d6672f58c7eb$var$_getCurrentUrl(), eventId)
                                ];
                            case 1:
                                url = _state.sent();
                                return [
                                    2,
                                    $0021d6672f58c7eb$var$_open(auth, url, $0021d6672f58c7eb$export$9f4f30ee63539e24())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_openRedirect",
            value: function _openRedirect(auth, provider, authType, eventId) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var url;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._originValidation(auth)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    $0021d6672f58c7eb$export$9fa96a7d116ea3ce(auth, provider, authType, $0021d6672f58c7eb$var$_getCurrentUrl(), eventId)
                                ];
                            case 2:
                                url = _state.sent();
                                $0021d6672f58c7eb$var$_setWindowLocation(url);
                                return [
                                    2,
                                    new Promise(function() {})
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_initialize",
            value: function _initialize(auth) {
                var _this = this;
                var key = auth._key();
                if (this.eventManagers[key]) {
                    var _this_eventManagers_key = this.eventManagers[key], manager = _this_eventManagers_key.manager, promise = _this_eventManagers_key.promise;
                    if (manager) return Promise.resolve(manager);
                    else {
                        $0021d6672f58c7eb$export$493d36ec626b6698(promise, "If manager is not set, promise should be");
                        return promise;
                    }
                }
                var promise1 = this.initAndGetManager(auth);
                this.eventManagers[key] = {
                    promise: promise1
                };
                // If the promise is rejected, the key should be removed so that the
                // operation can be retried later.
                promise1.catch(function() {
                    delete _this.eventManagers[key];
                });
                return promise1;
            }
        },
        {
            key: "initAndGetManager",
            value: function initAndGetManager(auth) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var iframe, manager;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$_openIframe(auth)
                                ];
                            case 1:
                                iframe = _state.sent();
                                manager = new $0021d6672f58c7eb$export$890c4ad488842ce7(auth);
                                iframe.register("authEvent", function(iframeEvent) {
                                    $0021d6672f58c7eb$export$9d398bebfec1c039(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
                                    // TODO: Consider splitting redirect and popup events earlier on
                                    var handled = manager.onEvent(iframeEvent.authEvent);
                                    return {
                                        status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
                                    };
                                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
                                _this.eventManagers[auth._key()] = {
                                    manager: manager
                                };
                                _this.iframes[auth._key()] = iframe;
                                return [
                                    2,
                                    manager
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_isIframeWebStorageSupported",
            value: function _isIframeWebStorageSupported(auth, cb) {
                var iframe = this.iframes[auth._key()];
                iframe.send($0021d6672f58c7eb$var$WEB_STORAGE_SUPPORT_KEY, {
                    type: $0021d6672f58c7eb$var$WEB_STORAGE_SUPPORT_KEY
                }, function(result) {
                    var _a;
                    var isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$0021d6672f58c7eb$var$WEB_STORAGE_SUPPORT_KEY];
                    if (isSupported !== undefined) cb(!!isSupported);
                    $0021d6672f58c7eb$export$92108d983e8ee699(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
            }
        },
        {
            key: "_originValidation",
            value: function _originValidation(auth) {
                var key = auth._key();
                if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $0021d6672f58c7eb$var$_validateOrigin(auth);
                return this.originValidationPromises[key];
            }
        },
        {
            key: "_shouldInitProactively",
            get: function get() {
                // Mobile browsers and Safari need to optimistically initialize
                return $0021d6672f58c7eb$var$_isMobileBrowser() || $0021d6672f58c7eb$var$_isSafari() || $0021d6672f58c7eb$export$1fbe638ecf81657e();
            }
        }
    ]);
    return BrowserPopupRedirectResolver;
}();
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ var $0021d6672f58c7eb$export$342063e11d6c3cad = $0021d6672f58c7eb$var$BrowserPopupRedirectResolver;
var $0021d6672f58c7eb$var$MultiFactorAssertionImpl = /*#__PURE__*/ function() {
    "use strict";
    function MultiFactorAssertionImpl(factorId) {
        (0, $978gY._)(this, MultiFactorAssertionImpl);
        this.factorId = factorId;
    }
    (0, $kry2a._)(MultiFactorAssertionImpl, [
        {
            key: "_process",
            value: function _process(auth, session, displayName) {
                switch(session.type){
                    case "enroll" /* MultiFactorSessionType.ENROLL */ :
                        return this._finalizeEnroll(auth, session.credential, displayName);
                    case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                        return this._finalizeSignIn(auth, session.credential);
                    default:
                        return $0021d6672f58c7eb$var$debugFail("unexpected MultiFactorSessionType");
                }
            }
        }
    ]);
    return MultiFactorAssertionImpl;
}();
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ var $0021d6672f58c7eb$var$PhoneMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $ftJVG._)(PhoneMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $6OZAO._)(PhoneMultiFactorAssertionImpl);
    function PhoneMultiFactorAssertionImpl(credential) {
        (0, $978gY._)(this, PhoneMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "phone" /* FactorId.PHONE */ );
        _this.credential = credential;
        return _this;
    }
    (0, $kry2a._)(PhoneMultiFactorAssertionImpl, [
        {
            /** @internal */ key: "_finalizeEnroll",
            value: function _finalizeEnroll(auth, idToken, displayName) {
                return $0021d6672f58c7eb$var$finalizeEnrollPhoneMfa(auth, {
                    idToken: idToken,
                    displayName: displayName,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        },
        {
            /** @internal */ key: "_finalizeSignIn",
            value: function _finalizeSignIn(auth, mfaPendingCredential) {
                return $0021d6672f58c7eb$var$finalizeSignInPhoneMfa(auth, {
                    mfaPendingCredential: mfaPendingCredential,
                    phoneVerificationInfo: this.credential._makeVerificationRequest()
                });
            }
        }
    ], [
        {
            key: "_fromCredential",
            value: /** @internal */ function _fromCredential(credential) {
                return new PhoneMultiFactorAssertionImpl(credential);
            }
        }
    ]);
    return PhoneMultiFactorAssertionImpl;
}($0021d6672f58c7eb$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ var $0021d6672f58c7eb$export$953cecd6e717a553 = /*#__PURE__*/ function() {
    "use strict";
    function PhoneMultiFactorGenerator() {
        (0, $978gY._)(this, PhoneMultiFactorGenerator);
    }
    (0, $kry2a._)(PhoneMultiFactorGenerator, null, [
        {
            key: "assertion",
            value: /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ function assertion(credential) {
                return $0021d6672f58c7eb$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
            }
        }
    ]);
    return PhoneMultiFactorGenerator;
}();
/**
 * The identifier of the phone second factor: `phone`.
 */ $0021d6672f58c7eb$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ var $0021d6672f58c7eb$export$971d5caa766a69d7 = /*#__PURE__*/ function() {
    "use strict";
    function TotpMultiFactorGenerator() {
        (0, $978gY._)(this, TotpMultiFactorGenerator);
    }
    (0, $kry2a._)(TotpMultiFactorGenerator, null, [
        {
            key: "assertionForEnrollment",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ function assertionForEnrollment(secret, oneTimePassword) {
                return $0021d6672f58c7eb$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
            }
        },
        {
            key: "assertionForSignIn",
            value: /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ function assertionForSignIn(enrollmentId, oneTimePassword) {
                return $0021d6672f58c7eb$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
            }
        },
        {
            key: "generateSecret",
            value: /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ function generateSecret(session) {
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _a, mfaSession, response;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                mfaSession = session;
                                $0021d6672f58c7eb$export$9d398bebfec1c039(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                                return [
                                    4,
                                    $0021d6672f58c7eb$var$startEnrollTotpMfa(mfaSession.user.auth, {
                                        idToken: mfaSession.credential,
                                        totpEnrollmentInfo: {}
                                    })
                                ];
                            case 1:
                                response = _state.sent();
                                return [
                                    2,
                                    $0021d6672f58c7eb$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return TotpMultiFactorGenerator;
}();
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $0021d6672f58c7eb$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
var $0021d6672f58c7eb$var$TotpMultiFactorAssertionImpl = /*#__PURE__*/ function(MultiFactorAssertionImpl) {
    "use strict";
    (0, $ftJVG._)(TotpMultiFactorAssertionImpl, MultiFactorAssertionImpl);
    var _super = (0, $6OZAO._)(TotpMultiFactorAssertionImpl);
    function TotpMultiFactorAssertionImpl(otp, enrollmentId, secret) {
        (0, $978gY._)(this, TotpMultiFactorAssertionImpl);
        var _this;
        _this = _super.call(this, "totp" /* FactorId.TOTP */ );
        _this.otp = otp;
        _this.enrollmentId = enrollmentId;
        _this.secret = secret;
        return _this;
    }
    (0, $kry2a._)(TotpMultiFactorAssertionImpl, [
        {
            key: "_finalizeEnroll",
            value: /** @internal */ function _finalizeEnroll(auth, idToken, displayName) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        $0021d6672f58c7eb$export$9d398bebfec1c039(typeof _this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        return [
                            2,
                            $0021d6672f58c7eb$var$finalizeEnrollTotpMfa(auth, {
                                idToken: idToken,
                                displayName: displayName,
                                totpVerificationInfo: _this.secret._makeTotpVerificationInfo(_this.otp)
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "_finalizeSignIn",
            value: /** @internal */ function _finalizeSignIn(auth, mfaPendingCredential) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var totpVerificationInfo;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        $0021d6672f58c7eb$export$9d398bebfec1c039(_this.enrollmentId !== undefined && _this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        totpVerificationInfo = {
                            verificationCode: _this.otp
                        };
                        return [
                            2,
                            $0021d6672f58c7eb$var$finalizeSignInTotpMfa(auth, {
                                mfaPendingCredential: mfaPendingCredential,
                                mfaEnrollmentId: _this.enrollmentId,
                                totpVerificationInfo: totpVerificationInfo
                            })
                        ];
                    });
                })();
            }
        }
    ], [
        {
            key: "_fromSecret",
            value: /** @internal */ function _fromSecret(secret, otp) {
                return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
            }
        },
        {
            key: "_fromEnrollmentId",
            value: /** @internal */ function _fromEnrollmentId(enrollmentId, otp) {
                return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
            }
        }
    ]);
    return TotpMultiFactorAssertionImpl;
}($0021d6672f58c7eb$var$MultiFactorAssertionImpl);
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ var $0021d6672f58c7eb$export$7ccc53e8f1e7dfc5 = /*#__PURE__*/ function() {
    "use strict";
    function TotpSecret(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth) {
        (0, $978gY._)(this, TotpSecret);
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    (0, $kry2a._)(TotpSecret, [
        {
            /** @internal */ key: "_makeTotpVerificationInfo",
            value: function _makeTotpVerificationInfo(otp) {
                return {
                    sessionInfo: this.sessionInfo,
                    verificationCode: otp
                };
            }
        },
        {
            /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ key: "generateQrCodeUrl",
            value: function generateQrCodeUrl(accountName, issuer) {
                var _a;
                var useDefaults = false;
                if ($0021d6672f58c7eb$var$_isEmptyString(accountName) || $0021d6672f58c7eb$var$_isEmptyString(issuer)) useDefaults = true;
                if (useDefaults) {
                    if ($0021d6672f58c7eb$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
                    if ($0021d6672f58c7eb$var$_isEmptyString(issuer)) issuer = this.auth.name;
                }
                return "otpauth://totp/".concat(issuer, ":").concat(accountName, "?secret=").concat(this.secretKey, "&issuer=").concat(issuer, "&algorithm=").concat(this.hashingAlgorithm, "&digits=").concat(this.codeLength);
            }
        }
    ], [
        {
            key: "_fromStartTotpMfaEnrollmentResponse",
            value: /** @internal */ function _fromStartTotpMfaEnrollmentResponse(response, auth) {
                return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
            }
        }
    ]);
    return TotpSecret;
}();
/** @internal */ function $0021d6672f58c7eb$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $0021d6672f58c7eb$var$name = "@firebase/auth";
var $0021d6672f58c7eb$var$version = "1.3.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$AuthInterop = /*#__PURE__*/ function() {
    "use strict";
    function AuthInterop(auth) {
        (0, $978gY._)(this, AuthInterop);
        this.auth = auth;
        this.internalListeners = new Map();
    }
    (0, $kry2a._)(AuthInterop, [
        {
            key: "getUid",
            value: function getUid() {
                var _a;
                this.assertAuthConfigured();
                return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
            }
        },
        {
            key: "getToken",
            value: function getToken(forceRefresh) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var accessToken;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.assertAuthConfigured();
                                return [
                                    4,
                                    _this.auth._initializationPromise
                                ];
                            case 1:
                                _state.sent();
                                if (!_this.auth.currentUser) return [
                                    2,
                                    null
                                ];
                                return [
                                    4,
                                    _this.auth.currentUser.getIdToken(forceRefresh)
                                ];
                            case 2:
                                accessToken = _state.sent();
                                return [
                                    2,
                                    {
                                        accessToken: accessToken
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "addAuthTokenListener",
            value: function addAuthTokenListener(listener) {
                this.assertAuthConfigured();
                if (this.internalListeners.has(listener)) return;
                var unsubscribe = this.auth.onIdTokenChanged(function(user) {
                    listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
                });
                this.internalListeners.set(listener, unsubscribe);
                this.updateProactiveRefresh();
            }
        },
        {
            key: "removeAuthTokenListener",
            value: function removeAuthTokenListener(listener) {
                this.assertAuthConfigured();
                var unsubscribe = this.internalListeners.get(listener);
                if (!unsubscribe) return;
                this.internalListeners.delete(listener);
                unsubscribe();
                this.updateProactiveRefresh();
            }
        },
        {
            key: "assertAuthConfigured",
            value: function assertAuthConfigured() {
                $0021d6672f58c7eb$export$9d398bebfec1c039(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
            }
        },
        {
            key: "updateProactiveRefresh",
            value: function updateProactiveRefresh() {
                if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
                else this.auth._stopProactiveRefresh();
            }
        }
    ]);
    return AuthInterop;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0021d6672f58c7eb$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        default:
            return undefined;
    }
}
/** @internal */ function $0021d6672f58c7eb$var$registerAuth(clientPlatform) {
    (0, $2b7c3095396a3894$export$c930050e7bb63965)(new (0, $48bece3fef299311$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , function(container, param) {
        var deps = param.options;
        var app = container.getProvider("app").getImmediate();
        var heartbeatServiceProvider = container.getProvider("heartbeat");
        var appCheckServiceProvider = container.getProvider("app-check-internal");
        var _app_options = app.options, apiKey = _app_options.apiKey, authDomain = _app_options.authDomain;
        $0021d6672f58c7eb$export$9d398bebfec1c039(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        var config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $0021d6672f58c7eb$export$91477dc880baac21(clientPlatform)
        };
        var authInstance = new $0021d6672f58c7eb$export$23ebac1979863676(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $0021d6672f58c7eb$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback(function(container, _instanceIdentifier, _instance) {
        var authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $2b7c3095396a3894$export$c930050e7bb63965)(new (0, $48bece3fef299311$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , function(container) {
        var auth = $0021d6672f58c7eb$export$b9a6b53f9be3734(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return function(auth) {
            return new $0021d6672f58c7eb$var$AuthInterop(auth);
        }(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $2b7c3095396a3894$export$d29d5299a7137abc)($0021d6672f58c7eb$var$name, $0021d6672f58c7eb$var$version, $0021d6672f58c7eb$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $2b7c3095396a3894$export$d29d5299a7137abc)($0021d6672f58c7eb$var$name, $0021d6672f58c7eb$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $0021d6672f58c7eb$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
var $0021d6672f58c7eb$var$authIdTokenMaxAge = (0, $b1467a785fc7cec5$export$5539a1a3afe87d6)("authIdTokenMaxAge") || $0021d6672f58c7eb$var$DEFAULT_ID_TOKEN_MAX_AGE;
var $0021d6672f58c7eb$var$lastPostedIdToken = null;
var $0021d6672f58c7eb$var$mintCookieFactory = function(url) {
    return function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(user) {
            var idTokenResult, _tmp, idTokenAge, idToken;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = user;
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            user.getIdTokenResult()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        idTokenResult = _tmp;
                        idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
                        if (idTokenAge && idTokenAge > $0021d6672f58c7eb$var$authIdTokenMaxAge) return [
                            2
                        ];
                        idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
                        if ($0021d6672f58c7eb$var$lastPostedIdToken === idToken) return [
                            2
                        ];
                        $0021d6672f58c7eb$var$lastPostedIdToken = idToken;
                        return [
                            4,
                            fetch(url, {
                                method: idToken ? "POST" : "DELETE",
                                headers: idToken ? {
                                    "Authorization": "Bearer ".concat(idToken)
                                } : {}
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(user) {
            return _ref.apply(this, arguments);
        };
    }();
};
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $0021d6672f58c7eb$export$ae1af26003f05816() {
    var app = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, $2b7c3095396a3894$export$f9962582c9e66d99)();
    var provider = (0, $2b7c3095396a3894$export$fa0d6da0f5838f50)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    var auth = $0021d6672f58c7eb$export$9bb611d729802a56(app, {
        popupRedirectResolver: $0021d6672f58c7eb$export$342063e11d6c3cad,
        persistence: [
            $0021d6672f58c7eb$export$23f2a1d2818174ef,
            $0021d6672f58c7eb$export$8b22cf2602fb60ce,
            $0021d6672f58c7eb$export$407448d2b89b1813
        ]
    });
    var authTokenSyncUrl = (0, $b1467a785fc7cec5$export$5539a1a3afe87d6)("authTokenSyncURL");
    if (authTokenSyncUrl) {
        var mintCookie = $0021d6672f58c7eb$var$mintCookieFactory(authTokenSyncUrl);
        $0021d6672f58c7eb$export$d141bba7fdc215a3(auth, mintCookie, function() {
            return mintCookie(auth.currentUser);
        });
        $0021d6672f58c7eb$export$efccba1c4a2ef57b(auth, function(user) {
            return mintCookie(user);
        });
    }
    var authEmulatorHost = (0, $b1467a785fc7cec5$export$9c11895284c8adad)("auth");
    if (authEmulatorHost) $0021d6672f58c7eb$export$b4171a6734a65d42(auth, "http://".concat(authEmulatorHost));
    return auth;
}
$0021d6672f58c7eb$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );











// Import the functions you need from the SDKs you need

var $2dbfff22a2c5b04b$var$name = "firebase";
var $2dbfff22a2c5b04b$var$version = "10.3.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $2b7c3095396a3894$export$d29d5299a7137abc)($2dbfff22a2c5b04b$var$name, $2dbfff22a2c5b04b$var$version, "app");




var $978gY = parcelRequire("978gY");

var $34cAK = parcelRequire("34cAK");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $ho5gk = parcelRequire("ho5gk");

var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $1ObTH = parcelRequire("1ObTH");

var $2TMdq = parcelRequire("2TMdq");

var $6OZAO = parcelRequire("6OZAO");

var $7UAGh = parcelRequire("7UAGh");

var $7UAGh = parcelRequire("7UAGh");





var $978gY = parcelRequire("978gY");

var $kry2a = parcelRequire("kry2a");

var $3cct3 = parcelRequire("3cct3");

var $g3d7z = parcelRequire("g3d7z");

var $ftJVG = parcelRequire("ftJVG");

var $8GFUW = parcelRequire("8GFUW");

var $1ObTH = parcelRequire("1ObTH");

var $6OZAO = parcelRequire("6OZAO");
var $bcffdc5a8182d43d$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $bcffdc5a8182d43d$export$2e2bcd8739ae039 = {};
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $bcffdc5a8182d43d$var$k, $bcffdc5a8182d43d$var$goog = $bcffdc5a8182d43d$var$goog || {}, $bcffdc5a8182d43d$var$l = $bcffdc5a8182d43d$var$commonjsGlobal || self;
function $bcffdc5a8182d43d$var$aa(a) {
    var b = typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a);
    b = "object" != b ? b : a ? Array.isArray(a) ? "array" : b : "null";
    return "array" == b || "object" == b && "number" == typeof a.length;
}
function $bcffdc5a8182d43d$var$p(a) {
    var b = typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a);
    return "object" == b && null != a || "function" == b;
}
function $bcffdc5a8182d43d$var$ba(a) {
    return Object.prototype.hasOwnProperty.call(a, $bcffdc5a8182d43d$var$ca) && a[$bcffdc5a8182d43d$var$ca] || (a[$bcffdc5a8182d43d$var$ca] = ++$bcffdc5a8182d43d$var$da);
}
var $bcffdc5a8182d43d$var$ca = "closure_uid_" + (1E9 * Math.random() >>> 0), $bcffdc5a8182d43d$var$da = 0;
function $bcffdc5a8182d43d$var$ea(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $bcffdc5a8182d43d$var$fa(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var e = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(e, d);
            return a.apply(b, e);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $bcffdc5a8182d43d$var$q(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $bcffdc5a8182d43d$var$q = $bcffdc5a8182d43d$var$ea : $bcffdc5a8182d43d$var$q = $bcffdc5a8182d43d$var$fa;
    return $bcffdc5a8182d43d$var$q.apply(null, arguments);
}
function $bcffdc5a8182d43d$var$ha(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var d = c.slice();
        d.push.apply(d, arguments);
        return a.apply(this, d);
    };
}
function $bcffdc5a8182d43d$var$r(a, b) {
    var c = function c() {};
    c.prototype = b.prototype;
    a.$ = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.ac = function(d, e, f) {
        for(var h = Array(arguments.length - 2), n = 2; n < arguments.length; n++)h[n - 2] = arguments[n];
        return b.prototype[e].apply(d, h);
    };
}
function $bcffdc5a8182d43d$var$v() {
    this.s = this.s;
    this.o = this.o;
}
var $bcffdc5a8182d43d$var$ia = 0;
$bcffdc5a8182d43d$var$v.prototype.s = !1;
$bcffdc5a8182d43d$var$v.prototype.sa = function() {
    if (!this.s && (this.s = !0, this.N(), 0 != $bcffdc5a8182d43d$var$ia)) $bcffdc5a8182d43d$var$ba(this);
};
$bcffdc5a8182d43d$var$v.prototype.N = function() {
    if (this.o) for(; this.o.length;)this.o.shift()();
};
var $bcffdc5a8182d43d$var$ka = Array.prototype.indexOf ? function ka(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
function $bcffdc5a8182d43d$var$ma(a) {
    var b = a.length;
    if (0 < b) {
        var c = Array(b);
        for(var d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
}
function $bcffdc5a8182d43d$var$na(a, b) {
    for(var c = 1; c < arguments.length; c++){
        var d = arguments[c];
        if ($bcffdc5a8182d43d$var$aa(d)) {
            var e = a.length || 0, f = d.length || 0;
            a.length = e + f;
            for(var h = 0; h < f; h++)a[e + h] = d[h];
        } else a.push(d);
    }
}
function $bcffdc5a8182d43d$var$w(a, b) {
    this.type = a;
    this.g = this.target = b;
    this.defaultPrevented = !1;
}
$bcffdc5a8182d43d$var$w.prototype.h = function() {
    this.defaultPrevented = !0;
};
var $bcffdc5a8182d43d$var$oa = function() {
    if (!$bcffdc5a8182d43d$var$l.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function get() {
            a = !0;
        }
    });
    try {
        $bcffdc5a8182d43d$var$l.addEventListener("test", function() {}, b), $bcffdc5a8182d43d$var$l.removeEventListener("test", function() {}, b);
    } catch (c) {}
    return a;
}();
function $bcffdc5a8182d43d$var$x(a) {
    return /^[\s\xa0]*$/.test(a);
}
function $bcffdc5a8182d43d$var$pa() {
    var a = $bcffdc5a8182d43d$var$l.navigator;
    return a && (a = a.userAgent) ? a : "";
}
function $bcffdc5a8182d43d$var$y(a) {
    return -1 != $bcffdc5a8182d43d$var$pa().indexOf(a);
}
function $bcffdc5a8182d43d$var$qa(a) {
    $bcffdc5a8182d43d$var$qa[" "](a);
    return a;
}
$bcffdc5a8182d43d$var$qa[" "] = function() {};
function $bcffdc5a8182d43d$var$ra(a, b) {
    var c = $bcffdc5a8182d43d$var$sa;
    return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a);
}
var $bcffdc5a8182d43d$var$ta = $bcffdc5a8182d43d$var$y("Opera"), $bcffdc5a8182d43d$var$z = $bcffdc5a8182d43d$var$y("Trident") || $bcffdc5a8182d43d$var$y("MSIE"), $bcffdc5a8182d43d$var$ua = $bcffdc5a8182d43d$var$y("Edge"), $bcffdc5a8182d43d$var$va = $bcffdc5a8182d43d$var$ua || $bcffdc5a8182d43d$var$z, $bcffdc5a8182d43d$var$wa = $bcffdc5a8182d43d$var$y("Gecko") && !(-1 != $bcffdc5a8182d43d$var$pa().toLowerCase().indexOf("webkit") && !$bcffdc5a8182d43d$var$y("Edge")) && !($bcffdc5a8182d43d$var$y("Trident") || $bcffdc5a8182d43d$var$y("MSIE")) && !$bcffdc5a8182d43d$var$y("Edge"), $bcffdc5a8182d43d$var$xa = -1 != $bcffdc5a8182d43d$var$pa().toLowerCase().indexOf("webkit") && !$bcffdc5a8182d43d$var$y("Edge");
function $bcffdc5a8182d43d$var$ya() {
    var a = $bcffdc5a8182d43d$var$l.document;
    return a ? a.documentMode : void 0;
}
var $bcffdc5a8182d43d$var$za;
a: {
    var $bcffdc5a8182d43d$var$Aa = "", $bcffdc5a8182d43d$var$Ba = function() {
        var a = $bcffdc5a8182d43d$var$pa();
        if ($bcffdc5a8182d43d$var$wa) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($bcffdc5a8182d43d$var$ua) return /Edge\/([\d\.]+)/.exec(a);
        if ($bcffdc5a8182d43d$var$z) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($bcffdc5a8182d43d$var$xa) return /WebKit\/(\S+)/.exec(a);
        if ($bcffdc5a8182d43d$var$ta) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $bcffdc5a8182d43d$var$Ba && ($bcffdc5a8182d43d$var$Aa = $bcffdc5a8182d43d$var$Ba ? $bcffdc5a8182d43d$var$Ba[1] : "");
    if ($bcffdc5a8182d43d$var$z) {
        var $bcffdc5a8182d43d$var$Ca = $bcffdc5a8182d43d$var$ya();
        if (null != $bcffdc5a8182d43d$var$Ca && $bcffdc5a8182d43d$var$Ca > parseFloat($bcffdc5a8182d43d$var$Aa)) {
            $bcffdc5a8182d43d$var$za = String($bcffdc5a8182d43d$var$Ca);
            break a;
        }
    }
    $bcffdc5a8182d43d$var$za = $bcffdc5a8182d43d$var$Aa;
}
var $bcffdc5a8182d43d$var$Da;
if ($bcffdc5a8182d43d$var$l.document && $bcffdc5a8182d43d$var$z) {
    var $bcffdc5a8182d43d$var$Ea = $bcffdc5a8182d43d$var$ya();
    $bcffdc5a8182d43d$var$Da = $bcffdc5a8182d43d$var$Ea ? $bcffdc5a8182d43d$var$Ea : parseInt($bcffdc5a8182d43d$var$za, 10) || void 0;
} else $bcffdc5a8182d43d$var$Da = void 0;
var $bcffdc5a8182d43d$var$Fa = $bcffdc5a8182d43d$var$Da;
function $bcffdc5a8182d43d$var$A(a, b) {
    $bcffdc5a8182d43d$var$w.call(this, a ? a.type : "");
    this.relatedTarget = this.g = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.state = null;
    this.pointerId = 0;
    this.pointerType = "";
    this.i = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        if (b = a.relatedTarget) {
            if ($bcffdc5a8182d43d$var$wa) {
                a: {
                    try {
                        $bcffdc5a8182d43d$var$qa(b.nodeName);
                        var e = !0;
                        break a;
                    } catch (f) {}
                    e = !1;
                }
                e || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $bcffdc5a8182d43d$var$Ga[a.pointerType] || "";
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && $bcffdc5a8182d43d$var$A.$.h.call(this);
    }
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$A, $bcffdc5a8182d43d$var$w);
var $bcffdc5a8182d43d$var$Ga = {
    2: "touch",
    3: "pen",
    4: "mouse"
};
$bcffdc5a8182d43d$var$A.prototype.h = function() {
    $bcffdc5a8182d43d$var$A.$.h.call(this);
    var a = this.i;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $bcffdc5a8182d43d$var$Ha = "closure_listenable_" + (1E6 * Math.random() | 0);
var $bcffdc5a8182d43d$var$Ia = 0;
function $bcffdc5a8182d43d$var$Ja(a, b, c, d, e) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.la = e;
    this.key = ++$bcffdc5a8182d43d$var$Ia;
    this.fa = this.ia = !1;
}
function $bcffdc5a8182d43d$var$Ka(a) {
    a.fa = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.la = null;
}
function $bcffdc5a8182d43d$var$Na(a, b, c) {
    for(var d in a)b.call(c, a[d], d, a);
}
function $bcffdc5a8182d43d$var$Oa(a, b) {
    for(var c in a)b.call(void 0, a[c], c, a);
}
function $bcffdc5a8182d43d$var$Pa(a) {
    var b = {};
    for(var c in a)b[c] = a[c];
    return b;
}
var $bcffdc5a8182d43d$var$Qa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $bcffdc5a8182d43d$var$Ra(a, b) {
    var c, d;
    for(var e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(var f = 0; f < $bcffdc5a8182d43d$var$Qa.length; f++)c = $bcffdc5a8182d43d$var$Qa[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $bcffdc5a8182d43d$var$Sa(a) {
    this.src = a;
    this.g = {};
    this.h = 0;
}
$bcffdc5a8182d43d$var$Sa.prototype.add = function(a, b, c, d, e) {
    var f = a.toString();
    a = this.g[f];
    a || (a = this.g[f] = [], this.h++);
    var h = $bcffdc5a8182d43d$var$Ta(a, b, d, e);
    -1 < h ? (b = a[h], c || (b.ia = !1)) : (b = new $bcffdc5a8182d43d$var$Ja(b, this.src, f, !!d, e), b.ia = c, a.push(b));
    return b;
};
function $bcffdc5a8182d43d$var$Ua(a, b) {
    var c = b.type;
    if (c in a.g) {
        var d = a.g[c], e = $bcffdc5a8182d43d$var$ka(d, b), f;
        (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
        f && ($bcffdc5a8182d43d$var$Ka(b), 0 == a.g[c].length && (delete a.g[c], a.h--));
    }
}
function $bcffdc5a8182d43d$var$Ta(a, b, c, d) {
    for(var e = 0; e < a.length; ++e){
        var f = a[e];
        if (!f.fa && f.listener == b && f.capture == !!c && f.la == d) return e;
    }
    return -1;
}
var $bcffdc5a8182d43d$var$Va = "closure_lm_" + (1E6 * Math.random() | 0), $bcffdc5a8182d43d$var$Wa = {};
function $bcffdc5a8182d43d$var$Ya(a, b, c, d, e) {
    if (d && d.once) return $bcffdc5a8182d43d$var$Za(a, b, c, d, e);
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$bcffdc5a8182d43d$var$Ya(a, b[f], c, d, e);
        return null;
    }
    c = $bcffdc5a8182d43d$var$$a(c);
    return a && a[$bcffdc5a8182d43d$var$Ha] ? a.O(b, c, $bcffdc5a8182d43d$var$p(d) ? !!d.capture : !!d, e) : $bcffdc5a8182d43d$var$ab(a, b, c, !1, d, e);
}
function $bcffdc5a8182d43d$var$ab(a, b, c, d, e, f) {
    if (!b) throw Error("Invalid event type");
    var h = $bcffdc5a8182d43d$var$p(e) ? !!e.capture : !!e, n = $bcffdc5a8182d43d$var$bb(a);
    n || (a[$bcffdc5a8182d43d$var$Va] = n = new $bcffdc5a8182d43d$var$Sa(a));
    c = n.add(b, c, d, h, f);
    if (c.proxy) return c;
    d = $bcffdc5a8182d43d$var$cb();
    c.proxy = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) $bcffdc5a8182d43d$var$oa || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
    else if (a.attachEvent) a.attachEvent($bcffdc5a8182d43d$var$db(b.toString()), d);
    else if (a.addListener && a.removeListener) a.addListener(d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    return c;
}
function $bcffdc5a8182d43d$var$cb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    var b = $bcffdc5a8182d43d$var$eb;
    return a;
}
function $bcffdc5a8182d43d$var$Za(a, b, c, d, e) {
    if (Array.isArray(b)) {
        for(var f = 0; f < b.length; f++)$bcffdc5a8182d43d$var$Za(a, b[f], c, d, e);
        return null;
    }
    c = $bcffdc5a8182d43d$var$$a(c);
    return a && a[$bcffdc5a8182d43d$var$Ha] ? a.P(b, c, $bcffdc5a8182d43d$var$p(d) ? !!d.capture : !!d, e) : $bcffdc5a8182d43d$var$ab(a, b, c, !0, d, e);
}
function $bcffdc5a8182d43d$var$fb(a, b, c, d, e) {
    if (Array.isArray(b)) for(var f = 0; f < b.length; f++)$bcffdc5a8182d43d$var$fb(a, b[f], c, d, e);
    else (d = $bcffdc5a8182d43d$var$p(d) ? !!d.capture : !!d, c = $bcffdc5a8182d43d$var$$a(c), a && a[$bcffdc5a8182d43d$var$Ha]) ? (a = a.i, b = String(b).toString(), b in a.g && (f = a.g[b], c = $bcffdc5a8182d43d$var$Ta(f, c, d, e), -1 < c && ($bcffdc5a8182d43d$var$Ka(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.g[b], a.h--)))) : a && (a = $bcffdc5a8182d43d$var$bb(a)) && (b = a.g[b.toString()], a = -1, b && (a = $bcffdc5a8182d43d$var$Ta(b, c, d, e)), (c = -1 < a ? b[a] : null) && $bcffdc5a8182d43d$var$gb(c));
}
function $bcffdc5a8182d43d$var$gb(a) {
    if ("number" !== typeof a && a && !a.fa) {
        var b = a.src;
        if (b && b[$bcffdc5a8182d43d$var$Ha]) $bcffdc5a8182d43d$var$Ua(b.i, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($bcffdc5a8182d43d$var$db(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            (c = $bcffdc5a8182d43d$var$bb(b)) ? ($bcffdc5a8182d43d$var$Ua(c, a), 0 == c.h && (c.src = null, b[$bcffdc5a8182d43d$var$Va] = null)) : $bcffdc5a8182d43d$var$Ka(a);
        }
    }
}
function $bcffdc5a8182d43d$var$db(a) {
    return a in $bcffdc5a8182d43d$var$Wa ? $bcffdc5a8182d43d$var$Wa[a] : $bcffdc5a8182d43d$var$Wa[a] = "on" + a;
}
function $bcffdc5a8182d43d$var$eb(a, b) {
    if (a.fa) a = !0;
    else {
        b = new $bcffdc5a8182d43d$var$A(b, this);
        var c = a.listener, d = a.la || a.src;
        a.ia && $bcffdc5a8182d43d$var$gb(a);
        a = c.call(d, b);
    }
    return a;
}
function $bcffdc5a8182d43d$var$bb(a) {
    a = a[$bcffdc5a8182d43d$var$Va];
    return a instanceof $bcffdc5a8182d43d$var$Sa ? a : null;
}
var $bcffdc5a8182d43d$var$hb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $bcffdc5a8182d43d$var$$a(a) {
    if ("function" === typeof a) return a;
    a[$bcffdc5a8182d43d$var$hb] || (a[$bcffdc5a8182d43d$var$hb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$bcffdc5a8182d43d$var$hb];
}
function $bcffdc5a8182d43d$var$B() {
    $bcffdc5a8182d43d$var$v.call(this);
    this.i = new $bcffdc5a8182d43d$var$Sa(this);
    this.S = this;
    this.J = null;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$B, $bcffdc5a8182d43d$var$v);
$bcffdc5a8182d43d$var$B.prototype[$bcffdc5a8182d43d$var$Ha] = !0;
$bcffdc5a8182d43d$var$B.prototype.removeEventListener = function(a, b, c, d) {
    $bcffdc5a8182d43d$var$fb(this, a, b, c, d);
};
function $bcffdc5a8182d43d$var$C(a, b) {
    var c, d = a.J;
    if (d) for(c = []; d; d = d.J)c.push(d);
    a = a.S;
    d = b.type || b;
    if ("string" === typeof b) b = new $bcffdc5a8182d43d$var$w(b, a);
    else if (b instanceof $bcffdc5a8182d43d$var$w) b.target = b.target || a;
    else {
        var e = b;
        b = new $bcffdc5a8182d43d$var$w(d, a);
        $bcffdc5a8182d43d$var$Ra(b, e);
    }
    e = !0;
    if (c) for(var f = c.length - 1; 0 <= f; f--){
        var h = b.g = c[f];
        e = $bcffdc5a8182d43d$var$ib(h, d, !0, b) && e;
    }
    h = b.g = a;
    e = $bcffdc5a8182d43d$var$ib(h, d, !0, b) && e;
    e = $bcffdc5a8182d43d$var$ib(h, d, !1, b) && e;
    if (c) for(f = 0; f < c.length; f++)h = b.g = c[f], e = $bcffdc5a8182d43d$var$ib(h, d, !1, b) && e;
}
$bcffdc5a8182d43d$var$B.prototype.N = function() {
    $bcffdc5a8182d43d$var$B.$.N.call(this);
    if (this.i) {
        var a = this.i, c;
        for(c in a.g){
            for(var d = a.g[c], e = 0; e < d.length; e++)$bcffdc5a8182d43d$var$Ka(d[e]);
            delete a.g[c];
            a.h--;
        }
    }
    this.J = null;
};
$bcffdc5a8182d43d$var$B.prototype.O = function(a, b, c, d) {
    return this.i.add(String(a), b, !1, c, d);
};
$bcffdc5a8182d43d$var$B.prototype.P = function(a, b, c, d) {
    return this.i.add(String(a), b, !0, c, d);
};
function $bcffdc5a8182d43d$var$ib(a, b, c, d) {
    b = a.i.g[String(b)];
    if (!b) return !0;
    b = b.concat();
    for(var e = !0, f = 0; f < b.length; ++f){
        var h = b[f];
        if (h && !h.fa && h.capture == c) {
            var n = h.listener, t = h.la || h.src;
            h.ia && $bcffdc5a8182d43d$var$Ua(a.i, h);
            e = !1 !== n.call(t, d) && e;
        }
    }
    return e && !d.defaultPrevented;
}
var $bcffdc5a8182d43d$var$jb = $bcffdc5a8182d43d$var$l.JSON.stringify;
var $bcffdc5a8182d43d$var$kb = /*#__PURE__*/ function() {
    "use strict";
    function kb(a, b) {
        (0, $978gY._)(this, kb);
        this.i = a;
        this.j = b;
        this.h = 0;
        this.g = null;
    }
    (0, $kry2a._)(kb, [
        {
            key: "get",
            value: function get() {
                var a;
                0 < this.h ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
                return a;
            }
        }
    ]);
    return kb;
}();
function $bcffdc5a8182d43d$var$lb() {
    var a = $bcffdc5a8182d43d$var$mb;
    var b = null;
    a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
    return b;
}
var $bcffdc5a8182d43d$var$nb = /*#__PURE__*/ function() {
    "use strict";
    function nb() {
        (0, $978gY._)(this, nb);
        this.h = this.g = null;
    }
    (0, $kry2a._)(nb, [
        {
            key: "add",
            value: function add(a, b) {
                var c = $bcffdc5a8182d43d$var$ob.get();
                c.set(a, b);
                this.h ? this.h.next = c : this.g = c;
                this.h = c;
            }
        }
    ]);
    return nb;
}();
var $bcffdc5a8182d43d$var$ob = new $bcffdc5a8182d43d$var$kb(function() {
    return new $bcffdc5a8182d43d$var$pb;
}, function(a) {
    return a.reset();
});
var $bcffdc5a8182d43d$var$pb = /*#__PURE__*/ function() {
    "use strict";
    function pb() {
        (0, $978gY._)(this, pb);
        this.next = this.g = this.h = null;
    }
    (0, $kry2a._)(pb, [
        {
            key: "set",
            value: function set(a, b) {
                this.h = a;
                this.g = b;
                this.next = null;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.next = this.g = this.h = null;
            }
        }
    ]);
    return pb;
}();
function $bcffdc5a8182d43d$var$qb(a) {
    var b = 1;
    a = a.split(":");
    var c = [];
    for(; 0 < b && a.length;)c.push(a.shift()), b--;
    a.length && c.push(a.join(":"));
    return c;
}
function $bcffdc5a8182d43d$var$rb(a) {
    $bcffdc5a8182d43d$var$l.setTimeout(function() {
        throw a;
    }, 0);
}
var $bcffdc5a8182d43d$var$sb, $bcffdc5a8182d43d$var$tb = !1, $bcffdc5a8182d43d$var$mb = new $bcffdc5a8182d43d$var$nb, $bcffdc5a8182d43d$var$vb = function() {
    var a = $bcffdc5a8182d43d$var$l.Promise.resolve(void 0);
    $bcffdc5a8182d43d$var$sb = function() {
        a.then($bcffdc5a8182d43d$var$ub);
    };
};
var $bcffdc5a8182d43d$var$ub = function() {
    for(var a; a = $bcffdc5a8182d43d$var$lb();){
        try {
            a.h.call(a.g);
        } catch (c) {
            $bcffdc5a8182d43d$var$rb(c);
        }
        var b = $bcffdc5a8182d43d$var$ob;
        b.j(a);
        100 > b.h && (b.h++, a.next = b.g, b.g = a);
    }
    $bcffdc5a8182d43d$var$tb = !1;
};
function $bcffdc5a8182d43d$var$wb(a, b) {
    $bcffdc5a8182d43d$var$B.call(this);
    this.h = a || 1;
    this.g = b || $bcffdc5a8182d43d$var$l;
    this.j = $bcffdc5a8182d43d$var$q(this.qb, this);
    this.l = Date.now();
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$wb, $bcffdc5a8182d43d$var$B);
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$wb.prototype;
$bcffdc5a8182d43d$var$k.ga = !1;
$bcffdc5a8182d43d$var$k.T = null;
$bcffdc5a8182d43d$var$k.qb = function() {
    if (this.ga) {
        var a = Date.now() - this.l;
        0 < a && a < .8 * this.h ? this.T = this.g.setTimeout(this.j, this.h - a) : (this.T && (this.g.clearTimeout(this.T), this.T = null), $bcffdc5a8182d43d$var$C(this, "tick"), this.ga && ($bcffdc5a8182d43d$var$xb(this), this.start()));
    }
};
$bcffdc5a8182d43d$var$k.start = function() {
    this.ga = !0;
    this.T || (this.T = this.g.setTimeout(this.j, this.h), this.l = Date.now());
};
function $bcffdc5a8182d43d$var$xb(a) {
    a.ga = !1;
    a.T && (a.g.clearTimeout(a.T), a.T = null);
}
$bcffdc5a8182d43d$var$k.N = function() {
    $bcffdc5a8182d43d$var$wb.$.N.call(this);
    $bcffdc5a8182d43d$var$xb(this);
    delete this.g;
};
function $bcffdc5a8182d43d$var$yb(a, b, c) {
    if ("function" === typeof a) c && (a = $bcffdc5a8182d43d$var$q(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $bcffdc5a8182d43d$var$q(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $bcffdc5a8182d43d$var$l.setTimeout(a, b || 0);
}
function $bcffdc5a8182d43d$var$zb(a) {
    a.g = $bcffdc5a8182d43d$var$yb(function() {
        a.g = null;
        a.i && (a.i = !1, $bcffdc5a8182d43d$var$zb(a));
    }, a.j);
    var b = a.h;
    a.h = null;
    a.m.apply(null, b);
}
var $bcffdc5a8182d43d$var$Ab = /*#__PURE__*/ function(v) {
    "use strict";
    (0, $ftJVG._)(Ab, v);
    var _super = (0, $6OZAO._)(Ab);
    function Ab(a, b) {
        (0, $978gY._)(this, Ab);
        var _this;
        _this = _super.call(this);
        _this.m = a;
        _this.j = b;
        _this.h = null;
        _this.i = !1;
        _this.g = null;
        return _this;
    }
    (0, $kry2a._)(Ab, [
        {
            key: "l",
            value: function l(a) {
                this.h = arguments;
                this.g ? this.i = !0 : $bcffdc5a8182d43d$var$zb(this);
            }
        },
        {
            key: "N",
            value: function N() {
                (0, $3cct3._)((0, $g3d7z._)(Ab.prototype), "N", this).call(this);
                this.g && ($bcffdc5a8182d43d$var$l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
            }
        }
    ]);
    return Ab;
}($bcffdc5a8182d43d$var$v);
function $bcffdc5a8182d43d$var$Bb(a) {
    $bcffdc5a8182d43d$var$v.call(this);
    this.h = a;
    this.g = {};
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Bb, $bcffdc5a8182d43d$var$v);
var $bcffdc5a8182d43d$var$Cb = [];
function $bcffdc5a8182d43d$var$Db(a, b, c, d) {
    Array.isArray(c) || (c && ($bcffdc5a8182d43d$var$Cb[0] = c.toString()), c = $bcffdc5a8182d43d$var$Cb);
    for(var e = 0; e < c.length; e++){
        var f = $bcffdc5a8182d43d$var$Ya(b, c[e], d || a.handleEvent, !1, a.h || a);
        if (!f) break;
        a.g[f.key] = f;
    }
}
function $bcffdc5a8182d43d$var$Fb(a) {
    $bcffdc5a8182d43d$var$Na(a.g, function(b, c) {
        this.g.hasOwnProperty(c) && $bcffdc5a8182d43d$var$gb(b);
    }, a);
    a.g = {};
}
$bcffdc5a8182d43d$var$Bb.prototype.N = function() {
    $bcffdc5a8182d43d$var$Bb.$.N.call(this);
    $bcffdc5a8182d43d$var$Fb(this);
};
$bcffdc5a8182d43d$var$Bb.prototype.handleEvent = function() {
    throw Error("EventHandler.handleEvent not implemented");
};
function $bcffdc5a8182d43d$var$Gb() {
    this.g = !0;
}
$bcffdc5a8182d43d$var$Gb.prototype.Ea = function() {
    this.g = !1;
};
function $bcffdc5a8182d43d$var$Hb(a, b, c, d, e, f) {
    a.info(function() {
        if (a.g) {
            if (f) {
                var h = "";
                for(var n = f.split("&"), t = 0; t < n.length; t++){
                    var m = n[t].split("=");
                    if (1 < m.length) {
                        var u = m[0];
                        m = m[1];
                        var L = u.split("_");
                        h = 2 <= L.length && "type" == L[1] ? h + (u + "=" + m + "&") : h + (u + "=redacted&");
                    }
                }
            } else h = null;
        } else h = f;
        return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + h;
    });
}
function $bcffdc5a8182d43d$var$Ib(a, b, c, d, e, f, h) {
    a.info(function() {
        return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + h;
    });
}
function $bcffdc5a8182d43d$var$D(a, b, c, d) {
    a.info(function() {
        return "XMLHTTP TEXT (" + b + "): " + $bcffdc5a8182d43d$var$Jb(a, c) + (d ? " " + d : "");
    });
}
function $bcffdc5a8182d43d$var$Kb(a, b) {
    a.info(function() {
        return "TIMEOUT: " + b;
    });
}
$bcffdc5a8182d43d$var$Gb.prototype.info = function() {};
function $bcffdc5a8182d43d$var$Jb(a, b) {
    if (!a.g) return b;
    if (!b) return null;
    try {
        var c = JSON.parse(b);
        if (c) {
            for(a = 0; a < c.length; a++)if (Array.isArray(c[a])) {
                var d = c[a];
                if (!(2 > d.length)) {
                    var e = d[1];
                    if (Array.isArray(e) && !(1 > e.length)) {
                        var f = e[0];
                        if ("noop" != f && "stop" != f && "close" != f) for(var h = 1; h < e.length; h++)e[h] = "";
                    }
                }
            }
        }
        return $bcffdc5a8182d43d$var$jb(c);
    } catch (n) {
        return b;
    }
}
var $bcffdc5a8182d43d$var$E = {}, $bcffdc5a8182d43d$var$Lb = null;
function $bcffdc5a8182d43d$var$Mb() {
    return $bcffdc5a8182d43d$var$Lb = $bcffdc5a8182d43d$var$Lb || new $bcffdc5a8182d43d$var$B;
}
$bcffdc5a8182d43d$var$E.Ta = "serverreachability";
function $bcffdc5a8182d43d$var$Nb(a) {
    $bcffdc5a8182d43d$var$w.call(this, $bcffdc5a8182d43d$var$E.Ta, a);
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Nb, $bcffdc5a8182d43d$var$w);
function $bcffdc5a8182d43d$var$Ob(a) {
    var b = $bcffdc5a8182d43d$var$Mb();
    $bcffdc5a8182d43d$var$C(b, new $bcffdc5a8182d43d$var$Nb(b));
}
$bcffdc5a8182d43d$var$E.STAT_EVENT = "statevent";
function $bcffdc5a8182d43d$var$Pb(a, b) {
    $bcffdc5a8182d43d$var$w.call(this, $bcffdc5a8182d43d$var$E.STAT_EVENT, a);
    this.stat = b;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Pb, $bcffdc5a8182d43d$var$w);
function $bcffdc5a8182d43d$var$F(a) {
    var b = $bcffdc5a8182d43d$var$Mb();
    $bcffdc5a8182d43d$var$C(b, new $bcffdc5a8182d43d$var$Pb(b, a));
}
$bcffdc5a8182d43d$var$E.Ua = "timingevent";
function $bcffdc5a8182d43d$var$Qb(a, b) {
    $bcffdc5a8182d43d$var$w.call(this, $bcffdc5a8182d43d$var$E.Ua, a);
    this.size = b;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Qb, $bcffdc5a8182d43d$var$w);
function $bcffdc5a8182d43d$var$Rb(a, b) {
    if ("function" !== typeof a) throw Error("Fn must not be null and must be a function");
    return $bcffdc5a8182d43d$var$l.setTimeout(function() {
        a();
    }, b);
}
var $bcffdc5a8182d43d$var$Sb = {
    NO_ERROR: 0,
    rb: 1,
    Eb: 2,
    Db: 3,
    yb: 4,
    Cb: 5,
    Fb: 6,
    Qa: 7,
    TIMEOUT: 8,
    Ib: 9
};
var $bcffdc5a8182d43d$var$Tb = {
    wb: "complete",
    Sb: "success",
    Ra: "error",
    Qa: "abort",
    Kb: "ready",
    Lb: "readystatechange",
    TIMEOUT: "timeout",
    Gb: "incrementaldata",
    Jb: "progress",
    zb: "downloadprogress",
    $b: "uploadprogress"
};
function $bcffdc5a8182d43d$var$Ub() {}
$bcffdc5a8182d43d$var$Ub.prototype.h = null;
function $bcffdc5a8182d43d$var$Vb(a) {
    return a.h || (a.h = a.i());
}
function $bcffdc5a8182d43d$var$Wb() {}
var $bcffdc5a8182d43d$var$Xb = {
    OPEN: "a",
    vb: "b",
    Ra: "c",
    Hb: "d"
};
function $bcffdc5a8182d43d$var$Yb() {
    $bcffdc5a8182d43d$var$w.call(this, "d");
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Yb, $bcffdc5a8182d43d$var$w);
function $bcffdc5a8182d43d$var$Zb() {
    $bcffdc5a8182d43d$var$w.call(this, "c");
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Zb, $bcffdc5a8182d43d$var$w);
var $bcffdc5a8182d43d$var$$b;
function $bcffdc5a8182d43d$var$ac() {}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$ac, $bcffdc5a8182d43d$var$Ub);
$bcffdc5a8182d43d$var$ac.prototype.g = function() {
    return new XMLHttpRequest;
};
$bcffdc5a8182d43d$var$ac.prototype.i = function() {
    return {};
};
$bcffdc5a8182d43d$var$$b = new $bcffdc5a8182d43d$var$ac;
function $bcffdc5a8182d43d$var$bc(a, b, c, d) {
    this.l = a;
    this.j = b;
    this.m = c;
    this.W = d || 1;
    this.U = new $bcffdc5a8182d43d$var$Bb(this);
    this.P = $bcffdc5a8182d43d$var$cc;
    a = $bcffdc5a8182d43d$var$va ? 125 : void 0;
    this.V = new $bcffdc5a8182d43d$var$wb(a);
    this.I = null;
    this.i = !1;
    this.s = this.A = this.v = this.L = this.G = this.Y = this.B = null;
    this.F = [];
    this.g = null;
    this.C = 0;
    this.o = this.u = null;
    this.ca = -1;
    this.J = !1;
    this.O = 0;
    this.M = null;
    this.ba = this.K = this.aa = this.S = !1;
    this.h = new $bcffdc5a8182d43d$var$dc;
}
function $bcffdc5a8182d43d$var$dc() {
    this.i = null;
    this.g = "";
    this.h = !1;
}
var $bcffdc5a8182d43d$var$cc = 45E3, $bcffdc5a8182d43d$var$ec = {}, $bcffdc5a8182d43d$var$fc = {};
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$bc.prototype;
$bcffdc5a8182d43d$var$k.setTimeout = function(a) {
    this.P = a;
};
function $bcffdc5a8182d43d$var$gc(a, b, c) {
    a.L = 1;
    a.v = $bcffdc5a8182d43d$var$hc($bcffdc5a8182d43d$var$G(b));
    a.s = c;
    a.S = !0;
    $bcffdc5a8182d43d$var$ic(a, null);
}
function $bcffdc5a8182d43d$var$ic(a, b) {
    a.G = Date.now();
    $bcffdc5a8182d43d$var$jc(a);
    a.A = $bcffdc5a8182d43d$var$G(a.v);
    var c = a.A, d = a.W;
    Array.isArray(d) || (d = [
        String(d)
    ]);
    $bcffdc5a8182d43d$var$kc(c.i, "t", d);
    a.C = 0;
    c = a.l.J;
    a.h = new $bcffdc5a8182d43d$var$dc;
    a.g = $bcffdc5a8182d43d$var$lc(a.l, c ? b : null, !a.s);
    0 < a.O && (a.M = new $bcffdc5a8182d43d$var$Ab($bcffdc5a8182d43d$var$q(a.Pa, a, a.g), a.O));
    $bcffdc5a8182d43d$var$Db(a.U, a.g, "readystatechange", a.nb);
    b = a.I ? $bcffdc5a8182d43d$var$Pa(a.I) : {};
    a.s ? (a.u || (a.u = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ha(a.A, a.u, a.s, b)) : (a.u = "GET", a.g.ha(a.A, a.u, null, b));
    $bcffdc5a8182d43d$var$Ob();
    $bcffdc5a8182d43d$var$Hb(a.j, a.u, a.A, a.m, a.W, a.s);
}
$bcffdc5a8182d43d$var$k.nb = function(a) {
    a = a.target;
    var b = this.M;
    b && 3 == $bcffdc5a8182d43d$var$H(a) ? b.l() : this.Pa(a);
};
$bcffdc5a8182d43d$var$k.Pa = function(a) {
    try {
        if (a == this.g) a: {
            var u = $bcffdc5a8182d43d$var$H(this.g);
            var b = this.g.Ia();
            var L = this.g.da();
            if (!(3 > u) && (3 != u || $bcffdc5a8182d43d$var$va || this.g && (this.h.h || this.g.ja() || $bcffdc5a8182d43d$var$mc(this.g)))) {
                this.J || 4 != u || 7 == b || (8 == b || 0 >= L ? $bcffdc5a8182d43d$var$Ob(3) : $bcffdc5a8182d43d$var$Ob(2));
                $bcffdc5a8182d43d$var$nc(this);
                var c = this.g.da();
                this.ca = c;
                b: if ($bcffdc5a8182d43d$var$oc(this)) {
                    var d = $bcffdc5a8182d43d$var$mc(this.g);
                    a = "";
                    var e = d.length, f = 4 == $bcffdc5a8182d43d$var$H(this.g);
                    if (!this.h.i) {
                        if ("undefined" === typeof TextDecoder) {
                            $bcffdc5a8182d43d$var$I(this);
                            $bcffdc5a8182d43d$var$pc(this);
                            var h = "";
                            break b;
                        }
                        this.h.i = new $bcffdc5a8182d43d$var$l.TextDecoder;
                    }
                    for(b = 0; b < e; b++)this.h.h = !0, a += this.h.i.decode(d[b], {
                        stream: f && b == e - 1
                    });
                    d.splice(0, e);
                    this.h.g += a;
                    this.C = 0;
                    h = this.h.g;
                } else h = this.g.ja();
                this.i = 200 == c;
                $bcffdc5a8182d43d$var$Ib(this.j, this.u, this.A, this.m, this.W, u, c);
                if (this.i) {
                    if (this.aa && !this.K) {
                        b: {
                            if (this.g) {
                                var n, t = this.g;
                                if ((n = t.g ? t.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !$bcffdc5a8182d43d$var$x(n)) {
                                    var m = n;
                                    break b;
                                }
                            }
                            m = null;
                        }
                        if (c = m) $bcffdc5a8182d43d$var$D(this.j, this.m, c, "Initial handshake response via X-HTTP-Initial-Response"), this.K = !0, $bcffdc5a8182d43d$var$qc(this, c);
                        else {
                            this.i = !1;
                            this.o = 3;
                            $bcffdc5a8182d43d$var$F(12);
                            $bcffdc5a8182d43d$var$I(this);
                            $bcffdc5a8182d43d$var$pc(this);
                            break a;
                        }
                    }
                    this.S ? ($bcffdc5a8182d43d$var$rc(this, u, h), $bcffdc5a8182d43d$var$va && this.i && 3 == u && ($bcffdc5a8182d43d$var$Db(this.U, this.V, "tick", this.mb), this.V.start())) : ($bcffdc5a8182d43d$var$D(this.j, this.m, h, null), $bcffdc5a8182d43d$var$qc(this, h));
                    4 == u && $bcffdc5a8182d43d$var$I(this);
                    this.i && !this.J && (4 == u ? $bcffdc5a8182d43d$var$sc(this.l, this) : (this.i = !1, $bcffdc5a8182d43d$var$jc(this)));
                } else $bcffdc5a8182d43d$var$tc(this.g), 400 == c && 0 < h.indexOf("Unknown SID") ? (this.o = 3, $bcffdc5a8182d43d$var$F(12)) : (this.o = 0, $bcffdc5a8182d43d$var$F(13)), $bcffdc5a8182d43d$var$I(this), $bcffdc5a8182d43d$var$pc(this);
            }
        }
    } catch (u) {} finally{}
};
function $bcffdc5a8182d43d$var$oc(a) {
    return a.g ? "GET" == a.u && 2 != a.L && a.l.Ha : !1;
}
function $bcffdc5a8182d43d$var$rc(a, b, c) {
    var d = !0, e;
    for(; !a.J && a.C < c.length;)if (e = $bcffdc5a8182d43d$var$uc(a, c), e == $bcffdc5a8182d43d$var$fc) {
        4 == b && (a.o = 4, $bcffdc5a8182d43d$var$F(14), d = !1);
        $bcffdc5a8182d43d$var$D(a.j, a.m, null, "[Incomplete Response]");
        break;
    } else if (e == $bcffdc5a8182d43d$var$ec) {
        a.o = 4;
        $bcffdc5a8182d43d$var$F(15);
        $bcffdc5a8182d43d$var$D(a.j, a.m, c, "[Invalid Chunk]");
        d = !1;
        break;
    } else $bcffdc5a8182d43d$var$D(a.j, a.m, e, null), $bcffdc5a8182d43d$var$qc(a, e);
    $bcffdc5a8182d43d$var$oc(a) && e != $bcffdc5a8182d43d$var$fc && e != $bcffdc5a8182d43d$var$ec && (a.h.g = "", a.C = 0);
    4 != b || 0 != c.length || a.h.h || (a.o = 1, $bcffdc5a8182d43d$var$F(16), d = !1);
    a.i = a.i && d;
    d ? 0 < c.length && !a.ba && (a.ba = !0, b = a.l, b.g == a && b.ca && !b.M && (b.l.info("Great, no buffering proxy detected. Bytes received: " + c.length), $bcffdc5a8182d43d$var$vc(b), b.M = !0, $bcffdc5a8182d43d$var$F(11))) : ($bcffdc5a8182d43d$var$D(a.j, a.m, c, "[Invalid Chunked Response]"), $bcffdc5a8182d43d$var$I(a), $bcffdc5a8182d43d$var$pc(a));
}
$bcffdc5a8182d43d$var$k.mb = function() {
    if (this.g) {
        var a = $bcffdc5a8182d43d$var$H(this.g), b = this.g.ja();
        this.C < b.length && ($bcffdc5a8182d43d$var$nc(this), $bcffdc5a8182d43d$var$rc(this, a, b), this.i && 4 != a && $bcffdc5a8182d43d$var$jc(this));
    }
};
function $bcffdc5a8182d43d$var$uc(a, b) {
    var c = a.C, d = b.indexOf("\n", c);
    if (-1 == d) return $bcffdc5a8182d43d$var$fc;
    c = Number(b.substring(c, d));
    if (isNaN(c)) return $bcffdc5a8182d43d$var$ec;
    d += 1;
    if (d + c > b.length) return $bcffdc5a8182d43d$var$fc;
    b = b.slice(d, d + c);
    a.C = d + c;
    return b;
}
$bcffdc5a8182d43d$var$k.cancel = function() {
    this.J = !0;
    $bcffdc5a8182d43d$var$I(this);
};
function $bcffdc5a8182d43d$var$jc(a) {
    a.Y = Date.now() + a.P;
    $bcffdc5a8182d43d$var$wc(a, a.P);
}
function $bcffdc5a8182d43d$var$wc(a, b) {
    if (null != a.B) throw Error("WatchDog timer not null");
    a.B = $bcffdc5a8182d43d$var$Rb($bcffdc5a8182d43d$var$q(a.lb, a), b);
}
function $bcffdc5a8182d43d$var$nc(a) {
    a.B && ($bcffdc5a8182d43d$var$l.clearTimeout(a.B), a.B = null);
}
$bcffdc5a8182d43d$var$k.lb = function() {
    this.B = null;
    var a = Date.now();
    0 <= a - this.Y ? ($bcffdc5a8182d43d$var$Kb(this.j, this.A), 2 != this.L && ($bcffdc5a8182d43d$var$Ob(), $bcffdc5a8182d43d$var$F(17)), $bcffdc5a8182d43d$var$I(this), this.o = 2, $bcffdc5a8182d43d$var$pc(this)) : $bcffdc5a8182d43d$var$wc(this, this.Y - a);
};
function $bcffdc5a8182d43d$var$pc(a) {
    0 == a.l.H || a.J || $bcffdc5a8182d43d$var$sc(a.l, a);
}
function $bcffdc5a8182d43d$var$I(a) {
    $bcffdc5a8182d43d$var$nc(a);
    var b = a.M;
    b && "function" == typeof b.sa && b.sa();
    a.M = null;
    $bcffdc5a8182d43d$var$xb(a.V);
    $bcffdc5a8182d43d$var$Fb(a.U);
    a.g && (b = a.g, a.g = null, b.abort(), b.sa());
}
function $bcffdc5a8182d43d$var$qc(a, b) {
    try {
        var c = a.l;
        if (0 != c.H && (c.g == a || $bcffdc5a8182d43d$var$xc(c.i, a))) {
            if (!a.K && $bcffdc5a8182d43d$var$xc(c.i, a) && 3 == c.H) {
                try {
                    var d = c.Ja.g.parse(b);
                } catch (m) {
                    d = null;
                }
                if (Array.isArray(d) && 3 == d.length) {
                    var e = d;
                    if (0 == e[0]) {
                        a: if (!c.u) {
                            if (c.g) {
                                if (c.g.G + 3E3 < a.G) $bcffdc5a8182d43d$var$yc(c), $bcffdc5a8182d43d$var$zc(c);
                                else break a;
                            }
                            $bcffdc5a8182d43d$var$Ac(c);
                            $bcffdc5a8182d43d$var$F(18);
                        }
                    } else c.Fa = e[1], 0 < c.Fa - c.V && 37500 > e[2] && c.G && 0 == c.A && !c.v && (c.v = $bcffdc5a8182d43d$var$Rb($bcffdc5a8182d43d$var$q(c.ib, c), 6E3));
                    if (1 >= $bcffdc5a8182d43d$var$Bc(c.i) && c.oa) {
                        try {
                            c.oa();
                        } catch (m) {}
                        c.oa = void 0;
                    }
                } else $bcffdc5a8182d43d$var$J(c, 11);
            } else if ((a.K || c.g == a) && $bcffdc5a8182d43d$var$yc(c), !$bcffdc5a8182d43d$var$x(b)) for(e = c.Ja.g.parse(b), b = 0; b < e.length; b++){
                var m = e[b];
                c.V = m[0];
                m = m[1];
                if (2 == c.H) {
                    if ("c" == m[0]) {
                        c.K = m[1];
                        c.pa = m[2];
                        var u = m[3];
                        null != u && (c.ra = u, c.l.info("VER=" + c.ra));
                        var L = m[4];
                        null != L && (c.Ga = L, c.l.info("SVER=" + c.Ga));
                        var La = m[5];
                        null != La && "number" === typeof La && 0 < La && (d = 1.5 * La, c.L = d, c.l.info("backChannelRequestTimeoutMs_=" + d));
                        d = c;
                        var la = a.g;
                        if (la) {
                            var Ma = la.g ? la.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                            if (Ma) {
                                var f = d.i;
                                f.g || -1 == Ma.indexOf("spdy") && -1 == Ma.indexOf("quic") && -1 == Ma.indexOf("h2") || (f.j = f.l, f.g = new Set, f.h && ($bcffdc5a8182d43d$var$Cc(f, f.h), f.h = null));
                            }
                            if (d.F) {
                                var Eb = la.g ? la.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                Eb && (d.Da = Eb, $bcffdc5a8182d43d$var$K(d.I, d.F, Eb));
                            }
                        }
                        c.H = 3;
                        c.h && c.h.Ba();
                        c.ca && (c.S = Date.now() - a.G, c.l.info("Handshake RTT: " + c.S + "ms"));
                        d = c;
                        var h = a;
                        d.wa = $bcffdc5a8182d43d$var$Dc(d, d.J ? d.pa : null, d.Y);
                        if (h.K) {
                            $bcffdc5a8182d43d$var$Ec(d.i, h);
                            var n = h, t = d.L;
                            t && n.setTimeout(t);
                            n.B && ($bcffdc5a8182d43d$var$nc(n), $bcffdc5a8182d43d$var$jc(n));
                            d.g = h;
                        } else $bcffdc5a8182d43d$var$Fc(d);
                        0 < c.j.length && $bcffdc5a8182d43d$var$Gc(c);
                    } else "stop" != m[0] && "close" != m[0] || $bcffdc5a8182d43d$var$J(c, 7);
                } else 3 == c.H && ("stop" == m[0] || "close" == m[0] ? "stop" == m[0] ? $bcffdc5a8182d43d$var$J(c, 7) : $bcffdc5a8182d43d$var$Hc(c) : "noop" != m[0] && c.h && c.h.Aa(m), c.A = 0);
            }
        }
        $bcffdc5a8182d43d$var$Ob(4);
    } catch (m) {}
}
function $bcffdc5a8182d43d$var$Ic(a) {
    if (a.Z && "function" == typeof a.Z) return a.Z();
    if ("undefined" !== typeof Map && a instanceof Map || "undefined" !== typeof Set && a instanceof Set) return Array.from(a.values());
    if ("string" === typeof a) return a.split("");
    if ($bcffdc5a8182d43d$var$aa(a)) {
        for(var b = [], c = a.length, d = 0; d < c; d++)b.push(a[d]);
        return b;
    }
    b = [];
    c = 0;
    for(d in a)b[c++] = a[d];
    return b;
}
function $bcffdc5a8182d43d$var$Jc(a) {
    if (a.ta && "function" == typeof a.ta) return a.ta();
    if (!a.Z || "function" != typeof a.Z) {
        if ("undefined" !== typeof Map && a instanceof Map) return Array.from(a.keys());
        if (!("undefined" !== typeof Set && a instanceof Set)) {
            if ($bcffdc5a8182d43d$var$aa(a) || "string" === typeof a) {
                var b = [];
                a = a.length;
                for(var c = 0; c < a; c++)b.push(c);
                return b;
            }
            b = [];
            c = 0;
            for(var d in a)b[c++] = d;
            return b;
        }
    }
}
function $bcffdc5a8182d43d$var$Kc(a, b) {
    if (a.forEach && "function" == typeof a.forEach) a.forEach(b, void 0);
    else if ($bcffdc5a8182d43d$var$aa(a) || "string" === typeof a) Array.prototype.forEach.call(a, b, void 0);
    else for(var c = $bcffdc5a8182d43d$var$Jc(a), d = $bcffdc5a8182d43d$var$Ic(a), e = d.length, f = 0; f < e; f++)b.call(void 0, d[f], c && c[f], a);
}
var $bcffdc5a8182d43d$var$Lc = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
function $bcffdc5a8182d43d$var$Mc(a, b) {
    if (a) {
        a = a.split("&");
        for(var c = 0; c < a.length; c++){
            var d = a[c].indexOf("="), e = null;
            if (0 <= d) {
                var f = a[c].substring(0, d);
                e = a[c].substring(d + 1);
            } else f = a[c];
            b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
        }
    }
}
function $bcffdc5a8182d43d$var$M(a) {
    this.g = this.s = this.j = "";
    this.m = null;
    this.o = this.l = "";
    this.h = !1;
    if (a instanceof $bcffdc5a8182d43d$var$M) {
        this.h = a.h;
        $bcffdc5a8182d43d$var$Nc(this, a.j);
        this.s = a.s;
        this.g = a.g;
        $bcffdc5a8182d43d$var$Oc(this, a.m);
        this.l = a.l;
        var b = a.i;
        var c = new $bcffdc5a8182d43d$var$Pc;
        c.i = b.i;
        b.g && (c.g = new Map(b.g), c.h = b.h);
        $bcffdc5a8182d43d$var$Qc(this, c);
        this.o = a.o;
    } else a && (b = String(a).match($bcffdc5a8182d43d$var$Lc)) ? (this.h = !1, $bcffdc5a8182d43d$var$Nc(this, b[1] || "", !0), this.s = $bcffdc5a8182d43d$var$Rc(b[2] || ""), this.g = $bcffdc5a8182d43d$var$Rc(b[3] || "", !0), $bcffdc5a8182d43d$var$Oc(this, b[4]), this.l = $bcffdc5a8182d43d$var$Rc(b[5] || "", !0), $bcffdc5a8182d43d$var$Qc(this, b[6] || "", !0), this.o = $bcffdc5a8182d43d$var$Rc(b[7] || "")) : (this.h = !1, this.i = new $bcffdc5a8182d43d$var$Pc(null, this.h));
}
$bcffdc5a8182d43d$var$M.prototype.toString = function() {
    var a = [], b = this.j;
    b && a.push($bcffdc5a8182d43d$var$Sc(b, $bcffdc5a8182d43d$var$Tc, !0), ":");
    var c = this.g;
    if (c || "file" == b) a.push("//"), (b = this.s) && a.push($bcffdc5a8182d43d$var$Sc(b, $bcffdc5a8182d43d$var$Tc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.m, null != c && a.push(":", String(c));
    if (c = this.l) this.g && "/" != c.charAt(0) && a.push("/"), a.push($bcffdc5a8182d43d$var$Sc(c, "/" == c.charAt(0) ? $bcffdc5a8182d43d$var$Uc : $bcffdc5a8182d43d$var$Vc, !0));
    (c = this.i.toString()) && a.push("?", c);
    (c = this.o) && a.push("#", $bcffdc5a8182d43d$var$Sc(c, $bcffdc5a8182d43d$var$Wc));
    return a.join("");
};
function $bcffdc5a8182d43d$var$G(a) {
    return new $bcffdc5a8182d43d$var$M(a);
}
function $bcffdc5a8182d43d$var$Nc(a, b, c) {
    a.j = c ? $bcffdc5a8182d43d$var$Rc(b, !0) : b;
    a.j && (a.j = a.j.replace(/:$/, ""));
}
function $bcffdc5a8182d43d$var$Oc(a, b) {
    if (b) {
        b = Number(b);
        if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
        a.m = b;
    } else a.m = null;
}
function $bcffdc5a8182d43d$var$Qc(a, b, c) {
    b instanceof $bcffdc5a8182d43d$var$Pc ? (a.i = b, $bcffdc5a8182d43d$var$Xc(a.i, a.h)) : (c || (b = $bcffdc5a8182d43d$var$Sc(b, $bcffdc5a8182d43d$var$Yc)), a.i = new $bcffdc5a8182d43d$var$Pc(b, a.h));
}
function $bcffdc5a8182d43d$var$K(a, b, c) {
    a.i.set(b, c);
}
function $bcffdc5a8182d43d$var$hc(a) {
    $bcffdc5a8182d43d$var$K(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ Date.now()).toString(36));
    return a;
}
function $bcffdc5a8182d43d$var$Rc(a, b) {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
}
function $bcffdc5a8182d43d$var$Sc(a, b, c) {
    return "string" === typeof a ? (a = encodeURI(a).replace(b, $bcffdc5a8182d43d$var$Zc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
}
function $bcffdc5a8182d43d$var$Zc(a) {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
}
var $bcffdc5a8182d43d$var$Tc = /[#\/\?@]/g, $bcffdc5a8182d43d$var$Vc = /[#\?:]/g, $bcffdc5a8182d43d$var$Uc = /[#\?]/g, $bcffdc5a8182d43d$var$Yc = /[#\?@]/g, $bcffdc5a8182d43d$var$Wc = /#/g;
function $bcffdc5a8182d43d$var$Pc(a, b) {
    this.h = this.g = null;
    this.i = a || null;
    this.j = !!b;
}
function $bcffdc5a8182d43d$var$N(a) {
    a.g || (a.g = new Map, a.h = 0, a.i && $bcffdc5a8182d43d$var$Mc(a.i, function(b, c) {
        a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
    }));
}
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$Pc.prototype;
$bcffdc5a8182d43d$var$k.add = function(a, b) {
    $bcffdc5a8182d43d$var$N(this);
    this.i = null;
    a = $bcffdc5a8182d43d$var$O(this, a);
    var c = this.g.get(a);
    c || this.g.set(a, c = []);
    c.push(b);
    this.h += 1;
    return this;
};
function $bcffdc5a8182d43d$var$$c(a, b) {
    $bcffdc5a8182d43d$var$N(a);
    b = $bcffdc5a8182d43d$var$O(a, b);
    a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
}
function $bcffdc5a8182d43d$var$ad(a, b) {
    $bcffdc5a8182d43d$var$N(a);
    b = $bcffdc5a8182d43d$var$O(a, b);
    return a.g.has(b);
}
$bcffdc5a8182d43d$var$k.forEach = function(a, b) {
    $bcffdc5a8182d43d$var$N(this);
    this.g.forEach(function(c, d) {
        c.forEach(function(e) {
            a.call(b, e, d, this);
        }, this);
    }, this);
};
$bcffdc5a8182d43d$var$k.ta = function() {
    $bcffdc5a8182d43d$var$N(this);
    var a = Array.from(this.g.values()), b = Array.from(this.g.keys()), c = [];
    for(var d = 0; d < b.length; d++){
        var e = a[d];
        for(var f = 0; f < e.length; f++)c.push(b[d]);
    }
    return c;
};
$bcffdc5a8182d43d$var$k.Z = function(a) {
    $bcffdc5a8182d43d$var$N(this);
    var b = [];
    if ("string" === typeof a) $bcffdc5a8182d43d$var$ad(this, a) && (b = b.concat(this.g.get($bcffdc5a8182d43d$var$O(this, a))));
    else {
        a = Array.from(this.g.values());
        for(var c = 0; c < a.length; c++)b = b.concat(a[c]);
    }
    return b;
};
$bcffdc5a8182d43d$var$k.set = function(a, b) {
    $bcffdc5a8182d43d$var$N(this);
    this.i = null;
    a = $bcffdc5a8182d43d$var$O(this, a);
    $bcffdc5a8182d43d$var$ad(this, a) && (this.h -= this.g.get(a).length);
    this.g.set(a, [
        b
    ]);
    this.h += 1;
    return this;
};
$bcffdc5a8182d43d$var$k.get = function(a, b) {
    if (!a) return b;
    a = this.Z(a);
    return 0 < a.length ? String(a[0]) : b;
};
function $bcffdc5a8182d43d$var$kc(a, b, c) {
    $bcffdc5a8182d43d$var$$c(a, b);
    0 < c.length && (a.i = null, a.g.set($bcffdc5a8182d43d$var$O(a, b), $bcffdc5a8182d43d$var$ma(c)), a.h += c.length);
}
$bcffdc5a8182d43d$var$k.toString = function() {
    if (this.i) return this.i;
    if (!this.g) return "";
    var a = [], b = Array.from(this.g.keys());
    for(var c = 0; c < b.length; c++){
        var d = b[c];
        var f = encodeURIComponent(String(d)), h = this.Z(d);
        for(d = 0; d < h.length; d++){
            var e = f;
            "" !== h[d] && (e += "=" + encodeURIComponent(String(h[d])));
            a.push(e);
        }
    }
    return this.i = a.join("&");
};
function $bcffdc5a8182d43d$var$O(a, b) {
    b = String(b);
    a.j && (b = b.toLowerCase());
    return b;
}
function $bcffdc5a8182d43d$var$Xc(a, b) {
    b && !a.j && ($bcffdc5a8182d43d$var$N(a), a.i = null, a.g.forEach(function(c, d) {
        var e = d.toLowerCase();
        d != e && ($bcffdc5a8182d43d$var$$c(this, d), $bcffdc5a8182d43d$var$kc(this, e, c));
    }, a));
    a.j = b;
}
var $bcffdc5a8182d43d$var$bd = function bd(a, b) {
    "use strict";
    (0, $978gY._)(this, bd);
    this.g = a;
    this.map = b;
};
function $bcffdc5a8182d43d$var$cd(a) {
    this.l = a || $bcffdc5a8182d43d$var$dd;
    $bcffdc5a8182d43d$var$l.PerformanceNavigationTiming ? (a = $bcffdc5a8182d43d$var$l.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!($bcffdc5a8182d43d$var$l.g && $bcffdc5a8182d43d$var$l.g.Ka && $bcffdc5a8182d43d$var$l.g.Ka() && $bcffdc5a8182d43d$var$l.g.Ka().ec);
    this.j = a ? this.l : 1;
    this.g = null;
    1 < this.j && (this.g = new Set);
    this.h = null;
    this.i = [];
}
var $bcffdc5a8182d43d$var$dd = 10;
function $bcffdc5a8182d43d$var$ed(a) {
    return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
}
function $bcffdc5a8182d43d$var$Bc(a) {
    return a.h ? 1 : a.g ? a.g.size : 0;
}
function $bcffdc5a8182d43d$var$xc(a, b) {
    return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
}
function $bcffdc5a8182d43d$var$Cc(a, b) {
    a.g ? a.g.add(b) : a.h = b;
}
function $bcffdc5a8182d43d$var$Ec(a, b) {
    a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
}
$bcffdc5a8182d43d$var$cd.prototype.cancel = function() {
    this.i = $bcffdc5a8182d43d$var$fd(this);
    if (this.h) this.h.cancel(), this.h = null;
    else if (this.g && 0 !== this.g.size) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.g.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var a = _step.value;
                a.cancel();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        this.g.clear();
    }
};
function $bcffdc5a8182d43d$var$fd(a) {
    if (null != a.h) return a.i.concat(a.h.F);
    if (null != a.g && 0 !== a.g.size) {
        var b = a.i;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = a.g.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                b = b.concat(c.F);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return b;
    }
    return $bcffdc5a8182d43d$var$ma(a.i);
}
var $bcffdc5a8182d43d$var$gd = /*#__PURE__*/ function() {
    "use strict";
    function gd() {
        (0, $978gY._)(this, gd);
    }
    (0, $kry2a._)(gd, [
        {
            key: "stringify",
            value: function stringify(a) {
                return $bcffdc5a8182d43d$var$l.JSON.stringify(a, void 0);
            }
        },
        {
            key: "parse",
            value: function parse(a) {
                return $bcffdc5a8182d43d$var$l.JSON.parse(a, void 0);
            }
        }
    ]);
    return gd;
}();
function $bcffdc5a8182d43d$var$hd() {
    this.g = new $bcffdc5a8182d43d$var$gd;
}
function $bcffdc5a8182d43d$var$id(a, b, c) {
    var d = c || "";
    try {
        $bcffdc5a8182d43d$var$Kc(a, function(e, f) {
            var h = e;
            $bcffdc5a8182d43d$var$p(e) && (h = $bcffdc5a8182d43d$var$jb(e));
            b.push(d + f + "=" + encodeURIComponent(h));
        });
    } catch (e) {
        throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
    }
}
function $bcffdc5a8182d43d$var$jd(a, b) {
    var c = new $bcffdc5a8182d43d$var$Gb;
    if ($bcffdc5a8182d43d$var$l.Image) {
        var d = new Image;
        d.onload = $bcffdc5a8182d43d$var$ha($bcffdc5a8182d43d$var$kd, c, d, "TestLoadImage: loaded", !0, b);
        d.onerror = $bcffdc5a8182d43d$var$ha($bcffdc5a8182d43d$var$kd, c, d, "TestLoadImage: error", !1, b);
        d.onabort = $bcffdc5a8182d43d$var$ha($bcffdc5a8182d43d$var$kd, c, d, "TestLoadImage: abort", !1, b);
        d.ontimeout = $bcffdc5a8182d43d$var$ha($bcffdc5a8182d43d$var$kd, c, d, "TestLoadImage: timeout", !1, b);
        $bcffdc5a8182d43d$var$l.setTimeout(function() {
            if (d.ontimeout) d.ontimeout();
        }, 1E4);
        d.src = a;
    } else b(!1);
}
function $bcffdc5a8182d43d$var$kd(a, b, c, d, e) {
    try {
        b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
    } catch (f) {}
}
function $bcffdc5a8182d43d$var$ld(a) {
    this.l = a.fc || null;
    this.j = a.ob || !1;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$ld, $bcffdc5a8182d43d$var$Ub);
$bcffdc5a8182d43d$var$ld.prototype.g = function() {
    return new $bcffdc5a8182d43d$var$md(this.l, this.j);
};
$bcffdc5a8182d43d$var$ld.prototype.i = function(a) {
    return function() {
        return a;
    };
}({});
function $bcffdc5a8182d43d$var$md(a, b) {
    $bcffdc5a8182d43d$var$B.call(this);
    this.F = a;
    this.u = b;
    this.m = void 0;
    this.readyState = $bcffdc5a8182d43d$var$nd;
    this.status = 0;
    this.responseType = this.responseText = this.response = this.statusText = "";
    this.onreadystatechange = null;
    this.v = new Headers;
    this.h = null;
    this.C = "GET";
    this.B = "";
    this.g = !1;
    this.A = this.j = this.l = null;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$md, $bcffdc5a8182d43d$var$B);
var $bcffdc5a8182d43d$var$nd = 0;
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$md.prototype;
$bcffdc5a8182d43d$var$k.open = function(a, b) {
    if (this.readyState != $bcffdc5a8182d43d$var$nd) throw this.abort(), Error("Error reopening a connection");
    this.C = a;
    this.B = b;
    this.readyState = 1;
    $bcffdc5a8182d43d$var$od(this);
};
$bcffdc5a8182d43d$var$k.send = function(a) {
    if (1 != this.readyState) throw this.abort(), Error("need to call open() first. ");
    this.g = !0;
    var b = {
        headers: this.v,
        method: this.C,
        credentials: this.m,
        cache: void 0
    };
    a && (b.body = a);
    (this.F || $bcffdc5a8182d43d$var$l).fetch(new Request(this.B, b)).then(this.$a.bind(this), this.ka.bind(this));
};
$bcffdc5a8182d43d$var$k.abort = function() {
    this.response = this.responseText = "";
    this.v = new Headers;
    this.status = 0;
    this.j && this.j.cancel("Request was aborted.").catch(function() {});
    1 <= this.readyState && this.g && 4 != this.readyState && (this.g = !1, $bcffdc5a8182d43d$var$pd(this));
    this.readyState = $bcffdc5a8182d43d$var$nd;
};
$bcffdc5a8182d43d$var$k.$a = function(a) {
    if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, $bcffdc5a8182d43d$var$od(this)), this.g && (this.readyState = 3, $bcffdc5a8182d43d$var$od(this), this.g))) {
        if ("arraybuffer" === this.responseType) a.arrayBuffer().then(this.Ya.bind(this), this.ka.bind(this));
        else if ("undefined" !== typeof $bcffdc5a8182d43d$var$l.ReadableStream && "body" in a) {
            this.j = a.body.getReader();
            if (this.u) {
                if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                this.response = [];
            } else this.response = this.responseText = "", this.A = new TextDecoder;
            $bcffdc5a8182d43d$var$qd(this);
        } else a.text().then(this.Za.bind(this), this.ka.bind(this));
    }
};
function $bcffdc5a8182d43d$var$qd(a) {
    a.j.read().then(a.Xa.bind(a)).catch(a.ka.bind(a));
}
$bcffdc5a8182d43d$var$k.Xa = function(a) {
    if (this.g) {
        if (this.u && a.value) this.response.push(a.value);
        else if (!this.u) {
            var b = a.value ? a.value : new Uint8Array(0);
            if (b = this.A.decode(b, {
                stream: !a.done
            })) this.response = this.responseText += b;
        }
        a.done ? $bcffdc5a8182d43d$var$pd(this) : $bcffdc5a8182d43d$var$od(this);
        3 == this.readyState && $bcffdc5a8182d43d$var$qd(this);
    }
};
$bcffdc5a8182d43d$var$k.Za = function(a) {
    this.g && (this.response = this.responseText = a, $bcffdc5a8182d43d$var$pd(this));
};
$bcffdc5a8182d43d$var$k.Ya = function(a) {
    this.g && (this.response = a, $bcffdc5a8182d43d$var$pd(this));
};
$bcffdc5a8182d43d$var$k.ka = function() {
    this.g && $bcffdc5a8182d43d$var$pd(this);
};
function $bcffdc5a8182d43d$var$pd(a) {
    a.readyState = 4;
    a.l = null;
    a.j = null;
    a.A = null;
    $bcffdc5a8182d43d$var$od(a);
}
$bcffdc5a8182d43d$var$k.setRequestHeader = function(a, b) {
    this.v.append(a, b);
};
$bcffdc5a8182d43d$var$k.getResponseHeader = function(a) {
    return this.h ? this.h.get(a.toLowerCase()) || "" : "";
};
$bcffdc5a8182d43d$var$k.getAllResponseHeaders = function() {
    if (!this.h) return "";
    var a = [], b = this.h.entries();
    for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
    return a.join("\r\n");
};
function $bcffdc5a8182d43d$var$od(a) {
    a.onreadystatechange && a.onreadystatechange.call(a);
}
Object.defineProperty($bcffdc5a8182d43d$var$md.prototype, "withCredentials", {
    get: function get() {
        return "include" === this.m;
    },
    set: function set(a) {
        this.m = a ? "include" : "same-origin";
    }
});
var $bcffdc5a8182d43d$var$rd = $bcffdc5a8182d43d$var$l.JSON.parse;
function $bcffdc5a8182d43d$var$P(a) {
    $bcffdc5a8182d43d$var$B.call(this);
    this.headers = new Map;
    this.u = a || null;
    this.h = !1;
    this.C = this.g = null;
    this.I = "";
    this.m = 0;
    this.j = "";
    this.l = this.G = this.v = this.F = !1;
    this.B = 0;
    this.A = null;
    this.K = $bcffdc5a8182d43d$var$sd;
    this.L = this.M = !1;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$P, $bcffdc5a8182d43d$var$B);
var $bcffdc5a8182d43d$var$sd = "", $bcffdc5a8182d43d$var$td = /^https?$/i, $bcffdc5a8182d43d$var$ud = [
    "POST",
    "PUT"
];
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$P.prototype;
$bcffdc5a8182d43d$var$k.Oa = function(a) {
    this.M = a;
};
$bcffdc5a8182d43d$var$k.ha = function(a, b, c, d) {
    if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.I + "; newUri=" + a);
    b = b ? b.toUpperCase() : "GET";
    this.I = a;
    this.j = "";
    this.m = 0;
    this.F = !1;
    this.h = !0;
    this.g = this.u ? this.u.g() : $bcffdc5a8182d43d$var$$b.g();
    this.C = this.u ? $bcffdc5a8182d43d$var$Vb(this.u) : $bcffdc5a8182d43d$var$Vb($bcffdc5a8182d43d$var$$b);
    this.g.onreadystatechange = $bcffdc5a8182d43d$var$q(this.La, this);
    try {
        this.G = !0, this.g.open(b, String(a), !0), this.G = !1;
    } catch (f) {
        $bcffdc5a8182d43d$var$vd(this, f);
        return;
    }
    a = c || "";
    c = new Map(this.headers);
    if (d) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
        else if ("function" === typeof d.keys && "function" === typeof d.get) try {
            for(var _iterator = d.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$f = _step.value;
                c.set(_$f, d.get(_$f));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else throw Error("Unknown input type for opt_headers: " + String(d));
    }
    d = Array.from(c.keys()).find(function(f) {
        return "content-type" == f.toLowerCase();
    });
    e = $bcffdc5a8182d43d$var$l.FormData && a instanceof $bcffdc5a8182d43d$var$l.FormData;
    !(0 <= $bcffdc5a8182d43d$var$ka($bcffdc5a8182d43d$var$ud, b)) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = c[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value = (0, $8GFUW._)(_step1.value, 2), _$f1 = _step_value[0], h = _step_value[1];
            this.g.setRequestHeader(_$f1, h);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    this.K && (this.g.responseType = this.K);
    "withCredentials" in this.g && this.g.withCredentials !== this.M && (this.g.withCredentials = this.M);
    try {
        $bcffdc5a8182d43d$var$wd(this), 0 < this.B && ((this.L = $bcffdc5a8182d43d$var$xd(this.g)) ? (this.g.timeout = this.B, this.g.ontimeout = $bcffdc5a8182d43d$var$q(this.ua, this)) : this.A = $bcffdc5a8182d43d$var$yb(this.ua, this.B, this)), this.v = !0, this.g.send(a), this.v = !1;
    } catch (f) {
        $bcffdc5a8182d43d$var$vd(this, f);
    }
};
function $bcffdc5a8182d43d$var$xd(a) {
    return $bcffdc5a8182d43d$var$z && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
$bcffdc5a8182d43d$var$k.ua = function() {
    "undefined" != typeof $bcffdc5a8182d43d$var$goog && this.g && (this.j = "Timed out after " + this.B + "ms, aborting", this.m = 8, $bcffdc5a8182d43d$var$C(this, "timeout"), this.abort(8));
};
function $bcffdc5a8182d43d$var$vd(a, b) {
    a.h = !1;
    a.g && (a.l = !0, a.g.abort(), a.l = !1);
    a.j = b;
    a.m = 5;
    $bcffdc5a8182d43d$var$yd(a);
    $bcffdc5a8182d43d$var$zd(a);
}
function $bcffdc5a8182d43d$var$yd(a) {
    a.F || (a.F = !0, $bcffdc5a8182d43d$var$C(a, "complete"), $bcffdc5a8182d43d$var$C(a, "error"));
}
$bcffdc5a8182d43d$var$k.abort = function(a) {
    this.g && this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1, this.m = a || 7, $bcffdc5a8182d43d$var$C(this, "complete"), $bcffdc5a8182d43d$var$C(this, "abort"), $bcffdc5a8182d43d$var$zd(this));
};
$bcffdc5a8182d43d$var$k.N = function() {
    this.g && (this.h && (this.h = !1, this.l = !0, this.g.abort(), this.l = !1), $bcffdc5a8182d43d$var$zd(this, !0));
    $bcffdc5a8182d43d$var$P.$.N.call(this);
};
$bcffdc5a8182d43d$var$k.La = function() {
    this.s || (this.G || this.v || this.l ? $bcffdc5a8182d43d$var$Ad(this) : this.kb());
};
$bcffdc5a8182d43d$var$k.kb = function() {
    $bcffdc5a8182d43d$var$Ad(this);
};
function $bcffdc5a8182d43d$var$Ad(a) {
    if (a.h && "undefined" != typeof $bcffdc5a8182d43d$var$goog && (!a.C[1] || 4 != $bcffdc5a8182d43d$var$H(a) || 2 != a.da())) {
        if (a.v && 4 == $bcffdc5a8182d43d$var$H(a)) $bcffdc5a8182d43d$var$yb(a.La, 0, a);
        else if ($bcffdc5a8182d43d$var$C(a, "readystatechange"), 4 == $bcffdc5a8182d43d$var$H(a)) {
            a.h = !1;
            try {
                var h = a.da();
                a: switch(h){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var b = !0;
                        break a;
                    default:
                        b = !1;
                }
                var c;
                if (!(c = b)) {
                    var d;
                    if (d = 0 === h) {
                        var e = String(a.I).match($bcffdc5a8182d43d$var$Lc)[1] || null;
                        !e && $bcffdc5a8182d43d$var$l.self && $bcffdc5a8182d43d$var$l.self.location && (e = $bcffdc5a8182d43d$var$l.self.location.protocol.slice(0, -1));
                        d = !$bcffdc5a8182d43d$var$td.test(e ? e.toLowerCase() : "");
                    }
                    c = d;
                }
                if (c) $bcffdc5a8182d43d$var$C(a, "complete"), $bcffdc5a8182d43d$var$C(a, "success");
                else {
                    a.m = 6;
                    try {
                        var f = 2 < $bcffdc5a8182d43d$var$H(a) ? a.g.statusText : "";
                    } catch (n) {
                        f = "";
                    }
                    a.j = f + " [" + a.da() + "]";
                    $bcffdc5a8182d43d$var$yd(a);
                }
            } finally{
                $bcffdc5a8182d43d$var$zd(a);
            }
        }
    }
}
function $bcffdc5a8182d43d$var$zd(a, b) {
    if (a.g) {
        $bcffdc5a8182d43d$var$wd(a);
        var c = a.g, d = a.C[0] ? function() {} : null;
        a.g = null;
        a.C = null;
        b || $bcffdc5a8182d43d$var$C(a, "ready");
        try {
            c.onreadystatechange = d;
        } catch (e) {}
    }
}
function $bcffdc5a8182d43d$var$wd(a) {
    a.g && a.L && (a.g.ontimeout = null);
    a.A && ($bcffdc5a8182d43d$var$l.clearTimeout(a.A), a.A = null);
}
$bcffdc5a8182d43d$var$k.isActive = function() {
    return !!this.g;
};
function $bcffdc5a8182d43d$var$H(a) {
    return a.g ? a.g.readyState : 0;
}
$bcffdc5a8182d43d$var$k.da = function() {
    try {
        return 2 < $bcffdc5a8182d43d$var$H(this) ? this.g.status : -1;
    } catch (a) {
        return -1;
    }
};
$bcffdc5a8182d43d$var$k.ja = function() {
    try {
        return this.g ? this.g.responseText : "";
    } catch (a) {
        return "";
    }
};
$bcffdc5a8182d43d$var$k.Wa = function(a) {
    if (this.g) {
        var b = this.g.responseText;
        a && 0 == b.indexOf(a) && (b = b.substring(a.length));
        return $bcffdc5a8182d43d$var$rd(b);
    }
};
function $bcffdc5a8182d43d$var$mc(a) {
    try {
        if (!a.g) return null;
        if ("response" in a.g) return a.g.response;
        switch(a.K){
            case $bcffdc5a8182d43d$var$sd:
            case "text":
                return a.g.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
        }
        return null;
    } catch (b) {
        return null;
    }
}
function $bcffdc5a8182d43d$var$tc(a) {
    var b = {};
    a = (a.g && 2 <= $bcffdc5a8182d43d$var$H(a) ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
    for(var d = 0; d < a.length; d++){
        if ($bcffdc5a8182d43d$var$x(a[d])) continue;
        var c = $bcffdc5a8182d43d$var$qb(a[d]);
        var e = c[0];
        c = c[1];
        if ("string" !== typeof c) continue;
        c = c.trim();
        var f = b[e] || [];
        b[e] = f;
        f.push(c);
    }
    $bcffdc5a8182d43d$var$Oa(b, function(d) {
        return d.join(", ");
    });
}
$bcffdc5a8182d43d$var$k.Ia = function() {
    return this.m;
};
$bcffdc5a8182d43d$var$k.Sa = function() {
    return "string" === typeof this.j ? this.j : String(this.j);
};
function $bcffdc5a8182d43d$var$Bd(a) {
    var b = "";
    $bcffdc5a8182d43d$var$Na(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $bcffdc5a8182d43d$var$Cd(a, b, c) {
    a: {
        for(d in c){
            var d = !1;
            break a;
        }
        d = !0;
    }
    d || (c = $bcffdc5a8182d43d$var$Bd(c), "string" === typeof a ? null != c && encodeURIComponent(String(c)) : $bcffdc5a8182d43d$var$K(a, b, c));
}
function $bcffdc5a8182d43d$var$Dd(a, b, c) {
    return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
}
function $bcffdc5a8182d43d$var$Ed(a) {
    this.Ga = 0;
    this.j = [];
    this.l = new $bcffdc5a8182d43d$var$Gb;
    this.pa = this.wa = this.I = this.Y = this.g = this.Da = this.F = this.na = this.o = this.U = this.s = null;
    this.fb = this.W = 0;
    this.cb = $bcffdc5a8182d43d$var$Dd("failFast", !1, a);
    this.G = this.v = this.u = this.m = this.h = null;
    this.aa = !0;
    this.Fa = this.V = -1;
    this.ba = this.A = this.C = 0;
    this.ab = $bcffdc5a8182d43d$var$Dd("baseRetryDelayMs", 5E3, a);
    this.hb = $bcffdc5a8182d43d$var$Dd("retryDelaySeedMs", 1E4, a);
    this.eb = $bcffdc5a8182d43d$var$Dd("forwardChannelMaxRetries", 2, a);
    this.xa = $bcffdc5a8182d43d$var$Dd("forwardChannelRequestTimeoutMs", 2E4, a);
    this.va = a && a.xmlHttpFactory || void 0;
    this.Ha = a && a.dc || !1;
    this.L = void 0;
    this.J = a && a.supportsCrossDomainXhr || !1;
    this.K = "";
    this.i = new $bcffdc5a8182d43d$var$cd(a && a.concurrentRequestLimit);
    this.Ja = new $bcffdc5a8182d43d$var$hd;
    this.P = a && a.fastHandshake || !1;
    this.O = a && a.encodeInitMessageHeaders || !1;
    this.P && this.O && (this.O = !1);
    this.bb = a && a.bc || !1;
    a && a.Ea && this.l.Ea();
    a && a.forceLongPolling && (this.aa = !1);
    this.ca = !this.P && this.aa && a && a.detectBufferingProxy || !1;
    this.qa = void 0;
    a && a.longPollingTimeout && 0 < a.longPollingTimeout && (this.qa = a.longPollingTimeout);
    this.oa = void 0;
    this.S = 0;
    this.M = !1;
    this.ma = this.B = null;
}
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$Ed.prototype;
$bcffdc5a8182d43d$var$k.ra = 8;
$bcffdc5a8182d43d$var$k.H = 1;
function $bcffdc5a8182d43d$var$Hc(a) {
    $bcffdc5a8182d43d$var$Fd(a);
    if (3 == a.H) {
        var b = a.W++, c = $bcffdc5a8182d43d$var$G(a.I);
        $bcffdc5a8182d43d$var$K(c, "SID", a.K);
        $bcffdc5a8182d43d$var$K(c, "RID", b);
        $bcffdc5a8182d43d$var$K(c, "TYPE", "terminate");
        $bcffdc5a8182d43d$var$Gd(a, c);
        b = new $bcffdc5a8182d43d$var$bc(a, a.l, b);
        b.L = 2;
        b.v = $bcffdc5a8182d43d$var$hc($bcffdc5a8182d43d$var$G(c));
        c = !1;
        if ($bcffdc5a8182d43d$var$l.navigator && $bcffdc5a8182d43d$var$l.navigator.sendBeacon) try {
            c = $bcffdc5a8182d43d$var$l.navigator.sendBeacon(b.v.toString(), "");
        } catch (d) {}
        !c && $bcffdc5a8182d43d$var$l.Image && ((new Image).src = b.v, c = !0);
        c || (b.g = $bcffdc5a8182d43d$var$lc(b.l, null), b.g.ha(b.v));
        b.G = Date.now();
        $bcffdc5a8182d43d$var$jc(b);
    }
    $bcffdc5a8182d43d$var$Hd(a);
}
function $bcffdc5a8182d43d$var$zc(a) {
    a.g && ($bcffdc5a8182d43d$var$vc(a), a.g.cancel(), a.g = null);
}
function $bcffdc5a8182d43d$var$Fd(a) {
    $bcffdc5a8182d43d$var$zc(a);
    a.u && ($bcffdc5a8182d43d$var$l.clearTimeout(a.u), a.u = null);
    $bcffdc5a8182d43d$var$yc(a);
    a.i.cancel();
    a.m && ("number" === typeof a.m && $bcffdc5a8182d43d$var$l.clearTimeout(a.m), a.m = null);
}
function $bcffdc5a8182d43d$var$Gc(a) {
    if (!$bcffdc5a8182d43d$var$ed(a.i) && !a.m) {
        a.m = !0;
        var b = a.Na;
        $bcffdc5a8182d43d$var$sb || $bcffdc5a8182d43d$var$vb();
        $bcffdc5a8182d43d$var$tb || ($bcffdc5a8182d43d$var$sb(), $bcffdc5a8182d43d$var$tb = !0);
        $bcffdc5a8182d43d$var$mb.add(b, a);
        a.C = 0;
    }
}
function $bcffdc5a8182d43d$var$Id(a, b) {
    if ($bcffdc5a8182d43d$var$Bc(a.i) >= a.i.j - (a.m ? 1 : 0)) return !1;
    if (a.m) return a.j = b.F.concat(a.j), !0;
    if (1 == a.H || 2 == a.H || a.C >= (a.cb ? 0 : a.eb)) return !1;
    a.m = $bcffdc5a8182d43d$var$Rb($bcffdc5a8182d43d$var$q(a.Na, a, b), $bcffdc5a8182d43d$var$Jd(a, a.C));
    a.C++;
    return !0;
}
$bcffdc5a8182d43d$var$k.Na = function(a) {
    if (this.m) {
        if (this.m = null, 1 == this.H) {
            if (!a) {
                this.W = Math.floor(1E5 * Math.random());
                a = this.W++;
                var e = new $bcffdc5a8182d43d$var$bc(this, this.l, a);
                var f = this.s;
                this.U && (f ? (f = $bcffdc5a8182d43d$var$Pa(f), $bcffdc5a8182d43d$var$Ra(f, this.U)) : f = this.U);
                null !== this.o || this.O || (e.I = f, f = null);
                if (this.P) a: {
                    var b = 0;
                    for(var c = 0; c < this.j.length; c++){
                        b: {
                            var d = this.j[c];
                            if ("__data__" in d.map && (d = d.map.__data__, "string" === typeof d)) {
                                d = d.length;
                                break b;
                            }
                            d = void 0;
                        }
                        if (void 0 === d) break;
                        b += d;
                        if (4096 < b) {
                            b = c;
                            break a;
                        }
                        if (4096 === b || c === this.j.length - 1) {
                            b = c + 1;
                            break a;
                        }
                    }
                    b = 1E3;
                }
                else b = 1E3;
                b = $bcffdc5a8182d43d$var$Kd(this, e, b);
                c = $bcffdc5a8182d43d$var$G(this.I);
                $bcffdc5a8182d43d$var$K(c, "RID", a);
                $bcffdc5a8182d43d$var$K(c, "CVER", 22);
                this.F && $bcffdc5a8182d43d$var$K(c, "X-HTTP-Session-Id", this.F);
                $bcffdc5a8182d43d$var$Gd(this, c);
                f && (this.O ? b = "headers=" + encodeURIComponent(String($bcffdc5a8182d43d$var$Bd(f))) + "&" + b : this.o && $bcffdc5a8182d43d$var$Cd(c, this.o, f));
                $bcffdc5a8182d43d$var$Cc(this.i, e);
                this.bb && $bcffdc5a8182d43d$var$K(c, "TYPE", "init");
                this.P ? ($bcffdc5a8182d43d$var$K(c, "$req", b), $bcffdc5a8182d43d$var$K(c, "SID", "null"), e.aa = !0, $bcffdc5a8182d43d$var$gc(e, c, null)) : $bcffdc5a8182d43d$var$gc(e, c, b);
                this.H = 2;
            }
        } else 3 == this.H && (a ? $bcffdc5a8182d43d$var$Ld(this, a) : 0 == this.j.length || $bcffdc5a8182d43d$var$ed(this.i) || $bcffdc5a8182d43d$var$Ld(this));
    }
};
function $bcffdc5a8182d43d$var$Ld(a, b) {
    var c;
    b ? c = b.m : c = a.W++;
    var d = $bcffdc5a8182d43d$var$G(a.I);
    $bcffdc5a8182d43d$var$K(d, "SID", a.K);
    $bcffdc5a8182d43d$var$K(d, "RID", c);
    $bcffdc5a8182d43d$var$K(d, "AID", a.V);
    $bcffdc5a8182d43d$var$Gd(a, d);
    a.o && a.s && $bcffdc5a8182d43d$var$Cd(d, a.o, a.s);
    c = new $bcffdc5a8182d43d$var$bc(a, a.l, c, a.C + 1);
    null === a.o && (c.I = a.s);
    b && (a.j = b.F.concat(a.j));
    b = $bcffdc5a8182d43d$var$Kd(a, c, 1E3);
    c.setTimeout(Math.round(.5 * a.xa) + Math.round(.5 * a.xa * Math.random()));
    $bcffdc5a8182d43d$var$Cc(a.i, c);
    $bcffdc5a8182d43d$var$gc(c, d, b);
}
function $bcffdc5a8182d43d$var$Gd(a, b) {
    a.na && $bcffdc5a8182d43d$var$Na(a.na, function(c, d) {
        $bcffdc5a8182d43d$var$K(b, d, c);
    });
    a.h && $bcffdc5a8182d43d$var$Kc({}, function(c, d) {
        $bcffdc5a8182d43d$var$K(b, d, c);
    });
}
function $bcffdc5a8182d43d$var$Kd(a, b, c) {
    c = Math.min(a.j.length, c);
    var d = a.h ? $bcffdc5a8182d43d$var$q(a.h.Va, a.h, a) : null;
    a: {
        var e = a.j;
        var f = -1;
        for(;;){
            var h = [
                "count=" + c
            ];
            -1 == f ? 0 < c ? (f = e[0].g, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
            var n = !0;
            for(var t = 0; t < c; t++){
                var m = e[t].g;
                var u = e[t].map;
                m -= f;
                if (0 > m) f = Math.max(0, e[t].g - 100), n = !1;
                else try {
                    $bcffdc5a8182d43d$var$id(u, h, "req" + m + "_");
                } catch (L) {
                    d && d(u);
                }
            }
            if (n) {
                d = h.join("&");
                break a;
            }
        }
    }
    a = a.j.splice(0, c);
    b.F = a;
    return d;
}
function $bcffdc5a8182d43d$var$Fc(a) {
    if (!a.g && !a.u) {
        a.ba = 1;
        var b = a.Ma;
        $bcffdc5a8182d43d$var$sb || $bcffdc5a8182d43d$var$vb();
        $bcffdc5a8182d43d$var$tb || ($bcffdc5a8182d43d$var$sb(), $bcffdc5a8182d43d$var$tb = !0);
        $bcffdc5a8182d43d$var$mb.add(b, a);
        a.A = 0;
    }
}
function $bcffdc5a8182d43d$var$Ac(a) {
    if (a.g || a.u || 3 <= a.A) return !1;
    a.ba++;
    a.u = $bcffdc5a8182d43d$var$Rb($bcffdc5a8182d43d$var$q(a.Ma, a), $bcffdc5a8182d43d$var$Jd(a, a.A));
    a.A++;
    return !0;
}
$bcffdc5a8182d43d$var$k.Ma = function() {
    this.u = null;
    $bcffdc5a8182d43d$var$Md(this);
    if (this.ca && !(this.M || null == this.g || 0 >= this.S)) {
        var a = 2 * this.S;
        this.l.info("BP detection timer enabled: " + a);
        this.B = $bcffdc5a8182d43d$var$Rb($bcffdc5a8182d43d$var$q(this.jb, this), a);
    }
};
$bcffdc5a8182d43d$var$k.jb = function() {
    this.B && (this.B = null, this.l.info("BP detection timeout reached."), this.l.info("Buffering proxy detected and switch to long-polling!"), this.G = !1, this.M = !0, $bcffdc5a8182d43d$var$F(10), $bcffdc5a8182d43d$var$zc(this), $bcffdc5a8182d43d$var$Md(this));
};
function $bcffdc5a8182d43d$var$vc(a) {
    null != a.B && ($bcffdc5a8182d43d$var$l.clearTimeout(a.B), a.B = null);
}
function $bcffdc5a8182d43d$var$Md(a) {
    a.g = new $bcffdc5a8182d43d$var$bc(a, a.l, "rpc", a.ba);
    null === a.o && (a.g.I = a.s);
    a.g.O = 0;
    var b = $bcffdc5a8182d43d$var$G(a.wa);
    $bcffdc5a8182d43d$var$K(b, "RID", "rpc");
    $bcffdc5a8182d43d$var$K(b, "SID", a.K);
    $bcffdc5a8182d43d$var$K(b, "AID", a.V);
    $bcffdc5a8182d43d$var$K(b, "CI", a.G ? "0" : "1");
    !a.G && a.qa && $bcffdc5a8182d43d$var$K(b, "TO", a.qa);
    $bcffdc5a8182d43d$var$K(b, "TYPE", "xmlhttp");
    $bcffdc5a8182d43d$var$Gd(a, b);
    a.o && a.s && $bcffdc5a8182d43d$var$Cd(b, a.o, a.s);
    a.L && a.g.setTimeout(a.L);
    var c = a.g;
    a = a.pa;
    c.L = 1;
    c.v = $bcffdc5a8182d43d$var$hc($bcffdc5a8182d43d$var$G(b));
    c.s = null;
    c.S = !0;
    $bcffdc5a8182d43d$var$ic(c, a);
}
$bcffdc5a8182d43d$var$k.ib = function() {
    null != this.v && (this.v = null, $bcffdc5a8182d43d$var$zc(this), $bcffdc5a8182d43d$var$Ac(this), $bcffdc5a8182d43d$var$F(19));
};
function $bcffdc5a8182d43d$var$yc(a) {
    null != a.v && ($bcffdc5a8182d43d$var$l.clearTimeout(a.v), a.v = null);
}
function $bcffdc5a8182d43d$var$sc(a, b) {
    var c = null;
    if (a.g == b) {
        $bcffdc5a8182d43d$var$yc(a);
        $bcffdc5a8182d43d$var$vc(a);
        a.g = null;
        var d = 2;
    } else if ($bcffdc5a8182d43d$var$xc(a.i, b)) c = b.F, $bcffdc5a8182d43d$var$Ec(a.i, b), d = 1;
    else return;
    if (0 != a.H) {
        if (b.i) {
            if (1 == d) {
                c = b.s ? b.s.length : 0;
                b = Date.now() - b.G;
                var e = a.C;
                d = $bcffdc5a8182d43d$var$Mb();
                $bcffdc5a8182d43d$var$C(d, new $bcffdc5a8182d43d$var$Qb(d, c));
                $bcffdc5a8182d43d$var$Gc(a);
            } else $bcffdc5a8182d43d$var$Fc(a);
        } else if (e = b.o, 3 == e || 0 == e && 0 < b.ca || !(1 == d && $bcffdc5a8182d43d$var$Id(a, b) || 2 == d && $bcffdc5a8182d43d$var$Ac(a))) switch(c && 0 < c.length && (b = a.i, b.i = b.i.concat(c)), e){
            case 1:
                $bcffdc5a8182d43d$var$J(a, 5);
                break;
            case 4:
                $bcffdc5a8182d43d$var$J(a, 10);
                break;
            case 3:
                $bcffdc5a8182d43d$var$J(a, 6);
                break;
            default:
                $bcffdc5a8182d43d$var$J(a, 2);
        }
    }
}
function $bcffdc5a8182d43d$var$Jd(a, b) {
    var c = a.ab + Math.floor(Math.random() * a.hb);
    a.isActive() || (c *= 2);
    return c * b;
}
function $bcffdc5a8182d43d$var$J(a, b) {
    a.l.info("Error code " + b);
    if (2 == b) {
        var c = null;
        a.h && (c = null);
        var d = $bcffdc5a8182d43d$var$q(a.pb, a);
        c || (c = new $bcffdc5a8182d43d$var$M("//www.google.com/images/cleardot.gif"), $bcffdc5a8182d43d$var$l.location && "http" == $bcffdc5a8182d43d$var$l.location.protocol || $bcffdc5a8182d43d$var$Nc(c, "https"), $bcffdc5a8182d43d$var$hc(c));
        $bcffdc5a8182d43d$var$jd(c.toString(), d);
    } else $bcffdc5a8182d43d$var$F(2);
    a.H = 0;
    a.h && a.h.za(b);
    $bcffdc5a8182d43d$var$Hd(a);
    $bcffdc5a8182d43d$var$Fd(a);
}
$bcffdc5a8182d43d$var$k.pb = function(a) {
    a ? (this.l.info("Successfully pinged google.com"), $bcffdc5a8182d43d$var$F(2)) : (this.l.info("Failed to ping google.com"), $bcffdc5a8182d43d$var$F(1));
};
function $bcffdc5a8182d43d$var$Hd(a) {
    a.H = 0;
    a.ma = [];
    if (a.h) {
        var b = $bcffdc5a8182d43d$var$fd(a.i);
        if (0 != b.length || 0 != a.j.length) $bcffdc5a8182d43d$var$na(a.ma, b), $bcffdc5a8182d43d$var$na(a.ma, a.j), a.i.i.length = 0, $bcffdc5a8182d43d$var$ma(a.j), a.j.length = 0;
        a.h.ya();
    }
}
function $bcffdc5a8182d43d$var$Dc(a, b, c) {
    var d = c instanceof $bcffdc5a8182d43d$var$M ? $bcffdc5a8182d43d$var$G(c) : new $bcffdc5a8182d43d$var$M(c);
    if ("" != d.g) b && (d.g = b + "." + d.g), $bcffdc5a8182d43d$var$Oc(d, d.m);
    else {
        var e = $bcffdc5a8182d43d$var$l.location;
        d = e.protocol;
        b = b ? b + "." + e.hostname : e.hostname;
        e = +e.port;
        var f = new $bcffdc5a8182d43d$var$M(null);
        d && $bcffdc5a8182d43d$var$Nc(f, d);
        b && (f.g = b);
        e && $bcffdc5a8182d43d$var$Oc(f, e);
        c && (f.l = c);
        d = f;
    }
    c = a.F;
    b = a.Da;
    c && b && $bcffdc5a8182d43d$var$K(d, c, b);
    $bcffdc5a8182d43d$var$K(d, "VER", a.ra);
    $bcffdc5a8182d43d$var$Gd(a, d);
    return d;
}
function $bcffdc5a8182d43d$var$lc(a, b, c) {
    if (b && !a.J) throw Error("Can't create secondary domain capable XhrIo object.");
    b = c && a.Ha && !a.va ? new $bcffdc5a8182d43d$var$P(new $bcffdc5a8182d43d$var$ld({
        ob: !0
    })) : new $bcffdc5a8182d43d$var$P(a.va);
    b.Oa(a.J);
    return b;
}
$bcffdc5a8182d43d$var$k.isActive = function() {
    return !!this.h && this.h.isActive(this);
};
function $bcffdc5a8182d43d$var$Nd() {}
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$Nd.prototype;
$bcffdc5a8182d43d$var$k.Ba = function() {};
$bcffdc5a8182d43d$var$k.Aa = function() {};
$bcffdc5a8182d43d$var$k.za = function() {};
$bcffdc5a8182d43d$var$k.ya = function() {};
$bcffdc5a8182d43d$var$k.isActive = function() {
    return !0;
};
$bcffdc5a8182d43d$var$k.Va = function() {};
function $bcffdc5a8182d43d$var$Od() {
    if ($bcffdc5a8182d43d$var$z && !(10 <= Number($bcffdc5a8182d43d$var$Fa))) throw Error("Environmental error: no available transport.");
}
$bcffdc5a8182d43d$var$Od.prototype.g = function(a, b) {
    return new $bcffdc5a8182d43d$var$Q(a, b);
};
function $bcffdc5a8182d43d$var$Q(a, b) {
    $bcffdc5a8182d43d$var$B.call(this);
    this.g = new $bcffdc5a8182d43d$var$Ed(b);
    this.l = a;
    this.h = b && b.messageUrlParams || null;
    a = b && b.messageHeaders || null;
    b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
        "X-Client-Protocol": "webchannel"
    });
    this.g.s = a;
    a = b && b.initMessageHeaders || null;
    b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
        "X-WebChannel-Content-Type": b.messageContentType
    });
    b && b.Ca && (a ? a["X-WebChannel-Client-Profile"] = b.Ca : a = {
        "X-WebChannel-Client-Profile": b.Ca
    });
    this.g.U = a;
    (a = b && b.cc) && !$bcffdc5a8182d43d$var$x(a) && (this.g.o = a);
    this.A = b && b.supportsCrossDomainXhr || !1;
    this.v = b && b.sendRawJson || !1;
    (b = b && b.httpSessionIdParam) && !$bcffdc5a8182d43d$var$x(b) && (this.g.F = b, a = this.h, null !== a && b in a && (a = this.h, b in a && delete a[b]));
    this.j = new $bcffdc5a8182d43d$var$R(this);
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Q, $bcffdc5a8182d43d$var$B);
$bcffdc5a8182d43d$var$Q.prototype.m = function() {
    this.g.h = this.j;
    this.A && (this.g.J = !0);
    var a = this.g, b = this.l, c = this.h || void 0;
    $bcffdc5a8182d43d$var$F(0);
    a.Y = b;
    a.na = c || {};
    a.G = a.aa;
    a.I = $bcffdc5a8182d43d$var$Dc(a, null, a.Y);
    $bcffdc5a8182d43d$var$Gc(a);
};
$bcffdc5a8182d43d$var$Q.prototype.close = function() {
    $bcffdc5a8182d43d$var$Hc(this.g);
};
$bcffdc5a8182d43d$var$Q.prototype.u = function(a) {
    var b = this.g;
    if ("string" === typeof a) {
        var c = {};
        c.__data__ = a;
        a = c;
    } else this.v && (c = {}, c.__data__ = $bcffdc5a8182d43d$var$jb(a), a = c);
    b.j.push(new $bcffdc5a8182d43d$var$bd(b.fb++, a));
    3 == b.H && $bcffdc5a8182d43d$var$Gc(b);
};
$bcffdc5a8182d43d$var$Q.prototype.N = function() {
    this.g.h = null;
    delete this.j;
    $bcffdc5a8182d43d$var$Hc(this.g);
    delete this.g;
    $bcffdc5a8182d43d$var$Q.$.N.call(this);
};
function $bcffdc5a8182d43d$var$Pd(a) {
    $bcffdc5a8182d43d$var$Yb.call(this);
    a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
    var b = a.__sm__;
    if (b) {
        a: {
            for(var c in b){
                a = c;
                break a;
            }
            a = void 0;
        }
        if (this.i = a) a = this.i, b = null !== b && a in b ? b[a] : void 0;
        this.data = b;
    } else this.data = a;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Pd, $bcffdc5a8182d43d$var$Yb);
function $bcffdc5a8182d43d$var$Qd() {
    $bcffdc5a8182d43d$var$Zb.call(this);
    this.status = 1;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$Qd, $bcffdc5a8182d43d$var$Zb);
function $bcffdc5a8182d43d$var$R(a) {
    this.g = a;
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$R, $bcffdc5a8182d43d$var$Nd);
$bcffdc5a8182d43d$var$R.prototype.Ba = function() {
    $bcffdc5a8182d43d$var$C(this.g, "a");
};
$bcffdc5a8182d43d$var$R.prototype.Aa = function(a) {
    $bcffdc5a8182d43d$var$C(this.g, new $bcffdc5a8182d43d$var$Pd(a));
};
$bcffdc5a8182d43d$var$R.prototype.za = function(a) {
    $bcffdc5a8182d43d$var$C(this.g, new $bcffdc5a8182d43d$var$Qd());
};
$bcffdc5a8182d43d$var$R.prototype.ya = function() {
    $bcffdc5a8182d43d$var$C(this.g, "b");
};
function $bcffdc5a8182d43d$var$Rd() {
    this.blockSize = -1;
}
function $bcffdc5a8182d43d$var$S() {
    this.blockSize = -1;
    this.blockSize = 64;
    this.g = Array(4);
    this.m = Array(this.blockSize);
    this.i = this.h = 0;
    this.reset();
}
$bcffdc5a8182d43d$var$r($bcffdc5a8182d43d$var$S, $bcffdc5a8182d43d$var$Rd);
$bcffdc5a8182d43d$var$S.prototype.reset = function() {
    this.g[0] = 1732584193;
    this.g[1] = 4023233417;
    this.g[2] = 2562383102;
    this.g[3] = 271733878;
    this.i = this.h = 0;
};
function $bcffdc5a8182d43d$var$Sd(a, b, c) {
    c || (c = 0);
    var d = Array(16);
    if ("string" === typeof b) for(var e = 0; 16 > e; ++e)d[e] = b.charCodeAt(c++) | b.charCodeAt(c++) << 8 | b.charCodeAt(c++) << 16 | b.charCodeAt(c++) << 24;
    else for(e = 0; 16 > e; ++e)d[e] = b[c++] | b[c++] << 8 | b[c++] << 16 | b[c++] << 24;
    b = a.g[0];
    c = a.g[1];
    e = a.g[2];
    var f = a.g[3];
    var h = b + (f ^ c & (e ^ f)) + d[0] + 3614090360 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[1] + 3905402710 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[2] + 606105819 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[3] + 3250441966 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[4] + 4118548399 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[5] + 1200080426 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[6] + 2821735955 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[7] + 4249261313 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[8] + 1770035416 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[9] + 2336552879 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[10] + 4294925233 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[11] + 2304563134 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (f ^ c & (e ^ f)) + d[12] + 1804603682 & 4294967295;
    b = c + (h << 7 & 4294967295 | h >>> 25);
    h = f + (e ^ b & (c ^ e)) + d[13] + 4254626195 & 4294967295;
    f = b + (h << 12 & 4294967295 | h >>> 20);
    h = e + (c ^ f & (b ^ c)) + d[14] + 2792965006 & 4294967295;
    e = f + (h << 17 & 4294967295 | h >>> 15);
    h = c + (b ^ e & (f ^ b)) + d[15] + 1236535329 & 4294967295;
    c = e + (h << 22 & 4294967295 | h >>> 10);
    h = b + (e ^ f & (c ^ e)) + d[1] + 4129170786 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[6] + 3225465664 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[11] + 643717713 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[0] + 3921069994 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[5] + 3593408605 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[10] + 38016083 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[15] + 3634488961 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[4] + 3889429448 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[9] + 568446438 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[14] + 3275163606 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[3] + 4107603335 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[8] + 1163531501 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (e ^ f & (c ^ e)) + d[13] + 2850285829 & 4294967295;
    b = c + (h << 5 & 4294967295 | h >>> 27);
    h = f + (c ^ e & (b ^ c)) + d[2] + 4243563512 & 4294967295;
    f = b + (h << 9 & 4294967295 | h >>> 23);
    h = e + (b ^ c & (f ^ b)) + d[7] + 1735328473 & 4294967295;
    e = f + (h << 14 & 4294967295 | h >>> 18);
    h = c + (f ^ b & (e ^ f)) + d[12] + 2368359562 & 4294967295;
    c = e + (h << 20 & 4294967295 | h >>> 12);
    h = b + (c ^ e ^ f) + d[5] + 4294588738 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[8] + 2272392833 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[11] + 1839030562 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[14] + 4259657740 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[1] + 2763975236 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[4] + 1272893353 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[7] + 4139469664 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[10] + 3200236656 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[13] + 681279174 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[0] + 3936430074 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[3] + 3572445317 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[6] + 76029189 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (c ^ e ^ f) + d[9] + 3654602809 & 4294967295;
    b = c + (h << 4 & 4294967295 | h >>> 28);
    h = f + (b ^ c ^ e) + d[12] + 3873151461 & 4294967295;
    f = b + (h << 11 & 4294967295 | h >>> 21);
    h = e + (f ^ b ^ c) + d[15] + 530742520 & 4294967295;
    e = f + (h << 16 & 4294967295 | h >>> 16);
    h = c + (e ^ f ^ b) + d[2] + 3299628645 & 4294967295;
    c = e + (h << 23 & 4294967295 | h >>> 9);
    h = b + (e ^ (c | ~f)) + d[0] + 4096336452 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[7] + 1126891415 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[14] + 2878612391 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[5] + 4237533241 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[12] + 1700485571 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[3] + 2399980690 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[10] + 4293915773 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[1] + 2240044497 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[8] + 1873313359 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[15] + 4264355552 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[6] + 2734768916 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[13] + 1309151649 & 4294967295;
    c = e + (h << 21 & 4294967295 | h >>> 11);
    h = b + (e ^ (c | ~f)) + d[4] + 4149444226 & 4294967295;
    b = c + (h << 6 & 4294967295 | h >>> 26);
    h = f + (c ^ (b | ~e)) + d[11] + 3174756917 & 4294967295;
    f = b + (h << 10 & 4294967295 | h >>> 22);
    h = e + (b ^ (f | ~c)) + d[2] + 718787259 & 4294967295;
    e = f + (h << 15 & 4294967295 | h >>> 17);
    h = c + (f ^ (e | ~b)) + d[9] + 3951481745 & 4294967295;
    a.g[0] = a.g[0] + b & 4294967295;
    a.g[1] = a.g[1] + (e + (h << 21 & 4294967295 | h >>> 11)) & 4294967295;
    a.g[2] = a.g[2] + e & 4294967295;
    a.g[3] = a.g[3] + f & 4294967295;
}
$bcffdc5a8182d43d$var$S.prototype.j = function(a, b) {
    void 0 === b && (b = a.length);
    for(var c = b - this.blockSize, d = this.m, e = this.h, f = 0; f < b;){
        if (0 == e) for(; f <= c;)$bcffdc5a8182d43d$var$Sd(this, a, f), f += this.blockSize;
        if ("string" === typeof a) {
            for(; f < b;)if (d[e++] = a.charCodeAt(f++), e == this.blockSize) {
                $bcffdc5a8182d43d$var$Sd(this, d);
                e = 0;
                break;
            }
        } else for(; f < b;)if (d[e++] = a[f++], e == this.blockSize) {
            $bcffdc5a8182d43d$var$Sd(this, d);
            e = 0;
            break;
        }
    }
    this.h = e;
    this.i += b;
};
$bcffdc5a8182d43d$var$S.prototype.l = function() {
    var a = Array((56 > this.h ? this.blockSize : 2 * this.blockSize) - this.h);
    a[0] = 128;
    for(var b = 1; b < a.length - 8; ++b)a[b] = 0;
    var c = 8 * this.i;
    for(b = a.length - 8; b < a.length; ++b)a[b] = c & 255, c /= 256;
    this.j(a);
    a = Array(16);
    for(b = c = 0; 4 > b; ++b)for(var d = 0; 32 > d; d += 8)a[c++] = this.g[b] >>> d & 255;
    return a;
};
function $bcffdc5a8182d43d$var$T(a, b) {
    this.h = b;
    for(var c = [], d = !0, e = a.length - 1; 0 <= e; e--){
        var f = a[e] | 0;
        d && f == b || (c[e] = f, d = !1);
    }
    this.g = c;
}
var $bcffdc5a8182d43d$var$sa = {};
function $bcffdc5a8182d43d$var$Td(a) {
    return -128 <= a && 128 > a ? $bcffdc5a8182d43d$var$ra(a, function(b) {
        return new $bcffdc5a8182d43d$var$T([
            b | 0
        ], 0 > b ? -1 : 0);
    }) : new $bcffdc5a8182d43d$var$T([
        a | 0
    ], 0 > a ? -1 : 0);
}
function $bcffdc5a8182d43d$var$U(a) {
    if (isNaN(a) || !isFinite(a)) return $bcffdc5a8182d43d$var$V;
    if (0 > a) return $bcffdc5a8182d43d$var$W($bcffdc5a8182d43d$var$U(-a));
    for(var b = [], c = 1, d = 0; a >= c; d++)b[d] = a / c | 0, c *= $bcffdc5a8182d43d$var$Ud;
    return new $bcffdc5a8182d43d$var$T(b, 0);
}
function $bcffdc5a8182d43d$var$Vd(a, b) {
    if (0 == a.length) throw Error("number format error: empty string");
    b = b || 10;
    if (2 > b || 36 < b) throw Error("radix out of range: " + b);
    if ("-" == a.charAt(0)) return $bcffdc5a8182d43d$var$W($bcffdc5a8182d43d$var$Vd(a.substring(1), b));
    if (0 <= a.indexOf("-")) throw Error('number format error: interior "-" character');
    for(var c = $bcffdc5a8182d43d$var$U(Math.pow(b, 8)), d = $bcffdc5a8182d43d$var$V, e = 0; e < a.length; e += 8){
        var f = Math.min(8, a.length - e), h = parseInt(a.substring(e, e + f), b);
        8 > f ? (f = $bcffdc5a8182d43d$var$U(Math.pow(b, f)), d = d.R(f).add($bcffdc5a8182d43d$var$U(h))) : (d = d.R(c), d = d.add($bcffdc5a8182d43d$var$U(h)));
    }
    return d;
}
var $bcffdc5a8182d43d$var$Ud = 4294967296, $bcffdc5a8182d43d$var$V = $bcffdc5a8182d43d$var$Td(0), $bcffdc5a8182d43d$var$Wd = $bcffdc5a8182d43d$var$Td(1), $bcffdc5a8182d43d$var$Xd = $bcffdc5a8182d43d$var$Td(16777216);
$bcffdc5a8182d43d$var$k = $bcffdc5a8182d43d$var$T.prototype;
$bcffdc5a8182d43d$var$k.ea = function() {
    if ($bcffdc5a8182d43d$var$X(this)) return -$bcffdc5a8182d43d$var$W(this).ea();
    for(var a = 0, b = 1, c = 0; c < this.g.length; c++){
        var d = this.D(c);
        a += (0 <= d ? d : $bcffdc5a8182d43d$var$Ud + d) * b;
        b *= $bcffdc5a8182d43d$var$Ud;
    }
    return a;
};
$bcffdc5a8182d43d$var$k.toString = function(a) {
    a = a || 10;
    if (2 > a || 36 < a) throw Error("radix out of range: " + a);
    if ($bcffdc5a8182d43d$var$Y(this)) return "0";
    if ($bcffdc5a8182d43d$var$X(this)) return "-" + $bcffdc5a8182d43d$var$W(this).toString(a);
    for(var b = $bcffdc5a8182d43d$var$U(Math.pow(a, 6)), c = this, d = "";;){
        var e = $bcffdc5a8182d43d$var$Yd(c, b).g;
        c = $bcffdc5a8182d43d$var$Zd(c, e.R(b));
        var f = ((0 < c.g.length ? c.g[0] : c.h) >>> 0).toString(a);
        c = e;
        if ($bcffdc5a8182d43d$var$Y(c)) return f + d;
        for(; 6 > f.length;)f = "0" + f;
        d = f + d;
    }
};
$bcffdc5a8182d43d$var$k.D = function(a) {
    return 0 > a ? 0 : a < this.g.length ? this.g[a] : this.h;
};
function $bcffdc5a8182d43d$var$Y(a) {
    if (0 != a.h) return !1;
    for(var b = 0; b < a.g.length; b++)if (0 != a.g[b]) return !1;
    return !0;
}
function $bcffdc5a8182d43d$var$X(a) {
    return -1 == a.h;
}
$bcffdc5a8182d43d$var$k.X = function(a) {
    a = $bcffdc5a8182d43d$var$Zd(this, a);
    return $bcffdc5a8182d43d$var$X(a) ? -1 : $bcffdc5a8182d43d$var$Y(a) ? 0 : 1;
};
function $bcffdc5a8182d43d$var$W(a) {
    for(var b = a.g.length, c = [], d = 0; d < b; d++)c[d] = ~a.g[d];
    return new $bcffdc5a8182d43d$var$T(c, ~a.h).add($bcffdc5a8182d43d$var$Wd);
}
$bcffdc5a8182d43d$var$k.abs = function() {
    return $bcffdc5a8182d43d$var$X(this) ? $bcffdc5a8182d43d$var$W(this) : this;
};
$bcffdc5a8182d43d$var$k.add = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0, e = 0; e <= b; e++){
        var f = d + (this.D(e) & 65535) + (a.D(e) & 65535), h = (f >>> 16) + (this.D(e) >>> 16) + (a.D(e) >>> 16);
        d = h >>> 16;
        f &= 65535;
        h &= 65535;
        c[e] = h << 16 | f;
    }
    return new $bcffdc5a8182d43d$var$T(c, c[c.length - 1] & -2147483648 ? -1 : 0);
};
function $bcffdc5a8182d43d$var$Zd(a, b) {
    return a.add($bcffdc5a8182d43d$var$W(b));
}
$bcffdc5a8182d43d$var$k.R = function(a) {
    if ($bcffdc5a8182d43d$var$Y(this) || $bcffdc5a8182d43d$var$Y(a)) return $bcffdc5a8182d43d$var$V;
    if ($bcffdc5a8182d43d$var$X(this)) return $bcffdc5a8182d43d$var$X(a) ? $bcffdc5a8182d43d$var$W(this).R($bcffdc5a8182d43d$var$W(a)) : $bcffdc5a8182d43d$var$W($bcffdc5a8182d43d$var$W(this).R(a));
    if ($bcffdc5a8182d43d$var$X(a)) return $bcffdc5a8182d43d$var$W(this.R($bcffdc5a8182d43d$var$W(a)));
    if (0 > this.X($bcffdc5a8182d43d$var$Xd) && 0 > a.X($bcffdc5a8182d43d$var$Xd)) return $bcffdc5a8182d43d$var$U(this.ea() * a.ea());
    for(var b = this.g.length + a.g.length, c = [], d = 0; d < 2 * b; d++)c[d] = 0;
    for(d = 0; d < this.g.length; d++)for(var e = 0; e < a.g.length; e++){
        var f = this.D(d) >>> 16, h = this.D(d) & 65535, n = a.D(e) >>> 16, t = a.D(e) & 65535;
        c[2 * d + 2 * e] += h * t;
        $bcffdc5a8182d43d$var$$d(c, 2 * d + 2 * e);
        c[2 * d + 2 * e + 1] += f * t;
        $bcffdc5a8182d43d$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 1] += h * n;
        $bcffdc5a8182d43d$var$$d(c, 2 * d + 2 * e + 1);
        c[2 * d + 2 * e + 2] += f * n;
        $bcffdc5a8182d43d$var$$d(c, 2 * d + 2 * e + 2);
    }
    for(d = 0; d < b; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
    for(d = b; d < 2 * b; d++)c[d] = 0;
    return new $bcffdc5a8182d43d$var$T(c, 0);
};
function $bcffdc5a8182d43d$var$$d(a, b) {
    for(; (a[b] & 65535) != a[b];)a[b + 1] += a[b] >>> 16, a[b] &= 65535, b++;
}
function $bcffdc5a8182d43d$var$ae(a, b) {
    this.g = a;
    this.h = b;
}
function $bcffdc5a8182d43d$var$Yd(a, b) {
    if ($bcffdc5a8182d43d$var$Y(b)) throw Error("division by zero");
    if ($bcffdc5a8182d43d$var$Y(a)) return new $bcffdc5a8182d43d$var$ae($bcffdc5a8182d43d$var$V, $bcffdc5a8182d43d$var$V);
    if ($bcffdc5a8182d43d$var$X(a)) return b = $bcffdc5a8182d43d$var$Yd($bcffdc5a8182d43d$var$W(a), b), new $bcffdc5a8182d43d$var$ae($bcffdc5a8182d43d$var$W(b.g), $bcffdc5a8182d43d$var$W(b.h));
    if ($bcffdc5a8182d43d$var$X(b)) return b = $bcffdc5a8182d43d$var$Yd(a, $bcffdc5a8182d43d$var$W(b)), new $bcffdc5a8182d43d$var$ae($bcffdc5a8182d43d$var$W(b.g), b.h);
    if (30 < a.g.length) {
        if ($bcffdc5a8182d43d$var$X(a) || $bcffdc5a8182d43d$var$X(b)) throw Error("slowDivide_ only works with positive integers.");
        for(var c = $bcffdc5a8182d43d$var$Wd, d = b; 0 >= d.X(a);)c = $bcffdc5a8182d43d$var$be(c), d = $bcffdc5a8182d43d$var$be(d);
        var e = $bcffdc5a8182d43d$var$Z(c, 1), f = $bcffdc5a8182d43d$var$Z(d, 1);
        d = $bcffdc5a8182d43d$var$Z(d, 2);
        for(c = $bcffdc5a8182d43d$var$Z(c, 2); !$bcffdc5a8182d43d$var$Y(d);){
            var h = f.add(d);
            0 >= h.X(a) && (e = e.add(c), f = h);
            d = $bcffdc5a8182d43d$var$Z(d, 1);
            c = $bcffdc5a8182d43d$var$Z(c, 1);
        }
        b = $bcffdc5a8182d43d$var$Zd(a, e.R(b));
        return new $bcffdc5a8182d43d$var$ae(e, b);
    }
    for(e = $bcffdc5a8182d43d$var$V; 0 <= a.X(b);){
        c = Math.max(1, Math.floor(a.ea() / b.ea()));
        d = Math.ceil(Math.log(c) / Math.LN2);
        d = 48 >= d ? 1 : Math.pow(2, d - 48);
        f = $bcffdc5a8182d43d$var$U(c);
        for(h = f.R(b); $bcffdc5a8182d43d$var$X(h) || 0 < h.X(a);)c -= d, f = $bcffdc5a8182d43d$var$U(c), h = f.R(b);
        $bcffdc5a8182d43d$var$Y(f) && (f = $bcffdc5a8182d43d$var$Wd);
        e = e.add(f);
        a = $bcffdc5a8182d43d$var$Zd(a, h);
    }
    return new $bcffdc5a8182d43d$var$ae(e, a);
}
$bcffdc5a8182d43d$var$k.gb = function(a) {
    return $bcffdc5a8182d43d$var$Yd(this, a).h;
};
$bcffdc5a8182d43d$var$k.and = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) & a.D(d);
    return new $bcffdc5a8182d43d$var$T(c, this.h & a.h);
};
$bcffdc5a8182d43d$var$k.or = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) | a.D(d);
    return new $bcffdc5a8182d43d$var$T(c, this.h | a.h);
};
$bcffdc5a8182d43d$var$k.xor = function(a) {
    for(var b = Math.max(this.g.length, a.g.length), c = [], d = 0; d < b; d++)c[d] = this.D(d) ^ a.D(d);
    return new $bcffdc5a8182d43d$var$T(c, this.h ^ a.h);
};
function $bcffdc5a8182d43d$var$be(a) {
    for(var b = a.g.length + 1, c = [], d = 0; d < b; d++)c[d] = a.D(d) << 1 | a.D(d - 1) >>> 31;
    return new $bcffdc5a8182d43d$var$T(c, a.h);
}
function $bcffdc5a8182d43d$var$Z(a, b) {
    var c = b >> 5;
    b %= 32;
    for(var d = a.g.length - c, e = [], f = 0; f < d; f++)e[f] = 0 < b ? a.D(f + c) >>> b | a.D(f + c + 1) << 32 - b : a.D(f + c);
    return new $bcffdc5a8182d43d$var$T(e, a.h);
}
$bcffdc5a8182d43d$var$Od.prototype.createWebChannel = $bcffdc5a8182d43d$var$Od.prototype.g;
$bcffdc5a8182d43d$var$Q.prototype.send = $bcffdc5a8182d43d$var$Q.prototype.u;
$bcffdc5a8182d43d$var$Q.prototype.open = $bcffdc5a8182d43d$var$Q.prototype.m;
$bcffdc5a8182d43d$var$Q.prototype.close = $bcffdc5a8182d43d$var$Q.prototype.close;
$bcffdc5a8182d43d$var$Sb.NO_ERROR = 0;
$bcffdc5a8182d43d$var$Sb.TIMEOUT = 8;
$bcffdc5a8182d43d$var$Sb.HTTP_ERROR = 6;
$bcffdc5a8182d43d$var$Tb.COMPLETE = "complete";
$bcffdc5a8182d43d$var$Wb.EventType = $bcffdc5a8182d43d$var$Xb;
$bcffdc5a8182d43d$var$Xb.OPEN = "a";
$bcffdc5a8182d43d$var$Xb.CLOSE = "b";
$bcffdc5a8182d43d$var$Xb.ERROR = "c";
$bcffdc5a8182d43d$var$Xb.MESSAGE = "d";
$bcffdc5a8182d43d$var$B.prototype.listen = $bcffdc5a8182d43d$var$B.prototype.O;
$bcffdc5a8182d43d$var$P.prototype.listenOnce = $bcffdc5a8182d43d$var$P.prototype.P;
$bcffdc5a8182d43d$var$P.prototype.getLastError = $bcffdc5a8182d43d$var$P.prototype.Sa;
$bcffdc5a8182d43d$var$P.prototype.getLastErrorCode = $bcffdc5a8182d43d$var$P.prototype.Ia;
$bcffdc5a8182d43d$var$P.prototype.getStatus = $bcffdc5a8182d43d$var$P.prototype.da;
$bcffdc5a8182d43d$var$P.prototype.getResponseJson = $bcffdc5a8182d43d$var$P.prototype.Wa;
$bcffdc5a8182d43d$var$P.prototype.getResponseText = $bcffdc5a8182d43d$var$P.prototype.ja;
$bcffdc5a8182d43d$var$P.prototype.send = $bcffdc5a8182d43d$var$P.prototype.ha;
$bcffdc5a8182d43d$var$P.prototype.setWithCredentials = $bcffdc5a8182d43d$var$P.prototype.Oa;
$bcffdc5a8182d43d$var$S.prototype.digest = $bcffdc5a8182d43d$var$S.prototype.l;
$bcffdc5a8182d43d$var$S.prototype.reset = $bcffdc5a8182d43d$var$S.prototype.reset;
$bcffdc5a8182d43d$var$S.prototype.update = $bcffdc5a8182d43d$var$S.prototype.j;
$bcffdc5a8182d43d$var$T.prototype.add = $bcffdc5a8182d43d$var$T.prototype.add;
$bcffdc5a8182d43d$var$T.prototype.multiply = $bcffdc5a8182d43d$var$T.prototype.R;
$bcffdc5a8182d43d$var$T.prototype.modulo = $bcffdc5a8182d43d$var$T.prototype.gb;
$bcffdc5a8182d43d$var$T.prototype.compare = $bcffdc5a8182d43d$var$T.prototype.X;
$bcffdc5a8182d43d$var$T.prototype.toNumber = $bcffdc5a8182d43d$var$T.prototype.ea;
$bcffdc5a8182d43d$var$T.prototype.toString = $bcffdc5a8182d43d$var$T.prototype.toString;
$bcffdc5a8182d43d$var$T.prototype.getBits = $bcffdc5a8182d43d$var$T.prototype.D;
$bcffdc5a8182d43d$var$T.fromNumber = $bcffdc5a8182d43d$var$U;
$bcffdc5a8182d43d$var$T.fromString = $bcffdc5a8182d43d$var$Vd;
var $bcffdc5a8182d43d$export$66869136fc133c3a = $bcffdc5a8182d43d$export$2e2bcd8739ae039.createWebChannelTransport = function createWebChannelTransport() {
    return new $bcffdc5a8182d43d$var$Od;
};
var $bcffdc5a8182d43d$export$888d0d9ab79d08fc = $bcffdc5a8182d43d$export$2e2bcd8739ae039.getStatEventTarget = function getStatEventTarget() {
    return $bcffdc5a8182d43d$var$Mb();
};
var $bcffdc5a8182d43d$export$d4e71bc0b80dc0fb = $bcffdc5a8182d43d$export$2e2bcd8739ae039.ErrorCode = $bcffdc5a8182d43d$var$Sb;
var $bcffdc5a8182d43d$export$3d7865934588d77e = $bcffdc5a8182d43d$export$2e2bcd8739ae039.EventType = $bcffdc5a8182d43d$var$Tb;
var $bcffdc5a8182d43d$export$d61e24a684f9e51 = $bcffdc5a8182d43d$export$2e2bcd8739ae039.Event = $bcffdc5a8182d43d$var$E;
var $bcffdc5a8182d43d$export$cbbc350c1dfc80cb = $bcffdc5a8182d43d$export$2e2bcd8739ae039.Stat = {
    xb: 0,
    Ab: 1,
    Bb: 2,
    Ub: 3,
    Zb: 4,
    Wb: 5,
    Xb: 6,
    Vb: 7,
    Tb: 8,
    Yb: 9,
    PROXY: 10,
    NOPROXY: 11,
    Rb: 12,
    Nb: 13,
    Ob: 14,
    Mb: 15,
    Pb: 16,
    Qb: 17,
    tb: 18,
    sb: 19,
    ub: 20
};
var $bcffdc5a8182d43d$export$ddb1030448106742 = $bcffdc5a8182d43d$export$2e2bcd8739ae039.FetchXmlHttpFactory = $bcffdc5a8182d43d$var$ld;
var $bcffdc5a8182d43d$export$aa726fb96ad3e039 = $bcffdc5a8182d43d$export$2e2bcd8739ae039.WebChannel = $bcffdc5a8182d43d$var$Wb;
var $bcffdc5a8182d43d$export$26404658cda3ee02 = $bcffdc5a8182d43d$export$2e2bcd8739ae039.XhrIo = $bcffdc5a8182d43d$var$P;
var $bcffdc5a8182d43d$export$9f5a3dfc7a9f5dd = $bcffdc5a8182d43d$export$2e2bcd8739ae039.Md5 = $bcffdc5a8182d43d$var$S;
var $bcffdc5a8182d43d$export$70ffa26850098d01 = $bcffdc5a8182d43d$export$2e2bcd8739ae039.Integer = $bcffdc5a8182d43d$var$T;



var $a8i8g = parcelRequire("a8i8g");
var $59fc9b849b320ded$var$w = "@firebase/firestore";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ var $59fc9b849b320ded$var$User = /*#__PURE__*/ function() {
    "use strict";
    function User(e) {
        (0, $978gY._)(this, User);
        this.uid = e;
    }
    (0, $kry2a._)(User, [
        {
            key: "isAuthenticated",
            value: function isAuthenticated() {
                return null != this.uid;
            }
        },
        {
            /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ key: "toKey",
            value: function toKey() {
                return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e.uid === this.uid;
            }
        }
    ]);
    return User;
}();
/** A user with a null UID. */ $59fc9b849b320ded$var$User.UNAUTHENTICATED = new $59fc9b849b320ded$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$59fc9b849b320ded$var$User.GOOGLE_CREDENTIALS = new $59fc9b849b320ded$var$User("google-credentials-uid"), $59fc9b849b320ded$var$User.FIRST_PARTY = new $59fc9b849b320ded$var$User("first-party-uid"), $59fc9b849b320ded$var$User.MOCK_USER = new $59fc9b849b320ded$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$S = "10.3.1";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$b = new (0, $a1a98c9cad39c4c7$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $59fc9b849b320ded$var$__PRIVATE_getLogLevel() {
    return $59fc9b849b320ded$var$b.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $59fc9b849b320ded$export$c622e99c0ce7b1c9(e) {
    $59fc9b849b320ded$var$b.setLogLevel(e);
}
function $59fc9b849b320ded$var$__PRIVATE_logDebug(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if ($59fc9b849b320ded$var$b.logLevel <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).DEBUG) {
        var _b;
        var n = t.map($59fc9b849b320ded$var$__PRIVATE_argToString);
        (_b = $59fc9b849b320ded$var$b).debug.apply(_b, [
            "Firestore (".concat($59fc9b849b320ded$var$S, "): ").concat(e)
        ].concat((0, $fLnyw._)(n)));
    }
}
function $59fc9b849b320ded$var$__PRIVATE_logError(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if ($59fc9b849b320ded$var$b.logLevel <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).ERROR) {
        var _b;
        var n = t.map($59fc9b849b320ded$var$__PRIVATE_argToString);
        (_b = $59fc9b849b320ded$var$b).error.apply(_b, [
            "Firestore (".concat($59fc9b849b320ded$var$S, "): ").concat(e)
        ].concat((0, $fLnyw._)(n)));
    }
}
/**
 * @internal
 */ function $59fc9b849b320ded$export$86cd73f49cc6e0bb(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    if ($59fc9b849b320ded$var$b.logLevel <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).WARN) {
        var _b;
        var n = t.map($59fc9b849b320ded$var$__PRIVATE_argToString);
        (_b = $59fc9b849b320ded$var$b).warn.apply(_b, [
            "Firestore (".concat($59fc9b849b320ded$var$S, "): ").concat(e)
        ].concat((0, $fLnyw._)(n)));
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $59fc9b849b320ded$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unconditionally fails, throwing an Error with the given message.
 * Messages are stripped in production builds.
 *
 * Returns `never` and can be used in expressions:
 * @example
 * let futureVar = fail('not implemented yet');
 */ function $59fc9b849b320ded$var$fail() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Unexpected state";
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    var t = "FIRESTORE (".concat($59fc9b849b320ded$var$S, ") INTERNAL ASSERTION FAILED: ") + e;
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $59fc9b849b320ded$var$__PRIVATE_logError(t), new Error(t);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * Messages are stripped in production builds.
 */ function $59fc9b849b320ded$var$__PRIVATE_hardAssert(e, t) {
    e || $59fc9b849b320ded$var$fail();
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $59fc9b849b320ded$export$1d2b90eea9bba017(e, t) {
    e || $59fc9b849b320ded$var$fail();
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $59fc9b849b320ded$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$D = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller can not be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ var $59fc9b849b320ded$export$8fada0bf726bf278 = /*#__PURE__*/ function(FirebaseError) {
    "use strict";
    (0, $ftJVG._)(FirestoreError, FirebaseError);
    var _super = (0, $6OZAO._)(FirestoreError);
    function FirestoreError(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t) {
        (0, $978gY._)(this, FirestoreError);
        var _this;
        _this = _super.call(this, e, t), _this.code = e, _this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        _this.toString = function() {
            return "".concat(_this.name, ": [code=").concat(_this.code, "]: ").concat(_this.message);
        };
        return (0, $ho5gk._)(_this);
    }
    return FirestoreError;
}((0, $b1467a785fc7cec5$export$dd24e9cd51226c56));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_Deferred = function __PRIVATE_Deferred() {
    "use strict";
    var _this = this;
    (0, $978gY._)(this, __PRIVATE_Deferred);
    this.promise = new Promise(function(e, t) {
        _this.resolve = e, _this.reject = t;
    });
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_OAuthToken = function __PRIVATE_OAuthToken(e, t) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_OAuthToken);
    this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", "Bearer ".concat(e));
};
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ var $59fc9b849b320ded$export$65ffa50b6039c992 = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmptyAuthCredentialsProvider() {
        (0, $978gY._)(this, __PRIVATE_EmptyAuthCredentialsProvider);
    }
    (0, $kry2a._)(__PRIVATE_EmptyAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {
                // Fire with initial user.
                e.enqueueRetryable(function() {
                    return t($59fc9b849b320ded$var$User.UNAUTHENTICATED);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        }
    ]);
    return __PRIVATE_EmptyAuthCredentialsProvider;
}();
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ var $59fc9b849b320ded$var$__PRIVATE_EmulatorAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmulatorAuthCredentialsProvider(e) {
        (0, $978gY._)(this, __PRIVATE_EmulatorAuthCredentialsProvider);
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    (0, $kry2a._)(__PRIVATE_EmulatorAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(this.token);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                this.changeListener = t, // Fire with initial user.
                e.enqueueRetryable(function() {
                    return t(_this.token.user);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.changeListener = null;
            }
        }
    ]);
    return __PRIVATE_EmulatorAuthCredentialsProvider;
}();
var $59fc9b849b320ded$var$__PRIVATE_FirebaseAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirebaseAuthCredentialsProvider(e) {
        (0, $978gY._)(this, __PRIVATE_FirebaseAuthCredentialsProvider);
        this.t = e, /** Tracks the current User. */ this.currentUser = $59fc9b849b320ded$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    (0, $kry2a._)(__PRIVATE_FirebaseAuthCredentialsProvider, [
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                var n = this.i;
                // A change listener that prevents double-firing for the same token change.
                var __PRIVATE_guardedChangeListener = function(e) {
                    return _this.i !== n ? (n = _this.i, t(e)) : Promise.resolve();
                };
                // A promise that can be waited on to block on the next token change.
                // This promise is re-created after each change.
                var r = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
                this.o = function() {
                    _this.i++, _this.currentUser = _this.u(), r.resolve(), r = new $59fc9b849b320ded$var$__PRIVATE_Deferred, e.enqueueRetryable(function() {
                        return __PRIVATE_guardedChangeListener(_this.currentUser);
                    });
                };
                var __PRIVATE_awaitNextToken = function() {
                    var t = r;
                    var _this1 = _this;
                    e.enqueueRetryable(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        t.promise
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        4,
                                        __PRIVATE_guardedChangeListener(_this1.currentUser)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                }, __PRIVATE_registerAuth = function(e) {
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), _this.auth = e, _this.auth.addAuthTokenListener(_this.o), __PRIVATE_awaitNextToken();
                };
                this.t.onInit(function(e) {
                    return __PRIVATE_registerAuth(e);
                }), // Our users can initialize Auth right after Firestore, so we give it
                // a chance to register itself with the component framework before we
                // determine whether to start up in unauthenticated mode.
                setTimeout(function() {
                    if (!_this.auth) {
                        var e = _this.t.getImmediate({
                            optional: !0
                        });
                        e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                        ($59fc9b849b320ded$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $59fc9b849b320ded$var$__PRIVATE_Deferred);
                    }
                }, 0), __PRIVATE_awaitNextToken();
            }
        },
        {
            key: "getToken",
            value: function getToken() {
                var _this = this;
                // Take note of the current value of the tokenCounter so that this method
                // can fail (with an ABORTED error) if there is a token change while the
                // request is outstanding.
                var e = this.i, t = this.forceRefresh;
                return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then(function(t) {
                    return(// Cancel the request since the token changed while the request was
                    // outstanding so the response is potentially for a previous user (which
                    // user, we can't be sure).
                    _this.i !== e ? ($59fc9b849b320ded$var$__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), _this.getToken()) : t ? ($59fc9b849b320ded$var$__PRIVATE_hardAssert("string" == typeof t.accessToken), new $59fc9b849b320ded$var$__PRIVATE_OAuthToken(t.accessToken, _this.currentUser)) : null);
                }) : Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {
                this.forceRefresh = !0;
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.auth && this.auth.removeAuthTokenListener(this.o);
            }
        },
        {
            // Auth.getUid() can return null even with a user logged in. It is because
            // getUid() is synchronous, but the auth code populating Uid is asynchronous.
            // This method should only be called in the AuthTokenListener callback
            // to guarantee to get the actual user.
            key: "u",
            value: function u() {
                var e = this.auth && this.auth.getUid();
                return $59fc9b849b320ded$var$__PRIVATE_hardAssert(null === e || "string" == typeof e), new $59fc9b849b320ded$var$User(e);
            }
        }
    ]);
    return __PRIVATE_FirebaseAuthCredentialsProvider;
}();
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ var $59fc9b849b320ded$var$__PRIVATE_FirstPartyToken = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirstPartyToken(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_FirstPartyToken);
        this.l = e, this.h = t, this.P = n, this.type = "FirstParty", this.user = $59fc9b849b320ded$var$User.FIRST_PARTY, this.I = new Map;
    }
    (0, $kry2a._)(__PRIVATE_FirstPartyToken, [
        {
            /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ key: "T",
            value: function T() {
                return this.P ? this.P() : null;
            }
        },
        {
            key: "headers",
            get: function get() {
                this.I.set("X-Goog-AuthUser", this.l);
                // Use array notation to prevent minification
                var e = this.T();
                return e && this.I.set("Authorization", e), this.h && this.I.set("X-Goog-Iam-Authorization-Token", this.h), this.I;
            }
        }
    ]);
    return __PRIVATE_FirstPartyToken;
}();
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ var $59fc9b849b320ded$var$__PRIVATE_FirstPartyAuthCredentialsProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirstPartyAuthCredentialsProvider(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_FirstPartyAuthCredentialsProvider);
        this.l = e, this.h = t, this.P = n;
    }
    (0, $kry2a._)(__PRIVATE_FirstPartyAuthCredentialsProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(new $59fc9b849b320ded$var$__PRIVATE_FirstPartyToken(this.l, this.h, this.P));
            }
        },
        {
            key: "start",
            value: function start(e, t) {
                // Fire with initial uid.
                e.enqueueRetryable(function() {
                    return t($59fc9b849b320ded$var$User.FIRST_PARTY);
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        }
    ]);
    return __PRIVATE_FirstPartyAuthCredentialsProvider;
}();
var $59fc9b849b320ded$var$AppCheckToken = function AppCheckToken(e) {
    "use strict";
    (0, $978gY._)(this, AppCheckToken);
    this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
};
var $59fc9b849b320ded$var$__PRIVATE_FirebaseAppCheckTokenProvider = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirebaseAppCheckTokenProvider(e) {
        (0, $978gY._)(this, __PRIVATE_FirebaseAppCheckTokenProvider);
        this.A = e, this.forceRefresh = !1, this.appCheck = null, this.R = null;
    }
    (0, $kry2a._)(__PRIVATE_FirebaseAppCheckTokenProvider, [
        {
            key: "start",
            value: function start(e, t) {
                var _this = this;
                var onTokenChanged = function(e) {
                    null != e.error && $59fc9b849b320ded$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "Error getting App Check token; using placeholder token instead. Error: ".concat(e.error.message));
                    var n = e.token !== _this.R;
                    return _this.R = e.token, $59fc9b849b320ded$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "Received ".concat(n ? "new" : "existing", " token.")), n ? t(e.token) : Promise.resolve();
                };
                this.o = function(t) {
                    e.enqueueRetryable(function() {
                        return onTokenChanged(t);
                    });
                };
                var __PRIVATE_registerAppCheck = function(e) {
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), _this.appCheck = e, _this.appCheck.addTokenListener(_this.o);
                };
                this.A.onInit(function(e) {
                    return __PRIVATE_registerAppCheck(e);
                }), // Our users can initialize AppCheck after Firestore, so we give it
                // a chance to register itself with the component framework.
                setTimeout(function() {
                    if (!_this.appCheck) {
                        var e = _this.A.getImmediate({
                            optional: !0
                        });
                        e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                        $59fc9b849b320ded$var$__PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
                    }
                }, 0);
            }
        },
        {
            key: "getToken",
            value: function getToken() {
                var _this = this;
                var e = this.forceRefresh;
                return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then(function(e) {
                    return e ? ($59fc9b849b320ded$var$__PRIVATE_hardAssert("string" == typeof e.token), _this.R = e.token, new $59fc9b849b320ded$var$AppCheckToken(e.token)) : null;
                }) : Promise.resolve(null);
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {
                this.forceRefresh = !0;
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.appCheck && this.appCheck.removeTokenListener(this.o);
            }
        }
    ]);
    return __PRIVATE_FirebaseAppCheckTokenProvider;
}();
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ var $59fc9b849b320ded$export$b342cec01954510f = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_EmptyAppCheckTokenProvider() {
        (0, $978gY._)(this, __PRIVATE_EmptyAppCheckTokenProvider);
    }
    (0, $kry2a._)(__PRIVATE_EmptyAppCheckTokenProvider, [
        {
            key: "getToken",
            value: function getToken() {
                return Promise.resolve(new $59fc9b849b320ded$var$AppCheckToken(""));
            }
        },
        {
            key: "invalidateToken",
            value: function invalidateToken() {}
        },
        {
            key: "start",
            value: function start(e, t) {}
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        }
    ]);
    return __PRIVATE_EmptyAppCheckTokenProvider;
}();
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $59fc9b849b320ded$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    var t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(var t1 = 0; t1 < e; t1++)n[t1] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_AutoId = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AutoId() {
        (0, $978gY._)(this, __PRIVATE_AutoId);
    }
    (0, $kry2a._)(__PRIVATE_AutoId, null, [
        {
            key: "V",
            value: function V() {
                // Alphanumeric characters
                var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = Math.floor(256 / e.length) * e.length;
                // The largest byte value that is a multiple of `char.length`.
                var n = "";
                for(; n.length < 20;){
                    var r = $59fc9b849b320ded$var$__PRIVATE_randomBytes(40);
                    for(var i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
                    // be evenly mapped to indices of `chars` via a modulo operation.
                    n.length < 20 && r[i] < t && (n += e.charAt(r[i] % e.length));
                }
                return n;
            }
        }
    ]);
    return __PRIVATE_AutoId;
}();
function $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Helper to compare arrays using isEqual(). */ function $59fc9b849b320ded$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every(function(e, r) {
        return n(e, t[r]);
    });
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $59fc9b849b320ded$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\x00";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ var $59fc9b849b320ded$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function() {
    "use strict";
    function Timestamp(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t) {
        (0, $978gY._)(this, Timestamp);
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < -62135596800) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    (0, $kry2a._)(Timestamp, [
        {
            /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ key: "toDate",
            value: function toDate() {
                return new Date(this.toMillis());
            }
        },
        {
            /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ key: "toMillis",
            value: function toMillis() {
                return 1e3 * this.seconds + this.nanoseconds / 1e6;
            }
        },
        {
            key: "_compareTo",
            value: function _compareTo(e) {
                return this.seconds === e.seconds ? $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
            }
        },
        {
            /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
            }
        },
        {
            /** Returns a textual representation of this `Timestamp`. */ key: "toString",
            value: function toString() {
                return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
            }
        },
        {
            /** Returns a JSON-serializable representation of this `Timestamp`. */ key: "toJSON",
            value: function toJSON() {
                return {
                    seconds: this.seconds,
                    nanoseconds: this.nanoseconds
                };
            }
        },
        {
            /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ key: "valueOf",
            value: function valueOf() {
                // This method returns a string of the form <seconds>.<nanoseconds> where
                // <seconds> is translated to have a non-negative value and both <seconds>
                // and <nanoseconds> are left-padded with zeroes to be a consistent length.
                // Strings with this format then have a lexiographical ordering that matches
                // the expected ordering. The <seconds> translation is done to avoid having
                // a leading negative sign (i.e. a leading '-' character) in its string
                // representation, which would affect its lexiographical ordering.
                var e = this.seconds - -62135596800;
                // Note: Up to 12 decimal digits are required to represent all valid
                // 'seconds' values.
                return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
            }
        }
    ], [
        {
            key: "now",
            value: /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ function now() {
                return Timestamp.fromMillis(Date.now());
            }
        },
        {
            key: "fromDate",
            value: /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ function fromDate(e) {
                return Timestamp.fromMillis(e.getTime());
            }
        },
        {
            key: "fromMillis",
            value: /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ function fromMillis(e) {
                var t = Math.floor(e / 1e3), n = Math.floor(1e6 * (e - 1e3 * t));
                return new Timestamp(t, n);
            }
        }
    ]);
    return Timestamp;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ var $59fc9b849b320ded$var$SnapshotVersion = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotVersion(e) {
        (0, $978gY._)(this, SnapshotVersion);
        this.timestamp = e;
    }
    (0, $kry2a._)(SnapshotVersion, [
        {
            key: "compareTo",
            value: function compareTo(e) {
                return this.timestamp._compareTo(e.timestamp);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.timestamp.isEqual(e.timestamp);
            }
        },
        {
            /** Returns a number representation of the version for use in spec tests. */ key: "toMicroseconds",
            value: function toMicroseconds() {
                // Convert to microseconds.
                return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "SnapshotVersion(" + this.timestamp.toString() + ")";
            }
        },
        {
            key: "toTimestamp",
            value: function toTimestamp() {
                return this.timestamp;
            }
        }
    ], [
        {
            key: "fromTimestamp",
            value: function fromTimestamp(e) {
                return new SnapshotVersion(e);
            }
        },
        {
            key: "min",
            value: function min() {
                return new SnapshotVersion(new $59fc9b849b320ded$export$d9bcbd5e1ff81430(0, 0));
            }
        },
        {
            key: "max",
            value: function max() {
                return new SnapshotVersion(new $59fc9b849b320ded$export$d9bcbd5e1ff81430(253402300799, 999999999));
            }
        }
    ]);
    return SnapshotVersion;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Path represents an ordered sequence of string segments.
 */ var $59fc9b849b320ded$var$BasePath = /*#__PURE__*/ function() {
    "use strict";
    function BasePath(e, t, n) {
        (0, $978gY._)(this, BasePath);
        void 0 === t ? t = 0 : t > e.length && $59fc9b849b320ded$var$fail(), void 0 === n ? n = e.length - t : n > e.length - t && $59fc9b849b320ded$var$fail(), this.segments = e, this.offset = t, this.len = n;
    }
    (0, $kry2a._)(BasePath, [
        {
            key: "length",
            get: function get() {
                return this.len;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return 0 === BasePath.comparator(this, e);
            }
        },
        {
            key: "child",
            value: function child(e) {
                var t = this.segments.slice(this.offset, this.limit());
                return e instanceof BasePath ? e.forEach(function(e) {
                    t.push(e);
                }) : t.push(e), this.construct(t);
            }
        },
        {
            /** The index of one past the last segment of the path. */ key: "limit",
            value: function limit() {
                return this.offset + this.length;
            }
        },
        {
            key: "popFirst",
            value: function popFirst(e) {
                return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
            }
        },
        {
            key: "popLast",
            value: function popLast() {
                return this.construct(this.segments, this.offset, this.length - 1);
            }
        },
        {
            key: "firstSegment",
            value: function firstSegment() {
                return this.segments[this.offset];
            }
        },
        {
            key: "lastSegment",
            value: function lastSegment() {
                return this.get(this.length - 1);
            }
        },
        {
            key: "get",
            value: function get(e) {
                return this.segments[this.offset + e];
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return 0 === this.length;
            }
        },
        {
            key: "isPrefixOf",
            value: function isPrefixOf(e) {
                if (e.length < this.length) return !1;
                for(var t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
                return !0;
            }
        },
        {
            key: "isImmediateParentOf",
            value: function isImmediateParentOf(e) {
                if (this.length + 1 !== e.length) return !1;
                for(var t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
                return !0;
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                for(var t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this.segments.slice(this.offset, this.limit());
            }
        }
    ], [
        {
            key: "comparator",
            value: function comparator(e, t) {
                var n = Math.min(e.length, t.length);
                for(var r = 0; r < n; r++){
                    var n1 = e.get(r), i = t.get(r);
                    if (n1 < i) return -1;
                    if (n1 > i) return 1;
                }
                return e.length < t.length ? -1 : e.length > t.length ? 1 : 0;
            }
        }
    ]);
    return BasePath;
}();
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ var $59fc9b849b320ded$var$ResourcePath = /*#__PURE__*/ function(BasePath) {
    "use strict";
    (0, $ftJVG._)(ResourcePath, BasePath);
    var _super = (0, $6OZAO._)(ResourcePath);
    function ResourcePath() {
        (0, $978gY._)(this, ResourcePath);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(ResourcePath, [
        {
            key: "construct",
            value: function construct(e, t, n) {
                return new ResourcePath(e, t, n);
            }
        },
        {
            key: "canonicalString",
            value: function canonicalString() {
                // NOTE: The client is ignorant of any path segments containing escape
                // sequences (e.g. __id123__) and just passes them through raw (they exist
                // for legacy reasons and should not be used frequently).
                return this.toArray().join("/");
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.canonicalString();
            }
        }
    ], [
        {
            key: "fromString",
            value: /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ function fromString() {
                for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
                    e[_key] = arguments[_key];
                }
                // NOTE: The client is ignorant of any path segments containing escape
                // sequences (e.g. __id123__) and just passes them through raw (they exist
                // for legacy reasons and should not be used frequently).
                var t = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        var // Strip leading and traling slashed.
                        _t;
                        if (n.indexOf("//") >= 0) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid segment (".concat(n, "). Paths must not contain // in them."));
                        (_t = t).push.apply(_t, (0, $fLnyw._)(n.split("/").filter(function(e) {
                            return e.length > 0;
                        })));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new ResourcePath(t);
            }
        },
        {
            key: "emptyPath",
            value: function emptyPath() {
                return new ResourcePath([]);
            }
        }
    ]);
    return ResourcePath;
}($59fc9b849b320ded$var$BasePath);
var $59fc9b849b320ded$var$C = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ var $59fc9b849b320ded$export$b7871852b967eaf1 = /*#__PURE__*/ function(BasePath) {
    "use strict";
    (0, $ftJVG._)(FieldPath$1, BasePath);
    var _super = (0, $6OZAO._)(FieldPath$1);
    function FieldPath$1() {
        (0, $978gY._)(this, FieldPath$1);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(FieldPath$1, [
        {
            key: "construct",
            value: function construct(e, t, n) {
                return new FieldPath$1(e, t, n);
            }
        },
        {
            key: "canonicalString",
            value: function canonicalString() {
                return this.toArray().map(function(e) {
                    return e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), FieldPath$1.isValidIdentifier(e) || (e = "`" + e + "`"), e;
                }).join(".");
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.canonicalString();
            }
        },
        {
            /**
     * Returns true if this field references the key of a document.
     */ key: "isKeyField",
            value: function isKeyField() {
                return 1 === this.length && "__name__" === this.get(0);
            }
        }
    ], [
        {
            key: "isValidIdentifier",
            value: /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ function isValidIdentifier(e) {
                return $59fc9b849b320ded$var$C.test(e);
            }
        },
        {
            key: "keyField",
            value: /**
     * The field designating the key of a document.
     */ function keyField() {
                return new FieldPath$1([
                    "__name__"
                ]);
            }
        },
        {
            key: "fromServerFormat",
            value: /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ function fromServerFormat(e) {
                var t = [];
                var n = "", r = 0;
                var __PRIVATE_addCurrentSegment = function() {
                    if (0 === n.length) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid field path (".concat(e, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"));
                    t.push(n), n = "";
                };
                var i = !1;
                for(; r < e.length;){
                    var t1 = e[r];
                    if ("\\" === t1) {
                        if (r + 1 === e.length) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                        var t2 = e[r + 1];
                        if ("\\" !== t2 && "." !== t2 && "`" !== t2) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                        n += t2, r += 2;
                    } else "`" === t1 ? (i = !i, r++) : "." !== t1 || i ? (n += t1, r++) : (__PRIVATE_addCurrentSegment(), r++);
                }
                if (__PRIVATE_addCurrentSegment(), i) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
                return new FieldPath$1(t);
            }
        },
        {
            key: "emptyPath",
            value: function emptyPath() {
                return new FieldPath$1([]);
            }
        }
    ]);
    return FieldPath$1;
}($59fc9b849b320ded$var$BasePath);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ var $59fc9b849b320ded$export$afc2e57c475b7810 = /*#__PURE__*/ function() {
    "use strict";
    function DocumentKey(e) {
        (0, $978gY._)(this, DocumentKey);
        this.path = e;
    }
    (0, $kry2a._)(DocumentKey, [
        {
            key: "collectionGroup",
            get: function get() {
                return this.path.popLast().lastSegment();
            }
        },
        {
            /** Returns true if the document is in the specified collectionId. */ key: "hasCollectionId",
            value: function hasCollectionId(e) {
                return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
            }
        },
        {
            /** Returns the collection group (i.e. the name of the parent collection) for this key. */ key: "getCollectionGroup",
            value: function getCollectionGroup() {
                return this.path.get(this.path.length - 2);
            }
        },
        {
            /** Returns the fully qualified path to the parent collection. */ key: "getCollectionPath",
            value: function getCollectionPath() {
                return this.path.popLast();
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return null !== e && 0 === $59fc9b849b320ded$var$ResourcePath.comparator(this.path, e.path);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return this.path.toString();
            }
        }
    ], [
        {
            key: "fromPath",
            value: function fromPath(e) {
                return new DocumentKey($59fc9b849b320ded$var$ResourcePath.fromString(e));
            }
        },
        {
            key: "fromName",
            value: function fromName(e) {
                return new DocumentKey($59fc9b849b320ded$var$ResourcePath.fromString(e).popFirst(5));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new DocumentKey($59fc9b849b320ded$var$ResourcePath.emptyPath());
            }
        },
        {
            key: "comparator",
            value: function comparator(e, t) {
                return $59fc9b849b320ded$var$ResourcePath.comparator(e.path, t.path);
            }
        },
        {
            key: "isDocumentKey",
            value: function isDocumentKey(e) {
                return e.length % 2 == 0;
            }
        },
        {
            key: "fromSegments",
            value: /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ function fromSegments(e) {
                return new DocumentKey(new $59fc9b849b320ded$var$ResourcePath(e.slice()));
            }
        }
    ]);
    return DocumentKey;
}();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ var $59fc9b849b320ded$var$FieldIndex = function FieldIndex(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r) {
    "use strict";
    (0, $978gY._)(this, FieldIndex);
    this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
};
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find(function(e) {
        return 2 /* IndexKind.CONTAINS */  === e.kind;
    });
}
/** Returns all directional (ascending/descending) segments for this index. */ function $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter(function(e) {
        return 2 /* IndexKind.CONTAINS */  !== e.kind;
    });
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $59fc9b849b320ded$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(var r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $59fc9b849b320ded$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $59fc9b849b320ded$var$FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ var $59fc9b849b320ded$var$IndexSegment = function IndexSegment(/** The field path of the component. */ e, /** The fields sorting order. */ t) {
    "use strict";
    (0, $978gY._)(this, IndexSegment);
    this.fieldPath = e, this.kind = t;
};
function $59fc9b849b320ded$var$__PRIVATE_indexSegmentComparator(e, t) {
    var n = $59fc9b849b320ded$export$b7871852b967eaf1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ var $59fc9b849b320ded$var$IndexState = /*#__PURE__*/ function() {
    "use strict";
    function IndexState(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t) {
        (0, $978gY._)(this, IndexState);
        this.sequenceNumber = e, this.offset = t;
    }
    (0, $kry2a._)(IndexState, null, [
        {
            key: "empty",
            value: /** The state of an index that has not yet been backfilled. */ function empty() {
                return new IndexState(0, $59fc9b849b320ded$var$IndexOffset.min());
            }
        }
    ]);
    return IndexState;
}();
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $59fc9b849b320ded$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    var n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $59fc9b849b320ded$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $59fc9b849b320ded$export$d9bcbd5e1ff81430(n + 1, 0) : new $59fc9b849b320ded$export$d9bcbd5e1ff81430(n, r));
    return new $59fc9b849b320ded$var$IndexOffset(i, $59fc9b849b320ded$export$afc2e57c475b7810.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $59fc9b849b320ded$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $59fc9b849b320ded$var$IndexOffset(e.readTime, e.key, -1);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ var $59fc9b849b320ded$var$IndexOffset = /*#__PURE__*/ function() {
    "use strict";
    function IndexOffset(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n) {
        (0, $978gY._)(this, IndexOffset);
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    (0, $kry2a._)(IndexOffset, null, [
        {
            key: "min",
            value: /** Returns an offset that sorts before all regular offsets. */ function min() {
                return new IndexOffset($59fc9b849b320ded$var$SnapshotVersion.min(), $59fc9b849b320ded$export$afc2e57c475b7810.empty(), -1);
            }
        },
        {
            key: "max",
            value: /** Returns an offset that sorts after all regular offsets. */ function max() {
                return new IndexOffset($59fc9b849b320ded$var$SnapshotVersion.max(), $59fc9b849b320ded$export$afc2e57c475b7810.empty(), -1);
            }
        }
    ]);
    return IndexOffset;
}();
function $59fc9b849b320ded$var$__PRIVATE_indexOffsetComparator(e, t) {
    var n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $59fc9b849b320ded$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$v = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ var $59fc9b849b320ded$var$PersistenceTransaction = /*#__PURE__*/ function() {
    "use strict";
    function PersistenceTransaction() {
        (0, $978gY._)(this, PersistenceTransaction);
        this.onCommittedListeners = [];
    }
    (0, $kry2a._)(PersistenceTransaction, [
        {
            key: "addOnCommittedListener",
            value: function addOnCommittedListener(e) {
                this.onCommittedListeners.push(e);
            }
        },
        {
            key: "raiseOnCommittedEvent",
            value: function raiseOnCommittedEvent() {
                this.onCommittedListeners.forEach(function(e) {
                    return e();
                });
            }
        }
    ]);
    return PersistenceTransaction;
}();
function $59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    return $59fc9b849b320ded$var$___PRIVATE_ignoreIfPrimaryLeaseLoss.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_ignoreIfPrimaryLeaseLoss() {
    $59fc9b849b320ded$var$___PRIVATE_ignoreIfPrimaryLeaseLoss = /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            if (e.code !== $59fc9b849b320ded$var$D.FAILED_PRECONDITION || e.message !== $59fc9b849b320ded$var$v) throw e;
            $59fc9b849b320ded$var$__PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
            return [
                2
            ];
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_ignoreIfPrimaryLeaseLoss.apply(this, arguments);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ var $59fc9b849b320ded$var$PersistencePromise = /*#__PURE__*/ function() {
    "use strict";
    function PersistencePromise(e) {
        var _this = this;
        (0, $978gY._)(this, PersistencePromise);
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e(function(e) {
            _this.isDone = !0, _this.result = e, _this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            _this.nextCallback(e);
        }, function(e) {
            _this.isDone = !0, _this.error = e, _this.catchCallback && _this.catchCallback(e);
        });
    }
    (0, $kry2a._)(PersistencePromise, [
        {
            key: "catch",
            value: function _catch(e) {
                return this.next(void 0, e);
            }
        },
        {
            key: "next",
            value: function next(e, t) {
                var _this = this;
                return this.callbackAttached && $59fc9b849b320ded$var$fail(), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new PersistencePromise(function(n, r) {
                    _this.nextCallback = function(t) {
                        _this.wrapSuccess(e, t).next(n, r);
                    }, _this.catchCallback = function(e) {
                        _this.wrapFailure(t, e).next(n, r);
                    };
                });
            }
        },
        {
            key: "toPromise",
            value: function toPromise() {
                var _this = this;
                return new Promise(function(e, t) {
                    _this.next(e, t);
                });
            }
        },
        {
            key: "wrapUserFunction",
            value: function wrapUserFunction(e) {
                try {
                    var t = e();
                    return t instanceof PersistencePromise ? t : PersistencePromise.resolve(t);
                } catch (e) {
                    return PersistencePromise.reject(e);
                }
            }
        },
        {
            key: "wrapSuccess",
            value: function wrapSuccess(e, t) {
                return e ? this.wrapUserFunction(function() {
                    return e(t);
                }) : PersistencePromise.resolve(t);
            }
        },
        {
            key: "wrapFailure",
            value: function wrapFailure(e, t) {
                return e ? this.wrapUserFunction(function() {
                    return e(t);
                }) : PersistencePromise.reject(t);
            }
        }
    ], [
        {
            key: "resolve",
            value: function resolve(e) {
                return new PersistencePromise(function(t, n) {
                    t(e);
                });
            }
        },
        {
            key: "reject",
            value: function reject(e) {
                return new PersistencePromise(function(t, n) {
                    n(e);
                });
            }
        },
        {
            key: "waitFor",
            value: function waitFor(// Accept all Promise types in waitFor().
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            e) {
                return new PersistencePromise(function(t, n) {
                    var r = 0, i = 0, s = !1;
                    e.forEach(function(e) {
                        ++r, e.next(function() {
                            ++i, s && i === r && t();
                        }, function(e) {
                            return n(e);
                        });
                    }), s = !0, i === r && t();
                });
            }
        },
        {
            key: "or",
            value: /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ function or(e) {
                var t = PersistencePromise.resolve(!1);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var n = _step.value;
                        t = t.next(function(e) {
                            return e ? PersistencePromise.resolve(e) : n();
                        });
                    };
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return t;
            }
        },
        {
            key: "forEach",
            value: function forEach(e, t) {
                var _this = this;
                var n = [];
                return e.forEach(function(e, r) {
                    n.push(t.call(_this, e, r));
                }), this.waitFor(n);
            }
        },
        {
            key: "mapArray",
            value: /**
     * Concurrently map all array elements through asynchronous function.
     */ function mapArray(e, t) {
                return new PersistencePromise(function(n, r) {
                    var _loop = function(_) {
                        var a = _;
                        t(e[a]).next(function(e) {
                            s[a] = e, ++o, o === i && n(s);
                        }, function(e) {
                            return r(e);
                        });
                    };
                    var i = e.length, s = new Array(i);
                    var o = 0;
                    for(var _ = 0; _ < i; _++)_loop(_);
                });
            }
        },
        {
            key: "doWhile",
            value: /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ function doWhile(e, t) {
                return new PersistencePromise(function(n, r) {
                    var process = function() {
                        !0 === e() ? t().next(function() {
                            process();
                        }, r) : n();
                    };
                    process();
                });
            }
        }
    ]);
    return PersistencePromise;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by SimpleDb.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ var $59fc9b849b320ded$var$__PRIVATE_SimpleDbTransaction = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDbTransaction(e, t) {
        var _this = this;
        (0, $978gY._)(this, __PRIVATE_SimpleDbTransaction);
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.m = new $59fc9b849b320ded$var$__PRIVATE_Deferred, this.transaction.oncomplete = function() {
            _this.m.resolve();
        }, this.transaction.onabort = function() {
            t.error ? _this.m.reject(new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : _this.m.resolve();
        }, this.transaction.onerror = function(t) {
            var n = $59fc9b849b320ded$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            _this.m.reject(new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    (0, $kry2a._)(__PRIVATE_SimpleDbTransaction, [
        {
            key: "g",
            get: function get() {
                return this.m.promise;
            }
        },
        {
            key: "abort",
            value: function abort(e) {
                e && this.m.reject(e), this.aborted || ($59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
            }
        },
        {
            key: "p",
            value: function p() {
                // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
                // speed up index DB processing if the event loop remains blocks.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var e = this.transaction;
                this.aborted || "function" != typeof e.commit || e.commit();
            }
        },
        {
            /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ key: "store",
            value: function store(e) {
                var t = this.transaction.objectStore(e);
                return new $59fc9b849b320ded$var$__PRIVATE_SimpleDbStore(t);
            }
        }
    ], [
        {
            key: "open",
            value: function open(e, t, n, r) {
                try {
                    return new __PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
                } catch (e) {
                    throw new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransactionError(t, e);
                }
            }
        }
    ]);
    return __PRIVATE_SimpleDbTransaction;
}();
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ var $59fc9b849b320ded$var$__PRIVATE_SimpleDb = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDb(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_SimpleDb);
        this.name = e, this.version = t, this.S = n;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === __PRIVATE_SimpleDb.D((0, $b1467a785fc7cec5$export$c36915b22ce77c19)()) && $59fc9b849b320ded$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    (0, $kry2a._)(__PRIVATE_SimpleDb, [
        {
            key: "N",
            value: /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ function N(e) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.db;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "Opening database:", _this.name);
                                return [
                                    4,
                                    new Promise(function(t, n) {
                                        // TODO(mikelehen): Investigate browser compatibility.
                                        // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
                                        // suggests IE9 and older WebKit browsers handle upgrade
                                        // differently. They expect setVersion, as described here:
                                        // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
                                        var r = indexedDB.open(_this.name, _this.version);
                                        r.onsuccess = function(e) {
                                            var n = e.target.result;
                                            t(n);
                                        }, r.onblocked = function() {
                                            n(new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
                                        }, r.onerror = function(t) {
                                            var r = t.target.error;
                                            "VersionError" === r.name ? n(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransactionError(e, r));
                                        }, r.onupgradeneeded = function(e) {
                                            $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", 'Database "' + _this.name + '" requires upgrade from version:', e.oldVersion);
                                            var t = e.target.result;
                                            _this.S.B(t, r.transaction, e.oldVersion, _this.version).next(function() {
                                                $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "Database upgrade to version " + _this.version + " complete");
                                            });
                                        };
                                    })
                                ];
                            case 1:
                                _tmp = _this.db = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (_tmp, _this.L && (_this.db.onversionchange = function(e) {
                                        return _this.L(e);
                                    }), _this.db)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "k",
            value: function k(e) {
                this.L = e, this.db && (this.db.onversionchange = function(t) {
                    return e(t);
                });
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n, r) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _loop, i, s, _ret;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _loop = function() {
                                    var _$t, s1, _tmp, e1, _$t1, _$n;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                ++s;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    4,
                                                    ,
                                                    5
                                                ]);
                                                return [
                                                    4,
                                                    _this.N(e)
                                                ];
                                            case 2:
                                                _this.db = _state.sent();
                                                _$t = $59fc9b849b320ded$var$__PRIVATE_SimpleDbTransaction.open(_this.db, e, i ? "readonly" : "readwrite", n), s1 = r(_$t).next(function(e) {
                                                    return _$t.p(), e;
                                                }).catch(function(e) {
                                                    return(// Abort the transaction if there was an error.
                                                    _$t.abort(e), $59fc9b849b320ded$var$PersistencePromise.reject(e));
                                                }).toPromise();
                                                _tmp = {};
                                                s1.catch(function() {});
                                                // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                                                // fire), but still return the original transactionFnResult back to the
                                                // caller.
                                                return [
                                                    4,
                                                    _$t.g
                                                ];
                                            case 3:
                                                // As noted above, errors are propagated by aborting the transaction. So
                                                // we swallow any error here to avoid the browser logging it as unhandled.
                                                return [
                                                    2,
                                                    (_tmp.v = (_state.sent(), s1), _tmp)
                                                ];
                                            case 4:
                                                e1 = _state.sent();
                                                _$t1 = e1, _$n = "FirebaseError" !== _$t1.name && s < 3;
                                                // TODO(schmidt-sebastian): We could probably be smarter about this and
                                                // not retry exceptions that are likely unrecoverable (such as quota
                                                // exceeded errors).
                                                // Note: We cannot use an instanceof check for FirestoreException, since the
                                                // exception is wrapped in a generic error by our async/await handling.
                                                if ($59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "Transaction failed with error:", _$t1.message, "Retrying:", _$n), _this.close(), !_$n) return [
                                                    2,
                                                    {
                                                        v: Promise.reject(_$t1)
                                                    }
                                                ];
                                                return [
                                                    3,
                                                    5
                                                ];
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                i = "readonly" === t;
                                s = 0;
                                _state.label = 1;
                            case 1:
                                return [
                                    5,
                                    (0, $7UAGh.__values)(_loop())
                                ];
                            case 2:
                                _ret = _state.sent();
                                if ((0, $1ObTH._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "close",
            value: function close() {
                this.db && this.db.close(), this.db = void 0;
            }
        }
    ], [
        {
            key: "delete",
            value: /** Deletes the specified database. */ function _delete(e) {
                return $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "Removing database:", e), $59fc9b849b320ded$var$__PRIVATE_wrapRequest(window.indexedDB.deleteDatabase(e)).toPromise();
            }
        },
        {
            key: "C",
            value: /** Returns true if IndexedDB is available in the current environment. */ function C() {
                if (!(0, $b1467a785fc7cec5$export$3865db50535c2055)()) return !1;
                if (__PRIVATE_SimpleDb.v()) return !0;
                // We extensively use indexed array values and compound keys,
                // which IE and Edge do not support. However, they still have indexedDB
                // defined on the window, so we need to check for them here and make sure
                // to return that persistence is not enabled for those browsers.
                // For tracking support of this feature, see here:
                // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
                // Check the UA string to find out the browser.
                var e = (0, $b1467a785fc7cec5$export$c36915b22ce77c19)(), t = __PRIVATE_SimpleDb.D(e), n = 0 < t && t < 10, r = __PRIVATE_SimpleDb.F(e), i = 0 < r && r < 4.5;
                // IE 10
                // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
                // IE 11
                // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
                // Edge
                // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
                // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
                // iOS Safari: Disable for users running iOS version < 10.
                return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
            }
        },
        {
            key: "v",
            value: /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ function v() {
                var e;
                return "undefined" != typeof $a8i8g && "YES" === ((e = {}, void 0 === e) ? void 0 : e.M);
            }
        },
        {
            key: "O",
            value: /** Helper to get a typed SimpleDbStore from a transaction. */ function O(e, t) {
                return e.store(t);
            }
        },
        {
            key: "D",
            value: // visible for testing
            /** Parse User Agent to determine iOS version. Returns -1 if not found. */ function D(e) {
                var t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
                return Number(n);
            }
        },
        {
            key: "F",
            value: // visible for testing
            /** Parse User Agent to determine Android version. Returns -1 if not found. */ function F(e) {
                var t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
                return Number(n);
            }
        }
    ]);
    return __PRIVATE_SimpleDb;
}();
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ var $59fc9b849b320ded$var$__PRIVATE_IterationController = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IterationController(e) {
        (0, $978gY._)(this, __PRIVATE_IterationController);
        this.q = e, this.K = !1, this.$ = null;
    }
    (0, $kry2a._)(__PRIVATE_IterationController, [
        {
            key: "isDone",
            get: function get() {
                return this.K;
            }
        },
        {
            key: "U",
            get: function get() {
                return this.$;
            }
        },
        {
            key: "cursor",
            set: function set(e) {
                this.q = e;
            }
        },
        {
            /**
     * This function can be called to stop iteration at any point.
     */ key: "done",
            value: function done() {
                this.K = !0;
            }
        },
        {
            /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ key: "W",
            value: function W(e) {
                this.$ = e;
            }
        },
        {
            /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ key: "delete",
            value: function _delete() {
                return $59fc9b849b320ded$var$__PRIVATE_wrapRequest(this.q.delete());
            }
        }
    ]);
    return __PRIVATE_IterationController;
}();
/** An error that wraps exceptions that thrown during IndexedDB execution. */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransactionError = /*#__PURE__*/ function(FirestoreError) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_IndexedDbTransactionError, FirestoreError);
    var _super = (0, $6OZAO._)(__PRIVATE_IndexedDbTransactionError);
    function __PRIVATE_IndexedDbTransactionError(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbTransactionError);
        var _this;
        _this = _super.call(this, $59fc9b849b320ded$var$D.UNAVAILABLE, "IndexedDB transaction '".concat(e, "' failed: ").concat(t)), _this.name = "IndexedDbTransactionError";
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_IndexedDbTransactionError;
}($59fc9b849b320ded$export$8fada0bf726bf278);
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ var $59fc9b849b320ded$var$__PRIVATE_SimpleDbStore = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SimpleDbStore(e) {
        (0, $978gY._)(this, __PRIVATE_SimpleDbStore);
        this.store = e;
    }
    (0, $kry2a._)(__PRIVATE_SimpleDbStore, [
        {
            key: "put",
            value: function put(e, t) {
                var n;
                return void 0 !== t ? ($59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $59fc9b849b320ded$var$__PRIVATE_wrapRequest(n);
            }
        },
        {
            /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ key: "add",
            value: function add(e) {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "ADD", this.store.name, e, e);
                return $59fc9b849b320ded$var$__PRIVATE_wrapRequest(this.store.add(e));
            }
        },
        {
            /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                // We're doing an unsafe cast to ValueType.
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return $59fc9b849b320ded$var$__PRIVATE_wrapRequest(this.store.get(e)).next(function(t) {
                    return(// Normalize nonexistence to null.
                    void 0 === t && (t = null), $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "GET", _this.store.name, e, t), t);
                });
            }
        },
        {
            key: "delete",
            value: function _delete(e) {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "DELETE", this.store.name, e);
                return $59fc9b849b320ded$var$__PRIVATE_wrapRequest(this.store.delete(e));
            }
        },
        {
            /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ key: "count",
            value: function count() {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "COUNT", this.store.name);
                return $59fc9b849b320ded$var$__PRIVATE_wrapRequest(this.store.count());
            }
        },
        {
            key: "G",
            value: function G(e, t) {
                var n = this.options(e, t);
                // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
                // 20% faster. Unfortunately, getAll() does not support custom indices.
                if (n.index || "function" != typeof this.store.getAll) {
                    var _$e = this.cursor(n), _$t = [];
                    return this.j(_$e, function(e, n) {
                        _$t.push(n);
                    }).next(function() {
                        return _$t;
                    });
                }
                {
                    var _$e1 = this.store.getAll(n.range);
                    return new $59fc9b849b320ded$var$PersistencePromise(function(t, n) {
                        _$e1.onerror = function(e) {
                            n(e.target.error);
                        }, _$e1.onsuccess = function(e) {
                            t(e.target.result);
                        };
                    });
                }
            }
        },
        {
            /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ key: "H",
            value: function H(e, t) {
                var n = this.store.getAll(e, null === t ? void 0 : t);
                return new $59fc9b849b320ded$var$PersistencePromise(function(e, t) {
                    n.onerror = function(e) {
                        t(e.target.error);
                    }, n.onsuccess = function(t) {
                        e(t.target.result);
                    };
                });
            }
        },
        {
            key: "J",
            value: function J(e, t) {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("SimpleDb", "DELETE ALL", this.store.name);
                var n = this.options(e, t);
                n.Y = !1;
                var r = this.cursor(n);
                return this.j(r, function(e, t, n) {
                    return n.delete();
                });
            }
        },
        {
            key: "Z",
            value: function Z(e, t) {
                var n;
                t ? n = e : (n = {}, t = e);
                var r = this.cursor(n);
                return this.j(r, t);
            }
        },
        {
            /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ key: "X",
            value: function X(e) {
                var t = this.cursor({});
                return new $59fc9b849b320ded$var$PersistencePromise(function(n, r) {
                    t.onerror = function(e) {
                        var t = $59fc9b849b320ded$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                        r(t);
                    }, t.onsuccess = function(t) {
                        var r = t.target.result;
                        r ? e(r.primaryKey, r.value).next(function(e) {
                            e ? r.continue() : n();
                        }) : n();
                    };
                });
            }
        },
        {
            key: "j",
            value: function j(e, t) {
                var n = [];
                return new $59fc9b849b320ded$var$PersistencePromise(function(r, i) {
                    e.onerror = function(e) {
                        i(e.target.error);
                    }, e.onsuccess = function(e) {
                        var i = e.target.result;
                        if (!i) return void r();
                        var s = new $59fc9b849b320ded$var$__PRIVATE_IterationController(i), o = t(i.primaryKey, i.value, s);
                        if (o instanceof $59fc9b849b320ded$var$PersistencePromise) {
                            var _$e = o.catch(function(e) {
                                return s.done(), $59fc9b849b320ded$var$PersistencePromise.reject(e);
                            });
                            n.push(_$e);
                        }
                        s.isDone ? r() : null === s.U ? i.continue() : i.continue(s.U);
                    };
                }).next(function() {
                    return $59fc9b849b320ded$var$PersistencePromise.waitFor(n);
                });
            }
        },
        {
            key: "options",
            value: function options(e, t) {
                var n;
                return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
                    index: n,
                    range: t
                };
            }
        },
        {
            key: "cursor",
            value: function cursor(e) {
                var t = "next";
                if (e.reverse && (t = "prev"), e.index) {
                    var n = this.store.index(e.index);
                    return e.Y ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
                }
                return this.store.openCursor(e.range, t);
            }
        }
    ]);
    return __PRIVATE_SimpleDbStore;
}();
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $59fc9b849b320ded$var$__PRIVATE_wrapRequest(e) {
    return new $59fc9b849b320ded$var$PersistencePromise(function(t, n) {
        e.onsuccess = function(e) {
            var n = e.target.result;
            t(n);
        }, e.onerror = function(e) {
            var t = $59fc9b849b320ded$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
var $59fc9b849b320ded$var$F = !1;
function $59fc9b849b320ded$var$__PRIVATE_checkForAndReportiOSError(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_SimpleDb.D((0, $b1467a785fc7cec5$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        var t1 = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t1) >= 0) {
            // Wrap error in a more descriptive one.
            var _$e = new $59fc9b849b320ded$export$8fada0bf726bf278("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '".concat(t1, "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround."));
            return $59fc9b849b320ded$var$F || ($59fc9b849b320ded$var$F = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(function() {
                throw _$e;
            }, 0)), _$e;
        }
    }
    return e;
}
/** This class is responsible for the scheduling of Index Backfiller. */ var $59fc9b849b320ded$var$__PRIVATE_IndexBackfillerScheduler = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexBackfillerScheduler(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexBackfillerScheduler);
        this.asyncQueue = e, this.ee = t, this.task = null;
    }
    (0, $kry2a._)(__PRIVATE_IndexBackfillerScheduler, [
        {
            key: "start",
            value: function start() {
                this.te(15e3);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.task && (this.task.cancel(), this.task = null);
            }
        },
        {
            key: "started",
            get: function get() {
                return null !== this.task;
            }
        },
        {
            key: "te",
            value: function te(e) {
                var _this = this;
                $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexBackiller", "Scheduled in ".concat(e, "ms")), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, /*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _tmp, _, _1, e, _tmp1;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.task = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    7
                                ]);
                                _tmp = [
                                    "IndexBackiller"
                                ];
                                _1 = (_ = "Documents written: ").concat;
                                return [
                                    4,
                                    _this.ee.ne()
                                ];
                            case 2:
                                $59fc9b849b320ded$var$__PRIVATE_logDebug.apply(void 0, _tmp.concat([
                                    _1.apply(_, [
                                        _state.sent()
                                    ])
                                ]));
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                e = _state.sent();
                                if (!$59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e)) return [
                                    3,
                                    4
                                ];
                                _tmp1 = $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexBackiller", "Ignoring IndexedDB error during index backfill: ", e);
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    $59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e)
                                ];
                            case 5:
                                _tmp1 = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp1;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    4,
                                    _this.te(6e4)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        }
    ]);
    return __PRIVATE_IndexBackfillerScheduler;
}();
/** Implements the steps for backfilling indexes. */ var $59fc9b849b320ded$var$__PRIVATE_IndexBackfiller = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexBackfiller(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexBackfiller);
        this.localStore = e, this.persistence = t;
    }
    (0, $kry2a._)(__PRIVATE_IndexBackfiller, [
        {
            key: "ne",
            value: function ne() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 50;
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", function(t) {
                                return _this.re(t, e);
                            })
                        ];
                    });
                })();
            }
        },
        {
            /** Writes index entries until the cap is reached. Returns the number of documents processed. */ key: "re",
            value: function re(e, t) {
                var _this = this;
                var n = new Set;
                var r = t, i = !0;
                return $59fc9b849b320ded$var$PersistencePromise.doWhile(function() {
                    return !0 === i && r > 0;
                }, function() {
                    return _this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next(function(t) {
                        if (null !== t && !n.has(t)) return $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexBackiller", "Processing collection: ".concat(t)), _this.ie(e, t, r).next(function(e) {
                            r -= e, n.add(t);
                        });
                        i = !1;
                    });
                }).next(function() {
                    return t - r;
                });
            }
        },
        {
            /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ key: "ie",
            value: function ie(e, t, n) {
                var _this = this;
                // Use the earliest offset of all field indexes to query the local cache.
                return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next(function(r) {
                    return _this.localStore.localDocuments.getNextDocuments(e, t, r, n).next(function(n) {
                        var i = n.changes;
                        return _this.localStore.indexManager.updateIndexEntries(e, i).next(function() {
                            return _this.se(r, n);
                        }).next(function(n) {
                            return $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexBackiller", "Updating offset: ".concat(n)), _this.localStore.indexManager.updateCollectionGroup(e, t, n);
                        }).next(function() {
                            return i.size;
                        });
                    });
                });
            }
        },
        {
            /** Returns the next offset based on the provided documents. */ key: "se",
            value: function se(e, t) {
                var n = e;
                return t.changes.forEach(function(e, t) {
                    var r = $59fc9b849b320ded$var$__PRIVATE_newIndexOffsetFromDocument(t);
                    $59fc9b849b320ded$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
                }), new $59fc9b849b320ded$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
            }
        }
    ]);
    return __PRIVATE_IndexBackfiller;
}();
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ var $59fc9b849b320ded$var$__PRIVATE_ListenSequence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ListenSequence(e, t) {
        var _this = this;
        (0, $978gY._)(this, __PRIVATE_ListenSequence);
        this.previousValue = e, t && (t.sequenceNumberHandler = function(e) {
            return _this.oe(e);
        }, this._e = function(e) {
            return t.writeSequenceNumber(e);
        });
    }
    (0, $kry2a._)(__PRIVATE_ListenSequence, [
        {
            key: "oe",
            value: function oe(e) {
                return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
            }
        },
        {
            key: "next",
            value: function next() {
                var e = ++this.previousValue;
                return this._e && this._e(e), e;
            }
        }
    ]);
    return __PRIVATE_ListenSequence;
}();
$59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $59fc9b849b320ded$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $59fc9b849b320ded$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $59fc9b849b320ded$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$59fc9b849b320ded$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(e) {
    var t = "";
    for(var n = 0; n < e.length; n++)t.length > 0 && (t = $59fc9b849b320ded$var$__PRIVATE_encodeSeparator(t)), t = $59fc9b849b320ded$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $59fc9b849b320ded$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $59fc9b849b320ded$var$__PRIVATE_encodeSegment(e, t) {
    var n = t;
    var r = e.length;
    for(var _$t = 0; _$t < r; _$t++){
        var r1 = e.charAt(_$t);
        switch(r1){
            case "\x00":
                n += "\x01\x10";
                break;
            case "\x01":
                n += "\x01\x11";
                break;
            default:
                n += r1;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $59fc9b849b320ded$var$__PRIVATE_encodeSeparator(e) {
    return e + "\x01\x01";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    var t = e.length;
    if ($59fc9b849b320ded$var$__PRIVATE_hardAssert(t >= 2), 2 === t) return $59fc9b849b320ded$var$__PRIVATE_hardAssert("\x01" === e.charAt(0) && "\x01" === e.charAt(1)), $59fc9b849b320ded$var$ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    var __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    var r = "";
    for(var i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        var t1 = e.indexOf("\x01", i);
        (t1 < 0 || t1 > __PRIVATE_lastReasonableEscapeIndex) && $59fc9b849b320ded$var$fail();
        switch(e.charAt(t1 + 1)){
            case "\x01":
                var s = e.substring(i, t1);
                var o = void 0;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                o = s : (r += s, o = r, r = ""), n.push(o);
                break;
            case "\x10":
                r += e.substring(i, t1), r += "\x00";
                break;
            case "\x11":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t1 + 1);
                break;
            default:
                $59fc9b849b320ded$var$fail();
        }
        i = t1 + 2;
    }
    return new $59fc9b849b320ded$var$ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$M = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ var $59fc9b849b320ded$var$x = {}, $59fc9b849b320ded$var$O = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $59fc9b849b320ded$var$N = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $59fc9b849b320ded$var$B = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $59fc9b849b320ded$var$L = [
    "canonicalId",
    "targetId"
], $59fc9b849b320ded$var$k = [
    "targetId",
    "path"
], $59fc9b849b320ded$var$q = [
    "path",
    "targetId"
], $59fc9b849b320ded$var$Q = [
    "collectionId",
    "parent"
], $59fc9b849b320ded$var$K = [
    "indexId",
    "uid"
], $59fc9b849b320ded$var$$ = [
    "uid",
    "sequenceNumber"
], $59fc9b849b320ded$var$U = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $59fc9b849b320ded$var$W = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $59fc9b849b320ded$var$G = [
    "userId",
    "collectionPath",
    "documentId"
], $59fc9b849b320ded$var$z = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $59fc9b849b320ded$var$j = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $59fc9b849b320ded$var$H = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocuments",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries"
], $59fc9b849b320ded$var$J = (0, $fLnyw._)($59fc9b849b320ded$var$H).concat([
    "documentOverlays"
]), $59fc9b849b320ded$var$Y = [
    "mutationQueues",
    "mutations",
    "documentMutations",
    "remoteDocumentsV14",
    "targets",
    "owner",
    "targetGlobal",
    "targetDocuments",
    "clientMetadata",
    "remoteDocumentGlobal",
    "collectionParents",
    "bundles",
    "namedQueries",
    "documentOverlays"
], $59fc9b849b320ded$var$Z = $59fc9b849b320ded$var$Y, $59fc9b849b320ded$var$X = (0, $fLnyw._)($59fc9b849b320ded$var$Z).concat([
    "indexConfiguration",
    "indexState",
    "indexEntries"
]);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransaction = /*#__PURE__*/ function(PersistenceTransaction) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_IndexedDbTransaction, PersistenceTransaction);
    var _super = (0, $6OZAO._)(__PRIVATE_IndexedDbTransaction);
    function __PRIVATE_IndexedDbTransaction(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbTransaction);
        var _this;
        _this = _super.call(this), _this.ue = e, _this.currentSequenceNumber = t;
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_IndexedDbTransaction;
}($59fc9b849b320ded$var$PersistenceTransaction);
function $59fc9b849b320ded$var$__PRIVATE_getStore(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return $59fc9b849b320ded$var$__PRIVATE_SimpleDb.O(n.ue, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fc9b849b320ded$var$__PRIVATE_objectSize(e) {
    var t = 0;
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $59fc9b849b320ded$var$forEach(e, t) {
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $59fc9b849b320ded$var$isEmpty(e) {
    for(var t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
var $59fc9b849b320ded$var$SortedMap = /*#__PURE__*/ function() {
    "use strict";
    function SortedMap(e, t) {
        (0, $978gY._)(this, SortedMap);
        this.comparator = e, this.root = t || $59fc9b849b320ded$var$LLRBNode.EMPTY;
    }
    (0, $kry2a._)(SortedMap, [
        {
            // Returns a copy of the map, with the specified key/value added or replaced.
            key: "insert",
            value: function insert(e, t) {
                return new SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $59fc9b849b320ded$var$LLRBNode.BLACK, null, null));
            }
        },
        {
            // Returns a copy of the map, with the specified key removed.
            key: "remove",
            value: function remove(e) {
                return new SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $59fc9b849b320ded$var$LLRBNode.BLACK, null, null));
            }
        },
        {
            // Returns the value of the node with the given key, or null.
            key: "get",
            value: function get(e) {
                var t = this.root;
                for(; !t.isEmpty();){
                    var n = this.comparator(e, t.key);
                    if (0 === n) return t.value;
                    n < 0 ? t = t.left : n > 0 && (t = t.right);
                }
                return null;
            }
        },
        {
            // Returns the index of the element in this sorted map, or -1 if it doesn't
            // exist.
            key: "indexOf",
            value: function indexOf(e) {
                // Number of nodes that were pruned when descending right
                var t = 0, n = this.root;
                for(; !n.isEmpty();){
                    var r = this.comparator(e, n.key);
                    if (0 === r) return t + n.left.size;
                    r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
                    (t += n.left.size + 1, n = n.right);
                }
                // Node not found
                return -1;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.root.isEmpty();
            }
        },
        {
            key: "size",
            get: // Returns the total number of nodes in the map.
            function get() {
                return this.root.size;
            }
        },
        {
            // Returns the minimum key in the map.
            key: "minKey",
            value: function minKey() {
                return this.root.minKey();
            }
        },
        {
            // Returns the maximum key in the map.
            key: "maxKey",
            value: function maxKey() {
                return this.root.maxKey();
            }
        },
        {
            // Traverses the map in key order and calls the specified action function
            // for each key/value pair. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return this.root.inorderTraversal(e);
            }
        },
        {
            key: "forEach",
            value: function forEach(e) {
                this.inorderTraversal(function(t, n) {
                    return e(t, n), !1;
                });
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.inorderTraversal(function(t, n) {
                    return e.push("".concat(t, ":").concat(n)), !1;
                }), "{".concat(e.join(", "), "}");
            }
        },
        {
            // Traverses the map in reverse key order and calls the specified action
            // function for each key/value pair. If action returns true, traversal is
            // aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return this.root.reverseTraversal(e);
            }
        },
        {
            // Returns an iterator over the SortedMap.
            key: "getIterator",
            value: function getIterator() {
                return new $59fc9b849b320ded$var$SortedMapIterator(this.root, null, this.comparator, !1);
            }
        },
        {
            key: "getIteratorFrom",
            value: function getIteratorFrom(e) {
                return new $59fc9b849b320ded$var$SortedMapIterator(this.root, e, this.comparator, !1);
            }
        },
        {
            key: "getReverseIterator",
            value: function getReverseIterator() {
                return new $59fc9b849b320ded$var$SortedMapIterator(this.root, null, this.comparator, !0);
            }
        },
        {
            key: "getReverseIteratorFrom",
            value: function getReverseIteratorFrom(e) {
                return new $59fc9b849b320ded$var$SortedMapIterator(this.root, e, this.comparator, !0);
            }
        }
    ]);
    return SortedMap;
}();
// end SortedMap
// An iterator over an LLRBNode.
var $59fc9b849b320ded$var$SortedMapIterator = /*#__PURE__*/ function() {
    "use strict";
    function SortedMapIterator(e, t, n, r) {
        (0, $978gY._)(this, SortedMapIterator);
        this.isReverse = r, this.nodeStack = [];
        var i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    (0, $kry2a._)(SortedMapIterator, [
        {
            key: "getNext",
            value: function getNext() {
                var e = this.nodeStack.pop();
                var t = {
                    key: e.key,
                    value: e.value
                };
                if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
                else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
                return t;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.nodeStack.length > 0;
            }
        },
        {
            key: "peek",
            value: function peek() {
                if (0 === this.nodeStack.length) return null;
                var e = this.nodeStack[this.nodeStack.length - 1];
                return {
                    key: e.key,
                    value: e.value
                };
            }
        }
    ]);
    return SortedMapIterator;
}();
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
var $59fc9b849b320ded$var$LLRBNode = /*#__PURE__*/ function() {
    "use strict";
    function LLRBNode(e, t, n, r, i) {
        (0, $978gY._)(this, LLRBNode);
        this.key = e, this.value = t, this.color = null != n ? n : LLRBNode.RED, this.left = null != r ? r : LLRBNode.EMPTY, this.right = null != i ? i : LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    (0, $kry2a._)(LLRBNode, [
        {
            // Returns a copy of the current node, optionally replacing pieces of it.
            key: "copy",
            value: function copy(e, t, n, r, i) {
                return new LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return !1;
            }
        },
        {
            // Traverses the tree in key order and calls the specified action function
            // for each node. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
            }
        },
        {
            // Traverses the tree in reverse key order and calls the specified action
            // function for each node. If action returns true, traversal is aborted.
            // Returns the first truthy value returned by action, or the last falsey
            // value returned by action.
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
            }
        },
        {
            // Returns the minimum node in the tree.
            key: "min",
            value: function min() {
                return this.left.isEmpty() ? this : this.left.min();
            }
        },
        {
            // Returns the maximum key in the tree.
            key: "minKey",
            value: function minKey() {
                return this.min().key;
            }
        },
        {
            // Returns the maximum key in the tree.
            key: "maxKey",
            value: function maxKey() {
                return this.right.isEmpty() ? this.key : this.right.maxKey();
            }
        },
        {
            // Returns new tree, with the key/value added.
            key: "insert",
            value: function insert(e, t, n) {
                var r = this;
                var i = n(e, r.key);
                return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
            }
        },
        {
            key: "removeMin",
            value: function removeMin() {
                if (this.left.isEmpty()) return LLRBNode.EMPTY;
                var e = this;
                return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
            }
        },
        {
            // Returns new tree, with the specified item removed.
            key: "remove",
            value: function remove(e, t) {
                var n, r = this;
                if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
                else {
                    if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                        if (r.right.isEmpty()) return LLRBNode.EMPTY;
                        n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
                    }
                    r = r.copy(null, null, null, null, r.right.remove(e, t));
                }
                return r.fixUp();
            }
        },
        {
            key: "isRed",
            value: function isRed() {
                return this.color;
            }
        },
        {
            // Returns new tree after performing any needed rotations.
            key: "fixUp",
            value: function fixUp() {
                var e = this;
                return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
            }
        },
        {
            key: "moveRedLeft",
            value: function moveRedLeft() {
                var e = this.colorFlip();
                return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
            }
        },
        {
            key: "moveRedRight",
            value: function moveRedRight() {
                var e = this.colorFlip();
                return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
            }
        },
        {
            key: "rotateLeft",
            value: function rotateLeft() {
                var e = this.copy(null, null, LLRBNode.RED, null, this.right.left);
                return this.right.copy(null, null, this.color, e, null);
            }
        },
        {
            key: "rotateRight",
            value: function rotateRight() {
                var e = this.copy(null, null, LLRBNode.RED, this.left.right, null);
                return this.left.copy(null, null, this.color, null, e);
            }
        },
        {
            key: "colorFlip",
            value: function colorFlip() {
                var e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
                return this.copy(null, null, !this.color, e, t);
            }
        },
        {
            // For testing.
            key: "checkMaxDepth",
            value: function checkMaxDepth() {
                var e = this.check();
                return Math.pow(2, e) <= this.size + 1;
            }
        },
        {
            // In a balanced RB tree, the black-depth (number of black nodes) from root to
            // leaves is equal on both sides.  This function verifies that or asserts.
            key: "check",
            value: function check() {
                if (this.isRed() && this.left.isRed()) throw $59fc9b849b320ded$var$fail();
                if (this.right.isRed()) throw $59fc9b849b320ded$var$fail();
                var e = this.left.check();
                if (e !== this.right.check()) throw $59fc9b849b320ded$var$fail();
                return e + (this.isRed() ? 0 : 1);
            }
        }
    ]);
    return LLRBNode;
}();
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$59fc9b849b320ded$var$LLRBNode.EMPTY = null, $59fc9b849b320ded$var$LLRBNode.RED = !0, $59fc9b849b320ded$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$59fc9b849b320ded$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
/*#__PURE__*/ (function() {
    "use strict";
    function LLRBEmptyNode() {
        (0, $978gY._)(this, LLRBEmptyNode);
        this.size = 0;
    }
    (0, $kry2a._)(LLRBEmptyNode, [
        {
            key: "key",
            get: function get() {
                throw $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "value",
            get: function get() {
                throw $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "color",
            get: function get() {
                throw $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "left",
            get: function get() {
                throw $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "right",
            get: function get() {
                throw $59fc9b849b320ded$var$fail();
            }
        },
        {
            // Returns a copy of the current node.
            key: "copy",
            value: function copy(e, t, n, r, i) {
                return this;
            }
        },
        {
            // Returns a copy of the tree, with the specified key/value added.
            key: "insert",
            value: function insert(e, t, n) {
                return new $59fc9b849b320ded$var$LLRBNode(e, t);
            }
        },
        {
            // Returns a copy of the tree, with the specified key removed.
            key: "remove",
            value: function remove(e, t) {
                return this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return !0;
            }
        },
        {
            key: "inorderTraversal",
            value: function inorderTraversal(e) {
                return !1;
            }
        },
        {
            key: "reverseTraversal",
            value: function reverseTraversal(e) {
                return !1;
            }
        },
        {
            key: "minKey",
            value: function minKey() {
                return null;
            }
        },
        {
            key: "maxKey",
            value: function maxKey() {
                return null;
            }
        },
        {
            key: "isRed",
            value: function isRed() {
                return !1;
            }
        },
        {
            // For testing.
            key: "checkMaxDepth",
            value: function checkMaxDepth() {
                return !0;
            }
        },
        {
            key: "check",
            value: function check() {
                return 0;
            }
        }
    ]);
    return LLRBEmptyNode;
}());
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ var $59fc9b849b320ded$var$SortedSet = /*#__PURE__*/ function() {
    "use strict";
    function SortedSet(e) {
        (0, $978gY._)(this, SortedSet);
        this.comparator = e, this.data = new $59fc9b849b320ded$var$SortedMap(this.comparator);
    }
    (0, $kry2a._)(SortedSet, [
        {
            key: "has",
            value: function has(e) {
                return null !== this.data.get(e);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.data.minKey();
            }
        },
        {
            key: "last",
            value: function last() {
                return this.data.maxKey();
            }
        },
        {
            key: "size",
            get: function get() {
                return this.data.size;
            }
        },
        {
            key: "indexOf",
            value: function indexOf(e) {
                return this.data.indexOf(e);
            }
        },
        {
            /** Iterates elements in order defined by "comparator" */ key: "forEach",
            value: function forEach(e) {
                this.data.inorderTraversal(function(t, n) {
                    return e(t), !1;
                });
            }
        },
        {
            /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ key: "forEachInRange",
            value: function forEachInRange(e, t) {
                var n = this.data.getIteratorFrom(e[0]);
                for(; n.hasNext();){
                    var r = n.getNext();
                    if (this.comparator(r.key, e[1]) >= 0) return;
                    t(r.key);
                }
            }
        },
        {
            /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ key: "forEachWhile",
            value: function forEachWhile(e, t) {
                var n;
                for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
                    if (!e(n.getNext().key)) return;
                }
            }
        },
        {
            /** Finds the least element greater than or equal to `elem`. */ key: "firstAfterOrEqual",
            value: function firstAfterOrEqual(e) {
                var t = this.data.getIteratorFrom(e);
                return t.hasNext() ? t.getNext().key : null;
            }
        },
        {
            key: "getIterator",
            value: function getIterator() {
                return new $59fc9b849b320ded$var$SortedSetIterator(this.data.getIterator());
            }
        },
        {
            key: "getIteratorFrom",
            value: function getIteratorFrom(e) {
                return new $59fc9b849b320ded$var$SortedSetIterator(this.data.getIteratorFrom(e));
            }
        },
        {
            /** Inserts or updates an element */ key: "add",
            value: function add(e) {
                return this.copy(this.data.remove(e).insert(e, !0));
            }
        },
        {
            /** Deletes an element */ key: "delete",
            value: function _delete(e) {
                return this.has(e) ? this.copy(this.data.remove(e)) : this;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.data.isEmpty();
            }
        },
        {
            key: "unionWith",
            value: function unionWith(e) {
                var t = this;
                // Make sure `result` always refers to the larger one of the two sets.
                return t.size < e.size && (t = e, e = this), e.forEach(function(e) {
                    t = t.add(e);
                }), t;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(e instanceof SortedSet)) return !1;
                if (this.size !== e.size) return !1;
                var t = this.data.getIterator(), n = e.data.getIterator();
                for(; t.hasNext();){
                    var _$e = t.getNext().key, r = n.getNext().key;
                    if (0 !== this.comparator(_$e, r)) return !1;
                }
                return !0;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var e = [];
                return this.forEach(function(t) {
                    e.push(t);
                }), e;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.forEach(function(t) {
                    return e.push(t);
                }), "SortedSet(" + e.toString() + ")";
            }
        },
        {
            key: "copy",
            value: function copy(e) {
                var t = new SortedSet(this.comparator);
                return t.data = e, t;
            }
        }
    ]);
    return SortedSet;
}();
var $59fc9b849b320ded$var$SortedSetIterator = /*#__PURE__*/ function() {
    "use strict";
    function SortedSetIterator(e) {
        (0, $978gY._)(this, SortedSetIterator);
        this.iter = e;
    }
    (0, $kry2a._)(SortedSetIterator, [
        {
            key: "getNext",
            value: function getNext() {
                return this.iter.getNext().key;
            }
        },
        {
            key: "hasNext",
            value: function hasNext() {
                return this.iter.hasNext();
            }
        }
    ]);
    return SortedSetIterator;
}();
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $59fc9b849b320ded$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ var $59fc9b849b320ded$var$FieldMask = /*#__PURE__*/ function() {
    "use strict";
    function FieldMask(e) {
        (0, $978gY._)(this, FieldMask);
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($59fc9b849b320ded$export$b7871852b967eaf1.comparator);
    }
    (0, $kry2a._)(FieldMask, [
        {
            /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ key: "unionWith",
            value: function unionWith(e) {
                var t = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$export$b7871852b967eaf1.comparator);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        t = t.add(_$e);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n = _step1.value;
                        t = t.add(n);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return new FieldMask(t.toArray());
            }
        },
        {
            /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ key: "covers",
            value: function covers(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (t.isPrefixOf(e)) return !0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !1;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return $59fc9b849b320ded$var$__PRIVATE_arrayEquals(this.fields, e.fields, function(e, t) {
                    return e.isEqual(t);
                });
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new FieldMask([]);
            }
        }
    ]);
    return FieldMask;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ var $59fc9b849b320ded$var$__PRIVATE_Base64DecodeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_Base64DecodeError, Error1);
    var _super = (0, $6OZAO._)(__PRIVATE_Base64DecodeError);
    function __PRIVATE_Base64DecodeError() {
        (0, $978gY._)(this, __PRIVATE_Base64DecodeError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.name = "Base64DecodeError";
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_Base64DecodeError;
}((0, $2TMdq._)(Error));
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $59fc9b849b320ded$export$cbfc1605afde699b() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ var $59fc9b849b320ded$export$67460cdabfa21253 = /*#__PURE__*/ function() {
    "use strict";
    function ByteString(e) {
        (0, $978gY._)(this, ByteString);
        this.binaryString = e;
    }
    (0, $kry2a._)(ByteString, [
        {
            key: Symbol.iterator,
            value: function value() {
                var _this = this;
                var e = 0;
                return {
                    next: function() {
                        return e < _this.binaryString.length ? {
                            value: _this.binaryString.charCodeAt(e++),
                            done: !1
                        } : {
                            value: void 0,
                            done: !0
                        };
                    }
                };
            }
        },
        {
            key: "toBase64",
            value: function toBase64() {
                return function __PRIVATE_encodeBase64(e) {
                    return btoa(e);
                }(this.binaryString);
            }
        },
        {
            key: "toUint8Array",
            value: function toUint8Array() {
                return function __PRIVATE_uint8ArrayFromBinaryString(e) {
                    var t = new Uint8Array(e.length);
                    for(var n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
                    return t;
                }(this.binaryString);
            }
        },
        {
            key: "approximateByteSize",
            value: function approximateByteSize() {
                return 2 * this.binaryString.length;
            }
        },
        {
            key: "compareTo",
            value: function compareTo(e) {
                return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.binaryString === e.binaryString;
            }
        }
    ], [
        {
            key: "fromBase64String",
            value: function fromBase64String(e) {
                var t = function __PRIVATE_decodeBase64(e) {
                    try {
                        return atob(e);
                    } catch (e) {
                        // Check that `DOMException` is defined before using it to avoid
                        // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                        // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                        throw "undefined" != typeof DOMException && e instanceof DOMException ? new $59fc9b849b320ded$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
                    }
                }(e);
                return new ByteString(t);
            }
        },
        {
            key: "fromUint8Array",
            value: function fromUint8Array(e) {
                // TODO(indexing); Remove the copy of the byte string here as this method
                // is frequently called during indexing.
                var t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
                    var t = "";
                    for(var n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
                    return t;
                }(e);
                return new ByteString(t);
            }
        }
    ]);
    return ByteString;
}();
$59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING = new $59fc9b849b320ded$export$67460cdabfa21253("");
var $59fc9b849b320ded$var$ee = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($59fc9b849b320ded$var$__PRIVATE_hardAssert(!!e), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        var t = 0;
        var n = $59fc9b849b320ded$var$ee.exec(e);
        if ($59fc9b849b320ded$var$__PRIVATE_hardAssert(!!n), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            var _$e = n[1];
            _$e = (_$e + "000000000").substr(0, 9), t = Number(_$e);
        }
        // Parse the date to get the seconds.
        var r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $59fc9b849b320ded$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $59fc9b849b320ded$export$67460cdabfa21253.fromBase64String(e) : $59fc9b849b320ded$export$67460cdabfa21253.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ function $59fc9b849b320ded$var$__PRIVATE_isServerTimestamp(e) {
    var t, n;
    return "server_timestamp" === (null === (n = ((null === (t = null == e ? void 0 : e.mapValue) || void 0 === t ? void 0 : t.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $59fc9b849b320ded$var$__PRIVATE_getPreviousValue(e) {
    var t = e.mapValue.fields.__previous_value__;
    return $59fc9b849b320ded$var$__PRIVATE_isServerTimestamp(t) ? $59fc9b849b320ded$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $59fc9b849b320ded$var$__PRIVATE_getLocalWriteTime(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields.__local_write_time__.timestampValue);
    return new $59fc9b849b320ded$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$DatabaseInfo = function DatabaseInfo(e, t, n, r, i, s, o, _, a) {
    "use strict";
    (0, $978gY._)(this, DatabaseInfo);
    this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = o, this.longPollingOptions = _, this.useFetchStreams = a;
};
/** The default database name for a project. */ /**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ var $59fc9b849b320ded$export$4c3ccc07620ae30a = /*#__PURE__*/ function() {
    "use strict";
    function DatabaseId(e, t) {
        (0, $978gY._)(this, DatabaseId);
        this.projectId = e, this.database = t || "(default)";
    }
    (0, $kry2a._)(DatabaseId, [
        {
            key: "isDefaultDatabase",
            get: function get() {
                return "(default)" === this.database;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof DatabaseId && e.projectId === this.projectId && e.database === this.database;
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new DatabaseId("", "");
            }
        }
    ]);
    return DatabaseId;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$te = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: "__max__"
            }
        }
    }
}, $59fc9b849b320ded$var$ne = {
    nullValue: "NULL_VALUE"
};
/** Extracts the backend's type order for the provided value. */ function $59fc9b849b320ded$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $59fc9b849b320ded$var$__PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $59fc9b849b320ded$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : 10 /* TypeOrder.ObjectValue */  : $59fc9b849b320ded$var$fail();
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $59fc9b849b320ded$var$__PRIVATE_valueEquals(e, t) {
    if (e === t) return !0;
    var n = $59fc9b849b320ded$var$__PRIVATE_typeOrder(e);
    if (n !== $59fc9b849b320ded$var$__PRIVATE_typeOrder(t)) return !1;
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $59fc9b849b320ded$var$__PRIVATE_getLocalWriteTime(e).isEqual($59fc9b849b320ded$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                var n = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($59fc9b849b320ded$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t) {
                if ("integerValue" in e && "integerValue" in t) return $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.integerValue) === $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(t.integerValue);
                if ("doubleValue" in e && "doubleValue" in t) {
                    var n = $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.doubleValue), r = $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(t.doubleValue);
                    return n === r ? $59fc9b849b320ded$var$__PRIVATE_isNegativeZero(n) === $59fc9b849b320ded$var$__PRIVATE_isNegativeZero(r) : isNaN(n) && isNaN(r);
                }
                return !1;
            }(e, t);
        case 9 /* TypeOrder.ArrayValue */ :
            return $59fc9b849b320ded$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], $59fc9b849b320ded$var$__PRIVATE_valueEquals);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t) {
                var n = e.mapValue.fields || {}, r = t.mapValue.fields || {};
                if ($59fc9b849b320ded$var$__PRIVATE_objectSize(n) !== $59fc9b849b320ded$var$__PRIVATE_objectSize(r)) return !1;
                for(var _$e in n)if (n.hasOwnProperty(_$e) && (void 0 === r[_$e] || !$59fc9b849b320ded$var$__PRIVATE_valueEquals(n[_$e], r[_$e]))) return !1;
                return !0;
            }(e, t);
        default:
            return $59fc9b849b320ded$var$fail();
    }
}
function $59fc9b849b320ded$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_valueEquals(e, t);
    });
}
function $59fc9b849b320ded$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    var n = $59fc9b849b320ded$var$__PRIVATE_typeOrder(e), r = $59fc9b849b320ded$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $59fc9b849b320ded$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $59fc9b849b320ded$var$__PRIVATE_compareTimestamps($59fc9b849b320ded$var$__PRIVATE_getLocalWriteTime(e), $59fc9b849b320ded$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_normalizeByteString(e), r = $59fc9b849b320ded$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                var n = e.split("/"), r = t.split("/");
                for(var _$e = 0; _$e < n.length && _$e < r.length; _$e++){
                    var _$t = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n[_$e], r[_$e]);
                    if (0 !== _$t) return _$t;
                }
                return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator($59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.latitude), $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator($59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.longitude), $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_compareArrays(e, t) {
                var n = e.values || [], r = t.values || [];
                for(var _$e = 0; _$e < n.length && _$e < r.length; ++_$e){
                    var _$t = $59fc9b849b320ded$var$__PRIVATE_valueCompare(n[_$e], r[_$e]);
                    if (_$t) return _$t;
                }
                return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $59fc9b849b320ded$var$te.mapValue && t === $59fc9b849b320ded$var$te.mapValue) return 0;
                if (e === $59fc9b849b320ded$var$te.mapValue) return 1;
                if (t === $59fc9b849b320ded$var$te.mapValue) return -1;
                var n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(var _$e = 0; _$e < r.length && _$e < s.length; ++_$e){
                    var _$t = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(r[_$e], s[_$e]);
                    if (0 !== _$t) return _$t;
                    var o = $59fc9b849b320ded$var$__PRIVATE_valueCompare(n[r[_$e]], i[s[_$e]]);
                    if (0 !== o) return o;
                }
                return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $59fc9b849b320ded$var$fail();
    }
}
function $59fc9b849b320ded$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e, t);
    var n = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(e), r = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(t), i = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $59fc9b849b320ded$var$canonicalId(e) {
    return $59fc9b849b320ded$var$__PRIVATE_canonifyValue(e);
}
function $59fc9b849b320ded$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        var t = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(e);
        return "time(".concat(t.seconds, ",").concat(t.nanos, ")");
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $59fc9b849b320ded$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $59fc9b849b320ded$export$afc2e57c475b7810.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return "geo(".concat(e.latitude, ",").concat(e.longitude, ")");
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        var t = "[", n = !0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (e.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var r = _step.value;
                n ? n = !1 : t += ",", t += $59fc9b849b320ded$var$__PRIVATE_canonifyValue(r);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        var t = Object.keys(e.fields || {}).sort();
        var n = "{", r = !0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                r ? r = !1 : n += ",", n += "".concat(i, ":").concat($59fc9b849b320ded$var$__PRIVATE_canonifyValue(e.fields[i]));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n + "}";
    }(e.mapValue) : $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$var$__PRIVATE_estimateByteSize(e) {
    switch($59fc9b849b320ded$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            var t = $59fc9b849b320ded$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $59fc9b849b320ded$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $59fc9b849b320ded$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce(function(e, t) {
                    return e + $59fc9b849b320ded$var$__PRIVATE_estimateByteSize(t);
                }, 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                var t = 0;
                return $59fc9b849b320ded$var$forEach(e.fields, function(e, n) {
                    t += e.length + $59fc9b849b320ded$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $59fc9b849b320ded$var$fail();
    }
}
function $59fc9b849b320ded$var$__PRIVATE_refValue(e, t) {
    return {
        referenceValue: "projects/".concat(e.projectId, "/databases/").concat(e.database, "/documents/").concat(t.path.canonicalString())
    };
}
/** Returns true if `value` is an IntegerValue . */ function $59fc9b849b320ded$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ /** Returns true if `value` is an ArrayValue. */ function $59fc9b849b320ded$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is a NullValue. */ function $59fc9b849b320ded$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $59fc9b849b320ded$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is a MapValue. */ function $59fc9b849b320ded$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Creates a deep copy of `source`. */ function $59fc9b849b320ded$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: Object.assign({}, e.geoPointValue)
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: Object.assign({}, e.timestampValue)
    };
    if (e.mapValue) {
        var t = {
            mapValue: {
                fields: {}
            }
        };
        return $59fc9b849b320ded$var$forEach(e.mapValue.fields, function(e, n) {
            return t.mapValue.fields[e] = $59fc9b849b320ded$var$__PRIVATE_deepClone(n);
        }), t;
    }
    if (e.arrayValue) {
        var t1 = {
            arrayValue: {
                values: []
            }
        };
        for(var n = 0; n < (e.arrayValue.values || []).length; ++n)t1.arrayValue.values[n] = $59fc9b849b320ded$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t1;
    }
    return Object.assign({}, e);
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $59fc9b849b320ded$var$__PRIVATE_isMaxValue(e) {
    return "__max__" === (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue;
}
/** Returns the lowest value for the given value type (inclusive). */ function $59fc9b849b320ded$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $59fc9b849b320ded$var$ne : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $59fc9b849b320ded$var$__PRIVATE_refValue($59fc9b849b320ded$export$4c3ccc07620ae30a.empty(), $59fc9b849b320ded$export$afc2e57c475b7810.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? {
        mapValue: {}
    } : $59fc9b849b320ded$var$fail();
}
/** Returns the largest value for the given value type (exclusive). */ function $59fc9b849b320ded$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $59fc9b849b320ded$var$__PRIVATE_refValue($59fc9b849b320ded$export$4c3ccc07620ae30a.empty(), $59fc9b849b320ded$export$afc2e57c475b7810.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? {
        mapValue: {}
    } : "mapValue" in e ? $59fc9b849b320ded$var$te : $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$var$__PRIVATE_lowerBoundCompare(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $59fc9b849b320ded$var$__PRIVATE_upperBoundCompare(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ var $59fc9b849b320ded$var$ObjectValue = /*#__PURE__*/ function() {
    "use strict";
    function ObjectValue(e) {
        (0, $978gY._)(this, ObjectValue);
        this.value = e;
    }
    (0, $kry2a._)(ObjectValue, [
        {
            /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ key: "field",
            value: function field(e) {
                if (e.isEmpty()) return this.value;
                {
                    var t = this.value;
                    for(var n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$59fc9b849b320ded$var$__PRIVATE_isMapValue(t)) return null;
                    return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
                }
            }
        },
        {
            /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ key: "set",
            value: function set(e, t) {
                this.getFieldsMap(e.popLast())[e.lastSegment()] = $59fc9b849b320ded$var$__PRIVATE_deepClone(t);
            }
        },
        {
            /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ key: "setAll",
            value: function setAll(e) {
                var _this = this;
                var t = $59fc9b849b320ded$export$b7871852b967eaf1.emptyPath(), n = {}, r = [];
                e.forEach(function(e, i) {
                    if (!t.isImmediateParentOf(i)) {
                        // Insert the accumulated changes at this parent location
                        var _$e = _this.getFieldsMap(t);
                        _this.applyChanges(_$e, n, r), n = {}, r = [], t = i.popLast();
                    }
                    e ? n[i.lastSegment()] = $59fc9b849b320ded$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
                });
                var i = this.getFieldsMap(t);
                this.applyChanges(i, n, r);
            }
        },
        {
            /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ key: "delete",
            value: function _delete(e) {
                var t = this.field(e.popLast());
                $59fc9b849b320ded$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return $59fc9b849b320ded$var$__PRIVATE_valueEquals(this.value, e.value);
            }
        },
        {
            /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ key: "getFieldsMap",
            value: function getFieldsMap(e) {
                var t = this.value;
                t.mapValue.fields || (t.mapValue = {
                    fields: {}
                });
                for(var n = 0; n < e.length; ++n){
                    var r = t.mapValue.fields[e.get(n)];
                    $59fc9b849b320ded$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                        mapValue: {
                            fields: {}
                        }
                    }, t.mapValue.fields[e.get(n)] = r), t = r;
                }
                return t.mapValue.fields;
            }
        },
        {
            /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ key: "applyChanges",
            value: function applyChanges(e, t, n) {
                $59fc9b849b320ded$var$forEach(t, function(t, n) {
                    return e[t] = n;
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        delete e[_$t];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "clone",
            value: function clone() {
                return new ObjectValue($59fc9b849b320ded$var$__PRIVATE_deepClone(this.value));
            }
        }
    ], [
        {
            key: "empty",
            value: function empty() {
                return new ObjectValue({
                    mapValue: {}
                });
            }
        }
    ]);
    return ObjectValue;
}();
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $59fc9b849b320ded$var$__PRIVATE_extractFieldMask(e) {
    var t = [];
    return $59fc9b849b320ded$var$forEach(e.fields, function(e, n) {
        var r = new $59fc9b849b320ded$export$b7871852b967eaf1([
            e
        ]);
        if ($59fc9b849b320ded$var$__PRIVATE_isMapValue(n)) {
            var _$e = $59fc9b849b320ded$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (0 === _$e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else try {
                // For nested and non-empty ObjectValues, add the FieldPath of the
                // leaf nodes.
                for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n = _step.value;
                    t.push(r.child(_$n));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $59fc9b849b320ded$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ var $59fc9b849b320ded$var$MutableDocument = /*#__PURE__*/ function() {
    "use strict";
    function MutableDocument(e, t, n, r, i, s, o) {
        (0, $978gY._)(this, MutableDocument);
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = o;
    }
    (0, $kry2a._)(MutableDocument, [
        {
            /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ key: "convertToFoundDocument",
            value: function convertToFoundDocument(e, t) {
                // If a document is switching state from being an invalid or deleted
                // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
                // update from Watch or due to applying a local set mutation on top
                // of a deleted document, our best guess about its createTime would be the
                // version at which the document transitioned to a FOUND_DOCUMENT.
                return !this.createTime.isEqual($59fc9b849b320ded$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
            }
        },
        {
            /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ key: "convertToNoDocument",
            value: function convertToNoDocument(e) {
                return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $59fc9b849b320ded$var$ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
            }
        },
        {
            /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ key: "convertToUnknownDocument",
            value: function convertToUnknownDocument(e) {
                return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $59fc9b849b320ded$var$ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
            }
        },
        {
            key: "setHasCommittedMutations",
            value: function setHasCommittedMutations() {
                return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
            }
        },
        {
            key: "setHasLocalMutations",
            value: function setHasLocalMutations() {
                return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $59fc9b849b320ded$var$SnapshotVersion.min(), this;
            }
        },
        {
            key: "setReadTime",
            value: function setReadTime(e) {
                return this.readTime = e, this;
            }
        },
        {
            key: "hasLocalMutations",
            get: function get() {
                return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
            }
        },
        {
            key: "hasCommittedMutations",
            get: function get() {
                return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
            }
        },
        {
            key: "hasPendingWrites",
            get: function get() {
                return this.hasLocalMutations || this.hasCommittedMutations;
            }
        },
        {
            key: "isValidDocument",
            value: function isValidDocument() {
                return 0 /* DocumentType.INVALID */  !== this.documentType;
            }
        },
        {
            key: "isFoundDocument",
            value: function isFoundDocument() {
                return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isNoDocument",
            value: function isNoDocument() {
                return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isUnknownDocument",
            value: function isUnknownDocument() {
                return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
            }
        },
        {
            key: "mutableCopy",
            value: function mutableCopy() {
                return new MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "Document(".concat(this.key, ", ").concat(this.version, ", ").concat(JSON.stringify(this.data.value), ", {createTime: ").concat(this.createTime, "}), {documentType: ").concat(this.documentType, "}), {documentState: ").concat(this.documentState, "})");
            }
        }
    ], [
        {
            key: "newInvalidDocument",
            value: /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ function newInvalidDocument(e) {
                return new MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $59fc9b849b320ded$var$SnapshotVersion.min(), /* readTime */ $59fc9b849b320ded$var$SnapshotVersion.min(), /* createTime */ $59fc9b849b320ded$var$SnapshotVersion.min(), $59fc9b849b320ded$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newFoundDocument",
            value: /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ function newFoundDocument(e, t, n, r) {
                return new MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $59fc9b849b320ded$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newNoDocument",
            value: /** Creates a new document that is known to not exist at the given version. */ function newNoDocument(e, t) {
                return new MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $59fc9b849b320ded$var$SnapshotVersion.min(), /* createTime */ $59fc9b849b320ded$var$SnapshotVersion.min(), $59fc9b849b320ded$var$ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
            }
        },
        {
            key: "newUnknownDocument",
            value: /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ function newUnknownDocument(e, t) {
                return new MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $59fc9b849b320ded$var$SnapshotVersion.min(), /* createTime */ $59fc9b849b320ded$var$SnapshotVersion.min(), $59fc9b849b320ded$var$ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
            }
        }
    ]);
    return MutableDocument;
}();
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ var $59fc9b849b320ded$var$Bound = function Bound(e, t) {
    "use strict";
    (0, $978gY._)(this, Bound);
    this.position = e, this.inclusive = t;
};
function $59fc9b849b320ded$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    var r = 0;
    for(var i = 0; i < e.position.length; i++){
        var s = t[i], o = e.position[i];
        if (s.field.isKeyField()) r = $59fc9b849b320ded$export$afc2e57c475b7810.comparator($59fc9b849b320ded$export$afc2e57c475b7810.fromName(o.referenceValue), n.key);
        else r = $59fc9b849b320ded$var$__PRIVATE_valueCompare(o, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $59fc9b849b320ded$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(var n = 0; n < e.position.length; n++){
        if (!$59fc9b849b320ded$var$__PRIVATE_valueEquals(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ var $59fc9b849b320ded$var$OrderBy = function OrderBy(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 /* Direction.ASCENDING */  ? arguments[1] : "asc";
    (0, $978gY._)(this, OrderBy);
    this.field = e, this.dir = t;
};
function $59fc9b849b320ded$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$Filter = function Filter() {
    "use strict";
    (0, $978gY._)(this, Filter);
};
var $59fc9b849b320ded$var$FieldFilter = /*#__PURE__*/ function(Filter) {
    "use strict";
    (0, $ftJVG._)(FieldFilter, Filter);
    var _super = (0, $6OZAO._)(FieldFilter);
    function FieldFilter(e, t, n) {
        (0, $978gY._)(this, FieldFilter);
        var _this;
        _this = _super.call(this), _this.field = e, _this.op = t, _this.value = n;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(FieldFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                // Types do not have to match in NOT_EQUAL filters.
                return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && this.matchesComparison($59fc9b849b320ded$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $59fc9b849b320ded$var$__PRIVATE_typeOrder(this.value) === $59fc9b849b320ded$var$__PRIVATE_typeOrder(t) && this.matchesComparison($59fc9b849b320ded$var$__PRIVATE_valueCompare(t, this.value));
            // Only compare types with matching backend order (such as double and int).
            }
        },
        {
            key: "matchesComparison",
            value: function matchesComparison(e) {
                switch(this.op){
                    case "<" /* Operator.LESS_THAN */ :
                        return e < 0;
                    case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                        return e <= 0;
                    case "==" /* Operator.EQUAL */ :
                        return 0 === e;
                    case "!=" /* Operator.NOT_EQUAL */ :
                        return 0 !== e;
                    case ">" /* Operator.GREATER_THAN */ :
                        return e > 0;
                    case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                        return e >= 0;
                    default:
                        return $59fc9b849b320ded$var$fail();
                }
            }
        },
        {
            key: "isInequality",
            value: function isInequality() {
                return [
                    "<" /* Operator.LESS_THAN */ ,
                    "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
                    ">" /* Operator.GREATER_THAN */ ,
                    ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ].indexOf(this.op) >= 0;
            }
        },
        {
            key: "getFlattenedFilters",
            value: function getFlattenedFilters() {
                return [
                    this
                ];
            }
        },
        {
            key: "getFilters",
            value: function getFilters() {
                return [
                    this
                ];
            }
        },
        {
            key: "getFirstInequalityField",
            value: function getFirstInequalityField() {
                return this.isInequality() ? this.field : null;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * Creates a filter based on the provided arguments.
     */ function create(e, t, n) {
                return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $59fc9b849b320ded$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $59fc9b849b320ded$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $59fc9b849b320ded$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $59fc9b849b320ded$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $59fc9b849b320ded$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new FieldFilter(e, t, n);
            }
        },
        {
            key: "createKeyFieldInFilter",
            value: function createKeyFieldInFilter(e, t, n) {
                return "in" /* Operator.IN */  === t ? new $59fc9b849b320ded$var$__PRIVATE_KeyFieldInFilter(e, n) : new $59fc9b849b320ded$var$__PRIVATE_KeyFieldNotInFilter(e, n);
            }
        }
    ]);
    return FieldFilter;
}($59fc9b849b320ded$var$Filter);
var $59fc9b849b320ded$var$CompositeFilter = /*#__PURE__*/ function(Filter) {
    "use strict";
    (0, $ftJVG._)(CompositeFilter, Filter);
    var _super = (0, $6OZAO._)(CompositeFilter);
    function CompositeFilter(e, t) {
        (0, $978gY._)(this, CompositeFilter);
        var _this;
        _this = _super.call(this), _this.filters = e, _this.op = t, _this.ce = null;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(CompositeFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find(function(t) {
                    return !t.matches(e);
                }) : void 0 !== this.filters.find(function(t) {
                    return t.matches(e);
                });
            }
        },
        {
            key: "getFlattenedFilters",
            value: function getFlattenedFilters() {
                return null !== this.ce || (this.ce = this.filters.reduce(function(e, t) {
                    return e.concat(t.getFlattenedFilters());
                }, [])), this.ce;
            }
        },
        {
            // Returns a mutable copy of `this.filters`
            key: "getFilters",
            value: function getFilters() {
                return Object.assign([], this.filters);
            }
        },
        {
            key: "getFirstInequalityField",
            value: function getFirstInequalityField() {
                var e = this.le(function(e) {
                    return e.isInequality();
                });
                return null !== e ? e.field : null;
            }
        },
        {
            // Performs a depth-first search to find and return the first FieldFilter in the composite filter
            // that satisfies the predicate. Returns `null` if none of the FieldFilters satisfy the
            // predicate.
            key: "le",
            value: function le(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.getFlattenedFilters()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (e(t)) return t;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        }
    ], [
        {
            key: "create",
            value: /**
     * Creates a filter based on the provided arguments.
     */ function create(e, t) {
                return new CompositeFilter(e, t);
            }
        }
    ]);
    return CompositeFilter;
}($59fc9b849b320ded$var$Filter);
function $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsFlat(e) && $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsFlat(e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            if (t instanceof $59fc9b849b320ded$var$CompositeFilter) return !1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return !0;
}
function $59fc9b849b320ded$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $59fc9b849b320ded$var$FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $59fc9b849b320ded$var$canonicalId(e.value);
    if ($59fc9b849b320ded$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_canonifyFilter(e);
    }).join(",");
    {
        // filter instanceof CompositeFilter
        var t = e.filters.map(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_canonifyFilter(e);
        }).join(",");
        return "".concat(e.op, "(").concat(t, ")");
    }
}
function $59fc9b849b320ded$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $59fc9b849b320ded$var$FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $59fc9b849b320ded$var$FieldFilter && e.op === t.op && e.field.isEqual(t.field) && $59fc9b849b320ded$var$__PRIVATE_valueEquals(e.value, t.value);
    }(e, t) : e instanceof $59fc9b849b320ded$var$CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $59fc9b849b320ded$var$CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce(function(e, n, r) {
            return e && $59fc9b849b320ded$var$__PRIVATE_filterEquals(n, t.filters[r]);
        }, !0);
        return !1;
    }(e, t) : void $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    var n = e.filters.concat(t);
    return $59fc9b849b320ded$var$CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $59fc9b849b320ded$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $59fc9b849b320ded$var$FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return "".concat(e.field.canonicalString(), " ").concat(e.op, " ").concat($59fc9b849b320ded$var$canonicalId(e.value));
    }(e) : e instanceof $59fc9b849b320ded$var$CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($59fc9b849b320ded$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
var $59fc9b849b320ded$var$__PRIVATE_KeyFieldFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_KeyFieldFilter, FieldFilter);
    var _super = (0, $6OZAO._)(__PRIVATE_KeyFieldFilter);
    function __PRIVATE_KeyFieldFilter(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_KeyFieldFilter);
        var _this;
        _this = _super.call(this, e, t, n), _this.key = $59fc9b849b320ded$export$afc2e57c475b7810.fromName(n.referenceValue);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_KeyFieldFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = $59fc9b849b320ded$export$afc2e57c475b7810.comparator(e.key, this.key);
                return this.matchesComparison(t);
            }
        }
    ]);
    return __PRIVATE_KeyFieldFilter;
}($59fc9b849b320ded$var$FieldFilter);
/** Filter that matches on key fields within an array. */ var $59fc9b849b320ded$var$__PRIVATE_KeyFieldInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_KeyFieldInFilter, FieldFilter);
    var _super = (0, $6OZAO._)(__PRIVATE_KeyFieldInFilter);
    function __PRIVATE_KeyFieldInFilter(e, t) {
        (0, $978gY._)(this, __PRIVATE_KeyFieldInFilter);
        var _this;
        _this = _super.call(this, e, "in" /* Operator.IN */ , t), _this.keys = $59fc9b849b320ded$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_KeyFieldInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return this.keys.some(function(t) {
                    return t.isEqual(e.key);
                });
            }
        }
    ]);
    return __PRIVATE_KeyFieldInFilter;
}($59fc9b849b320ded$var$FieldFilter);
/** Filter that matches on key fields not present within an array. */ var $59fc9b849b320ded$var$__PRIVATE_KeyFieldNotInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_KeyFieldNotInFilter, FieldFilter);
    var _super = (0, $6OZAO._)(__PRIVATE_KeyFieldNotInFilter);
    function __PRIVATE_KeyFieldNotInFilter(e, t) {
        (0, $978gY._)(this, __PRIVATE_KeyFieldNotInFilter);
        var _this;
        _this = _super.call(this, e, "not-in" /* Operator.NOT_IN */ , t), _this.keys = $59fc9b849b320ded$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_KeyFieldNotInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                return !this.keys.some(function(t) {
                    return t.isEqual(e.key);
                });
            }
        }
    ]);
    return __PRIVATE_KeyFieldNotInFilter;
}($59fc9b849b320ded$var$FieldFilter);
function $59fc9b849b320ded$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    var n;
    return ((null === (n = t.arrayValue) || void 0 === n ? void 0 : n.values) || []).map(function(e) {
        return $59fc9b849b320ded$export$afc2e57c475b7810.fromName(e.referenceValue);
    });
}
/** A Filter that implements the array-contains operator. */ var $59fc9b849b320ded$var$__PRIVATE_ArrayContainsFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ArrayContainsFilter, FieldFilter);
    var _super = (0, $6OZAO._)(__PRIVATE_ArrayContainsFilter);
    function __PRIVATE_ArrayContainsFilter(e, t) {
        (0, $978gY._)(this, __PRIVATE_ArrayContainsFilter);
        return _super.call(this, e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    (0, $kry2a._)(__PRIVATE_ArrayContainsFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                return $59fc9b849b320ded$var$isArray(t) && $59fc9b849b320ded$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
            }
        }
    ]);
    return __PRIVATE_ArrayContainsFilter;
}($59fc9b849b320ded$var$FieldFilter);
/** A Filter that implements the IN operator. */ var $59fc9b849b320ded$var$__PRIVATE_InFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_InFilter, FieldFilter);
    var _super = (0, $6OZAO._)(__PRIVATE_InFilter);
    function __PRIVATE_InFilter(e, t) {
        (0, $978gY._)(this, __PRIVATE_InFilter);
        return _super.call(this, e, "in" /* Operator.IN */ , t);
    }
    (0, $kry2a._)(__PRIVATE_InFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var t = e.data.field(this.field);
                return null !== t && $59fc9b849b320ded$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
            }
        }
    ]);
    return __PRIVATE_InFilter;
}($59fc9b849b320ded$var$FieldFilter);
/** A Filter that implements the not-in operator. */ var $59fc9b849b320ded$var$__PRIVATE_NotInFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_NotInFilter, FieldFilter);
    var _super = (0, $6OZAO._)(__PRIVATE_NotInFilter);
    function __PRIVATE_NotInFilter(e, t) {
        (0, $978gY._)(this, __PRIVATE_NotInFilter);
        return _super.call(this, e, "not-in" /* Operator.NOT_IN */ , t);
    }
    (0, $kry2a._)(__PRIVATE_NotInFilter, [
        {
            key: "matches",
            value: function matches(e) {
                if ($59fc9b849b320ded$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
                    nullValue: "NULL_VALUE"
                })) return !1;
                var t = e.data.field(this.field);
                return null !== t && !$59fc9b849b320ded$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
            }
        }
    ]);
    return __PRIVATE_NotInFilter;
}($59fc9b849b320ded$var$FieldFilter);
/** A Filter that implements the array-contains-any operator. */ var $59fc9b849b320ded$var$__PRIVATE_ArrayContainsAnyFilter = /*#__PURE__*/ function(FieldFilter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ArrayContainsAnyFilter, FieldFilter);
    var _super = (0, $6OZAO._)(__PRIVATE_ArrayContainsAnyFilter);
    function __PRIVATE_ArrayContainsAnyFilter(e, t) {
        (0, $978gY._)(this, __PRIVATE_ArrayContainsAnyFilter);
        return _super.call(this, e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    (0, $kry2a._)(__PRIVATE_ArrayContainsAnyFilter, [
        {
            key: "matches",
            value: function matches(e) {
                var _this = this;
                var t = e.data.field(this.field);
                return !(!$59fc9b849b320ded$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some(function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_arrayValueContains(_this.value.arrayValue, e);
                });
            }
        }
    ]);
    return __PRIVATE_ArrayContainsAnyFilter;
}($59fc9b849b320ded$var$FieldFilter);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
var $59fc9b849b320ded$var$__PRIVATE_TargetImpl = function __PRIVATE_TargetImpl(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    (0, $978gY._)(this, __PRIVATE_TargetImpl);
    this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = o, this.he = null;
};
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $59fc9b849b320ded$var$__PRIVATE_newTarget(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    return new $59fc9b849b320ded$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, o);
}
function $59fc9b849b320ded$var$__PRIVATE_canonifyTarget(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    if (null === t.he) {
        var _$e = t.path.canonicalString();
        null !== t.collectionGroup && (_$e += "|cg:" + t.collectionGroup), _$e += "|f:", _$e += t.filters.map(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_canonifyFilter(e);
        }).join(","), _$e += "|ob:", _$e += t.orderBy.map(function(e) {
            return function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            }(e);
        }).join(","), $59fc9b849b320ded$var$__PRIVATE_isNullOrUndefined(t.limit) || (_$e += "|l:", _$e += t.limit), t.startAt && (_$e += "|lb:", _$e += t.startAt.inclusive ? "b:" : "a:", _$e += t.startAt.position.map(function(e) {
            return $59fc9b849b320ded$var$canonicalId(e);
        }).join(",")), t.endAt && (_$e += "|ub:", _$e += t.endAt.inclusive ? "a:" : "b:", _$e += t.endAt.position.map(function(e) {
            return $59fc9b849b320ded$var$canonicalId(e);
        }).join(",")), t.he = _$e;
    }
    return t.he;
}
function $59fc9b849b320ded$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(var n = 0; n < e.orderBy.length; n++)if (!$59fc9b849b320ded$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(var n1 = 0; n1 < e.filters.length; n1++)if (!$59fc9b849b320ded$var$__PRIVATE_filterEquals(e.filters[n1], t.filters[n1])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$59fc9b849b320ded$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $59fc9b849b320ded$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $59fc9b849b320ded$var$__PRIVATE_targetIsDocumentTarget(e) {
    return $59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $59fc9b849b320ded$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter(function(e) {
        return e instanceof $59fc9b849b320ded$var$FieldFilter && e.field.isEqual(t);
    });
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $59fc9b849b320ded$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    var r = $59fc9b849b320ded$var$ne, i = !0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Process all filters to find a value for the current field segment
        for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$n = _step.value;
            var _$e = $59fc9b849b320ded$var$ne, _$t = !0;
            switch(_$n.op){
                case "<" /* Operator.LESS_THAN */ :
                case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                    _$e = $59fc9b849b320ded$var$__PRIVATE_valuesGetLowerBound(_$n.value);
                    break;
                case "==" /* Operator.EQUAL */ :
                case "in" /* Operator.IN */ :
                case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                    _$e = _$n.value;
                    break;
                case ">" /* Operator.GREATER_THAN */ :
                    _$e = _$n.value, _$t = !1;
                    break;
                case "!=" /* Operator.NOT_EQUAL */ :
                case "not-in" /* Operator.NOT_IN */ :
                    _$e = $59fc9b849b320ded$var$ne;
            }
            $59fc9b849b320ded$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e,
                inclusive: _$t
            }) < 0 && (r = _$e, i = _$t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(var s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            var _$e1 = n.position[s];
            $59fc9b849b320ded$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e1,
                inclusive: n.inclusive
            }) < 0 && (r = _$e1, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $59fc9b849b320ded$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    var r = $59fc9b849b320ded$var$te, i = !0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // Process all filters to find a value for the current field segment
        for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$n = _step.value;
            var _$e = $59fc9b849b320ded$var$te, _$t = !0;
            switch(_$n.op){
                case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                case ">" /* Operator.GREATER_THAN */ :
                    _$e = $59fc9b849b320ded$var$__PRIVATE_valuesGetUpperBound(_$n.value), _$t = !1;
                    break;
                case "==" /* Operator.EQUAL */ :
                case "in" /* Operator.IN */ :
                case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                    _$e = _$n.value;
                    break;
                case "<" /* Operator.LESS_THAN */ :
                    _$e = _$n.value, _$t = !1;
                    break;
                case "!=" /* Operator.NOT_EQUAL */ :
                case "not-in" /* Operator.NOT_IN */ :
                    _$e = $59fc9b849b320ded$var$te;
            }
            $59fc9b849b320ded$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e,
                inclusive: _$t
            }) > 0 && (r = _$e, i = _$t);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(var s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            var _$e1 = n.position[s];
            $59fc9b849b320ded$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: _$e1,
                inclusive: n.inclusive
            }) > 0 && (r = _$e1, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ var $59fc9b849b320ded$var$__PRIVATE_QueryImpl = function __PRIVATE_QueryImpl(e) {
    "use strict";
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [], i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, s = arguments.length > 5 && arguments[5] !== void 0 /* LimitType.First */  ? arguments[5] : "F", o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null, _ = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
    (0, $978gY._)(this, __PRIVATE_QueryImpl);
    this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = o, this.endAt = _, this.Pe = null, // The corresponding `Target` of this `Query` instance, for use with
    // non-aggregate queries.
    this.Ie = null, // The corresponding `Target` of this `Query` instance, for use with
    // aggregate queries. Unlike targets for non-aggregate queries,
    // aggregate query targets do not contain normalized order-bys, they only
    // contain explicit order-bys.
    this.de = null, this.startAt, this.endAt;
};
/** Creates a new Query instance with the options provided. */ function $59fc9b849b320ded$var$__PRIVATE_newQuery(e, t, n, r, i, s, o, _) {
    return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, o, _);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $59fc9b849b320ded$var$__PRIVATE_newQueryForPath(e) {
    return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $59fc9b849b320ded$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
function $59fc9b849b320ded$var$__PRIVATE_getFirstOrderByField(e) {
    return e.explicitOrderBy.length > 0 ? e.explicitOrderBy[0].field : null;
}
function $59fc9b849b320ded$var$__PRIVATE_getInequalityFilterField(e) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var t = _step.value;
            var _$e = t.getFirstInequalityField();
            if (null !== _$e) return _$e;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
/**
 * Creates a new Query for a collection group query that matches all documents
 * within the provided collection group.
 */ /**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $59fc9b849b320ded$var$__PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $59fc9b849b320ded$var$__PRIVATE_queryNormalizedOrderBy(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    if (null === t.Pe) {
        t.Pe = [];
        var _$e = $59fc9b849b320ded$var$__PRIVATE_getInequalityFilterField(t), n = $59fc9b849b320ded$var$__PRIVATE_getFirstOrderByField(t);
        if (null !== _$e && null === n) // In order to implicitly add key ordering, we must also add the
        // inequality filter field for it to be a valid query.
        // Note that the default inequality field and key ordering is ascending.
        _$e.isKeyField() || t.Pe.push(new $59fc9b849b320ded$var$OrderBy(_$e)), t.Pe.push(new $59fc9b849b320ded$var$OrderBy($59fc9b849b320ded$export$b7871852b967eaf1.keyField(), "asc" /* Direction.ASCENDING */ ));
        else {
            var _$e1 = !1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t.explicitOrderBy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n1 = _step.value;
                    t.Pe.push(n1), n1.field.isKeyField() && (_$e1 = !0);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (!_$e1) {
                // The order of the implicit key ordering always matches the last
                // explicit order-by
                var _$e2 = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ ;
                t.Pe.push(new $59fc9b849b320ded$var$OrderBy($59fc9b849b320ded$export$b7871852b967eaf1.keyField(), _$e2));
            }
        }
    }
    return t.Pe;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $59fc9b849b320ded$var$__PRIVATE_queryToTarget(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return t.Ie || (t.Ie = $59fc9b849b320ded$var$__PRIVATE__queryToTarget(t, $59fc9b849b320ded$var$__PRIVATE_queryNormalizedOrderBy(e))), t.Ie;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $59fc9b849b320ded$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $59fc9b849b320ded$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map(function(e) {
            var _$t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $59fc9b849b320ded$var$OrderBy(e.field, _$t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        var n = e.endAt ? new $59fc9b849b320ded$var$Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $59fc9b849b320ded$var$Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $59fc9b849b320ded$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $59fc9b849b320ded$var$__PRIVATE_queryWithAddedFilter(e, t) {
    t.getFirstInequalityField(), $59fc9b849b320ded$var$__PRIVATE_getInequalityFilterField(e);
    var n = e.filters.concat([
        t
    ]);
    return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $59fc9b849b320ded$var$__PRIVATE_queryWithLimit(e, t, n) {
    return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $59fc9b849b320ded$var$__PRIVATE_queryEquals(e, t) {
    return $59fc9b849b320ded$var$__PRIVATE_targetEquals($59fc9b849b320ded$var$__PRIVATE_queryToTarget(e), $59fc9b849b320ded$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $59fc9b849b320ded$var$__PRIVATE_canonifyQuery(e) {
    return "".concat($59fc9b849b320ded$var$__PRIVATE_canonifyTarget($59fc9b849b320ded$var$__PRIVATE_queryToTarget(e)), "|lt:").concat(e.limitType);
}
function $59fc9b849b320ded$var$__PRIVATE_stringifyQuery(e) {
    return "Query(target=".concat(function __PRIVATE_stringifyTarget(e) {
        var t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += ", filters: [".concat(e.filters.map(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_stringifyFilter(e);
        }).join(", "), "]")), $59fc9b849b320ded$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += ", orderBy: [".concat(e.orderBy.map(function(e) {
            return function __PRIVATE_stringifyOrderBy(e) {
                return "".concat(e.field.canonicalString(), " (").concat(e.dir, ")");
            }(e);
        }).join(", "), "]")), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map(function(e) {
            return $59fc9b849b320ded$var$canonicalId(e);
        }).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map(function(e) {
            return $59fc9b849b320ded$var$canonicalId(e);
        }).join(",")), "Target(".concat(t, ")");
    }($59fc9b849b320ded$var$__PRIVATE_queryToTarget(e)), "; limitType=").concat(e.limitType, ")");
}
/** Returns whether `doc` matches the constraints of `query`. */ function $59fc9b849b320ded$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        var n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
            // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
            // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
            // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
            // A document with content of {b:1} matches the filters, but does not match the orderBy because
            // it's missing the field 'a'.
            for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                // order-by key always matches
                if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var n = _step.value;
                if (!n.matches(t)) return !1;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            var r = $59fc9b849b320ded$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $59fc9b849b320ded$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            var r = $59fc9b849b320ded$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $59fc9b849b320ded$var$__PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
function $59fc9b849b320ded$var$__PRIVATE_queryCollectionGroup(e) {
    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $59fc9b849b320ded$var$__PRIVATE_newQueryComparator(e) {
    return function(t, n) {
        var r = !1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var i = _step.value;
                var _$e = $59fc9b849b320ded$var$__PRIVATE_compareDocs(i, t, n);
                if (0 !== _$e) return _$e;
                r = r || i.field.isKeyField();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return 0;
    };
}
function $59fc9b849b320ded$var$__PRIVATE_compareDocs(e, t, n) {
    var r = e.field.isKeyField() ? $59fc9b849b320ded$export$afc2e57c475b7810.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        var r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $59fc9b849b320ded$var$__PRIVATE_valueCompare(r, i) : $59fc9b849b320ded$var$fail();
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $59fc9b849b320ded$var$fail();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ var $59fc9b849b320ded$var$ObjectMap = /*#__PURE__*/ function() {
    "use strict";
    function ObjectMap(e, t) {
        (0, $978gY._)(this, ObjectMap);
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    (0, $kry2a._)(ObjectMap, [
        {
            /** Get a value for this key, or undefined if it does not exist. */ key: "get",
            value: function get(e) {
                var t = this.mapKeyFn(e), n = this.inner[t];
                if (void 0 !== n) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $8GFUW._)(_step.value, 2), t1 = _step_value[0], r = _step_value[1];
                            if (this.equalsFn(t1, e)) return r;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(e) {
                return void 0 !== this.get(e);
            }
        },
        {
            /** Put this key and value in the map. */ key: "set",
            value: function set(e, t) {
                var n = this.mapKeyFn(e), r = this.inner[n];
                if (void 0 === r) return this.inner[n] = [
                    [
                        e,
                        t
                    ]
                ], void this.innerSize++;
                for(var n1 = 0; n1 < r.length; n1++)if (this.equalsFn(r[n1][0], e)) // This is updating an existing entry and does not increase `innerSize`.
                return void (r[n1] = [
                    e,
                    t
                ]);
                r.push([
                    e,
                    t
                ]), this.innerSize++;
            }
        },
        {
            /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ key: "delete",
            value: function _delete(e) {
                var t = this.mapKeyFn(e), n = this.inner[t];
                if (void 0 === n) return !1;
                for(var r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
                return !1;
            }
        },
        {
            key: "forEach",
            value: function forEach1(e) {
                $59fc9b849b320ded$var$forEach(this.inner, function(t, n) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $8GFUW._)(_step.value, 2), t1 = _step_value[0], r = _step_value[1];
                            e(t1, r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty1() {
                return $59fc9b849b320ded$var$isEmpty(this.inner);
            }
        },
        {
            key: "size",
            value: function size() {
                return this.innerSize;
            }
        }
    ]);
    return ObjectMap;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$re = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
function $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap() {
    return $59fc9b849b320ded$var$re;
}
var $59fc9b849b320ded$var$ie = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
function $59fc9b849b320ded$var$documentMap() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t = $59fc9b849b320ded$var$ie;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            t = t.insert(n.key, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
function $59fc9b849b320ded$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    var t = $59fc9b849b320ded$var$ie;
    return e.forEach(function(e, n) {
        return t = t.insert(e, n.overlayedDocument);
    }), t;
}
function $59fc9b849b320ded$var$__PRIVATE_newOverlayMap() {
    return $59fc9b849b320ded$var$__PRIVATE_newDocumentKeyMap();
}
function $59fc9b849b320ded$var$__PRIVATE_newMutationMap() {
    return $59fc9b849b320ded$var$__PRIVATE_newDocumentKeyMap();
}
function $59fc9b849b320ded$var$__PRIVATE_newDocumentKeyMap() {
    return new $59fc9b849b320ded$var$ObjectMap(function(e) {
        return e.toString();
    }, function(e, t) {
        return e.isEqual(t);
    });
}
var $59fc9b849b320ded$var$se = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
var $59fc9b849b320ded$var$oe = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
function $59fc9b849b320ded$var$__PRIVATE_documentKeySet() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t = $59fc9b849b320ded$var$oe;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            t = t.add(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
var $59fc9b849b320ded$var$_e = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_primitiveComparator);
function $59fc9b849b320ded$var$__PRIVATE_targetIdSet() {
    return $59fc9b849b320ded$var$_e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $59fc9b849b320ded$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $59fc9b849b320ded$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $59fc9b849b320ded$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $59fc9b849b320ded$var$toNumber(e, t) {
    return $59fc9b849b320ded$var$isSafeInteger(t) ? $59fc9b849b320ded$var$__PRIVATE_toInteger(t) : $59fc9b849b320ded$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ var $59fc9b849b320ded$var$TransformOperation = function TransformOperation() {
    "use strict";
    (0, $978gY._)(this, TransformOperation);
    // Make sure that the structural type of `TransformOperation` is unique.
    // See https://github.com/microsoft/TypeScript/issues/5451
    this._ = void 0;
};
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $59fc9b849b320ded$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $59fc9b849b320ded$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        var _$n = {
            fields: {
                __type__: {
                    stringValue: "server_timestamp"
                },
                __local_write_time__: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $59fc9b849b320ded$var$__PRIVATE_isServerTimestamp(t) && (t = $59fc9b849b320ded$var$__PRIVATE_getPreviousValue(t)), t && (_$n.fields.__previous_value__ = t), {
            mapValue: _$n
        };
    }(n, t) : e instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation ? $59fc9b849b320ded$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation ? $59fc9b849b320ded$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        var _$n = $59fc9b849b320ded$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $59fc9b849b320ded$var$asNumber(_$n) + $59fc9b849b320ded$var$asNumber(e.Te);
        return $59fc9b849b320ded$var$isInteger(_$n) && $59fc9b849b320ded$var$isInteger(e.Te) ? $59fc9b849b320ded$var$__PRIVATE_toInteger(r) : $59fc9b849b320ded$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t);
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $59fc9b849b320ded$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation ? $59fc9b849b320ded$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation ? $59fc9b849b320ded$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $59fc9b849b320ded$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $59fc9b849b320ded$var$__PRIVATE_NumericIncrementTransformOperation ? /** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
        return $59fc9b849b320ded$var$isInteger(e) || function __PRIVATE_isDouble(e) {
            return !!e && "doubleValue" in e;
        }(e);
    }(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ var $59fc9b849b320ded$var$__PRIVATE_ServerTimestampTransform = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ServerTimestampTransform, TransformOperation);
    var _super = (0, $6OZAO._)(__PRIVATE_ServerTimestampTransform);
    function __PRIVATE_ServerTimestampTransform() {
        (0, $978gY._)(this, __PRIVATE_ServerTimestampTransform);
        return _super.apply(this, arguments);
    }
    return __PRIVATE_ServerTimestampTransform;
}($59fc9b849b320ded$var$TransformOperation);
/** Transforms an array value via a union operation. */ var $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ArrayUnionTransformOperation, TransformOperation);
    var _super = (0, $6OZAO._)(__PRIVATE_ArrayUnionTransformOperation);
    function __PRIVATE_ArrayUnionTransformOperation(e) {
        (0, $978gY._)(this, __PRIVATE_ArrayUnionTransformOperation);
        var _this;
        _this = _super.call(this), _this.elements = e;
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_ArrayUnionTransformOperation;
}($59fc9b849b320ded$var$TransformOperation);
function $59fc9b849b320ded$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_coercedFieldValuesArray(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _$t = _step.value;
            n.some(function(e) {
                return $59fc9b849b320ded$var$__PRIVATE_valueEquals(e, _$t);
            }) || n.push(_$t);
        };
        for(var _iterator = e.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ var $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ArrayRemoveTransformOperation, TransformOperation);
    var _super = (0, $6OZAO._)(__PRIVATE_ArrayRemoveTransformOperation);
    function __PRIVATE_ArrayRemoveTransformOperation(e) {
        (0, $978gY._)(this, __PRIVATE_ArrayRemoveTransformOperation);
        var _this;
        _this = _super.call(this), _this.elements = e;
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_ArrayRemoveTransformOperation;
}($59fc9b849b320ded$var$TransformOperation);
function $59fc9b849b320ded$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_coercedFieldValuesArray(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _$t = _step.value;
            n = n.filter(function(e) {
                return !$59fc9b849b320ded$var$__PRIVATE_valueEquals(e, _$t);
            });
        };
        for(var _iterator = e.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ var $59fc9b849b320ded$var$__PRIVATE_NumericIncrementTransformOperation = /*#__PURE__*/ function(TransformOperation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_NumericIncrementTransformOperation, TransformOperation);
    var _super = (0, $6OZAO._)(__PRIVATE_NumericIncrementTransformOperation);
    function __PRIVATE_NumericIncrementTransformOperation(e, t) {
        (0, $978gY._)(this, __PRIVATE_NumericIncrementTransformOperation);
        var _this;
        _this = _super.call(this), _this.serializer = e, _this.Te = t;
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_NumericIncrementTransformOperation;
}($59fc9b849b320ded$var$TransformOperation);
function $59fc9b849b320ded$var$asNumber(e) {
    return $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $59fc9b849b320ded$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $59fc9b849b320ded$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ var $59fc9b849b320ded$var$FieldTransform = function FieldTransform(e, t) {
    "use strict";
    (0, $978gY._)(this, FieldTransform);
    this.field = e, this.transform = t;
};
function $59fc9b849b320ded$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation ? $59fc9b849b320ded$var$__PRIVATE_arrayEquals(e.elements, t.elements, $59fc9b849b320ded$var$__PRIVATE_valueEquals) : e instanceof $59fc9b849b320ded$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $59fc9b849b320ded$var$__PRIVATE_NumericIncrementTransformOperation ? $59fc9b849b320ded$var$__PRIVATE_valueEquals(e.Te, t.Te) : e instanceof $59fc9b849b320ded$var$__PRIVATE_ServerTimestampTransform && t instanceof $59fc9b849b320ded$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ var $59fc9b849b320ded$var$MutationResult = function MutationResult(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t) {
    "use strict";
    (0, $978gY._)(this, MutationResult);
    this.version = e, this.transformResults = t;
};
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ var $59fc9b849b320ded$var$Precondition = /*#__PURE__*/ function() {
    "use strict";
    function Precondition(e, t) {
        (0, $978gY._)(this, Precondition);
        this.updateTime = e, this.exists = t;
    }
    (0, $kry2a._)(Precondition, [
        {
            key: "isNone",
            get: /** Returns whether this Precondition is empty. */ function get() {
                return void 0 === this.updateTime && void 0 === this.exists;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
            }
        }
    ], [
        {
            key: "none",
            value: /** Creates a new empty Precondition. */ function none() {
                return new Precondition;
            }
        },
        {
            key: "exists",
            value: /** Creates a new Precondition with an exists flag. */ function exists(e) {
                return new Precondition(void 0, e);
            }
        },
        {
            key: "updateTime",
            value: /** Creates a new Precondition based on a version a document exists at. */ function updateTime(e) {
                return new Precondition(e);
            }
        }
    ]);
    return Precondition;
}();
/** Returns true if the preconditions is valid for the given document. */ function $59fc9b849b320ded$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ var $59fc9b849b320ded$var$Mutation = function Mutation() {
    "use strict";
    (0, $978gY._)(this, Mutation);
};
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $59fc9b849b320ded$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $59fc9b849b320ded$var$__PRIVATE_DeleteMutation(e.key, $59fc9b849b320ded$var$Precondition.none()) : new $59fc9b849b320ded$var$__PRIVATE_SetMutation(e.key, e.data, $59fc9b849b320ded$var$Precondition.none());
    {
        var n = e.data, r = $59fc9b849b320ded$var$ObjectValue.empty();
        var i = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$export$b7871852b967eaf1.comparator);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                if (!i.has(_$e)) {
                    var _$t = n.field(_$e);
                    // If we are deleting a nested field, we take the immediate parent as
                    // the mask used to construct the resulting mutation.
                    // Justification: Nested fields can create parent fields implicitly. If
                    // only a leaf entry is deleted in later mutations, the parent field
                    // should still remain, but we may have lost this information.
                    // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
                    // This leaves the final result (foo, {}). Despite the fact that `doc`
                    // has the correct result, `foo` is not in `mask`, and the resulting
                    // mutation would miss `foo`.
                    null === _$t && _$e.length > 1 && (_$e = _$e.popLast(), _$t = n.field(_$e)), null === _$t ? r.delete(_$e) : r.set(_$e, _$t), i = i.add(_$e);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new $59fc9b849b320ded$var$__PRIVATE_PatchMutation(e.key, r, new $59fc9b849b320ded$var$FieldMask(i.toArray()), $59fc9b849b320ded$var$Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $59fc9b849b320ded$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $59fc9b849b320ded$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        var r = e.value.clone(), i = $59fc9b849b320ded$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $59fc9b849b320ded$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$59fc9b849b320ded$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        var r = $59fc9b849b320ded$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($59fc9b849b320ded$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $59fc9b849b320ded$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $59fc9b849b320ded$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$59fc9b849b320ded$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        var i = e.value.clone(), s = $59fc9b849b320ded$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $59fc9b849b320ded$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$59fc9b849b320ded$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        var i = $59fc9b849b320ded$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($59fc9b849b320ded$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map(function(e) {
            return e.field;
        }));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($59fc9b849b320ded$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $59fc9b849b320ded$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    var n = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.fieldTransforms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            var _$e = t.data.field(r.field), i = $59fc9b849b320ded$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, _$e || null);
            null != i && (null === n && (n = $59fc9b849b320ded$var$ObjectValue.empty()), n.set(r.field, i));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n || null;
}
function $59fc9b849b320ded$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $59fc9b849b320ded$var$__PRIVATE_arrayEquals(e, t, function(e, t) {
            return $59fc9b849b320ded$var$__PRIVATE_fieldTransformEquals(e, t);
        });
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ var $59fc9b849b320ded$var$__PRIVATE_SetMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_SetMutation, Mutation);
    var _super = (0, $6OZAO._)(__PRIVATE_SetMutation);
    function __PRIVATE_SetMutation(e, t, n) {
        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
        (0, $978gY._)(this, __PRIVATE_SetMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.value = t, _this.precondition = n, _this.fieldTransforms = r, _this.type = 0 /* MutationType.Set */ ;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_SetMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_SetMutation;
}($59fc9b849b320ded$var$Mutation);
var $59fc9b849b320ded$var$__PRIVATE_PatchMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_PatchMutation, Mutation);
    var _super = (0, $6OZAO._)(__PRIVATE_PatchMutation);
    function __PRIVATE_PatchMutation(e, t, n, r) {
        var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
        (0, $978gY._)(this, __PRIVATE_PatchMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.data = t, _this.fieldMask = n, _this.precondition = r, _this.fieldTransforms = i, _this.type = 1 /* MutationType.Patch */ ;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_PatchMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return this.fieldMask;
            }
        }
    ]);
    return __PRIVATE_PatchMutation;
}($59fc9b849b320ded$var$Mutation);
function $59fc9b849b320ded$var$__PRIVATE_getPatch(e) {
    var t = new Map;
    return e.fieldMask.fields.forEach(function(n) {
        if (!n.isEmpty()) {
            var r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $59fc9b849b320ded$var$__PRIVATE_serverTransformResults(e, t, n) {
    var r = new Map;
    $59fc9b849b320ded$var$__PRIVATE_hardAssert(e.length === n.length);
    for(var i = 0; i < n.length; i++){
        var s = e[i], o = s.transform, _ = t.data.field(s.field);
        r.set(s.field, $59fc9b849b320ded$var$__PRIVATE_applyTransformOperationToRemoteDocument(o, _, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $59fc9b849b320ded$var$__PRIVATE_localTransformResults(e, t, n) {
    var r = new Map;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i = _step.value;
            var _$e = i.transform, s = n.data.field(i.field);
            r.set(i.field, $59fc9b849b320ded$var$__PRIVATE_applyTransformOperationToLocalView(_$e, s, t));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ var $59fc9b849b320ded$var$__PRIVATE_DeleteMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_DeleteMutation, Mutation);
    var _super = (0, $6OZAO._)(__PRIVATE_DeleteMutation);
    function __PRIVATE_DeleteMutation(e, t) {
        (0, $978gY._)(this, __PRIVATE_DeleteMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.precondition = t, _this.type = 2 /* MutationType.Delete */ , _this.fieldTransforms = [];
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_DeleteMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_DeleteMutation;
}($59fc9b849b320ded$var$Mutation);
var $59fc9b849b320ded$var$__PRIVATE_VerifyMutation = /*#__PURE__*/ function(Mutation) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_VerifyMutation, Mutation);
    var _super = (0, $6OZAO._)(__PRIVATE_VerifyMutation);
    function __PRIVATE_VerifyMutation(e, t) {
        (0, $978gY._)(this, __PRIVATE_VerifyMutation);
        var _this;
        _this = _super.call(this), _this.key = e, _this.precondition = t, _this.type = 3 /* MutationType.Verify */ , _this.fieldTransforms = [];
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_VerifyMutation, [
        {
            key: "getFieldMask",
            value: function getFieldMask() {
                return null;
            }
        }
    ]);
    return __PRIVATE_VerifyMutation;
}($59fc9b849b320ded$var$Mutation);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ var $59fc9b849b320ded$var$MutationBatch = /*#__PURE__*/ function() {
    "use strict";
    function MutationBatch(e, t, n, r) {
        (0, $978gY._)(this, MutationBatch);
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    (0, $kry2a._)(MutationBatch, [
        {
            /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ key: "applyToRemoteDocument",
            value: function applyToRemoteDocument(e, t) {
                var n = t.mutationResults;
                for(var _$t = 0; _$t < this.mutations.length; _$t++){
                    var r = this.mutations[_$t];
                    if (r.key.isEqual(e.key)) $59fc9b849b320ded$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[_$t]);
                }
            }
        },
        {
            /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ key: "applyToLocalView",
            value: function applyToLocalView(e, t) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // First, apply the base state. This allows us to apply non-idempotent
                    // transform against a consistent set of values.
                    for(var _iterator = this.baseMutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        n.key.isEqual(e.key) && (t = $59fc9b849b320ded$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Second, apply all user-provided mutations.
                    for(var _iterator1 = this.mutations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n1 = _step1.value;
                        n1.key.isEqual(e.key) && (t = $59fc9b849b320ded$var$__PRIVATE_mutationApplyToLocalView(n1, e, t, this.localWriteTime));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return t;
            }
        },
        {
            /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ key: "applyToLocalDocumentSet",
            value: function applyToLocalDocumentSet(e, t) {
                var _this = this;
                // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
                // directly (as done in `applyToLocalView()`), we can reduce the complexity
                // to O(n).
                var n = $59fc9b849b320ded$var$__PRIVATE_newMutationMap();
                return this.mutations.forEach(function(r) {
                    var i = e.get(r.key), s = i.overlayedDocument;
                    // TODO(mutabledocuments): This method should take a MutableDocumentMap
                    // and we should remove this cast.
                    var o = _this.applyToLocalView(s, i.mutatedFields);
                    // Set mutatedFields to null if the document is only from local mutations.
                    // This creates a Set or Delete mutation, instead of trying to create a
                    // patch mutation as the overlay.
                    o = t.has(r.key) ? null : o;
                    var _ = $59fc9b849b320ded$var$__PRIVATE_calculateOverlayMutation(s, o);
                    null !== _ && n.set(r.key, _), s.isValidDocument() || s.convertToNoDocument($59fc9b849b320ded$var$SnapshotVersion.min());
                }), n;
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this.mutations.reduce(function(e, t) {
                    return e.add(t.key);
                }, $59fc9b849b320ded$var$__PRIVATE_documentKeySet());
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.batchId === e.batchId && $59fc9b849b320ded$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, function(e, t) {
                    return $59fc9b849b320ded$var$__PRIVATE_mutationEquals(e, t);
                }) && $59fc9b849b320ded$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, function(e, t) {
                    return $59fc9b849b320ded$var$__PRIVATE_mutationEquals(e, t);
                });
            }
        }
    ]);
    return MutationBatch;
}();
/** The result of applying a mutation batch to the backend. */ var $59fc9b849b320ded$var$MutationBatchResult = /*#__PURE__*/ function() {
    "use strict";
    function MutationBatchResult(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r) {
        (0, $978gY._)(this, MutationBatchResult);
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    (0, $kry2a._)(MutationBatchResult, null, [
        {
            key: "from",
            value: /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ function from(e, t, n) {
                $59fc9b849b320ded$var$__PRIVATE_hardAssert(e.mutations.length === n.length);
                var r = function __PRIVATE_documentVersionMap() {
                    return $59fc9b849b320ded$var$se;
                }();
                var i = e.mutations;
                for(var _$e = 0; _$e < i.length; _$e++)r = r.insert(i[_$e].key, n[_$e].version);
                return new MutationBatchResult(e, t, n, r);
            }
        }
    ]);
    return MutationBatchResult;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ var $59fc9b849b320ded$var$Overlay = /*#__PURE__*/ function() {
    "use strict";
    function Overlay(e, t) {
        (0, $978gY._)(this, Overlay);
        this.largestBatchId = e, this.mutation = t;
    }
    (0, $kry2a._)(Overlay, [
        {
            key: "getKey",
            value: function getKey() {
                return this.mutation.key;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return null !== e && this.mutation === e.mutation;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "Overlay{\n      largestBatchId: ".concat(this.largestBatchId, ",\n      mutation: ").concat(this.mutation.toString(), "\n    }");
            }
        }
    ]);
    return Overlay;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ var $59fc9b849b320ded$var$__PRIVATE_AggregateImpl = function __PRIVATE_AggregateImpl(e, t, n) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_AggregateImpl);
    this.alias = e, this.Ee = t, this.fieldPath = n;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$ExistenceFilter = function ExistenceFilter(e, t) {
    "use strict";
    (0, $978gY._)(this, ExistenceFilter);
    this.count = e, this.unchangedNames = t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $59fc9b849b320ded$var$ae, $59fc9b849b320ded$var$ue;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $59fc9b849b320ded$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        default:
            return $59fc9b849b320ded$var$fail();
        case $59fc9b849b320ded$var$D.CANCELLED:
        case $59fc9b849b320ded$var$D.UNKNOWN:
        case $59fc9b849b320ded$var$D.DEADLINE_EXCEEDED:
        case $59fc9b849b320ded$var$D.RESOURCE_EXHAUSTED:
        case $59fc9b849b320ded$var$D.INTERNAL:
        case $59fc9b849b320ded$var$D.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $59fc9b849b320ded$var$D.UNAUTHENTICATED:
            return !1;
        case $59fc9b849b320ded$var$D.INVALID_ARGUMENT:
        case $59fc9b849b320ded$var$D.NOT_FOUND:
        case $59fc9b849b320ded$var$D.ALREADY_EXISTS:
        case $59fc9b849b320ded$var$D.PERMISSION_DENIED:
        case $59fc9b849b320ded$var$D.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependant on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $59fc9b849b320ded$var$D.ABORTED:
        case $59fc9b849b320ded$var$D.OUT_OF_RANGE:
        case $59fc9b849b320ded$var$D.UNIMPLEMENTED:
        case $59fc9b849b320ded$var$D.DATA_LOSS:
            return !0;
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $59fc9b849b320ded$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $59fc9b849b320ded$var$__PRIVATE_logError("GRPC error has no .code"), $59fc9b849b320ded$var$D.UNKNOWN;
    switch(e){
        case $59fc9b849b320ded$var$ae.OK:
            return $59fc9b849b320ded$var$D.OK;
        case $59fc9b849b320ded$var$ae.CANCELLED:
            return $59fc9b849b320ded$var$D.CANCELLED;
        case $59fc9b849b320ded$var$ae.UNKNOWN:
            return $59fc9b849b320ded$var$D.UNKNOWN;
        case $59fc9b849b320ded$var$ae.DEADLINE_EXCEEDED:
            return $59fc9b849b320ded$var$D.DEADLINE_EXCEEDED;
        case $59fc9b849b320ded$var$ae.RESOURCE_EXHAUSTED:
            return $59fc9b849b320ded$var$D.RESOURCE_EXHAUSTED;
        case $59fc9b849b320ded$var$ae.INTERNAL:
            return $59fc9b849b320ded$var$D.INTERNAL;
        case $59fc9b849b320ded$var$ae.UNAVAILABLE:
            return $59fc9b849b320ded$var$D.UNAVAILABLE;
        case $59fc9b849b320ded$var$ae.UNAUTHENTICATED:
            return $59fc9b849b320ded$var$D.UNAUTHENTICATED;
        case $59fc9b849b320ded$var$ae.INVALID_ARGUMENT:
            return $59fc9b849b320ded$var$D.INVALID_ARGUMENT;
        case $59fc9b849b320ded$var$ae.NOT_FOUND:
            return $59fc9b849b320ded$var$D.NOT_FOUND;
        case $59fc9b849b320ded$var$ae.ALREADY_EXISTS:
            return $59fc9b849b320ded$var$D.ALREADY_EXISTS;
        case $59fc9b849b320ded$var$ae.PERMISSION_DENIED:
            return $59fc9b849b320ded$var$D.PERMISSION_DENIED;
        case $59fc9b849b320ded$var$ae.FAILED_PRECONDITION:
            return $59fc9b849b320ded$var$D.FAILED_PRECONDITION;
        case $59fc9b849b320ded$var$ae.ABORTED:
            return $59fc9b849b320ded$var$D.ABORTED;
        case $59fc9b849b320ded$var$ae.OUT_OF_RANGE:
            return $59fc9b849b320ded$var$D.OUT_OF_RANGE;
        case $59fc9b849b320ded$var$ae.UNIMPLEMENTED:
            return $59fc9b849b320ded$var$D.UNIMPLEMENTED;
        case $59fc9b849b320ded$var$ae.DATA_LOSS:
            return $59fc9b849b320ded$var$D.DATA_LOSS;
        default:
            return $59fc9b849b320ded$var$fail();
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($59fc9b849b320ded$var$ue = $59fc9b849b320ded$var$ae || ($59fc9b849b320ded$var$ae = {}))[$59fc9b849b320ded$var$ue.OK = 0] = "OK", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.CANCELLED = 1] = "CANCELLED", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.UNKNOWN = 2] = "UNKNOWN", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.NOT_FOUND = 5] = "NOT_FOUND", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.ABORTED = 10] = "ABORTED", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.INTERNAL = 13] = "INTERNAL", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.UNAVAILABLE = 14] = "UNAVAILABLE", $59fc9b849b320ded$var$ue[$59fc9b849b320ded$var$ue.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ var $59fc9b849b320ded$var$ce = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance the instance to set.
 */ /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $59fc9b849b320ded$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$le = new (0, $bcffdc5a8182d43d$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $59fc9b849b320ded$var$__PRIVATE_getMd5HashValue(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $bcffdc5a8182d43d$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $59fc9b849b320ded$var$__PRIVATE_get64BitUints(e) {
    var t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $bcffdc5a8182d43d$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $bcffdc5a8182d43d$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
var $59fc9b849b320ded$var$BloomFilter = /*#__PURE__*/ function() {
    "use strict";
    function BloomFilter(e, t, n) {
        (0, $978gY._)(this, BloomFilter);
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $59fc9b849b320ded$var$__PRIVATE_BloomFilterError("Invalid padding: ".concat(t));
        if (n < 0) throw new $59fc9b849b320ded$var$__PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $59fc9b849b320ded$var$__PRIVATE_BloomFilterError("Invalid hash count: ".concat(n));
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $59fc9b849b320ded$var$__PRIVATE_BloomFilterError("Invalid padding when bitmap length is 0: ".concat(t));
        this.Ae = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.Re = (0, $bcffdc5a8182d43d$export$70ffa26850098d01).fromNumber(this.Ae);
    }
    (0, $kry2a._)(BloomFilter, [
        {
            // Calculate the ith hash value based on the hashed 64bit integers,
            // and calculate its corresponding bit index in the bitmap to be checked.
            key: "Ve",
            value: function Ve(e, t, n) {
                // Calculate hashed value h(i) = h1 + (i * h2).
                var r = e.add(t.multiply((0, $bcffdc5a8182d43d$export$70ffa26850098d01).fromNumber(n)));
                // Wrap if hash value overflow 64bit.
                return 1 === r.compare($59fc9b849b320ded$var$le) && (r = new (0, $bcffdc5a8182d43d$export$70ffa26850098d01)([
                    r.getBits(0),
                    r.getBits(1)
                ], 0)), r.modulo(this.Re).toNumber();
            }
        },
        {
            // Return whether the bit on the given index in the bitmap is set to 1.
            key: "me",
            value: function me(e) {
                return 0 != (this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
            }
        },
        {
            key: "mightContain",
            value: function mightContain(e) {
                // Empty bitmap should always return false on membership check.
                if (0 === this.Ae) return !1;
                var t = $59fc9b849b320ded$var$__PRIVATE_getMd5HashValue(e), _$__PRIVATE_get64BitUints = (0, $8GFUW._)($59fc9b849b320ded$var$__PRIVATE_get64BitUints(t), 2), n = _$__PRIVATE_get64BitUints[0], r = _$__PRIVATE_get64BitUints[1];
                for(var _$e = 0; _$e < this.hashCount; _$e++){
                    var t1 = this.Ve(n, r, _$e);
                    if (!this.me(t1)) return !1;
                }
                return !0;
            }
        },
        {
            key: "insert",
            value: function insert(e) {
                if (0 === this.Ae) return;
                var t = $59fc9b849b320ded$var$__PRIVATE_getMd5HashValue(e), _$__PRIVATE_get64BitUints = (0, $8GFUW._)($59fc9b849b320ded$var$__PRIVATE_get64BitUints(t), 2), n = _$__PRIVATE_get64BitUints[0], r = _$__PRIVATE_get64BitUints[1];
                for(var _$e = 0; _$e < this.hashCount; _$e++){
                    var t1 = this.Ve(n, r, _$e);
                    this.fe(t1);
                }
            }
        },
        {
            key: "fe",
            value: function fe(e) {
                var t = Math.floor(e / 8), n = e % 8;
                this.bitmap[t] |= 1 << n;
            }
        }
    ], [
        {
            key: "create",
            value: /** Create bloom filter for testing purposes only. */ function create(e, t, n) {
                var r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new BloomFilter(i, r, t);
                return n.forEach(function(e) {
                    return s.insert(e);
                }), s;
            }
        }
    ]);
    return BloomFilter;
}();
var $59fc9b849b320ded$var$__PRIVATE_BloomFilterError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_BloomFilterError, Error1);
    var _super = (0, $6OZAO._)(__PRIVATE_BloomFilterError);
    function __PRIVATE_BloomFilterError() {
        (0, $978gY._)(this, __PRIVATE_BloomFilterError);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat(Array.prototype.slice.call(arguments))), _this.name = "BloomFilterError";
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_BloomFilterError;
}((0, $2TMdq._)(Error));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ var $59fc9b849b320ded$var$RemoteEvent = /*#__PURE__*/ function() {
    "use strict";
    function RemoteEvent(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ i) {
        (0, $978gY._)(this, RemoteEvent);
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.resolvedLimboDocuments = i;
    }
    (0, $kry2a._)(RemoteEvent, null, [
        {
            key: "createSynthesizedRemoteEventForCurrentChange",
            value: /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
            function createSynthesizedRemoteEventForCurrentChange(e, t, n) {
                var r = new Map;
                return r.set(e, $59fc9b849b320ded$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new RemoteEvent($59fc9b849b320ded$var$SnapshotVersion.min(), r, new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$var$__PRIVATE_primitiveComparator), $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap(), $59fc9b849b320ded$var$__PRIVATE_documentKeySet());
            }
        }
    ]);
    return RemoteEvent;
}();
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ var $59fc9b849b320ded$var$TargetChange = /*#__PURE__*/ function() {
    "use strict";
    function TargetChange(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i) {
        (0, $978gY._)(this, TargetChange);
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    (0, $kry2a._)(TargetChange, null, [
        {
            key: "createSynthesizedTargetChangeForCurrentChange",
            value: /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ function createSynthesizedTargetChangeForCurrentChange(e, t, n) {
                return new TargetChange(n, t, $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), $59fc9b849b320ded$var$__PRIVATE_documentKeySet());
            }
        }
    ]);
    return TargetChange;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ var $59fc9b849b320ded$var$__PRIVATE_DocumentWatchChange = function __PRIVATE_DocumentWatchChange(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_DocumentWatchChange);
    this.ge = e, this.removedTargetIds = t, this.key = n, this.pe = r;
};
var $59fc9b849b320ded$var$__PRIVATE_ExistenceFilterChange = function __PRIVATE_ExistenceFilterChange(e, t) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_ExistenceFilterChange);
    this.targetId = e, this.ye = t;
};
var $59fc9b849b320ded$var$__PRIVATE_WatchTargetChange = function __PRIVATE_WatchTargetChange(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t) {
    "use strict";
    var /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    (0, $978gY._)(this, __PRIVATE_WatchTargetChange);
    this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
};
/** Tracks the internal state of a Watch target. */ var $59fc9b849b320ded$var$__PRIVATE_TargetState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetState() {
        (0, $978gY._)(this, __PRIVATE_TargetState);
        /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.we = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Se = $59fc9b849b320ded$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.be = $59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING, this.De = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Ce = !0;
    }
    (0, $kry2a._)(__PRIVATE_TargetState, [
        {
            key: "current",
            get: /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ function get() {
                return this.De;
            }
        },
        {
            key: "resumeToken",
            get: /** The last resume token sent to us for this target. */ function get() {
                return this.be;
            }
        },
        {
            key: "ve",
            get: /** Whether this target has pending target adds or target removes. */ function get() {
                return 0 !== this.we;
            }
        },
        {
            key: "Fe",
            get: /** Whether we have modified any state that should trigger a snapshot. */ function get() {
                return this.Ce;
            }
        },
        {
            /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ key: "Me",
            value: function Me(e) {
                e.approximateByteSize() > 0 && (this.Ce = !0, this.be = e);
            }
        },
        {
            /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ key: "xe",
            value: function xe() {
                var e = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), t = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), n = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                return this.Se.forEach(function(r, i) {
                    switch(i){
                        case 0 /* ChangeType.Added */ :
                            e = e.add(r);
                            break;
                        case 2 /* ChangeType.Modified */ :
                            t = t.add(r);
                            break;
                        case 1 /* ChangeType.Removed */ :
                            n = n.add(r);
                            break;
                        default:
                            $59fc9b849b320ded$var$fail();
                    }
                }), new $59fc9b849b320ded$var$TargetChange(this.be, this.De, e, t, n);
            }
        },
        {
            /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ key: "Oe",
            value: function Oe() {
                this.Ce = !1, this.Se = $59fc9b849b320ded$var$__PRIVATE_snapshotChangesMap();
            }
        },
        {
            key: "Ne",
            value: function Ne(e, t) {
                this.Ce = !0, this.Se = this.Se.insert(e, t);
            }
        },
        {
            key: "Be",
            value: function Be(e) {
                this.Ce = !0, this.Se = this.Se.remove(e);
            }
        },
        {
            key: "Le",
            value: function Le() {
                this.we += 1;
            }
        },
        {
            key: "ke",
            value: function ke() {
                this.we -= 1;
            }
        },
        {
            key: "qe",
            value: function qe() {
                this.Ce = !0, this.De = !0;
            }
        }
    ]);
    return __PRIVATE_TargetState;
}();
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ var $59fc9b849b320ded$var$__PRIVATE_WatchChangeAggregator = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_WatchChangeAggregator(e) {
        (0, $978gY._)(this, __PRIVATE_WatchChangeAggregator);
        this.Qe = e, /** The internal state of all tracked targets. */ this.Ke = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.$e = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.Ue = $59fc9b849b320ded$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.We = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$var$__PRIVATE_primitiveComparator);
    }
    (0, $kry2a._)(__PRIVATE_WatchChangeAggregator, [
        {
            /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ key: "Ge",
            value: function Ge(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e.ge[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        e.pe && e.pe.isFoundDocument() ? this.ze(t, e.pe) : this.je(t, e.key, e.pe);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = e.removedTargetIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var t1 = _step1.value;
                        this.je(t1, e.key, e.pe);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            /** Processes and adds the WatchTargetChange to the current set of changes. */ key: "He",
            value: function He(e) {
                var _this = this;
                this.forEachTarget(e, function(t) {
                    var n = _this.Je(t);
                    switch(e.state){
                        case 0 /* WatchTargetChangeState.NoChange */ :
                            _this.Ye(t) && n.Me(e.resumeToken);
                            break;
                        case 1 /* WatchTargetChangeState.Added */ :
                            // We need to decrement the number of pending acks needed from watch
                            // for this targetId.
                            n.ke(), n.ve || // We have a freshly added target, so we need to reset any state
                            // that we had previously. This can happen e.g. when remove and add
                            // back a target for existence filter mismatches.
                            n.Oe(), n.Me(e.resumeToken);
                            break;
                        case 2 /* WatchTargetChangeState.Removed */ :
                            // We need to keep track of removed targets to we can post-filter and
                            // remove any target changes.
                            // We need to decrement the number of pending acks needed from watch
                            // for this targetId.
                            n.ke(), n.ve || _this.removeTarget(t);
                            break;
                        case 3 /* WatchTargetChangeState.Current */ :
                            _this.Ye(t) && (n.qe(), n.Me(e.resumeToken));
                            break;
                        case 4 /* WatchTargetChangeState.Reset */ :
                            _this.Ye(t) && // Reset the target and synthesizes removes for all existing
                            // documents. The backend will re-add any documents that still
                            // match the target before it sends the next global snapshot.
                            (_this.Ze(t), n.Me(e.resumeToken));
                            break;
                        default:
                            $59fc9b849b320ded$var$fail();
                    }
                });
            }
        },
        {
            /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ key: "forEachTarget",
            value: function forEachTarget(e, t) {
                var _this = this;
                e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.Ke.forEach(function(e, n) {
                    _this.Ye(n) && t(n);
                });
            }
        },
        {
            /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ key: "Xe",
            value: function Xe(e) {
                var t = e.targetId, n = e.ye.count, r = this.et(t);
                if (r) {
                    var i = r.target;
                    if ($59fc9b849b320ded$var$__PRIVATE_targetIsDocumentTarget(i)) {
                        if (0 === n) {
                            // The existence filter told us the document does not exist. We deduce
                            // that this document does not exist and apply a deleted document to
                            // our updates. Without applying this deleted document there might be
                            // another query that will raise this document as part of a snapshot
                            // until it is resolved, essentially exposing inconsistency between
                            // queries.
                            var _$e = new $59fc9b849b320ded$export$afc2e57c475b7810(i.path);
                            this.je(t, _$e, $59fc9b849b320ded$var$MutableDocument.newNoDocument(_$e, $59fc9b849b320ded$var$SnapshotVersion.min()));
                        } else $59fc9b849b320ded$var$__PRIVATE_hardAssert(1 === n);
                    } else {
                        var r1 = this.tt(t);
                        // Existence filter mismatch. Mark the documents as being in limbo, and
                        // raise a snapshot with `isFromCache:true`.
                        if (r1 !== n) {
                            // Apply bloom filter to identify and mark removed documents.
                            var n1 = this.nt(e), i1 = n1 ? this.rt(n1, e, r1) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                            if (0 /* BloomFilterApplicationStatus.Success */  !== i1) {
                                // If bloom filter application fails, we reset the mapping and
                                // trigger re-run of the query.
                                this.Ze(t);
                                var _$e1 = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i1 ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                                this.We = this.We.insert(t, _$e1);
                            }
                            null == $59fc9b849b320ded$var$ce || $59fc9b849b320ded$var$ce.it(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                                var s, o, _, a, u, c;
                                var l = {
                                    localCacheCount: e,
                                    existenceFilterCount: t.count,
                                    databaseId: n.database,
                                    projectId: n.projectId
                                }, h = t.unchangedNames;
                                h && (l.bloomFilter = {
                                    applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                                    hashCount: null !== (s = null == h ? void 0 : h.hashCount) && void 0 !== s ? s : 0,
                                    bitmapLength: null !== (a = null === (_ = null === (o = null == h ? void 0 : h.bits) || void 0 === o ? void 0 : o.bitmap) || void 0 === _ ? void 0 : _.length) && void 0 !== a ? a : 0,
                                    padding: null !== (c = null === (u = null == h ? void 0 : h.bits) || void 0 === u ? void 0 : u.padding) && void 0 !== c ? c : 0,
                                    mightContain: function(e) {
                                        var _$t;
                                        return null !== (_$t = null == r ? void 0 : r.mightContain(e)) && void 0 !== _$t && _$t;
                                    }
                                });
                                return l;
                            }(r1, e.ye, this.Qe.st(), n1, i1));
                        }
                    }
                }
            }
        },
        {
            /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ key: "nt",
            value: function nt(e) {
                var t = e.ye.unchangedNames;
                if (!t || !t.bits) return null;
                var _t_bits = t.bits, tmp = _t_bits.bitmap, n = tmp === void 0 ? "" : tmp, tmp1 = _t_bits.padding, r = tmp1 === void 0 ? 0 : tmp1, tmp2 = t.hashCount, i = tmp2 === void 0 ? 0 : tmp2;
                var s, o;
                try {
                    s = $59fc9b849b320ded$var$__PRIVATE_normalizeByteString(n).toUint8Array();
                } catch (e) {
                    if (e instanceof $59fc9b849b320ded$var$__PRIVATE_Base64DecodeError) return $59fc9b849b320ded$export$86cd73f49cc6e0bb("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
                    throw e;
                }
                try {
                    // BloomFilter throws error if the inputs are invalid.
                    o = new $59fc9b849b320ded$var$BloomFilter(s, r, i);
                } catch (e) {
                    return $59fc9b849b320ded$export$86cd73f49cc6e0bb(e instanceof $59fc9b849b320ded$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
                }
                return 0 === o.Ae ? null : o;
            }
        },
        {
            /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ key: "rt",
            value: function rt(e, t, n) {
                return t.ye.count === n - this.ot(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
            }
        },
        {
            /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ key: "ot",
            value: function ot(e, t) {
                var _this = this;
                var n = this.Qe.getRemoteKeysForTarget(t);
                var r = 0;
                return n.forEach(function(n) {
                    var i = _this.Qe.st(), s = "projects/".concat(i.projectId, "/databases/").concat(i.database, "/documents/").concat(n.path.canonicalString());
                    e.mightContain(s) || (_this.je(t, n, /*updatedDocument=*/ null), r++);
                }), r;
            }
        },
        {
            /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ key: "_t",
            value: function _t(e) {
                var _this = this;
                var t = new Map;
                this.Ke.forEach(function(n, r) {
                    var i = _this.et(r);
                    if (i) {
                        if (n.current && $59fc9b849b320ded$var$__PRIVATE_targetIsDocumentTarget(i.target)) {
                            // Document queries for document that don't exist can produce an empty
                            // result set. To update our local cache, we synthesize a document
                            // delete if we have not previously received the document. This
                            // resolves the limbo state of the document, removing it from
                            // limboDocumentRefs.
                            // TODO(dimond): Ideally we would have an explicit lookup target
                            // instead resulting in an explicit delete message and we could
                            // remove this special logic.
                            var t1 = new $59fc9b849b320ded$export$afc2e57c475b7810(i.target.path);
                            null !== _this.$e.get(t1) || _this.ut(r, t1) || _this.je(r, t1, $59fc9b849b320ded$var$MutableDocument.newNoDocument(t1, e));
                        }
                        n.Fe && (t.set(r, n.xe()), n.Oe());
                    }
                });
                var n = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                // We extract the set of limbo-only document updates as the GC logic
                // special-cases documents that do not appear in the target cache.
                // TODO(gsoltis): Expand on this comment once GC is available in the JS
                // client.
                this.Ue.forEach(function(e, t) {
                    var r = !0;
                    t.forEachWhile(function(e) {
                        var _$t = _this.et(e);
                        return !_$t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === _$t.purpose || (r = !1, !1);
                    }), r && (n = n.add(e));
                }), this.$e.forEach(function(t, n) {
                    return n.setReadTime(e);
                });
                var r = new $59fc9b849b320ded$var$RemoteEvent(e, t, this.We, this.$e, n);
                return this.$e = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap(), this.Ue = $59fc9b849b320ded$var$__PRIVATE_documentTargetMap(), this.We = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$var$__PRIVATE_primitiveComparator), r;
            }
        },
        {
            /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
            key: "ze",
            value: function ze(e, t) {
                if (!this.Ye(e)) return;
                var n = this.ut(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
                this.Je(e).Ne(t.key, n), this.$e = this.$e.insert(t.key, t), this.Ue = this.Ue.insert(t.key, this.ct(t.key).add(e));
            }
        },
        {
            /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
            key: "je",
            value: function je(e, t, n) {
                if (!this.Ye(e)) return;
                var r = this.Je(e);
                this.ut(e, t) ? r.Ne(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
                // snapshot, so we can just ignore the change.
                r.Be(t), this.Ue = this.Ue.insert(t, this.ct(t).delete(e)), n && (this.$e = this.$e.insert(t, n));
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e) {
                this.Ke.delete(e);
            }
        },
        {
            /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ key: "tt",
            value: function tt(e) {
                var t = this.Je(e).xe();
                return this.Qe.getRemoteKeysForTarget(e).size + t.addedDocuments.size - t.removedDocuments.size;
            }
        },
        {
            /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ key: "Le",
            value: function Le(e) {
                this.Je(e).Le();
            }
        },
        {
            key: "Je",
            value: function Je(e) {
                var t = this.Ke.get(e);
                return t || (t = new $59fc9b849b320ded$var$__PRIVATE_TargetState, this.Ke.set(e, t)), t;
            }
        },
        {
            key: "ct",
            value: function ct(e) {
                var t = this.Ue.get(e);
                return t || (t = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_primitiveComparator), this.Ue = this.Ue.insert(e, t)), t;
            }
        },
        {
            /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ key: "Ye",
            value: function Ye(e) {
                var t = null !== this.et(e);
                return t || $59fc9b849b320ded$var$__PRIVATE_logDebug("WatchChangeAggregator", "Detected inactive target", e), t;
            }
        },
        {
            /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ key: "et",
            value: function et(e) {
                var t = this.Ke.get(e);
                return t && t.ve ? null : this.Qe.lt(e);
            }
        },
        {
            /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ key: "Ze",
            value: function Ze(e) {
                var _this = this;
                this.Ke.set(e, new $59fc9b849b320ded$var$__PRIVATE_TargetState);
                this.Qe.getRemoteKeysForTarget(e).forEach(function(t) {
                    _this.je(e, t, /*updatedDocument=*/ null);
                });
            }
        },
        {
            /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ key: "ut",
            value: function ut(e, t) {
                return this.Qe.getRemoteKeysForTarget(e).has(t);
            }
        }
    ]);
    return __PRIVATE_WatchChangeAggregator;
}();
function $59fc9b849b320ded$var$__PRIVATE_documentTargetMap() {
    return new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
}
function $59fc9b849b320ded$var$__PRIVATE_snapshotChangesMap() {
    return new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
}
var $59fc9b849b320ded$var$he = function() {
    var e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
}(), $59fc9b849b320ded$var$Pe = function() {
    var e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
}(), $59fc9b849b320ded$var$Ie = function() {
    var e = {
        and: "AND",
        or: "OR"
    };
    return e;
}();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ var $59fc9b849b320ded$var$JsonProtoSerializer = function JsonProtoSerializer(e, t) {
    "use strict";
    (0, $978gY._)(this, JsonProtoSerializer);
    this.databaseId = e, this.useProto3Json = t;
};
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $59fc9b849b320ded$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $59fc9b849b320ded$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $59fc9b849b320ded$var$toTimestamp(e, t) {
    if (e.useProto3Json) return "".concat(new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", ""), ".").concat(("000000000" + t.nanoseconds).slice(-9), "Z");
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $59fc9b849b320ded$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $59fc9b849b320ded$var$__PRIVATE_toVersion(e, t) {
    return $59fc9b849b320ded$var$toTimestamp(e, t.toTimestamp());
}
function $59fc9b849b320ded$var$__PRIVATE_fromVersion(e) {
    return $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!e), $59fc9b849b320ded$var$SnapshotVersion.fromTimestamp(function fromTimestamp(e) {
        var t = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(e);
        return new $59fc9b849b320ded$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
    }(e));
}
function $59fc9b849b320ded$var$__PRIVATE_toResourceName(e, t) {
    return (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $59fc9b849b320ded$var$ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents").child(t).canonicalString();
}
function $59fc9b849b320ded$var$__PRIVATE_fromResourceName(e) {
    var t = $59fc9b849b320ded$var$ResourcePath.fromString(e);
    return $59fc9b849b320ded$var$__PRIVATE_hardAssert($59fc9b849b320ded$var$__PRIVATE_isValidResourceName(t)), t;
}
function $59fc9b849b320ded$var$__PRIVATE_toName(e, t) {
    return $59fc9b849b320ded$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $59fc9b849b320ded$var$fromName(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $59fc9b849b320ded$export$afc2e57c475b7810($59fc9b849b320ded$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $59fc9b849b320ded$var$__PRIVATE_toQueryPath(e, t) {
    return $59fc9b849b320ded$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $59fc9b849b320ded$var$__PRIVATE_fromQueryPath(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $59fc9b849b320ded$var$ResourcePath.emptyPath() : $59fc9b849b320ded$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $59fc9b849b320ded$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $59fc9b849b320ded$var$ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $59fc9b849b320ded$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $59fc9b849b320ded$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4)), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $59fc9b849b320ded$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $59fc9b849b320ded$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $59fc9b849b320ded$var$__PRIVATE_fromDocument(e, t, n) {
    var r = $59fc9b849b320ded$var$fromName(e, t.name), i = $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.createTime) : $59fc9b849b320ded$var$SnapshotVersion.min(), o = new $59fc9b849b320ded$var$ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), _ = $59fc9b849b320ded$var$MutableDocument.newFoundDocument(r, i, s, o);
    return n && _.setHasCommittedMutations(), n ? _.setHasCommittedMutations() : _;
}
function $59fc9b849b320ded$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!t.found), t.found.name, t.found.updateTime;
        var n = $59fc9b849b320ded$var$fromName(e, t.found.name), r = $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.found.createTime) : $59fc9b849b320ded$var$SnapshotVersion.min(), s = new $59fc9b849b320ded$var$ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $59fc9b849b320ded$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!t.missing), $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!t.readTime);
        var n = $59fc9b849b320ded$var$fromName(e, t.missing), r = $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.readTime);
        return $59fc9b849b320ded$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$var$__PRIVATE_fromWatchChange(e, t) {
    var n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        var r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $59fc9b849b320ded$var$fail();
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($59fc9b849b320ded$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t), $59fc9b849b320ded$export$67460cdabfa21253.fromBase64String(t || "")) : ($59fc9b849b320ded$var$__PRIVATE_hardAssert(void 0 === t || t instanceof Uint8Array), $59fc9b849b320ded$export$67460cdabfa21253.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), o = t.targetChange.cause, _ = o && function __PRIVATE_fromRpcStatus(e) {
            var _$t = void 0 === e.code ? $59fc9b849b320ded$var$D.UNKNOWN : $59fc9b849b320ded$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $59fc9b849b320ded$export$8fada0bf726bf278(_$t, e.message || "");
        }(o);
        n = new $59fc9b849b320ded$var$__PRIVATE_WatchTargetChange(r, i, s, _ || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        var r1 = t.documentChange;
        r1.document, r1.document.name, r1.document.updateTime;
        var i1 = $59fc9b849b320ded$var$fromName(e, r1.document.name), s1 = $59fc9b849b320ded$var$__PRIVATE_fromVersion(r1.document.updateTime), o1 = r1.document.createTime ? $59fc9b849b320ded$var$__PRIVATE_fromVersion(r1.document.createTime) : $59fc9b849b320ded$var$SnapshotVersion.min(), _1 = new $59fc9b849b320ded$var$ObjectValue({
            mapValue: {
                fields: r1.document.fields
            }
        }), a = $59fc9b849b320ded$var$MutableDocument.newFoundDocument(i1, s1, o1, _1), u = r1.targetIds || [], c = r1.removedTargetIds || [];
        n = new $59fc9b849b320ded$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        var r2 = t.documentDelete;
        r2.document;
        var i2 = $59fc9b849b320ded$var$fromName(e, r2.document), s2 = r2.readTime ? $59fc9b849b320ded$var$__PRIVATE_fromVersion(r2.readTime) : $59fc9b849b320ded$var$SnapshotVersion.min(), o2 = $59fc9b849b320ded$var$MutableDocument.newNoDocument(i2, s2), _2 = r2.removedTargetIds || [];
        n = new $59fc9b849b320ded$var$__PRIVATE_DocumentWatchChange([], _2, o2.key, o2);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        var r3 = t.documentRemove;
        r3.document;
        var i3 = $59fc9b849b320ded$var$fromName(e, r3.document), s3 = r3.removedTargetIds || [];
        n = new $59fc9b849b320ded$var$__PRIVATE_DocumentWatchChange([], s3, i3, null);
    } else {
        if (!("filter" in t)) return $59fc9b849b320ded$var$fail();
        {
            t.filter;
            var _$e = t.filter;
            _$e.targetId;
            var tmp = _$e.count, r4 = tmp === void 0 ? 0 : tmp, i4 = _$e.unchangedNames, s4 = new $59fc9b849b320ded$var$ExistenceFilter(r4, i4), o3 = _$e.targetId;
            n = new $59fc9b849b320ded$var$__PRIVATE_ExistenceFilterChange(o3, s4);
        }
    }
    return n;
}
function $59fc9b849b320ded$var$toMutation(e, t) {
    var n;
    if (t instanceof $59fc9b849b320ded$var$__PRIVATE_SetMutation) n = {
        update: $59fc9b849b320ded$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $59fc9b849b320ded$var$__PRIVATE_DeleteMutation) n = {
        delete: $59fc9b849b320ded$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $59fc9b849b320ded$var$__PRIVATE_PatchMutation) n = {
        update: $59fc9b849b320ded$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $59fc9b849b320ded$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $59fc9b849b320ded$var$__PRIVATE_VerifyMutation)) return $59fc9b849b320ded$var$fail();
        n = {
            verify: $59fc9b849b320ded$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map(function(e) {
        return function __PRIVATE_toFieldTransform(e, t) {
            var n = t.transform;
            if (n instanceof $59fc9b849b320ded$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $59fc9b849b320ded$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Te
            };
            throw $59fc9b849b320ded$var$fail();
        }(0, e);
    })), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $59fc9b849b320ded$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $59fc9b849b320ded$var$fail();
    }(e, t.precondition)), n;
}
function $59fc9b849b320ded$var$__PRIVATE_fromMutation(e, t) {
    var n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $59fc9b849b320ded$var$Precondition.updateTime($59fc9b849b320ded$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $59fc9b849b320ded$var$Precondition.exists(e.exists) : $59fc9b849b320ded$var$Precondition.none();
    }(t.currentDocument) : $59fc9b849b320ded$var$Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map(function(t) {
        return function __PRIVATE_fromFieldTransform(e, t) {
            var n = null;
            if ("setToServerValue" in t) $59fc9b849b320ded$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue), n = new $59fc9b849b320ded$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                var _$e = t.appendMissingElements.values || [];
                n = new $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation(_$e);
            } else if ("removeAllFromArray" in t) {
                var _$e1 = t.removeAllFromArray.values || [];
                n = new $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation(_$e1);
            } else "increment" in t ? n = new $59fc9b849b320ded$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : $59fc9b849b320ded$var$fail();
            var r = $59fc9b849b320ded$export$b7871852b967eaf1.fromServerFormat(t.fieldPath);
            return new $59fc9b849b320ded$var$FieldTransform(r, n);
        }(e, t);
    }) : [];
    if (t.update) {
        t.update.name;
        var i = $59fc9b849b320ded$var$fromName(e, t.update.name), s = new $59fc9b849b320ded$var$ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            var _$e = function __PRIVATE_fromDocumentMask(e) {
                var _$t = e.fieldPaths || [];
                return new $59fc9b849b320ded$var$FieldMask(_$t.map(function(e) {
                    return $59fc9b849b320ded$export$b7871852b967eaf1.fromServerFormat(e);
                }));
            }(t.updateMask);
            return new $59fc9b849b320ded$var$__PRIVATE_PatchMutation(i, s, _$e, n, r);
        }
        return new $59fc9b849b320ded$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        var r1 = $59fc9b849b320ded$var$fromName(e, t.delete);
        return new $59fc9b849b320ded$var$__PRIVATE_DeleteMutation(r1, n);
    }
    if (t.verify) {
        var r2 = $59fc9b849b320ded$var$fromName(e, t.verify);
        return new $59fc9b849b320ded$var$__PRIVATE_VerifyMutation(r2, n);
    }
    return $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($59fc9b849b320ded$var$__PRIVATE_hardAssert(void 0 !== t), e.map(function(e) {
        return function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            var n = e.updateTime ? $59fc9b849b320ded$var$__PRIVATE_fromVersion(e.updateTime) : $59fc9b849b320ded$var$__PRIVATE_fromVersion(t);
            return n.isEqual($59fc9b849b320ded$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $59fc9b849b320ded$var$__PRIVATE_fromVersion(t)), new $59fc9b849b320ded$var$MutationResult(n, e.transformResults || []);
        }(e, t);
    })) : [];
}
function $59fc9b849b320ded$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $59fc9b849b320ded$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $59fc9b849b320ded$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    var n = {
        structuredQuery: {}
    }, r = t.path;
    null !== t.collectionGroup ? (n.parent = $59fc9b849b320ded$var$__PRIVATE_toQueryPath(e, r), n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (n.parent = $59fc9b849b320ded$var$__PRIVATE_toQueryPath(e, r.popLast()), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]);
    var i = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $59fc9b849b320ded$var$__PRIVATE_toFilter($59fc9b849b320ded$var$CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    i && (n.structuredQuery.where = i);
    var s = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map(function(e) {
            return(// visible for testing
            function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $59fc9b849b320ded$var$__PRIVATE_toDirection(e.dir)
                };
            }(e));
        });
    }(t.orderBy);
    s && (n.structuredQuery.orderBy = s);
    var o = $59fc9b849b320ded$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== o && (n.structuredQuery.limit = o), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), n;
}
function $59fc9b849b320ded$var$__PRIVATE_convertQueryTargetToQuery(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_fromQueryPath(e.parent);
    var n = e.structuredQuery, r = n.from ? n.from.length : 0;
    var i = null;
    if (r > 0) {
        $59fc9b849b320ded$var$__PRIVATE_hardAssert(1 === r);
        var _$e = n.from[0];
        _$e.allDescendants ? i = _$e.collectionId : t = t.child(_$e.collectionId);
    }
    var s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        var t = $59fc9b849b320ded$var$__PRIVATE_fromFilter(e);
        if (t instanceof $59fc9b849b320ded$var$CompositeFilter && $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    var o = [];
    n.orderBy && (o = function __PRIVATE_fromOrder(e) {
        return e.map(function(e) {
            return function __PRIVATE_fromPropertyOrder(e) {
                return new $59fc9b849b320ded$var$OrderBy($59fc9b849b320ded$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            }(e);
        });
    }(n.orderBy));
    var _ = null;
    n.limit && (_ = function __PRIVATE_fromInt32Proto(e) {
        var t;
        return t = "object" == typeof e ? e.value : e, $59fc9b849b320ded$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    var a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        var t = !!e.before, n = e.values || [];
        return new $59fc9b849b320ded$var$Bound(n, t);
    }(n.startAt));
    var u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        var t = !e.before, n = e.values || [];
        return new $59fc9b849b320ded$var$Bound(n, t);
    }(n.endAt)), $59fc9b849b320ded$var$__PRIVATE_newQuery(t, i, o, s, _, "F" /* LimitType.First */ , a, u);
}
function $59fc9b849b320ded$var$__PRIVATE_toListenRequestLabels(e, t) {
    var n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $59fc9b849b320ded$var$fail();
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $59fc9b849b320ded$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                var t = $59fc9b849b320ded$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $59fc9b849b320ded$var$FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                var n = $59fc9b849b320ded$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $59fc9b849b320ded$var$FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                var r = $59fc9b849b320ded$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $59fc9b849b320ded$var$FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                var i = $59fc9b849b320ded$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $59fc9b849b320ded$var$FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            default:
                return $59fc9b849b320ded$var$fail();
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $59fc9b849b320ded$var$FieldFilter.create($59fc9b849b320ded$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                default:
                    return $59fc9b849b320ded$var$fail();
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $59fc9b849b320ded$var$CompositeFilter.create(e.compositeFilter.filters.map(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_fromFilter(e);
        }), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $59fc9b849b320ded$var$fail();
            }
        }(e.compositeFilter.op));
    }(e) : $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$var$__PRIVATE_toDirection(e) {
    return $59fc9b849b320ded$var$he[e];
}
function $59fc9b849b320ded$var$__PRIVATE_toOperatorName(e) {
    return $59fc9b849b320ded$var$Pe[e];
}
function $59fc9b849b320ded$var$__PRIVATE_toCompositeOperatorName(e) {
    return $59fc9b849b320ded$var$Ie[e];
}
function $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $59fc9b849b320ded$var$__PRIVATE_fromFieldPathReference(e) {
    return $59fc9b849b320ded$export$b7871852b967eaf1.fromServerFormat(e.fieldPath);
}
function $59fc9b849b320ded$var$__PRIVATE_toFilter(e) {
    return e instanceof $59fc9b849b320ded$var$FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($59fc9b849b320ded$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($59fc9b849b320ded$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($59fc9b849b320ded$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($59fc9b849b320ded$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.field),
                op: $59fc9b849b320ded$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $59fc9b849b320ded$var$CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        var t = e.getFilters().map(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_toFilter(e);
        });
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $59fc9b849b320ded$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$var$__PRIVATE_toDocumentMask(e) {
    var t = [];
    return e.fields.forEach(function(e) {
        return t.push(e.canonicalString());
    }), {
        fieldPaths: t
    };
}
function $59fc9b849b320ded$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ var $59fc9b849b320ded$var$TargetData = /*#__PURE__*/ function() {
    "use strict";
    function TargetData(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r) {
        var /** The latest snapshot version seen for this target. */ i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : $59fc9b849b320ded$var$SnapshotVersion.min(), s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $59fc9b849b320ded$var$SnapshotVersion.min(), o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING, _ = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null;
        (0, $978gY._)(this, TargetData);
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = o, this.expectedCount = _;
    }
    (0, $kry2a._)(TargetData, [
        {
            /** Creates a new target data instance with an updated sequence number. */ key: "withSequenceNumber",
            value: function withSequenceNumber(e) {
                return new TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ key: "withResumeToken",
            value: function withResumeToken(e, t) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated expected count.
     */ key: "withExpectedCount",
            value: function withExpectedCount(e) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
            }
        },
        {
            /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ key: "withLastLimboFreeSnapshotVersion",
            value: function withLastLimboFreeSnapshotVersion(e) {
                return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
            }
        }
    ]);
    return TargetData;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ var $59fc9b849b320ded$var$__PRIVATE_LocalSerializer = function __PRIVATE_LocalSerializer(e) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_LocalSerializer);
    this.ht = e;
};
/** Decodes a remote document from storage locally to a Document. */ function $59fc9b849b320ded$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    var n;
    if (t.document) n = $59fc9b849b320ded$var$__PRIVATE_fromDocument(e.ht, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        var _$e = $59fc9b849b320ded$export$afc2e57c475b7810.fromSegments(t.noDocument.path), r = $59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $59fc9b849b320ded$var$MutableDocument.newNoDocument(_$e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $59fc9b849b320ded$var$fail();
        {
            var _$e1 = $59fc9b849b320ded$export$afc2e57c475b7810.fromSegments(t.unknownDocument.path), r1 = $59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $59fc9b849b320ded$var$MutableDocument.newUnknownDocument(_$e1, r1);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        var _$t = new $59fc9b849b320ded$export$d9bcbd5e1ff81430(e[0], e[1]);
        return $59fc9b849b320ded$var$SnapshotVersion.fromTimestamp(_$t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $59fc9b849b320ded$var$__PRIVATE_toDbRemoteDocument(e, t) {
    var n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $59fc9b849b320ded$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $59fc9b849b320ded$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $59fc9b849b320ded$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $59fc9b849b320ded$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.ht, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $59fc9b849b320ded$var$fail();
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $59fc9b849b320ded$var$__PRIVATE_toDbTimestampKey(e) {
    var t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp(e) {
    var t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(e) {
    var t = new $59fc9b849b320ded$export$d9bcbd5e1ff81430(e.seconds, e.nanoseconds);
    return $59fc9b849b320ded$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(e, t) {
    var n = (t.baseMutations || []).map(function(t) {
        return $59fc9b849b320ded$var$__PRIVATE_fromMutation(e.ht, t);
    });
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(var e1 = 0; e1 < t.mutations.length - 1; ++e1){
        var n1 = t.mutations[e1];
        if (e1 + 1 < t.mutations.length && void 0 !== t.mutations[e1 + 1].transform) {
            var r = t.mutations[e1 + 1];
            n1.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e1 + 1, 1), ++e1;
        }
    }
    var r1 = t.mutations.map(function(t) {
        return $59fc9b849b320ded$var$__PRIVATE_fromMutation(e.ht, t);
    }), i = $59fc9b849b320ded$export$d9bcbd5e1ff81430.fromMillis(t.localWriteTimeMs);
    return new $59fc9b849b320ded$var$MutationBatch(t.batchId, i, n, r1);
}
/** Decodes a DbTarget into TargetData */ function $59fc9b849b320ded$var$__PRIVATE_fromDbTarget(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(e.readTime), n = void 0 !== e.lastLimboFreeSnapshotVersion ? $59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(e.lastLimboFreeSnapshotVersion) : $59fc9b849b320ded$var$SnapshotVersion.min();
    var r;
    return r = /**
 * A helper function for figuring out what kind of query has been stored.
 */ function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(e.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        return $59fc9b849b320ded$var$__PRIVATE_hardAssert(1 === e.documents.length), $59fc9b849b320ded$var$__PRIVATE_queryToTarget($59fc9b849b320ded$var$__PRIVATE_newQueryForPath($59fc9b849b320ded$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(e.query) : function __PRIVATE_fromQueryTarget(e) {
        return $59fc9b849b320ded$var$__PRIVATE_queryToTarget($59fc9b849b320ded$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(e.query), new $59fc9b849b320ded$var$TargetData(r, e.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.lastListenSequenceNumber, t, n, $59fc9b849b320ded$export$67460cdabfa21253.fromBase64String(e.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $59fc9b849b320ded$var$__PRIVATE_toDbTarget(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    var i;
    i = $59fc9b849b320ded$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $59fc9b849b320ded$var$__PRIVATE_toDocumentsTarget(e.ht, t.target) : $59fc9b849b320ded$var$__PRIVATE_toQueryTarget(e.ht, t.target);
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    var s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $59fc9b849b320ded$var$__PRIVATE_canonifyTarget(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $59fc9b849b320ded$var$__PRIVATE_fromBundledQuery(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $59fc9b849b320ded$var$__PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $59fc9b849b320ded$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $59fc9b849b320ded$var$Overlay(t.largestBatchId, $59fc9b849b320ded$var$__PRIVATE_fromMutation(e.ht, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $59fc9b849b320ded$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    var n = t.path.lastSegment();
    return [
        e,
        $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $59fc9b849b320ded$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t.uid || "",
        sequenceNumber: n,
        readTime: $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbBundleCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbBundleCache() {
        (0, $978gY._)(this, __PRIVATE_IndexedDbBundleCache);
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbBundleCache, [
        {
            key: "getBundleMetadata",
            value: function getBundleMetadata(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_bundlesStore(e).get(t).next(function(e) {
                    if (e) return function __PRIVATE_fromDbBundle(e) {
                        return {
                            id: e.bundleId,
                            createTime: $59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(e.createTime),
                            version: e.version
                        };
                    }(e);
                });
            }
        },
        {
            key: "saveBundleMetadata",
            value: function saveBundleMetadata(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
                    return {
                        bundleId: e.id,
                        createTime: $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp($59fc9b849b320ded$var$__PRIVATE_fromVersion(e.createTime)),
                        version: e.version
                    };
                }(t));
            }
        },
        {
            key: "getNamedQuery",
            value: function getNamedQuery(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_namedQueriesStore(e).get(t).next(function(e) {
                    if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                        return {
                            name: e.name,
                            query: $59fc9b849b320ded$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                            readTime: $59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(e.readTime)
                        };
                    }(e);
                });
            }
        },
        {
            key: "saveNamedQuery",
            value: function saveNamedQuery(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
                    return {
                        name: e.name,
                        readTime: $59fc9b849b320ded$var$__PRIVATE_toDbTimestamp($59fc9b849b320ded$var$__PRIVATE_fromVersion(e.readTime)),
                        bundledQuery: e.bundledQuery
                    };
                }(t));
            }
        }
    ]);
    return __PRIVATE_IndexedDbBundleCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_bundlesStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "bundles");
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_namedQueriesStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "namedQueries");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbDocumentOverlayCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbDocumentOverlayCache(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbDocumentOverlayCache);
        this.serializer = e, this.userId = t;
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbDocumentOverlayCache, [
        {
            key: "getOverlay",
            value: function getOverlay(e, t) {
                var _this = this;
                return $59fc9b849b320ded$var$__PRIVATE_documentOverlayStore(e).get($59fc9b849b320ded$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next(function(e) {
                    return e ? $59fc9b849b320ded$var$__PRIVATE_fromDbDocumentOverlay(_this.serializer, e) : null;
                });
            }
        },
        {
            key: "getOverlays",
            value: function getOverlays(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap();
                return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t) {
                    return _this.getOverlay(e, t).next(function(e) {
                        null !== e && n.set(t, e);
                    });
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "saveOverlays",
            value: function saveOverlays(e, t, n) {
                var _this = this;
                var r = [];
                return n.forEach(function(n, i) {
                    var s = new $59fc9b849b320ded$var$Overlay(t, i);
                    r.push(_this.It(e, s));
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(r);
            }
        },
        {
            key: "removeOverlaysForBatchId",
            value: function removeOverlaysForBatchId(e, t, n) {
                var _this = this;
                var r = new Set;
                // Get the set of unique collection paths.
                t.forEach(function(e) {
                    return r.add($59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(e.getCollectionPath()));
                });
                var i = [];
                return r.forEach(function(t) {
                    var r = IDBKeyRange.bound([
                        _this.userId,
                        t,
                        n
                    ], [
                        _this.userId,
                        t,
                        n + 1
                    ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                    i.push($59fc9b849b320ded$var$__PRIVATE_documentOverlayStore(e).J("collectionPathOverlayIndex", r));
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(i);
            }
        },
        {
            key: "getOverlaysForCollection",
            value: function getOverlaysForCollection(e, t, n) {
                var _this = this;
                var r = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap(), i = $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
                    this.userId,
                    i,
                    n
                ], [
                    this.userId,
                    i,
                    Number.POSITIVE_INFINITY
                ], /*lowerOpen=*/ !0);
                return $59fc9b849b320ded$var$__PRIVATE_documentOverlayStore(e).G("collectionPathOverlayIndex", s).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            var _$e = $59fc9b849b320ded$var$__PRIVATE_fromDbDocumentOverlay(_this.serializer, _$t);
                            r.set(_$e.getKey(), _$e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return r;
                });
            }
        },
        {
            key: "getOverlaysForCollectionGroup",
            value: function getOverlaysForCollectionGroup(e, t, n, r) {
                var _this = this;
                var i = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap();
                var s;
                // We want batch IDs larger than `sinceBatchId`, and so the lower bound
                // is not inclusive.
                var o = IDBKeyRange.bound([
                    this.userId,
                    t,
                    n
                ], [
                    this.userId,
                    t,
                    Number.POSITIVE_INFINITY
                ], /*lowerOpen=*/ !0);
                return $59fc9b849b320ded$var$__PRIVATE_documentOverlayStore(e).Z({
                    index: "collectionGroupOverlayIndex",
                    range: o
                }, function(e, t, n) {
                    // We do not want to return partial batch overlays, even if the size
                    // of the result set exceeds the given `count` argument. Therefore, we
                    // continue to aggregate results even after the result size exceeds
                    // `count` if there are more overlays from the `currentBatchId`.
                    var o = $59fc9b849b320ded$var$__PRIVATE_fromDbDocumentOverlay(_this.serializer, t);
                    i.size() < r || o.largestBatchId === s ? (i.set(o.getKey(), o), s = o.largestBatchId) : n.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "It",
            value: function It(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
                    var _$__PRIVATE_toDbDocumentOverlayKey = (0, $8GFUW._)($59fc9b849b320ded$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key), 3), r = _$__PRIVATE_toDbDocumentOverlayKey[0], i = _$__PRIVATE_toDbDocumentOverlayKey[1], s = _$__PRIVATE_toDbDocumentOverlayKey[2];
                    return {
                        userId: t,
                        collectionPath: i,
                        documentId: s,
                        collectionGroup: n.mutation.key.getCollectionGroup(),
                        largestBatchId: n.largestBatchId,
                        overlayMutation: $59fc9b849b320ded$var$toMutation(e.ht, n.mutation)
                    };
                }(this.serializer, this.userId, t));
            }
        }
    ], [
        {
            key: "Pt",
            value: function Pt(e, t) {
                var n = t.uid || "";
                return new __PRIVATE_IndexedDbDocumentOverlayCache(e, n);
            }
        }
    ]);
    return __PRIVATE_IndexedDbDocumentOverlayCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_documentOverlayStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "documentOverlays");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ var $59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_FirestoreIndexValueWriter() {
        (0, $978gY._)(this, __PRIVATE_FirestoreIndexValueWriter);
    }
    (0, $kry2a._)(__PRIVATE_FirestoreIndexValueWriter, [
        {
            // The write methods below short-circuit writing terminators for values
            // containing a (terminating) truncated value.
            // As an example, consider the resulting encoding for:
            // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
            // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
            // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
            /** Writes an index value.  */ key: "dt",
            value: function dt(e, t) {
                this.Tt(e, t), // Write separator to split index values
                // (see go/firestore-storage-format#encodings).
                t.Et();
            }
        },
        {
            key: "Tt",
            value: function Tt(e, t) {
                if ("nullValue" in e) this.At(t, 5);
                else if ("booleanValue" in e) this.At(t, 10), t.Rt(e.booleanValue ? 1 : 0);
                else if ("integerValue" in e) this.At(t, 15), t.Rt($59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.integerValue));
                else if ("doubleValue" in e) {
                    var n = $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.doubleValue);
                    isNaN(n) ? this.At(t, 13) : (this.At(t, 15), $59fc9b849b320ded$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
                    t.Rt(0) : t.Rt(n));
                } else if ("timestampValue" in e) {
                    var n1 = e.timestampValue;
                    this.At(t, 20), "string" == typeof n1 ? t.Vt(n1) : (t.Vt("".concat(n1.seconds || "")), t.Rt(n1.nanos || 0));
                } else if ("stringValue" in e) this.ft(e.stringValue, t), this.gt(t);
                else if ("bytesValue" in e) this.At(t, 30), t.yt($59fc9b849b320ded$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.gt(t);
                else if ("referenceValue" in e) this.wt(e.referenceValue, t);
                else if ("geoPointValue" in e) {
                    var n2 = e.geoPointValue;
                    this.At(t, 45), t.Rt(n2.latitude || 0), t.Rt(n2.longitude || 0);
                } else "mapValue" in e ? $59fc9b849b320ded$var$__PRIVATE_isMaxValue(e) ? this.At(t, Number.MAX_SAFE_INTEGER) : (this.St(e.mapValue, t), this.gt(t)) : "arrayValue" in e ? (this.bt(e.arrayValue, t), this.gt(t)) : $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "ft",
            value: function ft(e, t) {
                this.At(t, 25), this.Dt(e, t);
            }
        },
        {
            key: "Dt",
            value: function Dt(e, t) {
                t.Vt(e);
            }
        },
        {
            key: "St",
            value: function St(e, t) {
                var n = e.fields || {};
                this.At(t, 55);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(n)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        this.ft(_$e, t), this.Tt(n[_$e], t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "bt",
            value: function bt(e, t) {
                var n = e.values || [];
                this.At(t, 50);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        this.Tt(_$e, t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "wt",
            value: function wt(e, t) {
                var _this = this;
                this.At(t, 37);
                $59fc9b849b320ded$export$afc2e57c475b7810.fromName(e).path.forEach(function(e) {
                    _this.At(t, 60), _this.Dt(e, t);
                });
            }
        },
        {
            key: "At",
            value: function At(e, t) {
                e.Rt(t);
            }
        },
        {
            key: "gt",
            value: function gt(e) {
                // While the SDK does not implement truncation, the truncation marker is
                // used to terminate all variable length values (which are strings, bytes,
                // references, arrays and maps).
                e.Rt(2);
            }
        }
    ]);
    return __PRIVATE_FirestoreIndexValueWriter;
}();
$59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter.Ct = new $59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $59fc9b849b320ded$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    var t = 0;
    return e >> 4 == 0 && // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 == 0 && // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 == 0 && // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $59fc9b849b320ded$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    var t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        var t = 0;
        for(var n = 0; n < 8; ++n){
            var r = $59fc9b849b320ded$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ var $59fc9b849b320ded$var$__PRIVATE_OrderedCodeWriter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_OrderedCodeWriter() {
        (0, $978gY._)(this, __PRIVATE_OrderedCodeWriter);
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    (0, $kry2a._)(__PRIVATE_OrderedCodeWriter, [
        {
            key: "vt",
            value: function vt(e) {
                var t = e[Symbol.iterator]();
                var n = t.next();
                for(; !n.done;)this.Ft(n.value), n = t.next();
                this.Mt();
            }
        },
        {
            key: "xt",
            value: function xt(e) {
                var t = e[Symbol.iterator]();
                var n = t.next();
                for(; !n.done;)this.Ot(n.value), n = t.next();
                this.Nt();
            }
        },
        {
            /** Writes utf8 bytes into this byte sequence, ascending. */ key: "Bt",
            value: function Bt(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        var _$e = t.charCodeAt(0);
                        if (_$e < 128) this.Ft(_$e);
                        else if (_$e < 2048) this.Ft(960 | _$e >>> 6), this.Ft(128 | 63 & _$e);
                        else if (t < "\ud800" || "\udbff" < t) this.Ft(480 | _$e >>> 12), this.Ft(128 | 63 & _$e >>> 6), this.Ft(128 | 63 & _$e);
                        else {
                            var _$e1 = t.codePointAt(0);
                            this.Ft(240 | _$e1 >>> 18), this.Ft(128 | 63 & _$e1 >>> 12), this.Ft(128 | 63 & _$e1 >>> 6), this.Ft(128 | 63 & _$e1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.Mt();
            }
        },
        {
            /** Writes utf8 bytes into this byte sequence, descending */ key: "Lt",
            value: function Lt(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        var _$e = t.charCodeAt(0);
                        if (_$e < 128) this.Ot(_$e);
                        else if (_$e < 2048) this.Ot(960 | _$e >>> 6), this.Ot(128 | 63 & _$e);
                        else if (t < "\ud800" || "\udbff" < t) this.Ot(480 | _$e >>> 12), this.Ot(128 | 63 & _$e >>> 6), this.Ot(128 | 63 & _$e);
                        else {
                            var _$e1 = t.codePointAt(0);
                            this.Ot(240 | _$e1 >>> 18), this.Ot(128 | 63 & _$e1 >>> 12), this.Ot(128 | 63 & _$e1 >>> 6), this.Ot(128 | 63 & _$e1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.Nt();
            }
        },
        {
            key: "kt",
            value: function kt(e) {
                // Values are encoded with a single byte length prefix, followed by the
                // actual value in big-endian format with leading 0 bytes dropped.
                var t = this.qt(e), n = $59fc9b849b320ded$var$__PRIVATE_unsignedNumLength(t);
                this.Qt(1 + n), this.buffer[this.position++] = 255 & n;
                // Write the length
                for(var _$e = t.length - n; _$e < t.length; ++_$e)this.buffer[this.position++] = 255 & t[_$e];
            }
        },
        {
            key: "Kt",
            value: function Kt(e) {
                // Values are encoded with a single byte length prefix, followed by the
                // inverted value in big-endian format with leading 0 bytes dropped.
                var t = this.qt(e), n = $59fc9b849b320ded$var$__PRIVATE_unsignedNumLength(t);
                this.Qt(1 + n), this.buffer[this.position++] = ~(255 & n);
                // Write the length
                for(var _$e = t.length - n; _$e < t.length; ++_$e)this.buffer[this.position++] = ~(255 & t[_$e]);
            }
        },
        {
            /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ key: "$t",
            value: function $t() {
                this.Ut(255), this.Ut(255);
            }
        },
        {
            /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ key: "Wt",
            value: function Wt() {
                this.Gt(255), this.Gt(255);
            }
        },
        {
            /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ key: "reset",
            value: function reset() {
                this.position = 0;
            }
        },
        {
            key: "seed",
            value: function seed(e) {
                this.Qt(e.length), this.buffer.set(e, this.position), this.position += e.length;
            }
        },
        {
            /** Makes a copy of the encoded bytes in this buffer.  */ key: "zt",
            value: function zt() {
                return this.buffer.slice(0, this.position);
            }
        },
        {
            /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ key: "qt",
            value: function qt(e) {
                var t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
                    var t = new DataView(new ArrayBuffer(8));
                    return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
                }(e), n = 0 != (128 & t[0]);
                // Check if the first bit is set. We use a bit mask since value[0] is
                // encoded as a number from 0 to 255.
                // Revert the two complement to get natural ordering
                t[0] ^= n ? 255 : 128;
                for(var _$e = 1; _$e < t.length; ++_$e)t[_$e] ^= n ? 255 : 0;
                return t;
            }
        },
        {
            /** Writes a single byte ascending to the buffer. */ key: "Ft",
            value: function Ft(e) {
                var t = 255 & e;
                0 === t ? (this.Ut(0), this.Ut(255)) : 255 === t ? (this.Ut(255), this.Ut(0)) : this.Ut(t);
            }
        },
        {
            /** Writes a single byte descending to the buffer.  */ key: "Ot",
            value: function Ot(e) {
                var t = 255 & e;
                0 === t ? (this.Gt(0), this.Gt(255)) : 255 === t ? (this.Gt(255), this.Gt(0)) : this.Gt(e);
            }
        },
        {
            key: "Mt",
            value: function Mt() {
                this.Ut(0), this.Ut(1);
            }
        },
        {
            key: "Nt",
            value: function Nt() {
                this.Gt(0), this.Gt(1);
            }
        },
        {
            key: "Ut",
            value: function Ut(e) {
                this.Qt(1), this.buffer[this.position++] = e;
            }
        },
        {
            key: "Gt",
            value: function Gt(e) {
                this.Qt(1), this.buffer[this.position++] = ~e;
            }
        },
        {
            key: "Qt",
            value: function Qt(e) {
                var t = e + this.position;
                if (t <= this.buffer.length) return;
                // Try doubling.
                var n = 2 * this.buffer.length;
                // Still not big enough? Just allocate the right size.
                n < t && (n = t);
                // Create the new buffer.
                var r = new Uint8Array(n);
                r.set(this.buffer), this.buffer = r;
            }
        }
    ]);
    return __PRIVATE_OrderedCodeWriter;
}();
var $59fc9b849b320ded$var$__PRIVATE_AscendingIndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AscendingIndexByteEncoder(e) {
        (0, $978gY._)(this, __PRIVATE_AscendingIndexByteEncoder);
        this.jt = e;
    }
    (0, $kry2a._)(__PRIVATE_AscendingIndexByteEncoder, [
        {
            key: "yt",
            value: function yt(e) {
                this.jt.vt(e);
            }
        },
        {
            key: "Vt",
            value: function Vt(e) {
                this.jt.Bt(e);
            }
        },
        {
            key: "Rt",
            value: function Rt(e) {
                this.jt.kt(e);
            }
        },
        {
            key: "Et",
            value: function Et() {
                this.jt.$t();
            }
        }
    ]);
    return __PRIVATE_AscendingIndexByteEncoder;
}();
var $59fc9b849b320ded$var$__PRIVATE_DescendingIndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DescendingIndexByteEncoder(e) {
        (0, $978gY._)(this, __PRIVATE_DescendingIndexByteEncoder);
        this.jt = e;
    }
    (0, $kry2a._)(__PRIVATE_DescendingIndexByteEncoder, [
        {
            key: "yt",
            value: function yt(e) {
                this.jt.xt(e);
            }
        },
        {
            key: "Vt",
            value: function Vt(e) {
                this.jt.Lt(e);
            }
        },
        {
            key: "Rt",
            value: function Rt(e) {
                this.jt.Kt(e);
            }
        },
        {
            key: "Et",
            value: function Et() {
                this.jt.Wt();
            }
        }
    ]);
    return __PRIVATE_DescendingIndexByteEncoder;
}();
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexByteEncoder = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexByteEncoder() {
        (0, $978gY._)(this, __PRIVATE_IndexByteEncoder);
        this.jt = new $59fc9b849b320ded$var$__PRIVATE_OrderedCodeWriter, this.Ht = new $59fc9b849b320ded$var$__PRIVATE_AscendingIndexByteEncoder(this.jt), this.Jt = new $59fc9b849b320ded$var$__PRIVATE_DescendingIndexByteEncoder(this.jt);
    }
    (0, $kry2a._)(__PRIVATE_IndexByteEncoder, [
        {
            key: "seed",
            value: function seed(e) {
                this.jt.seed(e);
            }
        },
        {
            key: "Yt",
            value: function Yt(e) {
                return 0 /* IndexKind.ASCENDING */  === e ? this.Ht : this.Jt;
            }
        },
        {
            key: "zt",
            value: function zt() {
                return this.jt.zt();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.jt.reset();
            }
        }
    ]);
    return __PRIVATE_IndexByteEncoder;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ var $59fc9b849b320ded$var$__PRIVATE_IndexEntry = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexEntry(e, t, n, r) {
        (0, $978gY._)(this, __PRIVATE_IndexEntry);
        this.indexId = e, this.documentKey = t, this.arrayValue = n, this.directionalValue = r;
    }
    (0, $kry2a._)(__PRIVATE_IndexEntry, [
        {
            /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ key: "Zt",
            value: function Zt() {
                var e = this.directionalValue.length, t = 0 === e || 255 === this.directionalValue[e - 1] ? e + 1 : e, n = new Uint8Array(t);
                return n.set(this.directionalValue, 0), t !== e ? n.set([
                    0
                ], this.directionalValue.length) : ++n[n.length - 1], new __PRIVATE_IndexEntry(this.indexId, this.documentKey, this.arrayValue, n);
            }
        }
    ]);
    return __PRIVATE_IndexEntry;
}();
function $59fc9b849b320ded$var$__PRIVATE_indexEntryComparator(e, t) {
    var n = e.indexId - t.indexId;
    return 0 !== n ? n : (n = $59fc9b849b320ded$var$__PRIVATE_compareByteArrays(e.arrayValue, t.arrayValue), 0 !== n ? n : (n = $59fc9b849b320ded$var$__PRIVATE_compareByteArrays(e.directionalValue, t.directionalValue), 0 !== n ? n : $59fc9b849b320ded$export$afc2e57c475b7810.comparator(e.documentKey, t.documentKey)));
}
function $59fc9b849b320ded$var$__PRIVATE_compareByteArrays(e, t) {
    for(var n = 0; n < e.length && n < t.length; ++n){
        var r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A light query planner for Firestore.
 *
 * This class matches a `FieldIndex` against a Firestore Query `Target`. It
 * determines whether a given index can be used to serve the specified target.
 *
 * The following table showcases some possible index configurations:
 *
 * Query                                               | Index
 * -----------------------------------------------------------------------------
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC, b DESC
 * where('a', '==', 'a').where('b', '==', 'b')         | a ASC
 * where('a', '==', 'a').where('b', '==', 'b')         | b DESC
 * where('a', '>=', 'a').orderBy('a')                  | a ASC
 * where('a', '>=', 'a').orderBy('a', 'desc')          | a DESC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC, b ASC
 * where('a', '>=', 'a').orderBy('a').orderBy('b')     | a ASC
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS, b ASCENDING
 * where('a', 'array-contains', 'a').orderBy('b')      | a CONTAINS
 */ var $59fc9b849b320ded$var$__PRIVATE_TargetIndexMatcher = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetIndexMatcher(e) {
        (0, $978gY._)(this, __PRIVATE_TargetIndexMatcher);
        this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.Xt = e.orderBy, this.en = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                var _$e = t;
                _$e.isInequality() ? this.tn = _$e : this.en.push(_$e);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $kry2a._)(__PRIVATE_TargetIndexMatcher, [
        {
            /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ key: "nn",
            value: function nn(e) {
                $59fc9b849b320ded$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId);
                // If there is an array element, find a matching filter.
                var t = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetArraySegment(e);
                if (void 0 !== t && !this.rn(t)) return !1;
                var n = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
                var r = new Set, i = 0, s = 0;
                // Process all equalities first. Equalities can appear out of order.
                for(; i < n.length && this.rn(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
                // If we already have processed all segments, all segments are used to serve
                // the equality filters and we do not need to map any segments to the
                // target's inequality and orderBy clauses.
                if (i === n.length) return !0;
                if (void 0 !== this.tn) {
                    // If there is an inequality filter and the field was not in one of the
                    // equality filters above, the next segment must match both the filter
                    // and the first orderBy clause.
                    if (!r.has(this.tn.field.canonicalString())) {
                        var _$e = n[i];
                        if (!this.sn(this.tn, _$e) || !this.on(this.Xt[s++], _$e)) return !1;
                    }
                    ++i;
                }
                // All remaining segments need to represent the prefix of the target's
                // orderBy.
                for(; i < n.length; ++i){
                    var _$e1 = n[i];
                    if (s >= this.Xt.length || !this.on(this.Xt[s++], _$e1)) return !1;
                }
                return !0;
            }
        },
        {
            /** Returns a full matched field index for this target. */ key: "_n",
            value: function _n() {
                // We want to make sure only one segment created for one field. For example,
                // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
                // once.
                var e = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$export$b7871852b967eaf1.comparator);
                var t = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.en[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var n = _step.value;
                        if (n.field.isKeyField()) continue;
                        if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $59fc9b849b320ded$var$IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
                        else {
                            if (e.has(n.field)) continue;
                            e = e.add(n.field), t.push(new $59fc9b849b320ded$var$IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    // Note: We do not explicitly check `this.inequalityFilter` but rather rely
                    // on the target defining an appropriate "order by" to ensure that the
                    // required index segment is added. The query engine would reject a query
                    // with an inequality filter that lacks the required order-by clause.
                    for(var _iterator1 = this.Xt[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var n1 = _step1.value;
                        // Stop adding more segments if we see a order-by on key. Typically this
                        // is the default implicit order-by which is covered in the index_entry
                        // table as a separate column. If it is not the default order-by, the
                        // generated index will be missing some segments optimized for order-bys,
                        // which is probably fine.
                        n1.field.isKeyField() || e.has(n1.field) || (e = e.add(n1.field), t.push(new $59fc9b849b320ded$var$IndexSegment(n1.field, "asc" /* Direction.ASCENDING */  === n1.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return new $59fc9b849b320ded$var$FieldIndex($59fc9b849b320ded$var$FieldIndex.UNKNOWN_ID, this.collectionId, t, $59fc9b849b320ded$var$IndexState.empty());
            }
        },
        {
            key: "rn",
            value: function rn(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.en[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (this.sn(t, e)) return !0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !1;
            }
        },
        {
            key: "sn",
            value: function sn(e, t) {
                if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
                var n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
                return 2 /* IndexKind.CONTAINS */  === t.kind === n;
            }
        },
        {
            key: "on",
            value: function on(e, t) {
                return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
            }
        }
    ]);
    return __PRIVATE_TargetIndexMatcher;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $59fc9b849b320ded$var$__PRIVATE_computeInExpansion(e) {
    var t, n;
    if ($59fc9b849b320ded$var$__PRIVATE_hardAssert(e instanceof $59fc9b849b320ded$var$FieldFilter || e instanceof $59fc9b849b320ded$var$CompositeFilter), e instanceof $59fc9b849b320ded$var$FieldFilter) {
        if (e instanceof $59fc9b849b320ded$var$__PRIVATE_InFilter) {
            var r = (null === (n = null === (t = e.value.arrayValue) || void 0 === t ? void 0 : t.values) || void 0 === n ? void 0 : n.map(function(t) {
                return $59fc9b849b320ded$var$FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t);
            })) || [];
            return $59fc9b849b320ded$var$CompositeFilter.create(r, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    var r1 = e.filters.map(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_computeInExpansion(e);
    });
    return $59fc9b849b320ded$var$CompositeFilter.create(r1, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter the composite filter to calculate DNF transform for.
 * @return the terms in the DNF transform.
 */ function $59fc9b849b320ded$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    var t = $59fc9b849b320ded$var$__PRIVATE_computeDistributedNormalForm($59fc9b849b320ded$var$__PRIVATE_computeInExpansion(e));
    return $59fc9b849b320ded$var$__PRIVATE_hardAssert($59fc9b849b320ded$var$__PRIVATE_isDisjunctiveNormalForm(t)), $59fc9b849b320ded$var$__PRIVATE_isSingleFieldFilter(t) || $59fc9b849b320ded$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $59fc9b849b320ded$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $59fc9b849b320ded$var$FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $59fc9b849b320ded$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $59fc9b849b320ded$var$CompositeFilter && $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $59fc9b849b320ded$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $59fc9b849b320ded$var$__PRIVATE_isSingleFieldFilter(e) || $59fc9b849b320ded$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $59fc9b849b320ded$var$CompositeFilter && $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e.getFilters()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var t = _step.value;
                    if (!$59fc9b849b320ded$var$__PRIVATE_isSingleFieldFilter(t) && !$59fc9b849b320ded$var$__PRIVATE_isFlatConjunction(t)) return !1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !0;
        }
        return !1;
    }(e);
}
function $59fc9b849b320ded$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($59fc9b849b320ded$var$__PRIVATE_hardAssert(e instanceof $59fc9b849b320ded$var$FieldFilter || e instanceof $59fc9b849b320ded$var$CompositeFilter), e instanceof $59fc9b849b320ded$var$FieldFilter) return e;
    if (1 === e.filters.length) return $59fc9b849b320ded$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    var t = e.filters.map(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_computeDistributedNormalForm(e);
    });
    var n = $59fc9b849b320ded$var$CompositeFilter.create(t, e.op);
    return n = $59fc9b849b320ded$var$__PRIVATE_applyAssociation(n), $59fc9b849b320ded$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($59fc9b849b320ded$var$__PRIVATE_hardAssert(n instanceof $59fc9b849b320ded$var$CompositeFilter), $59fc9b849b320ded$var$__PRIVATE_hardAssert($59fc9b849b320ded$var$__PRIVATE_compositeFilterIsConjunction(n)), $59fc9b849b320ded$var$__PRIVATE_hardAssert(n.filters.length > 1), n.filters.reduce(function(e, t) {
        return $59fc9b849b320ded$var$__PRIVATE_applyDistribution(e, t);
    }));
}
function $59fc9b849b320ded$var$__PRIVATE_applyDistribution(e, t) {
    var n;
    return $59fc9b849b320ded$var$__PRIVATE_hardAssert(e instanceof $59fc9b849b320ded$var$FieldFilter || e instanceof $59fc9b849b320ded$var$CompositeFilter), $59fc9b849b320ded$var$__PRIVATE_hardAssert(t instanceof $59fc9b849b320ded$var$FieldFilter || t instanceof $59fc9b849b320ded$var$CompositeFilter), // FieldFilter FieldFilter
    n = e instanceof $59fc9b849b320ded$var$FieldFilter ? t instanceof $59fc9b849b320ded$var$FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $59fc9b849b320ded$var$CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $59fc9b849b320ded$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $59fc9b849b320ded$var$FieldFilter ? $59fc9b849b320ded$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($59fc9b849b320ded$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0), $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsConjunction(e) && $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsConjunction(t)) return $59fc9b849b320ded$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        var n = $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $59fc9b849b320ded$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_applyDistribution(e, r);
        });
        return $59fc9b849b320ded$var$CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $59fc9b849b320ded$var$__PRIVATE_applyAssociation(n);
}
function $59fc9b849b320ded$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($59fc9b849b320ded$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $59fc9b849b320ded$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        var n = t.filters.map(function(t) {
            return $59fc9b849b320ded$var$__PRIVATE_applyDistribution(e, t);
        });
        return $59fc9b849b320ded$var$CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $59fc9b849b320ded$var$__PRIVATE_applyAssociation(e) {
    if ($59fc9b849b320ded$var$__PRIVATE_hardAssert(e instanceof $59fc9b849b320ded$var$FieldFilter || e instanceof $59fc9b849b320ded$var$CompositeFilter), e instanceof $59fc9b849b320ded$var$FieldFilter) return e;
    var t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $59fc9b849b320ded$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($59fc9b849b320ded$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    var n = t.map(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_applyAssociation(e);
    }), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach(function(t) {
        var // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        _r;
        t instanceof $59fc9b849b320ded$var$FieldFilter ? r.push(t) : t instanceof $59fc9b849b320ded$var$CompositeFilter && (t.op === e.op ? (_r = r).push.apply(_r, (0, $fLnyw._)(t.filters)) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $59fc9b849b320ded$var$CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryIndexManager = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryIndexManager() {
        (0, $978gY._)(this, __PRIVATE_MemoryIndexManager);
        this.an = new $59fc9b849b320ded$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    (0, $kry2a._)(__PRIVATE_MemoryIndexManager, [
        {
            key: "addToCollectionParentIndex",
            value: function addToCollectionParentIndex(e, t) {
                return this.an.add(t), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "getCollectionParents",
            value: function getCollectionParents(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.an.getEntries(t));
            }
        },
        {
            key: "addFieldIndex",
            value: function addFieldIndex(e, t) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "deleteFieldIndex",
            value: function deleteFieldIndex(e, t) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "deleteAllFieldIndexes",
            value: function deleteAllFieldIndexes(e) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "createTargetIndexes",
            value: function createTargetIndexes(e, t) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "getDocumentsMatchingTarget",
            value: function getDocumentsMatchingTarget(e, t) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve(null);
            }
        },
        {
            key: "getIndexType",
            value: function getIndexType(e, t) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
            }
        },
        {
            key: "getFieldIndexes",
            value: function getFieldIndexes(e, t) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve([]);
            }
        },
        {
            key: "getNextCollectionGroupToUpdate",
            value: function getNextCollectionGroupToUpdate(e) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve(null);
            }
        },
        {
            key: "getMinOffset",
            value: function getMinOffset(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve($59fc9b849b320ded$var$IndexOffset.min());
            }
        },
        {
            key: "getMinOffsetFromCollectionGroup",
            value: function getMinOffsetFromCollectionGroup(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve($59fc9b849b320ded$var$IndexOffset.min());
            }
        },
        {
            key: "updateCollectionGroup",
            value: function updateCollectionGroup(e, t, n) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "updateIndexEntries",
            value: function updateIndexEntries(e, t) {
                // Field indices are not supported with memory persistence.
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        }
    ]);
    return __PRIVATE_MemoryIndexManager;
}();
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryCollectionParentIndex = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryCollectionParentIndex() {
        (0, $978gY._)(this, __PRIVATE_MemoryCollectionParentIndex);
        this.index = {};
    }
    (0, $kry2a._)(__PRIVATE_MemoryCollectionParentIndex, [
        {
            // Returns false if the entry already existed.
            key: "add",
            value: function add(e) {
                var t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$ResourcePath.comparator), i = !r.has(n);
                return this.index[t] = r.add(n), i;
            }
        },
        {
            key: "has",
            value: function has(e) {
                var t = e.lastSegment(), n = e.popLast(), r = this.index[t];
                return r && r.has(n);
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e) {
                return (this.index[e] || new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$ResourcePath.comparator)).toArray();
            }
        }
    ]);
    return __PRIVATE_MemoryCollectionParentIndex;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$de = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbIndexManager = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbIndexManager(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbIndexManager);
        this.user = e, this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.un = new $59fc9b849b320ded$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.cn = new $59fc9b849b320ded$var$ObjectMap(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_canonifyTarget(e);
        }, function(e, t) {
            return $59fc9b849b320ded$var$__PRIVATE_targetEquals(e, t);
        }), this.uid = e.uid || "";
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbIndexManager, [
        {
            /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ key: "addToCollectionParentIndex",
            value: function addToCollectionParentIndex(e, t) {
                var _this = this;
                if (!this.un.has(t)) {
                    var n = t.lastSegment(), r = t.popLast();
                    e.addOnCommittedListener(function() {
                        // Add the collection to the in memory cache only if the transaction was
                        // successfully committed.
                        _this.un.add(t);
                    });
                    var i = {
                        collectionId: n,
                        parent: $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(r)
                    };
                    return $59fc9b849b320ded$var$__PRIVATE_collectionParentsStore(e).put(i);
                }
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "getCollectionParents",
            value: function getCollectionParents(e, t) {
                var n = [], r = IDBKeyRange.bound([
                    t,
                    ""
                ], [
                    $59fc9b849b320ded$var$__PRIVATE_immediateSuccessor(t),
                    ""
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                return $59fc9b849b320ded$var$__PRIVATE_collectionParentsStore(e).G(r).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            // This collectionId guard shouldn't be necessary (and isn't as long
                            // as we're running in a real browser), but there's a bug in
                            // indexeddbshim that breaks our range in our tests running in node:
                            // https://github.com/axemclion/IndexedDBShim/issues/334
                            if (r.collectionId !== t) break;
                            n.push($59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(r.parent));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return n;
                });
            }
        },
        {
            key: "addFieldIndex",
            value: function addFieldIndex(e, t) {
                var _this = this;
                // TODO(indexing): Verify that the auto-incrementing index ID works in
                // Safari & Firefox.
                var n = $59fc9b849b320ded$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
                    return {
                        indexId: e.indexId,
                        collectionGroup: e.collectionGroup,
                        fields: e.fields.map(function(e) {
                            return [
                                e.fieldPath.canonicalString(),
                                e.kind
                            ];
                        })
                    };
                }(t);
                delete r.indexId;
                // `indexId` is auto-populated by IndexedDb
                var i = n.add(r);
                if (t.indexState) {
                    var n1 = $59fc9b849b320ded$var$__PRIVATE_indexStateStore(e);
                    return i.next(function(e) {
                        n1.put($59fc9b849b320ded$var$__PRIVATE_toDbIndexState(e, _this.user, t.indexState.sequenceNumber, t.indexState.offset));
                    });
                }
                return i.next();
            }
        },
        {
            key: "deleteFieldIndex",
            value: function deleteFieldIndex(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_indexConfigurationStore(e), r = $59fc9b849b320ded$var$__PRIVATE_indexStateStore(e), i = $59fc9b849b320ded$var$__PRIVATE_indexEntriesStore(e);
                return n.delete(t.indexId).next(function() {
                    return r.delete(IDBKeyRange.bound([
                        t.indexId
                    ], [
                        t.indexId + 1
                    ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0));
                }).next(function() {
                    return i.delete(IDBKeyRange.bound([
                        t.indexId
                    ], [
                        t.indexId + 1
                    ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0));
                });
            }
        },
        {
            key: "deleteAllFieldIndexes",
            value: function deleteAllFieldIndexes(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_indexConfigurationStore(e), n = $59fc9b849b320ded$var$__PRIVATE_indexEntriesStore(e), r = $59fc9b849b320ded$var$__PRIVATE_indexStateStore(e);
                return t.J().next(function() {
                    return n.J();
                }).next(function() {
                    return r.J();
                });
            }
        },
        {
            key: "createTargetIndexes",
            value: function createTargetIndexes(e, t) {
                var _this = this;
                return $59fc9b849b320ded$var$PersistencePromise.forEach(this.ln(t), function(t) {
                    return _this.getIndexType(e, t).next(function(n) {
                        if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                            var _$n = new $59fc9b849b320ded$var$__PRIVATE_TargetIndexMatcher(t);
                            return _this.addFieldIndex(e, _$n._n());
                        }
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingTarget",
            value: function getDocumentsMatchingTarget(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_indexEntriesStore(e);
                var r = !0;
                var i = new Map;
                return $59fc9b849b320ded$var$PersistencePromise.forEach(this.ln(t), function(t) {
                    return _this.hn(e, t).next(function(e) {
                        r && (r = !!e), i.set(t, e);
                    });
                }).next(function() {
                    if (r) {
                        var _$e = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                        var r1 = [];
                        return $59fc9b849b320ded$var$PersistencePromise.forEach(i, function(i, s) {
                            $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbIndexManager", "Using index ".concat(function __PRIVATE_fieldIndexToString(e) {
                                return "id=".concat(e.indexId, "|cg=").concat(e.collectionGroup, "|f=").concat(e.fields.map(function(e) {
                                    return "".concat(e.fieldPath, ":").concat(e.kind);
                                }).join(","));
                            }(i), " to execute ").concat($59fc9b849b320ded$var$__PRIVATE_canonifyTarget(t)));
                            var o = function __PRIVATE_targetGetArrayValues(e, t) {
                                var n = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetArraySegment(t);
                                if (void 0 === n) return null;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step.value;
                                        switch(_$t.op){
                                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                                return _$t.value.arrayValue.values || [];
                                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                                return [
                                                    _$t.value
                                                ];
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return null;
                            }(s, i), _ = function __PRIVATE_targetGetNotInValues(e, t) {
                                var n = new Map;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                        var r = _step.value;
                                        try {
                                            for(var _iterator1 = $59fc9b849b320ded$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                                var _$t = _step1.value;
                                                switch(_$t.op){
                                                    case "==" /* Operator.EQUAL */ :
                                                    case "in" /* Operator.IN */ :
                                                        // Encode equality prefix, which is encoded in the index value before
                                                        // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                                        // `value != 'ab'`).
                                                        n.set(r.fieldPath.canonicalString(), _$t.value);
                                                        break;
                                                    case "not-in" /* Operator.NOT_IN */ :
                                                    case "!=" /* Operator.NOT_EQUAL */ :
                                                        // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                                        // segments and hence we can return early here.
                                                        return n.set(r.fieldPath.canonicalString(), _$t.value), Array.from(n.values());
                                                }
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return null;
                            }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                                var n = [];
                                var r = !0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // For each segment, retrieve a lower bound if there is a suitable filter or
                                    // startAt.
                                    for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$i = _step.value;
                                        var _$t = 0 /* IndexKind.ASCENDING */  === _$i.kind ? $59fc9b849b320ded$var$__PRIVATE_targetGetAscendingBound(e, _$i.fieldPath, e.startAt) : $59fc9b849b320ded$var$__PRIVATE_targetGetDescendingBound(e, _$i.fieldPath, e.startAt);
                                        n.push(_$t.value), r && (r = _$t.inclusive);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return new $59fc9b849b320ded$var$Bound(n, r);
                            }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                                var n = [];
                                var r = !0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    // For each segment, retrieve an upper bound if there is a suitable filter or
                                    // endAt.
                                    for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$i = _step.value;
                                        var _$t = 0 /* IndexKind.ASCENDING */  === _$i.kind ? $59fc9b849b320ded$var$__PRIVATE_targetGetDescendingBound(e, _$i.fieldPath, e.endAt) : $59fc9b849b320ded$var$__PRIVATE_targetGetAscendingBound(e, _$i.fieldPath, e.endAt);
                                        n.push(_$t.value), r && (r = _$t.inclusive);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return new $59fc9b849b320ded$var$Bound(n, r);
                            }(s, i), c = _this.Pn(i, s, a), l = _this.Pn(i, s, u), h = _this.In(i, s, _), P = _this.dn(i.indexId, o, c, a.inclusive, l, u.inclusive, h);
                            return $59fc9b849b320ded$var$PersistencePromise.forEach(P, function(i) {
                                return n.H(i, t.limit).next(function(t) {
                                    t.forEach(function(t) {
                                        var n = $59fc9b849b320ded$export$afc2e57c475b7810.fromSegments(t.documentKey);
                                        _$e.has(n) || (_$e = _$e.add(n), r1.push(n));
                                    });
                                });
                            });
                        }).next(function() {
                            return r1;
                        });
                    }
                    return $59fc9b849b320ded$var$PersistencePromise.resolve(null);
                });
            }
        },
        {
            key: "ln",
            value: function ln(e) {
                var t = this.cn.get(e);
                if (t) return t;
                if (0 === e.filters.length) t = [
                    e
                ];
                else t = $59fc9b849b320ded$var$__PRIVATE_getDnfTerms($59fc9b849b320ded$var$CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map(function(t) {
                    return $59fc9b849b320ded$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt);
                });
                return this.cn.set(e, t), t;
            }
        },
        {
            /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ key: "dn",
            value: function dn(e, t, n, r, i, s, o) {
                var _this = this, _loop = function(c) {
                    var _u;
                    var _ = t ? _this.Tn(t[c / a]) : $59fc9b849b320ded$var$de, l = _this.En(e, _, n[c % a], r), h = _this.An(e, _, i[c % a], s), P = o.map(function(t) {
                        return _this1.En(e, _, t, /* inclusive= */ !0);
                    });
                    (_u = u).push.apply(_u, (0, $fLnyw._)(_this.createRange(l, h, P)));
                };
                var _this1 = this;
                // The number of total index scans we union together. This is similar to a
                // distributed normal form, but adapted for array values. We create a single
                // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
                // combined with the values from the query bounds.
                var _ = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = _ / (null != t ? t.length : 1), u = [];
                for(var c = 0; c < _; ++c)_loop(c);
                return u;
            }
        },
        {
            /** Generates the lower bound for `arrayValue` and `directionalValue`. */ key: "En",
            value: function En(e, t, n, r) {
                var i = new $59fc9b849b320ded$var$__PRIVATE_IndexEntry(e, $59fc9b849b320ded$export$afc2e57c475b7810.empty(), t, n);
                return r ? i : i.Zt();
            }
        },
        {
            /** Generates the upper bound for `arrayValue` and `directionalValue`. */ key: "An",
            value: function An(e, t, n, r) {
                var i = new $59fc9b849b320ded$var$__PRIVATE_IndexEntry(e, $59fc9b849b320ded$export$afc2e57c475b7810.empty(), t, n);
                return r ? i.Zt() : i;
            }
        },
        {
            key: "hn",
            value: function hn(e, t) {
                var n = new $59fc9b849b320ded$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
                return this.getFieldIndexes(e, r).next(function(e) {
                    // Return the index with the most number of segments.
                    var _$t = null;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var r = _step.value;
                            n.nn(r) && (!_$t || r.fields.length > _$t.fields.length) && (_$t = r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$t;
                });
            }
        },
        {
            key: "getIndexType",
            value: function getIndexType(e, t) {
                var _this = this;
                var n = 2 /* IndexType.FULL */ ;
                var r = this.ln(t);
                return $59fc9b849b320ded$var$PersistencePromise.forEach(r, function(t) {
                    return _this.hn(e, t).next(function(e) {
                        e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                            var _$t = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$export$b7871852b967eaf1.comparator), n = !1;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator = e.filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                    var r = _step.value;
                                    try {
                                        for(var _iterator1 = r.getFlattenedFilters()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                            var _$e = _step1.value;
                                            // __name__ is not an explicit segment of any index, so we don't need to
                                            // count it.
                                            _$e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                                            // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                                            // though these are on the same field, they should be counted as two
                                            // separate segments in an index.
                                            ("array-contains" /* Operator.ARRAY_CONTAINS */  === _$e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === _$e.op ? n = !0 : _$t = _$t.add(_$e.field));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = e.orderBy[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var n1 = _step2.value;
                                    // __name__ is not an explicit segment of any index, so we don't need to
                                    // count it.
                                    n1.field.isKeyField() || (_$t = _$t.add(n1.field));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            return _$t.size + (n ? 1 : 0);
                        }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
                    });
                }).next(function() {
                    return(// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
                    // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
                    // and apply the limit in memory as a post-processing step.
                    function __PRIVATE_targetHasLimit(e) {
                        return null !== e.limit;
                    }(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
                });
            }
        },
        {
            /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ key: "Rn",
            value: function Rn(e, t) {
                var n = new $59fc9b849b320ded$var$__PRIVATE_IndexByteEncoder;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        var _$e = t.data.field(r.fieldPath);
                        if (null == _$e) return null;
                        var i = n.Yt(r.kind);
                        $59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter.Ct.dt(_$e, i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return n.zt();
            }
        },
        {
            /** Encodes a single value to the ascending index format. */ key: "Tn",
            value: function Tn(e) {
                var t = new $59fc9b849b320ded$var$__PRIVATE_IndexByteEncoder;
                return $59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter.Ct.dt(e, t.Yt(0 /* IndexKind.ASCENDING */ )), t.zt();
            }
        },
        {
            /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ key: "Vn",
            value: function Vn(e, t) {
                var n = new $59fc9b849b320ded$var$__PRIVATE_IndexByteEncoder;
                return $59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter.Ct.dt($59fc9b849b320ded$var$__PRIVATE_refValue(this.databaseId, t), n.Yt(function __PRIVATE_fieldIndexGetKeyOrder(e) {
                    var _$t = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
                    return 0 === _$t.length ? 0 /* IndexKind.ASCENDING */  : _$t[_$t.length - 1].kind;
                }(e))), n.zt();
            }
        },
        {
            /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ key: "In",
            value: function In(e, t, n) {
                if (null === n) return [];
                var r = [];
                r.push(new $59fc9b849b320ded$var$__PRIVATE_IndexByteEncoder);
                var i = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        var _$e = n[i++];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$n = _step1.value;
                                if (this.mn(t, s.fieldPath) && $59fc9b849b320ded$var$isArray(_$e)) r = this.fn(r, s, _$e);
                                else {
                                    var _$t = _$n.Yt(s.kind);
                                    $59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter.Ct.dt(_$e, _$t);
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this.gn(r);
            }
        },
        {
            /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ key: "Pn",
            value: function Pn(e, t, n) {
                return this.In(e, t, n.position);
            }
        },
        {
            /** Returns the byte representation for the provided encoders. */ key: "gn",
            value: function gn(e) {
                var t = [];
                for(var n = 0; n < e.length; ++n)t[n] = e[n].zt();
                return t;
            }
        },
        {
            /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ key: "fn",
            value: function fn(e, t, n) {
                var r = (0, $fLnyw._)(e), i = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = (n.arrayValue.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var _$e = _step.value;
                        try {
                            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step1.value;
                                var r1 = new $59fc9b849b320ded$var$__PRIVATE_IndexByteEncoder;
                                r1.seed(_$n.zt()), $59fc9b849b320ded$var$__PRIVATE_FirestoreIndexValueWriter.Ct.dt(_$e, r1.Yt(t.kind)), i.push(r1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return i;
            }
        },
        {
            key: "mn",
            value: function mn(e, t) {
                return !!e.filters.find(function(e) {
                    return e instanceof $59fc9b849b320ded$var$FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op);
                });
            }
        },
        {
            key: "getFieldIndexes",
            value: function getFieldIndexes(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_indexConfigurationStore(e), r = $59fc9b849b320ded$var$__PRIVATE_indexStateStore(e);
                return (t ? n.G("collectionGroupIndex", IDBKeyRange.bound(t, t)) : n.G()).next(function(e) {
                    var _$t = [];
                    return $59fc9b849b320ded$var$PersistencePromise.forEach(e, function(e) {
                        return r.get([
                            e.indexId,
                            _this.uid
                        ]).next(function(n) {
                            _$t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                                var _$n = t ? new $59fc9b849b320ded$var$IndexState(t.sequenceNumber, new $59fc9b849b320ded$var$IndexOffset($59fc9b849b320ded$var$__PRIVATE_fromDbTimestamp(t.readTime), new $59fc9b849b320ded$export$afc2e57c475b7810($59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $59fc9b849b320ded$var$IndexState.empty(), r = e.fields.map(function(param) {
                                    var _param = (0, $8GFUW._)(param, 2), _$e = _param[0], _$t = _param[1];
                                    return new $59fc9b849b320ded$var$IndexSegment($59fc9b849b320ded$export$b7871852b967eaf1.fromServerFormat(_$e), _$t);
                                });
                                return new $59fc9b849b320ded$var$FieldIndex(e.indexId, e.collectionGroup, r, _$n);
                            }(e, n));
                        });
                    }).next(function() {
                        return _$t;
                    });
                });
            }
        },
        {
            key: "getNextCollectionGroupToUpdate",
            value: function getNextCollectionGroupToUpdate(e) {
                return this.getFieldIndexes(e).next(function(e) {
                    return 0 === e.length ? null : (e.sort(function(e, t) {
                        var n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                        return 0 !== n ? n : $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
                    }), e[0].collectionGroup);
                });
            }
        },
        {
            key: "updateCollectionGroup",
            value: function updateCollectionGroup(e, t, n) {
                var _this = this;
                var r = $59fc9b849b320ded$var$__PRIVATE_indexConfigurationStore(e), i = $59fc9b849b320ded$var$__PRIVATE_indexStateStore(e);
                return this.pn(e).next(function(e) {
                    return r.G("collectionGroupIndex", IDBKeyRange.bound(t, t)).next(function(t) {
                        return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t) {
                            return i.put($59fc9b849b320ded$var$__PRIVATE_toDbIndexState(t.indexId, _this.user, e, n));
                        });
                    });
                });
            }
        },
        {
            key: "updateIndexEntries",
            value: function updateIndexEntries(e, t) {
                var _this = this;
                // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
                // it could be used across different IndexedDB transactions. As any cached
                // data might be invalidated by other multi-tab clients, we can only trust
                // data within a single IndexedDB transaction. We therefore add a cache
                // here.
                var n = new Map;
                return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t, r) {
                    var i = n.get(t.collectionGroup);
                    return (i ? $59fc9b849b320ded$var$PersistencePromise.resolve(i) : _this.getFieldIndexes(e, t.collectionGroup)).next(function(i) {
                        return n.set(t.collectionGroup, i), $59fc9b849b320ded$var$PersistencePromise.forEach(i, function(n) {
                            return _this.yn(e, t, n).next(function(t) {
                                var _$i = _this.wn(r, n);
                                return t.isEqual(_$i) ? $59fc9b849b320ded$var$PersistencePromise.resolve() : _this.Sn(e, r, n, t, _$i);
                            });
                        });
                    });
                });
            }
        },
        {
            key: "bn",
            value: function bn(e, t, n, r) {
                return $59fc9b849b320ded$var$__PRIVATE_indexEntriesStore(e).put({
                    indexId: r.indexId,
                    uid: this.uid,
                    arrayValue: r.arrayValue,
                    directionalValue: r.directionalValue,
                    orderedDocumentKey: this.Vn(n, t.key),
                    documentKey: t.key.path.toArray()
                });
            }
        },
        {
            key: "Dn",
            value: function Dn(e, t, n, r) {
                return $59fc9b849b320ded$var$__PRIVATE_indexEntriesStore(e).delete([
                    r.indexId,
                    this.uid,
                    r.arrayValue,
                    r.directionalValue,
                    this.Vn(n, t.key),
                    t.key.path.toArray()
                ]);
            }
        },
        {
            key: "yn",
            value: function yn(e, t, n) {
                var r = $59fc9b849b320ded$var$__PRIVATE_indexEntriesStore(e);
                var i = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_indexEntryComparator);
                return r.Z({
                    index: "documentKeyIndex",
                    range: IDBKeyRange.only([
                        n.indexId,
                        this.uid,
                        this.Vn(n, t)
                    ])
                }, function(e, r) {
                    i = i.add(new $59fc9b849b320ded$var$__PRIVATE_IndexEntry(n.indexId, t, r.arrayValue, r.directionalValue));
                }).next(function() {
                    return i;
                });
            }
        },
        {
            /** Creates the index entries for the given document. */ key: "wn",
            value: function wn(e, t) {
                var n = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_indexEntryComparator);
                var r = this.Rn(t, e);
                if (null == r) return n;
                var i = $59fc9b849b320ded$var$__PRIVATE_fieldIndexGetArraySegment(t);
                if (null != i) {
                    var s = e.data.field(i.fieldPath);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if ($59fc9b849b320ded$var$isArray(s)) try {
                        for(var _iterator = (s.arrayValue.values || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var i1 = _step.value;
                            n = n.add(new $59fc9b849b320ded$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.Tn(i1), r));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else n = n.add(new $59fc9b849b320ded$var$__PRIVATE_IndexEntry(t.indexId, e.key, $59fc9b849b320ded$var$de, r));
                return n;
            }
        },
        {
            /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ key: "Sn",
            value: function Sn(e, t, n, r, i) {
                var _this = this;
                $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbIndexManager", "Updating index entries for document '%s'", t.key);
                var s = [];
                return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
                    var s = e.getIterator(), o = t.getIterator();
                    var _ = $59fc9b849b320ded$var$__PRIVATE_advanceIterator(s), a = $59fc9b849b320ded$var$__PRIVATE_advanceIterator(o);
                    // Walk through the two sets at the same time, using the ordering defined by
                    // `comparator`.
                    for(; _ || a;){
                        var _$e = !1, _$t = !1;
                        if (_ && a) {
                            var _$r = n(_, a);
                            _$r < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            _$t = !0 : _$r > 0 && // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            (_$e = !0);
                        } else null != _ ? _$t = !0 : _$e = !0;
                        _$e ? (r(a), a = $59fc9b849b320ded$var$__PRIVATE_advanceIterator(o)) : _$t ? (i(_), _ = $59fc9b849b320ded$var$__PRIVATE_advanceIterator(s)) : (_ = $59fc9b849b320ded$var$__PRIVATE_advanceIterator(s), a = $59fc9b849b320ded$var$__PRIVATE_advanceIterator(o));
                    }
                }(r, i, $59fc9b849b320ded$var$__PRIVATE_indexEntryComparator, /* onAdd= */ function(r) {
                    s.push(_this.bn(e, t, n, r));
                }, /* onRemove= */ function(r) {
                    s.push(_this.Dn(e, t, n, r));
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(s);
            }
        },
        {
            key: "pn",
            value: function pn(e) {
                var t = 1;
                return $59fc9b849b320ded$var$__PRIVATE_indexStateStore(e).Z({
                    index: "sequenceNumberIndex",
                    reverse: !0,
                    range: IDBKeyRange.upperBound([
                        this.uid,
                        Number.MAX_SAFE_INTEGER
                    ])
                }, function(e, n, r) {
                    r.done(), t = n.sequenceNumber + 1;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ key: "createRange",
            value: function createRange(e, t, n) {
                // The notIn values need to be sorted and unique so that we can return a
                // sorted set of non-overlapping ranges.
                n = n.sort(function(e, t) {
                    return $59fc9b849b320ded$var$__PRIVATE_indexEntryComparator(e, t);
                }).filter(function(e, t, n) {
                    return !t || 0 !== $59fc9b849b320ded$var$__PRIVATE_indexEntryComparator(e, n[t - 1]);
                });
                var r = [];
                r.push(e);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var _$n = $59fc9b849b320ded$var$__PRIVATE_indexEntryComparator(i, e), s = $59fc9b849b320ded$var$__PRIVATE_indexEntryComparator(i, t);
                        if (0 === _$n) // `notInValue` is the lower bound. We therefore need to raise the bound
                        // to the next value.
                        r[0] = e.Zt();
                        else if (_$n > 0 && s < 0) // `notInValue` is in the middle of the range
                        r.push(i), r.push(i.Zt());
                        else if (s > 0) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                r.push(t);
                var i1 = [];
                for(var _$e = 0; _$e < r.length; _$e += 2){
                    // If we encounter two bounds that will create an unmatchable key range,
                    // then we return an empty set of key ranges.
                    if (this.Cn(r[_$e], r[_$e + 1])) return [];
                    var _$t = [
                        r[_$e].indexId,
                        this.uid,
                        r[_$e].arrayValue,
                        r[_$e].directionalValue,
                        $59fc9b849b320ded$var$de,
                        []
                    ], _$n1 = [
                        r[_$e + 1].indexId,
                        this.uid,
                        r[_$e + 1].arrayValue,
                        r[_$e + 1].directionalValue,
                        $59fc9b849b320ded$var$de,
                        []
                    ];
                    i1.push(IDBKeyRange.bound(_$t, _$n1));
                }
                return i1;
            }
        },
        {
            key: "Cn",
            value: function Cn(e, t) {
                // If lower bound is greater than the upper bound, then the key
                // range can never be matched.
                return $59fc9b849b320ded$var$__PRIVATE_indexEntryComparator(e, t) > 0;
            }
        },
        {
            key: "getMinOffsetFromCollectionGroup",
            value: function getMinOffsetFromCollectionGroup(e, t) {
                return this.getFieldIndexes(e, t).next($59fc9b849b320ded$var$__PRIVATE_getMinOffsetFromFieldIndexes);
            }
        },
        {
            key: "getMinOffset",
            value: function getMinOffset(e, t) {
                var _this = this;
                return $59fc9b849b320ded$var$PersistencePromise.mapArray(this.ln(t), function(t) {
                    return _this.hn(e, t).next(function(e) {
                        return e || $59fc9b849b320ded$var$fail();
                    });
                }).next($59fc9b849b320ded$var$__PRIVATE_getMinOffsetFromFieldIndexes);
            }
        }
    ]);
    return __PRIVATE_IndexedDbIndexManager;
}();
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $59fc9b849b320ded$var$__PRIVATE_collectionParentsStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "collectionParents");
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_indexEntriesStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "indexEntries");
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_indexConfigurationStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "indexConfiguration");
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_indexStateStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "indexState");
}
function $59fc9b849b320ded$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $59fc9b849b320ded$var$__PRIVATE_hardAssert(0 !== e.length);
    var t = e[0].indexState.offset, n = t.largestBatchId;
    for(var r = 1; r < e.length; r++){
        var i = e[r].indexState.offset;
        $59fc9b849b320ded$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $59fc9b849b320ded$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$Te = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
};
var $59fc9b849b320ded$var$LruParams = /*#__PURE__*/ function() {
    "use strict";
    function LruParams(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n) {
        (0, $978gY._)(this, LruParams);
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
    (0, $kry2a._)(LruParams, null, [
        {
            key: "withCacheSize",
            value: function withCacheSize(e) {
                return new LruParams(e, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
            }
        }
    ]);
    return LruParams;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $59fc9b849b320ded$var$removeMutationBatch(e, t, n) {
    var r = e.store("mutations"), i = e.store("documentMutations"), s = [], o = IDBKeyRange.only(n.batchId);
    var _ = 0;
    var a = r.Z({
        range: o
    }, function(e, t, n) {
        return _++, n.delete();
    });
    s.push(a.next(function() {
        $59fc9b849b320ded$var$__PRIVATE_hardAssert(1 === _);
    }));
    var u = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = n.mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            var r1 = $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationKey(t, _$e.key.path, n.batchId);
            s.push(i.delete(r1)), u.push(_$e.key);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $59fc9b849b320ded$var$PersistencePromise.waitFor(s).next(function() {
        return u;
    });
}
/**
 * Returns an approximate size for the given document.
 */ function $59fc9b849b320ded$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    var t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $59fc9b849b320ded$var$fail();
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ $59fc9b849b320ded$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $59fc9b849b320ded$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $59fc9b849b320ded$var$LruParams.DEFAULT = new $59fc9b849b320ded$var$LruParams(41943040, $59fc9b849b320ded$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $59fc9b849b320ded$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $59fc9b849b320ded$var$LruParams.DISABLED = new $59fc9b849b320ded$var$LruParams(-1, 0, 0);
var $59fc9b849b320ded$var$__PRIVATE_IndexedDbMutationQueue = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbMutationQueue(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbMutationQueue);
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.vn = {};
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbMutationQueue, [
        {
            key: "checkEmpty",
            value: function checkEmpty(e) {
                var t = !0;
                var n = IDBKeyRange.bound([
                    this.userId,
                    Number.NEGATIVE_INFINITY
                ], [
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                return $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e).Z({
                    index: "userMutationsIndex",
                    range: n
                }, function(e, n, r) {
                    t = !1, r.done();
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "addMutationBatch",
            value: function addMutationBatch(e, t, n, r) {
                var _this = this;
                var i = $59fc9b849b320ded$var$__PRIVATE_documentMutationsStore(e), s = $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e);
                // The IndexedDb implementation in Chrome (and Firefox) does not handle
                // compound indices that include auto-generated keys correctly. To ensure
                // that the index entry is added correctly in all browsers, we perform two
                // writes: The first write is used to retrieve the next auto-generated Batch
                // ID, and the second write populates the index and stores the actual
                // mutation batch.
                // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
                // We write an empty object to obtain key
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return s.add({}).next(function(o) {
                    $59fc9b849b320ded$var$__PRIVATE_hardAssert("number" == typeof o);
                    var _ = new $59fc9b849b320ded$var$MutationBatch(o, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                        var _$r = n.baseMutations.map(function(t) {
                            return $59fc9b849b320ded$var$toMutation(e.ht, t);
                        }), i = n.mutations.map(function(t) {
                            return $59fc9b849b320ded$var$toMutation(e.ht, t);
                        });
                        return {
                            userId: t,
                            batchId: n.batchId,
                            localWriteTimeMs: n.localWriteTime.toMillis(),
                            baseMutations: _$r,
                            mutations: i
                        };
                    }(_this.serializer, _this.userId, _), u = [];
                    var c = new $59fc9b849b320ded$var$SortedSet(function(e, t) {
                        return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString());
                    });
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            var _$t = $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationKey(_this.userId, _$e.key.path, o);
                            c = c.add(_$e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(_$t, $59fc9b849b320ded$var$x));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return c.forEach(function(t) {
                        u.push(_this.indexManager.addToCollectionParentIndex(e, t));
                    }), e.addOnCommittedListener(function() {
                        _this.vn[o] = _.keys();
                    }), $59fc9b849b320ded$var$PersistencePromise.waitFor(u).next(function() {
                        return _;
                    });
                });
            }
        },
        {
            key: "lookupMutationBatch",
            value: function lookupMutationBatch(e, t) {
                var _this = this;
                return $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e).get(t).next(function(e) {
                    return e ? ($59fc9b849b320ded$var$__PRIVATE_hardAssert(e.userId === _this.userId), $59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(_this.serializer, e)) : null;
                });
            }
        },
        {
            /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
            key: "Fn",
            value: function Fn(e, t) {
                var _this = this;
                return this.vn[t] ? $59fc9b849b320ded$var$PersistencePromise.resolve(this.vn[t]) : this.lookupMutationBatch(e, t).next(function(e) {
                    if (e) {
                        var n = e.keys();
                        return _this.vn[t] = n, n;
                    }
                    return null;
                });
            }
        },
        {
            key: "getNextMutationBatchAfterBatchId",
            value: function getNextMutationBatchAfterBatchId(e, t) {
                var _this = this;
                var n = t + 1, r = IDBKeyRange.lowerBound([
                    this.userId,
                    n
                ]);
                var i = null;
                return $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e).Z({
                    index: "userMutationsIndex",
                    range: r
                }, function(e, t, r) {
                    t.userId === _this.userId && ($59fc9b849b320ded$var$__PRIVATE_hardAssert(t.batchId >= n), i = $59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(_this.serializer, t)), r.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "getHighestUnacknowledgedBatchId",
            value: function getHighestUnacknowledgedBatchId(e) {
                var t = IDBKeyRange.upperBound([
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                var n = -1;
                return $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e).Z({
                    index: "userMutationsIndex",
                    range: t,
                    reverse: !0
                }, function(e, t, r) {
                    n = t.batchId, r.done();
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getAllMutationBatches",
            value: function getAllMutationBatches(e) {
                var _this = this;
                var t = IDBKeyRange.bound([
                    this.userId,
                    -1
                ], [
                    this.userId,
                    Number.POSITIVE_INFINITY
                ]);
                return $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e).G("userMutationsIndex", t).next(function(e) {
                    return e.map(function(e) {
                        return $59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(_this.serializer, e);
                    });
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKey",
            value: function getAllMutationBatchesAffectingDocumentKey(e, t) {
                var _this = this;
                // Scan the document-mutation index starting with a prefix starting with
                // the given documentKey.
                var n = $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
                return $59fc9b849b320ded$var$__PRIVATE_documentMutationsStore(e).Z({
                    range: r
                }, function(n, r, s) {
                    var _n = (0, $8GFUW._)(n, 3), o = _n[0], _ = _n[1], a = _n[2], u = $59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(_);
                    // Only consider rows matching exactly the specific key of
                    // interest. Note that because we order by path first, and we
                    // order terminators before path separators, we'll encounter all
                    // the index rows for documentKey contiguously. In particular, all
                    // the rows for documentKey will occur before any rows for
                    // documents nested in a subcollection beneath documentKey so we
                    // can stop as soon as we hit any such row.
                    if (o === _this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
                    return $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e).get(a).next(function(e) {
                        if (!e) throw $59fc9b849b320ded$var$fail();
                        $59fc9b849b320ded$var$__PRIVATE_hardAssert(e.userId === _this.userId), i.push($59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(_this.serializer, e));
                    });
                    s.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKeys",
            value: function getAllMutationBatchesAffectingDocumentKeys(e, t) {
                var _this = this;
                var n = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_primitiveComparator);
                var r = [];
                return t.forEach(function(t) {
                    var i = $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationPrefixForPath(_this.userId, t.path), s = IDBKeyRange.lowerBound(i), o = $59fc9b849b320ded$var$__PRIVATE_documentMutationsStore(e).Z({
                        range: s
                    }, function(e, r, i) {
                        var _e = (0, $8GFUW._)(e, 3), s = _e[0], o = _e[1], _ = _e[2], a = $59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(o);
                        // Only consider rows matching exactly the specific key of
                        // interest. Note that because we order by path first, and we
                        // order terminators before path separators, we'll encounter all
                        // the index rows for documentKey contiguously. In particular, all
                        // the rows for documentKey will occur before any rows for
                        // documents nested in a subcollection beneath documentKey so we
                        // can stop as soon as we hit any such row.
                        s === _this.userId && t.path.isEqual(a) ? n = n.add(_) : i.done();
                    });
                    r.push(o);
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(r).next(function() {
                    return _this.Mn(e, n);
                });
            }
        },
        {
            key: "getAllMutationBatchesAffectingQuery",
            value: function getAllMutationBatchesAffectingQuery(e, t) {
                var _this = this;
                var n = t.path, r = n.length + 1, i = $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
                // Collect up unique batchIDs encountered during a scan of the index. Use a
                // SortedSet to accumulate batch IDs so they can be traversed in order in a
                // scan of the main table.
                var o = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_primitiveComparator);
                return $59fc9b849b320ded$var$__PRIVATE_documentMutationsStore(e).Z({
                    range: s
                }, function(e, t, i) {
                    var _e = (0, $8GFUW._)(e, 3), s = _e[0], _ = _e[1], a = _e[2], u = $59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(_);
                    s === _this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
                    // query path can't be matches. For example, a query on 'rooms'
                    // can't match the document /rooms/abc/messages/xyx.
                    // TODO(mcg): we'll need a different scanner when we implement
                    // ancestor queries.
                    u.length === r && (o = o.add(a)) : i.done();
                }).next(function() {
                    return _this.Mn(e, o);
                });
            }
        },
        {
            key: "Mn",
            value: function Mn(e, t) {
                var _this = this;
                var n = [], r = [];
                // TODO(rockwood): Implement this using iterate.
                return t.forEach(function(t) {
                    r.push($59fc9b849b320ded$var$__PRIVATE_mutationsStore(e).get(t).next(function(e) {
                        if (null === e) throw $59fc9b849b320ded$var$fail();
                        $59fc9b849b320ded$var$__PRIVATE_hardAssert(e.userId === _this.userId), n.push($59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(_this.serializer, e));
                    }));
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(r).next(function() {
                    return n;
                });
            }
        },
        {
            key: "removeMutationBatch",
            value: function removeMutationBatch1(e, t) {
                var _this = this;
                return $59fc9b849b320ded$var$removeMutationBatch(e.ue, this.userId, t).next(function(n) {
                    return e.addOnCommittedListener(function() {
                        _this.xn(t.batchId);
                    }), $59fc9b849b320ded$var$PersistencePromise.forEach(n, function(t) {
                        return _this.referenceDelegate.markPotentiallyOrphaned(e, t);
                    });
                });
            }
        },
        {
            /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
            key: "xn",
            value: function xn(e) {
                delete this.vn[e];
            }
        },
        {
            key: "performConsistencyCheck",
            value: function performConsistencyCheck(e) {
                var _this = this;
                return this.checkEmpty(e).next(function(t) {
                    if (!t) return $59fc9b849b320ded$var$PersistencePromise.resolve();
                    // Verify that there are no entries in the documentMutations index if
                    // the queue is empty.
                    var n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                        return [
                            e
                        ];
                    }(_this.userId)), r = [];
                    return $59fc9b849b320ded$var$__PRIVATE_documentMutationsStore(e).Z({
                        range: n
                    }, function(e, t, n) {
                        if (e[0] === _this.userId) {
                            var _$t = $59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(e[1]);
                            r.push(_$t);
                        } else n.done();
                    }).next(function() {
                        $59fc9b849b320ded$var$__PRIVATE_hardAssert(0 === r.length);
                    });
                });
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
            }
        },
        {
            // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
            /** Returns the mutation queue's metadata from IndexedDb. */ key: "On",
            value: function On(e) {
                var _this = this;
                return $59fc9b849b320ded$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next(function(e) {
                    return e || {
                        userId: _this.userId,
                        lastAcknowledgedBatchId: -1,
                        lastStreamToken: ""
                    };
                });
            }
        }
    ], [
        {
            key: "Pt",
            value: /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ function Pt(e, t, n, r) {
                // TODO(mcg): Figure out what constraints there are on userIDs
                // In particular, are there any reserved characters? are empty ids allowed?
                // For the moment store these together in the same mutations table assuming
                // that empty userIDs aren't allowed.
                $59fc9b849b320ded$var$__PRIVATE_hardAssert("" !== e.uid);
                var i = e.isAuthenticated() ? e.uid : "";
                return new __PRIVATE_IndexedDbMutationQueue(i, t, n, r);
            }
        }
    ]);
    return __PRIVATE_IndexedDbMutationQueue;
}();
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $59fc9b849b320ded$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    var r = $59fc9b849b320ded$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    var o = !1;
    return $59fc9b849b320ded$var$__PRIVATE_documentMutationsStore(e).Z({
        range: s,
        Y: !0
    }, function(e, n, r) {
        var _e = (0, $8GFUW._)(e, 3), s = _e[0], _ = _e[1], /*batchID*/ a = _e[2];
        s === t && _ === i && (o = !0), r.done();
    }).next(function() {
        return o;
    });
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_mutationsStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "mutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_documentMutationsStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "documentMutations");
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_mutationQueuesStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "mutationQueues");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ var $59fc9b849b320ded$var$__PRIVATE_TargetIdGenerator = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TargetIdGenerator(e) {
        (0, $978gY._)(this, __PRIVATE_TargetIdGenerator);
        this.Nn = e;
    }
    (0, $kry2a._)(__PRIVATE_TargetIdGenerator, [
        {
            key: "next",
            value: function next() {
                return this.Nn += 2, this.Nn;
            }
        }
    ], [
        {
            key: "Bn",
            value: function Bn() {
                // The target cache generator must return '2' in its first call to `next()`
                // as there is no differentiation in the protocol layer between an unset
                // number and the number '0'. If we were to sent a target with target ID
                // '0', the backend would consider it unset and replace it with its own ID.
                return new __PRIVATE_TargetIdGenerator(0);
            }
        },
        {
            key: "Ln",
            value: function Ln() {
                // Sync engine assigns target IDs for limbo document detection.
                return new __PRIVATE_TargetIdGenerator(-1);
            }
        }
    ]);
    return __PRIVATE_TargetIdGenerator;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbTargetCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbTargetCache(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbTargetCache);
        this.referenceDelegate = e, this.serializer = t;
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbTargetCache, [
        {
            // PORTING NOTE: We don't cache global metadata for the target cache, since
            // some of it (in particular `highestTargetId`) can be modified by secondary
            // tabs. We could perhaps be more granular (and e.g. still cache
            // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
            // to IndexedDb whenever we need to read metadata. We can revisit if it turns
            // out to have a meaningful performance impact.
            key: "allocateTargetId",
            value: function allocateTargetId(e) {
                var _this = this;
                return this.kn(e).next(function(t) {
                    var n = new $59fc9b849b320ded$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
                    return t.highestTargetId = n.next(), _this.qn(e, t).next(function() {
                        return t.highestTargetId;
                    });
                });
            }
        },
        {
            key: "getLastRemoteSnapshotVersion",
            value: function getLastRemoteSnapshotVersion(e) {
                return this.kn(e).next(function(e) {
                    return $59fc9b849b320ded$var$SnapshotVersion.fromTimestamp(new $59fc9b849b320ded$export$d9bcbd5e1ff81430(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds));
                });
            }
        },
        {
            key: "getHighestSequenceNumber",
            value: function getHighestSequenceNumber(e) {
                return this.kn(e).next(function(e) {
                    return e.highestListenSequenceNumber;
                });
            }
        },
        {
            key: "setTargetsMetadata",
            value: function setTargetsMetadata(e, t, n) {
                var _this = this;
                return this.kn(e).next(function(r) {
                    return r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), _this.qn(e, r);
                });
            }
        },
        {
            key: "addTargetData",
            value: function addTargetData(e, t) {
                var _this = this;
                return this.Qn(e, t).next(function() {
                    return _this.kn(e).next(function(n) {
                        return n.targetCount += 1, _this.Kn(t, n), _this.qn(e, n);
                    });
                });
            }
        },
        {
            key: "updateTargetData",
            value: function updateTargetData(e, t) {
                return this.Qn(e, t);
            }
        },
        {
            key: "removeTargetData",
            value: function removeTargetData(e, t) {
                var _this = this;
                return this.removeMatchingKeysForTargetId(e, t.targetId).next(function() {
                    return $59fc9b849b320ded$var$__PRIVATE_targetsStore(e).delete(t.targetId);
                }).next(function() {
                    return _this.kn(e);
                }).next(function(t) {
                    return $59fc9b849b320ded$var$__PRIVATE_hardAssert(t.targetCount > 0), t.targetCount -= 1, _this.qn(e, t);
                });
            }
        },
        {
            /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ key: "removeTargets",
            value: function removeTargets(e, t, n) {
                var _this = this;
                var r = 0;
                var i = [];
                return $59fc9b849b320ded$var$__PRIVATE_targetsStore(e).Z(function(s, o) {
                    var _ = $59fc9b849b320ded$var$__PRIVATE_fromDbTarget(o);
                    _.sequenceNumber <= t && null === n.get(_.targetId) && (r++, i.push(_this.removeTargetData(e, _)));
                }).next(function() {
                    return $59fc9b849b320ded$var$PersistencePromise.waitFor(i);
                }).next(function() {
                    return r;
                });
            }
        },
        {
            /**
     * Call provided function with each `TargetData` that we have cached.
     */ key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_targetsStore(e).Z(function(e, n) {
                    var r = $59fc9b849b320ded$var$__PRIVATE_fromDbTarget(n);
                    t(r);
                });
            }
        },
        {
            key: "kn",
            value: function kn(e) {
                return $59fc9b849b320ded$var$__PRIVATE_globalTargetStore(e).get("targetGlobalKey").next(function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_hardAssert(null !== e), e;
                });
            }
        },
        {
            key: "qn",
            value: function qn(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_globalTargetStore(e).put("targetGlobalKey", t);
            }
        },
        {
            key: "Qn",
            value: function Qn(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_targetsStore(e).put($59fc9b849b320ded$var$__PRIVATE_toDbTarget(this.serializer, t));
            }
        },
        {
            /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ key: "Kn",
            value: function Kn(e, t) {
                var n = !1;
                return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
            }
        },
        {
            key: "getTargetCount",
            value: function getTargetCount(e) {
                return this.kn(e).next(function(e) {
                    return e.targetCount;
                });
            }
        },
        {
            key: "getTargetData",
            value: function getTargetData(e, t) {
                // Iterating by the canonicalId may yield more than one result because
                // canonicalId values are not required to be unique per target. This query
                // depends on the queryTargets index to be efficient.
                var n = $59fc9b849b320ded$var$__PRIVATE_canonifyTarget(t), r = IDBKeyRange.bound([
                    n,
                    Number.NEGATIVE_INFINITY
                ], [
                    n,
                    Number.POSITIVE_INFINITY
                ]);
                var i = null;
                return $59fc9b849b320ded$var$__PRIVATE_targetsStore(e).Z({
                    range: r,
                    index: "queryTargetsIndex"
                }, function(e, n, r) {
                    var s = $59fc9b849b320ded$var$__PRIVATE_fromDbTarget(n);
                    // After finding a potential match, check that the target is
                    // actually equal to the requested target.
                    $59fc9b849b320ded$var$__PRIVATE_targetEquals(t, s.target) && (i = s, r.done());
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "addMatchingKeys",
            value: function addMatchingKeys(e, t, n) {
                var _this = this;
                // PORTING NOTE: The reverse index (documentsTargets) is maintained by
                // IndexedDb.
                var r = [], i = $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e);
                return t.forEach(function(t) {
                    var s = $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(t.path);
                    r.push(i.put({
                        targetId: n,
                        path: s
                    })), r.push(_this.referenceDelegate.addReference(e, n, t));
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(r);
            }
        },
        {
            key: "removeMatchingKeys",
            value: function removeMatchingKeys(e, t, n) {
                var _this = this;
                // PORTING NOTE: The reverse index (documentsTargets) is maintained by
                // IndexedDb.
                var r = $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e);
                return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t) {
                    var i = $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(t.path);
                    return $59fc9b849b320ded$var$PersistencePromise.waitFor([
                        r.delete([
                            n,
                            i
                        ]),
                        _this.referenceDelegate.removeReference(e, n, t)
                    ]);
                });
            }
        },
        {
            key: "removeMatchingKeysForTargetId",
            value: function removeMatchingKeysForTargetId(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
                    t
                ], [
                    t + 1
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                return n.delete(r);
            }
        },
        {
            key: "getMatchingKeysForTargetId",
            value: function getMatchingKeysForTargetId(e, t) {
                var n = IDBKeyRange.bound([
                    t
                ], [
                    t + 1
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e);
                var i = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                return r.Z({
                    range: n,
                    Y: !0
                }, function(e, t, n) {
                    var r = $59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(e[1]), s = new $59fc9b849b320ded$export$afc2e57c475b7810(r);
                    i = i.add(s);
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
                    n
                ], [
                    $59fc9b849b320ded$var$__PRIVATE_immediateSuccessor(n)
                ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
                var i = 0;
                return $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e).Z({
                    index: "documentTargetsIndex",
                    Y: !0,
                    range: r
                }, function(param, n, r) {
                    var _param = (0, $8GFUW._)(param, 2), _$e = _param[0], _$t = _param[1];
                    // Having a sentinel row for a document does not count as containing that document;
                    // For the target cache, containing the document means the document is part of some
                    // target.
                    0 !== _$e && (i++, r.done());
                }).next(function() {
                    return i > 0;
                });
            }
        },
        {
            /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
            key: "lt",
            value: function lt(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_targetsStore(e).get(t).next(function(e) {
                    return e ? $59fc9b849b320ded$var$__PRIVATE_fromDbTarget(e) : null;
                });
            }
        }
    ]);
    return __PRIVATE_IndexedDbTargetCache;
}();
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_targetsStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "targets");
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_globalTargetStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "targetGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "targetDocuments");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fc9b849b320ded$var$__PRIVATE_bufferEntryComparator(param, param1) {
    var _param = (0, $8GFUW._)(param, 2), e = _param[0], t = _param[1], _param1 = (0, $8GFUW._)(param1, 2), n = _param1[0], r = _param1[1];
    var i = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ var $59fc9b849b320ded$var$__PRIVATE_RollingSequenceNumberBuffer = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RollingSequenceNumberBuffer(e) {
        (0, $978gY._)(this, __PRIVATE_RollingSequenceNumberBuffer);
        this.$n = e, this.buffer = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_bufferEntryComparator), this.Un = 0;
    }
    (0, $kry2a._)(__PRIVATE_RollingSequenceNumberBuffer, [
        {
            key: "Wn",
            value: function Wn() {
                return ++this.Un;
            }
        },
        {
            key: "Gn",
            value: function Gn(e) {
                var t = [
                    e,
                    this.Wn()
                ];
                if (this.buffer.size < this.$n) this.buffer = this.buffer.add(t);
                else {
                    var _$e = this.buffer.last();
                    $59fc9b849b320ded$var$__PRIVATE_bufferEntryComparator(t, _$e) < 0 && (this.buffer = this.buffer.delete(_$e).add(t));
                }
            }
        },
        {
            key: "maxValue",
            get: function get() {
                // Guaranteed to be non-empty. If we decide we are not collecting any
                // sequence numbers, nthSequenceNumber below short-circuits. If we have
                // decided that we are collecting n sequence numbers, it's because n is some
                // percentage of the existing sequence numbers. That means we should never
                // be in a situation where we are collecting sequence numbers but don't
                // actually have any.
                return this.buffer.last()[0];
            }
        }
    ]);
    return __PRIVATE_RollingSequenceNumberBuffer;
}();
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ var $59fc9b849b320ded$var$__PRIVATE_LruScheduler = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LruScheduler(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_LruScheduler);
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.zn = null;
    }
    (0, $kry2a._)(__PRIVATE_LruScheduler, [
        {
            key: "start",
            value: function start() {
                -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.jn(6e4);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.zn && (this.zn.cancel(), this.zn = null);
            }
        },
        {
            key: "started",
            get: function get() {
                return null !== this.zn;
            }
        },
        {
            key: "jn",
            value: function jn(e) {
                var _this = this;
                $59fc9b849b320ded$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection scheduled in ".concat(e, "ms")), this.zn = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, /*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.zn = null;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    _this.localStore.collectGarbage(_this.garbageCollector)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 3:
                                e = _state.sent();
                                if (!$59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e)) return [
                                    3,
                                    4
                                ];
                                _tmp = $59fc9b849b320ded$var$__PRIVATE_logDebug("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", e);
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                return [
                                    4,
                                    $59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e)
                                ];
                            case 5:
                                _tmp = _state.sent();
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    4,
                                    _this.jn(3e5)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                }));
            }
        }
    ]);
    return __PRIVATE_LruScheduler;
}();
/**
 * Implements the steps for LRU garbage collection.
 */ var $59fc9b849b320ded$var$__PRIVATE_LruGarbageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LruGarbageCollectorImpl(e, t) {
        (0, $978gY._)(this, __PRIVATE_LruGarbageCollectorImpl);
        this.Hn = e, this.params = t;
    }
    (0, $kry2a._)(__PRIVATE_LruGarbageCollectorImpl, [
        {
            key: "calculateTargetCount",
            value: function calculateTargetCount(e, t) {
                return this.Hn.Jn(e).next(function(e) {
                    return Math.floor(t / 100 * e);
                });
            }
        },
        {
            key: "nthSequenceNumber",
            value: function nthSequenceNumber(e, t) {
                var _this = this;
                if (0 === t) return $59fc9b849b320ded$var$PersistencePromise.resolve($59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae);
                var n = new $59fc9b849b320ded$var$__PRIVATE_RollingSequenceNumberBuffer(t);
                return this.Hn.forEachTarget(e, function(e) {
                    return n.Gn(e.sequenceNumber);
                }).next(function() {
                    return _this.Hn.Yn(e, function(e) {
                        return n.Gn(e);
                    });
                }).next(function() {
                    return n.maxValue;
                });
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.Hn.removeTargets(e, t, n);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                return this.Hn.removeOrphanedDocuments(e, t);
            }
        },
        {
            key: "collect",
            value: function collect(e, t) {
                var _this = this;
                return -1 === this.params.cacheSizeCollectionThreshold ? ($59fc9b849b320ded$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), $59fc9b849b320ded$var$PersistencePromise.resolve($59fc9b849b320ded$var$Te)) : this.getCacheSize(e).next(function(n) {
                    return n < _this.params.cacheSizeCollectionThreshold ? ($59fc9b849b320ded$var$__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; Cache size ".concat(n, " is lower than threshold ").concat(_this.params.cacheSizeCollectionThreshold)), $59fc9b849b320ded$var$Te) : _this.Zn(e, t);
                });
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.Hn.getCacheSize(e);
            }
        },
        {
            key: "Zn",
            value: function Zn(e, t) {
                var _this = this;
                var n, r, i, s, o, a, u;
                var c = Date.now();
                return this.calculateTargetCount(e, this.params.percentileToCollect).next(function(t) {
                    return(// Cap at the configured max
                    t > _this.params.maximumSequenceNumbersToCollect ? ($59fc9b849b320ded$var$__PRIVATE_logDebug("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of ".concat(_this.params.maximumSequenceNumbersToCollect, " from ").concat(t)), r = _this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), _this.nthSequenceNumber(e, r));
                }).next(function(r) {
                    return n = r, o = Date.now(), _this.removeTargets(e, n, t);
                }).next(function(t) {
                    return i = t, a = Date.now(), _this.removeOrphanedDocuments(e, n);
                }).next(function(e) {
                    if (u = Date.now(), $59fc9b849b320ded$var$__PRIVATE_getLogLevel() <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).DEBUG) $59fc9b849b320ded$var$__PRIVATE_logDebug("LruGarbageCollector", "LRU Garbage Collection\n	Counted targets in ".concat(s - c, "ms\n	Determined least recently used ").concat(r, " in ") + (o - s) + "ms\n" + "	Removed ".concat(i, " targets in ") + (a - o) + "ms\n" + "	Removed ".concat(e, " documents in ") + (u - a) + "ms\n" + "Total Duration: ".concat(u - c, "ms"));
                    return $59fc9b849b320ded$var$PersistencePromise.resolve({
                        didRun: !0,
                        sequenceNumbersCollected: r,
                        targetsRemoved: i,
                        documentsRemoved: e
                    });
                });
            }
        }
    ]);
    return __PRIVATE_LruGarbageCollectorImpl;
}();
function $59fc9b849b320ded$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $59fc9b849b320ded$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbLruDelegateImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbLruDelegateImpl(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbLruDelegateImpl);
        this.db = e, this.garbageCollector = $59fc9b849b320ded$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbLruDelegateImpl, [
        {
            key: "Jn",
            value: function Jn(e) {
                var t = this.Xn(e);
                return this.db.getTargetCache().getTargetCount(e).next(function(e) {
                    return t.next(function(t) {
                        return e + t;
                    });
                });
            }
        },
        {
            key: "Xn",
            value: function Xn(e) {
                var t = 0;
                return this.Yn(e, function(e) {
                    t++;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.db.getTargetCache().forEachTarget(e, t);
            }
        },
        {
            key: "Yn",
            value: function Yn(e, t) {
                return this.er(e, function(e, n) {
                    return t(n);
                });
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return $59fc9b849b320ded$var$__PRIVATE_writeSentinelKey(e, n);
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return $59fc9b849b320ded$var$__PRIVATE_writeSentinelKey(e, n);
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.db.getTargetCache().removeTargets(e, t, n);
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_writeSentinelKey(e, t);
            }
        },
        {
            /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ key: "tr",
            value: function tr(e, t) {
                return function __PRIVATE_mutationQueuesContainKey(e, t) {
                    var n = !1;
                    return $59fc9b849b320ded$var$__PRIVATE_mutationQueuesStore(e).X(function(r) {
                        return $59fc9b849b320ded$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next(function(e) {
                            return e && (n = !0), $59fc9b849b320ded$var$PersistencePromise.resolve(!e);
                        });
                    }).next(function() {
                        return n;
                    });
                }(e, t);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                var _this = this;
                var n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
                var i = 0;
                return this.er(e, function(s, o) {
                    if (o <= t) {
                        var _$t = _this.tr(e, s).next(function(t) {
                            if (!t) // Our size accounting requires us to read all documents before
                            // removing them.
                            return i++, n.getEntry(e, s).next(function() {
                                return n.removeEntry(s, $59fc9b849b320ded$var$SnapshotVersion.min()), $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                                    return [
                                        0,
                                        $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(e.path)
                                    ];
                                }(s));
                            });
                        });
                        r.push(_$t);
                    }
                }).next(function() {
                    return $59fc9b849b320ded$var$PersistencePromise.waitFor(r);
                }).next(function() {
                    return n.apply(e);
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var n = t.withSequenceNumber(e.currentSequenceNumber);
                return this.db.getTargetCache().updateTargetData(e, n);
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_writeSentinelKey(e, t);
            }
        },
        {
            /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ key: "er",
            value: function er(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e);
                var r, i = $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae;
                return n.Z({
                    index: "documentTargetsIndex"
                }, function(param, param1) {
                    var _param = (0, $8GFUW._)(param, 2), _$e = _param[0], n = _param[1], s = param1.path, o = param1.sequenceNumber;
                    0 === _$e ? // if nextToReport is valid, report it, this is a new key so the
                    // last one must not be a member of any targets.
                    (i !== $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae && t(new $59fc9b849b320ded$export$afc2e57c475b7810($59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
                    // might report, if we don't find any targets for this document.
                    // Note that the sequence number must be defined when the targetId
                    // is 0.
                    i = o, r = s) : // set nextToReport to be invalid, we know we don't need to report
                    // this one since we found a target for it.
                    i = $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae;
                }).next(function() {
                    // Since we report sequence numbers after getting to the next key, we
                    // need to check if the last key we iterated over was an orphaned
                    // document and report it.
                    i !== $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae && t(new $59fc9b849b320ded$export$afc2e57c475b7810($59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(r)), i);
                });
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.db.getRemoteDocumentCache().getSize(e);
            }
        }
    ]);
    return __PRIVATE_IndexedDbLruDelegateImpl;
}();
function $59fc9b849b320ded$var$__PRIVATE_writeSentinelKey(e, t) {
    return $59fc9b849b320ded$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ var $59fc9b849b320ded$var$RemoteDocumentChangeBuffer = /*#__PURE__*/ function() {
    "use strict";
    function RemoteDocumentChangeBuffer() {
        (0, $978gY._)(this, RemoteDocumentChangeBuffer);
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $59fc9b849b320ded$var$ObjectMap(function(e) {
            return e.toString();
        }, function(e, t) {
            return e.isEqual(t);
        }), this.changesApplied = !1;
    }
    (0, $kry2a._)(RemoteDocumentChangeBuffer, [
        {
            /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ key: "addEntry",
            value: function addEntry(e) {
                this.assertNotApplied(), this.changes.set(e.key, e);
            }
        },
        {
            /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ key: "removeEntry",
            value: function removeEntry(e, t) {
                this.assertNotApplied(), this.changes.set(e, $59fc9b849b320ded$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
            }
        },
        {
            /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ key: "getEntry",
            value: function getEntry(e, t) {
                this.assertNotApplied();
                var n = this.changes.get(t);
                return void 0 !== n ? $59fc9b849b320ded$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
            }
        },
        {
            /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ key: "getEntries",
            value: function getEntries(e, t) {
                return this.getAllFromCache(e, t);
            }
        },
        {
            /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ key: "apply",
            value: function apply(e) {
                return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
            }
        },
        {
            /** Helper to assert this.changes is not null  */ key: "assertNotApplied",
            value: function assertNotApplied() {}
        }
    ]);
    return RemoteDocumentChangeBuffer;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbRemoteDocumentCacheImpl(e) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbRemoteDocumentCacheImpl);
        this.serializer = e;
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbRemoteDocumentCacheImpl, [
        {
            key: "setIndexManager",
            value: function setIndexManager(e) {
                this.indexManager = e;
            }
        },
        {
            /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ key: "addEntry",
            value: function addEntry(e, t, n) {
                return $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e).put(n);
            }
        },
        {
            /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ key: "removeEntry",
            value: function removeEntry(e, t, n) {
                return $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
                    var _$n = e.path.toArray();
                    return [
                        /* prefix path */ _$n.slice(0, _$n.length - 2),
                        /* collection id */ _$n[_$n.length - 2],
                        $59fc9b849b320ded$var$__PRIVATE_toDbTimestampKey(t),
                        /* document id */ _$n[_$n.length - 1]
                    ];
                }(t, n));
            }
        },
        {
            /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ key: "updateMetadata",
            value: function updateMetadata(e, t) {
                var _this = this;
                return this.getMetadata(e).next(function(n) {
                    return n.byteSize += t, _this.nr(e, n);
                });
            }
        },
        {
            key: "getEntry",
            value: function getEntry(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$MutableDocument.newInvalidDocument(t);
                return $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e).Z({
                    index: "documentKeyIndex",
                    range: IDBKeyRange.only($59fc9b849b320ded$var$__PRIVATE_dbKey(t))
                }, function(e, r) {
                    n = _this.rr(t, r);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ key: "ir",
            value: function ir(e, t) {
                var _this = this;
                var n = {
                    size: 0,
                    document: $59fc9b849b320ded$var$MutableDocument.newInvalidDocument(t)
                };
                return $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e).Z({
                    index: "documentKeyIndex",
                    range: IDBKeyRange.only($59fc9b849b320ded$var$__PRIVATE_dbKey(t))
                }, function(e, r) {
                    n = {
                        document: _this.rr(t, r),
                        size: $59fc9b849b320ded$var$__PRIVATE_dbDocumentSize(r)
                    };
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
                return this.sr(e, t, function(e, t) {
                    var r = _this.rr(e, t);
                    n = n.insert(e, r);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ key: "_r",
            value: function _r(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap(), r = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
                return this.sr(e, t, function(e, t) {
                    var i = _this.rr(e, t);
                    n = n.insert(e, i), r = r.insert(e, $59fc9b849b320ded$var$__PRIVATE_dbDocumentSize(t));
                }).next(function() {
                    return {
                        documents: n,
                        ar: r
                    };
                });
            }
        },
        {
            key: "sr",
            value: function sr(e, t, n) {
                if (t.isEmpty()) return $59fc9b849b320ded$var$PersistencePromise.resolve();
                var r = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_dbKeyComparator);
                t.forEach(function(e) {
                    return r = r.add(e);
                });
                var i = IDBKeyRange.bound($59fc9b849b320ded$var$__PRIVATE_dbKey(r.first()), $59fc9b849b320ded$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
                var o = s.getNext();
                return $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e).Z({
                    index: "documentKeyIndex",
                    range: i
                }, function(e, t, r) {
                    var i = $59fc9b849b320ded$export$afc2e57c475b7810.fromSegments((0, $fLnyw._)(t.prefixPath).concat([
                        t.collectionGroup,
                        t.documentId
                    ]));
                    // Go through keys not found in cache.
                    for(; o && $59fc9b849b320ded$var$__PRIVATE_dbKeyComparator(o, i) < 0;)n(o, null), o = s.getNext();
                    o && o.isEqual(i) && // Key found in cache.
                    (n(o, t), o = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
                    o ? r.W($59fc9b849b320ded$var$__PRIVATE_dbKey(o)) : r.done();
                }).next(function() {
                    // The rest of the keys are not in the cache. One case where `iterate`
                    // above won't go through them is when the cache is empty.
                    for(; o;)n(o, null), o = s.hasNext() ? s.getNext() : null;
                });
            }
        },
        {
            key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r, i) {
                var _this = this;
                var s = t.path, o = [
                    s.popLast().toArray(),
                    s.lastSegment(),
                    $59fc9b849b320ded$var$__PRIVATE_toDbTimestampKey(n.readTime),
                    n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
                ], _ = [
                    s.popLast().toArray(),
                    s.lastSegment(),
                    [
                        Number.MAX_SAFE_INTEGER,
                        Number.MAX_SAFE_INTEGER
                    ],
                    ""
                ];
                return $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e).G(IDBKeyRange.bound(o, _, !0)).next(function(e) {
                    null == i || i.incrementDocumentReadCount(e.length);
                    var _$n = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$i = _step.value;
                            var _$e = _this.rr($59fc9b849b320ded$export$afc2e57c475b7810.fromSegments(_$i.prefixPath.concat(_$i.collectionGroup, _$i.documentId)), _$i);
                            _$e.isFoundDocument() && ($59fc9b849b320ded$var$__PRIVATE_queryMatches(t, _$e) || r.has(_$e.key)) && // Either the document matches the given query, or it is mutated.
                            (_$n = _$n.insert(_$e.key, _$e));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$n;
                });
            }
        },
        {
            key: "getAllFromCollectionGroup",
            value: function getAllFromCollectionGroup(e, t, n, r) {
                var _this = this;
                var i = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
                var s = $59fc9b849b320ded$var$__PRIVATE_dbCollectionGroupKey(t, n), o = $59fc9b849b320ded$var$__PRIVATE_dbCollectionGroupKey(t, $59fc9b849b320ded$var$IndexOffset.max());
                return $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e).Z({
                    index: "collectionGroupIndex",
                    range: IDBKeyRange.bound(s, o, !0)
                }, function(e, t, n) {
                    var s = _this.rr($59fc9b849b320ded$export$afc2e57c475b7810.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
                    i = i.insert(s.key, s), i.size === r && n.done();
                }).next(function() {
                    return i;
                });
            }
        },
        {
            key: "newChangeBuffer",
            value: function newChangeBuffer(e) {
                return new $59fc9b849b320ded$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
            }
        },
        {
            key: "getSize",
            value: function getSize(e) {
                return this.getMetadata(e).next(function(e) {
                    return e.byteSize;
                });
            }
        },
        {
            key: "getMetadata",
            value: function getMetadata(e) {
                return $59fc9b849b320ded$var$__PRIVATE_documentGlobalStore(e).get("remoteDocumentGlobalKey").next(function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!e), e;
                });
            }
        },
        {
            key: "nr",
            value: function nr(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_documentGlobalStore(e).put("remoteDocumentGlobalKey", t);
            }
        },
        {
            /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ key: "rr",
            value: function rr(e, t) {
                if (t) {
                    var _$e = $59fc9b849b320ded$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
                    // Whether the document is a sentinel removal and should only be used in the
                    // `getNewDocumentChanges()`
                    if (!(_$e.isNoDocument() && _$e.version.isEqual($59fc9b849b320ded$var$SnapshotVersion.min()))) return _$e;
                }
                return $59fc9b849b320ded$var$MutableDocument.newInvalidDocument(e);
            }
        }
    ]);
    return __PRIVATE_IndexedDbRemoteDocumentCacheImpl;
}();
/** Creates a new IndexedDbRemoteDocumentCache. */ function $59fc9b849b320ded$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $59fc9b849b320ded$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer = /*#__PURE__*/ function(RemoteDocumentChangeBuffer) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer, RemoteDocumentChangeBuffer);
    var _super = (0, $6OZAO._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer);
    function __PRIVATE_IndexedDbRemoteDocumentChangeBuffer(e, t) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbRemoteDocumentChangeBuffer);
        var _this;
        _this = _super.call(this), _this.ur = e, _this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        _this.cr = new $59fc9b849b320ded$var$ObjectMap(function(e) {
            return e.toString();
        }, function(e, t) {
            return e.isEqual(t);
        });
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbRemoteDocumentChangeBuffer, [
        {
            key: "applyChanges",
            value: function applyChanges(e) {
                var _this = this;
                var t = [];
                var n = 0, r = new $59fc9b849b320ded$var$SortedSet(function(e, t) {
                    return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString());
                });
                return this.changes.forEach(function(i, s) {
                    var o = _this.cr.get(i);
                    if (t.push(_this.ur.removeEntry(e, i, o.readTime)), s.isValidDocument()) {
                        var _ = $59fc9b849b320ded$var$__PRIVATE_toDbRemoteDocument(_this.ur.serializer, s);
                        r = r.add(i.path.popLast());
                        var a = $59fc9b849b320ded$var$__PRIVATE_dbDocumentSize(_);
                        n += a - o.size, t.push(_this.ur.addEntry(e, i, _));
                    } else if (n -= o.size, _this.trackRemovals) {
                        // In order to track removals, we store a "sentinel delete" in the
                        // RemoteDocumentCache. This entry is represented by a NoDocument
                        // with a version of 0 and ignored by `maybeDecodeDocument()` but
                        // preserved in `getNewDocumentChanges()`.
                        var n1 = $59fc9b849b320ded$var$__PRIVATE_toDbRemoteDocument(_this.ur.serializer, s.convertToNoDocument($59fc9b849b320ded$var$SnapshotVersion.min()));
                        t.push(_this.ur.addEntry(e, i, n1));
                    }
                }), r.forEach(function(n) {
                    t.push(_this.ur.indexManager.addToCollectionParentIndex(e, n));
                }), t.push(this.ur.updateMetadata(e, n)), $59fc9b849b320ded$var$PersistencePromise.waitFor(t);
            }
        },
        {
            key: "getFromCache",
            value: function getFromCache(e, t) {
                var _this = this;
                // Record the size of everything we load from the cache so we can compute a delta later.
                return this.ur.ir(e, t).next(function(e) {
                    return _this.cr.set(t, {
                        size: e.size,
                        readTime: e.document.readTime
                    }), e.document;
                });
            }
        },
        {
            key: "getAllFromCache",
            value: function getAllFromCache(e, t) {
                var _this = this;
                // Record the size of everything we load from the cache so we can compute
                // a delta later.
                return this.ur._r(e, t).next(function(param) {
                    var _$e = param.documents, _$t = param.ar;
                    return(// Note: `getAllFromCache` returns two maps instead of a single map from
                    // keys to `DocumentSizeEntry`s. This is to allow returning the
                    // `MutableDocumentMap` directly, without a conversion.
                    _$t.forEach(function(t, n) {
                        _this.cr.set(t, {
                            size: n,
                            readTime: _$e.get(t).readTime
                        });
                    }), _$e);
                });
            }
        }
    ]);
    return __PRIVATE_IndexedDbRemoteDocumentChangeBuffer;
}($59fc9b849b320ded$var$RemoteDocumentChangeBuffer);
function $59fc9b849b320ded$var$__PRIVATE_documentGlobalStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "remoteDocumentGlobal");
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_remoteDocumentsStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "remoteDocumentsV14");
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $59fc9b849b320ded$var$__PRIVATE_dbKey(e) {
    var t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $59fc9b849b320ded$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    var n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $59fc9b849b320ded$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $59fc9b849b320ded$var$__PRIVATE_dbKeyComparator(e, t) {
    var n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    var i = 0;
    for(var _$e = 0; _$e < n.length - 2 && _$e < r.length - 2; ++_$e)if (i = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n[_$e], r[_$e]), i) return i;
    return i = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ var $59fc9b849b320ded$var$OverlayedDocument = function OverlayedDocument(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t) {
    "use strict";
    (0, $978gY._)(this, OverlayedDocument);
    this.overlayedDocument = e, this.mutatedFields = t;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ var $59fc9b849b320ded$var$LocalDocumentsView = /*#__PURE__*/ function() {
    "use strict";
    function LocalDocumentsView(e, t, n, r) {
        (0, $978gY._)(this, LocalDocumentsView);
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    (0, $kry2a._)(LocalDocumentsView, [
        {
            /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ key: "getDocument",
            value: function getDocument(e, t) {
                var _this = this;
                var n = null;
                return this.documentOverlayCache.getOverlay(e, t).next(function(r) {
                    return n = r, _this.remoteDocumentCache.getEntry(e, t);
                }).next(function(e) {
                    return null !== n && $59fc9b849b320ded$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $59fc9b849b320ded$var$FieldMask.empty(), $59fc9b849b320ded$export$d9bcbd5e1ff81430.now()), e;
                });
            }
        },
        {
            /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ key: "getDocuments",
            value: function getDocuments(e, t) {
                var _this = this;
                return this.remoteDocumentCache.getEntries(e, t).next(function(t) {
                    return _this.getLocalViewOfDocuments(e, t, $59fc9b849b320ded$var$__PRIVATE_documentKeySet()).next(function() {
                        return t;
                    });
                });
            }
        },
        {
            /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ key: "getLocalViewOfDocuments",
            value: function getLocalViewOfDocuments(e, t) {
                var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                var _this = this;
                var r = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap();
                return this.populateOverlays(e, r, t).next(function() {
                    return _this.computeViews(e, t, r, n).next(function(e) {
                        var _$t = $59fc9b849b320ded$var$documentMap();
                        return e.forEach(function(e, n) {
                            _$t = _$t.insert(e, n.overlayedDocument);
                        }), _$t;
                    });
                });
            }
        },
        {
            /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ key: "getOverlayedDocuments",
            value: function getOverlayedDocuments(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap();
                return this.populateOverlays(e, n, t).next(function() {
                    return _this.computeViews(e, t, n, $59fc9b849b320ded$var$__PRIVATE_documentKeySet());
                });
            }
        },
        {
            /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ key: "populateOverlays",
            value: function populateOverlays(e, t, n) {
                var r = [];
                return n.forEach(function(e) {
                    t.has(e) || r.push(e);
                }), this.documentOverlayCache.getOverlays(e, r).next(function(e) {
                    e.forEach(function(e, n) {
                        t.set(e, n);
                    });
                });
            }
        },
        {
            /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @return A map represents the local documents view.
     */ key: "computeViews",
            value: function computeViews(e, t, n, r) {
                var i = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
                var s = $59fc9b849b320ded$var$__PRIVATE_newDocumentKeyMap(), o = function __PRIVATE_newOverlayedDocumentMap() {
                    return $59fc9b849b320ded$var$__PRIVATE_newDocumentKeyMap();
                }();
                return t.forEach(function(e, t) {
                    var o = n.get(t.key);
                    // Recalculate an overlay if the document's existence state changed due to
                    // a remote event *and* the overlay is a PatchMutation. This is because
                    // document existence state can change if some patch mutation's
                    // preconditions are met.
                    // NOTE: we recalculate when `overlay` is undefined as well, because there
                    // might be a patch mutation whose precondition does not match before the
                    // change (hence overlay is undefined), but would now match.
                    r.has(t.key) && (void 0 === o || o.mutation instanceof $59fc9b849b320ded$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== o ? (s.set(t.key, o.mutation.getFieldMask()), $59fc9b849b320ded$var$__PRIVATE_mutationApplyToLocalView(o.mutation, t, o.mutation.getFieldMask(), $59fc9b849b320ded$export$d9bcbd5e1ff81430.now())) : // no overlay exists
                    // Using EMPTY to indicate there is no overlay for the document.
                    s.set(t.key, $59fc9b849b320ded$var$FieldMask.empty());
                }), this.recalculateAndSaveOverlays(e, i).next(function(e) {
                    return e.forEach(function(e, t) {
                        return s.set(e, t);
                    }), t.forEach(function(e, t) {
                        var n;
                        return o.set(e, new $59fc9b849b320ded$var$OverlayedDocument(t, null !== (n = s.get(e)) && void 0 !== n ? n : null));
                    }), o;
                });
            }
        },
        {
            key: "recalculateAndSaveOverlays",
            value: function recalculateAndSaveOverlays(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_newDocumentKeyMap();
                // A reverse lookup map from batch id to the documents within that batch.
                var r = new $59fc9b849b320ded$var$SortedMap(function(e, t) {
                    return e - t;
                }), i = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next(function(e) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        var _loop = function() {
                            var i = _step.value;
                            i.keys().forEach(function(e) {
                                var s = t.get(e);
                                if (null === s) return;
                                var o = n.get(e) || $59fc9b849b320ded$var$FieldMask.empty();
                                o = i.applyToLocalView(s, o), n.set(e, o);
                                var _ = (r.get(i.batchId) || $59fc9b849b320ded$var$__PRIVATE_documentKeySet()).add(e);
                                r = r.insert(i.batchId, _);
                            });
                        };
                        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }).next(function() {
                    var _loop = function() {
                        var r = o.getNext(), _ = r.key, a = r.value, u = $59fc9b849b320ded$var$__PRIVATE_newMutationMap();
                        a.forEach(function(e) {
                            if (!i.has(e)) {
                                var r = $59fc9b849b320ded$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                                null !== r && u.set(e, r), i = i.add(e);
                            }
                        }), s.push(_this.documentOverlayCache.saveOverlays(e, _, u));
                    };
                    var s = [], o = r.getReverseIterator();
                    // Iterate in descending order of batch IDs, and skip documents that are
                    // already saved.
                    for(; o.hasNext();)_loop();
                    return $59fc9b849b320ded$var$PersistencePromise.waitFor(s);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ key: "recalculateAndSaveOverlaysForDocumentKeys",
            value: function recalculateAndSaveOverlaysForDocumentKeys(e, t) {
                var _this = this;
                return this.remoteDocumentCache.getEntries(e, t).next(function(t) {
                    return _this.recalculateAndSaveOverlays(e, t);
                });
            }
        },
        {
            /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                /**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ return function __PRIVATE_isDocumentQuery$1(e) {
                    return $59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
                }(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $59fc9b849b320ded$var$__PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
            }
        },
        {
            /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup The collection group for the documents.
     * @param offset The offset to index into.
     * @param count The number of documents to return
     * @return A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ key: "getNextDocuments",
            value: function getNextDocuments(e, t, n, r) {
                var _this = this;
                return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next(function(i) {
                    var s = r - i.size > 0 ? _this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $59fc9b849b320ded$var$PersistencePromise.resolve($59fc9b849b320ded$var$__PRIVATE_newOverlayMap());
                    // The callsite will use the largest batch ID together with the latest read time to create
                    // a new index offset. Since we only process batch IDs if all remote documents have been read,
                    // no overlay will increase the overall read time. This is why we only need to special case
                    // the batch id.
                    var o = -1, _ = i;
                    return s.next(function(t) {
                        return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t, n) {
                            return o < n.largestBatchId && (o = n.largestBatchId), i.get(t) ? $59fc9b849b320ded$var$PersistencePromise.resolve() : _this.remoteDocumentCache.getEntry(e, t).next(function(e) {
                                _ = _.insert(t, e);
                            });
                        }).next(function() {
                            return _this.populateOverlays(e, t, i);
                        }).next(function() {
                            return _this.computeViews(e, _, t, $59fc9b849b320ded$var$__PRIVATE_documentKeySet());
                        }).next(function(e) {
                            return {
                                batchId: o,
                                changes: $59fc9b849b320ded$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                            };
                        });
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingDocumentQuery",
            value: function getDocumentsMatchingDocumentQuery(e, t) {
                // Just do a simple document lookup.
                return this.getDocument(e, new $59fc9b849b320ded$export$afc2e57c475b7810(t)).next(function(e) {
                    var _$t = $59fc9b849b320ded$var$documentMap();
                    return e.isFoundDocument() && (_$t = _$t.insert(e.key, e)), _$t;
                });
            }
        },
        {
            key: "getDocumentsMatchingCollectionGroupQuery",
            value: function getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
                var _this = this;
                var i = t.collectionGroup;
                var s = $59fc9b849b320ded$var$documentMap();
                return this.indexManager.getCollectionParents(e, i).next(function(o) {
                    return $59fc9b849b320ded$var$PersistencePromise.forEach(o, function(o) {
                        var _ = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                            return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                        }(t, o.child(i));
                        return _this.getDocumentsMatchingCollectionQuery(e, _, n, r).next(function(e) {
                            e.forEach(function(e, t) {
                                s = s.insert(e, t);
                            });
                        });
                    }).next(function() {
                        return s;
                    });
                });
            }
        },
        {
            key: "getDocumentsMatchingCollectionQuery",
            value: function getDocumentsMatchingCollectionQuery(e, t, n, r) {
                var _this = this;
                // Query the remote documents and overlay mutations.
                var i;
                return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next(function(s) {
                    return i = s, _this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r);
                }).next(function(e) {
                    // As documents might match the query because of their overlay we need to
                    // include documents for all overlays in the initial document set.
                    i.forEach(function(t, n) {
                        var r = n.getKey();
                        null === e.get(r) && (e = e.insert(r, $59fc9b849b320ded$var$MutableDocument.newInvalidDocument(r)));
                    });
                    // Apply the overlays and match against the query.
                    var _$n = $59fc9b849b320ded$var$documentMap();
                    return e.forEach(function(e, r) {
                        var s = i.get(e);
                        void 0 !== s && $59fc9b849b320ded$var$__PRIVATE_mutationApplyToLocalView(s.mutation, r, $59fc9b849b320ded$var$FieldMask.empty(), $59fc9b849b320ded$export$d9bcbd5e1ff81430.now()), // Finally, insert the documents that still match the query
                        $59fc9b849b320ded$var$__PRIVATE_queryMatches(t, r) && (_$n = _$n.insert(e, r));
                    }), _$n;
                });
            }
        }
    ]);
    return LocalDocumentsView;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryBundleCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryBundleCache(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryBundleCache);
        this.serializer = e, this.lr = new Map, this.hr = new Map;
    }
    (0, $kry2a._)(__PRIVATE_MemoryBundleCache, [
        {
            key: "getBundleMetadata",
            value: function getBundleMetadata(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.lr.get(t));
            }
        },
        {
            key: "saveBundleMetadata",
            value: function saveBundleMetadata(e, t) {
                return this.lr.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
                    return {
                        id: e.id,
                        version: e.version,
                        createTime: $59fc9b849b320ded$var$__PRIVATE_fromVersion(e.createTime)
                    };
                }(t)), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "getNamedQuery",
            value: function getNamedQuery(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.hr.get(t));
            }
        },
        {
            key: "saveNamedQuery",
            value: function saveNamedQuery(e, t) {
                return this.hr.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
                    return {
                        name: e.name,
                        query: $59fc9b849b320ded$var$__PRIVATE_fromBundledQuery(e.bundledQuery),
                        readTime: $59fc9b849b320ded$var$__PRIVATE_fromVersion(e.readTime)
                    };
                }(t)), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        }
    ]);
    return __PRIVATE_MemoryBundleCache;
}();
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryDocumentOverlayCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryDocumentOverlayCache() {
        (0, $978gY._)(this, __PRIVATE_MemoryDocumentOverlayCache);
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator), this.Pr = new Map;
    }
    (0, $kry2a._)(__PRIVATE_MemoryDocumentOverlayCache, [
        {
            key: "getOverlay",
            value: function getOverlay(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.overlays.get(t));
            }
        },
        {
            key: "getOverlays",
            value: function getOverlays(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap();
                return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t) {
                    return _this.getOverlay(e, t).next(function(e) {
                        null !== e && n.set(t, e);
                    });
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "saveOverlays",
            value: function saveOverlays(e, t, n) {
                var _this = this;
                return n.forEach(function(n, r) {
                    _this.It(e, t, r);
                }), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeOverlaysForBatchId",
            value: function removeOverlaysForBatchId(e, t, n) {
                var _this = this;
                var r = this.Pr.get(n);
                return void 0 !== r && (r.forEach(function(e) {
                    return _this.overlays = _this.overlays.remove(e);
                }), this.Pr.delete(n)), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "getOverlaysForCollection",
            value: function getOverlaysForCollection(e, t, n) {
                var r = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $59fc9b849b320ded$export$afc2e57c475b7810(t.child("")), o = this.overlays.getIteratorFrom(s);
                for(; o.hasNext();){
                    var e1 = o.getNext().value, s1 = e1.getKey();
                    if (!t.isPrefixOf(s1.path)) break;
                    // Documents from sub-collections
                    s1.path.length === i && e1.largestBatchId > n && r.set(e1.getKey(), e1);
                }
                return $59fc9b849b320ded$var$PersistencePromise.resolve(r);
            }
        },
        {
            key: "getOverlaysForCollectionGroup",
            value: function getOverlaysForCollectionGroup(e, t, n, r) {
                var i = new $59fc9b849b320ded$var$SortedMap(function(e, t) {
                    return e - t;
                });
                var s = this.overlays.getIterator();
                for(; s.hasNext();){
                    var e1 = s.getNext().value;
                    if (e1.getKey().getCollectionGroup() === t && e1.largestBatchId > n) {
                        var _$t = i.get(e1.largestBatchId);
                        null === _$t && (_$t = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap(), i = i.insert(e1.largestBatchId, _$t)), _$t.set(e1.getKey(), e1);
                    }
                }
                var o = $59fc9b849b320ded$var$__PRIVATE_newOverlayMap(), _ = i.getIterator();
                for(; _.hasNext();){
                    if (_.getNext().value.forEach(function(e, t) {
                        return o.set(e, t);
                    }), o.size() >= r) break;
                }
                return $59fc9b849b320ded$var$PersistencePromise.resolve(o);
            }
        },
        {
            key: "It",
            value: function It(e, t, n) {
                // Remove the association of the overlay to its batch id.
                var r = this.overlays.get(n.key);
                if (null !== r) {
                    var e1 = this.Pr.get(r.largestBatchId).delete(n.key);
                    this.Pr.set(r.largestBatchId, e1);
                }
                this.overlays = this.overlays.insert(n.key, new $59fc9b849b320ded$var$Overlay(t, n));
                // Create the association of this overlay to the given largestBatchId.
                var i = this.Pr.get(t);
                void 0 === i && (i = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), this.Pr.set(t, i)), this.Pr.set(t, i.add(n.key));
            }
        }
    ]);
    return __PRIVATE_MemoryDocumentOverlayCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ var $59fc9b849b320ded$var$__PRIVATE_ReferenceSet = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ReferenceSet() {
        (0, $978gY._)(this, __PRIVATE_ReferenceSet);
        // A set of outstanding references to a document sorted by key.
        this.Ir = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_DocReference.dr), // A set of outstanding references to a document sorted by target id.
        this.Tr = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_DocReference.Er);
    }
    (0, $kry2a._)(__PRIVATE_ReferenceSet, [
        {
            /** Returns true if the reference set contains no references. */ key: "isEmpty",
            value: function isEmpty() {
                return this.Ir.isEmpty();
            }
        },
        {
            /** Adds a reference to the given document key for the given ID. */ key: "addReference",
            value: function addReference(e, t) {
                var n = new $59fc9b849b320ded$var$__PRIVATE_DocReference(e, t);
                this.Ir = this.Ir.add(n), this.Tr = this.Tr.add(n);
            }
        },
        {
            /** Add references to the given document keys for the given ID. */ key: "Ar",
            value: function Ar(e, t) {
                var _this = this;
                e.forEach(function(e) {
                    return _this.addReference(e, t);
                });
            }
        },
        {
            /**
     * Removes a reference to the given document key for the given
     * ID.
     */ key: "removeReference",
            value: function removeReference(e, t) {
                this.Rr(new $59fc9b849b320ded$var$__PRIVATE_DocReference(e, t));
            }
        },
        {
            key: "Vr",
            value: function Vr(e, t) {
                var _this = this;
                e.forEach(function(e) {
                    return _this.removeReference(e, t);
                });
            }
        },
        {
            /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ key: "mr",
            value: function mr(e) {
                var _this = this;
                var t = new $59fc9b849b320ded$export$afc2e57c475b7810(new $59fc9b849b320ded$var$ResourcePath([])), n = new $59fc9b849b320ded$var$__PRIVATE_DocReference(t, e), r = new $59fc9b849b320ded$var$__PRIVATE_DocReference(t, e + 1), i = [];
                return this.Tr.forEachInRange([
                    n,
                    r
                ], function(e) {
                    _this.Rr(e), i.push(e.key);
                }), i;
            }
        },
        {
            key: "gr",
            value: function gr() {
                var _this = this;
                this.Ir.forEach(function(e) {
                    return _this.Rr(e);
                });
            }
        },
        {
            key: "Rr",
            value: function Rr(e) {
                this.Ir = this.Ir.delete(e), this.Tr = this.Tr.delete(e);
            }
        },
        {
            key: "pr",
            value: function pr(e) {
                var t = new $59fc9b849b320ded$export$afc2e57c475b7810(new $59fc9b849b320ded$var$ResourcePath([])), n = new $59fc9b849b320ded$var$__PRIVATE_DocReference(t, e), r = new $59fc9b849b320ded$var$__PRIVATE_DocReference(t, e + 1);
                var i = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                return this.Tr.forEachInRange([
                    n,
                    r
                ], function(e) {
                    i = i.add(e.key);
                }), i;
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e) {
                var t = new $59fc9b849b320ded$var$__PRIVATE_DocReference(e, 0), n = this.Ir.firstAfterOrEqual(t);
                return null !== n && e.isEqual(n.key);
            }
        }
    ]);
    return __PRIVATE_ReferenceSet;
}();
var $59fc9b849b320ded$var$__PRIVATE_DocReference = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DocReference(e, t) {
        (0, $978gY._)(this, __PRIVATE_DocReference);
        this.key = e, this.yr = t;
    }
    (0, $kry2a._)(__PRIVATE_DocReference, null, [
        {
            key: "dr",
            value: /** Compare by key then by ID */ function dr(e, t) {
                return $59fc9b849b320ded$export$afc2e57c475b7810.comparator(e.key, t.key) || $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.yr, t.yr);
            }
        },
        {
            key: "Er",
            value: /** Compare by ID then by key */ function Er(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(e.yr, t.yr) || $59fc9b849b320ded$export$afc2e57c475b7810.comparator(e.key, t.key);
            }
        }
    ]);
    return __PRIVATE_DocReference;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryMutationQueue = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryMutationQueue(e, t) {
        (0, $978gY._)(this, __PRIVATE_MemoryMutationQueue);
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.wr = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.Sr = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_DocReference.dr);
    }
    (0, $kry2a._)(__PRIVATE_MemoryMutationQueue, [
        {
            key: "checkEmpty",
            value: function checkEmpty(e) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
            }
        },
        {
            key: "addMutationBatch",
            value: function addMutationBatch(e, t, n, r) {
                var i = this.wr;
                this.wr++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
                var s = new $59fc9b849b320ded$var$MutationBatch(i, t, n, r);
                this.mutationQueue.push(s);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Track references by document key and index collection parents.
                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        this.Sr = this.Sr.add(new $59fc9b849b320ded$var$__PRIVATE_DocReference(_$t.key, i)), this.indexManager.addToCollectionParentIndex(e, _$t.key.path.popLast());
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return $59fc9b849b320ded$var$PersistencePromise.resolve(s);
            }
        },
        {
            key: "lookupMutationBatch",
            value: function lookupMutationBatch(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.br(t));
            }
        },
        {
            key: "getNextMutationBatchAfterBatchId",
            value: function getNextMutationBatchAfterBatchId(e, t) {
                var n = t + 1, r = this.Dr(n), i = r < 0 ? 0 : r;
                // The requested batchId may still be out of range so normalize it to the
                // start of the queue.
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
            }
        },
        {
            key: "getHighestUnacknowledgedBatchId",
            value: function getHighestUnacknowledgedBatchId() {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? -1 : this.wr - 1);
            }
        },
        {
            key: "getAllMutationBatches",
            value: function getAllMutationBatches(e) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.mutationQueue.slice());
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKey",
            value: function getAllMutationBatchesAffectingDocumentKey(e, t) {
                var _this = this;
                var n = new $59fc9b849b320ded$var$__PRIVATE_DocReference(t, 0), r = new $59fc9b849b320ded$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
                return this.Sr.forEachInRange([
                    n,
                    r
                ], function(e) {
                    var _$t = _this.br(e.yr);
                    i.push(_$t);
                }), $59fc9b849b320ded$var$PersistencePromise.resolve(i);
            }
        },
        {
            key: "getAllMutationBatchesAffectingDocumentKeys",
            value: function getAllMutationBatchesAffectingDocumentKeys(e, t) {
                var _this = this;
                var n = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_primitiveComparator);
                return t.forEach(function(e) {
                    var _$t = new $59fc9b849b320ded$var$__PRIVATE_DocReference(e, 0), r = new $59fc9b849b320ded$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
                    _this.Sr.forEachInRange([
                        _$t,
                        r
                    ], function(e) {
                        n = n.add(e.yr);
                    });
                }), $59fc9b849b320ded$var$PersistencePromise.resolve(this.Cr(n));
            }
        },
        {
            key: "getAllMutationBatchesAffectingQuery",
            value: function getAllMutationBatchesAffectingQuery(e, t) {
                // Use the query path as a prefix for testing if a document matches the
                // query.
                var n = t.path, r = n.length + 1;
                // Construct a document reference for actually scanning the index. Unlike
                // the prefix the document key in this reference must have an even number of
                // segments. The empty segment can be used a suffix of the query path
                // because it precedes all other segments in an ordered traversal.
                var i = n;
                $59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(i) || (i = i.child(""));
                var s = new $59fc9b849b320ded$var$__PRIVATE_DocReference(new $59fc9b849b320ded$export$afc2e57c475b7810(i), 0);
                // Find unique batchIDs referenced by all documents potentially matching the
                // query.
                var o = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_primitiveComparator);
                return this.Sr.forEachWhile(function(e) {
                    var _$t = e.key.path;
                    return !!n.isPrefixOf(_$t) && // Rows with document keys more than one segment longer than the query
                    // path can't be matches. For example, a query on 'rooms' can't match
                    // the document /rooms/abc/messages/xyx.
                    // TODO(mcg): we'll need a different scanner when we implement
                    // ancestor queries.
                    (_$t.length === r && (o = o.add(e.yr)), !0);
                }, s), $59fc9b849b320ded$var$PersistencePromise.resolve(this.Cr(o));
            }
        },
        {
            key: "Cr",
            value: function Cr(e) {
                var _this = this;
                // Construct an array of matching batches, sorted by batchID to ensure that
                // multiple mutations affecting the same document key are applied in order.
                var t = [];
                return e.forEach(function(e) {
                    var n = _this.br(e);
                    null !== n && t.push(n);
                }), t;
            }
        },
        {
            key: "removeMutationBatch",
            value: function removeMutationBatch(e, t) {
                var _this = this;
                $59fc9b849b320ded$var$__PRIVATE_hardAssert(0 === this.vr(t.batchId, "removed")), this.mutationQueue.shift();
                var n = this.Sr;
                return $59fc9b849b320ded$var$PersistencePromise.forEach(t.mutations, function(r) {
                    var i = new $59fc9b849b320ded$var$__PRIVATE_DocReference(r.key, t.batchId);
                    return n = n.delete(i), _this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
                }).next(function() {
                    _this.Sr = n;
                });
            }
        },
        {
            key: "xn",
            value: function xn(e) {
            // No-op since the memory mutation queue does not maintain a separate cache.
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                var n = new $59fc9b849b320ded$var$__PRIVATE_DocReference(t, 0), r = this.Sr.firstAfterOrEqual(n);
                return $59fc9b849b320ded$var$PersistencePromise.resolve(t.isEqual(r && r.key));
            }
        },
        {
            key: "performConsistencyCheck",
            value: function performConsistencyCheck(e) {
                return this.mutationQueue.length, $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ key: "vr",
            value: function vr(e, t) {
                return this.Dr(e);
            }
        },
        {
            /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been remvoed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ key: "Dr",
            value: function Dr(e) {
                if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
                return 0;
                // Examine the front of the queue to figure out the difference between the
                // batchId and indexes in the array. Note that since the queue is ordered
                // by batchId, if the first batch has a larger batchId then the requested
                // batchId doesn't exist in the queue.
                return e - this.mutationQueue[0].batchId;
            }
        },
        {
            /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficent.
     */ key: "br",
            value: function br(e) {
                var t = this.Dr(e);
                if (t < 0 || t >= this.mutationQueue.length) return null;
                return this.mutationQueue[t];
            }
        }
    ]);
    return __PRIVATE_MemoryMutationQueue;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryRemoteDocumentCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryRemoteDocumentCacheImpl(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryRemoteDocumentCacheImpl);
        this.Fr = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    (0, $kry2a._)(__PRIVATE_MemoryRemoteDocumentCacheImpl, [
        {
            key: "setIndexManager",
            value: function setIndexManager(e) {
                this.indexManager = e;
            }
        },
        {
            /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ key: "addEntry",
            value: function addEntry(e, t) {
                var n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.Fr(t);
                return this.docs = this.docs.insert(n, {
                    document: t.mutableCopy(),
                    size: s
                }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
            }
        },
        {
            /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ key: "removeEntry",
            value: function removeEntry(e) {
                var t = this.docs.get(e);
                t && (this.docs = this.docs.remove(e), this.size -= t.size);
            }
        },
        {
            key: "getEntry",
            value: function getEntry(e, t) {
                var n = this.docs.get(t);
                return $59fc9b849b320ded$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $59fc9b849b320ded$var$MutableDocument.newInvalidDocument(t));
            }
        },
        {
            key: "getEntries",
            value: function getEntries(e, t) {
                var _this = this;
                var n = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
                return t.forEach(function(e) {
                    var _$t = _this.docs.get(e);
                    n = n.insert(e, _$t ? _$t.document.mutableCopy() : $59fc9b849b320ded$var$MutableDocument.newInvalidDocument(e));
                }), $59fc9b849b320ded$var$PersistencePromise.resolve(n);
            }
        },
        {
            key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                var i = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
                // Documents are ordered by key, so we can use a prefix scan to narrow down
                // the documents we need to match the query against.
                var s = t.path, o = new $59fc9b849b320ded$export$afc2e57c475b7810(s.child("")), _ = this.docs.getIteratorFrom(o);
                for(; _.hasNext();){
                    var __getNext = _.getNext(), e1 = __getNext.key, __getNext_value = __getNext.value, o1 = __getNext_value.document;
                    if (!s.isPrefixOf(e1.path)) break;
                    e1.path.length > s.length + 1 || $59fc9b849b320ded$var$__PRIVATE_indexOffsetComparator($59fc9b849b320ded$var$__PRIVATE_newIndexOffsetFromDocument(o1), n) <= 0 || (r.has(o1.key) || $59fc9b849b320ded$var$__PRIVATE_queryMatches(t, o1)) && (i = i.insert(o1.key, o1.mutableCopy()));
                }
                return $59fc9b849b320ded$var$PersistencePromise.resolve(i);
            }
        },
        {
            key: "getAllFromCollectionGroup",
            value: function getAllFromCollectionGroup(e, t, n, r) {
                // This method should only be called from the IndexBackfiller if persistence
                // is enabled.
                $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "Mr",
            value: function Mr(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.forEach(this.docs, function(e) {
                    return t(e);
                });
            }
        },
        {
            key: "newChangeBuffer",
            value: function newChangeBuffer(e) {
                // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
                // a separate changelog and does not need special handling for removals.
                return new $59fc9b849b320ded$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
            }
        },
        {
            key: "getSize",
            value: function getSize(e) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.size);
            }
        }
    ]);
    return __PRIVATE_MemoryRemoteDocumentCacheImpl;
}();
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer = /*#__PURE__*/ function(RemoteDocumentChangeBuffer) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer, RemoteDocumentChangeBuffer);
    var _super = (0, $6OZAO._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer);
    function __PRIVATE_MemoryRemoteDocumentChangeBuffer(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryRemoteDocumentChangeBuffer);
        var _this;
        _this = _super.call(this), _this.ur = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_MemoryRemoteDocumentChangeBuffer, [
        {
            key: "applyChanges",
            value: function applyChanges(e) {
                var _this = this;
                var t = [];
                return this.changes.forEach(function(n, r) {
                    r.isValidDocument() ? t.push(_this.ur.addEntry(e, r)) : _this.ur.removeEntry(n);
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(t);
            }
        },
        {
            key: "getFromCache",
            value: function getFromCache(e, t) {
                return this.ur.getEntry(e, t);
            }
        },
        {
            key: "getAllFromCache",
            value: function getAllFromCache(e, t) {
                return this.ur.getEntries(e, t);
            }
        }
    ]);
    return __PRIVATE_MemoryRemoteDocumentChangeBuffer;
}($59fc9b849b320ded$var$RemoteDocumentChangeBuffer);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryTargetCache = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryTargetCache(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryTargetCache);
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.Or = new $59fc9b849b320ded$var$ObjectMap(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_canonifyTarget(e);
        }, $59fc9b849b320ded$var$__PRIVATE_targetEquals), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $59fc9b849b320ded$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.Nr = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.Br = new $59fc9b849b320ded$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.Lr = $59fc9b849b320ded$var$__PRIVATE_TargetIdGenerator.Bn();
    }
    (0, $kry2a._)(__PRIVATE_MemoryTargetCache, [
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.Or.forEach(function(e, n) {
                    return t(n);
                }), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "getLastRemoteSnapshotVersion",
            value: function getLastRemoteSnapshotVersion(e) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
            }
        },
        {
            key: "getHighestSequenceNumber",
            value: function getHighestSequenceNumber(e) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.Nr);
            }
        },
        {
            key: "allocateTargetId",
            value: function allocateTargetId(e) {
                return this.highestTargetId = this.Lr.next(), $59fc9b849b320ded$var$PersistencePromise.resolve(this.highestTargetId);
            }
        },
        {
            key: "setTargetsMetadata",
            value: function setTargetsMetadata(e, t, n) {
                return n && (this.lastRemoteSnapshotVersion = n), t > this.Nr && (this.Nr = t), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "Qn",
            value: function Qn(e) {
                this.Or.set(e.target, e);
                var t = e.targetId;
                t > this.highestTargetId && (this.Lr = new $59fc9b849b320ded$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.Nr && (this.Nr = e.sequenceNumber);
            }
        },
        {
            key: "addTargetData",
            value: function addTargetData(e, t) {
                return this.Qn(t), this.targetCount += 1, $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "updateTargetData",
            value: function updateTargetData(e, t) {
                return this.Qn(t), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeTargetData",
            value: function removeTargetData(e, t) {
                return this.Or.delete(t.target), this.Br.mr(t.targetId), this.targetCount -= 1, $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                var _this = this;
                var r = 0;
                var i = [];
                return this.Or.forEach(function(s, o) {
                    o.sequenceNumber <= t && null === n.get(o.targetId) && (_this.Or.delete(s), i.push(_this.removeMatchingKeysForTargetId(e, o.targetId)), r++);
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(i).next(function() {
                    return r;
                });
            }
        },
        {
            key: "getTargetCount",
            value: function getTargetCount(e) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.targetCount);
            }
        },
        {
            key: "getTargetData",
            value: function getTargetData(e, t) {
                var n = this.Or.get(t) || null;
                return $59fc9b849b320ded$var$PersistencePromise.resolve(n);
            }
        },
        {
            key: "addMatchingKeys",
            value: function addMatchingKeys(e, t, n) {
                return this.Br.Ar(t, n), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeMatchingKeys",
            value: function removeMatchingKeys(e, t, n) {
                this.Br.Vr(t, n);
                var r = this.persistence.referenceDelegate, i = [];
                return r && t.forEach(function(t) {
                    i.push(r.markPotentiallyOrphaned(e, t));
                }), $59fc9b849b320ded$var$PersistencePromise.waitFor(i);
            }
        },
        {
            key: "removeMatchingKeysForTargetId",
            value: function removeMatchingKeysForTargetId(e, t) {
                return this.Br.mr(t), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "getMatchingKeysForTargetId",
            value: function getMatchingKeysForTargetId(e, t) {
                var n = this.Br.pr(t);
                return $59fc9b849b320ded$var$PersistencePromise.resolve(n);
            }
        },
        {
            key: "containsKey",
            value: function containsKey(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve(this.Br.containsKey(t));
            }
        }
    ]);
    return __PRIVATE_MemoryTargetCache;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryPersistence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryPersistence(e, t) {
        var _this = this;
        (0, $978gY._)(this, __PRIVATE_MemoryPersistence);
        this.kr = {}, this.overlays = {}, this.qr = new $59fc9b849b320ded$var$__PRIVATE_ListenSequence(0), this.Qr = !1, this.Qr = !0, this.referenceDelegate = e(this), this.Kr = new $59fc9b849b320ded$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $59fc9b849b320ded$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $59fc9b849b320ded$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }(function(e) {
            return _this.referenceDelegate.$r(e);
        }), this.serializer = new $59fc9b849b320ded$var$__PRIVATE_LocalSerializer(t), this.Ur = new $59fc9b849b320ded$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    (0, $kry2a._)(__PRIVATE_MemoryPersistence, [
        {
            key: "start",
            value: function start() {
                return Promise.resolve();
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                // No durable state to ensure is closed on shutdown.
                return this.Qr = !1, Promise.resolve();
            }
        },
        {
            key: "started",
            get: function get() {
                return this.Qr;
            }
        },
        {
            key: "setDatabaseDeletedListener",
            value: function setDatabaseDeletedListener() {
            // No op.
            }
        },
        {
            key: "setNetworkEnabled",
            value: function setNetworkEnabled() {
            // No op.
            }
        },
        {
            key: "getIndexManager",
            value: function getIndexManager(e) {
                // We do not currently support indices for memory persistence, so we can
                // return the same shared instance of the memory index manager.
                return this.indexManager;
            }
        },
        {
            key: "getDocumentOverlayCache",
            value: function getDocumentOverlayCache(e) {
                var t = this.overlays[e.toKey()];
                return t || (t = new $59fc9b849b320ded$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
            }
        },
        {
            key: "getMutationQueue",
            value: function getMutationQueue(e, t) {
                var n = this.kr[e.toKey()];
                return n || (n = new $59fc9b849b320ded$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.kr[e.toKey()] = n), n;
            }
        },
        {
            key: "getTargetCache",
            value: function getTargetCache() {
                return this.Kr;
            }
        },
        {
            key: "getRemoteDocumentCache",
            value: function getRemoteDocumentCache() {
                return this.remoteDocumentCache;
            }
        },
        {
            key: "getBundleCache",
            value: function getBundleCache() {
                return this.Ur;
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n) {
                var _this = this;
                $59fc9b849b320ded$var$__PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
                var r = new $59fc9b849b320ded$var$__PRIVATE_MemoryTransaction(this.qr.next());
                return this.referenceDelegate.Wr(), n(r).next(function(e) {
                    return _this.referenceDelegate.Gr(r).next(function() {
                        return e;
                    });
                }).toPromise().then(function(e) {
                    return r.raiseOnCommittedEvent(), e;
                });
            }
        },
        {
            key: "zr",
            value: function zr(e, t) {
                return $59fc9b849b320ded$var$PersistencePromise.or(Object.values(this.kr).map(function(n) {
                    return function() {
                        return n.containsKey(e, t);
                    };
                }));
            }
        }
    ]);
    return __PRIVATE_MemoryPersistence;
}();
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ var $59fc9b849b320ded$var$__PRIVATE_MemoryTransaction = /*#__PURE__*/ function(PersistenceTransaction) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_MemoryTransaction, PersistenceTransaction);
    var _super = (0, $6OZAO._)(__PRIVATE_MemoryTransaction);
    function __PRIVATE_MemoryTransaction(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryTransaction);
        var _this;
        _this = _super.call(this), _this.currentSequenceNumber = e;
        return (0, $ho5gk._)(_this);
    }
    return __PRIVATE_MemoryTransaction;
}($59fc9b849b320ded$var$PersistenceTransaction);
var $59fc9b849b320ded$var$__PRIVATE_MemoryEagerDelegate = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryEagerDelegate(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryEagerDelegate);
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.jr = new $59fc9b849b320ded$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.Hr = null;
    }
    (0, $kry2a._)(__PRIVATE_MemoryEagerDelegate, [
        {
            key: "Yr",
            get: function get() {
                if (this.Hr) return this.Hr;
                throw $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return this.jr.addReference(n, t), this.Yr.delete(n.toString()), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return this.jr.removeReference(n, t), this.Yr.add(n.toString()), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return this.Yr.add(t.toString()), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var _this = this;
                this.jr.mr(t.targetId).forEach(function(e) {
                    return _this.Yr.add(e.toString());
                });
                var n = this.persistence.getTargetCache();
                return n.getMatchingKeysForTargetId(e, t.targetId).next(function(e) {
                    e.forEach(function(e) {
                        return _this.Yr.add(e.toString());
                    });
                }).next(function() {
                    return n.removeTargetData(e, t);
                });
            }
        },
        {
            key: "Wr",
            value: function Wr() {
                this.Hr = new Set;
            }
        },
        {
            key: "Gr",
            value: function Gr(e) {
                var _this = this;
                // Remove newly orphaned documents.
                var t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
                return $59fc9b849b320ded$var$PersistencePromise.forEach(this.Yr, function(n) {
                    var r = $59fc9b849b320ded$export$afc2e57c475b7810.fromPath(n);
                    return _this.Zr(e, r).next(function(e) {
                        e || t.removeEntry(r, $59fc9b849b320ded$var$SnapshotVersion.min());
                    });
                }).next(function() {
                    return _this.Hr = null, t.apply(e);
                });
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                var _this = this;
                return this.Zr(e, t).next(function(e) {
                    e ? _this.Yr.delete(t.toString()) : _this.Yr.add(t.toString());
                });
            }
        },
        {
            key: "$r",
            value: function $r(e) {
                // For eager GC, we don't care about the document size, there are no size thresholds.
                return 0;
            }
        },
        {
            key: "Zr",
            value: function Zr(e, t) {
                var _this = this;
                return $59fc9b849b320ded$var$PersistencePromise.or([
                    function() {
                        return $59fc9b849b320ded$var$PersistencePromise.resolve(_this.jr.containsKey(t));
                    },
                    function() {
                        return _this.persistence.getTargetCache().containsKey(e, t);
                    },
                    function() {
                        return _this.persistence.zr(e, t);
                    }
                ]);
            }
        }
    ], [
        {
            key: "Jr",
            value: function Jr(e) {
                return new __PRIVATE_MemoryEagerDelegate(e);
            }
        }
    ]);
    return __PRIVATE_MemoryEagerDelegate;
}();
var $59fc9b849b320ded$var$__PRIVATE_MemoryLruDelegate = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLruDelegate(e, t) {
        (0, $978gY._)(this, __PRIVATE_MemoryLruDelegate);
        this.persistence = e, this.Xr = new $59fc9b849b320ded$var$ObjectMap(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(e.path);
        }, function(e, t) {
            return e.isEqual(t);
        }), this.garbageCollector = $59fc9b849b320ded$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    (0, $kry2a._)(__PRIVATE_MemoryLruDelegate, [
        {
            // No-ops, present so memory persistence doesn't have to care which delegate
            // it has.
            key: "Wr",
            value: function Wr() {}
        },
        {
            key: "Gr",
            value: function Gr(e) {
                return $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "forEachTarget",
            value: function forEachTarget(e, t) {
                return this.persistence.getTargetCache().forEachTarget(e, t);
            }
        },
        {
            key: "Jn",
            value: function Jn(e) {
                var t = this.Xn(e);
                return this.persistence.getTargetCache().getTargetCount(e).next(function(e) {
                    return t.next(function(t) {
                        return e + t;
                    });
                });
            }
        },
        {
            key: "Xn",
            value: function Xn(e) {
                var t = 0;
                return this.Yn(e, function(e) {
                    t++;
                }).next(function() {
                    return t;
                });
            }
        },
        {
            key: "Yn",
            value: function Yn(e, t) {
                var _this = this;
                return $59fc9b849b320ded$var$PersistencePromise.forEach(this.Xr, function(n, r) {
                    return _this.tr(e, n, r).next(function(e) {
                        return e ? $59fc9b849b320ded$var$PersistencePromise.resolve() : t(r);
                    });
                });
            }
        },
        {
            key: "removeTargets",
            value: function removeTargets(e, t, n) {
                return this.persistence.getTargetCache().removeTargets(e, t, n);
            }
        },
        {
            key: "removeOrphanedDocuments",
            value: function removeOrphanedDocuments(e, t) {
                var _this = this;
                var n = 0;
                var r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
                return r.Mr(e, function(r) {
                    return _this.tr(e, r, t).next(function(e) {
                        e || (n++, i.removeEntry(r, $59fc9b849b320ded$var$SnapshotVersion.min()));
                    });
                }).next(function() {
                    return i.apply(e);
                }).next(function() {
                    return n;
                });
            }
        },
        {
            key: "markPotentiallyOrphaned",
            value: function markPotentiallyOrphaned(e, t) {
                return this.Xr.set(t, e.currentSequenceNumber), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeTarget",
            value: function removeTarget(e, t) {
                var n = t.withSequenceNumber(e.currentSequenceNumber);
                return this.persistence.getTargetCache().updateTargetData(e, n);
            }
        },
        {
            key: "addReference",
            value: function addReference(e, t, n) {
                return this.Xr.set(n, e.currentSequenceNumber), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "removeReference",
            value: function removeReference(e, t, n) {
                return this.Xr.set(n, e.currentSequenceNumber), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "updateLimboDocument",
            value: function updateLimboDocument(e, t) {
                return this.Xr.set(t, e.currentSequenceNumber), $59fc9b849b320ded$var$PersistencePromise.resolve();
            }
        },
        {
            key: "$r",
            value: function $r(e) {
                var t = e.key.toString().length;
                return e.isFoundDocument() && (t += $59fc9b849b320ded$var$__PRIVATE_estimateByteSize(e.data.value)), t;
            }
        },
        {
            key: "tr",
            value: function tr(e, t, n) {
                var _this = this;
                return $59fc9b849b320ded$var$PersistencePromise.or([
                    function() {
                        return _this.persistence.zr(e, t);
                    },
                    function() {
                        return _this.persistence.getTargetCache().containsKey(e, t);
                    },
                    function() {
                        var e = _this.Xr.get(t);
                        return $59fc9b849b320ded$var$PersistencePromise.resolve(void 0 !== e && e > n);
                    }
                ]);
            }
        },
        {
            key: "getCacheSize",
            value: function getCacheSize(e) {
                return this.persistence.getRemoteDocumentCache().getSize(e);
            }
        }
    ], [
        {
            key: "Jr",
            value: function Jr(e, t) {
                return new __PRIVATE_MemoryLruDelegate(e, t);
            }
        }
    ]);
    return __PRIVATE_MemoryLruDelegate;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ var $59fc9b849b320ded$var$__PRIVATE_SchemaConverter = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SchemaConverter(e) {
        (0, $978gY._)(this, __PRIVATE_SchemaConverter);
        this.serializer = e;
    }
    (0, $kry2a._)(__PRIVATE_SchemaConverter, [
        {
            /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ key: "B",
            value: function B1(e, t, n, r) {
                var _this = this;
                var i = new $59fc9b849b320ded$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
                n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
                    e.createObjectStore("owner");
                }(e), function __PRIVATE_createMutationQueue(e) {
                    e.createObjectStore("mutationQueues", {
                        keyPath: "userId"
                    });
                    e.createObjectStore("mutations", {
                        keyPath: "batchId",
                        autoIncrement: !0
                    }).createIndex("userMutationsIndex", $59fc9b849b320ded$var$M, {
                        unique: !0
                    }), e.createObjectStore("documentMutations");
                }(e), $59fc9b849b320ded$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
                    e.createObjectStore("remoteDocuments");
                }(e));
                // Migration 2 to populate the targetGlobal object no longer needed since
                // migration 3 unconditionally clears it.
                var s = $59fc9b849b320ded$var$PersistencePromise.resolve();
                return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
                // potentially have corrupt data.
                (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
                    e.deleteObjectStore("targetDocuments"), e.deleteObjectStore("targets"), e.deleteObjectStore("targetGlobal");
                }(e), $59fc9b849b320ded$var$__PRIVATE_createQueryCache(e)), s = s.next(function() {
                    return(/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                        var _$t = e.store("targetGlobal"), _$n = {
                            highestTargetId: 0,
                            highestListenSequenceNumber: 0,
                            lastRemoteSnapshotVersion: $59fc9b849b320ded$var$SnapshotVersion.min().toTimestamp(),
                            targetCount: 0
                        };
                        return _$t.put("targetGlobalKey", _$n);
                    }(i));
                })), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
                // mutation batch IDs (this was previously ensured internally by the
                // client). To migrate to the new schema, we have to read all mutations
                // and write them back out. We preserve the existing batch IDs to guarantee
                // consistency with other object stores. Any further mutation batch IDs will
                // be auto-generated.
                (s = s.next(function() {
                    return function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                        return t.store("mutations").G().next(function(n) {
                            e.deleteObjectStore("mutations");
                            e.createObjectStore("mutations", {
                                keyPath: "batchId",
                                autoIncrement: !0
                            }).createIndex("userMutationsIndex", $59fc9b849b320ded$var$M, {
                                unique: !0
                            });
                            var _$r = t.store("mutations"), i = n.map(function(e) {
                                return _$r.put(e);
                            });
                            return $59fc9b849b320ded$var$PersistencePromise.waitFor(i);
                        });
                    }(e, i);
                })), s = s.next(function() {
                    !function __PRIVATE_createClientMetadataStore(e) {
                        e.createObjectStore("clientMetadata", {
                            keyPath: "clientId"
                        });
                    }(e);
                })), n < 5 && r >= 5 && (s = s.next(function() {
                    return _this.ei(i);
                })), n < 6 && r >= 6 && (s = s.next(function() {
                    return function __PRIVATE_createDocumentGlobalStore(e) {
                        e.createObjectStore("remoteDocumentGlobal");
                    }(e), _this.ti(i);
                })), n < 7 && r >= 7 && (s = s.next(function() {
                    return _this.ni(i);
                })), n < 8 && r >= 8 && (s = s.next(function() {
                    return _this.ri(e, i);
                })), n < 9 && r >= 9 && (s = s.next(function() {
                    // Multi-Tab used to manage its own changelog, but this has been moved
                    // to the DbRemoteDocument object store itself. Since the previous change
                    // log only contained transient data, we can drop its object store.
                    !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                        e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
                    }(e);
                // Note: Schema version 9 used to create a read time index for the
                // RemoteDocumentCache. This is now done with schema version 13.
                })), n < 10 && r >= 10 && (s = s.next(function() {
                    return _this.ii(i);
                })), n < 11 && r >= 11 && (s = s.next(function() {
                    !function __PRIVATE_createBundlesStore(e) {
                        e.createObjectStore("bundles", {
                            keyPath: "bundleId"
                        });
                    }(e), function __PRIVATE_createNamedQueriesStore(e) {
                        e.createObjectStore("namedQueries", {
                            keyPath: "name"
                        });
                    }(e);
                })), n < 12 && r >= 12 && (s = s.next(function() {
                    !function __PRIVATE_createDocumentOverlayStore(e) {
                        var _$t = e.createObjectStore("documentOverlays", {
                            keyPath: $59fc9b849b320ded$var$G
                        });
                        _$t.createIndex("collectionPathOverlayIndex", $59fc9b849b320ded$var$z, {
                            unique: !1
                        }), _$t.createIndex("collectionGroupOverlayIndex", $59fc9b849b320ded$var$j, {
                            unique: !1
                        });
                    }(e);
                })), n < 13 && r >= 13 && (s = s.next(function() {
                    return function __PRIVATE_createRemoteDocumentCache(e) {
                        var _$t = e.createObjectStore("remoteDocumentsV14", {
                            keyPath: $59fc9b849b320ded$var$O
                        });
                        _$t.createIndex("documentKeyIndex", $59fc9b849b320ded$var$N), _$t.createIndex("collectionGroupIndex", $59fc9b849b320ded$var$B);
                    }(e);
                }).next(function() {
                    return _this.si(e, i);
                }).next(function() {
                    return e.deleteObjectStore("remoteDocuments");
                })), n < 14 && r >= 14 && (s = s.next(function() {
                    return _this.oi(e, i);
                })), n < 15 && r >= 15 && (s = s.next(function() {
                    return function __PRIVATE_createFieldIndex(e) {
                        e.createObjectStore("indexConfiguration", {
                            keyPath: "indexId",
                            autoIncrement: !0
                        }).createIndex("collectionGroupIndex", "collectionGroup", {
                            unique: !1
                        });
                        e.createObjectStore("indexState", {
                            keyPath: $59fc9b849b320ded$var$K
                        }).createIndex("sequenceNumberIndex", $59fc9b849b320ded$var$$, {
                            unique: !1
                        });
                        e.createObjectStore("indexEntries", {
                            keyPath: $59fc9b849b320ded$var$U
                        }).createIndex("documentKeyIndex", $59fc9b849b320ded$var$W, {
                            unique: !1
                        });
                    }(e);
                })), s;
            }
        },
        {
            key: "ti",
            value: function ti(e) {
                var t = 0;
                return e.store("remoteDocuments").Z(function(e, n) {
                    t += $59fc9b849b320ded$var$__PRIVATE_dbDocumentSize(n);
                }).next(function() {
                    var n = {
                        byteSize: t
                    };
                    return e.store("remoteDocumentGlobal").put("remoteDocumentGlobalKey", n);
                });
            }
        },
        {
            key: "ei",
            value: function ei(e) {
                var _this = this;
                var t = e.store("mutationQueues"), n = e.store("mutations");
                return t.G().next(function(t) {
                    return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t) {
                        var r = IDBKeyRange.bound([
                            t.userId,
                            -1
                        ], [
                            t.userId,
                            t.lastAcknowledgedBatchId
                        ]);
                        return n.G("userMutationsIndex", r).next(function(n) {
                            return $59fc9b849b320ded$var$PersistencePromise.forEach(n, function(n) {
                                $59fc9b849b320ded$var$__PRIVATE_hardAssert(n.userId === t.userId);
                                var r = $59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(_this.serializer, n);
                                return $59fc9b849b320ded$var$removeMutationBatch(e, t.userId, r).next(function() {});
                            });
                        });
                    });
                });
            }
        },
        {
            /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ key: "ni",
            value: function ni(e) {
                var t = e.store("targetDocuments"), n = e.store("remoteDocuments");
                return e.store("targetGlobal").get("targetGlobalKey").next(function(e) {
                    var r = [];
                    return n.Z(function(n, i) {
                        var s = new $59fc9b849b320ded$var$ResourcePath(n), o = function __PRIVATE_sentinelKey(e) {
                            return [
                                0,
                                $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(e)
                            ];
                        }(s);
                        r.push(t.get(o).next(function(n) {
                            return n ? $59fc9b849b320ded$var$PersistencePromise.resolve() : function(n) {
                                return t.put({
                                    targetId: 0,
                                    path: $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(n),
                                    sequenceNumber: e.highestListenSequenceNumber
                                });
                            }(s);
                        }));
                    }).next(function() {
                        return $59fc9b849b320ded$var$PersistencePromise.waitFor(r);
                    });
                });
            }
        },
        {
            key: "ri",
            value: function ri(e, t) {
                // Create the index.
                e.createObjectStore("collectionParents", {
                    keyPath: $59fc9b849b320ded$var$Q
                });
                var n = t.store("collectionParents"), r = new $59fc9b849b320ded$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = function(e) {
                    if (r.add(e)) {
                        var _$t = e.lastSegment(), r1 = e.popLast();
                        return n.put({
                            collectionId: _$t,
                            parent: $59fc9b849b320ded$var$__PRIVATE_encodeResourcePath(r1)
                        });
                    }
                };
                // Helper to add an index entry iff we haven't already written it.
                // Index existing remote documents.
                return t.store("remoteDocuments").Z({
                    Y: !0
                }, function(e, t) {
                    var n = new $59fc9b849b320ded$var$ResourcePath(e);
                    return addEntry(n.popLast());
                }).next(function() {
                    return t.store("documentMutations").Z({
                        Y: !0
                    }, function(param, r) {
                        var _param = (0, $8GFUW._)(param, 3), _$e = _param[0], _$t = _param[1], n = _param[2];
                        var i = $59fc9b849b320ded$var$__PRIVATE_decodeResourcePath(_$t);
                        return addEntry(i.popLast());
                    });
                });
            }
        },
        {
            key: "ii",
            value: function ii(e) {
                var _this = this;
                var t = e.store("targets");
                return t.Z(function(e, n) {
                    var r = $59fc9b849b320ded$var$__PRIVATE_fromDbTarget(n), i = $59fc9b849b320ded$var$__PRIVATE_toDbTarget(_this.serializer, r);
                    return t.put(i);
                });
            }
        },
        {
            key: "si",
            value: function si(e, t) {
                var n = t.store("remoteDocuments"), r = [];
                return n.Z(function(e, n) {
                    var i = t.store("remoteDocumentsV14"), s = (function __PRIVATE_extractKey(e) {
                        return e.document ? new $59fc9b849b320ded$export$afc2e57c475b7810($59fc9b849b320ded$var$ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? $59fc9b849b320ded$export$afc2e57c475b7810.fromSegments(e.noDocument.path) : e.unknownDocument ? $59fc9b849b320ded$export$afc2e57c475b7810.fromSegments(e.unknownDocument.path) : $59fc9b849b320ded$var$fail();
                    })(n).path.toArray(), o = {
                        prefixPath: s.slice(0, s.length - 2),
                        collectionGroup: s[s.length - 2],
                        documentId: s[s.length - 1],
                        readTime: n.readTime || [
                            0,
                            0
                        ],
                        unknownDocument: n.unknownDocument,
                        noDocument: n.noDocument,
                        document: n.document,
                        hasCommittedMutations: !!n.hasCommittedMutations
                    };
                    r.push(i.put(o));
                }).next(function() {
                    return $59fc9b849b320ded$var$PersistencePromise.waitFor(r);
                });
            }
        },
        {
            key: "oi",
            value: function oi(e, t) {
                var _this = this;
                var n = t.store("mutations"), r = $59fc9b849b320ded$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $59fc9b849b320ded$var$__PRIVATE_MemoryPersistence($59fc9b849b320ded$var$__PRIVATE_MemoryEagerDelegate.Jr, this.serializer.ht);
                return n.G().next(function(e) {
                    var n = new Map;
                    return e.forEach(function(e) {
                        var _$t;
                        var r = null !== (_$t = n.get(e.userId)) && void 0 !== _$t ? _$t : $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                        $59fc9b849b320ded$var$__PRIVATE_fromDbMutationBatch(_this.serializer, e).keys().forEach(function(e) {
                            return r = r.add(e);
                        }), n.set(e.userId, r);
                    }), $59fc9b849b320ded$var$PersistencePromise.forEach(n, function(e, n) {
                        var s = new $59fc9b849b320ded$var$User(n), o = $59fc9b849b320ded$var$__PRIVATE_IndexedDbDocumentOverlayCache.Pt(_this.serializer, s), _ = i.getIndexManager(s), a = $59fc9b849b320ded$var$__PRIVATE_IndexedDbMutationQueue.Pt(s, _this.serializer, _, i.referenceDelegate);
                        return new $59fc9b849b320ded$var$LocalDocumentsView(r, a, o, _).recalculateAndSaveOverlaysForDocumentKeys(new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransaction(t, $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae), e).next();
                    });
                });
            }
        }
    ]);
    return __PRIVATE_SchemaConverter;
}();
function $59fc9b849b320ded$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore("targetDocuments", {
        keyPath: $59fc9b849b320ded$var$k
    }).createIndex("documentTargetsIndex", $59fc9b849b320ded$var$q, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore("targets", {
        keyPath: "targetId"
    }).createIndex("queryTargetsIndex", $59fc9b849b320ded$var$L, {
        unique: !0
    }), e.createObjectStore("targetGlobal");
}
var $59fc9b849b320ded$var$Ee = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the “primary client”. An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s “owner” store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbPersistence = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_IndexedDbPersistence(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, o, _, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u) {
        var c = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : 15;
        (0, $978gY._)(this, __PRIVATE_IndexedDbPersistence);
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this._i = i, this.window = s, this.document = o, this.ai = a, this.ui = u, this.ci = c, this.qr = null, this.Qr = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.li = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.hi = null, /** The client metadata refresh task. */ this.Pi = null, /** The last time we garbage collected the client metadata object store. */ this.Ii = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.di = function(e) {
            return Promise.resolve();
        }, !__PRIVATE_IndexedDbPersistence.C()) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $59fc9b849b320ded$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Ti = t + "main", this.serializer = new $59fc9b849b320ded$var$__PRIVATE_LocalSerializer(_), this.Ei = new $59fc9b849b320ded$var$__PRIVATE_SimpleDb(this.Ti, this.ci, new $59fc9b849b320ded$var$__PRIVATE_SchemaConverter(this.serializer)), this.Kr = new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $59fc9b849b320ded$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.Ur = new $59fc9b849b320ded$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.Ai = this.window.localStorage : (this.Ai = null, !1 === u && $59fc9b849b320ded$var$__PRIVATE_logError("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbPersistence, [
        {
            /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ key: "start",
            value: function start() {
                var _this = this;
                // NOTE: This is expected to fail sometimes (in the case of another tab
                // already having the persistence lock), so it's the first thing we should
                // do.
                return this.Ri().then(function() {
                    if (!_this.isPrimary && !_this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
                    // obtain the primary lease.
                    throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, $59fc9b849b320ded$var$Ee);
                    return _this.Vi(), _this.mi(), _this.fi(), _this.runTransaction("getHighestListenSequenceNumber", "readonly", function(e) {
                        return _this.Kr.getHighestSequenceNumber(e);
                    });
                }).then(function(e) {
                    _this.qr = new $59fc9b849b320ded$var$__PRIVATE_ListenSequence(e, _this.ai);
                }).then(function() {
                    _this.Qr = !0;
                }).catch(function(e) {
                    return _this.Ei && _this.Ei.close(), Promise.reject(e);
                });
            }
        },
        {
            /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "gi",
            value: function gi(e) {
                var _this = this;
                return this.di = function() {
                    var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(t) {
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            if (_this.started) return [
                                2,
                                e(t)
                            ];
                            return [
                                2
                            ];
                        });
                    });
                    return function(t) {
                        return _ref.apply(this, arguments);
                    };
                }(), e(this.isPrimary);
            }
        },
        {
            /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "setDatabaseDeletedListener",
            value: function setDatabaseDeletedListener(e) {
                this.Ei.k(function() {
                    var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(t) {
                        var _tmp;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _tmp = // Check if an attempt is made to delete IndexedDB.
                                    null === t.newVersion;
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        e()
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(t) {
                        return _ref.apply(this, arguments);
                    };
                }());
            }
        },
        {
            /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "setNetworkEnabled",
            value: function setNetworkEnabled(e) {
                var _this = this;
                this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
                // lease update will be propagated via `primaryStateListener`.
                this._i.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.started;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.Ri()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })));
            }
        },
        {
            /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ key: "Ri",
            value: function Ri() {
                var _this = this;
                return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_clientMetadataStore(e).put({
                        clientId: _this.clientId,
                        updateTimeMs: Date.now(),
                        networkEnabled: _this.networkEnabled,
                        inForeground: _this.inForeground
                    }).next(function() {
                        if (_this.isPrimary) return _this.pi(e).next(function(e) {
                            e || (_this.isPrimary = !1, _this._i.enqueueRetryable(function() {
                                return _this.di(!1);
                            }));
                        });
                    }).next(function() {
                        return _this.yi(e);
                    }).next(function(t) {
                        return _this.isPrimary && !t ? _this.wi(e).next(function() {
                            return !1;
                        }) : !!t && _this.Si(e).next(function() {
                            return !0;
                        });
                    });
                }).catch(function(e) {
                    if ($59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
                    // IndexedDB will verify the lease.
                    return $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbPersistence", "Failed to extend owner lease: ", e), _this.isPrimary;
                    if (!_this.allowTabSynchronization) throw e;
                    return $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
                }).then(function(e) {
                    _this.isPrimary !== e && _this._i.enqueueRetryable(function() {
                        return _this.di(e);
                    }), _this.isPrimary = e;
                });
            }
        },
        {
            key: "pi",
            value: function pi(e) {
                var _this = this;
                return $59fc9b849b320ded$var$__PRIVATE_primaryClientStore(e).get("owner").next(function(e) {
                    return $59fc9b849b320ded$var$PersistencePromise.resolve(_this.bi(e));
                });
            }
        },
        {
            key: "Di",
            value: function Di(e) {
                return $59fc9b849b320ded$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
            }
        },
        {
            key: "Ci",
            value: /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ function Ci() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.isPrimary && !_this.vi(_this.Ii, 18e5))) return [
                                    3,
                                    2
                                ];
                                _this.Ii = Date.now();
                                return [
                                    4,
                                    _this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", function(e) {
                                        var t = $59fc9b849b320ded$var$__PRIVATE_getStore(e, "clientMetadata");
                                        return t.G().next(function(e) {
                                            var n = _this.Fi(e, 18e5), r = e.filter(function(e) {
                                                return -1 === n.indexOf(e);
                                            });
                                            // Delete metadata for clients that are no longer considered active.
                                            return $59fc9b849b320ded$var$PersistencePromise.forEach(r, function(e) {
                                                return t.delete(e.clientId);
                                            }).next(function() {
                                                return r;
                                            });
                                        });
                                    }).catch(function() {
                                        return [];
                                    })
                                ];
                            case 1:
                                e = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                // Delete potential leftover entries that may continue to mark the
                                // inactive clients as zombied in LocalStorage.
                                // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
                                // the client atomically, but we can't. So we opt to delete the IndexedDb
                                // entries first to avoid potentially reviving a zombied client.
                                if (_this.Ai) try {
                                    for(_iterator = e[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        t = _step.value;
                                        _this.Ai.removeItem(_this.Mi(t.clientId));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ key: "fi",
            value: function fi() {
                var _this = this;
                this.Pi = this._i.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, function() {
                    return _this.Ri().then(function() {
                        return _this.Ci();
                    }).then(function() {
                        return _this.fi();
                    });
                });
            }
        },
        {
            /** Checks whether `client` is the local client. */ key: "bi",
            value: function bi(e) {
                return !!e && e.ownerId === this.clientId;
            }
        },
        {
            /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ key: "yi",
            value: function yi(e) {
                var _this = this;
                if (this.ui) return $59fc9b849b320ded$var$PersistencePromise.resolve(!0);
                return $59fc9b849b320ded$var$__PRIVATE_primaryClientStore(e).get("owner").next(function(t) {
                    // A client is eligible for the primary lease if:
                    // - its network is enabled and the client's tab is in the foreground.
                    // - its network is enabled and no other client's tab is in the
                    //   foreground.
                    // - every clients network is disabled and the client's tab is in the
                    //   foreground.
                    // - every clients network is disabled and no other client's tab is in
                    //   the foreground.
                    // - the `forceOwningTab` setting was passed in.
                    if (null !== t && _this.vi(t.leaseTimestampMs, 5e3) && !_this.xi(t.ownerId)) {
                        if (_this.bi(t) && _this.networkEnabled) return !0;
                        if (!_this.bi(t)) {
                            if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                            // not opted into multi-tab synchronization. If this happens at
                            // client startup, we reject the Promise returned by
                            // `enablePersistence()` and the user can continue to use Firestore
                            // with in-memory persistence.
                            // If this fails during a lease refresh, we will instead block the
                            // AsyncQueue from executing further operations. Note that this is
                            // acceptable since mixing & matching different `synchronizeTabs`
                            // settings is not supported.
                            // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                            // no longer be turned off.
                            throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, $59fc9b849b320ded$var$Ee);
                            return !1;
                        }
                    }
                    return !(!_this.networkEnabled || !_this.inForeground) || $59fc9b849b320ded$var$__PRIVATE_clientMetadataStore(e).G().next(function(e) {
                        return void 0 === _this.Fi(e, 5e3).find(function(e) {
                            if (_this.clientId !== e.clientId) {
                                var _$t = !_this.networkEnabled && e.networkEnabled, n = !_this.inForeground && e.inForeground, r = _this.networkEnabled === e.networkEnabled;
                                if (_$t || n && r) return !0;
                            }
                            return !1;
                        });
                    });
                }).next(function(e) {
                    return _this.isPrimary !== e && $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbPersistence", "Client ".concat(e ? "is" : "is not", " eligible for a primary lease.")), e;
                });
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // The shutdown() operations are idempotent and can be called even when
                                // start() aborted (e.g. because it couldn't acquire the persistence lease).
                                _this.Qr = !1, _this.Oi(), _this.Pi && (_this.Pi.cancel(), _this.Pi = null), _this.Ni(), _this.Bi();
                                // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
                                // has obtained the primary lease.
                                return [
                                    4,
                                    _this.Ei.runTransaction("shutdown", "readwrite", [
                                        "owner",
                                        "clientMetadata"
                                    ], function(e) {
                                        var t = new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransaction(e, $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae);
                                        return _this.wi(t).next(function() {
                                            return _this.Di(t);
                                        });
                                    })
                                ];
                            case 1:
                                _state.sent(), _this.Ei.close(), // Remove the entry marking the client as zombied from LocalStorage since
                                // we successfully deleted its metadata from IndexedDb.
                                _this.Li();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ key: "Fi",
            value: function Fi(e, t) {
                var _this = this;
                return e.filter(function(e) {
                    return _this.vi(e.updateTimeMs, t) && !_this.xi(e.clientId);
                });
            }
        },
        {
            /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ key: "ki",
            value: function ki() {
                var _this = this;
                return this.runTransaction("getActiveClients", "readonly", function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_clientMetadataStore(e).G().next(function(e) {
                        return _this.Fi(e, 18e5).map(function(e) {
                            return e.clientId;
                        });
                    });
                });
            }
        },
        {
            key: "started",
            get: function get() {
                return this.Qr;
            }
        },
        {
            key: "getMutationQueue",
            value: function getMutationQueue(e, t) {
                return $59fc9b849b320ded$var$__PRIVATE_IndexedDbMutationQueue.Pt(e, this.serializer, t, this.referenceDelegate);
            }
        },
        {
            key: "getTargetCache",
            value: function getTargetCache() {
                return this.Kr;
            }
        },
        {
            key: "getRemoteDocumentCache",
            value: function getRemoteDocumentCache() {
                return this.remoteDocumentCache;
            }
        },
        {
            key: "getIndexManager",
            value: function getIndexManager(e) {
                return new $59fc9b849b320ded$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.ht.databaseId);
            }
        },
        {
            key: "getDocumentOverlayCache",
            value: function getDocumentOverlayCache(e) {
                return $59fc9b849b320ded$var$__PRIVATE_IndexedDbDocumentOverlayCache.Pt(this.serializer, e);
            }
        },
        {
            key: "getBundleCache",
            value: function getBundleCache() {
                return this.Ur;
            }
        },
        {
            key: "runTransaction",
            value: function runTransaction(e, t, n) {
                var _this = this;
                $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbPersistence", "Starting transaction:", e);
                var r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
                    return 15 === e ? $59fc9b849b320ded$var$X : 14 === e ? $59fc9b849b320ded$var$Z : 13 === e ? $59fc9b849b320ded$var$Y : 12 === e ? $59fc9b849b320ded$var$J : 11 === e ? $59fc9b849b320ded$var$H : void $59fc9b849b320ded$var$fail();
                }(this.ci);
                var s;
                // Do all transactions as readwrite against all object stores, since we
                // are the only reader/writer.
                return this.Ei.runTransaction(e, r, i, function(r) {
                    return s = new $59fc9b849b320ded$var$__PRIVATE_IndexedDbTransaction(r, _this.qr ? _this.qr.next() : $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae), "readwrite-primary" === t ? _this.pi(s).next(function(e) {
                        return !!e || _this.yi(s);
                    }).next(function(t) {
                        if (!t) throw $59fc9b849b320ded$var$__PRIVATE_logError("Failed to obtain primary lease for action '".concat(e, "'.")), _this.isPrimary = !1, _this._i.enqueueRetryable(function() {
                            return _this.di(!1);
                        }), new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, $59fc9b849b320ded$var$v);
                        return n(s);
                    }).next(function(e) {
                        return _this.Si(s).next(function() {
                            return e;
                        });
                    }) : _this.qi(s).next(function() {
                        return n(s);
                    });
                }).then(function(e) {
                    return s.raiseOnCommittedEvent(), e;
                });
            }
        },
        {
            /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
            // be turned off.
            key: "qi",
            value: function qi(e) {
                var _this = this;
                return $59fc9b849b320ded$var$__PRIVATE_primaryClientStore(e).get("owner").next(function(e) {
                    if (null !== e && _this.vi(e.leaseTimestampMs, 5e3) && !_this.xi(e.ownerId) && !_this.bi(e) && !(_this.ui || _this.allowTabSynchronization && e.allowTabSynchronization)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, $59fc9b849b320ded$var$Ee);
                });
            }
        },
        {
            /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ key: "Si",
            value: function Si(e) {
                var t = {
                    ownerId: this.clientId,
                    allowTabSynchronization: this.allowTabSynchronization,
                    leaseTimestampMs: Date.now()
                };
                return $59fc9b849b320ded$var$__PRIVATE_primaryClientStore(e).put("owner", t);
            }
        },
        {
            /** Checks the primary lease and removes it if we are the current primary. */ key: "wi",
            value: function wi(e) {
                var _this = this;
                var t = $59fc9b849b320ded$var$__PRIVATE_primaryClientStore(e);
                return t.get("owner").next(function(e) {
                    return _this.bi(e) ? ($59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbPersistence", "Releasing primary lease."), t.delete("owner")) : $59fc9b849b320ded$var$PersistencePromise.resolve();
                });
            }
        },
        {
            /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ key: "vi",
            value: function vi(e, t) {
                var n = Date.now();
                return !(e < n - t) && (!(e > n) || ($59fc9b849b320ded$var$__PRIVATE_logError("Detected an update time that is in the future: ".concat(e, " > ").concat(n)), !1));
            }
        },
        {
            key: "Vi",
            value: function Vi() {
                var _this = this;
                null !== this.document && "function" == typeof this.document.addEventListener && (this.hi = function() {
                    _this._i.enqueueAndForget(function() {
                        return _this.inForeground = "visible" === _this.document.visibilityState, _this.Ri();
                    });
                }, this.document.addEventListener("visibilitychange", this.hi), this.inForeground = "visible" === this.document.visibilityState);
            }
        },
        {
            key: "Ni",
            value: function Ni() {
                this.hi && (this.document.removeEventListener("visibilitychange", this.hi), this.hi = null);
            }
        },
        {
            /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ key: "mi",
            value: function mi() {
                var _this = this;
                var e;
                "function" == typeof (null === (e = this.window) || void 0 === e ? void 0 : e.addEventListener) && (this.li = function() {
                    // Note: In theory, this should be scheduled on the AsyncQueue since it
                    // accesses internal state. We execute this code directly during shutdown
                    // to make sure it gets a chance to run.
                    _this.Oi();
                    var e = /(?:Version|Mobile)\/1[456]/;
                    (0, $b1467a785fc7cec5$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
                    // trigger a bug that prevents Safari from re-opening IndexedDB during
                    // the next page load.
                    // See https://bugs.webkit.org/show_bug.cgi?id=226547
                    _this._i.enterRestrictedMode(/* purgeExistingTasks= */ !0), _this._i.enqueueAndForget(function() {
                        return _this.shutdown();
                    });
                }, this.window.addEventListener("pagehide", this.li));
            }
        },
        {
            key: "Bi",
            value: function Bi() {
                this.li && (this.window.removeEventListener("pagehide", this.li), this.li = null);
            }
        },
        {
            /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ key: "xi",
            value: function xi(e) {
                var t;
                try {
                    var n = null !== (null === (t = this.Ai) || void 0 === t ? void 0 : t.getItem(this.Mi(e)));
                    return $59fc9b849b320ded$var$__PRIVATE_logDebug("IndexedDbPersistence", "Client '".concat(e, "' ").concat(n ? "is" : "is not", " zombied in LocalStorage")), n;
                } catch (e) {
                    // Gracefully handle if LocalStorage isn't working.
                    return $59fc9b849b320ded$var$__PRIVATE_logError("IndexedDbPersistence", "Failed to get zombied client id.", e), !1;
                }
            }
        },
        {
            /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ key: "Oi",
            value: function Oi() {
                if (this.Ai) try {
                    this.Ai.setItem(this.Mi(this.clientId), String(Date.now()));
                } catch (e) {
                    // Gracefully handle if LocalStorage isn't available / working.
                    $59fc9b849b320ded$var$__PRIVATE_logError("Failed to set zombie client id.", e);
                }
            }
        },
        {
            /** Removes the zombied client entry if it exists. */ key: "Li",
            value: function Li() {
                if (this.Ai) try {
                    this.Ai.removeItem(this.Mi(this.clientId));
                } catch (e) {
                // Ignore
                }
            }
        },
        {
            key: "Mi",
            value: function Mi(e) {
                return "firestore_zombie_".concat(this.persistenceKey, "_").concat(e);
            }
        }
    ], [
        {
            key: "C",
            value: function C() {
                return $59fc9b849b320ded$var$__PRIVATE_SimpleDb.C();
            }
        }
    ]);
    return __PRIVATE_IndexedDbPersistence;
}();
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_primaryClientStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "owner");
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $59fc9b849b320ded$var$__PRIVATE_clientMetadataStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_getStore(e, "clientMetadata");
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $59fc9b849b320ded$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    var n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ var $59fc9b849b320ded$var$__PRIVATE_LocalViewChanges = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalViewChanges(e, t, n, r) {
        (0, $978gY._)(this, __PRIVATE_LocalViewChanges);
        this.targetId = e, this.fromCache = t, this.Qi = n, this.Ki = r;
    }
    (0, $kry2a._)(__PRIVATE_LocalViewChanges, null, [
        {
            key: "$i",
            value: function $i(e, t) {
                var n = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), r = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t.docChanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        switch(_$e.type){
                            case 0 /* ChangeType.Added */ :
                                n = n.add(_$e.doc.key);
                                break;
                            case 1 /* ChangeType.Removed */ :
                                r = r.add(_$e.doc.key);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new __PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
            }
        }
    ]);
    return __PRIVATE_LocalViewChanges;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ var $59fc9b849b320ded$var$QueryContext = /*#__PURE__*/ function() {
    "use strict";
    function QueryContext() {
        (0, $978gY._)(this, QueryContext);
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    (0, $kry2a._)(QueryContext, [
        {
            key: "documentReadCount",
            get: function get() {
                return this._documentReadCount;
            }
        },
        {
            key: "incrementDocumentReadCount",
            value: function incrementDocumentReadCount(e) {
                this._documentReadCount += e;
            }
        }
    ]);
    return QueryContext;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ var $59fc9b849b320ded$var$__PRIVATE_QueryEngine = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryEngine() {
        (0, $978gY._)(this, __PRIVATE_QueryEngine);
        this.Ui = !1, this.Wi = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.Gi = 100, this.zi = 2;
    }
    (0, $kry2a._)(__PRIVATE_QueryEngine, [
        {
            /** Sets the document view to query against. */ key: "initialize",
            value: function initialize(e, t) {
                this.ji = e, this.indexManager = t, this.Ui = !0;
            }
        },
        {
            /** Returns all local documents matching the specified query. */ key: "getDocumentsMatchingQuery",
            value: function getDocumentsMatchingQuery(e, t, n, r) {
                var _this = this;
                // Stores the result from executing the query; using this object is more
                // convenient than passing the result between steps of the persistence
                // transaction and improves readability comparatively.
                var i = {
                    result: null
                };
                return this.Hi(e, t).next(function(e) {
                    i.result = e;
                }).next(function() {
                    if (!i.result) return _this.Ji(e, t, r, n).next(function(e) {
                        i.result = e;
                    });
                }).next(function() {
                    if (i.result) return;
                    var n = new $59fc9b849b320ded$var$QueryContext;
                    return _this.Yi(e, t, n).next(function(r) {
                        if (i.result = r, _this.Wi) return _this.Zi(e, t, n, r.size);
                    });
                }).next(function() {
                    return i.result;
                });
            }
        },
        {
            key: "Zi",
            value: function Zi(e, t, n, r) {
                return n.documentReadCount < this.Gi ? ($59fc9b849b320ded$var$__PRIVATE_getLogLevel() <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).DEBUG && $59fc9b849b320ded$var$__PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", $59fc9b849b320ded$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.Gi, "documents"), $59fc9b849b320ded$var$PersistencePromise.resolve()) : ($59fc9b849b320ded$var$__PRIVATE_getLogLevel() <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).DEBUG && $59fc9b849b320ded$var$__PRIVATE_logDebug("QueryEngine", "Query:", $59fc9b849b320ded$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.zi * r ? ($59fc9b849b320ded$var$__PRIVATE_getLogLevel() <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).DEBUG && $59fc9b849b320ded$var$__PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", $59fc9b849b320ded$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $59fc9b849b320ded$var$__PRIVATE_queryToTarget(t))) : $59fc9b849b320ded$var$PersistencePromise.resolve());
            }
        },
        {
            /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ key: "Hi",
            value: function Hi(e, t) {
                var _this = this;
                if ($59fc9b849b320ded$var$__PRIVATE_queryMatchesAllDocuments(t)) // Queries that match all documents don't benefit from using
                // key-based lookups. It is more efficient to scan all documents in a
                // collection, rather than to perform individual lookups.
                return $59fc9b849b320ded$var$PersistencePromise.resolve(null);
                var n = $59fc9b849b320ded$var$__PRIVATE_queryToTarget(t);
                return this.indexManager.getIndexType(e, n).next(function(r) {
                    return 0 /* IndexType.NONE */  === r ? null : (null !== t.limit && 1 /* IndexType.PARTIAL */  === r && // We cannot apply a limit for targets that are served using a partial
                    // index. If a partial index will be used to serve the target, the
                    // query may return a superset of documents that match the target
                    // (e.g. if the index doesn't include all the target's filters), or
                    // may return the correct set of documents in the wrong order (e.g. if
                    // the index doesn't include a segment for one of the orderBys).
                    // Therefore, a limit should not be applied in such cases.
                    (t = $59fc9b849b320ded$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ ), n = $59fc9b849b320ded$var$__PRIVATE_queryToTarget(t)), _this.indexManager.getDocumentsMatchingTarget(e, n).next(function(r) {
                        var i = $59fc9b849b320ded$var$__PRIVATE_documentKeySet.apply(void 0, (0, $fLnyw._)(r));
                        return _this.ji.getDocuments(e, i).next(function(r) {
                            return _this.indexManager.getMinOffset(e, n).next(function(n) {
                                var s = _this.Xi(t, r);
                                return _this.es(t, s, i, n.readTime) ? _this.Hi(e, $59fc9b849b320ded$var$__PRIVATE_queryWithLimit(t, null, "F" /* LimitType.First */ )) : _this.ts(e, s, t, n);
                            });
                        });
                    }));
                });
            }
        },
        {
            /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ key: "Ji",
            value: function Ji(e, t, n, r) {
                var _this = this;
                return $59fc9b849b320ded$var$__PRIVATE_queryMatchesAllDocuments(t) || r.isEqual($59fc9b849b320ded$var$SnapshotVersion.min()) ? $59fc9b849b320ded$var$PersistencePromise.resolve(null) : this.ji.getDocuments(e, n).next(function(i) {
                    var s = _this.Xi(t, i);
                    return _this.es(t, s, n, r) ? $59fc9b849b320ded$var$PersistencePromise.resolve(null) : ($59fc9b849b320ded$var$__PRIVATE_getLogLevel() <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).DEBUG && $59fc9b849b320ded$var$__PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $59fc9b849b320ded$var$__PRIVATE_stringifyQuery(t)), _this.ts(e, s, t, $59fc9b849b320ded$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1)).next(function(e) {
                        return e;
                    }));
                });
            // Queries that have never seen a snapshot without limbo free documents
            // should also be run as a full collection scan.
            }
        },
        {
            /** Applies the query filter and sorting to the provided documents.  */ key: "Xi",
            value: function Xi(e, t) {
                // Sort the documents and re-apply the query filter since previously
                // matching documents do not necessarily still match the query.
                var n = new $59fc9b849b320ded$var$SortedSet($59fc9b849b320ded$var$__PRIVATE_newQueryComparator(e));
                return t.forEach(function(t, r) {
                    $59fc9b849b320ded$var$__PRIVATE_queryMatches(e, r) && (n = n.add(r));
                }), n;
            }
        },
        {
            /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ key: "es",
            value: function es(e, t, n, r) {
                if (null === e.limit) // Queries without limits do not need to be refilled.
                return !1;
                if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
                // longer matches.
                return !0;
                // Limit queries are not eligible for index-free query execution if there is
                // a potential that an older document from cache now sorts before a document
                // that was previously part of the limit. This, however, can only happen if
                // the document at the edge of the limit goes out of limit.
                // If a document that is not the limit boundary sorts differently,
                // the boundary of the limit itself did not change and documents from cache
                // will continue to be "rejected" by this boundary. Therefore, we can ignore
                // any modifications that don't affect the last document.
                var i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
                return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
            }
        },
        {
            key: "Yi",
            value: function Yi(e, t, n) {
                return $59fc9b849b320ded$var$__PRIVATE_getLogLevel() <= (0, $a1a98c9cad39c4c7$export$243e62d78d3b544d).DEBUG && $59fc9b849b320ded$var$__PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", $59fc9b849b320ded$var$__PRIVATE_stringifyQuery(t)), this.ji.getDocumentsMatchingQuery(e, t, $59fc9b849b320ded$var$IndexOffset.min(), n);
            }
        },
        {
            /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ key: "ts",
            value: function ts(e, t, n, r) {
                // Retrieve all results for documents that were updated since the offset.
                return this.ji.getDocumentsMatchingQuery(e, n, r).next(function(e) {
                    return(// Merge with existing results
                    t.forEach(function(t) {
                        e = e.insert(t.key, t);
                    }), e);
                });
            }
        }
    ]);
    return __PRIVATE_QueryEngine;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ var $59fc9b849b320ded$var$__PRIVATE_LocalStoreImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalStoreImpl(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
        (0, $978gY._)(this, __PRIVATE_LocalStoreImpl);
        this.persistence = e, this.ns = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.rs = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.ss = new $59fc9b849b320ded$var$ObjectMap(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_canonifyTarget(e);
        }, $59fc9b849b320ded$var$__PRIVATE_targetEquals), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.os = new Map, this._s = e.getRemoteDocumentCache(), this.Kr = e.getTargetCache(), this.Ur = e.getBundleCache(), this.us(n);
    }
    (0, $kry2a._)(__PRIVATE_LocalStoreImpl, [
        {
            key: "us",
            value: function us(e) {
                // TODO(indexing): Add spec tests that test these components change after a
                // user change
                this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $59fc9b849b320ded$var$LocalDocumentsView(this._s, this.mutationQueue, this.documentOverlayCache, this.indexManager), this._s.setIndexManager(this.indexManager), this.ns.initialize(this.localDocuments, this.indexManager);
            }
        },
        {
            key: "collectGarbage",
            value: function collectGarbage(e) {
                var _this = this;
                return this.persistence.runTransaction("Collect garbage", "readwrite-primary", function(t) {
                    return e.collect(t, _this.rs);
                });
            }
        }
    ]);
    return __PRIVATE_LocalStoreImpl;
}();
function $59fc9b849b320ded$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $59fc9b849b320ded$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
function $59fc9b849b320ded$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_localStoreHandleUserChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_localStoreHandleUserChange() {
    $59fc9b849b320ded$var$___PRIVATE_localStoreHandleUserChange = /**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
    // change.
    (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    return [
                        4,
                        n.persistence.runTransaction("Handle user change", "readonly", function(e) {
                            // Swap out the mutation queue, grabbing the pending mutation batches
                            // before and after.
                            var r;
                            return n.mutationQueue.getAllMutationBatches(e).next(function(i) {
                                return r = i, n.us(t), n.mutationQueue.getAllMutationBatches(e);
                            }).next(function(t) {
                                var i = [], s = [];
                                // Union the old/new changed keys.
                                var o = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$e = _step.value;
                                        i.push(_$e.batchId);
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(var _iterator1 = _$e.mutations[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var _$t = _step1.value;
                                                o = o.add(_$t.key);
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                try {
                                    for(var _iterator2 = t[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var _$e1 = _step2.value;
                                        s.push(_$e1.batchId);
                                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                        try {
                                            for(var _iterator3 = _$e1.mutations[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                                var _$t1 = _step3.value;
                                                o = o.add(_$t1.key);
                                            }
                                        } catch (err) {
                                            _didIteratorError3 = true;
                                            _iteratorError3 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                    _iterator3.return();
                                                }
                                            } finally{
                                                if (_didIteratorError3) {
                                                    throw _iteratorError3;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                                // Return the set of all (potentially) changed documents and the list
                                // of mutation batch IDs that were affected by change.
                                return n.localDocuments.getDocuments(e, o).next(function(e) {
                                    return {
                                        cs: e,
                                        removedBatchIds: i,
                                        addedBatchIds: s
                                    };
                                });
                            });
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_localStoreHandleUserChange.apply(this, arguments);
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $59fc9b849b320ded$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", function(e) {
        var r = t.batch.keys(), i = n._s.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            var i = n.batch, s = i.keys();
            var o = $59fc9b849b320ded$var$PersistencePromise.resolve();
            return s.forEach(function(e) {
                o = o.next(function() {
                    return r.getEntry(t, e);
                }).next(function(t) {
                    var s = n.docVersions.get(e);
                    $59fc9b849b320ded$var$__PRIVATE_hardAssert(null !== s), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), o.next(function() {
                return e.mutationQueue.removeMutationBatch(t, i);
            });
        })(n, e, t, i).next(function() {
            return i.apply(e);
        }).next(function() {
            return n.mutationQueue.performConsistencyCheck(e);
        }).next(function() {
            return n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId);
        }).next(function() {
            return n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                var _$t = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                for(var n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (_$t = _$t.add(e.batch.mutations[n].key));
                return _$t;
            }(t));
        }).next(function() {
            return n.localDocuments.getDocuments(e, r);
        });
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $59fc9b849b320ded$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", function(e) {
        return t.Kr.getLastRemoteSnapshotVersion(e);
    });
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $59fc9b849b320ded$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    var i = n.rs;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", function(e) {
        var s = n._s.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.rs;
        var o = [];
        t.targetChanges.forEach(function(s, _) {
            var a = i.get(_);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            o.push(n.Kr.removeMatchingKeys(e, s.removedDocuments, _).next(function() {
                return n.Kr.addMatchingKeys(e, s.addedDocuments, _);
            }));
            var u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(_) ? u = u.withResumeToken($59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING, $59fc9b849b320ded$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($59fc9b849b320ded$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(_, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                if (t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds() >= 3e8) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                return n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size > 0;
            }(a, u, s) && o.push(n.Kr.updateTargetData(e, u));
        });
        var _ = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap(), a = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach(function(r) {
            t.resolvedLimboDocuments.has(r) && o.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        o.push($59fc9b849b320ded$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next(function(e) {
            _ = e.ls, a = e.hs;
        })), !r.isEqual($59fc9b849b320ded$var$SnapshotVersion.min())) {
            var _$t = n.Kr.getLastRemoteSnapshotVersion(e).next(function(t) {
                return n.Kr.setTargetsMetadata(e, e.currentSequenceNumber, r);
            });
            o.push(_$t);
        }
        return $59fc9b849b320ded$var$PersistencePromise.waitFor(o).next(function() {
            return s.apply(e);
        }).next(function() {
            return n.localDocuments.getLocalViewOfDocuments(e, _, a);
        }).next(function() {
            return _;
        });
    }).then(function(e) {
        return n.rs = i, e;
    });
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $59fc9b849b320ded$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    var r = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), i = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
    return n.forEach(function(e) {
        return r = r.add(e);
    }), t.getEntries(e, r).next(function(e) {
        var r = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
        return n.forEach(function(n, s) {
            var o = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== o.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($59fc9b849b320ded$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !o.isValidDocument() || s.version.compareTo(o.version) > 0 || 0 === s.version.compareTo(o.version) && o.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $59fc9b849b320ded$var$__PRIVATE_logDebug("LocalStore", "Ignoring outdated watch update for ", n, ". Current version:", o.version, " Watch version:", s.version);
        }), {
            ls: r,
            hs: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $59fc9b849b320ded$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", function(e) {
        return void 0 === t && (t = -1), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t);
    });
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $59fc9b849b320ded$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", function(e) {
        var r;
        return n.Kr.getTargetData(e, t).next(function(i) {
            return i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $59fc9b849b320ded$var$PersistencePromise.resolve(r)) : n.Kr.allocateTargetId(e).next(function(i) {
                return r = new $59fc9b849b320ded$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.Kr.addTargetData(e, r).next(function() {
                    return r;
                });
            });
        });
    }).then(function(e) {
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        var r = n.rs.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.rs = n.rs.insert(e.targetId, e), n.ss.set(t, e.targetId)), e;
    });
}
function $59fc9b849b320ded$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_localStoreReleaseTarget.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_localStoreReleaseTarget() {
    $59fc9b849b320ded$var$___PRIVATE_localStoreReleaseTarget = /**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
    /**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
    (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, i, s, _tmp, e1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), i = r.rs.get(t), s = n ? "readwrite" : "readwrite-primary";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    _tmp = n;
                    if (_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        r.persistence.runTransaction("Release target", s, function(e) {
                            return r.persistence.referenceDelegate.removeTarget(e, i);
                        })
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    return [
                        3,
                        5
                    ];
                case 4:
                    e1 = _state.sent();
                    if (!$59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e1)) throw e1;
                    // All `releaseTarget` does is record the final metadata state for the
                    // target, but we've been recording this periodically during target
                    // activity. If we lose this write this could cause a very slight
                    // difference in the order of target deletion during GC, but we
                    // don't define exact LRU semantics so this is acceptable.
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers for target ".concat(t, ": ").concat(e1));
                    return [
                        3,
                        5
                    ];
                case 5:
                    r.rs = r.rs.remove(t), r.ss.delete(i.target);
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_localStoreReleaseTarget.apply(this, arguments);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $59fc9b849b320ded$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    var i = $59fc9b849b320ded$var$SnapshotVersion.min(), s = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    function(e) {
        return (function __PRIVATE_localStoreGetTargetData(e, t, n) {
            var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), i = r.ss.get(n);
            return void 0 !== i ? $59fc9b849b320ded$var$PersistencePromise.resolve(r.rs.get(i)) : r.Kr.getTargetData(t, n);
        })(r, e, $59fc9b849b320ded$var$__PRIVATE_queryToTarget(t)).next(function(t) {
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.Kr.getMatchingKeysForTargetId(e, t.targetId).next(function(e) {
                s = e;
            });
        }).next(function() {
            return r.ns.getDocumentsMatchingQuery(e, t, n ? i : $59fc9b849b320ded$var$SnapshotVersion.min(), n ? s : $59fc9b849b320ded$var$__PRIVATE_documentKeySet());
        }).next(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_setMaxReadTime(r, $59fc9b849b320ded$var$__PRIVATE_queryCollectionGroup(t), e), {
                documents: e,
                Ps: s
            };
        });
    });
}
// PORTING NOTE: Multi-Tab only.
function $59fc9b849b320ded$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = $59fc9b849b320ded$var$__PRIVATE_debugCast(n.Kr), i = n.rs.get(t);
    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", function(e) {
        return r.lt(e, t).next(function(e) {
            return e ? e.target : null;
        });
    });
}
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $59fc9b849b320ded$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = n.os.get(t) || $59fc9b849b320ded$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", function(e) {
        return n._s.getAllFromCollectionGroup(e, t, $59fc9b849b320ded$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, -1), /* limit= */ Number.MAX_SAFE_INTEGER);
    }).then(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_setMaxReadTime(n, t, e), e;
    });
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $59fc9b849b320ded$var$__PRIVATE_setMaxReadTime(e, t, n) {
    var r = e.os.get(t) || $59fc9b849b320ded$var$SnapshotVersion.min();
    n.forEach(function(e, t) {
        t.readTime.compareTo(r) > 0 && (r = t.readTime);
    }), e.os.set(t, r);
}
function $59fc9b849b320ded$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    return $59fc9b849b320ded$var$___PRIVATE_localStoreApplyBundledDocuments.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_localStoreApplyBundledDocuments() {
    $59fc9b849b320ded$var$___PRIVATE_localStoreApplyBundledDocuments = /**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n, r) {
        var i, s, o, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$n, _$r, _, a;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    s = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), o = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = n[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e = _step.value;
                            _$n = t.Is(_$e.metadata.name);
                            _$e.document && (s = s.add(_$n));
                            _$r = t.ds(_$e);
                            _$r.setReadTime(t.Ts(_$e.metadata.readTime)), o = o.insert(_$n, _$r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _ = i._s.newChangeBuffer({
                        trackRemovals: !0
                    });
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
                            // It is OK that the path used for the query is not valid, because this will
                            // not be read and queried.
                            return $59fc9b849b320ded$var$__PRIVATE_queryToTarget($59fc9b849b320ded$var$__PRIVATE_newQueryForPath($59fc9b849b320ded$var$ResourcePath.fromString("__bundle__/docs/".concat(e))));
                        }(r))
                    ];
                case 1:
                    a = _state.sent();
                    // Allocates a target to hold all document keys from the bundle, such that
                    // they will not get garbage collected right away.
                    return [
                        2,
                        i.persistence.runTransaction("Apply bundle documents", "readwrite", function(e) {
                            return $59fc9b849b320ded$var$__PRIVATE_populateDocumentChangeBuffer(e, _, o).next(function(t) {
                                return _.apply(e), t;
                            }).next(function(t) {
                                return i.Kr.removeMatchingKeysForTargetId(e, a.targetId).next(function() {
                                    return i.Kr.addMatchingKeys(e, s, a.targetId);
                                }).next(function() {
                                    return i.localDocuments.getLocalViewOfDocuments(e, t.ls, t.hs);
                                }).next(function() {
                                    return t.ls;
                                });
                            });
                        })
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_localStoreApplyBundledDocuments.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_localStoreSaveNamedQuery(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_localStoreSaveNamedQuery.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_localStoreSaveNamedQuery() {
    $59fc9b849b320ded$var$___PRIVATE_localStoreSaveNamedQuery = /**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r, i;
        var _arguments = arguments;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreAllocateTarget(e, $59fc9b849b320ded$var$__PRIVATE_queryToTarget($59fc9b849b320ded$var$__PRIVATE_fromBundledQuery(t.bundledQuery)))
                    ];
                case 1:
                    r = _state.sent(), i = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    return [
                        2,
                        i.persistence.runTransaction("Save named query", "readwrite", function(e) {
                            var s = $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.readTime);
                            // Simply save the query itself if it is older than what the SDK already
                            // has.
                            if (r.snapshotVersion.compareTo(s) >= 0) return i.Ur.saveNamedQuery(e, t);
                            // Update existing target data because the query from the bundle is newer.
                            var o = r.withResumeToken($59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING, s);
                            return i.rs = i.rs.insert(o.targetId, o), i.Kr.updateTargetData(e, o).next(function() {
                                return i.Kr.removeMatchingKeysForTargetId(e, r.targetId);
                            }).next(function() {
                                return i.Kr.addMatchingKeys(e, n, r.targetId);
                            }).next(function() {
                                return i.Ur.saveNamedQuery(e, t);
                            });
                        })
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_localStoreSaveNamedQuery.apply(this, arguments);
}
/** Assembles the key for a client state in WebStorage */ function $59fc9b849b320ded$var$createWebStorageClientStateKey(e, t) {
    return "firestore_clients_".concat(e, "_").concat(t);
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
/** Assembles the key for a mutation batch in WebStorage */ function $59fc9b849b320ded$var$createWebStorageMutationBatchKey(e, t, n) {
    var r = "firestore_mutations_".concat(e, "_").concat(n);
    return t.isAuthenticated() && (r += "_".concat(t.uid)), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
/** Assembles the key for a query state in WebStorage */ function $59fc9b849b320ded$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return "firestore_targets_".concat(e, "_").concat(t);
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
var $59fc9b849b320ded$var$__PRIVATE_MutationMetadata = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MutationMetadata(e, t, n, r) {
        (0, $978gY._)(this, __PRIVATE_MutationMetadata);
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    (0, $kry2a._)(__PRIVATE_MutationMetadata, [
        {
            key: "As",
            value: function As() {
                var e = {
                    state: this.state,
                    updateTimeMs: Date.now()
                };
                return this.error && (e.error = {
                    code: this.error.code,
                    message: this.error.message
                }), JSON.stringify(e);
            }
        }
    ], [
        {
            key: "Es",
            value: /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e, t, n) {
                var r = JSON.parse(n);
                var i, s = "object" == typeof r && -1 !== [
                    "pending",
                    "acknowledged",
                    "rejected"
                ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
                return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $59fc9b849b320ded$export$8fada0bf726bf278(r.error.code, r.error.message))), s ? new __PRIVATE_MutationMetadata(e, t, r.state, i) : ($59fc9b849b320ded$var$__PRIVATE_logError("SharedClientState", "Failed to parse mutation state for ID '".concat(t, "': ").concat(n)), null);
            }
        }
    ]);
    return __PRIVATE_MutationMetadata;
}();
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
var $59fc9b849b320ded$var$__PRIVATE_QueryTargetMetadata = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryTargetMetadata(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_QueryTargetMetadata);
        this.targetId = e, this.state = t, this.error = n;
    }
    (0, $kry2a._)(__PRIVATE_QueryTargetMetadata, [
        {
            key: "As",
            value: function As() {
                var e = {
                    state: this.state,
                    updateTimeMs: Date.now()
                };
                return this.error && (e.error = {
                    code: this.error.code,
                    message: this.error.message
                }), JSON.stringify(e);
            }
        }
    ], [
        {
            key: "Es",
            value: /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e, t) {
                var n = JSON.parse(t);
                var r, i = "object" == typeof n && -1 !== [
                    "not-current",
                    "current",
                    "rejected"
                ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
                return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $59fc9b849b320ded$export$8fada0bf726bf278(n.error.code, n.error.message))), i ? new __PRIVATE_QueryTargetMetadata(e, n.state, r) : ($59fc9b849b320ded$var$__PRIVATE_logError("SharedClientState", "Failed to parse target state for ID '".concat(e, "': ").concat(t)), null);
            }
        }
    ]);
    return __PRIVATE_QueryTargetMetadata;
}();
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ var $59fc9b849b320ded$var$__PRIVATE_RemoteClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RemoteClientState(e, t) {
        (0, $978gY._)(this, __PRIVATE_RemoteClientState);
        this.clientId = e, this.activeTargetIds = t;
    }
    (0, $kry2a._)(__PRIVATE_RemoteClientState, null, [
        {
            key: "Es",
            value: /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e, t) {
                var n = JSON.parse(t);
                var r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $59fc9b849b320ded$var$__PRIVATE_targetIdSet();
                for(var _$e = 0; r && _$e < n.activeTargetIds.length; ++_$e)r = $59fc9b849b320ded$var$isSafeInteger(n.activeTargetIds[_$e]), i = i.add(n.activeTargetIds[_$e]);
                return r ? new __PRIVATE_RemoteClientState(e, i) : ($59fc9b849b320ded$var$__PRIVATE_logError("SharedClientState", "Failed to parse client data for instance '".concat(e, "': ").concat(t)), null);
            }
        }
    ]);
    return __PRIVATE_RemoteClientState;
}();
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ var $59fc9b849b320ded$var$__PRIVATE_SharedOnlineState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SharedOnlineState(e, t) {
        (0, $978gY._)(this, __PRIVATE_SharedOnlineState);
        this.clientId = e, this.onlineState = t;
    }
    (0, $kry2a._)(__PRIVATE_SharedOnlineState, null, [
        {
            key: "Es",
            value: /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ function Es(e) {
                var t = JSON.parse(e);
                return "object" == typeof t && -1 !== [
                    "Unknown",
                    "Online",
                    "Offline"
                ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new __PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($59fc9b849b320ded$var$__PRIVATE_logError("SharedClientState", "Failed to parse online state: ".concat(e)), null);
            }
        }
    ]);
    return __PRIVATE_SharedOnlineState;
}();
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
var $59fc9b849b320ded$var$__PRIVATE_LocalClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_LocalClientState() {
        (0, $978gY._)(this, __PRIVATE_LocalClientState);
        this.activeTargetIds = $59fc9b849b320ded$var$__PRIVATE_targetIdSet();
    }
    (0, $kry2a._)(__PRIVATE_LocalClientState, [
        {
            key: "Rs",
            value: function Rs(e) {
                this.activeTargetIds = this.activeTargetIds.add(e);
            }
        },
        {
            key: "Vs",
            value: function Vs(e) {
                this.activeTargetIds = this.activeTargetIds.delete(e);
            }
        },
        {
            /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ key: "As",
            value: function As() {
                var e = {
                    activeTargetIds: this.activeTargetIds.toArray(),
                    updateTimeMs: Date.now()
                };
                return JSON.stringify(e);
            }
        }
    ]);
    return __PRIVATE_LocalClientState;
}();
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ var $59fc9b849b320ded$var$__PRIVATE_WebStorageSharedClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_WebStorageSharedClientState(e, t, n, r, i) {
        (0, $978gY._)(this, __PRIVATE_WebStorageSharedClientState);
        this.window = e, this._i = t, this.persistenceKey = n, this.fs = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.gs = this.ps.bind(this), this.ys = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.ws = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        var s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.Ss = $59fc9b849b320ded$var$createWebStorageClientStateKey(this.persistenceKey, this.fs), this.bs = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return "firestore_sequence_number_".concat(e);
        }(this.persistenceKey), this.ys = this.ys.insert(this.fs, new $59fc9b849b320ded$var$__PRIVATE_LocalClientState), this.Ds = new RegExp("^firestore_clients_".concat(s, "_([^_]*)$")), this.Cs = new RegExp("^firestore_mutations_".concat(s, "_(\\d+)(?:_(.*))?$")), this.vs = new RegExp("^firestore_targets_".concat(s, "_(\\d+)$")), this.Fs = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return "firestore_online_state_".concat(e);
        }(this.persistenceKey), this.Ms = function createBundleLoadedKey(e) {
            return "firestore_bundle_loaded_v2_".concat(e);
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.gs);
    }
    (0, $kry2a._)(__PRIVATE_WebStorageSharedClientState, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, e1, n, t1, e2, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, e3;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.syncEngine.ki()
                                ];
                            case 1:
                                e = _state.sent();
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = e[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        t = _step.value;
                                        if (t === _this.fs) continue;
                                        e1 = _this.getItem($59fc9b849b320ded$var$createWebStorageClientStateKey(_this.persistenceKey, t));
                                        if (e1) {
                                            n = $59fc9b849b320ded$var$__PRIVATE_RemoteClientState.Es(t, e1);
                                            n && (_this.ys = _this.ys.insert(n.clientId, n));
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _this.xs();
                                t1 = _this.storage.getItem(_this.Fs);
                                if (t1) {
                                    e2 = _this.Os(t1);
                                    e2 && _this.Ns(e2);
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = _this.ws[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        e3 = _step1.value;
                                        _this.ps(e3);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                _this.ws = [], // Register a window unload hook to remove the client metadata entry from
                                // WebStorage even if `shutdown()` was not called.
                                _this.window.addEventListener("pagehide", function() {
                                    return _this.shutdown();
                                }), _this.started = !0;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "writeSequenceNumber",
            value: function writeSequenceNumber(e) {
                this.setItem(this.bs, JSON.stringify(e));
            }
        },
        {
            key: "getAllActiveQueryTargets",
            value: function getAllActiveQueryTargets() {
                return this.Bs(this.ys);
            }
        },
        {
            key: "isActiveQueryTarget",
            value: function isActiveQueryTarget(e) {
                var t = !1;
                return this.ys.forEach(function(n, r) {
                    r.activeTargetIds.has(e) && (t = !0);
                }), t;
            }
        },
        {
            key: "addPendingMutation",
            value: function addPendingMutation(e) {
                this.Ls(e, "pending");
            }
        },
        {
            key: "updateMutationState",
            value: function updateMutationState(e, t, n) {
                this.Ls(e, t, n), // Once a final mutation result is observed by other clients, they no longer
                // access the mutation's metadata entry. Since WebStorage replays events
                // in order, it is safe to delete the entry right after updating it.
                this.ks(e);
            }
        },
        {
            key: "addLocalQueryTarget",
            value: function addLocalQueryTarget(e) {
                var t = "not-current";
                // Lookup an existing query state if the target ID was already registered
                // by another tab
                if (this.isActiveQueryTarget(e)) {
                    var n = this.storage.getItem($59fc9b849b320ded$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
                    if (n) {
                        var r = $59fc9b849b320ded$var$__PRIVATE_QueryTargetMetadata.Es(e, n);
                        r && (t = r.state);
                    }
                }
                return this.qs.Rs(e), this.xs(), t;
            }
        },
        {
            key: "removeLocalQueryTarget",
            value: function removeLocalQueryTarget(e) {
                this.qs.Vs(e), this.xs();
            }
        },
        {
            key: "isLocalQueryTarget",
            value: function isLocalQueryTarget(e) {
                return this.qs.activeTargetIds.has(e);
            }
        },
        {
            key: "clearQueryState",
            value: function clearQueryState(e) {
                this.removeItem($59fc9b849b320ded$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            }
        },
        {
            key: "updateQueryState",
            value: function updateQueryState(e, t, n) {
                this.Qs(e, t, n);
            }
        },
        {
            key: "handleUserChange",
            value: function handleUserChange(e, t, n) {
                var _this = this;
                t.forEach(function(e) {
                    _this.ks(e);
                }), this.currentUser = e, n.forEach(function(e) {
                    _this.addPendingMutation(e);
                });
            }
        },
        {
            key: "setOnlineState",
            value: function setOnlineState(e) {
                this.Ks(e);
            }
        },
        {
            key: "notifyBundleLoaded",
            value: function notifyBundleLoaded(e) {
                this.$s(e);
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                this.started && (this.window.removeEventListener("storage", this.gs), this.removeItem(this.Ss), this.started = !1);
            }
        },
        {
            key: "getItem",
            value: function getItem(e) {
                var t = this.storage.getItem(e);
                return $59fc9b849b320ded$var$__PRIVATE_logDebug("SharedClientState", "READ", e, t), t;
            }
        },
        {
            key: "setItem",
            value: function setItem(e, t) {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("SharedClientState", "SET", e, t), this.storage.setItem(e, t);
            }
        },
        {
            key: "removeItem",
            value: function removeItem(e) {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("SharedClientState", "REMOVE", e), this.storage.removeItem(e);
            }
        },
        {
            key: "ps",
            value: function ps(e) {
                // Note: The function is typed to take Event to be interface-compatible with
                // `Window.addEventListener`.
                var t = e;
                if (t.storageArea === this.storage) {
                    if ($59fc9b849b320ded$var$__PRIVATE_logDebug("SharedClientState", "EVENT", t.key, t.newValue), t.key === this.Ss) return void $59fc9b849b320ded$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
                    var _this = this;
                    this._i.enqueueRetryable(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                        var _$e, _$e1, _$e2, _$e3, _$e4, _$e5, _$e6;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!_this.started) return [
                                        3,
                                        8
                                    ];
                                    if (!(null !== t.key)) return [
                                        3,
                                        7
                                    ];
                                    if (!_this.Ds.test(t.key)) return [
                                        3,
                                        1
                                    ];
                                    if (null == t.newValue) {
                                        _$e = _this.Us(t.key);
                                        return [
                                            2,
                                            _this.Ws(_$e, null)
                                        ];
                                    }
                                    {
                                        _$e1 = _this.Gs(t.key, t.newValue);
                                        if (_$e1) return [
                                            2,
                                            _this.Ws(_$e1.clientId, _$e1)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 1:
                                    if (!_this.Cs.test(t.key)) return [
                                        3,
                                        2
                                    ];
                                    if (null !== t.newValue) {
                                        _$e2 = _this.zs(t.key, t.newValue);
                                        if (_$e2) return [
                                            2,
                                            _this.js(_$e2)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 2:
                                    if (!_this.vs.test(t.key)) return [
                                        3,
                                        3
                                    ];
                                    if (null !== t.newValue) {
                                        _$e3 = _this.Hs(t.key, t.newValue);
                                        if (_$e3) return [
                                            2,
                                            _this.Js(_$e3)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 3:
                                    if (!(t.key === _this.Fs)) return [
                                        3,
                                        4
                                    ];
                                    if (null !== t.newValue) {
                                        _$e4 = _this.Os(t.newValue);
                                        if (_$e4) return [
                                            2,
                                            _this.Ns(_$e4)
                                        ];
                                    }
                                    return [
                                        3,
                                        7
                                    ];
                                case 4:
                                    if (!(t.key === _this.bs)) return [
                                        3,
                                        5
                                    ];
                                    _$e5 = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                        var t = $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae;
                                        if (null != e) try {
                                            var n = JSON.parse(e);
                                            $59fc9b849b320ded$var$__PRIVATE_hardAssert("number" == typeof n), t = n;
                                        } catch (e) {
                                            $59fc9b849b320ded$var$__PRIVATE_logError("SharedClientState", "Failed to read sequence number from WebStorage", e);
                                        }
                                        return t;
                                    }(t.newValue);
                                    _$e5 !== $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae && _this.sequenceNumberHandler(_$e5);
                                    return [
                                        3,
                                        7
                                    ];
                                case 5:
                                    if (!(t.key === _this.Ms)) return [
                                        3,
                                        7
                                    ];
                                    _$e6 = _this.Ys(t.newValue);
                                    return [
                                        4,
                                        Promise.all(_$e6.map(function(e) {
                                            return _this.syncEngine.Zs(e);
                                        }))
                                    ];
                                case 6:
                                    _state.sent();
                                    _state.label = 7;
                                case 7:
                                    return [
                                        3,
                                        9
                                    ];
                                case 8:
                                    _this.ws.push(t);
                                    _state.label = 9;
                                case 9:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                }
            }
        },
        {
            key: "qs",
            get: function get() {
                return this.ys.get(this.fs);
            }
        },
        {
            key: "xs",
            value: function xs() {
                this.setItem(this.Ss, this.qs.As());
            }
        },
        {
            key: "Ls",
            value: function Ls(e, t, n) {
                var r = new $59fc9b849b320ded$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $59fc9b849b320ded$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
                this.setItem(i, r.As());
            }
        },
        {
            key: "ks",
            value: function ks(e) {
                var t = $59fc9b849b320ded$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
                this.removeItem(t);
            }
        },
        {
            key: "Ks",
            value: function Ks(e) {
                var t = {
                    clientId: this.fs,
                    onlineState: e
                };
                this.storage.setItem(this.Fs, JSON.stringify(t));
            }
        },
        {
            key: "Qs",
            value: function Qs(e, t, n) {
                var r = $59fc9b849b320ded$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $59fc9b849b320ded$var$__PRIVATE_QueryTargetMetadata(e, t, n);
                this.setItem(r, i.As());
            }
        },
        {
            key: "$s",
            value: function $s(e) {
                var t = JSON.stringify(Array.from(e));
                this.setItem(this.Ms, t);
            }
        },
        {
            /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ key: "Us",
            value: function Us(e) {
                var t = this.Ds.exec(e);
                return t ? t[1] : null;
            }
        },
        {
            /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ key: "Gs",
            value: function Gs(e, t) {
                var n = this.Us(e);
                return $59fc9b849b320ded$var$__PRIVATE_RemoteClientState.Es(n, t);
            }
        },
        {
            /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "zs",
            value: function zs(e, t) {
                var n = this.Cs.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
                return $59fc9b849b320ded$var$__PRIVATE_MutationMetadata.Es(new $59fc9b849b320ded$var$User(i), r, t);
            }
        },
        {
            /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "Hs",
            value: function Hs(e, t) {
                var n = this.vs.exec(e), r = Number(n[1]);
                return $59fc9b849b320ded$var$__PRIVATE_QueryTargetMetadata.Es(r, t);
            }
        },
        {
            /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ key: "Os",
            value: function Os(e) {
                return $59fc9b849b320ded$var$__PRIVATE_SharedOnlineState.Es(e);
            }
        },
        {
            key: "Ys",
            value: function Ys(e) {
                return JSON.parse(e);
            }
        },
        {
            key: "js",
            value: function js(e) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (e.user.uid === _this.currentUser.uid) return [
                            2,
                            _this.syncEngine.Xs(e.batchId, e.state, e.error)
                        ];
                        $59fc9b849b320ded$var$__PRIVATE_logDebug("SharedClientState", "Ignoring mutation for non-active user ".concat(e.user.uid));
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "Js",
            value: function Js(e) {
                return this.syncEngine.eo(e.targetId, e.state, e.error);
            }
        },
        {
            key: "Ws",
            value: function Ws(e, t) {
                var _this = this;
                var n = t ? this.ys.insert(e, t) : this.ys.remove(e), r = this.Bs(this.ys), i = this.Bs(n), s = [], o = [];
                return i.forEach(function(e) {
                    r.has(e) || s.push(e);
                }), r.forEach(function(e) {
                    i.has(e) || o.push(e);
                }), this.syncEngine.no(s, o).then(function() {
                    _this.ys = n;
                });
            }
        },
        {
            key: "Ns",
            value: function Ns(e) {
                // We check whether the client that wrote this online state is still active
                // by comparing its client ID to the list of clients kept active in
                // IndexedDb. If a client does not update their IndexedDb client state
                // within 5 seconds, it is considered inactive and we don't emit an online
                // state event.
                this.ys.get(e.clientId) && this.onlineStateHandler(e.onlineState);
            }
        },
        {
            key: "Bs",
            value: function Bs(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_targetIdSet();
                return e.forEach(function(e, n) {
                    t = t.unionWith(n.activeTargetIds);
                }), t;
            }
        }
    ], [
        {
            key: "C",
            value: /** Returns 'true' if WebStorage is available in the current environment. */ function C(e) {
                return !(!e || !e.localStorage);
            }
        }
    ]);
    return __PRIVATE_WebStorageSharedClientState;
}();
var $59fc9b849b320ded$var$__PRIVATE_MemorySharedClientState = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemorySharedClientState() {
        (0, $978gY._)(this, __PRIVATE_MemorySharedClientState);
        this.ro = new $59fc9b849b320ded$var$__PRIVATE_LocalClientState, this.io = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    (0, $kry2a._)(__PRIVATE_MemorySharedClientState, [
        {
            key: "addPendingMutation",
            value: function addPendingMutation(e) {
            // No op.
            }
        },
        {
            key: "updateMutationState",
            value: function updateMutationState(e, t, n) {
            // No op.
            }
        },
        {
            key: "addLocalQueryTarget",
            value: function addLocalQueryTarget(e) {
                return this.ro.Rs(e), this.io[e] || "not-current";
            }
        },
        {
            key: "updateQueryState",
            value: function updateQueryState(e, t, n) {
                this.io[e] = t;
            }
        },
        {
            key: "removeLocalQueryTarget",
            value: function removeLocalQueryTarget(e) {
                this.ro.Vs(e);
            }
        },
        {
            key: "isLocalQueryTarget",
            value: function isLocalQueryTarget(e) {
                return this.ro.activeTargetIds.has(e);
            }
        },
        {
            key: "clearQueryState",
            value: function clearQueryState(e) {
                delete this.io[e];
            }
        },
        {
            key: "getAllActiveQueryTargets",
            value: function getAllActiveQueryTargets() {
                return this.ro.activeTargetIds;
            }
        },
        {
            key: "isActiveQueryTarget",
            value: function isActiveQueryTarget(e) {
                return this.ro.activeTargetIds.has(e);
            }
        },
        {
            key: "start",
            value: function start() {
                return this.ro = new $59fc9b849b320ded$var$__PRIVATE_LocalClientState, Promise.resolve();
            }
        },
        {
            key: "handleUserChange",
            value: function handleUserChange(e, t, n) {
            // No op.
            }
        },
        {
            key: "setOnlineState",
            value: function setOnlineState(e) {
            // No op.
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {}
        },
        {
            key: "writeSequenceNumber",
            value: function writeSequenceNumber(e) {}
        },
        {
            key: "notifyBundleLoaded",
            value: function notifyBundleLoaded(e) {
            // No op.
            }
        }
    ]);
    return __PRIVATE_MemorySharedClientState;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_NoopConnectivityMonitor = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_NoopConnectivityMonitor() {
        (0, $978gY._)(this, __PRIVATE_NoopConnectivityMonitor);
    }
    (0, $kry2a._)(__PRIVATE_NoopConnectivityMonitor, [
        {
            key: "so",
            value: function so(e) {
            // No-op.
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
            // No-op.
            }
        }
    ]);
    return __PRIVATE_NoopConnectivityMonitor;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ /**
 * Browser implementation of ConnectivityMonitor.
 */ var $59fc9b849b320ded$var$__PRIVATE_BrowserConnectivityMonitor = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BrowserConnectivityMonitor() {
        var _this = this;
        (0, $978gY._)(this, __PRIVATE_BrowserConnectivityMonitor);
        this.oo = function() {
            return _this._o();
        }, this.ao = function() {
            return _this.uo();
        }, this.co = [], this.lo();
    }
    (0, $kry2a._)(__PRIVATE_BrowserConnectivityMonitor, [
        {
            key: "so",
            value: function so(e) {
                this.co.push(e);
            }
        },
        {
            key: "shutdown",
            value: function shutdown() {
                window.removeEventListener("online", this.oo), window.removeEventListener("offline", this.ao);
            }
        },
        {
            key: "lo",
            value: function lo() {
                window.addEventListener("online", this.oo), window.addEventListener("offline", this.ao);
            }
        },
        {
            key: "_o",
            value: function _o() {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.co[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        e(0 /* NetworkStatus.AVAILABLE */ );
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "uo",
            value: function uo() {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.co[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        e(1 /* NetworkStatus.UNAVAILABLE */ );
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "C",
            value: // TODO(chenbrian): Consider passing in window either into this component or
            // here for testing via FakeWindow.
            /** Checks that all used attributes of window are available. */ function C() {
                return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
            }
        }
    ]);
    return __PRIVATE_BrowserConnectivityMonitor;
}();
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ var $59fc9b849b320ded$var$Ae = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @return the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $59fc9b849b320ded$var$__PRIVATE_generateUniqueDebugId() {
    return null === $59fc9b849b320ded$var$Ae ? $59fc9b849b320ded$var$Ae = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $59fc9b849b320ded$var$Ae++, "0x" + $59fc9b849b320ded$var$Ae.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$Re = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ var $59fc9b849b320ded$var$__PRIVATE_StreamBridge = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_StreamBridge(e) {
        (0, $978gY._)(this, __PRIVATE_StreamBridge);
        this.ho = e.ho, this.Po = e.Po;
    }
    (0, $kry2a._)(__PRIVATE_StreamBridge, [
        {
            key: "Io",
            value: function Io(e) {
                this.To = e;
            }
        },
        {
            key: "Eo",
            value: function Eo(e) {
                this.Ao = e;
            }
        },
        {
            key: "onMessage",
            value: function onMessage(e) {
                this.Ro = e;
            }
        },
        {
            key: "close",
            value: function close() {
                this.Po();
            }
        },
        {
            key: "send",
            value: function send(e) {
                this.ho(e);
            }
        },
        {
            key: "Vo",
            value: function Vo() {
                this.To();
            }
        },
        {
            key: "mo",
            value: function mo(e) {
                this.Ao(e);
            }
        },
        {
            key: "fo",
            value: function fo(e) {
                this.Ro(e);
            }
        }
    ]);
    return __PRIVATE_StreamBridge;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$Ve = "WebChannelConnection";
var $59fc9b849b320ded$var$__PRIVATE_WebChannelConnection = /*#__PURE__*/ function(__PRIVATE_RestConnection) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_WebChannelConnection, __PRIVATE_RestConnection);
    var _super = (0, $6OZAO._)(__PRIVATE_WebChannelConnection);
    function __PRIVATE_WebChannelConnection(e) {
        (0, $978gY._)(this, __PRIVATE_WebChannelConnection);
        var _this;
        _this = _super.call(this, e), _this.forceLongPolling = e.forceLongPolling, _this.autoDetectLongPolling = e.autoDetectLongPolling, _this.useFetchStreams = e.useFetchStreams, _this.longPollingOptions = e.longPollingOptions;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_WebChannelConnection, [
        {
            key: "vo",
            value: function vo(e, t, n, r) {
                var i = $59fc9b849b320ded$var$__PRIVATE_generateUniqueDebugId();
                return new Promise(function(s, o) {
                    var _ = new (0, $bcffdc5a8182d43d$export$26404658cda3ee02);
                    _.setWithCredentials(!0), _.listenOnce((0, $bcffdc5a8182d43d$export$3d7865934588d77e).COMPLETE, function() {
                        try {
                            switch(_.getLastErrorCode()){
                                case (0, $bcffdc5a8182d43d$export$d4e71bc0b80dc0fb).NO_ERROR:
                                    var _$t = _.getResponseJson();
                                    $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "XHR for RPC '".concat(e, "' ").concat(i, " received:"), JSON.stringify(_$t)), s(_$t);
                                    break;
                                case (0, $bcffdc5a8182d43d$export$d4e71bc0b80dc0fb).TIMEOUT:
                                    $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' ").concat(i, " timed out")), o(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.DEADLINE_EXCEEDED, "Request time out"));
                                    break;
                                case (0, $bcffdc5a8182d43d$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                                    var _$n = _.getStatus();
                                    if ($59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' ").concat(i, " failed with status:"), _$n, "response text:", _.getResponseText()), _$n > 0) {
                                        var _$e = _.getResponseJson();
                                        Array.isArray(_$e) && (_$e = _$e[0]);
                                        var _$t1 = null == _$e ? void 0 : _$e.error;
                                        if (_$t1 && _$t1.status && _$t1.message) {
                                            var _$e1 = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                                var _$t = e.toLowerCase().replace(/_/g, "-");
                                                return Object.values($59fc9b849b320ded$var$D).indexOf(_$t) >= 0 ? _$t : $59fc9b849b320ded$var$D.UNKNOWN;
                                            }(_$t1.status);
                                            o(new $59fc9b849b320ded$export$8fada0bf726bf278(_$e1, _$t1.message));
                                        } else o(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNKNOWN, "Server responded with status " + _.getStatus()));
                                    } else // If we received an HTTP_ERROR but there's no status code,
                                    // it's most probably a connection issue
                                    o(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNAVAILABLE, "Connection failed."));
                                    break;
                                default:
                                    $59fc9b849b320ded$var$fail();
                            }
                        } finally{
                            $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' ").concat(i, " completed."));
                        }
                    });
                    var a = JSON.stringify(r);
                    $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' ").concat(i, " sending request:"), r), _.send(t, "POST", a, n, 15);
                });
            }
        },
        {
            key: "Mo",
            value: function Mo(e, t, n) {
                var r = $59fc9b849b320ded$var$__PRIVATE_generateUniqueDebugId(), i = [
                    this.po,
                    "/",
                    "google.firestore.v1.Firestore",
                    "/",
                    e,
                    "/channel"
                ], s = (0, $bcffdc5a8182d43d$export$66869136fc133c3a)(), o = (0, $bcffdc5a8182d43d$export$888d0d9ab79d08fc)(), _ = {
                    // Required for backend stickiness, routing behavior is based on this
                    // parameter.
                    httpSessionIdParam: "gsessionid",
                    initMessageHeaders: {},
                    messageUrlParams: {
                        // This param is used to improve routing and project isolation by the
                        // backend and must be included in every request.
                        database: "projects/".concat(this.databaseId.projectId, "/databases/").concat(this.databaseId.database)
                    },
                    sendRawJson: !0,
                    supportsCrossDomainXhr: !0,
                    internalChannelParams: {
                        // Override the default timeout (randomized between 10-20 seconds) since
                        // a large write batch on a slow internet connection may take a long
                        // time to send to the backend. Rather than have WebChannel impose a
                        // tight timeout which could lead to infinite timeouts and retries, we
                        // set it very large (5-10 minutes) and rely on the browser's builtin
                        // timeouts to kick in if the request isn't working.
                        forwardChannelRequestTimeoutMs: 6e5
                    },
                    forceLongPolling: this.forceLongPolling,
                    detectBufferingProxy: this.autoDetectLongPolling
                }, a = this.longPollingOptions.timeoutSeconds;
                void 0 !== a && (_.longPollingTimeout = Math.round(1e3 * a)), this.useFetchStreams && (_.useFetchStreams = !0), this.Co(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
                // (Authorization, etc.) will trigger the browser to make a CORS preflight
                // request because the XHR will no longer meet the criteria for a "simple"
                // CORS request:
                // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
                // Therefore to avoid the CORS preflight request (an extra network
                // roundtrip), we use the encodeInitMessageHeaders option to specify that
                // the headers should instead be encoded in the request's POST payload,
                // which is recognized by the webchannel backend.
                _.encodeInitMessageHeaders = !0;
                var u = i.join("");
                $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "Creating RPC '".concat(e, "' stream ").concat(r, ": ").concat(u), _);
                var c = s.createWebChannel(u, _);
                // WebChannel supports sending the first message with the handshake - saving
                // a network round trip. However, it will have to call send in the same
                // JS event loop as open. In order to enforce this, we delay actually
                // opening the WebChannel until send is called. Whether we have called
                // open is tracked with this variable.
                var l = !1, h = !1;
                // A flag to determine whether the stream was closed (by us or through an
                // error/close event) to avoid delivering multiple close events or sending
                // on a closed stream
                var P = new $59fc9b849b320ded$var$__PRIVATE_StreamBridge({
                    ho: function(t) {
                        h ? $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "Not sending because RPC '".concat(e, "' stream ").concat(r, " is closed:"), t) : (l || ($59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "Opening RPC '".concat(e, "' stream ").concat(r, " transport.")), c.open(), l = !0), $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " sending:"), t), c.send(t));
                    },
                    Po: function() {
                        return c.close();
                    }
                }), __PRIVATE_unguardedEventListen = function(e, t, n) {
                    // TODO(dimond): closure typing seems broken because WebChannel does
                    // not implement goog.events.Listenable
                    e.listen(t, function(e) {
                        try {
                            n(e);
                        } catch (e) {
                            setTimeout(function() {
                                throw e;
                            }, 0);
                        }
                    });
                };
                // Closure events are guarded and exceptions are swallowed, so catch any
                // exception and rethrow using a setTimeout so they become visible again.
                // Note that eventually this function could go away if we are confident
                // enough the code is exception free.
                return __PRIVATE_unguardedEventListen(c, (0, $bcffdc5a8182d43d$export$aa726fb96ad3e039).EventType.OPEN, function() {
                    h || $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " transport opened."));
                }), __PRIVATE_unguardedEventListen(c, (0, $bcffdc5a8182d43d$export$aa726fb96ad3e039).EventType.CLOSE, function() {
                    h || (h = !0, $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " transport closed")), P.mo());
                }), __PRIVATE_unguardedEventListen(c, (0, $bcffdc5a8182d43d$export$aa726fb96ad3e039).EventType.ERROR, function(t) {
                    h || (h = !0, $59fc9b849b320ded$export$86cd73f49cc6e0bb($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " transport errored:"), t), P.mo(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNAVAILABLE, "The operation could not be completed")));
                }), __PRIVATE_unguardedEventListen(c, (0, $bcffdc5a8182d43d$export$aa726fb96ad3e039).EventType.MESSAGE, function(t) {
                    var _$n;
                    if (!h) {
                        var i = t.data[0];
                        $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!i);
                        // TODO(b/35143891): There is a bug in One Platform that caused errors
                        // (and only errors) to be wrapped in an extra array. To be forward
                        // compatible with the bug we need to check either condition. The latter
                        // can be removed once the fix has been rolled out.
                        // Use any because msgData.error is not typed.
                        var s = i, o = s.error || (null === (_$n = s[0]) || void 0 === _$n ? void 0 : _$n.error);
                        if (o) {
                            $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " received error:"), o);
                            // error.status will be a string like 'OK' or 'NOT_FOUND'.
                            var _$t = o.status;
                            var _$n1 = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                                // lookup by string
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                var _$t = $59fc9b849b320ded$var$ae[e];
                                if (void 0 !== _$t) return $59fc9b849b320ded$var$__PRIVATE_mapCodeFromRpcCode(_$t);
                            }(_$t), i1 = o.message;
                            void 0 === _$n1 && (_$n1 = $59fc9b849b320ded$var$D.INTERNAL, i1 = "Unknown error status: " + _$t + " with message " + o.message), // Mark closed so no further events are propagated
                            h = !0, P.mo(new $59fc9b849b320ded$export$8fada0bf726bf278(_$n1, i1)), c.close();
                        } else $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " received:"), i), P.fo(i);
                    }
                }), __PRIVATE_unguardedEventListen(o, (0, $bcffdc5a8182d43d$export$d61e24a684f9e51).STAT_EVENT, function(t) {
                    t.stat === (0, $bcffdc5a8182d43d$export$cbbc350c1dfc80cb).PROXY ? $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " detected buffering proxy")) : t.stat === (0, $bcffdc5a8182d43d$export$cbbc350c1dfc80cb).NOPROXY && $59fc9b849b320ded$var$__PRIVATE_logDebug($59fc9b849b320ded$var$Ve, "RPC '".concat(e, "' stream ").concat(r, " detected no buffering proxy"));
                }), setTimeout(function() {
                    // Technically we could/should wait for the WebChannel opened event,
                    // but because we want to send the first message with the WebChannel
                    // handshake we pretend the channel opened here (asynchronously), and
                    // then delay the actual open until the first message is sent.
                    P.Vo();
                }, 0), P;
            }
        }
    ]);
    return __PRIVATE_WebChannelConnection;
}(/**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_RestConnection(e) {
        (0, $978gY._)(this, __PRIVATE_RestConnection);
        this.databaseInfo = e, this.databaseId = e.databaseId;
        var t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.po = t + "://" + e.host, this.yo = "projects/".concat(n, "/databases/").concat(r), this.wo = "(default)" === this.databaseId.database ? "project_id=".concat(n) : "project_id=".concat(n, "&database_id=").concat(r);
    }
    (0, $kry2a._)(__PRIVATE_RestConnection, [
        {
            key: "So",
            get: function get() {
                // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
                // where to run the query, and expect the `request` to NOT specify the "path".
                return !1;
            }
        },
        {
            key: "bo",
            value: function bo(e, t, n, r, i) {
                var s = $59fc9b849b320ded$var$__PRIVATE_generateUniqueDebugId(), o = this.Do(e, t);
                $59fc9b849b320ded$var$__PRIVATE_logDebug("RestConnection", "Sending RPC '".concat(e, "' ").concat(s, ":"), o, n);
                var _ = {
                    "google-cloud-resource-prefix": this.yo,
                    "x-goog-request-params": this.wo
                };
                return this.Co(_, r, i), this.vo(e, o, _, n).then(function(t) {
                    return $59fc9b849b320ded$var$__PRIVATE_logDebug("RestConnection", "Received RPC '".concat(e, "' ").concat(s, ": "), t), t;
                }, function(t) {
                    throw $59fc9b849b320ded$export$86cd73f49cc6e0bb("RestConnection", "RPC '".concat(e, "' ").concat(s, " failed with error: "), t, "url: ", o, "request:", n), t;
                });
            }
        },
        {
            key: "Fo",
            value: function Fo(e, t, n, r, i, s) {
                // The REST API automatically aggregates all of the streamed results, so we
                // can just use the normal invoke() method.
                return this.bo(e, t, n, r, i);
            }
        },
        {
            /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ key: "Co",
            value: function Co(e, t, n) {
                e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
                // so we need to get its value when we need it in a function.
                function __PRIVATE_getGoogApiClientValue() {
                    return "gl-js/ fire/" + $59fc9b849b320ded$var$S;
                }(), // Content-Type: text/plain will avoid preflight requests which might
                // mess with CORS and redirects by proxies. If we add custom headers
                // we will need to change this code to potentially use the $httpOverwrite
                // parameter supported by ESF to avoid triggering preflight requests.
                e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach(function(t, n) {
                    return e[n] = t;
                }), n && n.headers.forEach(function(t, n) {
                    return e[n] = t;
                });
            }
        },
        {
            key: "Do",
            value: function Do(e, t) {
                var n = $59fc9b849b320ded$var$Re[e];
                return "".concat(this.po, "/v1/").concat(t, ":").concat(n);
            }
        }
    ]);
    return __PRIVATE_RestConnection;
}());
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $59fc9b849b320ded$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $59fc9b849b320ded$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fc9b849b320ded$var$__PRIVATE_newSerializer(e) {
    return new $59fc9b849b320ded$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ var $59fc9b849b320ded$var$__PRIVATE_ExponentialBackoff = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ExponentialBackoff(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t) {
        var /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e3, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1.5, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 6e4;
        (0, $978gY._)(this, __PRIVATE_ExponentialBackoff);
        this._i = e, this.timerId = t, this.xo = n, this.Oo = r, this.No = i, this.Bo = 0, this.Lo = null, /** The last backoff attempt, as epoch milliseconds. */ this.ko = Date.now(), this.reset();
    }
    (0, $kry2a._)(__PRIVATE_ExponentialBackoff, [
        {
            /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ key: "reset",
            value: function reset() {
                this.Bo = 0;
            }
        },
        {
            /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ key: "qo",
            value: function qo() {
                this.Bo = this.No;
            }
        },
        {
            /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ key: "Qo",
            value: function Qo(e) {
                var _this = this;
                // Cancel any pending backoff operation.
                this.cancel();
                // First schedule using the current base (which may be 0 and should be
                // honored as such).
                var t = Math.floor(this.Bo + this.Ko()), n = Math.max(0, Date.now() - this.ko), r = Math.max(0, t - n);
                // Guard against lastAttemptTime being in the future due to a clock change.
                r > 0 && $59fc9b849b320ded$var$__PRIVATE_logDebug("ExponentialBackoff", "Backing off for ".concat(r, " ms (base delay: ").concat(this.Bo, " ms, delay with jitter: ").concat(t, " ms, last attempt: ").concat(n, " ms ago)")), this.Lo = this._i.enqueueAfterDelay(this.timerId, r, function() {
                    return _this.ko = Date.now(), e();
                }), // Apply backoff factor to determine next delay and ensure it is within
                // bounds.
                this.Bo *= this.Oo, this.Bo < this.xo && (this.Bo = this.xo), this.Bo > this.No && (this.Bo = this.No);
            }
        },
        {
            key: "$o",
            value: function $o() {
                null !== this.Lo && (this.Lo.skipDelay(), this.Lo = null);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                null !== this.Lo && (this.Lo.cancel(), this.Lo = null);
            }
        },
        {
            /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ key: "Ko",
            value: function Ko() {
                return (Math.random() - .5) * this.Bo;
            }
        }
    ]);
    return __PRIVATE_ExponentialBackoff;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ var $59fc9b849b320ded$var$__PRIVATE_PersistentStream = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_PersistentStream(e, t, n, r, i, s, o, _) {
        (0, $978gY._)(this, __PRIVATE_PersistentStream);
        this._i = e, this.Uo = n, this.Wo = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = o, this.listener = _, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.Go = 0, this.zo = null, this.jo = null, this.stream = null, this.Ho = new $59fc9b849b320ded$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    (0, $kry2a._)(__PRIVATE_PersistentStream, [
        {
            /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ key: "Jo",
            value: function Jo() {
                return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Yo();
            }
        },
        {
            /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ key: "Yo",
            value: function Yo() {
                return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
            }
        },
        {
            /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ key: "start",
            value: function start() {
                4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.Zo();
            }
        },
        {
            key: "stop",
            value: /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ function stop() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.Jo();
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.close(0 /* PersistentStreamState.Initial */ )
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ key: "Xo",
            value: function Xo() {
                this.state = 0 /* PersistentStreamState.Initial */ , this.Ho.reset();
            }
        },
        {
            /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ key: "e_",
            value: function e_() {
                var _this = this;
                // Starts the idle time if we are in state 'Open' and are not yet already
                // running a timer (in which case the previous idle timeout still applies).
                this.Yo() && null === this.zo && (this.zo = this._i.enqueueAfterDelay(this.Uo, 6e4, function() {
                    return _this.t_();
                }));
            }
        },
        {
            /** Sends a message to the underlying stream. */ key: "n_",
            value: function n_(e) {
                this.r_(), this.stream.send(e);
            }
        },
        {
            key: "t_",
            value: /** Called by the idle timer when the stream should close due to inactivity. */ function t_() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        if (_this.Yo()) // When timing out an idle stream there's no reason to force the stream into backoff when
                        // it restarts so set the stream state to Initial instead of Error.
                        return [
                            2,
                            _this.close(0 /* PersistentStreamState.Initial */ )
                        ];
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** Marks the stream as active again. */ key: "r_",
            value: function r_() {
                this.zo && (this.zo.cancel(), this.zo = null);
            }
        },
        {
            /** Cancels the health check delayed operation. */ key: "i_",
            value: function i_() {
                this.jo && (this.jo.cancel(), this.jo = null);
            }
        },
        {
            key: "close",
            value: /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ function close(e, t) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Cancel any outstanding timers (they're guaranteed not to execute).
                                _this.r_(), _this.i_(), _this.Ho.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
                                // underlying stream), guaranteeing they won't execute.
                                _this.Go++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
                                _this.Ho.reset() : t && t.code === $59fc9b849b320ded$var$D.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
                                ($59fc9b849b320ded$var$__PRIVATE_logError(t.toString()), $59fc9b849b320ded$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), _this.Ho.qo()) : t && t.code === $59fc9b849b320ded$var$D.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== _this.state && // "unauthenticated" error means the token was rejected. This should rarely
                                // happen since both Auth and AppCheck ensure a sufficient TTL when we
                                // request a token. If a user manually resets their system clock this can
                                // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
                                // before we received the first message and we need to invalidate the token
                                // to ensure that we fetch a new token.
                                (_this.authCredentialsProvider.invalidateToken(), _this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
                                null !== _this.stream && (_this.s_(), _this.stream.close(), _this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
                                // inhibit backoff or otherwise manipulate the state in its non-started state.
                                _this.state = e;
                                // Notify the listener that the stream closed.
                                return [
                                    4,
                                    _this.listener.Eo(t)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ key: "s_",
            value: function s_() {}
        },
        {
            key: "auth",
            value: function auth() {
                var _this = this;
                this.state = 1 /* PersistentStreamState.Starting */ ;
                var e = this.o_(this.Go), t = this.Go;
                // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
                Promise.all([
                    this.authCredentialsProvider.getToken(),
                    this.appCheckCredentialsProvider.getToken()
                ]).then(function(param) {
                    var _param = (0, $8GFUW._)(param, 2), e = _param[0], n = _param[1];
                    // Stream can be stopped while waiting for authentication.
                    // TODO(mikelehen): We really should just use dispatchIfNotClosed
                    // and let this dispatch onto the queue, but that opened a spec test can
                    // of worms that I don't want to deal with in this PR.
                    _this.Go === t && // Normally we'd have to schedule the callback on the AsyncQueue.
                    // However, the following calls are safe to be called outside the
                    // AsyncQueue since they don't chain asynchronous calls
                    _this.__(e, n);
                }, function(t) {
                    e(function() {
                        var e = new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNKNOWN, "Fetching auth token failed: " + t.message);
                        return _this.a_(e);
                    });
                });
            }
        },
        {
            key: "__",
            value: function __(e, t) {
                var _this = this;
                var n = this.o_(this.Go);
                this.stream = this.u_(e, t), this.stream.Io(function() {
                    n(function() {
                        return _this.state = 2 /* PersistentStreamState.Open */ , _this.jo = _this._i.enqueueAfterDelay(_this.Wo, 1e4, function() {
                            return _this.Yo() && (_this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve();
                        }), _this.listener.Io();
                    });
                }), this.stream.Eo(function(e) {
                    n(function() {
                        return _this.a_(e);
                    });
                }), this.stream.onMessage(function(e) {
                    n(function() {
                        return _this.onMessage(e);
                    });
                });
            }
        },
        {
            key: "Zo",
            value: function Zo() {
                var _this = this;
                this.state = 5 /* PersistentStreamState.Backoff */ , this.Ho.Qo(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        _this.state = 0 /* PersistentStreamState.Initial */ , _this.start();
                        return [
                            2
                        ];
                    });
                }));
            }
        },
        {
            // Visible for tests
            key: "a_",
            value: function a_(e) {
                // In theory the stream could close cleanly, however, in our current model
                // we never expect this to happen because if we stop a stream ourselves,
                // this callback will never be called. To prevent cases where we retry
                // without a backoff accidentally, we set the stream to error in all cases.
                return $59fc9b849b320ded$var$__PRIVATE_logDebug("PersistentStream", "close with error: ".concat(e)), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
            }
        },
        {
            /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ key: "o_",
            value: function o_(e) {
                var _this = this;
                return function(t) {
                    _this._i.enqueueAndForget(function() {
                        return _this.Go === e ? t() : ($59fc9b849b320ded$var$__PRIVATE_logDebug("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve());
                    });
                };
            }
        }
    ]);
    return __PRIVATE_PersistentStream;
}();
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ var $59fc9b849b320ded$var$__PRIVATE_PersistentListenStream = /*#__PURE__*/ function(__PRIVATE_PersistentStream) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_PersistentListenStream, __PRIVATE_PersistentStream);
    var _super = (0, $6OZAO._)(__PRIVATE_PersistentListenStream);
    function __PRIVATE_PersistentListenStream(e, t, n, r, i, s) {
        (0, $978gY._)(this, __PRIVATE_PersistentListenStream);
        var _this;
        _this = _super.call(this, e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), _this.serializer = i;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_PersistentListenStream, [
        {
            key: "u_",
            value: function u_(e, t) {
                return this.connection.Mo("Listen", e, t);
            }
        },
        {
            key: "onMessage",
            value: function onMessage(e) {
                // A successful response means the stream is healthy
                this.Ho.reset();
                var t = $59fc9b849b320ded$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
                    // We have only reached a consistent snapshot for the entire stream if there
                    // is a read_time set and it applies to all targets (i.e. the list of
                    // targets is empty). The backend is guaranteed to send such responses.
                    if (!("targetChange" in e)) return $59fc9b849b320ded$var$SnapshotVersion.min();
                    var t = e.targetChange;
                    return t.targetIds && t.targetIds.length ? $59fc9b849b320ded$var$SnapshotVersion.min() : t.readTime ? $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.readTime) : $59fc9b849b320ded$var$SnapshotVersion.min();
                }(e);
                return this.listener.c_(t, n);
            }
        },
        {
            /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ key: "l_",
            value: function l_(e) {
                var t = {};
                t.database = $59fc9b849b320ded$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
                    var n;
                    var r = t.target;
                    if (n = $59fc9b849b320ded$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                        documents: $59fc9b849b320ded$var$__PRIVATE_toDocumentsTarget(e, r)
                    } : {
                        query: $59fc9b849b320ded$var$__PRIVATE_toQueryTarget(e, r)
                    }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                        n.resumeToken = $59fc9b849b320ded$var$__PRIVATE_toBytes(e, t.resumeToken);
                        var r1 = $59fc9b849b320ded$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                        null !== r1 && (n.expectedCount = r1);
                    } else if (t.snapshotVersion.compareTo($59fc9b849b320ded$var$SnapshotVersion.min()) > 0) {
                        // TODO(wuandy): Consider removing above check because it is most likely true.
                        // Right now, many tests depend on this behaviour though (leaving min() out
                        // of serialization).
                        n.readTime = $59fc9b849b320ded$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                        var r2 = $59fc9b849b320ded$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                        null !== r2 && (n.expectedCount = r2);
                    }
                    return n;
                }(this.serializer, e);
                var n = $59fc9b849b320ded$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
                n && (t.labels = n), this.n_(t);
            }
        },
        {
            /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ key: "h_",
            value: function h_(e) {
                var t = {};
                t.database = $59fc9b849b320ded$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.n_(t);
            }
        }
    ]);
    return __PRIVATE_PersistentListenStream;
}($59fc9b849b320ded$var$__PRIVATE_PersistentStream);
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ var $59fc9b849b320ded$var$__PRIVATE_PersistentWriteStream = /*#__PURE__*/ function(__PRIVATE_PersistentStream) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_PersistentWriteStream, __PRIVATE_PersistentStream);
    var _super = (0, $6OZAO._)(__PRIVATE_PersistentWriteStream);
    function __PRIVATE_PersistentWriteStream(e, t, n, r, i, s) {
        (0, $978gY._)(this, __PRIVATE_PersistentWriteStream);
        var _this;
        _this = _super.call(this, e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), _this.serializer = i, _this.P_ = !1;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_PersistentWriteStream, [
        {
            key: "I_",
            get: /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ function get() {
                return this.P_;
            }
        },
        {
            // Override of PersistentStream.start
            key: "start",
            value: function start() {
                this.P_ = !1, this.lastStreamToken = void 0, (0, $3cct3._)((0, $g3d7z._)(__PRIVATE_PersistentWriteStream.prototype), "start", this).call(this);
            }
        },
        {
            key: "s_",
            value: function s_() {
                this.P_ && this.d_([]);
            }
        },
        {
            key: "u_",
            value: function u_(e, t) {
                return this.connection.Mo("Write", e, t);
            }
        },
        {
            key: "onMessage",
            value: function onMessage(e) {
                if (// Always capture the last stream token.
                $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!e.streamToken), this.lastStreamToken = e.streamToken, this.P_) {
                    // A successful first write response means the stream is healthy,
                    // Note, that we could consider a successful handshake healthy, however,
                    // the write itself might be causing an error we want to back off from.
                    this.Ho.reset();
                    var t = $59fc9b849b320ded$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $59fc9b849b320ded$var$__PRIVATE_fromVersion(e.commitTime);
                    return this.listener.T_(n, t);
                }
                // The first response is always the handshake response
                return $59fc9b849b320ded$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length), this.P_ = !0, this.listener.E_();
            }
        },
        {
            /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ key: "A_",
            value: function A_() {
                // TODO(dimond): Support stream resumption. We intentionally do not set the
                // stream token on the handshake, ignoring any stream token we might have.
                var e = {};
                e.database = $59fc9b849b320ded$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.n_(e);
            }
        },
        {
            /** Sends a group of mutations to the Firestore backend to apply. */ key: "d_",
            value: function d_(e) {
                var _this = this;
                var t = {
                    streamToken: this.lastStreamToken,
                    writes: e.map(function(e) {
                        return $59fc9b849b320ded$var$toMutation(_this.serializer, e);
                    })
                };
                this.n_(t);
            }
        }
    ]);
    return __PRIVATE_PersistentWriteStream;
}($59fc9b849b320ded$var$__PRIVATE_PersistentStream);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ /**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ var $59fc9b849b320ded$var$__PRIVATE_DatastoreImpl = /*#__PURE__*/ function(_Datastore) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_DatastoreImpl, _Datastore);
    var _super = (0, $6OZAO._)(__PRIVATE_DatastoreImpl);
    function __PRIVATE_DatastoreImpl(e, t, n, r) {
        (0, $978gY._)(this, __PRIVATE_DatastoreImpl);
        var _this;
        _this = _super.call(this), _this.authCredentials = e, _this.appCheckCredentials = t, _this.connection = n, _this.serializer = r, _this.R_ = !1;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_DatastoreImpl, [
        {
            key: "V_",
            value: function V_() {
                if (this.R_) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "The client has already been terminated.");
            }
        },
        {
            /** Invokes the provided RPC with auth and AppCheck tokens. */ key: "bo",
            value: function bo(e, t, n) {
                var _this = this;
                return this.V_(), Promise.all([
                    this.authCredentials.getToken(),
                    this.appCheckCredentials.getToken()
                ]).then(function(param) {
                    var _param = (0, $8GFUW._)(param, 2), r = _param[0], i = _param[1];
                    return _this.connection.bo(e, t, n, r, i);
                }).catch(function(e) {
                    throw "FirebaseError" === e.name ? (e.code === $59fc9b849b320ded$var$D.UNAUTHENTICATED && (_this.authCredentials.invalidateToken(), _this.appCheckCredentials.invalidateToken()), e) : new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNKNOWN, e.toString());
                });
            }
        },
        {
            /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ key: "Fo",
            value: function Fo(e, t, n, r) {
                var _this = this;
                return this.V_(), Promise.all([
                    this.authCredentials.getToken(),
                    this.appCheckCredentials.getToken()
                ]).then(function(param) {
                    var _param = (0, $8GFUW._)(param, 2), i = _param[0], s = _param[1];
                    return _this.connection.Fo(e, t, n, i, s, r);
                }).catch(function(e) {
                    throw "FirebaseError" === e.name ? (e.code === $59fc9b849b320ded$var$D.UNAUTHENTICATED && (_this.authCredentials.invalidateToken(), _this.appCheckCredentials.invalidateToken()), e) : new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNKNOWN, e.toString());
                });
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                this.R_ = !0;
            }
        }
    ]);
    return __PRIVATE_DatastoreImpl;
}(function Datastore() {
    "use strict";
    (0, $978gY._)(this, Datastore);
});
function $59fc9b849b320ded$var$__PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_invokeRunAggregationQueryRpc.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_invokeRunAggregationQueryRpc() {
    $59fc9b849b320ded$var$___PRIVATE_invokeRunAggregationQueryRpc = // TODO(firestorexp): Make sure there is only one Datastore instance per
    // firestore-exp client.
    (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, i, __PRIVATE_toRunAggregationQueryRequest, s, o, _, a, u;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), __PRIVATE_toRunAggregationQueryRequest = function __PRIVATE_toRunAggregationQueryRequest(e, t, n) {
                        var r = $59fc9b849b320ded$var$__PRIVATE_toQueryTarget(e, t), i = {}, s = [];
                        var o = 0;
                        return n.forEach(function(e) {
                            // Map all client-side aliases to a unique short-form
                            // alias. This avoids issues with client-side aliases that
                            // exceed the 1500-byte string size limit.
                            var _$t = "aggregate_" + o++;
                            i[_$t] = e.alias, "count" === e.Ee ? s.push({
                                alias: _$t,
                                count: {}
                            }) : "avg" === e.Ee ? s.push({
                                alias: _$t,
                                avg: {
                                    field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.fieldPath)
                                }
                            }) : "sum" === e.Ee && s.push({
                                alias: _$t,
                                sum: {
                                    field: $59fc9b849b320ded$var$__PRIVATE_toFieldPathReference(e.fieldPath)
                                }
                            });
                        }), {
                            request: {
                                structuredAggregationQuery: {
                                    aggregations: s,
                                    structuredQuery: r.structuredQuery
                                },
                                parent: r.parent
                            },
                            m_: i
                        };
                    }(i.serializer, function __PRIVATE_queryToAggregateTarget(e) {
                        var _$t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                        return _$t.de || // Do not include implicit order-bys for aggregate queries.
                        (_$t.de = $59fc9b849b320ded$var$__PRIVATE__queryToTarget(_$t, e.explicitOrderBy)), _$t.de;
                    }(t), n), s = __PRIVATE_toRunAggregationQueryRequest.request, o = __PRIVATE_toRunAggregationQueryRequest.m_, _ = s.parent;
                    i.connection.So || delete s.parent;
                    return [
                        4,
                        i.Fo("RunAggregationQuery", _, s, /*expectedResponseCount=*/ 1)
                    ];
                case 1:
                    a = _state.sent().filter(function(e) {
                        return !!e.result;
                    });
                    // Omit RunAggregationQueryResponse that only contain readTimes.
                    $59fc9b849b320ded$var$__PRIVATE_hardAssert(1 === a.length);
                    u = null === (r = a[0].result) || void 0 === r ? void 0 : r.aggregateFields;
                    return [
                        2,
                        Object.keys(u).reduce(function(e, t) {
                            return e[o[t]] = u[t], e;
                        }, {})
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_invokeRunAggregationQueryRpc.apply(this, arguments);
}
/**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ var $59fc9b849b320ded$var$__PRIVATE_OnlineStateTracker = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_OnlineStateTracker(e, t) {
        (0, $978gY._)(this, __PRIVATE_OnlineStateTracker);
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.f_ = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.g_ = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.p_ = !0;
    }
    (0, $kry2a._)(__PRIVATE_OnlineStateTracker, [
        {
            /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ key: "y_",
            value: function y_() {
                var _this = this;
                0 === this.f_ && (this.w_("Unknown" /* OnlineState.Unknown */ ), this.g_ = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, function() {
                    return _this.g_ = null, _this.S_("Backend didn't respond within 10 seconds."), _this.w_("Offline" /* OnlineState.Offline */ ), Promise.resolve();
                }));
            }
        },
        {
            /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ key: "b_",
            value: function b_(e) {
                "Online" /* OnlineState.Online */  === this.state ? this.w_("Unknown" /* OnlineState.Unknown */ ) : (this.f_++, this.f_ >= 1 && (this.D_(), this.S_("Connection failed 1 times. Most recent error: ".concat(e.toString())), this.w_("Offline" /* OnlineState.Offline */ )));
            }
        },
        {
            /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ key: "set",
            value: function set(e) {
                this.D_(), this.f_ = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
                // about being offline going forward.
                (this.p_ = !1), this.w_(e);
            }
        },
        {
            key: "w_",
            value: function w_(e) {
                e !== this.state && (this.state = e, this.onlineStateHandler(e));
            }
        },
        {
            key: "S_",
            value: function S_(e) {
                var t = "Could not reach Cloud Firestore backend. ".concat(e, "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.");
                this.p_ ? ($59fc9b849b320ded$var$__PRIVATE_logError(t), this.p_ = !1) : $59fc9b849b320ded$var$__PRIVATE_logDebug("OnlineStateTracker", t);
            }
        },
        {
            key: "D_",
            value: function D_() {
                null !== this.g_ && (this.g_.cancel(), this.g_ = null);
            }
        }
    ]);
    return __PRIVATE_OnlineStateTracker;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_RemoteStoreImpl = function __PRIVATE_RemoteStoreImpl(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i) {
    "use strict";
    var _this = this;
    (0, $978gY._)(this, __PRIVATE_RemoteStoreImpl);
    this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.C_ = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.v_ = new Map, /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.F_ = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.M_ = [], this.x_ = i, this.x_.so(function(e) {
        var _this1 = _this;
        n.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            var _tmp;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                        // network becomes unreachable as we don't have any other way to tear
                        // down our streams.
                        $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(_this1);
                        if (!_tmp) return [
                            3,
                            2
                        ];
                        $59fc9b849b320ded$var$__PRIVATE_logDebug("RemoteStore", "Restarting streams for network reachability change.");
                        return [
                            4,
                            (function() {
                                var ___PRIVATE_restartNetwork = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
                                    var _$t;
                                    return (0, $7UAGh.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _$t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                                                _$t.F_.add(4 /* OfflineCause.ConnectivityChange */ );
                                                return [
                                                    4,
                                                    $59fc9b849b320ded$var$__PRIVATE_disableNetworkInternal(_$t)
                                                ];
                                            case 1:
                                                _state.sent(), _$t.O_.set("Unknown" /* OnlineState.Unknown */ ), _$t.F_.delete(4 /* OfflineCause.ConnectivityChange */ );
                                                return [
                                                    4,
                                                    $59fc9b849b320ded$var$__PRIVATE_enableNetworkInternal(_$t)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                function __PRIVATE_restartNetwork(e) {
                                    return ___PRIVATE_restartNetwork.apply(this, arguments);
                                }
                                return __PRIVATE_restartNetwork;
                            })()(_this1)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        _state.label = 2;
                    case 2:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        }));
    }), this.O_ = new $59fc9b849b320ded$var$__PRIVATE_OnlineStateTracker(n, r);
};
function $59fc9b849b320ded$var$__PRIVATE_enableNetworkInternal(e) {
    return $59fc9b849b320ded$var$___PRIVATE_enableNetworkInternal.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_enableNetworkInternal() {
    $59fc9b849b320ded$var$___PRIVATE_enableNetworkInternal = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (!$59fc9b849b320ded$var$__PRIVATE_canUseNetwork(e)) return [
                        3,
                        8
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = e.M_[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    t = _step.value;
                    return [
                        4,
                        t(/* enabled= */ !0)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_enableNetworkInternal.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_disableNetworkInternal(e) {
    return $59fc9b849b320ded$var$___PRIVATE_disableNetworkInternal.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_disableNetworkInternal() {
    $59fc9b849b320ded$var$___PRIVATE_disableNetworkInternal = /**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, t, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = e.M_[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    t = _step.value;
                    return [
                        4,
                        t(/* enabled= */ !1)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_disableNetworkInternal.apply(this, arguments);
}
/**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $59fc9b849b320ded$var$__PRIVATE_remoteStoreListen(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    n.v_.has(t.targetId) || // Mark this as something the client is currently listening for.
    (n.v_.set(t.targetId, t), $59fc9b849b320ded$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $59fc9b849b320ded$var$__PRIVATE_startWatchStream(n) : $59fc9b849b320ded$var$__PRIVATE_ensureWatchStream(n).Yo() && $59fc9b849b320ded$var$__PRIVATE_sendWatchRequest(n, t));
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $59fc9b849b320ded$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = $59fc9b849b320ded$var$__PRIVATE_ensureWatchStream(n);
    n.v_.delete(t), r.Yo() && $59fc9b849b320ded$var$__PRIVATE_sendUnwatchRequest(n, t), 0 === n.v_.size && (r.Yo() ? r.e_() : $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.O_.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $59fc9b849b320ded$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.N_.Le(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($59fc9b849b320ded$var$SnapshotVersion.min()) > 0) {
        var n = e.remoteSyncer.getRemoteKeysForTarget(t.targetId).size;
        t = t.withExpectedCount(n);
    }
    $59fc9b849b320ded$var$__PRIVATE_ensureWatchStream(e).l_(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $59fc9b849b320ded$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.N_.Le(t), $59fc9b849b320ded$var$__PRIVATE_ensureWatchStream(e).h_(t);
}
function $59fc9b849b320ded$var$__PRIVATE_startWatchStream(e) {
    e.N_ = new $59fc9b849b320ded$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: function(t) {
            return e.remoteSyncer.getRemoteKeysForTarget(t);
        },
        lt: function(t) {
            return e.v_.get(t) || null;
        },
        st: function() {
            return e.datastore.serializer.databaseId;
        }
    }), $59fc9b849b320ded$var$__PRIVATE_ensureWatchStream(e).start(), e.O_.y_();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $59fc9b849b320ded$var$__PRIVATE_shouldStartWatchStream(e) {
    return $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(e) && !$59fc9b849b320ded$var$__PRIVATE_ensureWatchStream(e).Jo() && e.v_.size > 0;
}
function $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $59fc9b849b320ded$var$__PRIVATE_debugCast(e).F_.size;
}
function $59fc9b849b320ded$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.N_ = void 0;
}
function $59fc9b849b320ded$var$__PRIVATE_onWatchStreamOpen(e) {
    return $59fc9b849b320ded$var$___PRIVATE_onWatchStreamOpen.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_onWatchStreamOpen() {
    $59fc9b849b320ded$var$___PRIVATE_onWatchStreamOpen = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            e.v_.forEach(function(t, n) {
                $59fc9b849b320ded$var$__PRIVATE_sendWatchRequest(e, t);
            });
            return [
                2
            ];
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_onWatchStreamOpen.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_onWatchStreamClose(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_onWatchStreamClose.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_onWatchStreamClose() {
    $59fc9b849b320ded$var$___PRIVATE_onWatchStreamClose = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            $59fc9b849b320ded$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
            $59fc9b849b320ded$var$__PRIVATE_shouldStartWatchStream(e) ? (e.O_.b_(t), $59fc9b849b320ded$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
            // The online state is set to unknown because there is no active attempt
            // at establishing a connection
            e.O_.set("Unknown" /* OnlineState.Unknown */ );
            return [
                2
            ];
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_onWatchStreamClose.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_onWatchStreamChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_onWatchStreamChange() {
    $59fc9b849b320ded$var$___PRIVATE_onWatchStreamChange = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var n1, _$t, _tmp, t1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!// Mark the client as online since we got a message from the server
                    (e.O_.set("Online" /* OnlineState.Online */ ), t instanceof $59fc9b849b320ded$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause)) return [
                        3,
                        6
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        /** Handles an error on a target */ (function() {
                            var ___PRIVATE_handleTargetError = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
                                var _$n, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, _tmp, err;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _$n = t.cause;
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                7,
                                                8,
                                                9
                                            ]);
                                            _iterator = t.targetIds[Symbol.iterator]();
                                            _state.label = 2;
                                        case 2:
                                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                                3,
                                                6
                                            ];
                                            r = _step.value;
                                            _tmp = // A watched target might have been removed already.
                                            e.v_.has(r);
                                            if (!_tmp) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                e.remoteSyncer.rejectListen(r, _$n)
                                            ];
                                        case 3:
                                            _tmp = (_state.sent(), e.v_.delete(r), e.N_.removeTarget(r));
                                            _state.label = 4;
                                        case 4:
                                            _tmp;
                                            _state.label = 5;
                                        case 5:
                                            _iteratorNormalCompletion = true;
                                            return [
                                                3,
                                                2
                                            ];
                                        case 6:
                                            return [
                                                3,
                                                9
                                            ];
                                        case 7:
                                            err = _state.sent();
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                            return [
                                                3,
                                                9
                                            ];
                                        case 8:
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                            return [
                                                7
                                            ];
                                        case 9:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_handleTargetError(e, t) {
                                return ___PRIVATE_handleTargetError.apply(this, arguments);
                            }
                            return __PRIVATE_handleTargetError;
                        })()(e, t)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    n1 = _state.sent();
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), n1);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_disableNetworkUntilRecovery(e, n1)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        13
                    ];
                case 6:
                    if (!(t instanceof $59fc9b849b320ded$var$__PRIVATE_DocumentWatchChange ? e.N_.Ge(t) : t instanceof $59fc9b849b320ded$var$__PRIVATE_ExistenceFilterChange ? e.N_.Xe(t) : e.N_.He(t), !n.isEqual($59fc9b849b320ded$var$SnapshotVersion.min()))) return [
                        3,
                        13
                    ];
                    _state.label = 7;
                case 7:
                    _state.trys.push([
                        7,
                        11,
                        ,
                        13
                    ]);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)
                    ];
                case 8:
                    _$t = _state.sent();
                    _tmp = n.compareTo(_$t) >= 0;
                    if (!_tmp) return [
                        3,
                        10
                    ];
                    // We have received a target change with a global snapshot if the snapshot
                    // version is not equal to SnapshotVersion.min().
                    return [
                        4,
                        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ function __PRIVATE_raiseWatchSnapshot(e, t) {
                            var _$n = e.N_._t(t);
                            // Update in-memory resume tokens. LocalStore will update the
                            // persistent view of these when applying the completed RemoteEvent.
                            return _$n.targetChanges.forEach(function(n, r) {
                                if (n.resumeToken.approximateByteSize() > 0) {
                                    var i = e.v_.get(r);
                                    // A watched target might have been removed already.
                                    i && e.v_.set(r, i.withResumeToken(n.resumeToken, t));
                                }
                            }), // Re-establish listens for the targets that have been invalidated by
                            // existence filter mismatches.
                            _$n.targetMismatches.forEach(function(t, n) {
                                var r = e.v_.get(t);
                                if (!r) // A watched target might have been removed already.
                                return;
                                // Clear the resume token for the target, since we're in a known mismatch
                                // state.
                                e.v_.set(t, r.withResumeToken($59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                                // deliberately don't send a resume token so that we get a full update.
                                $59fc9b849b320ded$var$__PRIVATE_sendUnwatchRequest(e, t);
                                // Mark the target we send as being on behalf of an existence filter
                                // mismatch, but don't actually retain that in listenTargets. This ensures
                                // that we flag the first re-listen this way without impacting future
                                // listens of this target (that might happen e.g. on reconnect).
                                var i = new $59fc9b849b320ded$var$TargetData(r.target, t, n, r.sequenceNumber);
                                $59fc9b849b320ded$var$__PRIVATE_sendWatchRequest(e, i);
                            }), e.remoteSyncer.applyRemoteEvent(_$n);
                        }(e, n)
                    ];
                case 9:
                    _tmp = _state.sent();
                    _state.label = 10;
                case 10:
                    _tmp;
                    return [
                        3,
                        13
                    ];
                case 11:
                    t1 = _state.sent();
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("RemoteStore", "Failed to raise snapshot:", t1);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_disableNetworkUntilRecovery(e, t1)
                    ];
                case 12:
                    _state.sent();
                    return [
                        3,
                        13
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_onWatchStreamChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_disableNetworkUntilRecovery.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_disableNetworkUntilRecovery() {
    $59fc9b849b320ded$var$___PRIVATE_disableNetworkUntilRecovery = /**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!$59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
                    e.F_.add(1 /* OfflineCause.IndexedDbFailed */ );
                    // Disable network and raise offline snapshots
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_disableNetworkInternal(e)
                    ];
                case 1:
                    _state.sent(), e.O_.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
                    // Ideally, we would expose a health check directly on SimpleDb, but
                    // RemoteStore only has access to persistence through LocalStore.
                    (n = function() {
                        return $59fc9b849b320ded$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
                    }), // Probe IndexedDB periodically and re-enable network
                    e.asyncQueue.enqueueRetryable(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    $59fc9b849b320ded$var$__PRIVATE_logDebug("RemoteStore", "Retrying IndexedDB access");
                                    return [
                                        4,
                                        n()
                                    ];
                                case 1:
                                    _state.sent(), e.F_.delete(1 /* OfflineCause.IndexedDbFailed */ );
                                    return [
                                        4,
                                        $59fc9b849b320ded$var$__PRIVATE_enableNetworkInternal(e)
                                    ];
                                case 2:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_disableNetworkUntilRecovery.apply(this, arguments);
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $59fc9b849b320ded$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch(function(n) {
        return $59fc9b849b320ded$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t);
    });
}
function $59fc9b849b320ded$var$__PRIVATE_fillWritePipeline(e) {
    return $59fc9b849b320ded$var$___PRIVATE_fillWritePipeline.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_fillWritePipeline() {
    $59fc9b849b320ded$var$___PRIVATE_fillWritePipeline = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        var t, n, r, _$e, e1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), n = $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(t);
                    r = t.C_.length > 0 ? t.C_[t.C_.length - 1].batchId : -1;
                    _state.label = 1;
                case 1:
                    if (!$59fc9b849b320ded$var$__PRIVATE_canAddToWritePipeline(t)) return [
                        3,
                        7
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r)
                    ];
                case 3:
                    _$e = _state.sent();
                    if (null === _$e) {
                        0 === t.C_.length && n.e_();
                        return [
                            3,
                            7
                        ];
                    }
                    r = _$e.batchId, $59fc9b849b320ded$var$__PRIVATE_addToWritePipeline(t, _$e);
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_disableNetworkUntilRecovery(t, e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        3,
                        1
                    ];
                case 7:
                    $59fc9b849b320ded$var$__PRIVATE_shouldStartWriteStream(t) && $59fc9b849b320ded$var$__PRIVATE_startWriteStream(t);
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_fillWritePipeline.apply(this, arguments);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $59fc9b849b320ded$var$__PRIVATE_canAddToWritePipeline(e) {
    return $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(e) && e.C_.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $59fc9b849b320ded$var$__PRIVATE_addToWritePipeline(e, t) {
    e.C_.push(t);
    var n = $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e);
    n.Yo() && n.I_ && n.d_(t.mutations);
}
function $59fc9b849b320ded$var$__PRIVATE_shouldStartWriteStream(e) {
    return $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(e) && !$59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e).Jo() && e.C_.length > 0;
}
function $59fc9b849b320ded$var$__PRIVATE_startWriteStream(e) {
    $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e).start();
}
function $59fc9b849b320ded$var$__PRIVATE_onWriteStreamOpen(e) {
    return $59fc9b849b320ded$var$___PRIVATE_onWriteStreamOpen.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_onWriteStreamOpen() {
    $59fc9b849b320ded$var$___PRIVATE_onWriteStreamOpen = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        return (0, $7UAGh.__generator)(this, function(_state) {
            $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e).A_();
            return [
                2
            ];
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_onWriteStreamOpen.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_onWriteHandshakeComplete(e) {
    return $59fc9b849b320ded$var$___PRIVATE_onWriteHandshakeComplete.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_onWriteHandshakeComplete() {
    $59fc9b849b320ded$var$___PRIVATE_onWriteHandshakeComplete = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        var t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, n;
        return (0, $7UAGh.__generator)(this, function(_state) {
            t = $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e);
            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                // Send the write pipeline now that the stream is established.
                for(_iterator = e.C_[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    n = _step.value;
                    t.d_(n.mutations);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                2
            ];
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_onWriteHandshakeComplete.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_onMutationResult(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_onMutationResult.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_onMutationResult() {
    $59fc9b849b320ded$var$___PRIVATE_onMutationResult = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, i;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = e.C_.shift(), i = $59fc9b849b320ded$var$MutationBatchResult.from(r, t, n);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_executeWithRecovery(e, function() {
                            return e.remoteSyncer.applySuccessfulWrite(i);
                        })
                    ];
                case 1:
                    _state.sent();
                    // It's possible that with the completion of this mutation another
                    // slot has freed up.
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_fillWritePipeline(e)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_onMutationResult.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_onWriteStreamClose(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_onWriteStreamClose.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_onWriteStreamClose() {
    $59fc9b849b320ded$var$___PRIVATE_onWriteStreamClose = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var _tmp;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = // If the write stream closed after the write handshake completes, a write
                    // operation failed and we fail the pending operation.
                    t && $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e).I_;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    // This error affects the actual write.
                    return [
                        4,
                        (function() {
                            var ___PRIVATE_handleWriteError = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
                                var n;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!function __PRIVATE_isPermanentWriteError(e) {
                                                return $59fc9b849b320ded$var$__PRIVATE_isPermanentError(e) && e !== $59fc9b849b320ded$var$D.ABORTED;
                                            }(t.code)) return [
                                                3,
                                                3
                                            ];
                                            n = e.C_.shift();
                                            // In this case it's also unlikely that the server itself is melting
                                            // down -- this was just a bad request so inhibit backoff on the next
                                            // restart.
                                            $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e).Xo();
                                            return [
                                                4,
                                                $59fc9b849b320ded$var$__PRIVATE_executeWithRecovery(e, function() {
                                                    return e.remoteSyncer.rejectFailedWrite(n.batchId, t);
                                                })
                                            ];
                                        case 1:
                                            _state.sent();
                                            // It's possible that with the completion of this mutation
                                            // another slot has freed up.
                                            return [
                                                4,
                                                $59fc9b849b320ded$var$__PRIVATE_fillWritePipeline(e)
                                            ];
                                        case 2:
                                            _state.sent();
                                            _state.label = 3;
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_handleWriteError(e, t) {
                                return ___PRIVATE_handleWriteError.apply(this, arguments);
                            }
                            return __PRIVATE_handleWriteError;
                        })()(e, t)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp, // The write stream might have been started by refilling the write
                    // pipeline for failed writes
                    $59fc9b849b320ded$var$__PRIVATE_shouldStartWriteStream(e) && $59fc9b849b320ded$var$__PRIVATE_startWriteStream(e);
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_onWriteStreamClose.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_remoteStoreHandleCredentialChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_remoteStoreHandleCredentialChange() {
    $59fc9b849b320ded$var$___PRIVATE_remoteStoreHandleCredentialChange = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    n.asyncQueue.verifyOperationInProgress(), $59fc9b849b320ded$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore received new credentials");
                    r = $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(n);
                    // Tear down and re-create our network streams. This will ensure we get a
                    // fresh auth token for the new user and re-fill the write pipeline with
                    // new mutations from the LocalStore (since mutations are per-user).
                    n.F_.add(3 /* OfflineCause.CredentialChange */ );
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_disableNetworkInternal(n)
                    ];
                case 1:
                    _state.sent(), r && // Don't set the network status to Unknown if we are offline.
                    n.O_.set("Unknown" /* OnlineState.Unknown */ );
                    return [
                        4,
                        n.remoteSyncer.handleCredentialChange(t)
                    ];
                case 2:
                    _state.sent(), n.F_.delete(3 /* OfflineCause.CredentialChange */ );
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_enableNetworkInternal(n)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_remoteStoreHandleCredentialChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_remoteStoreApplyPrimaryState.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_remoteStoreApplyPrimaryState() {
    $59fc9b849b320ded$var$___PRIVATE_remoteStoreApplyPrimaryState = /**
 * Toggles the network state when the client gains or loses its primary lease.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, _tmp, _tmp1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    if (!t) return [
                        3,
                        2
                    ];
                    n.F_.delete(2 /* OfflineCause.IsSecondary */ );
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_enableNetworkInternal(n)
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp1 = t;
                    if (_tmp1) return [
                        3,
                        4
                    ];
                    n.F_.add(2 /* OfflineCause.IsSecondary */ );
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_disableNetworkInternal(n)
                    ];
                case 3:
                    _tmp1 = (_state.sent(), n.O_.set("Unknown" /* OnlineState.Unknown */ ));
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_remoteStoreApplyPrimaryState.apply(this, arguments);
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $59fc9b849b320ded$var$__PRIVATE_ensureWatchStream(e) {
    return e.B_ || // Create stream (but note that it is not started yet).
    (e.B_ = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
        return r.V_(), new $59fc9b849b320ded$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Io: $59fc9b849b320ded$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        Eo: $59fc9b849b320ded$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        c_: $59fc9b849b320ded$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.M_.push(function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(t) {
            var _tmp;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!t) return [
                            3,
                            1
                        ];
                        _tmp = (e.B_.Xo(), $59fc9b849b320ded$var$__PRIVATE_shouldStartWatchStream(e) ? $59fc9b849b320ded$var$__PRIVATE_startWatchStream(e) : e.O_.set("Unknown" /* OnlineState.Unknown */ ));
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            e.B_.stop()
                        ];
                    case 2:
                        _tmp = (_state.sent(), $59fc9b849b320ded$var$__PRIVATE_cleanUpWatchStreamState(e));
                        _state.label = 3;
                    case 3:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        });
        return function(t) {
            return _ref.apply(this, arguments);
        };
    }())), e.B_;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $59fc9b849b320ded$var$__PRIVATE_ensureWriteStream(e) {
    return e.L_ || // Create stream (but note that it is not started yet).
    (e.L_ = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
        return r.V_(), new $59fc9b849b320ded$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Io: $59fc9b849b320ded$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        Eo: $59fc9b849b320ded$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        E_: $59fc9b849b320ded$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        T_: $59fc9b849b320ded$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.M_.push(function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(t) {
            var _tmp;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!t) return [
                            3,
                            2
                        ];
                        e.L_.Xo();
                        // This will start the write stream if necessary.
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_fillWritePipeline(e)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            e.L_.stop()
                        ];
                    case 3:
                        _tmp = (_state.sent(), e.C_.length > 0 && ($59fc9b849b320ded$var$__PRIVATE_logDebug("RemoteStore", "Stopping write stream with ".concat(e.C_.length, " pending writes")), e.C_ = []));
                        _state.label = 4;
                    case 4:
                        _tmp;
                        return [
                            2
                        ];
                }
            });
        });
        return function(t) {
            return _ref.apply(this, arguments);
        };
    }())), e.L_;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ var $59fc9b849b320ded$var$DelayedOperation = /*#__PURE__*/ function() {
    "use strict";
    function DelayedOperation(e, t, n, r, i) {
        (0, $978gY._)(this, DelayedOperation);
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $59fc9b849b320ded$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch(function(e) {});
    }
    (0, $kry2a._)(DelayedOperation, [
        {
            key: "promise",
            get: function get() {
                return this.deferred.promise;
            }
        },
        {
            /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ key: "start",
            value: function start(e) {
                var _this = this;
                this.timerHandle = setTimeout(function() {
                    return _this.handleDelayElapsed();
                }, e);
            }
        },
        {
            /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ key: "skipDelay",
            value: function skipDelay() {
                return this.handleDelayElapsed();
            }
        },
        {
            /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ key: "cancel",
            value: function cancel(e) {
                null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
            }
        },
        {
            key: "handleDelayElapsed",
            value: function handleDelayElapsed() {
                var _this = this;
                this.asyncQueue.enqueueAndForget(function() {
                    return null !== _this.timerHandle ? (_this.clearTimeout(), _this.op().then(function(e) {
                        return _this.deferred.resolve(e);
                    })) : Promise.resolve();
                });
            }
        },
        {
            key: "clearTimeout",
            value: function clearTimeout1() {
                null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
            }
        }
    ], [
        {
            key: "createAndSchedule",
            value: /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ function createAndSchedule(e, t, n, r, i) {
                var s = Date.now() + n, o = new DelayedOperation(e, t, s, r, i);
                return o.start(n), o;
            }
        }
    ]);
    return DelayedOperation;
}();
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $59fc9b849b320ded$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($59fc9b849b320ded$var$__PRIVATE_logError("AsyncQueue", "".concat(t, ": ").concat(e)), $59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNAVAILABLE, "".concat(t, ": ").concat(e));
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ var $59fc9b849b320ded$var$DocumentSet = /*#__PURE__*/ function() {
    "use strict";
    function DocumentSet(e) {
        (0, $978gY._)(this, DocumentSet);
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? function(t, n) {
            return e(t, n) || $59fc9b849b320ded$export$afc2e57c475b7810.comparator(t.key, n.key);
        } : function(e, t) {
            return $59fc9b849b320ded$export$afc2e57c475b7810.comparator(e.key, t.key);
        }, this.keyedMap = $59fc9b849b320ded$var$documentMap(), this.sortedSet = new $59fc9b849b320ded$var$SortedMap(this.comparator);
    }
    (0, $kry2a._)(DocumentSet, [
        {
            key: "has",
            value: function has(e) {
                return null != this.keyedMap.get(e);
            }
        },
        {
            key: "get",
            value: function get(e) {
                return this.keyedMap.get(e);
            }
        },
        {
            key: "first",
            value: function first() {
                return this.sortedSet.minKey();
            }
        },
        {
            key: "last",
            value: function last() {
                return this.sortedSet.maxKey();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.sortedSet.isEmpty();
            }
        },
        {
            /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ key: "indexOf",
            value: function indexOf(e) {
                var t = this.keyedMap.get(e);
                return t ? this.sortedSet.indexOf(t) : -1;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.sortedSet.size;
            }
        },
        {
            /** Iterates documents in order defined by "comparator" */ key: "forEach",
            value: function forEach(e) {
                this.sortedSet.inorderTraversal(function(t, n) {
                    return e(t), !1;
                });
            }
        },
        {
            /** Inserts or updates a document with the same key */ key: "add",
            value: function add(e) {
                // First remove the element if we have it.
                var t = this.delete(e.key);
                return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
            }
        },
        {
            /** Deletes a document with a given key */ key: "delete",
            value: function _delete(e) {
                var t = this.get(e);
                return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(e instanceof DocumentSet)) return !1;
                if (this.size !== e.size) return !1;
                var t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
                for(; t.hasNext();){
                    var _$e = t.getNext().key, r = n.getNext().key;
                    if (!_$e.isEqual(r)) return !1;
                }
                return !0;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var e = [];
                return this.forEach(function(t) {
                    e.push(t.toString());
                }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
            }
        },
        {
            key: "copy",
            value: function copy(e, t) {
                var n = new DocumentSet;
                return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
            }
        }
    ], [
        {
            key: "emptySet",
            value: /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ function emptySet(e) {
                return new DocumentSet(e.comparator);
            }
        }
    ]);
    return DocumentSet;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ var $59fc9b849b320ded$var$__PRIVATE_DocumentChangeSet = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_DocumentChangeSet() {
        (0, $978gY._)(this, __PRIVATE_DocumentChangeSet);
        this.k_ = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
    }
    (0, $kry2a._)(__PRIVATE_DocumentChangeSet, [
        {
            key: "track",
            value: function track(e) {
                var t = e.doc.key, n = this.k_.get(t);
                n ? // Merge the new change with the existing change.
                0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.k_ = this.k_.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.k_ = this.k_.insert(t, {
                    type: n.type,
                    doc: e.doc
                }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.k_ = this.k_.insert(t, {
                    type: 2 /* ChangeType.Modified */ ,
                    doc: e.doc
                }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.k_ = this.k_.insert(t, {
                    type: 0 /* ChangeType.Added */ ,
                    doc: e.doc
                }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.k_ = this.k_.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.k_ = this.k_.insert(t, {
                    type: 1 /* ChangeType.Removed */ ,
                    doc: n.doc
                }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.k_ = this.k_.insert(t, {
                    type: 2 /* ChangeType.Modified */ ,
                    doc: e.doc
                }) : // This includes these cases, which don't make sense:
                // Added->Added
                // Removed->Removed
                // Modified->Added
                // Removed->Modified
                // Metadata->Added
                // Removed->Metadata
                $59fc9b849b320ded$var$fail() : this.k_ = this.k_.insert(t, e);
            }
        },
        {
            key: "q_",
            value: function q_() {
                var e = [];
                return this.k_.inorderTraversal(function(t, n) {
                    e.push(n);
                }), e;
            }
        }
    ]);
    return __PRIVATE_DocumentChangeSet;
}();
var $59fc9b849b320ded$var$ViewSnapshot = /*#__PURE__*/ function() {
    "use strict";
    function ViewSnapshot(e, t, n, r, i, s, o, _, a) {
        (0, $978gY._)(this, ViewSnapshot);
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = o, this.excludesMetadataChanges = _, this.hasCachedResults = a;
    }
    (0, $kry2a._)(ViewSnapshot, [
        {
            key: "hasPendingWrites",
            get: function get() {
                return !this.mutatedKeys.isEmpty();
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $59fc9b849b320ded$var$__PRIVATE_queryEquals(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
                var t = this.docChanges, n = e.docChanges;
                if (t.length !== n.length) return !1;
                for(var _$e = 0; _$e < t.length; _$e++)if (t[_$e].type !== n[_$e].type || !t[_$e].doc.isEqual(n[_$e].doc)) return !1;
                return !0;
            }
        }
    ], [
        {
            key: "fromInitialDocuments",
            value: /** Returns a view snapshot as if all documents in the snapshot were added. */ function fromInitialDocuments(e, t, n, r, i) {
                var s = [];
                return t.forEach(function(e) {
                    s.push({
                        type: 0 /* ChangeType.Added */ ,
                        doc: e
                    });
                }), new ViewSnapshot(e, t, $59fc9b849b320ded$var$DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
            }
        }
    ]);
    return ViewSnapshot;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ var $59fc9b849b320ded$var$__PRIVATE_QueryListenersInfo = function __PRIVATE_QueryListenersInfo() {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_QueryListenersInfo);
    this.Q_ = void 0, this.listeners = [];
};
var $59fc9b849b320ded$var$__PRIVATE_EventManagerImpl = function __PRIVATE_EventManagerImpl() {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_EventManagerImpl);
    this.queries = new $59fc9b849b320ded$var$ObjectMap(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_canonifyQuery(e);
    }, $59fc9b849b320ded$var$__PRIVATE_queryEquals), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.K_ = new Set;
};
function $59fc9b849b320ded$var$__PRIVATE_eventManagerListen(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_eventManagerListen.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_eventManagerListen() {
    $59fc9b849b320ded$var$___PRIVATE_eventManagerListen = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r, i, s, e1, n1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = t.query;
                    i = !1, s = n.queries.get(r);
                    if (!(s || (i = !0, s = new $59fc9b849b320ded$var$__PRIVATE_QueryListenersInfo), i)) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        n.onListen(r)
                    ];
                case 2:
                    s.Q_ = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    n1 = $59fc9b849b320ded$var$__PRIVATE_wrapInUserErrorIfRecoverable(e1, "Initialization of query '".concat($59fc9b849b320ded$var$__PRIVATE_stringifyQuery(t.query), "' failed"));
                    return [
                        2,
                        void t.onError(n1)
                    ];
                case 4:
                    if (n.queries.set(r, s), s.listeners.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
                    t.U_(n.onlineState), s.Q_) t.W_(s.Q_) && $59fc9b849b320ded$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_eventManagerListen.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_eventManagerUnlisten(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_eventManagerUnlisten.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_eventManagerUnlisten() {
    $59fc9b849b320ded$var$___PRIVATE_eventManagerUnlisten = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r, i, s, _$e;
        return (0, $7UAGh.__generator)(this, function(_state) {
            n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = t.query;
            i = !1;
            s = n.queries.get(r);
            if (s) {
                _$e = s.listeners.indexOf(t);
                _$e >= 0 && (s.listeners.splice(_$e, 1), i = 0 === s.listeners.length);
            }
            if (i) return [
                2,
                (n.queries.delete(r), n.onUnlisten(r))
            ];
            return [
                2
            ];
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_eventManagerUnlisten.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    var r = !1;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            var _$t = _$e.query, i = n.queries.get(_$t);
            if (i) {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = i.listeners[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t1 = _step1.value;
                        _$t1.W_(_$e) && (r = !0);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                i.Q_ = _$e;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    r && $59fc9b849b320ded$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $59fc9b849b320ded$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (i) try {
        for(var _iterator = i.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$e = _step.value;
            _$e.onError(n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
// Call all global snapshot listeners that have been set.
function $59fc9b849b320ded$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.K_.forEach(function(e) {
        e.next();
    });
}
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ var $59fc9b849b320ded$var$__PRIVATE_QueryListener = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_QueryListener(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_QueryListener);
        this.query = e, this.G_ = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.z_ = !1, this.j_ = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    (0, $kry2a._)(__PRIVATE_QueryListener, [
        {
            /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ key: "W_",
            value: function W_(e) {
                if (!this.options.includeMetadataChanges) {
                    // Remove the metadata only changes.
                    var t = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e.docChanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var n = _step.value;
                            3 /* ChangeType.Metadata */  !== n.type && t.push(n);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    e = new $59fc9b849b320ded$var$ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
                }
                var t1 = !1;
                return this.z_ ? this.H_(e) && (this.G_.next(e), t1 = !0) : this.J_(e, this.onlineState) && (this.Y_(e), t1 = !0), this.j_ = e, t1;
            }
        },
        {
            key: "onError",
            value: function onError(e) {
                this.G_.error(e);
            }
        },
        {
            /** Returns whether a snapshot was raised. */ key: "U_",
            value: function U_(e) {
                this.onlineState = e;
                var t = !1;
                return this.j_ && !this.z_ && this.J_(this.j_, e) && (this.Y_(this.j_), t = !0), t;
            }
        },
        {
            key: "J_",
            value: function J_(e, t) {
                // Always raise the first event when we're synced
                if (!e.fromCache) return !0;
                // NOTE: We consider OnlineState.Unknown as online (it should become Offline
                // or Online if we wait long enough).
                var n = "Offline" /* OnlineState.Offline */  !== t;
                // Don't raise the event if we're online, aren't synced yet (checked
                // above) and are waiting for a sync.
                return (!this.options.Z_ || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
            // Raise data from cache if we have any documents, have cached results before,
            // or we are offline.
            }
        },
        {
            key: "H_",
            value: function H_(e) {
                // We don't need to handle includeDocumentMetadataChanges here because
                // the Metadata only changes have already been stripped out if needed.
                // At this point the only changes we will see are the ones we should
                // propagate.
                if (e.docChanges.length > 0) return !0;
                var t = this.j_ && this.j_.hasPendingWrites !== e.hasPendingWrites;
                return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
            // Generally we should have hit one of the cases above, but it's possible
            // to get here if there were only metadata docChanges and they got
            // stripped out.
            }
        },
        {
            key: "Y_",
            value: function Y_(e) {
                e = $59fc9b849b320ded$var$ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.z_ = !0, this.G_.next(e);
            }
        }
    ]);
    return __PRIVATE_QueryListener;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ var $59fc9b849b320ded$var$__PRIVATE_SizedBundleElement = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SizedBundleElement(e, // How many bytes this element takes to store in the bundle.
    t) {
        (0, $978gY._)(this, __PRIVATE_SizedBundleElement);
        this.X_ = e, this.byteLength = t;
    }
    (0, $kry2a._)(__PRIVATE_SizedBundleElement, [
        {
            key: "ea",
            value: function ea() {
                return "metadata" in this.X_;
            }
        }
    ]);
    return __PRIVATE_SizedBundleElement;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ var $59fc9b849b320ded$var$__PRIVATE_BundleConverterImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleConverterImpl(e) {
        (0, $978gY._)(this, __PRIVATE_BundleConverterImpl);
        this.serializer = e;
    }
    (0, $kry2a._)(__PRIVATE_BundleConverterImpl, [
        {
            key: "Is",
            value: function Is(e) {
                return $59fc9b849b320ded$var$fromName(this.serializer, e);
            }
        },
        {
            /**
     * Converts a BundleDocument to a MutableDocument.
     */ key: "ds",
            value: function ds(e) {
                return e.metadata.exists ? $59fc9b849b320ded$var$__PRIVATE_fromDocument(this.serializer, e.document, !1) : $59fc9b849b320ded$var$MutableDocument.newNoDocument(this.Is(e.metadata.name), this.Ts(e.metadata.readTime));
            }
        },
        {
            key: "Ts",
            value: function Ts(e) {
                return $59fc9b849b320ded$var$__PRIVATE_fromVersion(e);
            }
        }
    ]);
    return __PRIVATE_BundleConverterImpl;
}();
/**
 * A class to process the elements from a bundle, load them into local
 * storage and provide progress update while loading.
 */ var $59fc9b849b320ded$var$__PRIVATE_BundleLoader = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleLoader(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_BundleLoader);
        this.ta = e, this.localStore = t, this.serializer = n, /** Batched queries to be saved into storage */ this.queries = [], /** Batched documents to be saved into storage */ this.documents = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $59fc9b849b320ded$var$__PRIVATE_bundleInitialProgress(e);
    }
    (0, $kry2a._)(__PRIVATE_BundleLoader, [
        {
            /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ key: "na",
            value: function na(e) {
                this.progress.bytesLoaded += e.byteLength;
                var t = this.progress.documentsLoaded;
                if (e.X_.namedQuery) this.queries.push(e.X_.namedQuery);
                else if (e.X_.documentMetadata) {
                    this.documents.push({
                        metadata: e.X_.documentMetadata
                    }), e.X_.documentMetadata.exists || ++t;
                    var n = $59fc9b849b320ded$var$ResourcePath.fromString(e.X_.documentMetadata.name);
                    this.collectionGroups.add(n.get(n.length - 2));
                } else e.X_.document && (this.documents[this.documents.length - 1].document = e.X_.document, ++t);
                return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, Object.assign({}, this.progress)) : null;
            }
        },
        {
            key: "ra",
            value: function ra(e) {
                var t = new Map, n = new $59fc9b849b320ded$var$__PRIVATE_BundleConverterImpl(this.serializer);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var r = _step.value;
                        if (r.metadata.queries) {
                            var _$e = n.Is(r.metadata.name);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = r.metadata.queries[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var n1 = _step1.value;
                                    var r1 = (t.get(n1) || $59fc9b849b320ded$var$__PRIVATE_documentKeySet()).add(_$e);
                                    t.set(n1, r1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return t;
            }
        },
        {
            key: "complete",
            value: /**
     * Update the progress to 'Success' and return the updated progress.
     */ function complete() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, e1, err;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $59fc9b849b320ded$var$__PRIVATE_localStoreApplyBundledDocuments(_this.localStore, new $59fc9b849b320ded$var$__PRIVATE_BundleConverterImpl(_this.serializer), _this.documents, _this.ta.id)
                                ];
                            case 1:
                                e = _state.sent(), t = _this.ra(_this.documents);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = _this.queries[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                e1 = _step.value;
                                return [
                                    4,
                                    $59fc9b849b320ded$var$__PRIVATE_localStoreSaveNamedQuery(_this.localStore, e1, t.get(e1.name))
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    (_this.progress.taskState = "Success", {
                                        progress: _this.progress,
                                        ia: _this.collectionGroups,
                                        sa: e
                                    })
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return __PRIVATE_BundleLoader;
}();
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $59fc9b849b320ded$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_AddedLimboDocument = function __PRIVATE_AddedLimboDocument(e) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_AddedLimboDocument);
    this.key = e;
};
var $59fc9b849b320ded$var$__PRIVATE_RemovedLimboDocument = function __PRIVATE_RemovedLimboDocument(e) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_RemovedLimboDocument);
    this.key = e;
};
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ var $59fc9b849b320ded$var$__PRIVATE_View = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_View(e, /** Documents included in the remote target */ t) {
        (0, $978gY._)(this, __PRIVATE_View);
        this.query = e, this.oa = t, this._a = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.aa = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), this.ua = $59fc9b849b320ded$var$__PRIVATE_newQueryComparator(e), this.ca = new $59fc9b849b320ded$var$DocumentSet(this.ua);
    }
    (0, $kry2a._)(__PRIVATE_View, [
        {
            key: "la",
            get: /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ function get() {
                return this.oa;
            }
        },
        {
            /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ key: "ha",
            value: function ha(e, t) {
                var _this = this;
                var n = t ? t.Pa : new $59fc9b849b320ded$var$__PRIVATE_DocumentChangeSet, r = t ? t.ca : this.ca;
                var i = t ? t.mutatedKeys : this.mutatedKeys, s = r, o = !1;
                // Track the last doc in a (full) limit. This is necessary, because some
                // update (a delete, or an update moving a doc past the old limit) might
                // mean there is some other document in the local cache that either should
                // come (1) between the old last limit doc and the new last document, in the
                // case of updates, or (2) after the new last document, in the case of
                // deletes. So we keep this doc at the old limit to compare the updates to.
                // Note that this should never get used in a refill (when previousChanges is
                // set), because there will only be adds -- no deletes or updates.
                var _ = "F" /* LimitType.First */  === this.query.limitType && r.size === this.query.limit ? r.last() : null, a = "L" /* LimitType.Last */  === this.query.limitType && r.size === this.query.limit ? r.first() : null;
                // Drop documents out to meet limit/limitToLast requirement.
                if (e.inorderTraversal(function(e, t) {
                    var u = r.get(e), c = $59fc9b849b320ded$var$__PRIVATE_queryMatches(_this.query, t) ? t : null, l = !!u && _this.mutatedKeys.has(u.key), h = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
                    // mutated during the lifetime of the view.
                    _this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
                    var P = !1;
                    // Calculate change
                    if (u && c) u.data.isEqual(c.data) ? l !== h && (n.track({
                        type: 3 /* ChangeType.Metadata */ ,
                        doc: c
                    }), P = !0) : _this.Ia(u, c) || (n.track({
                        type: 2 /* ChangeType.Modified */ ,
                        doc: c
                    }), P = !0, (_ && _this.ua(c, _) > 0 || a && _this.ua(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
                    // That means there may be some other doc in the local cache
                    // that should be included instead.
                    (o = !0));
                    else !u && c ? (n.track({
                        type: 0 /* ChangeType.Added */ ,
                        doc: c
                    }), P = !0) : u && !c && (n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: u
                    }), P = !0, (_ || a) && // A doc was removed from a full limit query. We'll need to
                    // requery from the local cache to see if we know about some other
                    // doc that should be in the results.
                    (o = !0));
                    P && (c ? (s = s.add(c), i = h ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
                }), null !== this.query.limit) for(; s.size > this.query.limit;){
                    var _$e = "F" /* LimitType.First */  === this.query.limitType ? s.last() : s.first();
                    s = s.delete(_$e.key), i = i.delete(_$e.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: _$e
                    });
                }
                return {
                    ca: s,
                    Pa: n,
                    es: o,
                    mutatedKeys: i
                };
            }
        },
        {
            key: "Ia",
            value: function Ia(e, t) {
                // We suppress the initial change event for documents that were modified as
                // part of a write acknowledgment (e.g. when the value of a server transform
                // is applied) as Watch will send us the same document again.
                // By suppressing the event, we only raise two user visible events (one with
                // `hasPendingWrites` and the final state of the document) instead of three
                // (one with `hasPendingWrites`, the modified document with
                // `hasPendingWrites` and the final state of the document).
                return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
            }
        },
        {
            /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param updateLimboDocuments - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
            key: "applyChanges",
            value: function applyChanges(e, t, n) {
                var _this = this;
                var r = this.ca;
                this.ca = e.ca, this.mutatedKeys = e.mutatedKeys;
                // Sort changes based on type and query comparator
                var i = e.Pa.q_();
                i.sort(function(e, t) {
                    return function __PRIVATE_compareChangeType(e, t) {
                        var order = function(e) {
                            switch(e){
                                case 0 /* ChangeType.Added */ :
                                    return 1;
                                case 2 /* ChangeType.Modified */ :
                                case 3 /* ChangeType.Metadata */ :
                                    // A metadata change is converted to a modified change at the public
                                    // api layer.  Since we sort by document key and then change type,
                                    // metadata and modified changes must be sorted equivalently.
                                    return 2;
                                case 1 /* ChangeType.Removed */ :
                                    return 0;
                                default:
                                    return $59fc9b849b320ded$var$fail();
                            }
                        };
                        return order(e) - order(t);
                    }(e.type, t.type) || _this.ua(e.doc, t.doc);
                }), this.da(n);
                var s = t ? this.Ta() : [], o = 0 === this.aa.size && this.current ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , _ = o !== this._a;
                if (this._a = o, 0 !== i.length || _) return {
                    snapshot: new $59fc9b849b320ded$var$ViewSnapshot(this.query, e.ca, r, i, e.mutatedKeys, 0 /* SyncState.Local */  === o, _, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
                    Ea: s
                };
                // no changes
                return {
                    Ea: s
                };
            }
        },
        {
            /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ key: "U_",
            value: function U_(e) {
                return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
                // to refresh our syncState and generate a ViewChange as appropriate. We
                // are guaranteed to get a new TargetChange that sets `current` back to
                // true once the client is back online.
                (this.current = !1, this.applyChanges({
                    ca: this.ca,
                    Pa: new $59fc9b849b320ded$var$__PRIVATE_DocumentChangeSet,
                    mutatedKeys: this.mutatedKeys,
                    es: !1
                }, /* updateLimboDocuments= */ !1)) : {
                    Ea: []
                };
            }
        },
        {
            /**
     * Returns whether the doc for the given key should be in limbo.
     */ key: "Aa",
            value: function Aa(e) {
                // If the remote end says it's part of this query, it's not in limbo.
                return !this.oa.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
                !!this.ca.has(e) && !this.ca.get(e).hasLocalMutations;
            }
        },
        {
            /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ key: "da",
            value: function da(e) {
                var _this = this;
                e && (e.addedDocuments.forEach(function(e) {
                    return _this.oa = _this.oa.add(e);
                }), e.modifiedDocuments.forEach(function(e) {}), e.removedDocuments.forEach(function(e) {
                    return _this.oa = _this.oa.delete(e);
                }), this.current = e.current);
            }
        },
        {
            key: "Ta",
            value: function Ta() {
                var _this = this;
                // We can only determine limbo documents when we're in-sync with the server.
                if (!this.current) return [];
                // TODO(klimt): Do this incrementally so that it's not quadratic when
                // updating many documents.
                var e = this.aa;
                this.aa = $59fc9b849b320ded$var$__PRIVATE_documentKeySet(), this.ca.forEach(function(e) {
                    _this.Aa(e.key) && (_this.aa = _this.aa.add(e.key));
                });
                // Diff the new limbo docs with the old limbo docs.
                var t = [];
                return e.forEach(function(e) {
                    _this.aa.has(e) || t.push(new $59fc9b849b320ded$var$__PRIVATE_RemovedLimboDocument(e));
                }), this.aa.forEach(function(n) {
                    e.has(n) || t.push(new $59fc9b849b320ded$var$__PRIVATE_AddedLimboDocument(n));
                }), t;
            }
        },
        {
            /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
            key: "Ra",
            value: function Ra(e) {
                this.oa = e.Ps, this.aa = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                var t = this.ha(e.documents);
                return this.applyChanges(t, /*updateLimboDocuments=*/ !0);
            }
        },
        {
            /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
            key: "Va",
            value: function Va() {
                return $59fc9b849b320ded$var$ViewSnapshot.fromInitialDocuments(this.query, this.ca, this.mutatedKeys, 0 /* SyncState.Local */  === this._a, this.hasCachedResults);
            }
        }
    ]);
    return __PRIVATE_View;
}();
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ var $59fc9b849b320ded$var$__PRIVATE_QueryView = function __PRIVATE_QueryView(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n) {
    "use strict";
    (0, $978gY._)(this, __PRIVATE_QueryView);
    this.query = e, this.targetId = t, this.view = n;
};
/** Tracks a limbo resolution. */ var $59fc9b849b320ded$var$LimboResolution = function LimboResolution(e) {
    "use strict";
    (0, $978gY._)(this, LimboResolution);
    this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.ma = !1;
};
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ var $59fc9b849b320ded$var$__PRIVATE_SyncEngineImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SyncEngineImpl(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s) {
        (0, $978gY._)(this, __PRIVATE_SyncEngineImpl);
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.fa = {}, this.ga = new $59fc9b849b320ded$var$ObjectMap(function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_canonifyQuery(e);
        }, $59fc9b849b320ded$var$__PRIVATE_queryEquals), this.pa = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.ya = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.wa = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.Sa = new Map, this.ba = new $59fc9b849b320ded$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.Da = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.Ca = new Map, this.va = $59fc9b849b320ded$var$__PRIVATE_TargetIdGenerator.Ln(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.Fa = void 0;
    }
    (0, $kry2a._)(__PRIVATE_SyncEngineImpl, [
        {
            key: "isPrimaryClient",
            get: function get() {
                return !0 === this.Fa;
            }
        }
    ]);
    return __PRIVATE_SyncEngineImpl;
}();
function $59fc9b849b320ded$var$__PRIVATE_syncEngineListen(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineListen.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineListen() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineListen = /**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r, i, s, _$e, s1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_ensureWatchCallbacks(e);
                    s = n.ga.get(t);
                    if (!s) return [
                        3,
                        1
                    ];
                    // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
                    // already exists when EventManager calls us for the first time. This
                    // happens when the primary tab is already listening to this query on
                    // behalf of another tab and the user of the primary also starts listening
                    // to the query. EventManager will not have an assigned target ID in this
                    // case and calls `listen` to obtain this ID.
                    r = s.targetId, n.sharedClientState.addLocalQueryTarget(r), i = s.view.Va();
                    return [
                        3,
                        4
                    ];
                case 1:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreAllocateTarget(n.localStore, $59fc9b849b320ded$var$__PRIVATE_queryToTarget(t))
                    ];
                case 2:
                    _$e = _state.sent(), s1 = n.sharedClientState.addLocalQueryTarget(_$e.targetId);
                    r = _$e.targetId;
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_initializeViewAndComputeSnapshot(n, t, r, "current" === s1, _$e.resumeToken)
                    ];
                case 3:
                    i = _state.sent(), n.isPrimaryClient && $59fc9b849b320ded$var$__PRIVATE_remoteStoreListen(n.remoteStore, _$e);
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        i
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineListen.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    return $59fc9b849b320ded$var$___PRIVATE_initializeViewAndComputeSnapshot.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_initializeViewAndComputeSnapshot() {
    $59fc9b849b320ded$var$___PRIVATE_initializeViewAndComputeSnapshot = /**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n, r, i) {
        var s, o, _, a, u, c;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
                    // targets based on view changes. This allows us to only depend on Limbo
                    // changes when user code includes queries.
                    e.Ma = function(t, n, r) {
                        return (function() {
                            var ___PRIVATE_applyDocChanges = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n, r) {
                                var _$i, _tmp, s, o;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _$i = t.view.ha(n);
                                            _tmp = _$i.es;
                                            if (!_tmp) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                $59fc9b849b320ded$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(function(param) {
                                                    var _$e = param.documents;
                                                    return t.view.ha(_$e, _$i);
                                                })
                                            ];
                                        case 1:
                                            _tmp = // The query has a limit and some docs were removed, so we need
                                            // to re-run the query against the local store to make sure we
                                            // didn't lose any good docs that had been past the limit.
                                            _$i = _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            _tmp;
                                            s = r && r.targetChanges.get(t.targetId), o = t.view.applyChanges(_$i, /* updateLimboDocuments= */ e.isPrimaryClient, s);
                                            return [
                                                2,
                                                ($59fc9b849b320ded$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, o.Ea), o.snapshot)
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_applyDocChanges(e, t, n, r) {
                                return ___PRIVATE_applyDocChanges.apply(this, arguments);
                            }
                            return __PRIVATE_applyDocChanges;
                        })()(e, t, n, r);
                    };
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    s = _state.sent(), o = new $59fc9b849b320ded$var$__PRIVATE_View(t, s.Ps), _ = o.ha(s.documents), a = $59fc9b849b320ded$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = o.applyChanges(_, /* updateLimboDocuments= */ e.isPrimaryClient, a);
                    $59fc9b849b320ded$var$__PRIVATE_updateTrackedLimbos(e, n, u.Ea);
                    c = new $59fc9b849b320ded$var$__PRIVATE_QueryView(t, n, o);
                    return [
                        2,
                        (e.ga.set(t, c), e.pa.has(n) ? e.pa.get(n).push(t) : e.pa.set(n, [
                            t
                        ]), u.snapshot)
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_initializeViewAndComputeSnapshot.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineUnlisten(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineUnlisten.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineUnlisten() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineUnlisten = /** Stops listening to the query. */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r, i, _tmp;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = n.ga.get(t), i = n.pa.get(r.targetId);
                    if (i.length > 1) return [
                        2,
                        (n.pa.set(r.targetId, i.filter(function(e) {
                            return !$59fc9b849b320ded$var$__PRIVATE_queryEquals(e, t);
                        })), void n.ga.delete(t))
                    ];
                    if (!n.isPrimaryClient) return [
                        3,
                        3
                    ];
                    // We need to remove the local query target first to allow us to verify
                    // whether any other client is still interested in this target.
                    n.sharedClientState.removeLocalQueryTarget(r.targetId);
                    _tmp = n.sharedClientState.isActiveQueryTarget(r.targetId);
                    if (_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreReleaseTarget(n.localStore, r.targetId, /*keepPersistedTargetData=*/ !1).then(function() {
                            n.sharedClientState.clearQueryState(r.targetId), $59fc9b849b320ded$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId), $59fc9b849b320ded$var$__PRIVATE_removeAndCleanupTarget(n, r.targetId);
                        }).catch($59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp;
                    return [
                        3,
                        5
                    ];
                case 3:
                    $59fc9b849b320ded$var$__PRIVATE_removeAndCleanupTarget(n, r.targetId);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreReleaseTarget(n.localStore, r.targetId, /*keepPersistedTargetData=*/ !0)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineUnlisten.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineWrite(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineWrite.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineWrite() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineWrite = /**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, _$e, e1, _$t;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = $59fc9b849b320ded$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreWriteLocally(e, t) {
                            var _$n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = $59fc9b849b320ded$export$d9bcbd5e1ff81430.now(), i = t.reduce(function(e, t) {
                                return e.add(t.key);
                            }, $59fc9b849b320ded$var$__PRIVATE_documentKeySet());
                            var s, o;
                            return _$n.persistence.runTransaction("Locally write mutations", "readwrite", function(e) {
                                // Figure out which keys do not have a remote version in the cache, this
                                // is needed to create the right overlay mutation: if no remote version
                                // presents, we do not need to create overlays as patch mutations.
                                // TODO(Overlay): Is there a better way to determine this? Using the
                                //  document version does not work because local mutations set them back
                                //  to 0.
                                var _ = $59fc9b849b320ded$var$__PRIVATE_mutableDocumentMap(), a = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
                                return _$n._s.getEntries(e, i).next(function(e) {
                                    _ = e, _.forEach(function(e, t) {
                                        t.isValidDocument() || (a = a.add(e));
                                    });
                                }).next(function() {
                                    return _$n.localDocuments.getOverlayedDocuments(e, _);
                                }).next(function(i) {
                                    s = i;
                                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                                    // we record the base state in a separate patch mutation. This is
                                    // later used to guarantee consistent values and prevents flicker
                                    // even if the backend sends us an update that already includes our
                                    // transform.
                                    var o = [];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$e = _step.value;
                                            var _$t = $59fc9b849b320ded$var$__PRIVATE_mutationExtractBaseValue(_$e, s.get(_$e.key).overlayedDocument);
                                            null != _$t && // NOTE: The base state should only be applied if there's some
                                            // existing document to override, so use a Precondition of
                                            // exists=true
                                            o.push(new $59fc9b849b320ded$var$__PRIVATE_PatchMutation(_$e.key, _$t, $59fc9b849b320ded$var$__PRIVATE_extractFieldMask(_$t.value.mapValue), $59fc9b849b320ded$var$Precondition.exists(!0)));
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    return _$n.mutationQueue.addMutationBatch(e, r, o, t);
                                }).next(function(t) {
                                    o = t;
                                    var r = t.applyToLocalDocumentSet(s, a);
                                    return _$n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                                });
                            }).then(function() {
                                return {
                                    batchId: o.batchId,
                                    changes: $59fc9b849b320ded$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                                };
                            });
                        }(r.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    r.sharedClientState.addPendingMutation(_$e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
                        var r = e.Da[e.currentUser.toKey()];
                        r || (r = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$var$__PRIVATE_primitiveComparator));
                        r = r.insert(t, n), e.Da[e.currentUser.toKey()] = r;
                    }(r, _$e.batchId, n);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, _$e.changes)
                    ];
                case 3:
                    _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_fillWritePipeline(r.remoteStore)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    e1 = _state.sent();
                    _$t = $59fc9b849b320ded$var$__PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to persist write");
                    n.reject(_$t);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineWrite.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyRemoteEvent.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyRemoteEvent() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyRemoteEvent = /**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, _$e, e1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // Update `receivedDocument` as appropriate for any limbo targets.
                    t.targetChanges.forEach(function(e, t) {
                        var r = n.Sa.get(t);
                        r && // Since this is a limbo resolution lookup, it's for a single document
                        // and it could be added, modified, or removed, but not a combination.
                        ($59fc9b849b320ded$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1), e.addedDocuments.size > 0 ? r.ma = !0 : e.modifiedDocuments.size > 0 ? $59fc9b849b320ded$var$__PRIVATE_hardAssert(r.ma) : e.removedDocuments.size > 0 && ($59fc9b849b320ded$var$__PRIVATE_hardAssert(r.ma), r.ma = !1));
                    });
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e, t)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyRemoteEvent.apply(this, arguments);
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        var _$e = [];
        r.ga.forEach(function(n, r) {
            var i = r.view.U_(t);
            i.snapshot && _$e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            var _$n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
            _$n.onlineState = t;
            var r = !1;
            _$n.queries.forEach(function(e, n) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = n.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        // Run global snapshot listeners if a consistent snapshot has been emitted.
                        _$e.U_(t) && (r = !0);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }), r && $59fc9b849b320ded$var$__PRIVATE_raiseSnapshotsInSyncEvent(_$n);
        }(r.eventManager, t), _$e.length && r.fa.c_(_$e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectListen.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectListen() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectListen = /**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, i, s, _$e, _$n, i1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    // PORTING NOTE: Multi-tab only.
                    r.sharedClientState.updateQueryState(t, "rejected", n);
                    i = r.Sa.get(t), s = i && i.key;
                    if (!s) return [
                        3,
                        2
                    ];
                    _$e = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
                    // TODO(b/217189216): This limbo document should ideally have a read time,
                    // so that it is picked up by any read-time based scans. The backend,
                    // however, does not send a read time for target removals.
                    _$e = _$e.insert(s, $59fc9b849b320ded$var$MutableDocument.newNoDocument(s, $59fc9b849b320ded$var$SnapshotVersion.min()));
                    _$n = $59fc9b849b320ded$var$__PRIVATE_documentKeySet().add(s), i1 = new $59fc9b849b320ded$var$RemoteEvent($59fc9b849b320ded$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$var$__PRIVATE_primitiveComparator), _$e, _$n);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i1)
                    ];
                case 1:
                    _state.sent(), // Since this query failed, we won't want to manually unlisten to it.
                    // We only remove it from bookkeeping after we successfully applied the
                    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
                    // this query when the RemoteStore restarts the Watch stream, which should
                    // re-trigger the target failure.
                    r.wa = r.wa.remove(s), r.Sa.delete(t), $59fc9b849b320ded$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(function() {
                            return $59fc9b849b320ded$var$__PRIVATE_removeAndCleanupTarget(r, t, n);
                        }).catch($59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectListen.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplySuccessfulWrite.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineApplySuccessfulWrite() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineApplySuccessfulWrite = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r, _$e, e1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught
                    // up), so we raise user callbacks first so that they consistently happen
                    // before listen events.
                    $59fc9b849b320ded$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $59fc9b849b320ded$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged");
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    e1 = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplySuccessfulWrite.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectFailedWrite.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectFailedWrite() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectFailedWrite = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, _$e, n1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreRejectBatch(e, t) {
                            var _$n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                            return _$n.persistence.runTransaction("Reject batch", "readwrite-primary", function(e) {
                                var r;
                                return _$n.mutationQueue.lookupMutationBatch(e, t).next(function(t) {
                                    return $59fc9b849b320ded$var$__PRIVATE_hardAssert(null !== t), r = t.keys(), _$n.mutationQueue.removeMutationBatch(e, t);
                                }).next(function() {
                                    return _$n.mutationQueue.performConsistencyCheck(e);
                                }).next(function() {
                                    return _$n.documentOverlayCache.removeOverlaysForBatchId(e, r, t);
                                }).next(function() {
                                    return _$n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r);
                                }).next(function() {
                                    return _$n.localDocuments.getDocuments(e, r);
                                });
                            });
                        }(r.localStore, t)
                    ];
                case 2:
                    _$e = _state.sent();
                    // The local store may or may not be able to apply the write result and
                    // raise events immediately (depending on whether the watcher is caught up),
                    // so we raise user callbacks first so that they consistently happen before
                    // listen events.
                    $59fc9b849b320ded$var$__PRIVATE_processUserCallback(r, t, n), $59fc9b849b320ded$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, _$e)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 4:
                    n1 = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n1)
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineRejectFailedWrite.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineRegisterPendingWritesCallback.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineRegisterPendingWritesCallback() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineRegisterPendingWritesCallback = /**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, _$e, r, e1, n1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    $59fc9b849b320ded$var$__PRIVATE_canUseNetwork(n.remoteStore) || $59fc9b849b320ded$var$__PRIVATE_logDebug("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
                            var _$t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                            return _$t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", function(e) {
                                return _$t.mutationQueue.getHighestUnacknowledgedBatchId(e);
                            });
                        }(n.localStore)
                    ];
                case 2:
                    _$e = _state.sent();
                    if (-1 === _$e) // Trigger the callback right away if there is no pending writes at the moment.
                    return [
                        2,
                        void t.resolve()
                    ];
                    r = n.Ca.get(_$e) || [];
                    r.push(t), n.Ca.set(_$e, r);
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    n1 = $59fc9b849b320ded$var$__PRIVATE_wrapInUserErrorIfRecoverable(e1, "Initialization of waitForPendingWrites() operation failed");
                    t.reject(n1);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineRegisterPendingWritesCallback.apply(this, arguments);
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $59fc9b849b320ded$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.Ca.get(t) || []).forEach(function(e) {
        e.resolve();
    }), e.Ca.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $59fc9b849b320ded$var$__PRIVATE_processUserCallback(e, t, n) {
    var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    var i = r.Da[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        var _$e = i.get(t);
        _$e && (n ? _$e.reject(n) : _$e.resolve(), i = i.remove(t)), r.Da[r.currentUser.toKey()] = i;
    }
}
function $59fc9b849b320ded$var$__PRIVATE_removeAndCleanupTarget(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    e.sharedClientState.removeLocalQueryTarget(t);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.pa.get(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            e.ga.delete(r), n && e.fa.xa(r, n);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (e.pa.delete(t), e.isPrimaryClient) e.ba.mr(t).forEach(function(t) {
        e.ba.containsKey(t) || // We removed the last reference for this key
        $59fc9b849b320ded$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $59fc9b849b320ded$var$__PRIVATE_removeLimboTarget(e, t) {
    e.ya.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    var n = e.wa.get(t);
    null !== n && ($59fc9b849b320ded$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.wa = e.wa.remove(t), e.Sa.delete(n), $59fc9b849b320ded$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $59fc9b849b320ded$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var r = _step.value;
            if (r instanceof $59fc9b849b320ded$var$__PRIVATE_AddedLimboDocument) e.ba.addReference(r.key, t), $59fc9b849b320ded$var$__PRIVATE_trackLimboChange(e, r);
            else if (r instanceof $59fc9b849b320ded$var$__PRIVATE_RemovedLimboDocument) {
                $59fc9b849b320ded$var$__PRIVATE_logDebug("SyncEngine", "Document no longer in limbo: " + r.key), e.ba.removeReference(r.key, t);
                e.ba.containsKey(r.key) || // We removed the last reference for this key
                $59fc9b849b320ded$var$__PRIVATE_removeLimboTarget(e, r.key);
            } else $59fc9b849b320ded$var$fail();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $59fc9b849b320ded$var$__PRIVATE_trackLimboChange(e, t) {
    var n = t.key, r = n.path.canonicalString();
    e.wa.get(n) || e.ya.has(r) || ($59fc9b849b320ded$var$__PRIVATE_logDebug("SyncEngine", "New document in limbo: " + n), e.ya.add(r), $59fc9b849b320ded$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $59fc9b849b320ded$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.ya.size > 0 && e.wa.size < e.maxConcurrentLimboResolutions;){
        var t = e.ya.values().next().value;
        e.ya.delete(t);
        var n = new $59fc9b849b320ded$export$afc2e57c475b7810($59fc9b849b320ded$var$ResourcePath.fromString(t)), r = e.va.next();
        e.Sa.set(r, new $59fc9b849b320ded$var$LimboResolution(n)), e.wa = e.wa.insert(n, r), $59fc9b849b320ded$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $59fc9b849b320ded$var$TargetData($59fc9b849b320ded$var$__PRIVATE_queryToTarget($59fc9b849b320ded$var$__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $59fc9b849b320ded$var$__PRIVATE_ListenSequence.ae));
    }
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, i, s, o, _tmp;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), i = [], s = [], o = [];
                    _tmp = r.ga.isEmpty();
                    if (_tmp) return [
                        3,
                        3
                    ];
                    r.ga.forEach(function(e, _) {
                        o.push(r.Ma(_, t, n).then(function(e) {
                            // Update views if there are actual changes.
                            if (// If there are changes, or we are handling a global snapshot, notify
                            // secondary clients to update query state.
                            (e || n) && r.isPrimaryClient && r.sharedClientState.updateQueryState(_.targetId, (null == e ? void 0 : e.fromCache) ? "not-current" : "current"), e) {
                                i.push(e);
                                var _$t = $59fc9b849b320ded$var$__PRIVATE_LocalViewChanges.$i(_.targetId, e);
                                s.push(_$t);
                            }
                        }));
                    });
                    return [
                        4,
                        Promise.all(o)
                    ];
                case 1:
                    _state.sent(), r.fa.c_(i);
                    return [
                        4,
                        (function() {
                            var ___PRIVATE_localStoreNotifyLocalViewChanges = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
                                var n, e1, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, _$e1, r, i;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", function(e) {
                                                    return $59fc9b849b320ded$var$PersistencePromise.forEach(t, function(t) {
                                                        return $59fc9b849b320ded$var$PersistencePromise.forEach(t.Qi, function(r) {
                                                            return n.persistence.referenceDelegate.addReference(e, t.targetId, r);
                                                        }).next(function() {
                                                            return $59fc9b849b320ded$var$PersistencePromise.forEach(t.Ki, function(r) {
                                                                return n.persistence.referenceDelegate.removeReference(e, t.targetId, r);
                                                            });
                                                        });
                                                    });
                                                })
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            e1 = _state.sent();
                                            if (!$59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e1)) throw e1;
                                            // If `notifyLocalViewChanges` fails, we did not advance the sequence
                                            // number for the documents that were included in this transaction.
                                            // This might trigger them to be deleted earlier than they otherwise
                                            // would have, but it should not invalidate the integrity of the data.
                                            $59fc9b849b320ded$var$__PRIVATE_logDebug("LocalStore", "Failed to update sequence numbers: " + e1);
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = t[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    _$e = _step.value;
                                                    _$t = _$e.targetId;
                                                    if (!_$e.fromCache) {
                                                        _$e1 = n.rs.get(_$t), r = _$e1.snapshotVersion, i = _$e1.withLastLimboFreeSnapshotVersion(r);
                                                        // Advance the last limbo free snapshot version
                                                        n.rs = n.rs.insert(_$t, i);
                                                    }
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
                                return ___PRIVATE_localStoreNotifyLocalViewChanges.apply(this, arguments);
                            }
                            return __PRIVATE_localStoreNotifyLocalViewChanges;
                        })()(r.localStore, s)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineHandleCredentialChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineHandleCredentialChange() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineHandleCredentialChange = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, _$e;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    if (!!n.currentUser.isEqual(t)) return [
                        3,
                        3
                    ];
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("SyncEngine", "User change. New user:", t.toKey());
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t)
                    ];
                case 1:
                    _$e = _state.sent();
                    n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
                    function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
                        e.Ca.forEach(function(e) {
                            e.forEach(function(e) {
                                e.reject(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.CANCELLED, t));
                            });
                        }), e.Ca.clear();
                    }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
                    n.sharedClientState.handleUserChange(t, _$e.removedBatchIds, _$e.addedBatchIds);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, _$e.cs)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineHandleCredentialChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = n.Sa.get(t);
    if (r && r.ma) return $59fc9b849b320ded$var$__PRIVATE_documentKeySet().add(r.key);
    {
        var _$e = $59fc9b849b320ded$var$__PRIVATE_documentKeySet();
        var r1 = n.pa.get(t);
        if (!r1) return _$e;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = r1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$t = _step.value;
                var r2 = n.ga.get(_$t);
                _$e = _$e.unionWith(r2.view.la);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return _$e;
    }
}
function $59fc9b849b320ded$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_synchronizeViewAndComputeSnapshot.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_synchronizeViewAndComputeSnapshot() {
    $59fc9b849b320ded$var$___PRIVATE_synchronizeViewAndComputeSnapshot = /**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r, i;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0)
                    ];
                case 1:
                    r = _state.sent(), i = t.view.Ra(r);
                    return [
                        2,
                        (n.isPrimaryClient && $59fc9b849b320ded$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.Ea), i)
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_synchronizeViewAndComputeSnapshot.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineSynchronizeWithChangedDocuments.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineSynchronizeWithChangedDocuments() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineSynchronizeWithChangedDocuments = /**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
    (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n;
        return (0, $7UAGh.__generator)(this, function(_state) {
            n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
            return [
                2,
                $59fc9b849b320ded$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then(function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
                })
            ];
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineSynchronizeWithChangedDocuments.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyBatchState.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyBatchState() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyBatchState = /** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
    (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n, r) {
        var i, s, _tmp, _tmp1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    return [
                        4,
                        function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
                            var _$n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), _$r = $59fc9b849b320ded$var$__PRIVATE_debugCast(_$n.mutationQueue);
                            return _$n.persistence.runTransaction("Lookup mutation documents", "readonly", function(e) {
                                return _$r.Fn(e, t).next(function(t) {
                                    return t ? _$n.localDocuments.getDocuments(e, t) : $59fc9b849b320ded$var$PersistencePromise.resolve(null);
                                });
                            });
                        }(i.localStore, t)
                    ];
                case 1:
                    s = _state.sent();
                    if (!(null !== s)) return [
                        3,
                        6
                    ];
                    if (!("pending" === n)) return [
                        3,
                        3
                    ];
                    // If we are the primary client, we need to send this write to the
                    // backend. Secondary clients will ignore these writes since their remote
                    // connection is disabled.
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_fillWritePipeline(i.remoteStore)
                    ];
                case 2:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp1 = "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
                    // other clients.
                    ($59fc9b849b320ded$var$__PRIVATE_processUserCallback(i, t, r || null), $59fc9b849b320ded$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
                        $59fc9b849b320ded$var$__PRIVATE_debugCast($59fc9b849b320ded$var$__PRIVATE_debugCast(e).mutationQueue).xn(t);
                    }(i.localStore, t)) : $59fc9b849b320ded$var$fail();
                    _state.label = 4;
                case 4:
                    _tmp1;
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = // A throttled tab may not have seen the mutation before it was completed
                    // and removed from the mutation queue, in which case we won't have cached
                    // the affected documents. In this case we can safely ignore the update
                    // since that means we didn't apply the mutation locally at all (if we
                    // had, we would have cached the affected documents), and so we will just
                    // see any resulting document changes via normal remote document updates
                    // as applicable.
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("SyncEngine", "Cannot apply mutation batch with id: " + t);
                    _state.label = 7;
                case 7:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyBatchState.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyPrimaryState.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyPrimaryState() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyPrimaryState = /** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
    (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, _$e, _$t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e1, _$e2, _$t1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    if (!($59fc9b849b320ded$var$__PRIVATE_ensureWatchCallbacks(n), $59fc9b849b320ded$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.Fa)) return [
                        3,
                        3
                    ];
                    _$e = n.sharedClientState.getAllActiveQueryTargets();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, _$e.toArray())
                    ];
                case 1:
                    _$t = _state.sent();
                    n.Fa = !0;
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0)
                    ];
                case 2:
                    _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = _$t[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            _$e1 = _step.value;
                            $59fc9b849b320ded$var$__PRIVATE_remoteStoreListen(n.remoteStore, _$e1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        3,
                        7
                    ];
                case 3:
                    if (!(!1 === t && !1 !== n.Fa)) return [
                        3,
                        7
                    ];
                    _$e2 = [];
                    _$t1 = Promise.resolve();
                    n.pa.forEach(function(r, i) {
                        n.sharedClientState.isLocalQueryTarget(i) ? _$e2.push(i) : _$t1 = _$t1.then(function() {
                            return $59fc9b849b320ded$var$__PRIVATE_removeAndCleanupTarget(n, i), $59fc9b849b320ded$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0);
                        }), $59fc9b849b320ded$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
                    });
                    return [
                        4,
                        _$t1
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, _$e2)
                    ];
                case 5:
                    _state.sent(), // PORTING NOTE: Multi-Tab only.
                    function __PRIVATE_resetLimboDocuments(e) {
                        var _$t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                        _$t.Sa.forEach(function(e, n) {
                            $59fc9b849b320ded$var$__PRIVATE_remoteStoreUnlisten(_$t.remoteStore, n);
                        }), _$t.ba.gr(), _$t.Sa = new Map, _$t.wa = new $59fc9b849b320ded$var$SortedMap($59fc9b849b320ded$export$afc2e57c475b7810.comparator);
                    }(n), n.Fa = !1;
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyPrimaryState.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots() {
    $59fc9b849b320ded$var$___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, i, s, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, n1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _$e1, _$t1, n2, err, n3, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), i = [], s = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        19,
                        20,
                        21
                    ]);
                    _iterator = t[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        18
                    ];
                    _$e = _step.value;
                    _$t = void 0;
                    n1 = r.pa.get(_$e);
                    if (!(n1 && 0 !== n1.length)) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $59fc9b849b320ded$var$__PRIVATE_queryToTarget(n1[0]))
                    ];
                case 3:
                    // For queries that have a local View, we fetch their current state
                    // from LocalStore (as the resume token and the snapshot version
                    // might have changed) and reconcile their views with the persisted
                    // state (the list of syncedDocuments may have gotten out of sync).
                    _$t = _state.sent();
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        9,
                        10,
                        11
                    ]);
                    _iterator1 = n1[Symbol.iterator]();
                    _state.label = 5;
                case 5:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        8
                    ];
                    _$e1 = _step1.value;
                    _$t1 = r.ga.get(_$e1);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, _$t1)
                    ];
                case 6:
                    n2 = _state.sent();
                    n2.snapshot && s.push(n2.snapshot);
                    _state.label = 7;
                case 7:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        5
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        11
                    ];
                case 10:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        3,
                        16
                    ];
                case 12:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, _$e)
                    ];
                case 13:
                    n3 = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n3)
                    ];
                case 14:
                    _$t = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $59fc9b849b320ded$var$__PRIVATE_synthesizeTargetToQuery(n3), _$e, /*current=*/ !1, _$t.resumeToken)
                    ];
                case 15:
                    _state.sent();
                    _state.label = 16;
                case 16:
                    i.push(_$t);
                    _state.label = 17;
                case 17:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 18:
                    return [
                        3,
                        21
                    ];
                case 19:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        21
                    ];
                case 20:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 21:
                    return [
                        2,
                        (r.fa.c_(s), i)
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_synchronizeQueryViewsAndRaiseSnapshots.apply(this, arguments);
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $59fc9b849b320ded$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $59fc9b849b320ded$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $59fc9b849b320ded$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $59fc9b849b320ded$var$__PRIVATE_debugCast($59fc9b849b320ded$var$__PRIVATE_debugCast(e).persistence).ki();
    }($59fc9b849b320ded$var$__PRIVATE_debugCast(e).localStore);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyTargetState.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyTargetState() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyTargetState = /** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
    (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n, r) {
        var i, s, _$e, _$r;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                    if (i.Fa) // If we receive a target state notification via WebStorage, we are
                    // either already secondary or another tab has taken the primary lease.
                    return [
                        2,
                        void $59fc9b849b320ded$var$__PRIVATE_logDebug("SyncEngine", "Ignoring unexpected query state notification.")
                    ];
                    s = i.pa.get(t);
                    if (!(s && s.length > 0)) return [
                        3,
                        7
                    ];
                    switch(n){
                        case "current":
                            return [
                                3,
                                1
                            ];
                        case "not-current":
                            return [
                                3,
                                1
                            ];
                        case "rejected":
                            return [
                                3,
                                4
                            ];
                    }
                    return [
                        3,
                        6
                    ];
                case 1:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $59fc9b849b320ded$var$__PRIVATE_queryCollectionGroup(s[0]))
                    ];
                case 2:
                    _$e = _state.sent(), _$r = $59fc9b849b320ded$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $59fc9b849b320ded$export$67460cdabfa21253.EMPTY_BYTE_STRING);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, _$e, _$r)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 4:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0)
                    ];
                case 5:
                    _state.sent(), $59fc9b849b320ded$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
                    return [
                        3,
                        7
                    ];
                case 6:
                    $59fc9b849b320ded$var$fail();
                    _state.label = 7;
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyTargetState.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyActiveTargetsChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyActiveTargetsChange() {
    $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyActiveTargetsChange = /** Adds or removes Watch targets for queries from different tabs. */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
        var r, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e, _$t, _$n, err, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _loop, _iterator1, _step1, err;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    r = $59fc9b849b320ded$var$__PRIVATE_ensureWatchCallbacks(e);
                    if (!r.Fa) return [
                        3,
                        18
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    _iterator = t[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    _$e = _step.value;
                    if (r.pa.has(_$e)) {
                        // A target might have been added in a previous attempt
                        $59fc9b849b320ded$var$__PRIVATE_logDebug("SyncEngine", "Adding an already active target " + _$e);
                        return [
                            3,
                            6
                        ];
                    }
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, _$e)
                    ];
                case 3:
                    _$t = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_localStoreAllocateTarget(r.localStore, _$t)
                    ];
                case 4:
                    _$n = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $59fc9b849b320ded$var$__PRIVATE_synthesizeTargetToQuery(_$t), _$n.targetId, /*current=*/ !1, _$n.resumeToken)
                    ];
                case 5:
                    _state.sent(), $59fc9b849b320ded$var$__PRIVATE_remoteStoreListen(r.remoteStore, _$n);
                    _state.label = 6;
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 11;
                case 11:
                    _state.trys.push([
                        11,
                        16,
                        17,
                        18
                    ]);
                    _loop = function() {
                        var _$e, _tmp;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _$e = _step1.value;
                                    _tmp = // Check that the target is still active since the target might have been
                                    // removed if it has been rejected by the backend.
                                    r.pa.has(_$e);
                                    if (!_tmp) return [
                                        3,
                                        2
                                    ];
                                    // Release queries that are still active.
                                    return [
                                        4,
                                        $59fc9b849b320ded$var$__PRIVATE_localStoreReleaseTarget(r.localStore, _$e, /* keepPersistedTargetData */ !1).then(function() {
                                            $59fc9b849b320ded$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, _$e), $59fc9b849b320ded$var$__PRIVATE_removeAndCleanupTarget(r, _$e);
                                        }).catch($59fc9b849b320ded$var$__PRIVATE_ignoreIfPrimaryLeaseLoss)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    _state.label = 2;
                                case 2:
                                    _tmp;
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator1 = n[Symbol.iterator]();
                    _state.label = 12;
                case 12:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        15
                    ];
                    return [
                        5,
                        (0, $7UAGh.__values)(_loop())
                    ];
                case 13:
                    _state.sent();
                    _state.label = 14;
                case 14:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        12
                    ];
                case 15:
                    return [
                        3,
                        18
                    ];
                case 16:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        18
                    ];
                case 17:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 18:
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_syncEngineApplyActiveTargetsChange.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_ensureWatchCallbacks(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $59fc9b849b320ded$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $59fc9b849b320ded$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.fa.c_ = $59fc9b849b320ded$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.fa.xa = $59fc9b849b320ded$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $59fc9b849b320ded$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $59fc9b849b320ded$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $59fc9b849b320ded$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $59fc9b849b320ded$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    var r = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
    (function() {
        var ___PRIVATE_loadBundleImpl = // eslint-disable-next-line @typescript-eslint/no-floating-promises
        /** Loads a bundle and returns the list of affected collection groups. */ (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
            var r, i, s, _$e, o, e1;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            14,
                            ,
                            15
                        ]);
                        return [
                            4,
                            t.getMetadata()
                        ];
                    case 1:
                        r = _state.sent();
                        return [
                            4,
                            function __PRIVATE_localStoreHasNewerBundle(e, t) {
                                var _$n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = $59fc9b849b320ded$var$__PRIVATE_fromVersion(t.createTime);
                                return _$n.persistence.runTransaction("hasNewerBundle", "readonly", function(e) {
                                    return _$n.Ur.getBundleMetadata(e, t.id);
                                }).then(function(e) {
                                    return !!e && e.createTime.compareTo(r) >= 0;
                                });
                            }(e.localStore, r)
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            t.close()
                        ];
                    case 3:
                        return [
                            2,
                            (_state.sent(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                                return {
                                    taskState: "Success",
                                    documentsLoaded: e.totalDocuments,
                                    bytesLoaded: e.totalBytes,
                                    totalDocuments: e.totalDocuments,
                                    totalBytes: e.totalBytes
                                };
                            }(r)), Promise.resolve(new Set))
                        ];
                    case 4:
                        n._updateProgress($59fc9b849b320ded$var$__PRIVATE_bundleInitialProgress(r));
                        i = new $59fc9b849b320ded$var$__PRIVATE_BundleLoader(r, e.localStore, t.serializer);
                        return [
                            4,
                            t.Oa()
                        ];
                    case 5:
                        s = _state.sent();
                        _state.label = 6;
                    case 6:
                        if (!s) return [
                            3,
                            10
                        ];
                        return [
                            4,
                            i.na(s)
                        ];
                    case 7:
                        _$e = _state.sent();
                        _$e && n._updateProgress(_$e);
                        return [
                            4,
                            t.Oa()
                        ];
                    case 8:
                        s = _state.sent();
                        _state.label = 9;
                    case 9:
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            4,
                            i.complete()
                        ];
                    case 11:
                        o = _state.sent();
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, o.sa, /* remoteEvent */ void 0)
                        ];
                    case 12:
                        _state.sent();
                        // Save metadata, so loading the same bundle will skip.
                        return [
                            4,
                            function __PRIVATE_localStoreSaveBundle(e, t) {
                                var _$n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                                return _$n.persistence.runTransaction("Save bundle", "readwrite", function(e) {
                                    return _$n.Ur.saveBundleMetadata(e, t);
                                });
                            }(e.localStore, r)
                        ];
                    case 13:
                        return [
                            2,
                            (_state.sent(), n._completeWith(o.progress), Promise.resolve(o.ia))
                        ];
                    case 14:
                        e1 = _state.sent();
                        return [
                            2,
                            ($59fc9b849b320ded$export$86cd73f49cc6e0bb("SyncEngine", "Loading bundle failed with ".concat(e1)), n._failWith(e1), Promise.resolve(new Set))
                        ];
                    case 15:
                        return [
                            2
                        ];
                }
            });
        });
        function __PRIVATE_loadBundleImpl(e, t, n) {
            return ___PRIVATE_loadBundleImpl.apply(this, arguments);
        }
        return __PRIVATE_loadBundleImpl;
    })()(r, t, n).then(function(e) {
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
var $59fc9b849b320ded$var$MemoryOfflineComponentProvider = /*#__PURE__*/ function() {
    "use strict";
    function MemoryOfflineComponentProvider() {
        (0, $978gY._)(this, MemoryOfflineComponentProvider);
        this.synchronizeTabs = !1;
    }
    (0, $kry2a._)(MemoryOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.serializer = $59fc9b849b320ded$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), _this.sharedClientState = _this.createSharedClientState(e), _this.persistence = _this.createPersistence(e);
                                return [
                                    4,
                                    _this.persistence.start()
                                ];
                            case 1:
                                _state.sent(), _this.localStore = _this.createLocalStore(e), _this.gcScheduler = _this.createGarbageCollectionScheduler(e, _this.localStore), _this.indexBackfillerScheduler = _this.createIndexBackfillerScheduler(e, _this.localStore);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createGarbageCollectionScheduler",
            value: function createGarbageCollectionScheduler(e, t) {
                return null;
            }
        },
        {
            key: "createIndexBackfillerScheduler",
            value: function createIndexBackfillerScheduler(e, t) {
                return null;
            }
        },
        {
            key: "createLocalStore",
            value: function createLocalStore(e) {
                return $59fc9b849b320ded$var$__PRIVATE_newLocalStore(this.persistence, new $59fc9b849b320ded$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
            }
        },
        {
            key: "createPersistence",
            value: function createPersistence(e) {
                return new $59fc9b849b320ded$var$__PRIVATE_MemoryPersistence($59fc9b849b320ded$var$__PRIVATE_MemoryEagerDelegate.Jr, this.serializer);
            }
        },
        {
            key: "createSharedClientState",
            value: function createSharedClientState(e) {
                return new $59fc9b849b320ded$var$__PRIVATE_MemorySharedClientState;
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.gcScheduler && _this.gcScheduler.stop();
                                return [
                                    4,
                                    _this.sharedClientState.shutdown()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this.persistence.shutdown()
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MemoryOfflineComponentProvider;
}();
var $59fc9b849b320ded$var$__PRIVATE_LruGcMemoryOfflineComponentProvider = /*#__PURE__*/ function(MemoryOfflineComponentProvider) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_LruGcMemoryOfflineComponentProvider, MemoryOfflineComponentProvider);
    var _super = (0, $6OZAO._)(__PRIVATE_LruGcMemoryOfflineComponentProvider);
    function __PRIVATE_LruGcMemoryOfflineComponentProvider(e) {
        (0, $978gY._)(this, __PRIVATE_LruGcMemoryOfflineComponentProvider);
        var _this;
        _this = _super.call(this), _this.cacheSizeBytes = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_LruGcMemoryOfflineComponentProvider, [
        {
            key: "createGarbageCollectionScheduler",
            value: function createGarbageCollectionScheduler(e, t) {
                $59fc9b849b320ded$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $59fc9b849b320ded$var$__PRIVATE_MemoryLruDelegate);
                var n = this.persistence.referenceDelegate.garbageCollector;
                return new $59fc9b849b320ded$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
            }
        },
        {
            key: "createPersistence",
            value: function createPersistence(e) {
                var t = void 0 !== this.cacheSizeBytes ? $59fc9b849b320ded$var$LruParams.withCacheSize(this.cacheSizeBytes) : $59fc9b849b320ded$var$LruParams.DEFAULT;
                return new $59fc9b849b320ded$var$__PRIVATE_MemoryPersistence(function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_MemoryLruDelegate.Jr(e, t);
                }, this.serializer);
            }
        }
    ]);
    return __PRIVATE_LruGcMemoryOfflineComponentProvider;
}($59fc9b849b320ded$var$MemoryOfflineComponentProvider);
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ var $59fc9b849b320ded$var$__PRIVATE_IndexedDbOfflineComponentProvider = /*#__PURE__*/ function(MemoryOfflineComponentProvider) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_IndexedDbOfflineComponentProvider, MemoryOfflineComponentProvider);
    var _super = (0, $6OZAO._)(__PRIVATE_IndexedDbOfflineComponentProvider);
    function __PRIVATE_IndexedDbOfflineComponentProvider(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_IndexedDbOfflineComponentProvider);
        var _this;
        _this = _super.call(this), _this.Na = e, _this.cacheSizeBytes = t, _this.forceOwnership = n, _this.synchronizeTabs = !1;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_IndexedDbOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                var _this1 = this, _superprop_get_initialize = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(__PRIVATE_IndexedDbOfflineComponentProvider.prototype), "initialize", _this);
                };
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get_initialize().call(_this1, e)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    _this1.Na.initialize(_this1, e)
                                ];
                            case 2:
                                _state.sent();
                                // Enqueue writes from a previous session
                                return [
                                    4,
                                    $59fc9b849b320ded$var$__PRIVATE_syncEngineEnsureWriteCallbacks(_this1.Na.syncEngine)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    4,
                                    $59fc9b849b320ded$var$__PRIVATE_fillWritePipeline(_this1.Na.remoteStore)
                                ];
                            case 4:
                                _state.sent();
                                // NOTE: This will immediately call the listener, so we make sure to
                                // set it after localStore / remoteStore are started.
                                return [
                                    4,
                                    _this1.persistence.gi(function() {
                                        return _this1.gcScheduler && !_this1.gcScheduler.started && _this1.gcScheduler.start(), _this1.indexBackfillerScheduler && !_this1.indexBackfillerScheduler.started && _this1.indexBackfillerScheduler.start(), Promise.resolve();
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createLocalStore",
            value: function createLocalStore(e) {
                return $59fc9b849b320ded$var$__PRIVATE_newLocalStore(this.persistence, new $59fc9b849b320ded$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
            }
        },
        {
            key: "createGarbageCollectionScheduler",
            value: function createGarbageCollectionScheduler(e, t) {
                var n = this.persistence.referenceDelegate.garbageCollector;
                return new $59fc9b849b320ded$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
            }
        },
        {
            key: "createIndexBackfillerScheduler",
            value: function createIndexBackfillerScheduler(e, t) {
                var n = new $59fc9b849b320ded$var$__PRIVATE_IndexBackfiller(t, this.persistence);
                return new $59fc9b849b320ded$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
            }
        },
        {
            key: "createPersistence",
            value: function createPersistence(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $59fc9b849b320ded$var$LruParams.withCacheSize(this.cacheSizeBytes) : $59fc9b849b320ded$var$LruParams.DEFAULT;
                return new $59fc9b849b320ded$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $59fc9b849b320ded$var$__PRIVATE_getWindow(), $59fc9b849b320ded$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
            }
        },
        {
            key: "createSharedClientState",
            value: function createSharedClientState(e) {
                return new $59fc9b849b320ded$var$__PRIVATE_MemorySharedClientState;
            }
        }
    ]);
    return __PRIVATE_IndexedDbOfflineComponentProvider;
}($59fc9b849b320ded$var$MemoryOfflineComponentProvider);
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ var $59fc9b849b320ded$var$__PRIVATE_MultiTabOfflineComponentProvider = /*#__PURE__*/ function(__PRIVATE_IndexedDbOfflineComponentProvider) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_MultiTabOfflineComponentProvider, __PRIVATE_IndexedDbOfflineComponentProvider);
    var _super = (0, $6OZAO._)(__PRIVATE_MultiTabOfflineComponentProvider);
    function __PRIVATE_MultiTabOfflineComponentProvider(e, t) {
        (0, $978gY._)(this, __PRIVATE_MultiTabOfflineComponentProvider);
        var _this;
        _this = _super.call(this, e, t, /* forceOwnership= */ !1), _this.Na = e, _this.cacheSizeBytes = t, _this.synchronizeTabs = !0;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_MultiTabOfflineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e) {
                var _this = this;
                var _this1 = this, _superprop_get_initialize = function() {
                    return (0, $3cct3._)((0, $g3d7z._)(__PRIVATE_MultiTabOfflineComponentProvider.prototype), "initialize", _this);
                };
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var t, _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _superprop_get_initialize().call(_this1, e)
                                ];
                            case 1:
                                _state.sent();
                                t = _this1.Na.syncEngine;
                                _tmp = _this1.sharedClientState instanceof $59fc9b849b320ded$var$__PRIVATE_WebStorageSharedClientState;
                                if (!_tmp) return [
                                    3,
                                    3
                                ];
                                _this1.sharedClientState.syncEngine = {
                                    Xs: $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
                                    eo: $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
                                    no: $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
                                    ki: $59fc9b849b320ded$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
                                    Zs: $59fc9b849b320ded$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
                                };
                                return [
                                    4,
                                    _this1.sharedClientState.start()
                                ];
                            case 2:
                                _tmp = _state.sent();
                                _state.label = 3;
                            case 3:
                                _tmp;
                                // NOTE: This will immediately call the listener, so we make sure to
                                // set it after localStore / remoteStore are started.
                                return [
                                    4,
                                    _this1.persistence.gi(function() {
                                        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyPrimaryState(_this1.Na.syncEngine, e)
                                                        ];
                                                    case 1:
                                                        _state.sent(), _this1.gcScheduler && (e && !_this1.gcScheduler.started ? _this1.gcScheduler.start() : e || _this1.gcScheduler.stop()), _this1.indexBackfillerScheduler && (e && !_this1.indexBackfillerScheduler.started ? _this1.indexBackfillerScheduler.start() : e || _this1.indexBackfillerScheduler.stop());
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(e) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }())
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createSharedClientState",
            value: function createSharedClientState(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_getWindow();
                if (!$59fc9b849b320ded$var$__PRIVATE_WebStorageSharedClientState.C(t)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
                var n = $59fc9b849b320ded$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
                return new $59fc9b849b320ded$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
            }
        }
    ]);
    return __PRIVATE_MultiTabOfflineComponentProvider;
}($59fc9b849b320ded$var$__PRIVATE_IndexedDbOfflineComponentProvider);
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ var $59fc9b849b320ded$var$OnlineComponentProvider = /*#__PURE__*/ function() {
    "use strict";
    function OnlineComponentProvider() {
        (0, $978gY._)(this, OnlineComponentProvider);
    }
    (0, $kry2a._)(OnlineComponentProvider, [
        {
            key: "initialize",
            value: function initialize(e, t) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _tmp;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = _this.localStore;
                                if (_tmp) return [
                                    3,
                                    2
                                ];
                                _this.localStore = e.localStore, _this.sharedClientState = e.sharedClientState, _this.datastore = _this.createDatastore(t), _this.remoteStore = _this.createRemoteStore(t), _this.eventManager = _this.createEventManager(t), _this.syncEngine = _this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), _this.sharedClientState.onlineStateHandler = function(e) {
                                    return $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyOnlineStateChange(_this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ );
                                }, _this.remoteStore.remoteSyncer.handleCredentialChange = $59fc9b849b320ded$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, _this.syncEngine);
                                return [
                                    4,
                                    $59fc9b849b320ded$var$__PRIVATE_remoteStoreApplyPrimaryState(_this.remoteStore, _this.syncEngine.isPrimaryClient)
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "createEventManager",
            value: function createEventManager(e) {
                return function __PRIVATE_newEventManager() {
                    return new $59fc9b849b320ded$var$__PRIVATE_EventManagerImpl;
                }();
            }
        },
        {
            key: "createDatastore",
            value: function createDatastore(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_newSerializer(e.databaseInfo.databaseId), n = function __PRIVATE_newConnection(e) {
                    return new $59fc9b849b320ded$var$__PRIVATE_WebChannelConnection(e);
                }(e.databaseInfo);
                return function __PRIVATE_newDatastore(e, t, n, r) {
                    return new $59fc9b849b320ded$var$__PRIVATE_DatastoreImpl(e, t, n, r);
                }(e.authCredentials, e.appCheckCredentials, n, t);
            }
        },
        {
            key: "createRemoteStore",
            value: function createRemoteStore(e) {
                var _this = this;
                return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
                    return new $59fc9b849b320ded$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
                }(this.localStore, this.datastore, e.asyncQueue, function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_syncEngineApplyOnlineStateChange(_this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ );
                }, function __PRIVATE_newConnectivityMonitor() {
                    return $59fc9b849b320ded$var$__PRIVATE_BrowserConnectivityMonitor.C() ? new $59fc9b849b320ded$var$__PRIVATE_BrowserConnectivityMonitor : new $59fc9b849b320ded$var$__PRIVATE_NoopConnectivityMonitor;
                }());
            }
        },
        {
            key: "createSyncEngine",
            value: function createSyncEngine(e, t) {
                return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
                r, i, s, o) {
                    var _ = new $59fc9b849b320ded$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
                    return o && (_.Fa = !0), _;
                }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                return (function() {
                    var ___PRIVATE_remoteStoreShutdown = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
                        var t;
                        return (0, $7UAGh.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                                    $59fc9b849b320ded$var$__PRIVATE_logDebug("RemoteStore", "RemoteStore shutting down."), t.F_.add(5 /* OfflineCause.Shutdown */ );
                                    return [
                                        4,
                                        $59fc9b849b320ded$var$__PRIVATE_disableNetworkInternal(t)
                                    ];
                                case 1:
                                    _state.sent(), t.x_.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
                                    // triggering spurious listener events with cached data, etc.
                                    t.O_.set("Unknown" /* OnlineState.Unknown */ );
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    function __PRIVATE_remoteStoreShutdown(e) {
                        return ___PRIVATE_remoteStoreShutdown.apply(this, arguments);
                    }
                    return __PRIVATE_remoteStoreShutdown;
                })()(this.remoteStore);
            }
        }
    ]);
    return OnlineComponentProvider;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * How many bytes to read each time when `ReadableStreamReader.read()` is
 * called. Only applicable for byte streams that we control (e.g. those backed
 * by an UInt8Array).
 */ /**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $59fc9b849b320ded$var$__PRIVATE_toByteStreamReaderHelper(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10240;
    var n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        read: // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function() {
            return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                var r;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    if (n < e.byteLength) {
                        r = {
                            value: e.slice(n, n + t),
                            done: !1
                        };
                        return [
                            2,
                            (n += t, r)
                        ];
                    }
                    return [
                        2,
                        {
                            done: !0
                        }
                    ];
                });
            })();
        },
        cancel: function() {
            return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                return (0, $7UAGh.__generator)(this, function(_state) {
                    return [
                        2
                    ];
                });
            })();
        },
        releaseLock: function() {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ var $59fc9b849b320ded$var$__PRIVATE_AsyncObserver = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AsyncObserver(e) {
        (0, $978gY._)(this, __PRIVATE_AsyncObserver);
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    (0, $kry2a._)(__PRIVATE_AsyncObserver, [
        {
            key: "next",
            value: function next(e) {
                this.observer.next && this.Ba(this.observer.next, e);
            }
        },
        {
            key: "error",
            value: function error(e) {
                this.observer.error ? this.Ba(this.observer.error, e) : $59fc9b849b320ded$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString());
            }
        },
        {
            key: "La",
            value: function La() {
                this.muted = !0;
            }
        },
        {
            key: "Ba",
            value: function Ba(e, t) {
                var _this = this;
                this.muted || setTimeout(function() {
                    _this.muted || e(t);
                }, 0);
            }
        }
    ]);
    return __PRIVATE_AsyncObserver;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ var $59fc9b849b320ded$var$__PRIVATE_BundleReaderImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_BundleReaderImpl(/** The reader to read from underlying binary bundle data source. */ e, t) {
        var _this = this;
        (0, $978gY._)(this, __PRIVATE_BundleReaderImpl);
        this.ka = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $59fc9b849b320ded$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.qa = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.Qa().then(function(e) {
            e && e.ea() ? _this.metadata.resolve(e.X_.metadata) : _this.metadata.reject(new Error("The first element of the bundle is not a metadata, it is\n             ".concat(JSON.stringify(null == e ? void 0 : e.X_))));
        }, function(e) {
            return _this.metadata.reject(e);
        });
    }
    (0, $kry2a._)(__PRIVATE_BundleReaderImpl, [
        {
            key: "close",
            value: function close() {
                return this.ka.cancel();
            }
        },
        {
            key: "getMetadata",
            value: function getMetadata() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            _this.metadata.promise
                        ];
                    });
                })();
            }
        },
        {
            key: "Oa",
            value: function Oa() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.getMetadata()
                                ];
                            case 1:
                                // Makes sure metadata is read before proceeding.
                                return [
                                    2,
                                    (_state.sent(), _this.Qa())
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "Qa",
            value: /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ function Qa() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, t, n, r;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.Ka()
                                ];
                            case 1:
                                e = _state.sent();
                                if (null === e) return [
                                    2,
                                    null
                                ];
                                t = _this.qa.decode(e), n = Number(t);
                                isNaN(n) && _this.$a("length string (".concat(t, ") is not valid number"));
                                return [
                                    4,
                                    _this.Ua(n)
                                ];
                            case 2:
                                r = _state.sent();
                                return [
                                    2,
                                    new $59fc9b849b320ded$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n)
                                ];
                        }
                    });
                })();
            }
        },
        {
            /** First index of '{' from the underlying buffer. */ key: "Wa",
            value: function Wa() {
                return this.buffer.findIndex(function(e) {
                    return e === "{".charCodeAt(0);
                });
            }
        },
        {
            key: "Ka",
            value: /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ function Ka() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.Wa() < 0)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.Ga()
                                ];
                            case 1:
                                if (_state.sent()) return [
                                    3,
                                    3
                                ];
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    0
                                ];
                            case 3:
                                // Broke out of the loop because underlying stream is closed, and there
                                // happens to be no more data to process.
                                if (0 === _this.buffer.length) return [
                                    2,
                                    null
                                ];
                                e = _this.Wa();
                                // Broke out of the loop because underlying stream is closed, but still
                                // cannot find an open bracket.
                                e < 0 && _this.$a("Reached the end of bundle when a length string is expected.");
                                t = _this.buffer.slice(0, e);
                                // Update the internal buffer to drop the read length.
                                return [
                                    2,
                                    (_this.buffer = _this.buffer.slice(e), t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "Ua",
            value: /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ function Ua(e) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(_this.buffer.length < e)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.Ga()
                                ];
                            case 1:
                                _state.sent() && _this.$a("Reached the end of bundle when more is expected.");
                                _state.label = 2;
                            case 2:
                                return [
                                    3,
                                    0
                                ];
                            case 3:
                                t = _this.qa.decode(_this.buffer.slice(0, e));
                                // Update the internal buffer to drop the read json string.
                                return [
                                    2,
                                    (_this.buffer = _this.buffer.slice(e), t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "$a",
            value: function $a(e) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                throw this.ka.cancel(), new Error("Invalid bundle format: ".concat(e));
            }
        },
        {
            key: "Ga",
            value: /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ function Ga() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.ka.read()
                                ];
                            case 1:
                                e = _state.sent();
                                if (!e.done) {
                                    t = new Uint8Array(_this.buffer.length + e.value.length);
                                    t.set(_this.buffer), t.set(e.value, _this.buffer.length), _this.buffer = t;
                                }
                                return [
                                    2,
                                    e.done
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return __PRIVATE_BundleReaderImpl;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ var $59fc9b849b320ded$var$Transaction$2 = /*#__PURE__*/ function() {
    "use strict";
    function Transaction$2(e) {
        (0, $978gY._)(this, Transaction$2);
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastWriteError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    (0, $kry2a._)(Transaction$2, [
        {
            key: "lookup",
            value: function lookup(e) {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.ensureCommitNotCalled(), _this.mutations.length > 0) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
                                return [
                                    4,
                                    (function() {
                                        var ___PRIVATE_invokeBatchGetDocumentsRpc = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
                                            var n, r, i, s, o, _;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = $59fc9b849b320ded$var$__PRIVATE_getEncodedDatabaseId(n.serializer) + "/documents", i = {
                                                            documents: t.map(function(e) {
                                                                return $59fc9b849b320ded$var$__PRIVATE_toName(n.serializer, e);
                                                            })
                                                        };
                                                        return [
                                                            4,
                                                            n.Fo("BatchGetDocuments", r, i, t.length)
                                                        ];
                                                    case 1:
                                                        s = _state.sent(), o = new Map;
                                                        s.forEach(function(e) {
                                                            var _$t = $59fc9b849b320ded$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                                                            o.set(_$t.key.toString(), _$t);
                                                        });
                                                        _ = [];
                                                        return [
                                                            2,
                                                            (t.forEach(function(e) {
                                                                var _$t = o.get(e.toString());
                                                                $59fc9b849b320ded$var$__PRIVATE_hardAssert(!!_$t), _.push(_$t);
                                                            }), _)
                                                        ];
                                                }
                                            });
                                        });
                                        function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
                                            return ___PRIVATE_invokeBatchGetDocumentsRpc.apply(this, arguments);
                                        }
                                        return __PRIVATE_invokeBatchGetDocumentsRpc;
                                    })()(_this.datastore, e)
                                ];
                            case 1:
                                t = _state.sent();
                                return [
                                    2,
                                    (t.forEach(function(e) {
                                        return _this.recordVersion(e);
                                    }), t)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "set",
            value: function set(e, t) {
                this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "update",
            value: function update(e, t) {
                try {
                    this.write(t.toMutation(e, this.preconditionForUpdate(e)));
                } catch (e) {
                    this.lastWriteError = e;
                }
                this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "delete",
            value: function _delete(e) {
                this.write(new $59fc9b849b320ded$var$__PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
            }
        },
        {
            key: "commit",
            value: function commit() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.ensureCommitNotCalled(), _this.lastWriteError) throw _this.lastWriteError;
                                e = _this.readVersions;
                                // For each mutation, note that the doc was written.
                                _this.mutations.forEach(function(t) {
                                    e.delete(t.key.toString());
                                }), // For each document that was read but not written to, we want to perform
                                // a `verify` operation.
                                e.forEach(function(e, t) {
                                    var n = $59fc9b849b320ded$export$afc2e57c475b7810.fromPath(t);
                                    _this.mutations.push(new $59fc9b849b320ded$var$__PRIVATE_VerifyMutation(n, _this.precondition(n)));
                                });
                                return [
                                    4,
                                    (function() {
                                        var ___PRIVATE_invokeCommitRpc = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
                                            var n, r, i;
                                            return (0, $7UAGh.__generator)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = $59fc9b849b320ded$var$__PRIVATE_getEncodedDatabaseId(n.serializer) + "/documents", i = {
                                                            writes: t.map(function(e) {
                                                                return $59fc9b849b320ded$var$toMutation(n.serializer, e);
                                                            })
                                                        };
                                                        return [
                                                            4,
                                                            n.bo("Commit", r, i)
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        function __PRIVATE_invokeCommitRpc(e, t) {
                                            return ___PRIVATE_invokeCommitRpc.apply(this, arguments);
                                        }
                                        return __PRIVATE_invokeCommitRpc;
                                    })()(_this.datastore, _this.mutations)
                                ];
                            case 1:
                                _state.sent(), _this.committed = !0;
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "recordVersion",
            value: function recordVersion(e) {
                var t;
                if (e.isFoundDocument()) t = e.version;
                else {
                    if (!e.isNoDocument()) throw $59fc9b849b320ded$var$fail();
                    // Represent a deleted doc using SnapshotVersion.min().
                    t = $59fc9b849b320ded$var$SnapshotVersion.min();
                }
                var n = this.readVersions.get(e.key.toString());
                if (n) {
                    if (!t.isEqual(n)) // This transaction will fail no matter what.
                    throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.ABORTED, "Document version changed between two reads.");
                } else this.readVersions.set(e.key.toString(), t);
            }
        },
        {
            /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ key: "precondition",
            value: function precondition(e) {
                var t = this.readVersions.get(e.toString());
                return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($59fc9b849b320ded$var$SnapshotVersion.min()) ? $59fc9b849b320ded$var$Precondition.exists(!1) : $59fc9b849b320ded$var$Precondition.updateTime(t) : $59fc9b849b320ded$var$Precondition.none();
            }
        },
        {
            /**
     * Returns the precondition for a document if the operation is an update.
     */ key: "preconditionForUpdate",
            value: function preconditionForUpdate(e) {
                var t = this.readVersions.get(e.toString());
                // The first time a document is written, we want to take into account the
                // read time and existence
                if (!this.writtenDocs.has(e.toString()) && t) {
                    if (t.isEqual($59fc9b849b320ded$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
                    // This has to be validated locally because you can't send a
                    // precondition that a document does not exist without changing the
                    // semantics of the backend write to be an insert. This is the reverse
                    // of what we want, since we want to assert that the document doesn't
                    // exist but then send the update and have it fail. Since we can't
                    // express that to the backend, we have to validate locally.
                    // Note: this can change once we can send separate verify writes in the
                    // transaction.
                    throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
                    // Document exists, base precondition on document update time.
                    return $59fc9b849b320ded$var$Precondition.updateTime(t);
                }
                // Document was not read, so we just use the preconditions for a blind
                // update.
                return $59fc9b849b320ded$var$Precondition.exists(!0);
            }
        },
        {
            key: "write",
            value: function write(e) {
                this.ensureCommitNotCalled(), this.mutations.push(e);
            }
        },
        {
            key: "ensureCommitNotCalled",
            value: function ensureCommitNotCalled() {}
        }
    ]);
    return Transaction$2;
}();
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ var $59fc9b849b320ded$var$__PRIVATE_TransactionRunner = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TransactionRunner(e, t, n, r, i) {
        (0, $978gY._)(this, __PRIVATE_TransactionRunner);
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.za = n.maxAttempts, this.Ho = new $59fc9b849b320ded$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    (0, $kry2a._)(__PRIVATE_TransactionRunner, [
        {
            /** Runs the transaction and sets the result on deferred. */ key: "run",
            value: function run() {
                this.za -= 1, this.ja();
            }
        },
        {
            key: "ja",
            value: function ja() {
                var _this = this;
                this.Ho.Qo(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e, t;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        e = new $59fc9b849b320ded$var$Transaction$2(_this.datastore), t = _this.Ha(e);
                        t && t.then(function(t) {
                            _this.asyncQueue.enqueueAndForget(function() {
                                return e.commit().then(function() {
                                    _this.deferred.resolve(t);
                                }).catch(function(e) {
                                    _this.Ja(e);
                                });
                            });
                        }).catch(function(e) {
                            _this.Ja(e);
                        });
                        return [
                            2
                        ];
                    });
                }));
            }
        },
        {
            key: "Ha",
            value: function Ha(e) {
                try {
                    var t = this.updateFunction(e);
                    return !$59fc9b849b320ded$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
                } catch (e) {
                    // Do not retry errors thrown by user provided updateFunction.
                    return this.deferred.reject(e), null;
                }
            }
        },
        {
            key: "Ja",
            value: function Ja(e) {
                var _this = this;
                this.za > 0 && this.Ya(e) ? (this.za -= 1, this.asyncQueue.enqueueAndForget(function() {
                    return _this.ja(), Promise.resolve();
                })) : this.deferred.reject(e);
            }
        },
        {
            key: "Ya",
            value: function Ya(e) {
                if ("FirebaseError" === e.name) {
                    // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
                    // non-matching document versions with ABORTED. These errors should be retried.
                    var t = e.code;
                    return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$59fc9b849b320ded$var$__PRIVATE_isPermanentError(t);
                }
                return !1;
            }
        }
    ]);
    return __PRIVATE_TransactionRunner;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ var $59fc9b849b320ded$var$FirestoreClient = /*#__PURE__*/ function() {
    "use strict";
    function FirestoreClient(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, r) {
        var _this = this;
        (0, $978gY._)(this, FirestoreClient);
        var _this1 = this;
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this.databaseInfo = r, this.user = $59fc9b849b320ded$var$User.UNAUTHENTICATED, this.clientId = $59fc9b849b320ded$var$__PRIVATE_AutoId.V(), this.authCredentialListener = function() {
            return Promise.resolve();
        }, this.appCheckCredentialListener = function() {
            return Promise.resolve();
        }, this.authCredentials.start(n, function() {
            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Received user=", e.uid);
                            return [
                                4,
                                _this1.authCredentialListener(e)
                            ];
                        case 1:
                            _state.sent(), _this1.user = e;
                            return [
                                2
                            ];
                    }
                });
            });
            return function(e) {
                return _ref.apply(this, arguments);
            };
        }()), this.appCheckCredentials.start(n, function(e) {
            return $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Received new app check token=", e), _this.appCheckCredentialListener(e, _this.user);
        });
    }
    (0, $kry2a._)(FirestoreClient, [
        {
            key: "getConfiguration",
            value: function getConfiguration() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        return [
                            2,
                            {
                                asyncQueue: _this.asyncQueue,
                                databaseInfo: _this.databaseInfo,
                                clientId: _this.clientId,
                                authCredentials: _this.authCredentials,
                                appCheckCredentials: _this.appCheckCredentials,
                                initialUser: _this.user,
                                maxConcurrentLimboResolutions: 100
                            }
                        ];
                    });
                })();
            }
        },
        {
            key: "setCredentialChangeListener",
            value: function setCredentialChangeListener(e) {
                this.authCredentialListener = e;
            }
        },
        {
            key: "setAppCheckTokenChangeListener",
            value: function setAppCheckTokenChangeListener(e) {
                this.appCheckCredentialListener = e;
            }
        },
        {
            /**
     * Checks that the client has not been terminated. Ensures that other methods on //
     * this class cannot be called after the client is terminated. //
     */ key: "verifyNotTerminated",
            value: function verifyNotTerminated() {
                if (this.asyncQueue.isShuttingDown) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "The client has already been terminated.");
            }
        },
        {
            key: "terminate",
            value: function terminate() {
                this.asyncQueue.enterRestrictedMode();
                var e = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
                var _this = this;
                return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var _tmp, _tmp1, t, n;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    5,
                                    ,
                                    6
                                ]);
                                _tmp = _this._onlineComponents;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this._onlineComponents.terminate()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _tmp;
                                _tmp1 = _this._offlineComponents;
                                if (!_tmp1) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    _this._offlineComponents.terminate()
                                ];
                            case 3:
                                _tmp1 = _state.sent();
                                _state.label = 4;
                            case 4:
                                _tmp1, // The credentials provider must be terminated after shutting down the
                                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                                // tokens.
                                _this.authCredentials.shutdown(), _this.appCheckCredentials.shutdown(), e.resolve();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                t = _state.sent();
                                n = $59fc9b849b320ded$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                                e.reject(n);
                                return [
                                    3,
                                    6
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                })), e.promise;
            }
        }
    ]);
    return FirestoreClient;
}();
function $59fc9b849b320ded$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_setOfflineComponentProvider.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_setOfflineComponentProvider() {
    $59fc9b849b320ded$var$___PRIVATE_setOfflineComponentProvider = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.asyncQueue.verifyOperationInProgress(), $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OfflineComponentProvider");
                    return [
                        4,
                        e.getConfiguration()
                    ];
                case 1:
                    n = _state.sent();
                    return [
                        4,
                        t.initialize(n)
                    ];
                case 2:
                    _state.sent();
                    r = n.initialUser;
                    e.setCredentialChangeListener(function() {
                        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
                            var _tmp;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = r.isEqual(e);
                                        if (_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $59fc9b849b320ded$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e)
                                        ];
                                    case 1:
                                        _tmp = (_state.sent(), r = e);
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }()), // When a user calls clearPersistence() in one client, all other clients
                    // need to be terminated to allow the delete to succeed.
                    t.persistence.setDatabaseDeletedListener(function() {
                        return e.terminate();
                    }), e._offlineComponents = t;
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_setOfflineComponentProvider.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    return $59fc9b849b320ded$var$___PRIVATE_setOnlineComponentProvider.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_setOnlineComponentProvider() {
    $59fc9b849b320ded$var$___PRIVATE_setOnlineComponentProvider = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
        var n, r;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.asyncQueue.verifyOperationInProgress();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_ensureOfflineComponents(e)
                    ];
                case 1:
                    n = _state.sent();
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Initializing OnlineComponentProvider");
                    return [
                        4,
                        e.getConfiguration()
                    ];
                case 2:
                    r = _state.sent();
                    return [
                        4,
                        t.initialize(n, r)
                    ];
                case 3:
                    _state.sent(), // The CredentialChangeListener of the online component provider takes
                    // precedence over the offline component provider.
                    e.setCredentialChangeListener(function(e) {
                        return $59fc9b849b320ded$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e);
                    }), e.setAppCheckTokenChangeListener(function(e, n) {
                        return $59fc9b849b320ded$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n);
                    }), e._onlineComponents = t;
                    return [
                        2
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_setOnlineComponentProvider.apply(this, arguments);
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ function $59fc9b849b320ded$var$__PRIVATE_canFallbackFromIndexedDbError(e) {
    return "FirebaseError" === e.name ? e.code === $59fc9b849b320ded$var$D.FAILED_PRECONDITION || e.code === $59fc9b849b320ded$var$D.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
    // or an aborted error depending on whether the error happened during
    // schema migration.
    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
    // INVALID_STATE for any usage.
    11 === e.code;
}
function $59fc9b849b320ded$var$__PRIVATE_ensureOfflineComponents(e) {
    return $59fc9b849b320ded$var$___PRIVATE_ensureOfflineComponents.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_ensureOfflineComponents() {
    $59fc9b849b320ded$var$___PRIVATE_ensureOfflineComponents = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        var t, n;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!e._offlineComponents) return [
                        3,
                        8
                    ];
                    if (!e._uninitializedComponentsProvider) return [
                        3,
                        6
                    ];
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OfflineComponentProvider");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    t = _state.sent();
                    n = t;
                    if (!$59fc9b849b320ded$var$__PRIVATE_canFallbackFromIndexedDbError(n)) throw n;
                    $59fc9b849b320ded$export$86cd73f49cc6e0bb("Error using user provided cache. Falling back to memory cache: " + n);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_setOfflineComponentProvider(e, new $59fc9b849b320ded$var$MemoryOfflineComponentProvider)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Using default OfflineComponentProvider");
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_setOfflineComponentProvider(e, new $59fc9b849b320ded$var$MemoryOfflineComponentProvider)
                    ];
                case 7:
                    _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        e._offlineComponents
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_ensureOfflineComponents.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_ensureOnlineComponents(e) {
    return $59fc9b849b320ded$var$___PRIVATE_ensureOnlineComponents.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_ensureOnlineComponents() {
    $59fc9b849b320ded$var$___PRIVATE_ensureOnlineComponents = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        var _tmp, _tmp1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = e._onlineComponents;
                    if (_tmp) return [
                        3,
                        5
                    ];
                    if (!e._uninitializedComponentsProvider) return [
                        3,
                        2
                    ];
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Using user provided OnlineComponentProvider");
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)
                    ];
                case 1:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    $59fc9b849b320ded$var$__PRIVATE_logDebug("FirestoreClient", "Using default OnlineComponentProvider");
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_setOnlineComponentProvider(e, new $59fc9b849b320ded$var$OnlineComponentProvider)
                    ];
                case 3:
                    _tmp1 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp = _tmp1;
                    _state.label = 5;
                case 5:
                    return [
                        2,
                        (_tmp, e._onlineComponents)
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_ensureOnlineComponents.apply(this, arguments);
}
function $59fc9b849b320ded$var$__PRIVATE_getPersistence(e) {
    return $59fc9b849b320ded$var$__PRIVATE_ensureOfflineComponents(e).then(function(e) {
        return e.persistence;
    });
}
function $59fc9b849b320ded$var$__PRIVATE_getLocalStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_ensureOfflineComponents(e).then(function(e) {
        return e.localStore;
    });
}
function $59fc9b849b320ded$var$__PRIVATE_getRemoteStore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.remoteStore;
    });
}
function $59fc9b849b320ded$var$__PRIVATE_getSyncEngine(e) {
    return $59fc9b849b320ded$var$__PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.syncEngine;
    });
}
function $59fc9b849b320ded$var$__PRIVATE_getDatastore(e) {
    return $59fc9b849b320ded$var$__PRIVATE_ensureOnlineComponents(e).then(function(e) {
        return e.datastore;
    });
}
function $59fc9b849b320ded$var$__PRIVATE_getEventManager(e) {
    return $59fc9b849b320ded$var$___PRIVATE_getEventManager.apply(this, arguments);
}
function $59fc9b849b320ded$var$___PRIVATE_getEventManager() {
    $59fc9b849b320ded$var$___PRIVATE_getEventManager = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
        var t, n;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_ensureOnlineComponents(e)
                    ];
                case 1:
                    t = _state.sent(), n = t.eventManager;
                    return [
                        2,
                        (n.onListen = $59fc9b849b320ded$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $59fc9b849b320ded$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n)
                    ];
            }
        });
    });
    return $59fc9b849b320ded$var$___PRIVATE_getEventManager.apply(this, arguments);
}
/** Enables the network connection and re-enqueues all pending operations. */ function $59fc9b849b320ded$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var t, n;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getPersistence(e)
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getRemoteStore(e)
                    ];
                case 2:
                    n = _state.sent();
                    return [
                        2,
                        (t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
                            var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                            return t.F_.delete(0 /* OfflineCause.UserDisabled */ ), $59fc9b849b320ded$var$__PRIVATE_enableNetworkInternal(t);
                        }(n))
                    ];
            }
        });
    }));
}
/** Disables the network connection. Pending operations will not complete. */ function $59fc9b849b320ded$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var t, n;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getPersistence(e)
                    ];
                case 1:
                    t = _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getRemoteStore(e)
                    ];
                case 2:
                    n = _state.sent();
                    return [
                        2,
                        (t.setNetworkEnabled(!1), (function() {
                            var ___PRIVATE_remoteStoreDisableNetwork = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
                                var t;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                                            t.F_.add(0 /* OfflineCause.UserDisabled */ );
                                            return [
                                                4,
                                                $59fc9b849b320ded$var$__PRIVATE_disableNetworkInternal(t)
                                            ];
                                        case 1:
                                            _state.sent(), // Set the OnlineState to Offline so get()s return from cache, etc.
                                            t.O_.set("Offline" /* OnlineState.Offline */ );
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_remoteStoreDisableNetwork(e) {
                                return ___PRIVATE_remoteStoreDisableNetwork.apply(this, arguments);
                            }
                            return __PRIVATE_remoteStoreDisableNetwork;
                        })()(n))
                    ];
            }
        });
    }));
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    var n = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function() {
                        var ___PRIVATE_readDocumentFromCache = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
                            var r, e1, r1;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            function __PRIVATE_localStoreReadDocument(e, t) {
                                                var _$n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                                                return _$n.persistence.runTransaction("read document", "readonly", function(e) {
                                                    return _$n.localDocuments.getDocument(e, t);
                                                });
                                            }(e, t)
                                        ];
                                    case 1:
                                        r = _state.sent();
                                        r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        e1 = _state.sent();
                                        r1 = $59fc9b849b320ded$var$__PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to get document '".concat(t, " from cache"));
                                        n.reject(r1);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        function __PRIVATE_readDocumentFromCache(e, t, n) {
                            return ___PRIVATE_readDocumentFromCache.apply(this, arguments);
                        }
                        return __PRIVATE_readDocumentFromCache;
                    }();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t,
                            n
                        ])
                    ];
            }
        });
    })), n.promise;
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var r = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
                        var s = new $59fc9b849b320ded$var$__PRIVATE_AsyncObserver({
                            next: function(s) {
                                // Remove query first before passing event to user to avoid
                                // user actions affecting the now stale query.
                                t.enqueueAndForget(function() {
                                    return $59fc9b849b320ded$var$__PRIVATE_eventManagerUnlisten(e, o);
                                });
                                var _ = s.docs.has(n);
                                !_ && s.fromCache ? // TODO(dimond): If we're online and the document doesn't
                                // exist then we resolve with a doc.exists set to false. If
                                // we're offline however, we reject the Promise in this
                                // case. Two options: 1) Cache the negative response from
                                // the server so we can deliver that even when you're
                                // offline 2) Actually reject the Promise in the online case
                                // if the document doesn't exist.
                                i.reject(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNAVAILABLE, "Failed to get document because the client is offline.")) : _ && s.fromCache && r && "server" === r.source ? i.reject(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(s);
                            },
                            error: function(e) {
                                return i.reject(e);
                            }
                        }), o = new $59fc9b849b320ded$var$__PRIVATE_QueryListener($59fc9b849b320ded$var$__PRIVATE_newQueryForPath(n.path), s, {
                            includeMetadataChanges: !0,
                            Z_: !0
                        });
                        return $59fc9b849b320ded$var$__PRIVATE_eventManagerListen(e, o);
                    };
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getEventManager(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            e.asyncQueue,
                            t,
                            n,
                            r
                        ])
                    ];
            }
        });
    })), r.promise;
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    var n = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function() {
                        var ___PRIVATE_executeQueryFromCache = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t, n) {
                            var r, i, s, o, e1, r1;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            $59fc9b849b320ded$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0)
                                        ];
                                    case 1:
                                        r = _state.sent(), i = new $59fc9b849b320ded$var$__PRIVATE_View(t, r.Ps), s = i.ha(r.documents), o = i.applyChanges(s, /* updateLimboDocuments= */ !1);
                                        n.resolve(o.snapshot);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        e1 = _state.sent();
                                        r1 = $59fc9b849b320ded$var$__PRIVATE_wrapInUserErrorIfRecoverable(e1, "Failed to execute query '".concat(t, " against cache"));
                                        n.reject(r1);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        function __PRIVATE_executeQueryFromCache(e, t, n) {
                            return ___PRIVATE_executeQueryFromCache.apply(this, arguments);
                        }
                        return __PRIVATE_executeQueryFromCache;
                    }();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t,
                            n
                        ])
                    ];
            }
        });
    })), n.promise;
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var r = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
                        var s = new $59fc9b849b320ded$var$__PRIVATE_AsyncObserver({
                            next: function(n) {
                                // Remove query first before passing event to user to avoid
                                // user actions affecting the now stale query.
                                t.enqueueAndForget(function() {
                                    return $59fc9b849b320ded$var$__PRIVATE_eventManagerUnlisten(e, o);
                                }), n.fromCache && "server" === r.source ? i.reject(new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                            },
                            error: function(e) {
                                return i.reject(e);
                            }
                        }), o = new $59fc9b849b320ded$var$__PRIVATE_QueryListener(n, s, {
                            includeMetadataChanges: !0,
                            Z_: !0
                        });
                        return $59fc9b849b320ded$var$__PRIVATE_eventManagerListen(e, o);
                    };
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getEventManager(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            e.asyncQueue,
                            t,
                            n,
                            r
                        ])
                    ];
            }
        });
    })), r.promise;
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    var n = new $59fc9b849b320ded$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_addSnapshotsInSyncListener(e, t) {
                        $59fc9b849b320ded$var$__PRIVATE_debugCast(e).K_.add(t), // Immediately fire an initial event, indicating all existing listeners
                        // are in-sync.
                        t.next();
                    };
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getEventManager(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            n
                        ])
                    ];
            }
        });
    })), function() {
        n.La(), e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            var _;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                            $59fc9b849b320ded$var$__PRIVATE_debugCast(e).K_.delete(t);
                        };
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_getEventManager(e)
                        ];
                    case 1:
                        return [
                            2,
                            _.apply(void 0, [
                                _state.sent(),
                                n
                            ])
                        ];
                }
            });
        }));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $59fc9b849b320ded$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    var i = function __PRIVATE_createBundleReader(e, t) {
        var _$n;
        _$n = "string" == typeof e ? $59fc9b849b320ded$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $59fc9b849b320ded$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $59fc9b849b320ded$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $59fc9b849b320ded$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(_$n), t);
    }(n, $59fc9b849b320ded$var$__PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getSyncEngine(e)
                    ];
                case 1:
                    $59fc9b849b320ded$var$__PRIVATE_syncEngineLoadBundle.apply(void 0, [
                        _state.sent(),
                        i,
                        r
                    ]);
                    return [
                        2
                    ];
            }
        });
    }));
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_localStoreGetNamedQuery(e, t) {
                        var n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e);
                        return n.persistence.runTransaction("Get named query", "readonly", function(e) {
                            return n.Ur.getNamedQuery(e, t);
                        });
                    };
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t
                        ])
                    ];
            }
        });
    }));
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function() {
                        var ___PRIVATE_localStoreConfigureFieldIndexes = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e, t) {
                            var n, r, i;
                            return (0, $7UAGh.__generator)(this, function(_state) {
                                n = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
                                return [
                                    2,
                                    n.persistence.runTransaction("Configure indexes", "readwrite", function(e) {
                                        return r.getFieldIndexes(e).next(function(n) {
                                            return(/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ function __PRIVATE_diffArrays(e, t, n, r, i) {
                                                e = (0, $fLnyw._)(e), t = (0, $fLnyw._)(t), e.sort(n), t.sort(n);
                                                var s = e.length, o = t.length;
                                                var _ = 0, a = 0;
                                                for(; _ < o && a < s;){
                                                    var s1 = n(e[a], t[_]);
                                                    s1 < 0 ? // The element was removed if the next element in our ordered
                                                    // walkthrough is only in `before`.
                                                    i(e[a++]) : s1 > 0 ? // The element was added if the next element in our ordered walkthrough
                                                    // is only in `after`.
                                                    r(t[_++]) : (_++, a++);
                                                }
                                                for(; _ < o;)r(t[_++]);
                                                for(; a < s;)i(e[a++]);
                                            }(n, t, $59fc9b849b320ded$var$__PRIVATE_fieldIndexSemanticComparator, function(t) {
                                                i.push(r.addFieldIndex(e, t));
                                            }, function(t) {
                                                i.push(r.deleteFieldIndex(e, t));
                                            }));
                                        }).next(function() {
                                            return $59fc9b849b320ded$var$PersistencePromise.waitFor(i);
                                        });
                                    })
                                ];
                            });
                        });
                        function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
                            return ___PRIVATE_localStoreConfigureFieldIndexes.apply(this, arguments);
                        }
                        return __PRIVATE_localStoreConfigureFieldIndexes;
                    }();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t
                        ])
                    ];
            }
        });
    }));
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
                        $59fc9b849b320ded$var$__PRIVATE_debugCast(e).ns.Wi = t;
                    };
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent(),
                            t
                        ])
                    ];
            }
        });
    }));
}
function $59fc9b849b320ded$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var _;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
                        var t = $59fc9b849b320ded$var$__PRIVATE_debugCast(e), n = t.indexManager;
                        return t.persistence.runTransaction("Delete All Indexes", "readwrite", function(e) {
                            return n.deleteAllFieldIndexes(e);
                        });
                    };
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_getLocalStore(e)
                    ];
                case 1:
                    return [
                        2,
                        _.apply(void 0, [
                            _state.sent()
                        ])
                    ];
            }
        });
    }));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ /**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $59fc9b849b320ded$var$__PRIVATE_cloneLongPollingOptions(e) {
    var t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$me = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fc9b849b320ded$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Function ".concat(e, "() cannot be called with an empty ").concat(t, "."));
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $59fc9b849b320ded$export$8731e8d1617cddb1(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "".concat(e, " and ").concat(n, " cannot be used together."));
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $59fc9b849b320ded$var$__PRIVATE_validateDocumentPath(e) {
    if (!$59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(e)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but ".concat(e, " has ").concat(e.length, "."));
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $59fc9b849b320ded$var$__PRIVATE_validateCollectionPath(e) {
    if ($59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(e)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but ".concat(e, " has ").concat(e.length, "."));
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ /** Returns a string describing the type / value of the provided input. */ function $59fc9b849b320ded$var$__PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = "".concat(e.substring(0, 20), "...")), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            var t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? "a custom ".concat(t, " object") : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $59fc9b849b320ded$var$fail();
}
function $59fc9b849b320ded$export$572106fb5803752c(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            var n = $59fc9b849b320ded$var$__PRIVATE_valueDescription(e);
            throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Expected type '".concat(t.name, "', but it was: ").concat(n));
        }
    }
    return e;
}
function $59fc9b849b320ded$var$__PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Function ".concat(e, "() requires a positive number, but it was: ").concat(t, "."));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ var $59fc9b849b320ded$var$FirestoreSettingsImpl = /*#__PURE__*/ function() {
    "use strict";
    function FirestoreSettingsImpl(e) {
        (0, $978gY._)(this, FirestoreSettingsImpl);
        var t, n;
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = "firestore.googleapis.com", this.ssl = true;
        } else this.host = e.host, this.ssl = null === (t = e.ssl) || void 0 === t || t;
        if (this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = 41943040;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < 1048576) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $59fc9b849b320ded$export$8731e8d1617cddb1("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $59fc9b849b320ded$var$__PRIVATE_cloneLongPollingOptions(null !== (n = e.experimentalLongPollingOptions) && void 0 !== n ? n : {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(e.timeoutSeconds, " (must not be NaN)"));
                if (e.timeoutSeconds < 5) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(e.timeoutSeconds, " (minimum allowed value is 5)"));
                if (e.timeoutSeconds > 30) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "invalid long polling timeout: ".concat(e.timeoutSeconds, " (maximum allowed value is 30)"));
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    (0, $kry2a._)(FirestoreSettingsImpl, [
        {
            key: "isEqual",
            value: function isEqual(e) {
                return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && function __PRIVATE_longPollingOptionsEqual(e, t) {
                    return e.timeoutSeconds === t.timeoutSeconds;
                }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
            }
        }
    ]);
    return FirestoreSettingsImpl;
}();
var $59fc9b849b320ded$var$Firestore$1 = /*#__PURE__*/ function() {
    "use strict";
    function Firestore$1(e, t, n, r) {
        (0, $978gY._)(this, Firestore$1);
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $59fc9b849b320ded$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1;
    }
    (0, $kry2a._)(Firestore$1, [
        {
            key: "app",
            get: /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ function get() {
                if (!this._app) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
                return this._app;
            }
        },
        {
            key: "_initialized",
            get: function get() {
                return this._settingsFrozen;
            }
        },
        {
            key: "_terminated",
            get: function get() {
                return void 0 !== this._terminateTask;
            }
        },
        {
            key: "_setSettings",
            value: function _setSettings(e) {
                if (this._settingsFrozen) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
                this._settings = new $59fc9b849b320ded$var$FirestoreSettingsImpl(e), void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
                    if (!e) return new $59fc9b849b320ded$export$65ffa50b6039c992;
                    switch(e.type){
                        case "firstParty":
                            return new $59fc9b849b320ded$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                        case "provider":
                            return e.client;
                        default:
                            throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
                    }
                }(e.credentials));
            }
        },
        {
            key: "_getSettings",
            value: function _getSettings() {
                return this._settings;
            }
        },
        {
            key: "_freezeSettings",
            value: function _freezeSettings() {
                return this._settingsFrozen = !0, this._settings;
            }
        },
        {
            key: "_delete",
            value: function _delete() {
                return this._terminateTask || (this._terminateTask = this._terminate()), this._terminateTask;
            }
        },
        {
            /** Returns a JSON-serializable representation of this `Firestore` instance. */ key: "toJSON",
            value: function toJSON() {
                return {
                    app: this._app,
                    databaseId: this._databaseId,
                    settings: this._settings
                };
            }
        },
        {
            /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ key: "_terminate",
            value: function _terminate() {
                /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
                    var t = $59fc9b849b320ded$var$me.get(e);
                    t && ($59fc9b849b320ded$var$__PRIVATE_logDebug("ComponentProvider", "Removing Datastore"), $59fc9b849b320ded$var$me.delete(e), t.terminate());
                }(this), Promise.resolve();
            }
        }
    ]);
    return Firestore$1;
}();
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $59fc9b849b320ded$export$966a03d25297d115(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var i;
    var s = (e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$var$Firestore$1))._getSettings(), o = "".concat(t, ":").concat(n);
    if ("firestore.googleapis.com" !== s.host && s.host !== o && $59fc9b849b320ded$export$86cd73f49cc6e0bb("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used."), e._setSettings(Object.assign(Object.assign({}, s), {
        host: o,
        ssl: !1
    })), r.mockUserToken) {
        var _$t, _$n;
        if ("string" == typeof r.mockUserToken) _$t = r.mockUserToken, _$n = $59fc9b849b320ded$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            _$t = (0, $b1467a785fc7cec5$export$367bf224123348f1)(r.mockUserToken, null === (i = e._app) || void 0 === i ? void 0 : i.options.projectId);
            var s1 = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!s1) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            _$n = new $59fc9b849b320ded$var$User(s1);
        }
        e._authCredentials = new $59fc9b849b320ded$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $59fc9b849b320ded$var$__PRIVATE_OAuthToken(_$t, _$n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ var $59fc9b849b320ded$export$62297b13309008b2 = /*#__PURE__*/ function() {
    "use strict";
    function Query(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n) {
        (0, $978gY._)(this, Query);
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    (0, $kry2a._)(Query, [
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new Query(this.firestore, e, this._query);
            }
        }
    ]);
    return Query;
}();
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ var $59fc9b849b320ded$export$6be62b059fb12175 = /*#__PURE__*/ function() {
    "use strict";
    function DocumentReference(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n) {
        (0, $978gY._)(this, DocumentReference);
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    (0, $kry2a._)(DocumentReference, [
        {
            key: "_path",
            get: function get() {
                return this._key.path;
            }
        },
        {
            key: "id",
            get: /**
     * The document's identifier within its collection.
     */ function get() {
                return this._key.path.lastSegment();
            }
        },
        {
            key: "path",
            get: /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ function get() {
                return this._key.path.canonicalString();
            }
        },
        {
            key: "parent",
            get: /**
     * The collection this `DocumentReference` belongs to.
     */ function get() {
                return new $59fc9b849b320ded$export$ab5a1a47940a200e(this.firestore, this.converter, this._key.path.popLast());
            }
        },
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new DocumentReference(this.firestore, e, this._key);
            }
        }
    ]);
    return DocumentReference;
}();
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ var $59fc9b849b320ded$export$ab5a1a47940a200e = /*#__PURE__*/ function(Query) {
    "use strict";
    (0, $ftJVG._)(CollectionReference, Query);
    var _super = (0, $6OZAO._)(CollectionReference);
    function CollectionReference(e, t, n) {
        (0, $978gY._)(this, CollectionReference);
        var _this;
        _this = _super.call(this, e, t, $59fc9b849b320ded$var$__PRIVATE_newQueryForPath(n)), _this._path = n, /** The type of this Firestore reference. */ _this.type = "collection";
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(CollectionReference, [
        {
            key: "id",
            get: /** The collection's identifier. */ function get() {
                return this._query.path.lastSegment();
            }
        },
        {
            key: "path",
            get: /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ function get() {
                return this._query.path.canonicalString();
            }
        },
        {
            key: "parent",
            get: /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ function get() {
                var e = this._path.popLast();
                return e.isEmpty() ? null : new $59fc9b849b320ded$export$6be62b059fb12175(this.firestore, /* converter= */ null, new $59fc9b849b320ded$export$afc2e57c475b7810(e));
            }
        },
        {
            key: "withConverter",
            value: function withConverter(e) {
                return new CollectionReference(this.firestore, e, this._path);
            }
        }
    ]);
    return CollectionReference;
}($59fc9b849b320ded$export$62297b13309008b2);
function $59fc9b849b320ded$export$bf5175b0c24981cd(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    if (e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e), $59fc9b849b320ded$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $59fc9b849b320ded$var$Firestore$1) {
        var _ResourcePath;
        var r = (_ResourcePath = $59fc9b849b320ded$var$ResourcePath).fromString.apply(_ResourcePath, [
            t
        ].concat((0, $fLnyw._)(n)));
        return $59fc9b849b320ded$var$__PRIVATE_validateCollectionPath(r), new $59fc9b849b320ded$export$ab5a1a47940a200e(e, /* converter= */ null, r);
    }
    {
        var _ResourcePath1;
        if (!(e instanceof $59fc9b849b320ded$export$6be62b059fb12175 || e instanceof $59fc9b849b320ded$export$ab5a1a47940a200e)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        var r1 = e._path.child((_ResourcePath1 = $59fc9b849b320ded$var$ResourcePath).fromString.apply(_ResourcePath1, [
            t
        ].concat((0, $fLnyw._)(n))));
        return $59fc9b849b320ded$var$__PRIVATE_validateCollectionPath(r1), new $59fc9b849b320ded$export$ab5a1a47940a200e(e.firestore, /* converter= */ null, r1);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $59fc9b849b320ded$export$473d82a73f88c107(e, t) {
    if (e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$var$Firestore$1), $59fc9b849b320ded$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid collection ID '".concat(t, "' passed to function collectionGroup(). Collection IDs must not contain '/'."));
    return new $59fc9b849b320ded$export$62297b13309008b2(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl($59fc9b849b320ded$var$ResourcePath.emptyPath(), e);
    }(t));
}
function $59fc9b849b320ded$export$2a111da947c407d2(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    if (e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $59fc9b849b320ded$var$__PRIVATE_AutoId.V()), $59fc9b849b320ded$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $59fc9b849b320ded$var$Firestore$1) {
        var _ResourcePath;
        var r = (_ResourcePath = $59fc9b849b320ded$var$ResourcePath).fromString.apply(_ResourcePath, [
            t
        ].concat((0, $fLnyw._)(n)));
        return $59fc9b849b320ded$var$__PRIVATE_validateDocumentPath(r), new $59fc9b849b320ded$export$6be62b059fb12175(e, /* converter= */ null, new $59fc9b849b320ded$export$afc2e57c475b7810(r));
    }
    {
        var _ResourcePath1;
        if (!(e instanceof $59fc9b849b320ded$export$6be62b059fb12175 || e instanceof $59fc9b849b320ded$export$ab5a1a47940a200e)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        var r1 = e._path.child((_ResourcePath1 = $59fc9b849b320ded$var$ResourcePath).fromString.apply(_ResourcePath1, [
            t
        ].concat((0, $fLnyw._)(n))));
        return $59fc9b849b320ded$var$__PRIVATE_validateDocumentPath(r1), new $59fc9b849b320ded$export$6be62b059fb12175(e.firestore, e instanceof $59fc9b849b320ded$export$ab5a1a47940a200e ? e.converter : null, new $59fc9b849b320ded$export$afc2e57c475b7810(r1));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $59fc9b849b320ded$export$62a32f2da6187d11(e, t) {
    return e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e), t = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(t), (e instanceof $59fc9b849b320ded$export$6be62b059fb12175 || e instanceof $59fc9b849b320ded$export$ab5a1a47940a200e) && (t instanceof $59fc9b849b320ded$export$6be62b059fb12175 || t instanceof $59fc9b849b320ded$export$ab5a1a47940a200e) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $59fc9b849b320ded$export$49b1d0de6ba30f41(e, t) {
    return e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e), t = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(t), e instanceof $59fc9b849b320ded$export$62297b13309008b2 && t instanceof $59fc9b849b320ded$export$62297b13309008b2 && e.firestore === t.firestore && $59fc9b849b320ded$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$__PRIVATE_AsyncQueueImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_AsyncQueueImpl() {
        var _this = this;
        (0, $978gY._)(this, __PRIVATE_AsyncQueueImpl);
        // The last promise in the queue.
        this.Za = Promise.resolve(), // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.Xa = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.eu = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.tu = [], // visible for testing
        this.nu = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.ru = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.iu = !1, // List of TimerIds to fast-forward delays for.
        this.su = [], // Backoff timer used to schedule retries for retryable operations
        this.Ho = new $59fc9b849b320ded$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.ou = function() {
            var e = $59fc9b849b320ded$var$getDocument();
            e && $59fc9b849b320ded$var$__PRIVATE_logDebug("AsyncQueue", "Visibility state changed to " + e.visibilityState), _this.Ho.$o();
        };
        var e = $59fc9b849b320ded$var$getDocument();
        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.ou);
    }
    (0, $kry2a._)(__PRIVATE_AsyncQueueImpl, [
        {
            key: "isShuttingDown",
            get: function get() {
                return this.eu;
            }
        },
        {
            /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ key: "enqueueAndForget",
            value: function enqueueAndForget(e) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.enqueue(e);
            }
        },
        {
            key: "enqueueAndForgetEvenWhileRestricted",
            value: function enqueueAndForgetEvenWhileRestricted(e) {
                this._u(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.au(e);
            }
        },
        {
            key: "enterRestrictedMode",
            value: function enterRestrictedMode(e) {
                if (!this.eu) {
                    this.eu = !0, this.iu = e || !1;
                    var t = $59fc9b849b320ded$var$getDocument();
                    t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.ou);
                }
            }
        },
        {
            key: "enqueue",
            value: function enqueue(e) {
                var _this = this;
                if (this._u(), this.eu) // Return a Promise which never resolves.
                return new Promise(function() {});
                // Create a deferred Promise that we can return to the callee. This
                // allows us to return a "hanging Promise" only to the callee and still
                // advance the queue even when the operation is not run.
                var t = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
                return this.au(function() {
                    return _this.eu && _this.iu ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise);
                }).then(function() {
                    return t.promise;
                });
            }
        },
        {
            key: "enqueueRetryable",
            value: function enqueueRetryable(e) {
                var _this = this;
                this.enqueueAndForget(function() {
                    return _this.Xa.push(e), _this.uu();
                });
            }
        },
        {
            key: "uu",
            value: /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ function uu() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(0 !== _this.Xa.length)) return [
                                    3,
                                    5
                                ];
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    _this.Xa[0]()
                                ];
                            case 2:
                                _state.sent(), _this.Xa.shift(), _this.Ho.reset();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                e = _state.sent();
                                if (!$59fc9b849b320ded$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                                // Failure will be handled by AsyncQueue
                                $59fc9b849b320ded$var$__PRIVATE_logDebug("AsyncQueue", "Operation failed with retryable error: " + e);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                _this.Xa.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
                                // This is necessary to run retryable operations that failed during
                                // their initial attempt since we don't know whether they are already
                                // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
                                // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
                                // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
                                // call scheduled here.
                                // Since `backoffAndRun()` cancels an existing backoff and schedules a
                                // new backoff on every call, there is only ever a single additional
                                // operation in the queue.
                                _this.Ho.Qo(function() {
                                    return _this.uu();
                                });
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "au",
            value: function au(e) {
                var _this = this;
                var t = this.Za.then(function() {
                    return _this.ru = !0, e().catch(function(e) {
                        _this.nu = e, _this.ru = !1;
                        var t = /**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
                            var t = e.message || "";
                            e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack);
                            return t;
                        }(e);
                        // Re-throw the error so that this.tail becomes a rejected Promise and
                        // all further attempts to chain (via .then) will just short-circuit
                        // and return the rejected Promise.
                        throw $59fc9b849b320ded$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", t), e;
                    }).then(function(e) {
                        return _this.ru = !1, e;
                    });
                });
                return this.Za = t, t;
            }
        },
        {
            key: "enqueueAfterDelay",
            value: function enqueueAfterDelay(e, t, n) {
                var _this = this;
                this._u(), // Fast-forward delays for timerIds that have been overriden.
                this.su.indexOf(e) > -1 && (t = 0);
                var r = $59fc9b849b320ded$var$DelayedOperation.createAndSchedule(this, e, t, n, function(e) {
                    return _this.cu(e);
                });
                return this.tu.push(r), r;
            }
        },
        {
            key: "_u",
            value: function _u() {
                this.nu && $59fc9b849b320ded$var$fail();
            }
        },
        {
            key: "verifyOperationInProgress",
            value: function verifyOperationInProgress() {}
        },
        {
            key: "lu",
            value: /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ function lu() {
                var _this = this;
                return (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                    var e;
                    return (0, $7UAGh.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e = _this.Za;
                                return [
                                    4,
                                    e
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                if (e !== _this.Za) return [
                                    3,
                                    0
                                ];
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ key: "hu",
            value: function hu(e) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.tu[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var t = _step.value;
                        if (t.timerId === e) return !0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !1;
            }
        },
        {
            /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ key: "Pu",
            value: function Pu(e) {
                var _this = this;
                // Note that draining may generate more delayed ops, so we do that first.
                return this.lu().then(function() {
                    // Run ops in the same order they'd run if they ran naturally.
                    _this.tu.sort(function(e, t) {
                        return e.targetTimeMs - t.targetTimeMs;
                    });
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this.tu[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var t = _step.value;
                            if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _this.lu();
                });
            }
        },
        {
            /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ key: "Iu",
            value: function Iu(e) {
                this.su.push(e);
            }
        },
        {
            /** Called once a DelayedOperation is run or canceled. */ key: "cu",
            value: function cu(e) {
                // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
                var t = this.tu.indexOf(e);
                this.tu.splice(t, 1);
            }
        }
    ]);
    return __PRIVATE_AsyncQueueImpl;
}();
function $59fc9b849b320ded$var$__PRIVATE_isPartialObserver(e) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(e, t) {
        if ("object" != typeof e || null === e) return !1;
        var n = e;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                if (_$e in n && "function" == typeof n[_$e]) return !0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return !1;
    }(e, [
        "next",
        "error",
        "complete"
    ]);
}
var $59fc9b849b320ded$export$6cac12425252ec14 = /*#__PURE__*/ function() {
    "use strict";
    function LoadBundleTask() {
        (0, $978gY._)(this, LoadBundleTask);
        this._progressObserver = {}, this._taskCompletionResolver = new $59fc9b849b320ded$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    (0, $kry2a._)(LoadBundleTask, [
        {
            /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ key: "onProgress",
            value: function onProgress(e, t, n) {
                this._progressObserver = {
                    next: e,
                    error: t,
                    complete: n
                };
            }
        },
        {
            /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ key: "catch",
            value: function _catch(e) {
                return this._taskCompletionResolver.promise.catch(e);
            }
        },
        {
            /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ key: "then",
            value: function then(e, t) {
                return this._taskCompletionResolver.promise.then(e, t);
            }
        },
        {
            /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ key: "_completeWith",
            value: function _completeWith(e) {
                this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
            }
        },
        {
            /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ key: "_failWith",
            value: function _failWith(e) {
                this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
            }
        },
        {
            /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ key: "_updateProgress",
            value: function _updateProgress(e) {
                this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
            }
        }
    ]);
    return LoadBundleTask;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ var $59fc9b849b320ded$export$3e714f2ae27d2df4 = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ var $59fc9b849b320ded$export$d0e2b3272814ce82 = /*#__PURE__*/ function(Firestore$1) {
    "use strict";
    (0, $ftJVG._)(Firestore, Firestore$1);
    var _super = (0, $6OZAO._)(Firestore);
    function Firestore(e, t, n, r) {
        (0, $978gY._)(this, Firestore);
        var _this;
        _this = _super.call(this, e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ _this.type = "firestore", _this._queue = function __PRIVATE_newAsyncQueue() {
            return new $59fc9b849b320ded$var$__PRIVATE_AsyncQueueImpl;
        }(), _this._persistenceKey = (null == r ? void 0 : r.name) || "[DEFAULT]";
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(Firestore, [
        {
            key: "_terminate",
            value: function _terminate() {
                return this._firestoreClient || // The client must be initialized to ensure that all subsequent API
                // usage throws an exception.
                $59fc9b849b320ded$var$__PRIVATE_configureFirestore(this), this._firestoreClient.terminate();
            }
        }
    ]);
    return Firestore;
}($59fc9b849b320ded$var$Firestore$1);
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $59fc9b849b320ded$export$9061557f3e3b42f9(e, t, n) {
    n || (n = "(default)");
    var r = (0, $2b7c3095396a3894$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        var _$e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $b1467a785fc7cec5$export$9cb4719e2e525b7a)(i, t)) return _$e;
        throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < 1048576) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    return r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $59fc9b849b320ded$export$f06a05d14c3a6678(t, n) {
    var r = "object" == typeof t ? t : (0, $2b7c3095396a3894$export$f9962582c9e66d99)(), i = "string" == typeof t ? t : n || "(default)", s = (0, $2b7c3095396a3894$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        var e = (0, $b1467a785fc7cec5$export$a3febcf1f14a3a0c)("firestore");
        e && $59fc9b849b320ded$export$966a03d25297d115.apply(void 0, [
            s
        ].concat((0, $fLnyw._)(e)));
    }
    return s;
}
/**
 * @internal
 */ function $59fc9b849b320ded$export$8da5fbea04405656(e) {
    return e._firestoreClient || $59fc9b849b320ded$var$__PRIVATE_configureFirestore(e), e._firestoreClient.verifyNotTerminated(), e._firestoreClient;
}
function $59fc9b849b320ded$var$__PRIVATE_configureFirestore(e) {
    var t, n, r;
    var i = e._freezeSettings(), s = function __PRIVATE_makeDatabaseInfo(e, t, n, r) {
        return new $59fc9b849b320ded$var$DatabaseInfo(e, t, n, r.host, r.ssl, r.experimentalForceLongPolling, r.experimentalAutoDetectLongPolling, $59fc9b849b320ded$var$__PRIVATE_cloneLongPollingOptions(r.experimentalLongPollingOptions), r.useFetchStreams);
    }(e._databaseId, (null === (t = e._app) || void 0 === t ? void 0 : t.options.appId) || "", e._persistenceKey, i);
    e._firestoreClient = new $59fc9b849b320ded$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, s), (null === (n = i.localCache) || void 0 === n ? void 0 : n._offlineComponentProvider) && (null === (r = i.localCache) || void 0 === r ? void 0 : r._onlineComponentProvider) && (e._firestoreClient._uninitializedComponentsProvider = {
        _offlineKind: i.localCache.kind,
        _offline: i.localCache._offlineComponentProvider,
        _online: i.localCache._onlineComponentProvider
    });
}
/**
 * Attempts to enable persistent storage, if possible.
 *
 * Must be called before any other functions (other than
 * {@link initializeFirestore}, {@link (getFirestore:1)} or
 * {@link clearIndexedDbPersistence}.
 *
 * If this fails, `enableIndexedDbPersistence()` will reject the promise it
 * returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * Persistence cannot be used in a Node.js environment.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @param persistenceSettings - Optional settings object to configure
 * persistence.
 * @returns A `Promise` that represents successfully enabling persistent storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on IndexedDb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function $59fc9b849b320ded$export$cebe3b626a79c5f3(e, t) {
    $59fc9b849b320ded$var$__PRIVATE_verifyNotInitialized(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82));
    var n = $59fc9b849b320ded$export$8da5fbea04405656(e);
    if (n._uninitializedComponentsProvider) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "SDK cache is already specified.");
    $59fc9b849b320ded$export$86cd73f49cc6e0bb("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    var r = e._freezeSettings(), i = new $59fc9b849b320ded$var$OnlineComponentProvider;
    return $59fc9b849b320ded$var$__PRIVATE_setPersistenceProviders(n, i, new $59fc9b849b320ded$var$__PRIVATE_IndexedDbOfflineComponentProvider(i, r.cacheSizeBytes, null == t ? void 0 : t.forceOwnership));
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * If this fails, `enableMultiTabIndexedDbPersistence()` will reject the promise
 * it returns. Note that even after this failure, the {@link Firestore} instance will
 * remain usable, however offline persistence will be disabled.
 *
 * There are several reasons why this can fail, which can be identified by
 * the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline
 *     persistence implementation.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ function $59fc9b849b320ded$export$6d4c055e91302ab9(e) {
    $59fc9b849b320ded$var$__PRIVATE_verifyNotInitialized(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82));
    var t = $59fc9b849b320ded$export$8da5fbea04405656(e);
    if (t._uninitializedComponentsProvider) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "SDK cache is already specified.");
    $59fc9b849b320ded$export$86cd73f49cc6e0bb("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    var n = e._freezeSettings(), r = new $59fc9b849b320ded$var$OnlineComponentProvider;
    return $59fc9b849b320ded$var$__PRIVATE_setPersistenceProviders(t, r, new $59fc9b849b320ded$var$__PRIVATE_MultiTabOfflineComponentProvider(r, n.cacheSizeBytes));
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $59fc9b849b320ded$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    var r = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueue(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var e1, _$t;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_setOfflineComponentProvider(e, n)
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        $59fc9b849b320ded$var$__PRIVATE_setOnlineComponentProvider(e, t)
                    ];
                case 2:
                    _state.sent(), r.resolve();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e1 = _state.sent();
                    _$t = e1;
                    if (!$59fc9b849b320ded$var$__PRIVATE_canFallbackFromIndexedDbError(_$t)) throw _$t;
                    $59fc9b849b320ded$export$86cd73f49cc6e0bb("Error enabling indexeddb cache. Falling back to memory cache: " + _$t), r.reject(_$t);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })).then(function() {
        return r.promise;
    });
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $59fc9b849b320ded$export$b4f5899b4e28cf7b(e) {
    if (e._initialized && !e._terminated) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    var t = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        var e1;
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (function() {
                            var ___PRIVATE_indexedDbClearPersistence = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
                                var t;
                                return (0, $7UAGh.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!$59fc9b849b320ded$var$__PRIVATE_SimpleDb.C()) return [
                                                2,
                                                Promise.resolve()
                                            ];
                                            t = e + "main";
                                            return [
                                                4,
                                                $59fc9b849b320ded$var$__PRIVATE_SimpleDb.delete(t)
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            function __PRIVATE_indexedDbClearPersistence(e) {
                                return ___PRIVATE_indexedDbClearPersistence.apply(this, arguments);
                            }
                            return __PRIVATE_indexedDbClearPersistence;
                        })()($59fc9b849b320ded$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey))
                    ];
                case 1:
                    _state.sent(), t.resolve();
                    return [
                        3,
                        3
                    ];
                case 2:
                    e1 = _state.sent();
                    t.reject(e1);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $59fc9b849b320ded$export$50b5113fd6653025(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        var t = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_getSyncEngine(e)
                        ];
                    case 1:
                        return [
                            2,
                            $59fc9b849b320ded$var$__PRIVATE_syncEngineRegisterPendingWritesCallback.apply(void 0, [
                                _state.sent(),
                                t
                            ])
                        ];
                }
            });
        })), t.promise;
    }($59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $59fc9b849b320ded$export$ee6bdee8287ecc5f(e) {
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientEnableNetwork($59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $59fc9b849b320ded$export$f35b708ad73d52eb(e) {
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientDisableNetwork($59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $59fc9b849b320ded$export$9aff22d1ec357a14(e) {
    return (0, $2b7c3095396a3894$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $59fc9b849b320ded$export$4b8b93c690c9810b(e, t) {
    var n = $59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82)), r = new $59fc9b849b320ded$export$6cac12425252ec14;
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $59fc9b849b320ded$export$169d2c6fe0f7f4ea(e, t) {
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetNamedQuery($59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82)), t).then(function(t) {
        return t ? new $59fc9b849b320ded$export$62297b13309008b2(e, null, t.query) : null;
    });
}
function $59fc9b849b320ded$var$__PRIVATE_verifyNotInitialized(e) {
    if (e._initialized || e._terminated) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $59fc9b849b320ded$export$fada2345be8928cf = function AggregateField() {
    "use strict";
    var // TODO (sum/avg) make aggregateType public when the feature is supported
    e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "count", t = arguments.length > 1 ? arguments[1] : void 0;
    (0, $978gY._)(this, AggregateField);
    this._aggregateType = e, this._internalFieldPath = t, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField";
};
/**
 * The results of executing an aggregation query.
 */ var $59fc9b849b320ded$export$40257fef64be808b = /*#__PURE__*/ function() {
    "use strict";
    function AggregateQuerySnapshot(e, t, n) {
        (0, $978gY._)(this, AggregateQuerySnapshot);
        this._userDataWriter = t, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = e;
    }
    (0, $kry2a._)(AggregateQuerySnapshot, [
        {
            /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ key: "data",
            value: function data() {
                return this._userDataWriter.convertObjectMap(this._data);
            }
        }
    ]);
    return AggregateQuerySnapshot;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ var $59fc9b849b320ded$export$9f55f2e2bf8c2fc1 = /*#__PURE__*/ function() {
    "use strict";
    function Bytes(e) {
        (0, $978gY._)(this, Bytes);
        this._byteString = e;
    }
    (0, $kry2a._)(Bytes, [
        {
            /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ key: "toBase64",
            value: function toBase64() {
                return this._byteString.toBase64();
            }
        },
        {
            /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ key: "toUint8Array",
            value: function toUint8Array() {
                return this._byteString.toUint8Array();
            }
        },
        {
            /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ key: "toString",
            value: function toString() {
                return "Bytes(base64: " + this.toBase64() + ")";
            }
        },
        {
            /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._byteString.isEqual(e._byteString);
            }
        }
    ], [
        {
            key: "fromBase64String",
            value: /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ function fromBase64String(e) {
                try {
                    return new Bytes($59fc9b849b320ded$export$67460cdabfa21253.fromBase64String(e));
                } catch (e) {
                    throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
                }
            }
        },
        {
            key: "fromUint8Array",
            value: /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ function fromUint8Array(e) {
                return new Bytes($59fc9b849b320ded$export$67460cdabfa21253.fromUint8Array(e));
            }
        }
    ]);
    return Bytes;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ var $59fc9b849b320ded$export$a1a8fea822d17659 = /*#__PURE__*/ function() {
    "use strict";
    function FieldPath() {
        for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
            e[_key] = arguments[_key];
        }
        (0, $978gY._)(this, FieldPath);
        for(var t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $59fc9b849b320ded$export$b7871852b967eaf1(e);
    }
    (0, $kry2a._)(FieldPath, [
        {
            /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._internalPath.isEqual(e._internalPath);
            }
        }
    ]);
    return FieldPath;
}();
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $59fc9b849b320ded$export$bf6e62266977b8eb() {
    return new $59fc9b849b320ded$export$a1a8fea822d17659("__name__");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ var $59fc9b849b320ded$export$c58bc8ee7ecc248d = function FieldValue(e) {
    "use strict";
    (0, $978gY._)(this, FieldValue);
    this._methodName = e;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ var $59fc9b849b320ded$export$f9f719d1b6419c4 = /*#__PURE__*/ function() {
    "use strict";
    function GeoPoint(e, t) {
        (0, $978gY._)(this, GeoPoint);
        if (!isFinite(e) || e < -90 || e > 90) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    (0, $kry2a._)(GeoPoint, [
        {
            key: "latitude",
            get: /**
     * The latitude of this `GeoPoint` instance.
     */ function get() {
                return this._lat;
            }
        },
        {
            key: "longitude",
            get: /**
     * The longitude of this `GeoPoint` instance.
     */ function get() {
                return this._long;
            }
        },
        {
            /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this._lat === e._lat && this._long === e._long;
            }
        },
        {
            /** Returns a JSON-serializable representation of this GeoPoint. */ key: "toJSON",
            value: function toJSON() {
                return {
                    latitude: this._lat,
                    longitude: this._long
                };
            }
        },
        {
            /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ key: "_compareTo",
            value: function _compareTo(e) {
                return $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $59fc9b849b320ded$var$__PRIVATE_primitiveComparator(this._long, e._long);
            }
        }
    ]);
    return GeoPoint;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$ge = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ var $59fc9b849b320ded$var$ParsedSetData = /*#__PURE__*/ function() {
    "use strict";
    function ParsedSetData(e, t, n) {
        (0, $978gY._)(this, ParsedSetData);
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    (0, $kry2a._)(ParsedSetData, [
        {
            key: "toMutation",
            value: function toMutation(e, t) {
                return null !== this.fieldMask ? new $59fc9b849b320ded$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $59fc9b849b320ded$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
            }
        }
    ]);
    return ParsedSetData;
}();
/** The result of parsing "update" data (i.e. for an updateData call). */ var $59fc9b849b320ded$var$ParsedUpdateData = /*#__PURE__*/ function() {
    "use strict";
    function ParsedUpdateData(e, // The fieldMask does not include document transforms.
    t, n) {
        (0, $978gY._)(this, ParsedUpdateData);
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    (0, $kry2a._)(ParsedUpdateData, [
        {
            key: "toMutation",
            value: function toMutation(e, t) {
                return new $59fc9b849b320ded$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
            }
        }
    ]);
    return ParsedUpdateData;
}();
function $59fc9b849b320ded$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $59fc9b849b320ded$var$fail();
    }
}
/** A "context" object passed around while parsing user data. */ var $59fc9b849b320ded$var$__PRIVATE_ParseContextImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_ParseContextImpl(e, t, n, r, i, s) {
        (0, $978gY._)(this, __PRIVATE_ParseContextImpl);
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.du(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    (0, $kry2a._)(__PRIVATE_ParseContextImpl, [
        {
            key: "path",
            get: function get() {
                return this.settings.path;
            }
        },
        {
            key: "Tu",
            get: function get() {
                return this.settings.Tu;
            }
        },
        {
            /** Returns a new context with the specified settings overwritten. */ key: "Eu",
            value: function Eu(e) {
                return new __PRIVATE_ParseContextImpl(Object.assign(Object.assign({}, this.settings), e), this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
            }
        },
        {
            key: "Au",
            value: function Au(e) {
                var t;
                var n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Eu({
                    path: n,
                    Ru: !1
                });
                return r.Vu(e), r;
            }
        },
        {
            key: "mu",
            value: function mu(e) {
                var t;
                var n = null === (t = this.path) || void 0 === t ? void 0 : t.child(e), r = this.Eu({
                    path: n,
                    Ru: !1
                });
                return r.du(), r;
            }
        },
        {
            key: "fu",
            value: function fu(e) {
                // TODO(b/34871131): We don't support array paths right now; so make path
                // undefined.
                return this.Eu({
                    path: void 0,
                    Ru: !0
                });
            }
        },
        {
            key: "gu",
            value: function gu(e) {
                return $59fc9b849b320ded$var$__PRIVATE_createError(e, this.settings.methodName, this.settings.pu || !1, this.path, this.settings.yu);
            }
        },
        {
            /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ key: "contains",
            value: function contains(e) {
                return void 0 !== this.fieldMask.find(function(t) {
                    return e.isPrefixOf(t);
                }) || void 0 !== this.fieldTransforms.find(function(t) {
                    return e.isPrefixOf(t.field);
                });
            }
        },
        {
            key: "du",
            value: function du() {
                // TODO(b/34871131): Remove null check once we have proper paths for fields
                // within arrays.
                if (this.path) for(var e = 0; e < this.path.length; e++)this.Vu(this.path.get(e));
            }
        },
        {
            key: "Vu",
            value: function Vu(e) {
                if (0 === e.length) throw this.gu("Document fields must not be empty");
                if ($59fc9b849b320ded$var$__PRIVATE_isWrite(this.Tu) && $59fc9b849b320ded$var$ge.test(e)) throw this.gu('Document fields cannot begin and end with "__"');
            }
        }
    ]);
    return __PRIVATE_ParseContextImpl;
}();
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ var $59fc9b849b320ded$var$__PRIVATE_UserDataReader = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_UserDataReader(e, t, n) {
        (0, $978gY._)(this, __PRIVATE_UserDataReader);
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $59fc9b849b320ded$var$__PRIVATE_newSerializer(e);
    }
    (0, $kry2a._)(__PRIVATE_UserDataReader, [
        {
            /** Creates a new top-level parse context. */ key: "wu",
            value: function wu(e, t, n) {
                var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
                return new $59fc9b849b320ded$var$__PRIVATE_ParseContextImpl({
                    Tu: e,
                    methodName: t,
                    yu: n,
                    path: $59fc9b849b320ded$export$b7871852b967eaf1.emptyPath(),
                    Ru: !1,
                    pu: r
                }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
            }
        }
    ]);
    return __PRIVATE_UserDataReader;
}();
function $59fc9b849b320ded$var$__PRIVATE_newUserDataReader(e) {
    var t = e._freezeSettings(), n = $59fc9b849b320ded$var$__PRIVATE_newSerializer(e._databaseId);
    return new $59fc9b849b320ded$var$__PRIVATE_UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $59fc9b849b320ded$var$__PRIVATE_parseSetData(e, t, n, r, i) {
    var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    var o = e.wu(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $59fc9b849b320ded$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", o, r);
    var _ = $59fc9b849b320ded$var$__PRIVATE_parseObject(r, o);
    var a, u;
    if (s.merge) a = new $59fc9b849b320ded$var$FieldMask(o.fieldMask), u = o.fieldTransforms;
    else if (s.mergeFields) {
        var _$e = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = s.mergeFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$r = _step.value;
                var _$i = $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument$1(t, _$r, n);
                if (!o.contains(_$i)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Field '".concat(_$i, "' is specified in your field mask but missing from your input data."));
                $59fc9b849b320ded$var$__PRIVATE_fieldMaskContains(_$e, _$i) || _$e.push(_$i);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        a = new $59fc9b849b320ded$var$FieldMask(_$e), u = o.fieldTransforms.filter(function(e) {
            return a.covers(e.field);
        });
    } else a = null, u = o.fieldTransforms;
    return new $59fc9b849b320ded$var$ParsedSetData(new $59fc9b849b320ded$var$ObjectValue(_), a, u);
}
var $59fc9b849b320ded$var$__PRIVATE_DeleteFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_DeleteFieldValueImpl, FieldValue);
    var _super = (0, $6OZAO._)(__PRIVATE_DeleteFieldValueImpl);
    function __PRIVATE_DeleteFieldValueImpl() {
        (0, $978gY._)(this, __PRIVATE_DeleteFieldValueImpl);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(__PRIVATE_DeleteFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                if (2 /* UserDataSource.MergeSet */  !== e.Tu) throw 1 /* UserDataSource.Update */  === e.Tu ? e.gu("".concat(this._methodName, "() can only appear at the top level of your update data")) : e.gu("".concat(this._methodName, "() cannot be used with set() unless you pass {merge:true}"));
                // No transform to add for a delete, but we need to add it to our
                // fieldMask so it gets deleted.
                return e.fieldMask.push(e.path), null;
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_DeleteFieldValueImpl;
            }
        }
    ]);
    return __PRIVATE_DeleteFieldValueImpl;
}($59fc9b849b320ded$export$c58bc8ee7ecc248d);
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $59fc9b849b320ded$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $59fc9b849b320ded$var$__PRIVATE_ParseContextImpl({
        Tu: 3 /* UserDataSource.Argument */ ,
        yu: t.settings.yu,
        methodName: e._methodName,
        Ru: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
var $59fc9b849b320ded$var$__PRIVATE_ServerTimestampFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ServerTimestampFieldValueImpl, FieldValue);
    var _super = (0, $6OZAO._)(__PRIVATE_ServerTimestampFieldValueImpl);
    function __PRIVATE_ServerTimestampFieldValueImpl() {
        (0, $978gY._)(this, __PRIVATE_ServerTimestampFieldValueImpl);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(__PRIVATE_ServerTimestampFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                return new $59fc9b849b320ded$var$FieldTransform(e.path, new $59fc9b849b320ded$var$__PRIVATE_ServerTimestampTransform);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                return e instanceof __PRIVATE_ServerTimestampFieldValueImpl;
            }
        }
    ]);
    return __PRIVATE_ServerTimestampFieldValueImpl;
}($59fc9b849b320ded$export$c58bc8ee7ecc248d);
var $59fc9b849b320ded$var$__PRIVATE_ArrayUnionFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ArrayUnionFieldValueImpl, FieldValue);
    var _super = (0, $6OZAO._)(__PRIVATE_ArrayUnionFieldValueImpl);
    function __PRIVATE_ArrayUnionFieldValueImpl(e, t) {
        (0, $978gY._)(this, __PRIVATE_ArrayUnionFieldValueImpl);
        var _this;
        _this = _super.call(this, e), _this.Su = t;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_ArrayUnionFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Su.map(function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_parseData(e, t);
                }), r = new $59fc9b849b320ded$var$__PRIVATE_ArrayUnionTransformOperation(n);
                return new $59fc9b849b320ded$var$FieldTransform(e.path, r);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                // TODO(mrschmidt): Implement isEquals
                return this === e;
            }
        }
    ]);
    return __PRIVATE_ArrayUnionFieldValueImpl;
}($59fc9b849b320ded$export$c58bc8ee7ecc248d);
var $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ArrayRemoveFieldValueImpl, FieldValue);
    var _super = (0, $6OZAO._)(__PRIVATE_ArrayRemoveFieldValueImpl);
    function __PRIVATE_ArrayRemoveFieldValueImpl(e, t) {
        (0, $978gY._)(this, __PRIVATE_ArrayRemoveFieldValueImpl);
        var _this;
        _this = _super.call(this, e), _this.Su = t;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_ArrayRemoveFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Su.map(function(e) {
                    return $59fc9b849b320ded$var$__PRIVATE_parseData(e, t);
                }), r = new $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveTransformOperation(n);
                return new $59fc9b849b320ded$var$FieldTransform(e.path, r);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                // TODO(mrschmidt): Implement isEquals
                return this === e;
            }
        }
    ]);
    return __PRIVATE_ArrayRemoveFieldValueImpl;
}($59fc9b849b320ded$export$c58bc8ee7ecc248d);
var $59fc9b849b320ded$var$__PRIVATE_NumericIncrementFieldValueImpl = /*#__PURE__*/ function(FieldValue) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_NumericIncrementFieldValueImpl, FieldValue);
    var _super = (0, $6OZAO._)(__PRIVATE_NumericIncrementFieldValueImpl);
    function __PRIVATE_NumericIncrementFieldValueImpl(e, t) {
        (0, $978gY._)(this, __PRIVATE_NumericIncrementFieldValueImpl);
        var _this;
        _this = _super.call(this, e), _this.bu = t;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_NumericIncrementFieldValueImpl, [
        {
            key: "_toFieldTransform",
            value: function _toFieldTransform(e) {
                var t = new $59fc9b849b320ded$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $59fc9b849b320ded$var$toNumber(e.serializer, this.bu));
                return new $59fc9b849b320ded$var$FieldTransform(e.path, t);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(e) {
                // TODO(mrschmidt): Implement isEquals
                return this === e;
            }
        }
    ]);
    return __PRIVATE_NumericIncrementFieldValueImpl;
}($59fc9b849b320ded$export$c58bc8ee7ecc248d);
/** Parse update data from an update() call. */ function $59fc9b849b320ded$var$__PRIVATE_parseUpdateData(e, t, n, r) {
    var i = e.wu(1 /* UserDataSource.Update */ , t, n);
    $59fc9b849b320ded$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    var s = [], o = $59fc9b849b320ded$var$ObjectValue.empty();
    $59fc9b849b320ded$var$forEach(r, function(e, r) {
        var _ = $59fc9b849b320ded$var$__PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(r);
        var a = i.mu(_);
        if (r instanceof $59fc9b849b320ded$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(_);
        else {
            var _$e = $59fc9b849b320ded$var$__PRIVATE_parseData(r, a);
            null != _$e && (s.push(_), o.set(_, _$e));
        }
    });
    var _ = new $59fc9b849b320ded$var$FieldMask(s);
    return new $59fc9b849b320ded$var$ParsedUpdateData(o, _, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $59fc9b849b320ded$var$__PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    var o = e.wu(1 /* UserDataSource.Update */ , t, n), _ = [
        $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument$1(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Function ".concat(t, "() needs to be called with an even number of arguments that alternate between field names and values."));
    for(var _$e = 0; _$e < s.length; _$e += 2)_.push($59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument$1(t, s[_$e])), a.push(s[_$e + 1]);
    var u = [], c = $59fc9b849b320ded$var$ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(var _$e1 = _.length - 1; _$e1 >= 0; --_$e1)if (!$59fc9b849b320ded$var$__PRIVATE_fieldMaskContains(u, _[_$e1])) {
        var _$t = _[_$e1];
        var _$n = a[_$e1];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        _$n = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(_$n);
        var _$r = o.mu(_$t);
        if (_$n instanceof $59fc9b849b320ded$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(_$t);
        else {
            var _$e2 = $59fc9b849b320ded$var$__PRIVATE_parseData(_$n, _$r);
            null != _$e2 && (u.push(_$t), c.set(_$t, _$e2));
        }
    }
    var l = new $59fc9b849b320ded$var$FieldMask(u);
    return new $59fc9b849b320ded$var$ParsedUpdateData(c, l, o.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $59fc9b849b320ded$var$__PRIVATE_parseQueryValue(e, t, n) {
    var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    return $59fc9b849b320ded$var$__PRIVATE_parseData(n, e.wu(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $59fc9b849b320ded$var$__PRIVATE_parseData(e, t) {
    if ($59fc9b849b320ded$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e))) return $59fc9b849b320ded$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $59fc9b849b320ded$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $59fc9b849b320ded$export$c58bc8ee7ecc248d) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$59fc9b849b320ded$var$__PRIVATE_isWrite(t.Tu)) throw t.gu("".concat(e._methodName, "() can only be used with update() and set()"));
        if (!t.path) throw t.gu("".concat(e._methodName, "() is not currently supported inside arrays"));
        var n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.Ru && 4 /* UserDataSource.ArrayArgument */  !== t.Tu) throw t.gu("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            var n = [];
            var r = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    var _$e = $59fc9b849b320ded$var$__PRIVATE_parseData(i, t.fu(r));
                    null == _$e && // Just include nulls in the array for fields being replaced with a
                    // sentinel.
                    (_$e = {
                        nullValue: "NULL_VALUE"
                    }), n.push(_$e), r++;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t) {
        if (null === (e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $59fc9b849b320ded$var$toNumber(t.serializer, e);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            var n = $59fc9b849b320ded$export$d9bcbd5e1ff81430.fromDate(e);
            return {
                timestampValue: $59fc9b849b320ded$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $59fc9b849b320ded$export$d9bcbd5e1ff81430) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            var n1 = new $59fc9b849b320ded$export$d9bcbd5e1ff81430(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $59fc9b849b320ded$var$toTimestamp(t.serializer, n1)
            };
        }
        if (e instanceof $59fc9b849b320ded$export$f9f719d1b6419c4) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $59fc9b849b320ded$export$9f55f2e2bf8c2fc1) return {
            bytesValue: $59fc9b849b320ded$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $59fc9b849b320ded$export$6be62b059fb12175) {
            var n2 = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n2)) throw t.gu("Document reference is for database ".concat(r.projectId, "/").concat(r.database, " but should be for database ").concat(n2.projectId, "/").concat(n2.database));
            return {
                referenceValue: $59fc9b849b320ded$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        throw t.gu("Unsupported field value: ".concat($59fc9b849b320ded$var$__PRIVATE_valueDescription(e)));
    }(e, t);
}
function $59fc9b849b320ded$var$__PRIVATE_parseObject(e, t) {
    var n = {};
    return $59fc9b849b320ded$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $59fc9b849b320ded$var$forEach(e, function(e, r) {
        var i = $59fc9b849b320ded$var$__PRIVATE_parseData(r, t.Au(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $59fc9b849b320ded$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $59fc9b849b320ded$export$d9bcbd5e1ff81430 || e instanceof $59fc9b849b320ded$export$f9f719d1b6419c4 || e instanceof $59fc9b849b320ded$export$9f55f2e2bf8c2fc1 || e instanceof $59fc9b849b320ded$export$6be62b059fb12175 || e instanceof $59fc9b849b320ded$export$c58bc8ee7ecc248d);
}
function $59fc9b849b320ded$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$59fc9b849b320ded$var$__PRIVATE_looksLikeJsonObject(n) || !function __PRIVATE_isPlainObject(e) {
        return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
    }(n)) {
        var r = $59fc9b849b320ded$var$__PRIVATE_valueDescription(n);
        throw "an object" === r ? t.gu(e + " a custom object") : t.gu(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument$1(e, t, n) {
    if (// If required, replace the FieldPath Compat class with with the firestore-exp
    // FieldPath.
    (t = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(t)) instanceof $59fc9b849b320ded$export$a1a8fea822d17659) return t._internalPath;
    if ("string" == typeof t) return $59fc9b849b320ded$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw $59fc9b849b320ded$var$__PRIVATE_createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ var $59fc9b849b320ded$var$pe = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $59fc9b849b320ded$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search($59fc9b849b320ded$var$pe) >= 0) throw $59fc9b849b320ded$var$__PRIVATE_createError("Invalid field path (".concat(t, "). Paths must not contain '~', '*', '/', '[', or ']'"), e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return (0, $34cAK._)($59fc9b849b320ded$export$a1a8fea822d17659, (0, $fLnyw._)(t.split(".")))._internalPath;
    } catch (r) {
        throw $59fc9b849b320ded$var$__PRIVATE_createError("Invalid field path (".concat(t, "). Paths must not be empty, begin with '.', end with '.', or contain '..'"), e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $59fc9b849b320ded$var$__PRIVATE_createError(e, t, n, r, i) {
    var s = r && !r.isEmpty(), o = void 0 !== i;
    var _ = "Function ".concat(t, "() called with invalid data");
    n && (_ += " (via `toFirestore()`)"), _ += ". ";
    var a = "";
    return (s || o) && (a += " (found", s && (a += " in field ".concat(r)), o && (a += " in document ".concat(i)), a += ")"), new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, _ + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $59fc9b849b320ded$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some(function(e) {
        return e.isEqual(t);
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ var $59fc9b849b320ded$var$DocumentSnapshot$1 = /*#__PURE__*/ function() {
    "use strict";
    function DocumentSnapshot$1(e, t, n, r, i) {
        (0, $978gY._)(this, DocumentSnapshot$1);
        this._firestore = e, this._userDataWriter = t, this._key = n, this._document = r, this._converter = i;
    }
    (0, $kry2a._)(DocumentSnapshot$1, [
        {
            key: "id",
            get: /** Property of the `DocumentSnapshot` that provides the document's ID. */ function get() {
                return this._key.path.lastSegment();
            }
        },
        {
            key: "ref",
            get: /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ function get() {
                return new $59fc9b849b320ded$export$6be62b059fb12175(this._firestore, this._converter, this._key);
            }
        },
        {
            /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ key: "exists",
            value: function exists() {
                return null !== this._document;
            }
        },
        {
            /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ key: "data",
            value: function data() {
                if (this._document) {
                    if (this._converter) {
                        // We only want to use the converter and create a new DocumentSnapshot
                        // if a converter has been provided.
                        var e = new $59fc9b849b320ded$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                        return this._converter.fromFirestore(e);
                    }
                    return this._userDataWriter.convertValue(this._document.data.value);
                }
            }
        },
        {
            /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "get",
            value: function get(e) {
                if (this._document) {
                    var t = this._document.data.field($59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
                    if (null !== t) return this._userDataWriter.convertValue(t);
                }
            }
        }
    ]);
    return DocumentSnapshot$1;
}();
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ var $59fc9b849b320ded$var$QueryDocumentSnapshot$1 = /*#__PURE__*/ function(DocumentSnapshot$1) {
    "use strict";
    (0, $ftJVG._)(QueryDocumentSnapshot$1, DocumentSnapshot$1);
    var _super = (0, $6OZAO._)(QueryDocumentSnapshot$1);
    function QueryDocumentSnapshot$1() {
        (0, $978gY._)(this, QueryDocumentSnapshot$1);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(QueryDocumentSnapshot$1, [
        {
            /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ key: "data",
            value: function data() {
                return (0, $3cct3._)((0, $g3d7z._)(QueryDocumentSnapshot$1.prototype), "data", this).call(this);
            }
        }
    ]);
    return QueryDocumentSnapshot$1;
}($59fc9b849b320ded$var$DocumentSnapshot$1);
/**
 * Helper that calls `fromDotSeparatedString()` but wraps any error thrown.
 */ function $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument(e, t) {
    return "string" == typeof t ? $59fc9b849b320ded$var$__PRIVATE_fieldPathFromDotSeparatedString(e, t) : t instanceof $59fc9b849b320ded$export$a1a8fea822d17659 ? t._internalPath : t._delegate._internalPath;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fc9b849b320ded$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e) {
    if ("L" /* LimitType.Last */  === e.limitType && 0 === e.explicitOrderBy.length) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ var $59fc9b849b320ded$var$AppliableConstraint = function AppliableConstraint() {
    "use strict";
    (0, $978gY._)(this, AppliableConstraint);
};
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ var $59fc9b849b320ded$export$b0e86f2c7431df4e = /*#__PURE__*/ function(AppliableConstraint) {
    "use strict";
    (0, $ftJVG._)(QueryConstraint, AppliableConstraint);
    var _super = (0, $6OZAO._)(QueryConstraint);
    function QueryConstraint() {
        (0, $978gY._)(this, QueryConstraint);
        return _super.apply(this, arguments);
    }
    return QueryConstraint;
}($59fc9b849b320ded$var$AppliableConstraint);
function $59fc9b849b320ded$export$2fa187e846a241c4(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    var r = [];
    t instanceof $59fc9b849b320ded$var$AppliableConstraint && r.push(t), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(e) {
        var _$t = e.filter(function(e) {
            return e instanceof $59fc9b849b320ded$export$6bbc7aef0717f3d2;
        }).length, n = e.filter(function(e) {
            return e instanceof $59fc9b849b320ded$export$f765fc5789dfd439;
        }).length;
        if (_$t > 1 || _$t > 0 && n > 0) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _$t = _step.value;
            e = _$t._apply(e);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ var $59fc9b849b320ded$export$f765fc5789dfd439 = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $ftJVG._)(QueryFieldFilterConstraint, QueryConstraint);
    var _super = (0, $6OZAO._)(QueryFieldFilterConstraint);
    function QueryFieldFilterConstraint(e, t, n) {
        (0, $978gY._)(this, QueryFieldFilterConstraint);
        var _this;
        _this = _super.call(this), _this._field = e, _this._op = t, _this._value = n, /** The type of this query constraint */ _this.type = "where";
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(QueryFieldFilterConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = this._parse(e);
                return $59fc9b849b320ded$var$__PRIVATE_validateNewFieldFilter(e._query, t), new $59fc9b849b320ded$export$62297b13309008b2(e.firestore, e.converter, $59fc9b849b320ded$var$__PRIVATE_queryWithAddedFilter(e._query, t));
            }
        },
        {
            key: "_parse",
            value: function _parse(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_newUserDataReader(e.firestore), n = function __PRIVATE_newQueryFilter(e, t, n, r, i, s, o) {
                    var _;
                    if (i.isKeyField()) {
                        if ("array-contains" /* Operator.ARRAY_CONTAINS */  === s || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === s) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid Query. You can't perform '".concat(s, "' queries on documentId()."));
                        if ("in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s) {
                            $59fc9b849b320ded$var$__PRIVATE_validateDisjunctiveFilterElements(o, s);
                            var _$t = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$n = _step.value;
                                    _$t.push($59fc9b849b320ded$var$__PRIVATE_parseDocumentIdValue(r, e, _$n));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _ = {
                                arrayValue: {
                                    values: _$t
                                }
                            };
                        } else _ = $59fc9b849b320ded$var$__PRIVATE_parseDocumentIdValue(r, e, o);
                    } else "in" /* Operator.IN */  !== s && "not-in" /* Operator.NOT_IN */  !== s && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== s || $59fc9b849b320ded$var$__PRIVATE_validateDisjunctiveFilterElements(o, s), _ = $59fc9b849b320ded$var$__PRIVATE_parseQueryValue(n, t, o, /* allowArrays= */ "in" /* Operator.IN */  === s || "not-in" /* Operator.NOT_IN */  === s);
                    return $59fc9b849b320ded$var$FieldFilter.create(i, s, _);
                }(e._query, "where", t, e.firestore._databaseId, this._field, this._op, this._value);
                return n;
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryFieldFilterConstraint(e, t, n);
            }
        }
    ]);
    return QueryFieldFilterConstraint;
}($59fc9b849b320ded$export$b0e86f2c7431df4e);
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $59fc9b849b320ded$export$9c59b80dda569a6e(e, t, n) {
    var r = t, i = $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument("where", e);
    return $59fc9b849b320ded$export$f765fc5789dfd439._create(i, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ var $59fc9b849b320ded$export$6bbc7aef0717f3d2 = /*#__PURE__*/ function(AppliableConstraint) {
    "use strict";
    (0, $ftJVG._)(QueryCompositeFilterConstraint, AppliableConstraint);
    var _super = (0, $6OZAO._)(QueryCompositeFilterConstraint);
    function QueryCompositeFilterConstraint(/** The type of this query constraint */ e, t) {
        (0, $978gY._)(this, QueryCompositeFilterConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._queryConstraints = t;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(QueryCompositeFilterConstraint, [
        {
            key: "_parse",
            value: function _parse(e) {
                var t = this._queryConstraints.map(function(t) {
                    return t._parse(e);
                }).filter(function(e) {
                    return e.getFilters().length > 0;
                });
                return 1 === t.length ? t[0] : $59fc9b849b320ded$var$CompositeFilter.create(t, this._getOperator());
            }
        },
        {
            key: "_apply",
            value: function _apply(e) {
                var t = this._parse(e);
                return 0 === t.getFilters().length ? e : (function __PRIVATE_validateNewFilter(e, t) {
                    var n = e;
                    var r = t.getFlattenedFilters();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            $59fc9b849b320ded$var$__PRIVATE_validateNewFieldFilter(n, _$e), n = $59fc9b849b320ded$var$__PRIVATE_queryWithAddedFilter(n, _$e);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }(e._query, t), new $59fc9b849b320ded$export$62297b13309008b2(e.firestore, e.converter, $59fc9b849b320ded$var$__PRIVATE_queryWithAddedFilter(e._query, t)));
            }
        },
        {
            key: "_getQueryConstraints",
            value: function _getQueryConstraints() {
                return this._queryConstraints;
            }
        },
        {
            key: "_getOperator",
            value: function _getOperator() {
                return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t) {
                return new QueryCompositeFilterConstraint(e, t);
            }
        }
    ]);
    return QueryCompositeFilterConstraint;
}($59fc9b849b320ded$var$AppliableConstraint);
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $59fc9b849b320ded$export$252bb8b3bbdf6749() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // Only support QueryFilterConstraints
    return e.forEach(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_validateQueryFilterConstraint("or", e);
    }), $59fc9b849b320ded$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , e);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $59fc9b849b320ded$export$21c0ac7fe1cef1b8() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // Only support QueryFilterConstraints
    return e.forEach(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_validateQueryFilterConstraint("and", e);
    }), $59fc9b849b320ded$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , e);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ var $59fc9b849b320ded$export$65a9ba8bbd6ed9e3 = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $ftJVG._)(QueryOrderByConstraint, QueryConstraint);
    var _super = (0, $6OZAO._)(QueryOrderByConstraint);
    function QueryOrderByConstraint(e, t) {
        (0, $978gY._)(this, QueryOrderByConstraint);
        var _this;
        _this = _super.call(this), _this._field = e, _this._direction = t, /** The type of this query constraint */ _this.type = "orderBy";
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(QueryOrderByConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = function __PRIVATE_newQueryOrderBy(e, t, n) {
                    if (null !== e.startAt) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
                    if (null !== e.endAt) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
                    var r = new $59fc9b849b320ded$var$OrderBy(t, n);
                    return function __PRIVATE_validateNewOrderBy(e, t) {
                        if (null === $59fc9b849b320ded$var$__PRIVATE_getFirstOrderByField(e)) {
                            // This is the first order by. It must match any inequality.
                            var _$n = $59fc9b849b320ded$var$__PRIVATE_getInequalityFilterField(e);
                            null !== _$n && $59fc9b849b320ded$var$__PRIVATE_validateOrderByAndInequalityMatch(e, _$n, t.field);
                        }
                    }(e, r), r;
                }(e._query, this._field, this._direction);
                return new $59fc9b849b320ded$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithAddedOrderBy(e, t) {
                    // TODO(dimond): validate that orderBy does not list the same key twice.
                    var n = e.explicitOrderBy.concat([
                        t
                    ]);
                    return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t) {
                return new QueryOrderByConstraint(e, t);
            }
        }
    ]);
    return QueryOrderByConstraint;
}($59fc9b849b320ded$export$b0e86f2c7431df4e);
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $59fc9b849b320ded$export$f18af21d6f4dafd8(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "asc";
    var n = t, r = $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument("orderBy", e);
    return $59fc9b849b320ded$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ var $59fc9b849b320ded$export$49bb5356ca788047 = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $ftJVG._)(QueryLimitConstraint, QueryConstraint);
    var _super = (0, $6OZAO._)(QueryLimitConstraint);
    function QueryLimitConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $978gY._)(this, QueryLimitConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._limit = t, _this._limitType = n;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(QueryLimitConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                return new $59fc9b849b320ded$export$62297b13309008b2(e.firestore, e.converter, $59fc9b849b320ded$var$__PRIVATE_queryWithLimit(e._query, this._limit, this._limitType));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryLimitConstraint(e, t, n);
            }
        }
    ]);
    return QueryLimitConstraint;
}($59fc9b849b320ded$export$b0e86f2c7431df4e);
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $59fc9b849b320ded$export$ee37e834aaad6f7e(e) {
    return $59fc9b849b320ded$var$__PRIVATE_validatePositiveNumber("limit", e), $59fc9b849b320ded$export$49bb5356ca788047._create("limit", e, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $59fc9b849b320ded$export$f823b3589f69d3b8(e) {
    return $59fc9b849b320ded$var$__PRIVATE_validatePositiveNumber("limitToLast", e), $59fc9b849b320ded$export$49bb5356ca788047._create("limitToLast", e, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ var $59fc9b849b320ded$export$d92e2830aca1d816 = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $ftJVG._)(QueryStartAtConstraint, QueryConstraint);
    var _super = (0, $6OZAO._)(QueryStartAtConstraint);
    function QueryStartAtConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $978gY._)(this, QueryStartAtConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._docOrFields = t, _this._inclusive = n;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(QueryStartAtConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
                return new $59fc9b849b320ded$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithStartAt(e, t) {
                    return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
                }(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryStartAtConstraint(e, t, n);
            }
        }
    ]);
    return QueryStartAtConstraint;
}($59fc9b849b320ded$export$b0e86f2c7431df4e);
function $59fc9b849b320ded$export$859941c5fc8eba6b() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return $59fc9b849b320ded$export$d92e2830aca1d816._create("startAt", e, /*inclusive=*/ !0);
}
function $59fc9b849b320ded$export$dd8dee5f7b804673() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return $59fc9b849b320ded$export$d92e2830aca1d816._create("startAfter", e, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ var $59fc9b849b320ded$export$fd1782fd870d1e06 = /*#__PURE__*/ function(QueryConstraint) {
    "use strict";
    (0, $ftJVG._)(QueryEndAtConstraint, QueryConstraint);
    var _super = (0, $6OZAO._)(QueryEndAtConstraint);
    function QueryEndAtConstraint(/** The type of this query constraint */ e, t, n) {
        (0, $978gY._)(this, QueryEndAtConstraint);
        var _this;
        _this = _super.call(this), _this.type = e, _this._docOrFields = t, _this._inclusive = n;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(QueryEndAtConstraint, [
        {
            key: "_apply",
            value: function _apply(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_newQueryBoundFromDocOrFields(e, this.type, this._docOrFields, this._inclusive);
                return new $59fc9b849b320ded$export$62297b13309008b2(e.firestore, e.converter, function __PRIVATE_queryWithEndAt(e, t) {
                    return new $59fc9b849b320ded$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
                }(e._query, t));
            }
        }
    ], [
        {
            key: "_create",
            value: function _create(e, t, n) {
                return new QueryEndAtConstraint(e, t, n);
            }
        }
    ]);
    return QueryEndAtConstraint;
}($59fc9b849b320ded$export$b0e86f2c7431df4e);
function $59fc9b849b320ded$export$57203950645b8b11() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return $59fc9b849b320ded$export$fd1782fd870d1e06._create("endBefore", e, /*inclusive=*/ !1);
}
function $59fc9b849b320ded$export$28ec54a8428bdb3f() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return $59fc9b849b320ded$export$fd1782fd870d1e06._create("endAt", e, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $59fc9b849b320ded$var$__PRIVATE_newQueryBoundFromDocOrFields(e, t, n, r) {
    if (n[0] = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $59fc9b849b320ded$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(e, t, n, r, i) {
        if (!r) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for ".concat(n, "()."));
        var s = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Because people expect to continue/end a query at the exact document
            // provided, we need to use the implicit sort order rather than the explicit
            // sort order, because it's guaranteed to contain the document key. That way
            // the position becomes unambiguous and the query continues/ends exactly at
            // the provided document. Without the key (by using the explicit sort
            // orders), multiple documents could match the position, yielding duplicate
            // results.
            for(var _iterator = $59fc9b849b320ded$var$__PRIVATE_queryNormalizedOrderBy(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$n = _step.value;
                if (_$n.field.isKeyField()) s.push($59fc9b849b320ded$var$__PRIVATE_refValue(t, r.key));
                else {
                    var _$e = r.data.field(_$n.field);
                    if ($59fc9b849b320ded$var$__PRIVATE_isServerTimestamp(_$e)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + _$n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
                    if (null === _$e) {
                        var _$e1 = _$n.field.canonicalString();
                        throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '".concat(_$e1, "' (used as the orderBy) does not exist."));
                    }
                    s.push(_$e);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return new $59fc9b849b320ded$var$Bound(s, i);
    }(e._query, e.firestore._databaseId, t, n[0]._document, r);
    {
        var i = $59fc9b849b320ded$var$__PRIVATE_newUserDataReader(e.firestore);
        return function __PRIVATE_newQueryBoundFromFields(e, t, n, r, i, s) {
            // Use explicit order by's because it has to match the query the user made
            var o = e.explicitOrderBy;
            if (i.length > o.length) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Too many arguments provided to ".concat(r, "(). The number of arguments must be less than or equal to the number of orderBy() clauses"));
            var _ = [];
            for(var _$s = 0; _$s < i.length; _$s++){
                var a = i[_$s];
                if (o[_$s].field.isKeyField()) {
                    if ("string" != typeof a) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in ".concat(r, "(), but got a ").concat(typeof a === "undefined" ? "undefined" : (0, $1ObTH._)(a)));
                    if (!$59fc9b849b320ded$var$__PRIVATE_isCollectionGroupQuery(e) && -1 !== a.indexOf("/")) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by documentId(), the value passed to ".concat(r, "() must be a plain document ID, but '").concat(a, "' contains a slash."));
                    var _$n = e.path.child($59fc9b849b320ded$var$ResourcePath.fromString(a));
                    if (!$59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(_$n)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by documentId(), the value passed to ".concat(r, "() must result in a valid document path, but '").concat(_$n, "' is not because it contains an odd number of segments."));
                    var _$i = new $59fc9b849b320ded$export$afc2e57c475b7810(_$n);
                    _.push($59fc9b849b320ded$var$__PRIVATE_refValue(t, _$i));
                } else {
                    var _$e = $59fc9b849b320ded$var$__PRIVATE_parseQueryValue(n, r, a);
                    _.push(_$e);
                }
            }
            return new $59fc9b849b320ded$var$Bound(_, s);
        }(e._query, e.firestore._databaseId, i, t, n, r);
    }
}
function $59fc9b849b320ded$var$__PRIVATE_parseDocumentIdValue(e, t, n) {
    if ("string" == typeof (n = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!$59fc9b849b320ded$var$__PRIVATE_isCollectionGroupQuery(t) && -1 !== n.indexOf("/")) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '".concat(n, "' contains a '/' character."));
        var r = t.path.child($59fc9b849b320ded$var$ResourcePath.fromString(n));
        if (!$59fc9b849b320ded$export$afc2e57c475b7810.isDocumentKey(r)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '".concat(r, "' is not because it has an odd number of segments (").concat(r.length, ")."));
        return $59fc9b849b320ded$var$__PRIVATE_refValue(e, new $59fc9b849b320ded$export$afc2e57c475b7810(r));
    }
    if (n instanceof $59fc9b849b320ded$export$6be62b059fb12175) return $59fc9b849b320ded$var$__PRIVATE_refValue(e, n._key);
    throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ".concat($59fc9b849b320ded$var$__PRIVATE_valueDescription(n), "."));
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $59fc9b849b320ded$var$__PRIVATE_validateDisjunctiveFilterElements(e, t) {
    if (!Array.isArray(e) || 0 === e.length) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '".concat(t.toString(), "' filters."));
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $59fc9b849b320ded$var$__PRIVATE_validateNewFieldFilter(e, t) {
    if (t.isInequality()) {
        var n = $59fc9b849b320ded$var$__PRIVATE_getInequalityFilterField(e), r = t.field;
        if (null !== n && !n.isEqual(r)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, !=, not-in, >, or >=) must be on the same field. But you have inequality filters on '".concat(n.toString(), "' and '").concat(r.toString(), "'"));
        var i = $59fc9b849b320ded$var$__PRIVATE_getFirstOrderByField(e);
        null !== i && $59fc9b849b320ded$var$__PRIVATE_validateOrderByAndInequalityMatch(e, r, i);
    }
    var n1 = function __PRIVATE_findOpInsideFilters(e, t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var n = _step.value;
                try {
                    for(var _iterator1 = n.getFlattenedFilters()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step1.value;
                        if (t.indexOf(_$e.op) >= 0) return _$e.op;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return null;
    }(e.filters, function __PRIVATE_conflictingOps(e) {
        switch(e){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(t.op));
    if (null !== n1) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n1 === t.op ? new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '".concat(t.op.toString(), "' filter.")) : new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. You cannot use '".concat(t.op.toString(), "' filters with '").concat(n1.toString(), "' filters."));
}
function $59fc9b849b320ded$var$__PRIVATE_validateOrderByAndInequalityMatch(e, t, n) {
    if (!n.isEqual(t)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, !=, not-in, >, or >=) on field '".concat(t.toString(), "' and so you must also use '").concat(t.toString(), "' as your first argument to orderBy(), but your first orderBy() is on field '").concat(n.toString(), "' instead."));
}
function $59fc9b849b320ded$var$__PRIVATE_validateQueryFilterConstraint(e, t) {
    if (!(t instanceof $59fc9b849b320ded$export$f765fc5789dfd439 || t instanceof $59fc9b849b320ded$export$6bbc7aef0717f3d2)) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Function ".concat(e, "() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'."));
}
var $59fc9b849b320ded$export$2cd31cfe6f6866e9 = /*#__PURE__*/ function() {
    "use strict";
    function AbstractUserDataWriter() {
        (0, $978gY._)(this, AbstractUserDataWriter);
    }
    (0, $kry2a._)(AbstractUserDataWriter, [
        {
            key: "convertValue",
            value: function convertValue(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
                switch($59fc9b849b320ded$var$__PRIVATE_typeOrder(e)){
                    case 0 /* TypeOrder.NullValue */ :
                        return null;
                    case 1 /* TypeOrder.BooleanValue */ :
                        return e.booleanValue;
                    case 2 /* TypeOrder.NumberValue */ :
                        return $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
                    case 3 /* TypeOrder.TimestampValue */ :
                        return this.convertTimestamp(e.timestampValue);
                    case 4 /* TypeOrder.ServerTimestampValue */ :
                        return this.convertServerTimestamp(e, t);
                    case 5 /* TypeOrder.StringValue */ :
                        return e.stringValue;
                    case 6 /* TypeOrder.BlobValue */ :
                        return this.convertBytes($59fc9b849b320ded$var$__PRIVATE_normalizeByteString(e.bytesValue));
                    case 7 /* TypeOrder.RefValue */ :
                        return this.convertReference(e.referenceValue);
                    case 8 /* TypeOrder.GeoPointValue */ :
                        return this.convertGeoPoint(e.geoPointValue);
                    case 9 /* TypeOrder.ArrayValue */ :
                        return this.convertArray(e.arrayValue, t);
                    case 10 /* TypeOrder.ObjectValue */ :
                        return this.convertObject(e.mapValue, t);
                    default:
                        throw $59fc9b849b320ded$var$fail();
                }
            }
        },
        {
            key: "convertObject",
            value: function convertObject(e, t) {
                return this.convertObjectMap(e.fields, t);
            }
        },
        {
            /**
     * @internal
     */ key: "convertObjectMap",
            value: function convertObjectMap(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
                var _this = this;
                var n = {};
                return $59fc9b849b320ded$var$forEach(e, function(e, r) {
                    n[e] = _this.convertValue(r, t);
                }), n;
            }
        },
        {
            key: "convertGeoPoint",
            value: function convertGeoPoint(e) {
                return new $59fc9b849b320ded$export$f9f719d1b6419c4($59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.latitude), $59fc9b849b320ded$var$__PRIVATE_normalizeNumber(e.longitude));
            }
        },
        {
            key: "convertArray",
            value: function convertArray(e, t) {
                var _this = this;
                return (e.values || []).map(function(e) {
                    return _this.convertValue(e, t);
                });
            }
        },
        {
            key: "convertServerTimestamp",
            value: function convertServerTimestamp(e, t) {
                switch(t){
                    case "previous":
                        var n = $59fc9b849b320ded$var$__PRIVATE_getPreviousValue(e);
                        return null == n ? null : this.convertValue(n, t);
                    case "estimate":
                        return this.convertTimestamp($59fc9b849b320ded$var$__PRIVATE_getLocalWriteTime(e));
                    default:
                        return null;
                }
            }
        },
        {
            key: "convertTimestamp",
            value: function convertTimestamp(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_normalizeTimestamp(e);
                return new $59fc9b849b320ded$export$d9bcbd5e1ff81430(t.seconds, t.nanos);
            }
        },
        {
            key: "convertDocumentKey",
            value: function convertDocumentKey(e, t) {
                var n = $59fc9b849b320ded$var$ResourcePath.fromString(e);
                $59fc9b849b320ded$var$__PRIVATE_hardAssert($59fc9b849b320ded$var$__PRIVATE_isValidResourceName(n));
                var r = new $59fc9b849b320ded$export$4c3ccc07620ae30a(n.get(1), n.get(3)), i = new $59fc9b849b320ded$export$afc2e57c475b7810(n.popFirst(5));
                return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
                $59fc9b849b320ded$var$__PRIVATE_logError("Document ".concat(i, " contains a document reference within a different database (").concat(r.projectId, "/").concat(r.database, ") which is not supported. It will be treated as a reference in the current database (").concat(t.projectId, "/").concat(t.database, ") instead.")), i;
            }
        }
    ]);
    return AbstractUserDataWriter;
}();
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts custom model object of type T into `DocumentData` by applying the
 * converter if it exists.
 *
 * This function is used when converting user objects to `DocumentData`
 * because we want to provide the user with a more specific error message if
 * their `set()` or fails due to invalid data originating from a `toFirestore()`
 * call.
 */ function $59fc9b849b320ded$var$__PRIVATE_applyFirestoreDataConverter(e, t, n) {
    var r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = e ? n && (n.merge || n.mergeFields) ? e.toFirestore(t, n) : e.toFirestore(t) : t, r;
}
var $59fc9b849b320ded$var$__PRIVATE_LiteUserDataWriter = /*#__PURE__*/ function(AbstractUserDataWriter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_LiteUserDataWriter, AbstractUserDataWriter);
    var _super = (0, $6OZAO._)(__PRIVATE_LiteUserDataWriter);
    function __PRIVATE_LiteUserDataWriter(e) {
        (0, $978gY._)(this, __PRIVATE_LiteUserDataWriter);
        var _this;
        _this = _super.call(this), _this.firestore = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_LiteUserDataWriter, [
        {
            key: "convertBytes",
            value: function convertBytes(e) {
                return new $59fc9b849b320ded$export$9f55f2e2bf8c2fc1(e);
            }
        },
        {
            key: "convertReference",
            value: function convertReference(e) {
                var t = this.convertDocumentKey(e, this.firestore._databaseId);
                return new $59fc9b849b320ded$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
            }
        }
    ]);
    return __PRIVATE_LiteUserDataWriter;
}($59fc9b849b320ded$export$2cd31cfe6f6866e9);
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to sum across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $59fc9b849b320ded$export$8a63f25cc62965f1(e) {
    return new $59fc9b849b320ded$export$fada2345be8928cf("sum", $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument$1("sum", e));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field Specifies the field to average across the result set.
 * @internal TODO (sum/avg) remove when public
 */ function $59fc9b849b320ded$export$cc6710ee5f037d57(e) {
    return new $59fc9b849b320ded$export$fada2345be8928cf("avg", $59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument$1("average", e));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 * @internal TODO (sum/avg) remove when public
 */ function $59fc9b849b320ded$export$85b9a36db797e02b() {
    return new $59fc9b849b320ded$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left Compare this AggregateField to the `right`.
 * @param right Compare this AggregateField to the `left`.
 * @internal TODO (sum/avg) remove when public
 */ function $59fc9b849b320ded$export$31fa8ec66e0239ad(e, t) {
    var n, r;
    return e instanceof $59fc9b849b320ded$export$fada2345be8928cf && t instanceof $59fc9b849b320ded$export$fada2345be8928cf && e._aggregateType === t._aggregateType && (null === (n = e._internalFieldPath) || void 0 === n ? void 0 : n.canonicalString()) === (null === (r = t._internalFieldPath) || void 0 === r ? void 0 : r.canonicalString());
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $59fc9b849b320ded$export$104f59389a332076(e, t) {
    return $59fc9b849b320ded$export$49b1d0de6ba30f41(e.query, t.query) && (0, $b1467a785fc7cec5$export$9cb4719e2e525b7a)(e.data(), t.data());
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ var $59fc9b849b320ded$export$99d61448206ab5cd = /*#__PURE__*/ function() {
    "use strict";
    function SnapshotMetadata(e, t) {
        (0, $978gY._)(this, SnapshotMetadata);
        this.hasPendingWrites = e, this.fromCache = t;
    }
    (0, $kry2a._)(SnapshotMetadata, [
        {
            /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ key: "isEqual",
            value: function isEqual(e) {
                return this.hasPendingWrites === e.hasPendingWrites && this.fromCache === e.fromCache;
            }
        }
    ]);
    return SnapshotMetadata;
}();
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ var $59fc9b849b320ded$export$acab0e6ef25eb301 = /*#__PURE__*/ function(DocumentSnapshot$1) {
    "use strict";
    (0, $ftJVG._)(DocumentSnapshot, DocumentSnapshot$1);
    var _super = (0, $6OZAO._)(DocumentSnapshot);
    function DocumentSnapshot(e, t, n, r, i, s) {
        (0, $978gY._)(this, DocumentSnapshot);
        var _this;
        _this = _super.call(this, e, t, n, r, s), _this._firestore = e, _this._firestoreImpl = e, _this.metadata = i;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(DocumentSnapshot, [
        {
            /**
     * Returns whether or not the data exists. True if the document exists.
     */ key: "exists",
            value: function exists() {
                return (0, $3cct3._)((0, $g3d7z._)(DocumentSnapshot.prototype), "exists", this).call(this);
            }
        },
        {
            /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ key: "data",
            value: function data() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                if (this._document) {
                    if (this._converter) {
                        // We only want to use the converter and create a new DocumentSnapshot
                        // if a converter has been provided.
                        var t = new $59fc9b849b320ded$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                        return this._converter.fromFirestore(t, e);
                    }
                    return this._userDataWriter.convertValue(this._document.data.value, e.serverTimestamps);
                }
            }
        },
        {
            /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "get",
            value: function get(e) {
                var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this._document) {
                    var n = this._document.data.field($59fc9b849b320ded$var$__PRIVATE_fieldPathFromArgument("DocumentSnapshot.get", e));
                    if (null !== n) return this._userDataWriter.convertValue(n, t.serverTimestamps);
                }
            }
        }
    ]);
    return DocumentSnapshot;
}($59fc9b849b320ded$var$DocumentSnapshot$1);
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ var $59fc9b849b320ded$export$6d4d04e42af6b03c = /*#__PURE__*/ function(DocumentSnapshot) {
    "use strict";
    (0, $ftJVG._)(QueryDocumentSnapshot, DocumentSnapshot);
    var _super = (0, $6OZAO._)(QueryDocumentSnapshot);
    function QueryDocumentSnapshot() {
        (0, $978gY._)(this, QueryDocumentSnapshot);
        return _super.apply(this, arguments);
    }
    (0, $kry2a._)(QueryDocumentSnapshot, [
        {
            /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ key: "data",
            value: function data() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                return (0, $3cct3._)((0, $g3d7z._)(QueryDocumentSnapshot.prototype), "data", this).call(this, e);
            }
        }
    ]);
    return QueryDocumentSnapshot;
}($59fc9b849b320ded$export$acab0e6ef25eb301);
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ var $59fc9b849b320ded$export$8f21149d8133945c = /*#__PURE__*/ function() {
    "use strict";
    function QuerySnapshot(e, t, n, r) {
        (0, $978gY._)(this, QuerySnapshot);
        this._firestore = e, this._userDataWriter = t, this._snapshot = r, this.metadata = new $59fc9b849b320ded$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    (0, $kry2a._)(QuerySnapshot, [
        {
            key: "docs",
            get: /** An array of all the documents in the `QuerySnapshot`. */ function get() {
                var e = [];
                return this.forEach(function(t) {
                    return e.push(t);
                }), e;
            }
        },
        {
            key: "size",
            get: /** The number of documents in the `QuerySnapshot`. */ function get() {
                return this._snapshot.docs.size;
            }
        },
        {
            key: "empty",
            get: /** True if there are no documents in the `QuerySnapshot`. */ function get() {
                return 0 === this.size;
            }
        },
        {
            /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ key: "forEach",
            value: function forEach(e, t) {
                var _this = this;
                this._snapshot.docs.forEach(function(n) {
                    e.call(t, new $59fc9b849b320ded$export$6d4d04e42af6b03c(_this._firestore, _this._userDataWriter, n.key, n, new $59fc9b849b320ded$export$99d61448206ab5cd(_this._snapshot.mutatedKeys.has(n.key), _this._snapshot.fromCache), _this.query.converter));
                });
            }
        },
        {
            /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ key: "docChanges",
            value: function docChanges() {
                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var t = !!e.includeMetadataChanges;
                if (t && this._snapshot.excludesMetadataChanges) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
                return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === t || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(e, t) {
                    if (e._snapshot.oldDocs.isEmpty()) {
                        var t1 = 0;
                        return e._snapshot.docChanges.map(function(n) {
                            var r = new $59fc9b849b320ded$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, n.doc.key, n.doc, new $59fc9b849b320ded$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(n.doc.key), e._snapshot.fromCache), e.query.converter);
                            return n.doc, {
                                type: "added",
                                doc: r,
                                oldIndex: -1,
                                newIndex: t1++
                            };
                        });
                    }
                    {
                        // A `DocumentSet` that is updated incrementally as changes are applied to use
                        // to lookup the index of a document.
                        var n = e._snapshot.oldDocs;
                        return e._snapshot.docChanges.filter(function(e) {
                            return t || 3 /* ChangeType.Metadata */  !== e.type;
                        }).map(function(t) {
                            var r = new $59fc9b849b320ded$export$6d4d04e42af6b03c(e._firestore, e._userDataWriter, t.doc.key, t.doc, new $59fc9b849b320ded$export$99d61448206ab5cd(e._snapshot.mutatedKeys.has(t.doc.key), e._snapshot.fromCache), e.query.converter);
                            var i = -1, s = -1;
                            return 0 /* ChangeType.Added */  !== t.type && (i = n.indexOf(t.doc.key), n = n.delete(t.doc.key)), 1 /* ChangeType.Removed */  !== t.type && (n = n.add(t.doc), s = n.indexOf(t.doc.key)), {
                                type: $59fc9b849b320ded$var$__PRIVATE_resultChangeType(t.type),
                                doc: r,
                                oldIndex: i,
                                newIndex: s
                            };
                        });
                    }
                }(this, t), this._cachedChangesIncludeMetadataChanges = t), this._cachedChanges;
            }
        }
    ]);
    return QuerySnapshot;
}();
function $59fc9b849b320ded$var$__PRIVATE_resultChangeType(e) {
    switch(e){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return $59fc9b849b320ded$var$fail();
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $59fc9b849b320ded$export$f243a5d948512846(e, t) {
    return e instanceof $59fc9b849b320ded$export$acab0e6ef25eb301 && t instanceof $59fc9b849b320ded$export$acab0e6ef25eb301 ? e._firestore === t._firestore && e._key.isEqual(t._key) && (null === e._document ? null === t._document : e._document.isEqual(t._document)) && e._converter === t._converter : e instanceof $59fc9b849b320ded$export$8f21149d8133945c && t instanceof $59fc9b849b320ded$export$8f21149d8133945c && e._firestore === t._firestore && $59fc9b849b320ded$export$49b1d0de6ba30f41(e.query, t.query) && e.metadata.isEqual(t.metadata) && e._snapshot.isEqual(t._snapshot);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A Promise resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $59fc9b849b320ded$export$11eb3b5ef9574821(e) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$6be62b059fb12175);
    var t = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82);
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($59fc9b849b320ded$export$8da5fbea04405656(t), e._key).then(function(n) {
        return $59fc9b849b320ded$var$__PRIVATE_convertToDocSnapshot(t, e, n);
    });
}
var $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter = /*#__PURE__*/ function(AbstractUserDataWriter) {
    "use strict";
    (0, $ftJVG._)(__PRIVATE_ExpUserDataWriter, AbstractUserDataWriter);
    var _super = (0, $6OZAO._)(__PRIVATE_ExpUserDataWriter);
    function __PRIVATE_ExpUserDataWriter(e) {
        (0, $978gY._)(this, __PRIVATE_ExpUserDataWriter);
        var _this;
        _this = _super.call(this), _this.firestore = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(__PRIVATE_ExpUserDataWriter, [
        {
            key: "convertBytes",
            value: function convertBytes(e) {
                return new $59fc9b849b320ded$export$9f55f2e2bf8c2fc1(e);
            }
        },
        {
            key: "convertReference",
            value: function convertReference(e) {
                var t = this.convertDocumentKey(e, this.firestore._databaseId);
                return new $59fc9b849b320ded$export$6be62b059fb12175(this.firestore, /* converter= */ null, t);
            }
        }
    ]);
    return __PRIVATE_ExpUserDataWriter;
}($59fc9b849b320ded$export$2cd31cfe6f6866e9);
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $59fc9b849b320ded$export$a58bd92642f7fb58(e) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$6be62b059fb12175);
    var t = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), n = $59fc9b849b320ded$export$8da5fbea04405656(t), r = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(t);
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentFromLocalCache(n, e._key).then(function(n) {
        return new $59fc9b849b320ded$export$acab0e6ef25eb301(t, r, e._key, n, new $59fc9b849b320ded$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), e.converter);
    });
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` resolved with a `DocumentSnapshot` containing the
 * current document contents.
 */ function $59fc9b849b320ded$export$35dd759aed9686b4(e) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$6be62b059fb12175);
    var t = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82);
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentViaSnapshotListener($59fc9b849b320ded$export$8da5fbea04405656(t), e._key, {
        source: "server"
    }).then(function(n) {
        return $59fc9b849b320ded$var$__PRIVATE_convertToDocSnapshot(t, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot`.
 *
 * Note: `getDocs()` attempts to provide up-to-date data when possible by
 * waiting for data from the server, but it may return cached data or fail if
 * you are offline and the server cannot be reached. To specify this behavior,
 * invoke {@link getDocsFromCache} or {@link getDocsFromServer}.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $59fc9b849b320ded$export$81d3477bd73c86ef(e) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$62297b13309008b2);
    var t = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), n = $59fc9b849b320ded$export$8da5fbea04405656(t), r = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(t);
    return $59fc9b849b320ded$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query), $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query).then(function(n) {
        return new $59fc9b849b320ded$export$8f21149d8133945c(t, r, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $59fc9b849b320ded$export$3fd010f18eac1dd(e) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$62297b13309008b2);
    var t = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), n = $59fc9b849b320ded$export$8da5fbea04405656(t), r = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(t);
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentsFromLocalCache(n, e._query).then(function(n) {
        return new $59fc9b849b320ded$export$8f21149d8133945c(t, r, e, n);
    });
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that will be resolved with the results of the query.
 */ function $59fc9b849b320ded$export$ec7d9e44f349c77b(e) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$62297b13309008b2);
    var t = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), n = $59fc9b849b320ded$export$8da5fbea04405656(t), r = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(t);
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(n, e._query, {
        source: "server"
    }).then(function(n) {
        return new $59fc9b849b320ded$export$8f21149d8133945c(t, r, e, n);
    });
}
function $59fc9b849b320ded$export$5ff77ddaff3c9e12(e, t, n) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$6be62b059fb12175);
    var r = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), i = $59fc9b849b320ded$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t, n);
    return $59fc9b849b320ded$export$1945f8fec9dda613(r, [
        $59fc9b849b320ded$var$__PRIVATE_parseSetData($59fc9b849b320ded$var$__PRIVATE_newUserDataReader(r), "setDoc", e._key, i, null !== e.converter, n).toMutation(e._key, $59fc9b849b320ded$var$Precondition.none())
    ]);
}
function $59fc9b849b320ded$export$22d1fdd1e73faff2(e, t, n) {
    for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        r[_key - 3] = arguments[_key];
    }
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$6be62b059fb12175);
    var i = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), s = $59fc9b849b320ded$var$__PRIVATE_newUserDataReader(i);
    var o;
    o = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (t = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(t)) || t instanceof $59fc9b849b320ded$export$a1a8fea822d17659 ? $59fc9b849b320ded$var$__PRIVATE_parseUpdateVarargs(s, "updateDoc", e._key, t, n, r) : $59fc9b849b320ded$var$__PRIVATE_parseUpdateData(s, "updateDoc", e._key, t);
    return $59fc9b849b320ded$export$1945f8fec9dda613(i, [
        o.toMutation(e._key, $59fc9b849b320ded$var$Precondition.exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * @param reference - A reference to the document to delete.
 * @returns A Promise resolved once the document has been successfully
 * deleted from the backend (note that it won't resolve while you're offline).
 */ function $59fc9b849b320ded$export$a4f20481fae8f78b(e) {
    return $59fc9b849b320ded$export$1945f8fec9dda613($59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), [
        new $59fc9b849b320ded$var$__PRIVATE_DeleteMutation(e._key, $59fc9b849b320ded$var$Precondition.none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` resolved with a `DocumentReference` pointing to the
 * newly created document after it has been written to the backend (Note that it
 * won't resolve while you're offline).
 */ function $59fc9b849b320ded$export$a13890143fb1c2dd(e, t) {
    var n = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), r = $59fc9b849b320ded$export$2a111da947c407d2(e), i = $59fc9b849b320ded$var$__PRIVATE_applyFirestoreDataConverter(e.converter, t);
    return $59fc9b849b320ded$export$1945f8fec9dda613(n, [
        $59fc9b849b320ded$var$__PRIVATE_parseSetData($59fc9b849b320ded$var$__PRIVATE_newUserDataReader(e.firestore), "addDoc", r._key, i, null !== e.converter, {}).toMutation(r._key, $59fc9b849b320ded$var$Precondition.exists(!1))
    ]).then(function() {
        return r;
    });
}
function $59fc9b849b320ded$export$d36370812fb26935(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    var n, r, i;
    e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e);
    var s = {
        includeMetadataChanges: !1
    }, o = 0;
    "object" != typeof t[o] || $59fc9b849b320ded$var$__PRIVATE_isPartialObserver(t[o]) || (s = t[o], o++);
    var _ = {
        includeMetadataChanges: s.includeMetadataChanges
    };
    if ($59fc9b849b320ded$var$__PRIVATE_isPartialObserver(t[o])) {
        var _$e = t[o];
        t[o] = null === (n = _$e.next) || void 0 === n ? void 0 : n.bind(_$e), t[o + 1] = null === (r = _$e.error) || void 0 === r ? void 0 : r.bind(_$e), t[o + 2] = null === (i = _$e.complete) || void 0 === i ? void 0 : i.bind(_$e);
    }
    var a, u, c;
    if (e instanceof $59fc9b849b320ded$export$6be62b059fb12175) u = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), c = $59fc9b849b320ded$var$__PRIVATE_newQueryForPath(e._key.path), a = {
        next: function(n) {
            t[o] && t[o]($59fc9b849b320ded$var$__PRIVATE_convertToDocSnapshot(u, e, n));
        },
        error: t[o + 1],
        complete: t[o + 2]
    };
    else {
        var n1 = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$62297b13309008b2);
        u = $59fc9b849b320ded$export$572106fb5803752c(n1.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), c = n1._query;
        var r1 = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(u);
        a = {
            next: function(e) {
                t[o] && t[o](new $59fc9b849b320ded$export$8f21149d8133945c(u, r1, n1, e));
            },
            error: t[o + 1],
            complete: t[o + 2]
        }, $59fc9b849b320ded$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(e._query);
    }
    return function __PRIVATE_firestoreClientListen(e, t, n, r) {
        var i = new $59fc9b849b320ded$var$__PRIVATE_AsyncObserver(r), s = new $59fc9b849b320ded$var$__PRIVATE_QueryListener(t, i, n);
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_getEventManager(e)
                        ];
                    case 1:
                        return [
                            2,
                            $59fc9b849b320ded$var$__PRIVATE_eventManagerListen.apply(void 0, [
                                _state.sent(),
                                s
                            ])
                        ];
                }
            });
        })), function() {
            i.La(), e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $59fc9b849b320ded$var$__PRIVATE_getEventManager(e)
                            ];
                        case 1:
                            return [
                                2,
                                $59fc9b849b320ded$var$__PRIVATE_eventManagerUnlisten.apply(void 0, [
                                    _state.sent(),
                                    s
                                ])
                            ];
                    }
                });
            }));
        };
    }($59fc9b849b320ded$export$8da5fbea04405656(u), c, _, a);
}
function $59fc9b849b320ded$export$9dff4f5aba83e348(e, t) {
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientAddSnapshotsInSyncListener($59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82)), $59fc9b849b320ded$var$__PRIVATE_isPartialObserver(t) ? t : {
        next: t
    });
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $59fc9b849b320ded$export$1945f8fec9dda613(e, t) {
    return function __PRIVATE_firestoreClientWrite(e, t) {
        var n = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_getSyncEngine(e)
                        ];
                    case 1:
                        return [
                            2,
                            $59fc9b849b320ded$var$__PRIVATE_syncEngineWrite.apply(void 0, [
                                _state.sent(),
                                t,
                                n
                            ])
                        ];
                }
            });
        })), n.promise;
    }($59fc9b849b320ded$export$8da5fbea04405656(e), t);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $59fc9b849b320ded$var$__PRIVATE_convertToDocSnapshot(e, t, n) {
    var r = n.docs.get(t._key), i = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(e);
    return new $59fc9b849b320ded$export$acab0e6ef25eb301(e, i, t._key, r, new $59fc9b849b320ded$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), t.converter);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query,
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can even
 * count the documents if the result set would be prohibitively large to
 * download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size to calculate.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $59fc9b849b320ded$export$b1de1b12889d0afb(e) {
    return $59fc9b849b320ded$export$a51511de2fae49b3(e, {
        count: $59fc9b849b320ded$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query, without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, is downloaded. This
 * function can even perform aggregations of the documents if the result set
 * would be prohibitively large to download entirely (e.g. thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used: every request using this source necessarily involves a round trip to
 * the server.
 *
 * @param query The query whose result set to aggregate over.
 * @param aggregateSpec An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 * @internal TODO (sum/avg) remove when public
 */ function $59fc9b849b320ded$export$a51511de2fae49b3(e, t) {
    var n = $59fc9b849b320ded$export$572106fb5803752c(e.firestore, $59fc9b849b320ded$export$d0e2b3272814ce82), r = $59fc9b849b320ded$export$8da5fbea04405656(n), i = function __PRIVATE_mapToArray(e, t) {
        var n = [];
        for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
        return n;
    }(t, function(e, t) {
        return new $59fc9b849b320ded$var$__PRIVATE_AggregateImpl(t, e._aggregateType, e._internalFieldPath);
    });
    // Run the aggregation and convert the results
    return (function __PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
        var r = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            var i, e1;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_getDatastore(e)
                        ];
                    case 1:
                        i = _state.sent();
                        r.resolve($59fc9b849b320ded$var$__PRIVATE_invokeRunAggregationQueryRpc(i, t, n));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e1 = _state.sent();
                        r.reject(e1);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })), r.promise;
    })(r, e._query, i).then(function(t) {
        return(/**
 * Converts the core aggregration result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult Core aggregation result
 * @internal
 */ function __PRIVATE_convertToAggregateQuerySnapshot(e, t, n) {
            var r = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(e);
            return new $59fc9b849b320ded$export$40257fef64be808b(t, r, n);
        }(n, e, t));
    });
}
var $59fc9b849b320ded$var$__PRIVATE_MemoryLocalCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLocalCacheImpl(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryLocalCacheImpl);
        this.kind = "memory", this._onlineComponentProvider = new $59fc9b849b320ded$var$OnlineComponentProvider, (null == e ? void 0 : e.garbageCollector) ? this._offlineComponentProvider = e.garbageCollector._offlineComponentProvider : this._offlineComponentProvider = new $59fc9b849b320ded$var$MemoryOfflineComponentProvider;
    }
    (0, $kry2a._)(__PRIVATE_MemoryLocalCacheImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryLocalCacheImpl;
}();
var $59fc9b849b320ded$var$__PRIVATE_PersistentLocalCacheImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_PersistentLocalCacheImpl(e) {
        (0, $978gY._)(this, __PRIVATE_PersistentLocalCacheImpl);
        var t;
        this.kind = "persistent", (null == e ? void 0 : e.tabManager) ? (e.tabManager._initialize(e), t = e.tabManager) : (t = $59fc9b849b320ded$export$d5f96a3c009e86ac(void 0), t._initialize(e)), this._onlineComponentProvider = t._onlineComponentProvider, this._offlineComponentProvider = t._offlineComponentProvider;
    }
    (0, $kry2a._)(__PRIVATE_PersistentLocalCacheImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_PersistentLocalCacheImpl;
}();
var $59fc9b849b320ded$var$__PRIVATE_MemoryEagerGabageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryEagerGabageCollectorImpl() {
        (0, $978gY._)(this, __PRIVATE_MemoryEagerGabageCollectorImpl);
        this.kind = "memoryEager", this._offlineComponentProvider = new $59fc9b849b320ded$var$MemoryOfflineComponentProvider;
    }
    (0, $kry2a._)(__PRIVATE_MemoryEagerGabageCollectorImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryEagerGabageCollectorImpl;
}();
var $59fc9b849b320ded$var$__PRIVATE_MemoryLruGabageCollectorImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MemoryLruGabageCollectorImpl(e) {
        (0, $978gY._)(this, __PRIVATE_MemoryLruGabageCollectorImpl);
        this.kind = "memoryLru", this._offlineComponentProvider = new $59fc9b849b320ded$var$__PRIVATE_LruGcMemoryOfflineComponentProvider(e);
    }
    (0, $kry2a._)(__PRIVATE_MemoryLruGabageCollectorImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        }
    ]);
    return __PRIVATE_MemoryLruGabageCollectorImpl;
}();
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $59fc9b849b320ded$export$574728f3be606189() {
    return new $59fc9b849b320ded$var$__PRIVATE_MemoryEagerGabageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $59fc9b849b320ded$export$2340f88905cc0c23(e) {
    return new $59fc9b849b320ded$var$__PRIVATE_MemoryLruGabageCollectorImpl(null == e ? void 0 : e.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $59fc9b849b320ded$export$72ef71adb739a32c(e) {
    return new $59fc9b849b320ded$var$__PRIVATE_MemoryLocalCacheImpl(e);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $59fc9b849b320ded$export$51b321e43d5331d5(e) {
    return new $59fc9b849b320ded$var$__PRIVATE_PersistentLocalCacheImpl(e);
}
var $59fc9b849b320ded$var$__PRIVATE_SingleTabManagerImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_SingleTabManagerImpl(e) {
        (0, $978gY._)(this, __PRIVATE_SingleTabManagerImpl);
        this.forceOwnership = e, this.kind = "persistentSingleTab";
    }
    (0, $kry2a._)(__PRIVATE_SingleTabManagerImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        },
        {
            /**
     * @internal
     */ key: "_initialize",
            value: function _initialize(e) {
                this._onlineComponentProvider = new $59fc9b849b320ded$var$OnlineComponentProvider, this._offlineComponentProvider = new $59fc9b849b320ded$var$__PRIVATE_IndexedDbOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes, this.forceOwnership);
            }
        }
    ]);
    return __PRIVATE_SingleTabManagerImpl;
}();
var $59fc9b849b320ded$var$__PRIVATE_MultiTabManagerImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_MultiTabManagerImpl() {
        (0, $978gY._)(this, __PRIVATE_MultiTabManagerImpl);
        this.kind = "PersistentMultipleTab";
    }
    (0, $kry2a._)(__PRIVATE_MultiTabManagerImpl, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    kind: this.kind
                };
            }
        },
        {
            /**
     * @internal
     */ key: "_initialize",
            value: function _initialize(e) {
                this._onlineComponentProvider = new $59fc9b849b320ded$var$OnlineComponentProvider, this._offlineComponentProvider = new $59fc9b849b320ded$var$__PRIVATE_MultiTabOfflineComponentProvider(this._onlineComponentProvider, null == e ? void 0 : e.cacheSizeBytes);
            }
        }
    ]);
    return __PRIVATE_MultiTabManagerImpl;
}();
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings Configures the created tab manager.
 */ function $59fc9b849b320ded$export$d5f96a3c009e86ac(e) {
    return new $59fc9b849b320ded$var$__PRIVATE_SingleTabManagerImpl(null == e ? void 0 : e.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $59fc9b849b320ded$export$57e9d290b0b4dc04() {
    return new $59fc9b849b320ded$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $59fc9b849b320ded$var$ye = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ var $59fc9b849b320ded$export$d94ed661b1cfd435 = /*#__PURE__*/ function() {
    "use strict";
    function WriteBatch(e, t) {
        (0, $978gY._)(this, WriteBatch);
        this._firestore = e, this._commitHandler = t, this._mutations = [], this._committed = !1, this._dataReader = $59fc9b849b320ded$var$__PRIVATE_newUserDataReader(e);
    }
    (0, $kry2a._)(WriteBatch, [
        {
            key: "set",
            value: function set(e, t, n) {
                this._verifyNotCommitted();
                var r = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore), i = $59fc9b849b320ded$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $59fc9b849b320ded$var$__PRIVATE_parseSetData(this._dataReader, "WriteBatch.set", r._key, i, null !== r.converter, n);
                return this._mutations.push(s.toMutation(r._key, $59fc9b849b320ded$var$Precondition.none())), this;
            }
        },
        {
            key: "update",
            value: function update(e, t, n) {
                for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    r[_key - 3] = arguments[_key];
                }
                this._verifyNotCommitted();
                var i = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore);
                // For Compat types, we have to "extract" the underlying types before
                // performing validation.
                var s;
                return s = "string" == typeof (t = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(t)) || t instanceof $59fc9b849b320ded$export$a1a8fea822d17659 ? $59fc9b849b320ded$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "WriteBatch.update", i._key, t, n, r) : $59fc9b849b320ded$var$__PRIVATE_parseUpdateData(this._dataReader, "WriteBatch.update", i._key, t), this._mutations.push(s.toMutation(i._key, $59fc9b849b320ded$var$Precondition.exists(!0))), this;
            }
        },
        {
            /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ key: "delete",
            value: function _delete(e) {
                this._verifyNotCommitted();
                var t = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore);
                return this._mutations = this._mutations.concat(new $59fc9b849b320ded$var$__PRIVATE_DeleteMutation(t._key, $59fc9b849b320ded$var$Precondition.none())), this;
            }
        },
        {
            /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ key: "commit",
            value: function commit() {
                return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
            }
        },
        {
            key: "_verifyNotCommitted",
            value: function _verifyNotCommitted() {
                if (this._committed) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
            }
        }
    ]);
    return WriteBatch;
}();
function $59fc9b849b320ded$var$__PRIVATE_validateReference(e, t) {
    if ((e = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(e)).firestore !== t) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ var $59fc9b849b320ded$export$febc5573c75cefb0 = /*#__PURE__*/ function(_Transaction$1) {
    "use strict";
    (0, $ftJVG._)(Transaction, _Transaction$1);
    var _super = (0, $6OZAO._)(Transaction);
    function Transaction(e, t) {
        (0, $978gY._)(this, Transaction);
        var _this;
        _this = _super.call(this, e, t), _this._firestore = e;
        return (0, $ho5gk._)(_this);
    }
    (0, $kry2a._)(Transaction, [
        {
            /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                var t = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore), n = new $59fc9b849b320ded$var$__PRIVATE_ExpUserDataWriter(this._firestore);
                return (0, $3cct3._)((0, $g3d7z._)(Transaction.prototype), "get", this).call(this, e).then(function(e) {
                    return new $59fc9b849b320ded$export$acab0e6ef25eb301(_this._firestore, n, t._key, e._document, new $59fc9b849b320ded$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), t.converter);
                });
            }
        }
    ]);
    return Transaction;
}(/*#__PURE__*/ function() {
    "use strict";
    function Transaction$1(e, t) {
        (0, $978gY._)(this, Transaction$1);
        this._firestore = e, this._transaction = t, this._dataReader = $59fc9b849b320ded$var$__PRIVATE_newUserDataReader(e);
    }
    (0, $kry2a._)(Transaction$1, [
        {
            /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ key: "get",
            value: function get(e) {
                var _this = this;
                var t = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore), n = new $59fc9b849b320ded$var$__PRIVATE_LiteUserDataWriter(this._firestore);
                return this._transaction.lookup([
                    t._key
                ]).then(function(e) {
                    if (!e || 1 !== e.length) return $59fc9b849b320ded$var$fail();
                    var r = e[0];
                    if (r.isFoundDocument()) return new $59fc9b849b320ded$var$DocumentSnapshot$1(_this._firestore, n, r.key, r, t.converter);
                    if (r.isNoDocument()) return new $59fc9b849b320ded$var$DocumentSnapshot$1(_this._firestore, n, t._key, null, t.converter);
                    throw $59fc9b849b320ded$var$fail();
                });
            }
        },
        {
            key: "set",
            value: function set(e, t, n) {
                var r = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore), i = $59fc9b849b320ded$var$__PRIVATE_applyFirestoreDataConverter(r.converter, t, n), s = $59fc9b849b320ded$var$__PRIVATE_parseSetData(this._dataReader, "Transaction.set", r._key, i, null !== r.converter, n);
                return this._transaction.set(r._key, s), this;
            }
        },
        {
            key: "update",
            value: function update(e, t, n) {
                for(var _len = arguments.length, r = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                    r[_key - 3] = arguments[_key];
                }
                var i = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore);
                // For Compat types, we have to "extract" the underlying types before
                // performing validation.
                var s;
                return s = "string" == typeof (t = (0, $b1467a785fc7cec5$export$4befe9b5fa509a1b)(t)) || t instanceof $59fc9b849b320ded$export$a1a8fea822d17659 ? $59fc9b849b320ded$var$__PRIVATE_parseUpdateVarargs(this._dataReader, "Transaction.update", i._key, t, n, r) : $59fc9b849b320ded$var$__PRIVATE_parseUpdateData(this._dataReader, "Transaction.update", i._key, t), this._transaction.update(i._key, s), this;
            }
        },
        {
            /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ key: "delete",
            value: function _delete(e) {
                var t = $59fc9b849b320ded$var$__PRIVATE_validateReference(e, this._firestore);
                return this._transaction.delete(t._key), this;
            }
        }
    ]);
    return Transaction$1;
}());
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $59fc9b849b320ded$export$3c54e006bf9c93b7(e, t, n) {
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82);
    var r = Object.assign(Object.assign({}, $59fc9b849b320ded$var$ye), n);
    !function __PRIVATE_validateTransactionOptions(e) {
        if (e.maxAttempts < 1) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    return function __PRIVATE_firestoreClientTransaction(e, t, n) {
        var r = new $59fc9b849b320ded$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(/*#__PURE__*/ (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            var i;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $59fc9b849b320ded$var$__PRIVATE_getDatastore(e)
                        ];
                    case 1:
                        i = _state.sent();
                        new $59fc9b849b320ded$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).run();
                        return [
                            2
                        ];
                }
            });
        })), r.promise;
    }($59fc9b849b320ded$export$8da5fbea04405656(e), function(n) {
        return t(new $59fc9b849b320ded$export$febc5573c75cefb0(e, n));
    }, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $59fc9b849b320ded$export$2bbad96c62fdba3e() {
    return new $59fc9b849b320ded$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $59fc9b849b320ded$export$3ff8e7e00c3264b7() {
    return new $59fc9b849b320ded$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $59fc9b849b320ded$export$f62af892fd92610c() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $59fc9b849b320ded$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $59fc9b849b320ded$export$30a014203d0d7e4f() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $59fc9b849b320ded$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $59fc9b849b320ded$export$a2647aa13413c947(e) {
    return new $59fc9b849b320ded$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a write batch, used for performing multiple writes as a single
 * atomic operation. The maximum number of writes allowed in a single {@link WriteBatch}
 * is 500.
 *
 * Unlike transactions, write batches are persisted offline and therefore are
 * preferable when you don't need to condition your writes on read data.
 *
 * @returns A {@link WriteBatch} that can be used to atomically execute multiple
 * writes.
 */ function $59fc9b849b320ded$export$44cd1c9d57edd9b1(e) {
    return $59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82)), new $59fc9b849b320ded$export$d94ed661b1cfd435(e, function(t) {
        return $59fc9b849b320ded$export$1945f8fec9dda613(e, t);
    });
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $59fc9b849b320ded$export$ff1663c0c1304f1a(e, t) {
    var n;
    var r = $59fc9b849b320ded$export$8da5fbea04405656(e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82));
    if (!r._uninitializedComponentsProvider || "memory" === (null === (n = r._uninitializedComponentsProvider) || void 0 === n ? void 0 : n._offlineKind)) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return $59fc9b849b320ded$export$86cd73f49cc6e0bb("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    var i = function __PRIVATE_parseIndexes(e) {
        var _$t = "string" == typeof e ? function __PRIVATE_tryParseJson(e) {
            try {
                return JSON.parse(e);
            } catch (e) {
                throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Failed to parse JSON: " + (null == e ? void 0 : e.message));
            }
        }(e) : e, n = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (Array.isArray(_$t.indexes)) try {
            for(var _iterator = _$t.indexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _$e = _step.value;
                var _$t1 = $59fc9b849b320ded$var$__PRIVATE_tryGetString(_$e, "collectionGroup"), r = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (Array.isArray(_$e.fields)) try {
                    for(var _iterator1 = _$e.fields[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t2 = _step1.value;
                        var _$e1 = $59fc9b849b320ded$var$__PRIVATE_fieldPathFromDotSeparatedString("setIndexConfiguration", $59fc9b849b320ded$var$__PRIVATE_tryGetString(_$t2, "fieldPath"));
                        "CONTAINS" === _$t2.arrayConfig ? r.push(new $59fc9b849b320ded$var$IndexSegment(_$e1, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === _$t2.order ? r.push(new $59fc9b849b320ded$var$IndexSegment(_$e1, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === _$t2.order && r.push(new $59fc9b849b320ded$var$IndexSegment(_$e1, 1 /* IndexKind.DESCENDING */ ));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                n.push(new $59fc9b849b320ded$var$FieldIndex($59fc9b849b320ded$var$FieldIndex.UNKNOWN_ID, _$t1, r, $59fc9b849b320ded$var$IndexState.empty()));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return n;
    }(t);
    return $59fc9b849b320ded$var$__PRIVATE_firestoreClientSetIndexConfiguration(r, i);
}
function $59fc9b849b320ded$var$__PRIVATE_tryGetString(e, t) {
    if ("string" != typeof e[t]) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, "Missing string value for: " + t);
    return e[t];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` which you can config persistent cache indexes
 * used for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 *
 * TODO(CSI) Remove @internal to make the API publicly available.
 * @internal
 */ var $59fc9b849b320ded$export$cf4db3c220e88bd8 = function PersistentCacheIndexManager(e) {
    "use strict";
    (0, $978gY._)(this, PersistentCacheIndexManager);
    this._client = e, this.type = "PersistentCacheIndexManager";
};
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @return The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 *
 * TODO(CSI) Remove @internal to make the API publicly available.
 * @internal
 */ function $59fc9b849b320ded$export$61c6347b57bdfa06(e) {
    var t;
    e = $59fc9b849b320ded$export$572106fb5803752c(e, $59fc9b849b320ded$export$d0e2b3272814ce82);
    var n = $59fc9b849b320ded$var$we.get(e);
    if (n) return n;
    var r = $59fc9b849b320ded$export$8da5fbea04405656(e);
    if ("persistent" !== (null === (t = r._uninitializedComponentsProvider) || void 0 === t ? void 0 : t._offlineKind)) return null;
    var i = new $59fc9b849b320ded$export$cf4db3c220e88bd8(r);
    return $59fc9b849b320ded$var$we.set(e, i), i;
}
/**
 * Enables SDK to create persistent cache indexes automatically for local query
 * execution when SDK believes cache indexes can help improves performance.
 *
 * This feature is disabled by default.
 *
 * TODO(CSI) Remove @internal to make the API publicly available.
 * @internal
 */ function $59fc9b849b320ded$export$9b2c0a7aacbcd151(e) {
    $59fc9b849b320ded$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 *
 * TODO(CSI) Remove @internal to make the API publicly available.
 * @internal
 */ function $59fc9b849b320ded$export$5b460d5f48076743(e) {
    $59fc9b849b320ded$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 *
 * TODO(CSI) Remove @internal to make the API publicly available.
 * @internal
 */ function $59fc9b849b320ded$export$72809fc2fc5083d5(e) {
    e._client.verifyNotTerminated();
    $59fc9b849b320ded$var$__PRIVATE_firestoreClientDeleteAllFieldIndexes(e._client).then(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_logDebug("deleting all persistent cache indexes succeeded");
    }).catch(function(e) {
        return $59fc9b849b320ded$export$86cd73f49cc6e0bb("deleting all persistent cache indexes failed", e);
    });
}
function $59fc9b849b320ded$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(e, t) {
    e._client.verifyNotTerminated();
    $59fc9b849b320ded$var$__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e._client, t).then(function(e) {
        return $59fc9b849b320ded$var$__PRIVATE_logDebug("setting persistent cache index auto creation isEnabled=".concat(t, " succeeded"));
    }).catch(function(e) {
        return $59fc9b849b320ded$export$86cd73f49cc6e0bb("setting persistent cache index auto creation isEnabled=".concat(t, " failed"), e);
    });
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ var $59fc9b849b320ded$var$we = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ var $59fc9b849b320ded$export$3ab3ff3652492b82 = /*#__PURE__*/ function() {
    "use strict";
    function TestingHooks() {
        (0, $978gY._)(this, TestingHooks);
        throw new Error("instances of this class should not be created");
    }
    (0, $kry2a._)(TestingHooks, null, [
        {
            key: "onExistenceFilterMismatch",
            value: /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback the callback to invoke upon existence filter mismatch.
     *
     * @return a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ function onExistenceFilterMismatch(e) {
                return $59fc9b849b320ded$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(e);
            }
        }
    ]);
    return TestingHooks;
}();
/**
 * The implementation of `TestingHooksSpi`.
 */ var $59fc9b849b320ded$var$__PRIVATE_TestingHooksSpiImpl = /*#__PURE__*/ function() {
    "use strict";
    function __PRIVATE_TestingHooksSpiImpl() {
        (0, $978gY._)(this, __PRIVATE_TestingHooksSpiImpl);
        this.Du = new Map;
    }
    (0, $kry2a._)(__PRIVATE_TestingHooksSpiImpl, [
        {
            key: "it",
            value: function it(e) {
                this.Du.forEach(function(t) {
                    return t(e);
                });
            }
        },
        {
            key: "onExistenceFilterMismatch",
            value: function onExistenceFilterMismatch(e) {
                var t = Symbol(), n = this.Du;
                return n.set(t, e), function() {
                    return n.delete(t);
                };
            }
        }
    ], [
        {
            key: "instance",
            get: function get() {
                return $59fc9b849b320ded$var$Se || ($59fc9b849b320ded$var$Se = new __PRIVATE_TestingHooksSpiImpl, function __PRIVATE_setTestingHooksSpi(e) {
                    if ($59fc9b849b320ded$var$ce) throw new Error("a TestingHooksSpi instance is already set");
                    $59fc9b849b320ded$var$ce = e;
                }($59fc9b849b320ded$var$Se)), $59fc9b849b320ded$var$Se;
            }
        }
    ]);
    return __PRIVATE_TestingHooksSpiImpl;
}();
var $59fc9b849b320ded$var$Se = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    !function __PRIVATE_setSDKVersion(e) {
        $59fc9b849b320ded$var$S = e;
    }((0, $2b7c3095396a3894$export$31499a9cd224b78c)), (0, $2b7c3095396a3894$export$c930050e7bb63965)(new (0, $48bece3fef299311$export$16fa2f45be04daa8)("firestore", function(e, param) {
        var n = param.instanceIdentifier, r = param.options;
        var i = e.getProvider("app").getImmediate(), s = new $59fc9b849b320ded$export$d0e2b3272814ce82(new $59fc9b849b320ded$var$__PRIVATE_FirebaseAuthCredentialsProvider(e.getProvider("auth-internal")), new $59fc9b849b320ded$var$__PRIVATE_FirebaseAppCheckTokenProvider(e.getProvider("app-check-internal")), function __PRIVATE_databaseIdFromApp(e, t) {
            if (!Object.prototype.hasOwnProperty.apply(e.options, [
                "projectId"
            ])) throw new $59fc9b849b320ded$export$8fada0bf726bf278($59fc9b849b320ded$var$D.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
            return new $59fc9b849b320ded$export$4c3ccc07620ae30a(e.options.projectId, t);
        }(i, n), i);
        return r = Object.assign({
            useFetchStreams: t
        }, r), s._setSettings(r), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $2b7c3095396a3894$export$d29d5299a7137abc)($59fc9b849b320ded$var$w, "4.1.3", e), // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $2b7c3095396a3894$export$d29d5299a7137abc)($59fc9b849b320ded$var$w, "4.1.3", "esm2017");
}();





// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
var $a65c674dc9c6bbe7$var$firebaseProdConfig = {};
var $a65c674dc9c6bbe7$var$firebaseTestConfig = {
    apiKey: "AIzaSyAZtGLDQk2wp46GopSGD_qdE2V4DPND3Js",
    authDomain: "car-rental-3a89c.firebaseapp.com",
    projectId: "car-rental-3a89c",
    storageBucket: "car-rental-3a89c.appspot.com",
    messagingSenderId: "245620725985",
    appId: "1:245620725985:web:742a591c5795ae01a6ffa0",
    measurementId: "G-XBB81DTK3F"
};
// Initialize Firebase
var $a65c674dc9c6bbe7$var$app = (0, $2b7c3095396a3894$export$c55cfd413944906d)($a65c674dc9c6bbe7$var$firebaseTestConfig);
// const analytics = process.env.REACT_APP_ENV ? getAnalytics(app) : {};
// Initialize Firebase
var $a65c674dc9c6bbe7$export$f932f06c7eb6abeb = (0, $59fc9b849b320ded$export$f06a05d14c3a6678)($a65c674dc9c6bbe7$var$app);
// Initialize Authentication
var $a65c674dc9c6bbe7$export$73693bad9f5880b0 = (0, $0021d6672f58c7eb$export$ae1af26003f05816)($a65c674dc9c6bbe7$var$app);
// Create a GoogleAuthProvider instance
var $a65c674dc9c6bbe7$export$ca328f169d304df4 = new (0, $0021d6672f58c7eb$export$71cec2538cb2c617)();
 // export default analytics;



parcelRequire("6cds3");
var $e6bd8855b2c94cc2$var$UserMenu = function(param) {
    var closeModal = param.closeModal, logoutHandler = param.logoutHandler;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "absolute top-16 px-4 py-2 rounded-sm bg-indigo-400 text-white border",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
            className: "cursor-pointer",
            onClick: function() {
                return logoutHandler();
            },
            children: "Log Out"
        })
    });
};
var $e6bd8855b2c94cc2$export$2e2bcd8739ae039 = $e6bd8855b2c94cc2$var$UserMenu;


var $9121ed6559fc7119$exports = {};


$9121ed6559fc7119$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("jwHqv");


var $c2f7c44039ab2a82$var$Header = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), openDrawer = _useState[0], setOpenDrawer = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)({}), 2), user = _useState1[0], setUser = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), showModal = _useState2[0], setShowModal = _useState2[1];
    var toggleDrawer = function() {
        setOpenDrawer(!openDrawer);
    };
    var googleLoginHandler = function() {
        (0, $0021d6672f58c7eb$export$db3b6bfb95261072)((0, $a65c674dc9c6bbe7$export$73693bad9f5880b0), (0, $a65c674dc9c6bbe7$export$ca328f169d304df4)).then(function(result) {
            setUser(result.user);
        }).catch(function(error) {
            return console.log(error.message);
        });
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex justify-between bg-gray-300 items-center navbar px-[6%] py-2 fixed w-full z-20 bg-white font-bold",
                style: {
                    background: "rgba(217, 217, 217, 0.01)",
                    boxShadow: "2px 4px 20px 0px rgba(125, 110, 235, 0.5)",
                    backdropFilter: "blur(10px)"
                },
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9121ed6559fc7119$exports))),
                            alt: "RentNHost",
                            width: 90,
                            height: 90
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "md:flex items-center justify-between hidden space-x-5",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "/about-us",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "hover:text-blue-800 cursor-pointer",
                                    children: "About"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "/allCars",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "hover:text-blue-800 cursor-pointer",
                                    children: "Cars"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "/maps",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "hover:text-blue-800 cursor-pointer",
                                    children: "Locations"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "/dashboard",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "hover:text-blue-800 cursor-pointer",
                                    children: "Dashboard"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                to: "/contact-us",
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "hover:text-blue-800 cursor-pointer",
                                    children: "Contact"
                                })
                            })
                        ]
                    }),
                    !user || Object.keys(user).length === 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        onClick: googleLoginHandler,
                        className: "md:flex hidden px-8 py-2 bg-indigo-800 rounded-md cursor-pointer text-white font-semibold shadow-md hover:bg-blue-700 hover:text-white transition-all duration-300",
                        children: "Sign In"
                    }),
                    user && Object.keys(user).length !== 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: " flex flex-col items-end",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                src: user.photoURL,
                                alt: "avatar",
                                className: "h-10 w-10 cursor-pointer rounded-full border border-indigo-800",
                                onClick: function() {
                                    return setShowModal(function(prev) {
                                        return !prev;
                                    });
                                }
                            }),
                            showModal && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e6bd8855b2c94cc2$export$2e2bcd8739ae039), {
                                closeModal: function() {
                                    return setShowModal(false);
                                },
                                logoutHandler: function() {
                                    setUser({});
                                    setShowModal(false); // Close the menu when logging out
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "md:hidden",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            onClick: toggleDrawer,
                            children: openDrawer ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                children: "✕"
                            }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fba0f23e9e6a11bb$exports.Fragment), {
                                children: "≡"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "md:hidden",
                children: openDrawer && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "fixed top-0 right-0 h-screen w-64 bg-white overflow-y-auto z-30",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            onClick: toggleDrawer,
                            className: "absolute top-5 right-5",
                            children: "✕"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "p-4 pt-14",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "mb-4 hover:text-blue-800 cursor-pointer",
                                    children: "About"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "mb-4 hover:text-blue-800 cursor-pointer",
                                    children: "Features"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "mb-4 hover:text-blue-800 cursor-pointer",
                                    children: "Pricing"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "mb-4 hover:text-blue-800 cursor-pointer",
                                    children: "Resources"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "mb-4 hover:text-blue-800 cursor-pointer",
                                    children: "Contact"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                    className: "px-8 py-2 bg-indigo-800 rounded-md cursor-pointer text-white font-semibold shadow-md hover:bg-blue-700 hover:text-white transition-all duration-300",
                                    children: "Sign In"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $c2f7c44039ab2a82$export$2e2bcd8739ae039 = $c2f7c44039ab2a82$var$Header;



parcelRequire("6cds3");
var $5c8d66dd78e8a9be$exports = {};


$5c8d66dd78e8a9be$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("2ytRI");


var $464f7e1e1b1e23b9$var$Summary = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex px-[6%] py-24 flex-row flex-wrap flex-grow",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5c8d66dd78e8a9be$exports))),
                    alt: "cars",
                    className: "rounded-md w-[90%] h-[90%]"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "text-blue-800 font-semibold py-2 text-2xl",
                        children: "About Us"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "font-bold text-3xl pb-4",
                        children: [
                            "More than 150+ special collection",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            " cars"
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "text-gray-600 pb-4",
                        children: [
                            "Get the car of your dreams with the installments of your",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            " choice. There are various attractive offers from Moladin",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            " through our collaboration with various trusted leasing",
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                            " partners."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "bg-blue-800 p-4 rounded-md span w-[200px] text-white font-bold",
                        children: "See all cars"
                    })
                ]
            })
        ]
    });
};
var $464f7e1e1b1e23b9$export$2e2bcd8739ae039 = $464f7e1e1b1e23b9$var$Summary;



parcelRequire("6cds3");
var $2ac43e6e762af0c6$var$services = [
    {
        image: "https://img.icons8.com/bubbles/500/000000/car.png",
        heading: "Select a Car",
        description: "We provide an extensive selection of vehicles catering to all your driving requirements. Our fleet offers the ideal car to suit your specific needs."
    },
    {
        image: "https://img.icons8.com/bubbles/500/000000/user.png",
        heading: "Contact Operator",
        description: "Our dedicated and amiable operators are available at all times, prepared to assist you with any inquiries or issues you may have."
    },
    {
        image: "https://img.icons8.com/external-flaticons-lineal-color-flat-icons/500/external-lease-automotive-dealership-flaticons-lineal-color-flat-icons-6.png",
        heading: "Drive your car",
        description: "Whether you're embarking on a road trip or any other journey, rest assured that our diverse array of cars has your transportation needs fully covered."
    }
];
var $2ac43e6e762af0c6$var$OurServices = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "text-blue-800 text-2xl font-semibold text-center",
                        children: "Plan your journey now"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "font-bold text-4xl text-center",
                        children: "Speedy Car Renting Solution"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "flex justify-around flex-col md:flex-row",
                children: $2ac43e6e762af0c6$var$services.map(function(service, index) {
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "flex flex-col items-center p-12",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    src: service.image,
                                    alt: "service",
                                    width: "170",
                                    height: "170"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "text-center font-bold text-2xl mb-2",
                                children: service.heading
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "text-center text-gray-600",
                                children: service.description
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var $2ac43e6e762af0c6$export$2e2bcd8739ae039 = $2ac43e6e762af0c6$var$OurServices;




var $8GFUW = parcelRequire("8GFUW");

var $fLnyw = parcelRequire("fLnyw");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");
var $2693aac9bc223c1f$exports = {};


$2693aac9bc223c1f$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("7YTpF");




parcelRequire("6cds3");

var $1b15c7dc9b0da310$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                class: "container",
                className: "px-[10%] mb-5",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("article", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "flex flex-row mx-10",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    class: "line"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    class: "line"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    class: "line"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    class: "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                            class: "shimmer"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                class: "container",
                className: "flex flex-wrap px-[10%]",
                children: new Array(6).fill(null).map(function(item, index) {
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("article", {
                        className: "flex flex-col flex-grow box-border p-5 m-1 w-[350px]",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                class: "img-line"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                class: "line"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                class: "line"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                class: "line"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                class: "shimmer"
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
var $1b15c7dc9b0da310$export$2e2bcd8739ae039 = $1b15c7dc9b0da310$var$Shimmer;


console.log("NODE_ENV:", "production");
var $38a2ebced121b915$var$apiUrl = "https://car-rental-backend-u6r1.onrender.com/";
console.log("apiUrl:", $38a2ebced121b915$var$apiUrl);
var $38a2ebced121b915$export$2e2bcd8739ae039 = $38a2ebced121b915$var$apiUrl;


var $f2b1fc8e16c23bf2$var$AvailableCars = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), cars = _useState[0], setCars = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(1), 2), selectedCategory = _useState1[0], setSelectedCategory = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(1), 2), visibleCategories = _useState2[0], setVisibleCategories = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(1), 2), showCategoryCarsId = _useState3[0], setShowCategoryCarsId = _useState3[1];
    var _useState4 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), buttonClick = _useState4[0], setButtonClick = _useState4[1];
    var _useState5 = (0, $8GFUW._)((0, $6cds3.useState)(true), 2), loading = _useState5[0], setIsLoading = _useState5[1];
    (0, $6cds3.useEffect)(function() {
        var getCars = function() {
            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                var response, data, error;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            setIsLoading(true);
                            return [
                                4,
                                fetch("".concat((0, $38a2ebced121b915$export$2e2bcd8739ae039), "cars/getCars?limit=6"))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            setCars(data);
                            setIsLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            alert("Something went wrong");
                            _state.label = 4;
                        case 4:
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            alert("Error: " + error);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getCars() {
                return _ref.apply(this, arguments);
            };
        }();
        getCars();
    }, []);
    var categoriesPerPage = {
        small: 1,
        medium: 2,
        large: 4
    };
    var handleNextClick = function() {
        setSelectedCategory(function(prev) {
            return prev % cars.length + 1;
        });
        setButtonClick("next");
    };
    var handlePrevClick = function() {
        setSelectedCategory(function(prev) {
            var nextCategory = prev - 1 <= 0 ? cars.length : prev - 1;
            return nextCategory;
        });
        setButtonClick("prev");
    };
    var updateVisibleCategories = function() {
        var screenWidth = window.innerWidth;
        if (screenWidth >= 1024) setVisibleCategories(categoriesPerPage.large);
        else if (screenWidth >= 768) setVisibleCategories(categoriesPerPage.medium);
        else setVisibleCategories(categoriesPerPage.small);
    };
    (0, $6cds3.useEffect)(function() {
        updateVisibleCategories();
        window.addEventListener("resize", updateVisibleCategories);
        return function() {
            window.removeEventListener("resize", updateVisibleCategories);
        };
    }, []);
    var handleCategoryClick = function(categoryId) {
        setShowCategoryCarsId(categoryId);
    };
    var visibleCategoryIds = (0, $fLnyw._)(Array(visibleCategories).keys()).map(function(index) {
        return (selectedCategory - 1 + index) % cars.length + 1;
    });
    (0, $6cds3.useEffect)(function() {
        if (visibleCategoryIds.includes(showCategoryCarsId)) return;
        else if (buttonClick == "prev") setShowCategoryCarsId(visibleCategoryIds[visibleCategoryIds.length - 1]);
        else if (buttonClick == "next") setShowCategoryCarsId(visibleCategoryIds[0]);
    }, [
        visibleCategoryIds
    ]);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex flex-col py-10",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "text-blue-800 text-2xl font-semibold text-center",
                children: "Collection"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "font-bold text-4xl text-center",
                children: "Our Collection Cars"
            }),
            loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1b15c7dc9b0da310$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "flex items-center justify-center space-x-12 mx-[5%]",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                width: "30",
                                height: "30",
                                src: "https://img.icons8.com/ios-filled/50/left-squared--v1.png",
                                alt: "left-squared--v1",
                                onClick: handlePrevClick,
                                className: "relative top-4 cursor-pointer"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "flex flex-1 justify-around border-b border-gray-300 text-gray-400 text-md",
                                children: visibleCategoryIds.map(function(categoryId) {
                                    var category = cars.find(function(car) {
                                        return car.id === categoryId;
                                    });
                                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "w-full text-center cursor-pointer ".concat(categoryId === showCategoryCarsId ? "border-b-2 border-black text-black transition ease-in-out duration-300" : ""),
                                        onClick: function() {
                                            return handleCategoryClick(categoryId);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: "text-6xl relative top-3",
                                                children: "\xb7"
                                            }),
                                            " " + (category === null || category === void 0 ? void 0 : category.name)
                                        ]
                                    }, category.id);
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                width: "30",
                                height: "30",
                                src: "https://img.icons8.com/ios-filled/50/right-squared--v1.png",
                                alt: "right-squared--v1",
                                className: "relative top-4 cursor-pointer",
                                onClick: handleNextClick
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "px-[5%]",
                        children: cars.map(function(car_category, category_index) {
                            if (car_category.id === showCategoryCarsId) return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                className: "flex flex-wrap",
                                children: car_category.cars.map(function(car, car_index) {
                                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "flex flex-col flex-grow box-border px-10 py-10 w-[350px]",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    className: "h-[160px]",
                                                    src: car.image_url,
                                                    alt: "car img"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                className: "flex justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                        className: "flex items-start",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                className: "center",
                                                                width: "30",
                                                                height: "30",
                                                                src: "https://img.icons8.com/color/48/rupee--v1.png",
                                                                alt: "rupee--v1"
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "font-bold text-lg",
                                                                children: car.price_per_day
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "text-gray-400",
                                                                children: " /days"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                        className: "flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "w-[20px] h-[20px]",
                                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2693aac9bc223c1f$exports))),
                                                                    alt: "location"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                                className: "text-gray-400",
                                                                children: car.location
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                className: "font-bold text-lg py-2",
                                                children: [
                                                    "  " + car.make + " ",
                                                    car.model + " ",
                                                    car.year
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                className: "flex items-center justify-center rounded-sm text-center p-2 ".concat(car_index == 0 ? " bg-indigo-800 text-white" : "bg-gray-200 hover:bg-indigo-800 hover:text-white", " "),
                                                children: [
                                                    car_index == 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        children: "\uD83D\uDCDE"
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                        children: " Book Now"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, car.id);
                                })
                            }, car_category.id);
                            return null;
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "text-center",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                    to: "/allCars",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        className: "bg-indigo-800 text-white my-5 p-2 px-4 rounded-sm font-medium",
                        children: "See all cars..."
                    })
                })
            })
        ]
    });
};
var $f2b1fc8e16c23bf2$export$2e2bcd8739ae039 = $f2b1fc8e16c23bf2$var$AvailableCars;



parcelRequire("6cds3");


var $1f748919507f0a47$var$Footer = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: " w-full flex items-start bg-gray-300 justify-around text-black text-lg py-10 flex-wrap cursor-pointer",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($9121ed6559fc7119$exports))),
                    alt: "renNHost",
                    width: 250,
                    height: 250
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "font-bold cursor-auto",
                        children: "Company"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "About Us"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Category"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Resources"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "font-bold cursor-auto",
                        children: "Developer"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Github"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Linkedin"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Leetcode"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "font-bold  cursor-auto",
                        children: "Social"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Linkedin"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Twitter"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Youtube"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Quora"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex flex-col space-y-2",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "font-bold  cursor-auto",
                        children: "Legal"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Terms of services"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: "Return Policy"
                    })
                ]
            })
        ]
    });
};
var $1f748919507f0a47$export$2e2bcd8739ae039 = $1f748919507f0a47$var$Footer;




var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");
var $44226215798a3592$export$c2de8e0aab246379 = [
    "Banjara Hills",
    "Jubilee Hills",
    "Hitech City",
    "Gachibowli",
    "Secunderabad",
    "Kukatpally",
    "Madhapur",
    "Ameerpet",
    "Begumpet",
    "Shamshabad"
];
var $44226215798a3592$export$3efe6757a6cde5e5 = [
    {
        id: 1,
        name: "SUV",
        cars: [
            {
                id: 101,
                make: "Toyota",
                model: "Fortuner",
                year: 2022,
                price_per_day: 90,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "3.0L V6",
                    transmission: "Automatic",
                    seating_capacity: 7
                },
                image_url: "https://imgd.aeplcdn.com/1920x1080/n/cw/ec/44709/fortuner-exterior-right-front-three-quarter-19.jpeg?q=75&q=75"
            },
            {
                id: 102,
                make: "Ford",
                model: "Endeavour",
                year: 2022,
                price_per_day: 85,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "2.0L EcoBlue",
                    transmission: "Automatic",
                    seating_capacity: 7
                },
                image_url: "https://imgd.aeplcdn.com/664x374/n/cw/ec/37640/endeavour-exterior-right-front-three-quarter-149473.jpeg?q=75&q=75"
            },
            {
                id: 103,
                make: "Nissan",
                model: "Pathfinder",
                year: 2022,
                price_per_day: 80,
                location: "Hitech City",
                available: true,
                specifications: {
                    engine: "3.5L V6",
                    transmission: "Automatic",
                    seating_capacity: 7
                },
                image_url: "https://www.motortrend.com/uploads/sites/10/2018/11/2019-nissan-pathfinder-s-4wd-suv-angular-front.png?fit=around%7C770:481.25"
            },
            {
                id: 104,
                make: "Chevrolet",
                model: "Traverse",
                year: 2022,
                price_per_day: 75,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "3.6L V6",
                    transmission: "Automatic",
                    seating_capacity: 8
                },
                image_url: "https://www.motortrend.com/uploads/sites/10/2017/09/2018-chevrolet-traverse-1lt-suv-angular-front.png"
            },
            {
                id: 105,
                make: "Honda",
                model: "Pilot",
                year: 2022,
                price_per_day: 88,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "3.5L V6",
                    transmission: "Automatic",
                    seating_capacity: 8
                },
                image_url: "https://www.motortrend.com/uploads/sites/10/2022/02/2022-honda-pilot-touring-suv-angular-front.png?fit=around%7C875:492.1875"
            },
            {
                id: 106,
                make: "Hyundai",
                model: "Santa Fe",
                year: 2022,
                price_per_day: 82,
                location: "Kukatpally",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/10/2021/09/2021-hyundai-santa-fe-hybrid-limited-hev-4wd-suv-angular-front.png?fit=around%7C770:481.25"
            },
            {
                id: 107,
                make: "Jeep",
                model: "Grand Cherokee",
                year: 2022,
                price_per_day: 95,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "3.6L V6",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/10/2021/09/2021-jeep-grand-cherokee-l-limited-4wd-suv-angular-front.png?fit=around%7C875:492.1875"
            },
            {
                id: 108,
                make: "Mitsubishi",
                model: "Outlander",
                year: 2022,
                price_per_day: 78,
                location: "Secunderabad",
                available: true,
                specifications: {
                    engine: "2.4L Inline-4",
                    transmission: "CVT",
                    seating_capacity: 7
                },
                image_url: "https://www.motortrend.com/uploads/izmo/mitsubishi/outlander/2022/outlander.png?fit=around%7C875:492.1875"
            },
            {
                id: 109,
                make: "Subaru",
                model: "Ascent",
                year: 2022,
                price_per_day: 86,
                location: "Ameerpet",
                available: true,
                specifications: {
                    engine: "2.4L Turbocharged Boxer-4",
                    transmission: "CVT",
                    seating_capacity: 8
                },
                image_url: "https://www.motortrend.com/uploads/2023/06/039-2024-Subaru-Ascent-Front-view.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 110,
                make: "Kia",
                model: "Telluride",
                year: 2022,
                price_per_day: 92,
                location: "Uppal",
                available: true,
                specifications: {
                    engine: "3.8L V6",
                    transmission: "Automatic",
                    seating_capacity: 8
                },
                image_url: "https://www.motortrend.com/uploads/2022/04/2023-Kia-Telluride-14.jpg?fit=around%7C770:481.25"
            },
            {
                id: 111,
                make: "GMC",
                model: "Acadia",
                year: 2022,
                price_per_day: 79,
                location: "L.B. Nagar",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 7
                },
                image_url: "https://www.motortrend.com/uploads/2022/09/001-2023-GMC-Acadia.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 112,
                make: "Volkswagen",
                model: "Atlas",
                year: 2022,
                price_per_day: 81,
                location: "Charminar",
                available: true,
                specifications: {
                    engine: "3.6L V6",
                    transmission: "Automatic",
                    seating_capacity: 7
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/08/2022-Volkswagen-Atlas-SEL-V6-4Motion-Basecamp-34.jpg?fit=around%7C770:481.25"
            }
        ]
    },
    {
        id: 2,
        name: "Sedan",
        cars: [
            {
                id: 201,
                make: "Toyota",
                model: "Camry",
                year: 2022,
                price_per_day: 70,
                location: "Himayat Nagar",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2023/02/2024-Toyota-Camry-rendering-front.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 202,
                make: "Honda",
                model: "Civic",
                year: 2022,
                price_per_day: 65,
                location: "Koti",
                available: true,
                specifications: {
                    engine: "1.5L Turbocharged Inline-4",
                    transmission: "CVT",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2022/09/2023-Honda-Civic-Sport-HPD-exterior-6.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 203,
                make: "Nissan",
                model: "Altima",
                year: 2022,
                price_per_day: 68,
                location: "Panjagutta",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2022/06/2023-Nissan-Altima-SR-2.0-VC-Turbo-29.jpg?fit=around%7C770:481.25"
            },
            {
                id: 204,
                make: "Ford",
                model: "Fusion",
                year: 2022,
                price_per_day: 63,
                location: "Secunderabad",
                available: true,
                specifications: {
                    engine: "2.0L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2020/06/2020-ford-fusion-hybrid.png?fit=around%7C875:492.1875"
            },
            {
                id: 205,
                make: "Chevrolet",
                model: "Malibu",
                year: 2022,
                price_per_day: 66,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "1.5L Turbocharged Inline-4",
                    transmission: "CVT",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2020/12/2021-Chevrolet-Malibu-4.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 206,
                make: "Hyundai",
                model: "Elantra",
                year: 2022,
                price_per_day: 67,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "2.0L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2022/07/2023-Hyundai-Elantra-Hybrid-Limited-4.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 207,
                make: "Kia",
                model: "Optima",
                year: 2022,
                price_per_day: 69,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.iihs.org/cdn-cgi/image/width=636/api/ratings/model-year-images/2906/"
            },
            {
                id: 208,
                make: "Mazda",
                model: "Mazda3",
                year: 2022,
                price_per_day: 72,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 209,
                make: "Volkswagen",
                model: "Jetta",
                year: 2022,
                price_per_day: 71,
                location: "Charminar",
                available: true,
                specifications: {
                    engine: "1.4L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 210,
                make: "Subaru",
                model: "Impreza",
                year: 2022,
                price_per_day: 64,
                location: "Ameerpet",
                available: true,
                specifications: {
                    engine: "2.0L Flat-4",
                    transmission: "CVT",
                    seating_capacity: 5
                }
            },
            {
                id: 211,
                make: "Mercedes-Benz",
                model: "C-Class",
                year: 2022,
                price_per_day: 80,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 212,
                make: "BMW",
                model: "3 Series",
                year: 2022,
                price_per_day: 82,
                location: "Kukatpally",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 213,
                make: "Audi",
                model: "A4",
                year: 2022,
                price_per_day: 85,
                location: "Uppal",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 214,
                make: "Lexus",
                model: "ES",
                year: 2022,
                price_per_day: 78,
                location: "Hitech City",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 215,
                make: "Infiniti",
                model: "Q50",
                year: 2022,
                price_per_day: 76,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "3.0L Twin-Turbo V6",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 216,
                make: "Cadillac",
                model: "CTS",
                year: 2022,
                price_per_day: 83,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "3.6L V6",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 217,
                make: "Lincoln",
                model: "MKZ",
                year: 2022,
                price_per_day: 77,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 218,
                make: "Jaguar",
                model: "XE",
                year: 2022,
                price_per_day: 79,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 219,
                make: "Volvo",
                model: "S60",
                year: 2022,
                price_per_day: 74,
                location: "Koti",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 220,
                make: "Tesla",
                model: "Model 3",
                year: 2022,
                price_per_day: 90,
                location: "Himayat Nagar",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            }
        ]
    },
    {
        id: 3,
        name: "Hatchback",
        cars: [
            {
                id: 301,
                make: "Toyota",
                model: "Corolla Hatchback",
                year: 2022,
                price_per_day: 60,
                location: "Himayat Nagar",
                available: true,
                specifications: {
                    engine: "2.0L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/06/2022-toyota-corolla-cross-exterior-03.jpg?fit=around%7C770:481.25"
            },
            {
                id: 302,
                make: "Honda",
                model: "Fit",
                year: 2022,
                price_per_day: 55,
                location: "Koti",
                available: true,
                specifications: {
                    engine: "1.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/10/2017/10/2018-honda-fit-ex-hatchback-angular-front.png?fit=around%7C875:492.1875"
            },
            {
                id: 303,
                make: "Nissan",
                model: "Versa",
                year: 2022,
                price_per_day: 58,
                location: "Panjagutta",
                available: true,
                specifications: {
                    engine: "1.6L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2022/10/2023-Nissan-Versa-sedan-debut-20.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 304,
                make: "Ford",
                model: "Fiesta",
                year: 2022,
                price_per_day: 53,
                location: "Secunderabad",
                available: true,
                specifications: {
                    engine: "1.6L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://stimg.cardekho.com/car-images/carexteriorimages/large/Ford/Ford-Fiesta/side-view-(left)-090.jpg?tr=w-456"
            },
            {
                id: 305,
                make: "Chevrolet",
                model: "Spark",
                year: 2022,
                price_per_day: 56,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "1.4L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 4
                },
                image_url: "https://www.motortrend.com/uploads/sites/10/2020/12/2021-chevrolet-spark-ls-5door-hatchback-angular-front.png?fit=around%7C875:492.1875"
            },
            {
                id: 306,
                make: "Hyundai",
                model: "i30",
                year: 2022,
                price_per_day: 57,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "2.0L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/11/2016/09/2017-Hyundai-I30-European-Spec-front-side-1.jpg?fit=around%7C875:492"
            },
            {
                id: 307,
                make: "Kia",
                model: "Rio",
                year: 2022,
                price_per_day: 59,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "1.6L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2021/11/2022-Kia-Rio-77.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 308,
                make: "Mazda",
                model: "Mazda2",
                year: 2022,
                price_per_day: 62,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "1.5L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/11/2014/11/Mazda2-sedan-front-side-view-in-motion-city.jpg?fit=around%7C875:492"
            },
            {
                id: 309,
                make: "Volkswagen",
                model: "Golf",
                year: 2022,
                price_per_day: 61,
                location: "Charminar",
                available: true,
                specifications: {
                    engine: "1.4L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/06/2021-volkswagen-golf-exterior-01.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 310,
                make: "Subaru",
                model: "Impreza Hatchback",
                year: 2022,
                price_per_day: 54,
                location: "Ameerpet",
                available: true,
                specifications: {
                    engine: "2.0L Flat-4",
                    transmission: "CVT",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2021/12/2022-Subaru-Impreza.jpg?fit=around%7C875:492.1875"
            }
        ]
    },
    {
        id: 4,
        name: "Convertible",
        cars: [
            {
                id: 401,
                make: "Mazda",
                model: "MX-5 Miata",
                year: 2022,
                price_per_day: 85,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "2.0L Inline-4",
                    transmission: "Manual",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/2022/11/2023-Mazda-MX-5-RF-Club-front-three-quarter-view-25.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 402,
                make: "Ford",
                model: "Mustang Convertible",
                year: 2022,
                price_per_day: 95,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "2.3L EcoBoost Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 4
                },
                image_url: "https://www.motortrend.com/uploads/2021/10/2022-Ford-Mustang-GT-California-Special_02-1.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 403,
                make: "Chevrolet",
                model: "Camaro Convertible",
                year: 2022,
                price_per_day: 90,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "3.6L V6",
                    transmission: "Automatic",
                    seating_capacity: 4
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/08/2022-Chevrolet-Camaro-RS-31.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 404,
                make: "BMW",
                model: "Z4",
                year: 2022,
                price_per_day: 100,
                location: "Hitech City",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/08/2022-BMW-Z4-m40i-350.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 405,
                make: "Porsche",
                model: "911 Cabriolet",
                year: 2022,
                price_per_day: 150,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "3.0L Twin-Turbo Flat-6",
                    transmission: "Automatic",
                    seating_capacity: 4
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2013/09/2014-Porsche-911-Turbo-S-Cabriolet-front-three-quarter-in-motion-032.jpg?fit=around%7C875:492"
            },
            {
                id: 406,
                make: "Audi",
                model: "A3 Cabriolet",
                year: 2022,
                price_per_day: 110,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "2.0L Turbocharged Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 4
                },
                image_url: "https://www.motortrend.com/uploads/2021/10/2022-Audi-A3-49.jpg?fit=around%7C875:492"
            }
        ]
    },
    {
        id: 5,
        name: "Luxury",
        cars: [
            {
                id: 501,
                make: "Mercedes-Benz",
                model: "S-Class",
                year: 2022,
                price_per_day: 250,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "3.0L Turbocharged Inline-6",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/08/2022-Mercedes-Benz-S-500-S-580-4Matic-28.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 502,
                make: "BMW",
                model: "7 Series",
                year: 2022,
                price_per_day: 240,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "3.0L Turbocharged Inline-6",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/04/2021-bmw-7series-exterior-01.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 503,
                make: "Audi",
                model: "A8",
                year: 2022,
                price_per_day: 230,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "3.0L Turbocharged V6",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2022/07/2023-Audi-A8-42-front-three-quarter-view.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 504,
                make: "Lexus",
                model: "LS",
                year: 2022,
                price_per_day: 220,
                location: "Hitech City",
                available: true,
                specifications: {
                    engine: "3.5L V6 Hybrid",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2022/02/2022-Lexus-LS-500-RWD-1.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 505,
                make: "Jaguar",
                model: "XJ",
                year: 2022,
                price_per_day: 210,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "3.0L Supercharged V6",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/sites/11/2020/11/1990-Jaguar-XJ-V-12-front-three-quarter-1.jpg?fit=around%7C875:492"
            },
            {
                id: 506,
                make: "Tesla",
                model: "Model S",
                year: 2022,
                price_per_day: 280,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 5
                },
                image_url: "https://www.motortrend.com/uploads/2022/11/2023-Tesla-Model-S-Plaid-Offsite-38.jpg?fit=around%7C875:492.1875"
            }
        ]
    },
    {
        id: 6,
        name: "Sports",
        cars: [
            {
                id: 601,
                make: "Porsche",
                model: "911",
                year: 2022,
                price_per_day: 300,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "3.0L Twin-Turbo Flat-6",
                    transmission: "Automatic",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/06/2022-Porsche-911-GT3-Touring-17.jpg?fit=around%7C875:492"
            },
            {
                id: 602,
                make: "Ferrari",
                model: "488 GTB",
                year: 2022,
                price_per_day: 500,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "3.9L Twin-Turbo V8",
                    transmission: "Automatic",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2015/03/2016-Ferrari-488-gtb-front-three-quarters1.jpg?fit=around%7C875:492"
            },
            {
                id: 603,
                make: "Lamborghini",
                model: "Hurac\xe1n",
                year: 2022,
                price_per_day: 550,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "5.2L V10",
                    transmission: "Automatic",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/2023/01/2023-Lamborghini-Huracan-Tecnica-6.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 604,
                make: "McLaren",
                model: "720S",
                year: 2022,
                price_per_day: 450,
                location: "Hitech City",
                available: true,
                specifications: {
                    engine: "4.0L Twin-Turbo V8",
                    transmission: "Automatic",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/2023/02/2023-McLaren-720S-Spider-13.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 605,
                make: "Aston Martin",
                model: "DB11",
                year: 2022,
                price_per_day: 400,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "4.0L Twin-Turbo V8",
                    transmission: "Automatic",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/sites/5/2021/09/2022-Aston-Martin-DB11-front-side-01.jpg?fit=around%7C875:492.1875"
            },
            {
                id: 606,
                make: "Nissan",
                model: "GT-R",
                year: 2022,
                price_per_day: 320,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "3.8L Twin-Turbo V6",
                    transmission: "Automatic",
                    seating_capacity: 2
                },
                image_url: "https://www.motortrend.com/uploads/2023/06/2024-Nissan-GT-R-NISMO-front-view-25.jpg?fit=around%7C875:492.1875x"
            }
        ]
    },
    {
        id: 7,
        name: "Electric",
        cars: [
            {
                id: 701,
                make: "Tesla",
                model: "Model S",
                year: 2022,
                price_per_day: 180,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 702,
                make: "Nissan",
                model: "Leaf",
                year: 2022,
                price_per_day: 150,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 703,
                make: "Chevrolet",
                model: "Bolt EV",
                year: 2022,
                price_per_day: 160,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 704,
                make: "Kia",
                model: "Niro EV",
                year: 2022,
                price_per_day: 170,
                location: "Hitech City",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 705,
                make: "BMW",
                model: "i3",
                year: 2022,
                price_per_day: 190,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 4
                }
            },
            {
                id: 706,
                make: "Hyundai",
                model: "Kona Electric",
                year: 2022,
                price_per_day: 155,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "Electric",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            }
        ]
    },
    {
        id: 8,
        name: "Minivan",
        cars: [
            {
                id: 801,
                make: "Toyota",
                model: "Sienna",
                year: 2022,
                price_per_day: 120,
                location: "Banjara Hills",
                available: true,
                specifications: {
                    engine: "2.5L Inline-4 Hybrid",
                    transmission: "CVT",
                    seating_capacity: 7
                }
            },
            {
                id: 802,
                make: "Honda",
                model: "Odyssey",
                year: 2022,
                price_per_day: 130,
                location: "Jubilee Hills",
                available: true,
                specifications: {
                    engine: "3.5L V6",
                    transmission: "Automatic",
                    seating_capacity: 8
                }
            },
            {
                id: 803,
                make: "Chrysler",
                model: "Pacifica",
                year: 2022,
                price_per_day: 125,
                location: "Gachibowli",
                available: true,
                specifications: {
                    engine: "3.6L V6 Hybrid",
                    transmission: "Automatic",
                    seating_capacity: 7
                }
            },
            {
                id: 804,
                make: "Kia",
                model: "Carnival",
                year: 2022,
                price_per_day: 140,
                location: "Hitech City",
                available: true,
                specifications: {
                    engine: "3.5L V6",
                    transmission: "Automatic",
                    seating_capacity: 8
                }
            },
            {
                id: 805,
                make: "Ford",
                model: "Transit Connect",
                year: 2022,
                price_per_day: 110,
                location: "Begumpet",
                available: true,
                specifications: {
                    engine: "2.0L Inline-4",
                    transmission: "Automatic",
                    seating_capacity: 5
                }
            },
            {
                id: 806,
                make: "Dodge",
                model: "Grand Caravan",
                year: 2022,
                price_per_day: 115,
                location: "Madhapur",
                available: true,
                specifications: {
                    engine: "3.6L V6",
                    transmission: "Automatic",
                    seating_capacity: 7
                }
            }
        ]
    }
];




var $7UAGh = parcelRequire("7UAGh");

var $829962ad92a0f7b9$export$c07c686062478869 = function() {
    var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
        return (0, $7UAGh.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch("".concat((0, $38a2ebced121b915$export$2e2bcd8739ae039), "locations/getLocations"), {
                            method: "GET"
                        }).then(function(resp) {
                            return resp.json();
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getLocations() {
        return _ref.apply(this, arguments);
    };
}();


var $80e55dc4a3b629e0$var$Booking = function() {
    var currentDate = new Date().toISOString().slice(0, 10);
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), pickUpLocation = _useState[0], setPickUpLocation = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), selectedPickUpLocation = _useState1[0], setSelectedPickUpLocation = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), dropOffLocation = _useState2[0], setDropOffLocation = _useState2[1];
    var _useState3 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), selectedDropOffLocation = _useState3[0], setSelectedDropOffLocation = _useState3[1];
    var _useState4 = (0, $8GFUW._)((0, $6cds3.useState)(currentDate), 2), selectedPickUpDate = _useState4[0], setSelectedPickUpDate = _useState4[1];
    var _useState5 = (0, $8GFUW._)((0, $6cds3.useState)("12:00"), 2), selectedPickUpTime = _useState5[0], setSelectedPickUpTime = _useState5[1];
    var _useState6 = (0, $8GFUW._)((0, $6cds3.useState)(currentDate), 2), selectedDropOffDate = _useState6[0], setSelectedDropOffDate = _useState6[1];
    var _useState7 = (0, $8GFUW._)((0, $6cds3.useState)("12:00"), 2), selectedDropOffTime = _useState7[0], setSelectedDropOffTime = _useState7[1];
    var _useState8 = (0, $8GFUW._)((0, $6cds3.useState)(false), 2), differentLocation = _useState8[0], setDifferentLocation = _useState8[1];
    var _useState9 = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), carRentalLocations = _useState9[0], setCarRentalLocations = _useState9[1];
    var _useState10 = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), filteredLocations = _useState10[0], setFilteredLocations = _useState10[1];
    var _useState11 = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), filteredDropOffLocations = _useState11[0], setFilteredDropOffLocations = _useState11[1];
    var _useState12 = (0, $8GFUW._)((0, $6cds3.useState)(true), 2), loading = _useState12[0], setLoading = _useState12[1];
    (0, $6cds3.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                var response, err;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, $829962ad92a0f7b9$export$c07c686062478869)()
                            ];
                        case 2:
                            response = _state.sent();
                            setCarRentalLocations(response);
                            setLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.log(err);
                            setLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    (0, $6cds3.useEffect)(function() {
        if (pickUpLocation) {
            var filtered = carRentalLocations.filter(function(location, index) {
                return location.name.toLowerCase().includes(pickUpLocation.toLocaleLowerCase());
            });
            setFilteredLocations(filtered);
        } else setFilteredLocations([]);
    }, [
        pickUpLocation
    ]);
    (0, $6cds3.useEffect)(function() {
        if (dropOffLocation) {
            var filtered = carRentalLocations.filter(function(location, index) {
                return location.name.toLowerCase().includes(dropOffLocation.toLocaleLowerCase());
            });
            setFilteredDropOffLocations(filtered);
        } else setFilteredDropOffLocations([]);
    }, [
        dropOffLocation
    ]);
    var locationSelectHandler = function(location) {
        setSelectedPickUpLocation(location); // Set the selected location
        setPickUpLocation(""); // Set the location's name in the input
        setFilteredLocations([]); // Clear the filtered locations when a location is selected
    };
    var dropOffLocationSelectHandler = function(location) {
        setSelectedDropOffLocation(location); // Set the selected location
        setDropOffLocation(""); // Set the location's name in the input
        setFilteredDropOffLocations([]); // Clear the filtered locations when a location is selected
    };
    var searchHandler = function() {
        var data = {
            selectedPickUpLocation: selectedPickUpLocation,
            selectedDropOffLocation: selectedDropOffLocation,
            selectedPickUpDate: selectedPickUpDate,
            selectedDropOffDate: selectedDropOffDate,
            selectedPickUpTime: selectedPickUpTime,
            selectedDropOffTime: selectedDropOffTime
        };
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "pt-10 px-[5%]",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: "rounded-lg w-full shadow-lg p-8 border-b-8 border-indigo-800",
            style: {
                boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.3)"
            },
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex justify-between flex-wrap items-center flex-grow",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            class: "relative",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                    class: "absolute top-0 left-2 font-medium text-amber-900 text-lg",
                                    children: [
                                        "Pick-up Location ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "text-red-500",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    type: "text",
                                    class: "border border-black pt-8 pb-2 pl-2 w-full text-xl bg-customGray",
                                    value: selectedPickUpLocation ? selectedPickUpLocation.name : pickUpLocation,
                                    placeholder: "Enter Location",
                                    onChange: function(e) {
                                        return setPickUpLocation(e.target.value);
                                    }
                                }),
                                selectedPickUpLocation && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                    onClick: function() {
                                        setSelectedPickUpLocation("");
                                        setPickUpLocation("");
                                    },
                                    className: "absolute top-[-4px] px-3 right-1 font-bold text-red-500 text-lg cursor-pointer",
                                    children: "x"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    onClick: function() {
                                        return setDifferentLocation(function(prev) {
                                            return !prev;
                                        });
                                    },
                                    className: "cursor-pointer absolute top-5 right-4 text-blue-500 underline",
                                    children: differentLocation ? "Same Return Location" : "Different Return Location"
                                }),
                                filteredLocations.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("ul", {
                                    className: "bg-white position absolute z-10 w-full p-5",
                                    children: filteredLocations.map(function(location, index) {
                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            className: "border-gray-400 border-b p-2 text-lg cursor-pointer",
                                            onClick: function() {
                                                return locationSelectHandler(location);
                                            },
                                            children: location.name
                                        }, index);
                                    })
                                })
                            ]
                        })
                    }),
                    differentLocation && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "w-full mt-2",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            class: "relative",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                    class: "absolute top-0 left-2 font-medium text-amber-900 text-lg",
                                    children: [
                                        "Drop-off Location ",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "text-red-500",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                    type: "text",
                                    class: "border border-black pt-8 pb-2 pl-2 w-full text-xl bg-customGray",
                                    value: selectedDropOffLocation ? selectedDropOffLocation.name : dropOffLocation,
                                    placeholder: "Enter Location",
                                    onChange: function(e) {
                                        return setDropOffLocation(e.target.value);
                                    }
                                }),
                                selectedDropOffLocation && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                    onClick: function() {
                                        setSelectedDropOffLocation("");
                                        setDropOffLocation("");
                                    },
                                    className: "absolute top-[-4px] px-3 right-1 font-bold text-red-500 text-lg cursor-pointer",
                                    children: "x"
                                }),
                                filteredDropOffLocations.length > 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("ul", {
                                    className: "bg-white position absolute z-10 w-full p-5",
                                    children: filteredDropOffLocations.map(function(location, index) {
                                        return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("li", {
                                            className: "border-gray-400 border-b p-2 text-lg cursor-pointer",
                                            onClick: function() {
                                                return dropOffLocationSelectHandler(location);
                                            },
                                            children: location.name
                                        }, index);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "relative mt-2",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "absolute top-0 left-2 text-lg font-medium mb-1",
                                    children: [
                                        "Pick-Up",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "text-red-500",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            type: "date",
                                            className: "border-t border-b border-l border-black pt-8 pb-2 pl-2 pr-2 bg-customGray",
                                            value: selectedPickUpDate,
                                            onChange: function(e) {
                                                return setSelectedPickUpDate(e.target.value);
                                            },
                                            min: currentDate
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            type: "time",
                                            className: "border border-black pt-8 pb-2 pl-2 pr-2 bg-customGray",
                                            value: selectedPickUpTime,
                                            onChange: function(e) {
                                                return setSelectedPickUpTime(e.target.value);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "relative mt-2",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "absolute top-0 left-2 text-lg font-medium mb-1",
                                    children: [
                                        "Drop-off",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                            className: "text-red-500",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "flex",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            type: "date",
                                            className: "border-t border-b border-l border-black pt-8 pb-2 pl-2 pr-2 bg-customGray",
                                            value: selectedDropOffDate,
                                            onChange: function(e) {
                                                return setSelectedDropOffDate(e.target.value);
                                            },
                                            min: currentDate
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                            type: "time",
                                            className: "border border-black pt-8 pb-2 pl-2 pr-2 bg-customGray",
                                            value: selectedDropOffTime,
                                            onChange: function(e) {
                                                return setSelectedDropOffTime(e.target.value);
                                            }
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            onClick: function() {
                                return searchHandler();
                            },
                            className: " bg-indigo-800 text-lg px-10 py-5 text-white font-bold mt-2 shadow-md hover:shadow-lg",
                            children: "Search"
                        })
                    })
                ]
            })
        })
    });
};
var $80e55dc4a3b629e0$export$2e2bcd8739ae039 = $80e55dc4a3b629e0$var$Booking;





var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");


var $15f32795f4aa14be$var$AllCars = function() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), cars = _useState[0], setCars = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(true), 2), loading = _useState1[0], setIsLoading = _useState1[1];
    (0, $6cds3.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                var response, data, err;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch("".concat((0, $38a2ebced121b915$export$2e2bcd8739ae039), "cars/getAllCars"))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            setCars(data);
                            setIsLoading(false);
                            return [
                                2
                            ];
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            err = _state.sent();
                            console.log(err);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    return !loading && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "flex flex-col",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "flex justify-around bg-gray-300 pt-28 flex-wrap px-10",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    className: "font-bold text-2xl py-2",
                                    children: "Not Sure which car is suitable for your trip?"
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                    children: "Car Finder can narrow down your choices."
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                    className: "p-2 text-white bg-black rounded-md my-10",
                                    children: "find your best match"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            className: "w-[400px]",
                            alt: "car",
                            src: "https://firebasestorage.googleapis.com/v0/b/car-rental-3a89c.appspot.com/o/car%2Fcars.png?alt=media&token=ef52deec-8ed2-40eb-95de-4b2f0ea00e8a"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "p-10 border-b-2 font-bold text-4xl",
                        children: "Compare Rental Car Sizes and Classes"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "p-10",
                        children: cars.map(function(car_category, index) {
                            return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "flex border-b-2 border-black py-10 justify-around w-full",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "w-[60%]",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                className: "flex items-center py-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                        className: "font-bold text-2xl",
                                                        children: car_category.name
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                        className: "pl-10 flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                width: "20",
                                                                height: "20",
                                                                className: "pr-1",
                                                                src: "https://img.icons8.com/ios/100/car-seat.png",
                                                                alt: "car-seat"
                                                            }),
                                                            "".concat(car_category.seatingCapacity, " people")
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                                        className: "pl-10 flex items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                                width: "20",
                                                                height: "20",
                                                                className: "pr-1",
                                                                src: "https://img.icons8.com/ios/100/bag-front-view.png",
                                                                alt: "bag-front-view"
                                                            }),
                                                            " ".concat(car_category.lagguageCapacity, " bags")
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                                children: car_category.description
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $0e36e707c39d0f3a$export$a6c7ac8248d6e38a), {
                                                to: "/allCars/".concat(car_category.name),
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                                    className: "py-1 px-3 text-white bg-black rounded-md mt-3",
                                                    children: "View all ".concat(car_category.cars.length, " vehichles")
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                        className: "w-[25%]",
                                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: car_category.image_url,
                                            className: "h-[160px]"
                                        })
                                    })
                                ]
                            });
                        })
                    })
                ]
            })
        ]
    });
};
var $15f32795f4aa14be$export$2e2bcd8739ae039 = $15f32795f4aa14be$var$AllCars;



parcelRequire("6cds3");
var $83dca54c84d6a991$var$CarHost = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "pt-28",
        children: "CarHost"
    });
};
var $83dca54c84d6a991$export$2e2bcd8739ae039 = $83dca54c84d6a991$var$CarHost;




var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");





var $3b701f1b1cef2347$var$CategoryCars = function() {
    var id = (0, $4a3e215446c0ed92$export$99eaa27ddbbb95ef)().id;
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), cars = _useState[0], setCars = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(true), 2), loading = _useState1[0], setIsLoading = _useState1[1];
    (0, $6cds3.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                var response, data, err;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch("".concat((0, $38a2ebced121b915$export$2e2bcd8739ae039), "cars/getCategoryCars/").concat(id))
                            ];
                        case 1:
                            response = _state.sent();
                            if (!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            data = _state.sent();
                            setCars(data.data);
                            setIsLoading(false);
                            return [
                                2
                            ];
                        case 3:
                            return [
                                3,
                                5
                            ];
                        case 4:
                            err = _state.sent();
                            console.log(err);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            loading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1b15c7dc9b0da310$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "flex flex-wrap pt-28 px-14",
                children: cars.cars.map(function(car, car_index) {
                    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "flex flex-col flex-grow box-border px-10 py-10 w-[350px]",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "h-[160px]",
                                    src: car.image_url,
                                    alt: "car img"
                                })
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "flex justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "flex items-start",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                className: "center",
                                                width: "30",
                                                height: "30",
                                                src: "https://img.icons8.com/color/48/rupee--v1.png",
                                                alt: "rupee--v1"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: "font-bold text-lg",
                                                children: car.price_per_day
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: "text-gray-400",
                                                children: " /days"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: "w-[20px] h-[20px]",
                                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2693aac9bc223c1f$exports))),
                                                    alt: "location"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                                className: "text-gray-400",
                                                children: car.location
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "font-bold text-lg py-2",
                                children: [
                                    "  " + car.make + " ",
                                    car.model + " ",
                                    car.year
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "flex items-center justify-center rounded-sm text-center p-2 ".concat(car_index == 0 ? "bg-blue-600 text-white" : "bg-gray-200 hover:bg-blue-600 hover:text-white", " "),
                                children: [
                                    car_index == 0 && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        children: "\uD83D\uDCDE"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                                        children: " Book Now"
                                    })
                                ]
                            })
                        ]
                    }, car.id);
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1f748919507f0a47$export$2e2bcd8739ae039), {})
        ]
    });
};
var $3b701f1b1cef2347$export$2e2bcd8739ae039 = $3b701f1b1cef2347$var$CategoryCars;


var $ad1e3b7171b5b1ff$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1ObTH = parcelRequire("1ObTH");

var $a8i8g = parcelRequire("a8i8g");
"use strict";
function $ad1e3b7171b5b1ff$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $ad1e3b7171b5b1ff$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $ad1e3b7171b5b1ff$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $ad1e3b7171b5b1ff$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $a8i8g.cwd();
                path = cwd;
            }
            $ad1e3b7171b5b1ff$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $ad1e3b7171b5b1ff$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $ad1e3b7171b5b1ff$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $ad1e3b7171b5b1ff$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $ad1e3b7171b5b1ff$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $ad1e3b7171b5b1ff$var$assertPath(from);
        $ad1e3b7171b5b1ff$var$assertPath(to);
        if (from === to) return "";
        from = $ad1e3b7171b5b1ff$var$posix.resolve(from);
        to = $ad1e3b7171b5b1ff$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + (typeof pathObject === "undefined" ? "undefined" : (0, $1ObTH._)(pathObject)));
        return $ad1e3b7171b5b1ff$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $ad1e3b7171b5b1ff$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$ad1e3b7171b5b1ff$var$posix.posix = $ad1e3b7171b5b1ff$var$posix;
$ad1e3b7171b5b1ff$exports = $ad1e3b7171b5b1ff$var$posix;




var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");
var $e23bb8612a60d53b$exports = {};

var $1ObTH = parcelRequire("1ObTH");













(function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "exports",
        "./GoogleApiComponent",
        "./components/Marker",
        "./components/InfoWindow",
        "./components/HeatMap",
        "./components/Polygon",
        "./components/Polyline",
        "./components/Circle",
        "./components/Rectangle",
        "react",
        "prop-types",
        "react-dom",
        "./lib/String",
        "./lib/cancelablePromise"
    ], factory);
    else {
        var mod;
        factory($e23bb8612a60d53b$exports, (parcelRequire("kK49L")), (parcelRequire("kA2Ux")), (parcelRequire("T1vzD")), (parcelRequire("cdzNs")), (parcelRequire("32tNv")), (parcelRequire("lFdtz")), (parcelRequire("fdRPg")), (parcelRequire("4JvLw")), (parcelRequire("6cds3")), (parcelRequire("aMJGV")), (parcelRequire("9nHRL")), (parcelRequire("cdv1q")), (parcelRequire("36D9o")));
    }
})(undefined, function(exports1, _GoogleApiComponent, _Marker, _InfoWindow, _HeatMap, _Polygon, _Polyline, _Circle, _Rectangle, _react, _propTypes, _reactDom, _String, _cancelablePromise) {
    "use strict";
    var _interopRequireDefault = function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    };
    var _classCallCheck = function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var _possibleConstructorReturn = function _possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    };
    var _inherits = function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $1ObTH._)(superClass)));
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    };
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
    exports1.Map = exports1.Rectangle = exports1.Circle = exports1.Polyline = exports1.Polygon = exports1.HeatMap = exports1.InfoWindow = exports1.Marker = exports1.GoogleApiWrapper = undefined;
    Object.defineProperty(exports1, "GoogleApiWrapper", {
        enumerable: true,
        get: function get() {
            return _GoogleApiComponent.wrapper;
        }
    });
    Object.defineProperty(exports1, "Marker", {
        enumerable: true,
        get: function get() {
            return _Marker.Marker;
        }
    });
    Object.defineProperty(exports1, "InfoWindow", {
        enumerable: true,
        get: function get() {
            return _InfoWindow.InfoWindow;
        }
    });
    Object.defineProperty(exports1, "HeatMap", {
        enumerable: true,
        get: function get() {
            return _HeatMap.HeatMap;
        }
    });
    Object.defineProperty(exports1, "Polygon", {
        enumerable: true,
        get: function get() {
            return _Polygon.Polygon;
        }
    });
    Object.defineProperty(exports1, "Polyline", {
        enumerable: true,
        get: function get() {
            return _Polyline.Polyline;
        }
    });
    Object.defineProperty(exports1, "Circle", {
        enumerable: true,
        get: function get() {
            return _Circle.Circle;
        }
    });
    Object.defineProperty(exports1, "Rectangle", {
        enumerable: true,
        get: function get() {
            return _Rectangle.Rectangle;
        }
    });
    var _react2 = _interopRequireDefault(_react);
    var _propTypes2 = _interopRequireDefault(_propTypes);
    var _reactDom2 = _interopRequireDefault(_reactDom);
    var _createClass = function() {
        var defineProperties = function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        };
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var mapStyles = {
        container: {
            position: "absolute",
            width: "100%",
            height: "100%"
        },
        map: {
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            top: 0
        }
    };
    var evtNames = [
        "ready",
        "click",
        "dragend",
        "recenter",
        "bounds_changed",
        "center_changed",
        "dblclick",
        "dragstart",
        "heading_change",
        "idle",
        "maptypeid_changed",
        "mousemove",
        "mouseout",
        "mouseover",
        "projection_changed",
        "resize",
        "rightclick",
        "tilesloaded",
        "tilt_changed",
        "zoom_changed"
    ];
    var Map = exports1.Map = function(_React$Component) {
        _inherits(Map, _React$Component);
        function Map(props) {
            _classCallCheck(this, Map);
            var _this = _possibleConstructorReturn(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));
            if (!props.hasOwnProperty("google")) throw new Error("You must include a `google` prop");
            _this.listeners = {};
            _this.state = {
                currentLocation: {
                    lat: _this.props.initialCenter.lat,
                    lng: _this.props.initialCenter.lng
                }
            };
            _this.mapRef = _react2.default.createRef();
            return _this;
        }
        _createClass(Map, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    if (this.props.centerAroundCurrentLocation) {
                        if (navigator && navigator.geolocation) {
                            this.geoPromise = (0, _cancelablePromise.makeCancelable)(new Promise(function(resolve, reject) {
                                navigator.geolocation.getCurrentPosition(resolve, reject);
                            }));
                            this.geoPromise.promise.then(function(pos) {
                                var coords = pos.coords;
                                _this2.setState({
                                    currentLocation: {
                                        lat: coords.latitude,
                                        lng: coords.longitude
                                    }
                                });
                            }).catch(function(e) {
                                return e;
                            });
                        }
                    }
                    this.loadMap();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps, prevState) {
                    if (prevProps.google !== this.props.google) this.loadMap();
                    if (this.props.visible !== prevProps.visible) this.restyleMap();
                    if (this.props.zoom !== prevProps.zoom) this.map.setZoom(this.props.zoom);
                    if (this.props.center !== prevProps.center) this.setState({
                        currentLocation: this.props.center
                    });
                    if (prevState.currentLocation !== this.state.currentLocation) this.recenterMap();
                    if (this.props.bounds && this.props.bounds !== prevProps.bounds) this.map.fitBounds(this.props.bounds);
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var _this3 = this;
                    var google = this.props.google;
                    if (this.geoPromise) this.geoPromise.cancel();
                    Object.keys(this.listeners).forEach(function(e) {
                        google.maps.event.removeListener(_this3.listeners[e]);
                    });
                }
            },
            {
                key: "loadMap",
                value: function loadMap() {
                    var _this4 = this;
                    if (this.props && this.props.google) {
                        var google = this.props.google;
                        var maps = google.maps;
                        var mapRef = this.mapRef.current;
                        var node = _reactDom2.default.findDOMNode(mapRef);
                        var curr = this.state.currentLocation;
                        var center = new maps.LatLng(curr.lat, curr.lng);
                        var mapTypeIds = this.props.google.maps.MapTypeId || {};
                        var mapTypeFromProps = String(this.props.mapType).toUpperCase();
                        var mapConfig = Object.assign({}, {
                            mapTypeId: mapTypeIds[mapTypeFromProps],
                            center: center,
                            zoom: this.props.zoom,
                            maxZoom: this.props.maxZoom,
                            minZoom: this.props.minZoom,
                            clickableIcons: !!this.props.clickableIcons,
                            disableDefaultUI: this.props.disableDefaultUI,
                            zoomControl: this.props.zoomControl,
                            zoomControlOptions: this.props.zoomControlOptions,
                            mapTypeControl: this.props.mapTypeControl,
                            mapTypeControlOptions: this.props.mapTypeControlOptions,
                            scaleControl: this.props.scaleControl,
                            streetViewControl: this.props.streetViewControl,
                            streetViewControlOptions: this.props.streetViewControlOptions,
                            panControl: this.props.panControl,
                            rotateControl: this.props.rotateControl,
                            fullscreenControl: this.props.fullscreenControl,
                            scrollwheel: this.props.scrollwheel,
                            draggable: this.props.draggable,
                            draggableCursor: this.props.draggableCursor,
                            keyboardShortcuts: this.props.keyboardShortcuts,
                            disableDoubleClickZoom: this.props.disableDoubleClickZoom,
                            noClear: this.props.noClear,
                            styles: this.props.styles,
                            gestureHandling: this.props.gestureHandling
                        });
                        Object.keys(mapConfig).forEach(function(key) {
                            // Allow to configure mapConfig with 'false'
                            if (mapConfig[key] === null) delete mapConfig[key];
                        });
                        this.map = new maps.Map(node, mapConfig);
                        evtNames.forEach(function(e) {
                            _this4.listeners[e] = _this4.map.addListener(e, _this4.handleEvent(e));
                        });
                        maps.event.trigger(this.map, "ready");
                        this.forceUpdate();
                    }
                }
            },
            {
                key: "handleEvent",
                value: function handleEvent(evtName) {
                    var _this5 = this;
                    var timeout = void 0;
                    var handlerName = "on" + (0, _String.camelize)(evtName);
                    return function(e) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        timeout = setTimeout(function() {
                            if (_this5.props[handlerName]) _this5.props[handlerName](_this5.props, _this5.map, e);
                        }, 0);
                    };
                }
            },
            {
                key: "recenterMap",
                value: function recenterMap() {
                    var map = this.map;
                    var google = this.props.google;
                    if (!google) return;
                    var maps = google.maps;
                    if (map) {
                        var center = this.state.currentLocation;
                        if (!(center instanceof google.maps.LatLng)) center = new google.maps.LatLng(center.lat, center.lng);
                        // map.panTo(center)
                        map.setCenter(center);
                        maps.event.trigger(map, "recenter");
                    }
                }
            },
            {
                key: "restyleMap",
                value: function restyleMap() {
                    if (this.map) {
                        var google = this.props.google;
                        google.maps.event.trigger(this.map, "resize");
                    }
                }
            },
            {
                key: "renderChildren",
                value: function renderChildren() {
                    var _this6 = this;
                    var children = this.props.children;
                    if (!children) return;
                    return _react2.default.Children.map(children, function(c) {
                        if (!c) return;
                        return _react2.default.cloneElement(c, {
                            map: _this6.map,
                            google: _this6.props.google,
                            mapCenter: _this6.state.currentLocation
                        });
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var style = Object.assign({}, mapStyles.map, this.props.style, {
                        display: this.props.visible ? "inherit" : "none"
                    });
                    var containerStyles = Object.assign({}, mapStyles.container, this.props.containerStyle);
                    return _react2.default.createElement("div", {
                        style: containerStyles,
                        className: this.props.className
                    }, _react2.default.createElement("div", {
                        style: style,
                        ref: this.mapRef
                    }, "Loading map..."), this.renderChildren());
                }
            }
        ]);
        return Map;
    }(_react2.default.Component);
    Map.propTypes = {
        google: _propTypes2.default.object,
        zoom: _propTypes2.default.number,
        centerAroundCurrentLocation: _propTypes2.default.bool,
        center: _propTypes2.default.object,
        initialCenter: _propTypes2.default.object,
        className: _propTypes2.default.string,
        style: _propTypes2.default.object,
        containerStyle: _propTypes2.default.object,
        visible: _propTypes2.default.bool,
        mapType: _propTypes2.default.string,
        maxZoom: _propTypes2.default.number,
        minZoom: _propTypes2.default.number,
        clickableIcons: _propTypes2.default.bool,
        disableDefaultUI: _propTypes2.default.bool,
        zoomControl: _propTypes2.default.bool,
        zoomControlOptions: _propTypes2.default.object,
        mapTypeControl: _propTypes2.default.bool,
        mapTypeControlOptions: _propTypes2.default.bool,
        scaleControl: _propTypes2.default.bool,
        streetViewControl: _propTypes2.default.bool,
        streetViewControlOptions: _propTypes2.default.object,
        panControl: _propTypes2.default.bool,
        rotateControl: _propTypes2.default.bool,
        fullscreenControl: _propTypes2.default.bool,
        scrollwheel: _propTypes2.default.bool,
        draggable: _propTypes2.default.bool,
        draggableCursor: _propTypes2.default.string,
        keyboardShortcuts: _propTypes2.default.bool,
        disableDoubleClickZoom: _propTypes2.default.bool,
        noClear: _propTypes2.default.bool,
        styles: _propTypes2.default.array,
        gestureHandling: _propTypes2.default.string,
        bounds: _propTypes2.default.object
    };
    evtNames.forEach(function(e) {
        return Map.propTypes[(0, _String.camelize)(e)] = _propTypes2.default.func;
    });
    Map.defaultProps = {
        zoom: 14,
        initialCenter: {
            lat: 37.774929,
            lng: -122.419416
        },
        center: {},
        centerAroundCurrentLocation: false,
        style: {},
        containerStyle: {},
        visible: true
    };
    exports1.default = Map;
});


var $51db79463a77e40f$export$d4214b4977c811ed = "AIzaSyAZtGLDQk2wp46GopSGD_qdE2V4DPND3Js";



var $fc727d7f86b4ce74$var$MapContainer = function(props) {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)([]), 2), carRentalLocations = _useState[0], setCarRentalLocations = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(true), 2), loading = _useState1[0], setLoading = _useState1[1];
    var _useState2 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), selectedLocation = _useState2[0], setSelectedLocation = _useState2[1];
    (0, $6cds3.useEffect)(function() {
        var fetchData = function() {
            var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
                var response, err;
                return (0, $7UAGh.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setLoading(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, $829962ad92a0f7b9$export$c07c686062478869)()
                            ];
                        case 2:
                            response = _state.sent();
                            setCarRentalLocations(response);
                            console.log("locations", carRentalLocations);
                            setLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.log(err);
                            setLoading(false);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    var center = (0, $6cds3.useMemo)(function() {
        return {
            lat: 17.385044,
            lng: 78.486671
        };
    }, []);
    return !loading && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e23bb8612a60d53b$exports.Map), {
            google: props.google,
            zoom: 6,
            initialCenter: center,
            children: carRentalLocations.map(function(location, index) {
                return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e23bb8612a60d53b$exports.Marker), {
                    onClick: function() {
                        return setSelectedLocation(location);
                    },
                    title: location.name,
                    position: {
                        lat: location.lat,
                        lng: location.lng
                    }
                }, index);
            })
        })
    });
};
var $fc727d7f86b4ce74$export$2e2bcd8739ae039 = (0, $e23bb8612a60d53b$exports.GoogleApiWrapper)({
    apiKey: (0, $51db79463a77e40f$export$d4214b4977c811ed)
})($fc727d7f86b4ce74$var$MapContainer);




var $8GFUW = parcelRequire("8GFUW");

var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");


function $abe7ae22f372318f$var$RegistrationForm() {
    var _useState = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), email = _useState[0], setEmail = _useState[1];
    var _useState1 = (0, $8GFUW._)((0, $6cds3.useState)(""), 2), password = _useState1[0], setPassword = _useState1[1];
    var handleRegistration = function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(e) {
            var userCredential, user, error;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $0021d6672f58c7eb$export$a9c996f45e5784d0)((0, $a65c674dc9c6bbe7$export$73693bad9f5880b0), email, password)
                        ];
                    case 2:
                        userCredential = _state.sent();
                        user = userCredential.user;
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Registration error:", error.message);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRegistration(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
        onSubmit: handleRegistration,
        className: "pt-28",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                children: "Email:"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                type: "email",
                value: email,
                onChange: function(e) {
                    return setEmail(e.target.value);
                },
                required: true
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                children: "Password:"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                type: "password",
                value: password,
                onChange: function(e) {
                    return setPassword(e.target.value);
                },
                required: true
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                type: "submit",
                children: "Register"
            })
        ]
    });
}
var $abe7ae22f372318f$export$2e2bcd8739ae039 = $abe7ae22f372318f$var$RegistrationForm;




var $7UAGh = parcelRequire("7UAGh");


var $6cds3 = parcelRequire("6cds3");

parcelRequire("6cds3");
var $2d0b4ccb540d25a7$var$CertificateTemplate = function(param) {
    var recipientName = param.recipientName, courseName = param.courseName, date = param.date;
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "p-10 w-full",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
            className: "p-6 border-2 border-black",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        src: "/path-to-your-logo.png" // Replace with the path to your logo
                        ,
                        alt: "Logo",
                        className: ""
                    })
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                    className: "text-2xl font-bold mb-5",
                    children: "Certificate of Course Completion"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-5",
                    children: "This is to certify that"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-5 font-bold mb-5",
                    children: recipientName
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-5px",
                    children: "has successfully completed the course"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-10 font-bold mb-5",
                    children: courseName
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-2",
                    children: "on"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-10 font-bold",
                    children: date
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                    className: "text-2xl font-bold mb-5",
                    children: "Certificate of Course Completion"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-5",
                    children: "This is to certify that"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-5 font-bold mb-5",
                    children: recipientName
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-5px",
                    children: "has successfully completed the course"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-10 font-bold mb-5",
                    children: courseName
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-2",
                    children: "on"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-10 font-bold",
                    children: date
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                    className: "text-2xl font-bold mb-5",
                    children: "Certificate of Course Completion"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-5",
                    children: "This is to certify that"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-5 font-bold mb-5",
                    children: recipientName
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-5px",
                    children: "has successfully completed the course"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-10 font-bold mb-5",
                    children: courseName
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "mb-2",
                    children: "on"
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                    className: "text-10 font-bold",
                    children: date
                })
            ]
        })
    });
};
var $2d0b4ccb540d25a7$export$2e2bcd8739ae039 = $2d0b4ccb540d25a7$var$CertificateTemplate;



var $6lLHD = parcelRequire("6lLHD");
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */ 
var $hrVOB = parcelRequire("hrVOB");
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Much of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// Many optimizations have been made, so the bundle size is ultimately smaller but performance is similar.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $b495f2b996e3784e$var$ch2 = {};
var $b495f2b996e3784e$var$wk = function wk(c, id, msg, transfer, cb) {
    var u = $b495f2b996e3784e$var$ch2[id] || ($b495f2b996e3784e$var$ch2[id] = URL.createObjectURL(new Blob([
        c
    ], {
        type: "text/javascript"
    })));
    var w = new Worker(u);
    w.onerror = function(e) {
        return cb(e.error, null);
    };
    w.onmessage = function(e) {
        return cb(null, e.data);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $b495f2b996e3784e$var$u8 = Uint8Array, $b495f2b996e3784e$var$u16 = Uint16Array, $b495f2b996e3784e$var$u32 = Uint32Array;
// fixed length extra bits
var $b495f2b996e3784e$var$fleb = new $b495f2b996e3784e$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
// see fleb note
var $b495f2b996e3784e$var$fdeb = new $b495f2b996e3784e$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $b495f2b996e3784e$var$clim = new $b495f2b996e3784e$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $b495f2b996e3784e$var$freb = function freb(eb, start) {
    var b = new $b495f2b996e3784e$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $b495f2b996e3784e$var$u32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return [
        b,
        r
    ];
};
var $b495f2b996e3784e$var$_a = $b495f2b996e3784e$var$freb($b495f2b996e3784e$var$fleb, 2), $b495f2b996e3784e$var$fl = $b495f2b996e3784e$var$_a[0], $b495f2b996e3784e$var$revfl = $b495f2b996e3784e$var$_a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$b495f2b996e3784e$var$fl[28] = 258, $b495f2b996e3784e$var$revfl[258] = 28;
var $b495f2b996e3784e$var$_b = $b495f2b996e3784e$var$freb($b495f2b996e3784e$var$fdeb, 0), $b495f2b996e3784e$var$fd = $b495f2b996e3784e$var$_b[0], $b495f2b996e3784e$var$revfd = $b495f2b996e3784e$var$_b[1];
// map of value to reverse (assuming 16 bits)
var $b495f2b996e3784e$var$rev = new $b495f2b996e3784e$var$u16(32768);
for(var $b495f2b996e3784e$var$i = 0; $b495f2b996e3784e$var$i < 32768; ++$b495f2b996e3784e$var$i){
    // reverse table algorithm from SO
    var $b495f2b996e3784e$var$x = ($b495f2b996e3784e$var$i & 0xAAAA) >>> 1 | ($b495f2b996e3784e$var$i & 0x5555) << 1;
    $b495f2b996e3784e$var$x = ($b495f2b996e3784e$var$x & 0xCCCC) >>> 2 | ($b495f2b996e3784e$var$x & 0x3333) << 2;
    $b495f2b996e3784e$var$x = ($b495f2b996e3784e$var$x & 0xF0F0) >>> 4 | ($b495f2b996e3784e$var$x & 0x0F0F) << 4;
    $b495f2b996e3784e$var$rev[$b495f2b996e3784e$var$i] = (($b495f2b996e3784e$var$x & 0xFF00) >>> 8 | ($b495f2b996e3784e$var$x & 0x00FF) << 8) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $b495f2b996e3784e$var$hMap = function hMap(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $b495f2b996e3784e$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $b495f2b996e3784e$var$u16(mb);
    for(i = 0; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $b495f2b996e3784e$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$b495f2b996e3784e$var$rev[v] >>> rvb] = sv;
        }
    } else {
        co = new $b495f2b996e3784e$var$u16(s);
        for(i = 0; i < s; ++i)co[i] = $b495f2b996e3784e$var$rev[le[cd[i] - 1]++] >>> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $b495f2b996e3784e$var$flt = new $b495f2b996e3784e$var$u8(288);
for(var $b495f2b996e3784e$var$i = 0; $b495f2b996e3784e$var$i < 144; ++$b495f2b996e3784e$var$i)$b495f2b996e3784e$var$flt[$b495f2b996e3784e$var$i] = 8;
for(var $b495f2b996e3784e$var$i = 144; $b495f2b996e3784e$var$i < 256; ++$b495f2b996e3784e$var$i)$b495f2b996e3784e$var$flt[$b495f2b996e3784e$var$i] = 9;
for(var $b495f2b996e3784e$var$i = 256; $b495f2b996e3784e$var$i < 280; ++$b495f2b996e3784e$var$i)$b495f2b996e3784e$var$flt[$b495f2b996e3784e$var$i] = 7;
for(var $b495f2b996e3784e$var$i = 280; $b495f2b996e3784e$var$i < 288; ++$b495f2b996e3784e$var$i)$b495f2b996e3784e$var$flt[$b495f2b996e3784e$var$i] = 8;
// fixed distance tree
var $b495f2b996e3784e$var$fdt = new $b495f2b996e3784e$var$u8(32);
for(var $b495f2b996e3784e$var$i = 0; $b495f2b996e3784e$var$i < 32; ++$b495f2b996e3784e$var$i)$b495f2b996e3784e$var$fdt[$b495f2b996e3784e$var$i] = 5;
// fixed length map
var $b495f2b996e3784e$var$flm = /*#__PURE__*/ $b495f2b996e3784e$var$hMap($b495f2b996e3784e$var$flt, 9, 0), $b495f2b996e3784e$var$flrm = /*#__PURE__*/ $b495f2b996e3784e$var$hMap($b495f2b996e3784e$var$flt, 9, 1);
// fixed distance map
var $b495f2b996e3784e$var$fdm = /*#__PURE__*/ $b495f2b996e3784e$var$hMap($b495f2b996e3784e$var$fdt, 5, 0), $b495f2b996e3784e$var$fdrm = /*#__PURE__*/ $b495f2b996e3784e$var$hMap($b495f2b996e3784e$var$fdt, 5, 1);
// find max of array
var $b495f2b996e3784e$var$max = function max(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $b495f2b996e3784e$var$bits = function bits(d, p, m) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8) >>> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $b495f2b996e3784e$var$bits16 = function bits16(d, p) {
    var o = p / 8 >> 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >>> (p & 7);
};
// get end of byte
var $b495f2b996e3784e$var$shft = function shft(p) {
    return (p / 8 >> 0) + (p & 7 && 1);
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $b495f2b996e3784e$var$slc = function slc(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof $b495f2b996e3784e$var$u16 ? $b495f2b996e3784e$var$u16 : v instanceof $b495f2b996e3784e$var$u32 ? $b495f2b996e3784e$var$u32 : $b495f2b996e3784e$var$u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var $b495f2b996e3784e$var$inflt = function inflt(dat, buf, st) {
    // source length
    var sl = dat.length;
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st) st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf) buf = new $b495f2b996e3784e$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function cbuf(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $b495f2b996e3784e$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = $b495f2b996e3784e$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $b495f2b996e3784e$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $b495f2b996e3784e$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) throw "unexpected EOF";
                    break;
                }
                // ensure size
                if (noBuf) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            } else if (type == 1) lm = $b495f2b996e3784e$var$flrm, dm = $b495f2b996e3784e$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $b495f2b996e3784e$var$bits(dat, pos, 31) + 257, hcLen = $b495f2b996e3784e$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $b495f2b996e3784e$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $b495f2b996e3784e$var$u8(tl);
                // code length tree
                var clt = new $b495f2b996e3784e$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$b495f2b996e3784e$var$clim[i]] = $b495f2b996e3784e$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $b495f2b996e3784e$var$max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts) break;
                // code lengths map
                var clm = $b495f2b996e3784e$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$b495f2b996e3784e$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $b495f2b996e3784e$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $b495f2b996e3784e$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $b495f2b996e3784e$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $b495f2b996e3784e$var$max(lt);
                // max dist bits
                dbt = $b495f2b996e3784e$var$max(dt);
                lm = $b495f2b996e3784e$var$hMap(lt, lbt, 1);
                dm = $b495f2b996e3784e$var$hMap(dt, dbt, 1);
            } else throw "invalid block type";
            if (pos > tbts) throw "unexpected EOF";
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while(noSt || pos + mxa < tbts){
            // bits read, code
            var c = lm[$b495f2b996e3784e$var$bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts) throw "unexpected EOF";
            if (!c) throw "invalid length/literal";
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $b495f2b996e3784e$var$fleb[i];
                    add = $b495f2b996e3784e$var$bits(dat, pos, (1 << b) - 1) + $b495f2b996e3784e$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$b495f2b996e3784e$var$bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d) throw "invalid distance";
                pos += d & 15;
                var dt = $b495f2b996e3784e$var$fd[dsym];
                if (dsym > 3) {
                    var b = $b495f2b996e3784e$var$fdeb[dsym];
                    dt += $b495f2b996e3784e$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) throw "unexpected EOF";
                if (noBuf) cbuf(bt + 131072);
                var end = bt + add;
                for(; bt < end; bt += 4){
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    return bt == buf.length ? buf : $b495f2b996e3784e$var$slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $b495f2b996e3784e$var$wbits = function wbits(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $b495f2b996e3784e$var$wbits16 = function wbits16(d, p, v) {
    v <<= p & 7;
    var o = p / 8 >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var $b495f2b996e3784e$var$hTree = function hTree(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return [
        new $b495f2b996e3784e$var$u8(0),
        0
    ];
    if (s == 1) {
        var v = new $b495f2b996e3784e$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [
            v,
            1
        ];
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $b495f2b996e3784e$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $b495f2b996e3784e$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [
        new $b495f2b996e3784e$var$u8(tr),
        mbt
    ];
};
// get the max length and assign length codes
var $b495f2b996e3784e$var$ln = function ln1(n, l, d) {
    return n.s == -1 ? Math.max($b495f2b996e3784e$var$ln(n.l, l, d + 1), $b495f2b996e3784e$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $b495f2b996e3784e$var$lc = function lc(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $b495f2b996e3784e$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function w(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return [
        cl.subarray(0, cli),
        s
    ];
};
// calculate the length of output from tree, code lengths
var $b495f2b996e3784e$var$clen = function clen(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $b495f2b996e3784e$var$wfblk = function wfblk(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $b495f2b996e3784e$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $b495f2b996e3784e$var$wblk = function wblk(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $b495f2b996e3784e$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $b495f2b996e3784e$var$hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = $b495f2b996e3784e$var$hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = $b495f2b996e3784e$var$lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = $b495f2b996e3784e$var$lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new $b495f2b996e3784e$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)lcfreq[lclt[i] & 31]++;
    for(var i = 0; i < lcdt.length; ++i)lcfreq[lcdt[i] & 31]++;
    var _e = $b495f2b996e3784e$var$hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$b495f2b996e3784e$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $b495f2b996e3784e$var$clen(lf, $b495f2b996e3784e$var$flt) + $b495f2b996e3784e$var$clen(df, $b495f2b996e3784e$var$fdt) + eb;
    var dtlen = $b495f2b996e3784e$var$clen(lf, dlt) + $b495f2b996e3784e$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $b495f2b996e3784e$var$clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen) return $b495f2b996e3784e$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $b495f2b996e3784e$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $b495f2b996e3784e$var$hMap(dlt, mlb, 0), ll = dlt, dm = $b495f2b996e3784e$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $b495f2b996e3784e$var$hMap(lct, mlcb, 0);
        $b495f2b996e3784e$var$wbits(out, p, nlc - 257);
        $b495f2b996e3784e$var$wbits(out, p + 5, ndc - 1);
        $b495f2b996e3784e$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$b495f2b996e3784e$var$wbits(out, p + 3 * i, lct[$b495f2b996e3784e$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $b495f2b996e3784e$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $b495f2b996e3784e$var$wbits(out, p, clct[i] >>> 5 & 127), p += clct[i] >>> 12;
            }
        }
    } else lm = $b495f2b996e3784e$var$flm, ll = $b495f2b996e3784e$var$flt, dm = $b495f2b996e3784e$var$fdm, dl = $b495f2b996e3784e$var$fdt;
    for(var i = 0; i < li; ++i)if (syms[i] > 255) {
        var len = syms[i] >>> 18 & 31;
        $b495f2b996e3784e$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
        if (len > 7) $b495f2b996e3784e$var$wbits(out, p, syms[i] >>> 23 & 31), p += $b495f2b996e3784e$var$fleb[len];
        var dst = syms[i] & 31;
        $b495f2b996e3784e$var$wbits16(out, p, dm[dst]), p += dl[dst];
        if (dst > 3) $b495f2b996e3784e$var$wbits16(out, p, syms[i] >>> 5 & 8191), p += $b495f2b996e3784e$var$fdeb[dst];
    } else $b495f2b996e3784e$var$wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
    $b495f2b996e3784e$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $b495f2b996e3784e$var$deo = /*#__PURE__*/ new $b495f2b996e3784e$var$u32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $b495f2b996e3784e$var$et = /*#__PURE__*/ new $b495f2b996e3784e$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $b495f2b996e3784e$var$dflt = function dflt(dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new $b495f2b996e3784e$var$u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) for(var i = 0; i <= s; i += 65535){
        // end
        var e = i + 65535;
        if (e < s) // write full block
        pos = $b495f2b996e3784e$var$wfblk(w, pos, dat.subarray(i, e));
        else {
            // write final block
            w[i] = lst;
            pos = $b495f2b996e3784e$var$wfblk(w, pos, dat.subarray(i, s));
        }
    }
    else {
        var opt = $b495f2b996e3784e$var$deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new $b495f2b996e3784e$var$u16(32768), head = new $b495f2b996e3784e$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function hsh(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $b495f2b996e3784e$var$u32(25000);
        // length/literal freq   distance freq
        var lf = new $b495f2b996e3784e$var$u16(288), df = new $b495f2b996e3784e$var$u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for(; i < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768
            var imod = i & 32767;
            // previous index with this value
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = $b495f2b996e3784e$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j + 32768 & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti + 32768 & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod + 32768 & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $b495f2b996e3784e$var$revfl[l] << 18 | $b495f2b996e3784e$var$revfd[d];
                    var lin = $b495f2b996e3784e$var$revfl[l] & 31, din = $b495f2b996e3784e$var$revfd[d] & 31;
                    eb += $b495f2b996e3784e$var$fleb[lin] + $b495f2b996e3784e$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = $b495f2b996e3784e$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst) pos = $b495f2b996e3784e$var$wfblk(w, pos, $b495f2b996e3784e$var$et);
    }
    return $b495f2b996e3784e$var$slc(o, 0, pre + $b495f2b996e3784e$var$shft(pos) + post);
};
// CRC32 table
var $b495f2b996e3784e$var$crct = /*#__PURE__*/ function() {
    var t = new $b495f2b996e3784e$var$u32(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && 0xEDB88320) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $b495f2b996e3784e$var$crc = function crc() {
    var c = 0xFFFFFFFF;
    return {
        p: function p(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $b495f2b996e3784e$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function d() {
            return c ^ 0xFFFFFFFF;
        }
    };
};
// Alder32
var $b495f2b996e3784e$var$adler = function adler() {
    var a = 1, b = 0;
    return {
        p: function p(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for(var i = 0; i != l;){
                var e = Math.min(i + 5552, l);
                for(; i < e; ++i)n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function d() {
            return (a >>> 8 << 16 | (b & 255) << 8 | b >>> 8) + ((a & 255) << 23) * 2;
        }
    };
};
// deflate with opts
var $b495f2b996e3784e$var$dopt = function dopt(dat, opt, pre, post, st) {
    return $b495f2b996e3784e$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 12 + opt.mem, pre, post, !st);
};
// Walmart object spread
var $b495f2b996e3784e$var$mrg = function mrg(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $b495f2b996e3784e$var$wcln = function wcln(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf("[") + 1, st.lastIndexOf("]")).replace(/ /g, "").split(",");
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == "function") {
            fnStr += ";" + k + "=";
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf("[native code]") != -1) {
                    var spInd = st_1.indexOf(" ", 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf("(", spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ";" + k + ".prototype." + t + "=" + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return [
        fnStr,
        td
    ];
};
var $b495f2b996e3784e$var$ch = [];
// clone bufs
var $b495f2b996e3784e$var$cbfs = function cbfs(v) {
    var tl = [];
    for(var k in v)if (v[k] instanceof $b495f2b996e3784e$var$u8 || v[k] instanceof $b495f2b996e3784e$var$u16 || v[k] instanceof $b495f2b996e3784e$var$u32) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $b495f2b996e3784e$var$wrkr = function wrkr(fns, init, id, cb) {
    var _a;
    if (!$b495f2b996e3784e$var$ch[id]) {
        var fnStr = "", td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)_a = $b495f2b996e3784e$var$wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        $b495f2b996e3784e$var$ch[id] = $b495f2b996e3784e$var$wcln(fns[m], fnStr, td_1);
    }
    var td = $b495f2b996e3784e$var$mrg({}, $b495f2b996e3784e$var$ch[id][1]);
    return $b495f2b996e3784e$var$wk($b495f2b996e3784e$var$ch[id][0] + ";onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=" + init.toString() + "}", id, td, $b495f2b996e3784e$var$cbfs(td), cb);
};
// base async inflate fn
var $b495f2b996e3784e$var$bInflt = function bInflt() {
    return [
        $b495f2b996e3784e$var$u8,
        $b495f2b996e3784e$var$u16,
        $b495f2b996e3784e$var$u32,
        $b495f2b996e3784e$var$fleb,
        $b495f2b996e3784e$var$fdeb,
        $b495f2b996e3784e$var$clim,
        $b495f2b996e3784e$var$fl,
        $b495f2b996e3784e$var$fd,
        $b495f2b996e3784e$var$flrm,
        $b495f2b996e3784e$var$fdrm,
        $b495f2b996e3784e$var$rev,
        $b495f2b996e3784e$var$hMap,
        $b495f2b996e3784e$var$max,
        $b495f2b996e3784e$var$bits,
        $b495f2b996e3784e$var$bits16,
        $b495f2b996e3784e$var$shft,
        $b495f2b996e3784e$var$slc,
        $b495f2b996e3784e$var$inflt,
        $b495f2b996e3784e$export$90366d8b308ba94a,
        $b495f2b996e3784e$var$pbf,
        $b495f2b996e3784e$var$gu8
    ];
};
var $b495f2b996e3784e$var$bDflt = function bDflt() {
    return [
        $b495f2b996e3784e$var$u8,
        $b495f2b996e3784e$var$u16,
        $b495f2b996e3784e$var$u32,
        $b495f2b996e3784e$var$fleb,
        $b495f2b996e3784e$var$fdeb,
        $b495f2b996e3784e$var$clim,
        $b495f2b996e3784e$var$revfl,
        $b495f2b996e3784e$var$revfd,
        $b495f2b996e3784e$var$flm,
        $b495f2b996e3784e$var$flt,
        $b495f2b996e3784e$var$fdm,
        $b495f2b996e3784e$var$fdt,
        $b495f2b996e3784e$var$rev,
        $b495f2b996e3784e$var$deo,
        $b495f2b996e3784e$var$et,
        $b495f2b996e3784e$var$hMap,
        $b495f2b996e3784e$var$wbits,
        $b495f2b996e3784e$var$wbits16,
        $b495f2b996e3784e$var$hTree,
        $b495f2b996e3784e$var$ln,
        $b495f2b996e3784e$var$lc,
        $b495f2b996e3784e$var$clen,
        $b495f2b996e3784e$var$wfblk,
        $b495f2b996e3784e$var$wblk,
        $b495f2b996e3784e$var$shft,
        $b495f2b996e3784e$var$slc,
        $b495f2b996e3784e$var$dflt,
        $b495f2b996e3784e$var$dopt,
        $b495f2b996e3784e$export$21533ff51b8a0b4a,
        $b495f2b996e3784e$var$pbf
    ];
};
// gzip extra
var $b495f2b996e3784e$var$gze = function gze() {
    return [
        $b495f2b996e3784e$var$gzh,
        $b495f2b996e3784e$var$gzhl,
        $b495f2b996e3784e$var$wbytes,
        $b495f2b996e3784e$var$crc,
        $b495f2b996e3784e$var$crct
    ];
};
// gunzip extra
var $b495f2b996e3784e$var$guze = function guze() {
    return [
        $b495f2b996e3784e$var$gzs,
        $b495f2b996e3784e$var$gzl
    ];
};
// zlib extra
var $b495f2b996e3784e$var$zle = function zle() {
    return [
        $b495f2b996e3784e$var$zlh,
        $b495f2b996e3784e$var$wbytes,
        $b495f2b996e3784e$var$adler
    ];
};
// unzlib extra
var $b495f2b996e3784e$var$zule = function zule() {
    return [
        $b495f2b996e3784e$var$zlv
    ];
};
// post buf
var $b495f2b996e3784e$var$pbf = function pbf(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get u8
var $b495f2b996e3784e$var$gu8 = function gu8(o) {
    return o && o.size && new $b495f2b996e3784e$var$u8(o.size);
};
// async helper
var $b495f2b996e3784e$var$cbify = function cbify(dat, opts, fns, init, id, cb) {
    var w = $b495f2b996e3784e$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    if (!opts.consume) dat = new $b495f2b996e3784e$var$u8(dat);
    w.postMessage([
        dat,
        opts
    ], [
        dat.buffer
    ]);
    return function() {
        w.terminate();
    };
};
// auto stream
var $b495f2b996e3784e$var$astrm = function astrm(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        return strm.push(ev.data[0], ev.data[1]);
    };
};
// async stream attach
var $b495f2b996e3784e$var$astrmify = function astrmify(fns, strm, opts, init, id) {
    var t;
    var w = $b495f2b996e3784e$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function(d, f) {
        if (t) throw "stream finished";
        if (!strm.ondata) throw "no stream handler";
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
};
// read 2 bytes
var $b495f2b996e3784e$var$b2 = function b2(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $b495f2b996e3784e$var$b4 = function b4(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16) + (d[b + 3] << 23) * 2;
};
// write bytes
var $b495f2b996e3784e$var$wbytes = function wbytes(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $b495f2b996e3784e$var$gzh = function gzh(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $b495f2b996e3784e$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $b495f2b996e3784e$var$gzs = function gzs(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) throw "invalid gzip data";
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += d[10] | (d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $b495f2b996e3784e$var$gzl = function gzl(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16) + 2 * (d[l - 1] << 23);
};
// gzip header length
var $b495f2b996e3784e$var$gzhl = function gzhl(o) {
    return 10 + (o.filename && o.filename.length + 1 || 0);
};
// zlib header
var $b495f2b996e3784e$var$zlh = function zlh(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (fl ? 32 - 2 * fl : 1);
};
// zlib valid
var $b495f2b996e3784e$var$zlv = function zlv(d) {
    if ((d[0] & 15) != 8 || d[0] >>> 4 > 7 || (d[0] << 8 | d[1]) % 31) throw "invalid zlib data";
    if (d[1] & 32) throw "invalid zlib data: preset dictionaries not supported";
};
function $b495f2b996e3784e$var$AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == "function") cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */ var $b495f2b996e3784e$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    var Deflate = function Deflate(opts, cb) {
        if (!cb && typeof opts == "function") cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    };
    Deflate.prototype.p = function(c, f) {
        this.ondata($b495f2b996e3784e$var$dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (this.d) throw "stream finished";
        if (!this.ondata) throw "no stream handler";
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $b495f2b996e3784e$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    var AsyncDeflate = function AsyncDeflate(opts, cb) {
        $b495f2b996e3784e$var$astrmify([
            $b495f2b996e3784e$var$bDflt,
            function() {
                return [
                    $b495f2b996e3784e$var$astrm,
                    $b495f2b996e3784e$export$ae157b6234afe138
                ];
            }
        ], this, $b495f2b996e3784e$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $b495f2b996e3784e$export$ae157b6234afe138(ev.data);
            onmessage = $b495f2b996e3784e$var$astrm(strm);
        }, 6);
    };
    return AsyncDeflate;
}();
function $b495f2b996e3784e$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    return $b495f2b996e3784e$var$cbify(data, opts, [
        $b495f2b996e3784e$var$bDflt
    ], function(ev) {
        return $b495f2b996e3784e$var$pbf($b495f2b996e3784e$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $b495f2b996e3784e$export$21533ff51b8a0b4a(data, opts) {
    if (opts === void 0) opts = {};
    return $b495f2b996e3784e$var$dopt(data, opts, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $b495f2b996e3784e$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    var Inflate = /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */ function Inflate(cb) {
        this.s = {};
        this.p = new $b495f2b996e3784e$var$u8(0);
        this.ondata = cb;
    };
    Inflate.prototype.e = function(c) {
        if (this.d) throw "stream finished";
        if (!this.ondata) throw "no stream handler";
        var l = this.p.length;
        var n = new $b495f2b996e3784e$var$u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function(final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = $b495f2b996e3784e$var$inflt(this.p, this.o, this.s);
        this.ondata($b495f2b996e3784e$var$slc(dt, bts, this.s.b), this.d);
        this.o = $b495f2b996e3784e$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $b495f2b996e3784e$var$slc(this.p, this.s.p / 8 >> 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $b495f2b996e3784e$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    var AsyncInflate = /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncInflate(cb) {
        this.ondata = cb;
        $b495f2b996e3784e$var$astrmify([
            $b495f2b996e3784e$var$bInflt,
            function() {
                return [
                    $b495f2b996e3784e$var$astrm,
                    $b495f2b996e3784e$export$d1de70a877d6e43c
                ];
            }
        ], this, 0, function() {
            var strm = new $b495f2b996e3784e$export$d1de70a877d6e43c();
            onmessage = $b495f2b996e3784e$var$astrm(strm);
        }, 7);
    };
    return AsyncInflate;
}();
function $b495f2b996e3784e$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    return $b495f2b996e3784e$var$cbify(data, opts, [
        $b495f2b996e3784e$var$bInflt
    ], function(ev) {
        return $b495f2b996e3784e$var$pbf($b495f2b996e3784e$export$90366d8b308ba94a(ev.data[0], $b495f2b996e3784e$var$gu8(ev.data[1])));
    }, 1, cb);
}
function $b495f2b996e3784e$export$90366d8b308ba94a(data, out) {
    return $b495f2b996e3784e$var$inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $b495f2b996e3784e$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    var Gzip = function Gzip(opts, cb) {
        this.c = $b495f2b996e3784e$var$crc();
        this.l = 0;
        this.v = 1;
        $b495f2b996e3784e$export$ae157b6234afe138.call(this, opts, cb);
    };
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        $b495f2b996e3784e$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = $b495f2b996e3784e$var$dopt(c, this.o, this.v && $b495f2b996e3784e$var$gzhl(this.o), f && 8, !f);
        if (this.v) $b495f2b996e3784e$var$gzh(raw, this.o), this.v = 0;
        if (f) $b495f2b996e3784e$var$wbytes(raw, raw.length - 8, this.c.d()), $b495f2b996e3784e$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $b495f2b996e3784e$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    var AsyncGzip = function AsyncGzip(opts, cb) {
        $b495f2b996e3784e$var$astrmify([
            $b495f2b996e3784e$var$bDflt,
            $b495f2b996e3784e$var$gze,
            function() {
                return [
                    $b495f2b996e3784e$var$astrm,
                    $b495f2b996e3784e$export$ae157b6234afe138,
                    $b495f2b996e3784e$export$8e4b66d280bf8342
                ];
            }
        ], this, $b495f2b996e3784e$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $b495f2b996e3784e$export$8e4b66d280bf8342(ev.data);
            onmessage = $b495f2b996e3784e$var$astrm(strm);
        }, 8);
    };
    return AsyncGzip;
}();
function $b495f2b996e3784e$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    return $b495f2b996e3784e$var$cbify(data, opts, [
        $b495f2b996e3784e$var$bDflt,
        $b495f2b996e3784e$var$gze,
        function() {
            return [
                $b495f2b996e3784e$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $b495f2b996e3784e$var$pbf($b495f2b996e3784e$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $b495f2b996e3784e$export$3d616c3fb3e15483(data, opts) {
    if (opts === void 0) opts = {};
    var c = $b495f2b996e3784e$var$crc(), l = data.length;
    c.p(data);
    var d = $b495f2b996e3784e$var$dopt(data, opts, $b495f2b996e3784e$var$gzhl(opts), 8), s = d.length;
    return $b495f2b996e3784e$var$gzh(d, opts), $b495f2b996e3784e$var$wbytes(d, s - 8, c.d()), $b495f2b996e3784e$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */ var $b495f2b996e3784e$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    var Gunzip = /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */ function Gunzip(cb) {
        this.v = 1;
        $b495f2b996e3784e$export$d1de70a877d6e43c.call(this, cb);
    };
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $b495f2b996e3784e$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            var s = $b495f2b996e3784e$var$gzs(this.p);
            if (s >= this.p.length && !final) return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8) throw "invalid gzip stream";
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $b495f2b996e3784e$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming GZIP decompression
 */ var $b495f2b996e3784e$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    var AsyncGunzip = /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncGunzip(cb) {
        this.ondata = cb;
        $b495f2b996e3784e$var$astrmify([
            $b495f2b996e3784e$var$bInflt,
            $b495f2b996e3784e$var$guze,
            function() {
                return [
                    $b495f2b996e3784e$var$astrm,
                    $b495f2b996e3784e$export$d1de70a877d6e43c,
                    $b495f2b996e3784e$export$4cb607de6db70415
                ];
            }
        ], this, 0, function() {
            var strm = new $b495f2b996e3784e$export$4cb607de6db70415();
            onmessage = $b495f2b996e3784e$var$astrm(strm);
        }, 9);
    };
    return AsyncGunzip;
}();
function $b495f2b996e3784e$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    return $b495f2b996e3784e$var$cbify(data, opts, [
        $b495f2b996e3784e$var$bInflt,
        $b495f2b996e3784e$var$guze,
        function() {
            return [
                $b495f2b996e3784e$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $b495f2b996e3784e$var$pbf($b495f2b996e3784e$export$c80456f7aaba691c(ev.data[0]));
    }, 3, cb);
}
function $b495f2b996e3784e$export$c80456f7aaba691c(data, out) {
    return $b495f2b996e3784e$var$inflt(data.subarray($b495f2b996e3784e$var$gzs(data), -8), out || new $b495f2b996e3784e$var$u8($b495f2b996e3784e$var$gzl(data)));
}
/**
 * Streaming Zlib compression
 */ var $b495f2b996e3784e$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    var Zlib = function Zlib(opts, cb) {
        this.c = $b495f2b996e3784e$var$adler();
        this.v = 1;
        $b495f2b996e3784e$export$ae157b6234afe138.call(this, opts, cb);
    };
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        $b495f2b996e3784e$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        this.c.p(c);
        var raw = $b495f2b996e3784e$var$dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v) $b495f2b996e3784e$var$zlh(raw, this.o), this.v = 0;
        if (f) $b495f2b996e3784e$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $b495f2b996e3784e$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    var AsyncZlib = function AsyncZlib(opts, cb) {
        $b495f2b996e3784e$var$astrmify([
            $b495f2b996e3784e$var$bDflt,
            $b495f2b996e3784e$var$zle,
            function() {
                return [
                    $b495f2b996e3784e$var$astrm,
                    $b495f2b996e3784e$export$ae157b6234afe138,
                    $b495f2b996e3784e$export$4187ccf2467013b9
                ];
            }
        ], this, $b495f2b996e3784e$var$AsyncCmpStrm.call(this, opts, cb), function(ev) {
            var strm = new $b495f2b996e3784e$export$4187ccf2467013b9(ev.data);
            onmessage = $b495f2b996e3784e$var$astrm(strm);
        }, 10);
    };
    return AsyncZlib;
}();
function $b495f2b996e3784e$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    return $b495f2b996e3784e$var$cbify(data, opts, [
        $b495f2b996e3784e$var$bDflt,
        $b495f2b996e3784e$var$zle,
        function() {
            return [
                $b495f2b996e3784e$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $b495f2b996e3784e$var$pbf($b495f2b996e3784e$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $b495f2b996e3784e$export$f87121a6d50aff25(data, opts) {
    if (opts === void 0) opts = {};
    var a = $b495f2b996e3784e$var$adler();
    a.p(data);
    var d = $b495f2b996e3784e$var$dopt(data, opts, 2, 4);
    return $b495f2b996e3784e$var$zlh(d, opts), $b495f2b996e3784e$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $b495f2b996e3784e$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    var Unzlib = /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */ function Unzlib(cb) {
        this.v = 1;
        $b495f2b996e3784e$export$d1de70a877d6e43c.call(this, cb);
    };
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $b495f2b996e3784e$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final) return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) throw "invalid zlib stream";
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $b495f2b996e3784e$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $b495f2b996e3784e$export$cf6668790220dcad = /*#__PURE__*/ function() {
    var AsyncUnzlib = /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */ function AsyncUnzlib(cb) {
        this.ondata = cb;
        $b495f2b996e3784e$var$astrmify([
            $b495f2b996e3784e$var$bInflt,
            $b495f2b996e3784e$var$zule,
            function() {
                return [
                    $b495f2b996e3784e$var$astrm,
                    $b495f2b996e3784e$export$d1de70a877d6e43c,
                    $b495f2b996e3784e$export$af2424f875ff1b17
                ];
            }
        ], this, 0, function() {
            var strm = new $b495f2b996e3784e$export$af2424f875ff1b17();
            onmessage = $b495f2b996e3784e$var$astrm(strm);
        }, 11);
    };
    return AsyncUnzlib;
}();
function $b495f2b996e3784e$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    return $b495f2b996e3784e$var$cbify(data, opts, [
        $b495f2b996e3784e$var$bInflt,
        $b495f2b996e3784e$var$zule,
        function() {
            return [
                $b495f2b996e3784e$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $b495f2b996e3784e$var$pbf($b495f2b996e3784e$export$9ec8134f0f1b9fc6(ev.data[0], $b495f2b996e3784e$var$gu8(ev.data[1])));
    }, 5, cb);
}
function $b495f2b996e3784e$export$9ec8134f0f1b9fc6(data, out) {
    return $b495f2b996e3784e$var$inflt(($b495f2b996e3784e$var$zlv(data), data.subarray(2, -4)), out);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $b495f2b996e3784e$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    var Decompress = /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */ function Decompress(cb) {
        this.G = $b495f2b996e3784e$export$4cb607de6db70415;
        this.I = $b495f2b996e3784e$export$d1de70a877d6e43c;
        this.Z = $b495f2b996e3784e$export$af2424f875ff1b17;
        this.ondata = cb;
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) throw "no stream handler";
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $b495f2b996e3784e$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function cb() {
                    _this_1.ondata.apply(_this_1, arguments);
                };
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(cb) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(cb) : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $b495f2b996e3784e$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    var AsyncDecompress = /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */ function AsyncDecompress(cb) {
        this.G = $b495f2b996e3784e$export$d5adcdd968132151;
        this.I = $b495f2b996e3784e$export$fff8358d6dbaa9cc;
        this.Z = $b495f2b996e3784e$export$cf6668790220dcad;
        this.ondata = cb;
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        $b495f2b996e3784e$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $b495f2b996e3784e$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $b495f2b996e3784e$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $b495f2b996e3784e$export$cae1ce83fe4a1782(data, opts, cb) : $b495f2b996e3784e$export$ca7cbb494e731274(data, opts, cb);
}
function $b495f2b996e3784e$export$c4bdbbbc9a4faabe(data, out) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $b495f2b996e3784e$export$c80456f7aaba691c(data, out) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $b495f2b996e3784e$export$90366d8b308ba94a(data, out) : $b495f2b996e3784e$export$9ec8134f0f1b9fc6(data, out);
}
// flatten a directory structure
var $b495f2b996e3784e$var$fltn = function fltn1(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k;
        if (val instanceof $b495f2b996e3784e$var$u8) t[n] = [
            val,
            o
        ];
        else if (Array.isArray(val)) t[n] = [
            val[0],
            $b495f2b996e3784e$var$mrg(o, val[1])
        ];
        else $b495f2b996e3784e$var$fltn(val, n + "/", t, o);
    }
};
function $b495f2b996e3784e$export$366b39a6daa8ed7a(str, latin1) {
    var l = str.length;
    if (!latin1 && typeof TextEncoder != "undefined") return new TextEncoder().encode(str);
    var ar = new $b495f2b996e3784e$var$u8(str.length + (str.length >>> 1));
    var ai = 0;
    var w = function w(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $b495f2b996e3784e$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >>> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >>> 18), w(128 | c >>> 12 & 63), w(128 | c >>> 6 & 63), w(128 | c & 63);
        else w(224 | c >>> 12), w(128 | c >>> 6 & 63), w(128 | c & 63);
    }
    return $b495f2b996e3784e$var$slc(ar, 0, ai);
}
function $b495f2b996e3784e$export$adb211f8cb999894(dat, latin1) {
    var r = "";
    if (!latin1 && typeof TextDecoder != "undefined") return new TextDecoder().decode(dat);
    for(var i = 0; i < dat.length;){
        var c = dat[i++];
        if (c < 128 || latin1) r += String.fromCharCode(c);
        else if (c < 224) r += String.fromCharCode((c & 31) << 6 | dat[i++] & 63);
        else if (c < 240) r += String.fromCharCode((c & 15) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63);
        else c = ((c & 15) << 18 | (dat[i++] & 63) << 12 | (dat[i++] & 63) << 6 | dat[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
    }
    return r;
}
// skip local zip header
var $b495f2b996e3784e$var$slzh = function slzh(d, b) {
    return b + 30 + $b495f2b996e3784e$var$b2(d, b + 26) + $b495f2b996e3784e$var$b2(d, b + 28);
};
// read zip header
var $b495f2b996e3784e$var$zh = function zh(d, b, z) {
    var fnl = $b495f2b996e3784e$var$b2(d, b + 28), fn = $b495f2b996e3784e$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($b495f2b996e3784e$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = z ? $b495f2b996e3784e$var$z64e(d, es) : [
        $b495f2b996e3784e$var$b4(d, b + 20),
        $b495f2b996e3784e$var$b4(d, b + 24),
        $b495f2b996e3784e$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $b495f2b996e3784e$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $b495f2b996e3784e$var$b2(d, b + 30) + $b495f2b996e3784e$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $b495f2b996e3784e$var$z64e = function z64e(d, b) {
    for(; $b495f2b996e3784e$var$b2(d, b) != 1; b += 4 + $b495f2b996e3784e$var$b2(d, b + 2));
    return [
        $b495f2b996e3784e$var$b4(d, b + 12),
        $b495f2b996e3784e$var$b4(d, b + 4),
        $b495f2b996e3784e$var$b4(d, b + 20)
    ];
};
// write zip header
var $b495f2b996e3784e$var$wzh = function wzh(d, b, c, cmp, su, fn, u, o, ce, t) {
    var fl = fn.length, l = cmp.length;
    $b495f2b996e3784e$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b] = 20, b += 2;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = t == 8 && (o.level == 1 ? 6 : o.level < 6 ? 4 : o.level == 9 ? 2 : 0), d[b++] = u && 8;
    d[b] = t, b += 2;
    var dt = new Date(o.mtime || Date.now()), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) throw "date not in range 1980-2099";
    $b495f2b996e3784e$var$wbytes(d, b, (y << 24) * 2 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >>> 1);
    b += 4;
    $b495f2b996e3784e$var$wbytes(d, b, c);
    $b495f2b996e3784e$var$wbytes(d, b + 4, l);
    $b495f2b996e3784e$var$wbytes(d, b + 8, su);
    $b495f2b996e3784e$var$wbytes(d, b + 12, fl), b += 16; // skip extra field, comment
    if (ce != null) $b495f2b996e3784e$var$wbytes(d, b += 10, ce), b += 4;
    d.set(fn, b);
    b += fl;
    if (ce == null) d.set(cmp, b);
};
// write zip footer (end of central directory)
var $b495f2b996e3784e$var$wzf = function wzf(o, b, c, d, e) {
    $b495f2b996e3784e$var$wbytes(o, b, 0x6054B50); // skip disk
    $b495f2b996e3784e$var$wbytes(o, b + 8, c);
    $b495f2b996e3784e$var$wbytes(o, b + 10, c);
    $b495f2b996e3784e$var$wbytes(o, b + 12, d);
    $b495f2b996e3784e$var$wbytes(o, b + 16, e);
};
function $b495f2b996e3784e$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != "function") throw "no callback";
    var r = {};
    $b495f2b996e3784e$var$fltn(data, "", r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function tAll() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbf = function cbf() {
        var out = new $b495f2b996e3784e$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                $b495f2b996e3784e$var$wzh(out, tot, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
                $b495f2b996e3784e$var$wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, tot, f.t), o += 46 + f.n.length, tot += 30 + f.n.length + f.d.length;
            } catch (e) {
                return cb(e, null);
            }
        }
        $b495f2b996e3784e$var$wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function _loop_1(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $b495f2b996e3784e$var$crc(), m = file.length;
        c.p(file);
        var n = $b495f2b996e3784e$export$366b39a6daa8ed7a(fn), s = n.length;
        var t = p.level == 0 ? 0 : 8;
        var cbl = function cbl(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                var l = d.length;
                files[i] = {
                    t: t,
                    d: d,
                    m: m,
                    c: c.d(),
                    u: fn.length != l,
                    n: n,
                    p: p
                };
                o += 30 + s + l;
                tot += 76 + 2 * s + l;
                if (!--lft) cbf();
            }
        };
        if (n.length > 65535) cbl("filename too long", null);
        if (!t) cbl(null, file);
        else if (m < 160000) try {
            cbl(null, $b495f2b996e3784e$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($b495f2b996e3784e$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $b495f2b996e3784e$export$eb1654f146d54eb3(data, opts) {
    if (opts === void 0) opts = {};
    var r = {};
    var files = [];
    $b495f2b996e3784e$var$fltn(data, "", r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var t = p.level == 0 ? 0 : 8;
        var n = $b495f2b996e3784e$export$366b39a6daa8ed7a(fn), s = n.length;
        if (n.length > 65535) throw "filename too long";
        var d = t ? $b495f2b996e3784e$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $b495f2b996e3784e$var$crc();
        c.p(file);
        files.push({
            t: t,
            d: d,
            m: file.length,
            c: c.d(),
            u: fn.length != s,
            n: n,
            o: o,
            p: p
        });
        o += 30 + s + l;
        tot += 76 + 2 * s + l;
    }
    var out = new $b495f2b996e3784e$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $b495f2b996e3784e$var$wzh(out, f.o, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
        $b495f2b996e3784e$var$wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, f.o, f.t), o += 46 + f.n.length;
    }
    $b495f2b996e3784e$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
function $b495f2b996e3784e$export$23c8d3f8757cab88(data, cb) {
    if (typeof cb != "function") throw "no callback";
    var term = [];
    var tAll = function tAll() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var e = data.length - 22;
    for(; $b495f2b996e3784e$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cb("invalid zip file", null);
        return;
    }
    var lft = $b495f2b996e3784e$var$b2(data, e + 8);
    if (!lft) cb(null, {});
    var c = lft;
    var o = $b495f2b996e3784e$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $b495f2b996e3784e$var$b4(data, e - 12);
        if ($b495f2b996e3784e$var$b4(data, e) != 0x6064B50) throw "invalid zip file";
        c = lft = $b495f2b996e3784e$var$b4(data, e + 32);
        o = $b495f2b996e3784e$var$b4(data, e + 48);
    }
    var _loop_2 = function _loop_2(i) {
        var _a = $b495f2b996e3784e$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $b495f2b996e3784e$var$slzh(data, off);
        o = no;
        var cbl = function cbl(e, d) {
            if (e) {
                tAll();
                cb(e, null);
            } else {
                files[fn] = d;
                if (!--lft) cb(null, files);
            }
        };
        if (!c_1) cbl(null, $b495f2b996e3784e$var$slc(data, b, b + sc));
        else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) try {
                cbl(null, $b495f2b996e3784e$export$90366d8b308ba94a(infl, new $b495f2b996e3784e$var$u8(su)));
            } catch (e) {
                cbl(e, null);
            }
            else term.push($b495f2b996e3784e$export$cae1ce83fe4a1782(infl, {
                size: su
            }, cbl));
        } else cbl("unknown compression type " + c_1, null);
    };
    for(var i = 0; i < c; ++i)_loop_2(i);
    return tAll;
}
function $b495f2b996e3784e$export$c757709326bb5901(data) {
    var files = {};
    var e = data.length - 22;
    for(; $b495f2b996e3784e$var$b4(data, e) != 0x6054B50; --e){
        if (!e || data.length - e > 65558) throw "invalid zip file";
    }
    var c = $b495f2b996e3784e$var$b2(data, e + 8);
    if (!c) return {};
    var o = $b495f2b996e3784e$var$b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = $b495f2b996e3784e$var$b4(data, e - 12);
        if ($b495f2b996e3784e$var$b4(data, e) != 0x6064B50) throw "invalid zip file";
        c = $b495f2b996e3784e$var$b4(data, e + 32);
        o = $b495f2b996e3784e$var$b4(data, e + 48);
    }
    for(var i = 0; i < c; ++i){
        var _a = $b495f2b996e3784e$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $b495f2b996e3784e$var$slzh(data, off);
        o = no;
        if (!c_2) files[fn] = $b495f2b996e3784e$var$slc(data, b, b + sc);
        else if (c_2 == 8) files[fn] = $b495f2b996e3784e$export$90366d8b308ba94a(data.subarray(b, b + sc), new $b495f2b996e3784e$var$u8(su));
        else throw "unknown compression type " + c_2;
    }
    return files;
}


var $cbf54afc98507811$var$n = function() {
    return "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : this;
}();
function $cbf54afc98507811$var$i() {
    $cbf54afc98507811$var$n.console && "function" == typeof $cbf54afc98507811$var$n.console.log && $cbf54afc98507811$var$n.console.log.apply($cbf54afc98507811$var$n.console, arguments);
}
var $cbf54afc98507811$var$a = {
    log: $cbf54afc98507811$var$i,
    warn: function warn(t) {
        $cbf54afc98507811$var$n.console && ("function" == typeof $cbf54afc98507811$var$n.console.warn ? $cbf54afc98507811$var$n.console.warn.apply($cbf54afc98507811$var$n.console, arguments) : $cbf54afc98507811$var$i.call(null, arguments));
    },
    error: function error(t) {
        $cbf54afc98507811$var$n.console && ("function" == typeof $cbf54afc98507811$var$n.console.error ? $cbf54afc98507811$var$n.console.error.apply($cbf54afc98507811$var$n.console, arguments) : $cbf54afc98507811$var$i(t));
    }
};
function $cbf54afc98507811$var$o(t, e, r) {
    var n = new XMLHttpRequest;
    n.open("GET", t), n.responseType = "blob", n.onload = function() {
        $cbf54afc98507811$var$l(n.response, e, r);
    }, n.onerror = function() {
        $cbf54afc98507811$var$a.error("could not download file");
    }, n.send();
}
function $cbf54afc98507811$var$s(t) {
    var e = new XMLHttpRequest;
    e.open("HEAD", t, !1);
    try {
        e.send();
    } catch (t) {}
    return e.status >= 200 && e.status <= 299;
}
function $cbf54afc98507811$var$c(t) {
    try {
        t.dispatchEvent(new MouseEvent("click"));
    } catch (r) {
        var e = document.createEvent("MouseEvents");
        e.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), t.dispatchEvent(e);
    }
}
var $cbf54afc98507811$var$u, $cbf54afc98507811$var$h, $cbf54afc98507811$var$l = $cbf54afc98507811$var$n.saveAs || ("object" !== ("undefined" == typeof window ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(window)) || window !== $cbf54afc98507811$var$n ? function() {} : "undefined" != typeof HTMLAnchorElement && "download" in HTMLAnchorElement.prototype ? function(t, e, r) {
    var _$i = $cbf54afc98507811$var$n.URL || $cbf54afc98507811$var$n.webkitURL, a = document.createElement("a");
    e = e || t.name || "download", a.download = e, a.rel = "noopener", "string" == typeof t ? (a.href = t, a.origin !== location.origin ? $cbf54afc98507811$var$s(a.href) ? $cbf54afc98507811$var$o(t, e, r) : $cbf54afc98507811$var$c(a, a.target = "_blank") : $cbf54afc98507811$var$c(a)) : (a.href = _$i.createObjectURL(t), setTimeout(function() {
        _$i.revokeObjectURL(a.href);
    }, 4e4), setTimeout(function() {
        $cbf54afc98507811$var$c(a);
    }, 0));
} : "msSaveOrOpenBlob" in navigator ? function(e, r, n) {
    if (r = r || e.name || "download", "string" == typeof e) {
        if ($cbf54afc98507811$var$s(e)) $cbf54afc98507811$var$o(e, r, n);
        else {
            var _$i = document.createElement("a");
            _$i.href = e, _$i.target = "_blank", setTimeout(function() {
                $cbf54afc98507811$var$c(_$i);
            });
        }
    } else navigator.msSaveOrOpenBlob(function(e, r) {
        return void 0 === r ? r = {
            autoBom: !1
        } : "object" !== (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(r) && ($cbf54afc98507811$var$a.warn("Deprecated: Expected third argument to be a object"), r = {
            autoBom: !r
        }), r.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob([
            String.fromCharCode(65279),
            e
        ], {
            type: e.type
        }) : e;
    }(e, n), r);
} : function(e, r, i, a) {
    if ((a = a || open("", "_blank")) && (a.document.title = a.document.body.innerText = "downloading..."), "string" == typeof e) return $cbf54afc98507811$var$o(e, r, i);
    var s = "application/octet-stream" === e.type, c = /constructor/i.test($cbf54afc98507811$var$n.HTMLElement) || $cbf54afc98507811$var$n.safari, u = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((u || s && c) && "object" === ("undefined" == typeof FileReader ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(FileReader))) {
        var h = new FileReader;
        h.onloadend = function() {
            var _$t = h.result;
            _$t = u ? _$t : _$t.replace(/^data:[^;]*;/, "data:attachment/file;"), a ? a.location.href = _$t : location = _$t, a = null;
        }, h.readAsDataURL(e);
    } else {
        var l = $cbf54afc98507811$var$n.URL || $cbf54afc98507811$var$n.webkitURL, f = l.createObjectURL(e);
        a ? a.location = f : location.href = f, a = null, setTimeout(function() {
            l.revokeObjectURL(f);
        }, 4e4);
    }
});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */ function $cbf54afc98507811$var$f(t) {
    var e;
    t = t || "", this.ok = !1, "#" == t.charAt(0) && (t = t.substr(1, 6));
    t = ({
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dodgerblue: "1e90ff",
        feldspar: "d19275",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslateblue: "8470ff",
        lightslategray: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        violetred: "d02090",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    })[t = (t = t.replace(/ /g, "")).toLowerCase()] || t;
    for(var r = [
        {
            re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
            example: [
                "rgb(123, 234, 45)",
                "rgb(255,234,245)"
            ],
            process: function process(t) {
                return [
                    parseInt(t[1]),
                    parseInt(t[2]),
                    parseInt(t[3])
                ];
            }
        },
        {
            re: /^(\w{2})(\w{2})(\w{2})$/,
            example: [
                "#00ff00",
                "336699"
            ],
            process: function process(t) {
                return [
                    parseInt(t[1], 16),
                    parseInt(t[2], 16),
                    parseInt(t[3], 16)
                ];
            }
        },
        {
            re: /^(\w{1})(\w{1})(\w{1})$/,
            example: [
                "#fb0",
                "f0f"
            ],
            process: function process(t) {
                return [
                    parseInt(t[1] + t[1], 16),
                    parseInt(t[2] + t[2], 16),
                    parseInt(t[3] + t[3], 16)
                ];
            }
        }
    ], n = 0; n < r.length; n++){
        var _$i = r[n].re, a = r[n].process, o = _$i.exec(t);
        o && (e = a(o), this.r = e[0], this.g = e[1], this.b = e[2], this.ok = !0);
    }
    this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.toRGB = function() {
        return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
    }, this.toHex = function() {
        var _$t = this.r.toString(16), e = this.g.toString(16), r = this.b.toString(16);
        return 1 == _$t.length && (_$t = "0" + _$t), 1 == e.length && (e = "0" + e), 1 == r.length && (r = "0" + r), "#" + _$t + e + r;
    };
}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */ function $cbf54afc98507811$var$d(t, e) {
    var r = t[0], n = t[1], _$i = t[2], a = t[3];
    r = $cbf54afc98507811$var$g(r, n, _$i, a, e[0], 7, -680876936), a = $cbf54afc98507811$var$g(a, r, n, _$i, e[1], 12, -389564586), _$i = $cbf54afc98507811$var$g(_$i, a, r, n, e[2], 17, 606105819), n = $cbf54afc98507811$var$g(n, _$i, a, r, e[3], 22, -1044525330), r = $cbf54afc98507811$var$g(r, n, _$i, a, e[4], 7, -176418897), a = $cbf54afc98507811$var$g(a, r, n, _$i, e[5], 12, 1200080426), _$i = $cbf54afc98507811$var$g(_$i, a, r, n, e[6], 17, -1473231341), n = $cbf54afc98507811$var$g(n, _$i, a, r, e[7], 22, -45705983), r = $cbf54afc98507811$var$g(r, n, _$i, a, e[8], 7, 1770035416), a = $cbf54afc98507811$var$g(a, r, n, _$i, e[9], 12, -1958414417), _$i = $cbf54afc98507811$var$g(_$i, a, r, n, e[10], 17, -42063), n = $cbf54afc98507811$var$g(n, _$i, a, r, e[11], 22, -1990404162), r = $cbf54afc98507811$var$g(r, n, _$i, a, e[12], 7, 1804603682), a = $cbf54afc98507811$var$g(a, r, n, _$i, e[13], 12, -40341101), _$i = $cbf54afc98507811$var$g(_$i, a, r, n, e[14], 17, -1502002290), r = $cbf54afc98507811$var$m(r, n = $cbf54afc98507811$var$g(n, _$i, a, r, e[15], 22, 1236535329), _$i, a, e[1], 5, -165796510), a = $cbf54afc98507811$var$m(a, r, n, _$i, e[6], 9, -1069501632), _$i = $cbf54afc98507811$var$m(_$i, a, r, n, e[11], 14, 643717713), n = $cbf54afc98507811$var$m(n, _$i, a, r, e[0], 20, -373897302), r = $cbf54afc98507811$var$m(r, n, _$i, a, e[5], 5, -701558691), a = $cbf54afc98507811$var$m(a, r, n, _$i, e[10], 9, 38016083), _$i = $cbf54afc98507811$var$m(_$i, a, r, n, e[15], 14, -660478335), n = $cbf54afc98507811$var$m(n, _$i, a, r, e[4], 20, -405537848), r = $cbf54afc98507811$var$m(r, n, _$i, a, e[9], 5, 568446438), a = $cbf54afc98507811$var$m(a, r, n, _$i, e[14], 9, -1019803690), _$i = $cbf54afc98507811$var$m(_$i, a, r, n, e[3], 14, -187363961), n = $cbf54afc98507811$var$m(n, _$i, a, r, e[8], 20, 1163531501), r = $cbf54afc98507811$var$m(r, n, _$i, a, e[13], 5, -1444681467), a = $cbf54afc98507811$var$m(a, r, n, _$i, e[2], 9, -51403784), _$i = $cbf54afc98507811$var$m(_$i, a, r, n, e[7], 14, 1735328473), r = $cbf54afc98507811$var$v(r, n = $cbf54afc98507811$var$m(n, _$i, a, r, e[12], 20, -1926607734), _$i, a, e[5], 4, -378558), a = $cbf54afc98507811$var$v(a, r, n, _$i, e[8], 11, -2022574463), _$i = $cbf54afc98507811$var$v(_$i, a, r, n, e[11], 16, 1839030562), n = $cbf54afc98507811$var$v(n, _$i, a, r, e[14], 23, -35309556), r = $cbf54afc98507811$var$v(r, n, _$i, a, e[1], 4, -1530992060), a = $cbf54afc98507811$var$v(a, r, n, _$i, e[4], 11, 1272893353), _$i = $cbf54afc98507811$var$v(_$i, a, r, n, e[7], 16, -155497632), n = $cbf54afc98507811$var$v(n, _$i, a, r, e[10], 23, -1094730640), r = $cbf54afc98507811$var$v(r, n, _$i, a, e[13], 4, 681279174), a = $cbf54afc98507811$var$v(a, r, n, _$i, e[0], 11, -358537222), _$i = $cbf54afc98507811$var$v(_$i, a, r, n, e[3], 16, -722521979), n = $cbf54afc98507811$var$v(n, _$i, a, r, e[6], 23, 76029189), r = $cbf54afc98507811$var$v(r, n, _$i, a, e[9], 4, -640364487), a = $cbf54afc98507811$var$v(a, r, n, _$i, e[12], 11, -421815835), _$i = $cbf54afc98507811$var$v(_$i, a, r, n, e[15], 16, 530742520), r = $cbf54afc98507811$var$b(r, n = $cbf54afc98507811$var$v(n, _$i, a, r, e[2], 23, -995338651), _$i, a, e[0], 6, -198630844), a = $cbf54afc98507811$var$b(a, r, n, _$i, e[7], 10, 1126891415), _$i = $cbf54afc98507811$var$b(_$i, a, r, n, e[14], 15, -1416354905), n = $cbf54afc98507811$var$b(n, _$i, a, r, e[5], 21, -57434055), r = $cbf54afc98507811$var$b(r, n, _$i, a, e[12], 6, 1700485571), a = $cbf54afc98507811$var$b(a, r, n, _$i, e[3], 10, -1894986606), _$i = $cbf54afc98507811$var$b(_$i, a, r, n, e[10], 15, -1051523), n = $cbf54afc98507811$var$b(n, _$i, a, r, e[1], 21, -2054922799), r = $cbf54afc98507811$var$b(r, n, _$i, a, e[8], 6, 1873313359), a = $cbf54afc98507811$var$b(a, r, n, _$i, e[15], 10, -30611744), _$i = $cbf54afc98507811$var$b(_$i, a, r, n, e[6], 15, -1560198380), n = $cbf54afc98507811$var$b(n, _$i, a, r, e[13], 21, 1309151649), r = $cbf54afc98507811$var$b(r, n, _$i, a, e[4], 6, -145523070), a = $cbf54afc98507811$var$b(a, r, n, _$i, e[11], 10, -1120210379), _$i = $cbf54afc98507811$var$b(_$i, a, r, n, e[2], 15, 718787259), n = $cbf54afc98507811$var$b(n, _$i, a, r, e[9], 21, -343485551), t[0] = $cbf54afc98507811$var$_(r, t[0]), t[1] = $cbf54afc98507811$var$_(n, t[1]), t[2] = $cbf54afc98507811$var$_(_$i, t[2]), t[3] = $cbf54afc98507811$var$_(a, t[3]);
}
function $cbf54afc98507811$var$p(t, e, r, n, i, a) {
    return e = $cbf54afc98507811$var$_($cbf54afc98507811$var$_(e, t), $cbf54afc98507811$var$_(n, a)), $cbf54afc98507811$var$_(e << i | e >>> 32 - i, r);
}
function $cbf54afc98507811$var$g(t, e, r, n, i, a, o) {
    return $cbf54afc98507811$var$p(e & r | ~e & n, t, e, i, a, o);
}
function $cbf54afc98507811$var$m(t, e, r, n, i, a, o) {
    return $cbf54afc98507811$var$p(e & n | r & ~n, t, e, i, a, o);
}
function $cbf54afc98507811$var$v(t, e, r, n, i, a, o) {
    return $cbf54afc98507811$var$p(e ^ r ^ n, t, e, i, a, o);
}
function $cbf54afc98507811$var$b(t, e, r, n, i, a, o) {
    return $cbf54afc98507811$var$p(r ^ (e | ~n), t, e, i, a, o);
}
function $cbf54afc98507811$var$y(t) {
    var e, r = t.length, n = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    for(e = 64; e <= t.length; e += 64)$cbf54afc98507811$var$d(n, $cbf54afc98507811$var$w(t.substring(e - 64, e)));
    t = t.substring(e - 64);
    var _$i = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(e = 0; e < t.length; e++)_$i[e >> 2] |= t.charCodeAt(e) << (e % 4 << 3);
    if (_$i[e >> 2] |= 128 << (e % 4 << 3), e > 55) for($cbf54afc98507811$var$d(n, _$i), e = 0; e < 16; e++)_$i[e] = 0;
    return _$i[14] = 8 * r, $cbf54afc98507811$var$d(n, _$i), n;
}
function $cbf54afc98507811$var$w(t) {
    var e, r = [];
    for(e = 0; e < 64; e += 4)r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
    return r;
}
$cbf54afc98507811$var$u = $cbf54afc98507811$var$n.atob.bind($cbf54afc98507811$var$n), $cbf54afc98507811$var$h = $cbf54afc98507811$var$n.btoa.bind($cbf54afc98507811$var$n);
var $cbf54afc98507811$var$N = "0123456789abcdef".split("");
function $cbf54afc98507811$var$L(t) {
    for(var e = "", r = 0; r < 4; r++)e += $cbf54afc98507811$var$N[t >> 8 * r + 4 & 15] + $cbf54afc98507811$var$N[t >> 8 * r & 15];
    return e;
}
function $cbf54afc98507811$var$A(t) {
    return String.fromCharCode((255 & t) >> 0, (65280 & t) >> 8, (16711680 & t) >> 16, (4278190080 & t) >> 24);
}
function $cbf54afc98507811$var$x(t) {
    return $cbf54afc98507811$var$y(t).map($cbf54afc98507811$var$A).join("");
}
var $cbf54afc98507811$var$S = "5d41402abc4b2a76b9719d911017c592" != function(t) {
    for(var e = 0; e < t.length; e++)t[e] = $cbf54afc98507811$var$L(t[e]);
    return t.join("");
}($cbf54afc98507811$var$y("hello"));
function $cbf54afc98507811$var$_(t, e) {
    if ($cbf54afc98507811$var$S) {
        var r = (65535 & t) + (65535 & e);
        return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
    }
    return t + e & 4294967295;
}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */ function $cbf54afc98507811$var$P(t, e) {
    var r, n, _$i, a;
    if (t !== r) {
        for(var o = (_$i = t, a = 1 + (256 / t.length >> 0), new Array(a + 1).join(_$i)), s = [], c = 0; c < 256; c++)s[c] = c;
        var u = 0;
        for(c = 0; c < 256; c++){
            var h = s[c];
            u = (u + h + o.charCodeAt(c)) % 256, s[c] = s[u], s[u] = h;
        }
        r = t, n = s;
    } else s = n;
    var l = e.length, f = 0, d = 0, p = "";
    for(c = 0; c < l; c++)d = (d + (h = s[f = (f + 1) % 256])) % 256, s[f] = s[d], s[d] = h, o = s[(s[f] + s[d]) % 256], p += String.fromCharCode(e.charCodeAt(c) ^ o);
    return p;
}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */ var $cbf54afc98507811$var$k = {
    print: 4,
    modify: 8,
    copy: 16,
    "annot-forms": 32
};
function $cbf54afc98507811$var$I(t, e, r, n) {
    this.v = 1, this.r = 2;
    var _$i = 192;
    t.forEach(function(t) {
        if (void 0 !== $cbf54afc98507811$var$k.perm) throw new Error("Invalid permission: " + t);
        _$i += $cbf54afc98507811$var$k[t];
    }), this.padding = "(\xbfN^Nu\x8aAd\x00NV\xff\xfa\x01\b..\x00\xb6\xd0h>\x80/\f\xa9\xfedSiz";
    var a = (e + this.padding).substr(0, 32), o = (r + this.padding).substr(0, 32);
    this.O = this.processOwnerPassword(a, o), this.P = -(1 + (255 ^ _$i)), this.encryptionKey = $cbf54afc98507811$var$x(a + this.O + this.lsbFirstWord(this.P) + this.hexToBytes(n)).substr(0, 5), this.U = $cbf54afc98507811$var$P(this.encryptionKey, this.padding);
}
function $cbf54afc98507811$var$F(t) {
    if (/[^\u0000-\u00ff]/.test(t)) throw new Error("Invalid PDF Name Object: " + t + ", Only accept ASCII characters.");
    for(var e = "", r = t.length, n = 0; n < r; n++){
        var _$i = t.charCodeAt(n);
        if (_$i < 33 || 35 === _$i || 37 === _$i || 40 === _$i || 41 === _$i || 47 === _$i || 60 === _$i || 62 === _$i || 91 === _$i || 93 === _$i || 123 === _$i || 125 === _$i || _$i > 126) e += "#" + ("0" + _$i.toString(16)).slice(-2);
        else e += t[n];
    }
    return e;
}
function $cbf54afc98507811$var$C(e) {
    if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e)) throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");
    var r = {};
    this.subscribe = function(t, e, n) {
        if (n = n || !1, "string" != typeof t || "function" != typeof e || "boolean" != typeof n) throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");
        r.hasOwnProperty(t) || (r[t] = {});
        var _$i = Math.random().toString(35);
        return r[t][_$i] = [
            e,
            !!n
        ], _$i;
    }, this.unsubscribe = function(t) {
        for(var _$e in r)if (r[_$e][t]) return delete r[_$e][t], 0 === Object.keys(r[_$e]).length && delete r[_$e], !0;
        return !1;
    }, this.publish = function(t) {
        if (r.hasOwnProperty(t)) {
            var _$i = Array.prototype.slice.call(arguments, 1), o = [];
            for(var s in r[t]){
                var c = r[t][s];
                try {
                    c[0].apply(e, _$i);
                } catch (t) {
                    $cbf54afc98507811$var$n.console && $cbf54afc98507811$var$a.error("jsPDF PubSub Error", t.message, t);
                }
                c[1] && o.push(s);
            }
            o.length && o.forEach(this.unsubscribe);
        }
    }, this.getTopics = function() {
        return r;
    };
}
function $cbf54afc98507811$export$1bc649ab427a02ba(t) {
    if (!(this instanceof $cbf54afc98507811$export$1bc649ab427a02ba)) return new $cbf54afc98507811$export$1bc649ab427a02ba(t);
    var e = "opacity,stroke-opacity".split(",");
    for(var r in t)t.hasOwnProperty(r) && e.indexOf(r) >= 0 && (this[r] = t[r]);
    this.id = "", this.objectNumber = -1;
}
function $cbf54afc98507811$var$O(t, e) {
    this.gState = t, this.matrix = e, this.id = "", this.objectNumber = -1;
}
function $cbf54afc98507811$export$7235f0ad083cb4c6(t, e, r, n, i) {
    if (!(this instanceof $cbf54afc98507811$export$7235f0ad083cb4c6)) return new $cbf54afc98507811$export$7235f0ad083cb4c6(t, e, r, n, i);
    this.type = "axial" === t ? 2 : 3, this.coords = e, this.colors = r, $cbf54afc98507811$var$O.call(this, n, i);
}
function $cbf54afc98507811$export$549f717800d2b57f(t, e, r, n, i) {
    if (!(this instanceof $cbf54afc98507811$export$549f717800d2b57f)) return new $cbf54afc98507811$export$549f717800d2b57f(t, e, r, n, i);
    this.boundingBox = t, this.xStep = e, this.yStep = r, this.stream = "", this.cloneIndex = 0, $cbf54afc98507811$var$O.call(this, n, i);
}
function $cbf54afc98507811$export$ba1e2ffc633a60f5(e) {
    var _ = function _() {
        this.saveGraphicsState(), lt(new Vt(_$_t, 0, 0, -_$_t, 0, Rr() * _$_t).toString() + " cm"), this.setFontSize(this.getFontSize() / _$_t), g = "n", S = x.ADVANCED;
    };
    var P = function P() {
        this.restoreGraphicsState(), g = "S", S = x.COMPAT;
    };
    var ir = function ir(t, e, r, n, i) {
        var a = new $cbf54afc98507811$export$549f717800d2b57f(e || this.boundingBox, r || this.xStep, n || this.yStep, this.gState, i || this.matrix);
        a.stream = this.stream;
        var o = t + "$$" + this.cloneIndex++ + "$$";
        return Jt(o, a), a;
    };
    var r, _$i = "string" == typeof arguments[0] ? arguments[0] : "p", o = arguments[1], s = arguments[2], c = arguments[3], u = [], d = 1, p = 16, g = "S", m = null;
    "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e = e || {}) && (_$i = e.orientation, o = e.unit || o, s = e.format || s, c = e.compress || e.compressPdf || c, null !== (m = e.encryption || null) && (m.userPassword = m.userPassword || "", m.ownerPassword = m.ownerPassword || "", m.userPermissions = m.userPermissions || []), d = "number" == typeof e.userUnit ? Math.abs(e.userUnit) : 1, void 0 !== e.precision && (r = e.precision), void 0 !== e.floatPrecision && (p = e.floatPrecision), g = e.defaultPathOperation || "S"), u = e.filters || (!0 === c ? [
        "FlateEncode"
    ] : u), o = o || "mm", _$i = ("" + (_$i || "P")).toLowerCase();
    var v = e.putOnlyUsedFonts || !1, b = {}, _$y = {
        internal: {},
        __private__: {}
    };
    _$y.__private__.PubSub = $cbf54afc98507811$var$C;
    var w = "1.3", N = _$y.__private__.getPdfVersion = function N() {
        return w;
    };
    _$y.__private__.setPdfVersion = function(t) {
        w = t;
    };
    var L = {
        a0: [
            2383.94,
            3370.39
        ],
        a1: [
            1683.78,
            2383.94
        ],
        a2: [
            1190.55,
            1683.78
        ],
        a3: [
            841.89,
            1190.55
        ],
        a4: [
            595.28,
            841.89
        ],
        a5: [
            419.53,
            595.28
        ],
        a6: [
            297.64,
            419.53
        ],
        a7: [
            209.76,
            297.64
        ],
        a8: [
            147.4,
            209.76
        ],
        a9: [
            104.88,
            147.4
        ],
        a10: [
            73.7,
            104.88
        ],
        b0: [
            2834.65,
            4008.19
        ],
        b1: [
            2004.09,
            2834.65
        ],
        b2: [
            1417.32,
            2004.09
        ],
        b3: [
            1000.63,
            1417.32
        ],
        b4: [
            708.66,
            1000.63
        ],
        b5: [
            498.9,
            708.66
        ],
        b6: [
            354.33,
            498.9
        ],
        b7: [
            249.45,
            354.33
        ],
        b8: [
            175.75,
            249.45
        ],
        b9: [
            124.72,
            175.75
        ],
        b10: [
            87.87,
            124.72
        ],
        c0: [
            2599.37,
            3676.54
        ],
        c1: [
            1836.85,
            2599.37
        ],
        c2: [
            1298.27,
            1836.85
        ],
        c3: [
            918.43,
            1298.27
        ],
        c4: [
            649.13,
            918.43
        ],
        c5: [
            459.21,
            649.13
        ],
        c6: [
            323.15,
            459.21
        ],
        c7: [
            229.61,
            323.15
        ],
        c8: [
            161.57,
            229.61
        ],
        c9: [
            113.39,
            161.57
        ],
        c10: [
            79.37,
            113.39
        ],
        dl: [
            311.81,
            623.62
        ],
        letter: [
            612,
            792
        ],
        "government-letter": [
            576,
            756
        ],
        legal: [
            612,
            1008
        ],
        "junior-legal": [
            576,
            360
        ],
        ledger: [
            1224,
            792
        ],
        tabloid: [
            792,
            1224
        ],
        "credit-card": [
            153,
            243
        ]
    };
    _$y.__private__.getPageFormats = function() {
        return L;
    };
    var A = _$y.__private__.getPageFormat = function A(t) {
        return L[t];
    };
    s = s || "a4";
    var x = {
        COMPAT: "compat",
        ADVANCED: "advanced"
    }, S = x.COMPAT;
    var k = _$y.__private__.combineFontStyleAndFontWeight = function k(t, e) {
        if ("bold" == t && "normal" == e || "bold" == t && 400 == e || "normal" == t && "italic" == e || "bold" == t && "italic" == e) throw new Error("Invalid Combination of fontweight and fontstyle");
        return e && (t = 400 == e || "normal" === e ? "italic" === t ? "italic" : "normal" : 700 != e && "bold" !== e || "normal" !== t ? (700 == e ? "bold" : e) + "" + t : "bold"), t;
    };
    _$y.advancedAPI = function(t) {
        var _$e = S === x.COMPAT;
        return _$e && _.call(this), "function" != typeof t || (t(this), _$e && P.call(this)), this;
    }, _$y.compatAPI = function(t) {
        var _$e = S === x.ADVANCED;
        return _$e && P.call(this), "function" != typeof t || (t(this), _$e && _.call(this)), this;
    }, _$y.isAdvancedAPI = function() {
        return S === x.ADVANCED;
    };
    var O, q = function q(t) {
        if (S !== x.ADVANCED) throw new Error(t + " is only available in 'advanced' API mode. You need to call advancedAPI() first.");
    }, D = _$y.roundToPrecision = _$y.__private__.roundToPrecision = function D(t, e) {
        var n = r || e;
        if (isNaN(t) || isNaN(n)) throw new Error("Invalid argument passed to jsPDF.roundToPrecision");
        return t.toFixed(n).replace(/0+$/, "");
    };
    O = _$y.hpf = _$y.__private__.hpf = "number" == typeof p ? function O(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, p);
    } : "smart" === p ? function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, t > -1 && t < 1 ? 16 : 5);
    } : function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.hpf");
        return D(t, 16);
    };
    var R = _$y.f2 = _$y.__private__.f2 = function R(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f2");
        return D(t, 2);
    }, T = _$y.__private__.f3 = function T(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.f3");
        return D(t, 3);
    }, U = _$y.scale = _$y.__private__.scale = function U(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.scale");
        return S === x.COMPAT ? t * _$_t : S === x.ADVANCED ? t : void 0;
    }, z = function z(t) {
        return S === x.COMPAT ? Rr() - t : S === x.ADVANCED ? t : void 0;
    }, H = function H(t) {
        return U(z(t));
    };
    _$y.__private__.setPrecision = _$y.setPrecision = function(t) {
        "number" == typeof parseInt(t, 10) && (r = parseInt(t, 10));
    };
    var W, V = "00000000000000000000000000000000", G = _$y.__private__.getFileId = function G() {
        return V;
    }, Y = _$y.__private__.setFileId = function Y(t) {
        return V = void 0 !== t && /^[a-fA-F0-9]{32}$/.test(t) ? t.toUpperCase() : V.split("").map(function() {
            return "ABCDEF0123456789".charAt(Math.floor(16 * Math.random()));
        }).join(""), null !== m && (Ye = new $cbf54afc98507811$var$I(m.userPermissions, m.userPassword, m.ownerPassword, V)), V;
    };
    _$y.setFileId = function(t) {
        return Y(t), this;
    }, _$y.getFileId = function() {
        return G();
    };
    var J = _$y.__private__.convertDateToPDFDate = function J(t) {
        var _$e = t.getTimezoneOffset(), r = _$e < 0 ? "+" : "-", n = Math.floor(Math.abs(_$e / 60)), _$i = Math.abs(_$e % 60), a = [
            r,
            Q(n),
            "'",
            Q(_$i),
            "'"
        ].join("");
        return [
            "D:",
            t.getFullYear(),
            Q(t.getMonth() + 1),
            Q(t.getDate()),
            Q(t.getHours()),
            Q(t.getMinutes()),
            Q(t.getSeconds()),
            a
        ].join("");
    }, X = _$y.__private__.convertPDFDateToDate = function X(t) {
        var _$e = parseInt(t.substr(2, 4), 10), r = parseInt(t.substr(6, 2), 10) - 1, n = parseInt(t.substr(8, 2), 10), _$i = parseInt(t.substr(10, 2), 10), a = parseInt(t.substr(12, 2), 10), o = parseInt(t.substr(14, 2), 10);
        return new Date(_$e, r, n, _$i, a, o, 0);
    }, K = _$y.__private__.setCreationDate = function K(t) {
        var _$e;
        if (void 0 === t && (t = new Date), t instanceof Date) _$e = J(t);
        else {
            if (!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t)) throw new Error("Invalid argument passed to jsPDF.setCreationDate");
            _$e = t;
        }
        return W = _$e;
    }, Z = _$y.__private__.getCreationDate = function Z(t) {
        var _$e = W;
        return "jsDate" === t && (_$e = X(W)), _$e;
    };
    _$y.setCreationDate = function(t) {
        return K(t), this;
    }, _$y.getCreationDate = function(t) {
        return Z(t);
    };
    var $, Q = _$y.__private__.padd2 = function Q(t) {
        return ("0" + parseInt(t)).slice(-2);
    }, tt = _$y.__private__.padd2Hex = function tt(t) {
        return ("00" + (t = t.toString())).substr(t.length);
    }, et = 0, rt = [], nt = [], it = 0, at = [], ot = [], st = !1, ct = nt, ut = function ut() {
        et = 0, it = 0, nt = [], rt = [], at = [], Qt = Kt(), _$te = Kt();
    };
    _$y.__private__.setCustomOutputDestination = function(t) {
        st = !0, ct = t;
    };
    var ht = function ht(t) {
        st || (ct = t);
    };
    _$y.__private__.resetCustomOutputDestination = function() {
        st = !1, ct = nt;
    };
    var lt = _$y.__private__.out = function lt(t) {
        return t = t.toString(), it += t.length + 1, ct.push(t), ct;
    }, ft = _$y.__private__.write = function ft(t) {
        return lt(1 === arguments.length ? t.toString() : Array.prototype.join.call(arguments, " "));
    }, dt = _$y.__private__.getArrayBuffer = function dt(t) {
        for(var _$e = t.length, r = new ArrayBuffer(_$e), n = new Uint8Array(r); _$e--;)n[_$e] = t.charCodeAt(_$e);
        return r;
    }, pt = [
        [
            "Helvetica",
            "helvetica",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Bold",
            "helvetica",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-Oblique",
            "helvetica",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Helvetica-BoldOblique",
            "helvetica",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Courier",
            "courier",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Bold",
            "courier",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Courier-Oblique",
            "courier",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Courier-BoldOblique",
            "courier",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "Times-Roman",
            "times",
            "normal",
            "WinAnsiEncoding"
        ],
        [
            "Times-Bold",
            "times",
            "bold",
            "WinAnsiEncoding"
        ],
        [
            "Times-Italic",
            "times",
            "italic",
            "WinAnsiEncoding"
        ],
        [
            "Times-BoldItalic",
            "times",
            "bolditalic",
            "WinAnsiEncoding"
        ],
        [
            "ZapfDingbats",
            "zapfdingbats",
            "normal",
            null
        ],
        [
            "Symbol",
            "symbol",
            "normal",
            null
        ]
    ];
    _$y.__private__.getStandardFonts = function() {
        return pt;
    };
    var gt = e.fontSize || 16;
    _$y.__private__.setFontSize = _$y.setFontSize = function(t) {
        return gt = S === x.ADVANCED ? t / _$_t : t, this;
    };
    var mt, vt = _$y.__private__.getFontSize = _$y.getFontSize = function vt() {
        return S === x.COMPAT ? gt : gt * _$_t;
    }, bt = e.R2L || !1;
    _$y.__private__.setR2L = _$y.setR2L = function(t) {
        return bt = t, this;
    }, _$y.__private__.getR2L = _$y.getR2L = function() {
        return bt;
    };
    var yt, wt = _$y.__private__.setZoomMode = function wt(t) {
        var _$e = [
            void 0,
            null,
            "fullwidth",
            "fullheight",
            "fullpage",
            "original"
        ];
        if (/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t)) mt = t;
        else if (isNaN(t)) {
            if (-1 === _$e.indexOf(t)) throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "' + t + '" is not recognized.');
            mt = t;
        } else mt = parseInt(t, 10);
    };
    _$y.__private__.getZoomMode = function() {
        return mt;
    };
    var Nt, Lt = _$y.__private__.setPageMode = function Lt(t) {
        if (-1 == [
            void 0,
            null,
            "UseNone",
            "UseOutlines",
            "UseThumbs",
            "FullScreen"
        ].indexOf(t)) throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "' + t + '" is not recognized.');
        yt = t;
    };
    _$y.__private__.getPageMode = function() {
        return yt;
    };
    var At = _$y.__private__.setLayoutMode = function At(t) {
        if (-1 == [
            void 0,
            null,
            "continuous",
            "single",
            "twoleft",
            "tworight",
            "two"
        ].indexOf(t)) throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "' + t + '" is not recognized.');
        Nt = t;
    };
    _$y.__private__.getLayoutMode = function() {
        return Nt;
    }, _$y.__private__.setDisplayMode = _$y.setDisplayMode = function(t, e, r) {
        return wt(t), At(e), Lt(r), this;
    };
    var xt = {
        title: "",
        subject: "",
        author: "",
        keywords: "",
        creator: ""
    };
    _$y.__private__.getDocumentProperty = function(t) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");
        return xt[t];
    }, _$y.__private__.getDocumentProperties = function() {
        return xt;
    }, _$y.__private__.setDocumentProperties = _$y.setProperties = _$y.setDocumentProperties = function(t) {
        for(var _$e in xt)xt.hasOwnProperty(_$e) && t[_$e] && (xt[_$e] = t[_$e]);
        return this;
    }, _$y.__private__.setDocumentProperty = function(t, e) {
        if (-1 === Object.keys(xt).indexOf(t)) throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");
        return xt[t] = e;
    };
    var St, _$_t, Pt, kt, It, Ft = {}, Ct = {}, jt = [], Ot = {}, Bt = {}, Mt = {}, Et = {}, qt = null, Dt = 0, Rt = [], Tt = new $cbf54afc98507811$var$C(_$y), Ut = e.hotfixes || [], zt = {}, Ht = {}, Wt = [], Vt = function t(e, r, n, i, a, o) {
        if (!(this instanceof t)) return new t(e, r, n, i, a, o);
        isNaN(e) && (e = 1), isNaN(r) && (r = 0), isNaN(n) && (n = 0), isNaN(i) && (i = 1), isNaN(a) && (a = 0), isNaN(o) && (o = 0), this._matrix = [
            e,
            r,
            n,
            i,
            a,
            o
        ];
    };
    Object.defineProperty(Vt.prototype, "sx", {
        get: function get() {
            return this._matrix[0];
        },
        set: function set(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shy", {
        get: function get() {
            return this._matrix[1];
        },
        set: function set(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "shx", {
        get: function get() {
            return this._matrix[2];
        },
        set: function set(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "sy", {
        get: function get() {
            return this._matrix[3];
        },
        set: function set(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "tx", {
        get: function get() {
            return this._matrix[4];
        },
        set: function set(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "ty", {
        get: function get() {
            return this._matrix[5];
        },
        set: function set(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "a", {
        get: function get() {
            return this._matrix[0];
        },
        set: function set(t) {
            this._matrix[0] = t;
        }
    }), Object.defineProperty(Vt.prototype, "b", {
        get: function get() {
            return this._matrix[1];
        },
        set: function set(t) {
            this._matrix[1] = t;
        }
    }), Object.defineProperty(Vt.prototype, "c", {
        get: function get() {
            return this._matrix[2];
        },
        set: function set(t) {
            this._matrix[2] = t;
        }
    }), Object.defineProperty(Vt.prototype, "d", {
        get: function get() {
            return this._matrix[3];
        },
        set: function set(t) {
            this._matrix[3] = t;
        }
    }), Object.defineProperty(Vt.prototype, "e", {
        get: function get() {
            return this._matrix[4];
        },
        set: function set(t) {
            this._matrix[4] = t;
        }
    }), Object.defineProperty(Vt.prototype, "f", {
        get: function get() {
            return this._matrix[5];
        },
        set: function set(t) {
            this._matrix[5] = t;
        }
    }), Object.defineProperty(Vt.prototype, "rotation", {
        get: function get() {
            return Math.atan2(this.shx, this.sx);
        }
    }), Object.defineProperty(Vt.prototype, "scaleX", {
        get: function get() {
            return this.decompose().scale.sx;
        }
    }), Object.defineProperty(Vt.prototype, "scaleY", {
        get: function get() {
            return this.decompose().scale.sy;
        }
    }), Object.defineProperty(Vt.prototype, "isIdentity", {
        get: function get() {
            return 1 === this.sx && 0 === this.shy && 0 === this.shx && 1 === this.sy && 0 === this.tx && 0 === this.ty;
        }
    }), Vt.prototype.join = function(t) {
        return [
            this.sx,
            this.shy,
            this.shx,
            this.sy,
            this.tx,
            this.ty
        ].map(O).join(t);
    }, Vt.prototype.multiply = function(t) {
        var _$e = t.sx * this.sx + t.shy * this.shx, r = t.sx * this.shy + t.shy * this.sy, n = t.shx * this.sx + t.sy * this.shx, _$i = t.shx * this.shy + t.sy * this.sy, a = t.tx * this.sx + t.ty * this.shx + this.tx, o = t.tx * this.shy + t.ty * this.sy + this.ty;
        return new Vt(_$e, r, n, _$i, a, o);
    }, Vt.prototype.decompose = function() {
        var _$t = this.sx, _$e = this.shy, r = this.shx, n = this.sy, _$i = this.tx, a = this.ty, o = Math.sqrt(_$t * _$t + _$e * _$e), s = (_$t /= o) * r + (_$e /= o) * n;
        r -= _$t * s, n -= _$e * s;
        var c = Math.sqrt(r * r + n * n);
        return s /= c, _$t * (n /= c) < _$e * (r /= c) && (_$t = -_$t, _$e = -_$e, s = -s, o = -o), {
            scale: new Vt(o, 0, 0, c, 0, 0),
            translate: new Vt(1, 0, 0, 1, _$i, a),
            rotate: new Vt(_$t, _$e, -_$e, _$t, 0, 0),
            skew: new Vt(1, 0, s, 1, 0, 0)
        };
    }, Vt.prototype.toString = function(t) {
        return this.join(" ");
    }, Vt.prototype.inversed = function() {
        var _$t = this.sx, _$e = this.shy, r = this.shx, n = this.sy, _$i = this.tx, a = this.ty, o = 1 / (_$t * n - _$e * r), s = n * o, c = -_$e * o, u = -r * o, h = _$t * o;
        return new Vt(s, c, u, h, -s * _$i - u * a, -c * _$i - h * a);
    }, Vt.prototype.applyToPoint = function(t) {
        var _$e = t.x * this.sx + t.y * this.shx + this.tx, r = t.x * this.shy + t.y * this.sy + this.ty;
        return new Cr(_$e, r);
    }, Vt.prototype.applyToRectangle = function(t) {
        var _$e = this.applyToPoint(t), r = this.applyToPoint(new Cr(t.x + t.w, t.y + t.h));
        return new jr(_$e.x, _$e.y, r.x - _$e.x, r.y - _$e.y);
    }, Vt.prototype.clone = function() {
        var _$t = this.sx, _$e = this.shy, r = this.shx, n = this.sy, _$i = this.tx, a = this.ty;
        return new Vt(_$t, _$e, r, n, _$i, a);
    }, _$y.Matrix = Vt;
    var Gt = _$y.matrixMult = function Gt(t, e) {
        return e.multiply(t);
    }, Yt = new Vt(1, 0, 0, 1, 0, 0);
    _$y.unitMatrix = _$y.identityMatrix = Yt;
    var Jt = function Jt(t, e) {
        if (!Bt[t]) {
            var r = (e instanceof $cbf54afc98507811$export$7235f0ad083cb4c6 ? "Sh" : "P") + (Object.keys(Ot).length + 1).toString(10);
            e.id = r, Bt[t] = r, Ot[r] = e, Tt.publish("addPattern", e);
        }
    };
    _$y.ShadingPattern = $cbf54afc98507811$export$7235f0ad083cb4c6, _$y.TilingPattern = $cbf54afc98507811$export$549f717800d2b57f, _$y.addShadingPattern = function(t, e) {
        return q("addShadingPattern()"), Jt(t, e), this;
    }, _$y.beginTilingPattern = function(t) {
        q("beginTilingPattern()"), Br(t.boundingBox[0], t.boundingBox[1], t.boundingBox[2] - t.boundingBox[0], t.boundingBox[3] - t.boundingBox[1], t.matrix);
    }, _$y.endTilingPattern = function(t, e) {
        q("endTilingPattern()"), e.stream = ot[$].join("\n"), Jt(t, e), Tt.publish("endTilingPattern", e), Wt.pop().restore();
    };
    var Xt = _$y.__private__.newObject = function Xt() {
        var _$t = Kt();
        return Zt(_$t, !0), _$t;
    }, Kt = _$y.__private__.newObjectDeferred = function Kt() {
        return et++, rt[et] = function() {
            return it;
        }, et;
    }, Zt = function Zt(t, e) {
        return e = "boolean" == typeof e && e, rt[t] = it, e && lt(t + " 0 obj"), t;
    }, $t = _$y.__private__.newAdditionalObject = function $t() {
        var _$t = {
            objId: Kt(),
            content: ""
        };
        return at.push(_$t), _$t;
    }, Qt = Kt(), _$te = Kt(), _$ee = _$y.__private__.decodeColorString = function ee(t) {
        var _$e = t.split(" ");
        if (2 !== _$e.length || "g" !== _$e[1] && "G" !== _$e[1]) {
            if (5 === _$e.length && ("k" === _$e[4] || "K" === _$e[4])) _$e = [
                (1 - _$e[0]) * (1 - _$e[3]),
                (1 - _$e[1]) * (1 - _$e[3]),
                (1 - _$e[2]) * (1 - _$e[3]),
                "r"
            ];
        } else {
            var r = parseFloat(_$e[0]);
            _$e = [
                r,
                r,
                r,
                "r"
            ];
        }
        for(var n = "#", _$i = 0; _$i < 3; _$i++)n += ("0" + Math.floor(255 * parseFloat(_$e[_$i])).toString(16)).slice(-2);
        return n;
    }, re = _$y.__private__.encodeColorString = function re(e) {
        var r;
        "string" == typeof e && (e = {
            ch1: e
        });
        var n = e.ch1, _$i = e.ch2, a = e.ch3, o = e.ch4, s = "draw" === e.pdfColorType ? [
            "G",
            "RG",
            "K"
        ] : [
            "g",
            "rg",
            "k"
        ];
        if ("string" == typeof n && "#" !== n.charAt(0)) {
            var c = new $cbf54afc98507811$var$f(n);
            if (c.ok) n = c.toHex();
            else if (!/^\d*\.?\d*$/.test(n)) throw new Error('Invalid color "' + n + '" passed to jsPDF.encodeColorString.');
        }
        if ("string" == typeof n && /^#[0-9A-Fa-f]{3}$/.test(n) && (n = "#" + n[1] + n[1] + n[2] + n[2] + n[3] + n[3]), "string" == typeof n && /^#[0-9A-Fa-f]{6}$/.test(n)) {
            var u = parseInt(n.substr(1), 16);
            n = u >> 16 & 255, _$i = u >> 8 & 255, a = 255 & u;
        }
        if (void 0 === _$i || void 0 === o && n === _$i && _$i === a) {
            if ("string" == typeof n) r = n + " " + s[0];
            else switch(e.precision){
                case 2:
                    r = R(n / 255) + " " + s[0];
                    break;
                case 3:
                default:
                    r = T(n / 255) + " " + s[0];
            }
        } else if (void 0 === o || "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(o)) {
            if (o && !isNaN(o.a) && 0 === o.a) return r = [
                "1.",
                "1.",
                "1.",
                s[1]
            ].join(" ");
            if ("string" == typeof n) r = [
                n,
                _$i,
                a,
                s[1]
            ].join(" ");
            else switch(e.precision){
                case 2:
                    r = [
                        R(n / 255),
                        R(_$i / 255),
                        R(a / 255),
                        s[1]
                    ].join(" ");
                    break;
                default:
                case 3:
                    r = [
                        T(n / 255),
                        T(_$i / 255),
                        T(a / 255),
                        s[1]
                    ].join(" ");
            }
        } else if ("string" == typeof n) r = [
            n,
            _$i,
            a,
            o,
            s[2]
        ].join(" ");
        else switch(e.precision){
            case 2:
                r = [
                    R(n),
                    R(_$i),
                    R(a),
                    R(o),
                    s[2]
                ].join(" ");
                break;
            case 3:
            default:
                r = [
                    T(n),
                    T(_$i),
                    T(a),
                    T(o),
                    s[2]
                ].join(" ");
        }
        return r;
    }, ne = _$y.__private__.getFilters = function ne() {
        return u;
    }, ie = _$y.__private__.putStream = function ie(t) {
        var _$e = (t = t || {}).data || "", r = t.filters || ne(), n = t.alreadyAppliedFilters || [], _$i = t.addLength1 || !1, a = _$e.length, o = t.objectId, s = function s(t) {
            return t;
        };
        if (null !== m && void 0 === o) throw new Error("ObjectId must be passed to putStream for file encryption");
        null !== m && (s = Ye.encryptor(o, 0));
        var c = {};
        !0 === r && (r = [
            "FlateEncode"
        ]);
        var u = t.additionalKeyValues || [], h = (c = void 0 !== $cbf54afc98507811$export$ba1e2ffc633a60f5.API.processDataByFilters ? $cbf54afc98507811$export$ba1e2ffc633a60f5.API.processDataByFilters(_$e, r) : {
            data: _$e,
            reverseChain: []
        }).reverseChain + (Array.isArray(n) ? n.join(" ") : n.toString());
        if (0 !== c.data.length && (u.push({
            key: "Length",
            value: c.data.length
        }), !0 === _$i && u.push({
            key: "Length1",
            value: a
        })), 0 != h.length) {
            if (h.split("/").length - 1 == 1) u.push({
                key: "Filter",
                value: h
            });
            else {
                u.push({
                    key: "Filter",
                    value: "[" + h + "]"
                });
                for(var l = 0; l < u.length; l += 1)if ("DecodeParms" === u[l].key) {
                    for(var f = [], d = 0; d < c.reverseChain.split("/").length - 1; d += 1)f.push("null");
                    f.push(u[l].value), u[l].value = "[" + f.join(" ") + "]";
                }
            }
        }
        lt("<<");
        for(var p = 0; p < u.length; p++)lt("/" + u[p].key + " " + u[p].value);
        lt(">>"), 0 !== c.data.length && (lt("stream"), lt(s(c.data)), lt("endstream"));
    }, ae = _$y.__private__.putPage = function ae(t) {
        var _$e = t.number, r = t.data, n = t.objId, _$i = t.contentsObjId;
        Zt(n, !0), lt("<</Type /Page"), lt("/Parent " + t.rootDictionaryObjId + " 0 R"), lt("/Resources " + t.resourceDictionaryObjId + " 0 R"), lt("/MediaBox [" + parseFloat(O(t.mediaBox.bottomLeftX)) + " " + parseFloat(O(t.mediaBox.bottomLeftY)) + " " + O(t.mediaBox.topRightX) + " " + O(t.mediaBox.topRightY) + "]"), null !== t.cropBox && lt("/CropBox [" + O(t.cropBox.bottomLeftX) + " " + O(t.cropBox.bottomLeftY) + " " + O(t.cropBox.topRightX) + " " + O(t.cropBox.topRightY) + "]"), null !== t.bleedBox && lt("/BleedBox [" + O(t.bleedBox.bottomLeftX) + " " + O(t.bleedBox.bottomLeftY) + " " + O(t.bleedBox.topRightX) + " " + O(t.bleedBox.topRightY) + "]"), null !== t.trimBox && lt("/TrimBox [" + O(t.trimBox.bottomLeftX) + " " + O(t.trimBox.bottomLeftY) + " " + O(t.trimBox.topRightX) + " " + O(t.trimBox.topRightY) + "]"), null !== t.artBox && lt("/ArtBox [" + O(t.artBox.bottomLeftX) + " " + O(t.artBox.bottomLeftY) + " " + O(t.artBox.topRightX) + " " + O(t.artBox.topRightY) + "]"), "number" == typeof t.userUnit && 1 !== t.userUnit && lt("/UserUnit " + t.userUnit), Tt.publish("putPage", {
            objId: n,
            pageContext: Rt[_$e],
            pageNumber: _$e,
            page: r
        }), lt("/Contents " + _$i + " 0 R"), lt(">>"), lt("endobj");
        var a = r.join("\n");
        return S === x.ADVANCED && (a += "\nQ"), Zt(_$i, !0), ie({
            data: a,
            filters: ne(),
            objectId: _$i
        }), lt("endobj"), n;
    }, oe = _$y.__private__.putPages = function oe() {
        var _$t, _$e, r = [];
        for(_$t = 1; _$t <= Dt; _$t++)Rt[_$t].objId = Kt(), Rt[_$t].contentsObjId = Kt();
        for(_$t = 1; _$t <= Dt; _$t++)r.push(ae({
            number: _$t,
            data: ot[_$t],
            objId: Rt[_$t].objId,
            contentsObjId: Rt[_$t].contentsObjId,
            mediaBox: Rt[_$t].mediaBox,
            cropBox: Rt[_$t].cropBox,
            bleedBox: Rt[_$t].bleedBox,
            trimBox: Rt[_$t].trimBox,
            artBox: Rt[_$t].artBox,
            userUnit: Rt[_$t].userUnit,
            rootDictionaryObjId: Qt,
            resourceDictionaryObjId: _$te
        }));
        Zt(Qt, !0), lt("<</Type /Pages");
        var n = "/Kids [";
        for(_$e = 0; _$e < Dt; _$e++)n += r[_$e] + " 0 R ";
        lt(n + "]"), lt("/Count " + Dt), lt(">>"), lt("endobj"), Tt.publish("postPutPages");
    }, se = function se(t) {
        Tt.publish("putFont", {
            font: t,
            out: lt,
            newObject: Xt,
            putStream: ie
        }), !0 !== t.isAlreadyPutted && (t.objectNumber = Xt(), lt("<<"), lt("/Type /Font"), lt("/BaseFont /" + $cbf54afc98507811$var$F(t.postScriptName)), lt("/Subtype /Type1"), "string" == typeof t.encoding && lt("/Encoding /" + t.encoding), lt("/FirstChar 32"), lt("/LastChar 255"), lt(">>"), lt("endobj"));
    }, ce = function ce() {
        for(var _$t in Ft)Ft.hasOwnProperty(_$t) && (!1 === v || !0 === v && b.hasOwnProperty(_$t)) && se(Ft[_$t]);
    }, ue = function ue(t) {
        t.objectNumber = Xt();
        var _$e = [];
        _$e.push({
            key: "Type",
            value: "/XObject"
        }), _$e.push({
            key: "Subtype",
            value: "/Form"
        }), _$e.push({
            key: "BBox",
            value: "[" + [
                O(t.x),
                O(t.y),
                O(t.x + t.width),
                O(t.y + t.height)
            ].join(" ") + "]"
        }), _$e.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        });
        var r = t.pages[1].join("\n");
        ie({
            data: r,
            additionalKeyValues: _$e,
            objectId: t.objectNumber
        }), lt("endobj");
    }, he = function he() {
        for(var _$t in zt)zt.hasOwnProperty(_$t) && ue(zt[_$t]);
    }, le = function le(t, e) {
        var r, n = [], _$i = 1 / (e - 1);
        for(r = 0; r < 1; r += _$i)n.push(r);
        if (n.push(1), 0 != t[0].offset) {
            var a = {
                offset: 0,
                color: t[0].color
            };
            t.unshift(a);
        }
        if (1 != t[t.length - 1].offset) {
            var o = {
                offset: 1,
                color: t[t.length - 1].color
            };
            t.push(o);
        }
        for(var s = "", c = 0, u = 0; u < n.length; u++){
            for(r = n[u]; r > t[c + 1].offset;)c++;
            var h = t[c].offset, l = (r - h) / (t[c + 1].offset - h), f = t[c].color, d = t[c + 1].color;
            s += tt(Math.round((1 - l) * f[0] + l * d[0]).toString(16)) + tt(Math.round((1 - l) * f[1] + l * d[1]).toString(16)) + tt(Math.round((1 - l) * f[2] + l * d[2]).toString(16));
        }
        return s.trim();
    }, fe = function fe(t, e) {
        e || (e = 21);
        var r = Xt(), n = le(t.colors, e), _$i = [];
        _$i.push({
            key: "FunctionType",
            value: "0"
        }), _$i.push({
            key: "Domain",
            value: "[0.0 1.0]"
        }), _$i.push({
            key: "Size",
            value: "[" + e + "]"
        }), _$i.push({
            key: "BitsPerSample",
            value: "8"
        }), _$i.push({
            key: "Range",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), _$i.push({
            key: "Decode",
            value: "[0.0 1.0 0.0 1.0 0.0 1.0]"
        }), ie({
            data: n,
            additionalKeyValues: _$i,
            alreadyAppliedFilters: [
                "/ASCIIHexDecode"
            ],
            objectId: r
        }), lt("endobj"), t.objectNumber = Xt(), lt("<< /ShadingType " + t.type), lt("/ColorSpace /DeviceRGB");
        var a = "/Coords [" + O(parseFloat(t.coords[0])) + " " + O(parseFloat(t.coords[1])) + " ";
        2 === t.type ? a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) : a += O(parseFloat(t.coords[2])) + " " + O(parseFloat(t.coords[3])) + " " + O(parseFloat(t.coords[4])) + " " + O(parseFloat(t.coords[5])), lt(a += "]"), t.matrix && lt("/Matrix [" + t.matrix.toString() + "]"), lt("/Function " + r + " 0 R"), lt("/Extend [true true]"), lt(">>"), lt("endobj");
    }, de = function de(t, e) {
        var r = Kt(), n = Xt();
        e.push({
            resourcesOid: r,
            objectOid: n
        }), t.objectNumber = n;
        var _$i = [];
        _$i.push({
            key: "Type",
            value: "/Pattern"
        }), _$i.push({
            key: "PatternType",
            value: "1"
        }), _$i.push({
            key: "PaintType",
            value: "1"
        }), _$i.push({
            key: "TilingType",
            value: "1"
        }), _$i.push({
            key: "BBox",
            value: "[" + t.boundingBox.map(O).join(" ") + "]"
        }), _$i.push({
            key: "XStep",
            value: O(t.xStep)
        }), _$i.push({
            key: "YStep",
            value: O(t.yStep)
        }), _$i.push({
            key: "Resources",
            value: r + " 0 R"
        }), t.matrix && _$i.push({
            key: "Matrix",
            value: "[" + t.matrix.toString() + "]"
        }), ie({
            data: t.stream,
            additionalKeyValues: _$i,
            objectId: t.objectNumber
        }), lt("endobj");
    }, pe = function pe(t) {
        var _$e;
        for(_$e in Ot)Ot.hasOwnProperty(_$e) && (Ot[_$e] instanceof $cbf54afc98507811$export$7235f0ad083cb4c6 ? fe(Ot[_$e]) : Ot[_$e] instanceof $cbf54afc98507811$export$549f717800d2b57f && de(Ot[_$e], t));
    }, ge = function ge(t) {
        for(var _$e in t.objectNumber = Xt(), lt("<<"), t)switch(_$e){
            case "opacity":
                lt("/ca " + R(t[_$e]));
                break;
            case "stroke-opacity":
                lt("/CA " + R(t[_$e]));
        }
        lt(">>"), lt("endobj");
    }, me = function me() {
        var _$t;
        for(_$t in Mt)Mt.hasOwnProperty(_$t) && ge(Mt[_$t]);
    }, ve = function ve() {
        for(var _$t in lt("/XObject <<"), zt)zt.hasOwnProperty(_$t) && zt[_$t].objectNumber >= 0 && lt("/" + _$t + " " + zt[_$t].objectNumber + " 0 R");
        Tt.publish("putXobjectDict"), lt(">>");
    }, be = function be() {
        Ye.oid = Xt(), lt("<<"), lt("/Filter /Standard"), lt("/V " + Ye.v), lt("/R " + Ye.r), lt("/U <" + Ye.toHexString(Ye.U) + ">"), lt("/O <" + Ye.toHexString(Ye.O) + ">"), lt("/P " + Ye.P), lt(">>"), lt("endobj");
    }, ye = function ye() {
        for(var _$t in lt("/Font <<"), Ft)Ft.hasOwnProperty(_$t) && (!1 === v || !0 === v && b.hasOwnProperty(_$t)) && lt("/" + _$t + " " + Ft[_$t].objectNumber + " 0 R");
        lt(">>");
    }, we = function we() {
        if (Object.keys(Ot).length > 0) {
            for(var _$t in lt("/Shading <<"), Ot)Ot.hasOwnProperty(_$t) && Ot[_$t] instanceof $cbf54afc98507811$export$7235f0ad083cb4c6 && Ot[_$t].objectNumber >= 0 && lt("/" + _$t + " " + Ot[_$t].objectNumber + " 0 R");
            Tt.publish("putShadingPatternDict"), lt(">>");
        }
    }, Ne = function Ne(t) {
        if (Object.keys(Ot).length > 0) {
            for(var _$e in lt("/Pattern <<"), Ot)Ot.hasOwnProperty(_$e) && Ot[_$e] instanceof _$y.TilingPattern && Ot[_$e].objectNumber >= 0 && Ot[_$e].objectNumber < t && lt("/" + _$e + " " + Ot[_$e].objectNumber + " 0 R");
            Tt.publish("putTilingPatternDict"), lt(">>");
        }
    }, Le = function Le() {
        if (Object.keys(Mt).length > 0) {
            var _$t;
            for(_$t in lt("/ExtGState <<"), Mt)Mt.hasOwnProperty(_$t) && Mt[_$t].objectNumber >= 0 && lt("/" + _$t + " " + Mt[_$t].objectNumber + " 0 R");
            Tt.publish("putGStateDict"), lt(">>");
        }
    }, Ae = function Ae(t) {
        Zt(t.resourcesOid, !0), lt("<<"), lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"), ye(), we(), Ne(t.objectOid), Le(), ve(), lt(">>"), lt("endobj");
    }, xe = function xe() {
        var _$t = [];
        ce(), me(), he(), pe(_$t), Tt.publish("putResources"), _$t.forEach(Ae), Ae({
            resourcesOid: _$te,
            objectOid: Number.MAX_SAFE_INTEGER
        }), Tt.publish("postPutResources");
    }, Se = function Se() {
        Tt.publish("putAdditionalObjects");
        for(var _$t = 0; _$t < at.length; _$t++){
            var _$e = at[_$t];
            Zt(_$e.objId, !0), lt(_$e.content), lt("endobj");
        }
        Tt.publish("postPutAdditionalObjects");
    }, _e = function _e(t) {
        Ct[t.fontName] = Ct[t.fontName] || {}, Ct[t.fontName][t.fontStyle] = t.id;
    }, Pe = function Pe(t, e, r, n, i) {
        var a = {
            id: "F" + (Object.keys(Ft).length + 1).toString(10),
            postScriptName: t,
            fontName: e,
            fontStyle: r,
            encoding: n,
            isStandardFont: i || !1,
            metadata: {}
        };
        return Tt.publish("addFont", {
            font: a,
            instance: this
        }), Ft[a.id] = a, _e(a), a.id;
    }, ke = function ke(t) {
        for(var _$e = 0, r = pt.length; _$e < r; _$e++){
            var n = Pe.call(this, t[_$e][0], t[_$e][1], t[_$e][2], pt[_$e][3], !0);
            !1 === v && (b[n] = !0);
            var _$i = t[_$e][0].split("-");
            _e({
                id: n,
                fontName: _$i[0],
                fontStyle: _$i[1] || ""
            });
        }
        Tt.publish("addFonts", {
            fonts: Ft,
            dictionary: Ct
        });
    }, Ie = function Ie(t) {
        return t.foo = function() {
            try {
                return t.apply(this, arguments);
            } catch (t) {
                var _$e = t.stack || "";
                ~_$e.indexOf(" at ") && (_$e = _$e.split(" at ")[1]);
                var r = "Error in function " + _$e.split("\n")[0].split("<")[0] + ": " + t.message;
                if (!$cbf54afc98507811$var$n.console) throw new Error(r);
                $cbf54afc98507811$var$n.console.error(r, t), $cbf54afc98507811$var$n.alert && alert(r);
            }
        }, t.foo.bar = t, t.foo;
    }, Fe = function Fe(t, e) {
        var r, n, _$i, a, o, s, c, u, h;
        if (_$i = (e = e || {}).sourceEncoding || "Unicode", o = e.outputEncoding, (e.autoencode || o) && Ft[St].metadata && Ft[St].metadata[_$i] && Ft[St].metadata[_$i].encoding && (a = Ft[St].metadata[_$i].encoding, !o && Ft[St].encoding && (o = Ft[St].encoding), !o && a.codePages && (o = a.codePages[0]), "string" == typeof o && (o = a[o]), o)) {
            for(c = !1, s = [], r = 0, n = t.length; r < n; r++)(u = o[t.charCodeAt(r)]) ? s.push(String.fromCharCode(u)) : s.push(t[r]), s[r].charCodeAt(0) >> 8 && (c = !0);
            t = s.join("");
        }
        for(r = t.length; void 0 === c && 0 !== r;)t.charCodeAt(r - 1) >> 8 && (c = !0), r--;
        if (!c) return t;
        for(s = e.noBOM ? [] : [
            254,
            255
        ], r = 0, n = t.length; r < n; r++){
            if ((h = (u = t.charCodeAt(r)) >> 8) >> 8) throw new Error("Character at position " + r + " of string '" + t + "' exceeds 16bits. Cannot be encoded into UCS-2 BE");
            s.push(h), s.push(u - (h << 8));
        }
        return String.fromCharCode.apply(void 0, s);
    }, Ce = _$y.__private__.pdfEscape = _$y.pdfEscape = function Ce(t, e) {
        return Fe(t, e).replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
    }, je = _$y.__private__.beginPage = function je(t) {
        ot[++Dt] = [], Rt[Dt] = {
            objId: 0,
            contentsObjId: 0,
            userUnit: Number(d),
            artBox: null,
            bleedBox: null,
            cropBox: null,
            trimBox: null,
            mediaBox: {
                bottomLeftX: 0,
                bottomLeftY: 0,
                topRightX: Number(t[0]),
                topRightY: Number(t[1])
            }
        }, Me(Dt), ht(ot[$]);
    }, Oe = function Oe(t, e) {
        var r, n, o;
        switch(_$i = e || _$i, "string" == typeof t && (r = A(t.toLowerCase()), Array.isArray(r) && (n = r[0], o = r[1])), Array.isArray(t) && (n = t[0] * _$_t, o = t[1] * _$_t), isNaN(n) && (n = s[0], o = s[1]), (n > 14400 || o > 14400) && ($cbf54afc98507811$var$a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"), n = Math.min(14400, n), o = Math.min(14400, o)), s = [
            n,
            o
        ], _$i.substr(0, 1)){
            case "l":
                o > n && (s = [
                    o,
                    n
                ]);
                break;
            case "p":
                n > o && (s = [
                    o,
                    n
                ]);
        }
        je(s), pr(fr), lt(Lr), 0 !== kr && lt(kr + " J"), 0 !== Ir && lt(Ir + " j"), Tt.publish("addPage", {
            pageNumber: Dt
        });
    }, Be = function Be(t) {
        t > 0 && t <= Dt && (ot.splice(t, 1), Rt.splice(t, 1), Dt--, $ > Dt && ($ = Dt), this.setPage($));
    }, Me = function Me(t) {
        t > 0 && t <= Dt && ($ = t);
    }, Ee = _$y.__private__.getNumberOfPages = _$y.getNumberOfPages = function Ee() {
        return ot.length - 1;
    }, qe = function qe(t, e, r) {
        var n, _$i = void 0;
        return r = r || {}, t = void 0 !== t ? t : Ft[St].fontName, e = void 0 !== e ? e : Ft[St].fontStyle, n = t.toLowerCase(), void 0 !== Ct[n] && void 0 !== Ct[n][e] ? _$i = Ct[n][e] : void 0 !== Ct[t] && void 0 !== Ct[t][e] ? _$i = Ct[t][e] : !1 === r.disableWarning && $cbf54afc98507811$var$a.warn("Unable to look up font label for font '" + t + "', '" + e + "'. Refer to getFontList() for available fonts."), _$i || r.noFallback || null == (_$i = Ct.times[e]) && (_$i = Ct.times.normal), _$i;
    }, De = _$y.__private__.putInfo = function De() {
        var _$t = Xt(), _$e = function e(t) {
            return t;
        };
        for(var r in null !== m && (_$e = Ye.encryptor(_$t, 0)), lt("<<"), lt("/Producer (" + Ce(_$e("jsPDF " + $cbf54afc98507811$export$ba1e2ffc633a60f5.version)) + ")"), xt)xt.hasOwnProperty(r) && xt[r] && lt("/" + r.substr(0, 1).toUpperCase() + r.substr(1) + " (" + Ce(_$e(xt[r])) + ")");
        lt("/CreationDate (" + Ce(_$e(W)) + ")"), lt(">>"), lt("endobj");
    }, Re = _$y.__private__.putCatalog = function Re(t) {
        var _$e = (t = t || {}).rootDictionaryObjId || Qt;
        switch(Xt(), lt("<<"), lt("/Type /Catalog"), lt("/Pages " + _$e + " 0 R"), mt || (mt = "fullwidth"), mt){
            case "fullwidth":
                lt("/OpenAction [3 0 R /FitH null]");
                break;
            case "fullheight":
                lt("/OpenAction [3 0 R /FitV null]");
                break;
            case "fullpage":
                lt("/OpenAction [3 0 R /Fit]");
                break;
            case "original":
                lt("/OpenAction [3 0 R /XYZ null null 1]");
                break;
            default:
                var r = "" + mt;
                "%" === r.substr(r.length - 1) && (mt = parseInt(mt) / 100), "number" == typeof mt && lt("/OpenAction [3 0 R /XYZ null null " + R(mt) + "]");
        }
        switch(Nt || (Nt = "continuous"), Nt){
            case "continuous":
                lt("/PageLayout /OneColumn");
                break;
            case "single":
                lt("/PageLayout /SinglePage");
                break;
            case "two":
            case "twoleft":
                lt("/PageLayout /TwoColumnLeft");
                break;
            case "tworight":
                lt("/PageLayout /TwoColumnRight");
        }
        yt && lt("/PageMode /" + yt), Tt.publish("putCatalog"), lt(">>"), lt("endobj");
    }, Te = _$y.__private__.putTrailer = function Te() {
        lt("trailer"), lt("<<"), lt("/Size " + (et + 1)), lt("/Root " + et + " 0 R"), lt("/Info " + (et - 1) + " 0 R"), null !== m && lt("/Encrypt " + Ye.oid + " 0 R"), lt("/ID [ <" + V + "> <" + V + "> ]"), lt(">>");
    }, Ue = _$y.__private__.putHeader = function Ue() {
        lt("%PDF-" + w), lt("%\xba\xdf\xac\xe0");
    }, ze = _$y.__private__.putXRef = function ze() {
        var _$t = "0000000000";
        lt("xref"), lt("0 " + (et + 1)), lt("0000000000 65535 f ");
        for(var _$e = 1; _$e <= et; _$e++)"function" == typeof rt[_$e] ? lt((_$t + rt[_$e]()).slice(-10) + " 00000 n ") : void 0 !== rt[_$e] ? lt((_$t + rt[_$e]).slice(-10) + " 00000 n ") : lt("0000000000 00000 n ");
    }, He = _$y.__private__.buildDocument = function He() {
        ut(), ht(nt), Tt.publish("buildDocument"), Ue(), oe(), Se(), xe(), null !== m && be(), De(), Re();
        var _$t = it;
        return ze(), Te(), lt("startxref"), lt("" + _$t), lt("%%EOF"), ht(ot[$]), nt.join("\n");
    }, We = _$y.__private__.getBlob = function We(t) {
        return new Blob([
            dt(t)
        ], {
            type: "application/pdf"
        });
    }, Ve = _$y.output = _$y.__private__.output = Ie(function(t, e) {
        switch("string" == typeof (e = e || {}) ? e = {
            filename: e
        } : e.filename = e.filename || "generated.pdf", t){
            case void 0:
                return He();
            case "save":
                _$y.save(e.filename);
                break;
            case "arraybuffer":
                return dt(He());
            case "blob":
                return We(He());
            case "bloburi":
            case "bloburl":
                if (void 0 !== $cbf54afc98507811$var$n.URL && "function" == typeof $cbf54afc98507811$var$n.URL.createObjectURL) return $cbf54afc98507811$var$n.URL && $cbf54afc98507811$var$n.URL.createObjectURL(We(He())) || void 0;
                $cbf54afc98507811$var$a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");
                break;
            case "datauristring":
            case "dataurlstring":
                var r = "", _$i = He();
                try {
                    r = $cbf54afc98507811$var$h(_$i);
                } catch (t) {
                    r = $cbf54afc98507811$var$h(unescape(encodeURIComponent(_$i)));
                }
                return "data:application/pdf;filename=" + e.filename + ";base64," + r;
            case "pdfobjectnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($cbf54afc98507811$var$n)) {
                    var o = "https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js", s = ' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';
                    e.pdfObjectUrl && (o = e.pdfObjectUrl, s = "");
                    var c = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="' + o + '"' + s + '></script><script >PDFObject.embed("' + this.output("dataurlstring") + '", ' + JSON.stringify(e) + ");</script></body></html>", u = $cbf54afc98507811$var$n.open();
                    return null !== u && u.document.write(c), u;
                }
                throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");
            case "pdfjsnewwindow":
                if ("[object Window]" === Object.prototype.toString.call($cbf54afc98507811$var$n)) {
                    var l = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="' + (e.pdfJsUrl || "examples/PDF.js/web/viewer.html") + "?file=&downloadName=" + e.filename + '" width="500px" height="400px" /></body></html>', f = $cbf54afc98507811$var$n.open();
                    if (null !== f) {
                        f.document.write(l);
                        var d = this;
                        f.document.documentElement.querySelector("#pdfViewer").onload = function() {
                            f.document.title = e.filename, f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"));
                        };
                    }
                    return f;
                }
                throw new Error("The option pdfjsnewwindow just works in a browser-environment.");
            case "dataurlnewwindow":
                if ("[object Window]" !== Object.prototype.toString.call($cbf54afc98507811$var$n)) throw new Error("The option dataurlnewwindow just works in a browser-environment.");
                var p = '<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="' + this.output("datauristring", e) + '"></iframe></body></html>', g = $cbf54afc98507811$var$n.open();
                if (null !== g && (g.document.write(p), g.document.title = e.filename), g || "undefined" == typeof safari) return g;
                break;
            case "datauri":
            case "dataurl":
                return $cbf54afc98507811$var$n.document.location.href = this.output("datauristring", e);
            default:
                return null;
        }
    }), Ge = function Ge(t) {
        return !0 === Array.isArray(Ut) && Ut.indexOf(t) > -1;
    };
    switch(o){
        case "pt":
            _$_t = 1;
            break;
        case "mm":
            _$_t = 72 / 25.4;
            break;
        case "cm":
            _$_t = 72 / 2.54;
            break;
        case "in":
            _$_t = 72;
            break;
        case "px":
            _$_t = 1 == Ge("px_scaling") ? .75 : 96 / 72;
            break;
        case "pc":
        case "em":
            _$_t = 12;
            break;
        case "ex":
            _$_t = 6;
            break;
        default:
            if ("number" != typeof o) throw new Error("Invalid unit: " + o);
            _$_t = o;
    }
    var Ye = null;
    K(), Y();
    var Je = function Je(t) {
        return null !== m ? Ye.encryptor(t, 0) : function(t) {
            return t;
        };
    }, Xe = _$y.__private__.getPageInfo = _$y.getPageInfo = function Xe(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfo");
        return {
            objId: Rt[t].objId,
            pageNumber: t,
            pageContext: Rt[t]
        };
    }, Ke = _$y.__private__.getPageInfoByObjId = function Ke(t) {
        if (isNaN(t) || t % 1 != 0) throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");
        for(var _$e in Rt)if (Rt[_$e].objId === t) break;
        return Xe(_$e);
    }, Ze = _$y.__private__.getCurrentPageInfo = _$y.getCurrentPageInfo = function Ze() {
        return {
            objId: Rt[$].objId,
            pageNumber: $,
            pageContext: Rt[$]
        };
    };
    _$y.addPage = function() {
        return Oe.apply(this, arguments), this;
    }, _$y.setPage = function() {
        return Me.apply(this, arguments), ht.call(this, ot[$]), this;
    }, _$y.insertPage = function(t) {
        return this.addPage(), this.movePage($, t), this;
    }, _$y.movePage = function(t, e) {
        var r, n;
        if (t > e) {
            r = ot[t], n = Rt[t];
            for(var _$i = t; _$i > e; _$i--)ot[_$i] = ot[_$i - 1], Rt[_$i] = Rt[_$i - 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        } else if (t < e) {
            r = ot[t], n = Rt[t];
            for(var a = t; a < e; a++)ot[a] = ot[a + 1], Rt[a] = Rt[a + 1];
            ot[e] = r, Rt[e] = n, this.setPage(e);
        }
        return this;
    }, _$y.deletePage = function() {
        return Be.apply(this, arguments), this;
    }, _$y.__private__.text = _$y.text = function(e, r, n, i, a) {
        var L = function L(t) {
            return t = t.split("	").join(Array(i.TabLen || 9).join(" ")), Ce(t, f);
        };
        var A = function A(t) {
            for(var _$e, _$r = t.concat(), _$n = [], _$i = _$r.length; _$i--;)"string" == typeof (_$e = _$r.shift()) ? _$n.push(_$e) : Array.isArray(t) && (1 === _$e.length || void 0 === _$e[1] && void 0 === _$e[2]) ? _$n.push(_$e[0]) : _$n.push([
                _$e[0],
                _$e[1],
                _$e[2]
            ]);
            return _$n;
        };
        var _ = function _(t, e) {
            var _$r;
            if ("string" == typeof t) _$r = e(t)[0];
            else if (Array.isArray(t)) {
                for(var _$n, _$i, _$a = t.concat(), o = [], s = _$a.length; s--;)"string" == typeof (_$n = _$a.shift()) ? o.push(e(_$n)[0]) : Array.isArray(_$n) && "string" == typeof _$n[0] && (_$i = e(_$n[0], _$n[1], _$n[2]), o.push([
                    _$i[0],
                    _$i[1],
                    _$i[2]
                ]));
                _$r = o;
            }
            return _$r;
        };
        var o, s, c, u, h, l, f, d, p, g = (i = i || {}).scope || this;
        if ("number" == typeof e && "number" == typeof r && ("string" == typeof n || Array.isArray(n))) {
            var m = n;
            n = r, r = e, e = m;
        }
        if (arguments[3] instanceof Vt == !1 ? (c = arguments[4], u = arguments[5], "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(f = arguments[3]) && null !== f || ("string" == typeof c && (u = c, c = null), "string" == typeof f && (u = f, f = null), "number" == typeof f && (c = f, f = null), i = {
            flags: f,
            angle: c,
            align: u
        })) : (q("The transform parameter of text() with a Matrix value"), p = a), isNaN(r) || isNaN(n) || null == e) throw new Error("Invalid arguments passed to jsPDF.text");
        if (0 === e.length) return g;
        var v = "", _$y = !1, w = "number" == typeof i.lineHeightFactor ? i.lineHeightFactor : lr, N = g.internal.scaleFactor;
        var P = !1, k = !0;
        if ("string" == typeof e) P = !0;
        else if (Array.isArray(e)) {
            var _$I = e.concat();
            s = [];
            for(var F, _$C = _$I.length; _$C--;)("string" != typeof (F = _$I.shift()) || Array.isArray(F) && "string" != typeof F[0]) && (k = !1);
            P = k;
        }
        if (!1 === P) throw new Error('Type of text must be string or Array. "' + e + '" is not recognized.');
        "string" == typeof e && (e = e.match(/[\r?\n]/) ? e.split(/\r\n|\r|\n/g) : [
            e
        ]);
        var _$j = gt / g.internal.scaleFactor, _$B = _$j * (w - 1);
        switch(i.baseline){
            case "bottom":
                n -= _$B;
                break;
            case "top":
                n += _$j - _$B;
                break;
            case "hanging":
                n += _$j - 2 * _$B;
                break;
            case "middle":
                n += _$j / 2 - _$B;
        }
        if ((l = i.maxWidth || 0) > 0 && ("string" == typeof e ? e = g.splitTextToSize(e, l) : "[object Array]" === Object.prototype.toString.call(e) && (e = e.reduce(function(t, e) {
            return t.concat(g.splitTextToSize(e, l));
        }, []))), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("preProcessText", o), e = o.text, c = (i = o.options).angle, p instanceof Vt == !1 && c && "number" == typeof c) {
            c *= Math.PI / 180, 0 === i.rotationDirection && (c = -c), S === x.ADVANCED && (c = -c);
            var _$M = Math.cos(c), _$E = Math.sin(c);
            p = new Vt(_$M, _$E, -_$E, _$M, 0, 0);
        } else c && c instanceof Vt && (p = c);
        S !== x.ADVANCED || p || (p = Yt), void 0 !== (h = i.charSpace || _r) && (v += O(U(h)) + " Tc\n", this.setCharSpace(this.getCharSpace() || 0)), void 0 !== (d = i.horizontalScale) && (v += O(100 * d) + " Tz\n");
        i.lang;
        var D = -1, R = void 0 !== i.renderingMode ? i.renderingMode : i.stroke, T = g.internal.getCurrentPageInfo().pageContext;
        switch(R){
            case 0:
            case !1:
            case "fill":
                D = 0;
                break;
            case 1:
            case !0:
            case "stroke":
                D = 1;
                break;
            case 2:
            case "fillThenStroke":
                D = 2;
                break;
            case 3:
            case "invisible":
                D = 3;
                break;
            case 4:
            case "fillAndAddForClipping":
                D = 4;
                break;
            case 5:
            case "strokeAndAddPathForClipping":
                D = 5;
                break;
            case 6:
            case "fillThenStrokeAndAddToPathForClipping":
                D = 6;
                break;
            case 7:
            case "addToPathForClipping":
                D = 7;
        }
        var z = void 0 !== T.usedRenderingMode ? T.usedRenderingMode : -1;
        -1 !== D ? v += D + " Tr\n" : -1 !== z && (v += "0 Tr\n"), -1 !== D && (T.usedRenderingMode = D), u = i.align || "left";
        var H, W = gt * w, V = g.internal.pageSize.getWidth(), G = Ft[St];
        h = i.charSpace || _r, l = i.maxWidth || 0, f = Object.assign({
            autoencode: !0,
            noBOM: !0
        }, i.flags);
        var Y = [];
        if ("[object Array]" === Object.prototype.toString.call(e)) {
            var J;
            s = A(e), "left" !== u && (H = s.map(function(t) {
                return g.getStringUnitWidth(t, {
                    font: G,
                    charSpace: h,
                    fontSize: gt,
                    doKerning: !1
                }) * gt / N;
            }));
            var X, K = 0;
            if ("right" === u) {
                r -= H[0], e = [], _$C = s.length;
                for(var Z = 0; Z < _$C; Z++)0 === Z ? (X = br(r), J = yr(n)) : (X = U(K - H[Z]), J = -W), e.push([
                    s[Z],
                    X,
                    J
                ]), K = H[Z];
            } else if ("center" === u) {
                r -= H[0] / 2, e = [], _$C = s.length;
                for(var $ = 0; $ < _$C; $++)0 === $ ? (X = br(r), J = yr(n)) : (X = U((K - H[$]) / 2), J = -W), e.push([
                    s[$],
                    X,
                    J
                ]), K = H[$];
            } else if ("left" === u) {
                e = [], _$C = s.length;
                for(var Q = 0; Q < _$C; Q++)e.push(s[Q]);
            } else {
                if ("justify" !== u) throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');
                e = [], _$C = s.length, l = 0 !== l ? l : V;
                for(var tt = 0; tt < _$C; tt++)J = 0 === tt ? yr(n) : -W, X = 0 === tt ? br(r) : 0, tt < _$C - 1 ? Y.push(O(U((l - H[tt]) / (s[tt].split(" ").length - 1)))) : Y.push(0), e.push([
                    s[tt],
                    X,
                    J
                ]);
            }
        }
        var et = "boolean" == typeof i.R2L ? i.R2L : bt;
        !0 === et && (e = _(e, function(t, e, r) {
            return [
                t.split("").reverse().join(""),
                e,
                r
            ];
        })), o = {
            text: e,
            x: r,
            y: n,
            options: i,
            mutex: {
                pdfEscape: Ce,
                activeFontKey: St,
                fonts: Ft,
                activeFontSize: gt
            }
        }, Tt.publish("postProcessText", o), e = o.text, _$y = o.mutex.isHex || !1;
        var rt = Ft[St].encoding;
        "WinAnsiEncoding" !== rt && "StandardEncoding" !== rt || (e = _(e, function(t, e, r) {
            return [
                L(t),
                e,
                r
            ];
        })), s = A(e), e = [];
        for(var nt, it, at, ot = 0, st = 1, ct = Array.isArray(s[0]) ? st : ot, ut = "", ht = function ht(t, e, r) {
            var _$n = "";
            return r instanceof Vt ? (r = "number" == typeof i.angle ? Gt(r, new Vt(1, 0, 0, 1, t, e)) : Gt(new Vt(1, 0, 0, 1, t, e), r), S === x.ADVANCED && (r = Gt(new Vt(1, 0, 0, -1, 0, 0), r)), _$n = r.join(" ") + " Tm\n") : _$n = O(t) + " " + O(e) + " Td\n", _$n;
        }, ft = 0; ft < s.length; ft++){
            switch(ut = "", ct){
                case st:
                    at = (_$y ? "<" : "(") + s[ft][0] + (_$y ? ">" : ")"), nt = parseFloat(s[ft][1]), it = parseFloat(s[ft][2]);
                    break;
                case ot:
                    at = (_$y ? "<" : "(") + s[ft] + (_$y ? ">" : ")"), nt = br(r), it = yr(n);
            }
            void 0 !== Y && void 0 !== Y[ft] && (ut = Y[ft] + " Tw\n"), 0 === ft ? e.push(ut + ht(nt, it, p) + at) : ct === ot ? e.push(ut + at) : ct === st && e.push(ut + ht(nt, it, p) + at);
        }
        e = ct === ot ? e.join(" Tj\nT* ") : e.join(" Tj\n"), e += " Tj\n";
        var dt = "BT\n/";
        return dt += St + " " + gt + " Tf\n", dt += O(gt * w) + " TL\n", dt += xr + "\n", dt += v, dt += e, lt(dt += "ET"), b[St] = !0, g;
    };
    var $e = _$y.__private__.clip = _$y.clip = function $e(t) {
        return lt("evenodd" === t ? "W*" : "W"), this;
    };
    _$y.clipEvenOdd = function() {
        return $e("evenodd");
    }, _$y.__private__.discardPath = _$y.discardPath = function() {
        return lt("n"), this;
    };
    var Qe = _$y.__private__.isValidStyle = function Qe(t) {
        var _$e = !1;
        return -1 !== [
            void 0,
            null,
            "S",
            "D",
            "F",
            "DF",
            "FD",
            "f",
            "f*",
            "B",
            "B*",
            "n"
        ].indexOf(t) && (_$e = !0), _$e;
    };
    _$y.__private__.setDefaultPathOperation = _$y.setDefaultPathOperation = function(t) {
        return Qe(t) && (g = t), this;
    };
    var tr = _$y.__private__.getStyle = _$y.getStyle = function tr(t) {
        var _$e = g;
        switch(t){
            case "D":
            case "S":
                _$e = "S";
                break;
            case "F":
                _$e = "f";
                break;
            case "FD":
            case "DF":
                _$e = "B";
                break;
            case "f":
            case "f*":
            case "B":
            case "B*":
                _$e = t;
        }
        return _$e;
    }, er = _$y.close = function er() {
        return lt("h"), this;
    };
    _$y.stroke = function() {
        return lt("S"), this;
    }, _$y.fill = function(t) {
        return rr("f", t), this;
    }, _$y.fillEvenOdd = function(t) {
        return rr("f*", t), this;
    }, _$y.fillStroke = function(t) {
        return rr("B", t), this;
    }, _$y.fillStrokeEvenOdd = function(t) {
        return rr("B*", t), this;
    };
    var rr = function rr(e, r) {
        "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(r) ? ar(r, e) : lt(e);
    }, nr = function nr(t) {
        null === t || S === x.ADVANCED && void 0 === t || (t = tr(t), lt(t));
    };
    var ar = function ar(t, e) {
        var r = Bt[t.key], n = Ot[r];
        if (n instanceof $cbf54afc98507811$export$7235f0ad083cb4c6) lt("q"), lt(or(e)), n.gState && _$y.setGState(n.gState), lt(t.matrix.toString() + " cm"), lt("/" + r + " sh"), lt("Q");
        else if (n instanceof $cbf54afc98507811$export$549f717800d2b57f) {
            var _$i = new Vt(1, 0, 0, -1, 0, Rr());
            t.matrix && (_$i = _$i.multiply(t.matrix || Yt), r = ir.call(n, t.key, t.boundingBox, t.xStep, t.yStep, _$i).id), lt("q"), lt("/Pattern cs"), lt("/" + r + " scn"), n.gState && _$y.setGState(n.gState), lt(e), lt("Q");
        }
    }, or = function or(t) {
        switch(t){
            case "f":
            case "F":
                return "W n";
            case "f*":
                return "W* n";
            case "B":
                return "W S";
            case "B*":
                return "W* S";
            case "S":
                return "W S";
            case "n":
                return "W n";
        }
    }, sr = _$y.moveTo = function sr(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " m"), this;
    }, cr = _$y.lineTo = function cr(t, e) {
        return lt(O(U(t)) + " " + O(H(e)) + " l"), this;
    }, ur = _$y.curveTo = function ur(t, e, r, n, i, a) {
        return lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(H(n)),
            O(U(i)),
            O(H(a)),
            "c"
        ].join(" ")), this;
    };
    _$y.__private__.line = _$y.line = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.line");
        return S === x.COMPAT ? this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ], i || "S") : this.lines([
            [
                r - t,
                n - e
            ]
        ], t, e, [
            1,
            1
        ]).stroke();
    }, _$y.__private__.lines = _$y.lines = function(t, e, r, n, i, a) {
        var o, s, c, u, h, l, f, d, p, g, m, v;
        if ("number" == typeof t && (v = r, r = e, e = t, t = v), n = n || [
            1,
            1
        ], a = a || !1, isNaN(e) || isNaN(r) || !Array.isArray(t) || !Array.isArray(n) || !Qe(i) || "boolean" != typeof a) throw new Error("Invalid arguments passed to jsPDF.lines");
        for(sr(e, r), o = n[0], s = n[1], u = t.length, g = e, m = r, c = 0; c < u; c++)2 === (h = t[c]).length ? (g = h[0] * o + g, m = h[1] * s + m, cr(g, m)) : (l = h[0] * o + g, f = h[1] * s + m, d = h[2] * o + g, p = h[3] * s + m, g = h[4] * o + g, m = h[5] * s + m, ur(l, f, d, p, g, m));
        return a && er(), nr(i), this;
    }, _$y.path = function(t) {
        for(var _$e = 0; _$e < t.length; _$e++){
            var r = t[_$e], n = r.c;
            switch(r.op){
                case "m":
                    sr(n[0], n[1]);
                    break;
                case "l":
                    cr(n[0], n[1]);
                    break;
                case "c":
                    ur.apply(this, n);
                    break;
                case "h":
                    er();
            }
        }
        return this;
    }, _$y.__private__.rect = _$y.rect = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.rect");
        return S === x.COMPAT && (n = -n), lt([
            O(U(t)),
            O(H(e)),
            O(U(r)),
            O(U(n)),
            "re"
        ].join(" ")), nr(i), this;
    }, _$y.__private__.triangle = _$y.triangle = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.triangle");
        return this.lines([
            [
                r - t,
                n - e
            ],
            [
                i - r,
                a - n
            ],
            [
                t - i,
                e - a
            ]
        ], t, e, [
            1,
            1
        ], o, !0), this;
    }, _$y.__private__.roundedRect = _$y.roundedRect = function(t, e, r, n, i, a, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(a) || !Qe(o)) throw new Error("Invalid arguments passed to jsPDF.roundedRect");
        var s = 4 / 3 * (Math.SQRT2 - 1);
        return i = Math.min(i, .5 * r), a = Math.min(a, .5 * n), this.lines([
            [
                r - 2 * i,
                0
            ],
            [
                i * s,
                0,
                i,
                a - a * s,
                i,
                a
            ],
            [
                0,
                n - 2 * a
            ],
            [
                0,
                a * s,
                -i * s,
                a,
                -i,
                a
            ],
            [
                2 * i - r,
                0
            ],
            [
                -i * s,
                0,
                -i,
                -a * s,
                -i,
                -a
            ],
            [
                0,
                2 * a - n
            ],
            [
                0,
                -a * s,
                i * s,
                -a,
                i,
                -a
            ]
        ], t + i, e, [
            1,
            1
        ], o, !0), this;
    }, _$y.__private__.ellipse = _$y.ellipse = function(t, e, r, n, i) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || !Qe(i)) throw new Error("Invalid arguments passed to jsPDF.ellipse");
        var a = 4 / 3 * (Math.SQRT2 - 1) * r, o = 4 / 3 * (Math.SQRT2 - 1) * n;
        return sr(t + r, e), ur(t + r, e - o, t + a, e - n, t, e - n), ur(t - a, e - n, t - r, e - o, t - r, e), ur(t - r, e + o, t - a, e + n, t, e + n), ur(t + a, e + n, t + r, e + o, t + r, e), nr(i), this;
    }, _$y.__private__.circle = _$y.circle = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || !Qe(n)) throw new Error("Invalid arguments passed to jsPDF.circle");
        return this.ellipse(t, e, r, r, n);
    }, _$y.setFont = function(t, e, r) {
        return r && (e = k(e, r)), St = qe(t, e, {
            disableWarning: !1
        }), this;
    };
    var hr = _$y.__private__.getFont = _$y.getFont = function hr() {
        return Ft[qe.apply(_$y, arguments)];
    };
    _$y.__private__.getFontList = _$y.getFontList = function() {
        var _$t, _$e, r = {};
        for(_$t in Ct)if (Ct.hasOwnProperty(_$t)) for(_$e in r[_$t] = [], Ct[_$t])Ct[_$t].hasOwnProperty(_$e) && r[_$t].push(_$e);
        return r;
    }, _$y.addFont = function(t, e, r, n, i) {
        var a = [
            "StandardEncoding",
            "MacRomanEncoding",
            "Identity-H",
            "WinAnsiEncoding"
        ];
        return arguments[3] && -1 !== a.indexOf(arguments[3]) ? i = arguments[3] : arguments[3] && -1 == a.indexOf(arguments[3]) && (r = k(r, n)), i = i || "Identity-H", Pe.call(this, t, e, r, i);
    };
    var lr, fr = e.lineWidth || .200025, dr = _$y.__private__.getLineWidth = _$y.getLineWidth = function dr() {
        return fr;
    }, pr = _$y.__private__.setLineWidth = _$y.setLineWidth = function pr(t) {
        return fr = t, lt(O(U(t)) + " w"), this;
    };
    _$y.__private__.setLineDash = $cbf54afc98507811$export$ba1e2ffc633a60f5.API.setLineDash = $cbf54afc98507811$export$ba1e2ffc633a60f5.API.setLineDashPattern = function(t, e) {
        if (t = t || [], e = e || 0, isNaN(e) || !Array.isArray(t)) throw new Error("Invalid arguments passed to jsPDF.setLineDash");
        return t = t.map(function(t) {
            return O(U(t));
        }).join(" "), e = O(U(e)), lt("[" + t + "] " + e + " d"), this;
    };
    var gr = _$y.__private__.getLineHeight = _$y.getLineHeight = function gr() {
        return gt * lr;
    };
    _$y.__private__.getLineHeight = _$y.getLineHeight = function() {
        return gt * lr;
    };
    var mr = _$y.__private__.setLineHeightFactor = _$y.setLineHeightFactor = function mr(t) {
        return "number" == typeof (t = t || 1.15) && (lr = t), this;
    }, vr = _$y.__private__.getLineHeightFactor = _$y.getLineHeightFactor = function vr() {
        return lr;
    };
    mr(e.lineHeight);
    var br = _$y.__private__.getHorizontalCoordinate = function br(t) {
        return U(t);
    }, yr = _$y.__private__.getVerticalCoordinate = function yr(t) {
        return S === x.ADVANCED ? t : Rt[$].mediaBox.topRightY - Rt[$].mediaBox.bottomLeftY - U(t);
    }, wr = _$y.__private__.getHorizontalCoordinateString = _$y.getHorizontalCoordinateString = function wr(t) {
        return O(br(t));
    }, Nr = _$y.__private__.getVerticalCoordinateString = _$y.getVerticalCoordinateString = function Nr(t) {
        return O(yr(t));
    }, Lr = e.strokeColor || "0 G";
    _$y.__private__.getStrokeColor = _$y.getDrawColor = function() {
        return _$ee(Lr);
    }, _$y.__private__.setStrokeColor = _$y.setDrawColor = function(t, e, r, n) {
        return Lr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "draw",
            precision: 2
        }), lt(Lr), this;
    };
    var Ar = e.fillColor || "0 g";
    _$y.__private__.getFillColor = _$y.getFillColor = function() {
        return _$ee(Ar);
    }, _$y.__private__.setFillColor = _$y.setFillColor = function(t, e, r, n) {
        return Ar = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "fill",
            precision: 2
        }), lt(Ar), this;
    };
    var xr = e.textColor || "0 g", Sr = _$y.__private__.getTextColor = _$y.getTextColor = function Sr() {
        return _$ee(xr);
    };
    _$y.__private__.setTextColor = _$y.setTextColor = function(t, e, r, n) {
        return xr = re({
            ch1: t,
            ch2: e,
            ch3: r,
            ch4: n,
            pdfColorType: "text",
            precision: 3
        }), this;
    };
    var _r = e.charSpace, Pr = _$y.__private__.getCharSpace = _$y.getCharSpace = function Pr() {
        return parseFloat(_r || 0);
    };
    _$y.__private__.setCharSpace = _$y.setCharSpace = function(t) {
        if (isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setCharSpace");
        return _r = t, this;
    };
    var kr = 0;
    _$y.CapJoinStyles = {
        0: 0,
        butt: 0,
        but: 0,
        miter: 0,
        1: 1,
        round: 1,
        rounded: 1,
        circle: 1,
        2: 2,
        projecting: 2,
        project: 2,
        square: 2,
        bevel: 2
    }, _$y.__private__.setLineCap = _$y.setLineCap = function(t) {
        var _$e = _$y.CapJoinStyles[t];
        if (void 0 === _$e) throw new Error("Line cap style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return kr = _$e, lt(_$e + " J"), this;
    };
    var Ir = 0;
    _$y.__private__.setLineJoin = _$y.setLineJoin = function(t) {
        var _$e = _$y.CapJoinStyles[t];
        if (void 0 === _$e) throw new Error("Line join style of '" + t + "' is not recognized. See or extend .CapJoinStyles property for valid styles");
        return Ir = _$e, lt(_$e + " j"), this;
    }, _$y.__private__.setLineMiterLimit = _$y.__private__.setMiterLimit = _$y.setLineMiterLimit = _$y.setMiterLimit = function(t) {
        if (t = t || 0, isNaN(t)) throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");
        return lt(O(U(t)) + " M"), this;
    }, _$y.GState = $cbf54afc98507811$export$1bc649ab427a02ba, _$y.setGState = function(t) {
        (t = "string" == typeof t ? Mt[Et[t]] : Fr(null, t)).equals(qt) || (lt("/" + t.id + " gs"), qt = t);
    };
    var Fr = function Fr(t, e) {
        if (!t || !Et[t]) {
            var r = !1;
            for(var n in Mt)if (Mt.hasOwnProperty(n) && Mt[n].equals(e)) {
                r = !0;
                break;
            }
            if (r) e = Mt[n];
            else {
                var _$i = "GS" + (Object.keys(Mt).length + 1).toString(10);
                Mt[_$i] = e, e.id = _$i;
            }
            return t && (Et[t] = e.id), Tt.publish("addGState", e), e;
        }
    };
    _$y.addGState = function(t, e) {
        return Fr(t, e), this;
    }, _$y.saveGraphicsState = function() {
        return lt("q"), jt.push({
            key: St,
            size: gt,
            color: xr
        }), this;
    }, _$y.restoreGraphicsState = function() {
        lt("Q");
        var _$t = jt.pop();
        return St = _$t.key, gt = _$t.size, xr = _$t.color, qt = null, this;
    }, _$y.setCurrentTransformationMatrix = function(t) {
        return lt(t.toString() + " cm"), this;
    }, _$y.comment = function(t) {
        return lt("#" + t), this;
    };
    var Cr = function Cr(t, e) {
        var r = t || 0;
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function get() {
                return r;
            },
            set: function set(t) {
                isNaN(t) || (r = parseFloat(t));
            }
        });
        var n = e || 0;
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function get() {
                return n;
            },
            set: function set(t) {
                isNaN(t) || (n = parseFloat(t));
            }
        });
        var _$i = "pt";
        return Object.defineProperty(this, "type", {
            enumerable: !0,
            get: function get() {
                return _$i;
            },
            set: function set(t) {
                _$i = t.toString();
            }
        }), this;
    }, jr = function jr(t, e, r, n) {
        Cr.call(this, t, e), this.type = "rect";
        var _$i = r || 0;
        Object.defineProperty(this, "w", {
            enumerable: !0,
            get: function get() {
                return _$i;
            },
            set: function set(t) {
                isNaN(t) || (_$i = parseFloat(t));
            }
        });
        var a = n || 0;
        return Object.defineProperty(this, "h", {
            enumerable: !0,
            get: function get() {
                return a;
            },
            set: function set(t) {
                isNaN(t) || (a = parseFloat(t));
            }
        }), this;
    }, Or = function Or() {
        this.page = Dt, this.currentPage = $, this.pages = ot.slice(0), this.pagesContext = Rt.slice(0), this.x = Pt, this.y = kt, this.matrix = It, this.width = qr($), this.height = Rr($), this.outputDestination = ct, this.id = "", this.objectNumber = -1;
    };
    Or.prototype.restore = function() {
        Dt = this.page, $ = this.currentPage, Rt = this.pagesContext, ot = this.pages, Pt = this.x, kt = this.y, It = this.matrix, Dr($, this.width), Tr($, this.height), ct = this.outputDestination;
    };
    var Br = function Br(t, e, r, n, i) {
        Wt.push(new Or), Dt = $ = 0, ot = [], Pt = t, kt = e, It = i, je([
            r,
            n
        ]);
    }, Mr = function Mr(t) {
        if (Ht[t]) Wt.pop().restore();
        else {
            var _$e = new Or, r = "Xo" + (Object.keys(zt).length + 1).toString(10);
            _$e.id = r, Ht[t] = r, zt[r] = _$e, Tt.publish("addFormObject", _$e), Wt.pop().restore();
        }
    };
    for(var Er in _$y.beginFormObject = function(t, e, r, n, i) {
        return Br(t, e, r, n, i), this;
    }, _$y.endFormObject = function(t) {
        return Mr(t), this;
    }, _$y.doFormObject = function(t, e) {
        var r = zt[Ht[t]];
        return lt("q"), lt(e.toString() + " cm"), lt("/" + r.id + " Do"), lt("Q"), this;
    }, _$y.getFormObject = function(t) {
        var _$e = zt[Ht[t]];
        return {
            x: _$e.x,
            y: _$e.y,
            width: _$e.width,
            height: _$e.height,
            matrix: _$e.matrix
        };
    }, _$y.save = function(t, e) {
        return t = t || "generated.pdf", (e = e || {}).returnPromise = e.returnPromise || !1, !1 === e.returnPromise ? ($cbf54afc98507811$var$l(We(He()), t), "function" == typeof $cbf54afc98507811$var$l.unload && $cbf54afc98507811$var$n.setTimeout && setTimeout($cbf54afc98507811$var$l.unload, 911), this) : new Promise(function(e, r) {
            try {
                var _$i = $cbf54afc98507811$var$l(We(He()), t);
                "function" == typeof $cbf54afc98507811$var$l.unload && $cbf54afc98507811$var$n.setTimeout && setTimeout($cbf54afc98507811$var$l.unload, 911), e(_$i);
            } catch (t) {
                r(t.message);
            }
        });
    }, $cbf54afc98507811$export$ba1e2ffc633a60f5.API)$cbf54afc98507811$export$ba1e2ffc633a60f5.API.hasOwnProperty(Er) && ("events" === Er && $cbf54afc98507811$export$ba1e2ffc633a60f5.API.events.length ? function(t, e) {
        var r, n, _$i;
        for(_$i = e.length - 1; -1 !== _$i; _$i--)r = e[_$i][0], n = e[_$i][1], t.subscribe.apply(t, [
            r
        ].concat("function" == typeof n ? [
            n
        ] : n));
    }(Tt, $cbf54afc98507811$export$ba1e2ffc633a60f5.API.events) : _$y[Er] = $cbf54afc98507811$export$ba1e2ffc633a60f5.API[Er]);
    var qr = _$y.getPageWidth = function qr(t) {
        return (Rt[t = t || $].mediaBox.topRightX - Rt[t].mediaBox.bottomLeftX) / _$_t;
    }, Dr = _$y.setPageWidth = function Dr(t, e) {
        Rt[t].mediaBox.topRightX = e * _$_t + Rt[t].mediaBox.bottomLeftX;
    }, Rr = _$y.getPageHeight = function Rr(t) {
        return (Rt[t = t || $].mediaBox.topRightY - Rt[t].mediaBox.bottomLeftY) / _$_t;
    }, Tr = _$y.setPageHeight = function Tr(t, e) {
        Rt[t].mediaBox.topRightY = e * _$_t + Rt[t].mediaBox.bottomLeftY;
    };
    return _$y.internal = {
        pdfEscape: Ce,
        getStyle: tr,
        getFont: hr,
        getFontSize: vt,
        getCharSpace: Pr,
        getTextColor: Sr,
        getLineHeight: gr,
        getLineHeightFactor: vr,
        getLineWidth: dr,
        write: ft,
        getHorizontalCoordinate: br,
        getVerticalCoordinate: yr,
        getCoordinateString: wr,
        getVerticalCoordinateString: Nr,
        collections: {},
        newObject: Xt,
        newAdditionalObject: $t,
        newObjectDeferred: Kt,
        newObjectDeferredBegin: Zt,
        getFilters: ne,
        putStream: ie,
        events: Tt,
        scaleFactor: _$_t,
        pageSize: {
            getWidth: function getWidth() {
                return qr($);
            },
            setWidth: function setWidth(t) {
                Dr($, t);
            },
            getHeight: function getHeight() {
                return Rr($);
            },
            setHeight: function setHeight(t) {
                Tr($, t);
            }
        },
        encryptionOptions: m,
        encryption: Ye,
        getEncryptor: Je,
        output: Ve,
        getNumberOfPages: Ee,
        pages: ot,
        out: lt,
        f2: R,
        f3: T,
        getPageInfo: Xe,
        getPageInfoByObjId: Ke,
        getCurrentPageInfo: Ze,
        getPDFVersion: N,
        Point: Cr,
        Rectangle: jr,
        Matrix: Vt,
        hasHotfix: Ge
    }, Object.defineProperty(_$y.internal.pageSize, "width", {
        get: function get() {
            return qr($);
        },
        set: function set(t) {
            Dr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(_$y.internal.pageSize, "height", {
        get: function get() {
            return Rr($);
        },
        set: function set(t) {
            Tr($, t);
        },
        enumerable: !0,
        configurable: !0
    }), ke.call(_$y, pt), St = "F1", Oe(s, _$i), Tt.publish("initialized"), _$y;
}
$cbf54afc98507811$var$I.prototype.lsbFirstWord = function(t) {
    return String.fromCharCode(t >> 0 & 255, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255);
}, $cbf54afc98507811$var$I.prototype.toHexString = function(t) {
    return t.split("").map(function(t) {
        return ("0" + (255 & t.charCodeAt(0)).toString(16)).slice(-2);
    }).join("");
}, $cbf54afc98507811$var$I.prototype.hexToBytes = function(t) {
    for(var e = [], r = 0; r < t.length; r += 2)e.push(String.fromCharCode(parseInt(t.substr(r, 2), 16)));
    return e.join("");
}, $cbf54afc98507811$var$I.prototype.processOwnerPassword = function(t, e) {
    return $cbf54afc98507811$var$P($cbf54afc98507811$var$x(e).substr(0, 5), t);
}, $cbf54afc98507811$var$I.prototype.encryptor = function(t, e) {
    var r = $cbf54afc98507811$var$x(this.encryptionKey + String.fromCharCode(255 & t, t >> 8 & 255, t >> 16 & 255, 255 & e, e >> 8 & 255)).substr(0, 10);
    return function(t) {
        return $cbf54afc98507811$var$P(r, t);
    };
}, $cbf54afc98507811$export$1bc649ab427a02ba.prototype.equals = function(e) {
    var r, n = "id,objectNumber,equals";
    if (!e || (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e) !== (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(this)) return !1;
    var _$i = 0;
    for(r in this)if (!(n.indexOf(r) >= 0)) {
        if (this.hasOwnProperty(r) && !e.hasOwnProperty(r)) return !1;
        if (this[r] !== e[r]) return !1;
        _$i++;
    }
    for(r in e)e.hasOwnProperty(r) && n.indexOf(r) < 0 && _$i--;
    return 0 === _$i;
}, $cbf54afc98507811$export$ba1e2ffc633a60f5.API = {
    events: []
}, $cbf54afc98507811$export$ba1e2ffc633a60f5.version = "2.5.1";
var $cbf54afc98507811$var$q = $cbf54afc98507811$export$ba1e2ffc633a60f5.API, $cbf54afc98507811$var$D = 1, $cbf54afc98507811$var$R = function R(t) {
    return t.replace(/\\/g, "\\\\").replace(/\(/g, "\\(").replace(/\)/g, "\\)");
}, $cbf54afc98507811$var$T = function T(t) {
    return t.replace(/\\\\/g, "\\").replace(/\\\(/g, "(").replace(/\\\)/g, ")");
}, $cbf54afc98507811$var$U = function U(t) {
    return t.toFixed(2);
}, $cbf54afc98507811$var$z = function z(t) {
    return t.toFixed(5);
};
$cbf54afc98507811$var$q.__acroform__ = {};
var $cbf54afc98507811$var$H = function H(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t;
}, $cbf54afc98507811$var$W = function W(t) {
    return t * $cbf54afc98507811$var$D;
}, $cbf54afc98507811$var$V = function V(t) {
    var e = new $cbf54afc98507811$var$ut, r = $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) || 0, n = $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) || 0;
    return e.BBox = [
        0,
        0,
        Number($cbf54afc98507811$var$U(n)),
        Number($cbf54afc98507811$var$U(r))
    ], e;
}, $cbf54afc98507811$var$G = $cbf54afc98507811$var$q.__acroform__.setBit = function G(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");
    return t |= 1 << e;
}, $cbf54afc98507811$var$Y = $cbf54afc98507811$var$q.__acroform__.clearBit = function Y(t, e) {
    if (t = t || 0, e = e || 0, isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");
    return t &= ~(1 << e);
}, $cbf54afc98507811$var$J = $cbf54afc98507811$var$q.__acroform__.getBit = function J(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");
    return 0 == (t & 1 << e) ? 0 : 1;
}, $cbf54afc98507811$var$X = $cbf54afc98507811$var$q.__acroform__.getBitForPdf = function X(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");
    return $cbf54afc98507811$var$J(t, e - 1);
}, $cbf54afc98507811$var$K = $cbf54afc98507811$var$q.__acroform__.setBitForPdf = function K(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");
    return $cbf54afc98507811$var$G(t, e - 1);
}, $cbf54afc98507811$var$Z = $cbf54afc98507811$var$q.__acroform__.clearBitForPdf = function Z(t, e) {
    if (isNaN(t) || isNaN(e)) throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");
    return $cbf54afc98507811$var$Y(t, e - 1);
}, $cbf54afc98507811$var$$ = $cbf54afc98507811$var$q.__acroform__.calculateCoordinates = function $(t, e) {
    var r = e.internal.getHorizontalCoordinate, n = e.internal.getVerticalCoordinate, _$i = t[0], a = t[1], o = t[2], s = t[3], c = {};
    return c.lowerLeft_X = r(_$i) || 0, c.lowerLeft_Y = n(a + s) || 0, c.upperRight_X = r(_$i + o) || 0, c.upperRight_Y = n(a) || 0, [
        Number($cbf54afc98507811$var$U(c.lowerLeft_X)),
        Number($cbf54afc98507811$var$U(c.lowerLeft_Y)),
        Number($cbf54afc98507811$var$U(c.upperRight_X)),
        Number($cbf54afc98507811$var$U(c.upperRight_Y))
    ];
}, $cbf54afc98507811$var$Q = function Q(t) {
    if (t.appearanceStreamContent) return t.appearanceStreamContent;
    if (t.V || t.DV) {
        var e = [], r = t._V || t.DV, n = $cbf54afc98507811$var$tt(t, r), _$i = t.scope.internal.getFont(t.fontName, t.fontStyle).id;
        e.push("/Tx BMC"), e.push("q"), e.push("BT"), e.push(t.scope.__private__.encodeColorString(t.color)), e.push("/" + _$i + " " + $cbf54afc98507811$var$U(n.fontSize) + " Tf"), e.push("1 0 0 1 0 0 Tm"), e.push(n.text), e.push("ET"), e.push("Q"), e.push("EMC");
        var a = $cbf54afc98507811$var$V(t);
        return a.scope = t.scope, a.stream = e.join("\n"), a;
    }
}, $cbf54afc98507811$var$tt = function tt(t, e) {
    var r = 0 === t.fontSize ? t.maxFontSize : t.fontSize, n = {
        text: "",
        fontSize: ""
    }, _$i = (e = ")" == (e = "(" == e.substr(0, 1) ? e.substr(1) : e).substr(e.length - 1) ? e.substr(0, e.length - 1) : e).split(" ");
    _$i = t.multiline ? _$i.map(function(t) {
        return t.split("\n");
    }) : _$i.map(function(t) {
        return [
            t
        ];
    });
    var a = r, o = $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) || 0;
    o = o < 0 ? -o : o;
    var s = $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) || 0;
    s = s < 0 ? -s : s;
    var c = function c(e, r, n) {
        if (e + 1 < _$i.length) {
            var a = r + " " + _$i[e + 1][0];
            return $cbf54afc98507811$var$et(a, t, n).width <= s - 4;
        }
        return !1;
    };
    a++;
    t: for(; a > 0;){
        e = "", a--;
        var u, h, l = $cbf54afc98507811$var$et("3", t, a).height, f = t.multiline ? o - a : (o - l) / 2, d = f += 2, p = 0, g = 0, m = 0;
        if (a <= 0) {
            e = "(...) Tj\n", e += "% Width of Text: " + $cbf54afc98507811$var$et(e, t, a = 12).width + ", FieldWidth:" + s + "\n";
            break;
        }
        for(var v = "", b = 0, _$y = 0; _$y < _$i.length; _$y++)if (_$i.hasOwnProperty(_$y)) {
            var w = !1;
            if (1 !== _$i[_$y].length && m !== _$i[_$y].length - 1) {
                if ((l + 2) * (b + 2) + 2 > o) continue t;
                v += _$i[_$y][m], w = !0, g = _$y, _$y--;
            } else {
                v = " " == (v += _$i[_$y][m] + " ").substr(v.length - 1) ? v.substr(0, v.length - 1) : v;
                var N = parseInt(_$y), L = c(N, v, a), A = _$y >= _$i.length - 1;
                if (L && !A) {
                    v += " ", m = 0;
                    continue;
                }
                if (L || A) {
                    if (A) g = N;
                    else if (t.multiline && (l + 2) * (b + 2) + 2 > o) continue t;
                } else {
                    if (!t.multiline) continue t;
                    if ((l + 2) * (b + 2) + 2 > o) continue t;
                    g = N;
                }
            }
            for(var x = "", S = p; S <= g; S++){
                var _ = _$i[S];
                if (t.multiline) {
                    if (S === g) {
                        x += _[m] + " ", m = (m + 1) % _.length;
                        continue;
                    }
                    if (S === p) {
                        x += _[_.length - 1] + " ";
                        continue;
                    }
                }
                x += _[0] + " ";
            }
            switch(x = " " == x.substr(x.length - 1) ? x.substr(0, x.length - 1) : x, h = $cbf54afc98507811$var$et(x, t, a).width, t.textAlign){
                case "right":
                    u = s - h - 2;
                    break;
                case "center":
                    u = (s - h) / 2;
                    break;
                case "left":
                default:
                    u = 2;
            }
            e += $cbf54afc98507811$var$U(u) + " " + $cbf54afc98507811$var$U(d) + " Td\n", e += "(" + $cbf54afc98507811$var$R(x) + ") Tj\n", e += -$cbf54afc98507811$var$U(u) + " 0 Td\n", d = -(a + 2), h = 0, p = w ? g : g + 1, b++, v = "";
        }
        break;
    }
    return n.text = e, n.fontSize = a, n;
}, $cbf54afc98507811$var$et = function et(t, e, r) {
    var n = e.scope.internal.getFont(e.fontName, e.fontStyle), _$i = e.scope.getStringUnitWidth(t, {
        font: n,
        fontSize: parseFloat(r),
        charSpace: 0
    }) * parseFloat(r);
    return {
        height: e.scope.getStringUnitWidth("3", {
            font: n,
            fontSize: parseFloat(r),
            charSpace: 0
        }) * parseFloat(r) * 1.5,
        width: _$i
    };
}, $cbf54afc98507811$var$rt = {
    fields: [],
    xForms: [],
    acroFormDictionaryRoot: null,
    printedOut: !1,
    internal: null,
    isInitialized: !1
}, $cbf54afc98507811$var$nt = function nt(t, e) {
    var r = {
        type: "reference",
        object: t
    };
    void 0 === e.internal.getPageInfo(t.page).pageContext.annotations.find(function(t) {
        return t.type === r.type && t.object === r.object;
    }) && e.internal.getPageInfo(t.page).pageContext.annotations.push(r);
}, $cbf54afc98507811$var$it = function it(e, r) {
    for(var n in e)if (e.hasOwnProperty(n)) {
        var _$i = n, a = e[n];
        r.internal.newObjectDeferredBegin(a.objId, !0), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(a) && "function" == typeof a.putStream && a.putStream(), delete e[_$i];
    }
}, $cbf54afc98507811$var$at = function at(e, r) {
    if (r.scope = e, void 0 !== e.internal && (void 0 === e.internal.acroformPlugin || !1 === e.internal.acroformPlugin.isInitialized)) {
        if ($cbf54afc98507811$var$lt.FieldNum = 0, e.internal.acroformPlugin = JSON.parse(JSON.stringify($cbf54afc98507811$var$rt)), e.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("Exception while creating AcroformDictionary");
        $cbf54afc98507811$var$D = e.internal.scaleFactor, e.internal.acroformPlugin.acroFormDictionaryRoot = new $cbf54afc98507811$var$ht, e.internal.acroformPlugin.acroFormDictionaryRoot.scope = e, e.internal.acroformPlugin.acroFormDictionaryRoot._eventID = e.internal.events.subscribe("postPutResources", function() {
            !function(t) {
                t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID), delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID, t.internal.acroformPlugin.printedOut = !0;
            }(e);
        }), e.internal.events.subscribe("buildDocument", function() {
            !function(t) {
                t.internal.acroformPlugin.acroFormDictionaryRoot.objId = void 0;
                var _$e = t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;
                for(var _$r in _$e)if (_$e.hasOwnProperty(_$r)) {
                    var n = _$e[_$r];
                    n.objId = void 0, n.hasAnnotation && $cbf54afc98507811$var$nt(n, t);
                }
            }(e);
        }), e.internal.events.subscribe("putCatalog", function() {
            !function(t) {
                if (void 0 === t.internal.acroformPlugin.acroFormDictionaryRoot) throw new Error("putCatalogCallback: Root missing.");
                t.internal.write("/AcroForm " + t.internal.acroformPlugin.acroFormDictionaryRoot.objId + " 0 R");
            }(e);
        }), e.internal.events.subscribe("postPutPages", function(r) {
            !function(e, r) {
                var n = !e;
                for(var _$i in e || (r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId, !0), r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()), e = e || r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if (e.hasOwnProperty(_$i)) {
                    var a = e[_$i], o = [], s = a.Rect;
                    if (a.Rect && (a.Rect = $cbf54afc98507811$var$$(a.Rect, r)), r.internal.newObjectDeferredBegin(a.objId, !0), a.DA = $cbf54afc98507811$export$7d753ad993606f45.createDefaultAppearanceStream(a), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(a) && "function" == typeof a.getKeyValueListForStream && (o = a.getKeyValueListForStream()), a.Rect = s, a.hasAppearanceStream && !a.appearanceStreamContent) {
                        var c = $cbf54afc98507811$var$Q(a);
                        o.push({
                            key: "AP",
                            value: "<</N " + c + ">>"
                        }), r.internal.acroformPlugin.xForms.push(c);
                    }
                    if (a.appearanceStreamContent) {
                        var u = "";
                        for(var h in a.appearanceStreamContent)if (a.appearanceStreamContent.hasOwnProperty(h)) {
                            var l = a.appearanceStreamContent[h];
                            if (u += "/" + h + " ", u += "<<", Object.keys(l).length >= 1 || Array.isArray(l)) {
                                for(var _$i in l)if (l.hasOwnProperty(_$i)) {
                                    var f = l[_$i];
                                    "function" == typeof f && (f = f.call(r, a)), u += "/" + _$i + " " + f + " ", r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                                }
                            } else "function" == typeof (f = l) && (f = f.call(r, a)), u += "/" + _$i + " " + f, r.internal.acroformPlugin.xForms.indexOf(f) >= 0 || r.internal.acroformPlugin.xForms.push(f);
                            u += ">>";
                        }
                        o.push({
                            key: "AP",
                            value: "<<\n" + u + ">>"
                        });
                    }
                    r.internal.putStream({
                        additionalKeyValues: o,
                        objectId: a.objId
                    }), r.internal.out("endobj");
                }
                n && $cbf54afc98507811$var$it(r.internal.acroformPlugin.xForms, r);
            }(r, e);
        }), e.internal.acroformPlugin.isInitialized = !0;
    }
}, $cbf54afc98507811$var$ot = $cbf54afc98507811$var$q.__acroform__.arrayToPdfArray = function ot(e, r, n) {
    var _$i = function i(t) {
        return t;
    };
    if (Array.isArray(e)) {
        for(var a = "[", o = 0; o < e.length; o++)switch(0 !== o && (a += " "), (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e[o])){
            case "boolean":
            case "number":
            case "object":
                a += e[o].toString();
                break;
            case "string":
                "/" !== e[o].substr(0, 1) ? (void 0 !== r && n && (_$i = n.internal.getEncryptor(r)), a += "(" + $cbf54afc98507811$var$R(_$i(e[o].toString())) + ")") : a += e[o].toString();
        }
        return a += "]";
    }
    throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray");
};
var $cbf54afc98507811$var$st = function st(t, e, r) {
    var n = function n(t) {
        return t;
    };
    return void 0 !== e && r && (n = r.internal.getEncryptor(e)), (t = t || "").toString(), t = "(" + $cbf54afc98507811$var$R(n(t)) + ")";
}, $cbf54afc98507811$var$ct = function ct() {
    this._objId = void 0, this._scope = void 0, Object.defineProperty(this, "objId", {
        get: function get() {
            if (void 0 === this._objId) {
                if (void 0 === this.scope) return;
                this._objId = this.scope.internal.newObjectDeferred();
            }
            return this._objId;
        },
        set: function set(t) {
            this._objId = t;
        }
    }), Object.defineProperty(this, "scope", {
        value: this._scope,
        writable: !0
    });
};
$cbf54afc98507811$var$ct.prototype.toString = function() {
    return this.objId + " 0 R";
}, $cbf54afc98507811$var$ct.prototype.putStream = function() {
    var _$t = this.getKeyValueListForStream();
    this.scope.internal.putStream({
        data: this.stream,
        additionalKeyValues: _$t,
        objectId: this.objId
    }), this.scope.internal.out("endobj");
}, $cbf54afc98507811$var$ct.prototype.getKeyValueListForStream = function() {
    var _$t = [], e = Object.getOwnPropertyNames(this).filter(function(t) {
        return "content" != t && "appearanceStreamContent" != t && "scope" != t && "objId" != t && "_" != t.substring(0, 1);
    });
    for(var r in e)if (!1 === Object.getOwnPropertyDescriptor(this, e[r]).configurable) {
        var n = e[r], _$i = this[n];
        _$i && (Array.isArray(_$i) ? _$t.push({
            key: n,
            value: $cbf54afc98507811$var$ot(_$i, this.objId, this.scope)
        }) : _$i instanceof $cbf54afc98507811$var$ct ? (_$i.scope = this.scope, _$t.push({
            key: n,
            value: _$i.objId + " 0 R"
        })) : "function" != typeof _$i && _$t.push({
            key: n,
            value: _$i
        }));
    }
    return _$t;
};
var $cbf54afc98507811$var$ut = function ut() {
    $cbf54afc98507811$var$ct.call(this), Object.defineProperty(this, "Type", {
        value: "/XObject",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "Subtype", {
        value: "/Form",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "FormType", {
        value: 1,
        configurable: !1,
        writable: !0
    });
    var _$t, e = [];
    Object.defineProperty(this, "BBox", {
        configurable: !1,
        get: function get() {
            return e;
        },
        set: function set(t) {
            e = t;
        }
    }), Object.defineProperty(this, "Resources", {
        value: "2 0 R",
        configurable: !1,
        writable: !0
    }), Object.defineProperty(this, "stream", {
        enumerable: !1,
        configurable: !0,
        set: function set(e) {
            _$t = e.trim();
        },
        get: function get() {
            return _$t || null;
        }
    });
};
$cbf54afc98507811$var$H($cbf54afc98507811$var$ut, $cbf54afc98507811$var$ct);
var $cbf54afc98507811$var$ht = function ht() {
    $cbf54afc98507811$var$ct.call(this);
    var _$t, e = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !1,
        configurable: !0,
        get: function get() {
            return e.length > 0 ? e : void 0;
        }
    }), Object.defineProperty(this, "Fields", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            return e;
        }
    }), Object.defineProperty(this, "DA", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            if (_$t) {
                var e = function e(t) {
                    return t;
                };
                return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $cbf54afc98507811$var$R(e(_$t)) + ")";
            }
        },
        set: function set(e) {
            _$t = e;
        }
    });
};
$cbf54afc98507811$var$H($cbf54afc98507811$var$ht, $cbf54afc98507811$var$ct);
var $cbf54afc98507811$var$lt = function t() {
    $cbf54afc98507811$var$ct.call(this);
    var e = 4;
    Object.defineProperty(this, "F", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            return e;
        },
        set: function set(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute F supplied.');
            e = t;
        }
    }), Object.defineProperty(this, "showWhenPrinted", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(e, 3));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.F = $cbf54afc98507811$var$K(e, 3) : this.F = $cbf54afc98507811$var$Z(e, 3);
        }
    });
    var r = 0;
    Object.defineProperty(this, "Ff", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            return r;
        },
        set: function set(t) {
            if (isNaN(t)) throw new Error('Invalid value "' + t + '" for attribute Ff supplied.');
            r = t;
        }
    });
    var n = [];
    Object.defineProperty(this, "Rect", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            if (0 !== n.length) return n;
        },
        set: function set(t) {
            n = void 0 !== t ? t : [];
        }
    }), Object.defineProperty(this, "x", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return !n || isNaN(n[0]) ? 0 : n[0];
        },
        set: function set(t) {
            n[0] = t;
        }
    }), Object.defineProperty(this, "y", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return !n || isNaN(n[1]) ? 0 : n[1];
        },
        set: function set(t) {
            n[1] = t;
        }
    }), Object.defineProperty(this, "width", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return !n || isNaN(n[2]) ? 0 : n[2];
        },
        set: function set(t) {
            n[2] = t;
        }
    }), Object.defineProperty(this, "height", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return !n || isNaN(n[3]) ? 0 : n[3];
        },
        set: function set(t) {
            n[3] = t;
        }
    });
    var _$i = "";
    Object.defineProperty(this, "FT", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            return _$i;
        },
        set: function set(t) {
            switch(t){
                case "/Btn":
                case "/Tx":
                case "/Ch":
                case "/Sig":
                    _$i = t;
                    break;
                default:
                    throw new Error('Invalid value "' + t + '" for attribute FT supplied.');
            }
        }
    });
    var a = null;
    Object.defineProperty(this, "T", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            if (!a || a.length < 1) {
                if (this instanceof $cbf54afc98507811$var$yt) return;
                a = "FieldObject" + t.FieldNum++;
            }
            var e = function e(t) {
                return t;
            };
            return this.scope && (e = this.scope.internal.getEncryptor(this.objId)), "(" + $cbf54afc98507811$var$R(e(a)) + ")";
        },
        set: function set(t) {
            a = t.toString();
        }
    }), Object.defineProperty(this, "fieldName", {
        configurable: !0,
        enumerable: !0,
        get: function get() {
            return a;
        },
        set: function set(t) {
            a = t;
        }
    });
    var o = "helvetica";
    Object.defineProperty(this, "fontName", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return o;
        },
        set: function set(t) {
            o = t;
        }
    });
    var s = "normal";
    Object.defineProperty(this, "fontStyle", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return s;
        },
        set: function set(t) {
            s = t;
        }
    });
    var c = 0;
    Object.defineProperty(this, "fontSize", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return c;
        },
        set: function set(t) {
            c = t;
        }
    });
    var u = void 0;
    Object.defineProperty(this, "maxFontSize", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return void 0 === u ? 50 / $cbf54afc98507811$var$D : u;
        },
        set: function set(t) {
            u = t;
        }
    });
    var h = "black";
    Object.defineProperty(this, "color", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return h;
        },
        set: function set(t) {
            h = t;
        }
    });
    var l = "/F1 0 Tf 0 g";
    Object.defineProperty(this, "DA", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            if (!(!l || this instanceof $cbf54afc98507811$var$yt || this instanceof $cbf54afc98507811$export$9d1b52e7fab50c84)) return $cbf54afc98507811$var$st(l, this.objId, this.scope);
        },
        set: function set(t) {
            t = t.toString(), l = t;
        }
    });
    var f = null;
    Object.defineProperty(this, "DV", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            if (f) return this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !1 ? $cbf54afc98507811$var$st(f, this.objId, this.scope) : f;
        },
        set: function set(t) {
            t = t.toString(), f = this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $cbf54afc98507811$var$T(t.substr(1, t.length - 2)) : $cbf54afc98507811$var$T(t) : t;
        }
    }), Object.defineProperty(this, "defaultValue", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !0 ? $cbf54afc98507811$var$T(f.substr(1, f.length - 1)) : f;
        },
        set: function set(t) {
            t = t.toString(), f = this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    });
    var d = null;
    Object.defineProperty(this, "_V", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            if (d) return d;
        },
        set: function set(t) {
            this.V = t;
        }
    }), Object.defineProperty(this, "V", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            if (d) return this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !1 ? $cbf54afc98507811$var$st(d, this.objId, this.scope) : d;
        },
        set: function set(t) {
            t = t.toString(), d = this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !1 ? "(" === t.substr(0, 1) ? $cbf54afc98507811$var$T(t.substr(1, t.length - 2)) : $cbf54afc98507811$var$T(t) : t;
        }
    }), Object.defineProperty(this, "value", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !0 ? $cbf54afc98507811$var$T(d.substr(1, d.length - 1)) : d;
        },
        set: function set(t) {
            t = t.toString(), d = this instanceof $cbf54afc98507811$export$6aae594af76bbb7b == !0 ? "/" + t : t;
        }
    }), Object.defineProperty(this, "hasAnnotation", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return this.Rect;
        }
    }), Object.defineProperty(this, "Type", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            return this.hasAnnotation ? "/Annot" : null;
        }
    }), Object.defineProperty(this, "Subtype", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            return this.hasAnnotation ? "/Widget" : null;
        }
    });
    var p, g = !1;
    Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return g;
        },
        set: function set(t) {
            t = Boolean(t), g = t;
        }
    }), Object.defineProperty(this, "page", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            if (p) return p;
        },
        set: function set(t) {
            p = t;
        }
    }), Object.defineProperty(this, "readOnly", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 1));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 1) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 1);
        }
    }), Object.defineProperty(this, "required", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 2));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 2) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 2);
        }
    }), Object.defineProperty(this, "noExport", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 3));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 3) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 3);
        }
    });
    var m = null;
    Object.defineProperty(this, "Q", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            if (null !== m) return m;
        },
        set: function set(t) {
            if (-1 === [
                0,
                1,
                2
            ].indexOf(t)) throw new Error('Invalid value "' + t + '" for attribute Q supplied.');
            m = t;
        }
    }), Object.defineProperty(this, "textAlign", {
        get: function get() {
            var _$t;
            switch(m){
                case 0:
                default:
                    _$t = "left";
                    break;
                case 1:
                    _$t = "center";
                    break;
                case 2:
                    _$t = "right";
            }
            return _$t;
        },
        configurable: !0,
        enumerable: !0,
        set: function set(t) {
            switch(t){
                case "right":
                case 2:
                    m = 2;
                    break;
                case "center":
                case 1:
                    m = 1;
                    break;
                case "left":
                case 0:
                default:
                    m = 0;
            }
        }
    });
};
$cbf54afc98507811$var$H($cbf54afc98507811$var$lt, $cbf54afc98507811$var$ct);
var $cbf54afc98507811$export$a47202eb3f827bb2 = function ft() {
    $cbf54afc98507811$var$lt.call(this), this.FT = "/Ch", this.V = "()", this.fontName = "zapfdingbats";
    var _$t = 0;
    Object.defineProperty(this, "TI", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            return _$t;
        },
        set: function set(e) {
            _$t = e;
        }
    }), Object.defineProperty(this, "topIndex", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return _$t;
        },
        set: function set(e) {
            _$t = e;
        }
    });
    var e = [];
    Object.defineProperty(this, "Opt", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            return $cbf54afc98507811$var$ot(e, this.objId, this.scope);
        },
        set: function set(t) {
            var r, n;
            n = [], "string" == typeof (r = t) && (n = function(t, e, r) {
                r || (r = 1);
                for(var n, _$i = []; n = e.exec(t);)_$i.push(n[r]);
                return _$i;
            }(r, /\((.*?)\)/g)), e = n;
        }
    }), this.getOptions = function() {
        return e;
    }, this.setOptions = function(t) {
        e = t, this.sort && e.sort();
    }, this.addOption = function(t) {
        t = (t = t || "").toString(), e.push(t), this.sort && e.sort();
    }, this.removeOption = function(t, r) {
        for(r = r || !1, t = (t = t || "").toString(); -1 !== e.indexOf(t) && (e.splice(e.indexOf(t), 1), !1 !== r););
    }, Object.defineProperty(this, "combo", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 18));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 18) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 18);
        }
    }), Object.defineProperty(this, "edit", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 19));
        },
        set: function set(t) {
            !0 === this.combo && (!0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 19) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 19));
        }
    }), Object.defineProperty(this, "sort", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 20));
        },
        set: function set(t) {
            !0 === Boolean(t) ? (this.Ff = $cbf54afc98507811$var$K(this.Ff, 20), e.sort()) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 20);
        }
    }), Object.defineProperty(this, "multiSelect", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 22));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 22) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 22);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 23));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 23) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "commitOnSelChange", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 27));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 27) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 27);
        }
    }), this.hasAppearanceStream = !1;
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$a47202eb3f827bb2, $cbf54afc98507811$var$lt);
var $cbf54afc98507811$export$9e021dd9568dc486 = function dt() {
    $cbf54afc98507811$export$a47202eb3f827bb2.call(this), this.fontName = "helvetica", this.combo = !1;
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$9e021dd9568dc486, $cbf54afc98507811$export$a47202eb3f827bb2);
var $cbf54afc98507811$export$f2239d28df5f43bd = function pt() {
    $cbf54afc98507811$export$9e021dd9568dc486.call(this), this.combo = !0;
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$f2239d28df5f43bd, $cbf54afc98507811$export$9e021dd9568dc486);
var $cbf54afc98507811$export$4af052e7e598ad1a = function gt() {
    $cbf54afc98507811$export$f2239d28df5f43bd.call(this), this.edit = !0;
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$4af052e7e598ad1a, $cbf54afc98507811$export$f2239d28df5f43bd);
var $cbf54afc98507811$export$6aae594af76bbb7b = function mt() {
    $cbf54afc98507811$var$lt.call(this), this.FT = "/Btn", Object.defineProperty(this, "noToggleToOff", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 15));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 15) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 15);
        }
    }), Object.defineProperty(this, "radio", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 16));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 16) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 16);
        }
    }), Object.defineProperty(this, "pushButton", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 17));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 17) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 17);
        }
    }), Object.defineProperty(this, "radioIsUnison", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 26));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 26) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 26);
        }
    });
    var e, r = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            var _$t = function t(_t) {
                return _t;
            };
            if (this.scope && (_$t = this.scope.internal.getEncryptor(this.objId)), 0 !== Object.keys(r).length) {
                var e, n = [];
                for(e in n.push("<<"), r)n.push("/" + e + " (" + $cbf54afc98507811$var$R(_$t(r[e])) + ")");
                return n.push(">>"), n.join("\n");
            }
        },
        set: function set(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e) && (r = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return r.CA || "";
        },
        set: function set(t) {
            "string" == typeof t && (r.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            return e;
        },
        set: function set(t) {
            e = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return e.substr(1, e.length - 1);
        },
        set: function set(t) {
            e = "/" + t;
        }
    });
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$6aae594af76bbb7b, $cbf54afc98507811$var$lt);
var $cbf54afc98507811$export$98b7c3ef37465410 = function vt() {
    $cbf54afc98507811$export$6aae594af76bbb7b.call(this), this.pushButton = !0;
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$98b7c3ef37465410, $cbf54afc98507811$export$6aae594af76bbb7b);
var $cbf54afc98507811$export$bc1318bc7e5f1315 = function bt() {
    $cbf54afc98507811$export$6aae594af76bbb7b.call(this), this.radio = !0, this.pushButton = !1;
    var _$t = [];
    Object.defineProperty(this, "Kids", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            return _$t;
        },
        set: function set(e) {
            _$t = void 0 !== e ? e : [];
        }
    });
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$bc1318bc7e5f1315, $cbf54afc98507811$export$6aae594af76bbb7b);
var $cbf54afc98507811$var$yt = function yt() {
    var e, r;
    $cbf54afc98507811$var$lt.call(this), Object.defineProperty(this, "Parent", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            return e;
        },
        set: function set(t) {
            e = t;
        }
    }), Object.defineProperty(this, "optionName", {
        enumerable: !1,
        configurable: !0,
        get: function get() {
            return r;
        },
        set: function set(t) {
            r = t;
        }
    });
    var n, _$i = {};
    Object.defineProperty(this, "MK", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            var _$t = function t(_t) {
                return _t;
            };
            this.scope && (_$t = this.scope.internal.getEncryptor(this.objId));
            var e, r = [];
            for(e in r.push("<<"), _$i)r.push("/" + e + " (" + $cbf54afc98507811$var$R(_$t(_$i[e])) + ")");
            return r.push(">>"), r.join("\n");
        },
        set: function set(e) {
            "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e) && (_$i = e);
        }
    }), Object.defineProperty(this, "caption", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return _$i.CA || "";
        },
        set: function set(t) {
            "string" == typeof t && (_$i.CA = t);
        }
    }), Object.defineProperty(this, "AS", {
        enumerable: !1,
        configurable: !1,
        get: function get() {
            return n;
        },
        set: function set(t) {
            n = t;
        }
    }), Object.defineProperty(this, "appearanceState", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return n.substr(1, n.length - 1);
        },
        set: function set(t) {
            n = "/" + t;
        }
    }), this.caption = "l", this.appearanceState = "Off", this._AppearanceType = $cbf54afc98507811$export$7d753ad993606f45.RadioButton.Circle, this.appearanceStreamContent = this._AppearanceType.createAppearanceStream(this.optionName);
};
$cbf54afc98507811$var$H($cbf54afc98507811$var$yt, $cbf54afc98507811$var$lt), $cbf54afc98507811$export$bc1318bc7e5f1315.prototype.setAppearance = function(t) {
    if (!("createAppearanceStream" in t) || !("getCA" in t)) throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");
    for(var e in this.Kids)if (this.Kids.hasOwnProperty(e)) {
        var r = this.Kids[e];
        r.appearanceStreamContent = t.createAppearanceStream(r.optionName), r.caption = t.getCA();
    }
}, $cbf54afc98507811$export$bc1318bc7e5f1315.prototype.createOption = function(t) {
    var e = new $cbf54afc98507811$var$yt;
    return e.Parent = this, e.optionName = t, this.Kids.push(e), $cbf54afc98507811$var$xt.call(this.scope, e), e;
};
var $cbf54afc98507811$export$5fd5db01c4615478 = function wt() {
    $cbf54afc98507811$export$6aae594af76bbb7b.call(this), this.fontName = "zapfdingbats", this.caption = "3", this.appearanceState = "On", this.value = "On", this.textAlign = "center", this.appearanceStreamContent = $cbf54afc98507811$export$7d753ad993606f45.CheckBox.createAppearanceStream();
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$5fd5db01c4615478, $cbf54afc98507811$export$6aae594af76bbb7b);
var $cbf54afc98507811$export$9d1b52e7fab50c84 = function Nt() {
    $cbf54afc98507811$var$lt.call(this), this.FT = "/Tx", Object.defineProperty(this, "multiline", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 13));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 13) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 13);
        }
    }), Object.defineProperty(this, "fileSelect", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 21));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 21) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 21);
        }
    }), Object.defineProperty(this, "doNotSpellCheck", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 23));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 23) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 23);
        }
    }), Object.defineProperty(this, "doNotScroll", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 24));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 24) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 24);
        }
    }), Object.defineProperty(this, "comb", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 25));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 25) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 25);
        }
    }), Object.defineProperty(this, "richText", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 26));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 26) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 26);
        }
    });
    var _$t = null;
    Object.defineProperty(this, "MaxLen", {
        enumerable: !0,
        configurable: !1,
        get: function get() {
            return _$t;
        },
        set: function set(e) {
            _$t = e;
        }
    }), Object.defineProperty(this, "maxLength", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return _$t;
        },
        set: function set(e) {
            Number.isInteger(e) && (_$t = e);
        }
    }), Object.defineProperty(this, "hasAppearanceStream", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return this.V || this.DV;
        }
    });
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$9d1b52e7fab50c84, $cbf54afc98507811$var$lt);
var $cbf54afc98507811$export$c48d8668f8cea64d = function Lt() {
    $cbf54afc98507811$export$9d1b52e7fab50c84.call(this), Object.defineProperty(this, "password", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
            return Boolean($cbf54afc98507811$var$X(this.Ff, 14));
        },
        set: function set(t) {
            !0 === Boolean(t) ? this.Ff = $cbf54afc98507811$var$K(this.Ff, 14) : this.Ff = $cbf54afc98507811$var$Z(this.Ff, 14);
        }
    }), this.password = !0;
};
$cbf54afc98507811$var$H($cbf54afc98507811$export$c48d8668f8cea64d, $cbf54afc98507811$export$9d1b52e7fab50c84);
var $cbf54afc98507811$export$7d753ad993606f45 = {
    CheckBox: {
        createAppearanceStream: function createAppearanceStream() {
            return {
                N: {
                    On: $cbf54afc98507811$export$7d753ad993606f45.CheckBox.YesNormal
                },
                D: {
                    On: $cbf54afc98507811$export$7d753ad993606f45.CheckBox.YesPushDown,
                    Off: $cbf54afc98507811$export$7d753ad993606f45.CheckBox.OffPushDown
                }
            };
        },
        YesPushDown: function YesPushDown(t) {
            var e = $cbf54afc98507811$var$V(t);
            e.scope = t.scope;
            var r = [], n = t.scope.internal.getFont(t.fontName, t.fontStyle).id, _$i = t.scope.__private__.encodeColorString(t.color), a = $cbf54afc98507811$var$tt(t, t.caption);
            return r.push("0.749023 g"), r.push("0 0 " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t)) + " " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), r.push("BMC"), r.push("q"), r.push("0 0 1 rg"), r.push("/" + n + " " + $cbf54afc98507811$var$U(a.fontSize) + " Tf " + _$i), r.push("BT"), r.push(a.text), r.push("ET"), r.push("Q"), r.push("EMC"), e.stream = r.join("\n"), e;
        },
        YesNormal: function YesNormal(t) {
            var e = $cbf54afc98507811$var$V(t);
            e.scope = t.scope;
            var r = t.scope.internal.getFont(t.fontName, t.fontStyle).id, n = t.scope.__private__.encodeColorString(t.color), _$i = [], a = $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t), o = $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t), s = $cbf54afc98507811$var$tt(t, t.caption);
            return _$i.push("1 g"), _$i.push("0 0 " + $cbf54afc98507811$var$U(o) + " " + $cbf54afc98507811$var$U(a) + " re"), _$i.push("f"), _$i.push("q"), _$i.push("0 0 1 rg"), _$i.push("0 0 " + $cbf54afc98507811$var$U(o - 1) + " " + $cbf54afc98507811$var$U(a - 1) + " re"), _$i.push("W"), _$i.push("n"), _$i.push("0 g"), _$i.push("BT"), _$i.push("/" + r + " " + $cbf54afc98507811$var$U(s.fontSize) + " Tf " + n), _$i.push(s.text), _$i.push("ET"), _$i.push("Q"), e.stream = _$i.join("\n"), e;
        },
        OffPushDown: function OffPushDown(t) {
            var e = $cbf54afc98507811$var$V(t);
            e.scope = t.scope;
            var r = [];
            return r.push("0.749023 g"), r.push("0 0 " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t)) + " " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
        }
    },
    RadioButton: {
        Circle: {
            createAppearanceStream: function createAppearanceStream(t) {
                var e = {
                    D: {
                        Off: $cbf54afc98507811$export$7d753ad993606f45.RadioButton.Circle.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $cbf54afc98507811$export$7d753ad993606f45.RadioButton.Circle.YesNormal, e.D[t] = $cbf54afc98507811$export$7d753ad993606f45.RadioButton.Circle.YesPushDown, e;
            },
            getCA: function getCA() {
                return "l";
            },
            YesNormal: function YesNormal(t) {
                var e = $cbf54afc98507811$var$V(t);
                e.scope = t.scope;
                var r = [], n = $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) <= $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) ? $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) / 4 : $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var _$i = $cbf54afc98507811$export$7d753ad993606f45.internal.Bezier_C, a = Number((n * _$i).toFixed(5));
                return r.push("q"), r.push("1 0 0 1 " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + a + " " + a + " " + n + " 0 " + n + " c"), r.push("-" + a + " " + n + " -" + n + " " + a + " -" + n + " 0 c"), r.push("-" + n + " -" + a + " -" + a + " -" + n + " 0 -" + n + " c"), r.push(a + " -" + n + " " + n + " -" + a + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function YesPushDown(t) {
                var e = $cbf54afc98507811$var$V(t);
                e.scope = t.scope;
                var r = [], n = $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) <= $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) ? $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) / 4 : $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var _$i = Number((2 * n).toFixed(5)), a = Number((_$i * $cbf54afc98507811$export$7d753ad993606f45.internal.Bezier_C).toFixed(5)), o = Number((n * $cbf54afc98507811$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(_$i + " 0 m"), r.push(_$i + " " + a + " " + a + " " + _$i + " 0 " + _$i + " c"), r.push("-" + a + " " + _$i + " -" + _$i + " " + a + " -" + _$i + " 0 c"), r.push("-" + _$i + " -" + a + " -" + a + " -" + _$i + " 0 -" + _$i + " c"), r.push(a + " -" + _$i + " " + _$i + " -" + a + " " + _$i + " 0 c"), r.push("f"), r.push("Q"), r.push("0 g"), r.push("q"), r.push("1 0 0 1 " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(n + " 0 m"), r.push(n + " " + o + " " + o + " " + n + " 0 " + n + " c"), r.push("-" + o + " " + n + " -" + n + " " + o + " -" + n + " 0 c"), r.push("-" + n + " -" + o + " -" + o + " -" + n + " 0 -" + n + " c"), r.push(o + " -" + n + " " + n + " -" + o + " " + n + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            OffPushDown: function OffPushDown(t) {
                var e = $cbf54afc98507811$var$V(t);
                e.scope = t.scope;
                var r = [], n = $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) <= $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) ? $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) / 4 : $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) / 4;
                n = Number((.9 * n).toFixed(5));
                var _$i = Number((2 * n).toFixed(5)), a = Number((_$i * $cbf54afc98507811$export$7d753ad993606f45.internal.Bezier_C).toFixed(5));
                return r.push("0.749023 g"), r.push("q"), r.push("1 0 0 1 " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) / 2) + " " + $cbf54afc98507811$var$z($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) / 2) + " cm"), r.push(_$i + " 0 m"), r.push(_$i + " " + a + " " + a + " " + _$i + " 0 " + _$i + " c"), r.push("-" + a + " " + _$i + " -" + _$i + " " + a + " -" + _$i + " 0 c"), r.push("-" + _$i + " -" + a + " -" + a + " -" + _$i + " 0 -" + _$i + " c"), r.push(a + " -" + _$i + " " + _$i + " -" + a + " " + _$i + " 0 c"), r.push("f"), r.push("Q"), e.stream = r.join("\n"), e;
            }
        },
        Cross: {
            createAppearanceStream: function createAppearanceStream(t) {
                var e = {
                    D: {
                        Off: $cbf54afc98507811$export$7d753ad993606f45.RadioButton.Cross.OffPushDown
                    },
                    N: {}
                };
                return e.N[t] = $cbf54afc98507811$export$7d753ad993606f45.RadioButton.Cross.YesNormal, e.D[t] = $cbf54afc98507811$export$7d753ad993606f45.RadioButton.Cross.YesPushDown, e;
            },
            getCA: function getCA() {
                return "8";
            },
            YesNormal: function YesNormal(t) {
                var e = $cbf54afc98507811$var$V(t);
                e.scope = t.scope;
                var r = [], n = $cbf54afc98507811$export$7d753ad993606f45.internal.calculateCross(t);
                return r.push("q"), r.push("1 1 " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), r.push("W"), r.push("n"), r.push($cbf54afc98507811$var$U(n.x1.x) + " " + $cbf54afc98507811$var$U(n.x1.y) + " m"), r.push($cbf54afc98507811$var$U(n.x2.x) + " " + $cbf54afc98507811$var$U(n.x2.y) + " l"), r.push($cbf54afc98507811$var$U(n.x4.x) + " " + $cbf54afc98507811$var$U(n.x4.y) + " m"), r.push($cbf54afc98507811$var$U(n.x3.x) + " " + $cbf54afc98507811$var$U(n.x3.y) + " l"), r.push("s"), r.push("Q"), e.stream = r.join("\n"), e;
            },
            YesPushDown: function YesPushDown(t) {
                var e = $cbf54afc98507811$var$V(t);
                e.scope = t.scope;
                var r = $cbf54afc98507811$export$7d753ad993606f45.internal.calculateCross(t), n = [];
                return n.push("0.749023 g"), n.push("0 0 " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t)) + " " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t)) + " re"), n.push("f"), n.push("q"), n.push("1 1 " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t) - 2) + " " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t) - 2) + " re"), n.push("W"), n.push("n"), n.push($cbf54afc98507811$var$U(r.x1.x) + " " + $cbf54afc98507811$var$U(r.x1.y) + " m"), n.push($cbf54afc98507811$var$U(r.x2.x) + " " + $cbf54afc98507811$var$U(r.x2.y) + " l"), n.push($cbf54afc98507811$var$U(r.x4.x) + " " + $cbf54afc98507811$var$U(r.x4.y) + " m"), n.push($cbf54afc98507811$var$U(r.x3.x) + " " + $cbf54afc98507811$var$U(r.x3.y) + " l"), n.push("s"), n.push("Q"), e.stream = n.join("\n"), e;
            },
            OffPushDown: function OffPushDown(t) {
                var e = $cbf54afc98507811$var$V(t);
                e.scope = t.scope;
                var r = [];
                return r.push("0.749023 g"), r.push("0 0 " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t)) + " " + $cbf54afc98507811$var$U($cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t)) + " re"), r.push("f"), e.stream = r.join("\n"), e;
            }
        }
    },
    createDefaultAppearanceStream: function createDefaultAppearanceStream(t) {
        var e = t.scope.internal.getFont(t.fontName, t.fontStyle).id, r = t.scope.__private__.encodeColorString(t.color);
        return "/" + e + " " + t.fontSize + " Tf " + r;
    }
};
$cbf54afc98507811$export$7d753ad993606f45.internal = {
    Bezier_C: .551915024494,
    calculateCross: function calculateCross(t) {
        var e = $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth(t), r = $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight(t), n = Math.min(e, r);
        return {
            x1: {
                x: (e - n) / 2,
                y: (r - n) / 2 + n
            },
            x2: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2
            },
            x3: {
                x: (e - n) / 2,
                y: (r - n) / 2
            },
            x4: {
                x: (e - n) / 2 + n,
                y: (r - n) / 2 + n
            }
        };
    }
}, $cbf54afc98507811$export$7d753ad993606f45.internal.getWidth = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e) && (r = $cbf54afc98507811$var$W(e.Rect[2])), r;
}, $cbf54afc98507811$export$7d753ad993606f45.internal.getHeight = function(e) {
    var r = 0;
    return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e) && (r = $cbf54afc98507811$var$W(e.Rect[3])), r;
};
var $cbf54afc98507811$var$xt = $cbf54afc98507811$var$q.addField = function xt(t) {
    if ($cbf54afc98507811$var$at(this, t), !(t instanceof $cbf54afc98507811$var$lt)) throw new Error("Invalid argument passed to jsPDF.addField.");
    var e;
    return (e = t).scope.internal.acroformPlugin.printedOut && (e.scope.internal.acroformPlugin.printedOut = !1, e.scope.internal.acroformPlugin.acroFormDictionaryRoot = null), e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e), t.page = t.scope.internal.getCurrentPageInfo().pageNumber, this;
};
$cbf54afc98507811$var$q.AcroFormChoiceField = $cbf54afc98507811$export$a47202eb3f827bb2, $cbf54afc98507811$var$q.AcroFormListBox = $cbf54afc98507811$export$9e021dd9568dc486, $cbf54afc98507811$var$q.AcroFormComboBox = $cbf54afc98507811$export$f2239d28df5f43bd, $cbf54afc98507811$var$q.AcroFormEditBox = $cbf54afc98507811$export$4af052e7e598ad1a, $cbf54afc98507811$var$q.AcroFormButton = $cbf54afc98507811$export$6aae594af76bbb7b, $cbf54afc98507811$var$q.AcroFormPushButton = $cbf54afc98507811$export$98b7c3ef37465410, $cbf54afc98507811$var$q.AcroFormRadioButton = $cbf54afc98507811$export$bc1318bc7e5f1315, $cbf54afc98507811$var$q.AcroFormCheckBox = $cbf54afc98507811$export$5fd5db01c4615478, $cbf54afc98507811$var$q.AcroFormTextField = $cbf54afc98507811$export$9d1b52e7fab50c84, $cbf54afc98507811$var$q.AcroFormPasswordField = $cbf54afc98507811$export$c48d8668f8cea64d, $cbf54afc98507811$var$q.AcroFormAppearance = $cbf54afc98507811$export$7d753ad993606f45, $cbf54afc98507811$var$q.AcroForm = {
    ChoiceField: $cbf54afc98507811$export$a47202eb3f827bb2,
    ListBox: $cbf54afc98507811$export$9e021dd9568dc486,
    ComboBox: $cbf54afc98507811$export$f2239d28df5f43bd,
    EditBox: $cbf54afc98507811$export$4af052e7e598ad1a,
    Button: $cbf54afc98507811$export$6aae594af76bbb7b,
    PushButton: $cbf54afc98507811$export$98b7c3ef37465410,
    RadioButton: $cbf54afc98507811$export$bc1318bc7e5f1315,
    CheckBox: $cbf54afc98507811$export$5fd5db01c4615478,
    TextField: $cbf54afc98507811$export$9d1b52e7fab50c84,
    PasswordField: $cbf54afc98507811$export$c48d8668f8cea64d,
    Appearance: $cbf54afc98507811$export$7d753ad993606f45
}, $cbf54afc98507811$export$ba1e2ffc633a60f5.AcroForm = {
    ChoiceField: $cbf54afc98507811$export$a47202eb3f827bb2,
    ListBox: $cbf54afc98507811$export$9e021dd9568dc486,
    ComboBox: $cbf54afc98507811$export$f2239d28df5f43bd,
    EditBox: $cbf54afc98507811$export$4af052e7e598ad1a,
    Button: $cbf54afc98507811$export$6aae594af76bbb7b,
    PushButton: $cbf54afc98507811$export$98b7c3ef37465410,
    RadioButton: $cbf54afc98507811$export$bc1318bc7e5f1315,
    CheckBox: $cbf54afc98507811$export$5fd5db01c4615478,
    TextField: $cbf54afc98507811$export$9d1b52e7fab50c84,
    PasswordField: $cbf54afc98507811$export$c48d8668f8cea64d,
    Appearance: $cbf54afc98507811$export$7d753ad993606f45
};
var $cbf54afc98507811$export$9cf40f67b77f45f4 = $cbf54afc98507811$export$ba1e2ffc633a60f5.AcroForm;
function $cbf54afc98507811$var$_t(t) {
    return t.reduce(function(t, e, r) {
        return t[e] = r, t;
    }, {});
}
!function(e) {
    e.__addimage__ = {};
    var r = "UNKNOWN", n = {
        PNG: [
            [
                137,
                80,
                78,
                71
            ]
        ],
        TIFF: [
            [
                77,
                77,
                0,
                42
            ],
            [
                73,
                73,
                42,
                0
            ]
        ],
        JPEG: [
            [
                255,
                216,
                255,
                224,
                void 0,
                void 0,
                74,
                70,
                73,
                70,
                0
            ],
            [
                255,
                216,
                255,
                225,
                void 0,
                void 0,
                69,
                120,
                105,
                102,
                0,
                0
            ],
            [
                255,
                216,
                255,
                219
            ],
            [
                255,
                216,
                255,
                238
            ]
        ],
        JPEG2000: [
            [
                0,
                0,
                0,
                12,
                106,
                80,
                32,
                32
            ]
        ],
        GIF87a: [
            [
                71,
                73,
                70,
                56,
                55,
                97
            ]
        ],
        GIF89a: [
            [
                71,
                73,
                70,
                56,
                57,
                97
            ]
        ],
        WEBP: [
            [
                82,
                73,
                70,
                70,
                void 0,
                void 0,
                void 0,
                void 0,
                87,
                69,
                66,
                80
            ]
        ],
        BMP: [
            [
                66,
                77
            ],
            [
                66,
                65
            ],
            [
                67,
                73
            ],
            [
                67,
                80
            ],
            [
                73,
                67
            ],
            [
                80,
                84
            ]
        ]
    }, _$i = e.__addimage__.getImageFileTypeByImageData = function i(t, e) {
        var _$i, a, o, s, c, u = r;
        if ("RGBA" === (e = e || r) || void 0 !== t.data && t.data instanceof Uint8ClampedArray && "height" in t && "width" in t) return "RGBA";
        if (x(t)) for(c in n)for(o = n[c], _$i = 0; _$i < o.length; _$i += 1){
            for(s = !0, a = 0; a < o[_$i].length; a += 1)if (void 0 !== o[_$i][a] && o[_$i][a] !== t[a]) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        else for(c in n)for(o = n[c], _$i = 0; _$i < o.length; _$i += 1){
            for(s = !0, a = 0; a < o[_$i].length; a += 1)if (void 0 !== o[_$i][a] && o[_$i][a] !== t.charCodeAt(a)) {
                s = !1;
                break;
            }
            if (!0 === s) {
                u = c;
                break;
            }
        }
        return u === r && e !== r && (u = e), u;
    }, a = function t(e) {
        for(var r = this.internal.write, n = this.internal.putStream, _$i = (0, this.internal.getFilters)(); -1 !== _$i.indexOf("FlateEncode");)_$i.splice(_$i.indexOf("FlateEncode"), 1);
        e.objectId = this.internal.newObject();
        var a = [];
        if (a.push({
            key: "Type",
            value: "/XObject"
        }), a.push({
            key: "Subtype",
            value: "/Image"
        }), a.push({
            key: "Width",
            value: e.width
        }), a.push({
            key: "Height",
            value: e.height
        }), e.colorSpace === b.INDEXED ? a.push({
            key: "ColorSpace",
            value: "[/Indexed /DeviceRGB " + (e.palette.length / 3 - 1) + " " + ("sMask" in e && void 0 !== e.sMask ? e.objectId + 2 : e.objectId + 1) + " 0 R]"
        }) : (a.push({
            key: "ColorSpace",
            value: "/" + e.colorSpace
        }), e.colorSpace === b.DEVICE_CMYK && a.push({
            key: "Decode",
            value: "[1 0 1 0 1 0 1 0]"
        })), a.push({
            key: "BitsPerComponent",
            value: e.bitsPerComponent
        }), "decodeParameters" in e && void 0 !== e.decodeParameters && a.push({
            key: "DecodeParms",
            value: "<<" + e.decodeParameters + ">>"
        }), "transparency" in e && Array.isArray(e.transparency)) {
            for(var o = "", s = 0, c = e.transparency.length; s < c; s++)o += e.transparency[s] + " " + e.transparency[s] + " ";
            a.push({
                key: "Mask",
                value: "[" + o + "]"
            });
        }
        void 0 !== e.sMask && a.push({
            key: "SMask",
            value: e.objectId + 1 + " 0 R"
        });
        var u = void 0 !== e.filter ? [
            "/" + e.filter
        ] : void 0;
        if (n({
            data: e.data,
            additionalKeyValues: a,
            alreadyAppliedFilters: u,
            objectId: e.objectId
        }), r("endobj"), "sMask" in e && void 0 !== e.sMask) {
            var h = "/Predictor " + e.predictor + " /Colors 1 /BitsPerComponent " + e.bitsPerComponent + " /Columns " + e.width, l = {
                width: e.width,
                height: e.height,
                colorSpace: "DeviceGray",
                bitsPerComponent: e.bitsPerComponent,
                decodeParameters: h,
                data: e.sMask
            };
            "filter" in e && (l.filter = e.filter), t.call(this, l);
        }
        if (e.colorSpace === b.INDEXED) {
            var f = this.internal.newObject();
            n({
                data: _(new Uint8Array(e.palette)),
                objectId: f
            }), r("endobj");
        }
    }, o = function o() {
        var _$t = this.internal.collections.addImage_images;
        for(var _$e in _$t)a.call(this, _$t[_$e]);
    }, s = function s() {
        var _$t, _$e = this.internal.collections.addImage_images, r = this.internal.write;
        for(var n in _$e)r("/I" + (_$t = _$e[n]).index, _$t.objectId, "0", "R");
    }, c = function c() {
        this.internal.collections.addImage_images || (this.internal.collections.addImage_images = {}, this.internal.events.subscribe("putResources", o), this.internal.events.subscribe("putXobjectDict", s));
    }, h = function h() {
        var _$t = this.internal.collections.addImage_images;
        return c.call(this), _$t;
    }, l = function l() {
        return Object.keys(this.internal.collections.addImage_images).length;
    }, f = function f(t) {
        return "function" == typeof e["process" + t.toUpperCase()];
    }, d = function d(e) {
        return "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e) && 1 === e.nodeType;
    }, p = function p(t, r) {
        if ("IMG" === t.nodeName && t.hasAttribute("src")) {
            var n = "" + t.getAttribute("src");
            if (0 === n.indexOf("data:image/")) return $cbf54afc98507811$var$u(unescape(n).split("base64,").pop());
            var _$i = e.loadFile(n, !0);
            if (void 0 !== _$i) return _$i;
        }
        if ("CANVAS" === t.nodeName) {
            if (0 === t.width || 0 === t.height) throw new Error("Given canvas must have data. Canvas width: " + t.width + ", height: " + t.height);
            var a;
            switch(r){
                case "PNG":
                    a = "image/png";
                    break;
                case "WEBP":
                    a = "image/webp";
                    break;
                case "JPEG":
                case "JPG":
                default:
                    a = "image/jpeg";
            }
            return $cbf54afc98507811$var$u(t.toDataURL(a, 1).split("base64,").pop());
        }
    }, g = function g(t) {
        var _$e = this.internal.collections.addImage_images;
        if (_$e) {
            for(var r in _$e)if (t === _$e[r].alias) return _$e[r];
        }
    }, m = function m(t, e, r) {
        return t || e || (t = -96, e = -96), t < 0 && (t = -1 * r.width * 72 / t / this.internal.scaleFactor), e < 0 && (e = -1 * r.height * 72 / e / this.internal.scaleFactor), 0 === t && (t = e * r.width / r.height), 0 === e && (e = t * r.height / r.width), [
            t,
            e
        ];
    }, v = function v(t, e, r, n, i, a) {
        var o = m.call(this, r, n, i), s = this.internal.getCoordinateString, c = this.internal.getVerticalCoordinateString, u = h.call(this);
        if (r = o[0], n = o[1], u[i.index] = i, a) {
            a *= Math.PI / 180;
            var l = Math.cos(a), f = Math.sin(a), d = function d(t) {
                return t.toFixed(4);
            }, p = [
                d(l),
                d(f),
                d(-1 * f),
                d(l),
                0,
                0,
                "cm"
            ];
        }
        this.internal.write("q"), a ? (this.internal.write([
            1,
            "0",
            "0",
            1,
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.internal.write(p.join(" ")), this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            "0",
            "0",
            "cm"
        ].join(" "))) : this.internal.write([
            s(r),
            "0",
            "0",
            s(n),
            s(t),
            c(e + n),
            "cm"
        ].join(" ")), this.isAdvancedAPI() && this.internal.write([
            1,
            0,
            0,
            -1,
            0,
            0,
            "cm"
        ].join(" ")), this.internal.write("/I" + i.index + " Do"), this.internal.write("Q");
    }, b = e.color_spaces = {
        DEVICE_RGB: "DeviceRGB",
        DEVICE_GRAY: "DeviceGray",
        DEVICE_CMYK: "DeviceCMYK",
        CAL_GREY: "CalGray",
        CAL_RGB: "CalRGB",
        LAB: "Lab",
        ICC_BASED: "ICCBased",
        INDEXED: "Indexed",
        PATTERN: "Pattern",
        SEPARATION: "Separation",
        DEVICE_N: "DeviceN"
    };
    e.decode = {
        DCT_DECODE: "DCTDecode",
        FLATE_DECODE: "FlateDecode",
        LZW_DECODE: "LZWDecode",
        JPX_DECODE: "JPXDecode",
        JBIG2_DECODE: "JBIG2Decode",
        ASCII85_DECODE: "ASCII85Decode",
        ASCII_HEX_DECODE: "ASCIIHexDecode",
        RUN_LENGTH_DECODE: "RunLengthDecode",
        CCITT_FAX_DECODE: "CCITTFaxDecode"
    };
    var _$y = e.image_compression = {
        NONE: "NONE",
        FAST: "FAST",
        MEDIUM: "MEDIUM",
        SLOW: "SLOW"
    }, w = e.__addimage__.sHashCode = function w(t) {
        var _$e, r, n = 0;
        if ("string" == typeof t) for(r = t.length, _$e = 0; _$e < r; _$e++)n = (n << 5) - n + t.charCodeAt(_$e), n |= 0;
        else if (x(t)) for(r = t.byteLength / 2, _$e = 0; _$e < r; _$e++)n = (n << 5) - n + t[_$e], n |= 0;
        return n;
    }, N = e.__addimage__.validateStringAsBase64 = function N(t) {
        (t = t || "").toString().trim();
        var _$e = !0;
        return 0 === t.length && (_$e = !1), t.length % 4 != 0 && (_$e = !1), !1 === /^[A-Za-z0-9+/]+$/.test(t.substr(0, t.length - 2)) && (_$e = !1), !1 === /^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2)) && (_$e = !1), _$e;
    }, L = e.__addimage__.extractImageFromDataUrl = function L(t) {
        var _$e = (t = t || "").split("base64,"), r = null;
        if (2 === _$e.length) {
            var n = /^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(_$e[0]);
            Array.isArray(n) && (r = {
                mimeType: n[1],
                charset: n[2],
                data: _$e[1]
            });
        }
        return r;
    }, A = e.__addimage__.supportsArrayBuffer = function A() {
        return "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array;
    };
    e.__addimage__.isArrayBuffer = function(t) {
        return A() && t instanceof ArrayBuffer;
    };
    var x = e.__addimage__.isArrayBufferView = function x(t) {
        return A() && "undefined" != typeof Uint32Array && (t instanceof Int8Array || t instanceof Uint8Array || "undefined" != typeof Uint8ClampedArray && t instanceof Uint8ClampedArray || t instanceof Int16Array || t instanceof Uint16Array || t instanceof Int32Array || t instanceof Uint32Array || t instanceof Float32Array || t instanceof Float64Array);
    }, S = e.__addimage__.binaryStringToUint8Array = function S(t) {
        for(var _$e = t.length, r = new Uint8Array(_$e), n = 0; n < _$e; n++)r[n] = t.charCodeAt(n);
        return r;
    }, _ = e.__addimage__.arrayBufferToBinaryString = function _(t) {
        for(var _$e = "", r = x(t) ? t : new Uint8Array(t), n = 0; n < r.length; n += 8192)_$e += String.fromCharCode.apply(null, r.subarray(n, n + 8192));
        return _$e;
    };
    e.addImage = function() {
        var _$e, n, _$i, a, o, s, u, h, l;
        if ("number" == typeof arguments[1] ? (n = r, _$i = arguments[1], a = arguments[2], o = arguments[3], s = arguments[4], u = arguments[5], h = arguments[6], l = arguments[7]) : (n = arguments[1], _$i = arguments[2], a = arguments[3], o = arguments[4], s = arguments[5], u = arguments[6], h = arguments[7], l = arguments[8]), "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(_$e = arguments[0]) && !d(_$e) && "imageData" in _$e) {
            var f = _$e;
            _$e = f.imageData, n = f.format || n || r, _$i = f.x || _$i || 0, a = f.y || a || 0, o = f.w || f.width || o, s = f.h || f.height || s, u = f.alias || u, h = f.compression || h, l = f.rotation || f.angle || l;
        }
        var p = this.internal.getFilters();
        if (void 0 === h && -1 !== p.indexOf("FlateEncode") && (h = "SLOW"), isNaN(_$i) || isNaN(a)) throw new Error("Invalid coordinates passed to jsPDF.addImage");
        c.call(this);
        var g = P.call(this, _$e, n, u, h);
        return v.call(this, _$i, a, o, s, g, l), this;
    };
    var P = function P(t, n, a, o) {
        var s, c, u;
        if ("string" == typeof t && _$i(t) === r) {
            t = unescape(t);
            var h = k(t, !1);
            ("" !== h || void 0 !== (h = e.loadFile(t, !0))) && (t = h);
        }
        if (d(t) && (t = p(t, n)), n = _$i(t, n), !f(n)) throw new Error("addImage does not support files of type '" + n + "', please ensure that a plugin for '" + n + "' support is added.");
        if ((null == (u = a) || 0 === u.length) && (a = function(t) {
            return "string" == typeof t || x(t) ? w(t) : x(t.data) ? w(t.data) : null;
        }(t)), (s = g.call(this, a)) || (A() && (t instanceof Uint8Array || "RGBA" === n || (c = t, t = S(t))), s = this["process" + n.toUpperCase()](t, l.call(this), a, function(t) {
            return t && "string" == typeof t && (t = t.toUpperCase()), t in e.image_compression ? t : _$y.NONE;
        }(o), c)), !s) throw new Error("An unknown error occurred whilst processing the image.");
        return s;
    }, k = e.__addimage__.convertBase64ToBinaryString = function k(t, e) {
        var r;
        e = "boolean" != typeof e || e;
        var n, _$i = "";
        if ("string" == typeof t) {
            n = null !== (r = L(t)) ? r.data : t;
            try {
                _$i = $cbf54afc98507811$var$u(n);
            } catch (t) {
                if (e) throw N(n) ? new Error("atob-Error in jsPDF.convertBase64ToBinaryString " + t.message) : new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ");
            }
        }
        return _$i;
    };
    e.getImageProperties = function(t) {
        var n, a, o = "";
        if (d(t) && (t = p(t)), "string" == typeof t && _$i(t) === r && ("" === (o = k(t, !1)) && (o = e.loadFile(t) || ""), t = o), a = _$i(t), !f(a)) throw new Error("addImage does not support files of type '" + a + "', please ensure that a plugin for '" + a + "' support is added.");
        if (!A() || t instanceof Uint8Array || (t = S(t)), !(n = this["process" + a.toUpperCase()](t))) throw new Error("An unknown error occurred whilst processing the image");
        return n.fileType = a, n;
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function e(t) {
        if (void 0 !== t && "" != t) return !0;
    };
    $cbf54afc98507811$export$ba1e2ffc633a60f5.API.events.push([
        "addPage",
        function(t) {
            this.internal.getPageInfo(t.pageNumber).pageContext.annotations = [];
        }
    ]), t.events.push([
        "putPage",
        function(t) {
            for(var r, n, _$i, a = this.internal.getCoordinateString, o = this.internal.getVerticalCoordinateString, s = this.internal.getPageInfoByObjId(t.objId), c = t.pageContext.annotations, u = !1, h = 0; h < c.length && !u; h++)switch((r = c[h]).type){
                case "link":
                    (e(r.options.url) || e(r.options.pageNumber)) && (u = !0);
                    break;
                case "reference":
                case "text":
                case "freetext":
                    u = !0;
            }
            if (0 != u) {
                this.internal.write("/Annots [");
                for(var l = 0; l < c.length; l++){
                    r = c[l];
                    var f = this.internal.pdfEscape, d = this.internal.getEncryptor(t.objId);
                    switch(r.type){
                        case "reference":
                            this.internal.write(" " + r.object.objId + " 0 R ");
                            break;
                        case "text":
                            var p = this.internal.newAdditionalObject(), g = this.internal.newAdditionalObject(), m = this.internal.getEncryptor(p.objId), v = r.title || "Note";
                            _$i = "<</Type /Annot /Subtype /Text " + (n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y) + "] ") + "/Contents (" + f(m(r.contents)) + ")", _$i += " /Popup " + g.objId + " 0 R", _$i += " /P " + s.objId + " 0 R", _$i += " /T (" + f(m(v)) + ") >>", p.content = _$i;
                            var b = p.objId + " 0 R";
                            _$i = "<</Type /Annot /Subtype /Popup " + (n = "/Rect [" + a(r.bounds.x + 30) + " " + o(r.bounds.y + r.bounds.h) + " " + a(r.bounds.x + r.bounds.w + 30) + " " + o(r.bounds.y) + "] ") + " /Parent " + b, r.open && (_$i += " /Open true"), _$i += " >>", g.content = _$i, this.internal.write(p.objId, "0 R", g.objId, "0 R");
                            break;
                        case "freetext":
                            n = "/Rect [" + a(r.bounds.x) + " " + o(r.bounds.y) + " " + a(r.bounds.x + r.bounds.w) + " " + o(r.bounds.y + r.bounds.h) + "] ";
                            var _$y = r.color || "#000000";
                            _$i = "<</Type /Annot /Subtype /FreeText " + n + "/Contents (" + f(d(r.contents)) + ")", _$i += " /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#" + _$y + ")", _$i += " /Border [0 0 0]", _$i += " >>", this.internal.write(_$i);
                            break;
                        case "link":
                            if (r.options.name) {
                                var w = this.annotations._nameMap[r.options.name];
                                r.options.pageNumber = w.page, r.options.top = w.y;
                            } else r.options.top || (r.options.top = 0);
                            if (n = "/Rect [" + r.finalBounds.x + " " + r.finalBounds.y + " " + r.finalBounds.w + " " + r.finalBounds.h + "] ", _$i = "", r.options.url) _$i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /A <</S /URI /URI (" + f(d(r.options.url)) + ") >>";
                            else if (r.options.pageNumber) switch(_$i = "<</Type /Annot /Subtype /Link " + n + "/Border [0 0 0] /Dest [" + this.internal.getPageInfo(r.options.pageNumber).objId + " 0 R", r.options.magFactor = r.options.magFactor || "XYZ", r.options.magFactor){
                                case "Fit":
                                    _$i += " /Fit]";
                                    break;
                                case "FitH":
                                    _$i += " /FitH " + r.options.top + "]";
                                    break;
                                case "FitV":
                                    r.options.left = r.options.left || 0, _$i += " /FitV " + r.options.left + "]";
                                    break;
                                case "XYZ":
                                default:
                                    var N = o(r.options.top);
                                    r.options.left = r.options.left || 0, void 0 === r.options.zoom && (r.options.zoom = 0), _$i += " /XYZ " + r.options.left + " " + N + " " + r.options.zoom + "]";
                            }
                            "" != _$i && (_$i += " >>", this.internal.write(_$i));
                    }
                }
                this.internal.write("]");
            }
        }
    ]), t.createAnnotation = function(t) {
        var e = this.internal.getCurrentPageInfo();
        switch(t.type){
            case "link":
                this.link(t.bounds.x, t.bounds.y, t.bounds.w, t.bounds.h, t);
                break;
            case "text":
            case "freetext":
                e.pageContext.annotations.push(t);
        }
    }, t.link = function(t, e, r, n, i) {
        var a = this.internal.getCurrentPageInfo(), o = this.internal.getCoordinateString, s = this.internal.getVerticalCoordinateString;
        a.pageContext.annotations.push({
            finalBounds: {
                x: o(t),
                y: s(e),
                w: o(t + r),
                h: s(e + n)
            },
            options: i,
            type: "link"
        });
    }, t.textWithLink = function(t, e, r, n) {
        var _$i, a, o = this.getTextWidth(t), s = this.internal.getLineHeight() / this.internal.scaleFactor;
        if (void 0 !== n.maxWidth) {
            a = n.maxWidth;
            var c = this.splitTextToSize(t, a).length;
            _$i = Math.ceil(s * c);
        } else a = o, _$i = s;
        return this.text(t, e, r, n), r += .2 * s, "center" === n.align && (e -= o / 2), "right" === n.align && (e -= o), this.link(e, r - s, a, _$i, n), o;
    }, t.getTextWidth = function(t) {
        var e = this.internal.getFontSize();
        return this.getStringUnitWidth(t) * e / this.internal.scaleFactor;
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = {
        1569: [
            65152
        ],
        1570: [
            65153,
            65154
        ],
        1571: [
            65155,
            65156
        ],
        1572: [
            65157,
            65158
        ],
        1573: [
            65159,
            65160
        ],
        1574: [
            65161,
            65162,
            65163,
            65164
        ],
        1575: [
            65165,
            65166
        ],
        1576: [
            65167,
            65168,
            65169,
            65170
        ],
        1577: [
            65171,
            65172
        ],
        1578: [
            65173,
            65174,
            65175,
            65176
        ],
        1579: [
            65177,
            65178,
            65179,
            65180
        ],
        1580: [
            65181,
            65182,
            65183,
            65184
        ],
        1581: [
            65185,
            65186,
            65187,
            65188
        ],
        1582: [
            65189,
            65190,
            65191,
            65192
        ],
        1583: [
            65193,
            65194
        ],
        1584: [
            65195,
            65196
        ],
        1585: [
            65197,
            65198
        ],
        1586: [
            65199,
            65200
        ],
        1587: [
            65201,
            65202,
            65203,
            65204
        ],
        1588: [
            65205,
            65206,
            65207,
            65208
        ],
        1589: [
            65209,
            65210,
            65211,
            65212
        ],
        1590: [
            65213,
            65214,
            65215,
            65216
        ],
        1591: [
            65217,
            65218,
            65219,
            65220
        ],
        1592: [
            65221,
            65222,
            65223,
            65224
        ],
        1593: [
            65225,
            65226,
            65227,
            65228
        ],
        1594: [
            65229,
            65230,
            65231,
            65232
        ],
        1601: [
            65233,
            65234,
            65235,
            65236
        ],
        1602: [
            65237,
            65238,
            65239,
            65240
        ],
        1603: [
            65241,
            65242,
            65243,
            65244
        ],
        1604: [
            65245,
            65246,
            65247,
            65248
        ],
        1605: [
            65249,
            65250,
            65251,
            65252
        ],
        1606: [
            65253,
            65254,
            65255,
            65256
        ],
        1607: [
            65257,
            65258,
            65259,
            65260
        ],
        1608: [
            65261,
            65262
        ],
        1609: [
            65263,
            65264,
            64488,
            64489
        ],
        1610: [
            65265,
            65266,
            65267,
            65268
        ],
        1649: [
            64336,
            64337
        ],
        1655: [
            64477
        ],
        1657: [
            64358,
            64359,
            64360,
            64361
        ],
        1658: [
            64350,
            64351,
            64352,
            64353
        ],
        1659: [
            64338,
            64339,
            64340,
            64341
        ],
        1662: [
            64342,
            64343,
            64344,
            64345
        ],
        1663: [
            64354,
            64355,
            64356,
            64357
        ],
        1664: [
            64346,
            64347,
            64348,
            64349
        ],
        1667: [
            64374,
            64375,
            64376,
            64377
        ],
        1668: [
            64370,
            64371,
            64372,
            64373
        ],
        1670: [
            64378,
            64379,
            64380,
            64381
        ],
        1671: [
            64382,
            64383,
            64384,
            64385
        ],
        1672: [
            64392,
            64393
        ],
        1676: [
            64388,
            64389
        ],
        1677: [
            64386,
            64387
        ],
        1678: [
            64390,
            64391
        ],
        1681: [
            64396,
            64397
        ],
        1688: [
            64394,
            64395
        ],
        1700: [
            64362,
            64363,
            64364,
            64365
        ],
        1702: [
            64366,
            64367,
            64368,
            64369
        ],
        1705: [
            64398,
            64399,
            64400,
            64401
        ],
        1709: [
            64467,
            64468,
            64469,
            64470
        ],
        1711: [
            64402,
            64403,
            64404,
            64405
        ],
        1713: [
            64410,
            64411,
            64412,
            64413
        ],
        1715: [
            64406,
            64407,
            64408,
            64409
        ],
        1722: [
            64414,
            64415
        ],
        1723: [
            64416,
            64417,
            64418,
            64419
        ],
        1726: [
            64426,
            64427,
            64428,
            64429
        ],
        1728: [
            64420,
            64421
        ],
        1729: [
            64422,
            64423,
            64424,
            64425
        ],
        1733: [
            64480,
            64481
        ],
        1734: [
            64473,
            64474
        ],
        1735: [
            64471,
            64472
        ],
        1736: [
            64475,
            64476
        ],
        1737: [
            64482,
            64483
        ],
        1739: [
            64478,
            64479
        ],
        1740: [
            64508,
            64509,
            64510,
            64511
        ],
        1744: [
            64484,
            64485,
            64486,
            64487
        ],
        1746: [
            64430,
            64431
        ],
        1747: [
            64432,
            64433
        ]
    }, r = {
        65247: {
            65154: 65269,
            65156: 65271,
            65160: 65273,
            65166: 65275
        },
        65248: {
            65154: 65270,
            65156: 65272,
            65160: 65274,
            65166: 65276
        },
        65165: {
            65247: {
                65248: {
                    65258: 65010
                }
            }
        },
        1617: {
            1612: 64606,
            1613: 64607,
            1614: 64608,
            1615: 64609,
            1616: 64610
        }
    }, n = {
        1612: 64606,
        1613: 64607,
        1614: 64608,
        1615: 64609,
        1616: 64610
    }, _$i = [
        1570,
        1571,
        1573,
        1575
    ];
    t.__arabicParser__ = {};
    var a = t.__arabicParser__.isInArabicSubstitutionA = function a(t) {
        return void 0 !== e[t.charCodeAt(0)];
    }, o = t.__arabicParser__.isArabicLetter = function o(t) {
        return "string" == typeof t && /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t);
    }, s = t.__arabicParser__.isArabicEndLetter = function s(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length <= 2;
    }, c = t.__arabicParser__.isArabicAlfLetter = function c(t) {
        return o(t) && _$i.indexOf(t.charCodeAt(0)) >= 0;
    };
    t.__arabicParser__.arabicLetterHasIsolatedForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 1;
    };
    var u = t.__arabicParser__.arabicLetterHasFinalForm = function u(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 2;
    };
    t.__arabicParser__.arabicLetterHasInitialForm = function(t) {
        return o(t) && a(t) && e[t.charCodeAt(0)].length >= 3;
    };
    var h = t.__arabicParser__.arabicLetterHasMedialForm = function h(t) {
        return o(t) && a(t) && 4 == e[t.charCodeAt(0)].length;
    }, l = t.__arabicParser__.resolveLigatures = function l(t) {
        var e = 0, n = r, _$i = "", a = 0;
        for(e = 0; e < t.length; e += 1)void 0 !== n[t.charCodeAt(e)] ? (a++, "number" == typeof (n = n[t.charCodeAt(e)]) && (_$i += String.fromCharCode(n), n = r, a = 0), e === t.length - 1 && (n = r, _$i += t.charAt(e - (a - 1)), e -= a - 1, a = 0)) : (n = r, _$i += t.charAt(e - a), e -= a, a = 0);
        return _$i;
    };
    t.__arabicParser__.isArabicDiacritic = function(t) {
        return void 0 !== t && void 0 !== n[t.charCodeAt(0)];
    };
    var f = t.__arabicParser__.getCorrectForm = function f(t, e, r) {
        return o(t) ? !1 === a(t) ? -1 : !u(t) || !o(e) && !o(r) || !o(r) && s(e) || s(t) && !o(e) || s(t) && c(e) || s(t) && s(e) ? 0 : h(t) && o(e) && !s(e) && o(r) && u(r) ? 3 : s(t) || !o(r) ? 1 : 2 : -1;
    }, d = function d(t) {
        var r = 0, n = 0, _$i = 0, a = "", s = "", c = "", u = (t = t || "").split("\\s+"), h = [];
        for(r = 0; r < u.length; r += 1){
            for(h.push(""), n = 0; n < u[r].length; n += 1)a = u[r][n], s = u[r][n - 1], c = u[r][n + 1], o(a) ? (_$i = f(a, s, c), h[r] += -1 !== _$i ? String.fromCharCode(e[a.charCodeAt(0)][_$i]) : a) : h[r] += a;
            h[r] = l(h[r]);
        }
        return h.join(" ");
    }, p = t.__arabicParser__.processArabic = t.processArabic = function p() {
        var _$t, e = "string" == typeof arguments[0] ? arguments[0] : arguments[0].text, r = [];
        if (Array.isArray(e)) {
            var n = 0;
            for(r = [], n = 0; n < e.length; n += 1)Array.isArray(e[n]) ? r.push([
                d(e[n][0]),
                e[n][1],
                e[n][2]
            ]) : r.push([
                d(e[n])
            ]);
            _$t = r;
        } else _$t = d(e);
        return "string" == typeof arguments[0] ? _$t : (arguments[0].text = _$t, arguments[0]);
    };
    t.events.push([
        "preProcessText",
        p
    ]);
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), $cbf54afc98507811$export$ba1e2ffc633a60f5.API.autoPrint = function(t) {
    var e;
    switch((t = t || {}).variant = t.variant || "non-conform", t.variant){
        case "javascript":
            this.addJS("print({});");
            break;
        case "non-conform":
        default:
            this.internal.events.subscribe("postPutResources", function() {
                e = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /Named"), this.internal.out("/Type /Action"), this.internal.out("/N /Print"), this.internal.out(">>"), this.internal.out("endobj");
            }), this.internal.events.subscribe("putCatalog", function() {
                this.internal.out("/OpenAction " + e + " 0 R");
            });
    }
    return this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function e() {
        var _$t = void 0;
        Object.defineProperty(this, "pdf", {
            get: function get() {
                return _$t;
            },
            set: function set(e) {
                _$t = e;
            }
        });
        var e = 150;
        Object.defineProperty(this, "width", {
            get: function get() {
                return e;
            },
            set: function set(t) {
                e = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 150 : t, this.getContext("2d").pageWrapXEnabled && (this.getContext("2d").pageWrapX = e + 1);
            }
        });
        var r = 300;
        Object.defineProperty(this, "height", {
            get: function get() {
                return r;
            },
            set: function set(t) {
                r = isNaN(t) || !1 === Number.isInteger(t) || t < 0 ? 300 : t, this.getContext("2d").pageWrapYEnabled && (this.getContext("2d").pageWrapY = r + 1);
            }
        });
        var n = [];
        Object.defineProperty(this, "childNodes", {
            get: function get() {
                return n;
            },
            set: function set(t) {
                n = t;
            }
        });
        var _$i = {};
        Object.defineProperty(this, "style", {
            get: function get() {
                return _$i;
            },
            set: function set(t) {
                _$i = t;
            }
        }), Object.defineProperty(this, "parentNode", {});
    };
    e.prototype.getContext = function(t, e) {
        var r;
        if ("2d" !== (t = t || "2d")) return null;
        for(r in e)this.pdf.context2d.hasOwnProperty(r) && (this.pdf.context2d[r] = e[r]);
        return this.pdf.context2d._canvas = this, this.pdf.context2d;
    }, e.prototype.toDataURL = function() {
        throw new Error("toDataURL is not implemented.");
    }, t.events.push([
        "initialized",
        function() {
            this.canvas = new e, this.canvas.pdf = this;
        }
    ]);
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), function(e) {
    var r = {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }, n = !1, _$i = function i() {
        void 0 === this.internal.__cell__ && (this.internal.__cell__ = {}, this.internal.__cell__.padding = 3, this.internal.__cell__.headerFunction = void 0, this.internal.__cell__.margins = Object.assign({}, r), this.internal.__cell__.margins.width = this.getPageWidth(), a.call(this));
    }, a = function a() {
        this.internal.__cell__.lastCell = new o, this.internal.__cell__.pages = 1;
    }, o = function o() {
        var _$t = arguments[0];
        Object.defineProperty(this, "x", {
            enumerable: !0,
            get: function get() {
                return _$t;
            },
            set: function set(e) {
                _$t = e;
            }
        });
        var _$e = arguments[1];
        Object.defineProperty(this, "y", {
            enumerable: !0,
            get: function get() {
                return _$e;
            },
            set: function set(t) {
                _$e = t;
            }
        });
        var r = arguments[2];
        Object.defineProperty(this, "width", {
            enumerable: !0,
            get: function get() {
                return r;
            },
            set: function set(t) {
                r = t;
            }
        });
        var n = arguments[3];
        Object.defineProperty(this, "height", {
            enumerable: !0,
            get: function get() {
                return n;
            },
            set: function set(t) {
                n = t;
            }
        });
        var _$i = arguments[4];
        Object.defineProperty(this, "text", {
            enumerable: !0,
            get: function get() {
                return _$i;
            },
            set: function set(t) {
                _$i = t;
            }
        });
        var a = arguments[5];
        Object.defineProperty(this, "lineNumber", {
            enumerable: !0,
            get: function get() {
                return a;
            },
            set: function set(t) {
                a = t;
            }
        });
        var o = arguments[6];
        return Object.defineProperty(this, "align", {
            enumerable: !0,
            get: function get() {
                return o;
            },
            set: function set(t) {
                o = t;
            }
        }), this;
    };
    o.prototype.clone = function() {
        return new o(this.x, this.y, this.width, this.height, this.text, this.lineNumber, this.align);
    }, o.prototype.toArray = function() {
        return [
            this.x,
            this.y,
            this.width,
            this.height,
            this.text,
            this.lineNumber,
            this.align
        ];
    }, e.setHeaderFunction = function(t) {
        return _$i.call(this), this.internal.__cell__.headerFunction = "function" == typeof t ? t : void 0, this;
    }, e.getTextDimensions = function(t, e) {
        _$i.call(this);
        var r = (e = e || {}).fontSize || this.getFontSize(), n = e.font || this.getFont(), a = e.scaleFactor || this.internal.scaleFactor, o = 0, s = 0, c = 0, u = this;
        if (!Array.isArray(t) && "string" != typeof t) {
            if ("number" != typeof t) throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");
            t = String(t);
        }
        var h = e.maxWidth;
        h > 0 ? "string" == typeof t ? t = this.splitTextToSize(t, h) : "[object Array]" === Object.prototype.toString.call(t) && (t = t.reduce(function(t, e) {
            return t.concat(u.splitTextToSize(e, h));
        }, [])) : t = Array.isArray(t) ? t : [
            t
        ];
        for(var l = 0; l < t.length; l++)o < (c = this.getStringUnitWidth(t[l], {
            font: n
        }) * r) && (o = c);
        return 0 !== o && (s = t.length), {
            w: o /= a,
            h: Math.max((s * r * this.getLineHeightFactor() - r * (this.getLineHeightFactor() - 1)) / a, 0)
        };
    }, e.cellAddPage = function() {
        _$i.call(this), this.addPage();
        var _$t = this.internal.__cell__.margins || r;
        return this.internal.__cell__.lastCell = new o(_$t.left, _$t.top, void 0, void 0), this.internal.__cell__.pages += 1, this;
    };
    var s = e.cell = function s() {
        var _$t;
        _$t = arguments[0] instanceof o ? arguments[0] : new o(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]), _$i.call(this);
        var _$e = this.internal.__cell__.lastCell, a = this.internal.__cell__.padding, s = this.internal.__cell__.margins || r, c = this.internal.__cell__.tableHeaderRow, u = this.internal.__cell__.printHeaders;
        return void 0 !== _$e.lineNumber && (_$e.lineNumber === _$t.lineNumber ? (_$t.x = (_$e.x || 0) + (_$e.width || 0), _$t.y = _$e.y || 0) : _$e.y + _$e.height + _$t.height + s.bottom > this.getPageHeight() ? (this.cellAddPage(), _$t.y = s.top, u && c && (this.printHeaderRow(_$t.lineNumber, !0), _$t.y += c[0].height)) : _$t.y = _$e.y + _$e.height || _$t.y), void 0 !== _$t.text[0] && (this.rect(_$t.x, _$t.y, _$t.width, _$t.height, !0 === n ? "FD" : void 0), "right" === _$t.align ? this.text(_$t.text, _$t.x + _$t.width - a, _$t.y + a, {
            align: "right",
            baseline: "top"
        }) : "center" === _$t.align ? this.text(_$t.text, _$t.x + _$t.width / 2, _$t.y + a, {
            align: "center",
            baseline: "top",
            maxWidth: _$t.width - a - a
        }) : this.text(_$t.text, _$t.x + a, _$t.y + a, {
            align: "left",
            baseline: "top",
            maxWidth: _$t.width - a - a
        })), this.internal.__cell__.lastCell = _$t, this;
    };
    e.table = function(e, n, u, h, l) {
        if (_$i.call(this), !u) throw new Error("No data for PDF table.");
        var f, d, p, g, m = [], v = [], b = [], _$y = {}, w = {}, N = [], L = [], A = (l = l || {}).autoSize || !1, x = !1 !== l.printHeaders, S = l.css && void 0 !== l.css["font-size"] ? 16 * l.css["font-size"] : l.fontSize || 12, _ = l.margins || Object.assign({
            width: this.getPageWidth()
        }, r), P = "number" == typeof l.padding ? l.padding : 3, k = l.headerBackgroundColor || "#c8c8c8", _$I = l.headerTextColor || "#000";
        if (a.call(this), this.internal.__cell__.printHeaders = x, this.internal.__cell__.margins = _, this.internal.__cell__.table_font_size = S, this.internal.__cell__.padding = P, this.internal.__cell__.headerBackgroundColor = k, this.internal.__cell__.headerTextColor = _$I, this.setFontSize(S), null == h) v = m = Object.keys(u[0]), b = m.map(function() {
            return "left";
        });
        else if (Array.isArray(h) && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(h[0])) for(m = h.map(function(t) {
            return t.name;
        }), v = h.map(function(t) {
            return t.prompt || t.name || "";
        }), b = h.map(function(t) {
            return t.align || "left";
        }), f = 0; f < h.length; f += 1)w[h[f].name] = h[f].width * (19.049976 / 25.4);
        else Array.isArray(h) && "string" == typeof h[0] && (v = m = h, b = m.map(function() {
            return "left";
        }));
        if (A || Array.isArray(h) && "string" == typeof h[0]) for(f = 0; f < m.length; f += 1){
            for(_$y[g = m[f]] = u.map(function(t) {
                return t[g];
            }), this.setFont(void 0, "bold"), N.push(this.getTextDimensions(v[f], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w), d = _$y[g], this.setFont(void 0, "normal"), p = 0; p < d.length; p += 1)N.push(this.getTextDimensions(d[p], {
                fontSize: this.internal.__cell__.table_font_size,
                scaleFactor: this.internal.scaleFactor
            }).w);
            w[g] = Math.max.apply(null, N) + P + P, N = [];
        }
        if (x) {
            var F = {};
            for(f = 0; f < m.length; f += 1)F[m[f]] = {}, F[m[f]].text = v[f], F[m[f]].align = b[f];
            var C = c.call(this, F, w);
            L = m.map(function(t) {
                return new o(e, n, w[t], C, F[t].text, void 0, F[t].align);
            }), this.setTableHeaderRow(L), this.printHeaderRow(1, !1);
        }
        var _$j = h.reduce(function(t, e) {
            return t[e.name] = e.align, t;
        }, {});
        for(f = 0; f < u.length; f += 1){
            "rowStart" in l && l.rowStart instanceof Function && l.rowStart({
                row: f,
                data: u[f]
            }, this);
            var O = c.call(this, u[f], w);
            for(p = 0; p < m.length; p += 1){
                var B = u[f][m[p]];
                "cellStart" in l && l.cellStart instanceof Function && l.cellStart({
                    row: f,
                    col: p,
                    data: B
                }, this), s.call(this, new o(e, n, w[m[p]], O, B, f + 2, _$j[m[p]]));
            }
        }
        return this.internal.__cell__.table_x = e, this.internal.__cell__.table_y = n, this;
    };
    var c = function c(t, e) {
        var r = this.internal.__cell__.padding, n = this.internal.__cell__.table_font_size, _$i = this.internal.scaleFactor;
        return Object.keys(t).map(function(n) {
            var _$i = t[n];
            return this.splitTextToSize(_$i.hasOwnProperty("text") ? _$i.text : _$i, e[n] - r - r);
        }, this).map(function(t) {
            return this.getLineHeightFactor() * t.length * n / _$i + r + r;
        }, this).reduce(function(t, e) {
            return Math.max(t, e);
        }, 0);
    };
    e.setTableHeaderRow = function(t) {
        _$i.call(this), this.internal.__cell__.tableHeaderRow = t;
    }, e.printHeaderRow = function(t, e) {
        if (_$i.call(this), !this.internal.__cell__.tableHeaderRow) throw new Error("Property tableHeaderRow does not exist.");
        var r;
        if (n = !0, "function" == typeof this.internal.__cell__.headerFunction) {
            var a = this.internal.__cell__.headerFunction(this, this.internal.__cell__.pages);
            this.internal.__cell__.lastCell = new o(a[0], a[1], a[2], a[3], void 0, -1);
        }
        this.setFont(void 0, "bold");
        for(var c = [], u = 0; u < this.internal.__cell__.tableHeaderRow.length; u += 1){
            r = this.internal.__cell__.tableHeaderRow[u].clone(), e && (r.y = this.internal.__cell__.margins.top || 0, c.push(r)), r.lineNumber = t;
            var h = this.getTextColor();
            this.setTextColor(this.internal.__cell__.headerTextColor), this.setFillColor(this.internal.__cell__.headerBackgroundColor), s.call(this, r), this.setTextColor(h);
        }
        c.length > 0 && this.setTableHeaderRow(c), this.setFont(void 0, "normal"), n = !1;
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API);
var $cbf54afc98507811$var$Pt = {
    italic: [
        "italic",
        "oblique",
        "normal"
    ],
    oblique: [
        "oblique",
        "italic",
        "normal"
    ],
    normal: [
        "normal",
        "oblique",
        "italic"
    ]
}, $cbf54afc98507811$var$kt = [
    "ultra-condensed",
    "extra-condensed",
    "condensed",
    "semi-condensed",
    "normal",
    "semi-expanded",
    "expanded",
    "extra-expanded",
    "ultra-expanded"
], $cbf54afc98507811$var$It = $cbf54afc98507811$var$_t($cbf54afc98507811$var$kt), $cbf54afc98507811$var$Ft = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900
], $cbf54afc98507811$var$Ct = $cbf54afc98507811$var$_t($cbf54afc98507811$var$Ft);
function $cbf54afc98507811$var$jt(t) {
    var e = t.family.replace(/"|'/g, "").toLowerCase(), r = function(t) {
        return $cbf54afc98507811$var$Pt[t = t || "normal"] ? t : "normal";
    }(t.style), n = function(t) {
        if (!t) return 400;
        if ("number" == typeof t) return t >= 100 && t <= 900 && t % 100 == 0 ? t : 400;
        if (/^\d00$/.test(t)) return parseInt(t);
        switch(t){
            case "bold":
                return 700;
            case "normal":
            default:
                return 400;
        }
    }(t.weight), _$i = function(t) {
        return "number" == typeof $cbf54afc98507811$var$It[t = t || "normal"] ? t : "normal";
    }(t.stretch);
    return {
        family: e,
        style: r,
        weight: n,
        stretch: _$i,
        src: t.src || [],
        ref: t.ref || {
            name: e,
            style: [
                _$i,
                r,
                n
            ].join(" ")
        }
    };
}
function $cbf54afc98507811$var$Ot(t, e, r, n) {
    var _$i;
    for(_$i = r; _$i >= 0 && _$i < e.length; _$i += n)if (t[e[_$i]]) return t[e[_$i]];
    for(_$i = r; _$i >= 0 && _$i < e.length; _$i -= n)if (t[e[_$i]]) return t[e[_$i]];
}
var $cbf54afc98507811$var$Bt = {
    "sans-serif": "helvetica",
    fixed: "courier",
    monospace: "courier",
    terminal: "courier",
    cursive: "times",
    fantasy: "times",
    serif: "times"
}, $cbf54afc98507811$var$Mt = {
    caption: "times",
    icon: "times",
    menu: "times",
    "message-box": "times",
    "small-caption": "times",
    "status-bar": "times"
};
function $cbf54afc98507811$var$Et(t) {
    return [
        t.stretch,
        t.style,
        t.weight,
        t.family
    ].join(" ");
}
function $cbf54afc98507811$var$qt(t, e, r) {
    for(var n = (r = r || {}).defaultFontFamily || "times", _$i = Object.assign({}, $cbf54afc98507811$var$Bt, r.genericFontFamilies || {}), a = null, o = null, s = 0; s < e.length; ++s)if (_$i[(a = $cbf54afc98507811$var$jt(e[s])).family] && (a.family = _$i[a.family]), t.hasOwnProperty(a.family)) {
        o = t[a.family];
        break;
    }
    if (!(o = o || t[n])) throw new Error("Could not find a font-family for the rule '" + $cbf54afc98507811$var$Et(a) + "' and default family '" + n + "'.");
    if (o = function(t, e) {
        if (e[t]) return e[t];
        var _$r = $cbf54afc98507811$var$It[t], n = _$r <= $cbf54afc98507811$var$It.normal ? -1 : 1, _$i = $cbf54afc98507811$var$Ot(e, $cbf54afc98507811$var$kt, _$r, n);
        if (!_$i) throw new Error("Could not find a matching font-stretch value for " + t);
        return _$i;
    }(a.stretch, o), o = function(t, e) {
        if (e[t]) return e[t];
        for(var _$r = $cbf54afc98507811$var$Pt[t], n = 0; n < _$r.length; ++n)if (e[_$r[n]]) return e[_$r[n]];
        throw new Error("Could not find a matching font-style for " + t);
    }(a.style, o), !(o = function(t, e) {
        if (e[t]) return e[t];
        if (400 === t && e[500]) return e[500];
        if (500 === t && e[400]) return e[400];
        var _$r = $cbf54afc98507811$var$Ct[t], n = $cbf54afc98507811$var$Ot(e, $cbf54afc98507811$var$Ft, _$r, t < 400 ? -1 : 1);
        if (!n) throw new Error("Could not find a matching font-weight for value " + t);
        return n;
    }(a.weight, o))) throw new Error("Failed to resolve a font for the rule '" + $cbf54afc98507811$var$Et(a) + "'.");
    return o;
}
function $cbf54afc98507811$var$Dt(t) {
    return t.trimLeft();
}
function $cbf54afc98507811$var$Rt(t, e) {
    for(var r = 0; r < t.length;){
        if (t.charAt(r) === e) return [
            t.substring(0, r),
            t.substring(r + 1)
        ];
        r += 1;
    }
    return null;
}
function $cbf54afc98507811$var$Tt(t) {
    var e = t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);
    return null === e ? null : [
        e[0],
        t.substring(e[0].length)
    ];
}
var $cbf54afc98507811$var$Ut, $cbf54afc98507811$var$zt, $cbf54afc98507811$var$Ht, $cbf54afc98507811$var$Wt = [
    "times"
];


!function(e) {
    var r, n, _$i, o, s, c, u, h, l, d = function d(t) {
        return t = t || {}, this.isStrokeTransparent = t.isStrokeTransparent || !1, this.strokeOpacity = t.strokeOpacity || 1, this.strokeStyle = t.strokeStyle || "#000000", this.fillStyle = t.fillStyle || "#000000", this.isFillTransparent = t.isFillTransparent || !1, this.fillOpacity = t.fillOpacity || 1, this.font = t.font || "10px sans-serif", this.textBaseline = t.textBaseline || "alphabetic", this.textAlign = t.textAlign || "left", this.lineWidth = t.lineWidth || 1, this.lineJoin = t.lineJoin || "miter", this.lineCap = t.lineCap || "butt", this.path = t.path || [], this.transform = void 0 !== t.transform ? t.transform.clone() : new h, this.globalCompositeOperation = t.globalCompositeOperation || "normal", this.globalAlpha = t.globalAlpha || 1, this.clip_path = t.clip_path || [], this.currentPoint = t.currentPoint || new c, this.miterLimit = t.miterLimit || 10, this.lastPoint = t.lastPoint || new c, this.lineDashOffset = t.lineDashOffset || 0, this.lineDash = t.lineDash || [], this.margin = t.margin || [
            0,
            0,
            0,
            0
        ], this.prevPageLastElemOffset = t.prevPageLastElemOffset || 0, this.ignoreClearRect = "boolean" != typeof t.ignoreClearRect || t.ignoreClearRect, this;
    };
    e.events.push([
        "initialized",
        function() {
            this.context2d = new p(this), r = this.internal.f2, n = this.internal.getCoordinateString, _$i = this.internal.getVerticalCoordinateString, o = this.internal.getHorizontalCoordinate, s = this.internal.getVerticalCoordinate, c = this.internal.Point, u = this.internal.Rectangle, h = this.internal.Matrix, l = new d;
        }
    ]);
    var p = function p(t) {
        var f = function f(t, e) {
            if (null === h) {
                var r = function(t) {
                    var _$e = [];
                    return Object.keys(t).forEach(function(r) {
                        t[r].forEach(function(t) {
                            var n = null;
                            switch(t){
                                case "bold":
                                    n = {
                                        family: r,
                                        weight: "bold"
                                    };
                                    break;
                                case "italic":
                                    n = {
                                        family: r,
                                        style: "italic"
                                    };
                                    break;
                                case "bolditalic":
                                    n = {
                                        family: r,
                                        weight: "bold",
                                        style: "italic"
                                    };
                                    break;
                                case "":
                                case "normal":
                                    n = {
                                        family: r
                                    };
                            }
                            null !== n && (n.ref = {
                                name: r,
                                style: t
                            }, _$e.push(n));
                        });
                    }), _$e;
                }(t.getFontList());
                h = function(t) {
                    for(var _$e = {}, r = 0; r < t.length; ++r){
                        var n = $cbf54afc98507811$var$jt(t[r]), _$i = n.family, a = n.stretch, o = n.style, s = n.weight;
                        _$e[_$i] = _$e[_$i] || {}, _$e[_$i][a] = _$e[_$i][a] || {}, _$e[_$i][a][o] = _$e[_$i][a][o] || {}, _$e[_$i][a][o][s] = n;
                    }
                    return _$e;
                }(r.concat(e));
            }
            return h;
        };
        Object.defineProperty(this, "canvas", {
            get: function get() {
                return {
                    parentNode: !1,
                    style: !1
                };
            }
        });
        var _$e = t;
        Object.defineProperty(this, "pdf", {
            get: function get() {
                return _$e;
            }
        });
        var r = !1;
        Object.defineProperty(this, "pageWrapXEnabled", {
            get: function get() {
                return r;
            },
            set: function set(t) {
                r = Boolean(t);
            }
        });
        var n = !1;
        Object.defineProperty(this, "pageWrapYEnabled", {
            get: function get() {
                return n;
            },
            set: function set(t) {
                n = Boolean(t);
            }
        });
        var _$i = 0;
        Object.defineProperty(this, "posX", {
            get: function get() {
                return _$i;
            },
            set: function set(t) {
                isNaN(t) || (_$i = t);
            }
        });
        var a = 0;
        Object.defineProperty(this, "posY", {
            get: function get() {
                return a;
            },
            set: function set(t) {
                isNaN(t) || (a = t);
            }
        }), Object.defineProperty(this, "margin", {
            get: function get() {
                return l.margin;
            },
            set: function set(t) {
                var _$e;
                "number" == typeof t ? _$e = [
                    t,
                    t,
                    t,
                    t
                ] : ((_$e = new Array(4))[0] = t[0], _$e[1] = t.length >= 2 ? t[1] : _$e[0], _$e[2] = t.length >= 3 ? t[2] : _$e[0], _$e[3] = t.length >= 4 ? t[3] : _$e[1]), l.margin = _$e;
            }
        });
        var o = !1;
        Object.defineProperty(this, "autoPaging", {
            get: function get() {
                return o;
            },
            set: function set(t) {
                o = t;
            }
        });
        var s = 0;
        Object.defineProperty(this, "lastBreak", {
            get: function get() {
                return s;
            },
            set: function set(t) {
                s = t;
            }
        });
        var c = [];
        Object.defineProperty(this, "pageBreaks", {
            get: function get() {
                return c;
            },
            set: function set(t) {
                c = t;
            }
        }), Object.defineProperty(this, "ctx", {
            get: function get() {
                return l;
            },
            set: function set(t) {
                t instanceof d && (l = t);
            }
        }), Object.defineProperty(this, "path", {
            get: function get() {
                return l.path;
            },
            set: function set(t) {
                l.path = t;
            }
        });
        var u = [];
        Object.defineProperty(this, "ctxStack", {
            get: function get() {
                return u;
            },
            set: function set(t) {
                u = t;
            }
        }), Object.defineProperty(this, "fillStyle", {
            get: function get() {
                return this.ctx.fillStyle;
            },
            set: function set(t) {
                var _$e;
                _$e = g(t), this.ctx.fillStyle = _$e.style, this.ctx.isFillTransparent = 0 === _$e.a, this.ctx.fillOpacity = _$e.a, this.pdf.setFillColor(_$e.r, _$e.g, _$e.b, {
                    a: _$e.a
                }), this.pdf.setTextColor(_$e.r, _$e.g, _$e.b, {
                    a: _$e.a
                });
            }
        }), Object.defineProperty(this, "strokeStyle", {
            get: function get() {
                return this.ctx.strokeStyle;
            },
            set: function set(t) {
                var _$e = g(t);
                this.ctx.strokeStyle = _$e.style, this.ctx.isStrokeTransparent = 0 === _$e.a, this.ctx.strokeOpacity = _$e.a, 0 === _$e.a ? this.pdf.setDrawColor(255, 255, 255) : (_$e.a, this.pdf.setDrawColor(_$e.r, _$e.g, _$e.b));
            }
        }), Object.defineProperty(this, "lineCap", {
            get: function get() {
                return this.ctx.lineCap;
            },
            set: function set(t) {
                -1 !== [
                    "butt",
                    "round",
                    "square"
                ].indexOf(t) && (this.ctx.lineCap = t, this.pdf.setLineCap(t));
            }
        }), Object.defineProperty(this, "lineWidth", {
            get: function get() {
                return this.ctx.lineWidth;
            },
            set: function set(t) {
                isNaN(t) || (this.ctx.lineWidth = t, this.pdf.setLineWidth(t));
            }
        }), Object.defineProperty(this, "lineJoin", {
            get: function get() {
                return this.ctx.lineJoin;
            },
            set: function set(t) {
                -1 !== [
                    "bevel",
                    "round",
                    "miter"
                ].indexOf(t) && (this.ctx.lineJoin = t, this.pdf.setLineJoin(t));
            }
        }), Object.defineProperty(this, "miterLimit", {
            get: function get() {
                return this.ctx.miterLimit;
            },
            set: function set(t) {
                isNaN(t) || (this.ctx.miterLimit = t, this.pdf.setMiterLimit(t));
            }
        }), Object.defineProperty(this, "textBaseline", {
            get: function get() {
                return this.ctx.textBaseline;
            },
            set: function set(t) {
                this.ctx.textBaseline = t;
            }
        }), Object.defineProperty(this, "textAlign", {
            get: function get() {
                return this.ctx.textAlign;
            },
            set: function set(t) {
                -1 !== [
                    "right",
                    "end",
                    "center",
                    "left",
                    "start"
                ].indexOf(t) && (this.ctx.textAlign = t);
            }
        });
        var h = null;
        var p = null;
        Object.defineProperty(this, "fontFaces", {
            get: function get() {
                return p;
            },
            set: function set(t) {
                h = null, p = t;
            }
        }), Object.defineProperty(this, "font", {
            get: function get() {
                return this.ctx.font;
            },
            set: function set(t) {
                var _$e;
                if (this.ctx.font = t, null !== (_$e = /^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))) {
                    var r = _$e[1], n = (_$e[2], _$e[3]), _$i = _$e[4], a = (_$e[5], _$e[6]), o = /^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(_$i)[2];
                    _$i = "px" === o ? Math.floor(parseFloat(_$i) * this.pdf.internal.scaleFactor) : "em" === o ? Math.floor(parseFloat(_$i) * this.pdf.getFontSize()) : Math.floor(parseFloat(_$i) * this.pdf.internal.scaleFactor), this.pdf.setFontSize(_$i);
                    var s = function(t) {
                        var _$e, r, n = [], _$i = t.trim();
                        if ("" === _$i) return $cbf54afc98507811$var$Wt;
                        if (_$i in $cbf54afc98507811$var$Mt) return [
                            $cbf54afc98507811$var$Mt[_$i]
                        ];
                        for(; "" !== _$i;){
                            switch(r = null, _$e = (_$i = $cbf54afc98507811$var$Dt(_$i)).charAt(0)){
                                case '"':
                                case "'":
                                    r = $cbf54afc98507811$var$Rt(_$i.substring(1), _$e);
                                    break;
                                default:
                                    r = $cbf54afc98507811$var$Tt(_$i);
                            }
                            if (null === r) return $cbf54afc98507811$var$Wt;
                            if (n.push(r[0]), "" !== (_$i = $cbf54afc98507811$var$Dt(r[1])) && "," !== _$i.charAt(0)) return $cbf54afc98507811$var$Wt;
                            _$i = _$i.replace(/^,/, "");
                        }
                        return n;
                    }(a);
                    if (this.fontFaces) {
                        var c = $cbf54afc98507811$var$qt(f(this.pdf, this.fontFaces), s.map(function(t) {
                            return {
                                family: t,
                                stretch: "normal",
                                weight: n,
                                style: r
                            };
                        }));
                        this.pdf.setFont(c.ref.name, c.ref.style);
                    } else {
                        var u = "";
                        ("bold" === n || parseInt(n, 10) >= 700 || "bold" === r) && (u = "bold"), "italic" === r && (u += "italic"), 0 === u.length && (u = "normal");
                        for(var h = "", l = {
                            arial: "Helvetica",
                            Arial: "Helvetica",
                            verdana: "Helvetica",
                            Verdana: "Helvetica",
                            helvetica: "Helvetica",
                            Helvetica: "Helvetica",
                            "sans-serif": "Helvetica",
                            fixed: "Courier",
                            monospace: "Courier",
                            terminal: "Courier",
                            cursive: "Times",
                            fantasy: "Times",
                            serif: "Times"
                        }, d = 0; d < s.length; d++){
                            if (void 0 !== this.pdf.internal.getFont(s[d], u, {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d];
                                break;
                            }
                            if ("bolditalic" === u && void 0 !== this.pdf.internal.getFont(s[d], "bold", {
                                noFallback: !0,
                                disableWarning: !0
                            })) h = s[d], u = "bold";
                            else if (void 0 !== this.pdf.internal.getFont(s[d], "normal", {
                                noFallback: !0,
                                disableWarning: !0
                            })) {
                                h = s[d], u = "normal";
                                break;
                            }
                        }
                        if ("" === h) {
                            for(var p = 0; p < s.length; p++)if (l[s[p]]) {
                                h = l[s[p]];
                                break;
                            }
                        }
                        h = "" === h ? "Times" : h, this.pdf.setFont(h, u);
                    }
                }
            }
        }), Object.defineProperty(this, "globalCompositeOperation", {
            get: function get() {
                return this.ctx.globalCompositeOperation;
            },
            set: function set(t) {
                this.ctx.globalCompositeOperation = t;
            }
        }), Object.defineProperty(this, "globalAlpha", {
            get: function get() {
                return this.ctx.globalAlpha;
            },
            set: function set(t) {
                this.ctx.globalAlpha = t;
            }
        }), Object.defineProperty(this, "lineDashOffset", {
            get: function get() {
                return this.ctx.lineDashOffset;
            },
            set: function set(t) {
                this.ctx.lineDashOffset = t, T.call(this);
            }
        }), Object.defineProperty(this, "lineDash", {
            get: function get() {
                return this.ctx.lineDash;
            },
            set: function set(t) {
                this.ctx.lineDash = t, T.call(this);
            }
        }), Object.defineProperty(this, "ignoreClearRect", {
            get: function get() {
                return this.ctx.ignoreClearRect;
            },
            set: function set(t) {
                this.ctx.ignoreClearRect = Boolean(t);
            }
        });
    };
    p.prototype.setLineDash = function(t) {
        this.lineDash = t;
    }, p.prototype.getLineDash = function() {
        return this.lineDash.length % 2 ? this.lineDash.concat(this.lineDash) : this.lineDash.slice();
    }, p.prototype.fill = function() {
        A.call(this, "fill", !1);
    }, p.prototype.stroke = function() {
        A.call(this, "stroke", !1);
    }, p.prototype.beginPath = function() {
        this.path = [
            {
                type: "begin"
            }
        ];
    }, p.prototype.moveTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.moveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.moveTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "mt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(t, e);
    }, p.prototype.closePath = function() {
        var _$e = new c(0, 0), r = 0;
        for(r = this.path.length - 1; -1 !== r; r--)if ("begin" === this.path[r].type && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(this.path[r + 1]) && "number" == typeof this.path[r + 1].x) {
            _$e = new c(this.path[r + 1].x, this.path[r + 1].y);
            break;
        }
        this.path.push({
            type: "close"
        }), this.ctx.lastPoint = new c(_$e.x, _$e.y);
    }, p.prototype.lineTo = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.lineTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.lineTo");
        var r = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "lt",
            x: r.x,
            y: r.y
        }), this.ctx.lastPoint = new c(r.x, r.y);
    }, p.prototype.clip = function() {
        this.ctx.clip_path = JSON.parse(JSON.stringify(this.path)), A.call(this, null, !0);
    }, p.prototype.quadraticCurveTo = function(t, e, r, n) {
        if (isNaN(r) || isNaN(n) || isNaN(t) || isNaN(e)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");
        var _$i = this.ctx.transform.applyToPoint(new c(r, n)), o = this.ctx.transform.applyToPoint(new c(t, e));
        this.path.push({
            type: "qct",
            x1: o.x,
            y1: o.y,
            x: _$i.x,
            y: _$i.y
        }), this.ctx.lastPoint = new c(_$i.x, _$i.y);
    }, p.prototype.bezierCurveTo = function(t, e, r, n, i, o) {
        if (isNaN(i) || isNaN(o) || isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");
        var s = this.ctx.transform.applyToPoint(new c(i, o)), u = this.ctx.transform.applyToPoint(new c(t, e)), h = this.ctx.transform.applyToPoint(new c(r, n));
        this.path.push({
            type: "bct",
            x1: u.x,
            y1: u.y,
            x2: h.x,
            y2: h.y,
            x: s.x,
            y: s.y
        }), this.ctx.lastPoint = new c(s.x, s.y);
    }, p.prototype.arc = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.arc: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.arc");
        if (o = Boolean(o), !this.ctx.transform.isIdentity) {
            var s = this.ctx.transform.applyToPoint(new c(t, e));
            t = s.x, e = s.y;
            var u = this.ctx.transform.applyToPoint(new c(0, r)), h = this.ctx.transform.applyToPoint(new c(0, 0));
            r = Math.sqrt(Math.pow(u.x - h.x, 2) + Math.pow(u.y - h.y, 2));
        }
        Math.abs(i - n) >= 2 * Math.PI && (n = 0, i = 2 * Math.PI), this.path.push({
            type: "arc",
            x: t,
            y: e,
            radius: r,
            startAngle: n,
            endAngle: i,
            counterclockwise: o
        });
    }, p.prototype.arcTo = function(t, e, r, n, i) {
        throw new Error("arcTo not implemented.");
    }, p.prototype.rect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.rect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rect");
        this.moveTo(t, e), this.lineTo(t + r, e), this.lineTo(t + r, e + n), this.lineTo(t, e + n), this.lineTo(t, e), this.lineTo(t + r, e), this.lineTo(t, e);
    }, p.prototype.fillRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.fillRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillRect");
        if (!m.call(this)) {
            var _$i = {};
            "butt" !== this.lineCap && (_$i.lineCap = this.lineCap, this.lineCap = "butt"), "miter" !== this.lineJoin && (_$i.lineJoin = this.lineJoin, this.lineJoin = "miter"), this.beginPath(), this.rect(t, e, r, n), this.fill(), _$i.hasOwnProperty("lineCap") && (this.lineCap = _$i.lineCap), _$i.hasOwnProperty("lineJoin") && (this.lineJoin = _$i.lineJoin);
        }
    }, p.prototype.strokeRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.strokeRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");
        v.call(this) || (this.beginPath(), this.rect(t, e, r, n), this.stroke());
    }, p.prototype.clearRect = function(t, e, r, n) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.clearRect: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.clearRect");
        this.ignoreClearRect || (this.fillStyle = "#ffffff", this.fillRect(t, e, r, n));
    }, p.prototype.save = function(t) {
        t = "boolean" != typeof t || t;
        for(var _$e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("q");
        if (this.pdf.setPage(_$e), t) {
            this.ctx.fontSize = this.pdf.internal.getFontSize();
            var n = new d(this.ctx);
            this.ctxStack.push(this.ctx), this.ctx = n;
        }
    }, p.prototype.restore = function(t) {
        t = "boolean" != typeof t || t;
        for(var _$e = this.pdf.internal.getCurrentPageInfo().pageNumber, r = 0; r < this.pdf.internal.getNumberOfPages(); r++)this.pdf.setPage(r + 1), this.pdf.internal.out("Q");
        this.pdf.setPage(_$e), t && 0 !== this.ctxStack.length && (this.ctx = this.ctxStack.pop(), this.fillStyle = this.ctx.fillStyle, this.strokeStyle = this.ctx.strokeStyle, this.font = this.ctx.font, this.lineCap = this.ctx.lineCap, this.lineWidth = this.ctx.lineWidth, this.lineJoin = this.ctx.lineJoin, this.lineDash = this.ctx.lineDash, this.lineDashOffset = this.ctx.lineDashOffset);
    }, p.prototype.toDataURL = function() {
        throw new Error("toDataUrl not implemented.");
    };
    var g = function g(t) {
        var _$e, r, n, _$i;
        if (!0 === t.isCanvasGradient && (t = t.getColor()), !t) return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            style: t
        };
        if (/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t)) _$e = 0, r = 0, n = 0, _$i = 0;
        else {
            var a = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);
            if (null !== a) _$e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), _$i = 1;
            else if (null !== (a = /rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t))) _$e = parseInt(a[1]), r = parseInt(a[2]), n = parseInt(a[3]), _$i = parseFloat(a[4]);
            else {
                if (_$i = 1, "string" == typeof t && "#" !== t.charAt(0)) {
                    var o = new $cbf54afc98507811$var$f(t);
                    t = o.ok ? o.toHex() : "#000000";
                }
                4 === t.length ? (_$e = t.substring(1, 2), _$e += _$e, r = t.substring(2, 3), r += r, n = t.substring(3, 4), n += n) : (_$e = t.substring(1, 3), r = t.substring(3, 5), n = t.substring(5, 7)), _$e = parseInt(_$e, 16), r = parseInt(r, 16), n = parseInt(n, 16);
            }
        }
        return {
            r: _$e,
            g: r,
            b: n,
            a: _$i,
            style: t
        };
    }, m = function m() {
        return this.ctx.isFillTransparent || 0 == this.globalAlpha;
    }, v = function v() {
        return Boolean(this.ctx.isStrokeTransparent || 0 == this.globalAlpha);
    };
    p.prototype.fillText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.fillText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.fillText");
        if (n = isNaN(n) ? void 0 : n, !m.call(this)) {
            var _$i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                angle: _$i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.strokeText = function(t, e, r, n) {
        if (isNaN(e) || isNaN(r) || "string" != typeof t) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.strokeText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.strokeText");
        if (!v.call(this)) {
            n = isNaN(n) ? void 0 : n;
            var _$i = q(this.ctx.transform.rotation), o = this.ctx.transform.scaleX;
            C.call(this, {
                text: t,
                x: e,
                y: r,
                scale: o,
                renderingMode: "stroke",
                angle: _$i,
                align: this.textAlign,
                maxWidth: n
            });
        }
    }, p.prototype.measureText = function(t) {
        if ("string" != typeof t) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.measureText: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.measureText");
        var _$e = this.pdf, r = this.pdf.internal.scaleFactor, n = _$e.internal.getFontSize(), _$i = _$e.getStringUnitWidth(t) * n / _$e.internal.scaleFactor, o = function o(t) {
            var _$e = (t = t || {}).width || 0;
            return Object.defineProperty(this, "width", {
                get: function get() {
                    return _$e;
                }
            }), this;
        };
        return new o({
            width: _$i *= Math.round(96 * r / 72 * 1e4) / 1e4
        });
    }, p.prototype.scale = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.scale: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.scale");
        var r = new h(t, 0, 0, e, 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.rotate = function(t) {
        if (isNaN(t)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.rotate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.rotate");
        var _$e = new h(Math.cos(t), Math.sin(t), -Math.sin(t), Math.cos(t), 0, 0);
        this.ctx.transform = this.ctx.transform.multiply(_$e);
    }, p.prototype.translate = function(t, e) {
        if (isNaN(t) || isNaN(e)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.translate: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.translate");
        var r = new h(1, 0, 0, 1, t, e);
        this.ctx.transform = this.ctx.transform.multiply(r);
    }, p.prototype.transform = function(t, e, r, n, i, o) {
        if (isNaN(t) || isNaN(e) || isNaN(r) || isNaN(n) || isNaN(i) || isNaN(o)) throw $cbf54afc98507811$var$a.error("jsPDF.context2d.transform: Invalid arguments", arguments), new Error("Invalid arguments passed to jsPDF.context2d.transform");
        var s = new h(t, e, r, n, i, o);
        this.ctx.transform = this.ctx.transform.multiply(s);
    }, p.prototype.setTransform = function(t, e, r, n, i, a) {
        t = isNaN(t) ? 1 : t, e = isNaN(e) ? 0 : e, r = isNaN(r) ? 0 : r, n = isNaN(n) ? 1 : n, i = isNaN(i) ? 0 : i, a = isNaN(a) ? 0 : a, this.ctx.transform = new h(t, e, r, n, i, a);
    };
    var b = function b() {
        return this.margin[0] > 0 || this.margin[1] > 0 || this.margin[2] > 0 || this.margin[3] > 0;
    };
    p.prototype.drawImage = function(t, e, r, n, i, a, o, s, c) {
        var l = this.pdf.getImageProperties(t), f = 1, d = 1, p = 1, g = 1;
        void 0 !== n && void 0 !== s && (p = s / n, g = c / i, f = l.width / n * s / n, d = l.height / i * c / i), void 0 === a && (a = e, o = r, e = 0, r = 0), void 0 !== n && void 0 === s && (s = n, c = i), void 0 === n && void 0 === s && (s = l.width, c = l.height);
        for(var m, v = this.ctx.transform.decompose(), w = q(v.rotate.shx), A = new h, S = (A = (A = (A = A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a - e * p, o - r * g, n * f, i * d)), _ = _$y.call(this, S), P = [], k = 0; k < _.length; k += 1)-1 === P.indexOf(_[k]) && P.push(_[k]);
        if (L(P), this.autoPaging) for(var _$I = P[0], F = P[P.length - 1], C = _$I; C < F + 1; C++){
            this.pdf.setPage(C);
            var _$j = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], O = 1 === C ? this.posY + this.margin[0] : this.margin[0], B = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], M = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], _$E = 1 === C ? 0 : B + (C - 2) * M;
            if (0 !== this.ctx.clip_path.length) {
                var D = this.path;
                m = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(m, this.posX + this.margin[3], -_$E + O + this.ctx.prevPageLastElemOffset), x.call(this, "fill", !0), this.path = D;
            }
            var R = JSON.parse(JSON.stringify(S));
            R = N([
                R
            ], this.posX + this.margin[3], -_$E + O + this.ctx.prevPageLastElemOffset)[0];
            var T = (C > _$I || C < F) && b.call(this);
            T && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _$j, M, null).clip().discardPath()), this.pdf.addImage(t, "JPEG", R.x, R.y, R.w, R.h, null, null, w), T && this.pdf.restoreGraphicsState();
        }
        else this.pdf.addImage(t, "JPEG", S.x, S.y, S.w, S.h, null, null, w);
    };
    var _$y = function y(t, e, r) {
        var n = [];
        e = e || this.pdf.internal.pageSize.width, r = r || this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2];
        var _$i = this.posY + this.ctx.prevPageLastElemOffset;
        switch(t.type){
            default:
            case "mt":
            case "lt":
                n.push(Math.floor((t.y + _$i) / r) + 1);
                break;
            case "arc":
                n.push(Math.floor((t.y + _$i - t.radius) / r) + 1), n.push(Math.floor((t.y + _$i + t.radius) / r) + 1);
                break;
            case "qct":
                var a = D(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x, t.y);
                n.push(Math.floor((a.y + _$i) / r) + 1), n.push(Math.floor((a.y + a.h + _$i) / r) + 1);
                break;
            case "bct":
                var o = R(this.ctx.lastPoint.x, this.ctx.lastPoint.y, t.x1, t.y1, t.x2, t.y2, t.x, t.y);
                n.push(Math.floor((o.y + _$i) / r) + 1), n.push(Math.floor((o.y + o.h + _$i) / r) + 1);
                break;
            case "rect":
                n.push(Math.floor((t.y + _$i) / r) + 1), n.push(Math.floor((t.y + t.h + _$i) / r) + 1);
        }
        for(var s = 0; s < n.length; s += 1)for(; this.pdf.internal.getNumberOfPages() < n[s];)w.call(this);
        return n;
    }, w = function w() {
        var _$t = this.fillStyle, _$e = this.strokeStyle, r = this.font, n = this.lineCap, _$i = this.lineWidth, a = this.lineJoin;
        this.pdf.addPage(), this.fillStyle = _$t, this.strokeStyle = _$e, this.font = r, this.lineCap = n, this.lineWidth = _$i, this.lineJoin = a;
    }, N = function N(t, e, r) {
        for(var n = 0; n < t.length; n++)switch(t[n].type){
            case "bct":
                t[n].x2 += e, t[n].y2 += r;
            case "qct":
                t[n].x1 += e, t[n].y1 += r;
            case "mt":
            case "lt":
            case "arc":
            default:
                t[n].x += e, t[n].y += r;
        }
        return t;
    }, L = function L(t) {
        return t.sort(function(t, e) {
            return t - e;
        });
    }, A = function A(t, e) {
        for(var r, n, _$i = this.fillStyle, a = this.strokeStyle, o = this.lineCap, s = this.lineWidth, c = Math.abs(s * this.ctx.transform.scaleX), u = this.lineJoin, h = JSON.parse(JSON.stringify(this.path)), l = JSON.parse(JSON.stringify(this.path)), f = [], d = 0; d < l.length; d++)if (void 0 !== l[d].x) for(var p = _$y.call(this, l[d]), g = 0; g < p.length; g += 1)-1 === f.indexOf(p[g]) && f.push(p[g]);
        for(var m = 0; m < f.length; m++)for(; this.pdf.internal.getNumberOfPages() < f[m];)w.call(this);
        if (L(f), this.autoPaging) for(var v = f[0], A = f[f.length - 1], S = v; S < A + 1; S++){
            this.pdf.setPage(S), this.fillStyle = _$i, this.strokeStyle = a, this.lineCap = o, this.lineWidth = c, this.lineJoin = u;
            var _ = this.pdf.internal.pageSize.width - this.margin[3] - this.margin[1], P = 1 === S ? this.posY + this.margin[0] : this.margin[0], k = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], _$I = this.pdf.internal.pageSize.height - this.margin[0] - this.margin[2], F = 1 === S ? 0 : k + (S - 2) * _$I;
            if (0 !== this.ctx.clip_path.length) {
                var C = this.path;
                r = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(r, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), x.call(this, t, !0), this.path = C;
            }
            if (n = JSON.parse(JSON.stringify(h)), this.path = N(n, this.posX + this.margin[3], -F + P + this.ctx.prevPageLastElemOffset), !1 === e || 0 === S) {
                var _$j = (S > v || S < A) && b.call(this);
                _$j && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], _, _$I, null).clip().discardPath()), x.call(this, t, e), _$j && this.pdf.restoreGraphicsState();
            }
            this.lineWidth = s;
        }
        else this.lineWidth = c, x.call(this, t, e), this.lineWidth = s;
        this.path = h;
    }, x = function x(t, e) {
        if (("stroke" !== t || e || !v.call(this)) && ("stroke" === t || e || !m.call(this))) {
            for(var r, n, _$i = [], a = this.path, o = 0; o < a.length; o++){
                var s = a[o];
                switch(s.type){
                    case "begin":
                        _$i.push({
                            begin: !0
                        });
                        break;
                    case "close":
                        _$i.push({
                            close: !0
                        });
                        break;
                    case "mt":
                        _$i.push({
                            start: s,
                            deltas: [],
                            abs: []
                        });
                        break;
                    case "lt":
                        var c = _$i.length;
                        if (a[o - 1] && !isNaN(a[o - 1].x) && (r = [
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], c > 0)) {
                            for(; c >= 0; c--)if (!0 !== _$i[c - 1].close && !0 !== _$i[c - 1].begin) {
                                _$i[c - 1].deltas.push(r), _$i[c - 1].abs.push(s);
                                break;
                            }
                        }
                        break;
                    case "bct":
                        r = [
                            s.x1 - a[o - 1].x,
                            s.y1 - a[o - 1].y,
                            s.x2 - a[o - 1].x,
                            s.y2 - a[o - 1].y,
                            s.x - a[o - 1].x,
                            s.y - a[o - 1].y
                        ], _$i[_$i.length - 1].deltas.push(r);
                        break;
                    case "qct":
                        var u = a[o - 1].x + 2 / 3 * (s.x1 - a[o - 1].x), h = a[o - 1].y + 2 / 3 * (s.y1 - a[o - 1].y), l = s.x + 2 / 3 * (s.x1 - s.x), f = s.y + 2 / 3 * (s.y1 - s.y), d = s.x, p = s.y;
                        r = [
                            u - a[o - 1].x,
                            h - a[o - 1].y,
                            l - a[o - 1].x,
                            f - a[o - 1].y,
                            d - a[o - 1].x,
                            p - a[o - 1].y
                        ], _$i[_$i.length - 1].deltas.push(r);
                        break;
                    case "arc":
                        _$i.push({
                            deltas: [],
                            abs: [],
                            arc: !0
                        }), Array.isArray(_$i[_$i.length - 1].abs) && _$i[_$i.length - 1].abs.push(s);
                }
            }
            n = e ? null : "stroke" === t ? "stroke" : "fill";
            for(var g = !1, b = 0; b < _$i.length; b++)if (_$i[b].arc) for(var _$y = _$i[b].abs, w = 0; w < _$y.length; w++){
                var N = _$y[w];
                "arc" === N.type ? P.call(this, N.x, N.y, N.radius, N.startAngle, N.endAngle, N.counterclockwise, void 0, e, !g) : _$j.call(this, N.x, N.y), g = !0;
            }
            else if (!0 === _$i[b].close) this.pdf.internal.out("h"), g = !1;
            else if (!0 !== _$i[b].begin) {
                var L = _$i[b].start.x, A = _$i[b].start.y;
                O.call(this, _$i[b].deltas, L, A), g = !0;
            }
            n && k.call(this, n), e && _$I.call(this);
        }
    }, S = function S(t) {
        var _$e = this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor, r = _$e * (this.pdf.internal.getLineHeightFactor() - 1);
        switch(this.ctx.textBaseline){
            case "bottom":
                return t - r;
            case "top":
                return t + _$e - r;
            case "hanging":
                return t + _$e - 2 * r;
            case "middle":
                return t + _$e / 2 - r;
            case "ideographic":
                return t;
            case "alphabetic":
            default:
                return t;
        }
    }, _ = function _(t) {
        return t + this.pdf.internal.getFontSize() / this.pdf.internal.scaleFactor * (this.pdf.internal.getLineHeightFactor() - 1);
    };
    p.prototype.createLinearGradient = function() {
        var _$t = function t() {};
        return _$t.colorStops = [], _$t.addColorStop = function(t, e) {
            this.colorStops.push([
                t,
                e
            ]);
        }, _$t.getColor = function() {
            return 0 === this.colorStops.length ? "#000000" : this.colorStops[0][1];
        }, _$t.isCanvasGradient = !0, _$t;
    }, p.prototype.createPattern = function() {
        return this.createLinearGradient();
    }, p.prototype.createRadialGradient = function() {
        return this.createLinearGradient();
    };
    var P = function P(t, e, r, n, i, a, o, s, c) {
        for(var u = M.call(this, r, n, i, a), h = 0; h < u.length; h++){
            var l = u[h];
            0 === h && (c ? F.call(this, l.x1 + t, l.y1 + e) : _$j.call(this, l.x1 + t, l.y1 + e)), B.call(this, t, e, l.x2, l.y2, l.x3, l.y3, l.x4, l.y4);
        }
        s ? _$I.call(this) : k.call(this, o);
    }, k = function k(t) {
        switch(t){
            case "stroke":
                this.pdf.internal.out("S");
                break;
            case "fill":
                this.pdf.internal.out("f");
        }
    }, _$I = function I() {
        this.pdf.clip(), this.pdf.discardPath();
    }, F = function F(t, e) {
        this.pdf.internal.out(n(t) + " " + _$i(e) + " m");
    }, C = function C(t) {
        var _$e;
        switch(t.align){
            case "right":
            case "end":
                _$e = "right";
                break;
            case "center":
                _$e = "center";
                break;
            case "left":
            case "start":
            default:
                _$e = "left";
        }
        var r = this.pdf.getTextDimensions(t.text), n = S.call(this, t.y), _$i = _.call(this, n) - r.h, a = this.ctx.transform.applyToPoint(new c(t.x, n)), o = this.ctx.transform.decompose(), s = new h;
        s = (s = (s = s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);
        for(var l, f, d, p = this.ctx.transform.applyToRectangle(new u(t.x, n, r.w, r.h)), g = s.applyToRectangle(new u(t.x, _$i, r.w, r.h)), m = _$y.call(this, g), v = [], w = 0; w < m.length; w += 1)-1 === v.indexOf(m[w]) && v.push(m[w]);
        if (L(v), this.autoPaging) for(var A = v[0], P = v[v.length - 1], k = A; k < P + 1; k++){
            this.pdf.setPage(k);
            var _$I = 1 === k ? this.posY + this.margin[0] : this.margin[0], F = this.pdf.internal.pageSize.height - this.posY - this.margin[0] - this.margin[2], C = this.pdf.internal.pageSize.height - this.margin[2], _$j = C - this.margin[0], O = this.pdf.internal.pageSize.width - this.margin[1], B = O - this.margin[3], M = 1 === k ? 0 : F + (k - 2) * _$j;
            if (0 !== this.ctx.clip_path.length) {
                var _$E = this.path;
                l = JSON.parse(JSON.stringify(this.ctx.clip_path)), this.path = N(l, this.posX + this.margin[3], -1 * M + _$I), x.call(this, "fill", !0), this.path = _$E;
            }
            var q = N([
                JSON.parse(JSON.stringify(g))
            ], this.posX + this.margin[3], -M + _$I + this.ctx.prevPageLastElemOffset)[0];
            t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale);
            var D = "text" !== this.autoPaging;
            if (D || q.y + q.h <= C) {
                if (D || q.y >= _$I && q.x <= O) {
                    var R = D ? t.text : this.pdf.splitTextToSize(t.text, t.maxWidth || O - q.x)[0], T = N([
                        JSON.parse(JSON.stringify(p))
                    ], this.posX + this.margin[3], -M + _$I + this.ctx.prevPageLastElemOffset)[0], U = D && (k > A || k < P) && b.call(this);
                    U && (this.pdf.saveGraphicsState(), this.pdf.rect(this.margin[3], this.margin[0], B, _$j, null).clip().discardPath()), this.pdf.text(R, T.x, T.y, {
                        angle: t.angle,
                        align: _$e,
                        renderingMode: t.renderingMode
                    }), U && this.pdf.restoreGraphicsState();
                }
            } else q.y < C && (this.ctx.prevPageLastElemOffset += C - q.y);
            t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
        }
        else t.scale >= .01 && (f = this.pdf.internal.getFontSize(), this.pdf.setFontSize(f * t.scale), d = this.lineWidth, this.lineWidth = d * t.scale), this.pdf.text(t.text, a.x + this.posX, a.y + this.posY, {
            angle: t.angle,
            align: _$e,
            renderingMode: t.renderingMode,
            maxWidth: t.maxWidth
        }), t.scale >= .01 && (this.pdf.setFontSize(f), this.lineWidth = d);
    }, _$j = function j(t, e, r, a) {
        r = r || 0, a = a || 0, this.pdf.internal.out(n(t + r) + " " + _$i(e + a) + " l");
    }, O = function O(t, e, r) {
        return this.pdf.lines(t, e, r, null, null);
    }, B = function B(t, e, n, i, a, c, u, h) {
        this.pdf.internal.out([
            r(o(n + t)),
            r(s(i + e)),
            r(o(a + t)),
            r(s(c + e)),
            r(o(u + t)),
            r(s(h + e)),
            "c"
        ].join(" "));
    }, M = function M(t, e, r, n) {
        for(var _$i = 2 * Math.PI, a = Math.PI / 2; e > r;)e -= _$i;
        var o = Math.abs(r - e);
        o < _$i && n && (o = _$i - o);
        for(var s = [], c = n ? -1 : 1, u = e; o > 1e-5;){
            var h = u + c * Math.min(o, a);
            s.push(_$E.call(this, t, u, h)), o -= Math.abs(h - u), u = h;
        }
        return s;
    }, _$E = function E(t, e, r) {
        var n = (r - e) / 2, _$i = t * Math.cos(n), a = t * Math.sin(n), o = _$i, s = -a, c = o * o + s * s, u = c + o * _$i + s * a, h = 4 / 3 * (Math.sqrt(2 * c * u) - u) / (o * a - s * _$i), l = o - h * s, f = s + h * o, d = l, p = -f, g = n + e, m = Math.cos(g), v = Math.sin(g);
        return {
            x1: t * Math.cos(e),
            y1: t * Math.sin(e),
            x2: l * m - f * v,
            y2: l * v + f * m,
            x3: d * m - p * v,
            y3: d * v + p * m,
            x4: t * Math.cos(r),
            y4: t * Math.sin(r)
        };
    }, q = function q(t) {
        return 180 * t / Math.PI;
    }, D = function D(t, e, r, n, i, a) {
        var o = t + .5 * (r - t), s = e + .5 * (n - e), c = i + .5 * (r - i), h = a + .5 * (n - a), l = Math.min(t, i, o, c), f = Math.max(t, i, o, c), d = Math.min(e, a, s, h), p = Math.max(e, a, s, h);
        return new u(l, d, f - l, p - d);
    }, R = function R(t, e, r, n, i, a, o, s) {
        var c, h, l, f, d, p, g, m, v, b, _$y, w, N, L, A = r - t, x = n - e, S = i - r, _ = a - n, P = o - i, k = s - a;
        for(h = 0; h < 41; h++)v = (g = (l = t + (c = h / 40) * A) + c * ((d = r + c * S) - l)) + c * (d + c * (i + c * P - d) - g), b = (m = (f = e + c * x) + c * ((p = n + c * _) - f)) + c * (p + c * (a + c * k - p) - m), 0 == h ? (_$y = v, w = b, N = v, L = b) : (_$y = Math.min(_$y, v), w = Math.min(w, b), N = Math.max(N, v), L = Math.max(L, b));
        return new u(Math.round(_$y), Math.round(w), Math.round(N - _$y), Math.round(L - w));
    }, T = function T() {
        if (this.prevLineDash || this.ctx.lineDash.length || this.ctx.lineDashOffset) {
            var _$t, _$e, r = (_$t = this.ctx.lineDash, _$e = this.ctx.lineDashOffset, JSON.stringify({
                lineDash: _$t,
                lineDashOffset: _$e
            }));
            this.prevLineDash !== r && (this.pdf.setLineDash(this.ctx.lineDash, this.ctx.lineDashOffset), this.prevLineDash = r);
        }
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), /**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var r = function r(t) {
        var e, r, n, _$i, a, o, s, c, u, h;
        for(/[^\x00-\xFF]/.test(t), r = [], n = 0, _$i = (t += e = "\x00\x00\x00\x00".slice(t.length % 4 || 4)).length; _$i > n; n += 4)0 !== (a = (t.charCodeAt(n) << 24) + (t.charCodeAt(n + 1) << 16) + (t.charCodeAt(n + 2) << 8) + t.charCodeAt(n + 3)) ? (o = (a = ((a = ((a = ((a = (a - (h = a % 85)) / 85) - (u = a % 85)) / 85) - (c = a % 85)) / 85) - (s = a % 85)) / 85) % 85, r.push(o + 33, s + 33, c + 33, u + 33, h + 33)) : r.push(122);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(r, e.length), String.fromCharCode.apply(String, r) + "~>";
    }, n = function n(t) {
        var e, r, n, _$i, a, o = String, s = "length", c = 255, u = "charCodeAt", h = "slice", l = "replace";
        for(t[h](-2), t = t[h](0, -2)[l](/\s/g, "")[l]("z", "!!!!!"), n = [], _$i = 0, a = (t += e = "uuuuu"[h](t[s] % 5 || 5))[s]; a > _$i; _$i += 5)r = 52200625 * (t[u](_$i) - 33) + 614125 * (t[u](_$i + 1) - 33) + 7225 * (t[u](_$i + 2) - 33) + 85 * (t[u](_$i + 3) - 33) + (t[u](_$i + 4) - 33), n.push(c & r >> 24, c & r >> 16, c & r >> 8, c & r);
        return function(t, e) {
            for(var r = e; r > 0; r--)t.pop();
        }(n, e[s]), o.fromCharCode.apply(o, n);
    }, _$i = function i(t) {
        var e = new RegExp(/^([0-9A-Fa-f]{2})+$/);
        if (-1 !== (t = t.replace(/\s/g, "")).indexOf(">") && (t = t.substr(0, t.indexOf(">"))), t.length % 2 && (t += "0"), !1 === e.test(t)) return "";
        for(var r = "", n = 0; n < t.length; n += 2)r += String.fromCharCode("0x" + (t[n] + t[n + 1]));
        return r;
    }, a = function a(t) {
        for(var r = new Uint8Array(t.length), n = t.length; n--;)r[n] = t.charCodeAt(n);
        return t = (r = (0, $b495f2b996e3784e$export$f87121a6d50aff25)(r)).reduce(function(t, e) {
            return t + String.fromCharCode(e);
        }, "");
    };
    t.processDataByFilters = function(t, e) {
        var o = 0, s = t || "", c = [];
        for("string" == typeof (e = e || []) && (e = [
            e
        ]), o = 0; o < e.length; o += 1)switch(e[o]){
            case "ASCII85Decode":
            case "/ASCII85Decode":
                s = n(s), c.push("/ASCII85Encode");
                break;
            case "ASCII85Encode":
            case "/ASCII85Encode":
                s = r(s), c.push("/ASCII85Decode");
                break;
            case "ASCIIHexDecode":
            case "/ASCIIHexDecode":
                s = _$i(s), c.push("/ASCIIHexEncode");
                break;
            case "ASCIIHexEncode":
            case "/ASCIIHexEncode":
                s = s.split("").map(function(t) {
                    return ("0" + t.charCodeAt().toString(16)).slice(-2);
                }).join("") + ">", c.push("/ASCIIHexDecode");
                break;
            case "FlateEncode":
            case "/FlateEncode":
                s = a(s), c.push("/FlateDecode");
                break;
            default:
                throw new Error('The filter: "' + e[o] + '" is not implemented');
        }
        return {
            data: s,
            reverseChain: c.reverse().join(" ")
        };
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), /**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.loadFile = function(t, e, r) {
        return function(t, e, r) {
            e = !1 !== e, r = "function" == typeof r ? r : function r() {};
            var n = void 0;
            try {
                n = function(t, e, r) {
                    var n = new XMLHttpRequest, _$i = 0, a = function a(t) {
                        var _$e = t.length, _$r = [], n = String.fromCharCode;
                        for(_$i = 0; _$i < _$e; _$i += 1)_$r.push(n(255 & t.charCodeAt(_$i)));
                        return _$r.join("");
                    };
                    if (n.open("GET", t, !e), n.overrideMimeType("text/plain; charset=x-user-defined"), !1 === e && (n.onload = function() {
                        200 === n.status ? r(a(this.responseText)) : r(void 0);
                    }), n.send(null), e && 200 === n.status) return a(n.responseText);
                }(t, e, r);
            } catch (t) {}
            return n;
        }(t, e, r);
    }, t.loadImageFile = t.loadFile;
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), function(e) {
    var r = function r() {
        return ($cbf54afc98507811$var$n.html2canvas ? Promise.resolve($cbf54afc98507811$var$n.html2canvas) : Promise.resolve((parcelRequire("6lLHD")))).catch(function(t) {
            return Promise.reject(new Error("Could not load html2canvas: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    };
    var _$i = function _$i() {
        return ($cbf54afc98507811$var$n.DOMPurify ? Promise.resolve($cbf54afc98507811$var$n.DOMPurify) : (parcelRequire("jkOtN"))).catch(function(t) {
            return Promise.reject(new Error("Could not load dompurify: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    };
    var a = function a(e) {
        var r = (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e);
        return "undefined" === r ? "undefined" : "string" === r || e instanceof String ? "string" : "number" === r || e instanceof Number ? "number" : "function" === r || e instanceof Function ? "function" : e && e.constructor === Array ? "array" : e && 1 === e.nodeType ? "element" : "object" === r ? "object" : "unknown";
    }, o = function o(t, e) {
        var r = document.createElement(t);
        for(var n in e.className && (r.className = e.className), e.innerHTML && e.dompurify && (r.innerHTML = e.dompurify.sanitize(e.innerHTML)), e.style)r.style[n] = e.style[n];
        return r;
    }, s = function t(e) {
        var r = Object.assign(t.convert(Promise.resolve()), JSON.parse(JSON.stringify(t.template))), n = t.convert(Promise.resolve(), r);
        return n = (n = n.setProgress(1, t, 1, [
            t
        ])).set(e);
    };
    (s.prototype = Object.create(Promise.prototype)).constructor = s, s.convert = function(t, e) {
        return t.__proto__ = e || s.prototype, t;
    }, s.template = {
        prop: {
            src: null,
            container: null,
            overlay: null,
            canvas: null,
            img: null,
            pdf: null,
            pageSize: null,
            callback: function callback() {}
        },
        progress: {
            val: 0,
            state: null,
            n: 0,
            stack: []
        },
        opt: {
            filename: "file.pdf",
            margin: [
                0,
                0,
                0,
                0
            ],
            enableLinks: !0,
            x: 0,
            y: 0,
            html2canvas: {},
            jsPDF: {},
            backgroundColor: "transparent"
        }
    }, s.prototype.from = function(t, e) {
        return this.then(function() {
            switch(e = e || function(t) {
                switch(a(t)){
                    case "string":
                        return "string";
                    case "element":
                        return "canvas" === t.nodeName.toLowerCase() ? "canvas" : "element";
                    default:
                        return "unknown";
                }
            }(t)){
                case "string":
                    return this.then(_$i).then(function(e) {
                        return this.set({
                            src: o("div", {
                                innerHTML: t,
                                dompurify: e
                            })
                        });
                    });
                case "element":
                    return this.set({
                        src: t
                    });
                case "canvas":
                    return this.set({
                        canvas: t
                    });
                case "img":
                    return this.set({
                        img: t
                    });
                default:
                    return this.error("Unknown source type.");
            }
        });
    }, s.prototype.to = function(t) {
        switch(t){
            case "container":
                return this.toContainer();
            case "canvas":
                return this.toCanvas();
            case "img":
                return this.toImg();
            case "pdf":
                return this.toPdf();
            default:
                return this.error("Invalid target.");
        }
    }, s.prototype.toContainer = function() {
        return this.thenList([
            function() {
                return this.prop.src || this.error("Cannot duplicate - no source HTML.");
            },
            function() {
                return this.prop.pageSize || this.setPageSize();
            }
        ]).then(function() {
            var _$t = {
                position: "relative",
                display: "inline-block",
                width: ("number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? Math.max(this.prop.src.clientWidth, this.prop.src.scrollWidth, this.prop.src.offsetWidth) : this.opt.windowWidth) + "px",
                left: 0,
                right: 0,
                top: 0,
                margin: "auto",
                backgroundColor: this.opt.backgroundColor
            }, _$e = function t(e, r) {
                for(var n = 3 === e.nodeType ? document.createTextNode(e.nodeValue) : e.cloneNode(!1), _$i = e.firstChild; _$i; _$i = _$i.nextSibling)!0 !== r && 1 === _$i.nodeType && "SCRIPT" === _$i.nodeName || n.appendChild(t(_$i, r));
                return 1 === e.nodeType && ("CANVAS" === e.nodeName ? (n.width = e.width, n.height = e.height, n.getContext("2d").drawImage(e, 0, 0)) : "TEXTAREA" !== e.nodeName && "SELECT" !== e.nodeName || (n.value = e.value), n.addEventListener("load", function() {
                    n.scrollTop = e.scrollTop, n.scrollLeft = e.scrollLeft;
                }, !0)), n;
            }(this.prop.src, this.opt.html2canvas.javascriptEnabled);
            "BODY" === _$e.tagName && (_$t.height = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) + "px"), this.prop.overlay = o("div", {
                className: "html2pdf__overlay",
                style: {
                    position: "fixed",
                    overflow: "hidden",
                    zIndex: 1e3,
                    left: "-100000px",
                    right: 0,
                    bottom: 0,
                    top: 0
                }
            }), this.prop.container = o("div", {
                className: "html2pdf__container",
                style: _$t
            }), this.prop.container.appendChild(_$e), this.prop.container.firstChild.appendChild(o("div", {
                style: {
                    clear: "both",
                    border: "0 none transparent",
                    margin: 0,
                    padding: 0,
                    height: 0
                }
            })), this.prop.container.style.float = "none", this.prop.overlay.appendChild(this.prop.container), document.body.appendChild(this.prop.overlay), this.prop.container.firstChild.style.position = "relative", this.prop.container.height = Math.max(this.prop.container.firstChild.clientHeight, this.prop.container.firstChild.scrollHeight, this.prop.container.firstChild.offsetHeight) + "px";
        });
    }, s.prototype.toCanvas = function() {
        var _$t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(_$t).then(r).then(function(t) {
            var _$e = Object.assign({}, this.opt.html2canvas);
            return delete _$e.onrendered, t(this.prop.container, _$e);
        }).then(function(t) {
            (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toContext2d = function() {
        var _$t = [
            function() {
                return document.body.contains(this.prop.container) || this.toContainer();
            }
        ];
        return this.thenList(_$t).then(r).then(function(t) {
            var _$e = this.opt.jsPDF, r = this.opt.fontFaces, n = "number" != typeof this.opt.width || isNaN(this.opt.width) || "number" != typeof this.opt.windowWidth || isNaN(this.opt.windowWidth) ? 1 : this.opt.width / this.opt.windowWidth, _$i = Object.assign({
                async: !0,
                allowTaint: !0,
                scale: n,
                scrollX: this.opt.scrollX || 0,
                scrollY: this.opt.scrollY || 0,
                backgroundColor: "#ffffff",
                imageTimeout: 15e3,
                logging: !0,
                proxy: null,
                removeContainer: !0,
                foreignObjectRendering: !1,
                useCORS: !1
            }, this.opt.html2canvas);
            if (delete _$i.onrendered, _$e.context2d.autoPaging = void 0 === this.opt.autoPaging || this.opt.autoPaging, _$e.context2d.posX = this.opt.x, _$e.context2d.posY = this.opt.y, _$e.context2d.margin = this.opt.margin, _$e.context2d.fontFaces = r, r) for(var a = 0; a < r.length; ++a){
                var o = r[a], s = o.src.find(function(t) {
                    return "truetype" === t.format;
                });
                s && _$e.addFont(s.url, o.ref.name, o.ref.style);
            }
            return _$i.windowHeight = _$i.windowHeight || 0, _$i.windowHeight = 0 == _$i.windowHeight ? Math.max(this.prop.container.clientHeight, this.prop.container.scrollHeight, this.prop.container.offsetHeight) : _$i.windowHeight, _$e.context2d.save(!0), t(this.prop.container, _$i);
        }).then(function(t) {
            this.opt.jsPDF.context2d.restore(!0), (this.opt.html2canvas.onrendered || function() {})(t), this.prop.canvas = t, document.body.removeChild(this.prop.overlay);
        });
    }, s.prototype.toImg = function() {
        return this.thenList([
            function() {
                return this.prop.canvas || this.toCanvas();
            }
        ]).then(function() {
            var _$t = this.prop.canvas.toDataURL("image/" + this.opt.image.type, this.opt.image.quality);
            this.prop.img = document.createElement("img"), this.prop.img.src = _$t;
        });
    }, s.prototype.toPdf = function() {
        return this.thenList([
            function() {
                return this.toContext2d();
            }
        ]).then(function() {
            this.prop.pdf = this.prop.pdf || this.opt.jsPDF;
        });
    }, s.prototype.output = function(t, e, r) {
        return "img" === (r = r || "pdf").toLowerCase() || "image" === r.toLowerCase() ? this.outputImg(t, e) : this.outputPdf(t, e);
    }, s.prototype.outputPdf = function(t, e) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            return this.prop.pdf.output(t, e);
        });
    }, s.prototype.outputImg = function(t) {
        return this.thenList([
            function() {
                return this.prop.img || this.toImg();
            }
        ]).then(function() {
            switch(t){
                case void 0:
                case "img":
                    return this.prop.img;
                case "datauristring":
                case "dataurlstring":
                    return this.prop.img.src;
                case "datauri":
                case "dataurl":
                    return document.location.href = this.prop.img.src;
                default:
                    throw 'Image output type "' + t + '" is not supported.';
            }
        });
    }, s.prototype.save = function(t) {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).set(t ? {
            filename: t
        } : null).then(function() {
            this.prop.pdf.save(this.opt.filename);
        });
    }, s.prototype.doCallback = function() {
        return this.thenList([
            function() {
                return this.prop.pdf || this.toPdf();
            }
        ]).then(function() {
            this.prop.callback(this.prop.pdf);
        });
    }, s.prototype.set = function(t) {
        if ("object" !== a(t)) return this;
        var _$e = Object.keys(t || {}).map(function(e) {
            if (e in s.template.prop) return function() {
                this.prop[e] = t[e];
            };
            switch(e){
                case "margin":
                    return this.setMargin.bind(this, t.margin);
                case "jsPDF":
                    return function() {
                        return this.opt.jsPDF = t.jsPDF, this.setPageSize();
                    };
                case "pageSize":
                    return this.setPageSize.bind(this, t.pageSize);
                default:
                    return function() {
                        this.opt[e] = t[e];
                    };
            }
        }, this);
        return this.then(function() {
            return this.thenList(_$e);
        });
    }, s.prototype.get = function(t, e) {
        return this.then(function() {
            var r = t in s.template.prop ? this.prop[t] : this.opt[t];
            return e ? e(r) : r;
        });
    }, s.prototype.setMargin = function(t) {
        return this.then(function() {
            switch(a(t)){
                case "number":
                    t = [
                        t,
                        t,
                        t,
                        t
                    ];
                case "array":
                    if (2 === t.length && (t = [
                        t[0],
                        t[1],
                        t[0],
                        t[1]
                    ]), 4 === t.length) break;
                default:
                    return this.error("Invalid margin array.");
            }
            this.opt.margin = t;
        }).then(this.setPageSize);
    }, s.prototype.setPageSize = function(t) {
        var _$e = function _$e(t, e) {
            return Math.floor(t * e / 72 * 96);
        };
        return this.then(function() {
            (t = t || $cbf54afc98507811$export$ba1e2ffc633a60f5.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner") || (t.inner = {
                width: t.width - this.opt.margin[1] - this.opt.margin[3],
                height: t.height - this.opt.margin[0] - this.opt.margin[2]
            }, t.inner.px = {
                width: _$e(t.inner.width, t.k),
                height: _$e(t.inner.height, t.k)
            }, t.inner.ratio = t.inner.height / t.inner.width), this.prop.pageSize = t;
        });
    }, s.prototype.setProgress = function(t, e, r, n) {
        return null != t && (this.progress.val = t), null != e && (this.progress.state = e), null != r && (this.progress.n = r), null != n && (this.progress.stack = n), this.progress.ratio = this.progress.val / this.progress.state, this;
    }, s.prototype.updateProgress = function(t, e, r, n) {
        return this.setProgress(t ? this.progress.val + t : null, e || null, r ? this.progress.n + r : null, n ? this.progress.stack.concat(n) : null);
    }, s.prototype.then = function(t, e) {
        var r = this;
        return this.thenCore(t, e, function(t, e) {
            return r.updateProgress(null, null, 1, [
                t
            ]), Promise.prototype.then.call(this, function(e) {
                return r.updateProgress(null, t), e;
            }).then(t, e).then(function(t) {
                return r.updateProgress(1), t;
            });
        });
    }, s.prototype.thenCore = function(t, e, r) {
        r = r || Promise.prototype.then;
        t && (t = t.bind(this)), e && (e = e.bind(this));
        var n = -1 !== Promise.toString().indexOf("[native code]") && "Promise" === Promise.name ? this : s.convert(Object.assign({}, this), Promise.prototype), _$i = r.call(n, t, e);
        return s.convert(_$i, this.__proto__);
    }, s.prototype.thenExternal = function(t, e) {
        return Promise.prototype.then.call(this, t, e);
    }, s.prototype.thenList = function(t) {
        var _$e = this;
        return t.forEach(function(t) {
            _$e = _$e.thenCore(t);
        }), _$e;
    }, s.prototype.catch = function(t) {
        t && (t = t.bind(this));
        var _$e = Promise.prototype.catch.call(this, t);
        return s.convert(_$e, this);
    }, s.prototype.catchExternal = function(t) {
        return Promise.prototype.catch.call(this, t);
    }, s.prototype.error = function(t) {
        return this.then(function() {
            throw new Error(t);
        });
    }, s.prototype.using = s.prototype.set, s.prototype.saveAs = s.prototype.save, s.prototype.export = s.prototype.output, s.prototype.run = s.prototype.then, $cbf54afc98507811$export$ba1e2ffc633a60f5.getPageSize = function(e, r, n) {
        if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e)) {
            var _$i = e;
            e = _$i.orientation, r = _$i.unit || r, n = _$i.format || n;
        }
        r = r || "mm", n = n || "a4", e = ("" + (e || "P")).toLowerCase();
        var a, o = ("" + n).toLowerCase(), s = {
            a0: [
                2383.94,
                3370.39
            ],
            a1: [
                1683.78,
                2383.94
            ],
            a2: [
                1190.55,
                1683.78
            ],
            a3: [
                841.89,
                1190.55
            ],
            a4: [
                595.28,
                841.89
            ],
            a5: [
                419.53,
                595.28
            ],
            a6: [
                297.64,
                419.53
            ],
            a7: [
                209.76,
                297.64
            ],
            a8: [
                147.4,
                209.76
            ],
            a9: [
                104.88,
                147.4
            ],
            a10: [
                73.7,
                104.88
            ],
            b0: [
                2834.65,
                4008.19
            ],
            b1: [
                2004.09,
                2834.65
            ],
            b2: [
                1417.32,
                2004.09
            ],
            b3: [
                1000.63,
                1417.32
            ],
            b4: [
                708.66,
                1000.63
            ],
            b5: [
                498.9,
                708.66
            ],
            b6: [
                354.33,
                498.9
            ],
            b7: [
                249.45,
                354.33
            ],
            b8: [
                175.75,
                249.45
            ],
            b9: [
                124.72,
                175.75
            ],
            b10: [
                87.87,
                124.72
            ],
            c0: [
                2599.37,
                3676.54
            ],
            c1: [
                1836.85,
                2599.37
            ],
            c2: [
                1298.27,
                1836.85
            ],
            c3: [
                918.43,
                1298.27
            ],
            c4: [
                649.13,
                918.43
            ],
            c5: [
                459.21,
                649.13
            ],
            c6: [
                323.15,
                459.21
            ],
            c7: [
                229.61,
                323.15
            ],
            c8: [
                161.57,
                229.61
            ],
            c9: [
                113.39,
                161.57
            ],
            c10: [
                79.37,
                113.39
            ],
            dl: [
                311.81,
                623.62
            ],
            letter: [
                612,
                792
            ],
            "government-letter": [
                576,
                756
            ],
            legal: [
                612,
                1008
            ],
            "junior-legal": [
                576,
                360
            ],
            ledger: [
                1224,
                792
            ],
            tabloid: [
                792,
                1224
            ],
            "credit-card": [
                153,
                243
            ]
        };
        switch(r){
            case "pt":
                a = 1;
                break;
            case "mm":
                a = 72 / 25.4;
                break;
            case "cm":
                a = 72 / 2.54;
                break;
            case "in":
                a = 72;
                break;
            case "px":
                a = .75;
                break;
            case "pc":
            case "em":
                a = 12;
                break;
            case "ex":
                a = 6;
                break;
            default:
                throw "Invalid unit: " + r;
        }
        var c, u = 0, h = 0;
        if (s.hasOwnProperty(o)) u = s[o][1] / a, h = s[o][0] / a;
        else try {
            u = n[1], h = n[0];
        } catch (t) {
            throw new Error("Invalid format: " + n);
        }
        if ("p" === e || "portrait" === e) e = "p", h > u && (c = h, h = u, u = c);
        else {
            if ("l" !== e && "landscape" !== e) throw "Invalid orientation: " + e;
            e = "l", u > h && (c = h, h = u, u = c);
        }
        return {
            width: h,
            height: u,
            unit: r,
            k: a,
            orientation: e
        };
    }, e.html = function(t, e) {
        (e = e || {}).callback = e.callback || function() {}, e.html2canvas = e.html2canvas || {}, e.html2canvas.canvas = e.html2canvas.canvas || this.canvas, e.jsPDF = e.jsPDF || this, e.fontFaces = e.fontFaces ? e.fontFaces.map($cbf54afc98507811$var$jt) : null;
        var r = new s(e);
        return e.worker ? r : r.from(t).doCallback();
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), $cbf54afc98507811$export$ba1e2ffc633a60f5.API.addJS = function(t) {
    return $cbf54afc98507811$var$Ht = t, this.internal.events.subscribe("postPutResources", function() {
        $cbf54afc98507811$var$Ut = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/Names [(EmbeddedJS) " + ($cbf54afc98507811$var$Ut + 1) + " 0 R]"), this.internal.out(">>"), this.internal.out("endobj"), $cbf54afc98507811$var$zt = this.internal.newObject(), this.internal.out("<<"), this.internal.out("/S /JavaScript"), this.internal.out("/JS (" + $cbf54afc98507811$var$Ht + ")"), this.internal.out(">>"), this.internal.out("endobj");
    }), this.internal.events.subscribe("putCatalog", function() {
        void 0 !== $cbf54afc98507811$var$Ut && void 0 !== $cbf54afc98507811$var$zt && this.internal.out("/Names <</JavaScript " + $cbf54afc98507811$var$Ut + " 0 R>>");
    }), this;
}, /**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e;
    t.events.push([
        "postPutResources",
        function() {
            var _$t = this, r = /^(\d+) 0 obj$/;
            if (this.outline.root.children.length > 0) for(var n = _$t.outline.render().split(/\r\n/), _$i = 0; _$i < n.length; _$i++){
                var a = n[_$i], o = r.exec(a);
                if (null != o) {
                    var s = o[1];
                    _$t.internal.newObjectDeferredBegin(s, !1);
                }
                _$t.internal.write(a);
            }
            if (this.outline.createNamedDestinations) {
                var c = this.internal.pages.length, u = [];
                for(_$i = 0; _$i < c; _$i++){
                    var h = _$t.internal.newObject();
                    u.push(h);
                    var l = _$t.internal.getPageInfo(_$i + 1);
                    _$t.internal.write("<< /D[" + l.objId + " 0 R /XYZ null null null]>> endobj");
                }
                var f = _$t.internal.newObject();
                _$t.internal.write("<< /Names [ ");
                for(_$i = 0; _$i < u.length; _$i++)_$t.internal.write("(page_" + (_$i + 1) + ")" + u[_$i] + " 0 R");
                _$t.internal.write(" ] >>", "endobj"), e = _$t.internal.newObject(), _$t.internal.write("<< /Dests " + f + " 0 R"), _$t.internal.write(">>", "endobj");
            }
        }
    ]), t.events.push([
        "putCatalog",
        function() {
            this.outline.root.children.length > 0 && (this.internal.write("/Outlines", this.outline.makeRef(this.outline.root)), this.outline.createNamedDestinations && this.internal.write("/Names " + e + " 0 R"));
        }
    ]), t.events.push([
        "initialized",
        function() {
            var _$t = this;
            _$t.outline = {
                createNamedDestinations: !1,
                root: {
                    children: []
                }
            }, _$t.outline.add = function(t, e, r) {
                var n = {
                    title: e,
                    options: r,
                    children: []
                };
                return null == t && (t = this.root), t.children.push(n), n;
            }, _$t.outline.render = function() {
                return this.ctx = {}, this.ctx.val = "", this.ctx.pdf = _$t, this.genIds_r(this.root), this.renderRoot(this.root), this.renderItems(this.root), this.ctx.val;
            }, _$t.outline.genIds_r = function(e) {
                e.id = _$t.internal.newObjectDeferred();
                for(var r = 0; r < e.children.length; r++)this.genIds_r(e.children[r]);
            }, _$t.outline.renderRoot = function(t) {
                this.objStart(t), this.line("/Type /Outlines"), t.children.length > 0 && (this.line("/First " + this.makeRef(t.children[0])), this.line("/Last " + this.makeRef(t.children[t.children.length - 1]))), this.line("/Count " + this.count_r({
                    count: 0
                }, t)), this.objEnd();
            }, _$t.outline.renderItems = function(e) {
                for(var r = this.ctx.pdf.internal.getVerticalCoordinateString, n = 0; n < e.children.length; n++){
                    var _$i = e.children[n];
                    this.objStart(_$i), this.line("/Title " + this.makeString(_$i.title)), this.line("/Parent " + this.makeRef(e)), n > 0 && this.line("/Prev " + this.makeRef(e.children[n - 1])), n < e.children.length - 1 && this.line("/Next " + this.makeRef(e.children[n + 1])), _$i.children.length > 0 && (this.line("/First " + this.makeRef(_$i.children[0])), this.line("/Last " + this.makeRef(_$i.children[_$i.children.length - 1])));
                    var a = this.count = this.count_r({
                        count: 0
                    }, _$i);
                    if (a > 0 && this.line("/Count " + a), _$i.options && _$i.options.pageNumber) {
                        var o = _$t.internal.getPageInfo(_$i.options.pageNumber);
                        this.line("/Dest [" + o.objId + " 0 R /XYZ 0 " + r(0) + " 0]");
                    }
                    this.objEnd();
                }
                for(var s = 0; s < e.children.length; s++)this.renderItems(e.children[s]);
            }, _$t.outline.line = function(t) {
                this.ctx.val += t + "\r\n";
            }, _$t.outline.makeRef = function(t) {
                return t.id + " 0 R";
            }, _$t.outline.makeString = function(e) {
                return "(" + _$t.internal.pdfEscape(e) + ")";
            }, _$t.outline.objStart = function(t) {
                this.ctx.val += "\r\n" + t.id + " 0 obj\r\n<<\r\n";
            }, _$t.outline.objEnd = function() {
                this.ctx.val += ">> \r\nendobj\r\n";
            }, _$t.outline.count_r = function(t, e) {
                for(var r = 0; r < e.children.length; r++)t.count++, this.count_r(t, e.children[r]);
                return t.count;
            };
        }
    ]);
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), /**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = [
        192,
        193,
        194,
        195,
        196,
        197,
        198,
        199
    ];
    t.processJPEG = function(t, r, n, i, a, o) {
        var s, c = this.decode.DCT_DECODE, u = null;
        if ("string" == typeof t || this.__addimage__.isArrayBuffer(t) || this.__addimage__.isArrayBufferView(t)) {
            switch(t = a || t, t = this.__addimage__.isArrayBuffer(t) ? new Uint8Array(t) : t, (s = function(t) {
                for(var _$r, _$n = 256 * t.charCodeAt(4) + t.charCodeAt(5), _$i = t.length, _$a = {
                    width: 0,
                    height: 0,
                    numcomponents: 1
                }, _$o = 4; _$o < _$i; _$o += 2){
                    if (_$o += _$n, -1 !== e.indexOf(t.charCodeAt(_$o + 1))) {
                        _$r = 256 * t.charCodeAt(_$o + 5) + t.charCodeAt(_$o + 6), _$a = {
                            width: 256 * t.charCodeAt(_$o + 7) + t.charCodeAt(_$o + 8),
                            height: _$r,
                            numcomponents: t.charCodeAt(_$o + 9)
                        };
                        break;
                    }
                    _$n = 256 * t.charCodeAt(_$o + 2) + t.charCodeAt(_$o + 3);
                }
                return _$a;
            }(t = this.__addimage__.isArrayBufferView(t) ? this.__addimage__.arrayBufferToBinaryString(t) : t)).numcomponents){
                case 1:
                    o = this.color_spaces.DEVICE_GRAY;
                    break;
                case 4:
                    o = this.color_spaces.DEVICE_CMYK;
                    break;
                case 3:
                    o = this.color_spaces.DEVICE_RGB;
            }
            u = {
                data: t,
                width: s.width,
                height: s.height,
                colorSpace: o,
                bitsPerComponent: 8,
                filter: c,
                index: r,
                alias: n
            };
        }
        return u;
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API);
var $cbf54afc98507811$var$Vt, $cbf54afc98507811$var$Gt, $cbf54afc98507811$var$Yt, $cbf54afc98507811$var$Jt, $cbf54afc98507811$var$Xt, $cbf54afc98507811$var$Kt = function() {
    var a = function a(t) {
        var e, r, n, _$i, a, o, s, c, u, h, l, f, d, p;
        for(this.data = t, this.pos = 8, this.palette = [], this.imgData = [], this.transparency = {}, this.animation = null, this.text = {}, o = null;;){
            switch(e = this.readUInt32(), u = (function() {
                var _$t, e;
                for(e = [], _$t = 0; _$t < 4; ++_$t)e.push(String.fromCharCode(this.data[this.pos++]));
                return e;
            }).call(this).join("")){
                case "IHDR":
                    this.width = this.readUInt32(), this.height = this.readUInt32(), this.bits = this.data[this.pos++], this.colorType = this.data[this.pos++], this.compressionMethod = this.data[this.pos++], this.filterMethod = this.data[this.pos++], this.interlaceMethod = this.data[this.pos++];
                    break;
                case "acTL":
                    this.animation = {
                        numFrames: this.readUInt32(),
                        numPlays: this.readUInt32() || 1 / 0,
                        frames: []
                    };
                    break;
                case "PLTE":
                    this.palette = this.read(e);
                    break;
                case "fcTL":
                    o && this.animation.frames.push(o), this.pos += 4, o = {
                        width: this.readUInt32(),
                        height: this.readUInt32(),
                        xOffset: this.readUInt32(),
                        yOffset: this.readUInt32()
                    }, a = this.readUInt16(), _$i = this.readUInt16() || 100, o.delay = 1e3 * a / _$i, o.disposeOp = this.data[this.pos++], o.blendOp = this.data[this.pos++], o.data = [];
                    break;
                case "IDAT":
                case "fdAT":
                    for("fdAT" === u && (this.pos += 4, e -= 4), t = (null != o ? o.data : void 0) || this.imgData, f = 0; 0 <= e ? f < e : f > e; 0 <= e ? ++f : --f)t.push(this.data[this.pos++]);
                    break;
                case "tRNS":
                    switch(this.transparency = {}, this.colorType){
                        case 3:
                            if (n = this.palette.length / 3, this.transparency.indexed = this.read(e), this.transparency.indexed.length > n) throw new Error("More transparent colors than palette size");
                            if ((h = n - this.transparency.indexed.length) > 0) for(d = 0; 0 <= h ? d < h : d > h; 0 <= h ? ++d : --d)this.transparency.indexed.push(255);
                            break;
                        case 0:
                            this.transparency.grayscale = this.read(e)[0];
                            break;
                        case 2:
                            this.transparency.rgb = this.read(e);
                    }
                    break;
                case "tEXt":
                    s = (l = this.read(e)).indexOf(0), c = String.fromCharCode.apply(String, l.slice(0, s)), this.text[c] = String.fromCharCode.apply(String, l.slice(s + 1));
                    break;
                case "IEND":
                    return o && this.animation.frames.push(o), this.colors = (function() {
                        switch(this.colorType){
                            case 0:
                            case 3:
                            case 4:
                                return 1;
                            case 2:
                            case 6:
                                return 3;
                        }
                    }).call(this), this.hasAlphaChannel = 4 === (p = this.colorType) || 6 === p, r = this.colors + (this.hasAlphaChannel ? 1 : 0), this.pixelBitlength = this.bits * r, this.colorSpace = (function() {
                        switch(this.colors){
                            case 1:
                                return "DeviceGray";
                            case 3:
                                return "DeviceRGB";
                        }
                    }).call(this), void (this.imgData = new Uint8Array(this.imgData));
                default:
                    this.pos += e;
            }
            if (this.pos += 4, this.pos > this.data.length) throw new Error("Incomplete or corrupt PNG file");
        }
    };
    var _$t, e, _$i;
    a.prototype.read = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; 0 <= t ? ++e : --e)r.push(this.data[this.pos++]);
        return r;
    }, a.prototype.readUInt32 = function() {
        return this.data[this.pos++] << 24 | this.data[this.pos++] << 16 | this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.readUInt16 = function() {
        return this.data[this.pos++] << 8 | this.data[this.pos++];
    }, a.prototype.decodePixels = function(t) {
        var o = function o(r, o, s, c) {
            var u, h, l, f, d, p, g, m, v, b, _$y, w, N, L, A, x, S, _, P, k, _$I, F = Math.ceil((a.width - r) / s), C = Math.ceil((a.height - o) / c), _$j = a.width == F && a.height == C;
            for(L = e * F, w = _$j ? n : new Uint8Array(L * C), p = t.length, N = 0, h = 0; N < C && _$i < p;){
                switch(t[_$i++]){
                    case 0:
                        for(f = S = 0; S < L; f = S += 1)w[h++] = t[_$i++];
                        break;
                    case 1:
                        for(f = _ = 0; _ < L; f = _ += 1)u = t[_$i++], d = f < e ? 0 : w[h - e], w[h++] = (u + d) % 256;
                        break;
                    case 2:
                        for(f = P = 0; P < L; f = P += 1)u = t[_$i++], l = (f - f % e) / e, A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (A + u) % 256;
                        break;
                    case 3:
                        for(f = k = 0; k < L; f = k += 1)u = t[_$i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], A = N && w[(N - 1) * L + l * e + f % e], w[h++] = (u + Math.floor((d + A) / 2)) % 256;
                        break;
                    case 4:
                        for(f = _$I = 0; _$I < L; f = _$I += 1)u = t[_$i++], l = (f - f % e) / e, d = f < e ? 0 : w[h - e], 0 === N ? A = x = 0 : (A = w[(N - 1) * L + l * e + f % e], x = l && w[(N - 1) * L + (l - 1) * e + f % e]), g = d + A - x, m = Math.abs(g - d), b = Math.abs(g - A), _$y = Math.abs(g - x), v = m <= b && m <= _$y ? d : b <= _$y ? A : x, w[h++] = (u + v) % 256;
                        break;
                    default:
                        throw new Error("Invalid filter algorithm: " + t[_$i - 1]);
                }
                if (!_$j) {
                    var O = ((o + N * c) * a.width + r) * e, B = N * L;
                    for(f = 0; f < F; f += 1){
                        for(var M = 0; M < e; M += 1)n[O++] = w[B++];
                        O += (s - 1) * e;
                    }
                }
                N++;
            }
        };
        var e = this.pixelBitlength / 8, n = new Uint8Array(this.width * this.height * e), _$i = 0, a = this;
        if (null == t && (t = this.imgData), 0 === t.length) return new Uint8Array(0);
        return t = (0, $b495f2b996e3784e$export$9ec8134f0f1b9fc6)(t), 1 == a.interlaceMethod ? (o(0, 0, 8, 8), o(4, 0, 8, 8), o(0, 4, 4, 8), o(2, 0, 4, 4), o(0, 2, 2, 4), o(1, 0, 2, 2), o(0, 1, 1, 2)) : o(0, 0, 1, 1), n;
    }, a.prototype.decodePalette = function() {
        var _$t, e, r, n, _$i, a, o, s, c;
        for(r = this.palette, a = this.transparency.indexed || [], _$i = new Uint8Array((a.length || 0) + r.length), n = 0, _$t = 0, e = o = 0, s = r.length; o < s; e = o += 3)_$i[n++] = r[e], _$i[n++] = r[e + 1], _$i[n++] = r[e + 2], _$i[n++] = null != (c = a[_$t++]) ? c : 255;
        return _$i;
    }, a.prototype.copyToImageData = function(t, e) {
        var r, n, _$i, a, o, s, c, u, h, l, f;
        if (n = this.colors, h = null, r = this.hasAlphaChannel, this.palette.length && (h = null != (f = this._decodedPalette) ? f : this._decodedPalette = this.decodePalette(), n = 4, r = !0), u = (_$i = t.data || t).length, o = h || e, a = s = 0, 1 === n) for(; a < u;)c = h ? 4 * e[a / 4] : s, l = o[c++], _$i[a++] = l, _$i[a++] = l, _$i[a++] = l, _$i[a++] = r ? o[c++] : 255, s = c;
        else for(; a < u;)c = h ? 4 * e[a / 4] : s, _$i[a++] = o[c++], _$i[a++] = o[c++], _$i[a++] = o[c++], _$i[a++] = r ? o[c++] : 255, s = c;
    }, a.prototype.decode = function() {
        var _$t;
        return _$t = new Uint8Array(this.width * this.height * 4), this.copyToImageData(_$t, this.decodePixels()), _$t;
    };
    var o = function o() {
        if ("[object Window]" === Object.prototype.toString.call($cbf54afc98507811$var$n)) {
            try {
                e = $cbf54afc98507811$var$n.document.createElement("canvas"), _$i = e.getContext("2d");
            } catch (t) {
                return !1;
            }
            return !0;
        }
        return !1;
    };
    return o(), _$t = function t(t) {
        var r;
        if (!0 === o()) return _$i.width = t.width, _$i.height = t.height, _$i.clearRect(0, 0, t.width, t.height), _$i.putImageData(t, 0, 0), (r = new Image).src = e.toDataURL(), r;
        throw new Error("This method requires a Browser with Canvas-capability.");
    }, a.prototype.decodeFrames = function(e) {
        var r, n, _$i, a, o, s, c, u;
        if (this.animation) {
            for(u = [], n = o = 0, s = (c = this.animation.frames).length; o < s; n = ++o)r = c[n], _$i = e.createImageData(r.width, r.height), a = this.decodePixels(new Uint8Array(r.data)), this.copyToImageData(_$i, a), r.imageData = _$i, u.push(r.image = _$t(_$i));
            return u;
        }
    }, a.prototype.renderFrame = function(t, e) {
        var r, n, _$i;
        return r = (n = this.animation.frames)[e], _$i = n[e - 1], 0 === e && t.clearRect(0, 0, this.width, this.height), 1 === (null != _$i ? _$i.disposeOp : void 0) ? t.clearRect(_$i.xOffset, _$i.yOffset, _$i.width, _$i.height) : 2 === (null != _$i ? _$i.disposeOp : void 0) && t.putImageData(_$i.imageData, _$i.xOffset, _$i.yOffset), 0 === r.blendOp && t.clearRect(r.xOffset, r.yOffset, r.width, r.height), t.drawImage(r.image, r.xOffset, r.yOffset);
    }, a.prototype.animate = function(t) {
        var e, r, n, _$i, a, o, s = this;
        return r = 0, o = this.animation, _$i = o.numFrames, n = o.frames, a = o.numPlays, (e = function() {
            var o, c;
            if (o = r++ % _$i, c = n[o], s.renderFrame(t, o), _$i > 1 && r / _$i < a) return s.animation._timeout = setTimeout(e, c.delay);
        })();
    }, a.prototype.stopAnimation = function() {
        var _$t;
        return clearTimeout(null != (_$t = this.animation) ? _$t._timeout : void 0);
    }, a.prototype.render = function(t) {
        var e, r;
        return t._png && t._png.stopAnimation(), t._png = this, t.width = this.width, t.height = this.height, e = t.getContext("2d"), this.animation ? (this.decodeFrames(e), this.animate(e)) : (r = e.createImageData(this.width, this.height), this.copyToImageData(r, this.decodePixels()), e.putImageData(r, 0, 0));
    }, a;
}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ /**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */ function $cbf54afc98507811$var$Zt(t) {
    var e = 0;
    if (71 !== t[e++] || 73 !== t[e++] || 70 !== t[e++] || 56 !== t[e++] || 56 != (t[e++] + 1 & 253) || 97 !== t[e++]) throw new Error("Invalid GIF 87a/89a header.");
    var r = t[e++] | t[e++] << 8, n = t[e++] | t[e++] << 8, _$i = t[e++], a = _$i >> 7, o = 1 << (7 & _$i) + 1;
    t[e++];
    t[e++];
    var s = null, c = null;
    a && (s = e, c = o, e += 3 * o);
    var u = !0, h = [], l = 0, f = null, d = 0, p = null;
    for(this.width = r, this.height = n; u && e < t.length;)switch(t[e++]){
        case 33:
            switch(t[e++]){
                case 255:
                    if (11 !== t[e] || 78 == t[e + 1] && 69 == t[e + 2] && 84 == t[e + 3] && 83 == t[e + 4] && 67 == t[e + 5] && 65 == t[e + 6] && 80 == t[e + 7] && 69 == t[e + 8] && 50 == t[e + 9] && 46 == t[e + 10] && 48 == t[e + 11] && 3 == t[e + 12] && 1 == t[e + 13] && 0 == t[e + 16]) e += 14, p = t[e++] | t[e++] << 8, e++;
                    else for(e += 12;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                case 249:
                    if (4 !== t[e++] || 0 !== t[e + 4]) throw new Error("Invalid graphics extension block.");
                    var g = t[e++];
                    l = t[e++] | t[e++] << 8, f = t[e++], 0 == (1 & g) && (f = null), d = g >> 2 & 7, e++;
                    break;
                case 254:
                    for(;;){
                        if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                        if (0 === P) break;
                        e += P;
                    }
                    break;
                default:
                    throw new Error("Unknown graphic control label: 0x" + t[e - 1].toString(16));
            }
            break;
        case 44:
            var m = t[e++] | t[e++] << 8, v = t[e++] | t[e++] << 8, b = t[e++] | t[e++] << 8, _$y = t[e++] | t[e++] << 8, w = t[e++], N = w >> 6 & 1, L = 1 << (7 & w) + 1, A = s, x = c, S = !1;
            if (w >> 7) {
                S = !0;
                A = e, x = L, e += 3 * L;
            }
            var _ = e;
            for(e++;;){
                var P;
                if (!((P = t[e++]) >= 0)) throw Error("Invalid block size");
                if (0 === P) break;
                e += P;
            }
            h.push({
                x: m,
                y: v,
                width: b,
                height: _$y,
                has_local_palette: S,
                palette_offset: A,
                palette_size: x,
                data_offset: _,
                data_length: e - _,
                transparent_index: f,
                interlaced: !!N,
                delay: l,
                disposal: d
            });
            break;
        case 59:
            u = !1;
            break;
        default:
            throw new Error("Unknown gif block: 0x" + t[e - 1].toString(16));
    }
    this.numFrames = function() {
        return h.length;
    }, this.loopCount = function() {
        return p;
    }, this.frameInfo = function(t) {
        if (t < 0 || t >= h.length) throw new Error("Frame index out of range.");
        return h[t];
    }, this.decodeAndBlitFrameBGRA = function(e, n) {
        var _$i = this.frameInfo(e), a = _$i.width * _$i.height, o = new Uint8Array(a);
        $cbf54afc98507811$var$$t(t, _$i.data_offset, o, a);
        var s = _$i.palette_offset, c = _$i.transparent_index;
        null === c && (c = 256);
        var u = _$i.width, h = r - u, l = u, f = 4 * (_$i.y * r + _$i.x), d = 4 * ((_$i.y + _$i.height) * r + _$i.x), p = f, g = 4 * h;
        !0 === _$i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var _$y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), _$y === c) p += 4;
            else {
                var w = t[s + 3 * _$y], N = t[s + 3 * _$y + 1], L = t[s + 3 * _$y + 2];
                n[p++] = L, n[p++] = N, n[p++] = w, n[p++] = 255;
            }
            --l;
        }
    }, this.decodeAndBlitFrameRGBA = function(e, n) {
        var _$i = this.frameInfo(e), a = _$i.width * _$i.height, o = new Uint8Array(a);
        $cbf54afc98507811$var$$t(t, _$i.data_offset, o, a);
        var s = _$i.palette_offset, c = _$i.transparent_index;
        null === c && (c = 256);
        var u = _$i.width, h = r - u, l = u, f = 4 * (_$i.y * r + _$i.x), d = 4 * ((_$i.y + _$i.height) * r + _$i.x), p = f, g = 4 * h;
        !0 === _$i.interlaced && (g += 4 * r * 7);
        for(var m = 8, v = 0, b = o.length; v < b; ++v){
            var _$y = o[v];
            if (0 === l && (l = u, (p += g) >= d && (g = 4 * h + 4 * r * (m - 1), p = f + (u + h) * (m << 1), m >>= 1)), _$y === c) p += 4;
            else {
                var w = t[s + 3 * _$y], N = t[s + 3 * _$y + 1], L = t[s + 3 * _$y + 2];
                n[p++] = w, n[p++] = N, n[p++] = L, n[p++] = 255;
            }
            --l;
        }
    };
}
function $cbf54afc98507811$var$$t(t, e, r, n) {
    for(var _$i = t[e++], o = 1 << _$i, s = o + 1, c = s + 1, u = _$i + 1, h = (1 << u) - 1, l = 0, f = 0, d = 0, p = t[e++], g = new Int32Array(4096), m = null;;){
        for(; l < 16 && 0 !== p;)f |= t[e++] << l, l += 8, 1 === p ? p = t[e++] : --p;
        if (l < u) break;
        var v = f & h;
        if (f >>= u, l -= u, v !== o) {
            if (v === s) break;
            for(var b = v < c ? v : m, _$y = 0, w = b; w > o;)w = g[w] >> 8, ++_$y;
            var N = w;
            if (d + _$y + (b !== v ? 1 : 0) > n) return void $cbf54afc98507811$var$a.log("Warning, gif stream longer than expected.");
            r[d++] = N;
            var L = d += _$y;
            for(b !== v && (r[d++] = N), w = b; _$y--;)w = g[w], r[--L] = 255 & w, w >>= 8;
            null !== m && c < 4096 && (g[c++] = m << 8 | N, c >= h + 1 && u < 12 && (++u, h = h << 1 | 1)), m = v;
        } else c = s + 1, h = (1 << (u = _$i + 1)) - 1, m = null;
    }
    return d !== n && $cbf54afc98507811$var$a.log("Warning, gif stream shorter than expected."), r;
}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ function $cbf54afc98507811$var$Qt(t) {
    var _$j = function _$j(t, e) {
        for(var r = 0, n = 0, _$i = new Array, a = 1; a <= 16; a++){
            for(var o = 1; o <= t[a]; o++)_$i[e[n]] = [], _$i[e[n]][0] = r, _$i[e[n]][1] = a, n++, r++;
            r *= 2;
        }
        return _$i;
    };
    var O = function O(t) {
        for(var e = t[0], r = t[1] - 1; r >= 0;)e & 1 << r && (m |= 1 << v), r--, --v < 0 && (255 == m ? (B(255), B(0)) : B(m), v = 7, m = 0);
    };
    var B = function B(t) {
        g.push(t);
    };
    var M = function M(t) {
        B(t >> 8 & 255), B(255 & t);
    };
    var _$E = function _$E(t, e, r, n, i) {
        for(var a, o = i[0], s = i[240], c = function(t, e) {
            var _$r, _$n, _$i, a, o, s, c, u, h, l, f = 0;
            for(h = 0; h < 8; ++h){
                _$r = t[f], _$n = t[f + 1], _$i = t[f + 2], a = t[f + 3], o = t[f + 4], s = t[f + 5], c = t[f + 6];
                var p = _$r + (u = t[f + 7]), g = _$r - u, m = _$n + c, v = _$n - c, b = _$i + s, _$y = _$i - s, w = a + o, N = a - o, L = p + w, A = p - w, x = m + b, S = m - b;
                t[f] = L + x, t[f + 4] = L - x;
                var _ = .707106781 * (S + A);
                t[f + 2] = A + _, t[f + 6] = A - _;
                var P = .382683433 * ((L = N + _$y) - (S = v + g)), k = .5411961 * L + P, _$I = 1.306562965 * S + P, F = .707106781 * (x = _$y + v), C = g + F, _$j = g - F;
                t[f + 5] = _$j + k, t[f + 3] = _$j - k, t[f + 1] = C + _$I, t[f + 7] = C - _$I, f += 8;
            }
            for(f = 0, h = 0; h < 8; ++h){
                _$r = t[f], _$n = t[f + 8], _$i = t[f + 16], a = t[f + 24], o = t[f + 32], s = t[f + 40], c = t[f + 48];
                var O = _$r + (u = t[f + 56]), B = _$r - u, M = _$n + c, _$E = _$n - c, q = _$i + s, D = _$i - s, R = a + o, T = a - o, U = O + R, z = O - R, H = M + q, W = M - q;
                t[f] = U + H, t[f + 32] = U - H;
                var V = .707106781 * (W + z);
                t[f + 16] = z + V, t[f + 48] = z - V;
                var G = .382683433 * ((U = T + D) - (W = _$E + B)), Y = .5411961 * U + G, J = 1.306562965 * W + G, X = .707106781 * (H = D + _$E), K = B + X, Z = B - X;
                t[f + 40] = Z + Y, t[f + 24] = Z - Y, t[f + 8] = K + J, t[f + 56] = K - J, f++;
            }
            for(h = 0; h < 64; ++h)l = t[h] * e[h], d[h] = l > 0 ? l + .5 | 0 : l - .5 | 0;
            return d;
        }(t, e), u = 0; u < 64; ++u)p[A[u]] = c[u];
        var h = p[0] - r;
        r = p[0], 0 == h ? O(n[0]) : (O(n[f[a = 32767 + h]]), O(l[a]));
        for(var g = 63; g > 0 && 0 == p[g];)g--;
        if (0 == g) return O(o), r;
        for(var m, v = 1; v <= g;){
            for(var b = v; 0 == p[v] && v <= g;)++v;
            var _$y = v - b;
            if (_$y >= 16) {
                m = _$y >> 4;
                for(var w = 1; w <= m; ++w)O(s);
                _$y &= 15;
            }
            a = 32767 + p[v], O(i[(_$y << 4) + f[a]]), O(l[a]), v++;
        }
        return 63 != g && O(o), r;
    };
    var q = function q(t) {
        (t = Math.min(Math.max(t, 1), 100), a != t) && (!function(t) {
            for(var e = [
                16,
                11,
                10,
                16,
                24,
                40,
                51,
                61,
                12,
                12,
                14,
                19,
                26,
                58,
                60,
                55,
                14,
                13,
                16,
                24,
                40,
                57,
                69,
                56,
                14,
                17,
                22,
                29,
                51,
                87,
                80,
                62,
                18,
                22,
                37,
                56,
                68,
                109,
                103,
                77,
                24,
                35,
                55,
                64,
                81,
                104,
                113,
                92,
                49,
                64,
                78,
                87,
                103,
                121,
                120,
                101,
                72,
                92,
                95,
                98,
                112,
                100,
                103,
                99
            ], r = 0; r < 64; r++){
                var n = o((e[r] * t + 50) / 100);
                n = Math.min(Math.max(n, 1), 255), s[A[r]] = n;
            }
            for(var _$i = [
                17,
                18,
                24,
                47,
                99,
                99,
                99,
                99,
                18,
                21,
                26,
                66,
                99,
                99,
                99,
                99,
                24,
                26,
                56,
                99,
                99,
                99,
                99,
                99,
                47,
                66,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99,
                99
            ], a = 0; a < 64; a++){
                var l = o((_$i[a] * t + 50) / 100);
                l = Math.min(Math.max(l, 1), 255), c[A[a]] = l;
            }
            for(var f = [
                1,
                1.387039845,
                1.306562965,
                1.175875602,
                1,
                .785694958,
                .5411961,
                .275899379
            ], d = 0, p = 0; p < 8; p++)for(var g = 0; g < 8; g++)u[d] = 1 / (s[A[d]] * f[p] * f[g] * 8), h[d] = 1 / (c[A[d]] * f[p] * f[g] * 8), d++;
        }(t < 50 ? Math.floor(5e3 / t) : Math.floor(200 - 2 * t)), a = t);
    };
    var e, r, n, _$i, a, o = Math.floor, s = new Array(64), c = new Array(64), u = new Array(64), h = new Array(64), l = new Array(65535), f = new Array(65535), d = new Array(64), p = new Array(64), g = [], m = 0, v = 7, b = new Array(64), _$y = new Array(64), w = new Array(64), N = new Array(256), L = new Array(2048), A = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ], x = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], S = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], _ = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        125
    ], P = [
        1,
        2,
        3,
        0,
        4,
        17,
        5,
        18,
        33,
        49,
        65,
        6,
        19,
        81,
        97,
        7,
        34,
        113,
        20,
        50,
        129,
        145,
        161,
        8,
        35,
        66,
        177,
        193,
        21,
        82,
        209,
        240,
        36,
        51,
        98,
        114,
        130,
        9,
        10,
        22,
        23,
        24,
        25,
        26,
        37,
        38,
        39,
        40,
        41,
        42,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        225,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        241,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ], k = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ], _$I = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ], F = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        119
    ], C = [
        0,
        1,
        2,
        3,
        17,
        4,
        5,
        33,
        49,
        6,
        18,
        65,
        81,
        7,
        97,
        113,
        19,
        34,
        50,
        129,
        8,
        20,
        66,
        145,
        161,
        177,
        193,
        9,
        35,
        51,
        82,
        240,
        21,
        98,
        114,
        209,
        10,
        22,
        36,
        52,
        225,
        37,
        241,
        23,
        24,
        25,
        26,
        38,
        39,
        40,
        41,
        42,
        53,
        54,
        55,
        56,
        57,
        58,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        162,
        163,
        164,
        165,
        166,
        167,
        168,
        169,
        170,
        178,
        179,
        180,
        181,
        182,
        183,
        184,
        185,
        186,
        194,
        195,
        196,
        197,
        198,
        199,
        200,
        201,
        202,
        210,
        211,
        212,
        213,
        214,
        215,
        216,
        217,
        218,
        226,
        227,
        228,
        229,
        230,
        231,
        232,
        233,
        234,
        242,
        243,
        244,
        245,
        246,
        247,
        248,
        249,
        250
    ];
    this.encode = function(t, a) {
        a && q(a), g = new Array, m = 0, v = 7, M(65496), M(65504), M(16), B(74), B(70), B(73), B(70), B(0), B(1), B(1), B(0), M(1), M(1), B(0), B(0), function() {
            M(65499), M(132), B(0);
            for(var _$t = 0; _$t < 64; _$t++)B(s[_$t]);
            B(1);
            for(var e = 0; e < 64; e++)B(c[e]);
        }(), function(t, e) {
            M(65472), M(17), B(8), M(e), M(t), B(3), B(1), B(17), B(0), B(2), B(17), B(1), B(3), B(17), B(1);
        }(t.width, t.height), function() {
            M(65476), M(418), B(0);
            for(var _$t = 0; _$t < 16; _$t++)B(x[_$t + 1]);
            for(var e = 0; e <= 11; e++)B(S[e]);
            B(16);
            for(var r = 0; r < 16; r++)B(_[r + 1]);
            for(var n = 0; n <= 161; n++)B(P[n]);
            B(1);
            for(var _$i = 0; _$i < 16; _$i++)B(k[_$i + 1]);
            for(var _$a = 0; _$a <= 11; _$a++)B(_$I[_$a]);
            B(17);
            for(var o = 0; o < 16; o++)B(F[o + 1]);
            for(var s = 0; s <= 161; s++)B(C[s]);
        }(), M(65498), M(12), B(3), B(1), B(0), B(2), B(17), B(3), B(17), B(0), B(63), B(0);
        var o = 0, l = 0, f = 0;
        m = 0, v = 7, this.encode.displayName = "_encode_";
        for(var d, p, N, A, _$j, D, R, T, U, z = t.data, H = t.width, W = t.height, V = 4 * H, G = 0; G < W;){
            for(d = 0; d < V;){
                for(_$j = V * G + d, R = -1, T = 0, U = 0; U < 64; U++)D = _$j + (T = U >> 3) * V + (R = 4 * (7 & U)), G + T >= W && (D -= V * (G + 1 + T - W)), d + R >= V && (D -= d + R - V + 4), p = z[D++], N = z[D++], A = z[D++], b[U] = (L[p] + L[N + 256 >> 0] + L[A + 512 >> 0] >> 16) - 128, _$y[U] = (L[p + 768 >> 0] + L[N + 1024 >> 0] + L[A + 1280 >> 0] >> 16) - 128, w[U] = (L[p + 1280 >> 0] + L[N + 1536 >> 0] + L[A + 1792 >> 0] >> 16) - 128;
                o = _$E(b, u, o, e, n), l = _$E(_$y, h, l, r, _$i), f = _$E(w, h, f, r, _$i), d += 32;
            }
            G += 8;
        }
        if (v >= 0) {
            var Y = [];
            Y[1] = v + 1, Y[0] = (1 << v + 1) - 1, O(Y);
        }
        return M(65497), new Uint8Array(g);
    }, t = t || 50, function() {
        for(var _$t = String.fromCharCode, e = 0; e < 256; e++)N[e] = _$t(e);
    }(), e = _$j(x, S), r = _$j(k, _$I), n = _$j(_, P), _$i = _$j(F, C), function() {
        for(var _$t = 1, e = 2, r = 1; r <= 15; r++){
            for(var n = _$t; n < e; n++)f[32767 + n] = r, l[32767 + n] = [], l[32767 + n][1] = r, l[32767 + n][0] = n;
            for(var _$i = -(e - 1); _$i <= -_$t; _$i++)f[32767 + _$i] = r, l[32767 + _$i] = [], l[32767 + _$i][1] = r, l[32767 + _$i][0] = e - 1 + _$i;
            _$t <<= 1, e <<= 1;
        }
    }(), function() {
        for(var _$t = 0; _$t < 256; _$t++)L[_$t] = 19595 * _$t, L[_$t + 256 >> 0] = 38470 * _$t, L[_$t + 512 >> 0] = 7471 * _$t + 32768, L[_$t + 768 >> 0] = -11059 * _$t, L[_$t + 1024 >> 0] = -21709 * _$t, L[_$t + 1280 >> 0] = 32768 * _$t + 8421375, L[_$t + 1536 >> 0] = -27439 * _$t, L[_$t + 1792 >> 0] = -5329 * _$t;
    }(), q(t);
}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function $cbf54afc98507811$var$te(t, e) {
    if (this.pos = 0, this.buffer = t, this.datav = new DataView(t.buffer), this.is_with_alpha = !!e, this.bottom_up = !0, this.flag = String.fromCharCode(this.buffer[0]) + String.fromCharCode(this.buffer[1]), this.pos += 2, -1 === [
        "BM",
        "BA",
        "CI",
        "CP",
        "IC",
        "PT"
    ].indexOf(this.flag)) throw new Error("Invalid BMP File");
    this.parseHeader(), this.parseBGR();
}
function $cbf54afc98507811$var$ee(t) {
    var e = function e(t) {
        if (!t) throw Error("assert :P");
    };
    var r = function r(t, e, _r1) {
        for(var n = 0; 4 > n; n++)if (t[e + n] != _r1.charCodeAt(n)) return !0;
        return !1;
    };
    var n = function n(t, e, r, _n, i) {
        for(var a = 0; a < i; a++)t[e + a] = r[_n + a];
    };
    var _$i = function _$i(t, e, r, n) {
        for(var _$i = 0; _$i < n; _$i++)t[e + _$i] = r;
    };
    var a = function a(t) {
        return new Int32Array(t);
    };
    var o = function o(t, e) {
        for(var r = [], n = 0; n < t; n++)r.push(new e);
        return r;
    };
    var s = function s(t, e) {
        var r = [];
        return function t(r, n, i) {
            for(var a = i[n], o = 0; o < a && (r.push(i.length > n + 1 ? [] : new e), !(i.length < n + 1)); o++)t(r[o], n + 1, i);
        }(r, 0, t), r;
    };
    var u = function u(t, e) {
        for(var r = "", n = 0; n < 4; n++)r += String.fromCharCode(t[e++]);
        return r;
    };
    var h = function h(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16) >>> 0;
    };
    var l = function l(t, e) {
        return (t[e + 0] << 0 | t[e + 1] << 8 | t[e + 2] << 16 | t[e + 3] << 24) >>> 0;
    };
    var c = function c() {
        var c = function c(t, e) {
            for(var r = 1 << e - 1 >>> 0; t & r;)r >>>= 1;
            return r ? (t & r - 1) + r : t;
        };
        var u = function u(t, r, n, i, a) {
            e(!(i % n));
            do t[r + (i -= n)] = a;
            while (0 < i);
        };
        var h = function h(t, r, n, i, o) {
            if (e(2328 >= o), 512 >= o) var s = a(512);
            else if (null == (s = a(o))) return 0;
            return function(t, r, n, i, o, s) {
                var h, f, d = r, p = 1 << n, g = a(16), m = a(16);
                for(e(0 != o), e(null != i), e(null != t), e(0 < n), f = 0; f < o; ++f){
                    if (15 < i[f]) return 0;
                    ++g[i[f]];
                }
                if (g[0] == o) return 0;
                for(m[1] = 0, h = 1; 15 > h; ++h){
                    if (g[h] > 1 << h) return 0;
                    m[h + 1] = m[h] + g[h];
                }
                for(f = 0; f < o; ++f)h = i[f], 0 < i[f] && (s[m[h]++] = f);
                if (1 == m[15]) return (i = new l).g = 0, i.value = s[0], u(t, d, 1, p, i), p;
                var v, b = -1, _$y = p - 1, w = 0, N = 1, L = 1, A = 1 << n;
                for(f = 0, h = 1, o = 2; h <= n; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h])(i = new l).g = h, i.value = s[f++], u(t, d + w, o, A, i), w = c(w, h);
                }
                for(h = n + 1, o = 2; 15 >= h; ++h, o <<= 1){
                    if (N += L <<= 1, 0 > (L -= g[h])) return 0;
                    for(; 0 < g[h]; --g[h]){
                        if (i = new l, (w & _$y) != b) {
                            for(d += A, v = 1 << (b = h) - n; 15 > b && !(0 >= (v -= g[b]));)++b, v <<= 1;
                            p += A = 1 << (v = b - n), t[r + (b = w & _$y)].g = v + n, t[r + b].value = d - r - b;
                        }
                        i.g = h - n, i.value = s[f++], u(t, d + (w >> n), o, A, i), w = c(w, h);
                    }
                }
                return N != 2 * m[15] - 1 ? 0 : p;
            }(t, r, n, i, o, s);
        };
        var l = function l() {
            this.value = this.g = 0;
        };
        var f = function f() {
            this.value = this.g = 0;
        };
        var d = function d() {
            this.G = o(5, l), this.H = a(5), this.jc = this.Qb = this.qb = this.nd = 0, this.pd = o(Dr, f);
        };
        var p = function p(t, r, n, i) {
            e(null != t), e(null != r), e(2147483648 > i), t.Ca = 254, t.I = 0, t.b = -8, t.Ka = 0, t.oa = r, t.pa = n, t.Jd = r, t.Yc = n + i, t.Zc = 4 <= i ? n + i - 4 + 1 : n, _(t);
        };
        var g = function g(t, e) {
            for(var r = 0; 0 < e--;)r |= k(t, 128) << e;
            return r;
        };
        var m = function m(t, e) {
            var r = g(t, e);
            return P(t) ? -r : r;
        };
        var v = function v(t, r, n, i) {
            var a, o = 0;
            for(e(null != t), e(null != r), e(4294967288 > i), t.Sb = i, t.Ra = 0, t.u = 0, t.h = 0, 4 < i && (i = 4), a = 0; a < i; ++a)o += r[n + a] << 8 * a;
            t.Ra = o, t.bb = i, t.oa = r, t.pa = n;
        };
        var b = function b(t) {
            for(; 8 <= t.u && t.bb < t.Sb;)t.Ra >>>= 8, t.Ra += t.oa[t.pa + t.bb] << Ur - 8 >>> 0, ++t.bb, t.u -= 8;
            A(t) && (t.h = 1, t.u = 0);
        };
        var _$y = function _$y(t, r) {
            if (e(0 <= r), !t.h && r <= Tr) {
                var n = L(t) & Rr[r];
                return t.u += r, b(t), n;
            }
            return t.h = 1, t.u = 0;
        };
        var w = function w() {
            this.b = this.Ca = this.I = 0, this.oa = [], this.pa = 0, this.Jd = [], this.Yc = 0, this.Zc = [], this.Ka = 0;
        };
        var N = function N() {
            this.Ra = 0, this.oa = [], this.h = this.u = this.bb = this.Sb = this.pa = 0;
        };
        var L = function L(t) {
            return t.Ra >>> (t.u & Ur - 1) >>> 0;
        };
        var A = function A(t) {
            return e(t.bb <= t.Sb), t.h || t.bb == t.Sb && t.u > Ur;
        };
        var x = function x(t, e) {
            t.u = e, t.h = A(t);
        };
        var S = function S(t) {
            t.u >= zr && (e(t.u >= zr), b(t));
        };
        var _ = function _(t) {
            e(null != t && null != t.oa), t.pa < t.Zc ? (t.I = (t.oa[t.pa++] | t.I << 8) >>> 0, t.b += 8) : (e(null != t && null != t.oa), t.pa < t.Yc ? (t.b += 8, t.I = t.oa[t.pa++] | t.I << 8) : t.Ka ? t.b = 0 : (t.I <<= 8, t.b += 8, t.Ka = 1));
        };
        var P = function P(t) {
            return g(t, 1);
        };
        var k = function k(t, e) {
            var r = t.Ca;
            0 > t.b && _(t);
            var n = t.b, _$i = r * e >>> 8, a = (t.I >>> n > _$i) + 0;
            for(a ? (r -= _$i, t.I -= _$i + 1 << n >>> 0) : r = _$i + 1, n = r, _$i = 0; 256 <= n;)_$i += 8, n >>= 8;
            return n = 7 ^ _$i + Hr[n], t.b -= n, t.Ca = (r << n) - 1, a;
        };
        var _$I = function _$I(t, e, r) {
            t[e + 0] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = r >> 0 & 255;
        };
        var F = function F(t, e) {
            return t[e + 0] << 0 | t[e + 1] << 8;
        };
        var C = function C(t, e) {
            return F(t, e) | t[e + 2] << 16;
        };
        var _$j = function _$j(t, e) {
            return F(t, e) | F(t, e + 2) << 16;
        };
        var O = function O(t, r) {
            var n = 1 << r;
            return e(null != t), e(0 < r), t.X = a(n), null == t.X ? 0 : (t.Mb = 32 - r, t.Xa = r, 1);
        };
        var B = function B(t, r) {
            e(null != t), e(null != r), e(t.Xa == r.Xa), n(r.X, 0, t.X, 0, 1 << r.Xa);
        };
        var M = function M() {
            this.X = [], this.Xa = this.Mb = 0;
        };
        var _$E = function _$E(t, r, n, i) {
            e(null != n), e(null != i);
            var a = n[0], o = i[0];
            return 0 == a && (a = (t * o + r / 2) / r), 0 == o && (o = (r * a + t / 2) / t), 0 >= a || 0 >= o ? 0 : (n[0] = a, i[0] = o, 1);
        };
        var q = function q(t, e) {
            return t + (1 << e) - 1 >>> e;
        };
        var D = function D(t, e) {
            return ((4278255360 & t) + (4278255360 & e) >>> 0 & 4278255360) + ((16711935 & t) + (16711935 & e) >>> 0 & 16711935) >>> 0;
        };
        var R = function R(e, r) {
            _$t[r] = function(r, n, i, a, o, s, c) {
                var u;
                for(u = 0; u < o; ++u){
                    var h = _$t[e](s[c + u - 1], i, a + u);
                    s[c + u] = D(r[n + u], h);
                }
            };
        };
        var T = function T() {
            this.ud = this.hd = this.jd = 0;
        };
        var U = function U(t, e) {
            return ((4278124286 & (t ^ e)) >>> 1) + (t & e) >>> 0;
        };
        var z = function z(t) {
            return 0 <= t && 256 > t ? t : 0 > t ? 0 : 255 < t ? 255 : void 0;
        };
        var H = function H(t, e) {
            return z(t + (t - e + .5 >> 1));
        };
        var W = function W(t, e, r) {
            return Math.abs(e - r) - Math.abs(t - r);
        };
        var V = function V(t, e, r, n, i, a, o) {
            for(n = a[o - 1], r = 0; r < i; ++r)a[o + r] = n = D(t[e + r], n);
        };
        var G = function G(t, e, r, n, i) {
            var a;
            for(a = 0; a < r; ++a){
                var o = t[e + a], s = o >> 8 & 255, c = 16711935 & (c = (c = 16711935 & o) + ((s << 16) + s));
                n[i + a] = (4278255360 & o) + c >>> 0;
            }
        };
        var Y = function Y(t, e) {
            e.jd = t >> 0 & 255, e.hd = t >> 8 & 255, e.ud = t >> 16 & 255;
        };
        var J = function J(t, e, r, n, i, a) {
            var o;
            for(o = 0; o < n; ++o){
                var s = e[r + o], c = s >>> 8, u = s, h = 255 & (h = (h = s >>> 16) + ((t.jd << 24 >> 24) * (c << 24 >> 24) >>> 5));
                u = 255 & (u = (u = u + ((t.hd << 24 >> 24) * (c << 24 >> 24) >>> 5)) + ((t.ud << 24 >> 24) * (h << 24 >> 24) >>> 5));
                i[a + o] = (4278255360 & s) + (h << 16) + u;
            }
        };
        var X = function X(e, r, n, i, a) {
            _$t[r] = function(t, e, r, n, o, s, c, u, h) {
                for(n = c; n < u; ++n)for(c = 0; c < h; ++c)o[s++] = a(r[i(t[e++])]);
            }, _$t[e] = function(e, r, o, s, c, u, h) {
                var l = 8 >> e.b, f = e.Ea, d = e.K[0], p = e.w;
                if (8 > l) for(e = (1 << e.b) - 1, p = (1 << l) - 1; r < o; ++r){
                    var g, m = 0;
                    for(g = 0; g < f; ++g)g & e || (m = i(s[c++])), u[h++] = a(d[m & p]), m >>= l;
                }
                else _$t["VP8LMapColor" + n](s, c, d, p, u, h, r, o, f);
            };
        };
        var K = function K(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255;
            }
        };
        var Z = function Z(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 16 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 0 & 255, n[i++] = a >> 24 & 255;
            }
        };
        var $ = function $(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 240 | o >> 12 & 15, o = o >> 0 & 240 | o >> 28 & 15;
                n[i++] = a, n[i++] = o;
            }
        };
        var Q = function Q(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = (o = t[e++]) >> 16 & 248 | o >> 13 & 7, o = o >> 5 & 224 | o >> 3 & 31;
                n[i++] = a, n[i++] = o;
            }
        };
        var tt = function tt(t, e, r, n, i) {
            for(r = e + r; e < r;){
                var a = t[e++];
                n[i++] = a >> 0 & 255, n[i++] = a >> 8 & 255, n[i++] = a >> 16 & 255;
            }
        };
        var et = function et(t, e, r, i, a, o) {
            if (0 == o) for(r = e + r; e < r;)_$I(i, ((o = t[e++])[0] >> 24 | o[1] >> 8 & 65280 | o[2] << 8 & 16711680 | o[3] << 24) >>> 0), a += 32;
            else n(i, a, t, e, r);
        };
        var rt = function rt(e, r) {
            _$t[r][0] = _$t[e + "0"], _$t[r][1] = _$t[e + "1"], _$t[r][2] = _$t[e + "2"], _$t[r][3] = _$t[e + "3"], _$t[r][4] = _$t[e + "4"], _$t[r][5] = _$t[e + "5"], _$t[r][6] = _$t[e + "6"], _$t[r][7] = _$t[e + "7"], _$t[r][8] = _$t[e + "8"], _$t[r][9] = _$t[e + "9"], _$t[r][10] = _$t[e + "10"], _$t[r][11] = _$t[e + "11"], _$t[r][12] = _$t[e + "12"], _$t[r][13] = _$t[e + "13"], _$t[r][14] = _$t[e + "0"], _$t[r][15] = _$t[e + "0"];
        };
        var nt = function nt(t) {
            return t == Hn || t == Wn || t == Vn || t == Gn;
        };
        var it = function it() {
            this.eb = [], this.size = this.A = this.fb = 0;
        };
        var at = function at() {
            this.y = [], this.f = [], this.ea = [], this.F = [], this.Tc = this.Ed = this.Cd = this.Fd = this.lb = this.Db = this.Ab = this.fa = this.J = this.W = this.N = this.O = 0;
        };
        var ot = function ot() {
            this.Rd = this.height = this.width = this.S = 0, this.f = {}, this.f.RGBA = new it, this.f.kb = new at, this.sd = null;
        };
        var st = function st() {
            this.width = [
                0
            ], this.height = [
                0
            ], this.Pd = [
                0
            ], this.Qd = [
                0
            ], this.format = [
                0
            ];
        };
        var ct = function ct() {
            this.Id = this.fd = this.Md = this.hb = this.ib = this.da = this.bd = this.cd = this.j = this.v = this.Da = this.Sd = this.ob = 0;
        };
        var ut = function ut(t) {
            return alert("todo:WebPSamplerProcessPlane"), t.T;
        };
        var ht = function ht(t, e) {
            var r = t.T, _$i = e.ba.f.RGBA, a = _$i.eb, o = _$i.fb + t.ka * _$i.A, s = vi[e.ba.S], c = t.y, u = t.O, h = t.f, l = t.N, f = t.ea, d = t.W, p = e.cc, g = e.dc, m = e.Mc, v = e.Nc, b = t.ka, _$y = t.ka + t.T, w = t.U, N = w + 1 >> 1;
            for(0 == b ? s(c, u, null, null, h, l, f, d, h, l, f, d, a, o, null, null, w) : (s(e.ec, e.fc, c, u, p, g, m, v, h, l, f, d, a, o - _$i.A, a, o, w), ++r); b + 2 < _$y; b += 2)p = h, g = l, m = f, v = d, l += t.Rc, d += t.Rc, o += 2 * _$i.A, s(c, (u += 2 * t.fa) - t.fa, c, u, p, g, m, v, h, l, f, d, a, o - _$i.A, a, o, w);
            return u += t.fa, t.j + _$y < t.o ? (n(e.ec, e.fc, c, u, w), n(e.cc, e.dc, h, l, N), n(e.Mc, e.Nc, f, d, N), r--) : 1 & _$y || s(c, u, null, null, h, l, f, d, h, l, f, d, a, o + _$i.A, null, null, w), r;
        };
        var lt = function lt(t, r, n) {
            var _$i = t.F, a = [
                t.J
            ];
            if (null != _$i) {
                var o = t.U, s = r.ba.S, c = s == Tn || s == Vn;
                r = r.ba.f.RGBA;
                var u = [
                    0
                ], h = t.ka;
                u[0] = t.T, t.Kb && (0 == h ? --u[0] : (--h, a[0] -= t.width), t.j + t.ka + t.T == t.o && (u[0] = t.o - t.j - h));
                var l = r.eb;
                h = r.fb + h * r.A;
                t = Sn(_$i, a[0], t.width, o, u, l, h + (c ? 0 : 3), r.A), e(n == u), t && nt(s) && An(l, h, c, o, u, r.A);
            }
            return 0;
        };
        var ft = function ft(t) {
            var e = t.ma, r = e.ba.S, n = 11 > r, _$i = r == qn || r == Rn || r == Tn || r == Un || 12 == r || nt(r);
            if (e.memory = null, e.Ib = null, e.Jb = null, e.Nd = null, !Mr(e.Oa, t, _$i ? 11 : 12)) return 0;
            if (_$i && nt(r) && br(), t.da) alert("todo:use_scaling");
            else {
                if (n) {
                    if (e.Ib = ut, t.Kb) {
                        if (r = t.U + 1 >> 1, e.memory = a(t.U + 2 * r), null == e.memory) return 0;
                        e.ec = e.memory, e.fc = 0, e.cc = e.ec, e.dc = e.fc + t.U, e.Mc = e.cc, e.Nc = e.dc + r, e.Ib = ht, br();
                    }
                } else alert("todo:EmitYUV");
                _$i && (e.Jb = lt, n && mr());
            }
            if (n && !Ci) {
                for(t = 0; 256 > t; ++t)ji[t] = 89858 * (t - 128) + _i >> Si, Mi[t] = -22014 * (t - 128) + _i, Bi[t] = -45773 * (t - 128), Oi[t] = 113618 * (t - 128) + _i >> Si;
                for(t = Pi; t < ki; ++t)e = 76283 * (t - 16) + _i >> Si, Ei[t - Pi] = Vt(e, 255), qi[t - Pi] = Vt(e + 8 >> 4, 15);
                Ci = 1;
            }
            return 1;
        };
        var dt = function dt(t) {
            var r = t.ma, n = t.U, _$i = t.T;
            return e(!(1 & t.ka)), 0 >= n || 0 >= _$i ? 0 : (n = r.Ib(t, r), null != r.Jb && r.Jb(t, r, n), r.Dc += n, 1);
        };
        var pt = function pt(t) {
            t.ma.memory = null;
        };
        var gt = function gt(t, e, r, n) {
            return 47 != _$y(t, 8) ? 0 : (e[0] = _$y(t, 14) + 1, r[0] = _$y(t, 14) + 1, n[0] = _$y(t, 1), 0 != _$y(t, 3) ? 0 : !t.h);
        };
        var mt = function mt(t, e) {
            if (4 > t) return t + 1;
            var r = t - 2 >> 1;
            return (2 + (1 & t) << r) + _$y(e, r) + 1;
        };
        var vt = function vt(t, e) {
            var r;
            return 120 < e ? e - 120 : 1 <= (r = ((r = $n[e - 1]) >> 4) * t + (8 - (15 & r))) ? r : 1;
        };
        var bt = function bt(t, e, r) {
            var n = L(r), _$i = t[e += 255 & n].g - 8;
            return 0 < _$i && (x(r, r.u + 8), n = L(r), e += t[e].value, e += n & (1 << _$i) - 1), x(r, r.u + t[e].g), t[e].value;
        };
        var yt = function yt(t, r, n) {
            return n.g += t.g, n.value += t.value << r >>> 0, e(8 >= n.g), t.g;
        };
        var wt = function wt(t, r, n) {
            var _$i = t.xc;
            return e((r = 0 == _$i ? 0 : t.vc[t.md * (n >> _$i) + (r >> _$i)]) < t.Wb), t.Ya[r];
        };
        var Nt = function Nt(t, r, i, a) {
            var o = t.ab, s = t.c * r, c = t.C;
            r = c + r;
            var u = i, h = a;
            for(a = t.Ta, i = t.Ua; 0 < o--;){
                var l = t.gc[o], f = c, d = r, p = u, g = h, m = (h = a, u = i, l.Ea);
                switch(e(f < d), e(d <= l.nc), l.hc){
                    case 2:
                        Gr(p, g, (d - f) * m, h, u);
                        break;
                    case 0:
                        var v = f, b = d, _$y = h, w = u, N = (_ = l).Ea;
                        0 == v && (Wr(p, g, null, null, 1, _$y, w), V(p, g + 1, 0, 0, N - 1, _$y, w + 1), g += N, w += N, ++v);
                        for(var L = 1 << _.b, A = L - 1, x = q(N, _.b), S = _.K, _ = _.w + (v >> _.b) * x; v < b;){
                            var P = S, k = _, _$I = 1;
                            for(Vr(p, g, _$y, w - N, 1, _$y, w); _$I < N;){
                                var F = (_$I & ~A) + L;
                                F > N && (F = N), (0, Zr[P[k++] >> 8 & 15])(p, g + +_$I, _$y, w + _$I - N, F - _$I, _$y, w + _$I), _$I = F;
                            }
                            g += N, w += N, ++v & A || (_ += x);
                        }
                        d != l.nc && n(h, u - m, h, u + (d - f - 1) * m, m);
                        break;
                    case 1:
                        for(m = p, b = g, N = (p = l.Ea) - (w = p & ~(_$y = (g = 1 << l.b) - 1)), v = q(p, l.b), L = l.K, l = l.w + (f >> l.b) * v; f < d;){
                            for(A = L, x = l, S = new T, _ = b + w, P = b + p; b < _;)Y(A[x++], S), $r(S, m, b, g, h, u), b += g, u += g;
                            b < P && (Y(A[x++], S), $r(S, m, b, N, h, u), b += N, u += N), ++f & _$y || (l += v);
                        }
                        break;
                    case 3:
                        if (p == h && g == u && 0 < l.b) {
                            for(b = h, p = m = u + (d - f) * m - (w = (d - f) * q(l.Ea, l.b)), g = h, _$y = u, v = [], w = (N = w) - 1; 0 <= w; --w)v[w] = g[_$y + w];
                            for(w = N - 1; 0 <= w; --w)b[p + w] = v[w];
                            Yr(l, f, d, h, m, h, u);
                        } else Yr(l, f, d, p, g, h, u);
                }
                u = a, h = i;
            }
            h != i && n(a, i, u, h, s);
        };
        var Lt = function Lt(t, r) {
            var n = t.V, _$i = t.Ba + t.c * t.C, a = r - t.C;
            if (e(r <= t.l.o), e(16 >= a), 0 < a) {
                var o = t.l, s = t.Ta, c = t.Ua, u = o.width;
                if (Nt(t, a, n, _$i), a = c = [
                    c
                ], e((n = t.C) < (_$i = r)), e(o.v < o.va), _$i > o.o && (_$i = o.o), n < o.j) {
                    var h = o.j - n;
                    n = o.j;
                    a[0] += h * u;
                }
                if (n >= _$i ? n = 0 : (a[0] += 4 * o.v, o.ka = n - o.j, o.U = o.va - o.v, o.T = _$i - n, n = 1), n) {
                    if (c = c[0], 11 > (n = t.ca).S) {
                        var l = n.f.RGBA, f = (_$i = n.S, a = o.U, o = o.T, h = l.eb, l.A), d = o;
                        for(l = l.fb + t.Ma * l.A; 0 < d--;){
                            var p = s, g = c, m = a, v = h, b = l;
                            switch(_$i){
                                case En:
                                    Qr(p, g, m, v, b);
                                    break;
                                case qn:
                                    tn(p, g, m, v, b);
                                    break;
                                case Hn:
                                    tn(p, g, m, v, b), An(v, b, 0, m, 1, 0);
                                    break;
                                case Dn:
                                    nn(p, g, m, v, b);
                                    break;
                                case Rn:
                                    et(p, g, m, v, b, 1);
                                    break;
                                case Wn:
                                    et(p, g, m, v, b, 1), An(v, b, 0, m, 1, 0);
                                    break;
                                case Tn:
                                    et(p, g, m, v, b, 0);
                                    break;
                                case Vn:
                                    et(p, g, m, v, b, 0), An(v, b, 1, m, 1, 0);
                                    break;
                                case Un:
                                    en(p, g, m, v, b);
                                    break;
                                case Gn:
                                    en(p, g, m, v, b), xn(v, b, m, 1, 0);
                                    break;
                                case zn:
                                    rn(p, g, m, v, b);
                                    break;
                                default:
                                    e(0);
                            }
                            c += u, l += f;
                        }
                        t.Ma += o;
                    } else alert("todo:EmitRescaledRowsYUVA");
                    e(t.Ma <= n.height);
                }
            }
            t.C = r, e(t.C <= t.i);
        };
        var At = function At(t) {
            var e;
            if (0 < t.ua) return 0;
            for(e = 0; e < t.Wb; ++e){
                var r = t.Ya[e].G, n = t.Ya[e].H;
                if (0 < r[1][n[1] + 0].g || 0 < r[2][n[2] + 0].g || 0 < r[3][n[3] + 0].g) return 0;
            }
            return 1;
        };
        var xt = function xt(t, r, n, i, a, o) {
            if (0 != t.Z) {
                var s = t.qd, c = t.rd;
                for(e(null != mi[t.Z]); r < n; ++r)mi[t.Z](s, c, i, a, i, a, o), s = i, c = a, a += o;
                t.qd = s, t.rd = c;
            }
        };
        var St = function St(t, r) {
            var n = t.l.ma, _$i = 0 == n.Z || 1 == n.Z ? t.l.j : t.C;
            _$i = t.C < _$i ? _$i : t.C;
            if (e(r <= t.l.o), r > _$i) {
                var a = t.l.width, o = n.ca, s = n.tb + a * _$i, c = t.V, u = t.Ba + t.c * _$i, h = t.gc;
                e(1 == t.ab), e(3 == h[0].hc), Xr(h[0], _$i, r, c, u, o, s), xt(n, _$i, r, o, s, a);
            }
            t.C = t.Ma = r;
        };
        var _$_t = function _$_t(t, r, n, i, a, o, s) {
            var c = t.$ / i, u = t.$ % i, h = t.m, l = t.s, f = n + t.$, d = f;
            a = n + i * a;
            var p = n + i * o, g = 280 + l.ua, m = t.Pb ? c : 16777216, v = 0 < l.ua ? l.Wa : null, b = l.wc, _$y = f < p ? wt(l, u, c) : null;
            e(t.C < o), e(p <= a);
            var w = !1;
            t: for(;;){
                for(; w || f < p;){
                    var N = 0;
                    if (c >= m) {
                        var _ = f - n;
                        e((m = t).Pb), m.wd = m.m, m.xd = _, 0 < m.s.ua && B(m.s.Wa, m.s.vb), m = c + ti;
                    }
                    if (u & b || (_$y = wt(l, u, c)), e(null != _$y), _$y.Qb && (r[f] = _$y.qb, w = !0), !w) {
                        if (S(h), _$y.jc) {
                            N = h, _ = r;
                            var P = f, k = _$y.pd[L(N) & Dr - 1];
                            e(_$y.jc), 256 > k.g ? (x(N, N.u + k.g), _[P] = k.value, N = 0) : (x(N, N.u + k.g - 256), e(256 <= k.value), N = k.value), 0 == N && (w = !0);
                        } else N = bt(_$y.G[0], _$y.H[0], h);
                    }
                    if (h.h) break;
                    if (w || 256 > N) {
                        if (!w) {
                            if (_$y.nd) r[f] = (_$y.qb | N << 8) >>> 0;
                            else {
                                if (S(h), w = bt(_$y.G[1], _$y.H[1], h), S(h), _ = bt(_$y.G[2], _$y.H[2], h), P = bt(_$y.G[3], _$y.H[3], h), h.h) break;
                                r[f] = (P << 24 | w << 16 | N << 8 | _) >>> 0;
                            }
                        }
                        if (w = !1, ++f, ++u >= i && (u = 0, ++c, null != s && c <= o && !(c % 16) && s(t, c), null != v)) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else if (280 > N) {
                        if (N = mt(N - 256, h), _ = bt(_$y.G[4], _$y.H[4], h), S(h), _ = vt(i, _ = mt(_, h)), h.h) break;
                        if (f - n < _ || a - f < N) break t;
                        for(P = 0; P < N; ++P)r[f + P] = r[f + P - _];
                        for(f += N, u += N; u >= i;)u -= i, ++c, null != s && c <= o && !(c % 16) && s(t, c);
                        if (e(f <= a), u & b && (_$y = wt(l, u, c)), null != v) for(; d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                    } else {
                        if (!(N < g)) break t;
                        for(w = N - 280, e(null != v); d < f;)N = r[d++], v.X[(506832829 * N & 4294967295) >>> v.Mb] = N;
                        N = f, e(!(w >>> (_ = v).Xa)), r[N] = _.X[w], w = !0;
                    }
                    w || e(h.h == A(h));
                }
                if (t.Pb && h.h && f < a) e(t.m.h), t.a = 5, t.m = t.wd, t.$ = t.xd, 0 < t.s.ua && B(t.s.vb, t.s.Wa);
                else {
                    if (h.h) break t;
                    null != s && s(t, c > o ? o : c), t.a = 0, t.$ = f - n;
                }
                return 1;
            }
            return t.a = 3, 0;
        };
        var Pt = function Pt(t) {
            e(null != t), t.vc = null, t.yc = null, t.Ya = null;
            var r = t.Wa;
            null != r && (r.X = null), t.vb = null, e(null != t);
        };
        var kt = function kt() {
            var e = new or;
            return null == e ? null : (e.a = 0, e.xb = gi, rt("Predictor", "VP8LPredictors"), rt("Predictor", "VP8LPredictors_C"), rt("PredictorAdd", "VP8LPredictorsAdd"), rt("PredictorAdd", "VP8LPredictorsAdd_C"), Gr = G, $r = J, Qr = K, tn = Z, en = $, rn = Q, nn = tt, _$t.VP8LMapColor32b = Jr, _$t.VP8LMapColor8b = Kr, e);
        };
        var Ft = function Ft(t, r) {
            var n = t.c * t.i, _$i = n + r + 16 * r;
            return e(t.c <= r), t.V = a(_$i), null == t.V ? (t.Ta = null, t.Ua = 0, t.a = 1, 0) : (t.Ta = t.V, t.Ua = t.Ba + n + r, 1);
        };
        var Ct = function Ct(t, r) {
            var n = t.C, _$i = r - n, a = t.V, o = t.Ba + t.c * n;
            for(e(r <= t.l.o); 0 < _$i;){
                var s = 16 < _$i ? 16 : _$i, c = t.l.ma, u = t.l.width, h = u * s, l = c.ca, f = c.tb + u * n, d = t.Ta, p = t.Ua;
                Nt(t, s, a, o), _n(d, p, l, f, h), xt(c, n, n + s, l, f, u), _$i -= s, a += s * t.c, n += s;
            }
            e(n == r), t.C = t.Ma = r;
        };
        var jt = function jt() {
            this.ub = this.yd = this.td = this.Rb = 0;
        };
        var Ot = function Ot() {
            this.Kd = this.Ld = this.Ud = this.Td = this.i = this.c = 0;
        };
        var Bt = function Bt() {
            this.Fb = this.Bb = this.Cb = 0, this.Zb = a(4), this.Lb = a(4);
        };
        var Mt = function Mt() {
            this.Yb = function() {
                var _$t = [];
                return function t(e, r, n) {
                    for(var _$i = n[r], a = 0; a < _$i && (e.push(n.length > r + 1 ? [] : 0), !(n.length < r + 1)); a++)t(e[a], r + 1, n);
                }(_$t, 0, [
                    3,
                    11
                ]), _$t;
            }();
        };
        var Et = function Et() {
            this.jb = a(3), this.Wc = s([
                4,
                8
            ], Mt), this.Xc = s([
                4,
                17
            ], Mt);
        };
        var qt = function qt() {
            this.Pc = this.wb = this.Tb = this.zd = 0, this.vd = new a(4), this.od = new a(4);
        };
        var Dt = function Dt() {
            this.ld = this.La = this.dd = this.tc = 0;
        };
        var Rt = function Rt() {
            this.Na = this.la = 0;
        };
        var Tt = function Tt() {
            this.Sc = [
                0,
                0
            ], this.Eb = [
                0,
                0
            ], this.Qc = [
                0,
                0
            ], this.ia = this.lc = 0;
        };
        var Ut = function Ut() {
            this.ad = a(384), this.Za = 0, this.Ob = a(16), this.$b = this.Ad = this.ia = this.Gc = this.Hc = this.Dd = 0;
        };
        var zt = function zt() {
            this.uc = this.M = this.Nb = 0, this.wa = Array(new Dt), this.Y = 0, this.ya = Array(new Ut), this.aa = 0, this.l = new Gt;
        };
        var Ht = function Ht() {
            this.y = a(16), this.f = a(8), this.ea = a(8);
        };
        var Wt = function Wt() {
            this.cb = this.a = 0, this.sc = "", this.m = new w, this.Od = new jt, this.Kc = new Ot, this.ed = new qt, this.Qa = new Bt, this.Ic = this.$c = this.Aa = 0, this.D = new zt, this.Xb = this.Va = this.Hb = this.zb = this.yb = this.Ub = this.za = 0, this.Jc = o(8, w), this.ia = 0, this.pb = o(4, Tt), this.Pa = new Et, this.Bd = this.kc = 0, this.Ac = [], this.Bc = 0, this.zc = [
                0,
                0,
                0,
                0
            ], this.Gd = Array(new Ht), this.Hd = 0, this.rb = Array(new Rt), this.sb = 0, this.wa = Array(new Dt), this.Y = 0, this.oc = [], this.pc = 0, this.sa = [], this.ta = 0, this.qa = [], this.ra = 0, this.Ha = [], this.B = this.R = this.Ia = 0, this.Ec = [], this.M = this.ja = this.Vb = this.Fc = 0, this.ya = Array(new Ut), this.L = this.aa = 0, this.gd = s([
                4,
                2
            ], Dt), this.ga = null, this.Fa = [], this.Cc = this.qc = this.P = 0, this.Gb = [], this.Uc = 0, this.mb = [], this.nb = 0, this.rc = [], this.Ga = this.Vc = 0;
        };
        var Vt = function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        };
        var Gt = function Gt() {
            this.T = this.U = this.ka = this.height = this.width = 0, this.y = [], this.f = [], this.ea = [], this.Rc = this.fa = this.W = this.N = this.O = 0, this.ma = "void", this.put = "VP8IoPutHook", this.ac = "VP8IoSetupHook", this.bc = "VP8IoTeardownHook", this.ha = this.Kb = 0, this.data = [], this.hb = this.ib = this.da = this.o = this.j = this.va = this.v = this.Da = this.ob = this.w = 0, this.F = [], this.J = 0;
        };
        var Yt = function Yt() {
            var _$t = new Wt;
            return null != _$t && (_$t.a = 0, _$t.sc = "OK", _$t.cb = 0, _$t.Xb = 0, ni || (ni = Zt)), _$t;
        };
        var Jt = function Jt(t, e, r) {
            return 0 == t.a && (t.a = e, t.sc = r, t.cb = 0), 0;
        };
        var Xt = function Xt(t, e, r) {
            return 3 <= r && 157 == t[e + 0] && 1 == t[e + 1] && 42 == t[e + 2];
        };
        var Kt = function Kt(t, r) {
            if (null == t) return 0;
            if (t.a = 0, t.sc = "OK", null == r) return Jt(t, 2, "null VP8Io passed to VP8GetHeaders()");
            var n = r.data, a = r.w, o = r.ha;
            if (4 > o) return Jt(t, 7, "Truncated header.");
            var s = n[a + 0] | n[a + 1] << 8 | n[a + 2] << 16, c = t.Od;
            if (c.Rb = !(1 & s), c.td = s >> 1 & 7, c.yd = s >> 4 & 1, c.ub = s >> 5, 3 < c.td) return Jt(t, 3, "Incorrect keyframe parameters.");
            if (!c.yd) return Jt(t, 4, "Frame not displayable.");
            a += 3, o -= 3;
            var u = t.Kc;
            if (c.Rb) {
                if (7 > o) return Jt(t, 7, "cannot parse picture header");
                if (!Xt(n, a, o)) return Jt(t, 3, "Bad code word");
                u.c = 16383 & (n[a + 4] << 8 | n[a + 3]), u.Td = n[a + 4] >> 6, u.i = 16383 & (n[a + 6] << 8 | n[a + 5]), u.Ud = n[a + 6] >> 6, a += 7, o -= 7, t.za = u.c + 15 >> 4, t.Ub = u.i + 15 >> 4, r.width = u.c, r.height = u.i, r.Da = 0, r.j = 0, r.v = 0, r.va = r.width, r.o = r.height, r.da = 0, r.ib = r.width, r.hb = r.height, r.U = r.width, r.T = r.height, _$i((s = t.Pa).jb, 0, 255, s.jb.length), e(null != (s = t.Qa)), s.Cb = 0, s.Bb = 0, s.Fb = 1, _$i(s.Zb, 0, 0, s.Zb.length), _$i(s.Lb, 0, 0, s.Lb);
            }
            if (c.ub > o) return Jt(t, 7, "bad partition length");
            p(s = t.m, n, a, c.ub), a += c.ub, o -= c.ub, c.Rb && (u.Ld = P(s), u.Kd = P(s)), u = t.Qa;
            var h, l = t.Pa;
            if (e(null != s), e(null != u), u.Cb = P(s), u.Cb) {
                if (u.Bb = P(s), P(s)) {
                    for(u.Fb = P(s), h = 0; 4 > h; ++h)u.Zb[h] = P(s) ? m(s, 7) : 0;
                    for(h = 0; 4 > h; ++h)u.Lb[h] = P(s) ? m(s, 6) : 0;
                }
                if (u.Bb) for(h = 0; 3 > h; ++h)l.jb[h] = P(s) ? g(s, 8) : 255;
            } else u.Bb = 0;
            if (s.Ka) return Jt(t, 3, "cannot parse segment header");
            if ((u = t.ed).zd = P(s), u.Tb = g(s, 6), u.wb = g(s, 3), u.Pc = P(s), u.Pc && P(s)) {
                for(l = 0; 4 > l; ++l)P(s) && (u.vd[l] = m(s, 6));
                for(l = 0; 4 > l; ++l)P(s) && (u.od[l] = m(s, 6));
            }
            if (t.L = 0 == u.Tb ? 0 : u.zd ? 1 : 2, s.Ka) return Jt(t, 3, "cannot parse filter header");
            var f = o;
            if (o = h = a, a = h + f, u = f, t.Xb = (1 << g(t.m, 2)) - 1, f < 3 * (l = t.Xb)) n = 7;
            else {
                for(h += 3 * l, u -= 3 * l, f = 0; f < l; ++f){
                    var d = n[o + 0] | n[o + 1] << 8 | n[o + 2] << 16;
                    d > u && (d = u), p(t.Jc[+f], n, h, d), h += d, u -= d, o += 3;
                }
                p(t.Jc[+l], n, h, u), n = h < a ? 0 : 5;
            }
            if (0 != n) return Jt(t, n, "cannot parse partitions");
            for(n = g(h = t.m, 7), o = P(h) ? m(h, 4) : 0, a = P(h) ? m(h, 4) : 0, u = P(h) ? m(h, 4) : 0, l = P(h) ? m(h, 4) : 0, h = P(h) ? m(h, 4) : 0, f = t.Qa, d = 0; 4 > d; ++d){
                if (f.Cb) {
                    var v = f.Zb[d];
                    f.Fb || (v += n);
                } else {
                    if (0 < d) {
                        t.pb[d] = t.pb[0];
                        continue;
                    }
                    v = n;
                }
                var b = t.pb[d];
                b.Sc[0] = ei[Vt(v + o, 127)], b.Sc[1] = ri[Vt(v + 0, 127)], b.Eb[0] = 2 * ei[Vt(v + a, 127)], b.Eb[1] = 101581 * ri[Vt(v + u, 127)] >> 16, 8 > b.Eb[1] && (b.Eb[1] = 8), b.Qc[0] = ei[Vt(v + l, 117)], b.Qc[1] = ri[Vt(v + h, 127)], b.lc = v + h;
            }
            if (!c.Rb) return Jt(t, 4, "Not a key frame.");
            for(P(s), c = t.Pa, n = 0; 4 > n; ++n){
                for(o = 0; 8 > o; ++o)for(a = 0; 3 > a; ++a)for(u = 0; 11 > u; ++u)l = k(s, ui[n][o][a][u]) ? g(s, 8) : si[n][o][a][u], c.Wc[n][o].Yb[a][u] = l;
                for(o = 0; 17 > o; ++o)c.Xc[n][o] = c.Wc[n][hi[o]];
            }
            return t.kc = P(s), t.kc && (t.Bd = g(s, 8)), t.cb = 1;
        };
        var Zt = function Zt(t, e, r, n, i, a, o) {
            var s = e[i].Yb[r];
            for(r = 0; 16 > i; ++i){
                if (!k(t, s[r + 0])) return i;
                for(; !k(t, s[r + 1]);)if (s = e[++i].Yb[0], r = 0, 16 == i) return 16;
                var c = e[i + 1].Yb;
                if (k(t, s[r + 2])) {
                    var u = t, h = 0;
                    if (k(u, (f = s)[(l = r) + 3])) {
                        if (k(u, f[l + 6])) {
                            for(s = 0, l = 2 * (h = k(u, f[l + 8])) + (f = k(u, f[l + 9 + h])), h = 0, f = ii[l]; f[s]; ++s)h += h + k(u, f[s]);
                            h += 3 + (8 << l);
                        } else k(u, f[l + 7]) ? (h = 7 + 2 * k(u, 165), h += k(u, 145)) : h = 5 + k(u, 159);
                    } else h = k(u, f[l + 4]) ? 3 + k(u, f[l + 5]) : 2;
                    s = c[2];
                } else h = 1, s = c[1];
                c = o + ai[i], 0 > (u = t).b && _(u);
                var l, f = u.b, d = (l = u.Ca >> 1) - (u.I >> f) >> 31;
                --u.b, u.Ca += d, u.Ca |= 1, u.I -= (l + 1 & d) << f, a[c] = ((h ^ d) - d) * n[(0 < i) + 0];
            }
            return 16;
        };
        var $t = function $t(t) {
            var e = t.rb[t.sb - 1];
            e.la = 0, e.Na = 0, _$i(t.zc, 0, 0, t.zc.length), t.ja = 0;
        };
        var Qt = function Qt(t, r) {
            if (null == t) return 0;
            if (null == r) return Jt(t, 2, "NULL VP8Io parameter in VP8Decode().");
            if (!t.cb && !Kt(t, r)) return 0;
            if (e(t.cb), null == r.ac || r.ac(r)) {
                r.ob && (t.L = 0);
                var s = Ri[t.L];
                if (2 == t.L ? (t.yb = 0, t.zb = 0) : (t.yb = r.v - s >> 4, t.zb = r.j - s >> 4, 0 > t.yb && (t.yb = 0), 0 > t.zb && (t.zb = 0)), t.Va = r.o + 15 + s >> 4, t.Hb = r.va + 15 + s >> 4, t.Hb > t.za && (t.Hb = t.za), t.Va > t.Ub && (t.Va = t.Ub), 0 < t.L) {
                    var c = t.ed;
                    for(s = 0; 4 > s; ++s){
                        var u;
                        if (t.Qa.Cb) {
                            var h = t.Qa.Lb[s];
                            t.Qa.Fb || (h += c.Tb);
                        } else h = c.Tb;
                        for(u = 0; 1 >= u; ++u){
                            var l = t.gd[s][u], f = h;
                            if (c.Pc && (f += c.vd[0], u && (f += c.od[0])), 0 < (f = 0 > f ? 0 : 63 < f ? 63 : f)) {
                                var d = f;
                                0 < c.wb && (d = 4 < c.wb ? d >> 2 : d >> 1) > 9 - c.wb && (d = 9 - c.wb), 1 > d && (d = 1), l.dd = d, l.tc = 2 * f + d, l.ld = 40 <= f ? 2 : 15 <= f ? 1 : 0;
                            } else l.tc = 0;
                            l.La = u;
                        }
                    }
                }
                s = 0;
            } else Jt(t, 6, "Frame setup failed"), s = t.a;
            if (s = 0 == s) {
                if (s) {
                    t.$c = 0, 0 < t.Aa || (t.Ic = Ui);
                    t: {
                        s = t.Ic;
                        c = 4 * (d = t.za);
                        var p = 32 * d, g = d + 1, m = 0 < t.L ? d * (0 < t.Aa ? 2 : 1) : 0, v = (2 == t.Aa ? 2 : 1) * d;
                        if ((l = c + 832 + (u = 3 * (16 * s + Ri[t.L]) / 2 * p) + (h = null != t.Fa && 0 < t.Fa.length ? t.Kc.c * t.Kc.i : 0)) != l) s = 0;
                        else {
                            if (l > t.Vb) {
                                if (t.Vb = 0, t.Ec = a(l), t.Fc = 0, null == t.Ec) {
                                    s = Jt(t, 1, "no memory during frame initialization.");
                                    break t;
                                }
                                t.Vb = l;
                            }
                            l = t.Ec, f = t.Fc, t.Ac = l, t.Bc = f, f += c, t.Gd = o(p, Ht), t.Hd = 0, t.rb = o(g + 1, Rt), t.sb = 1, t.wa = m ? o(m, Dt) : null, t.Y = 0, t.D.Nb = 0, t.D.wa = t.wa, t.D.Y = t.Y, 0 < t.Aa && (t.D.Y += d), e(!0), t.oc = l, t.pc = f, f += 832, t.ya = o(v, Ut), t.aa = 0, t.D.ya = t.ya, t.D.aa = t.aa, 2 == t.Aa && (t.D.aa += d), t.R = 16 * d, t.B = 8 * d, d = (p = Ri[t.L]) * t.R, p = p / 2 * t.B, t.sa = l, t.ta = f + d, t.qa = t.sa, t.ra = t.ta + 16 * s * t.R + p, t.Ha = t.qa, t.Ia = t.ra + 8 * s * t.B + p, t.$c = 0, f += u, t.mb = h ? l : null, t.nb = h ? f : null, e(f + h <= t.Fc + t.Vb), $t(t), _$i(t.Ac, t.Bc, 0, c), s = 1;
                        }
                    }
                    if (s) {
                        if (r.ka = 0, r.y = t.sa, r.O = t.ta, r.f = t.qa, r.N = t.ra, r.ea = t.Ha, r.Vd = t.Ia, r.fa = t.R, r.Rc = t.B, r.F = null, r.J = 0, !Cn) {
                            for(s = -255; 255 >= s; ++s)Pn[255 + s] = 0 > s ? -s : s;
                            for(s = -1020; 1020 >= s; ++s)kn[1020 + s] = -128 > s ? -128 : 127 < s ? 127 : s;
                            for(s = -112; 112 >= s; ++s)In[112 + s] = -16 > s ? -16 : 15 < s ? 15 : s;
                            for(s = -255; 510 >= s; ++s)Fn[255 + s] = 0 > s ? 0 : 255 < s ? 255 : s;
                            Cn = 1;
                        }
                        an = ue, on = ae, cn = oe, un = se, hn = ce, sn = ie, ln = Je, fn = Xe, dn = $e, pn = Qe, gn = Ke, mn = Ze, vn = tr, bn = er, yn = ze, wn = He, Nn = We, Ln = Ve, fi[0] = xe, fi[1] = le, fi[2] = Le, fi[3] = Ae, fi[4] = Se, fi[5] = Pe, fi[6] = _e, fi[7] = ke, fi[8] = Fe, fi[9] = Ie, li[0] = ve, li[1] = de, li[2] = pe, li[3] = ge, li[4] = be, li[5] = ye, li[6] = we, di[0] = Be, di[1] = fe, di[2] = Ce, di[3] = je, di[4] = Ee, di[5] = Me, di[6] = qe, s = 1;
                    } else s = 0;
                }
                s && (s = function(t, r) {
                    for(t.M = 0; t.M < t.Va; ++t.M){
                        var o, s = t.Jc[t.M & t.Xb], c = t.m, u = t;
                        for(o = 0; o < u.za; ++o){
                            var h = c, l = u, f = l.Ac, d = l.Bc + 4 * o, p = l.zc, g = l.ya[l.aa + o];
                            if (l.Qa.Bb ? g.$b = k(h, l.Pa.jb[0]) ? 2 + k(h, l.Pa.jb[2]) : k(h, l.Pa.jb[1]) : g.$b = 0, l.kc && (g.Ad = k(h, l.Bd)), g.Za = !k(h, 145) + 0, g.Za) {
                                var m = g.Ob, v = 0;
                                for(l = 0; 4 > l; ++l){
                                    var b, _$y = p[0 + l];
                                    for(b = 0; 4 > b; ++b){
                                        _$y = ci[f[d + b]][_$y];
                                        for(var w = oi[k(h, _$y[0])]; 0 < w;)w = oi[2 * w + k(h, _$y[w])];
                                        _$y = -w, f[d + b] = _$y;
                                    }
                                    n(m, v, f, d, 4), v += 4, p[0 + l] = _$y;
                                }
                            } else _$y = k(h, 156) ? k(h, 128) ? 1 : 3 : k(h, 163) ? 2 : 0, g.Ob[0] = _$y, _$i(f, d, _$y, 4), _$i(p, 0, _$y, 4);
                            g.Dd = k(h, 142) ? k(h, 114) ? k(h, 183) ? 1 : 3 : 2 : 0;
                        }
                        if (u.m.Ka) return Jt(t, 7, "Premature end-of-partition0 encountered.");
                        for(; t.ja < t.za; ++t.ja){
                            if (u = s, h = (c = t).rb[c.sb - 1], f = c.rb[c.sb + c.ja], o = c.ya[c.aa + c.ja], d = c.kc ? o.Ad : 0) h.la = f.la = 0, o.Za || (h.Na = f.Na = 0), o.Hc = 0, o.Gc = 0, o.ia = 0;
                            else {
                                var N, L;
                                h = f, f = u, d = c.Pa.Xc, p = c.ya[c.aa + c.ja], g = c.pb[p.$b];
                                if (l = p.ad, m = 0, v = c.rb[c.sb - 1], _$y = b = 0, _$i(l, m, 0, 384), p.Za) var A = 0, x = d[3];
                                else {
                                    w = a(16);
                                    var S = h.Na + v.Na;
                                    if (S = ni(f, d[1], S, g.Eb, 0, w, 0), h.Na = v.Na = (0 < S) + 0, 1 < S) an(w, 0, l, m);
                                    else {
                                        var _ = w[0] + 3 >> 3;
                                        for(w = 0; 256 > w; w += 16)l[m + w] = _;
                                    }
                                    A = 1, x = d[0];
                                }
                                var P = 15 & h.la, _$I = 15 & v.la;
                                for(w = 0; 4 > w; ++w){
                                    var F = 1 & _$I;
                                    for(_ = L = 0; 4 > _; ++_)P = P >> 1 | (F = (S = ni(f, x, S = F + (1 & P), g.Sc, A, l, m)) > A) << 7, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                    P >>= 4, _$I = _$I >> 1 | F << 7, b = (b << 8 | L) >>> 0;
                                }
                                for(x = P, A = _$I >> 4, N = 0; 4 > N; N += 2){
                                    for(L = 0, P = h.la >> 4 + N, _$I = v.la >> 4 + N, w = 0; 2 > w; ++w){
                                        for(F = 1 & _$I, _ = 0; 2 > _; ++_)S = F + (1 & P), P = P >> 1 | (F = 0 < (S = ni(f, d[2], S, g.Qc, 0, l, m))) << 3, L = L << 2 | (3 < S ? 3 : 1 < S ? 2 : 0 != l[m + 0]), m += 16;
                                        P >>= 2, _$I = _$I >> 1 | F << 5;
                                    }
                                    _$y |= L << 4 * N, x |= P << 4 << N, A |= (240 & _$I) << N;
                                }
                                h.la = x, v.la = A, p.Hc = b, p.Gc = _$y, p.ia = 43690 & _$y ? 0 : g.ia, d = !(b | _$y);
                            }
                            if (0 < c.L && (c.wa[c.Y + c.ja] = c.gd[o.$b][o.Za], c.wa[c.Y + c.ja].La |= !d), u.Ka) return Jt(t, 7, "Premature end-of-file encountered.");
                        }
                        if ($t(t), c = r, u = 1, o = (s = t).D, h = 0 < s.L && s.M >= s.zb && s.M <= s.Va, 0 == s.Aa) t: {
                            if (o.M = s.M, o.uc = h, Or(s, o), u = 1, o = (L = s.D).Nb, h = (_$y = Ri[s.L]) * s.R, f = _$y / 2 * s.B, w = 16 * o * s.R, _ = 8 * o * s.B, d = s.sa, p = s.ta - h + w, g = s.qa, l = s.ra - f + _, m = s.Ha, v = s.Ia - f + _, _$I = 0 == (P = L.M), b = P >= s.Va - 1, 2 == s.Aa && Or(s, L), L.uc) for(F = (S = s).D.M, e(S.D.uc), L = S.yb; L < S.Hb; ++L){
                                A = L, x = F;
                                var C = (_$j = (U = S).D).Nb;
                                N = U.R;
                                var _$j = _$j.wa[_$j.Y + A], O = U.sa, B = U.ta + 16 * C * N + 16 * A, M = _$j.dd, _$E = _$j.tc;
                                if (0 != _$E) {
                                    if (e(3 <= _$E), 1 == U.L) 0 < A && wn(O, B, N, _$E + 4), _$j.La && Ln(O, B, N, _$E), 0 < x && yn(O, B, N, _$E + 4), _$j.La && Nn(O, B, N, _$E);
                                    else {
                                        var q = U.B, D = U.qa, R = U.ra + 8 * C * q + 8 * A, T = U.Ha, U = U.Ia + 8 * C * q + 8 * A;
                                        C = _$j.ld;
                                        0 < A && (fn(O, B, N, _$E + 4, M, C), pn(D, R, T, U, q, _$E + 4, M, C)), _$j.La && (mn(O, B, N, _$E, M, C), bn(D, R, T, U, q, _$E, M, C)), 0 < x && (ln(O, B, N, _$E + 4, M, C), dn(D, R, T, U, q, _$E + 4, M, C)), _$j.La && (gn(O, B, N, _$E, M, C), vn(D, R, T, U, q, _$E, M, C));
                                    }
                                }
                            }
                            if (s.ia && alert("todo:DitherRow"), null != c.put) {
                                if (L = 16 * P, P = 16 * (P + 1), _$I ? (c.y = s.sa, c.O = s.ta + w, c.f = s.qa, c.N = s.ra + _, c.ea = s.Ha, c.W = s.Ia + _) : (L -= _$y, c.y = d, c.O = p, c.f = g, c.N = l, c.ea = m, c.W = v), b || (P -= _$y), P > c.o && (P = c.o), c.F = null, c.J = null, null != s.Fa && 0 < s.Fa.length && L < P && (c.J = lr(s, c, L, P - L), c.F = s.mb, null == c.F && 0 == c.F.length)) {
                                    u = Jt(s, 3, "Could not decode alpha data.");
                                    break t;
                                }
                                L < c.j && (_$y = c.j - L, L = c.j, e(!(1 & _$y)), c.O += s.R * _$y, c.N += s.B * (_$y >> 1), c.W += s.B * (_$y >> 1), null != c.F && (c.J += c.width * _$y)), L < P && (c.O += c.v, c.N += c.v >> 1, c.W += c.v >> 1, null != c.F && (c.J += c.v), c.ka = L - c.j, c.U = c.va - c.v, c.T = P - L, u = c.put(c));
                            }
                            o + 1 != s.Ic || b || (n(s.sa, s.ta - h, d, p + 16 * s.R, h), n(s.qa, s.ra - f, g, l + 8 * s.B, f), n(s.Ha, s.Ia - f, m, v + 8 * s.B, f));
                        }
                        if (!u) return Jt(t, 6, "Output aborted.");
                    }
                    return 1;
                }(t, r)), null != r.bc && r.bc(r), s &= 1;
            }
            return s ? (t.cb = 0, s) : 0;
        };
        var _$te = function _$te(t, e, r, n, i) {
            i = t[e + r + 32 * n] + (i >> 3), t[e + r + 32 * n] = -256 & i ? 0 > i ? 0 : 255 : i;
        };
        var _$ee = function _$ee(t, e, r, n, i, a) {
            _$te(t, e, 0, r, n + i), _$te(t, e, 1, r, n + a), _$te(t, e, 2, r, n - a), _$te(t, e, 3, r, n - i);
        };
        var re = function re(t) {
            return (20091 * t >> 16) + t;
        };
        var ne = function ne(t, e, r, n) {
            var _$i, o = 0, s = a(16);
            for(_$i = 0; 4 > _$i; ++_$i){
                var c = t[e + 0] + t[e + 8], u = t[e + 0] - t[e + 8], h = (35468 * t[e + 4] >> 16) - re(t[e + 12]), l = re(t[e + 4]) + (35468 * t[e + 12] >> 16);
                s[o + 0] = c + l, s[o + 1] = u + h, s[o + 2] = u - h, s[o + 3] = c - l, o += 4, e++;
            }
            for(_$i = o = 0; 4 > _$i; ++_$i)c = (t = s[o + 0] + 4) + s[o + 8], u = t - s[o + 8], h = (35468 * s[o + 4] >> 16) - re(s[o + 12]), _$te(r, n, 0, 0, c + (l = re(s[o + 4]) + (35468 * s[o + 12] >> 16))), _$te(r, n, 1, 0, u + h), _$te(r, n, 2, 0, u - h), _$te(r, n, 3, 0, c - l), o++, n += 32;
        };
        var ie = function ie(t, e, r, n) {
            var _$i = t[e + 0] + 4, a = 35468 * t[e + 4] >> 16, o = re(t[e + 4]), s = 35468 * t[e + 1] >> 16;
            _$ee(r, n, 0, _$i + o, t = re(t[e + 1]), s), _$ee(r, n, 1, _$i + a, t, s), _$ee(r, n, 2, _$i - a, t, s), _$ee(r, n, 3, _$i - o, t, s);
        };
        var ae = function ae(t, e, r, n, i) {
            ne(t, e, r, n), i && ne(t, e + 16, r, n + 4);
        };
        var oe = function oe(t, e, r, n) {
            on(t, e + 0, r, n, 1), on(t, e + 32, r, n + 128, 1);
        };
        var se = function se(t, e, r, n) {
            var _$i;
            for(t = t[e + 0] + 4, _$i = 0; 4 > _$i; ++_$i)for(e = 0; 4 > e; ++e)_$te(r, n, e, _$i, t);
        };
        var ce = function ce(t, e, r, n) {
            t[e + 0] && un(t, e + 0, r, n), t[e + 16] && un(t, e + 16, r, n + 4), t[e + 32] && un(t, e + 32, r, n + 128), t[e + 48] && un(t, e + 48, r, n + 128 + 4);
        };
        var ue = function ue(t, e, r, n) {
            var _$i, o = a(16);
            for(_$i = 0; 4 > _$i; ++_$i){
                var s = t[e + 0 + _$i] + t[e + 12 + _$i], c = t[e + 4 + _$i] + t[e + 8 + _$i], u = t[e + 4 + _$i] - t[e + 8 + _$i], h = t[e + 0 + _$i] - t[e + 12 + _$i];
                o[0 + _$i] = s + c, o[8 + _$i] = s - c, o[4 + _$i] = h + u, o[12 + _$i] = h - u;
            }
            for(_$i = 0; 4 > _$i; ++_$i)s = (t = o[0 + 4 * _$i] + 3) + o[3 + 4 * _$i], c = o[1 + 4 * _$i] + o[2 + 4 * _$i], u = o[1 + 4 * _$i] - o[2 + 4 * _$i], h = t - o[3 + 4 * _$i], r[n + 0] = s + c >> 3, r[n + 16] = h + u >> 3, r[n + 32] = s - c >> 3, r[n + 48] = h - u >> 3, n += 64;
        };
        var he = function he(t, e, r) {
            var n, _$i = e - 32, a = Bn, o = 255 - t[_$i - 1];
            for(n = 0; n < r; ++n){
                var s, c = a, u = o + t[e - 1];
                for(s = 0; s < r; ++s)t[e + s] = c[u + t[_$i + s]];
                e += 32;
            }
        };
        var le = function le(t, e) {
            he(t, e, 4);
        };
        var fe = function fe(t, e) {
            he(t, e, 8);
        };
        var de = function de(t, e) {
            he(t, e, 16);
        };
        var pe = function pe(t, e) {
            var r;
            for(r = 0; 16 > r; ++r)n(t, e + 32 * r, t, e - 32, 16);
        };
        var ge = function ge(t, e) {
            var r;
            for(r = 16; 0 < r; --r)_$i(t, e, t[e - 1], 16), e += 32;
        };
        var me = function me(t, e, r) {
            var n;
            for(n = 0; 16 > n; ++n)_$i(e, r + 32 * n, t, 16);
        };
        var ve = function ve(t, e) {
            var r, n = 16;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r] + t[e + r - 32];
            me(n >> 5, t, e);
        };
        var be = function be(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e - 1 + 32 * r];
            me(n >> 4, t, e);
        };
        var ye = function ye(t, e) {
            var r, n = 8;
            for(r = 0; 16 > r; ++r)n += t[e + r - 32];
            me(n >> 4, t, e);
        };
        var we = function we(t, e) {
            me(128, t, e);
        };
        var Ne = function Ne(t, e, r) {
            return t + 2 * e + r + 2 >> 2;
        };
        var Le = function Le(t, e) {
            var r, _$i = e - 32;
            _$i = new Uint8Array([
                Ne(t[_$i - 1], t[_$i + 0], t[_$i + 1]),
                Ne(t[_$i + 0], t[_$i + 1], t[_$i + 2]),
                Ne(t[_$i + 1], t[_$i + 2], t[_$i + 3]),
                Ne(t[_$i + 2], t[_$i + 3], t[_$i + 4])
            ]);
            for(r = 0; 4 > r; ++r)n(t, e + 32 * r, _$i, 0, _$i.length);
        };
        var Ae = function Ae(t, e) {
            var r = t[e - 1], n = t[e - 1 + 32], _$i = t[e - 1 + 64], a = t[e - 1 + 96];
            _$I(t, e + 0, 16843009 * Ne(t[e - 1 - 32], r, n)), _$I(t, e + 32, 16843009 * Ne(r, n, _$i)), _$I(t, e + 64, 16843009 * Ne(n, _$i, a)), _$I(t, e + 96, 16843009 * Ne(_$i, a, a));
        };
        var xe = function xe(t, e) {
            var r, n = 4;
            for(r = 0; 4 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            for(n >>= 3, r = 0; 4 > r; ++r)_$i(t, e + 32 * r, n, 4);
        };
        var Se = function Se(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], _$i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 96] = Ne(n, _$i, t[e - 1 + 96]), t[e + 1 + 96] = t[e + 0 + 64] = Ne(r, n, _$i), t[e + 2 + 96] = t[e + 1 + 64] = t[e + 0 + 32] = Ne(a, r, n), t[e + 3 + 96] = t[e + 2 + 64] = t[e + 1 + 32] = t[e + 0 + 0] = Ne(o, a, r), t[e + 3 + 64] = t[e + 2 + 32] = t[e + 1 + 0] = Ne(s, o, a), t[e + 3 + 32] = t[e + 2 + 0] = Ne(c, s, o), t[e + 3 + 0] = Ne(u, c, s);
        };
        var _e = function _e(t, e) {
            var r = t[e + 1 - 32], n = t[e + 2 - 32], _$i = t[e + 3 - 32], a = t[e + 4 - 32], o = t[e + 5 - 32], s = t[e + 6 - 32], c = t[e + 7 - 32];
            t[e + 0 + 0] = Ne(t[e + 0 - 32], r, n), t[e + 1 + 0] = t[e + 0 + 32] = Ne(r, n, _$i), t[e + 2 + 0] = t[e + 1 + 32] = t[e + 0 + 64] = Ne(n, _$i, a), t[e + 3 + 0] = t[e + 2 + 32] = t[e + 1 + 64] = t[e + 0 + 96] = Ne(_$i, a, o), t[e + 3 + 32] = t[e + 2 + 64] = t[e + 1 + 96] = Ne(a, o, s), t[e + 3 + 64] = t[e + 2 + 96] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, c);
        };
        var Pe = function Pe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], _$i = t[e - 1 + 64], a = t[e - 1 - 32], o = t[e + 0 - 32], s = t[e + 1 - 32], c = t[e + 2 - 32], u = t[e + 3 - 32];
            t[e + 0 + 0] = t[e + 1 + 64] = a + o + 1 >> 1, t[e + 1 + 0] = t[e + 2 + 64] = o + s + 1 >> 1, t[e + 2 + 0] = t[e + 3 + 64] = s + c + 1 >> 1, t[e + 3 + 0] = c + u + 1 >> 1, t[e + 0 + 96] = Ne(_$i, n, r), t[e + 0 + 64] = Ne(n, r, a), t[e + 0 + 32] = t[e + 1 + 96] = Ne(r, a, o), t[e + 1 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 2 + 32] = t[e + 3 + 96] = Ne(o, s, c), t[e + 3 + 32] = Ne(s, c, u);
        };
        var ke = function ke(t, e) {
            var r = t[e + 0 - 32], n = t[e + 1 - 32], _$i = t[e + 2 - 32], a = t[e + 3 - 32], o = t[e + 4 - 32], s = t[e + 5 - 32], c = t[e + 6 - 32], u = t[e + 7 - 32];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 1 + 0] = t[e + 0 + 64] = n + _$i + 1 >> 1, t[e + 2 + 0] = t[e + 1 + 64] = _$i + a + 1 >> 1, t[e + 3 + 0] = t[e + 2 + 64] = a + o + 1 >> 1, t[e + 0 + 32] = Ne(r, n, _$i), t[e + 1 + 32] = t[e + 0 + 96] = Ne(n, _$i, a), t[e + 2 + 32] = t[e + 1 + 96] = Ne(_$i, a, o), t[e + 3 + 32] = t[e + 2 + 96] = Ne(a, o, s), t[e + 3 + 64] = Ne(o, s, c), t[e + 3 + 96] = Ne(s, c, u);
        };
        var Ie = function Ie(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], _$i = t[e - 1 + 64], a = t[e - 1 + 96];
            t[e + 0 + 0] = r + n + 1 >> 1, t[e + 2 + 0] = t[e + 0 + 32] = n + _$i + 1 >> 1, t[e + 2 + 32] = t[e + 0 + 64] = _$i + a + 1 >> 1, t[e + 1 + 0] = Ne(r, n, _$i), t[e + 3 + 0] = t[e + 1 + 32] = Ne(n, _$i, a), t[e + 3 + 32] = t[e + 1 + 64] = Ne(_$i, a, a), t[e + 3 + 64] = t[e + 2 + 64] = t[e + 0 + 96] = t[e + 1 + 96] = t[e + 2 + 96] = t[e + 3 + 96] = a;
        };
        var Fe = function Fe(t, e) {
            var r = t[e - 1 + 0], n = t[e - 1 + 32], _$i = t[e - 1 + 64], a = t[e - 1 + 96], o = t[e - 1 - 32], s = t[e + 0 - 32], c = t[e + 1 - 32], u = t[e + 2 - 32];
            t[e + 0 + 0] = t[e + 2 + 32] = r + o + 1 >> 1, t[e + 0 + 32] = t[e + 2 + 64] = n + r + 1 >> 1, t[e + 0 + 64] = t[e + 2 + 96] = _$i + n + 1 >> 1, t[e + 0 + 96] = a + _$i + 1 >> 1, t[e + 3 + 0] = Ne(s, c, u), t[e + 2 + 0] = Ne(o, s, c), t[e + 1 + 0] = t[e + 3 + 32] = Ne(r, o, s), t[e + 1 + 32] = t[e + 3 + 64] = Ne(n, r, o), t[e + 1 + 64] = t[e + 3 + 96] = Ne(_$i, n, r), t[e + 1 + 96] = Ne(a, _$i, n);
        };
        var Ce = function Ce(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)n(t, e + 32 * r, t, e - 32, 8);
        };
        var je = function je(t, e) {
            var r;
            for(r = 0; 8 > r; ++r)_$i(t, e, t[e - 1], 8), e += 32;
        };
        var Oe = function Oe(t, e, r) {
            var n;
            for(n = 0; 8 > n; ++n)_$i(e, r + 32 * n, t, 8);
        };
        var Be = function Be(t, e) {
            var r, n = 8;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32] + t[e - 1 + 32 * r];
            Oe(n >> 4, t, e);
        };
        var Me = function Me(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e + r - 32];
            Oe(n >> 3, t, e);
        };
        var Ee = function Ee(t, e) {
            var r, n = 4;
            for(r = 0; 8 > r; ++r)n += t[e - 1 + 32 * r];
            Oe(n >> 3, t, e);
        };
        var qe = function qe(t, e) {
            Oe(128, t, e);
        };
        var De = function De(t, e, r) {
            var n = t[e - r], _$i = t[e + 0], a = 3 * (_$i - n) + jn[1020 + t[e - 2 * r] - t[e + r]], o = On[112 + (a + 4 >> 3)];
            t[e - r] = Bn[255 + n + On[112 + (a + 3 >> 3)]], t[e + 0] = Bn[255 + _$i - o];
        };
        var Re = function Re(t, e, r, n) {
            var _$i = t[e + 0], a = t[e + r];
            return Mn[255 + t[e - 2 * r] - t[e - r]] > n || Mn[255 + a - _$i] > n;
        };
        var Te = function Te(t, e, r, n) {
            return 4 * Mn[255 + t[e - r] - t[e + 0]] + Mn[255 + t[e - 2 * r] - t[e + r]] <= n;
        };
        var Ue = function Ue(t, e, r, n, i) {
            var a = t[e - 3 * r], o = t[e - 2 * r], s = t[e - r], c = t[e + 0], u = t[e + r], h = t[e + 2 * r], l = t[e + 3 * r];
            return 4 * Mn[255 + s - c] + Mn[255 + o - u] > n ? 0 : Mn[255 + t[e - 4 * r] - a] <= i && Mn[255 + a - o] <= i && Mn[255 + o - s] <= i && Mn[255 + l - h] <= i && Mn[255 + h - u] <= i && Mn[255 + u - c] <= i;
        };
        var ze = function ze(t, e, r, n) {
            var _$i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n, r, _$i) && De(t, e + n, r);
        };
        var He = function He(t, e, r, n) {
            var _$i = 2 * n + 1;
            for(n = 0; 16 > n; ++n)Te(t, e + n * r, 1, _$i) && De(t, e + n * r, 1);
        };
        var We = function We(t, e, r, n) {
            var _$i;
            for(_$i = 3; 0 < _$i; --_$i)ze(t, e += 4 * r, r, n);
        };
        var Ve = function Ve(t, e, r, n) {
            var _$i;
            for(_$i = 3; 0 < _$i; --_$i)He(t, e += 4, r, n);
        };
        var Ge = function Ge(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - 2 * h], f = c[u - h], d = c[u + 0], p = c[u + h], g = c[u + 2 * h], m = 27 * (b = jn[1020 + 3 * (d - f) + jn[1020 + l - p]]) + 63 >> 7, v = 18 * b + 63 >> 7, b = 9 * b + 63 >> 7;
                        c[u - 3 * h] = Bn[255 + c[u - 3 * h] + b], c[u - 2 * h] = Bn[255 + l + v], c[u - h] = Bn[255 + f + m], c[u + 0] = Bn[255 + d - m], c[u + h] = Bn[255 + p - v], c[u + 2 * h] = Bn[255 + g - b];
                    }
                }
                e += n;
            }
        };
        var Ye = function Ye(t, e, r, n, i, a, o, s) {
            for(a = 2 * a + 1; 0 < i--;){
                if (Ue(t, e, r, a, o)) {
                    if (Re(t, e, r, s)) De(t, e, r);
                    else {
                        var c = t, u = e, h = r, l = c[u - h], f = c[u + 0], d = c[u + h], p = On[112 + ((g = 3 * (f - l)) + 4 >> 3)], g = On[112 + (g + 3 >> 3)], m = p + 1 >> 1;
                        c[u - 2 * h] = Bn[255 + c[u - 2 * h] + m], c[u - h] = Bn[255 + l + g], c[u + 0] = Bn[255 + f - p], c[u + h] = Bn[255 + d - m];
                    }
                }
                e += n;
            }
        };
        var Je = function Je(t, e, r, n, i, a) {
            Ge(t, e, r, 1, 16, n, i, a);
        };
        var Xe = function Xe(t, e, r, n, i, a) {
            Ge(t, e, 1, r, 16, n, i, a);
        };
        var Ke = function Ke(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4 * r, r, 1, 16, n, i, a);
        };
        var Ze = function Ze(t, e, r, n, i, a) {
            var o;
            for(o = 3; 0 < o; --o)Ye(t, e += 4, 1, r, 16, n, i, a);
        };
        var $e = function $e(t, e, r, n, i, a, o, s) {
            Ge(t, e, i, 1, 8, a, o, s), Ge(r, n, i, 1, 8, a, o, s);
        };
        var Qe = function Qe(t, e, r, n, i, a, o, s) {
            Ge(t, e, 1, i, 8, a, o, s), Ge(r, n, 1, i, 8, a, o, s);
        };
        var tr = function tr(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4 * i, i, 1, 8, a, o, s), Ye(r, n + 4 * i, i, 1, 8, a, o, s);
        };
        var er = function er(t, e, r, n, i, a, o, s) {
            Ye(t, e + 4, 1, i, 8, a, o, s), Ye(r, n + 4, 1, i, 8, a, o, s);
        };
        var rr = function rr() {
            this.ba = new ot, this.ec = [], this.cc = [], this.Mc = [], this.Dc = this.Nc = this.dc = this.fc = 0, this.Oa = new ct, this.memory = 0, this.Ib = "OutputFunc", this.Jb = "OutputAlphaFunc", this.Nd = "OutputRowFunc";
        };
        var nr = function nr() {
            this.data = [], this.offset = this.kd = this.ha = this.w = 0, this.na = [], this.xa = this.gb = this.Ja = this.Sa = this.P = 0;
        };
        var ir = function ir() {
            this.nc = this.Ea = this.b = this.hc = 0, this.K = [], this.w = 0;
        };
        var ar = function ar() {
            this.ua = 0, this.Wa = new M, this.vb = new M, this.md = this.xc = this.wc = 0, this.vc = [], this.Wb = 0, this.Ya = new d, this.yc = new l;
        };
        var or = function or() {
            this.xb = this.a = 0, this.l = new Gt, this.ca = new ot, this.V = [], this.Ba = 0, this.Ta = [], this.Ua = 0, this.m = new N, this.Pb = 0, this.wd = new N, this.Ma = this.$ = this.C = this.i = this.c = this.xd = 0, this.s = new ar, this.ab = 0, this.gc = o(4, ir), this.Oc = 0;
        };
        var sr = function sr() {
            this.Lc = this.Z = this.$a = this.i = this.c = 0, this.l = new Gt, this.ic = 0, this.ca = [], this.tb = 0, this.qd = null, this.rd = 0;
        };
        var cr = function cr(t, e, r, n, i, a, o) {
            for(t = null == t ? 0 : t[e + 0], e = 0; e < o; ++e)i[a + e] = t + r[n + e] & 255, t = i[a + e];
        };
        var ur = function ur(t, e, r, n, i, a, o) {
            var s;
            if (null == t) cr(null, null, r, n, i, a, o);
            else for(s = 0; s < o; ++s)i[a + s] = t[e + s] + r[n + s] & 255;
        };
        var hr = function hr(t, e, r, n, i, a, o) {
            if (null == t) cr(null, null, r, n, i, a, o);
            else {
                var s, c = t[e + 0], u = c, h = c;
                for(s = 0; s < o; ++s)u = h + (c = t[e + s]) - u, h = r[n + s] + (-256 & u ? 0 > u ? 0 : 255 : u) & 255, u = c, i[a + s] = h;
            }
        };
        var lr = function lr(t, r, i, o) {
            var s = r.width, c = r.o;
            if (e(null != t && null != r), 0 > i || 0 >= o || i + o > c) return null;
            if (!t.Cc) {
                if (null == t.ga) {
                    var u;
                    if (t.ga = new sr, (u = null == t.ga) || (u = r.width * r.o, e(0 == t.Gb.length), t.Gb = a(u), t.Uc = 0, null == t.Gb ? u = 0 : (t.mb = t.Gb, t.nb = t.Uc, t.rc = null, u = 1), u = !u), !u) {
                        u = t.ga;
                        var h = t.Fa, l = t.P, f = t.qc, d = t.mb, p = t.nb, g = l + 1, m = f - 1, b = u.l;
                        if (e(null != h && null != d && null != r), mi[0] = null, mi[1] = cr, mi[2] = ur, mi[3] = hr, u.ca = d, u.tb = p, u.c = r.width, u.i = r.height, e(0 < u.c && 0 < u.i), 1 >= f) r = 0;
                        else if (u.$a = h[l + 0] >> 0 & 3, u.Z = h[l + 0] >> 2 & 3, u.Lc = h[l + 0] >> 4 & 3, l = h[l + 0] >> 6 & 3, 0 > u.$a || 1 < u.$a || 4 <= u.Z || 1 < u.Lc || l) r = 0;
                        else if (b.put = dt, b.ac = ft, b.bc = pt, b.ma = u, b.width = r.width, b.height = r.height, b.Da = r.Da, b.v = r.v, b.va = r.va, b.j = r.j, b.o = r.o, u.$a) t: {
                            e(1 == u.$a), r = kt();
                            e: for(;;){
                                if (null == r) {
                                    r = 0;
                                    break t;
                                }
                                if (e(null != u), u.mc = r, r.c = u.c, r.i = u.i, r.l = u.l, r.l.ma = u, r.l.width = u.c, r.l.height = u.i, r.a = 0, v(r.m, h, g, m), !It(u.c, u.i, 1, r, null)) break e;
                                if (1 == r.ab && 3 == r.gc[0].hc && At(r.s) ? (u.ic = 1, h = r.c * r.i, r.Ta = null, r.Ua = 0, r.V = a(h), r.Ba = 0, null == r.V ? (r.a = 1, r = 0) : r = 1) : (u.ic = 0, r = Ft(r, u.c)), !r) break e;
                                r = 1;
                                break t;
                            }
                            u.mc = null, r = 0;
                        }
                        else r = m >= u.c * u.i;
                        u = !r;
                    }
                    if (u) return null;
                    1 != t.ga.Lc ? t.Ga = 0 : o = c - i;
                }
                e(null != t.ga), e(i + o <= c);
                t: {
                    if (r = (h = t.ga).c, c = h.l.o, 0 == h.$a) {
                        if (g = t.rc, m = t.Vc, b = t.Fa, l = t.P + 1 + i * r, f = t.mb, d = t.nb + i * r, e(l <= t.P + t.qc), 0 != h.Z) for(e(null != mi[h.Z]), u = 0; u < o; ++u)mi[h.Z](g, m, b, l, f, d, r), g = f, m = d, d += r, l += r;
                        else for(u = 0; u < o; ++u)n(f, d, b, l, r), g = f, m = d, d += r, l += r;
                        t.rc = g, t.Vc = m;
                    } else {
                        if (e(null != h.mc), r = i + o, e(null != (u = h.mc)), e(r <= u.i), u.C >= r) r = 1;
                        else if (h.ic || mr(), h.ic) {
                            h = u.V, g = u.Ba, m = u.c;
                            var _$y = u.i, w = (b = 1, l = u.$ / m, f = u.$ % m, d = u.m, p = u.s, u.$), N = m * _$y, L = m * r, x = p.wc, _ = w < L ? wt(p, f, l) : null;
                            e(w <= N), e(r <= _$y), e(At(p));
                            e: for(;;){
                                for(; !d.h && w < L;){
                                    if (f & x || (_ = wt(p, f, l)), e(null != _), S(d), 256 > (_$y = bt(_.G[0], _.H[0], d))) h[g + w] = _$y, ++w, ++f >= m && (f = 0, ++l <= r && !(l % 16) && St(u, l));
                                    else {
                                        if (!(280 > _$y)) {
                                            b = 0;
                                            break e;
                                        }
                                        _$y = mt(_$y - 256, d);
                                        var P, k = bt(_.G[4], _.H[4], d);
                                        if (S(d), !(w >= (k = vt(m, k = mt(k, d))) && N - w >= _$y)) {
                                            b = 0;
                                            break e;
                                        }
                                        for(P = 0; P < _$y; ++P)h[g + w + P] = h[g + w + P - k];
                                        for(w += _$y, f += _$y; f >= m;)f -= m, ++l <= r && !(l % 16) && St(u, l);
                                        w < L && f & x && (_ = wt(p, f, l));
                                    }
                                    e(d.h == A(d));
                                }
                                St(u, l > r ? r : l);
                                break e;
                            }
                            !b || d.h && w < N ? (b = 0, u.a = d.h ? 5 : 3) : u.$ = w, r = b;
                        } else r = _$_t(u, u.V, u.Ba, u.c, u.i, r, Ct);
                        if (!r) {
                            o = 0;
                            break t;
                        }
                    }
                    i + o >= c && (t.Cc = 1), o = 1;
                }
                if (!o) return null;
                if (t.Cc && (null != (o = t.ga) && (o.mc = null), t.ga = null, 0 < t.Ga)) return alert("todo:WebPDequantizeLevels"), null;
            }
            return t.nb + i * s;
        };
        var fr = function fr(t, e, r, n, i, a) {
            for(; 0 < i--;){
                var o, s = t, c = e + (r ? 1 : 0), u = t, h = e + (r ? 0 : 3);
                for(o = 0; o < n; ++o){
                    var l = u[h + 4 * o];
                    255 != l && (l *= 32897, s[c + 4 * o + 0] = s[c + 4 * o + 0] * l >> 23, s[c + 4 * o + 1] = s[c + 4 * o + 1] * l >> 23, s[c + 4 * o + 2] = s[c + 4 * o + 2] * l >> 23);
                }
                e += a;
            }
        };
        var dr = function dr(t, e, r, n, i) {
            for(; 0 < n--;){
                var a;
                for(a = 0; a < r; ++a){
                    var o = t[e + 2 * a + 0], s = 15 & (u = t[e + 2 * a + 1]), c = 4369 * s, u = (240 & u | u >> 4) * c >> 16;
                    t[e + 2 * a + 0] = (240 & o | o >> 4) * c >> 16 & 240 | (15 & o | o << 4) * c >> 16 >> 4 & 15, t[e + 2 * a + 1] = 240 & u | s;
                }
                e += i;
            }
        };
        var pr = function pr(t, e, r, n, i, a, o, s) {
            var c, u, h = 255;
            for(u = 0; u < i; ++u){
                for(c = 0; c < n; ++c){
                    var l = t[e + c];
                    a[o + 4 * c] = l, h &= l;
                }
                e += r, o += s;
            }
            return 255 != h;
        };
        var gr = function gr(t, e, r, n, i) {
            var a;
            for(a = 0; a < i; ++a)r[n + a] = t[e + a] >> 8;
        };
        var mr = function mr() {
            An = fr, xn = dr, Sn = pr, _n = gr;
        };
        var vr = function vr(r, n, i) {
            _$t[r] = function(t, r, a, o, s, c, u, h, l, f, d, p, g, m, v, b, y) {
                var w, N = y - 1 >> 1, L = s[c + 0] | u[h + 0] << 16, A = l[f + 0] | d[p + 0] << 16;
                e(null != t);
                var x = 3 * L + A + 131074 >> 2;
                for(n(t[r + 0], 255 & x, x >> 16, g, m), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + 0], 255 & x, x >> 16, v, b)), w = 1; w <= N; ++w){
                    var S = s[c + w] | u[h + w] << 16, _ = l[f + w] | d[p + w] << 16, P = L + S + A + _ + 524296, k = P + 2 * (S + A) >> 3;
                    x = k + L >> 1, L = (P = P + 2 * (L + _) >> 3) + S >> 1, n(t[r + 2 * w - 1], 255 & x, x >> 16, g, m + (2 * w - 1) * i), n(t[r + 2 * w - 0], 255 & L, L >> 16, g, m + (2 * w - 0) * i), null != a && (x = P + A >> 1, L = k + _ >> 1, n(a[o + 2 * w - 1], 255 & x, x >> 16, v, b + (2 * w - 1) * i), n(a[o + 2 * w + 0], 255 & L, L >> 16, v, b + (2 * w + 0) * i)), L = S, A = _;
                }
                1 & y || (x = 3 * L + A + 131074 >> 2, n(t[r + y - 1], 255 & x, x >> 16, g, m + (y - 1) * i), null != a && (x = 3 * A + L + 131074 >> 2, n(a[o + y - 1], 255 & x, x >> 16, v, b + (y - 1) * i)));
            };
        };
        var br = function br() {
            vi[En] = bi, vi[qn] = wi, vi[Dn] = yi, vi[Rn] = Ni, vi[Tn] = Li, vi[Un] = Ai, vi[zn] = xi, vi[Hn] = wi, vi[Wn] = Ni, vi[Vn] = Li, vi[Gn] = Ai;
        };
        var yr = function yr(t) {
            return t & ~Fi ? 0 > t ? 0 : 255 : t >> Ii;
        };
        var wr = function wr(t, e) {
            return yr((19077 * t >> 8) + (26149 * e >> 8) - 14234);
        };
        var Nr = function Nr(t, e, r) {
            return yr((19077 * t >> 8) - (6419 * e >> 8) - (13320 * r >> 8) + 8708);
        };
        var Lr = function Lr(t, e) {
            return yr((19077 * t >> 8) + (33050 * e >> 8) - 17685);
        };
        var Ar = function Ar(t, e, r, n, i) {
            n[i + 0] = wr(t, r), n[i + 1] = Nr(t, e, r), n[i + 2] = Lr(t, e);
        };
        var xr = function xr(t, e, r, n, i) {
            n[i + 0] = Lr(t, e), n[i + 1] = Nr(t, e, r), n[i + 2] = wr(t, r);
        };
        var Sr = function Sr(t, e, r, n, i) {
            var a = Nr(t, e, r);
            e = a << 3 & 224 | Lr(t, e) >> 3, n[i + 0] = 248 & wr(t, r) | a >> 5, n[i + 1] = e;
        };
        var _r = function _r(t, e, r, n, i) {
            var a = 240 & Lr(t, e) | 15;
            n[i + 0] = 240 & wr(t, r) | Nr(t, e, r) >> 4, n[i + 1] = a;
        };
        var Pr = function Pr(t, e, r, n, i) {
            n[i + 0] = 255, Ar(t, e, r, n, i + 1);
        };
        var kr = function kr(t, e, r, n, i) {
            xr(t, e, r, n, i), n[i + 3] = 255;
        };
        var Ir = function Ir(t, e, r, n, i) {
            Ar(t, e, r, n, i), n[i + 3] = 255;
        };
        var Vt = function Vt(t, e) {
            return 0 > t ? 0 : t > e ? e : t;
        };
        var Fr = function Fr(e, r, n) {
            _$t[e] = function(t, e, i, a, o, s, c, u, h) {
                for(var l = u + (-2 & h) * n; u != l;)r(t[e + 0], i[a + 0], o[s + 0], c, u), r(t[e + 1], i[a + 0], o[s + 0], c, u + n), e += 2, ++a, ++s, u += 2 * n;
                1 & h && r(t[e + 0], i[a + 0], o[s + 0], c, u);
            };
        };
        var Cr = function Cr(t, e, r) {
            return 0 == r ? 0 == t ? 0 == e ? 6 : 5 : 0 == e ? 4 : 0 : r;
        };
        var jr = function jr(t, e, r, n, i) {
            switch(t >>> 30){
                case 3:
                    on(e, r, n, i, 0);
                    break;
                case 2:
                    sn(e, r, n, i);
                    break;
                case 1:
                    un(e, r, n, i);
            }
        };
        var Or = function Or(t, e) {
            var r, a, o = e.M, s = e.Nb, c = t.oc, u = t.pc + 40, h = t.oc, l = t.pc + 584, f = t.oc, d = t.pc + 600;
            for(r = 0; 16 > r; ++r)c[u + 32 * r - 1] = 129;
            for(r = 0; 8 > r; ++r)h[l + 32 * r - 1] = 129, f[d + 32 * r - 1] = 129;
            for(0 < o ? c[u - 1 - 32] = h[l - 1 - 32] = f[d - 1 - 32] = 129 : (_$i(c, u - 32 - 1, 127, 21), _$i(h, l - 32 - 1, 127, 9), _$i(f, d - 32 - 1, 127, 9)), a = 0; a < t.za; ++a){
                var p = e.ya[e.aa + a];
                if (0 < a) {
                    for(r = -1; 16 > r; ++r)n(c, u + 32 * r - 4, c, u + 32 * r + 12, 4);
                    for(r = -1; 8 > r; ++r)n(h, l + 32 * r - 4, h, l + 32 * r + 4, 4), n(f, d + 32 * r - 4, f, d + 32 * r + 4, 4);
                }
                var g = t.Gd, m = t.Hd + a, v = p.ad, b = p.Hc;
                if (0 < o && (n(c, u - 32, g[m].y, 0, 16), n(h, l - 32, g[m].f, 0, 8), n(f, d - 32, g[m].ea, 0, 8)), p.Za) {
                    var _$y = c, w = u - 32 + 16;
                    for(0 < o && (a >= t.za - 1 ? _$i(_$y, w, g[m].y[15], 4) : n(_$y, w, g[m + 1].y, 0, 4)), r = 0; 4 > r; r++)_$y[w + 128 + r] = _$y[w + 256 + r] = _$y[w + 384 + r] = _$y[w + 0 + r];
                    for(r = 0; 16 > r; ++r, b <<= 2)_$y = c, w = u + Di[r], fi[p.Ob[r]](_$y, w), jr(b, v, 16 * +r, _$y, w);
                } else if (_$y = Cr(a, o, p.Ob[0]), li[_$y](c, u), 0 != b) for(r = 0; 16 > r; ++r, b <<= 2)jr(b, v, 16 * +r, c, u + Di[r]);
                for(r = p.Gc, _$y = Cr(a, o, p.Dd), di[_$y](h, l), di[_$y](f, d), b = v, _$y = h, w = l, 255 & (p = r >> 0) && (170 & p ? cn(b, 256, _$y, w) : hn(b, 256, _$y, w)), p = f, b = d, 255 & (r >>= 8) && (170 & r ? cn(v, 320, p, b) : hn(v, 320, p, b)), o < t.Ub - 1 && (n(g[m].y, 0, c, u + 480, 16), n(g[m].f, 0, h, l + 224, 8), n(g[m].ea, 0, f, d + 224, 8)), r = 8 * s * t.B, g = t.sa, m = t.ta + 16 * a + 16 * s * t.R, v = t.qa, p = t.ra + 8 * a + r, b = t.Ha, _$y = t.Ia + 8 * a + r, r = 0; 16 > r; ++r)n(g, m + r * t.R, c, u + 32 * r, 16);
                for(r = 0; 8 > r; ++r)n(v, p + r * t.B, h, l + 32 * r, 8), n(b, _$y + r * t.B, f, d + 32 * r, 8);
            }
        };
        var Br = function Br(t, n, i, a, o, s, c, u, h) {
            var l = [
                0
            ], f = [
                0
            ], d = 0, p = null != h ? h.kd : 0, g = null != h ? h : new nr;
            if (null == t || 12 > i) return 7;
            g.data = t, g.w = n, g.ha = i, n = [
                n
            ], i = [
                i
            ], g.gb = [
                g.gb
            ];
            t: {
                var m = n, b = i, _$y = g.gb;
                if (e(null != t), e(null != b), e(null != _$y), _$y[0] = 0, 12 <= b[0] && !r(t, m[0], "RIFF")) {
                    if (r(t, m[0] + 8, "WEBP")) {
                        _$y = 3;
                        break t;
                    }
                    var w = _$j(t, m[0] + 4);
                    if (12 > w || 4294967286 < w) {
                        _$y = 3;
                        break t;
                    }
                    if (p && w > b[0] - 8) {
                        _$y = 7;
                        break t;
                    }
                    _$y[0] = w, m[0] += 12, b[0] -= 12;
                }
                _$y = 0;
            }
            if (0 != _$y) return _$y;
            for(w = 0 < g.gb[0], i = i[0];;){
                t: {
                    var L = t;
                    b = n, _$y = i;
                    var A = l, x = f, S = m = [
                        0
                    ];
                    if ((k = d = [
                        d
                    ])[0] = 0, 8 > _$y[0]) _$y = 7;
                    else {
                        if (!r(L, b[0], "VP8X")) {
                            if (10 != _$j(L, b[0] + 4)) {
                                _$y = 3;
                                break t;
                            }
                            if (18 > _$y[0]) {
                                _$y = 7;
                                break t;
                            }
                            var _ = _$j(L, b[0] + 8), P = 1 + C(L, b[0] + 12);
                            if (2147483648 <= P * (L = 1 + C(L, b[0] + 15))) {
                                _$y = 3;
                                break t;
                            }
                            null != S && (S[0] = _), null != A && (A[0] = P), null != x && (x[0] = L), b[0] += 18, _$y[0] -= 18, k[0] = 1;
                        }
                        _$y = 0;
                    }
                }
                if (d = d[0], m = m[0], 0 != _$y) return _$y;
                if (b = !!(2 & m), !w && d) return 3;
                if (null != s && (s[0] = !!(16 & m)), null != c && (c[0] = b), null != u && (u[0] = 0), c = l[0], m = f[0], d && b && null == h) {
                    _$y = 0;
                    break;
                }
                if (4 > i) {
                    _$y = 7;
                    break;
                }
                if (w && d || !w && !d && !r(t, n[0], "ALPH")) {
                    i = [
                        i
                    ], g.na = [
                        g.na
                    ], g.P = [
                        g.P
                    ], g.Sa = [
                        g.Sa
                    ];
                    t: {
                        _ = t, _$y = n, w = i;
                        var k = g.gb;
                        A = g.na, x = g.P, S = g.Sa;
                        P = 22, e(null != _), e(null != w), L = _$y[0];
                        var _$I = w[0];
                        for(e(null != A), e(null != S), A[0] = null, x[0] = null, S[0] = 0;;){
                            if (_$y[0] = L, w[0] = _$I, 8 > _$I) {
                                _$y = 7;
                                break t;
                            }
                            var F = _$j(_, L + 4);
                            if (4294967286 < F) {
                                _$y = 3;
                                break t;
                            }
                            var O = 8 + F + 1 & -2;
                            if (P += O, 0 < k && P > k) {
                                _$y = 3;
                                break t;
                            }
                            if (!r(_, L, "VP8 ") || !r(_, L, "VP8L")) {
                                _$y = 0;
                                break t;
                            }
                            if (_$I[0] < O) {
                                _$y = 7;
                                break t;
                            }
                            r(_, L, "ALPH") || (A[0] = _, x[0] = L + 8, S[0] = F), L += O, _$I -= O;
                        }
                    }
                    if (i = i[0], g.na = g.na[0], g.P = g.P[0], g.Sa = g.Sa[0], 0 != _$y) break;
                }
                i = [
                    i
                ], g.Ja = [
                    g.Ja
                ], g.xa = [
                    g.xa
                ];
                t: if (k = t, _$y = n, w = i, A = g.gb[0], x = g.Ja, S = g.xa, _ = _$y[0], L = !r(k, _, "VP8 "), P = !r(k, _, "VP8L"), e(null != k), e(null != w), e(null != x), e(null != S), 8 > w[0]) _$y = 7;
                else {
                    if (L || P) {
                        if (k = _$j(k, _ + 4), 12 <= A && k > A - 12) {
                            _$y = 3;
                            break t;
                        }
                        if (p && k > w[0] - 8) {
                            _$y = 7;
                            break t;
                        }
                        x[0] = k, _$y[0] += 8, w[0] -= 8, S[0] = P;
                    } else S[0] = 5 <= w[0] && 47 == k[_ + 0] && !(k[_ + 4] >> 5), x[0] = w[0];
                    _$y = 0;
                }
                if (i = i[0], g.Ja = g.Ja[0], g.xa = g.xa[0], n = n[0], 0 != _$y) break;
                if (4294967286 < g.Ja) return 3;
                if (null == u || b || (u[0] = g.xa ? 2 : 1), c = [
                    c
                ], m = [
                    m
                ], g.xa) {
                    if (5 > i) {
                        _$y = 7;
                        break;
                    }
                    u = c, p = m, b = s, null == t || 5 > i ? t = 0 : 5 <= i && 47 == t[n + 0] && !(t[n + 4] >> 5) ? (w = [
                        0
                    ], k = [
                        0
                    ], A = [
                        0
                    ], v(x = new N, t, n, i), gt(x, w, k, A) ? (null != u && (u[0] = w[0]), null != p && (p[0] = k[0]), null != b && (b[0] = A[0]), t = 1) : t = 0) : t = 0;
                } else {
                    if (10 > i) {
                        _$y = 7;
                        break;
                    }
                    u = m, null == t || 10 > i || !Xt(t, n + 3, i - 3) ? t = 0 : (p = t[n + 0] | t[n + 1] << 8 | t[n + 2] << 16, b = 16383 & (t[n + 7] << 8 | t[n + 6]), t = 16383 & (t[n + 9] << 8 | t[n + 8]), 1 & p || 3 < (p >> 1 & 7) || !(p >> 4 & 1) || p >> 5 >= g.Ja || !b || !t ? t = 0 : (c && (c[0] = b), u && (u[0] = t), t = 1));
                }
                if (!t) return 3;
                if (c = c[0], m = m[0], d && (l[0] != c || f[0] != m)) return 3;
                null != h && (h[0] = g, h.offset = n - h.w, e(4294967286 > n - h.w), e(h.offset == h.ha - i));
                break;
            }
            return 0 == _$y || 7 == _$y && d && null == h ? (null != s && (s[0] |= null != g.na && 0 < g.na.length), null != a && (a[0] = c), null != o && (o[0] = m), 0) : _$y;
        };
        var Mr = function Mr(t, e, r) {
            var n = e.width, _$i = e.height, a = 0, o = 0, s = n, c = _$i;
            if (e.Da = null != t && 0 < t.Da, e.Da && (s = t.cd, c = t.bd, a = t.v, o = t.j, 11 > r || (a &= -2, o &= -2), 0 > a || 0 > o || 0 >= s || 0 >= c || a + s > n || o + c > _$i)) return 0;
            if (e.v = a, e.j = o, e.va = a + s, e.o = o + c, e.U = s, e.T = c, e.da = null != t && 0 < t.da, e.da) {
                if (!_$E(s, c, r = [
                    t.ib
                ], a = [
                    t.hb
                ])) return 0;
                e.ib = r[0], e.hb = a[0];
            }
            return e.ob = null != t && t.ob, e.Kb = null == t || !t.Sd, e.da && (e.ob = e.ib < 3 * n / 4 && e.hb < 3 * _$i / 4, e.Kb = 0), 1;
        };
        var Er = function Er(t) {
            if (null == t) return 2;
            if (11 > t.S) {
                var e = t.f.RGBA;
                e.fb += (t.height - 1) * e.A, e.A = -e.A;
            } else e = t.f.kb, t = t.height, e.O += (t - 1) * e.fa, e.fa = -e.fa, e.N += (t - 1 >> 1) * e.Ab, e.Ab = -e.Ab, e.W += (t - 1 >> 1) * e.Db, e.Db = -e.Db, null != e.F && (e.J += (t - 1) * e.lb, e.lb = -e.lb);
            return 0;
        };
        var qr = function qr(t, e, r, n) {
            if (null == n || 0 >= t || 0 >= e) return 2;
            if (null != r) {
                if (r.Da) {
                    var _$i = r.cd, o = r.bd, s = -2 & r.v, c = -2 & r.j;
                    if (0 > s || 0 > c || 0 >= _$i || 0 >= o || s + _$i > t || c + o > e) return 2;
                    t = _$i, e = o;
                }
                if (r.da) {
                    if (!_$E(t, e, _$i = [
                        r.ib
                    ], o = [
                        r.hb
                    ])) return 2;
                    t = _$i[0], e = o[0];
                }
            }
            n.width = t, n.height = e;
            t: {
                var u = n.width, h = n.height;
                if (t = n.S, 0 >= u || 0 >= h || !(t >= En && 13 > t)) t = 2;
                else {
                    if (0 >= n.Rd && null == n.sd) {
                        s = o = _$i = e = 0;
                        var l = (c = u * zi[t]) * h;
                        if (11 > t || (o = (h + 1) / 2 * (e = (u + 1) / 2), 12 == t && (s = (_$i = u) * h)), null == (h = a(l + 2 * o + s))) {
                            t = 1;
                            break t;
                        }
                        n.sd = h, 11 > t ? ((u = n.f.RGBA).eb = h, u.fb = 0, u.A = c, u.size = l) : ((u = n.f.kb).y = h, u.O = 0, u.fa = c, u.Fd = l, u.f = h, u.N = 0 + l, u.Ab = e, u.Cd = o, u.ea = h, u.W = 0 + l + o, u.Db = e, u.Ed = o, 12 == t && (u.F = h, u.J = 0 + l + 2 * o), u.Tc = s, u.lb = _$i);
                    }
                    if (e = 1, _$i = n.S, o = n.width, s = n.height, _$i >= En && 13 > _$i) {
                        if (11 > _$i) t = n.f.RGBA, e &= (c = Math.abs(t.A)) * (s - 1) + o <= t.size, e &= c >= o * zi[_$i], e &= null != t.eb;
                        else {
                            t = n.f.kb, c = (o + 1) / 2, l = (s + 1) / 2, u = Math.abs(t.fa);
                            h = Math.abs(t.Ab);
                            var f = Math.abs(t.Db), d = Math.abs(t.lb), p = d * (s - 1) + o;
                            e &= u * (s - 1) + o <= t.Fd, e &= h * (l - 1) + c <= t.Cd, e = (e &= f * (l - 1) + c <= t.Ed) & u >= o & h >= c & f >= c, e &= null != t.y, e &= null != t.f, e &= null != t.ea, 12 == _$i && (e &= d >= o, e &= p <= t.Tc, e &= null != t.F);
                        }
                    } else e = 0;
                    t = e ? 0 : 2;
                }
            }
            return 0 != t || null != r && r.fd && (t = Er(n)), t;
        };
        var _$t = this;
        function It(t, r, n, s, c) {
            var u = 1, f = [
                t
            ], p = [
                r
            ], g = s.m, m = s.s, v = null, b = 0;
            t: for(;;){
                if (n) for(; u && _$y(g, 1);){
                    var w = f, N = p, A = s, _ = 1, P = A.m, k = A.gc[A.ab], _$I = _$y(P, 2);
                    if (A.Oc & 1 << _$I) u = 0;
                    else {
                        switch(A.Oc |= 1 << _$I, k.hc = _$I, k.Ea = w[0], k.nc = N[0], k.K = [
                            null
                        ], ++A.ab, e(4 >= A.ab), _$I){
                            case 0:
                            case 1:
                                k.b = _$y(P, 3) + 2, _ = It(q(k.Ea, k.b), q(k.nc, k.b), 0, A, k.K), k.K = k.K[0];
                                break;
                            case 3:
                                var F, C = _$y(P, 8) + 1, _$j = 16 < C ? 0 : 4 < C ? 1 : 2 < C ? 2 : 3;
                                if (w[0] = q(k.Ea, _$j), k.b = _$j, F = _ = It(C, 1, 0, A, k.K)) {
                                    var B, M = C, _$E = k, R = 1 << (8 >> _$E.b), T = a(R);
                                    if (null == T) F = 0;
                                    else {
                                        var U = _$E.K[0], z = _$E.w;
                                        for(T[0] = _$E.K[0][0], B = 1; B < 1 * M; ++B)T[B] = D(U[z + B], T[B - 1]);
                                        for(; B < 4 * R; ++B)T[B] = 0;
                                        _$E.K[0] = null, _$E.K[0] = T, F = 1;
                                    }
                                }
                                _ = F;
                                break;
                            case 2:
                                break;
                            default:
                                e(0);
                        }
                        u = _;
                    }
                }
                if (f = f[0], p = p[0], u && _$y(g, 1) && !(u = 1 <= (b = _$y(g, 4)) && 11 >= b)) {
                    s.a = 3;
                    break t;
                }
                var H;
                if (H = u) e: {
                    var W, V, G, Y = s, J = f, X = p, K = b, Z = n, $ = Y.m, Q = Y.s, tt = [
                        null
                    ], et = 1, rt = 0, nt = Qn[K];
                    r: for(;;){
                        if (Z && _$y($, 1)) {
                            var it = _$y($, 3) + 2, at = q(J, it), ot = q(X, it), st = at * ot;
                            if (!It(at, ot, 0, Y, tt)) break r;
                            for(tt = tt[0], Q.xc = it, W = 0; W < st; ++W){
                                var ct = tt[W] >> 8 & 65535;
                                tt[W] = ct, ct >= et && (et = ct + 1);
                            }
                        }
                        if ($.h) break r;
                        for(V = 0; 5 > V; ++V){
                            var ut = Xn[V];
                            !V && 0 < K && (ut += 1 << K), rt < ut && (rt = ut);
                        }
                        var ht = o(et * nt, l), lt = et, ft = o(lt, d);
                        if (null == ft) var dt = null;
                        else e(65536 >= lt), dt = ft;
                        var pt = a(rt);
                        if (null == dt || null == pt || null == ht) {
                            Y.a = 1;
                            break r;
                        }
                        var gt = ht;
                        for(W = G = 0; W < et; ++W){
                            var mt = dt[W], vt = mt.G, bt = mt.H, wt = 0, Nt = 1, Lt = 0;
                            for(V = 0; 5 > V; ++V){
                                ut = Xn[V], vt[V] = gt, bt[V] = G, !V && 0 < K && (ut += 1 << K);
                                n: {
                                    var At, xt = ut, St = Y, kt = pt, Ft = gt, Ct = G, jt = 0, Ot = St.m, Bt = _$y(Ot, 1);
                                    if (_$i(kt, 0, 0, xt), Bt) {
                                        var Mt = _$y(Ot, 1) + 1, Et = _$y(Ot, 1), qt = _$y(Ot, 0 == Et ? 1 : 8);
                                        kt[qt] = 1, 2 == Mt && (kt[qt = _$y(Ot, 8)] = 1);
                                        var Dt = 1;
                                    } else {
                                        var Rt = a(19), Tt = _$y(Ot, 4) + 4;
                                        if (19 < Tt) {
                                            St.a = 3;
                                            var Ut = 0;
                                            break n;
                                        }
                                        for(At = 0; At < Tt; ++At)Rt[Zn[At]] = _$y(Ot, 3);
                                        var zt = void 0, Ht = void 0, Wt = St, Vt = Rt, Gt = xt, Yt = kt, Jt = 0, Xt = Wt.m, Kt = 8, Zt = o(128, l);
                                        i: for(; h(Zt, 0, 7, Vt, 19);){
                                            if (_$y(Xt, 1)) {
                                                var $t = 2 + 2 * _$y(Xt, 3);
                                                if ((zt = 2 + _$y(Xt, $t)) > Gt) break i;
                                            } else zt = Gt;
                                            for(Ht = 0; Ht < Gt && zt--;){
                                                S(Xt);
                                                var Qt = Zt[0 + (127 & L(Xt))];
                                                x(Xt, Xt.u + Qt.g);
                                                var _$te = Qt.value;
                                                if (16 > _$te) Yt[Ht++] = _$te, 0 != _$te && (Kt = _$te);
                                                else {
                                                    var _$ee = 16 == _$te, re = _$te - 16, ne = Jn[re], ie = _$y(Xt, Yn[re]) + ne;
                                                    if (Ht + ie > Gt) break i;
                                                    for(var ae = _$ee ? Kt : 0; 0 < ie--;)Yt[Ht++] = ae;
                                                }
                                            }
                                            Jt = 1;
                                            break i;
                                        }
                                        Jt || (Wt.a = 3), Dt = Jt;
                                    }
                                    (Dt = Dt && !Ot.h) && (jt = h(Ft, Ct, 8, kt, xt)), Dt && 0 != jt ? Ut = jt : (St.a = 3, Ut = 0);
                                }
                                if (0 == Ut) break r;
                                if (Nt && 1 == Kn[V] && (Nt = 0 == gt[G].g), wt += gt[G].g, G += Ut, 3 >= V) {
                                    var oe, se = pt[0];
                                    for(oe = 1; oe < ut; ++oe)pt[oe] > se && (se = pt[oe]);
                                    Lt += se;
                                }
                            }
                            if (mt.nd = Nt, mt.Qb = 0, Nt && (mt.qb = (vt[3][bt[3] + 0].value << 24 | vt[1][bt[1] + 0].value << 16 | vt[2][bt[2] + 0].value) >>> 0, 0 == wt && 256 > vt[0][bt[0] + 0].value && (mt.Qb = 1, mt.qb += vt[0][bt[0] + 0].value << 8)), mt.jc = !mt.Qb && 6 > Lt, mt.jc) {
                                var ce, ue = mt;
                                for(ce = 0; ce < Dr; ++ce){
                                    var he = ce, le = ue.pd[he], fe = ue.G[0][ue.H[0] + he];
                                    256 <= fe.value ? (le.g = fe.g + 256, le.value = fe.value) : (le.g = 0, le.value = 0, he >>= yt(fe, 8, le), he >>= yt(ue.G[1][ue.H[1] + he], 16, le), he >>= yt(ue.G[2][ue.H[2] + he], 0, le), yt(ue.G[3][ue.H[3] + he], 24, le));
                                }
                            }
                        }
                        Q.vc = tt, Q.Wb = et, Q.Ya = dt, Q.yc = ht, H = 1;
                        break e;
                    }
                    H = 0;
                }
                if (!(u = H)) {
                    s.a = 3;
                    break t;
                }
                if (0 < b) {
                    if (m.ua = 1 << b, !O(m.Wa, b)) {
                        s.a = 1, u = 0;
                        break t;
                    }
                } else m.ua = 0;
                var de = s, pe = f, ge = p, me = de.s, ve = me.xc;
                if (de.c = pe, de.i = ge, me.md = q(pe, ve), me.wc = 0 == ve ? -1 : (1 << ve) - 1, n) {
                    s.xb = pi;
                    break t;
                }
                if (null == (v = a(f * p))) {
                    s.a = 1, u = 0;
                    break t;
                }
                u = (u = _$_t(s, v, 0, f, p, p, null)) && !g.h;
                break t;
            }
            return u ? (null != c ? c[0] = v : (e(null == v), e(n)), s.$ = 0, n || Pt(m)) : Pt(m), u;
        }
        var Dr = 64, Rr = [
            0,
            1,
            3,
            7,
            15,
            31,
            63,
            127,
            255,
            511,
            1023,
            2047,
            4095,
            8191,
            16383,
            32767,
            65535,
            131071,
            262143,
            524287,
            1048575,
            2097151,
            4194303,
            8388607,
            16777215
        ], Tr = 24, Ur = 32, zr = 8, Hr = [
            0,
            0,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7,
            7
        ];
        R("Predictor0", "PredictorAdd0"), _$t.Predictor0 = function() {
            return 4278190080;
        }, _$t.Predictor1 = function(t) {
            return t;
        }, _$t.Predictor2 = function(t, e, r) {
            return e[r + 0];
        }, _$t.Predictor3 = function(t, e, r) {
            return e[r + 1];
        }, _$t.Predictor4 = function(t, e, r) {
            return e[r - 1];
        }, _$t.Predictor5 = function(t, e, r) {
            return U(U(t, e[r + 1]), e[r + 0]);
        }, _$t.Predictor6 = function(t, e, r) {
            return U(t, e[r - 1]);
        }, _$t.Predictor7 = function(t, e, r) {
            return U(t, e[r + 0]);
        }, _$t.Predictor8 = function(t, e, r) {
            return U(e[r - 1], e[r + 0]);
        }, _$t.Predictor9 = function(t, e, r) {
            return U(e[r + 0], e[r + 1]);
        }, _$t.Predictor10 = function(t, e, r) {
            return U(U(t, e[r - 1]), U(e[r + 0], e[r + 1]));
        }, _$t.Predictor11 = function(t, e, r) {
            var n = e[r + 0];
            return 0 >= W(n >> 24 & 255, t >> 24 & 255, (e = e[r - 1]) >> 24 & 255) + W(n >> 16 & 255, t >> 16 & 255, e >> 16 & 255) + W(n >> 8 & 255, t >> 8 & 255, e >> 8 & 255) + W(255 & n, 255 & t, 255 & e) ? n : t;
        }, _$t.Predictor12 = function(t, e, r) {
            var n = e[r + 0];
            return (z((t >> 24 & 255) + (n >> 24 & 255) - ((e = e[r - 1]) >> 24 & 255)) << 24 | z((t >> 16 & 255) + (n >> 16 & 255) - (e >> 16 & 255)) << 16 | z((t >> 8 & 255) + (n >> 8 & 255) - (e >> 8 & 255)) << 8 | z((255 & t) + (255 & n) - (255 & e))) >>> 0;
        }, _$t.Predictor13 = function(t, e, r) {
            var n = e[r - 1];
            return (H((t = U(t, e[r + 0])) >> 24 & 255, n >> 24 & 255) << 24 | H(t >> 16 & 255, n >> 16 & 255) << 16 | H(t >> 8 & 255, n >> 8 & 255) << 8 | H(t >> 0 & 255, n >> 0 & 255)) >>> 0;
        };
        var Wr = _$t.PredictorAdd0;
        _$t.PredictorAdd1 = V, R("Predictor2", "PredictorAdd2"), R("Predictor3", "PredictorAdd3"), R("Predictor4", "PredictorAdd4"), R("Predictor5", "PredictorAdd5"), R("Predictor6", "PredictorAdd6"), R("Predictor7", "PredictorAdd7"), R("Predictor8", "PredictorAdd8"), R("Predictor9", "PredictorAdd9"), R("Predictor10", "PredictorAdd10"), R("Predictor11", "PredictorAdd11"), R("Predictor12", "PredictorAdd12"), R("Predictor13", "PredictorAdd13");
        var Vr = _$t.PredictorAdd2;
        X("ColorIndexInverseTransform", "MapARGB", "32b", function(t) {
            return t >> 8 & 255;
        }, function(t) {
            return t;
        }), X("VP8LColorIndexInverseTransformAlpha", "MapAlpha", "8b", function(t) {
            return t;
        }, function(t) {
            return t >> 8 & 255;
        });
        var Gr, Yr = _$t.ColorIndexInverseTransform, Jr = _$t.MapARGB, Xr = _$t.VP8LColorIndexInverseTransformAlpha, Kr = _$t.MapAlpha, Zr = _$t.VP8LPredictorsAdd = [];
        Zr.length = 16, (_$t.VP8LPredictors = []).length = 16, (_$t.VP8LPredictorsAdd_C = []).length = 16, (_$t.VP8LPredictors_C = []).length = 16;
        var $r, Qr, tn, en, rn, nn, an, on, sn, cn, un, hn, ln, fn, dn, pn, gn, mn, vn, bn, yn, wn, Nn, Ln, An, xn, Sn, _n, Pn = a(511), kn = a(2041), In = a(225), Fn = a(767), Cn = 0, jn = kn, On = In, Bn = Fn, Mn = Pn, En = 0, qn = 1, Dn = 2, Rn = 3, Tn = 4, Un = 5, zn = 6, Hn = 7, Wn = 8, Vn = 9, Gn = 10, Yn = [
            2,
            3,
            7
        ], Jn = [
            3,
            3,
            11
        ], Xn = [
            280,
            256,
            256,
            256,
            40
        ], Kn = [
            0,
            1,
            1,
            1,
            0
        ], Zn = [
            17,
            18,
            0,
            1,
            2,
            3,
            4,
            5,
            16,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15
        ], $n = [
            24,
            7,
            23,
            25,
            40,
            6,
            39,
            41,
            22,
            26,
            38,
            42,
            56,
            5,
            55,
            57,
            21,
            27,
            54,
            58,
            37,
            43,
            72,
            4,
            71,
            73,
            20,
            28,
            53,
            59,
            70,
            74,
            36,
            44,
            88,
            69,
            75,
            52,
            60,
            3,
            87,
            89,
            19,
            29,
            86,
            90,
            35,
            45,
            68,
            76,
            85,
            91,
            51,
            61,
            104,
            2,
            103,
            105,
            18,
            30,
            102,
            106,
            34,
            46,
            84,
            92,
            67,
            77,
            101,
            107,
            50,
            62,
            120,
            1,
            119,
            121,
            83,
            93,
            17,
            31,
            100,
            108,
            66,
            78,
            118,
            122,
            33,
            47,
            117,
            123,
            49,
            63,
            99,
            109,
            82,
            94,
            0,
            116,
            124,
            65,
            79,
            16,
            32,
            98,
            110,
            48,
            115,
            125,
            81,
            95,
            64,
            114,
            126,
            97,
            111,
            80,
            113,
            127,
            96,
            112
        ], Qn = [
            2954,
            2956,
            2958,
            2962,
            2970,
            2986,
            3018,
            3082,
            3212,
            3468,
            3980,
            5004
        ], ti = 8, ei = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            17,
            18,
            19,
            20,
            20,
            21,
            21,
            22,
            22,
            23,
            23,
            24,
            25,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            59,
            60,
            61,
            62,
            63,
            64,
            65,
            66,
            67,
            68,
            69,
            70,
            71,
            72,
            73,
            74,
            75,
            76,
            76,
            77,
            78,
            79,
            80,
            81,
            82,
            83,
            84,
            85,
            86,
            87,
            88,
            89,
            91,
            93,
            95,
            96,
            98,
            100,
            101,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            118,
            122,
            124,
            126,
            128,
            130,
            132,
            134,
            136,
            138,
            140,
            143,
            145,
            148,
            151,
            154,
            157
        ], ri = [
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26,
            27,
            28,
            29,
            30,
            31,
            32,
            33,
            34,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            44,
            45,
            46,
            47,
            48,
            49,
            50,
            51,
            52,
            53,
            54,
            55,
            56,
            57,
            58,
            60,
            62,
            64,
            66,
            68,
            70,
            72,
            74,
            76,
            78,
            80,
            82,
            84,
            86,
            88,
            90,
            92,
            94,
            96,
            98,
            100,
            102,
            104,
            106,
            108,
            110,
            112,
            114,
            116,
            119,
            122,
            125,
            128,
            131,
            134,
            137,
            140,
            143,
            146,
            149,
            152,
            155,
            158,
            161,
            164,
            167,
            170,
            173,
            177,
            181,
            185,
            189,
            193,
            197,
            201,
            205,
            209,
            213,
            217,
            221,
            225,
            229,
            234,
            239,
            245,
            249,
            254,
            259,
            264,
            269,
            274,
            279,
            284
        ], ni = null, ii = [
            [
                173,
                148,
                140,
                0
            ],
            [
                176,
                155,
                140,
                135,
                0
            ],
            [
                180,
                157,
                141,
                134,
                130,
                0
            ],
            [
                254,
                254,
                243,
                230,
                196,
                177,
                153,
                140,
                133,
                130,
                129,
                0
            ]
        ], ai = [
            0,
            1,
            4,
            8,
            5,
            2,
            3,
            6,
            9,
            12,
            13,
            10,
            7,
            11,
            14,
            15
        ], oi = [
            -0,
            1,
            -1,
            2,
            -2,
            3,
            4,
            6,
            -3,
            5,
            -4,
            -5,
            -6,
            7,
            -7,
            8,
            -8,
            -9
        ], si = [
            [
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        253,
                        136,
                        254,
                        255,
                        228,
                        219,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        189,
                        129,
                        242,
                        255,
                        227,
                        213,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        106,
                        126,
                        227,
                        252,
                        214,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        98,
                        248,
                        255,
                        236,
                        226,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        181,
                        133,
                        238,
                        254,
                        221,
                        234,
                        255,
                        154,
                        128,
                        128,
                        128
                    ],
                    [
                        78,
                        134,
                        202,
                        247,
                        198,
                        180,
                        255,
                        219,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        185,
                        249,
                        255,
                        243,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        150,
                        247,
                        255,
                        236,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        77,
                        110,
                        216,
                        255,
                        236,
                        230,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        101,
                        251,
                        255,
                        241,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        170,
                        139,
                        241,
                        252,
                        236,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        37,
                        116,
                        196,
                        243,
                        228,
                        255,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        204,
                        254,
                        255,
                        245,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        207,
                        160,
                        250,
                        255,
                        238,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        102,
                        103,
                        231,
                        255,
                        211,
                        171,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        152,
                        252,
                        255,
                        240,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        177,
                        135,
                        243,
                        255,
                        234,
                        225,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        80,
                        129,
                        211,
                        255,
                        194,
                        224,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        246,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        198,
                        35,
                        237,
                        223,
                        193,
                        187,
                        162,
                        160,
                        145,
                        155,
                        62
                    ],
                    [
                        131,
                        45,
                        198,
                        221,
                        172,
                        176,
                        220,
                        157,
                        252,
                        221,
                        1
                    ],
                    [
                        68,
                        47,
                        146,
                        208,
                        149,
                        167,
                        221,
                        162,
                        255,
                        223,
                        128
                    ]
                ],
                [
                    [
                        1,
                        149,
                        241,
                        255,
                        221,
                        224,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        184,
                        141,
                        234,
                        253,
                        222,
                        220,
                        255,
                        199,
                        128,
                        128,
                        128
                    ],
                    [
                        81,
                        99,
                        181,
                        242,
                        176,
                        190,
                        249,
                        202,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        129,
                        232,
                        253,
                        214,
                        197,
                        242,
                        196,
                        255,
                        255,
                        128
                    ],
                    [
                        99,
                        121,
                        210,
                        250,
                        201,
                        198,
                        255,
                        202,
                        128,
                        128,
                        128
                    ],
                    [
                        23,
                        91,
                        163,
                        242,
                        170,
                        187,
                        247,
                        210,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        200,
                        246,
                        255,
                        234,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        109,
                        178,
                        241,
                        255,
                        231,
                        245,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        44,
                        130,
                        201,
                        253,
                        205,
                        192,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        132,
                        239,
                        251,
                        219,
                        209,
                        255,
                        165,
                        128,
                        128,
                        128
                    ],
                    [
                        94,
                        136,
                        225,
                        251,
                        218,
                        190,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        22,
                        100,
                        174,
                        245,
                        186,
                        161,
                        255,
                        199,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        249,
                        255,
                        232,
                        235,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        124,
                        143,
                        241,
                        255,
                        227,
                        234,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        35,
                        77,
                        181,
                        251,
                        193,
                        211,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        157,
                        247,
                        255,
                        236,
                        231,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        121,
                        141,
                        235,
                        255,
                        225,
                        227,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        45,
                        99,
                        188,
                        251,
                        195,
                        217,
                        255,
                        224,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        251,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        203,
                        1,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        137,
                        1,
                        177,
                        255,
                        224,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        253,
                        9,
                        248,
                        251,
                        207,
                        208,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        175,
                        13,
                        224,
                        243,
                        193,
                        185,
                        249,
                        198,
                        255,
                        255,
                        128
                    ],
                    [
                        73,
                        17,
                        171,
                        221,
                        161,
                        179,
                        236,
                        167,
                        255,
                        234,
                        128
                    ]
                ],
                [
                    [
                        1,
                        95,
                        247,
                        253,
                        212,
                        183,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        239,
                        90,
                        244,
                        250,
                        211,
                        209,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        155,
                        77,
                        195,
                        248,
                        188,
                        195,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        24,
                        239,
                        251,
                        218,
                        219,
                        255,
                        205,
                        128,
                        128,
                        128
                    ],
                    [
                        201,
                        51,
                        219,
                        255,
                        196,
                        186,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        69,
                        46,
                        190,
                        239,
                        201,
                        218,
                        255,
                        228,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        191,
                        251,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        223,
                        165,
                        249,
                        255,
                        213,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        124,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        16,
                        248,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        190,
                        36,
                        230,
                        255,
                        236,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        226,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        247,
                        192,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        240,
                        128,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        134,
                        252,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        213,
                        62,
                        250,
                        255,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        55,
                        93,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ],
            [
                [
                    [
                        202,
                        24,
                        213,
                        235,
                        186,
                        191,
                        220,
                        160,
                        240,
                        175,
                        255
                    ],
                    [
                        126,
                        38,
                        182,
                        232,
                        169,
                        184,
                        228,
                        174,
                        255,
                        187,
                        128
                    ],
                    [
                        61,
                        46,
                        138,
                        219,
                        151,
                        178,
                        240,
                        170,
                        255,
                        216,
                        128
                    ]
                ],
                [
                    [
                        1,
                        112,
                        230,
                        250,
                        199,
                        191,
                        247,
                        159,
                        255,
                        255,
                        128
                    ],
                    [
                        166,
                        109,
                        228,
                        252,
                        211,
                        215,
                        255,
                        174,
                        128,
                        128,
                        128
                    ],
                    [
                        39,
                        77,
                        162,
                        232,
                        172,
                        180,
                        245,
                        178,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        52,
                        220,
                        246,
                        198,
                        199,
                        249,
                        220,
                        255,
                        255,
                        128
                    ],
                    [
                        124,
                        74,
                        191,
                        243,
                        183,
                        193,
                        250,
                        221,
                        255,
                        255,
                        128
                    ],
                    [
                        24,
                        71,
                        130,
                        219,
                        154,
                        170,
                        243,
                        182,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        182,
                        225,
                        249,
                        219,
                        240,
                        255,
                        224,
                        128,
                        128,
                        128
                    ],
                    [
                        149,
                        150,
                        226,
                        252,
                        216,
                        205,
                        255,
                        171,
                        128,
                        128,
                        128
                    ],
                    [
                        28,
                        108,
                        170,
                        242,
                        183,
                        194,
                        254,
                        223,
                        255,
                        255,
                        128
                    ]
                ],
                [
                    [
                        1,
                        81,
                        230,
                        252,
                        204,
                        203,
                        255,
                        192,
                        128,
                        128,
                        128
                    ],
                    [
                        123,
                        102,
                        209,
                        247,
                        188,
                        196,
                        255,
                        233,
                        128,
                        128,
                        128
                    ],
                    [
                        20,
                        95,
                        153,
                        243,
                        164,
                        173,
                        255,
                        203,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        222,
                        248,
                        255,
                        216,
                        213,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        168,
                        175,
                        246,
                        252,
                        235,
                        205,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        47,
                        116,
                        215,
                        255,
                        211,
                        212,
                        255,
                        255,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        121,
                        236,
                        253,
                        212,
                        214,
                        255,
                        255,
                        128,
                        128,
                        128
                    ],
                    [
                        141,
                        84,
                        213,
                        252,
                        201,
                        202,
                        255,
                        219,
                        128,
                        128,
                        128
                    ],
                    [
                        42,
                        80,
                        160,
                        240,
                        162,
                        185,
                        255,
                        205,
                        128,
                        128,
                        128
                    ]
                ],
                [
                    [
                        1,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        244,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ],
                    [
                        238,
                        1,
                        255,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128,
                        128
                    ]
                ]
            ]
        ], ci = [
            [
                [
                    231,
                    120,
                    48,
                    89,
                    115,
                    113,
                    120,
                    152,
                    112
                ],
                [
                    152,
                    179,
                    64,
                    126,
                    170,
                    118,
                    46,
                    70,
                    95
                ],
                [
                    175,
                    69,
                    143,
                    80,
                    85,
                    82,
                    72,
                    155,
                    103
                ],
                [
                    56,
                    58,
                    10,
                    171,
                    218,
                    189,
                    17,
                    13,
                    152
                ],
                [
                    114,
                    26,
                    17,
                    163,
                    44,
                    195,
                    21,
                    10,
                    173
                ],
                [
                    121,
                    24,
                    80,
                    195,
                    26,
                    62,
                    44,
                    64,
                    85
                ],
                [
                    144,
                    71,
                    10,
                    38,
                    171,
                    213,
                    144,
                    34,
                    26
                ],
                [
                    170,
                    46,
                    55,
                    19,
                    136,
                    160,
                    33,
                    206,
                    71
                ],
                [
                    63,
                    20,
                    8,
                    114,
                    114,
                    208,
                    12,
                    9,
                    226
                ],
                [
                    81,
                    40,
                    11,
                    96,
                    182,
                    84,
                    29,
                    16,
                    36
                ]
            ],
            [
                [
                    134,
                    183,
                    89,
                    137,
                    98,
                    101,
                    106,
                    165,
                    148
                ],
                [
                    72,
                    187,
                    100,
                    130,
                    157,
                    111,
                    32,
                    75,
                    80
                ],
                [
                    66,
                    102,
                    167,
                    99,
                    74,
                    62,
                    40,
                    234,
                    128
                ],
                [
                    41,
                    53,
                    9,
                    178,
                    241,
                    141,
                    26,
                    8,
                    107
                ],
                [
                    74,
                    43,
                    26,
                    146,
                    73,
                    166,
                    49,
                    23,
                    157
                ],
                [
                    65,
                    38,
                    105,
                    160,
                    51,
                    52,
                    31,
                    115,
                    128
                ],
                [
                    104,
                    79,
                    12,
                    27,
                    217,
                    255,
                    87,
                    17,
                    7
                ],
                [
                    87,
                    68,
                    71,
                    44,
                    114,
                    51,
                    15,
                    186,
                    23
                ],
                [
                    47,
                    41,
                    14,
                    110,
                    182,
                    183,
                    21,
                    17,
                    194
                ],
                [
                    66,
                    45,
                    25,
                    102,
                    197,
                    189,
                    23,
                    18,
                    22
                ]
            ],
            [
                [
                    88,
                    88,
                    147,
                    150,
                    42,
                    46,
                    45,
                    196,
                    205
                ],
                [
                    43,
                    97,
                    183,
                    117,
                    85,
                    38,
                    35,
                    179,
                    61
                ],
                [
                    39,
                    53,
                    200,
                    87,
                    26,
                    21,
                    43,
                    232,
                    171
                ],
                [
                    56,
                    34,
                    51,
                    104,
                    114,
                    102,
                    29,
                    93,
                    77
                ],
                [
                    39,
                    28,
                    85,
                    171,
                    58,
                    165,
                    90,
                    98,
                    64
                ],
                [
                    34,
                    22,
                    116,
                    206,
                    23,
                    34,
                    43,
                    166,
                    73
                ],
                [
                    107,
                    54,
                    32,
                    26,
                    51,
                    1,
                    81,
                    43,
                    31
                ],
                [
                    68,
                    25,
                    106,
                    22,
                    64,
                    171,
                    36,
                    225,
                    114
                ],
                [
                    34,
                    19,
                    21,
                    102,
                    132,
                    188,
                    16,
                    76,
                    124
                ],
                [
                    62,
                    18,
                    78,
                    95,
                    85,
                    57,
                    50,
                    48,
                    51
                ]
            ],
            [
                [
                    193,
                    101,
                    35,
                    159,
                    215,
                    111,
                    89,
                    46,
                    111
                ],
                [
                    60,
                    148,
                    31,
                    172,
                    219,
                    228,
                    21,
                    18,
                    111
                ],
                [
                    112,
                    113,
                    77,
                    85,
                    179,
                    255,
                    38,
                    120,
                    114
                ],
                [
                    40,
                    42,
                    1,
                    196,
                    245,
                    209,
                    10,
                    25,
                    109
                ],
                [
                    88,
                    43,
                    29,
                    140,
                    166,
                    213,
                    37,
                    43,
                    154
                ],
                [
                    61,
                    63,
                    30,
                    155,
                    67,
                    45,
                    68,
                    1,
                    209
                ],
                [
                    100,
                    80,
                    8,
                    43,
                    154,
                    1,
                    51,
                    26,
                    71
                ],
                [
                    142,
                    78,
                    78,
                    16,
                    255,
                    128,
                    34,
                    197,
                    171
                ],
                [
                    41,
                    40,
                    5,
                    102,
                    211,
                    183,
                    4,
                    1,
                    221
                ],
                [
                    51,
                    50,
                    17,
                    168,
                    209,
                    192,
                    23,
                    25,
                    82
                ]
            ],
            [
                [
                    138,
                    31,
                    36,
                    171,
                    27,
                    166,
                    38,
                    44,
                    229
                ],
                [
                    67,
                    87,
                    58,
                    169,
                    82,
                    115,
                    26,
                    59,
                    179
                ],
                [
                    63,
                    59,
                    90,
                    180,
                    59,
                    166,
                    93,
                    73,
                    154
                ],
                [
                    40,
                    40,
                    21,
                    116,
                    143,
                    209,
                    34,
                    39,
                    175
                ],
                [
                    47,
                    15,
                    16,
                    183,
                    34,
                    223,
                    49,
                    45,
                    183
                ],
                [
                    46,
                    17,
                    33,
                    183,
                    6,
                    98,
                    15,
                    32,
                    183
                ],
                [
                    57,
                    46,
                    22,
                    24,
                    128,
                    1,
                    54,
                    17,
                    37
                ],
                [
                    65,
                    32,
                    73,
                    115,
                    28,
                    128,
                    23,
                    128,
                    205
                ],
                [
                    40,
                    3,
                    9,
                    115,
                    51,
                    192,
                    18,
                    6,
                    223
                ],
                [
                    87,
                    37,
                    9,
                    115,
                    59,
                    77,
                    64,
                    21,
                    47
                ]
            ],
            [
                [
                    104,
                    55,
                    44,
                    218,
                    9,
                    54,
                    53,
                    130,
                    226
                ],
                [
                    64,
                    90,
                    70,
                    205,
                    40,
                    41,
                    23,
                    26,
                    57
                ],
                [
                    54,
                    57,
                    112,
                    184,
                    5,
                    41,
                    38,
                    166,
                    213
                ],
                [
                    30,
                    34,
                    26,
                    133,
                    152,
                    116,
                    10,
                    32,
                    134
                ],
                [
                    39,
                    19,
                    53,
                    221,
                    26,
                    114,
                    32,
                    73,
                    255
                ],
                [
                    31,
                    9,
                    65,
                    234,
                    2,
                    15,
                    1,
                    118,
                    73
                ],
                [
                    75,
                    32,
                    12,
                    51,
                    192,
                    255,
                    160,
                    43,
                    51
                ],
                [
                    88,
                    31,
                    35,
                    67,
                    102,
                    85,
                    55,
                    186,
                    85
                ],
                [
                    56,
                    21,
                    23,
                    111,
                    59,
                    205,
                    45,
                    37,
                    192
                ],
                [
                    55,
                    38,
                    70,
                    124,
                    73,
                    102,
                    1,
                    34,
                    98
                ]
            ],
            [
                [
                    125,
                    98,
                    42,
                    88,
                    104,
                    85,
                    117,
                    175,
                    82
                ],
                [
                    95,
                    84,
                    53,
                    89,
                    128,
                    100,
                    113,
                    101,
                    45
                ],
                [
                    75,
                    79,
                    123,
                    47,
                    51,
                    128,
                    81,
                    171,
                    1
                ],
                [
                    57,
                    17,
                    5,
                    71,
                    102,
                    57,
                    53,
                    41,
                    49
                ],
                [
                    38,
                    33,
                    13,
                    121,
                    57,
                    73,
                    26,
                    1,
                    85
                ],
                [
                    41,
                    10,
                    67,
                    138,
                    77,
                    110,
                    90,
                    47,
                    114
                ],
                [
                    115,
                    21,
                    2,
                    10,
                    102,
                    255,
                    166,
                    23,
                    6
                ],
                [
                    101,
                    29,
                    16,
                    10,
                    85,
                    128,
                    101,
                    196,
                    26
                ],
                [
                    57,
                    18,
                    10,
                    102,
                    102,
                    213,
                    34,
                    20,
                    43
                ],
                [
                    117,
                    20,
                    15,
                    36,
                    163,
                    128,
                    68,
                    1,
                    26
                ]
            ],
            [
                [
                    102,
                    61,
                    71,
                    37,
                    34,
                    53,
                    31,
                    243,
                    192
                ],
                [
                    69,
                    60,
                    71,
                    38,
                    73,
                    119,
                    28,
                    222,
                    37
                ],
                [
                    68,
                    45,
                    128,
                    34,
                    1,
                    47,
                    11,
                    245,
                    171
                ],
                [
                    62,
                    17,
                    19,
                    70,
                    146,
                    85,
                    55,
                    62,
                    70
                ],
                [
                    37,
                    43,
                    37,
                    154,
                    100,
                    163,
                    85,
                    160,
                    1
                ],
                [
                    63,
                    9,
                    92,
                    136,
                    28,
                    64,
                    32,
                    201,
                    85
                ],
                [
                    75,
                    15,
                    9,
                    9,
                    64,
                    255,
                    184,
                    119,
                    16
                ],
                [
                    86,
                    6,
                    28,
                    5,
                    64,
                    255,
                    25,
                    248,
                    1
                ],
                [
                    56,
                    8,
                    17,
                    132,
                    137,
                    255,
                    55,
                    116,
                    128
                ],
                [
                    58,
                    15,
                    20,
                    82,
                    135,
                    57,
                    26,
                    121,
                    40
                ]
            ],
            [
                [
                    164,
                    50,
                    31,
                    137,
                    154,
                    133,
                    25,
                    35,
                    218
                ],
                [
                    51,
                    103,
                    44,
                    131,
                    131,
                    123,
                    31,
                    6,
                    158
                ],
                [
                    86,
                    40,
                    64,
                    135,
                    148,
                    224,
                    45,
                    183,
                    128
                ],
                [
                    22,
                    26,
                    17,
                    131,
                    240,
                    154,
                    14,
                    1,
                    209
                ],
                [
                    45,
                    16,
                    21,
                    91,
                    64,
                    222,
                    7,
                    1,
                    197
                ],
                [
                    56,
                    21,
                    39,
                    155,
                    60,
                    138,
                    23,
                    102,
                    213
                ],
                [
                    83,
                    12,
                    13,
                    54,
                    192,
                    255,
                    68,
                    47,
                    28
                ],
                [
                    85,
                    26,
                    85,
                    85,
                    128,
                    128,
                    32,
                    146,
                    171
                ],
                [
                    18,
                    11,
                    7,
                    63,
                    144,
                    171,
                    4,
                    4,
                    246
                ],
                [
                    35,
                    27,
                    10,
                    146,
                    174,
                    171,
                    12,
                    26,
                    128
                ]
            ],
            [
                [
                    190,
                    80,
                    35,
                    99,
                    180,
                    80,
                    126,
                    54,
                    45
                ],
                [
                    85,
                    126,
                    47,
                    87,
                    176,
                    51,
                    41,
                    20,
                    32
                ],
                [
                    101,
                    75,
                    128,
                    139,
                    118,
                    146,
                    116,
                    128,
                    85
                ],
                [
                    56,
                    41,
                    15,
                    176,
                    236,
                    85,
                    37,
                    9,
                    62
                ],
                [
                    71,
                    30,
                    17,
                    119,
                    118,
                    255,
                    17,
                    18,
                    138
                ],
                [
                    101,
                    38,
                    60,
                    138,
                    55,
                    70,
                    43,
                    26,
                    142
                ],
                [
                    146,
                    36,
                    19,
                    30,
                    171,
                    255,
                    97,
                    27,
                    20
                ],
                [
                    138,
                    45,
                    61,
                    62,
                    219,
                    1,
                    81,
                    188,
                    64
                ],
                [
                    32,
                    41,
                    20,
                    117,
                    151,
                    142,
                    20,
                    21,
                    163
                ],
                [
                    112,
                    19,
                    12,
                    61,
                    195,
                    128,
                    48,
                    4,
                    24
                ]
            ]
        ], ui = [
            [
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        176,
                        246,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        241,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        244,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        246,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        239,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        217,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        225,
                        252,
                        241,
                        253,
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        250,
                        241,
                        250,
                        253,
                        255,
                        253,
                        254,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        223,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        238,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        248,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        247,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        186,
                        251,
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        234,
                        251,
                        244,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        251,
                        243,
                        253,
                        254,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        236,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        251,
                        253,
                        253,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ],
            [
                [
                    [
                        248,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        254,
                        252,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        249,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        246,
                        253,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        254,
                        251,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        254,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        248,
                        254,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        255,
                        254,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        245,
                        251,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        253,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        251,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        252,
                        253,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        252,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        249,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        253,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        250,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ],
                [
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        254,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ],
                    [
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255,
                        255
                    ]
                ]
            ]
        ], hi = [
            0,
            1,
            2,
            3,
            6,
            4,
            5,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            6,
            7,
            0
        ], li = [], fi = [], di = [], pi = 1, gi = 2, mi = [], vi = [];
        vr("UpsampleRgbLinePair", Ar, 3), vr("UpsampleBgrLinePair", xr, 3), vr("UpsampleRgbaLinePair", Ir, 4), vr("UpsampleBgraLinePair", kr, 4), vr("UpsampleArgbLinePair", Pr, 4), vr("UpsampleRgba4444LinePair", _r, 2), vr("UpsampleRgb565LinePair", Sr, 2);
        var bi = _$t.UpsampleRgbLinePair, yi = _$t.UpsampleBgrLinePair, wi = _$t.UpsampleRgbaLinePair, Ni = _$t.UpsampleBgraLinePair, Li = _$t.UpsampleArgbLinePair, Ai = _$t.UpsampleRgba4444LinePair, xi = _$t.UpsampleRgb565LinePair, Si = 16, _i = 1 << Si - 1, Pi = -227, ki = 482, Ii = 6, Fi = (256 << Ii) - 1, Ci = 0, ji = a(256), Oi = a(256), Bi = a(256), Mi = a(256), Ei = a(ki - Pi), qi = a(ki - Pi);
        Fr("YuvToRgbRow", Ar, 3), Fr("YuvToBgrRow", xr, 3), Fr("YuvToRgbaRow", Ir, 4), Fr("YuvToBgraRow", kr, 4), Fr("YuvToArgbRow", Pr, 4), Fr("YuvToRgba4444Row", _r, 2), Fr("YuvToRgb565Row", Sr, 2);
        var Di = [
            0,
            4,
            8,
            12,
            128,
            132,
            136,
            140,
            256,
            260,
            264,
            268,
            384,
            388,
            392,
            396
        ], Ri = [
            0,
            2,
            8
        ], Ti = [
            8,
            7,
            6,
            4,
            4,
            2,
            2,
            2,
            1,
            1,
            1,
            1
        ], Ui = 1;
        this.WebPDecodeRGBA = function(t, r, n, i, a) {
            var o = qn, s = new rr, c = new ot;
            s.ba = c, c.S = o, c.width = [
                c.width
            ], c.height = [
                c.height
            ];
            var u = c.width, h = c.height, l = new st;
            if (null == l || null == t) var f = 2;
            else e(null != l), f = Br(t, r, n, l.width, l.height, l.Pd, l.Qd, l.format, null);
            if (0 != f ? u = 0 : (null != u && (u[0] = l.width[0]), null != h && (h[0] = l.height[0]), u = 1), u) {
                c.width = c.width[0], c.height = c.height[0], null != i && (i[0] = c.width), null != a && (a[0] = c.height);
                t: {
                    if (i = new Gt, (a = new nr).data = t, a.w = r, a.ha = n, a.kd = 1, r = [
                        0
                    ], e(null != a), (0 == (t = Br(a.data, a.w, a.ha, null, null, null, r, null, a)) || 7 == t) && r[0] && (t = 4), 0 == (r = t)) {
                        if (e(null != s), i.data = a.data, i.w = a.w + a.offset, i.ha = a.ha - a.offset, i.put = dt, i.ac = ft, i.bc = pt, i.ma = s, a.xa) {
                            if (null == (t = kt())) {
                                s = 1;
                                break t;
                            }
                            if (function(t, r) {
                                var _$n = [
                                    0
                                ], _$i = [
                                    0
                                ], _$a = [
                                    0
                                ];
                                e: for(;;){
                                    if (null == t) return 0;
                                    if (null == r) return t.a = 2, 0;
                                    if (t.l = r, t.a = 0, v(t.m, r.data, r.w, r.ha), !gt(t.m, _$n, _$i, _$a)) {
                                        t.a = 3;
                                        break e;
                                    }
                                    if (t.xb = gi, r.width = _$n[0], r.height = _$i[0], !It(_$n[0], _$i[0], 1, t, null)) break e;
                                    return 1;
                                }
                                return e(0 != t.a), 0;
                            }(t, i)) {
                                if (i = 0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    e: {
                                        i = t;
                                        r: for(;;){
                                            if (null == i) {
                                                i = 0;
                                                break e;
                                            }
                                            if (e(null != i.s.yc), e(null != i.s.Ya), e(0 < i.s.Wb), e(null != (n = i.l)), e(null != (a = n.ma)), 0 != i.xb) {
                                                if (i.ca = a.ba, i.tb = a.tb, e(null != i.ca), !Mr(a.Oa, n, Rn)) {
                                                    i.a = 2;
                                                    break r;
                                                }
                                                if (!Ft(i, n.width)) break r;
                                                if (n.da) break r;
                                                if ((n.da || nt(i.ca.S)) && mr(), 11 > i.ca.S || (alert("todo:WebPInitConvertARGBToYUV"), null != i.ca.f.kb.F && mr()), i.Pb && 0 < i.s.ua && null == i.s.vb.X && !O(i.s.vb, i.s.Wa.Xa)) {
                                                    i.a = 1;
                                                    break r;
                                                }
                                                i.xb = 0;
                                            }
                                            if (!_$_t(i, i.V, i.Ba, i.c, i.i, n.o, Lt)) break r;
                                            a.Dc = i.Ma, i = 1;
                                            break e;
                                        }
                                        e(0 != i.a), i = 0;
                                    }
                                    i = !i;
                                }
                                i && (r = t.a);
                            } else r = t.a;
                        } else {
                            t = new Yt;
                            if (t.Fa = a.na, t.P = a.P, t.qc = a.Sa, Kt(t, i)) {
                                if (0 == (r = qr(i.width, i.height, s.Oa, s.ba))) {
                                    if (t.Aa = 0, n = s.Oa, e(null != (a = t)), null != n) {
                                        if (0 < (u = 0 > (u = n.Md) ? 0 : 100 < u ? 255 : 255 * u / 100)) {
                                            for(h = l = 0; 4 > h; ++h)12 > (f = a.pb[h]).lc && (f.ia = u * Ti[0 > f.lc ? 0 : f.lc] >> 3), l |= f.ia;
                                            l && (alert("todo:VP8InitRandom"), a.ia = 1);
                                        }
                                        a.Ga = n.Id, 100 < a.Ga ? a.Ga = 100 : 0 > a.Ga && (a.Ga = 0);
                                    }
                                    Qt(t, i) || (r = t.a);
                                }
                            } else r = t.a;
                        }
                        0 == r && null != s.Oa && s.Oa.fd && (r = Er(s.ba));
                    }
                    s = r;
                }
                o = 0 != s ? null : 11 > o ? c.f.RGBA.eb : c.f.kb.y;
            } else o = null;
            return o;
        };
        var zi = [
            3,
            4,
            3,
            4,
            4,
            2,
            2,
            4,
            4,
            4,
            2,
            1,
            1
        ];
    };
    new c;
    var f = [
        0
    ], d = [
        0
    ], p = [], g = new c, m = t, v = function(t, e) {
        var r = {}, n = 0, _$i = !1, a = 0, o = 0;
        if (r.frames = [], !/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */ function(t, e, r, n) {
            for(var _$i = 0; _$i < n; _$i++)if (t[e + _$i] != r.charCodeAt(_$i)) return !0;
            return !1;
        }(t, e, "RIFF", 4)) {
            var s, c;
            l(t, e += 4);
            for(e += 8; e < t.length;){
                var f = u(t, e), d = l(t, e += 4);
                e += 4;
                var p = d + (1 & d);
                switch(f){
                    case "VP8 ":
                    case "VP8L":
                        void 0 === r.frames[n] && (r.frames[n] = {});
                        (v = r.frames[n]).src_off = _$i ? o : e - 8, v.src_size = a + d + 8, n++, _$i && (_$i = !1, a = 0, o = 0);
                        break;
                    case "VP8X":
                        (v = r.header = {}).feature_flags = t[e];
                        var g = e + 4;
                        v.canvas_width = 1 + h(t, g);
                        g += 3;
                        v.canvas_height = 1 + h(t, g);
                        g += 3;
                        break;
                    case "ALPH":
                        _$i = !0, a = p + 8, o = e - 8;
                        break;
                    case "ANIM":
                        (v = r.header).bgcolor = l(t, e);
                        g = e + 4;
                        v.loop_count = (s = t)[(c = g) + 0] << 0 | s[c + 1] << 8;
                        g += 2;
                        break;
                    case "ANMF":
                        var m, v;
                        (v = r.frames[n] = {}).offset_x = 2 * h(t, e), e += 3, v.offset_y = 2 * h(t, e), e += 3, v.width = 1 + h(t, e), e += 3, v.height = 1 + h(t, e), e += 3, v.duration = h(t, e), e += 3, m = t[e++], v.dispose = 1 & m, v.blend = m >> 1 & 1;
                }
                "ANMF" != f && (e += p);
            }
            return r;
        }
    }(m, 0);
    v.response = m, v.rgbaoutput = !0, v.dataurl = !1;
    var b = v.header ? v.header : null, _$y = v.frames ? v.frames : null;
    if (b) {
        b.loop_counter = b.loop_count, f = [
            b.canvas_height
        ], d = [
            b.canvas_width
        ];
        for(var w = 0; w < _$y.length && 0 != _$y[w].blend; w++);
    }
    var N = _$y[0], L = g.WebPDecodeRGBA(m, N.src_off, N.src_size, d, f);
    N.rgba = L, N.imgwidth = d[0], N.imgheight = f[0];
    for(var A = 0; A < d[0] * f[0] * 4; A++)p[A] = L[A];
    return this.width = d, this.height = f, this.data = p, this;
}

!function(t) {
    var r = function r() {
        return "function" == typeof (0, $b495f2b996e3784e$export$f87121a6d50aff25);
    }, n = function n(r, n, a, h) {
        var l = 4, f = s;
        switch(h){
            case t.image_compression.FAST:
                l = 1, f = o;
                break;
            case t.image_compression.MEDIUM:
                l = 6, f = c;
                break;
            case t.image_compression.SLOW:
                l = 9, f = u;
        }
        r = _$i(r, n, a, f);
        var d = (0, $b495f2b996e3784e$export$f87121a6d50aff25)(r, {
            level: l
        });
        return t.__addimage__.arrayBufferToBinaryString(d);
    }, _$i = function i(t, e, r, n) {
        for(var _$i, a, o, s = t.length / e, c = new Uint8Array(t.length + s), u = l(), h = 0; h < s; h += 1){
            if (o = h * e, _$i = t.subarray(o, o + e), n) c.set(n(_$i, r, a), o + h);
            else {
                for(var d, p = u.length, g = []; d < p; d += 1)g[d] = u[d](_$i, r, a);
                var m = f(g.concat());
                c.set(g[m], o + h);
            }
            a = _$i;
        }
        return c;
    }, a = function a(t) {
        var e = Array.apply([], t);
        return e.unshift(0), e;
    }, o = function o(t, e) {
        var r, n = [], _$i = t.length;
        n[0] = 1;
        for(var a = 0; a < _$i; a += 1)r = t[a - e] || 0, n[a + 1] = t[a] - r + 256 & 255;
        return n;
    }, s = function s(t, e, r) {
        var n, _$i = [], a = t.length;
        _$i[0] = 2;
        for(var o = 0; o < a; o += 1)n = r && r[o] || 0, _$i[o + 1] = t[o] - n + 256 & 255;
        return _$i;
    }, c = function c(t, e, r) {
        var n, _$i, a = [], o = t.length;
        a[0] = 3;
        for(var s = 0; s < o; s += 1)n = t[s - e] || 0, _$i = r && r[s] || 0, a[s + 1] = t[s] + 256 - (n + _$i >>> 1) & 255;
        return a;
    }, u = function u(t, e, r) {
        var n, _$i, a, o, s = [], c = t.length;
        s[0] = 4;
        for(var u = 0; u < c; u += 1)n = t[u - e] || 0, _$i = r && r[u] || 0, a = r && r[u - e] || 0, o = h(n, _$i, a), s[u + 1] = t[u] - o + 256 & 255;
        return s;
    }, h = function h(t, e, r) {
        if (t === e && e === r) return t;
        var n = Math.abs(e - r), _$i = Math.abs(t - r), a = Math.abs(t + e - r - r);
        return n <= _$i && n <= a ? t : _$i <= a ? e : r;
    }, l = function l() {
        return [
            a,
            o,
            s,
            c,
            u
        ];
    }, f = function f(t) {
        var e = t.map(function(t) {
            return t.reduce(function(t, e) {
                return t + Math.abs(e);
            }, 0);
        });
        return e.indexOf(Math.min.apply(null, e));
    };
    t.processPNG = function(e, i, a, o) {
        var s, c, u, h, l, f, d, p, g, m, v, b, _$y, w, N, L = this.decode.FLATE_DECODE, A = "";
        if (this.__addimage__.isArrayBuffer(e) && (e = new Uint8Array(e)), this.__addimage__.isArrayBufferView(e)) {
            if (e = (u = new $cbf54afc98507811$var$Kt(e)).imgData, c = u.bits, s = u.colorSpace, l = u.colors, -1 !== [
                4,
                6
            ].indexOf(u.colorType)) {
                if (8 === u.bits) {
                    g = (p = 32 == u.pixelBitlength ? new Uint32Array(u.decodePixels().buffer) : 16 == u.pixelBitlength ? new Uint16Array(u.decodePixels().buffer) : new Uint8Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * u.colors), m = new Uint8Array(g);
                    var x, S = u.pixelBitlength - u.bits;
                    for(w = 0, N = 0; w < g; w++){
                        for(_$y = p[w], x = 0; x < S;)v[N++] = _$y >>> x & 255, x += u.bits;
                        m[w] = _$y >>> x & 255;
                    }
                }
                if (16 === u.bits) {
                    g = (p = new Uint32Array(u.decodePixels().buffer)).length, v = new Uint8Array(g * (32 / u.pixelBitlength) * u.colors), m = new Uint8Array(g * (32 / u.pixelBitlength)), b = u.colors > 1, w = 0, N = 0;
                    for(var _ = 0; w < g;)_$y = p[w++], v[N++] = _$y >>> 0 & 255, b && (v[N++] = _$y >>> 16 & 255, _$y = p[w++], v[N++] = _$y >>> 0 & 255), m[_++] = _$y >>> 16 & 255;
                    c = 8;
                }
                o !== t.image_compression.NONE && r() ? (e = n(v, u.width * u.colors, u.colors, o), d = n(m, u.width, 1, o)) : (e = v, d = m, L = void 0);
            }
            if (3 === u.colorType && (s = this.color_spaces.INDEXED, f = u.palette, u.transparency.indexed)) {
                var P = u.transparency.indexed, k = 0;
                for(w = 0, g = P.length; w < g; ++w)k += P[w];
                if ((k /= 255) === g - 1 && -1 !== P.indexOf(0)) h = [
                    P.indexOf(0)
                ];
                else if (k !== g) {
                    for(p = u.decodePixels(), m = new Uint8Array(p.length), w = 0, g = p.length; w < g; w++)m[w] = P[p[w]];
                    d = n(m, u.width, 1);
                }
            }
            var _$I = function(e) {
                var r;
                switch(e){
                    case t.image_compression.FAST:
                        r = 11;
                        break;
                    case t.image_compression.MEDIUM:
                        r = 13;
                        break;
                    case t.image_compression.SLOW:
                        r = 14;
                        break;
                    default:
                        r = 12;
                }
                return r;
            }(o);
            return L === this.decode.FLATE_DECODE && (A = "/Predictor " + _$I + " "), A += "/Colors " + l + " /BitsPerComponent " + c + " /Columns " + u.width, (this.__addimage__.isArrayBuffer(e) || this.__addimage__.isArrayBufferView(e)) && (e = this.__addimage__.arrayBufferToBinaryString(e)), (d && this.__addimage__.isArrayBuffer(d) || this.__addimage__.isArrayBufferView(d)) && (d = this.__addimage__.arrayBufferToBinaryString(d)), {
                alias: a,
                data: e,
                index: i,
                filter: L,
                decodeParameters: A,
                transparency: h,
                palette: f,
                sMask: d,
                predictor: _$I,
                width: u.width,
                height: u.height,
                bitsPerComponent: c,
                colorSpace: s
            };
        }
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), function(t) {
    t.processGIF89A = function(e, r, n, i) {
        var a = new $cbf54afc98507811$var$Zt(e), o = a.width, s = a.height, c = [];
        a.decodeAndBlitFrameRGBA(0, c);
        var u = {
            data: c,
            width: o,
            height: s
        }, h = new $cbf54afc98507811$var$Qt(100).encode(u, 100);
        return t.processJPEG.call(this, h, r, n, i);
    }, t.processGIF87A = t.processGIF89A;
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), $cbf54afc98507811$var$te.prototype.parseHeader = function() {
    if (this.fileSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.reserved = this.datav.getUint32(this.pos, !0), this.pos += 4, this.offset = this.datav.getUint32(this.pos, !0), this.pos += 4, this.headerSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.width = this.datav.getUint32(this.pos, !0), this.pos += 4, this.height = this.datav.getInt32(this.pos, !0), this.pos += 4, this.planes = this.datav.getUint16(this.pos, !0), this.pos += 2, this.bitPP = this.datav.getUint16(this.pos, !0), this.pos += 2, this.compress = this.datav.getUint32(this.pos, !0), this.pos += 4, this.rawSize = this.datav.getUint32(this.pos, !0), this.pos += 4, this.hr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.vr = this.datav.getUint32(this.pos, !0), this.pos += 4, this.colors = this.datav.getUint32(this.pos, !0), this.pos += 4, this.importantColors = this.datav.getUint32(this.pos, !0), this.pos += 4, 16 === this.bitPP && this.is_with_alpha && (this.bitPP = 15), this.bitPP < 15) {
        var _$t = 0 === this.colors ? 1 << this.bitPP : this.colors;
        this.palette = new Array(_$t);
        for(var e = 0; e < _$t; e++){
            var r = this.datav.getUint8(this.pos++, !0), n = this.datav.getUint8(this.pos++, !0), _$i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0);
            this.palette[e] = {
                red: _$i,
                green: n,
                blue: r,
                quad: a
            };
        }
    }
    this.height < 0 && (this.height *= -1, this.bottom_up = !1);
}, $cbf54afc98507811$var$te.prototype.parseBGR = function() {
    this.pos = this.offset;
    try {
        var _$t = "bit" + this.bitPP, e = this.width * this.height * 4;
        this.data = new Uint8Array(e), this[_$t]();
    } catch (t) {
        $cbf54afc98507811$var$a.log("bit decode error:" + t);
    }
}, $cbf54afc98507811$var$te.prototype.bit1 = function() {
    var _$t, e = Math.ceil(this.width / 8), r = e % 4;
    for(_$t = this.height - 1; _$t >= 0; _$t--){
        for(var n = this.bottom_up ? _$t : this.height - 1 - _$t, _$i = 0; _$i < e; _$i++)for(var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 8 * _$i * 4, s = 0; s < 8 && 8 * _$i + s < this.width; s++){
            var c = this.palette[a >> 7 - s & 1];
            this.data[o + 4 * s] = c.blue, this.data[o + 4 * s + 1] = c.green, this.data[o + 4 * s + 2] = c.red, this.data[o + 4 * s + 3] = 255;
        }
        0 !== r && (this.pos += 4 - r);
    }
}, $cbf54afc98507811$var$te.prototype.bit4 = function() {
    for(var _$t = Math.ceil(this.width / 2), e = _$t % 4, r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, _$i = 0; _$i < _$t; _$i++){
            var a = this.datav.getUint8(this.pos++, !0), o = n * this.width * 4 + 2 * _$i * 4, s = a >> 4, c = 15 & a, u = this.palette[s];
            if (this.data[o] = u.blue, this.data[o + 1] = u.green, this.data[o + 2] = u.red, this.data[o + 3] = 255, 2 * _$i + 1 >= this.width) break;
            u = this.palette[c], this.data[o + 4] = u.blue, this.data[o + 4 + 1] = u.green, this.data[o + 4 + 2] = u.red, this.data[o + 4 + 3] = 255;
        }
        0 !== e && (this.pos += 4 - e);
    }
}, $cbf54afc98507811$var$te.prototype.bit8 = function() {
    for(var _$t = this.width % 4, e = this.height - 1; e >= 0; e--){
        for(var r = this.bottom_up ? e : this.height - 1 - e, n = 0; n < this.width; n++){
            var _$i = this.datav.getUint8(this.pos++, !0), a = r * this.width * 4 + 4 * n;
            if (_$i < this.palette.length) {
                var o = this.palette[_$i];
                this.data[a] = o.red, this.data[a + 1] = o.green, this.data[a + 2] = o.blue, this.data[a + 3] = 255;
            } else this.data[a] = 255, this.data[a + 1] = 255, this.data[a + 2] = 255, this.data[a + 3] = 255;
        }
        0 !== _$t && (this.pos += 4 - _$t);
    }
}, $cbf54afc98507811$var$te.prototype.bit15 = function() {
    for(var _$t = this.width % 3, e = parseInt("11111", 2), r = this.height - 1; r >= 0; r--){
        for(var n = this.bottom_up ? r : this.height - 1 - r, _$i = 0; _$i < this.width; _$i++){
            var a = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var o = (a & e) / e * 255 | 0, s = (a >> 5 & e) / e * 255 | 0, c = (a >> 10 & e) / e * 255 | 0, u = a >> 15 ? 255 : 0, h = n * this.width * 4 + 4 * _$i;
            this.data[h] = c, this.data[h + 1] = s, this.data[h + 2] = o, this.data[h + 3] = u;
        }
        this.pos += _$t;
    }
}, $cbf54afc98507811$var$te.prototype.bit16 = function() {
    for(var _$t = this.width % 3, e = parseInt("11111", 2), r = parseInt("111111", 2), n = this.height - 1; n >= 0; n--){
        for(var _$i = this.bottom_up ? n : this.height - 1 - n, a = 0; a < this.width; a++){
            var o = this.datav.getUint16(this.pos, !0);
            this.pos += 2;
            var s = (o & e) / e * 255 | 0, c = (o >> 5 & r) / r * 255 | 0, u = (o >> 11) / e * 255 | 0, h = _$i * this.width * 4 + 4 * a;
            this.data[h] = u, this.data[h + 1] = c, this.data[h + 2] = s, this.data[h + 3] = 255;
        }
        this.pos += _$t;
    }
}, $cbf54afc98507811$var$te.prototype.bit24 = function() {
    for(var _$t = this.height - 1; _$t >= 0; _$t--){
        for(var e = this.bottom_up ? _$t : this.height - 1 - _$t, r = 0; r < this.width; r++){
            var n = this.datav.getUint8(this.pos++, !0), _$i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = e * this.width * 4 + 4 * r;
            this.data[o] = a, this.data[o + 1] = _$i, this.data[o + 2] = n, this.data[o + 3] = 255;
        }
        this.pos += this.width % 4;
    }
}, $cbf54afc98507811$var$te.prototype.bit32 = function() {
    for(var _$t = this.height - 1; _$t >= 0; _$t--)for(var e = this.bottom_up ? _$t : this.height - 1 - _$t, r = 0; r < this.width; r++){
        var n = this.datav.getUint8(this.pos++, !0), _$i = this.datav.getUint8(this.pos++, !0), a = this.datav.getUint8(this.pos++, !0), o = this.datav.getUint8(this.pos++, !0), s = e * this.width * 4 + 4 * r;
        this.data[s] = a, this.data[s + 1] = _$i, this.data[s + 2] = n, this.data[s + 3] = o;
    }
}, $cbf54afc98507811$var$te.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processBMP = function(e, r, n, i) {
        var a = new $cbf54afc98507811$var$te(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $cbf54afc98507811$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), $cbf54afc98507811$var$ee.prototype.getData = function() {
    return this.data;
}, /**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    t.processWEBP = function(e, r, n, i) {
        var a = new $cbf54afc98507811$var$ee(e, !1), o = a.width, s = a.height, c = {
            data: a.getData(),
            width: o,
            height: s
        }, u = new $cbf54afc98507811$var$Qt(100).encode(c, 100);
        return t.processJPEG.call(this, u, r, n, i);
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), $cbf54afc98507811$export$ba1e2ffc633a60f5.API.processRGBA = function(t, e, r) {
    for(var n = t.data, _$i = n.length, a = new Uint8Array(_$i / 4 * 3), o = new Uint8Array(_$i / 4), s = 0, c = 0, u = 0; u < _$i; u += 4){
        var h = n[u], l = n[u + 1], f = n[u + 2], d = n[u + 3];
        a[s++] = h, a[s++] = l, a[s++] = f, o[c++] = d;
    }
    var p = this.__addimage__.arrayBufferToBinaryString(a);
    return {
        alpha: this.__addimage__.arrayBufferToBinaryString(o),
        data: p,
        index: e,
        alias: r,
        colorSpace: "DeviceRGB",
        bitsPerComponent: 8,
        width: t.width,
        height: t.height
    };
}, $cbf54afc98507811$export$ba1e2ffc633a60f5.API.setLanguage = function(t) {
    return void 0 === this.internal.languageSettings && (this.internal.languageSettings = {}, this.internal.languageSettings.isSubscribed = !1), void 0 !== ({
        af: "Afrikaans",
        sq: "Albanian",
        ar: "Arabic (Standard)",
        "ar-DZ": "Arabic (Algeria)",
        "ar-BH": "Arabic (Bahrain)",
        "ar-EG": "Arabic (Egypt)",
        "ar-IQ": "Arabic (Iraq)",
        "ar-JO": "Arabic (Jordan)",
        "ar-KW": "Arabic (Kuwait)",
        "ar-LB": "Arabic (Lebanon)",
        "ar-LY": "Arabic (Libya)",
        "ar-MA": "Arabic (Morocco)",
        "ar-OM": "Arabic (Oman)",
        "ar-QA": "Arabic (Qatar)",
        "ar-SA": "Arabic (Saudi Arabia)",
        "ar-SY": "Arabic (Syria)",
        "ar-TN": "Arabic (Tunisia)",
        "ar-AE": "Arabic (U.A.E.)",
        "ar-YE": "Arabic (Yemen)",
        an: "Aragonese",
        hy: "Armenian",
        as: "Assamese",
        ast: "Asturian",
        az: "Azerbaijani",
        eu: "Basque",
        be: "Belarusian",
        bn: "Bengali",
        bs: "Bosnian",
        br: "Breton",
        bg: "Bulgarian",
        my: "Burmese",
        ca: "Catalan",
        ch: "Chamorro",
        ce: "Chechen",
        zh: "Chinese",
        "zh-HK": "Chinese (Hong Kong)",
        "zh-CN": "Chinese (PRC)",
        "zh-SG": "Chinese (Singapore)",
        "zh-TW": "Chinese (Taiwan)",
        cv: "Chuvash",
        co: "Corsican",
        cr: "Cree",
        hr: "Croatian",
        cs: "Czech",
        da: "Danish",
        nl: "Dutch (Standard)",
        "nl-BE": "Dutch (Belgian)",
        en: "English",
        "en-AU": "English (Australia)",
        "en-BZ": "English (Belize)",
        "en-CA": "English (Canada)",
        "en-IE": "English (Ireland)",
        "en-JM": "English (Jamaica)",
        "en-NZ": "English (New Zealand)",
        "en-PH": "English (Philippines)",
        "en-ZA": "English (South Africa)",
        "en-TT": "English (Trinidad & Tobago)",
        "en-GB": "English (United Kingdom)",
        "en-US": "English (United States)",
        "en-ZW": "English (Zimbabwe)",
        eo: "Esperanto",
        et: "Estonian",
        fo: "Faeroese",
        fj: "Fijian",
        fi: "Finnish",
        fr: "French (Standard)",
        "fr-BE": "French (Belgium)",
        "fr-CA": "French (Canada)",
        "fr-FR": "French (France)",
        "fr-LU": "French (Luxembourg)",
        "fr-MC": "French (Monaco)",
        "fr-CH": "French (Switzerland)",
        fy: "Frisian",
        fur: "Friulian",
        gd: "Gaelic (Scots)",
        "gd-IE": "Gaelic (Irish)",
        gl: "Galacian",
        ka: "Georgian",
        de: "German (Standard)",
        "de-AT": "German (Austria)",
        "de-DE": "German (Germany)",
        "de-LI": "German (Liechtenstein)",
        "de-LU": "German (Luxembourg)",
        "de-CH": "German (Switzerland)",
        el: "Greek",
        gu: "Gujurati",
        ht: "Haitian",
        he: "Hebrew",
        hi: "Hindi",
        hu: "Hungarian",
        is: "Icelandic",
        id: "Indonesian",
        iu: "Inuktitut",
        ga: "Irish",
        it: "Italian (Standard)",
        "it-CH": "Italian (Switzerland)",
        ja: "Japanese",
        kn: "Kannada",
        ks: "Kashmiri",
        kk: "Kazakh",
        km: "Khmer",
        ky: "Kirghiz",
        tlh: "Klingon",
        ko: "Korean",
        "ko-KP": "Korean (North Korea)",
        "ko-KR": "Korean (South Korea)",
        la: "Latin",
        lv: "Latvian",
        lt: "Lithuanian",
        lb: "Luxembourgish",
        mk: "North Macedonia",
        ms: "Malay",
        ml: "Malayalam",
        mt: "Maltese",
        mi: "Maori",
        mr: "Marathi",
        mo: "Moldavian",
        nv: "Navajo",
        ng: "Ndonga",
        ne: "Nepali",
        no: "Norwegian",
        nb: "Norwegian (Bokmal)",
        nn: "Norwegian (Nynorsk)",
        oc: "Occitan",
        or: "Oriya",
        om: "Oromo",
        fa: "Persian",
        "fa-IR": "Persian/Iran",
        pl: "Polish",
        pt: "Portuguese",
        "pt-BR": "Portuguese (Brazil)",
        pa: "Punjabi",
        "pa-IN": "Punjabi (India)",
        "pa-PK": "Punjabi (Pakistan)",
        qu: "Quechua",
        rm: "Rhaeto-Romanic",
        ro: "Romanian",
        "ro-MO": "Romanian (Moldavia)",
        ru: "Russian",
        "ru-MO": "Russian (Moldavia)",
        sz: "Sami (Lappish)",
        sg: "Sango",
        sa: "Sanskrit",
        sc: "Sardinian",
        sd: "Sindhi",
        si: "Singhalese",
        sr: "Serbian",
        sk: "Slovak",
        sl: "Slovenian",
        so: "Somani",
        sb: "Sorbian",
        es: "Spanish",
        "es-AR": "Spanish (Argentina)",
        "es-BO": "Spanish (Bolivia)",
        "es-CL": "Spanish (Chile)",
        "es-CO": "Spanish (Colombia)",
        "es-CR": "Spanish (Costa Rica)",
        "es-DO": "Spanish (Dominican Republic)",
        "es-EC": "Spanish (Ecuador)",
        "es-SV": "Spanish (El Salvador)",
        "es-GT": "Spanish (Guatemala)",
        "es-HN": "Spanish (Honduras)",
        "es-MX": "Spanish (Mexico)",
        "es-NI": "Spanish (Nicaragua)",
        "es-PA": "Spanish (Panama)",
        "es-PY": "Spanish (Paraguay)",
        "es-PE": "Spanish (Peru)",
        "es-PR": "Spanish (Puerto Rico)",
        "es-ES": "Spanish (Spain)",
        "es-UY": "Spanish (Uruguay)",
        "es-VE": "Spanish (Venezuela)",
        sx: "Sutu",
        sw: "Swahili",
        sv: "Swedish",
        "sv-FI": "Swedish (Finland)",
        "sv-SV": "Swedish (Sweden)",
        ta: "Tamil",
        tt: "Tatar",
        te: "Teluga",
        th: "Thai",
        tig: "Tigre",
        ts: "Tsonga",
        tn: "Tswana",
        tr: "Turkish",
        tk: "Turkmen",
        uk: "Ukrainian",
        hsb: "Upper Sorbian",
        ur: "Urdu",
        ve: "Venda",
        vi: "Vietnamese",
        vo: "Volapuk",
        wa: "Walloon",
        cy: "Welsh",
        xh: "Xhosa",
        ji: "Yiddish",
        zu: "Zulu"
    })[t] && (this.internal.languageSettings.languageCode = t, !1 === this.internal.languageSettings.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        this.internal.write("/Lang (" + this.internal.languageSettings.languageCode + ")");
    }), this.internal.languageSettings.isSubscribed = !0)), this;
}, $cbf54afc98507811$var$Vt = $cbf54afc98507811$export$ba1e2ffc633a60f5.API, $cbf54afc98507811$var$Gt = $cbf54afc98507811$var$Vt.getCharWidthsArray = function Gt(e, r) {
    var n, _$i, a = (r = r || {}).font || this.internal.getFont(), o = r.fontSize || this.internal.getFontSize(), s = r.charSpace || this.internal.getCharSpace(), c = r.widths ? r.widths : a.metadata.Unicode.widths, u = c.fof ? c.fof : 1, h = r.kerning ? r.kerning : a.metadata.Unicode.kerning, l = h.fof ? h.fof : 1, f = !1 !== r.doKerning, d = 0, p = e.length, g = 0, m = c[0] || u, v = [];
    for(n = 0; n < p; n++)_$i = e.charCodeAt(n), "function" == typeof a.metadata.widthOfString ? v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(_$i)) + s * (1e3 / o) || 0) / 1e3) : (d = f && "object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(h[_$i]) && !isNaN(parseInt(h[_$i][g], 10)) ? h[_$i][g] / l : 0, v.push((c[_$i] || m) / u + d)), g = _$i;
    return v;
}, $cbf54afc98507811$var$Yt = $cbf54afc98507811$var$Vt.getStringUnitWidth = function Yt(t, e) {
    var r = (e = e || {}).fontSize || this.internal.getFontSize(), n = e.font || this.internal.getFont(), _$i = e.charSpace || this.internal.getCharSpace();
    return $cbf54afc98507811$var$Vt.processArabic && (t = $cbf54afc98507811$var$Vt.processArabic(t)), "function" == typeof n.metadata.widthOfString ? n.metadata.widthOfString(t, r, _$i) / r : $cbf54afc98507811$var$Gt.apply(this, arguments).reduce(function(t, e) {
        return t + e;
    }, 0);
}, $cbf54afc98507811$var$Jt = function Jt(t, e, r, n) {
    for(var _$i = [], a = 0, o = t.length, s = 0; a !== o && s + e[a] < r;)s += e[a], a++;
    _$i.push(t.slice(0, a));
    var c = a;
    for(s = 0; a !== o;)s + e[a] > n && (_$i.push(t.slice(c, a)), s = 0, c = a), s += e[a], a++;
    return c !== a && _$i.push(t.slice(c, a)), _$i;
}, $cbf54afc98507811$var$Xt = function Xt(t, e, r) {
    r || (r = {});
    var n, _$i, a, o, s, c, u, h = [], l = [
        h
    ], f = r.textIndent || 0, d = 0, p = 0, g = t.split(" "), m = $cbf54afc98507811$var$Gt.apply(this, [
        " ",
        r
    ])[0];
    if (c = -1 === r.lineIndent ? g[0].length + 2 : r.lineIndent || 0) {
        var v = Array(c).join(" "), b = [];
        g.map(function(t) {
            (t = t.split(/\s*\n/)).length > 1 ? b = b.concat(t.map(function(t, e) {
                return (e && t.length ? "\n" : "") + t;
            })) : b.push(t[0]);
        }), g = b, c = $cbf54afc98507811$var$Yt.apply(this, [
            v,
            r
        ]);
    }
    for(a = 0, o = g.length; a < o; a++){
        var _$y = 0;
        if (n = g[a], c && "\n" == n[0] && (n = n.substr(1), _$y = 1), f + d + (p = (_$i = $cbf54afc98507811$var$Gt.apply(this, [
            n,
            r
        ])).reduce(function(t, e) {
            return t + e;
        }, 0)) > e || _$y) {
            if (p > e) {
                for(s = $cbf54afc98507811$var$Jt.apply(this, [
                    n,
                    _$i,
                    e - (f + d),
                    e
                ]), h.push(s.shift()), h = [
                    s.pop()
                ]; s.length;)l.push([
                    s.shift()
                ]);
                p = _$i.slice(n.length - (h[0] ? h[0].length : 0)).reduce(function(t, e) {
                    return t + e;
                }, 0);
            } else h = [
                n
            ];
            l.push(h), f = p + c, d = m;
        } else h.push(n), f += d + p, d = m;
    }
    return u = c ? function u(t, e) {
        return (e ? v : "") + t.join(" ");
    } : function(t) {
        return t.join(" ");
    }, l.map(u);
}, $cbf54afc98507811$var$Vt.splitTextToSize = function(t, e, r) {
    var n, _$i = (r = r || {}).fontSize || this.internal.getFontSize(), a = (function(t) {
        if (t.widths && t.kerning) return {
            widths: t.widths,
            kerning: t.kerning
        };
        var _$e = this.internal.getFont(t.fontName, t.fontStyle);
        return _$e.metadata.Unicode ? {
            widths: _$e.metadata.Unicode.widths || {
                0: 1
            },
            kerning: _$e.metadata.Unicode.kerning || {}
        } : {
            font: _$e.metadata,
            fontSize: this.internal.getFontSize(),
            charSpace: this.internal.getCharSpace()
        };
    }).call(this, r);
    n = Array.isArray(t) ? t : String(t).split(/\r?\n/);
    var o = 1 * this.internal.scaleFactor * e / _$i;
    a.textIndent = r.textIndent ? 1 * r.textIndent * this.internal.scaleFactor / _$i : 0, a.lineIndent = r.lineIndent;
    var s, c, u = [];
    for(s = 0, c = n.length; s < c; s++)u = u.concat($cbf54afc98507811$var$Xt.apply(this, [
        n[s],
        o,
        a
    ]));
    return u;
}, function(e) {
    e.__fontmetrics__ = e.__fontmetrics__ || {};
    for(var r = "klmnopqrstuvwxyz", n = {}, _$i = {}, a = 0; a < r.length; a++)n[r[a]] = "0123456789abcdef"[a], _$i["0123456789abcdef"[a]] = r[a];
    var o = function o(t) {
        return "0x" + parseInt(t, 10).toString(16);
    }, s = e.__fontmetrics__.compress = function s1(e) {
        var r, n, a, c, u = [
            "{"
        ];
        for(var h in e){
            if (r = e[h], isNaN(parseInt(h, 10)) ? n = "'" + h + "'" : (h = parseInt(h, 10), n = (n = o(h).slice(2)).slice(0, -1) + _$i[n.slice(-1)]), "number" == typeof r) r < 0 ? (a = o(r).slice(3), c = "-") : (a = o(r).slice(2), c = ""), a = c + a.slice(0, -1) + _$i[a.slice(-1)];
            else {
                if ("object" !== (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(r)) throw new Error("Don't know what to do with value type " + (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(r) + ".");
                a = s(r);
            }
            u.push(n + a);
        }
        return u.push("}"), u.join("");
    }, c = e.__fontmetrics__.uncompress = function c(t) {
        if ("string" != typeof t) throw new Error("Invalid argument passed to uncompress.");
        for(var _$e, r, _$i, a, o = {}, s = 1, c = o, u = [], h = "", l = "", f = t.length - 1, d = 1; d < f; d += 1)"'" == (a = t[d]) ? _$e ? (_$i = _$e.join(""), _$e = void 0) : _$e = [] : _$e ? _$e.push(a) : "{" == a ? (u.push([
            c,
            _$i
        ]), c = {}, _$i = void 0) : "}" == a ? ((r = u.pop())[0][r[1]] = c, _$i = void 0, c = r[0]) : "-" == a ? s = -1 : void 0 === _$i ? n.hasOwnProperty(a) ? (h += n[a], _$i = parseInt(h, 16) * s, s = 1, h = "") : h += a : n.hasOwnProperty(a) ? (l += n[a], c[_$i] = parseInt(l, 16) * s, s = 1, _$i = void 0, l = "") : l += a;
        return o;
    }, u = {
        codePages: [
            "WinAnsiEncoding"
        ],
        WinAnsiEncoding: c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")
    }, h = {
        Unicode: {
            Courier: u,
            "Courier-Bold": u,
            "Courier-BoldOblique": u,
            "Courier-Oblique": u,
            Helvetica: u,
            "Helvetica-Bold": u,
            "Helvetica-BoldOblique": u,
            "Helvetica-Oblique": u,
            "Times-Roman": u,
            "Times-Bold": u,
            "Times-BoldItalic": u,
            "Times-Italic": u
        }
    }, l = {
        Unicode: {
            "Courier-Oblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-BoldItalic": c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),
            "Helvetica-Bold": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            Courier: c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-BoldOblique": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Bold": c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),
            Symbol: c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),
            Helvetica: c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),
            "Helvetica-BoldOblique": c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),
            ZapfDingbats: c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),
            "Courier-Bold": c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),
            "Times-Italic": c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),
            "Times-Roman": c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),
            "Helvetica-Oblique": c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")
        }
    };
    e.events.push([
        "addFont",
        function(t) {
            var _$e = t.font, r = l.Unicode[_$e.postScriptName];
            r && (_$e.metadata.Unicode = {}, _$e.metadata.Unicode.widths = r.widths, _$e.metadata.Unicode.kerning = r.kerning);
            var n = h.Unicode[_$e.postScriptName];
            n && (_$e.metadata.Unicode.encoding = n, _$e.encoding = n.codePages[0]);
        }
    ]);
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function e(t) {
        for(var e = t.length, r = new Uint8Array(e), n = 0; n < e; n++)r[n] = t.charCodeAt(n);
        return r;
    };
    t.API.events.push([
        "addFont",
        function(r) {
            var n = void 0, _$i = r.font, a = r.instance;
            if (!_$i.isStandardFont) {
                if (void 0 === a) throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('" + _$i.postScriptName + "').");
                if ("string" != typeof (n = !1 === a.existsFileInVFS(_$i.postScriptName) ? a.loadFile(_$i.postScriptName) : a.getFileFromVFS(_$i.postScriptName))) throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('" + _$i.postScriptName + "').");
                !function(r, n) {
                    n = /^\x00\x01\x00\x00/.test(n) ? e(n) : e($cbf54afc98507811$var$u(n)), r.metadata = t.API.TTFFont.open(n), r.metadata.Unicode = r.metadata.Unicode || {
                        encoding: {},
                        kerning: {},
                        widths: []
                    }, r.metadata.glyIdsUsed = [
                        0
                    ];
                }(_$i, n);
            }
        }
    ]);
}($cbf54afc98507811$export$ba1e2ffc633a60f5), /** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function e() {
        return ($cbf54afc98507811$var$n.canvg ? Promise.resolve($cbf54afc98507811$var$n.canvg) : (parcelRequire("2cAE0"))).catch(function(t) {
            return Promise.reject(new Error("Could not load canvg: " + t));
        }).then(function(t) {
            return t.default ? t.default : t;
        });
    };
    $cbf54afc98507811$export$ba1e2ffc633a60f5.API.addSvgAsImage = function(t, r, n, i, o, s, c, u) {
        if (isNaN(r) || isNaN(n)) throw $cbf54afc98507811$var$a.error("jsPDF.addSvgAsImage: Invalid coordinates", arguments), new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");
        if (isNaN(i) || isNaN(o)) throw $cbf54afc98507811$var$a.error("jsPDF.addSvgAsImage: Invalid measurements", arguments), new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");
        var h = document.createElement("canvas");
        h.width = i, h.height = o;
        var l = h.getContext("2d");
        l.fillStyle = "#fff", l.fillRect(0, 0, h.width, h.height);
        var f = {
            ignoreMouse: !0,
            ignoreAnimation: !0,
            ignoreDimensions: !0
        }, d = this;
        return e().then(function(e) {
            return e.fromString(l, t, f);
        }, function() {
            return Promise.reject(new Error("Could not load canvg."));
        }).then(function(t) {
            return t.render(f);
        }).then(function() {
            d.addImage(h.toDataURL("image/jpeg", 1), r, n, i, o, c, u);
        });
    };
}(), $cbf54afc98507811$export$ba1e2ffc633a60f5.API.putTotalPages = function(t) {
    var e, r = 0;
    parseInt(this.internal.getFont().id.substr(1), 10) < 15 ? (e = new RegExp(t, "g"), r = this.internal.getNumberOfPages()) : (e = new RegExp(this.pdfEscape16(t, this.internal.getFont()), "g"), r = this.pdfEscape16(this.internal.getNumberOfPages() + "", this.internal.getFont()));
    for(var n = 1; n <= this.internal.getNumberOfPages(); n++)for(var _$i = 0; _$i < this.internal.pages[n].length; _$i++)this.internal.pages[n][_$i] = this.internal.pages[n][_$i].replace(e, r);
    return this;
}, $cbf54afc98507811$export$ba1e2ffc633a60f5.API.viewerPreferences = function(e, r) {
    var d = function d(t, e) {
        var _$r, n = !1;
        for(_$r = 0; _$r < t.length; _$r += 1)t[_$r] === e && (n = !0);
        return n;
    };
    var n;
    e = e || {}, r = r || !1;
    var _$i, a, o, s = {
        HideToolbar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideMenubar: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        HideWindowUI: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        FitWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        CenterWindow: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.3
        },
        DisplayDocTitle: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.4
        },
        NonFullScreenPageMode: {
            defaultValue: "UseNone",
            value: "UseNone",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "UseNone",
                "UseOutlines",
                "UseThumbs",
                "UseOC"
            ],
            pdfVersion: 1.3
        },
        Direction: {
            defaultValue: "L2R",
            value: "L2R",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "L2R",
                "R2L"
            ],
            pdfVersion: 1.3
        },
        ViewArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        ViewClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintArea: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintClip: {
            defaultValue: "CropBox",
            value: "CropBox",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "MediaBox",
                "CropBox",
                "TrimBox",
                "BleedBox",
                "ArtBox"
            ],
            pdfVersion: 1.4
        },
        PrintScaling: {
            defaultValue: "AppDefault",
            value: "AppDefault",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "AppDefault",
                "None"
            ],
            pdfVersion: 1.6
        },
        Duplex: {
            defaultValue: "",
            value: "none",
            type: "name",
            explicitSet: !1,
            valueSet: [
                "Simplex",
                "DuplexFlipShortEdge",
                "DuplexFlipLongEdge",
                "none"
            ],
            pdfVersion: 1.7
        },
        PickTrayByPDFSize: {
            defaultValue: !1,
            value: !1,
            type: "boolean",
            explicitSet: !1,
            valueSet: [
                !0,
                !1
            ],
            pdfVersion: 1.7
        },
        PrintPageRange: {
            defaultValue: "",
            value: "",
            type: "array",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        },
        NumCopies: {
            defaultValue: 1,
            value: 1,
            type: "integer",
            explicitSet: !1,
            valueSet: null,
            pdfVersion: 1.7
        }
    }, c = Object.keys(s), u = [], h = 0, l = 0, f = 0;
    if (void 0 === this.internal.viewerpreferences && (this.internal.viewerpreferences = {}, this.internal.viewerpreferences.configuration = JSON.parse(JSON.stringify(s)), this.internal.viewerpreferences.isSubscribed = !1), n = this.internal.viewerpreferences.configuration, "reset" === e || !0 === r) {
        var p = c.length;
        for(f = 0; f < p; f += 1)n[c[f]].value = n[c[f]].defaultValue, n[c[f]].explicitSet = !1;
    }
    if ("object" === (0, (/*@__PURE__*/$parcel$interopDefault($hrVOB)))(e)) {
        for(a in e)if (o = e[a], d(c, a) && void 0 !== o) {
            if ("boolean" === n[a].type && "boolean" == typeof o) n[a].value = o;
            else if ("name" === n[a].type && d(n[a].valueSet, o)) n[a].value = o;
            else if ("integer" === n[a].type && Number.isInteger(o)) n[a].value = o;
            else if ("array" === n[a].type) {
                for(h = 0; h < o.length; h += 1)if (_$i = !0, 1 === o[h].length && "number" == typeof o[h][0]) u.push(String(o[h] - 1));
                else if (o[h].length > 1) {
                    for(l = 0; l < o[h].length; l += 1)"number" != typeof o[h][l] && (_$i = !1);
                    !0 === _$i && u.push([
                        o[h][0] - 1,
                        o[h][1] - 1
                    ].join(" "));
                }
                n[a].value = "[" + u.join(" ") + "]";
            } else n[a].value = n[a].defaultValue;
            n[a].explicitSet = !0;
        }
    }
    return !1 === this.internal.viewerpreferences.isSubscribed && (this.internal.events.subscribe("putCatalog", function() {
        var _$t, _$e = [];
        for(_$t in n)!0 === n[_$t].explicitSet && ("name" === n[_$t].type ? _$e.push("/" + _$t + " /" + n[_$t].value) : _$e.push("/" + _$t + " " + n[_$t].value));
        0 !== _$e.length && this.internal.write("/ViewerPreferences\n<<\n" + _$e.join("\n") + "\n>>");
    }), this.internal.viewerpreferences.isSubscribed = !0), this.internal.viewerpreferences.configuration = n, this;
}, /** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */ function(t) {
    var e = function e() {
        var _$t = '<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="' + this.internal.__metadata__.namespaceuri + '"><jspdf:metadata>', e = unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')), r = unescape(encodeURIComponent(_$t)), n = unescape(encodeURIComponent(this.internal.__metadata__.metadata)), _$i = unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")), a = unescape(encodeURIComponent("</x:xmpmeta>")), o = r.length + n.length + _$i.length + e.length + a.length;
        this.internal.__metadata__.metadata_object_number = this.internal.newObject(), this.internal.write("<< /Type /Metadata /Subtype /XML /Length " + o + " >>"), this.internal.write("stream"), this.internal.write(e + r + n + _$i + a), this.internal.write("endstream"), this.internal.write("endobj");
    }, r = function r() {
        this.internal.__metadata__.metadata_object_number && this.internal.write("/Metadata " + this.internal.__metadata__.metadata_object_number + " 0 R");
    };
    t.addMetadata = function(t, n) {
        return void 0 === this.internal.__metadata__ && (this.internal.__metadata__ = {
            metadata: t,
            namespaceuri: n || "http://jspdf.default.namespaceuri/"
        }, this.internal.events.subscribe("putCatalog", r), this.internal.events.subscribe("postPutResources", e)), this;
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), function(t) {
    var e = t.API, r = e.pdfEscape16 = function r(t, e) {
        for(var r, n = e.metadata.Unicode.widths, _$i = [
            "",
            "0",
            "00",
            "000",
            "0000"
        ], a = [
            ""
        ], o = 0, s = t.length; o < s; ++o){
            if (r = e.metadata.characterToGlyph(t.charCodeAt(o)), e.metadata.glyIdsUsed.push(r), e.metadata.toUnicode[r] = t.charCodeAt(o), -1 == n.indexOf(r) && (n.push(r), n.push([
                parseInt(e.metadata.widthOfGlyph(r), 10)
            ])), "0" == r) return a.join("");
            r = r.toString(16), a.push(_$i[4 - r.length], r);
        }
        return a.join("");
    }, n = function n(t) {
        var e, r, n, _$i, a, o, s;
        for(a = "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange", n = [], o = 0, s = (r = Object.keys(t).sort(function(t, e) {
            return t - e;
        })).length; o < s; o++)e = r[o], n.length >= 100 && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar", n = []), void 0 !== t[e] && null !== t[e] && "function" == typeof t[e].toString && (_$i = ("0000" + t[e].toString(16)).slice(-4), e = ("0000" + (+e).toString(16)).slice(-4), n.push("<" + e + "><" + _$i + ">"));
        return n.length && (a += "\n" + n.length + " beginbfchar\n" + n.join("\n") + "\nendbfchar\n"), a += "endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
    };
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, _$i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "Identity-H" === r.encoding) {
                    for(var s = r.metadata.Unicode.widths, c = r.metadata.subset.encode(r.metadata.glyIdsUsed, 1), u = "", h = 0; h < c.length; h++)u += String.fromCharCode(c[h]);
                    var l = a();
                    o({
                        data: u,
                        addLength1: !0,
                        objectId: l
                    }), _$i("endobj");
                    var f = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: f
                    }), _$i("endobj");
                    var d = a();
                    _$i("<<"), _$i("/Type /FontDescriptor"), _$i("/FontName /" + $cbf54afc98507811$var$F(r.fontName)), _$i("/FontFile2 " + l + " 0 R"), _$i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), _$i("/Flags " + r.metadata.flags), _$i("/StemV " + r.metadata.stemV), _$i("/ItalicAngle " + r.metadata.italicAngle), _$i("/Ascent " + r.metadata.ascender), _$i("/Descent " + r.metadata.decender), _$i("/CapHeight " + r.metadata.capHeight), _$i(">>"), _$i("endobj");
                    var p = a();
                    _$i("<<"), _$i("/Type /Font"), _$i("/BaseFont /" + $cbf54afc98507811$var$F(r.fontName)), _$i("/FontDescriptor " + d + " 0 R"), _$i("/W " + t.API.PDFObject.convert(s)), _$i("/CIDToGIDMap /Identity"), _$i("/DW 1000"), _$i("/Subtype /CIDFontType2"), _$i("/CIDSystemInfo"), _$i("<<"), _$i("/Supplement 0"), _$i("/Registry (Adobe)"), _$i("/Ordering (" + r.encoding + ")"), _$i(">>"), _$i(">>"), _$i("endobj"), r.objectNumber = a(), _$i("<<"), _$i("/Type /Font"), _$i("/Subtype /Type0"), _$i("/ToUnicode " + f + " 0 R"), _$i("/BaseFont /" + $cbf54afc98507811$var$F(r.fontName)), _$i("/Encoding /" + r.encoding), _$i("/DescendantFonts [" + p + " 0 R]"), _$i(">>"), _$i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    e.events.push([
        "putFont",
        function(e) {
            !function(e) {
                var r = e.font, _$i = e.out, a = e.newObject, o = e.putStream;
                if (r.metadata instanceof t.API.TTFFont && "WinAnsiEncoding" === r.encoding) {
                    for(var s = r.metadata.rawData, c = "", u = 0; u < s.length; u++)c += String.fromCharCode(s[u]);
                    var h = a();
                    o({
                        data: c,
                        addLength1: !0,
                        objectId: h
                    }), _$i("endobj");
                    var l = a();
                    o({
                        data: n(r.metadata.toUnicode),
                        addLength1: !0,
                        objectId: l
                    }), _$i("endobj");
                    var f = a();
                    _$i("<<"), _$i("/Descent " + r.metadata.decender), _$i("/CapHeight " + r.metadata.capHeight), _$i("/StemV " + r.metadata.stemV), _$i("/Type /FontDescriptor"), _$i("/FontFile2 " + h + " 0 R"), _$i("/Flags 96"), _$i("/FontBBox " + t.API.PDFObject.convert(r.metadata.bbox)), _$i("/FontName /" + $cbf54afc98507811$var$F(r.fontName)), _$i("/ItalicAngle " + r.metadata.italicAngle), _$i("/Ascent " + r.metadata.ascender), _$i(">>"), _$i("endobj"), r.objectNumber = a();
                    for(var d = 0; d < r.metadata.hmtx.widths.length; d++)r.metadata.hmtx.widths[d] = parseInt(r.metadata.hmtx.widths[d] * (1e3 / r.metadata.head.unitsPerEm));
                    _$i("<</Subtype/TrueType/Type/Font/ToUnicode " + l + " 0 R/BaseFont/" + $cbf54afc98507811$var$F(r.fontName) + "/FontDescriptor " + f + " 0 R/Encoding/" + r.encoding + " /FirstChar 29 /LastChar 255 /Widths " + t.API.PDFObject.convert(r.metadata.hmtx.widths) + ">>"), _$i("endobj"), r.isAlreadyPutted = !0;
                }
            }(e);
        }
    ]);
    var _$i = function i(t) {
        var e, n = t.text || "", _$i = t.x, a = t.y, o = t.options || {}, s = t.mutex || {}, c = s.pdfEscape, u = s.activeFontKey, h = s.fonts, l = u, f = "", d = 0, p = "", g = h[l].encoding;
        if ("Identity-H" !== h[l].encoding) return {
            text: n,
            x: _$i,
            y: a,
            options: o,
            mutex: s
        };
        for(p = n, l = u, Array.isArray(n) && (p = n[0]), d = 0; d < p.length; d += 1)h[l].metadata.hasOwnProperty("cmap") && (e = h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]), e || p[d].charCodeAt(0) < 256 && h[l].metadata.hasOwnProperty("Unicode") ? f += p[d] : f += "";
        var m = "";
        return parseInt(l.slice(1)) < 14 || "WinAnsiEncoding" === g ? m = c(f, l).split("").map(function(t) {
            return t.charCodeAt(0).toString(16);
        }).join("") : "Identity-H" === g && (m = r(f, h[l])), s.isHex = !0, {
            text: m,
            x: _$i,
            y: a,
            options: o,
            mutex: s
        };
    };
    e.events.push([
        "postProcessText",
        function(t) {
            var e = t.text || "", r = [], n = {
                text: e,
                x: t.x,
                y: t.y,
                options: t.options,
                mutex: t.mutex
            };
            if (Array.isArray(e)) {
                var a = 0;
                for(a = 0; a < e.length; a += 1)Array.isArray(e[a]) && 3 === e[a].length ? r.push([
                    _$i(Object.assign({}, n, {
                        text: e[a][0]
                    })).text,
                    e[a][1],
                    e[a][2]
                ]) : r.push(_$i(Object.assign({}, n, {
                    text: e[a]
                })).text);
                t.text = r;
            } else t.text = _$i(Object.assign({}, n, {
                text: e
            })).text;
        }
    ]);
}($cbf54afc98507811$export$ba1e2ffc633a60f5), /**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */ function(t) {
    var e = function e() {
        return void 0 === this.internal.vFS && (this.internal.vFS = {}), !0;
    };
    t.existsFileInVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t];
    }, t.addFileToVFS = function(t, r) {
        return e.call(this), this.internal.vFS[t] = r, this;
    }, t.getFileFromVFS = function(t) {
        return e.call(this), void 0 !== this.internal.vFS[t] ? this.internal.vFS[t] : null;
    };
}($cbf54afc98507811$export$ba1e2ffc633a60f5.API), /**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */ function(t) {
    t.__bidiEngine__ = t.prototype.__bidiEngine__ = function(t) {
        var r, n, _$i, a, o, s, c, u = e, h = [
            [
                0,
                3,
                0,
                1,
                0,
                0,
                0
            ],
            [
                0,
                3,
                0,
                1,
                2,
                2,
                0
            ],
            [
                0,
                3,
                0,
                17,
                2,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                1,
                0
            ],
            [
                0,
                3,
                21,
                21,
                4,
                0,
                1
            ],
            [
                0,
                3,
                5,
                5,
                4,
                2,
                0
            ]
        ], l = [
            [
                2,
                0,
                1,
                1,
                0,
                1,
                0
            ],
            [
                2,
                0,
                1,
                1,
                0,
                2,
                0
            ],
            [
                2,
                0,
                2,
                1,
                3,
                2,
                0
            ],
            [
                2,
                0,
                2,
                33,
                3,
                1,
                1
            ]
        ], f = {
            L: 0,
            R: 1,
            EN: 2,
            AN: 3,
            N: 4,
            B: 5,
            S: 6
        }, d = {
            0: 0,
            5: 1,
            6: 2,
            7: 3,
            32: 4,
            251: 5,
            254: 6,
            255: 7
        }, p = [
            "(",
            ")",
            "(",
            "<",
            ">",
            "<",
            "[",
            "]",
            "[",
            "{",
            "}",
            "{",
            "\xab",
            "\xbb",
            "\xab",
            "‹",
            "›",
            "‹",
            "⁅",
            "⁆",
            "⁅",
            "⁽",
            "⁾",
            "⁽",
            "₍",
            "₎",
            "₍",
            "≤",
            "≥",
            "≤",
            "〈",
            "〉",
            "〈",
            "﹙",
            "﹚",
            "﹙",
            "﹛",
            "﹜",
            "﹛",
            "﹝",
            "﹞",
            "﹝",
            "﹤",
            "﹥",
            "﹤"
        ], g = new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/), m = !1, v = 0;
        this.__bidiEngine__ = {};
        var b = function b(t) {
            var e = t.charCodeAt(), r = e >> 8, n = d[r];
            return void 0 !== n ? u[256 * n + (255 & e)] : 252 === r || 253 === r ? "AL" : g.test(r) ? "L" : 8 === r ? "R" : "N";
        }, _$y = function y(t) {
            for(var e, r = 0; r < t.length; r++){
                if ("L" === (e = b(t.charAt(r)))) return !1;
                if ("R" === e) return !0;
            }
            return !1;
        }, w = function w(t, e, o, s) {
            var c, u, h, l, f = e[s];
            switch(f){
                case "L":
                case "R":
                    m = !1;
                    break;
                case "N":
                case "AN":
                    break;
                case "EN":
                    m && (f = "AN");
                    break;
                case "AL":
                    m = !0, f = "R";
                    break;
                case "WS":
                    f = "N";
                    break;
                case "CS":
                    s < 1 || s + 1 >= e.length || "EN" !== (c = o[s - 1]) && "AN" !== c || "EN" !== (u = e[s + 1]) && "AN" !== u ? f = "N" : m && (u = "AN"), f = u === c ? u : "N";
                    break;
                case "ES":
                    f = "EN" === (c = s > 0 ? o[s - 1] : "B") && s + 1 < e.length && "EN" === e[s + 1] ? "EN" : "N";
                    break;
                case "ET":
                    if (s > 0 && "EN" === o[s - 1]) {
                        f = "EN";
                        break;
                    }
                    if (m) {
                        f = "N";
                        break;
                    }
                    for(h = s + 1, l = e.length; h < l && "ET" === e[h];)h++;
                    f = h < l && "EN" === e[h] ? "EN" : "N";
                    break;
                case "NSM":
                    if (_$i && !a) {
                        for(l = e.length, h = s + 1; h < l && "NSM" === e[h];)h++;
                        if (h < l) {
                            var d = t[s], p = d >= 1425 && d <= 2303 || 64286 === d;
                            if (c = e[h], p && ("R" === c || "AL" === c)) {
                                f = "R";
                                break;
                            }
                        }
                    }
                    f = s < 1 || "B" === (c = e[s - 1]) ? "N" : o[s - 1];
                    break;
                case "B":
                    m = !1, r = !0, f = v;
                    break;
                case "S":
                    n = !0, f = "N";
                    break;
                case "LRE":
                case "RLE":
                case "LRO":
                case "RLO":
                case "PDF":
                    m = !1;
                    break;
                case "BN":
                    f = "N";
            }
            return f;
        }, N = function N(t, e, r) {
            var n = t.split("");
            return r && L(n, r, {
                hiLevel: v
            }), n.reverse(), e && e.reverse(), n.join("");
        }, L = function L(t, e, i) {
            var a, o, s, c, u, d = -1, p = t.length, g = 0, _$y = [], N = v ? l : h, L = [];
            for(m = !1, r = !1, n = !1, o = 0; o < p; o++)L[o] = b(t[o]);
            for(s = 0; s < p; s++){
                if (u = g, _$y[s] = w(t, L, _$y, s), a = 240 & (g = N[u][f[_$y[s]]]), g &= 15, e[s] = c = N[g][5], a > 0) {
                    if (16 === a) {
                        for(o = d; o < s; o++)e[o] = 1;
                        d = -1;
                    } else d = -1;
                }
                if (N[g][6]) -1 === d && (d = s);
                else if (d > -1) {
                    for(o = d; o < s; o++)e[o] = c;
                    d = -1;
                }
                "B" === L[s] && (e[s] = 0), i.hiLevel |= c;
            }
            n && function(t, e, r) {
                for(var n = 0; n < r; n++)if ("S" === t[n]) {
                    e[n] = v;
                    for(var _$i = n - 1; _$i >= 0 && "WS" === t[_$i]; _$i--)e[_$i] = v;
                }
            }(L, e, p);
        }, A = function A(t, e, n, i, a) {
            if (!(a.hiLevel < t)) {
                if (1 === t && 1 === v && !r) return e.reverse(), void (n && n.reverse());
                for(var o, s, c, u, h = e.length, l = 0; l < h;){
                    if (i[l] >= t) {
                        for(c = l + 1; c < h && i[c] >= t;)c++;
                        for(u = l, s = c - 1; u < s; u++, s--)o = e[u], e[u] = e[s], e[s] = o, n && (o = n[u], n[u] = n[s], n[s] = o);
                        l = c;
                    }
                    l++;
                }
            }
        }, x = function x(t, e, r) {
            var n = t.split(""), _$i = {
                hiLevel: v
            };
            return r || (r = []), L(n, r, _$i), function(t, e, r) {
                if (0 !== r.hiLevel && c) for(var n, _$i = 0; _$i < t.length; _$i++)1 === e[_$i] && (n = p.indexOf(t[_$i])) >= 0 && (t[_$i] = p[n + 1]);
            }(n, r, _$i), A(2, n, e, r, _$i), A(1, n, e, r, _$i), n.join("");
        };
        return this.__bidiEngine__.doBidiReorder = function(t, e, r) {
            if (function(t, e) {
                if (e) for(var _$r = 0; _$r < t.length; _$r++)e[_$r] = _$r;
                void 0 === a && (a = _$y(t)), void 0 === s && (s = _$y(t));
            }(t, e), _$i || !o || s) {
                if (_$i && o && a ^ s) v = a ? 1 : 0, t = N(t, e, r);
                else if (!_$i && o && s) v = a ? 1 : 0, t = x(t, e, r), t = N(t, e);
                else if (!_$i || a || o || s) {
                    if (_$i && !o && a ^ s) t = N(t, e), a ? (v = 0, t = x(t, e, r)) : (v = 1, t = x(t, e, r), t = N(t, e));
                    else if (_$i && a && !o && s) v = 1, t = x(t, e, r), t = N(t, e);
                    else if (!_$i && !o && a ^ s) {
                        var n = c;
                        a ? (v = 1, t = x(t, e, r), v = 0, c = !1, t = x(t, e, r), c = n) : (v = 0, t = x(t, e, r), t = N(t, e), v = 1, c = !1, t = x(t, e, r), c = n, t = N(t, e));
                    }
                } else v = 0, t = x(t, e, r);
            } else v = a ? 1 : 0, t = x(t, e, r);
            return t;
        }, this.__bidiEngine__.setOptions = function(t) {
            t && (_$i = t.isInputVisual, o = t.isOutputVisual, a = t.isInputRtl, s = t.isOutputRtl, c = t.isSymmetricSwapping);
        }, this.__bidiEngine__.setOptions(t), this.__bidiEngine__;
    };
    var e = [
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "S",
        "B",
        "S",
        "WS",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "B",
        "B",
        "S",
        "WS",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "B",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "CS",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "L",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "ET",
        "ET",
        "EN",
        "EN",
        "N",
        "L",
        "N",
        "N",
        "N",
        "EN",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "NSM",
        "R",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "N",
        "N",
        "AL",
        "ET",
        "ET",
        "AL",
        "CS",
        "AL",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "AN",
        "ET",
        "AN",
        "AN",
        "AL",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AN",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "AL",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "NSM",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "R",
        "R",
        "N",
        "N",
        "N",
        "N",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "WS",
        "BN",
        "BN",
        "BN",
        "L",
        "R",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "B",
        "LRE",
        "RLE",
        "PDF",
        "LRO",
        "RLO",
        "CS",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "WS",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "N",
        "LRI",
        "RLI",
        "FSI",
        "PDI",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "BN",
        "EN",
        "L",
        "N",
        "N",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "L",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "R",
        "NSM",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "ES",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "N",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "N",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "R",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "NSM",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "CS",
        "N",
        "CS",
        "N",
        "N",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "N",
        "N",
        "ES",
        "ES",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "AL",
        "N",
        "N",
        "BN",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "ES",
        "CS",
        "ES",
        "CS",
        "CS",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "EN",
        "CS",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "L",
        "L",
        "L",
        "N",
        "N",
        "L",
        "L",
        "L",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "ET",
        "ET",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N",
        "N"
    ], r = new t.__bidiEngine__({
        isInputVisual: !0
    });
    t.API.events.push([
        "postProcessText",
        function(t) {
            var e = t.text, n = (t.x, t.y, t.options || {}), _$i = (t.mutex, n.lang, []);
            if (n.isInputVisual = "boolean" != typeof n.isInputVisual || n.isInputVisual, r.setOptions(n), "[object Array]" === Object.prototype.toString.call(e)) {
                var a = 0;
                for(_$i = [], a = 0; a < e.length; a += 1)"[object Array]" === Object.prototype.toString.call(e[a]) ? _$i.push([
                    r.doBidiReorder(e[a][0]),
                    e[a][1],
                    e[a][2]
                ]) : _$i.push([
                    r.doBidiReorder(e[a])
                ]);
                t.text = _$i;
            } else t.text = r.doBidiReorder(e);
            r.setOptions({
                isInputVisual: !0
            });
        }
    ]);
}($cbf54afc98507811$export$ba1e2ffc633a60f5), $cbf54afc98507811$export$ba1e2ffc633a60f5.API.TTFFont = function() {
    var _$t = function _$t(t) {
        var e;
        if (this.rawData = t, e = this.contents = new $cbf54afc98507811$var$ne(t), this.contents.pos = 4, "ttcf" === e.readString(4)) throw new Error("TTCF not supported.");
        e.pos = 0, this.parse(), this.subset = new $cbf54afc98507811$var$Le(this), this.registerTTF();
    };
    return _$t.open = function(e) {
        return new _$t(e);
    }, _$t.prototype.parse = function() {
        return this.directory = new $cbf54afc98507811$var$ie(this.contents), this.head = new $cbf54afc98507811$var$se(this), this.name = new $cbf54afc98507811$var$pe(this), this.cmap = new $cbf54afc98507811$var$ue(this), this.toUnicode = {}, this.hhea = new $cbf54afc98507811$var$he(this), this.maxp = new $cbf54afc98507811$var$ge(this), this.hmtx = new $cbf54afc98507811$var$me(this), this.post = new $cbf54afc98507811$var$fe(this), this.os2 = new $cbf54afc98507811$var$le(this), this.loca = new $cbf54afc98507811$var$Ne(this), this.glyf = new $cbf54afc98507811$var$be(this), this.ascender = this.os2.exists && this.os2.ascender || this.hhea.ascender, this.decender = this.os2.exists && this.os2.decender || this.hhea.decender, this.lineGap = this.os2.exists && this.os2.lineGap || this.hhea.lineGap, this.bbox = [
            this.head.xMin,
            this.head.yMin,
            this.head.xMax,
            this.head.yMax
        ];
    }, _$t.prototype.registerTTF = function() {
        var _$t, e, r, n, _$i;
        if (this.scaleFactor = 1e3 / this.head.unitsPerEm, this.bbox = (function() {
            var e, r, n, _$i;
            for(_$i = [], e = 0, r = (n = this.bbox).length; e < r; e++)_$t = n[e], _$i.push(Math.round(_$t * this.scaleFactor));
            return _$i;
        }).call(this), this.stemV = 0, this.post.exists ? (r = 255 & (n = this.post.italic_angle), 0 != (32768 & (e = n >> 16)) && (e = -(1 + (65535 ^ e))), this.italicAngle = +(e + "." + r)) : this.italicAngle = 0, this.ascender = Math.round(this.ascender * this.scaleFactor), this.decender = Math.round(this.decender * this.scaleFactor), this.lineGap = Math.round(this.lineGap * this.scaleFactor), this.capHeight = this.os2.exists && this.os2.capHeight || this.ascender, this.xHeight = this.os2.exists && this.os2.xHeight || 0, this.familyClass = (this.os2.exists && this.os2.familyClass || 0) >> 8, this.isSerif = 1 === (_$i = this.familyClass) || 2 === _$i || 3 === _$i || 4 === _$i || 5 === _$i || 7 === _$i, this.isScript = 10 === this.familyClass, this.flags = 0, this.post.isFixedPitch && (this.flags |= 1), this.isSerif && (this.flags |= 2), this.isScript && (this.flags |= 8), 0 !== this.italicAngle && (this.flags |= 64), this.flags |= 32, !this.cmap.unicode) throw new Error("No unicode cmap for font");
    }, _$t.prototype.characterToGlyph = function(t) {
        var e;
        return (null != (e = this.cmap.unicode) ? e.codeMap[t] : void 0) || 0;
    }, _$t.prototype.widthOfGlyph = function(t) {
        var e;
        return e = 1e3 / this.head.unitsPerEm, this.hmtx.forGlyph(t).advance * e;
    }, _$t.prototype.widthOfString = function(t, e, r) {
        var n, _$i, a, o;
        for(a = 0, _$i = 0, o = (t = "" + t).length; 0 <= o ? _$i < o : _$i > o; _$i = 0 <= o ? ++_$i : --_$i)n = t.charCodeAt(_$i), a += this.widthOfGlyph(this.characterToGlyph(n)) + r * (1e3 / e) || 0;
        return a * (e / 1e3);
    }, _$t.prototype.lineHeight = function(t, e) {
        var r;
        return null == e && (e = !1), r = e ? this.lineGap : 0, (this.ascender + r - this.decender) / 1e3 * t;
    }, _$t;
}();
var $cbf54afc98507811$var$re, $cbf54afc98507811$var$ne = function() {
    var _$t = function _$t(t) {
        this.data = null != t ? t : [], this.pos = 0, this.length = this.data.length;
    };
    return _$t.prototype.readByte = function() {
        return this.data[this.pos++];
    }, _$t.prototype.writeByte = function(t) {
        return this.data[this.pos++] = t;
    }, _$t.prototype.readUInt32 = function() {
        return 16777216 * this.readByte() + (this.readByte() << 16) + (this.readByte() << 8) + this.readByte();
    }, _$t.prototype.writeUInt32 = function(t) {
        return this.writeByte(t >>> 24 & 255), this.writeByte(t >> 16 & 255), this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, _$t.prototype.readInt32 = function() {
        var _$t;
        return (_$t = this.readUInt32()) >= 2147483648 ? _$t - 4294967296 : _$t;
    }, _$t.prototype.writeInt32 = function(t) {
        return t < 0 && (t += 4294967296), this.writeUInt32(t);
    }, _$t.prototype.readUInt16 = function() {
        return this.readByte() << 8 | this.readByte();
    }, _$t.prototype.writeUInt16 = function(t) {
        return this.writeByte(t >> 8 & 255), this.writeByte(255 & t);
    }, _$t.prototype.readInt16 = function() {
        var _$t;
        return (_$t = this.readUInt16()) >= 32768 ? _$t - 65536 : _$t;
    }, _$t.prototype.writeInt16 = function(t) {
        return t < 0 && (t += 65536), this.writeUInt16(t);
    }, _$t.prototype.readString = function(t) {
        var e, r;
        for(r = [], e = 0; 0 <= t ? e < t : e > t; e = 0 <= t ? ++e : --e)r[e] = String.fromCharCode(this.readByte());
        return r.join("");
    }, _$t.prototype.writeString = function(t) {
        var e, r, n;
        for(n = [], e = 0, r = t.length; 0 <= r ? e < r : e > r; e = 0 <= r ? ++e : --e)n.push(this.writeByte(t.charCodeAt(e)));
        return n;
    }, _$t.prototype.readShort = function() {
        return this.readInt16();
    }, _$t.prototype.writeShort = function(t) {
        return this.writeInt16(t);
    }, _$t.prototype.readLongLong = function() {
        var _$t, e, r, n, _$i, a, o, s;
        return _$t = this.readByte(), e = this.readByte(), r = this.readByte(), n = this.readByte(), _$i = this.readByte(), a = this.readByte(), o = this.readByte(), s = this.readByte(), 128 & _$t ? -1 * (72057594037927940 * (255 ^ _$t) + 281474976710656 * (255 ^ e) + 1099511627776 * (255 ^ r) + 4294967296 * (255 ^ n) + 16777216 * (255 ^ _$i) + 65536 * (255 ^ a) + 256 * (255 ^ o) + (255 ^ s) + 1) : 72057594037927940 * _$t + 281474976710656 * e + 1099511627776 * r + 4294967296 * n + 16777216 * _$i + 65536 * a + 256 * o + s;
    }, _$t.prototype.writeLongLong = function(t) {
        var e, r;
        return e = Math.floor(t / 4294967296), r = 4294967295 & t, this.writeByte(e >> 24 & 255), this.writeByte(e >> 16 & 255), this.writeByte(e >> 8 & 255), this.writeByte(255 & e), this.writeByte(r >> 24 & 255), this.writeByte(r >> 16 & 255), this.writeByte(r >> 8 & 255), this.writeByte(255 & r);
    }, _$t.prototype.readInt = function() {
        return this.readInt32();
    }, _$t.prototype.writeInt = function(t) {
        return this.writeInt32(t);
    }, _$t.prototype.read = function(t) {
        var e, r;
        for(e = [], r = 0; 0 <= t ? r < t : r > t; r = 0 <= t ? ++r : --r)e.push(this.readByte());
        return e;
    }, _$t.prototype.write = function(t) {
        var e, r, n, _$i;
        for(_$i = [], r = 0, n = t.length; r < n; r++)e = t[r], _$i.push(this.writeByte(e));
        return _$i;
    }, _$t;
}(), $cbf54afc98507811$var$ie = function() {
    var e = function e(t) {
        var e, r, n;
        for(this.scalarType = t.readInt(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), this.tables = {}, r = 0, n = this.tableCount; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)e = {
            tag: t.readString(4),
            checksum: t.readInt(),
            offset: t.readInt(),
            length: t.readInt()
        }, this.tables[e.tag] = e;
    };
    var _$t;
    return e.prototype.encode = function(e) {
        var r, n, _$i, a, o, s, c, u, h, l, f, d, p;
        for(p in f = Object.keys(e).length, s = Math.log(2), h = 16 * Math.floor(Math.log(f) / s), a = Math.floor(h / s), u = 16 * f - h, (n = new $cbf54afc98507811$var$ne).writeInt(this.scalarType), n.writeShort(f), n.writeShort(h), n.writeShort(a), n.writeShort(u), _$i = 16 * f, c = n.pos + _$i, o = null, d = [], e)for(l = e[p], n.writeString(p), n.writeInt(_$t(l)), n.writeInt(c), n.writeInt(l.length), d = d.concat(l), "head" === p && (o = c), c += l.length; c % 4;)d.push(0), c++;
        return n.write(d), r = 2981146554 - _$t(n.data), n.pos = o + 8, n.writeUInt32(r), n.data;
    }, _$t = function t(t) {
        var e, r, n, _$i;
        for(t = $cbf54afc98507811$var$ve.call(t); t.length % 4;)t.push(0);
        for(n = new $cbf54afc98507811$var$ne(t), r = 0, e = 0, _$i = t.length; e < _$i; e = e += 4)r += n.readUInt32();
        return 4294967295 & r;
    }, e;
}(), $cbf54afc98507811$var$ae = {}.hasOwnProperty, $cbf54afc98507811$var$oe = function oe(t, e) {
    var n = function n() {
        this.constructor = t;
    };
    for(var r in e)$cbf54afc98507811$var$ae.call(e, r) && (t[r] = e[r]);
    return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t;
};
$cbf54afc98507811$var$re = function() {
    var _$t = function _$t(t) {
        var e;
        this.file = t, e = this.file.directory.tables[this.tag], this.exists = !!e, e && (this.offset = e.offset, this.length = e.length, this.parse(this.file.contents));
    };
    return _$t.prototype.parse = function() {}, _$t.prototype.encode = function() {}, _$t.prototype.raw = function() {
        return this.exists ? (this.file.contents.pos = this.offset, this.file.contents.read(this.length)) : null;
    }, _$t;
}();
var $cbf54afc98507811$var$se = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "head", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.revision = t.readInt(), this.checkSumAdjustment = t.readInt(), this.magicNumber = t.readInt(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.readLongLong(), this.modified = t.readLongLong(), this.xMin = t.readShort(), this.yMin = t.readShort(), this.xMax = t.readShort(), this.yMax = t.readShort(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort(), this.indexToLocFormat = t.readShort(), this.glyphDataFormat = t.readShort();
    }, e.prototype.encode = function(t) {
        var _$e;
        return (_$e = new $cbf54afc98507811$var$ne).writeInt(this.version), _$e.writeInt(this.revision), _$e.writeInt(this.checkSumAdjustment), _$e.writeInt(this.magicNumber), _$e.writeShort(this.flags), _$e.writeShort(this.unitsPerEm), _$e.writeLongLong(this.created), _$e.writeLongLong(this.modified), _$e.writeShort(this.xMin), _$e.writeShort(this.yMin), _$e.writeShort(this.xMax), _$e.writeShort(this.yMax), _$e.writeShort(this.macStyle), _$e.writeShort(this.lowestRecPPEM), _$e.writeShort(this.fontDirectionHint), _$e.writeShort(t), _$e.writeShort(this.glyphDataFormat), _$e.data;
    }, e;
}(), $cbf54afc98507811$var$ce = function() {
    var _$t = function _$t(t, e) {
        var r, n, _$i, a, o, s, c, u, h, l, f, d, p, g, m, v, b;
        switch(this.platformID = t.readUInt16(), this.encodingID = t.readShort(), this.offset = e + t.readInt(), h = t.pos, t.pos = this.offset, this.format = t.readUInt16(), this.length = t.readUInt16(), this.language = t.readUInt16(), this.isUnicode = 3 === this.platformID && 1 === this.encodingID && 4 === this.format || 0 === this.platformID && 4 === this.format, this.codeMap = {}, this.format){
            case 0:
                for(s = 0; s < 256; ++s)this.codeMap[s] = t.readByte();
                break;
            case 4:
                for(f = t.readUInt16(), l = f / 2, t.pos += 6, _$i = function() {
                    var _$e, r;
                    for(r = [], s = _$e = 0; 0 <= l ? _$e < l : _$e > l; s = 0 <= l ? ++_$e : --_$e)r.push(t.readUInt16());
                    return r;
                }(), t.pos += 2, p = function() {
                    var _$e, r;
                    for(r = [], s = _$e = 0; 0 <= l ? _$e < l : _$e > l; s = 0 <= l ? ++_$e : --_$e)r.push(t.readUInt16());
                    return r;
                }(), c = function() {
                    var _$e, r;
                    for(r = [], s = _$e = 0; 0 <= l ? _$e < l : _$e > l; s = 0 <= l ? ++_$e : --_$e)r.push(t.readUInt16());
                    return r;
                }(), u = function() {
                    var _$e, r;
                    for(r = [], s = _$e = 0; 0 <= l ? _$e < l : _$e > l; s = 0 <= l ? ++_$e : --_$e)r.push(t.readUInt16());
                    return r;
                }(), n = (this.length - t.pos + this.offset) / 2, o = function() {
                    var _$e, r;
                    for(r = [], s = _$e = 0; 0 <= n ? _$e < n : _$e > n; s = 0 <= n ? ++_$e : --_$e)r.push(t.readUInt16());
                    return r;
                }(), s = m = 0, b = _$i.length; m < b; s = ++m)for(g = _$i[s], r = v = d = p[s]; d <= g ? v <= g : v >= g; r = d <= g ? ++v : --v)0 === u[s] ? a = r + c[s] : 0 !== (a = o[u[s] / 2 + (r - d) - (l - s)] || 0) && (a += c[s]), this.codeMap[r] = 65535 & a;
        }
        t.pos = h;
    };
    return _$t.encode = function(t, e) {
        var r, n, _$i, a, o, s, c, u, h, l, f, d, p, g, m, v, b, _$y, w, N, L, A, x, S, _, P, k, _$I, F, C, _$j, O, B, M, _$E, q, D, R, T, U, z, H, W, V, G, Y;
        switch(_$I = new $cbf54afc98507811$var$ne, a = Object.keys(t).sort(function(t, e) {
            return t - e;
        }), e){
            case "macroman":
                for(p = 0, g = function() {
                    var _$t = [];
                    for(d = 0; d < 256; ++d)_$t.push(0);
                    return _$t;
                }(), v = {
                    0: 0
                }, _$i = {}, F = 0, B = a.length; F < B; F++)null == v[W = t[n = a[F]]] && (v[W] = ++p), _$i[n] = {
                    old: t[n],
                    new: v[t[n]]
                }, g[n] = v[t[n]];
                return _$I.writeUInt16(1), _$I.writeUInt16(0), _$I.writeUInt32(12), _$I.writeUInt16(0), _$I.writeUInt16(262), _$I.writeUInt16(0), _$I.write(g), {
                    charMap: _$i,
                    subtable: _$I.data,
                    maxGlyphID: p + 1
                };
            case "unicode":
                for(P = [], h = [], b = 0, v = {}, r = {}, m = c = null, C = 0, M = a.length; C < M; C++)null == v[w = t[n = a[C]]] && (v[w] = ++b), r[n] = {
                    old: w,
                    new: v[w]
                }, o = v[w] - n, null != m && o === c || (m && h.push(m), P.push(n), c = o), m = n;
                for(m && h.push(m), h.push(65535), P.push(65535), S = 2 * (x = P.length), A = 2 * Math.pow(Math.log(x) / Math.LN2, 2), l = Math.log(A / 2) / Math.LN2, L = 2 * x - A, s = [], N = [], f = [], d = _$j = 0, _$E = P.length; _$j < _$E; d = ++_$j){
                    if (_ = P[d], u = h[d], 65535 === _) {
                        s.push(0), N.push(0);
                        break;
                    }
                    if (_ - (k = r[_].new) >= 32768) for(s.push(0), N.push(2 * (f.length + x - d)), n = O = _; _ <= u ? O <= u : O >= u; n = _ <= u ? ++O : --O)f.push(r[n].new);
                    else s.push(k - _), N.push(0);
                }
                for(_$I.writeUInt16(3), _$I.writeUInt16(1), _$I.writeUInt32(12), _$I.writeUInt16(4), _$I.writeUInt16(16 + 8 * x + 2 * f.length), _$I.writeUInt16(0), _$I.writeUInt16(S), _$I.writeUInt16(A), _$I.writeUInt16(l), _$I.writeUInt16(L), z = 0, q = h.length; z < q; z++)n = h[z], _$I.writeUInt16(n);
                for(_$I.writeUInt16(0), H = 0, D = P.length; H < D; H++)n = P[H], _$I.writeUInt16(n);
                for(V = 0, R = s.length; V < R; V++)o = s[V], _$I.writeUInt16(o);
                for(G = 0, T = N.length; G < T; G++)_$y = N[G], _$I.writeUInt16(_$y);
                for(Y = 0, U = f.length; Y < U; Y++)p = f[Y], _$I.writeUInt16(p);
                return {
                    charMap: r,
                    subtable: _$I.data,
                    maxGlyphID: b + 1
                };
        }
    }, _$t;
}(), $cbf54afc98507811$var$ue = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "cmap", e.prototype.parse = function(t) {
        var _$e, r, n;
        for(t.pos = this.offset, this.version = t.readUInt16(), n = t.readUInt16(), this.tables = [], this.unicode = null, r = 0; 0 <= n ? r < n : r > n; r = 0 <= n ? ++r : --r)_$e = new $cbf54afc98507811$var$ce(t, this.offset), this.tables.push(_$e), _$e.isUnicode && null == this.unicode && (this.unicode = _$e);
        return !0;
    }, e.encode = function(t, e) {
        var r, n;
        return null == e && (e = "macroman"), r = $cbf54afc98507811$var$ce.encode(t, e), (n = new $cbf54afc98507811$var$ne).writeUInt16(0), n.writeUInt16(1), r.table = n.data.concat(r.subtable), r;
    }, e;
}(), $cbf54afc98507811$var$he = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "hhea", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.ascender = t.readShort(), this.decender = t.readShort(), this.lineGap = t.readShort(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort(), this.minRightSideBearing = t.readShort(), this.xMaxExtent = t.readShort(), this.caretSlopeRise = t.readShort(), this.caretSlopeRun = t.readShort(), this.caretOffset = t.readShort(), t.pos += 8, this.metricDataFormat = t.readShort(), this.numberOfMetrics = t.readUInt16();
    }, e;
}(), $cbf54afc98507811$var$le = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "OS/2", e.prototype.parse = function(t) {
        if (t.pos = this.offset, this.version = t.readUInt16(), this.averageCharWidth = t.readShort(), this.weightClass = t.readUInt16(), this.widthClass = t.readUInt16(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort(), this.ySubscriptYSize = t.readShort(), this.ySubscriptXOffset = t.readShort(), this.ySubscriptYOffset = t.readShort(), this.ySuperscriptXSize = t.readShort(), this.ySuperscriptYSize = t.readShort(), this.ySuperscriptXOffset = t.readShort(), this.ySuperscriptYOffset = t.readShort(), this.yStrikeoutSize = t.readShort(), this.yStrikeoutPosition = t.readShort(), this.familyClass = t.readShort(), this.panose = function() {
            var _$e, r;
            for(r = [], _$e = 0; _$e < 10; ++_$e)r.push(t.readByte());
            return r;
        }(), this.charRange = function() {
            var _$e, r;
            for(r = [], _$e = 0; _$e < 4; ++_$e)r.push(t.readInt());
            return r;
        }(), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort(), this.descent = t.readShort(), this.lineGap = t.readShort(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = function() {
            var _$e, r;
            for(r = [], _$e = 0; _$e < 2; _$e = ++_$e)r.push(t.readInt());
            return r;
        }(), this.version > 1)) return this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort();
    }, e;
}(), $cbf54afc98507811$var$fe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "post", e.prototype.parse = function(t) {
        var _$e, r, n;
        switch(t.pos = this.offset, this.format = t.readInt(), this.italicAngle = t.readInt(), this.underlinePosition = t.readShort(), this.underlineThickness = t.readShort(), this.isFixedPitch = t.readInt(), this.minMemType42 = t.readInt(), this.maxMemType42 = t.readInt(), this.minMemType1 = t.readInt(), this.maxMemType1 = t.readInt(), this.format){
            case 65536:
                break;
            case 131072:
                var _$i;
                for(r = t.readUInt16(), this.glyphNameIndex = [], _$i = 0; 0 <= r ? _$i < r : _$i > r; _$i = 0 <= r ? ++_$i : --_$i)this.glyphNameIndex.push(t.readUInt16());
                for(this.names = [], n = []; t.pos < this.offset + this.length;)_$e = t.readByte(), n.push(this.names.push(t.readString(_$e)));
                return n;
            case 151552:
                return r = t.readUInt16(), this.offsets = t.read(r);
            case 196608:
                break;
            case 262144:
                return this.map = (function() {
                    var _$e, r, n;
                    for(n = [], _$i = _$e = 0, r = this.file.maxp.numGlyphs; 0 <= r ? _$e < r : _$e > r; _$i = 0 <= r ? ++_$e : --_$e)n.push(t.readUInt32());
                    return n;
                }).call(this);
        }
    }, e;
}(), $cbf54afc98507811$var$de = function de(t, e) {
    this.raw = t, this.length = t.length, this.platformID = e.platformID, this.encodingID = e.encodingID, this.languageID = e.languageID;
}, $cbf54afc98507811$var$pe = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "name", e.prototype.parse = function(t) {
        var _$e, r, n, _$i, a, o, s, c, u, h, l;
        for(t.pos = this.offset, t.readShort(), _$e = t.readShort(), o = t.readShort(), r = [], _$i = 0; 0 <= _$e ? _$i < _$e : _$i > _$e; _$i = 0 <= _$e ? ++_$i : --_$i)r.push({
            platformID: t.readShort(),
            encodingID: t.readShort(),
            languageID: t.readShort(),
            nameID: t.readShort(),
            length: t.readShort(),
            offset: this.offset + o + t.readShort()
        });
        for(s = {}, _$i = u = 0, h = r.length; u < h; _$i = ++u)n = r[_$i], t.pos = n.offset, c = t.readString(n.length), a = new $cbf54afc98507811$var$de(c, n), null == s[l = n.nameID] && (s[l] = []), s[n.nameID].push(a);
        this.strings = s, this.copyright = s[0], this.fontFamily = s[1], this.fontSubfamily = s[2], this.uniqueSubfamily = s[3], this.fontName = s[4], this.version = s[5];
        try {
            this.postscriptName = s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        } catch (t) {
            this.postscriptName = s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g, "");
        }
        return this.trademark = s[7], this.manufacturer = s[8], this.designer = s[9], this.description = s[10], this.vendorUrl = s[11], this.designerUrl = s[12], this.license = s[13], this.licenseUrl = s[14], this.preferredFamily = s[15], this.preferredSubfamily = s[17], this.compatibleFull = s[18], this.sampleText = s[19];
    }, e;
}(), $cbf54afc98507811$var$ge = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "maxp", e.prototype.parse = function(t) {
        return t.pos = this.offset, this.version = t.readInt(), this.numGlyphs = t.readUInt16(), this.maxPoints = t.readUInt16(), this.maxContours = t.readUInt16(), this.maxCompositePoints = t.readUInt16(), this.maxComponentContours = t.readUInt16(), this.maxZones = t.readUInt16(), this.maxTwilightPoints = t.readUInt16(), this.maxStorage = t.readUInt16(), this.maxFunctionDefs = t.readUInt16(), this.maxInstructionDefs = t.readUInt16(), this.maxStackElements = t.readUInt16(), this.maxSizeOfInstructions = t.readUInt16(), this.maxComponentElements = t.readUInt16(), this.maxComponentDepth = t.readUInt16();
    }, e;
}(), $cbf54afc98507811$var$me = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "hmtx", e.prototype.parse = function(t) {
        var _$e, r, n, _$i, a, o, s;
        for(t.pos = this.offset, this.metrics = [], _$e = 0, o = this.file.hhea.numberOfMetrics; 0 <= o ? _$e < o : _$e > o; _$e = 0 <= o ? ++_$e : --_$e)this.metrics.push({
            advance: t.readUInt16(),
            lsb: t.readInt16()
        });
        for(n = this.file.maxp.numGlyphs - this.file.hhea.numberOfMetrics, this.leftSideBearings = function() {
            var r, _$i;
            for(_$i = [], _$e = r = 0; 0 <= n ? r < n : r > n; _$e = 0 <= n ? ++r : --r)_$i.push(t.readInt16());
            return _$i;
        }(), this.widths = (function() {
            var _$t, _$e, r, n;
            for(n = [], _$t = 0, _$e = (r = this.metrics).length; _$t < _$e; _$t++)_$i = r[_$t], n.push(_$i.advance);
            return n;
        }).call(this), r = this.widths[this.widths.length - 1], s = [], _$e = a = 0; 0 <= n ? a < n : a > n; _$e = 0 <= n ? ++a : --a)s.push(this.widths.push(r));
        return s;
    }, e.prototype.forGlyph = function(t) {
        return t in this.metrics ? this.metrics[t] : {
            advance: this.metrics[this.metrics.length - 1].advance,
            lsb: this.leftSideBearings[t - this.metrics.length]
        };
    }, e;
}(), $cbf54afc98507811$var$ve = [].slice, $cbf54afc98507811$var$be = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "glyf", e.prototype.parse = function() {
        return this.cache = {};
    }, e.prototype.glyphFor = function(t) {
        var _$e, r, n, _$i, a, o, s, c, u, h;
        return t in this.cache ? this.cache[t] : (_$i = this.file.loca, _$e = this.file.contents, r = _$i.indexOf(t), 0 === (n = _$i.lengthOf(t)) ? this.cache[t] = null : (_$e.pos = this.offset + r, a = (o = new $cbf54afc98507811$var$ne(_$e.read(n))).readShort(), c = o.readShort(), h = o.readShort(), s = o.readShort(), u = o.readShort(), this.cache[t] = -1 === a ? new $cbf54afc98507811$var$we(o, c, h, s, u) : new $cbf54afc98507811$var$ye(o, a, c, h, s, u), this.cache[t]));
    }, e.prototype.encode = function(t, e, r) {
        var n, _$i, a, o, s;
        for(a = [], _$i = [], o = 0, s = e.length; o < s; o++)n = t[e[o]], _$i.push(a.length), n && (a = a.concat(n.encode(r)));
        return _$i.push(a.length), {
            table: a,
            offsets: _$i
        };
    }, e;
}(), $cbf54afc98507811$var$ye = function() {
    var _$t = function _$t(t, e, r, n, i, a) {
        this.raw = t, this.numberOfContours = e, this.xMin = r, this.yMin = n, this.xMax = i, this.yMax = a, this.compound = !1;
    };
    return _$t.prototype.encode = function() {
        return this.raw.data;
    }, _$t;
}(), $cbf54afc98507811$var$we = function() {
    var _$t = function _$t(t, e, r, n, i) {
        var a, o;
        for(this.raw = t, this.xMin = e, this.yMin = r, this.xMax = n, this.yMax = i, this.compound = !0, this.glyphIDs = [], this.glyphOffsets = [], a = this.raw; o = a.readShort(), this.glyphOffsets.push(a.pos), this.glyphIDs.push(a.readUInt16()), 32 & o;)a.pos += 1 & o ? 4 : 2, 128 & o ? a.pos += 8 : 64 & o ? a.pos += 4 : 8 & o && (a.pos += 2);
    };
    return _$t.prototype.encode = function() {
        var _$t, e, r;
        for(e = new $cbf54afc98507811$var$ne($cbf54afc98507811$var$ve.call(this.raw.data)), _$t = 0, r = this.glyphIDs.length; _$t < r; ++_$t)e.pos = this.glyphOffsets[_$t];
        return e.data;
    }, _$t;
}(), $cbf54afc98507811$var$Ne = function(t) {
    function e() {
        return e.__super__.constructor.apply(this, arguments);
    }
    return $cbf54afc98507811$var$oe(e, $cbf54afc98507811$var$re), e.prototype.tag = "loca", e.prototype.parse = function(t) {
        var _$e, r;
        return t.pos = this.offset, _$e = this.file.head.indexToLocFormat, this.offsets = 0 === _$e ? (function() {
            var _$e, n;
            for(n = [], r = 0, _$e = this.length; r < _$e; r += 2)n.push(2 * t.readUInt16());
            return n;
        }).call(this) : (function() {
            var _$e, n;
            for(n = [], r = 0, _$e = this.length; r < _$e; r += 4)n.push(t.readUInt32());
            return n;
        }).call(this);
    }, e.prototype.indexOf = function(t) {
        return this.offsets[t];
    }, e.prototype.lengthOf = function(t) {
        return this.offsets[t + 1] - this.offsets[t];
    }, e.prototype.encode = function(t, e) {
        for(var r = new Uint32Array(this.offsets.length), n = 0, _$i = 0, a = 0; a < r.length; ++a)if (r[a] = n, _$i < e.length && e[_$i] == a) {
            ++_$i, r[a] = n;
            var o = this.offsets[a], s = this.offsets[a + 1] - o;
            s > 0 && (n += s);
        }
        for(var c = new Array(4 * r.length), u = 0; u < r.length; ++u)c[4 * u + 3] = 255 & r[u], c[4 * u + 2] = (65280 & r[u]) >> 8, c[4 * u + 1] = (16711680 & r[u]) >> 16, c[4 * u] = (4278190080 & r[u]) >> 24;
        return c;
    }, e;
}(), $cbf54afc98507811$var$Le = function() {
    var _$t = function _$t(t) {
        this.font = t, this.subset = {}, this.unicodes = {}, this.next = 33;
    };
    return _$t.prototype.generateCmap = function() {
        var _$t, e, r, n, _$i;
        for(e in n = this.font.cmap.tables[0].codeMap, _$t = {}, _$i = this.subset)r = _$i[e], _$t[e] = n[r];
        return _$t;
    }, _$t.prototype.glyphsFor = function(t) {
        var e, r, n, _$i, a, o, s;
        for(n = {}, a = 0, o = t.length; a < o; a++)n[_$i = t[a]] = this.font.glyf.glyphFor(_$i);
        for(_$i in e = [], n)(null != (r = n[_$i]) ? r.compound : void 0) && e.push.apply(e, r.glyphIDs);
        if (e.length > 0) for(_$i in s = this.glyphsFor(e))r = s[_$i], n[_$i] = r;
        return n;
    }, _$t.prototype.encode = function(t, e) {
        var r, n, _$i, a, o, s, c, u, h, l, f, d, p, g, m;
        for(n in r = $cbf54afc98507811$var$ue.encode(this.generateCmap(), "unicode"), a = this.glyphsFor(t), f = {
            0: 0
        }, m = r.charMap)f[(s = m[n]).old] = s.new;
        for(d in l = r.maxGlyphID, a)d in f || (f[d] = l++);
        return u = function(t) {
            var _$e, r;
            for(_$e in r = {}, t)r[t[_$e]] = _$e;
            return r;
        }(f), h = Object.keys(u).sort(function(t, e) {
            return t - e;
        }), p = function() {
            var _$t, _$e, r;
            for(r = [], _$t = 0, _$e = h.length; _$t < _$e; _$t++)o = h[_$t], r.push(u[o]);
            return r;
        }(), _$i = this.font.glyf.encode(a, p, f), c = this.font.loca.encode(_$i.offsets, p), g = {
            cmap: this.font.cmap.raw(),
            glyf: _$i.table,
            loca: c,
            hmtx: this.font.hmtx.raw(),
            hhea: this.font.hhea.raw(),
            maxp: this.font.maxp.raw(),
            post: this.font.post.raw(),
            name: this.font.name.raw(),
            head: this.font.head.encode(e)
        }, this.font.os2.exists && (g["OS/2"] = this.font.os2.raw()), this.font.directory.encode(g);
    }, _$t;
}();
$cbf54afc98507811$export$ba1e2ffc633a60f5.API.PDFObject = function() {
    var e = function e() {};
    var _$t;
    return _$t = function t(t, e) {
        return (Array(e + 1).join("0") + t).slice(-e);
    }, e.convert = function(r) {
        var n, _$i, a, o;
        if (Array.isArray(r)) return "[" + (function() {
            var _$t, _$i, a;
            for(a = [], _$t = 0, _$i = r.length; _$t < _$i; _$t++)n = r[_$t], a.push(e.convert(n));
            return a;
        })().join(" ") + "]";
        if ("string" == typeof r) return "/" + r;
        if (null != r ? r.isString : void 0) return "(" + r + ")";
        if (r instanceof Date) return "(D:" + _$t(r.getUTCFullYear(), 4) + _$t(r.getUTCMonth(), 2) + _$t(r.getUTCDate(), 2) + _$t(r.getUTCHours(), 2) + _$t(r.getUTCMinutes(), 2) + _$t(r.getUTCSeconds(), 2) + "Z)";
        if ("[object Object]" === ({}).toString.call(r)) {
            for(_$i in a = [
                "<<"
            ], r)o = r[_$i], a.push("/" + _$i + " " + e.convert(o));
            return a.push(">>"), a.join("\n");
        }
        return "" + r;
    }, e;
}();
var $cbf54afc98507811$export$2e2bcd8739ae039 = $cbf54afc98507811$export$ba1e2ffc633a60f5;


var $423479fd1c28444f$var$Certificate = function() {
    var certificateRef = (0, $6cds3.useRef)(null);
    var downloadPdf = function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function() {
            var input, canvas, pdf, scaleFactor, scaledHeight, verticalPosition;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        input = certificateRef.current;
                        return [
                            4,
                            (0, (/*@__PURE__*/$parcel$interopDefault($6lLHD)))(input)
                        ];
                    case 1:
                        canvas = _state.sent();
                        pdf = new (0, $cbf54afc98507811$export$2e2bcd8739ae039)({
                            orientation: "landscape",
                            unit: "mm",
                            format: "a4"
                        });
                        scaleFactor = pdf.internal.pageSize.getWidth() / canvas.width;
                        scaledHeight = canvas.height * scaleFactor;
                        verticalPosition = (pdf.internal.pageSize.getHeight() - scaledHeight) / 2;
                        // Add the image to the PDF, scaling it to fit the entire width and centered vertically
                        pdf.addImage(canvas.toDataURL("image/png"), "PNG", 0, verticalPosition, pdf.internal.pageSize.getWidth(), scaledHeight);
                        // Download the PDF
                        pdf.save("certificate.pdf");
                        return [
                            2
                        ];
                }
            });
        });
        return function downloadPdf() {
            return _ref.apply(this, arguments);
        };
    }();
    var downloadImage = function() {
        var _ref = (0, $869ea882f885334a$export$7c398597f8905a1)(function(format) {
            var input, canvas, image, a;
            return (0, $7UAGh.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        input = certificateRef.current;
                        return [
                            4,
                            (0, (/*@__PURE__*/$parcel$interopDefault($6lLHD)))(input)
                        ];
                    case 1:
                        canvas = _state.sent();
                        image = new Image();
                        image.src = canvas.toDataURL("image/".concat(format));
                        a = document.createElement("a");
                        a.href = image.src;
                        a.download = "certificate.".concat(format);
                        a.click();
                        return [
                            2
                        ];
                }
            });
        });
        return function downloadImage(format) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                ref: certificateRef,
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2d0b4ccb540d25a7$export$2e2bcd8739ae039), {
                    recipientName: "John Doe",
                    courseName: "React Workshop",
                    date: "2023-09-14"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex justify-around p-10 text-white",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        onClick: downloadPdf,
                        className: "p-2 bg-purple-800",
                        children: "Download PDF"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        onClick: function() {
                            return downloadImage("jpeg");
                        },
                        className: "p-2 bg-purple-800",
                        children: "Download JPEG"
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                        onClick: function() {
                            return downloadImage("png");
                        },
                        className: "p-2 bg-purple-800",
                        children: "Download PNG"
                    })
                ]
            })
        ]
    });
};
var $423479fd1c28444f$export$2e2bcd8739ae039 = $423479fd1c28444f$var$Certificate;



parcelRequire("6cds3");
var $ddc9877927f5836f$exports = {};


$ddc9877927f5836f$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("kcuBU");


var $9c46635dd61cf02f$exports = {};


$9c46635dd61cf02f$exports = (parcelRequire("17QCl")).getBundleURL("7lpHJ") + (parcelRequire("lGKbD")).resolve("9FObG");


var $182cc8fd11f53dca$var$AboutPage = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "bg-gray-100 min-h-screen",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "bg-blue-400 py-20 text-white text-center",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                            className: "text-4xl font-bold mb-4",
                            children: "About RentNHost"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "text-lg",
                            children: "Your go-to platform for renting cars or hosting your own car."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "py-16",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                            className: "text-3xl font-bold mb-8",
                            children: "Who We Are"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "text-lg",
                            children: "We are passionate about providing a seamless experience for car renters and hosts alike. Our platform connects people looking for reliable transportation with those willing to share their cars."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "bg-gray-200 py-16",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                            className: "text-3xl font-bold mb-8 text-center",
                            children: "Meet the Team"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "flex flex-wrap justify-center",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "m-4",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ddc9877927f5836f$exports))),
                                            alt: "Team Member 1",
                                            className: "rounded-full w-32 h-32 mb-4 mx-auto"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                            className: "text-xl font-bold",
                                            children: "John Doe"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "text-gray-600",
                                            children: "CEO & Co-founder"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "m-4",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9c46635dd61cf02f$exports))),
                                            alt: "Team Member 2",
                                            className: "rounded-full w-32 h-32 mb-4 mx-auto"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                            className: "text-xl font-bold",
                                            children: "Samantha"
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "text-gray-600",
                                            children: "CTO & Co-founder"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "py-16",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                            className: "text-3xl font-bold mb-8 text-center",
                            children: "What Our Users Say"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                            className: "max-w-lg mx-auto",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "bg-white rounded-lg shadow-md p-6 mb-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "text-lg mb-4",
                                            children: '"RentNHost made it so easy for me to find a car for my weekend trip. Highly recommended!"'
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "text-gray-600 text-right",
                                            children: "- Alice Johnson"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                    className: "bg-white rounded-lg shadow-md p-6",
                                    children: [
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "text-lg mb-4",
                                            children: "\"I've been hosting my car on RentNHost for months now, and it's been a great way to earn extra income.\""
                                        }),
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                            className: "text-gray-600 text-right",
                                            children: "- Michael Lee"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "py-16 bg-gray-300",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                            className: "text-3xl font-bold mb-8 text-center",
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("p", {
                            className: "text-lg text-center",
                            children: [
                                "If you have any questions or feedback, feel free to reach out to us at",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                    href: "mailto:info@rentnhost.com",
                                    className: "text-blue-500",
                                    children: "info@rentnhost.com"
                                }),
                                "."
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $182cc8fd11f53dca$export$2e2bcd8739ae039 = $182cc8fd11f53dca$var$AboutPage;



parcelRequire("6cds3");
var $1515689d2b26e0a6$var$ContactUsPage = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "bg-gray-100 min-h-screen",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "py-20 bg-blue-400 text-white text-center",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                            className: "text-4xl font-bold mb-4",
                            children: "Contact Us"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "text-lg",
                            children: "Have questions or feedback? We'd love to hear from you!"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "py-16",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "container mx-auto",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "max-w-lg mx-auto bg-white shadow-md rounded-lg p-8",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                className: "text-3xl font-bold mb-6 text-center",
                                children: "Get in Touch"
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("form", {
                                className: "space-y-4",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                                htmlFor: "name",
                                                className: "text-lg font-medium",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                type: "text",
                                                id: "name",
                                                className: "border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:border-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                                htmlFor: "email",
                                                className: "text-lg font-medium",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("input", {
                                                type: "email",
                                                id: "email",
                                                className: "border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:border-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("label", {
                                                htmlFor: "message",
                                                className: "text-lg font-medium",
                                                children: "Message"
                                            }),
                                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("textarea", {
                                                id: "message",
                                                rows: "4",
                                                className: "border border-gray-300 rounded-lg py-2 px-4 focus:outline-none focus:border-blue-500"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                        type: "submit",
                                        className: "bg-blue-500 text-white font-bold py-2 px-6 rounded-lg hover:bg-blue-600 transition-colors",
                                        children: "Submit"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $1515689d2b26e0a6$export$2e2bcd8739ae039 = $1515689d2b26e0a6$var$ContactUsPage;



parcelRequire("6cds3");
var $e8fa9c22fb5ee701$var$DashboardPage = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "bg-gray-100 min-h-screen",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "py-20 bg-blue-400 text-white text-center",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "container mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h1", {
                            className: "text-4xl font-bold mb-4",
                            children: "Dashboard"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "text-lg",
                            children: "Welcome back, [User Name]! Here's an overview of your account."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("section", {
                className: "py-16",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                    className: "container mx-auto",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "bg-white shadow-md rounded-lg p-6",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                        className: "text-2xl font-bold mb-4",
                                        children: "Profile"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "text-lg",
                                        children: "Update your profile information and preferences."
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: "/profile",
                                        className: "text-blue-400 font-medium mt-2 inline-block hover:underline",
                                        children: "Edit Profile"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "bg-white shadow-md rounded-lg p-6",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                        className: "text-2xl font-bold mb-4",
                                        children: "Bookings"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "text-lg",
                                        children: "View and manage your car rental bookings."
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: "/bookings",
                                        className: "text-blue-400 font-medium mt-2 inline-block hover:underline",
                                        children: "View Bookings"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "bg-white shadow-md rounded-lg p-6",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                        className: "text-2xl font-bold mb-4",
                                        children: "Hostings"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "text-lg",
                                        children: "Manage your car listings and host settings."
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: "/hostings",
                                        className: "text-blue-400 font-medium mt-2 inline-block hover:underline",
                                        children: "Manage Hostings"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                                className: "bg-white shadow-md rounded-lg p-6",
                                children: [
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h2", {
                                        className: "text-2xl font-bold mb-4",
                                        children: "Support"
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                                        className: "text-lg",
                                        children: "Contact customer support for assistance."
                                    }),
                                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                        href: "/support",
                                        className: "text-blue-400 font-medium mt-2 inline-block hover:underline",
                                        children: "Contact Support"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $e8fa9c22fb5ee701$export$2e2bcd8739ae039 = $e8fa9c22fb5ee701$var$DashboardPage;


var $a198c5b7f78064c1$var$App = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c2f7c44039ab2a82$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$910ae8079b2c2852), {})
        ]
    });
};
var $a198c5b7f78064c1$var$Body = function() {
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)((0, $fba0f23e9e6a11bb$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ea75739bc7566219$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $80e55dc4a3b629e0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $464f7e1e1b1e23b9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $2ac43e6e762af0c6$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f2b1fc8e16c23bf2$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1f748919507f0a47$export$2e2bcd8739ae039), {})
        ]
    });
};
var $a198c5b7f78064c1$export$9b5cb5a1fbefff82 = (0, $0e36e707c39d0f3a$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a198c5b7f78064c1$var$App, {}),
        children: [
            {
                index: "/",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($a198c5b7f78064c1$var$Body, {})
            },
            {
                path: "/allCars",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $15f32795f4aa14be$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about-us",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $182cc8fd11f53dca$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact-us",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1515689d2b26e0a6$export$2e2bcd8739ae039), {})
            },
            {
                path: "/dashboard",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $e8fa9c22fb5ee701$export$2e2bcd8739ae039), {})
            },
            {
                path: "/carHost",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $83dca54c84d6a991$export$2e2bcd8739ae039), {})
            },
            {
                path: "/allCars/:id",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $3b701f1b1cef2347$export$2e2bcd8739ae039), {})
            },
            {
                path: "/maps",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $fc727d7f86b4ce74$export$2e2bcd8739ae039), {})
            },
            {
                path: "/registerUser",
                element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $abe7ae22f372318f$export$2e2bcd8739ae039), {})
            }
        ]
    },
    {
        path: "/certificate",
        element: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $423479fd1c28444f$export$2e2bcd8739ae039), {})
    }
]);



var $f25e85c08ff84b11$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(document.getElementById("root"));
$f25e85c08ff84b11$var$root.render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $4a3e215446c0ed92$export$323e4fc2fa4753fb), {
    router: (0, $a198c5b7f78064c1$export$9b5cb5a1fbefff82)
}));

})();
//# sourceMappingURL=index.0d5b9412.js.map
